import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CustomGenericScalar: any;
  Date: any;
  DateTime: any;
  Decimal: any;
  GenericScalar: any;
  JSONScalar: any;
  JSONString: any;
  Time: any;
  UUID: any;
  _numeric: any;
  bigint: any;
  date: any;
  float8: any;
  geography: any;
  geometry: any;
  jsonb: any;
  numeric: any;
  smallint: any;
  time: any;
  timestamptz: any;
  uuid: any;
};

export type AcceptingTermsAndConditions = {
  __typename?: 'AcceptingTermsAndConditions';
  id?: Maybe<Scalars['Int']>;
  planned_key_stages?: Maybe<Scalars['Int']>;
  planned_operations_count?: Maybe<Scalars['Int']>;
};

export type AccountGlType = {
  __typename?: 'AccountGlType';
  account_type: AccountTypeGlType;
  /** Final Outstanding Amount */
  balance: Scalars['Float'];
  bank_detail?: Maybe<BankDetailGlType>;
  baseuser_set: Array<BaseUserGlType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by: BaseUserGlType;
  distributioncentre_set: Array<DistributionCentreGlType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  object_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserGlType>;
};

export type AccountTypeGlType = {
  __typename?: 'AccountTypeGlType';
  account_set: Array<AccountGlType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** An enumeration. */
export enum ActionLogActionFlag {
  /** Create */
  Create = 'CREATE',
  /** Delete */
  Delete = 'DELETE',
  /** Update */
  Update = 'UPDATE'
}

export type ActionLogType = {
  __typename?: 'ActionLogType';
  action_flag: ActionLogActionFlag;
  base_user: BaseUserType;
  change_message: Scalars['String'];
  change_object?: Maybe<Scalars['JSONScalar']>;
  content_type: GeneralContentType;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  object_id: Scalars['Int'];
  updated_at: Scalars['DateTime'];
};

export type AddUpdateBaseUser = {
  __typename?: 'AddUpdateBaseUser';
  base_user?: Maybe<BaseUserType>;
};

export type AddUpdateDockDetailMutation = {
  __typename?: 'AddUpdateDockDetailMutation';
  dock_detail?: Maybe<DockDetailGlType>;
};

export type AddUpdateOrderTransactionMutation = {
  __typename?: 'AddUpdateOrderTransactionMutation';
  order_transaction?: Maybe<OrderTransactionGlType>;
};

export type AddUpdateReceipt = {
  __typename?: 'AddUpdateReceipt';
  receipt: ReceiptType;
};

/** An enumeration. */
export enum AddressAddressKind {
  /** Collection Centre */
  Collection = 'COLLECTION',
  /** Depot */
  Depot = 'DEPOT',
  /** Distribution Centre */
  Distribution = 'DISTRIBUTION',
  /** Home */
  Home = 'HOME',
  /** Market Yard */
  Market = 'MARKET',
  /** Other */
  Other = 'OTHER',
  /** Plot */
  Plot = 'PLOT',
  /** Work */
  Work = 'WORK'
}

export type AddressGlInput = {
  address?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  geofence_radius?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  pincode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  village?: InputMaybe<Scalars['String']>;
};

export type AddressGlType = {
  __typename?: 'AddressGlType';
  address?: Maybe<Scalars['String']>;
  billed_orders: Array<OrderGlType>;
  booking?: Maybe<BookingGlType>;
  depot_set: Array<DepotGlType>;
  distributioncentre_set: Array<DistributionCentreGlType>;
  district?: Maybe<Scalars['String']>;
  dock_set: Array<DockGlType>;
  /** Vendor's Business Address */
  familygroup_set: Array<FamilyGroupGlType>;
  /** Specify raduis if it is geofence */
  geofence_radius: Scalars['Int'];
  geopoint?: Maybe<GeometryObjectType>;
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  mediaentity_set: Array<MediaGlType>;
  order_set: Array<OrderGlType>;
  pincode?: Maybe<Scalars['String']>;
  plot_set: Array<PlotGlType>;
  shipping_set: Array<ShippingGlType>;
  state?: Maybe<Scalars['String']>;
  taluka?: Maybe<Scalars['String']>;
  users_located: Array<BaseUserGlType>;
  village: Scalars['String'];
  w3w_name?: Maybe<Scalars['String']>;
};

export type AdviceCategory = {
  __typename?: 'AdviceCategory';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
};

export type AgentCompanyType = {
  __typename?: 'AgentCompanyType';
  accepts_tnc: Scalars['Boolean'];
  agent: AgentType;
  company: CompanyType;
  id: Scalars['ID'];
};

export type AgentDepartmentType = {
  __typename?: 'AgentDepartmentType';
  agent?: Maybe<AgentType>;
  department?: Maybe<DepartmentType>;
  id: Scalars['ID'];
};

export type AgentLogin = {
  __typename?: 'AgentLogin';
  me?: Maybe<BaseUserType>;
  payload: Scalars['GenericScalar'];
  refresh_expires_in: Scalars['Int'];
  refresh_token: Scalars['String'];
  token: Scalars['String'];
};

export type AgentType = {
  __typename?: 'AgentType';
  accepts_tnc: Scalars['Boolean'];
  codename: Scalars['String'];
  companies: Array<AgentCompanyType>;
  current_department?: Maybe<DepartmentType>;
  departments?: Maybe<Array<Maybe<AgentDepartmentType>>>;
  description: Scalars['String'];
  /** Agents employee id */
  eid: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** Required. Company phone number. */
  number: Scalars['String'];
  organisation: OrganisationType;
  user: BaseUserType;
};

export type AggregateSupplierGroupPlot = {
  __typename?: 'AggregateSupplierGroupPlot';
  crop_count?: Maybe<Scalars['Int']>;
  farmer_document_count?: Maybe<Scalars['Int']>;
  mutual_group?: Maybe<MutualGroupType>;
  plot_count?: Maybe<Scalars['Int']>;
  plot_document_count?: Maybe<Scalars['Int']>;
  supplier_count?: Maybe<Scalars['Int']>;
  tag_count?: Maybe<Scalars['Int']>;
  total_area?: Maybe<Scalars['Float']>;
  village_count?: Maybe<Scalars['Int']>;
};

export type AggregatedSampleType = {
  __typename?: 'AggregatedSampleType';
  aggregation_type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  value_unit?: Maybe<Scalars['String']>;
};

export type AgronomistPlotCropDiaryList = {
  __typename?: 'AgronomistPlotCropDiaryList';
  count?: Maybe<Scalars['Int']>;
  records?: Maybe<Array<Maybe<AgronomistPlotCropDiaryType>>>;
};

export type AgronomistPlotCropDiaryType = {
  __typename?: 'AgronomistPlotCropDiaryType';
  created_at: Scalars['DateTime'];
  /** BaseUser UUID from KiteDB */
  created_by_id: Scalars['String'];
  /** Autogenerated UUID as Primary Key */
  id: Scalars['UUID'];
  is_active: Scalars['Boolean'];
  /** Location where diary is captured */
  location?: Maybe<GeometryObjectType>;
  /** Agronomist insights on the PlotCrop */
  notes?: Maybe<Scalars['String']>;
  /** Organisation UUID from KiteDB */
  organisation_id?: Maybe<Scalars['String']>;
  /** Plot Crop UUID from KiteDB */
  plot_crop_id?: Maybe<Scalars['String']>;
  /** Datetime on which diary recorded */
  record_datetime: Scalars['DateTime'];
  share_with_grower: Scalars['Boolean'];
  updated_at: Scalars['DateTime'];
  /** BaseUser UUID from KiteDB */
  updated_by_id: Scalars['String'];
};

export type AppliedProductsOperationSchema = {
  product_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

export type AppliedProductsSchema = {
  __typename?: 'AppliedProductsSchema';
  product_name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
};

export type ArticleDetail = {
  __typename?: 'ArticleDetail';
  article_type?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<AttachmentSchema>>>;
  author_list?: Maybe<Array<Maybe<AuthorDetails>>>;
  authors?: Maybe<Array<Maybe<Scalars['String']>>>;
  bookmarked_id?: Maybe<Scalars['Int']>;
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  content?: Maybe<Scalars['String']>;
  creator_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  favorites?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['UUID']>;
  image_url?: Maybe<Scalars['String']>;
  is_bookmarked?: Maybe<Scalars['Boolean']>;
  is_liked?: Maybe<Scalars['Boolean']>;
  is_viewed?: Maybe<Scalars['Boolean']>;
  like_count?: Maybe<Scalars['Int']>;
  liked_id?: Maybe<Scalars['Int']>;
  likes?: Maybe<Scalars['Int']>;
  publish_date?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  view_count?: Maybe<Scalars['Int']>;
  view_details?: Maybe<ViewDetails>;
  viewed_id?: Maybe<Scalars['Int']>;
  views?: Maybe<Scalars['Int']>;
};

export type ArticleDetailTrendingMetrics = {
  __typename?: 'ArticleDetailTrendingMetrics';
  favorites?: Maybe<UserAndCountSchema>;
  likes?: Maybe<UserAndCountSchema>;
  views?: Maybe<UserAndCountSchema>;
};

export type ArticleList = {
  __typename?: 'ArticleList';
  count?: Maybe<Scalars['Int']>;
  records?: Maybe<Array<Maybe<ArticleDetail>>>;
};

export type ArticleSubcriptionPackageType = {
  __typename?: 'ArticleSubcriptionPackageType';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
};

export type ArticlesInProgress = {
  __typename?: 'ArticlesInProgress';
  article?: Maybe<ArticleDetail>;
  current_viewtime?: Maybe<Scalars['Int']>;
};

export type AttachmentSchema = {
  __typename?: 'AttachmentSchema';
  duration?: Maybe<Scalars['Int']>;
  extension?: Maybe<Scalars['String']>;
  media_type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AttributesSchema = {
  __typename?: 'AttributesSchema';
  display_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AuthorDetails = {
  __typename?: 'AuthorDetails';
  about?: Maybe<Scalars['String']>;
  follower_id?: Maybe<Scalars['Int']>;
  followers_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  is_following?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BankDetailGlType = {
  __typename?: 'BankDetailGlType';
  account_holder_name: Scalars['String'];
  account_number: Scalars['String'];
  account_set: Array<AccountGlType>;
  attachments: Array<MediaGlType>;
  branch_name: Scalars['String'];
  id: Scalars['ID'];
  ifsc_code: Scalars['String'];
  object_id?: Maybe<Scalars['Int']>;
  user?: Maybe<BaseUserGlType>;
};

export type BaseUserAggregationType = {
  __typename?: 'BaseUserAggregationType';
  address?: Maybe<Scalars['String']>;
  contact?: Maybe<UserContactType>;
  documents?: Maybe<Array<Maybe<Scalars['JSONScalar']>>>;
  farm_count?: Maybe<Scalars['Int']>;
  field_acreage?: Maybe<Scalars['Float']>;
  field_count?: Maybe<Scalars['Int']>;
  fullname?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  last_active_on_mobile?: Maybe<Scalars['DateTime']>;
  last_active_on_web?: Maybe<Scalars['DateTime']>;
  organisation_user_tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  pincode?: Maybe<Scalars['String']>;
  plot_acreage?: Maybe<Scalars['Float']>;
  plot_count?: Maybe<Scalars['Int']>;
  plot_crop_count?: Maybe<Scalars['Int']>;
  primary_contact?: Maybe<UserContactTypeV2>;
  reference_id?: Maybe<Scalars['String']>;
  secondary_contact?: Maybe<UserContactTypeV2>;
  teams?: Maybe<Array<Maybe<MutualGroupSummaryType>>>;
  user_documents_count?: Maybe<Scalars['Int']>;
  village?: Maybe<Scalars['String']>;
};

export type BaseUserAggregationTypeWithTotal = {
  __typename?: 'BaseUserAggregationTypeWithTotal';
  records?: Maybe<Array<Maybe<BaseUserAggregationType>>>;
  total?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum BaseUserGender {
  /** Female */
  Fm = 'FM',
  /** Male */
  Ml = 'ML'
}

export type BaseUserGlType = {
  __typename?: 'BaseUserGlType';
  address?: Maybe<AddressGlType>;
  current_department?: Maybe<DepartmentGlType>;
  customer_id: Scalars['String'];
  /** The department this user belongs to. A user will get all permissions for related commodities granted to each of their departments. */
  departments: Array<DepartmentGlType>;
  distributioncentre_set: Array<DistributionCentreGlType>;
  documents?: Maybe<Array<Maybe<CertificationGlType>>>;
  email: Scalars['String'];
  family_group?: Maybe<FamilyGroupGlType>;
  full_name?: Maybe<Scalars['String']>;
  gender?: Maybe<BaseUserGender>;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups: Array<GroupGlType>;
  id: Scalars['ID'];
  kite_reference_id?: Maybe<Scalars['String']>;
  /** Primary phone number user for contact purposes */
  number: Scalars['String'];
  primary_dcs: Array<DistributionCentreGlType>;
  reference_id: Scalars['String'];
};

export type BaseUserInput = {
  address?: InputMaybe<KiteAddressInput>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  data_consent?: InputMaybe<KiteMediaInput>;
  date_of_birth?: InputMaybe<Scalars['Date']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  mutual_group_id?: InputMaybe<Scalars['ID']>;
  networks?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  number?: InputMaybe<Scalars['String']>;
  payment_options?: InputMaybe<Array<InputMaybe<PaymentDetailInput>>>;
  photo?: InputMaybe<KiteMediaInput>;
  preferred_language?: InputMaybe<Scalars['String']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

/** An enumeration. */
export enum BaseUserPreferredLanguage {
  /** Afrikaans */
  Af = 'AF',
  /** Arabic */
  Ar = 'AR',
  /** Algerian Arabic */
  ArDz = 'AR_DZ',
  /** Asturian */
  Ast = 'AST',
  /** Azerbaijani */
  Az = 'AZ',
  /** Belarusian */
  Be = 'BE',
  /** Bulgarian */
  Bg = 'BG',
  /** Bengali */
  Bn = 'BN',
  /** Breton */
  Br = 'BR',
  /** Bosnian */
  Bs = 'BS',
  /** Catalan */
  Ca = 'CA',
  /** Czech */
  Cs = 'CS',
  /** Welsh */
  Cy = 'CY',
  /** Danish */
  Da = 'DA',
  /** German */
  De = 'DE',
  /** Lower Sorbian */
  Dsb = 'DSB',
  /** Greek */
  El = 'EL',
  /** English */
  En = 'EN',
  /** Australian English */
  EnAu = 'EN_AU',
  /** British English */
  EnGb = 'EN_GB',
  /** Esperanto */
  Eo = 'EO',
  /** Spanish */
  Es = 'ES',
  /** Argentinian Spanish */
  EsAr = 'ES_AR',
  /** Colombian Spanish */
  EsCo = 'ES_CO',
  /** Mexican Spanish */
  EsMx = 'ES_MX',
  /** Nicaraguan Spanish */
  EsNi = 'ES_NI',
  /** Venezuelan Spanish */
  EsVe = 'ES_VE',
  /** Estonian */
  Et = 'ET',
  /** Basque */
  Eu = 'EU',
  /** Persian */
  Fa = 'FA',
  /** Finnish */
  Fi = 'FI',
  /** French */
  Fr = 'FR',
  /** Frisian */
  Fy = 'FY',
  /** Irish */
  Ga = 'GA',
  /** Scottish Gaelic */
  Gd = 'GD',
  /** Galician */
  Gl = 'GL',
  /** Hebrew */
  He = 'HE',
  /** Hindi */
  Hi = 'HI',
  /** Croatian */
  Hr = 'HR',
  /** Upper Sorbian */
  Hsb = 'HSB',
  /** Hungarian */
  Hu = 'HU',
  /** Armenian */
  Hy = 'HY',
  /** Interlingua */
  Ia = 'IA',
  /** Indonesian */
  Id = 'ID',
  /** Igbo */
  Ig = 'IG',
  /** Ido */
  Io = 'IO',
  /** Icelandic */
  Is = 'IS',
  /** Italian */
  It = 'IT',
  /** Japanese */
  Ja = 'JA',
  /** Georgian */
  Ka = 'KA',
  /** Kabyle */
  Kab = 'KAB',
  /** Kazakh */
  Kk = 'KK',
  /** Khmer */
  Km = 'KM',
  /** Kannada */
  Kn = 'KN',
  /** Korean */
  Ko = 'KO',
  /** Kyrgyz */
  Ky = 'KY',
  /** Luxembourgish */
  Lb = 'LB',
  /** Lithuanian */
  Lt = 'LT',
  /** Latvian */
  Lv = 'LV',
  /** Macedonian */
  Mk = 'MK',
  /** Malayalam */
  Ml = 'ML',
  /** Mongolian */
  Mn = 'MN',
  /** Marathi */
  Mr = 'MR',
  /** Burmese */
  My = 'MY',
  /** Norwegian Bokmål */
  Nb = 'NB',
  /** Nepali */
  Ne = 'NE',
  /** Dutch */
  Nl = 'NL',
  /** Norwegian Nynorsk */
  Nn = 'NN',
  /** Ossetic */
  Os = 'OS',
  /** Punjabi */
  Pa = 'PA',
  /** Polish */
  Pl = 'PL',
  /** Portuguese */
  Pt = 'PT',
  /** Brazilian Portuguese */
  PtBr = 'PT_BR',
  /** Romanian */
  Ro = 'RO',
  /** Russian */
  Ru = 'RU',
  /** Slovak */
  Sk = 'SK',
  /** Slovenian */
  Sl = 'SL',
  /** Albanian */
  Sq = 'SQ',
  /** Serbian */
  Sr = 'SR',
  /** Serbian Latin */
  SrLatn = 'SR_LATN',
  /** Swedish */
  Sv = 'SV',
  /** Swahili */
  Sw = 'SW',
  /** Tamil */
  Ta = 'TA',
  /** Telugu */
  Te = 'TE',
  /** Tajik */
  Tg = 'TG',
  /** Thai */
  Th = 'TH',
  /** Turkmen */
  Tk = 'TK',
  /** Turkish */
  Tr = 'TR',
  /** Tatar */
  Tt = 'TT',
  /** Udmurt */
  Udm = 'UDM',
  /** Ukrainian */
  Uk = 'UK',
  /** Urdu */
  Ur = 'UR',
  /** Uzbek */
  Uz = 'UZ',
  /** Vietnamese */
  Vi = 'VI',
  /** Simplified Chinese */
  ZhHans = 'ZH_HANS',
  /** Traditional Chinese */
  ZhHant = 'ZH_HANT'
}

/** An enumeration. */
export enum BaseUserStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Blocked */
  Blocked = 'BLOCKED',
  /** Busy */
  Busy = 'BUSY',
  /** In Active */
  Inactive = 'INACTIVE'
}

export type BaseUserType = {
  __typename?: 'BaseUserType';
  actionlog_set: Array<ActionLogType>;
  address_book: Array<KiteAddressType>;
  agent?: Maybe<AgentType>;
  agents: Array<AgentType>;
  allowed_roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  business_set: Array<BusinessType>;
  companies: Array<CompanyType>;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  current_address?: Maybe<KiteAddressType>;
  current_department?: Maybe<DepartmentType>;
  data_consent?: Maybe<MediaType>;
  date_joined: Scalars['DateTime'];
  date_of_birth: Scalars['Date'];
  departments: Array<DepartmentType>;
  devices: Array<DeviceType>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  documents_document_created: Array<DocumentType>;
  documents_document_updated: Array<DocumentType>;
  documents_document_verified: Array<DocumentType>;
  education: Scalars['String'];
  email: Scalars['String'];
  external_reference_id?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  full_name?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups: Array<UserGroupType>;
  id: Scalars['ID'];
  is_verified?: Maybe<Scalars['Boolean']>;
  last_active_on_mobile?: Maybe<Scalars['DateTime']>;
  last_active_on_web?: Maybe<Scalars['DateTime']>;
  last_login?: Maybe<Scalars['DateTime']>;
  last_name: Scalars['String'];
  metadata: Scalars['JSONString'];
  mutual_groups: Array<MutualGroupType>;
  mutualgroupmembership_set: Array<MutualGroupMembersipType>;
  my_businesses: Array<BusinessType>;
  my_farms: Array<FarmType>;
  my_plot_crops: Array<PlotCropDetailType>;
  my_plots: Array<PlotType>;
  /** Required. 10-digit unique phone number. */
  number: Scalars['String'];
  number_country_code: Scalars['String'];
  organisation_organisation_created: Array<OrganisationType>;
  organisation_organisation_updated: Array<OrganisationType>;
  payment_options?: Maybe<Array<Maybe<PaymentDetailType>>>;
  payment_paymentdetail_created: Array<PaymentDetailType>;
  payment_paymentdetail_updated: Array<PaymentDetailType>;
  payment_paymentdetail_verified: Array<PaymentDetailType>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  photo?: Maybe<MediaType>;
  preferred_language: BaseUserPreferredLanguage;
  preferred_payment_option?: Maybe<PaymentDetailType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  reference_id: Scalars['String'];
  secondary_number: Scalars['String'];
  secondary_number_country_code: Scalars['String'];
  status: BaseUserStatus;
  trade_business_created: Array<BusinessType>;
  trade_business_updated: Array<BusinessType>;
  trade_business_verified: Array<BusinessType>;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String'];
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
  vt_core_baseuser_created: Array<BaseUserType>;
  vt_core_baseuser_updated: Array<BaseUserType>;
  vt_core_baseuser_verified: Array<BaseUserType>;
  vt_core_mutualgroup_created: Array<MutualGroupType>;
  vt_core_mutualgroup_updated: Array<MutualGroupType>;
  vt_core_mutualgroup_verified: Array<MutualGroupType>;
  vt_plot_farm_created: Array<FarmType>;
  vt_plot_farm_updated: Array<FarmType>;
  vt_plot_farm_verified: Array<FarmType>;
  vt_plot_plot_created: Array<PlotType>;
  vt_plot_plot_updated: Array<PlotType>;
  vt_plot_plot_verified: Array<PlotType>;
  vt_plot_plotcrop_created: Array<PlotCropDetailType>;
  vt_plot_plotcrop_updated: Array<PlotCropDetailType>;
  vt_plot_plotcrop_verified: Array<PlotCropDetailType>;
  vt_plot_plotcropgrowthstage_created: Array<PlotCropGrowthStageType>;
  vt_plot_plotcropgrowthstage_updated: Array<PlotCropGrowthStageType>;
  vt_plot_plotcropmilestone_created: Array<PlotCropMilestoneType>;
  vt_plot_plotcropmilestone_updated: Array<PlotCropMilestoneType>;
};

export type BillingDocGlType = {
  __typename?: 'BillingDocGlType';
  billing_doc_number: Scalars['String'];
  erp_ref_code: Scalars['String'];
  id: Scalars['ID'];
  invoice?: Maybe<MediaGlType>;
  invoice_document_path?: Maybe<Scalars['String']>;
  metadata: Scalars['JSONString'];
  order: OrderGlType;
  trip?: Maybe<TripGlType>;
};

export type BookingGlFilterInput = {
  approval_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  booking_id?: InputMaybe<Scalars['ID']>;
  date__gte?: InputMaybe<Scalars['Date']>;
  date__lte?: InputMaybe<Scalars['Date']>;
  destination_dc_id?: InputMaybe<Scalars['ID']>;
  gate_pass_no?: InputMaybe<Scalars['String']>;
  order_item_id?: InputMaybe<Scalars['ID']>;
  sellable_item_id?: InputMaybe<Scalars['ID']>;
  source_dc_id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trip_id?: InputMaybe<Scalars['ID']>;
  trip_status__nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BookingGlType = {
  __typename?: 'BookingGlType';
  approval_status?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inwards: Array<InwardGlType>;
  loaded_skus: Scalars['Int'];
  order_item?: Maybe<OrderItemGlType>;
  procured_quantity: Scalars['Int'];
  required_quantity: Scalars['Int'];
  schedule: ScheduleGlType;
  status: BookingStatus;
  trip?: Maybe<TripGlType>;
};

/** An enumeration. */
export enum BookingStatus {
  /** Booked */
  Bkd = 'BKD',
  /** Confirmed by Aggregator */
  Cfa = 'CFA',
  /** Confirmed by Supplier */
  Cff = 'CFF',
  /** Completed */
  Cmp = 'CMP',
  /** Cancelled */
  Cnl = 'CNL',
  /** Inwarding */
  Inw = 'INW',
  /** Picked up */
  Pkd = 'PKD'
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type BroadcastConsents = {
  __typename?: 'BroadcastConsents';
  buyer_status?: Maybe<Scalars['Boolean']>;
  seller_status?: Maybe<Scalars['Boolean']>;
};

export type BulkMilestoneRecordInputType = {
  crop_milestone_id?: InputMaybe<Scalars['Int']>;
  date: Scalars['Date'];
  plot_crop_milestone_id?: InputMaybe<Scalars['Int']>;
};

export type BulkUpdateBaseUserCompaniesMutation = {
  __typename?: 'BulkUpdateBaseUserCompaniesMutation';
  users?: Maybe<Array<Maybe<BaseUserType>>>;
};

export type BulkUpdateOrderMutation = {
  __typename?: 'BulkUpdateOrderMutation';
  order?: Maybe<Array<Maybe<OrderGlType>>>;
};

/** An enumeration. */
export enum BusinessKind {
  /** Cooperative */
  Cooperative = 'COOPERATIVE',
  /** Farmer Producer Organisation */
  Fpo = 'FPO',
  /** Other */
  Other = 'OTHER',
  /** Partnership Firm (LLP) */
  PartnershipLlp = 'PARTNERSHIP_LLP',
  /** Pvt. Ltd. Company */
  PrivateLimited = 'PRIVATE_LIMITED',
  /** Proprietor */
  Proprietor = 'PROPRIETOR',
  /** Public Ltd. Company */
  PublicLimited = 'PUBLIC_LIMITED',
  /** Section 8 Company (Foundation) */
  Section_8 = 'SECTION_8',
  /** Section 25 Company */
  Section_25 = 'SECTION_25'
}

export type BusinessType = {
  __typename?: 'BusinessType';
  address?: Maybe<KiteAddressType>;
  alternate_email: Scalars['String'];
  codename: Scalars['String'];
  companies: Array<CompanyType>;
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  data_consent?: Maybe<MediaType>;
  description: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  incorporated_on?: Maybe<Scalars['Date']>;
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  kind: BusinessKind;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  number: Scalars['String'];
  primary_poc?: Maybe<BaseUserType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  secondary_number: Scalars['String'];
  secondary_pocs: Array<BaseUserType>;
  updated_by?: Maybe<BaseUserType>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  display_value?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type CertificationGlType = {
  __typename?: 'CertificationGlType';
  attachments: Array<MediaGlType>;
  certification_type: CertificationGraphGlType;
  id: Scalars['ID'];
  id_number: Scalars['String'];
  issued_by: Scalars['String'];
  object_id: Scalars['Int'];
  photo?: Maybe<Scalars['String']>;
  remark: Scalars['String'];
  valid_from?: Maybe<Scalars['Date']>;
  valid_till?: Maybe<Scalars['Date']>;
};

export type CertificationGraphGlType = {
  __typename?: 'CertificationGraphGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  name: Scalars['String'];
};

export type CommodityGlType = {
  __typename?: 'CommodityGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  kite_codename?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CommodityGroupGlType = {
  __typename?: 'CommodityGroupGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  kite_codename?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sku_type?: Maybe<SkuTypeGlType>;
};

export type CommodityVarietyGlType = {
  __typename?: 'CommodityVarietyGlType';
  commodity: CommodityGlType;
  groups: Array<CommodityGroupGlType>;
  id: Scalars['ID'];
  kite_codename?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  primary_group?: Maybe<CommodityGroupGlType>;
  reference_id: Scalars['String'];
};

export type CompanyGlType = {
  __typename?: 'CompanyGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  display_name: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CompanyType = {
  __typename?: 'CompanyType';
  /** Abbreviation for short name */
  abbreviation: Scalars['String'];
  /** The location details of the company, HQ or otherwise */
  address?: Maybe<KiteAddressType>;
  agents: Array<AgentCompanyType>;
  baseuser_set: Array<BaseUserType>;
  business_set: Array<BusinessType>;
  codename: Scalars['String'];
  departments: Array<DepartmentType>;
  description: Scalars['String'];
  /** Display name for showing on the website */
  display_name: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  networks: Array<NetworkType>;
  /** The company's phone number */
  number?: Maybe<Scalars['String']>;
  /** The organisation that manages the company */
  organisation?: Maybe<OrganisationType>;
  photo?: Maybe<MediaType>;
  purpose?: Maybe<Scalars['String']>;
  /** Terms and conditions */
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export type CoursesInProgress = {
  __typename?: 'CoursesInProgress';
  article?: Maybe<ArticleDetail>;
  current_viewtime?: Maybe<Scalars['Int']>;
  series_id?: Maybe<Scalars['String']>;
};

export type CreateAgronomistPlotCropDiaryMutation = {
  __typename?: 'CreateAgronomistPlotCropDiaryMutation';
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  record_datetime?: Maybe<Scalars['DateTime']>;
  share_with_grower?: Maybe<Scalars['Boolean']>;
};

export type CreateExpenseConfigMutation = {
  __typename?: 'CreateExpenseConfigMutation';
  department_id?: Maybe<Scalars['Int']>;
  expenses_details?: Maybe<Array<Maybe<OrganisationTradeExpensesTemplateSchema>>>;
  trade_kind?: Maybe<Scalars['String']>;
  trade_mode?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type CreateNotification = {
  __typename?: 'CreateNotification';
  id?: Maybe<Scalars['String']>;
};

/**
 * {
 *   "plot_crop_id": "",
 *   "record_date": "",
 *   "notes": "Notes",
 *   "attachments": [1, 2],
 *   "observations": [
 *     {
 *       "parameter_id": ""
 *       "recorded_value": "",
 *       "recorded_unit_id": "",
 *       "attachments": [2, 4],
 *       "notes": ""
 *     },
 *     {
 *       "parameter_id": ""
 *       "recorded_value": "",
 *       "recorded_unit_id": "",
 *       "attachments": []
 *     },
 *   ]
 * }
 */
export type CreateObservationMutation = {
  __typename?: 'CreateObservationMutation';
  hons_earned?: Maybe<Scalars['Int']>;
  observation_count?: Maybe<Scalars['Int']>;
  observations?: Maybe<Array<Maybe<ObservationSampleResponseType>>>;
  record_datetime?: Maybe<Scalars['DateTime']>;
  total_hons?: Maybe<Scalars['Int']>;
};

export type CreateOperationMutation = {
  __typename?: 'CreateOperationMutation';
  activity_name?: Maybe<Scalars['String']>;
  activity_type?: Maybe<Scalars['String']>;
  attributes?: Maybe<Array<Maybe<AttributesSchema>>>;
  hons_earned?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  record_date?: Maybe<Scalars['String']>;
  record_display_date?: Maybe<Scalars['String']>;
  total_hons?: Maybe<Scalars['Int']>;
};

export type CreateTncConfigMutation = {
  __typename?: 'CreateTNCConfigMutation';
  conditions?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['Int']>;
  trade_kind?: Maybe<Scalars['String']>;
  trade_mode?: Maybe<Scalars['String']>;
  trade_party?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type CropInfestationDetailType = {
  __typename?: 'CropInfestationDetailType';
  /** Affects */
  affects?: Maybe<Scalars['String']>;
  /** Biological measures */
  biological_measures?: Maybe<Scalars['String']>;
  category_name?: Maybe<Scalars['String']>;
  /** Chemical measures */
  chemical_measures?: Maybe<Scalars['String']>;
  crop: CropType;
  /** Cultural measures */
  cultural_measures?: Maybe<Scalars['String']>;
  /** Nature of damage */
  damage_nature?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** URL of the image related to this crop monitoring parameter */
  image_url?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Calendar months of infestation */
  infestation_period?: Maybe<Scalars['String']>;
  /** Vegetative stage of infestation */
  infestation_stage?: Maybe<Scalars['String']>;
  /** Mechanical measures */
  mechanical_measures?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Feature photo */
  photo?: Maybe<MediaType>;
  /** Impact on produce quality */
  quality_impact?: Maybe<Scalars['String']>;
  /** Impact on produce quantity */
  quantity_impact?: Maybe<Scalars['String']>;
  scientific_name?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  /** Symptoms */
  symptoms?: Maybe<Scalars['String']>;
  /** Favorable weather conditions */
  weather_conditions?: Maybe<Scalars['String']>;
};

export type CropInfestationListType = {
  __typename?: 'CropInfestationListType';
  category_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CropInfoType = {
  __typename?: 'CropInfoType';
  crop_image?: Maybe<Scalars['String']>;
  crop_name?: Maybe<Scalars['String']>;
  variety_name?: Maybe<Scalars['String']>;
};

export type CropList = {
  __typename?: 'CropList';
  codename?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CropMilestoneType = {
  __typename?: 'CropMilestoneType';
  crop: CropType;
  id?: Maybe<Scalars['Int']>;
  ignore_crop_year: Scalars['Boolean'];
  image_url?: Maybe<Scalars['String']>;
  milestone: MilestoneDetailType;
  /** Display order */
  order: Scalars['Int'];
  plotcropmilestone_set: Array<PlotCropMilestoneType>;
};

export type CropType = {
  __typename?: 'CropType';
  codename: Scalars['String'];
  cropinfestation_set: Array<CropInfestationDetailType>;
  cropmilestone_set: Array<CropMilestoneType>;
  description: Scalars['String'];
  /** The color representing a crop - used to visually represent crops in a plot */
  hex_color_code: Scalars['String'];
  id: Scalars['ID'];
  /** URL of the image related to this crop monitoring parameter */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  photo?: Maybe<MediaType>;
  plotcrop_set: Array<PlotCropDetailType>;
  primarygrowthstage_set: Array<PrimaryGsType>;
  varieties: Array<CropVarietyType>;
};

export type CropVarietyType = {
  __typename?: 'CropVarietyType';
  codename: Scalars['String'];
  crop: CropType;
  description: Scalars['String'];
  id: Scalars['ID'];
  /** URL of the image related to this crop monitoring parameter */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  photo?: Maybe<MediaType>;
  plotcrop_set: Array<PlotCropDetailType>;
};

export type DataChoices = {
  __typename?: 'DataChoices';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DataUnitChoices = {
  __typename?: 'DataUnitChoices';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type DemandGlType = {
  __typename?: 'DemandGlType';
  broadcast_time: Scalars['DateTime'];
  created_at: Scalars['DateTime'];
  date: Scalars['Date'];
  id: Scalars['ID'];
  is_live: Scalars['Boolean'];
  name: Scalars['String'];
  updated_at: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

/** An enumeration. */
export enum DepartmentDepartmentType {
  /** Export Department */
  Ex = 'EX',
  /** Processing Department */
  Pr = 'PR',
  /** Retail Department */
  Rt = 'RT',
  /** Wholesale Department */
  Wh = 'WH'
}

export type DepartmentGlType = {
  __typename?: 'DepartmentGlType';
  active_members: Array<BaseUserGlType>;
  allowed_depots: Array<DepotGlType>;
  assigned_trips: Array<TripGlType>;
  /** The department this user belongs to. A user will get all permissions for related commodities granted to each of their departments. */
  baseuser_set: Array<BaseUserGlType>;
  codename?: Maybe<Scalars['String']>;
  companies: Array<CompanyGlType>;
  control_pricing: Scalars['Boolean'];
  created_at: Scalars['DateTime'];
  demand_set: Array<DemandGlType>;
  department_type: DepartmentDepartmentType;
  distributioncentre_set: Array<DistributionCentreGlType>;
  generate_po_after_inward: Scalars['Boolean'];
  generate_po_plot_wise: Scalars['Boolean'];
  has_dynamic_stock: Scalars['Boolean'];
  id: Scalars['ID'];
  invoice_type: DepartmentInvoiceType;
  kite_reference_id?: Maybe<Scalars['String']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  optional_pricing: Scalars['Boolean'];
  order_set: Array<OrderGlType>;
  photo?: Maybe<Scalars['String']>;
  preferred_depot?: Maybe<DepotGlType>;
  schedule_set: Array<ScheduleGlType>;
  schedulerequest_set: Array<ScheduleRequestGlType>;
  sellableitem_set: Array<SellableItemGlType>;
  sellableitemstock_set: Array<SellableItemStockGlType>;
  should_cross_po: Scalars['Boolean'];
  togo_subscription: Scalars['Boolean'];
  updated_at: Scalars['DateTime'];
  varieties: Array<CommodityVarietyGlType>;
  vehicle_set: Array<VehicleGlType>;
};

/** An enumeration. */
export enum DepartmentInvoiceType {
  /** Sap Billing Doc */
  Spbd = 'SPBD',
  /** Sap Invoice */
  Spin = 'SPIN',
  /** Vesatogo Invoice */
  Vtin = 'VTIN'
}

export type DepartmentType = {
  __typename?: 'DepartmentType';
  /** Abbreviation for short name */
  abbreviation: Scalars['String'];
  active_agents: Array<AgentType>;
  active_members: Array<BaseUserType>;
  agents: Array<AgentDepartmentType>;
  baseuser_set: Array<BaseUserType>;
  codename: Scalars['String'];
  company?: Maybe<CompanyType>;
  description: Scalars['String'];
  /** Display name for showing on the website */
  display_name: Scalars['String'];
  documents_document_created: Array<DocumentType>;
  external_reference_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  organisation_organisation_created: Array<OrganisationType>;
  payment_paymentdetail_created: Array<PaymentDetailType>;
  photo?: Maybe<MediaType>;
  trade_business_created: Array<BusinessType>;
  uid?: Maybe<Scalars['String']>;
  vt_core_baseuser_created: Array<BaseUserType>;
  vt_core_mutualgroup_created: Array<MutualGroupType>;
  vt_plot_farm_created: Array<FarmType>;
  vt_plot_plot_created: Array<PlotType>;
  vt_plot_plotcrop_created: Array<PlotCropDetailType>;
  vt_plot_plotcropgrowthstage_created: Array<PlotCropGrowthStageType>;
  vt_plot_plotcropmilestone_created: Array<PlotCropMilestoneType>;
};

export type DepotGlType = {
  __typename?: 'DepotGlType';
  codename: Scalars['String'];
  distribution_centre?: Maybe<DistributionCentreGlType>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DeviceType = {
  __typename?: 'DeviceType';
  /** Version of the app */
  app_version?: Maybe<Scalars['String']>;
  base_user: BaseUserType;
  /** The name of the app package */
  bundle_id?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  description: Scalars['String'];
  /** The android device id */
  device_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  location?: Maybe<KiteAddressType>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  private_metadata: Scalars['JSONString'];
  token: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type DiscountGlType = {
  __typename?: 'DiscountGlType';
  code: Scalars['String'];
  created_at: Scalars['DateTime'];
  discount_conditions: Scalars['JSONString'];
  end_date: Scalars['Date'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  order_set: Array<OrderGlType>;
  percentage: Scalars['Float'];
  start_date: Scalars['Date'];
  updated_at: Scalars['DateTime'];
};

export type DistributionCentreGlFilterInput = {
  assigned_cpc?: InputMaybe<Scalars['ID']>;
  assigned_cpc__isnull?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  department_codename?: InputMaybe<Scalars['String']>;
  is_manufacturing_plant?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type DistributionCentreGlType = {
  __typename?: 'DistributionCentreGlType';
  address: AddressGlType;
  allowed_departments: Array<DepartmentGlType>;
  assigned_cpc?: Maybe<DistributionCentreGlType>;
  codename: Scalars['String'];
  delivery_conditions?: Maybe<Scalars['JSONScalar']>;
  delivery_slots: Array<TimeSlotGlType>;
  depot?: Maybe<DepotGlType>;
  docks: Array<DockGlType>;
  id: Scalars['ID'];
  maintenance_slots: Array<TimeSlotGlType>;
  name: Scalars['String'];
  organisation?: Maybe<OrganisationGlObject>;
  photos: Array<MediaGlType>;
  pickup_slots: Array<TimeSlotGlType>;
  point_of_contacts: Array<BaseUserGlType>;
  primary_poc?: Maybe<BaseUserGlType>;
};

export type DockDetailGlType = {
  __typename?: 'DockDetailGlType';
  dock: DockGlType;
  id: Scalars['ID'];
  kind: DockDetailKind;
  supervisor: BaseUserGlType;
  trip: TripGlType;
};

/** An enumeration. */
export enum DockDetailKind {
  /** Delivery */
  Delivery = 'DELIVERY',
  /** Loading */
  Loading = 'LOADING',
  /** Unloading */
  Unloading = 'UNLOADING'
}

export type DockFilterGlInput = {
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
};

export type DockGlType = {
  __typename?: 'DockGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  distribution_centre?: Maybe<DistributionCentreGlType>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DocumentInput = {
  attachments?: InputMaybe<Array<InputMaybe<KiteMediaInput>>>;
  document_kind_codename?: InputMaybe<Scalars['String']>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_number?: InputMaybe<Scalars['String']>;
  issued_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['Date']>;
  valid_till?: InputMaybe<Scalars['Date']>;
};

export type DocumentKindType = {
  __typename?: 'DocumentKindType';
  allowed_content_type: GeneralContentType;
  codename: Scalars['String'];
  description: Scalars['String'];
  document_set: Array<DocumentType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  /** The minimum number of attachements to be collected for thisdocument type */
  minimum_attachments?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type DocumentListResponseType = {
  __typename?: 'DocumentListResponseType';
  count?: Maybe<Scalars['Int']>;
  records?: Maybe<Array<Maybe<Scalars['JSONScalar']>>>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  attachments: Array<MediaType>;
  content_type: GeneralContentType;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  document_kind: DocumentKindType;
  document_kind_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  id_number: Scalars['String'];
  image_url?: Maybe<Scalars['String']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  issued_by: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  object_id: Scalars['Int'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  remarks: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  valid_from?: Maybe<Scalars['Date']>;
  valid_till?: Maybe<Scalars['Date']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type DurationSchema = {
  hours?: InputMaybe<Scalars['Int']>;
  minutes?: InputMaybe<Scalars['Int']>;
};

export type EcomMediaInput = {
  id?: InputMaybe<Scalars['ID']>;
  media_type: Scalars['String'];
  url: Scalars['String'];
};

export type EntityAttributeObject = {
  __typename?: 'EntityAttributeObject';
  attribute_value?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
};

export type ExpenseInput = {
  expense_parameter_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  paid_by?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type ExpenseParameterType = {
  __typename?: 'ExpenseParameterType';
  codename: Scalars['String'];
  config_organisationtradeexpenseconfig_expense_parameters: Array<OrganisationTradeExpenseConfigType>;
  description: Scalars['String'];
  expenses: Array<ExpenseType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ExpenseType = {
  __typename?: 'ExpenseType';
  amount?: Maybe<Scalars['Decimal']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  expense_parameter: ExpenseParameterType;
  id: Scalars['ID'];
  kind: TradeExpenseKindChoices;
  paid_by: TradeExpensePaidByChoices;
  receipt?: Maybe<ReceiptType>;
  trade?: Maybe<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
};

export type ExpensesConfigSchema = {
  expense_parameter_id: Scalars['Int'];
  kind: Scalars['String'];
  paid_by: Scalars['String'];
  value: Scalars['Float'];
};

export type FamilyGroupGlType = {
  __typename?: 'FamilyGroupGlType';
  /** Vendor's Business Address */
  address?: Maybe<AddressGlType>;
  id: Scalars['ID'];
  leader?: Maybe<BaseUserGlType>;
  name: Scalars['String'];
};

export type FarmAggregationType = {
  __typename?: 'FarmAggregationType';
  codename?: Maybe<Scalars['String']>;
  farmer?: Maybe<BaseUserType>;
  field_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  plot_count?: Maybe<Scalars['Int']>;
  plot_crop_count?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
};

export type FarmType = {
  __typename?: 'FarmType';
  address: KiteAddressType;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  description: Scalars['String'];
  farmer: BaseUserType;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  remarks: Scalars['String'];
  tag: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type FeatureType = {
  __typename?: 'FeatureType';
  /** Autogenerated UUID as Primary Key */
  id: Scalars['UUID'];
  is_active: Scalars['Boolean'];
  key: Scalars['String'];
  name: Scalars['String'];
  project: Scalars['String'];
  tutorial_set: Array<TutorialType>;
};

export type FilterSampleInput = {
  detection_count?: InputMaybe<Scalars['Int']>;
  market_id?: InputMaybe<Scalars['Int']>;
  max_detection?: InputMaybe<Scalars['Float']>;
  sample_date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  total_detection?: InputMaybe<Scalars['Float']>;
};

export type FinancialSummaryType = {
  __typename?: 'FinancialSummaryType';
  actual_expenses?: Maybe<Scalars['Float']>;
  actual_income?: Maybe<Scalars['Float']>;
  actual_profit?: Maybe<Scalars['Float']>;
  based_on_plot_crops?: Maybe<Scalars['Int']>;
  crop_year?: Maybe<Scalars['String']>;
  estimated_expenses?: Maybe<Scalars['Float']>;
  estimated_income?: Maybe<Scalars['Float']>;
  estimated_profit?: Maybe<Scalars['Float']>;
  exceeded_by?: Maybe<Scalars['Float']>;
  is_budget_low?: Maybe<Scalars['Boolean']>;
  is_expense_high?: Maybe<Scalars['Boolean']>;
  last_recorded_expense_date?: Maybe<Scalars['Date']>;
  last_recorded_expense_display_date?: Maybe<Scalars['String']>;
  last_recorded_income_date?: Maybe<Scalars['Date']>;
  last_recorded_income_display_date?: Maybe<Scalars['String']>;
  percent_actual_profit?: Maybe<Scalars['Float']>;
  percent_estimated_profit?: Maybe<Scalars['Float']>;
  percent_exceeded_by?: Maybe<Scalars['Float']>;
  percent_expenses_deviation?: Maybe<Scalars['Float']>;
  percent_income_deviation?: Maybe<Scalars['Float']>;
  percent_profit_deviation?: Maybe<Scalars['Float']>;
  percent_remaining_budget?: Maybe<Scalars['Float']>;
  remaining_budget?: Maybe<Scalars['Float']>;
  total_plot_crops?: Maybe<Scalars['Int']>;
};

export type FinancialTimelineTransactionType = {
  __typename?: 'FinancialTimelineTransactionType';
  activity_name?: Maybe<Scalars['String']>;
  activity_type?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<FinancialTransactionMediaType>>>;
  created_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['String']>;
  from_date?: Maybe<Scalars['Date']>;
  from_display_date?: Maybe<Scalars['String']>;
  hex_color_code?: Maybe<Scalars['String']>;
  icon_image_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_edited?: Maybe<Scalars['Boolean']>;
  purposes?: Maybe<Array<Maybe<PurposeAmountType>>>;
  record_date?: Maybe<Scalars['Date']>;
  record_display_date?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  transaction_category?: Maybe<Scalars['String']>;
  transaction_description?: Maybe<Scalars['String']>;
  transaction_notes?: Maybe<Scalars['String']>;
  transaction_type?: Maybe<Scalars['String']>;
  transaction_type_display?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['String']>;
};

export type FinancialTransactionInsertType = {
  __typename?: 'FinancialTransactionInsertType';
  activity_id?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  from_date?: Maybe<Scalars['Date']>;
  from_display_date?: Maybe<Scalars['String']>;
  hons_earned?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  record_date?: Maybe<Scalars['Date']>;
  record_display_date?: Maybe<Scalars['String']>;
  total_hons?: Maybe<Scalars['Int']>;
  transaction_description?: Maybe<Scalars['String']>;
  transaction_type?: Maybe<Scalars['String']>;
};

export type FinancialTransactionMediaType = {
  __typename?: 'FinancialTransactionMediaType';
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
};

export type GeneralContentType = {
  __typename?: 'GeneralContentType';
  actionlog_set: Array<ActionLogType>;
  app_label: Scalars['String'];
  document_set: Array<DocumentType>;
  documentkind_set: Array<DocumentKindType>;
  id: Scalars['ID'];
  model: Scalars['String'];
  paymentdetail_set: Array<PaymentDetailType>;
};

export type GenerateAgentToken = {
  __typename?: 'GenerateAgentToken';
  token?: Maybe<Scalars['String']>;
};

export type GenerateBaseUserToken = {
  __typename?: 'GenerateBaseUserToken';
  token?: Maybe<Scalars['String']>;
};

export type GenerateGenericToken = {
  __typename?: 'GenerateGenericToken';
  refresh_expires_in?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type GenerateInvoiceMutation = {
  __typename?: 'GenerateInvoiceMutation';
  invoices?: Maybe<Array<Maybe<InvoiceType>>>;
};

export type GenerateOtp = {
  __typename?: 'GenerateOTP';
  status?: Maybe<Scalars['Boolean']>;
};

export type GenerateTradeOtp = {
  __typename?: 'GenerateTradeOTP';
  status?: Maybe<Scalars['Boolean']>;
};

/**
 *
 * `GeometryObjectType` represents a pair of values:
 * - Geometry `type`
 * - Geometry `coordinates`
 *
 */
export type GeometryObjectType = {
  __typename?: 'GeometryObjectType';
  coordinates?: Maybe<Scalars['GenericScalar']>;
  type?: Maybe<Scalars['String']>;
};

export type GroupGlType = {
  __typename?: 'GroupGlType';
  allowed_dcs: Array<DistributionCentreGlType>;
  demand_set: Array<DemandGlType>;
  familygroup_set: Array<FamilyGroupGlType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  user_set: Array<BaseUserGlType>;
  /** Do not change! May result in inconsistencies. */
  visible_sellable_items: Array<SellableItemStockGlType>;
};

export type HarvestGradeGlType = {
  __typename?: 'HarvestGradeGlType';
  id: Scalars['ID'];
  name: Scalars['String'];
  specifications: Scalars['String'];
  variety?: Maybe<CommodityVarietyGlType>;
};

export type HarvestOperationSchema = {
  is_final?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Scalars['Float']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp_Remote_Rel_Tradecreated_By = {
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp_Remote_Rel_Tradeupdated_By = {
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type InvoiceType = {
  __typename?: 'InvoiceType';
  /** Sum of buyer expense amount in trades */
  buyer_expense_amount?: Maybe<Scalars['Decimal']>;
  /** Final amount buyer has to pay */
  buyer_payable_amount?: Maybe<Scalars['Decimal']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  date?: Maybe<Scalars['Date']>;
  /** Sum of deducted amount in trades */
  deducted_amount?: Maybe<Scalars['Decimal']>;
  /** Sum of deducted quantity in trades */
  deducted_quantity?: Maybe<Scalars['Decimal']>;
  /** Sum of expense amount in trades */
  expense_amount?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  reverse_status_mode: Scalars['Boolean'];
  standard_deduction?: Maybe<Scalars['Decimal']>;
  /** Sum of total amount in trades */
  total_amount?: Maybe<Scalars['Decimal']>;
  /** Sum of total quantity in trades */
  total_quantity?: Maybe<Scalars['Decimal']>;
  tracking_code: Scalars['String'];
  trades: Array<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type InwardBatchInput = {
  gross_weight?: InputMaybe<Scalars['Float']>;
  net_weight?: InputMaybe<Scalars['Float']>;
  sku_count?: InputMaybe<Scalars['Int']>;
  sku_tare_weight?: InputMaybe<Scalars['Float']>;
  sku_type?: InputMaybe<Scalars['Int']>;
  tare_weight?: InputMaybe<Scalars['Float']>;
};

export type InwardGlType = {
  __typename?: 'InwardGlType';
  booking: BookingGlType;
  date: Scalars['Date'];
  grade: HarvestGradeGlType;
  grn: Scalars['String'];
  id: Scalars['ID'];
  purchase_order?: Maybe<PurchaseOrderItemGlType>;
  status: InwardStatus;
};

export type InwardInput = {
  batches?: InputMaybe<Array<InputMaybe<InwardBatchInput>>>;
  booking?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
  farm_weight?: InputMaybe<Scalars['Float']>;
  final_weight?: InputMaybe<Scalars['Float']>;
  grade?: InputMaybe<Scalars['String']>;
  gross_weight?: InputMaybe<Scalars['Float']>;
  invoicing_done_on?: InputMaybe<Scalars['String']>;
  inwarded_quantity?: InputMaybe<Scalars['Int']>;
  net_weight?: InputMaybe<Scalars['Float']>;
  tare_weight?: InputMaybe<Scalars['Float']>;
  weight_loss?: InputMaybe<Scalars['Float']>;
};

/** An enumeration. */
export enum InwardStatus {
  /** Completed */
  Cmp = 'CMP',
  /** On Hold */
  Hld = 'HLD',
  /** Not Started */
  Nst = 'NST',
  /** Rejected */
  Rjc = 'RJC'
}

export type KiteAddressInput = {
  address_kind?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  village?: InputMaybe<Scalars['String']>;
};

export type KiteAddressType = {
  __typename?: 'KiteAddressType';
  address_kind: AddressAddressKind;
  baseuser_set: Array<BaseUserType>;
  business_address: Array<BusinessType>;
  /** The location details of the company, HQ or otherwise */
  company_address: Array<CompanyType>;
  country: Scalars['String'];
  created_at: Scalars['DateTime'];
  device_set: Array<DeviceType>;
  district: Scalars['String'];
  farm_set: Array<FarmType>;
  id: Scalars['ID'];
  local_area: Scalars['String'];
  location?: Maybe<GeometryObjectType>;
  media_set: Array<MediaType>;
  /** An address of a mutual group depicts a location out of which these related users operate out of */
  mutualgroup_set: Array<MutualGroupType>;
  name: Scalars['String'];
  organisation?: Maybe<OrganisationType>;
  pincode: Scalars['String'];
  raw_address?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  taluka: Scalars['String'];
  updated_at: Scalars['DateTime'];
  users_located: Array<BaseUserType>;
  village: Scalars['String'];
  w3w_code: Scalars['String'];
};

export type KiteMediaInput = {
  id?: InputMaybe<Scalars['ID']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  media_kind: Scalars['String'];
  url: Scalars['String'];
};

export type LocationData = {
  __typename?: 'LocationData';
  district?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  talukas?: Maybe<Array<Maybe<Scalars['String']>>>;
  villages?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Login = {
  __typename?: 'Login';
  me?: Maybe<BaseUserType>;
  payload: Scalars['GenericScalar'];
  refresh_expires_in: Scalars['Int'];
  refresh_token: Scalars['String'];
  token: Scalars['String'];
};

export type LonLatInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type MarketGlType = {
  __typename?: 'MarketGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  plotcommoditysample_set: Array<PlotCommoditySampleGlType>;
};

/** An enumeration. */
export enum MediaAccess {
  /** Private */
  Private = 'PRIVATE',
  /** Protected */
  Protected = 'PROTECTED',
  /** Public */
  Public = 'PUBLIC'
}

/** An enumeration. */
export enum MediaEntityMediaType {
  /** Folder */
  Fld = 'FLD',
  /** File */
  Fle = 'FLE',
  /** Photo */
  Pht = 'PHT',
  /** Video */
  Vdo = 'VDO'
}

export type MediaGlInput = {
  id?: InputMaybe<Scalars['ID']>;
  media_type: Scalars['String'];
  url: Scalars['String'];
};

export type MediaGlType = {
  __typename?: 'MediaGlType';
  id: Scalars['ID'];
  media_type: MediaEntityMediaType;
  url: Scalars['String'];
};

export type MediaType = {
  __typename?: 'MediaType';
  access: MediaAccess;
  baseuser_set: Array<BaseUserType>;
  business?: Maybe<BusinessType>;
  company?: Maybe<CompanyType>;
  created_at: Scalars['DateTime'];
  crop_set: Array<CropType>;
  /** Feature photo */
  cropinfestation_set: Array<CropInfestationDetailType>;
  cropvariety_set: Array<CropVarietyType>;
  department?: Maybe<DepartmentType>;
  document_set: Array<DocumentType>;
  etag?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_encrypted: Scalars['Boolean'];
  location?: Maybe<KiteAddressType>;
  media_kind?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  organisation?: Maybe<OrganisationType>;
  paymentdetail_set: Array<PaymentDetailType>;
  primarygrowthstage_set: Array<PrimaryGsType>;
  related_mutual_group?: Maybe<MutualGroupType>;
  related_user?: Maybe<BaseUserType>;
  size?: Maybe<Scalars['Int']>;
  thumbnail?: Maybe<Scalars['JSONString']>;
  updated_at: Scalars['DateTime'];
  url: Scalars['String'];
};

export type MediaUrlType = {
  __typename?: 'MediaUrlType';
  preview_url?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MetabaseUrlInput = {
  dashboard?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['Int']>;
};

export type MetabaseUrlType = {
  __typename?: 'MetabaseURLType';
  iframe_url?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum MilestoneDateFormat {
  /** Days */
  D = 'D',
  /** Month, Days */
  MD = 'M_D',
  /** Year, Month, Days */
  YMD = 'Y_M_D'
}

export type MilestoneDetailType = {
  __typename?: 'MilestoneDetailType';
  cropmilestone_set: Array<CropMilestoneType>;
  /** The representation of time elapsed */
  date_format: MilestoneDateFormat;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type MilestoneType = {
  __typename?: 'MilestoneType';
  crop_year?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  display_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  is_editable?: Maybe<Scalars['Boolean']>;
  iso_date?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  primary_milestone_name?: Maybe<Scalars['String']>;
  secondary_milestone_name?: Maybe<Scalars['String']>;
  time_elapsed?: Maybe<TimeElapsedObjectType>;
};

export type MutualGroupAggregationType = {
  __typename?: 'MutualGroupAggregationType';
  base_user_fullname?: Maybe<Scalars['String']>;
  farm_count?: Maybe<Scalars['Int']>;
  field_count?: Maybe<Scalars['Int']>;
  mutual_group?: Maybe<MutualGroupType>;
  plot_count?: Maybe<Scalars['Int']>;
  plot_crop_count?: Maybe<Scalars['Int']>;
  user_count?: Maybe<Scalars['Int']>;
};

export type MutualGroupAggregationTypeWithTotal = {
  __typename?: 'MutualGroupAggregationTypeWithTotal';
  records?: Maybe<Array<Maybe<MutualGroupAggregationType>>>;
  total?: Maybe<Scalars['Int']>;
};

export type MutualGroupMembersipType = {
  __typename?: 'MutualGroupMembersipType';
  base_user: BaseUserType;
  created_at: Scalars['DateTime'];
  crop_count?: Maybe<Scalars['Int']>;
  farmer_document_count?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  mutual_group: MutualGroupType;
  plot_count?: Maybe<Scalars['Int']>;
  plot_document_count?: Maybe<Scalars['Int']>;
  remark: Scalars['String'];
  tag_count?: Maybe<Scalars['Int']>;
  total_area?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
  village_count?: Maybe<Scalars['Int']>;
};

export type MutualGroupSummaryType = {
  __typename?: 'MutualGroupSummaryType';
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type MutualGroupType = {
  __typename?: 'MutualGroupType';
  address?: Maybe<KiteAddressType>;
  baseuser_set: Array<BaseUserType>;
  codename: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  data_consent?: Maybe<MediaType>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  lead_farmer?: Maybe<BaseUserType>;
  mutualgroupmembership_set: Array<MutualGroupMembersipType>;
  name: Scalars['String'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  region?: Maybe<RegionType>;
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<BaseUserType>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type MutualGroupWeatherStationType = {
  __typename?: 'MutualGroupWeatherStationType';
  gateway_id?: Maybe<Scalars['String']>;
  is_public?: Maybe<Scalars['Boolean']>;
  location_text?: Maybe<Scalars['String']>;
  mutual_group?: Maybe<MutualGroupType>;
  name?: Maybe<Scalars['String']>;
  network?: Maybe<NetworkType>;
};

export type MySellableItemStockFilterInput = {
  discounted_rate__gte?: InputMaybe<Scalars['Float']>;
  discounted_rate__lte?: InputMaybe<Scalars['Float']>;
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  is_cod_available?: InputMaybe<Scalars['Boolean']>;
  is_home_delivery_available?: InputMaybe<Scalars['Boolean']>;
  item_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rejected_stock_count__gte?: InputMaybe<Scalars['Int']>;
  sellable_item_id?: InputMaybe<Scalars['ID']>;
};

export type NetworkType = {
  __typename?: 'NetworkType';
  codename: Scalars['String'];
  company: CompanyType;
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  valid_from?: Maybe<Scalars['DateTime']>;
  valid_till?: Maybe<Scalars['DateTime']>;
};

export type NotificationByRegion = {
  __typename?: 'NotificationByRegion';
  count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type NotificationContent = {
  body: Scalars['String'];
  extra_fields?: InputMaybe<Scalars['JSONScalar']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NotificationMetrics = {
  __typename?: 'NotificationMetrics';
  category__name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type NotificationTemplateFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  value: Array<InputMaybe<Scalars['CustomGenericScalar']>>;
};

export type NotificationTotalMetrics = {
  __typename?: 'NotificationTotalMetrics';
  name?: Maybe<Scalars['String']>;
  seen_count?: Maybe<Scalars['Int']>;
  sent_count?: Maybe<Scalars['Int']>;
};

export type ObservationCategoriesQuery = {
  __typename?: 'ObservationCategoriesQuery';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ObservationDetailsResponse = {
  __typename?: 'ObservationDetailsResponse';
  area?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<OnFarmAttachmentSchema>>>;
  category?: Maybe<Scalars['String']>;
  crop_info?: Maybe<Scalars['String']>;
  crop_year?: Maybe<Scalars['String']>;
  farm_tag?: Maybe<Scalars['String']>;
  field_tag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latest_milestone?: Maybe<Scalars['String']>;
  notify?: Maybe<Scalars['Boolean']>;
  observation_details?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  parameter?: Maybe<Scalars['String']>;
  plot_crop_name?: Maybe<Scalars['String']>;
  plot_crop_tag?: Maybe<Scalars['String']>;
  record_date?: Maybe<Scalars['DateTime']>;
  recorded_by?: Maybe<Scalars['String']>;
  reply_count?: Maybe<Scalars['Int']>;
  subcategory?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ObservationList = {
  __typename?: 'ObservationList';
  count?: Maybe<Scalars['Int']>;
  records?: Maybe<Array<Maybe<ObservationDetailsResponse>>>;
};

export type ObservationSampleResponseType = {
  __typename?: 'ObservationSampleResponseType';
  computed_values?: Maybe<Array<Maybe<AggregatedSampleType>>>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  no_of_samples?: Maybe<Scalars['Int']>;
  recorded_values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Obtain JSON Web Token mutation */
export type ObtainJsonWebToken = {
  __typename?: 'ObtainJSONWebToken';
  payload: Scalars['GenericScalar'];
  refresh_expires_in: Scalars['Int'];
  refresh_token: Scalars['String'];
  token: Scalars['String'];
};

export type OnFarmAttachmentSchema = {
  __typename?: 'OnFarmAttachmentSchema';
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
};

export type OnFarmSiUnitType = {
  __typename?: 'OnFarmSIUnitType';
  codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type OperationDetail = {
  __typename?: 'OperationDetail';
  applied_products?: Maybe<Array<Maybe<AppliedProductsSchema>>>;
  attachments?: Maybe<Array<Maybe<OnFarmAttachmentSchema>>>;
  creator_name?: Maybe<Scalars['String']>;
  crop_year?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  is_applied?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  planned_operation_id?: Maybe<Scalars['String']>;
  plot_crop_id?: Maybe<Scalars['String']>;
  plot_crop_name?: Maybe<Scalars['String']>;
  plot_id?: Maybe<Scalars['String']>;
  plot_name?: Maybe<Scalars['String']>;
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
};

export type OperationList = {
  __typename?: 'OperationList';
  count?: Maybe<Scalars['Int']>;
  records?: Maybe<Array<Maybe<OperationDetail>>>;
};

export type OperationLonLatInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type OperationMethodSchema = {
  __typename?: 'OperationMethodSchema';
  crop_method_id?: Maybe<Scalars['UUID']>;
  display_name?: Maybe<Scalars['String']>;
  grace_period_in_days?: Maybe<Scalars['Int']>;
  has_products?: Maybe<Scalars['Boolean']>;
  has_water_quantity?: Maybe<Scalars['Boolean']>;
  image_url?: Maybe<Scalars['String']>;
  method_id?: Maybe<Scalars['UUID']>;
  water_quantity_units?: Maybe<Array<Maybe<OnFarmSiUnitType>>>;
};

export type OperationTypesSchema = {
  __typename?: 'OperationTypesSchema';
  image_url?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OrderFilterInput = {
  aggregator_id?: InputMaybe<Scalars['ID']>;
  approval_statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  approved_by_id?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  date__gte?: InputMaybe<Scalars['Date']>;
  date__lte?: InputMaybe<Scalars['Date']>;
  delivery_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Distribution centre ID */
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  distribution_centre_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  oib_return_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Valid only for pickup_date, date, pickup_slot_from_time, pickup_slot_to_time */
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order_categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order_categories_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  outstanding_amount_remaining?: InputMaybe<Scalars['Boolean']>;
  /** 'COD | CHQ and more' orders will be filtered according to payment method */
  payment_methods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  payment_methods_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  payment_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  payment_status_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pickup_date?: InputMaybe<Scalars['Date']>;
  pickup_date__gte?: InputMaybe<Scalars['Date']>;
  pickup_date__lte?: InputMaybe<Scalars['Date']>;
  pincodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placed_by_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  placed_in_codename?: InputMaybe<Scalars['String']>;
  /** department ID */
  placed_in_id?: InputMaybe<Scalars['ID']>;
  salesman_id?: InputMaybe<Scalars['ID']>;
  sellable_item_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** 'settled' status shows : Settled Transactions, 'unsettled' status shows : Unsettled Transactions */
  settlement_status?: InputMaybe<Scalars['String']>;
  supplying_dc_id?: InputMaybe<Scalars['ID']>;
  target_dc_id?: InputMaybe<Scalars['ID']>;
  transaction_date__gte?: InputMaybe<Scalars['Date']>;
  transaction_date__lte?: InputMaybe<Scalars['Date']>;
  /** 'COD | CHQ and more' orders and transactions will be filtered according to payment method */
  transaction_payment_methods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transaction_recorded_by_group?: InputMaybe<Scalars['String']>;
  transaction_recorded_by_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type OrderGlType = {
  __typename?: 'OrderGlType';
  billing_address?: Maybe<AddressGlType>;
  billing_doc: Array<BillingDocGlType>;
  created_at: Scalars['DateTime'];
  date: Scalars['Date'];
  delivery_status?: Maybe<Scalars['String']>;
  discount?: Maybe<DiscountGlType>;
  id: Scalars['ID'];
  latest_transaction?: Maybe<OrderTransactionGlType>;
  order_category?: Maybe<Scalars['String']>;
  order_items: Array<OrderItemGlType>;
  order_status?: Maybe<Scalars['String']>;
  ordering_dc?: Maybe<DistributionCentreGlType>;
  otp: Scalars['Int'];
  outstanding_amount: Scalars['Float'];
  payment_method?: Maybe<Scalars['String']>;
  payment_status?: Maybe<Scalars['String']>;
  pickup_date?: Maybe<Scalars['Date']>;
  pickup_slot_from_time?: Maybe<Scalars['Time']>;
  pickup_slot_to_time?: Maybe<Scalars['Time']>;
  placed_by?: Maybe<BaseUserGlType>;
  placed_in?: Maybe<DepartmentGlType>;
  poc_name: Scalars['String'];
  poc_number: Scalars['String'];
  remark: Scalars['String'];
  selected_pickup_slot?: Maybe<TimeSlotGlType>;
  shipping_address: AddressGlType;
  shipping_charges: Scalars['Float'];
  shipping_method?: Maybe<Scalars['String']>;
  status_logs: Array<OrderStatusLogGlType>;
  target_dc?: Maybe<DistributionCentreGlType>;
  taxes: Array<TaxGlType>;
  total_amount: Scalars['Float'];
  tracking_code: Scalars['String'];
  transactions: Array<OrderTransactionGlType>;
  updated_at: Scalars['DateTime'];
  user: BaseUserGlType;
};

export type OrderItemGlType = {
  __typename?: 'OrderItemGlType';
  actual_rate: Scalars['Float'];
  approved_rate: Scalars['Float'];
  created_at: Scalars['DateTime'];
  delivered_quantity?: Maybe<Scalars['Int']>;
  delivered_taxed_item_cost?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  item_actual_cost?: Maybe<Scalars['Float']>;
  item_cost?: Maybe<Scalars['Float']>;
  item_status?: Maybe<Scalars['String']>;
  item_stock?: Maybe<SellableItemStockGlType>;
  order: OrderGlType;
  quantity: Scalars['Int'];
  rate: Scalars['Float'];
  remark?: Maybe<Scalars['String']>;
  sellable_item: SellableItemGlType;
  settled_quantity?: Maybe<Scalars['Int']>;
  settlement_remark?: Maybe<Scalars['String']>;
  shipping?: Maybe<ShippingGlType>;
  tax_rate: Scalars['Float'];
  taxed_item_cost?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
};

export type OrderItemStockInput = {
  actual_rate?: InputMaybe<Scalars['Float']>;
  approval_status?: InputMaybe<Scalars['String']>;
  approver_remark?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<InputMaybe<EcomMediaInput>>>;
  batch_stock_rate_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  ordering_item_stock_id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  rate?: InputMaybe<Scalars['Float']>;
  rejection_rate?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  requested_at?: InputMaybe<Scalars['Date']>;
  sellable_item_stock_id: Scalars['ID'];
};

export type OrderPickupSlotInput = {
  distribution_centre_id: Scalars['ID'];
  time_slot_id: Scalars['ID'];
};

export type OrderStatusLogGlType = {
  __typename?: 'OrderStatusLogGlType';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  order: OrderGlType;
  status?: Maybe<Scalars['String']>;
  status_type?: Maybe<Scalars['String']>;
  trip?: Maybe<TripGlType>;
  updated_at: Scalars['DateTime'];
};

export type OrderTransactionGlType = {
  __typename?: 'OrderTransactionGlType';
  amount: Scalars['Float'];
  attachment?: Maybe<MediaGlType>;
  billing_doc?: Maybe<Array<Maybe<BillingDocGlType>>>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  order: OrderGlType;
  payment_method?: Maybe<Scalars['String']>;
  recorded_by?: Maybe<BaseUserGlType>;
  reference_id: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  settled_for_transaction?: Maybe<OrderTransactionGlType>;
  settlement_remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trip?: Maybe<TripGlType>;
  /** Only captured transaction will have unsettled amount */
  unsettled_amount?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
  user: BaseUserGlType;
};

export type OrganisationGlObject = {
  __typename?: 'OrganisationGlObject';
  address?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
};

export type OrganisationPricingGlType = {
  __typename?: 'OrganisationPricingGlType';
  created_at: Scalars['DateTime'];
  end_date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  organisation_rate: Scalars['Float'];
  start_date?: Maybe<Scalars['Date']>;
  supplier_rate: Scalars['Float'];
  tax_percentage: Scalars['Float'];
  unit: SiUnitGlType;
  updated_at: Scalars['DateTime'];
};

export type OrganisationTradeExpenseConfigType = {
  __typename?: 'OrganisationTradeExpenseConfigType';
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  expense_parameter: ExpenseParameterType;
  id: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
  paid_by?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
  version: Scalars['Int'];
};

export type OrganisationTradeExpensesTemplateSchema = {
  __typename?: 'OrganisationTradeExpensesTemplateSchema';
  buyer_charge?: Maybe<Scalars['Decimal']>;
  expense_parameter?: Maybe<Scalars['String']>;
  expense_parameter_id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  seller_charge?: Maybe<Scalars['Decimal']>;
};

export type OrganisationTradeExpensesVersionSchema = {
  __typename?: 'OrganisationTradeExpensesVersionSchema';
  default?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  version_id?: Maybe<Scalars['Int']>;
};

export type OrganisationTradeTnCsTemplateSchema = {
  __typename?: 'OrganisationTradeTNCsTemplateSchema';
  buyer?: Maybe<Scalars['String']>;
  facilitator?: Maybe<Scalars['String']>;
  seller?: Maybe<Scalars['String']>;
};

export type OrganisationTradeTnCsVersionSchema = {
  __typename?: 'OrganisationTradeTNCsVersionSchema';
  default?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  version_id?: Maybe<Scalars['Int']>;
};

export type OrganisationType = {
  __typename?: 'OrganisationType';
  /** Abbreviation for short name */
  abbreviation: Scalars['String'];
  address: KiteAddressType;
  agents: Array<AgentType>;
  codename: Scalars['String'];
  /** The organisation that manages the company */
  companies: Array<CompanyType>;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  description: Scalars['String'];
  /** Display name for showing on the website */
  display_name: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  photo?: Maybe<MediaType>;
  private_metadata: Scalars['JSONString'];
  /** Terms and conditions */
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
};

export type OtherAppliedProductsOperationSchema = {
  product_name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

export type PackageArticleSchema = {
  __typename?: 'PackageArticleSchema';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PackageDetail = {
  __typename?: 'PackageDetail';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Parameters = {
  __typename?: 'Parameters';
  compute_avg?: Maybe<Scalars['Boolean']>;
  compute_max?: Maybe<Scalars['Boolean']>;
  compute_min?: Maybe<Scalars['Boolean']>;
  compute_sum?: Maybe<Scalars['Boolean']>;
  data_choices?: Maybe<Array<Maybe<DataChoices>>>;
  data_type?: Maybe<Scalars['String']>;
  data_unit_choices?: Maybe<Array<Maybe<DataUnitChoices>>>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  max_attachments_per_sample?: Maybe<Scalars['Int']>;
  max_samples?: Maybe<Scalars['Int']>;
  min_samples?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sub_category?: Maybe<Scalars['String']>;
};

export type PayUHashType = {
  __typename?: 'PayUHashType';
  hash_value?: Maybe<Scalars['String']>;
};

export type PayUPayload = {
  __typename?: 'PayUPayload';
  data?: Maybe<Scalars['JSONScalar']>;
};

export type PaymentDetailInput = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<InputMaybe<KiteMediaInput>>>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  method_id?: InputMaybe<Scalars['Int']>;
};

export type PaymentDetailType = {
  __typename?: 'PaymentDetailType';
  account_holder_name: Scalars['String'];
  account_number: Scalars['String'];
  attachments: Array<MediaType>;
  bank_name: Scalars['String'];
  baseuser_set: Array<BaseUserType>;
  branch_name: Scalars['String'];
  content_type: GeneralContentType;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  id: Scalars['ID'];
  ifsc_code: Scalars['String'];
  is_verified?: Maybe<Scalars['Boolean']>;
  method: PaymentMethodType;
  object_id: Scalars['Int'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type PaymentMethodType = {
  __typename?: 'PaymentMethodType';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  paymentdetail_set: Array<PaymentDetailType>;
};

export type PlaceOrder = {
  __typename?: 'PlaceOrder';
  order?: Maybe<OrderGlType>;
};

export type PlotAssessmentGlType = {
  __typename?: 'PlotAssessmentGlType';
  id: Scalars['ID'];
  seal_number: Scalars['String'];
};

export type PlotCommodityFilterInput = {
  assigned_to?: InputMaybe<Scalars['Int']>;
  company_tags?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  crop?: InputMaybe<Scalars['String']>;
  harvesting_date?: InputMaybe<Scalars['Date']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  po_status?: InputMaybe<Scalars['Boolean']>;
  sampling_status?: InputMaybe<FilterSampleInput>;
  sowing_date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updated_after?: InputMaybe<Scalars['DateTime']>;
  variety_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  village?: InputMaybe<Scalars['String']>;
};

export type PlotCommodityGlType = {
  __typename?: 'PlotCommodityGlType';
  agronomist?: Maybe<BaseUserGlType>;
  assessment?: Maybe<PlotAssessmentGlType>;
  growing_cycle: Scalars['Int'];
  harvesting_date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  plot: PlotGlType;
  reference_id: Scalars['String'];
  registration_code: Scalars['String'];
  samples: Array<PlotCommoditySampleGlType>;
  sowing_date?: Maybe<Scalars['Date']>;
  status: PlotCommodityStatus;
  variety: CommodityVarietyGlType;
};

/** An enumeration. */
export enum PlotCommoditySampleChemicalStatus {
  /** Pass */
  Dn = 'DN',
  /** Not Sampled */
  Nd = 'ND',
  /** Fail */
  Rj = 'RJ',
  /** Waiting */
  Wt = 'WT'
}

export type PlotCommoditySampleGlType = {
  __typename?: 'PlotCommoditySampleGlType';
  chemical_status: PlotCommoditySampleChemicalStatus;
  chemical_test_date: Scalars['Date'];
  created: Scalars['DateTime'];
  detection_count: Scalars['Int'];
  id: Scalars['ID'];
  market?: Maybe<MarketGlType>;
  max_detection: Scalars['Float'];
  physical_status: PlotCommoditySamplePhysicalStatus;
  physical_test_date: Scalars['Date'];
  plot_commodity: PlotCommodityGlType;
  total_detection: Scalars['Float'];
  updated: Scalars['DateTime'];
};

/** An enumeration. */
export enum PlotCommoditySamplePhysicalStatus {
  /** Pass */
  Dn = 'DN',
  /** Not Sampled */
  Nd = 'ND',
  /** Fail */
  Rj = 'RJ',
  /** Waiting */
  Wt = 'WT'
}

/** An enumeration. */
export enum PlotCommodityStatus {
  /** Harvesting Done */
  Cmp = 'CMP',
  /** On Hold */
  Hld = 'HLD',
  /** Not Ready for Harvest */
  Nrd = 'NRD',
  /** Ready for Harvest */
  Rdy = 'RDY',
  /** Scheduled for Harvest */
  Sch = 'SCH',
  /** Harvest in Progress */
  Wip = 'WIP'
}

export type PlotCropBudgetSetType = {
  __typename?: 'PlotCropBudgetSetType';
  codename?: Maybe<Scalars['String']>;
  crop?: Maybe<Scalars['String']>;
  farm_tag?: Maybe<Scalars['String']>;
  field_area?: Maybe<Scalars['Float']>;
  field_area_unit?: Maybe<Scalars['String']>;
  field_tag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  is_budget_set?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  plot_area?: Maybe<Scalars['Float']>;
  plot_area_unit?: Maybe<Scalars['String']>;
  plot_owner?: Maybe<Scalars['String']>;
  plot_tag?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  variety?: Maybe<Scalars['String']>;
};

export type PlotCropDetailType = {
  __typename?: 'PlotCropDetailType';
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  crop?: Maybe<CropType>;
  crop_variety?: Maybe<CropVarietyType>;
  crop_year?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  estd_harvest_quantity?: Maybe<Scalars['Decimal']>;
  estd_harvest_quantity_unit?: Maybe<SiUnitType>;
  estd_harvesting_date?: Maybe<Scalars['Date']>;
  estd_sowing_date?: Maybe<Scalars['Date']>;
  farm_tag?: Maybe<Scalars['String']>;
  farmer: BaseUserType;
  field_tag?: Maybe<Scalars['String']>;
  growing_cycle: Scalars['Int'];
  harvest_quantity?: Maybe<Scalars['Decimal']>;
  harvest_quantity_unit?: Maybe<SiUnitType>;
  harvesting_date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Int']>;
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_budget_set?: Maybe<Scalars['Boolean']>;
  is_seed: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  latest_milestone?: Maybe<MilestoneType>;
  metadata: Scalars['JSONString'];
  milestone_recording_enabled?: Maybe<Scalars['Boolean']>;
  milestones?: Maybe<Array<Maybe<MilestoneType>>>;
  name: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  p2p_distance?: Maybe<Scalars['Decimal']>;
  p2p_distance_unit?: Maybe<SiUnitType>;
  plant_count: Scalars['Int'];
  plot?: Maybe<PlotType>;
  plot_area?: Maybe<Scalars['Float']>;
  plot_area_unit?: Maybe<Scalars['String']>;
  plot_tag?: Maybe<Scalars['String']>;
  plotcropgrowthstage_set: Array<PlotCropGrowthStageType>;
  plotcropmilestone_set: Array<PlotCropMilestoneType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  r2r_distance?: Maybe<Scalars['Decimal']>;
  r2r_distance_unit?: Maybe<SiUnitType>;
  sowing_date?: Maybe<Scalars['Date']>;
  tag: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  variety_name?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type PlotCropExpenseByDateType = {
  __typename?: 'PlotCropExpenseByDateType';
  details?: Maybe<Array<Maybe<PurposeAmountType>>>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type PlotCropGrowthStageType = {
  __typename?: 'PlotCropGrowthStageType';
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  date: Scalars['Date'];
  id?: Maybe<Scalars['Int']>;
  plot_crop: PlotCropDetailType;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
};

export type PlotCropGrowthStagesType = {
  __typename?: 'PlotCropGrowthStagesType';
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_milestone_stage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_current_stage?: Maybe<Scalars['Boolean']>;
  max_days_after?: Maybe<Scalars['Int']>;
  milestone_stage?: Maybe<Scalars['String']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_url?: Maybe<Scalars['String']>;
  primary_growth_stage?: Maybe<PrimaryGsType>;
  stage_length?: Maybe<Scalars['String']>;
  stage_status?: Maybe<Scalars['String']>;
};

export type PlotCropIncomeByDateType = {
  __typename?: 'PlotCropIncomeByDateType';
  details?: Maybe<Array<Maybe<PurposeAmountType>>>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
};

export type PlotCropMilestoneType = {
  __typename?: 'PlotCropMilestoneType';
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  crop_milestone: CropMilestoneType;
  date: Scalars['Date'];
  id?: Maybe<Scalars['Int']>;
  plot_crop: PlotCropDetailType;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
};

export type PlotCropSearchInput = {
  status__codename?: InputMaybe<Scalars['ID']>;
};

export type PlotCropTimelineTransactionType = {
  __typename?: 'PlotCropTimelineTransactionType';
  area?: Maybe<UnitAndValueType>;
  crop_info?: Maybe<CropInfoType>;
  farm_tag?: Maybe<Scalars['String']>;
  field_tag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  latest_milestone?: Maybe<MilestoneType>;
  owner?: Maybe<Scalars['String']>;
  plot_crop_codename?: Maybe<Scalars['String']>;
  plot_crop_tag?: Maybe<Scalars['String']>;
  plot_tag?: Maybe<Scalars['String']>;
  transaction_history?: Maybe<Array<Maybe<FinancialTimelineTransactionType>>>;
};

export type PlotCropTransactionCategoryTypes = {
  __typename?: 'PlotCropTransactionCategoryTypes';
  expenses?: Maybe<Array<Maybe<CategoryType>>>;
  income?: Maybe<Array<Maybe<CategoryType>>>;
};

export type PlotCropTransactionInsertType = {
  __typename?: 'PlotCropTransactionInsertType';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  record_date?: Maybe<Scalars['Date']>;
  transaction_type?: Maybe<Scalars['String']>;
};

export type PlotCropType = {
  __typename?: 'PlotCropType';
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  crop: CropType;
  crop_variety?: Maybe<CropVarietyType>;
  crop_year?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  estd_harvest_quantity?: Maybe<Scalars['Decimal']>;
  estd_harvest_quantity_unit?: Maybe<SiUnitType>;
  estd_harvesting_date?: Maybe<Scalars['Date']>;
  estd_sowing_date?: Maybe<Scalars['Date']>;
  external_reference_id?: Maybe<Scalars['String']>;
  farmer: BaseUserType;
  growing_cycle: Scalars['Int'];
  harvest_quantity?: Maybe<Scalars['Decimal']>;
  harvest_quantity_unit?: Maybe<SiUnitType>;
  harvesting_date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_seed: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  p2p_distance?: Maybe<Scalars['Decimal']>;
  p2p_distance_unit?: Maybe<SiUnitType>;
  plant_count: Scalars['Int'];
  plot: PlotType;
  plotcropgrowthstage_set: Array<PlotCropGrowthStageType>;
  plotcropmilestone_set: Array<PlotCropMilestoneType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  r2r_distance?: Maybe<Scalars['Decimal']>;
  r2r_distance_unit?: Maybe<SiUnitType>;
  sowing_date?: Maybe<Scalars['Date']>;
  tag: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type PlotGlType = {
  __typename?: 'PlotGlType';
  address: AddressGlType;
  area: Scalars['Float'];
  codename: Scalars['String'];
  farmer: BaseUserGlType;
  gat_number?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PlotProperties = {
  __typename?: 'PlotProperties';
  area?: Maybe<Scalars['Decimal']>;
  area_unit?: Maybe<SiUnitType>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  description: Scalars['String'];
  farmer: BaseUserType;
  /** Internally used to filter fields to fix data */
  geo_area_remark?: Maybe<Scalars['Float']>;
  /** Area auto calculated by boundaries in acre */
  geo_bound_area?: Maybe<Scalars['Float']>;
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  plotcrop_set: Array<PlotCropDetailType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  tag: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type PlotRiskTotalQuery = {
  __typename?: 'PlotRiskTotalQuery';
  risk?: Maybe<Scalars['String']>;
  total_plots?: Maybe<Scalars['Int']>;
};

export type PlotType = {
  __typename?: 'PlotType';
  bbox?: Maybe<Scalars['GenericScalar']>;
  geometry: GeometryObjectType;
  id: Scalars['ID'];
  properties?: Maybe<PlotProperties>;
  type?: Maybe<Scalars['String']>;
};

export type PrimaryGsType = {
  __typename?: 'PrimaryGSType';
  /** Base stage, Planting, Sowing, Pruning */
  base_stage: PrimaryGrowthStageBaseStage;
  /** PGS-0# */
  code: Scalars['String'];
  codename: Scalars['String'];
  crop: CropType;
  description: Scalars['String'];
  id: Scalars['ID'];
  /** URL of the image related to this crop monitoring parameter */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  /** Maximum days after base stage */
  max_days_after: Scalars['Int'];
  /** Minimum days after base stage */
  min_days_after: Scalars['Int'];
  name: Scalars['String'];
  photo?: Maybe<MediaType>;
};

/** An enumeration. */
export enum PrimaryGrowthStageBaseStage {
  /** Foundation Pruning */
  FoundationPruning = 'FOUNDATION_PRUNING',
  /** Fruit Pruning */
  FruitPruning = 'FRUIT_PRUNING',
  /** Planting */
  Planting = 'PLANTING',
  /** Sowing */
  Sowing = 'SOWING'
}

export type PrimaryGrowthStagesType = {
  __typename?: 'PrimaryGrowthStagesType';
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_milestone_stage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_current_stage?: Maybe<Scalars['Boolean']>;
  max_days_after?: Maybe<Scalars['Int']>;
  milestone_stage?: Maybe<Scalars['String']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_url?: Maybe<Scalars['String']>;
  secondary_growth_stages?: Maybe<Array<Maybe<SecondaryGrowthStagesType>>>;
  stage_length?: Maybe<Scalars['String']>;
  stage_status?: Maybe<Scalars['String']>;
};

export type PurchaseOrderGlType = {
  __typename?: 'PurchaseOrderGlType';
  code: Scalars['String'];
  id: Scalars['ID'];
};

export type PurchaseOrderItemGlType = {
  __typename?: 'PurchaseOrderItemGlType';
  id: Scalars['ID'];
  po: PurchaseOrderGlType;
};

export type PurposeAmountType = {
  __typename?: 'PurposeAmountType';
  amount?: Maybe<Scalars['Float']>;
  display_value?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type PurposeExpenseType = {
  amount: Scalars['Float'];
  purpose: Scalars['String'];
};

export type ReceiptInput = {
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['ID']>;
  commodity_variety_id?: InputMaybe<Scalars['ID']>;
  department_id?: InputMaybe<Scalars['ID']>;
  end_date?: InputMaybe<Scalars['String']>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseInput>>>;
  expiry?: InputMaybe<Scalars['String']>;
  facilitator_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  plot_crop_id?: InputMaybe<Scalars['ID']>;
  seller_id?: InputMaybe<Scalars['ID']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['Decimal']>;
  start_date?: InputMaybe<Scalars['String']>;
  trades?: InputMaybe<Array<InputMaybe<ReceiptTradeInput>>>;
};

export type ReceiptTradeInput = {
  buyer_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<InputMaybe<TradeItemInput>>>;
};

export type ReceiptType = {
  __typename?: 'ReceiptType';
  buyer_tnc?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  /** Total amount reducing std. deduction */
  deducted_amount?: Maybe<Scalars['Decimal']>;
  /** Total quantity reducing std. deduction */
  deducted_quantity?: Maybe<Scalars['Decimal']>;
  end_date?: Maybe<Scalars['Date']>;
  /** Only expense amount */
  expense_amount?: Maybe<Scalars['Decimal']>;
  expiry?: Maybe<Scalars['Date']>;
  group_expenses: Array<ExpenseType>;
  id: Scalars['ID'];
  kind: TradeReceiptKindChoices;
  mode: TradeReceiptModeChoices;
  packaging: TradeReceiptPackagingChoices;
  /** Sum of seller expense amount in trades */
  seller_expense_amount?: Maybe<Scalars['Decimal']>;
  /** Final amount seller can receive */
  seller_receivable_amount?: Maybe<Scalars['Decimal']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['Decimal']>;
  start_date?: Maybe<Scalars['Date']>;
  /** Sum of total amount in trades */
  total_amount?: Maybe<Scalars['Decimal']>;
  /** Sum of total amount in trades */
  total_quantity?: Maybe<Scalars['Decimal']>;
  tracking_code: Scalars['String'];
  trades: Array<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type RecordCropMilestone = {
  __typename?: 'RecordCropMilestone';
  plot_crop_milestones?: Maybe<Array<Maybe<PlotCropMilestoneType>>>;
};

export type RecordExpenseMutation = {
  __typename?: 'RecordExpenseMutation';
  plot_crop_transaction?: Maybe<PlotCropTransactionInsertType>;
};

export type RecordExpenseMutationV2 = {
  __typename?: 'RecordExpenseMutationV2';
  plot_crop_transaction?: Maybe<FinancialTransactionInsertType>;
};

export type RecordGrowthStage = {
  __typename?: 'RecordGrowthStage';
  growth_stage?: Maybe<PlotCropGrowthStageType>;
};

export type RecordIncomeMutation = {
  __typename?: 'RecordIncomeMutation';
  plot_crop_transaction?: Maybe<PlotCropTransactionInsertType>;
};

export type RecordIncomeMutationV2 = {
  __typename?: 'RecordIncomeMutationV2';
  plot_crop_transaction?: Maybe<FinancialTransactionInsertType>;
};

export type Refresh = {
  __typename?: 'Refresh';
  payload: Scalars['GenericScalar'];
  refresh_expires_in: Scalars['Int'];
  refresh_token: Scalars['String'];
  token: Scalars['String'];
};

export type RegionType = {
  __typename?: 'RegionType';
  codename: Scalars['String'];
  description: Scalars['String'];
  geom?: Maybe<GeometryObjectType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  /** The region in which this mutual group is situated at */
  mutualgroup_set: Array<MutualGroupType>;
  name: Scalars['String'];
  parent_region?: Maybe<RegionType>;
  regions: Array<RegionType>;
};

export type SiUnitGlType = {
  __typename?: 'SIUnitGlType';
  base_conversion: Scalars['Float'];
  base_unit?: Maybe<SiUnitGlType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SiUnitType = {
  __typename?: 'SIUnitType';
  base_conversion: Scalars['Decimal'];
  base_unit?: Maybe<SiUnitType>;
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  plot_set: Array<PlotType>;
  siunit_set: Array<SiUnitType>;
  vt_plot_plotcrop_estd_harvest_quantity_unit: Array<PlotCropDetailType>;
  vt_plot_plotcrop_harvest_quantity_unit: Array<PlotCropDetailType>;
  vt_plot_plotcrop_p2p_distance_unit: Array<PlotCropDetailType>;
  vt_plot_plotcrop_r2r_distance_unit: Array<PlotCropDetailType>;
};

export type SkuTypeGlType = {
  __typename?: 'SKUTypeGlType';
  capacity: Scalars['Float'];
  capacity_unit: SiUnitGlType;
  codename: Scalars['UUID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SampleRecordType = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  choice_id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  parameter_id?: InputMaybe<Scalars['String']>;
  recorded_unit_id?: InputMaybe<Scalars['String']>;
  recorded_value?: InputMaybe<Scalars['String']>;
};

export type ScheduleGlType = {
  __typename?: 'ScheduleGlType';
  aggregator?: Maybe<BaseUserGlType>;
  commodity_code?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyGlType>;
  crop_group?: Maybe<CommodityGroupGlType>;
  date: Scalars['Date'];
  destination_depot?: Maybe<DepotGlType>;
  gate_pass: Scalars['String'];
  id: Scalars['ID'];
  labour_count: Scalars['Int'];
  plot_commodity: PlotCommodityGlType;
  schedule_request?: Maybe<ScheduleRequestGlType>;
  scheduled_in?: Maybe<DepartmentGlType>;
  sku_type?: Maybe<SkuTypeGlType>;
  source_depot?: Maybe<DepotGlType>;
  variety: CommodityVarietyGlType;
  vehicle?: Maybe<VehicleGlType>;
};

export type ScheduleRequestGlType = {
  __typename?: 'ScheduleRequestGlType';
  id: Scalars['ID'];
  raised_by: BaseUserGlType;
  raised_in: DepartmentGlType;
  request_approved_by?: Maybe<BaseUserGlType>;
  sku_count: Scalars['Int'];
  sku_type: SkuTypeGlType;
  time_slot?: Maybe<TimeSlotRequirementGlType>;
};

export type SecondaryGrowthStagesType = {
  __typename?: 'SecondaryGrowthStagesType';
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_milestone_stage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_current_stage?: Maybe<Scalars['Boolean']>;
  max_days_after?: Maybe<Scalars['Int']>;
  milestone_stage?: Maybe<Scalars['String']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_url?: Maybe<Scalars['String']>;
  stage_length?: Maybe<Scalars['String']>;
  stage_status?: Maybe<Scalars['String']>;
};

export type SellableItemGlType = {
  __typename?: 'SellableItemGlType';
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  fscodename?: Maybe<Scalars['String']>;
  fsmeta?: Maybe<Scalars['JSONScalar']>;
  id: Scalars['ID'];
  long_description: Scalars['String'];
  name: Scalars['String'];
  overall_rating: Scalars['Float'];
  primary_photo: MediaGlType;
  related_item?: Maybe<SellableItemGlType>;
  related_quantity: Scalars['Int'];
  secondary_sku_type?: Maybe<SkuTypeGlType>;
  sellable_stocks: Array<SellableItemStockGlType>;
  short_description: Scalars['String'];
  taxes: Array<TaxGlType>;
  transportation_type: SellableItemTransportationType;
  updated_at: Scalars['DateTime'];
};

export type SellableItemStockGlType = {
  __typename?: 'SellableItemStockGlType';
  booked_stock_count: Scalars['Int'];
  created_at: Scalars['DateTime'];
  current_stock_count: Scalars['Int'];
  department?: Maybe<DepartmentGlType>;
  discounted_rate: Scalars['Float'];
  distribution_centre: DistributionCentreGlType;
  dumped_stock_count: Scalars['Int'];
  expiry_date?: Maybe<Scalars['DateTime']>;
  hold_stock_count: Scalars['Int'];
  id: Scalars['ID'];
  intransit_stock_count: Scalars['Int'];
  is_live: Scalars['Boolean'];
  max_rate: Scalars['Float'];
  min_rate: Scalars['Float'];
  offer_stock_count: Scalars['Int'];
  ordering_conditions: Scalars['JSONString'];
  rejected_stock_count: Scalars['Int'];
  related_stock?: Maybe<SellableItemStockGlType>;
  sellable_item: SellableItemGlType;
  unit_rate: Scalars['Float'];
  updated_at: Scalars['DateTime'];
};

/** An enumeration. */
export enum SellableItemTransportationType {
  /** Normal */
  Nr = 'NR',
  /** Other */
  Ot = 'OT',
  /** Refrigerated */
  Rf = 'RF'
}

export type SendNotification = {
  __typename?: 'SendNotification';
  success?: Maybe<Scalars['Boolean']>;
};

export type SeriesArticleList = {
  __typename?: 'SeriesArticleList';
  article_id?: Maybe<Scalars['String']>;
  assessment_id?: Maybe<Scalars['String']>;
  assessment_name?: Maybe<Scalars['String']>;
  favorites?: Maybe<Scalars['Int']>;
  likes?: Maybe<Scalars['Int']>;
  next_id?: Maybe<Scalars['String']>;
  next_title?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  series_article_id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  views?: Maybe<Scalars['Int']>;
};

export type SeriesDetail = {
  __typename?: 'SeriesDetail';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  is_active?: Maybe<Scalars['Boolean']>;
  lecture_count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  package?: Maybe<ArticleSubcriptionPackageType>;
  total_favorites?: Maybe<Scalars['Int']>;
  total_likes?: Maybe<Scalars['Int']>;
  total_views?: Maybe<Scalars['Int']>;
};

export type SeriesLectureList = {
  __typename?: 'SeriesLectureList';
  articles?: Maybe<Array<Maybe<SeriesArticleList>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  package?: Maybe<PackageDetail>;
  package_articles?: Maybe<Array<Maybe<PackageArticleSchema>>>;
  subscription_count?: Maybe<Scalars['Int']>;
};

export type SeriesList = {
  __typename?: 'SeriesList';
  count?: Maybe<Scalars['Int']>;
  records?: Maybe<Array<Maybe<SeriesDetail>>>;
};

export type SetBaseUserFieldsMutation = {
  __typename?: 'SetBaseUserFieldsMutation';
  base_user?: Maybe<BaseUserType>;
};

export type SetBudgetMutation = {
  __typename?: 'SetBudgetMutation';
  plot_crop_transaction?: Maybe<PlotCropTransactionInsertType>;
};

export type SetBudgetMutationV2 = {
  __typename?: 'SetBudgetMutationV2';
  plot_crop_transaction?: Maybe<FinancialTransactionInsertType>;
};

export type SetBusinessFieldsMutation = {
  __typename?: 'SetBusinessFieldsMutation';
  business?: Maybe<BusinessType>;
};

export type SetDocumentAttachmentsMutation = {
  __typename?: 'SetDocumentAttachmentsMutation';
  document?: Maybe<DocumentType>;
};

export type SetPaymentDetailAttachmentsMutation = {
  __typename?: 'SetPaymentDetailAttachmentsMutation';
  payment_detail?: Maybe<PaymentDetailType>;
};

export type ShippingGlType = {
  __typename?: 'ShippingGlType';
  actual_delivery?: Maybe<Scalars['DateTime']>;
  charges: Scalars['Float'];
  created_at: Scalars['DateTime'];
  delivery_remark: Scalars['String'];
  delivery_status?: Maybe<Scalars['String']>;
  delivery_taxes: Array<TaxGlType>;
  distribution_centre: DistributionCentreGlType;
  estimated_delivery?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  poc_name: Scalars['String'];
  poc_number: Scalars['String'];
  shipment_slot_selected?: Maybe<TimeSlotGlType>;
  shipping_address?: Maybe<AddressGlType>;
  shipping_method?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Active_Ingredientcreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Active_Ingredientupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Article_Author_Favorite_Insightsauthor = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Article_Author_Like_Insightsauthor = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Article_Author_View_Insightsauthor = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Article_Authorsauthor = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Article_Categorymutual_Group = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Article_Crop_Categoriescrop_Group = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Article_Crop_Varietiesvarieties = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Article_Cropscrop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Article_Regionsregion = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Article_User_Groupmutual_Group = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Articlecreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Articleupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Commentcreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Commentupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Cost_Itemcreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Cost_Itemupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Crop_Fertiliserscrop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Crop_Operation_Methodscrop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Crop_Pesticidescrop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Crop_Variety_Seedsvariety = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Cropmonitoring_Parametercrop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Fileuploadcreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Fileuploadupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Messagesender = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Categorycreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Categoryupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Parameter_Unit_Choicesunit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Parametercreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Parameterupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Recordaggregated_Value_Unit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Recordcreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Recordplot = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Recordplot_Crop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Recordprimary_Growth_Stage = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Recordsecondary_Growth_Stage = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Recordupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Samplecreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Sampleunit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Monitoring_Sampleupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Mutual_Group_Subscription_Packagemutual_Group = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Notification_Template_Distribution_Regionregion = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Notification_Template_Distribution_Teamteam = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Notification_Template_Distribution_Userreceiver = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Notificationreceiver = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Notificationsender = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Nutrientscreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Nutrientsupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Observation_Notificationreceiver = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Observation_Notificationsender = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Operations_Applied_Fertiliserquantity_Unit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Operations_Applied_Pesticidequantity_Unit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Operations_Harvestquantity_Unit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Operationscreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Operationsplot = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Operationsplot_Crop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Operationsupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Products_Fertiliser_Unitsunit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Products_Pesticide_Unitsunit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Productscreator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Productsupdater = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Recommended_Productquantity_Unit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Series_Authorsauthor = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Series_Cropscrop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Series_Favoritesuser = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Series_Likesuser = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitycommodity = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitycommodity_Variety = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitycrop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitydepartment = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityfacilitator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityfarm = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityfield = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityowner_Team = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitypackaging_Unit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityplot = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityplot_Crop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityregion = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitysi_Unit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityuser = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityvariety_Grade = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Threadplot_Crop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Trade_Commoditycommodity = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Trade_Regionregion = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Trade_Unitunit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type SubCategoriesQuery = {
  __typename?: 'SubCategoriesQuery';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  parameters?: Maybe<Array<Maybe<Parameters>>>;
};

export type SupplierPlotAggregateInput = {
  mutual_group_id?: InputMaybe<Scalars['ID']>;
};

export type TaxGlType = {
  __typename?: 'TaxGlType';
  codename: Scalars['String'];
  distributioncentre_set: Array<DistributionCentreGlType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  order_set: Array<OrderGlType>;
  percentage: Scalars['Float'];
  sellableitem_set: Array<SellableItemGlType>;
  shipping_set: Array<ShippingGlType>;
};

export type TimeElapsedObjectType = {
  __typename?: 'TimeElapsedObjectType';
  days?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  years?: Maybe<Scalars['Int']>;
};

export type TimeSlotGlType = {
  __typename?: 'TimeSlotGlType';
  dc_alternate_sales_slots: Array<DistributionCentreGlType>;
  dc_delivery_slots: Array<DistributionCentreGlType>;
  dc_maintenance_slots: Array<DistributionCentreGlType>;
  dc_pickup_slots: Array<DistributionCentreGlType>;
  estimated_delivery: Scalars['String'];
  from_time: Scalars['Time'];
  id: Scalars['ID'];
  maximum_orders: Scalars['Int'];
  name: Scalars['String'];
  order_set: Array<OrderGlType>;
  shipping_set: Array<ShippingGlType>;
  threshold_from?: Maybe<Scalars['Time']>;
  threshold_to?: Maybe<Scalars['Time']>;
  timeslotrequirement_set: Array<TimeSlotRequirementGlType>;
  to_time: Scalars['Time'];
};

export type TimeSlotRequirementGlType = {
  __typename?: 'TimeSlotRequirementGlType';
  booked_quantity: Scalars['Float'];
  demand: DemandGlType;
  id: Scalars['ID'];
  quantity: Scalars['Float'];
};

export type TotalArticleMetrics = {
  __typename?: 'TotalArticleMetrics';
  favorites_count?: Maybe<Scalars['Int']>;
  likes_count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
  views_count?: Maybe<Scalars['Int']>;
};

export type TotalMetrics = {
  __typename?: 'TotalMetrics';
  total?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum TradeExpenseKindChoices {
  /** Amount Percent */
  AmountPercent = 'AMOUNT_PERCENT',
  /** Deducted Quantity Per Unit */
  DeductedQuantityPerUnit = 'DEDUCTED_QUANTITY_PER_UNIT',
  /** Flat */
  Flat = 'FLAT',
  /** Quantity Per Unit */
  QuantityPerUnit = 'QUANTITY_PER_UNIT'
}

/** An enumeration. */
export enum TradeExpensePaidByChoices {
  /** Buyer */
  Buyer = 'BUYER',
  /** Facilitator */
  Facilitator = 'FACILITATOR',
  /** Seller */
  Seller = 'SELLER'
}

export type TradeGradeSummaryReportSchema = {
  __typename?: 'TradeGradeSummaryReportSchema';
  grade_summary?: Maybe<Array<Maybe<TradeGradeSummarySchema>>>;
  more_trade?: Maybe<Scalars['Boolean']>;
};

export type TradeGradeSummarySchema = {
  __typename?: 'TradeGradeSummarySchema';
  booked_quantity?: Maybe<Scalars['Float']>;
  remaining_quantity?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Int']>;
  variety_grade_name?: Maybe<Scalars['String']>;
};

export type TradeItemInput = {
  currency_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Decimal']>;
  rate?: InputMaybe<Scalars['Decimal']>;
  unit_id?: InputMaybe<Scalars['ID']>;
  variety_grade_id?: InputMaybe<Scalars['ID']>;
};

export type TradeItemType = {
  __typename?: 'TradeItemType';
  amount?: Maybe<Scalars['Decimal']>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  trade: TradeType;
  updated_at: Scalars['DateTime'];
};

/** An enumeration. */
export enum TradeReceiptKindChoices {
  /** Booking */
  Booking = 'BOOKING',
  /** Final */
  Final = 'FINAL',
  /** Pro Forma */
  ProForma = 'PRO_FORMA'
}

/** An enumeration. */
export enum TradeReceiptModeChoices {
  /** Direct */
  Direct = 'DIRECT',
  /** Facilitator */
  Facilitator = 'FACILITATOR',
  /** Non KYC */
  NonKyc = 'NON_KYC'
}

/** An enumeration. */
export enum TradeReceiptPackagingChoices {
  /** Finished Goods */
  FinishedGoods = 'FINISHED_GOODS',
  /** Raw Material */
  RawMaterial = 'RAW_MATERIAL'
}

/** An enumeration. */
export enum TradeTradeKindChoices {
  /** Booking */
  Booking = 'BOOKING',
  /** Final */
  Final = 'FINAL',
  /** Pro Forma */
  ProForma = 'PRO_FORMA'
}

/** An enumeration. */
export enum TradeTradeModeChoices {
  /** Direct */
  Direct = 'DIRECT',
  /** Facilitator */
  Facilitator = 'FACILITATOR',
  /** Non KYC */
  NonKyc = 'NON_KYC'
}

/** An enumeration. */
export enum TradeTradePackagingChoices {
  /** Finished Goods */
  FinishedGoods = 'FINISHED_GOODS',
  /** Raw Material */
  RawMaterial = 'RAW_MATERIAL'
}

export type TradeType = {
  __typename?: 'TradeType';
  buyer_remark?: Maybe<Scalars['String']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  buyer_verification?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  /** Total amount reducing std. deduction */
  deducted_amount?: Maybe<Scalars['Decimal']>;
  /** Total quantity reducing std. deduction */
  deducted_quantity?: Maybe<Scalars['Decimal']>;
  end_date?: Maybe<Scalars['Date']>;
  /** Only expense amount */
  expense_amount?: Maybe<Scalars['Decimal']>;
  expenses: Array<ExpenseType>;
  expiry?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoice?: Maybe<InvoiceType>;
  items: Array<TradeItemType>;
  kind: TradeTradeKindChoices;
  mode: TradeTradeModeChoices;
  packaging: TradeTradePackagingChoices;
  parent_trade?: Maybe<TradeType>;
  receipt?: Maybe<ReceiptType>;
  reverse_status_mode: Scalars['Boolean'];
  seller_remark?: Maybe<Scalars['String']>;
  seller_tnc?: Maybe<Scalars['String']>;
  seller_verification?: Maybe<Scalars['Boolean']>;
  standard_deduction?: Maybe<Scalars['Decimal']>;
  start_date?: Maybe<Scalars['Date']>;
  /** Sum of total amount in trades */
  total_amount?: Maybe<Scalars['Decimal']>;
  /** Sum of total amount in trades */
  total_quantity?: Maybe<Scalars['Decimal']>;
  tracking_code: Scalars['String'];
  trade_amounts_counter: Scalars['Int'];
  trades: Array<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type TrendingArticleMetrics = {
  __typename?: 'TrendingArticleMetrics';
  article_type?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type TrendingMetrics = {
  __typename?: 'TrendingMetrics';
  count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TripGlFilterInput = {
  booking_approval_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  date__gte?: InputMaybe<Scalars['Date']>;
  date__lte?: InputMaybe<Scalars['Date']>;
  destination_dc_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  source_dc_id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status__nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TripGlType = {
  __typename?: 'TripGlType';
  aggregator: BaseUserGlType;
  booking_count?: Maybe<Scalars['Int']>;
  booking_status?: Maybe<Array<Maybe<Scalars['String']>>>;
  bookings?: Maybe<Array<Maybe<BookingGlType>>>;
  date: Scalars['Date'];
  department_assigned: DepartmentGlType;
  destination_depot?: Maybe<DepotGlType>;
  dock?: Maybe<DockGlType>;
  dock_detail?: Maybe<DockDetailGlType>;
  dock_details?: Maybe<Array<Maybe<DockDetailGlType>>>;
  id: Scalars['ID'];
  labour_approval_status?: Maybe<Scalars['String']>;
  labour_count?: Maybe<Scalars['Int']>;
  source_depot?: Maybe<DepotGlType>;
  status: TripStatus;
  vehicle: VehicleGlType;
  vehicle_approval_status?: Maybe<Scalars['String']>;
};


export type TripGlTypeDock_DetailArgs = {
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
};


export type TripGlTypeDock_DetailsArgs = {
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum TripStatus {
  /** Completed */
  Cp = 'CP',
  /** Discarded */
  Ds = 'DS',
  /** Idle */
  Il = 'IL',
  /** Not Started */
  Ns = 'NS',
  /** On Trip */
  Ot = 'OT',
  /** Paused */
  Ps = 'PS',
  /** Settled */
  St = 'ST'
}

export type TutorialType = {
  __typename?: 'TutorialType';
  description: Scalars['String'];
  feature?: Maybe<FeatureType>;
  heading: Scalars['String'];
  /** Autogenerated UUID as Primary Key */
  id: Scalars['UUID'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  order: Scalars['Int'];
};

export type UnitAndValueType = {
  __typename?: 'UnitAndValueType';
  unit_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type UpdateBookingStatus = {
  __typename?: 'UpdateBookingStatus';
  booking?: Maybe<BookingGlType>;
};

export type UpdatePasswordMutation = {
  __typename?: 'UpdatePasswordMutation';
  user?: Maybe<BaseUserType>;
};

export type UpdateTradeAmountMutation = {
  __typename?: 'UpdateTradeAmountMutation';
  trade?: Maybe<TradeType>;
};

export type UpdateTripDetailsMutation = {
  __typename?: 'UpdateTripDetailsMutation';
  trip?: Maybe<TripGlType>;
};

export type UpsertInterculturalOperationMutation = {
  __typename?: 'UpsertInterculturalOperationMutation';
  id?: Maybe<Scalars['UUID']>;
};

export type UserAndCountSchema = {
  __typename?: 'UserAndCountSchema';
  count?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UserContactType = {
  __typename?: 'UserContactType';
  email?: Maybe<Scalars['String']>;
  primary_number?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
};

export type UserContactTypeV2 = {
  __typename?: 'UserContactTypeV2';
  country_code?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type UserGroupType = {
  __typename?: 'UserGroupType';
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  user_set: Array<BaseUserType>;
};

export type VehicleGlInput = {
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  depot?: InputMaybe<Scalars['Int']>;
  registration_number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type VehicleGlType = {
  __typename?: 'VehicleGlType';
  driver?: Maybe<BaseUserGlType>;
  id: Scalars['ID'];
  registration_number: Scalars['String'];
  vehicle_type: VehicleTypeGlType;
};

export type VehicleTypeGlType = {
  __typename?: 'VehicleTypeGlType';
  capacity: Scalars['Int'];
  category: Scalars['String'];
  id: Scalars['ID'];
  max_capacity: Scalars['Int'];
  name: Scalars['String'];
  passenger_capacity: Scalars['Int'];
};

export type Verify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar'];
};

export type VerifyOtp = {
  __typename?: 'VerifyOTP';
  me?: Maybe<BaseUserType>;
  payload?: Maybe<Scalars['GenericScalar']>;
  refresh_expires_in?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type VerifyTradeOtp = {
  __typename?: 'VerifyTradeOTP';
  payload?: Maybe<Scalars['GenericScalar']>;
  refresh_expires_in?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type ViewDetails = {
  __typename?: 'ViewDetails';
  current_viewtime?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_viewed?: Maybe<Scalars['Int']>;
  total_duration?: Maybe<Scalars['Int']>;
};

export type WaterUsedOperationSchema = {
  quantity?: InputMaybe<Scalars['Float']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "_numeric". All fields are combined with logical 'AND'. */
export type _Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_numeric']>;
  _gt?: InputMaybe<Scalars['_numeric']>;
  _gte?: InputMaybe<Scalars['_numeric']>;
  _in?: InputMaybe<Array<Scalars['_numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_numeric']>;
  _lte?: InputMaybe<Scalars['_numeric']>;
  _neq?: InputMaybe<Scalars['_numeric']>;
  _nin?: InputMaybe<Array<Scalars['_numeric']>>;
};

/** columns and relationships of "action_log" */
export type Action_Log = {
  __typename?: 'action_log';
  action_flag: Scalars['String'];
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  change_message: Scalars['String'];
  change_object?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  content_type: Django_Content_Type;
  content_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  object_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "action_log" */
export type Action_LogChange_ObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "action_log" */
export type Action_Log_Aggregate = {
  __typename?: 'action_log_aggregate';
  aggregate?: Maybe<Action_Log_Aggregate_Fields>;
  nodes: Array<Action_Log>;
};

/** aggregate fields of "action_log" */
export type Action_Log_Aggregate_Fields = {
  __typename?: 'action_log_aggregate_fields';
  avg?: Maybe<Action_Log_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Action_Log_Max_Fields>;
  min?: Maybe<Action_Log_Min_Fields>;
  stddev?: Maybe<Action_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Action_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Action_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Action_Log_Sum_Fields>;
  var_pop?: Maybe<Action_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Action_Log_Var_Samp_Fields>;
  variance?: Maybe<Action_Log_Variance_Fields>;
};


/** aggregate fields of "action_log" */
export type Action_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Action_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Action_Log_Append_Input = {
  change_object?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Action_Log_Avg_Fields = {
  __typename?: 'action_log_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "action_log". All fields are combined with a logical 'AND'. */
export type Action_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Action_Log_Bool_Exp>>;
  _not?: InputMaybe<Action_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Log_Bool_Exp>>;
  action_flag?: InputMaybe<String_Comparison_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  change_message?: InputMaybe<String_Comparison_Exp>;
  change_object?: InputMaybe<Jsonb_Comparison_Exp>;
  content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "action_log" */
export enum Action_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActionLogPkey = 'action_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Action_Log_Delete_At_Path_Input = {
  change_object?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Action_Log_Delete_Elem_Input = {
  change_object?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Action_Log_Delete_Key_Input = {
  change_object?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "action_log" */
export type Action_Log_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "action_log" */
export type Action_Log_Insert_Input = {
  action_flag?: InputMaybe<Scalars['String']>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Action_Log_Max_Fields = {
  __typename?: 'action_log_max_fields';
  action_flag?: Maybe<Scalars['String']>;
  base_user_id?: Maybe<Scalars['Int']>;
  change_message?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Action_Log_Min_Fields = {
  __typename?: 'action_log_min_fields';
  action_flag?: Maybe<Scalars['String']>;
  base_user_id?: Maybe<Scalars['Int']>;
  change_message?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "action_log" */
export type Action_Log_Mutation_Response = {
  __typename?: 'action_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Action_Log>;
};

/** on_conflict condition type for table "action_log" */
export type Action_Log_On_Conflict = {
  constraint: Action_Log_Constraint;
  update_columns?: Array<Action_Log_Update_Column>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "action_log". */
export type Action_Log_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  change_object?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Django_Content_Type_Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: action_log */
export type Action_Log_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Action_Log_Prepend_Input = {
  change_object?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "action_log" */
export enum Action_Log_Select_Column {
  /** column name */
  ActionFlag = 'action_flag',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  ChangeMessage = 'change_message',
  /** column name */
  ChangeObject = 'change_object',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "action_log" */
export type Action_Log_Set_Input = {
  action_flag?: InputMaybe<Scalars['String']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Action_Log_Stddev_Fields = {
  __typename?: 'action_log_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Action_Log_Stddev_Pop_Fields = {
  __typename?: 'action_log_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Action_Log_Stddev_Samp_Fields = {
  __typename?: 'action_log_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "action_log" */
export type Action_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Action_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Action_Log_Stream_Cursor_Value_Input = {
  action_flag?: InputMaybe<Scalars['String']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Action_Log_Sum_Fields = {
  __typename?: 'action_log_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "action_log" */
export enum Action_Log_Update_Column {
  /** column name */
  ActionFlag = 'action_flag',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  ChangeMessage = 'change_message',
  /** column name */
  ChangeObject = 'change_object',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Action_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Action_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Action_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Action_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Action_Log_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Action_Log_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Action_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Action_Log_Set_Input>;
  where: Action_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Action_Log_Var_Pop_Fields = {
  __typename?: 'action_log_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Action_Log_Var_Samp_Fields = {
  __typename?: 'action_log_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Action_Log_Variance_Fields = {
  __typename?: 'action_log_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "active_ingredient" */
export type Active_Ingredient = {
  __typename?: 'active_ingredient';
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  products_pesticide_contents: Array<Products_Pesticide_Contents>;
  /** An aggregate relationship */
  products_pesticide_contents_aggregate: Products_Pesticide_Contents_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
};


/** columns and relationships of "active_ingredient" */
export type Active_IngredientCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Active_Ingredientcreator>;
};


/** columns and relationships of "active_ingredient" */
export type Active_IngredientProducts_Pesticide_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Contents_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
};


/** columns and relationships of "active_ingredient" */
export type Active_IngredientProducts_Pesticide_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Contents_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
};


/** columns and relationships of "active_ingredient" */
export type Active_IngredientUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Active_Ingredientupdater>;
};

/** aggregated selection of "active_ingredient" */
export type Active_Ingredient_Aggregate = {
  __typename?: 'active_ingredient_aggregate';
  aggregate?: Maybe<Active_Ingredient_Aggregate_Fields>;
  nodes: Array<Active_Ingredient>;
};

/** aggregate fields of "active_ingredient" */
export type Active_Ingredient_Aggregate_Fields = {
  __typename?: 'active_ingredient_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Active_Ingredient_Max_Fields>;
  min?: Maybe<Active_Ingredient_Min_Fields>;
};


/** aggregate fields of "active_ingredient" */
export type Active_Ingredient_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Active_Ingredient_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "active_ingredient". All fields are combined with a logical 'AND'. */
export type Active_Ingredient_Bool_Exp = {
  _and?: InputMaybe<Array<Active_Ingredient_Bool_Exp>>;
  _not?: InputMaybe<Active_Ingredient_Bool_Exp>;
  _or?: InputMaybe<Array<Active_Ingredient_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  products_pesticide_contents?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "active_ingredient" */
export enum Active_Ingredient_Constraint {
  /** unique or primary key constraint on columns "name" */
  ActiveIngredientNameKey = 'active_ingredient_name_key',
  /** unique or primary key constraint on columns "id" */
  ActiveIngredientPkey = 'active_ingredient_pkey'
}

/** input type for inserting data into table "active_ingredient" */
export type Active_Ingredient_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  products_pesticide_contents?: InputMaybe<Products_Pesticide_Contents_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Active_Ingredient_Max_Fields = {
  __typename?: 'active_ingredient_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Active_Ingredient_Min_Fields = {
  __typename?: 'active_ingredient_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "active_ingredient" */
export type Active_Ingredient_Mutation_Response = {
  __typename?: 'active_ingredient_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Active_Ingredient>;
};

/** input type for inserting object relation for remote table "active_ingredient" */
export type Active_Ingredient_Obj_Rel_Insert_Input = {
  data: Active_Ingredient_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Active_Ingredient_On_Conflict>;
};

/** on_conflict condition type for table "active_ingredient" */
export type Active_Ingredient_On_Conflict = {
  constraint: Active_Ingredient_Constraint;
  update_columns?: Array<Active_Ingredient_Update_Column>;
  where?: InputMaybe<Active_Ingredient_Bool_Exp>;
};

/** Ordering options when selecting data from "active_ingredient". */
export type Active_Ingredient_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  products_pesticide_contents_aggregate?: InputMaybe<Products_Pesticide_Contents_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: active_ingredient */
export type Active_Ingredient_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "active_ingredient" */
export enum Active_Ingredient_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "active_ingredient" */
export type Active_Ingredient_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "active_ingredient" */
export type Active_Ingredient_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Active_Ingredient_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Active_Ingredient_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "active_ingredient" */
export enum Active_Ingredient_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Active_Ingredient_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Active_Ingredient_Set_Input>;
  where: Active_Ingredient_Bool_Exp;
};

/** columns and relationships of "actual_reading" */
export type Actual_Reading = {
  __typename?: 'actual_reading';
  apparent_temperature?: Maybe<Scalars['float8']>;
  cloud_cover?: Maybe<Scalars['float8']>;
  created_at: Scalars['timestamptz'];
  date_time: Scalars['timestamptz'];
  delta_t?: Maybe<Scalars['float8']>;
  dew_point?: Maybe<Scalars['float8']>;
  id: Scalars['bigint'];
  location_id: Scalars['uuid'];
  melted_snow_depth?: Maybe<Scalars['float8']>;
  precip_prob?: Maybe<Scalars['float8']>;
  precipitation?: Maybe<Scalars['float8']>;
  pressure?: Maybe<Scalars['float8']>;
  provider: Scalars['String'];
  relative_humidity?: Maybe<Scalars['float8']>;
  snow_depth?: Maybe<Scalars['float8']>;
  solar_radiation?: Maybe<Scalars['float8']>;
  spray_decision: Scalars['Boolean'];
  temperature?: Maybe<Scalars['float8']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  weather_location: Weather_Location;
  weather_type?: Maybe<Scalars['String']>;
  wind_direction?: Maybe<Scalars['String']>;
  wind_direction_deg?: Maybe<Scalars['float8']>;
  wind_speed?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "actual_reading" */
export type Actual_Reading_Aggregate = {
  __typename?: 'actual_reading_aggregate';
  aggregate?: Maybe<Actual_Reading_Aggregate_Fields>;
  nodes: Array<Actual_Reading>;
};

/** aggregate fields of "actual_reading" */
export type Actual_Reading_Aggregate_Fields = {
  __typename?: 'actual_reading_aggregate_fields';
  avg?: Maybe<Actual_Reading_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Actual_Reading_Max_Fields>;
  min?: Maybe<Actual_Reading_Min_Fields>;
  stddev?: Maybe<Actual_Reading_Stddev_Fields>;
  stddev_pop?: Maybe<Actual_Reading_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Actual_Reading_Stddev_Samp_Fields>;
  sum?: Maybe<Actual_Reading_Sum_Fields>;
  var_pop?: Maybe<Actual_Reading_Var_Pop_Fields>;
  var_samp?: Maybe<Actual_Reading_Var_Samp_Fields>;
  variance?: Maybe<Actual_Reading_Variance_Fields>;
};


/** aggregate fields of "actual_reading" */
export type Actual_Reading_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Actual_Reading_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "actual_reading" */
export type Actual_Reading_Aggregate_Order_By = {
  avg?: InputMaybe<Actual_Reading_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Actual_Reading_Max_Order_By>;
  min?: InputMaybe<Actual_Reading_Min_Order_By>;
  stddev?: InputMaybe<Actual_Reading_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Actual_Reading_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Actual_Reading_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Actual_Reading_Sum_Order_By>;
  var_pop?: InputMaybe<Actual_Reading_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Actual_Reading_Var_Samp_Order_By>;
  variance?: InputMaybe<Actual_Reading_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "actual_reading" */
export type Actual_Reading_Arr_Rel_Insert_Input = {
  data: Array<Actual_Reading_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Actual_Reading_On_Conflict>;
};

/** aggregate avg on columns */
export type Actual_Reading_Avg_Fields = {
  __typename?: 'actual_reading_avg_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "actual_reading" */
export type Actual_Reading_Avg_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "actual_reading". All fields are combined with a logical 'AND'. */
export type Actual_Reading_Bool_Exp = {
  _and?: InputMaybe<Array<Actual_Reading_Bool_Exp>>;
  _not?: InputMaybe<Actual_Reading_Bool_Exp>;
  _or?: InputMaybe<Array<Actual_Reading_Bool_Exp>>;
  apparent_temperature?: InputMaybe<Float8_Comparison_Exp>;
  cloud_cover?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  delta_t?: InputMaybe<Float8_Comparison_Exp>;
  dew_point?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  melted_snow_depth?: InputMaybe<Float8_Comparison_Exp>;
  precip_prob?: InputMaybe<Float8_Comparison_Exp>;
  precipitation?: InputMaybe<Float8_Comparison_Exp>;
  pressure?: InputMaybe<Float8_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  relative_humidity?: InputMaybe<Float8_Comparison_Exp>;
  snow_depth?: InputMaybe<Float8_Comparison_Exp>;
  solar_radiation?: InputMaybe<Float8_Comparison_Exp>;
  spray_decision?: InputMaybe<Boolean_Comparison_Exp>;
  temperature?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weather_location?: InputMaybe<Weather_Location_Bool_Exp>;
  weather_type?: InputMaybe<String_Comparison_Exp>;
  wind_direction?: InputMaybe<String_Comparison_Exp>;
  wind_direction_deg?: InputMaybe<Float8_Comparison_Exp>;
  wind_speed?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "actual_reading" */
export enum Actual_Reading_Constraint {
  /** unique or primary key constraint on columns "date_time", "provider", "location_id" */
  ActualReadingDateTimeProviderLocationId_9dca515dUniq = 'actual_reading_date_time_provider_location_id_9dca515d_uniq',
  /** unique or primary key constraint on columns "id" */
  ActualReadingPkey = 'actual_reading_pkey'
}

/** input type for incrementing numeric columns in table "actual_reading" */
export type Actual_Reading_Inc_Input = {
  apparent_temperature?: InputMaybe<Scalars['float8']>;
  cloud_cover?: InputMaybe<Scalars['float8']>;
  delta_t?: InputMaybe<Scalars['float8']>;
  dew_point?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  melted_snow_depth?: InputMaybe<Scalars['float8']>;
  precip_prob?: InputMaybe<Scalars['float8']>;
  precipitation?: InputMaybe<Scalars['float8']>;
  pressure?: InputMaybe<Scalars['float8']>;
  relative_humidity?: InputMaybe<Scalars['float8']>;
  snow_depth?: InputMaybe<Scalars['float8']>;
  solar_radiation?: InputMaybe<Scalars['float8']>;
  temperature?: InputMaybe<Scalars['float8']>;
  wind_direction_deg?: InputMaybe<Scalars['float8']>;
  wind_speed?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "actual_reading" */
export type Actual_Reading_Insert_Input = {
  apparent_temperature?: InputMaybe<Scalars['float8']>;
  cloud_cover?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_time?: InputMaybe<Scalars['timestamptz']>;
  delta_t?: InputMaybe<Scalars['float8']>;
  dew_point?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  melted_snow_depth?: InputMaybe<Scalars['float8']>;
  precip_prob?: InputMaybe<Scalars['float8']>;
  precipitation?: InputMaybe<Scalars['float8']>;
  pressure?: InputMaybe<Scalars['float8']>;
  provider?: InputMaybe<Scalars['String']>;
  relative_humidity?: InputMaybe<Scalars['float8']>;
  snow_depth?: InputMaybe<Scalars['float8']>;
  solar_radiation?: InputMaybe<Scalars['float8']>;
  spray_decision?: InputMaybe<Scalars['Boolean']>;
  temperature?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weather_location?: InputMaybe<Weather_Location_Obj_Rel_Insert_Input>;
  weather_type?: InputMaybe<Scalars['String']>;
  wind_direction?: InputMaybe<Scalars['String']>;
  wind_direction_deg?: InputMaybe<Scalars['float8']>;
  wind_speed?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Actual_Reading_Max_Fields = {
  __typename?: 'actual_reading_max_fields';
  apparent_temperature?: Maybe<Scalars['float8']>;
  cloud_cover?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  delta_t?: Maybe<Scalars['float8']>;
  dew_point?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  melted_snow_depth?: Maybe<Scalars['float8']>;
  precip_prob?: Maybe<Scalars['float8']>;
  precipitation?: Maybe<Scalars['float8']>;
  pressure?: Maybe<Scalars['float8']>;
  provider?: Maybe<Scalars['String']>;
  relative_humidity?: Maybe<Scalars['float8']>;
  snow_depth?: Maybe<Scalars['float8']>;
  solar_radiation?: Maybe<Scalars['float8']>;
  temperature?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weather_type?: Maybe<Scalars['String']>;
  wind_direction?: Maybe<Scalars['String']>;
  wind_direction_deg?: Maybe<Scalars['float8']>;
  wind_speed?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "actual_reading" */
export type Actual_Reading_Max_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_time?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weather_type?: InputMaybe<Order_By>;
  wind_direction?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Actual_Reading_Min_Fields = {
  __typename?: 'actual_reading_min_fields';
  apparent_temperature?: Maybe<Scalars['float8']>;
  cloud_cover?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  delta_t?: Maybe<Scalars['float8']>;
  dew_point?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  melted_snow_depth?: Maybe<Scalars['float8']>;
  precip_prob?: Maybe<Scalars['float8']>;
  precipitation?: Maybe<Scalars['float8']>;
  pressure?: Maybe<Scalars['float8']>;
  provider?: Maybe<Scalars['String']>;
  relative_humidity?: Maybe<Scalars['float8']>;
  snow_depth?: Maybe<Scalars['float8']>;
  solar_radiation?: Maybe<Scalars['float8']>;
  temperature?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weather_type?: Maybe<Scalars['String']>;
  wind_direction?: Maybe<Scalars['String']>;
  wind_direction_deg?: Maybe<Scalars['float8']>;
  wind_speed?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "actual_reading" */
export type Actual_Reading_Min_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_time?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weather_type?: InputMaybe<Order_By>;
  wind_direction?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "actual_reading" */
export type Actual_Reading_Mutation_Response = {
  __typename?: 'actual_reading_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Actual_Reading>;
};

/** on_conflict condition type for table "actual_reading" */
export type Actual_Reading_On_Conflict = {
  constraint: Actual_Reading_Constraint;
  update_columns?: Array<Actual_Reading_Update_Column>;
  where?: InputMaybe<Actual_Reading_Bool_Exp>;
};

/** Ordering options when selecting data from "actual_reading". */
export type Actual_Reading_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_time?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  spray_decision?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weather_location?: InputMaybe<Weather_Location_Order_By>;
  weather_type?: InputMaybe<Order_By>;
  wind_direction?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** primary key columns input for table: actual_reading */
export type Actual_Reading_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "actual_reading" */
export enum Actual_Reading_Select_Column {
  /** column name */
  ApparentTemperature = 'apparent_temperature',
  /** column name */
  CloudCover = 'cloud_cover',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  DeltaT = 'delta_t',
  /** column name */
  DewPoint = 'dew_point',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MeltedSnowDepth = 'melted_snow_depth',
  /** column name */
  PrecipProb = 'precip_prob',
  /** column name */
  Precipitation = 'precipitation',
  /** column name */
  Pressure = 'pressure',
  /** column name */
  Provider = 'provider',
  /** column name */
  RelativeHumidity = 'relative_humidity',
  /** column name */
  SnowDepth = 'snow_depth',
  /** column name */
  SolarRadiation = 'solar_radiation',
  /** column name */
  SprayDecision = 'spray_decision',
  /** column name */
  Temperature = 'temperature',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeatherType = 'weather_type',
  /** column name */
  WindDirection = 'wind_direction',
  /** column name */
  WindDirectionDeg = 'wind_direction_deg',
  /** column name */
  WindSpeed = 'wind_speed'
}

/** input type for updating data in table "actual_reading" */
export type Actual_Reading_Set_Input = {
  apparent_temperature?: InputMaybe<Scalars['float8']>;
  cloud_cover?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_time?: InputMaybe<Scalars['timestamptz']>;
  delta_t?: InputMaybe<Scalars['float8']>;
  dew_point?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  melted_snow_depth?: InputMaybe<Scalars['float8']>;
  precip_prob?: InputMaybe<Scalars['float8']>;
  precipitation?: InputMaybe<Scalars['float8']>;
  pressure?: InputMaybe<Scalars['float8']>;
  provider?: InputMaybe<Scalars['String']>;
  relative_humidity?: InputMaybe<Scalars['float8']>;
  snow_depth?: InputMaybe<Scalars['float8']>;
  solar_radiation?: InputMaybe<Scalars['float8']>;
  spray_decision?: InputMaybe<Scalars['Boolean']>;
  temperature?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weather_type?: InputMaybe<Scalars['String']>;
  wind_direction?: InputMaybe<Scalars['String']>;
  wind_direction_deg?: InputMaybe<Scalars['float8']>;
  wind_speed?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Actual_Reading_Stddev_Fields = {
  __typename?: 'actual_reading_stddev_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "actual_reading" */
export type Actual_Reading_Stddev_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Actual_Reading_Stddev_Pop_Fields = {
  __typename?: 'actual_reading_stddev_pop_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "actual_reading" */
export type Actual_Reading_Stddev_Pop_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Actual_Reading_Stddev_Samp_Fields = {
  __typename?: 'actual_reading_stddev_samp_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "actual_reading" */
export type Actual_Reading_Stddev_Samp_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "actual_reading" */
export type Actual_Reading_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Actual_Reading_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Actual_Reading_Stream_Cursor_Value_Input = {
  apparent_temperature?: InputMaybe<Scalars['float8']>;
  cloud_cover?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_time?: InputMaybe<Scalars['timestamptz']>;
  delta_t?: InputMaybe<Scalars['float8']>;
  dew_point?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  melted_snow_depth?: InputMaybe<Scalars['float8']>;
  precip_prob?: InputMaybe<Scalars['float8']>;
  precipitation?: InputMaybe<Scalars['float8']>;
  pressure?: InputMaybe<Scalars['float8']>;
  provider?: InputMaybe<Scalars['String']>;
  relative_humidity?: InputMaybe<Scalars['float8']>;
  snow_depth?: InputMaybe<Scalars['float8']>;
  solar_radiation?: InputMaybe<Scalars['float8']>;
  spray_decision?: InputMaybe<Scalars['Boolean']>;
  temperature?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weather_type?: InputMaybe<Scalars['String']>;
  wind_direction?: InputMaybe<Scalars['String']>;
  wind_direction_deg?: InputMaybe<Scalars['float8']>;
  wind_speed?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Actual_Reading_Sum_Fields = {
  __typename?: 'actual_reading_sum_fields';
  apparent_temperature?: Maybe<Scalars['float8']>;
  cloud_cover?: Maybe<Scalars['float8']>;
  delta_t?: Maybe<Scalars['float8']>;
  dew_point?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  melted_snow_depth?: Maybe<Scalars['float8']>;
  precip_prob?: Maybe<Scalars['float8']>;
  precipitation?: Maybe<Scalars['float8']>;
  pressure?: Maybe<Scalars['float8']>;
  relative_humidity?: Maybe<Scalars['float8']>;
  snow_depth?: Maybe<Scalars['float8']>;
  solar_radiation?: Maybe<Scalars['float8']>;
  temperature?: Maybe<Scalars['float8']>;
  wind_direction_deg?: Maybe<Scalars['float8']>;
  wind_speed?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "actual_reading" */
export type Actual_Reading_Sum_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** update columns of table "actual_reading" */
export enum Actual_Reading_Update_Column {
  /** column name */
  ApparentTemperature = 'apparent_temperature',
  /** column name */
  CloudCover = 'cloud_cover',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  DeltaT = 'delta_t',
  /** column name */
  DewPoint = 'dew_point',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MeltedSnowDepth = 'melted_snow_depth',
  /** column name */
  PrecipProb = 'precip_prob',
  /** column name */
  Precipitation = 'precipitation',
  /** column name */
  Pressure = 'pressure',
  /** column name */
  Provider = 'provider',
  /** column name */
  RelativeHumidity = 'relative_humidity',
  /** column name */
  SnowDepth = 'snow_depth',
  /** column name */
  SolarRadiation = 'solar_radiation',
  /** column name */
  SprayDecision = 'spray_decision',
  /** column name */
  Temperature = 'temperature',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeatherType = 'weather_type',
  /** column name */
  WindDirection = 'wind_direction',
  /** column name */
  WindDirectionDeg = 'wind_direction_deg',
  /** column name */
  WindSpeed = 'wind_speed'
}

export type Actual_Reading_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Actual_Reading_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Actual_Reading_Set_Input>;
  where: Actual_Reading_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Actual_Reading_Var_Pop_Fields = {
  __typename?: 'actual_reading_var_pop_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "actual_reading" */
export type Actual_Reading_Var_Pop_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Actual_Reading_Var_Samp_Fields = {
  __typename?: 'actual_reading_var_samp_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "actual_reading" */
export type Actual_Reading_Var_Samp_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Actual_Reading_Variance_Fields = {
  __typename?: 'actual_reading_variance_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "actual_reading" */
export type Actual_Reading_Variance_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** columns and relationships of "address" */
export type Address = {
  __typename?: 'address';
  address_kind: Scalars['String'];
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  district: Scalars['String'];
  id: Scalars['Int'];
  local_area: Scalars['String'];
  location?: Maybe<Scalars['geometry']>;
  /** An array relationship */
  mutual_groups: Array<Mutual_Group>;
  /** An aggregate relationship */
  mutual_groups_aggregate: Mutual_Group_Aggregate;
  name: Scalars['String'];
  pincode: Scalars['String'];
  raw_address?: Maybe<Scalars['String']>;
  /** SQL Short Address */
  short_address?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  taluka: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  village: Scalars['String'];
  w3w_code: Scalars['String'];
};


/** columns and relationships of "address" */
export type AddressMutual_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressMutual_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};

/** aggregated selection of "address" */
export type Address_Aggregate = {
  __typename?: 'address_aggregate';
  aggregate?: Maybe<Address_Aggregate_Fields>;
  nodes: Array<Address>;
};

/** aggregate fields of "address" */
export type Address_Aggregate_Fields = {
  __typename?: 'address_aggregate_fields';
  avg?: Maybe<Address_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Address_Max_Fields>;
  min?: Maybe<Address_Min_Fields>;
  stddev?: Maybe<Address_Stddev_Fields>;
  stddev_pop?: Maybe<Address_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Address_Stddev_Samp_Fields>;
  sum?: Maybe<Address_Sum_Fields>;
  var_pop?: Maybe<Address_Var_Pop_Fields>;
  var_samp?: Maybe<Address_Var_Samp_Fields>;
  variance?: Maybe<Address_Variance_Fields>;
};


/** aggregate fields of "address" */
export type Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Address_Avg_Fields = {
  __typename?: 'address_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  address_kind?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  local_area?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Geometry_Comparison_Exp>;
  mutual_groups?: InputMaybe<Mutual_Group_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pincode?: InputMaybe<String_Comparison_Exp>;
  raw_address?: InputMaybe<String_Comparison_Exp>;
  short_address?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  taluka?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  village?: InputMaybe<String_Comparison_Exp>;
  w3w_code?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** input type for incrementing numeric columns in table "address" */
export type Address_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  address_kind?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geometry']>;
  mutual_groups?: InputMaybe<Mutual_Group_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  village?: InputMaybe<Scalars['String']>;
  w3w_code?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Address_Max_Fields = {
  __typename?: 'address_max_fields';
  address_kind?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  local_area?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taluka?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  village?: Maybe<Scalars['String']>;
  w3w_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Address_Min_Fields = {
  __typename?: 'address_min_fields';
  address_kind?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  local_area?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taluka?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  village?: Maybe<Scalars['String']>;
  w3w_code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: 'address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  address_kind?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local_area?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  mutual_groups_aggregate?: InputMaybe<Mutual_Group_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  raw_address?: InputMaybe<Order_By>;
  short_address?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  taluka?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  village?: InputMaybe<Order_By>;
  w3w_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  AddressKind = 'address_kind',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  LocalArea = 'local_area',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  State = 'state',
  /** column name */
  Taluka = 'taluka',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Village = 'village',
  /** column name */
  W3wCode = 'w3w_code'
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  address_kind?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geometry']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  village?: InputMaybe<Scalars['String']>;
  w3w_code?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Address_Stddev_Fields = {
  __typename?: 'address_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Address_Stddev_Pop_Fields = {
  __typename?: 'address_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Address_Stddev_Samp_Fields = {
  __typename?: 'address_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  address_kind?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geometry']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  village?: InputMaybe<Scalars['String']>;
  w3w_code?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Address_Sum_Fields = {
  __typename?: 'address_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  AddressKind = 'address_kind',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  LocalArea = 'local_area',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  State = 'state',
  /** column name */
  Taluka = 'taluka',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Village = 'village',
  /** column name */
  W3wCode = 'w3w_code'
}

export type Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Address_Var_Pop_Fields = {
  __typename?: 'address_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Address_Var_Samp_Fields = {
  __typename?: 'address_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Address_Variance_Fields = {
  __typename?: 'address_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "advice_author_followers" */
export type Advice_Author_Followers = {
  __typename?: 'advice_author_followers';
  /** An object relationship */
  advice_author: Advice_Authors;
  author_id: Scalars['uuid'];
  follower_id?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  shared_follower_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "advice_author_followers" */
export type Advice_Author_Followers_Aggregate = {
  __typename?: 'advice_author_followers_aggregate';
  aggregate?: Maybe<Advice_Author_Followers_Aggregate_Fields>;
  nodes: Array<Advice_Author_Followers>;
};

/** aggregate fields of "advice_author_followers" */
export type Advice_Author_Followers_Aggregate_Fields = {
  __typename?: 'advice_author_followers_aggregate_fields';
  avg?: Maybe<Advice_Author_Followers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Advice_Author_Followers_Max_Fields>;
  min?: Maybe<Advice_Author_Followers_Min_Fields>;
  stddev?: Maybe<Advice_Author_Followers_Stddev_Fields>;
  stddev_pop?: Maybe<Advice_Author_Followers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Advice_Author_Followers_Stddev_Samp_Fields>;
  sum?: Maybe<Advice_Author_Followers_Sum_Fields>;
  var_pop?: Maybe<Advice_Author_Followers_Var_Pop_Fields>;
  var_samp?: Maybe<Advice_Author_Followers_Var_Samp_Fields>;
  variance?: Maybe<Advice_Author_Followers_Variance_Fields>;
};


/** aggregate fields of "advice_author_followers" */
export type Advice_Author_Followers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advice_Author_Followers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "advice_author_followers" */
export type Advice_Author_Followers_Aggregate_Order_By = {
  avg?: InputMaybe<Advice_Author_Followers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Advice_Author_Followers_Max_Order_By>;
  min?: InputMaybe<Advice_Author_Followers_Min_Order_By>;
  stddev?: InputMaybe<Advice_Author_Followers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Advice_Author_Followers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Advice_Author_Followers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Advice_Author_Followers_Sum_Order_By>;
  var_pop?: InputMaybe<Advice_Author_Followers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Advice_Author_Followers_Var_Samp_Order_By>;
  variance?: InputMaybe<Advice_Author_Followers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "advice_author_followers" */
export type Advice_Author_Followers_Arr_Rel_Insert_Input = {
  data: Array<Advice_Author_Followers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Advice_Author_Followers_On_Conflict>;
};

/** aggregate avg on columns */
export type Advice_Author_Followers_Avg_Fields = {
  __typename?: 'advice_author_followers_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_follower_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "advice_author_followers" */
export type Advice_Author_Followers_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "advice_author_followers". All fields are combined with a logical 'AND'. */
export type Advice_Author_Followers_Bool_Exp = {
  _and?: InputMaybe<Array<Advice_Author_Followers_Bool_Exp>>;
  _not?: InputMaybe<Advice_Author_Followers_Bool_Exp>;
  _or?: InputMaybe<Array<Advice_Author_Followers_Bool_Exp>>;
  advice_author?: InputMaybe<Advice_Authors_Bool_Exp>;
  author_id?: InputMaybe<Uuid_Comparison_Exp>;
  follower_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_follower_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "advice_author_followers" */
export enum Advice_Author_Followers_Constraint {
  /** unique or primary key constraint on columns "author_id", "follower_id" */
  AdviceAuthorFollowersAuthorIdFollowerId_6dda65fdUniq = 'advice_author_followers_author_id_follower_id_6dda65fd_uniq',
  /** unique or primary key constraint on columns "id" */
  AdviceAuthorFollowersPkey = 'advice_author_followers_pkey'
}

/** input type for incrementing numeric columns in table "advice_author_followers" */
export type Advice_Author_Followers_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_follower_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "advice_author_followers" */
export type Advice_Author_Followers_Insert_Input = {
  advice_author?: InputMaybe<Advice_Authors_Obj_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['uuid']>;
  follower_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_follower_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Advice_Author_Followers_Max_Fields = {
  __typename?: 'advice_author_followers_max_fields';
  author_id?: Maybe<Scalars['uuid']>;
  follower_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_follower_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "advice_author_followers" */
export type Advice_Author_Followers_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Advice_Author_Followers_Min_Fields = {
  __typename?: 'advice_author_followers_min_fields';
  author_id?: Maybe<Scalars['uuid']>;
  follower_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_follower_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "advice_author_followers" */
export type Advice_Author_Followers_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "advice_author_followers" */
export type Advice_Author_Followers_Mutation_Response = {
  __typename?: 'advice_author_followers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Advice_Author_Followers>;
};

/** on_conflict condition type for table "advice_author_followers" */
export type Advice_Author_Followers_On_Conflict = {
  constraint: Advice_Author_Followers_Constraint;
  update_columns?: Array<Advice_Author_Followers_Update_Column>;
  where?: InputMaybe<Advice_Author_Followers_Bool_Exp>;
};

/** Ordering options when selecting data from "advice_author_followers". */
export type Advice_Author_Followers_Order_By = {
  advice_author?: InputMaybe<Advice_Authors_Order_By>;
  author_id?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: advice_author_followers */
export type Advice_Author_Followers_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "advice_author_followers" */
export enum Advice_Author_Followers_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  FollowerId = 'follower_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedFollowerId = 'shared_follower_id'
}

/** input type for updating data in table "advice_author_followers" */
export type Advice_Author_Followers_Set_Input = {
  author_id?: InputMaybe<Scalars['uuid']>;
  follower_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_follower_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Advice_Author_Followers_Stddev_Fields = {
  __typename?: 'advice_author_followers_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_follower_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "advice_author_followers" */
export type Advice_Author_Followers_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Advice_Author_Followers_Stddev_Pop_Fields = {
  __typename?: 'advice_author_followers_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_follower_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "advice_author_followers" */
export type Advice_Author_Followers_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Advice_Author_Followers_Stddev_Samp_Fields = {
  __typename?: 'advice_author_followers_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_follower_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "advice_author_followers" */
export type Advice_Author_Followers_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "advice_author_followers" */
export type Advice_Author_Followers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advice_Author_Followers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advice_Author_Followers_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['uuid']>;
  follower_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_follower_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Advice_Author_Followers_Sum_Fields = {
  __typename?: 'advice_author_followers_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_follower_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "advice_author_followers" */
export type Advice_Author_Followers_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** update columns of table "advice_author_followers" */
export enum Advice_Author_Followers_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  FollowerId = 'follower_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedFollowerId = 'shared_follower_id'
}

export type Advice_Author_Followers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Advice_Author_Followers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advice_Author_Followers_Set_Input>;
  where: Advice_Author_Followers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Advice_Author_Followers_Var_Pop_Fields = {
  __typename?: 'advice_author_followers_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_follower_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "advice_author_followers" */
export type Advice_Author_Followers_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Advice_Author_Followers_Var_Samp_Fields = {
  __typename?: 'advice_author_followers_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_follower_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "advice_author_followers" */
export type Advice_Author_Followers_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Advice_Author_Followers_Variance_Fields = {
  __typename?: 'advice_author_followers_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_follower_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "advice_author_followers" */
export type Advice_Author_Followers_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_follower_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "advice_authors" */
export type Advice_Authors = {
  __typename?: 'advice_authors';
  about?: Maybe<Scalars['String']>;
  /** An array relationship */
  article_authors: Array<Article_Authors>;
  /** An aggregate relationship */
  article_authors_aggregate: Article_Authors_Aggregate;
  author_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  followers: Array<Advice_Author_Followers>;
  /** An aggregate relationship */
  followers_aggregate: Advice_Author_Followers_Aggregate;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_school_mentor: Scalars['Boolean'];
  organisation_id?: Maybe<Scalars['Int']>;
  photo?: Maybe<Scalars['String']>;
  /** An array relationship */
  series_authors: Array<Series_Authors>;
  /** An aggregate relationship */
  series_authors_aggregate: Series_Authors_Aggregate;
  /** An object relationship */
  shared_author?: Maybe<Shared_Entity>;
  shared_author_id?: Maybe<Scalars['bigint']>;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  title?: Maybe<Scalars['String']>;
};


/** columns and relationships of "advice_authors" */
export type Advice_AuthorsArticle_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Article_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Authors_Order_By>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


/** columns and relationships of "advice_authors" */
export type Advice_AuthorsArticle_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Authors_Order_By>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


/** columns and relationships of "advice_authors" */
export type Advice_AuthorsFollowersArgs = {
  distinct_on?: InputMaybe<Array<Advice_Author_Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Author_Followers_Order_By>>;
  where?: InputMaybe<Advice_Author_Followers_Bool_Exp>;
};


/** columns and relationships of "advice_authors" */
export type Advice_AuthorsFollowers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advice_Author_Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Author_Followers_Order_By>>;
  where?: InputMaybe<Advice_Author_Followers_Bool_Exp>;
};


/** columns and relationships of "advice_authors" */
export type Advice_AuthorsSeries_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Series_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Authors_Order_By>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};


/** columns and relationships of "advice_authors" */
export type Advice_AuthorsSeries_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Authors_Order_By>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};

/** aggregated selection of "advice_authors" */
export type Advice_Authors_Aggregate = {
  __typename?: 'advice_authors_aggregate';
  aggregate?: Maybe<Advice_Authors_Aggregate_Fields>;
  nodes: Array<Advice_Authors>;
};

/** aggregate fields of "advice_authors" */
export type Advice_Authors_Aggregate_Fields = {
  __typename?: 'advice_authors_aggregate_fields';
  avg?: Maybe<Advice_Authors_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Advice_Authors_Max_Fields>;
  min?: Maybe<Advice_Authors_Min_Fields>;
  stddev?: Maybe<Advice_Authors_Stddev_Fields>;
  stddev_pop?: Maybe<Advice_Authors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Advice_Authors_Stddev_Samp_Fields>;
  sum?: Maybe<Advice_Authors_Sum_Fields>;
  var_pop?: Maybe<Advice_Authors_Var_Pop_Fields>;
  var_samp?: Maybe<Advice_Authors_Var_Samp_Fields>;
  variance?: Maybe<Advice_Authors_Variance_Fields>;
};


/** aggregate fields of "advice_authors" */
export type Advice_Authors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advice_Authors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "advice_authors" */
export type Advice_Authors_Aggregate_Order_By = {
  avg?: InputMaybe<Advice_Authors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Advice_Authors_Max_Order_By>;
  min?: InputMaybe<Advice_Authors_Min_Order_By>;
  stddev?: InputMaybe<Advice_Authors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Advice_Authors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Advice_Authors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Advice_Authors_Sum_Order_By>;
  var_pop?: InputMaybe<Advice_Authors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Advice_Authors_Var_Samp_Order_By>;
  variance?: InputMaybe<Advice_Authors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "advice_authors" */
export type Advice_Authors_Arr_Rel_Insert_Input = {
  data: Array<Advice_Authors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Advice_Authors_On_Conflict>;
};

/** aggregate avg on columns */
export type Advice_Authors_Avg_Fields = {
  __typename?: 'advice_authors_avg_fields';
  organisation_id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "advice_authors" */
export type Advice_Authors_Avg_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "advice_authors". All fields are combined with a logical 'AND'. */
export type Advice_Authors_Bool_Exp = {
  _and?: InputMaybe<Array<Advice_Authors_Bool_Exp>>;
  _not?: InputMaybe<Advice_Authors_Bool_Exp>;
  _or?: InputMaybe<Array<Advice_Authors_Bool_Exp>>;
  about?: InputMaybe<String_Comparison_Exp>;
  article_authors?: InputMaybe<Article_Authors_Bool_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  followers?: InputMaybe<Advice_Author_Followers_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_school_mentor?: InputMaybe<Boolean_Comparison_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  photo?: InputMaybe<String_Comparison_Exp>;
  series_authors?: InputMaybe<Series_Authors_Bool_Exp>;
  shared_author?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_author_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_organisation_id?: InputMaybe<Bigint_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "advice_authors" */
export enum Advice_Authors_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdviceAuthorsPkey = 'advice_authors_pkey'
}

/** input type for incrementing numeric columns in table "advice_authors" */
export type Advice_Authors_Inc_Input = {
  organisation_id?: InputMaybe<Scalars['Int']>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "advice_authors" */
export type Advice_Authors_Insert_Input = {
  about?: InputMaybe<Scalars['String']>;
  article_authors?: InputMaybe<Article_Authors_Arr_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['String']>;
  followers?: InputMaybe<Advice_Author_Followers_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_school_mentor?: InputMaybe<Scalars['Boolean']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo?: InputMaybe<Scalars['String']>;
  series_authors?: InputMaybe<Series_Authors_Arr_Rel_Insert_Input>;
  shared_author?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Advice_Authors_Max_Fields = {
  __typename?: 'advice_authors_max_fields';
  about?: Maybe<Scalars['String']>;
  author_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  organisation_id?: Maybe<Scalars['Int']>;
  photo?: Maybe<Scalars['String']>;
  shared_author_id?: Maybe<Scalars['bigint']>;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "advice_authors" */
export type Advice_Authors_Max_Order_By = {
  about?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Advice_Authors_Min_Fields = {
  __typename?: 'advice_authors_min_fields';
  about?: Maybe<Scalars['String']>;
  author_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  organisation_id?: Maybe<Scalars['Int']>;
  photo?: Maybe<Scalars['String']>;
  shared_author_id?: Maybe<Scalars['bigint']>;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "advice_authors" */
export type Advice_Authors_Min_Order_By = {
  about?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "advice_authors" */
export type Advice_Authors_Mutation_Response = {
  __typename?: 'advice_authors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Advice_Authors>;
};

/** input type for inserting object relation for remote table "advice_authors" */
export type Advice_Authors_Obj_Rel_Insert_Input = {
  data: Advice_Authors_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Advice_Authors_On_Conflict>;
};

/** on_conflict condition type for table "advice_authors" */
export type Advice_Authors_On_Conflict = {
  constraint: Advice_Authors_Constraint;
  update_columns?: Array<Advice_Authors_Update_Column>;
  where?: InputMaybe<Advice_Authors_Bool_Exp>;
};

/** Ordering options when selecting data from "advice_authors". */
export type Advice_Authors_Order_By = {
  about?: InputMaybe<Order_By>;
  article_authors_aggregate?: InputMaybe<Article_Authors_Aggregate_Order_By>;
  author_id?: InputMaybe<Order_By>;
  followers_aggregate?: InputMaybe<Advice_Author_Followers_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_school_mentor?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo?: InputMaybe<Order_By>;
  series_authors_aggregate?: InputMaybe<Series_Authors_Aggregate_Order_By>;
  shared_author?: InputMaybe<Shared_Entity_Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: advice_authors */
export type Advice_Authors_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "advice_authors" */
export enum Advice_Authors_Select_Column {
  /** column name */
  About = 'about',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSchoolMentor = 'is_school_mentor',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Photo = 'photo',
  /** column name */
  SharedAuthorId = 'shared_author_id',
  /** column name */
  SharedOrganisationId = 'shared_organisation_id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "advice_authors" */
export type Advice_Authors_Set_Input = {
  about?: InputMaybe<Scalars['String']>;
  author_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_school_mentor?: InputMaybe<Scalars['Boolean']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo?: InputMaybe<Scalars['String']>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Advice_Authors_Stddev_Fields = {
  __typename?: 'advice_authors_stddev_fields';
  organisation_id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "advice_authors" */
export type Advice_Authors_Stddev_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Advice_Authors_Stddev_Pop_Fields = {
  __typename?: 'advice_authors_stddev_pop_fields';
  organisation_id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "advice_authors" */
export type Advice_Authors_Stddev_Pop_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Advice_Authors_Stddev_Samp_Fields = {
  __typename?: 'advice_authors_stddev_samp_fields';
  organisation_id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "advice_authors" */
export type Advice_Authors_Stddev_Samp_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "advice_authors" */
export type Advice_Authors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advice_Authors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advice_Authors_Stream_Cursor_Value_Input = {
  about?: InputMaybe<Scalars['String']>;
  author_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_school_mentor?: InputMaybe<Scalars['Boolean']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo?: InputMaybe<Scalars['String']>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Advice_Authors_Sum_Fields = {
  __typename?: 'advice_authors_sum_fields';
  organisation_id?: Maybe<Scalars['Int']>;
  shared_author_id?: Maybe<Scalars['bigint']>;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "advice_authors" */
export type Advice_Authors_Sum_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
};

/** update columns of table "advice_authors" */
export enum Advice_Authors_Update_Column {
  /** column name */
  About = 'about',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSchoolMentor = 'is_school_mentor',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Photo = 'photo',
  /** column name */
  SharedAuthorId = 'shared_author_id',
  /** column name */
  SharedOrganisationId = 'shared_organisation_id',
  /** column name */
  Title = 'title'
}

export type Advice_Authors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Advice_Authors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advice_Authors_Set_Input>;
  where: Advice_Authors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Advice_Authors_Var_Pop_Fields = {
  __typename?: 'advice_authors_var_pop_fields';
  organisation_id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "advice_authors" */
export type Advice_Authors_Var_Pop_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Advice_Authors_Var_Samp_Fields = {
  __typename?: 'advice_authors_var_samp_fields';
  organisation_id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "advice_authors" */
export type Advice_Authors_Var_Samp_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Advice_Authors_Variance_Fields = {
  __typename?: 'advice_authors_variance_fields';
  organisation_id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "advice_authors" */
export type Advice_Authors_Variance_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "agent" */
export type Agent = {
  __typename?: 'agent';
  accepts_tnc: Scalars['Boolean'];
  /** An object relationship */
  base_user: Base_User;
  codename: Scalars['String'];
  /** An array relationship */
  companies: Array<Agent_Company>;
  /** An aggregate relationship */
  companies_aggregate: Agent_Company_Aggregate;
  current_department_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  department?: Maybe<Department>;
  description: Scalars['String'];
  eid: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  number: Scalars['String'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** columns and relationships of "agent" */
export type AgentCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


/** columns and relationships of "agent" */
export type AgentCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};

/** aggregated selection of "agent" */
export type Agent_Aggregate = {
  __typename?: 'agent_aggregate';
  aggregate?: Maybe<Agent_Aggregate_Fields>;
  nodes: Array<Agent>;
};

/** aggregate fields of "agent" */
export type Agent_Aggregate_Fields = {
  __typename?: 'agent_aggregate_fields';
  avg?: Maybe<Agent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agent_Max_Fields>;
  min?: Maybe<Agent_Min_Fields>;
  stddev?: Maybe<Agent_Stddev_Fields>;
  stddev_pop?: Maybe<Agent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agent_Stddev_Samp_Fields>;
  sum?: Maybe<Agent_Sum_Fields>;
  var_pop?: Maybe<Agent_Var_Pop_Fields>;
  var_samp?: Maybe<Agent_Var_Samp_Fields>;
  variance?: Maybe<Agent_Variance_Fields>;
};


/** aggregate fields of "agent" */
export type Agent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agent" */
export type Agent_Aggregate_Order_By = {
  avg?: InputMaybe<Agent_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agent_Max_Order_By>;
  min?: InputMaybe<Agent_Min_Order_By>;
  stddev?: InputMaybe<Agent_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agent_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agent_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agent_Sum_Order_By>;
  var_pop?: InputMaybe<Agent_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agent_Var_Samp_Order_By>;
  variance?: InputMaybe<Agent_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agent" */
export type Agent_Arr_Rel_Insert_Input = {
  data: Array<Agent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agent_On_Conflict>;
};

/** aggregate avg on columns */
export type Agent_Avg_Fields = {
  __typename?: 'agent_avg_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agent" */
export type Agent_Avg_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agent". All fields are combined with a logical 'AND'. */
export type Agent_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Bool_Exp>>;
  _not?: InputMaybe<Agent_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Bool_Exp>>;
  accepts_tnc?: InputMaybe<Boolean_Comparison_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Agent_Company_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  eid?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "agent_company" */
export type Agent_Company = {
  __typename?: 'agent_company';
  accepts_tnc: Scalars['Boolean'];
  /** An object relationship */
  agent: Agent;
  agent_id: Scalars['Int'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "agent_company" */
export type Agent_Company_Aggregate = {
  __typename?: 'agent_company_aggregate';
  aggregate?: Maybe<Agent_Company_Aggregate_Fields>;
  nodes: Array<Agent_Company>;
};

/** aggregate fields of "agent_company" */
export type Agent_Company_Aggregate_Fields = {
  __typename?: 'agent_company_aggregate_fields';
  avg?: Maybe<Agent_Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agent_Company_Max_Fields>;
  min?: Maybe<Agent_Company_Min_Fields>;
  stddev?: Maybe<Agent_Company_Stddev_Fields>;
  stddev_pop?: Maybe<Agent_Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agent_Company_Stddev_Samp_Fields>;
  sum?: Maybe<Agent_Company_Sum_Fields>;
  var_pop?: Maybe<Agent_Company_Var_Pop_Fields>;
  var_samp?: Maybe<Agent_Company_Var_Samp_Fields>;
  variance?: Maybe<Agent_Company_Variance_Fields>;
};


/** aggregate fields of "agent_company" */
export type Agent_Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agent_Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agent_company" */
export type Agent_Company_Aggregate_Order_By = {
  avg?: InputMaybe<Agent_Company_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agent_Company_Max_Order_By>;
  min?: InputMaybe<Agent_Company_Min_Order_By>;
  stddev?: InputMaybe<Agent_Company_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agent_Company_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agent_Company_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agent_Company_Sum_Order_By>;
  var_pop?: InputMaybe<Agent_Company_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agent_Company_Var_Samp_Order_By>;
  variance?: InputMaybe<Agent_Company_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agent_company" */
export type Agent_Company_Arr_Rel_Insert_Input = {
  data: Array<Agent_Company_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agent_Company_On_Conflict>;
};

/** aggregate avg on columns */
export type Agent_Company_Avg_Fields = {
  __typename?: 'agent_company_avg_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agent_company" */
export type Agent_Company_Avg_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agent_company". All fields are combined with a logical 'AND'. */
export type Agent_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Company_Bool_Exp>>;
  _not?: InputMaybe<Agent_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Company_Bool_Exp>>;
  accepts_tnc?: InputMaybe<Boolean_Comparison_Exp>;
  agent?: InputMaybe<Agent_Bool_Exp>;
  agent_id?: InputMaybe<Int_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "agent_company" */
export enum Agent_Company_Constraint {
  /** unique or primary key constraint on columns "agent_id", "company_id" */
  AgentCompanyAgentIdCompanyIdCc3e7b91Uniq = 'agent_company_agent_id_company_id_cc3e7b91_uniq',
  /** unique or primary key constraint on columns "id" */
  AgentCompanyPkey = 'agent_company_pkey'
}

/** input type for incrementing numeric columns in table "agent_company" */
export type Agent_Company_Inc_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agent_company" */
export type Agent_Company_Insert_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  agent?: InputMaybe<Agent_Obj_Rel_Insert_Input>;
  agent_id?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Agent_Company_Max_Fields = {
  __typename?: 'agent_company_max_fields';
  agent_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "agent_company" */
export type Agent_Company_Max_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agent_Company_Min_Fields = {
  __typename?: 'agent_company_min_fields';
  agent_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "agent_company" */
export type Agent_Company_Min_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agent_company" */
export type Agent_Company_Mutation_Response = {
  __typename?: 'agent_company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agent_Company>;
};

/** on_conflict condition type for table "agent_company" */
export type Agent_Company_On_Conflict = {
  constraint: Agent_Company_Constraint;
  update_columns?: Array<Agent_Company_Update_Column>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};

/** Ordering options when selecting data from "agent_company". */
export type Agent_Company_Order_By = {
  accepts_tnc?: InputMaybe<Order_By>;
  agent?: InputMaybe<Agent_Order_By>;
  agent_id?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent_company */
export type Agent_Company_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agent_company" */
export enum Agent_Company_Select_Column {
  /** column name */
  AcceptsTnc = 'accepts_tnc',
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "agent_company" */
export type Agent_Company_Set_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  agent_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Agent_Company_Stddev_Fields = {
  __typename?: 'agent_company_stddev_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agent_company" */
export type Agent_Company_Stddev_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agent_Company_Stddev_Pop_Fields = {
  __typename?: 'agent_company_stddev_pop_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agent_company" */
export type Agent_Company_Stddev_Pop_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agent_Company_Stddev_Samp_Fields = {
  __typename?: 'agent_company_stddev_samp_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agent_company" */
export type Agent_Company_Stddev_Samp_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agent_company" */
export type Agent_Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Company_Stream_Cursor_Value_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  agent_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Agent_Company_Sum_Fields = {
  __typename?: 'agent_company_sum_fields';
  agent_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agent_company" */
export type Agent_Company_Sum_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "agent_company" */
export enum Agent_Company_Update_Column {
  /** column name */
  AcceptsTnc = 'accepts_tnc',
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

export type Agent_Company_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agent_Company_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agent_Company_Set_Input>;
  where: Agent_Company_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agent_Company_Var_Pop_Fields = {
  __typename?: 'agent_company_var_pop_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agent_company" */
export type Agent_Company_Var_Pop_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agent_Company_Var_Samp_Fields = {
  __typename?: 'agent_company_var_samp_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agent_company" */
export type Agent_Company_Var_Samp_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agent_Company_Variance_Fields = {
  __typename?: 'agent_company_variance_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agent_company" */
export type Agent_Company_Variance_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "agent" */
export enum Agent_Constraint {
  /** unique or primary key constraint on columns "codename" */
  AgentCodenameKey = 'agent_codename_key',
  /** unique or primary key constraint on columns "organisation_id", "eid" */
  AgentOrganisationIdEid_6689a3f2Uniq = 'agent_organisation_id_eid_6689a3f2_uniq',
  /** unique or primary key constraint on columns "organisation_id", "user_id" */
  AgentOrganisationIdUserId_44d1bc58Uniq = 'agent_organisation_id_user_id_44d1bc58_uniq',
  /** unique or primary key constraint on columns "id" */
  AgentPkey = 'agent_pkey'
}

/** input type for incrementing numeric columns in table "agent" */
export type Agent_Inc_Input = {
  current_department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agent" */
export type Agent_Insert_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Agent_Company_Arr_Rel_Insert_Input>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  eid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Agent_Max_Fields = {
  __typename?: 'agent_max_fields';
  codename?: Maybe<Scalars['String']>;
  current_department_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  eid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "agent" */
export type Agent_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  eid?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agent_Min_Fields = {
  __typename?: 'agent_min_fields';
  codename?: Maybe<Scalars['String']>;
  current_department_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  eid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "agent" */
export type Agent_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  eid?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agent" */
export type Agent_Mutation_Response = {
  __typename?: 'agent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agent>;
};

/** input type for inserting object relation for remote table "agent" */
export type Agent_Obj_Rel_Insert_Input = {
  data: Agent_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agent_On_Conflict>;
};

/** on_conflict condition type for table "agent" */
export type Agent_On_Conflict = {
  constraint: Agent_Constraint;
  update_columns?: Array<Agent_Update_Column>;
  where?: InputMaybe<Agent_Bool_Exp>;
};

/** Ordering options when selecting data from "agent". */
export type Agent_Order_By = {
  accepts_tnc?: InputMaybe<Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  codename?: InputMaybe<Order_By>;
  companies_aggregate?: InputMaybe<Agent_Company_Aggregate_Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Department_Order_By>;
  description?: InputMaybe<Order_By>;
  eid?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent */
export type Agent_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agent" */
export enum Agent_Select_Column {
  /** column name */
  AcceptsTnc = 'accepts_tnc',
  /** column name */
  Codename = 'codename',
  /** column name */
  CurrentDepartmentId = 'current_department_id',
  /** column name */
  Description = 'description',
  /** column name */
  Eid = 'eid',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "agent" */
export type Agent_Set_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  eid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Agent_Stddev_Fields = {
  __typename?: 'agent_stddev_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agent" */
export type Agent_Stddev_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agent_Stddev_Pop_Fields = {
  __typename?: 'agent_stddev_pop_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agent" */
export type Agent_Stddev_Pop_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agent_Stddev_Samp_Fields = {
  __typename?: 'agent_stddev_samp_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agent" */
export type Agent_Stddev_Samp_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agent" */
export type Agent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Stream_Cursor_Value_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  eid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Agent_Sum_Fields = {
  __typename?: 'agent_sum_fields';
  current_department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agent" */
export type Agent_Sum_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "agent" */
export enum Agent_Update_Column {
  /** column name */
  AcceptsTnc = 'accepts_tnc',
  /** column name */
  Codename = 'codename',
  /** column name */
  CurrentDepartmentId = 'current_department_id',
  /** column name */
  Description = 'description',
  /** column name */
  Eid = 'eid',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

export type Agent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agent_Set_Input>;
  where: Agent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agent_Var_Pop_Fields = {
  __typename?: 'agent_var_pop_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agent" */
export type Agent_Var_Pop_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agent_Var_Samp_Fields = {
  __typename?: 'agent_var_samp_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agent" */
export type Agent_Var_Samp_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agent_Variance_Fields = {
  __typename?: 'agent_variance_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agent" */
export type Agent_Variance_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "answer_choice" */
export type Answer_Choice = {
  __typename?: 'answer_choice';
  /** An object relationship */
  assessment_question: Assessment_Question;
  assessment_question_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_correct_answer: Scalars['Boolean'];
  order: Scalars['smallint'];
  text: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
};

/** aggregated selection of "answer_choice" */
export type Answer_Choice_Aggregate = {
  __typename?: 'answer_choice_aggregate';
  aggregate?: Maybe<Answer_Choice_Aggregate_Fields>;
  nodes: Array<Answer_Choice>;
};

/** aggregate fields of "answer_choice" */
export type Answer_Choice_Aggregate_Fields = {
  __typename?: 'answer_choice_aggregate_fields';
  avg?: Maybe<Answer_Choice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Answer_Choice_Max_Fields>;
  min?: Maybe<Answer_Choice_Min_Fields>;
  stddev?: Maybe<Answer_Choice_Stddev_Fields>;
  stddev_pop?: Maybe<Answer_Choice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Answer_Choice_Stddev_Samp_Fields>;
  sum?: Maybe<Answer_Choice_Sum_Fields>;
  var_pop?: Maybe<Answer_Choice_Var_Pop_Fields>;
  var_samp?: Maybe<Answer_Choice_Var_Samp_Fields>;
  variance?: Maybe<Answer_Choice_Variance_Fields>;
};


/** aggregate fields of "answer_choice" */
export type Answer_Choice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Answer_Choice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "answer_choice" */
export type Answer_Choice_Aggregate_Order_By = {
  avg?: InputMaybe<Answer_Choice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Answer_Choice_Max_Order_By>;
  min?: InputMaybe<Answer_Choice_Min_Order_By>;
  stddev?: InputMaybe<Answer_Choice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Answer_Choice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Answer_Choice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Answer_Choice_Sum_Order_By>;
  var_pop?: InputMaybe<Answer_Choice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Answer_Choice_Var_Samp_Order_By>;
  variance?: InputMaybe<Answer_Choice_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "answer_choice" */
export type Answer_Choice_Arr_Rel_Insert_Input = {
  data: Array<Answer_Choice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Answer_Choice_On_Conflict>;
};

/** aggregate avg on columns */
export type Answer_Choice_Avg_Fields = {
  __typename?: 'answer_choice_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "answer_choice" */
export type Answer_Choice_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "answer_choice". All fields are combined with a logical 'AND'. */
export type Answer_Choice_Bool_Exp = {
  _and?: InputMaybe<Array<Answer_Choice_Bool_Exp>>;
  _not?: InputMaybe<Answer_Choice_Bool_Exp>;
  _or?: InputMaybe<Array<Answer_Choice_Bool_Exp>>;
  assessment_question?: InputMaybe<Assessment_Question_Bool_Exp>;
  assessment_question_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_correct_answer?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "answer_choice" */
export enum Answer_Choice_Constraint {
  /** unique or primary key constraint on columns "order", "assessment_question_id", "text" */
  AnswerChoiceOrderAssessmentQuestionIdText_22da8cdcUniq = 'answer_choice_order_assessment_question_id_text_22da8cdc_uniq',
  /** unique or primary key constraint on columns "id" */
  AnswerChoicePkey = 'answer_choice_pkey'
}

/** input type for incrementing numeric columns in table "answer_choice" */
export type Answer_Choice_Inc_Input = {
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "answer_choice" */
export type Answer_Choice_Insert_Input = {
  assessment_question?: InputMaybe<Assessment_Question_Obj_Rel_Insert_Input>;
  assessment_question_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_correct_answer?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  text?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Answer_Choice_Max_Fields = {
  __typename?: 'answer_choice_max_fields';
  assessment_question_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "answer_choice" */
export type Answer_Choice_Max_Order_By = {
  assessment_question_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Answer_Choice_Min_Fields = {
  __typename?: 'answer_choice_min_fields';
  assessment_question_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "answer_choice" */
export type Answer_Choice_Min_Order_By = {
  assessment_question_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "answer_choice" */
export type Answer_Choice_Mutation_Response = {
  __typename?: 'answer_choice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Answer_Choice>;
};

/** input type for inserting object relation for remote table "answer_choice" */
export type Answer_Choice_Obj_Rel_Insert_Input = {
  data: Answer_Choice_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Answer_Choice_On_Conflict>;
};

/** on_conflict condition type for table "answer_choice" */
export type Answer_Choice_On_Conflict = {
  constraint: Answer_Choice_Constraint;
  update_columns?: Array<Answer_Choice_Update_Column>;
  where?: InputMaybe<Answer_Choice_Bool_Exp>;
};

/** Ordering options when selecting data from "answer_choice". */
export type Answer_Choice_Order_By = {
  assessment_question?: InputMaybe<Assessment_Question_Order_By>;
  assessment_question_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_correct_answer?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: answer_choice */
export type Answer_Choice_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "answer_choice" */
export enum Answer_Choice_Select_Column {
  /** column name */
  AssessmentQuestionId = 'assessment_question_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCorrectAnswer = 'is_correct_answer',
  /** column name */
  Order = 'order',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "answer_choice" */
export type Answer_Choice_Set_Input = {
  assessment_question_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_correct_answer?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  text?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Answer_Choice_Stddev_Fields = {
  __typename?: 'answer_choice_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "answer_choice" */
export type Answer_Choice_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Answer_Choice_Stddev_Pop_Fields = {
  __typename?: 'answer_choice_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "answer_choice" */
export type Answer_Choice_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Answer_Choice_Stddev_Samp_Fields = {
  __typename?: 'answer_choice_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "answer_choice" */
export type Answer_Choice_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "answer_choice" */
export type Answer_Choice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Answer_Choice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Answer_Choice_Stream_Cursor_Value_Input = {
  assessment_question_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_correct_answer?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  text?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Answer_Choice_Sum_Fields = {
  __typename?: 'answer_choice_sum_fields';
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "answer_choice" */
export type Answer_Choice_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "answer_choice" */
export enum Answer_Choice_Update_Column {
  /** column name */
  AssessmentQuestionId = 'assessment_question_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCorrectAnswer = 'is_correct_answer',
  /** column name */
  Order = 'order',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Answer_Choice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Answer_Choice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Answer_Choice_Set_Input>;
  where: Answer_Choice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Answer_Choice_Var_Pop_Fields = {
  __typename?: 'answer_choice_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "answer_choice" */
export type Answer_Choice_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Answer_Choice_Var_Samp_Fields = {
  __typename?: 'answer_choice_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "answer_choice" */
export type Answer_Choice_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Answer_Choice_Variance_Fields = {
  __typename?: 'answer_choice_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "answer_choice" */
export type Answer_Choice_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "application_product_unit" */
export type Application_Product_Unit = {
  __typename?: 'application_product_unit';
  /** An object relationship */
  application_product_unit?: Maybe<Care_Shared_Entity>;
  id: Scalars['bigint'];
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid'];
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id: Scalars['String'];
};

/** aggregated selection of "application_product_unit" */
export type Application_Product_Unit_Aggregate = {
  __typename?: 'application_product_unit_aggregate';
  aggregate?: Maybe<Application_Product_Unit_Aggregate_Fields>;
  nodes: Array<Application_Product_Unit>;
};

/** aggregate fields of "application_product_unit" */
export type Application_Product_Unit_Aggregate_Fields = {
  __typename?: 'application_product_unit_aggregate_fields';
  avg?: Maybe<Application_Product_Unit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Application_Product_Unit_Max_Fields>;
  min?: Maybe<Application_Product_Unit_Min_Fields>;
  stddev?: Maybe<Application_Product_Unit_Stddev_Fields>;
  stddev_pop?: Maybe<Application_Product_Unit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Application_Product_Unit_Stddev_Samp_Fields>;
  sum?: Maybe<Application_Product_Unit_Sum_Fields>;
  var_pop?: Maybe<Application_Product_Unit_Var_Pop_Fields>;
  var_samp?: Maybe<Application_Product_Unit_Var_Samp_Fields>;
  variance?: Maybe<Application_Product_Unit_Variance_Fields>;
};


/** aggregate fields of "application_product_unit" */
export type Application_Product_Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Application_Product_Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "application_product_unit" */
export type Application_Product_Unit_Aggregate_Order_By = {
  avg?: InputMaybe<Application_Product_Unit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Application_Product_Unit_Max_Order_By>;
  min?: InputMaybe<Application_Product_Unit_Min_Order_By>;
  stddev?: InputMaybe<Application_Product_Unit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Application_Product_Unit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Application_Product_Unit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Application_Product_Unit_Sum_Order_By>;
  var_pop?: InputMaybe<Application_Product_Unit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Application_Product_Unit_Var_Samp_Order_By>;
  variance?: InputMaybe<Application_Product_Unit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "application_product_unit" */
export type Application_Product_Unit_Arr_Rel_Insert_Input = {
  data: Array<Application_Product_Unit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_Product_Unit_On_Conflict>;
};

/** aggregate avg on columns */
export type Application_Product_Unit_Avg_Fields = {
  __typename?: 'application_product_unit_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "application_product_unit" */
export type Application_Product_Unit_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "application_product_unit". All fields are combined with a logical 'AND'. */
export type Application_Product_Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Application_Product_Unit_Bool_Exp>>;
  _not?: InputMaybe<Application_Product_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Application_Product_Unit_Bool_Exp>>;
  application_product_unit?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "application_product_unit" */
export enum Application_Product_Unit_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationProductUnitPkey = 'application_product_unit_pkey'
}

/** input type for incrementing numeric columns in table "application_product_unit" */
export type Application_Product_Unit_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "application_product_unit" */
export type Application_Product_Unit_Insert_Input = {
  application_product_unit?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Application_Product_Unit_Max_Fields = {
  __typename?: 'application_product_unit_max_fields';
  id?: Maybe<Scalars['bigint']>;
  product_id?: Maybe<Scalars['uuid']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "application_product_unit" */
export type Application_Product_Unit_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Application_Product_Unit_Min_Fields = {
  __typename?: 'application_product_unit_min_fields';
  id?: Maybe<Scalars['bigint']>;
  product_id?: Maybe<Scalars['uuid']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "application_product_unit" */
export type Application_Product_Unit_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "application_product_unit" */
export type Application_Product_Unit_Mutation_Response = {
  __typename?: 'application_product_unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Application_Product_Unit>;
};

/** on_conflict condition type for table "application_product_unit" */
export type Application_Product_Unit_On_Conflict = {
  constraint: Application_Product_Unit_Constraint;
  update_columns?: Array<Application_Product_Unit_Update_Column>;
  where?: InputMaybe<Application_Product_Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "application_product_unit". */
export type Application_Product_Unit_Order_By = {
  application_product_unit?: InputMaybe<Care_Shared_Entity_Order_By>;
  id?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: application_product_unit */
export type Application_Product_Unit_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "application_product_unit" */
export enum Application_Product_Unit_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  SharedUnitId = 'shared_unit_id',
  /** column name */
  UnitId = 'unit_id'
}

/** input type for updating data in table "application_product_unit" */
export type Application_Product_Unit_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Application_Product_Unit_Stddev_Fields = {
  __typename?: 'application_product_unit_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "application_product_unit" */
export type Application_Product_Unit_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Application_Product_Unit_Stddev_Pop_Fields = {
  __typename?: 'application_product_unit_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "application_product_unit" */
export type Application_Product_Unit_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Application_Product_Unit_Stddev_Samp_Fields = {
  __typename?: 'application_product_unit_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "application_product_unit" */
export type Application_Product_Unit_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "application_product_unit" */
export type Application_Product_Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Product_Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Product_Unit_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Application_Product_Unit_Sum_Fields = {
  __typename?: 'application_product_unit_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "application_product_unit" */
export type Application_Product_Unit_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** update columns of table "application_product_unit" */
export enum Application_Product_Unit_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  SharedUnitId = 'shared_unit_id',
  /** column name */
  UnitId = 'unit_id'
}

export type Application_Product_Unit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Application_Product_Unit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Application_Product_Unit_Set_Input>;
  where: Application_Product_Unit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Application_Product_Unit_Var_Pop_Fields = {
  __typename?: 'application_product_unit_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "application_product_unit" */
export type Application_Product_Unit_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Application_Product_Unit_Var_Samp_Fields = {
  __typename?: 'application_product_unit_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "application_product_unit" */
export type Application_Product_Unit_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Application_Product_Unit_Variance_Fields = {
  __typename?: 'application_product_unit_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "application_product_unit" */
export type Application_Product_Unit_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "article" */
export type Article = {
  __typename?: 'article';
  /** An array relationship */
  article_favorites: Array<Article_Favorites>;
  /** An aggregate relationship */
  article_favorites_aggregate: Article_Favorites_Aggregate;
  /** An array relationship */
  article_series: Array<Article_Series>;
  /** An aggregate relationship */
  article_series_aggregate: Article_Series_Aggregate;
  article_type: Scalars['String'];
  /** An array relationship */
  attachments: Array<Article_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Article_Attachments_Aggregate;
  /** An array relationship */
  authors: Array<Article_Authors>;
  /** An aggregate relationship */
  authors_aggregate: Article_Authors_Aggregate;
  /** An array relationship */
  categories: Array<Article_Categories>;
  /** An aggregate relationship */
  categories_aggregate: Article_Categories_Aggregate;
  /** An array relationship */
  comments: Array<Comment>;
  /** An aggregate relationship */
  comments_aggregate: Comment_Aggregate;
  content?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  /** An array relationship */
  crop_categories: Array<Article_Crop_Categories>;
  /** An aggregate relationship */
  crop_categories_aggregate: Article_Crop_Categories_Aggregate;
  /** An array relationship */
  crop_varieties: Array<Article_Crop_Varieties>;
  /** An aggregate relationship */
  crop_varieties_aggregate: Article_Crop_Varieties_Aggregate;
  /** An array relationship */
  crops: Array<Article_Crops>;
  /** An aggregate relationship */
  crops_aggregate: Article_Crops_Aggregate;
  description: Scalars['String'];
  duration: Scalars['Int'];
  expiry_date?: Maybe<Scalars['date']>;
  feature_date_from?: Maybe<Scalars['date']>;
  feature_date_till?: Maybe<Scalars['date']>;
  /** An object relationship */
  feature_image?: Maybe<Fileupload>;
  feature_image_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_series: Scalars['Boolean'];
  /** An array relationship */
  likes: Array<Article_Likes>;
  /** An aggregate relationship */
  likes_aggregate: Article_Likes_Aggregate;
  publish_date?: Maybe<Scalars['date']>;
  /** An array relationship */
  regions: Array<Article_Regions>;
  /** An aggregate relationship */
  regions_aggregate: Article_Regions_Aggregate;
  status: Scalars['String'];
  /** An array relationship */
  subscriptions: Array<Article_Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Article_Subscriptions_Aggregate;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
  /** An array relationship */
  user_groups: Array<Article_User_Group>;
  /** An aggregate relationship */
  user_groups_aggregate: Article_User_Group_Aggregate;
  /** An array relationship */
  views: Array<Article_Views>;
  /** An aggregate relationship */
  views_aggregate: Article_Views_Aggregate;
};


/** columns and relationships of "article" */
export type ArticleArticle_FavoritesArgs = {
  distinct_on?: InputMaybe<Array<Article_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Favorites_Order_By>>;
  where?: InputMaybe<Article_Favorites_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleArticle_Favorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Favorites_Order_By>>;
  where?: InputMaybe<Article_Favorites_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleArticle_SeriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleArticle_Series_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Article_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Attachments_Order_By>>;
  where?: InputMaybe<Article_Attachments_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Attachments_Order_By>>;
  where?: InputMaybe<Article_Attachments_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleAuthorsArgs = {
  distinct_on?: InputMaybe<Array<Article_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Authors_Order_By>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleAuthors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Authors_Order_By>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Categories_Order_By>>;
  where?: InputMaybe<Article_Categories_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Categories_Order_By>>;
  where?: InputMaybe<Article_Categories_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Articlecreator>;
};


/** columns and relationships of "article" */
export type ArticleCrop_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Categories_Order_By>>;
  where?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleCrop_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Categories_Order_By>>;
  where?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleCrop_VarietiesArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Varieties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Varieties_Order_By>>;
  where?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleCrop_Varieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Varieties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Varieties_Order_By>>;
  where?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleCropsArgs = {
  distinct_on?: InputMaybe<Array<Article_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crops_Order_By>>;
  where?: InputMaybe<Article_Crops_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleCrops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crops_Order_By>>;
  where?: InputMaybe<Article_Crops_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleLikesArgs = {
  distinct_on?: InputMaybe<Array<Article_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Likes_Order_By>>;
  where?: InputMaybe<Article_Likes_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleLikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Likes_Order_By>>;
  where?: InputMaybe<Article_Likes_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleRegionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Regions_Order_By>>;
  where?: InputMaybe<Article_Regions_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Regions_Order_By>>;
  where?: InputMaybe<Article_Regions_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscriptions_Order_By>>;
  where?: InputMaybe<Article_Subscriptions_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscriptions_Order_By>>;
  where?: InputMaybe<Article_Subscriptions_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Articleupdater>;
};


/** columns and relationships of "article" */
export type ArticleUser_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Article_User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_User_Group_Order_By>>;
  where?: InputMaybe<Article_User_Group_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleUser_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_User_Group_Order_By>>;
  where?: InputMaybe<Article_User_Group_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleViewsArgs = {
  distinct_on?: InputMaybe<Array<Article_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Views_Order_By>>;
  where?: InputMaybe<Article_Views_Bool_Exp>;
};


/** columns and relationships of "article" */
export type ArticleViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Views_Order_By>>;
  where?: InputMaybe<Article_Views_Bool_Exp>;
};

/** aggregated selection of "article" */
export type Article_Aggregate = {
  __typename?: 'article_aggregate';
  aggregate?: Maybe<Article_Aggregate_Fields>;
  nodes: Array<Article>;
};

/** aggregate fields of "article" */
export type Article_Aggregate_Fields = {
  __typename?: 'article_aggregate_fields';
  avg?: Maybe<Article_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Max_Fields>;
  min?: Maybe<Article_Min_Fields>;
  stddev?: Maybe<Article_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Sum_Fields>;
  var_pop?: Maybe<Article_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Var_Samp_Fields>;
  variance?: Maybe<Article_Variance_Fields>;
};


/** aggregate fields of "article" */
export type Article_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article" */
export type Article_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Max_Order_By>;
  min?: InputMaybe<Article_Min_Order_By>;
  stddev?: InputMaybe<Article_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article" */
export type Article_Arr_Rel_Insert_Input = {
  data: Array<Article_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_On_Conflict>;
};

/** columns and relationships of "article_attachments" */
export type Article_Attachments = {
  __typename?: 'article_attachments';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  /** An object relationship */
  attachment: Fileupload;
  attachment_id: Scalars['bigint'];
  id: Scalars['bigint'];
};

/** aggregated selection of "article_attachments" */
export type Article_Attachments_Aggregate = {
  __typename?: 'article_attachments_aggregate';
  aggregate?: Maybe<Article_Attachments_Aggregate_Fields>;
  nodes: Array<Article_Attachments>;
};

/** aggregate fields of "article_attachments" */
export type Article_Attachments_Aggregate_Fields = {
  __typename?: 'article_attachments_aggregate_fields';
  avg?: Maybe<Article_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Attachments_Max_Fields>;
  min?: Maybe<Article_Attachments_Min_Fields>;
  stddev?: Maybe<Article_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Attachments_Sum_Fields>;
  var_pop?: Maybe<Article_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Article_Attachments_Variance_Fields>;
};


/** aggregate fields of "article_attachments" */
export type Article_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_attachments" */
export type Article_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Attachments_Max_Order_By>;
  min?: InputMaybe<Article_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Article_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_attachments" */
export type Article_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Article_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Attachments_Avg_Fields = {
  __typename?: 'article_attachments_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_attachments" */
export type Article_Attachments_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_attachments". All fields are combined with a logical 'AND'. */
export type Article_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Article_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Attachments_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  attachment?: InputMaybe<Fileupload_Bool_Exp>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_attachments" */
export enum Article_Attachments_Constraint {
  /** unique or primary key constraint on columns "attachment_id", "article_id" */
  ArticleAttachmentsArticleIdAttachmentIdFc40a706Uniq = 'article_attachments_article_id_attachment_id_fc40a706_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleAttachmentsPkey = 'article_attachments_pkey'
}

/** input type for incrementing numeric columns in table "article_attachments" */
export type Article_Attachments_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_attachments" */
export type Article_Attachments_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  attachment?: InputMaybe<Fileupload_Obj_Rel_Insert_Input>;
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Attachments_Max_Fields = {
  __typename?: 'article_attachments_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "article_attachments" */
export type Article_Attachments_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Attachments_Min_Fields = {
  __typename?: 'article_attachments_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "article_attachments" */
export type Article_Attachments_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_attachments" */
export type Article_Attachments_Mutation_Response = {
  __typename?: 'article_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Attachments>;
};

/** on_conflict condition type for table "article_attachments" */
export type Article_Attachments_On_Conflict = {
  constraint: Article_Attachments_Constraint;
  update_columns?: Array<Article_Attachments_Update_Column>;
  where?: InputMaybe<Article_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "article_attachments". */
export type Article_Attachments_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  attachment?: InputMaybe<Fileupload_Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_attachments */
export type Article_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_attachments" */
export enum Article_Attachments_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "article_attachments" */
export type Article_Attachments_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Article_Attachments_Stddev_Fields = {
  __typename?: 'article_attachments_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_attachments" */
export type Article_Attachments_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Attachments_Stddev_Pop_Fields = {
  __typename?: 'article_attachments_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_attachments" */
export type Article_Attachments_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Attachments_Stddev_Samp_Fields = {
  __typename?: 'article_attachments_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_attachments" */
export type Article_Attachments_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_attachments" */
export type Article_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Attachments_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Attachments_Sum_Fields = {
  __typename?: 'article_attachments_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_attachments" */
export type Article_Attachments_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "article_attachments" */
export enum Article_Attachments_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id'
}

export type Article_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Attachments_Set_Input>;
  where: Article_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Attachments_Var_Pop_Fields = {
  __typename?: 'article_attachments_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_attachments" */
export type Article_Attachments_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Attachments_Var_Samp_Fields = {
  __typename?: 'article_attachments_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_attachments" */
export type Article_Attachments_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Attachments_Variance_Fields = {
  __typename?: 'article_attachments_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_attachments" */
export type Article_Attachments_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "article_author_favorite_insights" */
export type Article_Author_Favorite_Insights = {
  __typename?: 'article_author_favorite_insights';
  author: Array<Base_User>;
  author_id?: Maybe<Scalars['String']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "article_author_favorite_insights" */
export type Article_Author_Favorite_InsightsAuthorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Article_Author_Favorite_Insightsauthor>;
};

/** aggregated selection of "article_author_favorite_insights" */
export type Article_Author_Favorite_Insights_Aggregate = {
  __typename?: 'article_author_favorite_insights_aggregate';
  aggregate?: Maybe<Article_Author_Favorite_Insights_Aggregate_Fields>;
  nodes: Array<Article_Author_Favorite_Insights>;
};

/** aggregate fields of "article_author_favorite_insights" */
export type Article_Author_Favorite_Insights_Aggregate_Fields = {
  __typename?: 'article_author_favorite_insights_aggregate_fields';
  avg?: Maybe<Article_Author_Favorite_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Author_Favorite_Insights_Max_Fields>;
  min?: Maybe<Article_Author_Favorite_Insights_Min_Fields>;
  stddev?: Maybe<Article_Author_Favorite_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Author_Favorite_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Author_Favorite_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Author_Favorite_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Author_Favorite_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Author_Favorite_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Author_Favorite_Insights_Variance_Fields>;
};


/** aggregate fields of "article_author_favorite_insights" */
export type Article_Author_Favorite_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Author_Favorite_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Author_Favorite_Insights_Avg_Fields = {
  __typename?: 'article_author_favorite_insights_avg_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_author_favorite_insights". All fields are combined with a logical 'AND'. */
export type Article_Author_Favorite_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Author_Favorite_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Author_Favorite_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Author_Favorite_Insights_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  total_favorites?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Article_Author_Favorite_Insights_Max_Fields = {
  __typename?: 'article_author_favorite_insights_max_fields';
  author_id?: Maybe<Scalars['String']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Author_Favorite_Insights_Min_Fields = {
  __typename?: 'article_author_favorite_insights_min_fields';
  author_id?: Maybe<Scalars['String']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "article_author_favorite_insights". */
export type Article_Author_Favorite_Insights_Order_By = {
  author_id?: InputMaybe<Order_By>;
  total_favorites?: InputMaybe<Order_By>;
};

/** select columns of table "article_author_favorite_insights" */
export enum Article_Author_Favorite_Insights_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  TotalFavorites = 'total_favorites'
}

/** aggregate stddev on columns */
export type Article_Author_Favorite_Insights_Stddev_Fields = {
  __typename?: 'article_author_favorite_insights_stddev_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Author_Favorite_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_author_favorite_insights_stddev_pop_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Author_Favorite_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_author_favorite_insights_stddev_samp_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_author_favorite_insights" */
export type Article_Author_Favorite_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Author_Favorite_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Author_Favorite_Insights_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']>;
  total_favorites?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Author_Favorite_Insights_Sum_Fields = {
  __typename?: 'article_author_favorite_insights_sum_fields';
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Author_Favorite_Insights_Var_Pop_Fields = {
  __typename?: 'article_author_favorite_insights_var_pop_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Author_Favorite_Insights_Var_Samp_Fields = {
  __typename?: 'article_author_favorite_insights_var_samp_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Author_Favorite_Insights_Variance_Fields = {
  __typename?: 'article_author_favorite_insights_variance_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "article_author_like_insights" */
export type Article_Author_Like_Insights = {
  __typename?: 'article_author_like_insights';
  author: Array<Base_User>;
  author_id?: Maybe<Scalars['String']>;
  total_likes?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "article_author_like_insights" */
export type Article_Author_Like_InsightsAuthorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Article_Author_Like_Insightsauthor>;
};

/** aggregated selection of "article_author_like_insights" */
export type Article_Author_Like_Insights_Aggregate = {
  __typename?: 'article_author_like_insights_aggregate';
  aggregate?: Maybe<Article_Author_Like_Insights_Aggregate_Fields>;
  nodes: Array<Article_Author_Like_Insights>;
};

/** aggregate fields of "article_author_like_insights" */
export type Article_Author_Like_Insights_Aggregate_Fields = {
  __typename?: 'article_author_like_insights_aggregate_fields';
  avg?: Maybe<Article_Author_Like_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Author_Like_Insights_Max_Fields>;
  min?: Maybe<Article_Author_Like_Insights_Min_Fields>;
  stddev?: Maybe<Article_Author_Like_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Author_Like_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Author_Like_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Author_Like_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Author_Like_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Author_Like_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Author_Like_Insights_Variance_Fields>;
};


/** aggregate fields of "article_author_like_insights" */
export type Article_Author_Like_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Author_Like_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Author_Like_Insights_Avg_Fields = {
  __typename?: 'article_author_like_insights_avg_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_author_like_insights". All fields are combined with a logical 'AND'. */
export type Article_Author_Like_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Author_Like_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Author_Like_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Author_Like_Insights_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  total_likes?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Article_Author_Like_Insights_Max_Fields = {
  __typename?: 'article_author_like_insights_max_fields';
  author_id?: Maybe<Scalars['String']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Author_Like_Insights_Min_Fields = {
  __typename?: 'article_author_like_insights_min_fields';
  author_id?: Maybe<Scalars['String']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "article_author_like_insights". */
export type Article_Author_Like_Insights_Order_By = {
  author_id?: InputMaybe<Order_By>;
  total_likes?: InputMaybe<Order_By>;
};

/** select columns of table "article_author_like_insights" */
export enum Article_Author_Like_Insights_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  TotalLikes = 'total_likes'
}

/** aggregate stddev on columns */
export type Article_Author_Like_Insights_Stddev_Fields = {
  __typename?: 'article_author_like_insights_stddev_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Author_Like_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_author_like_insights_stddev_pop_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Author_Like_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_author_like_insights_stddev_samp_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_author_like_insights" */
export type Article_Author_Like_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Author_Like_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Author_Like_Insights_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']>;
  total_likes?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Author_Like_Insights_Sum_Fields = {
  __typename?: 'article_author_like_insights_sum_fields';
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Author_Like_Insights_Var_Pop_Fields = {
  __typename?: 'article_author_like_insights_var_pop_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Author_Like_Insights_Var_Samp_Fields = {
  __typename?: 'article_author_like_insights_var_samp_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Author_Like_Insights_Variance_Fields = {
  __typename?: 'article_author_like_insights_variance_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "article_author_view_insights" */
export type Article_Author_View_Insights = {
  __typename?: 'article_author_view_insights';
  author: Array<Base_User>;
  author_id?: Maybe<Scalars['String']>;
  total_views?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "article_author_view_insights" */
export type Article_Author_View_InsightsAuthorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Article_Author_View_Insightsauthor>;
};

/** aggregated selection of "article_author_view_insights" */
export type Article_Author_View_Insights_Aggregate = {
  __typename?: 'article_author_view_insights_aggregate';
  aggregate?: Maybe<Article_Author_View_Insights_Aggregate_Fields>;
  nodes: Array<Article_Author_View_Insights>;
};

/** aggregate fields of "article_author_view_insights" */
export type Article_Author_View_Insights_Aggregate_Fields = {
  __typename?: 'article_author_view_insights_aggregate_fields';
  avg?: Maybe<Article_Author_View_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Author_View_Insights_Max_Fields>;
  min?: Maybe<Article_Author_View_Insights_Min_Fields>;
  stddev?: Maybe<Article_Author_View_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Author_View_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Author_View_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Author_View_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Author_View_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Author_View_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Author_View_Insights_Variance_Fields>;
};


/** aggregate fields of "article_author_view_insights" */
export type Article_Author_View_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Author_View_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Author_View_Insights_Avg_Fields = {
  __typename?: 'article_author_view_insights_avg_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_author_view_insights". All fields are combined with a logical 'AND'. */
export type Article_Author_View_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Author_View_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Author_View_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Author_View_Insights_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  total_views?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Article_Author_View_Insights_Max_Fields = {
  __typename?: 'article_author_view_insights_max_fields';
  author_id?: Maybe<Scalars['String']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Author_View_Insights_Min_Fields = {
  __typename?: 'article_author_view_insights_min_fields';
  author_id?: Maybe<Scalars['String']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "article_author_view_insights". */
export type Article_Author_View_Insights_Order_By = {
  author_id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
};

/** select columns of table "article_author_view_insights" */
export enum Article_Author_View_Insights_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  TotalViews = 'total_views'
}

/** aggregate stddev on columns */
export type Article_Author_View_Insights_Stddev_Fields = {
  __typename?: 'article_author_view_insights_stddev_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Author_View_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_author_view_insights_stddev_pop_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Author_View_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_author_view_insights_stddev_samp_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_author_view_insights" */
export type Article_Author_View_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Author_View_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Author_View_Insights_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']>;
  total_views?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Author_View_Insights_Sum_Fields = {
  __typename?: 'article_author_view_insights_sum_fields';
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Author_View_Insights_Var_Pop_Fields = {
  __typename?: 'article_author_view_insights_var_pop_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Author_View_Insights_Var_Samp_Fields = {
  __typename?: 'article_author_view_insights_var_samp_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Author_View_Insights_Variance_Fields = {
  __typename?: 'article_author_view_insights_variance_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "article_authors" */
export type Article_Authors = {
  __typename?: 'article_authors';
  /** An object relationship */
  advice_author?: Maybe<Advice_Authors>;
  advice_author_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  author: Array<Base_User>;
  author_id: Scalars['String'];
  id: Scalars['bigint'];
  shared_author_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "article_authors" */
export type Article_AuthorsAuthorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Article_Authorsauthor>;
};

/** aggregated selection of "article_authors" */
export type Article_Authors_Aggregate = {
  __typename?: 'article_authors_aggregate';
  aggregate?: Maybe<Article_Authors_Aggregate_Fields>;
  nodes: Array<Article_Authors>;
};

/** aggregate fields of "article_authors" */
export type Article_Authors_Aggregate_Fields = {
  __typename?: 'article_authors_aggregate_fields';
  avg?: Maybe<Article_Authors_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Authors_Max_Fields>;
  min?: Maybe<Article_Authors_Min_Fields>;
  stddev?: Maybe<Article_Authors_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Authors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Authors_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Authors_Sum_Fields>;
  var_pop?: Maybe<Article_Authors_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Authors_Var_Samp_Fields>;
  variance?: Maybe<Article_Authors_Variance_Fields>;
};


/** aggregate fields of "article_authors" */
export type Article_Authors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Authors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_authors" */
export type Article_Authors_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Authors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Authors_Max_Order_By>;
  min?: InputMaybe<Article_Authors_Min_Order_By>;
  stddev?: InputMaybe<Article_Authors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Authors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Authors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Authors_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Authors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Authors_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Authors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_authors" */
export type Article_Authors_Arr_Rel_Insert_Input = {
  data: Array<Article_Authors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Authors_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Authors_Avg_Fields = {
  __typename?: 'article_authors_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_authors" */
export type Article_Authors_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_authors". All fields are combined with a logical 'AND'. */
export type Article_Authors_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Authors_Bool_Exp>>;
  _not?: InputMaybe<Article_Authors_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Authors_Bool_Exp>>;
  advice_author?: InputMaybe<Advice_Authors_Bool_Exp>;
  advice_author_id?: InputMaybe<Uuid_Comparison_Exp>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_author_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_authors" */
export enum Article_Authors_Constraint {
  /** unique or primary key constraint on columns "author_id", "article_id" */
  ArticleAuthorsArticleIdAuthorId_0ca51f63Uniq = 'article_authors_article_id_author_id_0ca51f63_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleAuthorsPkey = 'article_authors_pkey'
}

/** input type for incrementing numeric columns in table "article_authors" */
export type Article_Authors_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_authors" */
export type Article_Authors_Insert_Input = {
  advice_author?: InputMaybe<Advice_Authors_Obj_Rel_Insert_Input>;
  advice_author_id?: InputMaybe<Scalars['uuid']>;
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  author_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Authors_Max_Fields = {
  __typename?: 'article_authors_max_fields';
  advice_author_id?: Maybe<Scalars['uuid']>;
  article_id?: Maybe<Scalars['uuid']>;
  author_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_author_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "article_authors" */
export type Article_Authors_Max_Order_By = {
  advice_author_id?: InputMaybe<Order_By>;
  article_id?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Authors_Min_Fields = {
  __typename?: 'article_authors_min_fields';
  advice_author_id?: Maybe<Scalars['uuid']>;
  article_id?: Maybe<Scalars['uuid']>;
  author_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_author_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "article_authors" */
export type Article_Authors_Min_Order_By = {
  advice_author_id?: InputMaybe<Order_By>;
  article_id?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_authors" */
export type Article_Authors_Mutation_Response = {
  __typename?: 'article_authors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Authors>;
};

/** on_conflict condition type for table "article_authors" */
export type Article_Authors_On_Conflict = {
  constraint: Article_Authors_Constraint;
  update_columns?: Array<Article_Authors_Update_Column>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};

/** Ordering options when selecting data from "article_authors". */
export type Article_Authors_Order_By = {
  advice_author?: InputMaybe<Advice_Authors_Order_By>;
  advice_author_id?: InputMaybe<Order_By>;
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_authors */
export type Article_Authors_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_authors" */
export enum Article_Authors_Select_Column {
  /** column name */
  AdviceAuthorId = 'advice_author_id',
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedAuthorId = 'shared_author_id'
}

/** input type for updating data in table "article_authors" */
export type Article_Authors_Set_Input = {
  advice_author_id?: InputMaybe<Scalars['uuid']>;
  article_id?: InputMaybe<Scalars['uuid']>;
  author_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Article_Authors_Stddev_Fields = {
  __typename?: 'article_authors_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_authors" */
export type Article_Authors_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Authors_Stddev_Pop_Fields = {
  __typename?: 'article_authors_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_authors" */
export type Article_Authors_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Authors_Stddev_Samp_Fields = {
  __typename?: 'article_authors_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_authors" */
export type Article_Authors_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_authors" */
export type Article_Authors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Authors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Authors_Stream_Cursor_Value_Input = {
  advice_author_id?: InputMaybe<Scalars['uuid']>;
  article_id?: InputMaybe<Scalars['uuid']>;
  author_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Authors_Sum_Fields = {
  __typename?: 'article_authors_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_author_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_authors" */
export type Article_Authors_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** update columns of table "article_authors" */
export enum Article_Authors_Update_Column {
  /** column name */
  AdviceAuthorId = 'advice_author_id',
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedAuthorId = 'shared_author_id'
}

export type Article_Authors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Authors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Authors_Set_Input>;
  where: Article_Authors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Authors_Var_Pop_Fields = {
  __typename?: 'article_authors_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_authors" */
export type Article_Authors_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Authors_Var_Samp_Fields = {
  __typename?: 'article_authors_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_authors" */
export type Article_Authors_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Authors_Variance_Fields = {
  __typename?: 'article_authors_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_authors" */
export type Article_Authors_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Article_Avg_Fields = {
  __typename?: 'article_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  feature_image_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article" */
export type Article_Avg_Order_By = {
  duration?: InputMaybe<Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article". All fields are combined with a logical 'AND'. */
export type Article_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Bool_Exp>>;
  _not?: InputMaybe<Article_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Bool_Exp>>;
  article_favorites?: InputMaybe<Article_Favorites_Bool_Exp>;
  article_series?: InputMaybe<Article_Series_Bool_Exp>;
  article_type?: InputMaybe<String_Comparison_Exp>;
  attachments?: InputMaybe<Article_Attachments_Bool_Exp>;
  authors?: InputMaybe<Article_Authors_Bool_Exp>;
  categories?: InputMaybe<Article_Categories_Bool_Exp>;
  comments?: InputMaybe<Comment_Bool_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  crop_categories?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
  crop_varieties?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
  crops?: InputMaybe<Article_Crops_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  expiry_date?: InputMaybe<Date_Comparison_Exp>;
  feature_date_from?: InputMaybe<Date_Comparison_Exp>;
  feature_date_till?: InputMaybe<Date_Comparison_Exp>;
  feature_image?: InputMaybe<Fileupload_Bool_Exp>;
  feature_image_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_series?: InputMaybe<Boolean_Comparison_Exp>;
  likes?: InputMaybe<Article_Likes_Bool_Exp>;
  publish_date?: InputMaybe<Date_Comparison_Exp>;
  regions?: InputMaybe<Article_Regions_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Article_Subscriptions_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user_groups?: InputMaybe<Article_User_Group_Bool_Exp>;
  views?: InputMaybe<Article_Views_Bool_Exp>;
};

/** columns and relationships of "article_categories" */
export type Article_Categories = {
  __typename?: 'article_categories';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  /** An object relationship */
  category: Article_Category;
  category_id: Scalars['uuid'];
  id: Scalars['bigint'];
};

/** aggregated selection of "article_categories" */
export type Article_Categories_Aggregate = {
  __typename?: 'article_categories_aggregate';
  aggregate?: Maybe<Article_Categories_Aggregate_Fields>;
  nodes: Array<Article_Categories>;
};

/** aggregate fields of "article_categories" */
export type Article_Categories_Aggregate_Fields = {
  __typename?: 'article_categories_aggregate_fields';
  avg?: Maybe<Article_Categories_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Categories_Max_Fields>;
  min?: Maybe<Article_Categories_Min_Fields>;
  stddev?: Maybe<Article_Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Categories_Sum_Fields>;
  var_pop?: Maybe<Article_Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Categories_Var_Samp_Fields>;
  variance?: Maybe<Article_Categories_Variance_Fields>;
};


/** aggregate fields of "article_categories" */
export type Article_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_categories" */
export type Article_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Categories_Max_Order_By>;
  min?: InputMaybe<Article_Categories_Min_Order_By>;
  stddev?: InputMaybe<Article_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Categories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_categories" */
export type Article_Categories_Arr_Rel_Insert_Input = {
  data: Array<Article_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Categories_Avg_Fields = {
  __typename?: 'article_categories_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_categories" */
export type Article_Categories_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_categories". All fields are combined with a logical 'AND'. */
export type Article_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Categories_Bool_Exp>>;
  _not?: InputMaybe<Article_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Categories_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  category?: InputMaybe<Article_Category_Bool_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_categories" */
export enum Article_Categories_Constraint {
  /** unique or primary key constraint on columns "category_id", "article_id" */
  ArticleCategoriesArticleIdCategoryId_89e29601Uniq = 'article_categories_article_id_category_id_89e29601_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleCategoriesPkey = 'article_categories_pkey'
}

/** input type for incrementing numeric columns in table "article_categories" */
export type Article_Categories_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_categories" */
export type Article_Categories_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Article_Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Categories_Max_Fields = {
  __typename?: 'article_categories_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  category_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "article_categories" */
export type Article_Categories_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Categories_Min_Fields = {
  __typename?: 'article_categories_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  category_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "article_categories" */
export type Article_Categories_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_categories" */
export type Article_Categories_Mutation_Response = {
  __typename?: 'article_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Categories>;
};

/** on_conflict condition type for table "article_categories" */
export type Article_Categories_On_Conflict = {
  constraint: Article_Categories_Constraint;
  update_columns?: Array<Article_Categories_Update_Column>;
  where?: InputMaybe<Article_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "article_categories". */
export type Article_Categories_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Article_Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_categories */
export type Article_Categories_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_categories" */
export enum Article_Categories_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "article_categories" */
export type Article_Categories_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Article_Categories_Stddev_Fields = {
  __typename?: 'article_categories_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_categories" */
export type Article_Categories_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Categories_Stddev_Pop_Fields = {
  __typename?: 'article_categories_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_categories" */
export type Article_Categories_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Categories_Stddev_Samp_Fields = {
  __typename?: 'article_categories_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_categories" */
export type Article_Categories_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_categories" */
export type Article_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Categories_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Categories_Sum_Fields = {
  __typename?: 'article_categories_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_categories" */
export type Article_Categories_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "article_categories" */
export enum Article_Categories_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Id = 'id'
}

export type Article_Categories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Categories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Categories_Set_Input>;
  where: Article_Categories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Categories_Var_Pop_Fields = {
  __typename?: 'article_categories_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_categories" */
export type Article_Categories_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Categories_Var_Samp_Fields = {
  __typename?: 'article_categories_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_categories" */
export type Article_Categories_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Categories_Variance_Fields = {
  __typename?: 'article_categories_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_categories" */
export type Article_Categories_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "article_category" */
export type Article_Category = {
  __typename?: 'article_category';
  /** An array relationship */
  article_categories: Array<Article_Categories>;
  /** An aggregate relationship */
  article_categories_aggregate: Article_Categories_Aggregate;
  description: Scalars['String'];
  group_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_course_category: Scalars['Boolean'];
  mutual_group: Array<Mutual_Group>;
  name: Scalars['String'];
  order: Scalars['Int'];
  /** An array relationship */
  series_categories: Array<Series_Category>;
  /** An aggregate relationship */
  series_categories_aggregate: Series_Category_Aggregate;
  shared_group_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "article_category" */
export type Article_CategoryArticle_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Categories_Order_By>>;
  where?: InputMaybe<Article_Categories_Bool_Exp>;
};


/** columns and relationships of "article_category" */
export type Article_CategoryArticle_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Categories_Order_By>>;
  where?: InputMaybe<Article_Categories_Bool_Exp>;
};


/** columns and relationships of "article_category" */
export type Article_CategoryMutual_GroupArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp_Remote_Rel_Article_Categorymutual_Group>;
};


/** columns and relationships of "article_category" */
export type Article_CategorySeries_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Series_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Category_Order_By>>;
  where?: InputMaybe<Series_Category_Bool_Exp>;
};


/** columns and relationships of "article_category" */
export type Article_CategorySeries_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Category_Order_By>>;
  where?: InputMaybe<Series_Category_Bool_Exp>;
};

/** aggregated selection of "article_category" */
export type Article_Category_Aggregate = {
  __typename?: 'article_category_aggregate';
  aggregate?: Maybe<Article_Category_Aggregate_Fields>;
  nodes: Array<Article_Category>;
};

/** aggregate fields of "article_category" */
export type Article_Category_Aggregate_Fields = {
  __typename?: 'article_category_aggregate_fields';
  avg?: Maybe<Article_Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Category_Max_Fields>;
  min?: Maybe<Article_Category_Min_Fields>;
  stddev?: Maybe<Article_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Category_Sum_Fields>;
  var_pop?: Maybe<Article_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Category_Var_Samp_Fields>;
  variance?: Maybe<Article_Category_Variance_Fields>;
};


/** aggregate fields of "article_category" */
export type Article_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Category_Avg_Fields = {
  __typename?: 'article_category_avg_fields';
  order?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_category". All fields are combined with a logical 'AND'. */
export type Article_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Category_Bool_Exp>>;
  _not?: InputMaybe<Article_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Category_Bool_Exp>>;
  article_categories?: InputMaybe<Article_Categories_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_course_category?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  series_categories?: InputMaybe<Series_Category_Bool_Exp>;
  shared_group_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_category" */
export enum Article_Category_Constraint {
  /** unique or primary key constraint on columns "name", "group_id", "order" */
  ArticleCategoryNameOrderGroupIdBa993caaUniq = 'article_category_name_order_group_id_ba993caa_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleCategoryPkey = 'article_category_pkey'
}

/** input type for incrementing numeric columns in table "article_category" */
export type Article_Category_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_category" */
export type Article_Category_Insert_Input = {
  article_categories?: InputMaybe<Article_Categories_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_course_category?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  series_categories?: InputMaybe<Series_Category_Arr_Rel_Insert_Input>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Category_Max_Fields = {
  __typename?: 'article_category_max_fields';
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Category_Min_Fields = {
  __typename?: 'article_category_min_fields';
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "article_category" */
export type Article_Category_Mutation_Response = {
  __typename?: 'article_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Category>;
};

/** input type for inserting object relation for remote table "article_category" */
export type Article_Category_Obj_Rel_Insert_Input = {
  data: Article_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Category_On_Conflict>;
};

/** on_conflict condition type for table "article_category" */
export type Article_Category_On_Conflict = {
  constraint: Article_Category_Constraint;
  update_columns?: Array<Article_Category_Update_Column>;
  where?: InputMaybe<Article_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "article_category". */
export type Article_Category_Order_By = {
  article_categories_aggregate?: InputMaybe<Article_Categories_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_course_category?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  series_categories_aggregate?: InputMaybe<Series_Category_Aggregate_Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_category */
export type Article_Category_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "article_category" */
export enum Article_Category_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCourseCategory = 'is_course_category',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SharedGroupId = 'shared_group_id'
}

/** input type for updating data in table "article_category" */
export type Article_Category_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_course_category?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Article_Category_Stddev_Fields = {
  __typename?: 'article_category_stddev_fields';
  order?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Category_Stddev_Pop_Fields = {
  __typename?: 'article_category_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Category_Stddev_Samp_Fields = {
  __typename?: 'article_category_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_category" */
export type Article_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Category_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_course_category?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Category_Sum_Fields = {
  __typename?: 'article_category_sum_fields';
  order?: Maybe<Scalars['Int']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "article_category" */
export enum Article_Category_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCourseCategory = 'is_course_category',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SharedGroupId = 'shared_group_id'
}

export type Article_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Category_Set_Input>;
  where: Article_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Category_Var_Pop_Fields = {
  __typename?: 'article_category_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Category_Var_Samp_Fields = {
  __typename?: 'article_category_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Category_Variance_Fields = {
  __typename?: 'article_category_variance_fields';
  order?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "article" */
export enum Article_Constraint {
  /** unique or primary key constraint on columns "id" */
  ArticlePkey = 'article_pkey'
}

/** columns and relationships of "article_crop_categories" */
export type Article_Crop_Categories = {
  __typename?: 'article_crop_categories';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  crop_category_id: Scalars['String'];
  crop_group: Array<Crop_Group>;
  id: Scalars['bigint'];
  shared_crop_category_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "article_crop_categories" */
export type Article_Crop_CategoriesCrop_GroupArgs = {
  distinct_on?: InputMaybe<Array<Crop_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Group_Order_By>>;
  where?: InputMaybe<Crop_Group_Bool_Exp_Remote_Rel_Article_Crop_Categoriescrop_Group>;
};

/** aggregated selection of "article_crop_categories" */
export type Article_Crop_Categories_Aggregate = {
  __typename?: 'article_crop_categories_aggregate';
  aggregate?: Maybe<Article_Crop_Categories_Aggregate_Fields>;
  nodes: Array<Article_Crop_Categories>;
};

/** aggregate fields of "article_crop_categories" */
export type Article_Crop_Categories_Aggregate_Fields = {
  __typename?: 'article_crop_categories_aggregate_fields';
  avg?: Maybe<Article_Crop_Categories_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Crop_Categories_Max_Fields>;
  min?: Maybe<Article_Crop_Categories_Min_Fields>;
  stddev?: Maybe<Article_Crop_Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Crop_Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Crop_Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Crop_Categories_Sum_Fields>;
  var_pop?: Maybe<Article_Crop_Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Crop_Categories_Var_Samp_Fields>;
  variance?: Maybe<Article_Crop_Categories_Variance_Fields>;
};


/** aggregate fields of "article_crop_categories" */
export type Article_Crop_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Crop_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_crop_categories" */
export type Article_Crop_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Crop_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Crop_Categories_Max_Order_By>;
  min?: InputMaybe<Article_Crop_Categories_Min_Order_By>;
  stddev?: InputMaybe<Article_Crop_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Crop_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Crop_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Crop_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Crop_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Crop_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Crop_Categories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_crop_categories" */
export type Article_Crop_Categories_Arr_Rel_Insert_Input = {
  data: Array<Article_Crop_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Crop_Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Crop_Categories_Avg_Fields = {
  __typename?: 'article_crop_categories_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_category_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_crop_categories" */
export type Article_Crop_Categories_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_crop_categories". All fields are combined with a logical 'AND'. */
export type Article_Crop_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Crop_Categories_Bool_Exp>>;
  _not?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Crop_Categories_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  crop_category_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_crop_category_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_crop_categories" */
export enum Article_Crop_Categories_Constraint {
  /** unique or primary key constraint on columns "crop_category_id", "article_id" */
  ArticleCropCategoriesArticleIdCropCategory_49e74ae3Uniq = 'article_crop_categories_article_id_crop_category_49e74ae3_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleCropCategoriesPkey = 'article_crop_categories_pkey'
}

/** input type for incrementing numeric columns in table "article_crop_categories" */
export type Article_Crop_Categories_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_crop_category_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_crop_categories" */
export type Article_Crop_Categories_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  crop_category_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_crop_category_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Crop_Categories_Max_Fields = {
  __typename?: 'article_crop_categories_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  crop_category_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_crop_category_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "article_crop_categories" */
export type Article_Crop_Categories_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  crop_category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Crop_Categories_Min_Fields = {
  __typename?: 'article_crop_categories_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  crop_category_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_crop_category_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "article_crop_categories" */
export type Article_Crop_Categories_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  crop_category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_crop_categories" */
export type Article_Crop_Categories_Mutation_Response = {
  __typename?: 'article_crop_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Crop_Categories>;
};

/** on_conflict condition type for table "article_crop_categories" */
export type Article_Crop_Categories_On_Conflict = {
  constraint: Article_Crop_Categories_Constraint;
  update_columns?: Array<Article_Crop_Categories_Update_Column>;
  where?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "article_crop_categories". */
export type Article_Crop_Categories_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  crop_category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_crop_categories */
export type Article_Crop_Categories_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_crop_categories" */
export enum Article_Crop_Categories_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CropCategoryId = 'crop_category_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedCropCategoryId = 'shared_crop_category_id'
}

/** input type for updating data in table "article_crop_categories" */
export type Article_Crop_Categories_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  crop_category_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_crop_category_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Article_Crop_Categories_Stddev_Fields = {
  __typename?: 'article_crop_categories_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_category_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_crop_categories" */
export type Article_Crop_Categories_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Crop_Categories_Stddev_Pop_Fields = {
  __typename?: 'article_crop_categories_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_category_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_crop_categories" */
export type Article_Crop_Categories_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Crop_Categories_Stddev_Samp_Fields = {
  __typename?: 'article_crop_categories_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_category_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_crop_categories" */
export type Article_Crop_Categories_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_crop_categories" */
export type Article_Crop_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Crop_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Crop_Categories_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  crop_category_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_crop_category_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Crop_Categories_Sum_Fields = {
  __typename?: 'article_crop_categories_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_crop_category_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_crop_categories" */
export type Article_Crop_Categories_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** update columns of table "article_crop_categories" */
export enum Article_Crop_Categories_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CropCategoryId = 'crop_category_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedCropCategoryId = 'shared_crop_category_id'
}

export type Article_Crop_Categories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Crop_Categories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Crop_Categories_Set_Input>;
  where: Article_Crop_Categories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Crop_Categories_Var_Pop_Fields = {
  __typename?: 'article_crop_categories_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_category_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_crop_categories" */
export type Article_Crop_Categories_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Crop_Categories_Var_Samp_Fields = {
  __typename?: 'article_crop_categories_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_category_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_crop_categories" */
export type Article_Crop_Categories_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Crop_Categories_Variance_Fields = {
  __typename?: 'article_crop_categories_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_category_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_crop_categories" */
export type Article_Crop_Categories_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_category_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "article_crop_varieties" */
export type Article_Crop_Varieties = {
  __typename?: 'article_crop_varieties';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  id: Scalars['bigint'];
  shared_variety_id?: Maybe<Scalars['bigint']>;
  varieties: Array<Crop_Variety>;
  variety_id: Scalars['String'];
};


/** columns and relationships of "article_crop_varieties" */
export type Article_Crop_VarietiesVarietiesArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp_Remote_Rel_Article_Crop_Varietiesvarieties>;
};

/** aggregated selection of "article_crop_varieties" */
export type Article_Crop_Varieties_Aggregate = {
  __typename?: 'article_crop_varieties_aggregate';
  aggregate?: Maybe<Article_Crop_Varieties_Aggregate_Fields>;
  nodes: Array<Article_Crop_Varieties>;
};

/** aggregate fields of "article_crop_varieties" */
export type Article_Crop_Varieties_Aggregate_Fields = {
  __typename?: 'article_crop_varieties_aggregate_fields';
  avg?: Maybe<Article_Crop_Varieties_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Crop_Varieties_Max_Fields>;
  min?: Maybe<Article_Crop_Varieties_Min_Fields>;
  stddev?: Maybe<Article_Crop_Varieties_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Crop_Varieties_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Crop_Varieties_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Crop_Varieties_Sum_Fields>;
  var_pop?: Maybe<Article_Crop_Varieties_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Crop_Varieties_Var_Samp_Fields>;
  variance?: Maybe<Article_Crop_Varieties_Variance_Fields>;
};


/** aggregate fields of "article_crop_varieties" */
export type Article_Crop_Varieties_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Crop_Varieties_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_crop_varieties" */
export type Article_Crop_Varieties_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Crop_Varieties_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Crop_Varieties_Max_Order_By>;
  min?: InputMaybe<Article_Crop_Varieties_Min_Order_By>;
  stddev?: InputMaybe<Article_Crop_Varieties_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Crop_Varieties_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Crop_Varieties_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Crop_Varieties_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Crop_Varieties_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Crop_Varieties_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Crop_Varieties_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_crop_varieties" */
export type Article_Crop_Varieties_Arr_Rel_Insert_Input = {
  data: Array<Article_Crop_Varieties_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Crop_Varieties_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Crop_Varieties_Avg_Fields = {
  __typename?: 'article_crop_varieties_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_variety_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_crop_varieties" */
export type Article_Crop_Varieties_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_crop_varieties". All fields are combined with a logical 'AND'. */
export type Article_Crop_Varieties_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Crop_Varieties_Bool_Exp>>;
  _not?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Crop_Varieties_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_variety_id?: InputMaybe<Bigint_Comparison_Exp>;
  variety_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_crop_varieties" */
export enum Article_Crop_Varieties_Constraint {
  /** unique or primary key constraint on columns "article_id", "variety_id" */
  ArticleCropVarietiesArticleIdVarietyIdF02f47fcUniq = 'article_crop_varieties_article_id_variety_id_f02f47fc_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleCropVarietiesPkey = 'article_crop_varieties_pkey'
}

/** input type for incrementing numeric columns in table "article_crop_varieties" */
export type Article_Crop_Varieties_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_variety_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_crop_varieties" */
export type Article_Crop_Varieties_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_variety_id?: InputMaybe<Scalars['bigint']>;
  variety_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Article_Crop_Varieties_Max_Fields = {
  __typename?: 'article_crop_varieties_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  shared_variety_id?: Maybe<Scalars['bigint']>;
  variety_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "article_crop_varieties" */
export type Article_Crop_Varieties_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Crop_Varieties_Min_Fields = {
  __typename?: 'article_crop_varieties_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  shared_variety_id?: Maybe<Scalars['bigint']>;
  variety_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "article_crop_varieties" */
export type Article_Crop_Varieties_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_crop_varieties" */
export type Article_Crop_Varieties_Mutation_Response = {
  __typename?: 'article_crop_varieties_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Crop_Varieties>;
};

/** on_conflict condition type for table "article_crop_varieties" */
export type Article_Crop_Varieties_On_Conflict = {
  constraint: Article_Crop_Varieties_Constraint;
  update_columns?: Array<Article_Crop_Varieties_Update_Column>;
  where?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
};

/** Ordering options when selecting data from "article_crop_varieties". */
export type Article_Crop_Varieties_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_crop_varieties */
export type Article_Crop_Varieties_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_crop_varieties" */
export enum Article_Crop_Varieties_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedVarietyId = 'shared_variety_id',
  /** column name */
  VarietyId = 'variety_id'
}

/** input type for updating data in table "article_crop_varieties" */
export type Article_Crop_Varieties_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_variety_id?: InputMaybe<Scalars['bigint']>;
  variety_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Article_Crop_Varieties_Stddev_Fields = {
  __typename?: 'article_crop_varieties_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_crop_varieties" */
export type Article_Crop_Varieties_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Crop_Varieties_Stddev_Pop_Fields = {
  __typename?: 'article_crop_varieties_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_crop_varieties" */
export type Article_Crop_Varieties_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Crop_Varieties_Stddev_Samp_Fields = {
  __typename?: 'article_crop_varieties_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_crop_varieties" */
export type Article_Crop_Varieties_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_crop_varieties" */
export type Article_Crop_Varieties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Crop_Varieties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Crop_Varieties_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_variety_id?: InputMaybe<Scalars['bigint']>;
  variety_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Article_Crop_Varieties_Sum_Fields = {
  __typename?: 'article_crop_varieties_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_variety_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_crop_varieties" */
export type Article_Crop_Varieties_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
};

/** update columns of table "article_crop_varieties" */
export enum Article_Crop_Varieties_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedVarietyId = 'shared_variety_id',
  /** column name */
  VarietyId = 'variety_id'
}

export type Article_Crop_Varieties_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Crop_Varieties_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Crop_Varieties_Set_Input>;
  where: Article_Crop_Varieties_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Crop_Varieties_Var_Pop_Fields = {
  __typename?: 'article_crop_varieties_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_variety_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_crop_varieties" */
export type Article_Crop_Varieties_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Crop_Varieties_Var_Samp_Fields = {
  __typename?: 'article_crop_varieties_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_variety_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_crop_varieties" */
export type Article_Crop_Varieties_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Crop_Varieties_Variance_Fields = {
  __typename?: 'article_crop_varieties_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_variety_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_crop_varieties" */
export type Article_Crop_Varieties_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_variety_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "article_crops" */
export type Article_Crops = {
  __typename?: 'article_crops';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  crop: Array<Crop>;
  crop_id?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  /** An object relationship */
  shared_crop?: Maybe<Shared_Entity>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "article_crops" */
export type Article_CropsCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp_Remote_Rel_Article_Cropscrop>;
};

/** aggregated selection of "article_crops" */
export type Article_Crops_Aggregate = {
  __typename?: 'article_crops_aggregate';
  aggregate?: Maybe<Article_Crops_Aggregate_Fields>;
  nodes: Array<Article_Crops>;
};

/** aggregate fields of "article_crops" */
export type Article_Crops_Aggregate_Fields = {
  __typename?: 'article_crops_aggregate_fields';
  avg?: Maybe<Article_Crops_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Crops_Max_Fields>;
  min?: Maybe<Article_Crops_Min_Fields>;
  stddev?: Maybe<Article_Crops_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Crops_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Crops_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Crops_Sum_Fields>;
  var_pop?: Maybe<Article_Crops_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Crops_Var_Samp_Fields>;
  variance?: Maybe<Article_Crops_Variance_Fields>;
};


/** aggregate fields of "article_crops" */
export type Article_Crops_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Crops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_crops" */
export type Article_Crops_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Crops_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Crops_Max_Order_By>;
  min?: InputMaybe<Article_Crops_Min_Order_By>;
  stddev?: InputMaybe<Article_Crops_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Crops_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Crops_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Crops_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Crops_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Crops_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Crops_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_crops" */
export type Article_Crops_Arr_Rel_Insert_Input = {
  data: Array<Article_Crops_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Crops_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Crops_Avg_Fields = {
  __typename?: 'article_crops_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_crops" */
export type Article_Crops_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_crops". All fields are combined with a logical 'AND'. */
export type Article_Crops_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Crops_Bool_Exp>>;
  _not?: InputMaybe<Article_Crops_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Crops_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  crop_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_crop?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_crops" */
export enum Article_Crops_Constraint {
  /** unique or primary key constraint on columns "crop_id", "article_id" */
  ArticleCropsArticleIdCropId_8d4eb943Uniq = 'article_crops_article_id_crop_id_8d4eb943_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleCropsPkey = 'article_crops_pkey'
}

/** input type for incrementing numeric columns in table "article_crops" */
export type Article_Crops_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_crops" */
export type Article_Crops_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  crop_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_crop?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Crops_Max_Fields = {
  __typename?: 'article_crops_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  crop_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "article_crops" */
export type Article_Crops_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Crops_Min_Fields = {
  __typename?: 'article_crops_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  crop_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "article_crops" */
export type Article_Crops_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_crops" */
export type Article_Crops_Mutation_Response = {
  __typename?: 'article_crops_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Crops>;
};

/** on_conflict condition type for table "article_crops" */
export type Article_Crops_On_Conflict = {
  constraint: Article_Crops_Constraint;
  update_columns?: Array<Article_Crops_Update_Column>;
  where?: InputMaybe<Article_Crops_Bool_Exp>;
};

/** Ordering options when selecting data from "article_crops". */
export type Article_Crops_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_crop?: InputMaybe<Shared_Entity_Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_crops */
export type Article_Crops_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_crops" */
export enum Article_Crops_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedCropId = 'shared_crop_id'
}

/** input type for updating data in table "article_crops" */
export type Article_Crops_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  crop_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Article_Crops_Stddev_Fields = {
  __typename?: 'article_crops_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_crops" */
export type Article_Crops_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Crops_Stddev_Pop_Fields = {
  __typename?: 'article_crops_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_crops" */
export type Article_Crops_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Crops_Stddev_Samp_Fields = {
  __typename?: 'article_crops_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_crops" */
export type Article_Crops_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_crops" */
export type Article_Crops_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Crops_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Crops_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  crop_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Crops_Sum_Fields = {
  __typename?: 'article_crops_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_crops" */
export type Article_Crops_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "article_crops" */
export enum Article_Crops_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedCropId = 'shared_crop_id'
}

export type Article_Crops_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Crops_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Crops_Set_Input>;
  where: Article_Crops_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Crops_Var_Pop_Fields = {
  __typename?: 'article_crops_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_crops" */
export type Article_Crops_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Crops_Var_Samp_Fields = {
  __typename?: 'article_crops_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_crops" */
export type Article_Crops_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Crops_Variance_Fields = {
  __typename?: 'article_crops_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_crops" */
export type Article_Crops_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "article_favorite_insights" */
export type Article_Favorite_Insights = {
  __typename?: 'article_favorite_insights';
  /** An object relationship */
  article?: Maybe<Article>;
  article_id?: Maybe<Scalars['uuid']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "article_favorite_insights" */
export type Article_Favorite_Insights_Aggregate = {
  __typename?: 'article_favorite_insights_aggregate';
  aggregate?: Maybe<Article_Favorite_Insights_Aggregate_Fields>;
  nodes: Array<Article_Favorite_Insights>;
};

/** aggregate fields of "article_favorite_insights" */
export type Article_Favorite_Insights_Aggregate_Fields = {
  __typename?: 'article_favorite_insights_aggregate_fields';
  avg?: Maybe<Article_Favorite_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Favorite_Insights_Max_Fields>;
  min?: Maybe<Article_Favorite_Insights_Min_Fields>;
  stddev?: Maybe<Article_Favorite_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Favorite_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Favorite_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Favorite_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Favorite_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Favorite_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Favorite_Insights_Variance_Fields>;
};


/** aggregate fields of "article_favorite_insights" */
export type Article_Favorite_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Favorite_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Favorite_Insights_Avg_Fields = {
  __typename?: 'article_favorite_insights_avg_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_favorite_insights". All fields are combined with a logical 'AND'. */
export type Article_Favorite_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Favorite_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Favorite_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Favorite_Insights_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_favorites?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Article_Favorite_Insights_Max_Fields = {
  __typename?: 'article_favorite_insights_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Favorite_Insights_Min_Fields = {
  __typename?: 'article_favorite_insights_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "article_favorite_insights". */
export type Article_Favorite_Insights_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  total_favorites?: InputMaybe<Order_By>;
};

/** select columns of table "article_favorite_insights" */
export enum Article_Favorite_Insights_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  TotalFavorites = 'total_favorites'
}

/** aggregate stddev on columns */
export type Article_Favorite_Insights_Stddev_Fields = {
  __typename?: 'article_favorite_insights_stddev_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Favorite_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_favorite_insights_stddev_pop_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Favorite_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_favorite_insights_stddev_samp_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_favorite_insights" */
export type Article_Favorite_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Favorite_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Favorite_Insights_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  total_favorites?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Favorite_Insights_Sum_Fields = {
  __typename?: 'article_favorite_insights_sum_fields';
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Favorite_Insights_Var_Pop_Fields = {
  __typename?: 'article_favorite_insights_var_pop_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Favorite_Insights_Var_Samp_Fields = {
  __typename?: 'article_favorite_insights_var_samp_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Favorite_Insights_Variance_Fields = {
  __typename?: 'article_favorite_insights_variance_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "article_favorites" */
export type Article_Favorites = {
  __typename?: 'article_favorites';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  id: Scalars['bigint'];
  /** An object relationship */
  shared_user?: Maybe<Shared_Entity>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user_id: Scalars['String'];
};

/** aggregated selection of "article_favorites" */
export type Article_Favorites_Aggregate = {
  __typename?: 'article_favorites_aggregate';
  aggregate?: Maybe<Article_Favorites_Aggregate_Fields>;
  nodes: Array<Article_Favorites>;
};

/** aggregate fields of "article_favorites" */
export type Article_Favorites_Aggregate_Fields = {
  __typename?: 'article_favorites_aggregate_fields';
  avg?: Maybe<Article_Favorites_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Favorites_Max_Fields>;
  min?: Maybe<Article_Favorites_Min_Fields>;
  stddev?: Maybe<Article_Favorites_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Favorites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Favorites_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Favorites_Sum_Fields>;
  var_pop?: Maybe<Article_Favorites_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Favorites_Var_Samp_Fields>;
  variance?: Maybe<Article_Favorites_Variance_Fields>;
};


/** aggregate fields of "article_favorites" */
export type Article_Favorites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Favorites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_favorites" */
export type Article_Favorites_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Favorites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Favorites_Max_Order_By>;
  min?: InputMaybe<Article_Favorites_Min_Order_By>;
  stddev?: InputMaybe<Article_Favorites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Favorites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Favorites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Favorites_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Favorites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Favorites_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Favorites_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_favorites" */
export type Article_Favorites_Arr_Rel_Insert_Input = {
  data: Array<Article_Favorites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Favorites_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Favorites_Avg_Fields = {
  __typename?: 'article_favorites_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_favorites" */
export type Article_Favorites_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_favorites". All fields are combined with a logical 'AND'. */
export type Article_Favorites_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Favorites_Bool_Exp>>;
  _not?: InputMaybe<Article_Favorites_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Favorites_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_user?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_favorites" */
export enum Article_Favorites_Constraint {
  /** unique or primary key constraint on columns "user_id", "article_id" */
  ArticleFavoritesArticleIdUserIdBdc39ec8Uniq = 'article_favorites_article_id_user_id_bdc39ec8_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleFavoritesPkey = 'article_favorites_pkey'
}

/** input type for incrementing numeric columns in table "article_favorites" */
export type Article_Favorites_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_favorites" */
export type Article_Favorites_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_user?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Article_Favorites_Max_Fields = {
  __typename?: 'article_favorites_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "article_favorites" */
export type Article_Favorites_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Favorites_Min_Fields = {
  __typename?: 'article_favorites_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "article_favorites" */
export type Article_Favorites_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_favorites" */
export type Article_Favorites_Mutation_Response = {
  __typename?: 'article_favorites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Favorites>;
};

/** on_conflict condition type for table "article_favorites" */
export type Article_Favorites_On_Conflict = {
  constraint: Article_Favorites_Constraint;
  update_columns?: Array<Article_Favorites_Update_Column>;
  where?: InputMaybe<Article_Favorites_Bool_Exp>;
};

/** Ordering options when selecting data from "article_favorites". */
export type Article_Favorites_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user?: InputMaybe<Shared_Entity_Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_favorites */
export type Article_Favorites_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_favorites" */
export enum Article_Favorites_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "article_favorites" */
export type Article_Favorites_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Article_Favorites_Stddev_Fields = {
  __typename?: 'article_favorites_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_favorites" */
export type Article_Favorites_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Favorites_Stddev_Pop_Fields = {
  __typename?: 'article_favorites_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_favorites" */
export type Article_Favorites_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Favorites_Stddev_Samp_Fields = {
  __typename?: 'article_favorites_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_favorites" */
export type Article_Favorites_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_favorites" */
export type Article_Favorites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Favorites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Favorites_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Article_Favorites_Sum_Fields = {
  __typename?: 'article_favorites_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_favorites" */
export type Article_Favorites_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** update columns of table "article_favorites" */
export enum Article_Favorites_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Article_Favorites_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Favorites_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Favorites_Set_Input>;
  where: Article_Favorites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Favorites_Var_Pop_Fields = {
  __typename?: 'article_favorites_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_favorites" */
export type Article_Favorites_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Favorites_Var_Samp_Fields = {
  __typename?: 'article_favorites_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_favorites" */
export type Article_Favorites_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Favorites_Variance_Fields = {
  __typename?: 'article_favorites_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_favorites" */
export type Article_Favorites_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "article" */
export type Article_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  feature_image_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article" */
export type Article_Insert_Input = {
  article_favorites?: InputMaybe<Article_Favorites_Arr_Rel_Insert_Input>;
  article_series?: InputMaybe<Article_Series_Arr_Rel_Insert_Input>;
  article_type?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Article_Attachments_Arr_Rel_Insert_Input>;
  authors?: InputMaybe<Article_Authors_Arr_Rel_Insert_Input>;
  categories?: InputMaybe<Article_Categories_Arr_Rel_Insert_Input>;
  comments?: InputMaybe<Comment_Arr_Rel_Insert_Input>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_categories?: InputMaybe<Article_Crop_Categories_Arr_Rel_Insert_Input>;
  crop_varieties?: InputMaybe<Article_Crop_Varieties_Arr_Rel_Insert_Input>;
  crops?: InputMaybe<Article_Crops_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  feature_date_from?: InputMaybe<Scalars['date']>;
  feature_date_till?: InputMaybe<Scalars['date']>;
  feature_image?: InputMaybe<Fileupload_Obj_Rel_Insert_Input>;
  feature_image_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_series?: InputMaybe<Scalars['Boolean']>;
  likes?: InputMaybe<Article_Likes_Arr_Rel_Insert_Input>;
  publish_date?: InputMaybe<Scalars['date']>;
  regions?: InputMaybe<Article_Regions_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  subscriptions?: InputMaybe<Article_Subscriptions_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_groups?: InputMaybe<Article_User_Group_Arr_Rel_Insert_Input>;
  views?: InputMaybe<Article_Views_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "article_like_insights" */
export type Article_Like_Insights = {
  __typename?: 'article_like_insights';
  /** An object relationship */
  article?: Maybe<Article>;
  article_id?: Maybe<Scalars['uuid']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "article_like_insights" */
export type Article_Like_Insights_Aggregate = {
  __typename?: 'article_like_insights_aggregate';
  aggregate?: Maybe<Article_Like_Insights_Aggregate_Fields>;
  nodes: Array<Article_Like_Insights>;
};

/** aggregate fields of "article_like_insights" */
export type Article_Like_Insights_Aggregate_Fields = {
  __typename?: 'article_like_insights_aggregate_fields';
  avg?: Maybe<Article_Like_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Like_Insights_Max_Fields>;
  min?: Maybe<Article_Like_Insights_Min_Fields>;
  stddev?: Maybe<Article_Like_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Like_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Like_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Like_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Like_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Like_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Like_Insights_Variance_Fields>;
};


/** aggregate fields of "article_like_insights" */
export type Article_Like_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Like_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Like_Insights_Avg_Fields = {
  __typename?: 'article_like_insights_avg_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_like_insights". All fields are combined with a logical 'AND'. */
export type Article_Like_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Like_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Like_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Like_Insights_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_likes?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Article_Like_Insights_Max_Fields = {
  __typename?: 'article_like_insights_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Like_Insights_Min_Fields = {
  __typename?: 'article_like_insights_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "article_like_insights". */
export type Article_Like_Insights_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  total_likes?: InputMaybe<Order_By>;
};

/** select columns of table "article_like_insights" */
export enum Article_Like_Insights_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  TotalLikes = 'total_likes'
}

/** aggregate stddev on columns */
export type Article_Like_Insights_Stddev_Fields = {
  __typename?: 'article_like_insights_stddev_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Like_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_like_insights_stddev_pop_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Like_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_like_insights_stddev_samp_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_like_insights" */
export type Article_Like_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Like_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Like_Insights_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  total_likes?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Like_Insights_Sum_Fields = {
  __typename?: 'article_like_insights_sum_fields';
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Like_Insights_Var_Pop_Fields = {
  __typename?: 'article_like_insights_var_pop_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Like_Insights_Var_Samp_Fields = {
  __typename?: 'article_like_insights_var_samp_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Like_Insights_Variance_Fields = {
  __typename?: 'article_like_insights_variance_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "article_likes" */
export type Article_Likes = {
  __typename?: 'article_likes';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  id: Scalars['bigint'];
  liked_date: Scalars['timestamptz'];
  /** An object relationship */
  shared_user?: Maybe<Shared_Entity>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user_id: Scalars['String'];
};

/** aggregated selection of "article_likes" */
export type Article_Likes_Aggregate = {
  __typename?: 'article_likes_aggregate';
  aggregate?: Maybe<Article_Likes_Aggregate_Fields>;
  nodes: Array<Article_Likes>;
};

/** aggregate fields of "article_likes" */
export type Article_Likes_Aggregate_Fields = {
  __typename?: 'article_likes_aggregate_fields';
  avg?: Maybe<Article_Likes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Likes_Max_Fields>;
  min?: Maybe<Article_Likes_Min_Fields>;
  stddev?: Maybe<Article_Likes_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Likes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Likes_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Likes_Sum_Fields>;
  var_pop?: Maybe<Article_Likes_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Likes_Var_Samp_Fields>;
  variance?: Maybe<Article_Likes_Variance_Fields>;
};


/** aggregate fields of "article_likes" */
export type Article_Likes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_likes" */
export type Article_Likes_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Likes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Likes_Max_Order_By>;
  min?: InputMaybe<Article_Likes_Min_Order_By>;
  stddev?: InputMaybe<Article_Likes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Likes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Likes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Likes_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Likes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Likes_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Likes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_likes" */
export type Article_Likes_Arr_Rel_Insert_Input = {
  data: Array<Article_Likes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Likes_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Likes_Avg_Fields = {
  __typename?: 'article_likes_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_likes" */
export type Article_Likes_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_likes". All fields are combined with a logical 'AND'. */
export type Article_Likes_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Likes_Bool_Exp>>;
  _not?: InputMaybe<Article_Likes_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Likes_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  liked_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  shared_user?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_likes" */
export enum Article_Likes_Constraint {
  /** unique or primary key constraint on columns "user_id", "article_id" */
  ArticleLikesArticleIdUserId_4f1e8d35Uniq = 'article_likes_article_id_user_id_4f1e8d35_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleLikesPkey = 'article_likes_pkey'
}

/** input type for incrementing numeric columns in table "article_likes" */
export type Article_Likes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_likes" */
export type Article_Likes_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  liked_date?: InputMaybe<Scalars['timestamptz']>;
  shared_user?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Article_Likes_Max_Fields = {
  __typename?: 'article_likes_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  liked_date?: Maybe<Scalars['timestamptz']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "article_likes" */
export type Article_Likes_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liked_date?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Likes_Min_Fields = {
  __typename?: 'article_likes_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  liked_date?: Maybe<Scalars['timestamptz']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "article_likes" */
export type Article_Likes_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liked_date?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_likes" */
export type Article_Likes_Mutation_Response = {
  __typename?: 'article_likes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Likes>;
};

/** on_conflict condition type for table "article_likes" */
export type Article_Likes_On_Conflict = {
  constraint: Article_Likes_Constraint;
  update_columns?: Array<Article_Likes_Update_Column>;
  where?: InputMaybe<Article_Likes_Bool_Exp>;
};

/** Ordering options when selecting data from "article_likes". */
export type Article_Likes_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liked_date?: InputMaybe<Order_By>;
  shared_user?: InputMaybe<Shared_Entity_Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_likes */
export type Article_Likes_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_likes" */
export enum Article_Likes_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Id = 'id',
  /** column name */
  LikedDate = 'liked_date',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "article_likes" */
export type Article_Likes_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  liked_date?: InputMaybe<Scalars['timestamptz']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Article_Likes_Stddev_Fields = {
  __typename?: 'article_likes_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_likes" */
export type Article_Likes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Likes_Stddev_Pop_Fields = {
  __typename?: 'article_likes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_likes" */
export type Article_Likes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Likes_Stddev_Samp_Fields = {
  __typename?: 'article_likes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_likes" */
export type Article_Likes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_likes" */
export type Article_Likes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Likes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Likes_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  liked_date?: InputMaybe<Scalars['timestamptz']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Article_Likes_Sum_Fields = {
  __typename?: 'article_likes_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_likes" */
export type Article_Likes_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** update columns of table "article_likes" */
export enum Article_Likes_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Id = 'id',
  /** column name */
  LikedDate = 'liked_date',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Article_Likes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Likes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Likes_Set_Input>;
  where: Article_Likes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Likes_Var_Pop_Fields = {
  __typename?: 'article_likes_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_likes" */
export type Article_Likes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Likes_Var_Samp_Fields = {
  __typename?: 'article_likes_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_likes" */
export type Article_Likes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Likes_Variance_Fields = {
  __typename?: 'article_likes_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_likes" */
export type Article_Likes_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Article_Max_Fields = {
  __typename?: 'article_max_fields';
  article_type?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  expiry_date?: Maybe<Scalars['date']>;
  feature_date_from?: Maybe<Scalars['date']>;
  feature_date_till?: Maybe<Scalars['date']>;
  feature_image_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  publish_date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "article" */
export type Article_Max_Order_By = {
  article_type?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  feature_date_from?: InputMaybe<Order_By>;
  feature_date_till?: InputMaybe<Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publish_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Min_Fields = {
  __typename?: 'article_min_fields';
  article_type?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  expiry_date?: Maybe<Scalars['date']>;
  feature_date_from?: Maybe<Scalars['date']>;
  feature_date_till?: Maybe<Scalars['date']>;
  feature_image_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  publish_date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "article" */
export type Article_Min_Order_By = {
  article_type?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  feature_date_from?: InputMaybe<Order_By>;
  feature_date_till?: InputMaybe<Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publish_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article" */
export type Article_Mutation_Response = {
  __typename?: 'article_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article>;
};

/** input type for inserting object relation for remote table "article" */
export type Article_Obj_Rel_Insert_Input = {
  data: Article_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_On_Conflict>;
};

/** on_conflict condition type for table "article" */
export type Article_On_Conflict = {
  constraint: Article_Constraint;
  update_columns?: Array<Article_Update_Column>;
  where?: InputMaybe<Article_Bool_Exp>;
};

/** Ordering options when selecting data from "article". */
export type Article_Order_By = {
  article_favorites_aggregate?: InputMaybe<Article_Favorites_Aggregate_Order_By>;
  article_series_aggregate?: InputMaybe<Article_Series_Aggregate_Order_By>;
  article_type?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Article_Attachments_Aggregate_Order_By>;
  authors_aggregate?: InputMaybe<Article_Authors_Aggregate_Order_By>;
  categories_aggregate?: InputMaybe<Article_Categories_Aggregate_Order_By>;
  comments_aggregate?: InputMaybe<Comment_Aggregate_Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_categories_aggregate?: InputMaybe<Article_Crop_Categories_Aggregate_Order_By>;
  crop_varieties_aggregate?: InputMaybe<Article_Crop_Varieties_Aggregate_Order_By>;
  crops_aggregate?: InputMaybe<Article_Crops_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  feature_date_from?: InputMaybe<Order_By>;
  feature_date_till?: InputMaybe<Order_By>;
  feature_image?: InputMaybe<Fileupload_Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_series?: InputMaybe<Order_By>;
  likes_aggregate?: InputMaybe<Article_Likes_Aggregate_Order_By>;
  publish_date?: InputMaybe<Order_By>;
  regions_aggregate?: InputMaybe<Article_Regions_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Article_Subscriptions_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_groups_aggregate?: InputMaybe<Article_User_Group_Aggregate_Order_By>;
  views_aggregate?: InputMaybe<Article_Views_Aggregate_Order_By>;
};

/** primary key columns input for table: article */
export type Article_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "article_regions" */
export type Article_Regions = {
  __typename?: 'article_regions';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  id: Scalars['bigint'];
  region: Array<Region>;
  region_id: Scalars['String'];
  shared_region_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "article_regions" */
export type Article_RegionsRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp_Remote_Rel_Article_Regionsregion>;
};

/** aggregated selection of "article_regions" */
export type Article_Regions_Aggregate = {
  __typename?: 'article_regions_aggregate';
  aggregate?: Maybe<Article_Regions_Aggregate_Fields>;
  nodes: Array<Article_Regions>;
};

/** aggregate fields of "article_regions" */
export type Article_Regions_Aggregate_Fields = {
  __typename?: 'article_regions_aggregate_fields';
  avg?: Maybe<Article_Regions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Regions_Max_Fields>;
  min?: Maybe<Article_Regions_Min_Fields>;
  stddev?: Maybe<Article_Regions_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Regions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Regions_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Regions_Sum_Fields>;
  var_pop?: Maybe<Article_Regions_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Regions_Var_Samp_Fields>;
  variance?: Maybe<Article_Regions_Variance_Fields>;
};


/** aggregate fields of "article_regions" */
export type Article_Regions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Regions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_regions" */
export type Article_Regions_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Regions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Regions_Max_Order_By>;
  min?: InputMaybe<Article_Regions_Min_Order_By>;
  stddev?: InputMaybe<Article_Regions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Regions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Regions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Regions_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Regions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Regions_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Regions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_regions" */
export type Article_Regions_Arr_Rel_Insert_Input = {
  data: Array<Article_Regions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Regions_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Regions_Avg_Fields = {
  __typename?: 'article_regions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_regions" */
export type Article_Regions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_regions". All fields are combined with a logical 'AND'. */
export type Article_Regions_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Regions_Bool_Exp>>;
  _not?: InputMaybe<Article_Regions_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Regions_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  region_id?: InputMaybe<String_Comparison_Exp>;
  shared_region_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_regions" */
export enum Article_Regions_Constraint {
  /** unique or primary key constraint on columns "region_id", "article_id" */
  ArticleRegionsArticleIdRegionIdDac362f9Uniq = 'article_regions_article_id_region_id_dac362f9_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleRegionsPkey = 'article_regions_pkey'
}

/** input type for incrementing numeric columns in table "article_regions" */
export type Article_Regions_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_region_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_regions" */
export type Article_Regions_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  region_id?: InputMaybe<Scalars['String']>;
  shared_region_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Regions_Max_Fields = {
  __typename?: 'article_regions_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  region_id?: Maybe<Scalars['String']>;
  shared_region_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "article_regions" */
export type Article_Regions_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Regions_Min_Fields = {
  __typename?: 'article_regions_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  region_id?: Maybe<Scalars['String']>;
  shared_region_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "article_regions" */
export type Article_Regions_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_regions" */
export type Article_Regions_Mutation_Response = {
  __typename?: 'article_regions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Regions>;
};

/** on_conflict condition type for table "article_regions" */
export type Article_Regions_On_Conflict = {
  constraint: Article_Regions_Constraint;
  update_columns?: Array<Article_Regions_Update_Column>;
  where?: InputMaybe<Article_Regions_Bool_Exp>;
};

/** Ordering options when selecting data from "article_regions". */
export type Article_Regions_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_regions */
export type Article_Regions_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_regions" */
export enum Article_Regions_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Id = 'id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SharedRegionId = 'shared_region_id'
}

/** input type for updating data in table "article_regions" */
export type Article_Regions_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  region_id?: InputMaybe<Scalars['String']>;
  shared_region_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Article_Regions_Stddev_Fields = {
  __typename?: 'article_regions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_regions" */
export type Article_Regions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Regions_Stddev_Pop_Fields = {
  __typename?: 'article_regions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_regions" */
export type Article_Regions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Regions_Stddev_Samp_Fields = {
  __typename?: 'article_regions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_regions" */
export type Article_Regions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_regions" */
export type Article_Regions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Regions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Regions_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  region_id?: InputMaybe<Scalars['String']>;
  shared_region_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Regions_Sum_Fields = {
  __typename?: 'article_regions_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_region_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_regions" */
export type Article_Regions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** update columns of table "article_regions" */
export enum Article_Regions_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Id = 'id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SharedRegionId = 'shared_region_id'
}

export type Article_Regions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Regions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Regions_Set_Input>;
  where: Article_Regions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Regions_Var_Pop_Fields = {
  __typename?: 'article_regions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_regions" */
export type Article_Regions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Regions_Var_Samp_Fields = {
  __typename?: 'article_regions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_regions" */
export type Article_Regions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Regions_Variance_Fields = {
  __typename?: 'article_regions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_regions" */
export type Article_Regions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** select columns of table "article" */
export enum Article_Select_Column {
  /** column name */
  ArticleType = 'article_type',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  FeatureDateFrom = 'feature_date_from',
  /** column name */
  FeatureDateTill = 'feature_date_till',
  /** column name */
  FeatureImageId = 'feature_image_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSeries = 'is_series',
  /** column name */
  PublishDate = 'publish_date',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** columns and relationships of "article_series" */
export type Article_Series = {
  __typename?: 'article_series';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  /** An array relationship */
  article_series: Array<Article_Series>;
  /** An aggregate relationship */
  article_series_aggregate: Article_Series_Aggregate;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  favourites?: Maybe<Article_Series_Favourite_Insights>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  likes?: Maybe<Article_Series_Like_Insights>;
  /** An object relationship */
  next_article_series_id?: Maybe<Article_Series>;
  next_id?: Maybe<Scalars['uuid']>;
  order: Scalars['smallint'];
  /** An object relationship */
  related_assessment?: Maybe<Assessment>;
  related_assessment_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  series: Series;
  series_id: Scalars['uuid'];
  /** An object relationship */
  views?: Maybe<Article_Series_Favourite_Insights>;
};


/** columns and relationships of "article_series" */
export type Article_SeriesArticle_SeriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


/** columns and relationships of "article_series" */
export type Article_SeriesArticle_Series_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};

/** aggregated selection of "article_series" */
export type Article_Series_Aggregate = {
  __typename?: 'article_series_aggregate';
  aggregate?: Maybe<Article_Series_Aggregate_Fields>;
  nodes: Array<Article_Series>;
};

/** aggregate fields of "article_series" */
export type Article_Series_Aggregate_Fields = {
  __typename?: 'article_series_aggregate_fields';
  avg?: Maybe<Article_Series_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Series_Max_Fields>;
  min?: Maybe<Article_Series_Min_Fields>;
  stddev?: Maybe<Article_Series_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Series_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Series_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Series_Sum_Fields>;
  var_pop?: Maybe<Article_Series_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Series_Var_Samp_Fields>;
  variance?: Maybe<Article_Series_Variance_Fields>;
};


/** aggregate fields of "article_series" */
export type Article_Series_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Series_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_series" */
export type Article_Series_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Series_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Series_Max_Order_By>;
  min?: InputMaybe<Article_Series_Min_Order_By>;
  stddev?: InputMaybe<Article_Series_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Series_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Series_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Series_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Series_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Series_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Series_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_series" */
export type Article_Series_Arr_Rel_Insert_Input = {
  data: Array<Article_Series_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Series_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Series_Avg_Fields = {
  __typename?: 'article_series_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_series" */
export type Article_Series_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_series". All fields are combined with a logical 'AND'. */
export type Article_Series_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Series_Bool_Exp>>;
  _not?: InputMaybe<Article_Series_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Series_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  article_series?: InputMaybe<Article_Series_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  favourites?: InputMaybe<Article_Series_Favourite_Insights_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  likes?: InputMaybe<Article_Series_Like_Insights_Bool_Exp>;
  next_article_series_id?: InputMaybe<Article_Series_Bool_Exp>;
  next_id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  related_assessment?: InputMaybe<Assessment_Bool_Exp>;
  related_assessment_id?: InputMaybe<Uuid_Comparison_Exp>;
  series?: InputMaybe<Series_Bool_Exp>;
  series_id?: InputMaybe<Uuid_Comparison_Exp>;
  views?: InputMaybe<Article_Series_Favourite_Insights_Bool_Exp>;
};

/** unique or primary key constraints on table "article_series" */
export enum Article_Series_Constraint {
  /** unique or primary key constraint on columns "id" */
  ArticleSeriesPkey = 'article_series_pkey',
  /** unique or primary key constraint on columns "series_id", "article_id", "order" */
  ArticleSeriesSeriesIdArticleIdOrder_33a2cc4cUniq = 'article_series_series_id_article_id_order_33a2cc4c_uniq'
}

/** columns and relationships of "article_series_favourite_insights" */
export type Article_Series_Favourite_Insights = {
  __typename?: 'article_series_favourite_insights';
  series_id?: Maybe<Scalars['uuid']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "article_series_favourite_insights" */
export type Article_Series_Favourite_Insights_Aggregate = {
  __typename?: 'article_series_favourite_insights_aggregate';
  aggregate?: Maybe<Article_Series_Favourite_Insights_Aggregate_Fields>;
  nodes: Array<Article_Series_Favourite_Insights>;
};

/** aggregate fields of "article_series_favourite_insights" */
export type Article_Series_Favourite_Insights_Aggregate_Fields = {
  __typename?: 'article_series_favourite_insights_aggregate_fields';
  avg?: Maybe<Article_Series_Favourite_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Series_Favourite_Insights_Max_Fields>;
  min?: Maybe<Article_Series_Favourite_Insights_Min_Fields>;
  stddev?: Maybe<Article_Series_Favourite_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Series_Favourite_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Series_Favourite_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Series_Favourite_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Series_Favourite_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Series_Favourite_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Series_Favourite_Insights_Variance_Fields>;
};


/** aggregate fields of "article_series_favourite_insights" */
export type Article_Series_Favourite_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Series_Favourite_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Series_Favourite_Insights_Avg_Fields = {
  __typename?: 'article_series_favourite_insights_avg_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_series_favourite_insights". All fields are combined with a logical 'AND'. */
export type Article_Series_Favourite_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Series_Favourite_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Series_Favourite_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Series_Favourite_Insights_Bool_Exp>>;
  series_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_favorites?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "article_series_favourite_insights" */
export type Article_Series_Favourite_Insights_Insert_Input = {
  series_id?: InputMaybe<Scalars['uuid']>;
  total_favorites?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Series_Favourite_Insights_Max_Fields = {
  __typename?: 'article_series_favourite_insights_max_fields';
  series_id?: Maybe<Scalars['uuid']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Series_Favourite_Insights_Min_Fields = {
  __typename?: 'article_series_favourite_insights_min_fields';
  series_id?: Maybe<Scalars['uuid']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** input type for inserting object relation for remote table "article_series_favourite_insights" */
export type Article_Series_Favourite_Insights_Obj_Rel_Insert_Input = {
  data: Article_Series_Favourite_Insights_Insert_Input;
};

/** Ordering options when selecting data from "article_series_favourite_insights". */
export type Article_Series_Favourite_Insights_Order_By = {
  series_id?: InputMaybe<Order_By>;
  total_favorites?: InputMaybe<Order_By>;
};

/** select columns of table "article_series_favourite_insights" */
export enum Article_Series_Favourite_Insights_Select_Column {
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  TotalFavorites = 'total_favorites'
}

/** aggregate stddev on columns */
export type Article_Series_Favourite_Insights_Stddev_Fields = {
  __typename?: 'article_series_favourite_insights_stddev_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Series_Favourite_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_series_favourite_insights_stddev_pop_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Series_Favourite_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_series_favourite_insights_stddev_samp_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_series_favourite_insights" */
export type Article_Series_Favourite_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Series_Favourite_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Series_Favourite_Insights_Stream_Cursor_Value_Input = {
  series_id?: InputMaybe<Scalars['uuid']>;
  total_favorites?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Series_Favourite_Insights_Sum_Fields = {
  __typename?: 'article_series_favourite_insights_sum_fields';
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Series_Favourite_Insights_Var_Pop_Fields = {
  __typename?: 'article_series_favourite_insights_var_pop_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Series_Favourite_Insights_Var_Samp_Fields = {
  __typename?: 'article_series_favourite_insights_var_samp_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Series_Favourite_Insights_Variance_Fields = {
  __typename?: 'article_series_favourite_insights_variance_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "article_series" */
export type Article_Series_Inc_Input = {
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "article_series" */
export type Article_Series_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  article_series?: InputMaybe<Article_Series_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  favourites?: InputMaybe<Article_Series_Favourite_Insights_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  likes?: InputMaybe<Article_Series_Like_Insights_Obj_Rel_Insert_Input>;
  next_article_series_id?: InputMaybe<Article_Series_Obj_Rel_Insert_Input>;
  next_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  related_assessment?: InputMaybe<Assessment_Obj_Rel_Insert_Input>;
  related_assessment_id?: InputMaybe<Scalars['uuid']>;
  series?: InputMaybe<Series_Obj_Rel_Insert_Input>;
  series_id?: InputMaybe<Scalars['uuid']>;
  views?: InputMaybe<Article_Series_Favourite_Insights_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "article_series_like_insights" */
export type Article_Series_Like_Insights = {
  __typename?: 'article_series_like_insights';
  series_id?: Maybe<Scalars['uuid']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "article_series_like_insights" */
export type Article_Series_Like_Insights_Aggregate = {
  __typename?: 'article_series_like_insights_aggregate';
  aggregate?: Maybe<Article_Series_Like_Insights_Aggregate_Fields>;
  nodes: Array<Article_Series_Like_Insights>;
};

/** aggregate fields of "article_series_like_insights" */
export type Article_Series_Like_Insights_Aggregate_Fields = {
  __typename?: 'article_series_like_insights_aggregate_fields';
  avg?: Maybe<Article_Series_Like_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Series_Like_Insights_Max_Fields>;
  min?: Maybe<Article_Series_Like_Insights_Min_Fields>;
  stddev?: Maybe<Article_Series_Like_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Series_Like_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Series_Like_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Series_Like_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Series_Like_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Series_Like_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Series_Like_Insights_Variance_Fields>;
};


/** aggregate fields of "article_series_like_insights" */
export type Article_Series_Like_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Series_Like_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Series_Like_Insights_Avg_Fields = {
  __typename?: 'article_series_like_insights_avg_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_series_like_insights". All fields are combined with a logical 'AND'. */
export type Article_Series_Like_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Series_Like_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Series_Like_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Series_Like_Insights_Bool_Exp>>;
  series_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_likes?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "article_series_like_insights" */
export type Article_Series_Like_Insights_Insert_Input = {
  series_id?: InputMaybe<Scalars['uuid']>;
  total_likes?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Series_Like_Insights_Max_Fields = {
  __typename?: 'article_series_like_insights_max_fields';
  series_id?: Maybe<Scalars['uuid']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Series_Like_Insights_Min_Fields = {
  __typename?: 'article_series_like_insights_min_fields';
  series_id?: Maybe<Scalars['uuid']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** input type for inserting object relation for remote table "article_series_like_insights" */
export type Article_Series_Like_Insights_Obj_Rel_Insert_Input = {
  data: Article_Series_Like_Insights_Insert_Input;
};

/** Ordering options when selecting data from "article_series_like_insights". */
export type Article_Series_Like_Insights_Order_By = {
  series_id?: InputMaybe<Order_By>;
  total_likes?: InputMaybe<Order_By>;
};

/** select columns of table "article_series_like_insights" */
export enum Article_Series_Like_Insights_Select_Column {
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  TotalLikes = 'total_likes'
}

/** aggregate stddev on columns */
export type Article_Series_Like_Insights_Stddev_Fields = {
  __typename?: 'article_series_like_insights_stddev_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Series_Like_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_series_like_insights_stddev_pop_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Series_Like_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_series_like_insights_stddev_samp_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_series_like_insights" */
export type Article_Series_Like_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Series_Like_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Series_Like_Insights_Stream_Cursor_Value_Input = {
  series_id?: InputMaybe<Scalars['uuid']>;
  total_likes?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Series_Like_Insights_Sum_Fields = {
  __typename?: 'article_series_like_insights_sum_fields';
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Series_Like_Insights_Var_Pop_Fields = {
  __typename?: 'article_series_like_insights_var_pop_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Series_Like_Insights_Var_Samp_Fields = {
  __typename?: 'article_series_like_insights_var_samp_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Series_Like_Insights_Variance_Fields = {
  __typename?: 'article_series_like_insights_variance_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Article_Series_Max_Fields = {
  __typename?: 'article_series_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  next_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  related_assessment_id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "article_series" */
export type Article_Series_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  related_assessment_id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Series_Min_Fields = {
  __typename?: 'article_series_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  next_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  related_assessment_id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "article_series" */
export type Article_Series_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  related_assessment_id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_series" */
export type Article_Series_Mutation_Response = {
  __typename?: 'article_series_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Series>;
};

/** input type for inserting object relation for remote table "article_series" */
export type Article_Series_Obj_Rel_Insert_Input = {
  data: Article_Series_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Series_On_Conflict>;
};

/** on_conflict condition type for table "article_series" */
export type Article_Series_On_Conflict = {
  constraint: Article_Series_Constraint;
  update_columns?: Array<Article_Series_Update_Column>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};

/** Ordering options when selecting data from "article_series". */
export type Article_Series_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  article_series_aggregate?: InputMaybe<Article_Series_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  favourites?: InputMaybe<Article_Series_Favourite_Insights_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  likes?: InputMaybe<Article_Series_Like_Insights_Order_By>;
  next_article_series_id?: InputMaybe<Article_Series_Order_By>;
  next_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  related_assessment?: InputMaybe<Assessment_Order_By>;
  related_assessment_id?: InputMaybe<Order_By>;
  series?: InputMaybe<Series_Order_By>;
  series_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Article_Series_Favourite_Insights_Order_By>;
};

/** primary key columns input for table: article_series */
export type Article_Series_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "article_series" */
export enum Article_Series_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  NextId = 'next_id',
  /** column name */
  Order = 'order',
  /** column name */
  RelatedAssessmentId = 'related_assessment_id',
  /** column name */
  SeriesId = 'series_id'
}

/** input type for updating data in table "article_series" */
export type Article_Series_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  next_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  related_assessment_id?: InputMaybe<Scalars['uuid']>;
  series_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Article_Series_Stddev_Fields = {
  __typename?: 'article_series_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_series" */
export type Article_Series_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Series_Stddev_Pop_Fields = {
  __typename?: 'article_series_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_series" */
export type Article_Series_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Series_Stddev_Samp_Fields = {
  __typename?: 'article_series_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_series" */
export type Article_Series_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_series" */
export type Article_Series_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Series_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Series_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  next_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  related_assessment_id?: InputMaybe<Scalars['uuid']>;
  series_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Article_Series_Sum_Fields = {
  __typename?: 'article_series_sum_fields';
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "article_series" */
export type Article_Series_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "article_series" */
export enum Article_Series_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  NextId = 'next_id',
  /** column name */
  Order = 'order',
  /** column name */
  RelatedAssessmentId = 'related_assessment_id',
  /** column name */
  SeriesId = 'series_id'
}

export type Article_Series_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Series_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Series_Set_Input>;
  where: Article_Series_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Series_Var_Pop_Fields = {
  __typename?: 'article_series_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_series" */
export type Article_Series_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Series_Var_Samp_Fields = {
  __typename?: 'article_series_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_series" */
export type Article_Series_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Series_Variance_Fields = {
  __typename?: 'article_series_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_series" */
export type Article_Series_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "article_series_view_insights" */
export type Article_Series_View_Insights = {
  __typename?: 'article_series_view_insights';
  series_id?: Maybe<Scalars['uuid']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "article_series_view_insights" */
export type Article_Series_View_Insights_Aggregate = {
  __typename?: 'article_series_view_insights_aggregate';
  aggregate?: Maybe<Article_Series_View_Insights_Aggregate_Fields>;
  nodes: Array<Article_Series_View_Insights>;
};

/** aggregate fields of "article_series_view_insights" */
export type Article_Series_View_Insights_Aggregate_Fields = {
  __typename?: 'article_series_view_insights_aggregate_fields';
  avg?: Maybe<Article_Series_View_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Series_View_Insights_Max_Fields>;
  min?: Maybe<Article_Series_View_Insights_Min_Fields>;
  stddev?: Maybe<Article_Series_View_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Series_View_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Series_View_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Series_View_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Series_View_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Series_View_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Series_View_Insights_Variance_Fields>;
};


/** aggregate fields of "article_series_view_insights" */
export type Article_Series_View_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Series_View_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Series_View_Insights_Avg_Fields = {
  __typename?: 'article_series_view_insights_avg_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_series_view_insights". All fields are combined with a logical 'AND'. */
export type Article_Series_View_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Series_View_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Series_View_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Series_View_Insights_Bool_Exp>>;
  series_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_views?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "article_series_view_insights" */
export type Article_Series_View_Insights_Insert_Input = {
  series_id?: InputMaybe<Scalars['uuid']>;
  total_views?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Series_View_Insights_Max_Fields = {
  __typename?: 'article_series_view_insights_max_fields';
  series_id?: Maybe<Scalars['uuid']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Series_View_Insights_Min_Fields = {
  __typename?: 'article_series_view_insights_min_fields';
  series_id?: Maybe<Scalars['uuid']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** input type for inserting object relation for remote table "article_series_view_insights" */
export type Article_Series_View_Insights_Obj_Rel_Insert_Input = {
  data: Article_Series_View_Insights_Insert_Input;
};

/** Ordering options when selecting data from "article_series_view_insights". */
export type Article_Series_View_Insights_Order_By = {
  series_id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
};

/** select columns of table "article_series_view_insights" */
export enum Article_Series_View_Insights_Select_Column {
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  TotalViews = 'total_views'
}

/** aggregate stddev on columns */
export type Article_Series_View_Insights_Stddev_Fields = {
  __typename?: 'article_series_view_insights_stddev_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Series_View_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_series_view_insights_stddev_pop_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Series_View_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_series_view_insights_stddev_samp_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_series_view_insights" */
export type Article_Series_View_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Series_View_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Series_View_Insights_Stream_Cursor_Value_Input = {
  series_id?: InputMaybe<Scalars['uuid']>;
  total_views?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Series_View_Insights_Sum_Fields = {
  __typename?: 'article_series_view_insights_sum_fields';
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Series_View_Insights_Var_Pop_Fields = {
  __typename?: 'article_series_view_insights_var_pop_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Series_View_Insights_Var_Samp_Fields = {
  __typename?: 'article_series_view_insights_var_samp_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Series_View_Insights_Variance_Fields = {
  __typename?: 'article_series_view_insights_variance_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** input type for updating data in table "article" */
export type Article_Set_Input = {
  article_type?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  feature_date_from?: InputMaybe<Scalars['date']>;
  feature_date_till?: InputMaybe<Scalars['date']>;
  feature_image_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_series?: InputMaybe<Scalars['Boolean']>;
  publish_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Article_Stddev_Fields = {
  __typename?: 'article_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  feature_image_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article" */
export type Article_Stddev_Order_By = {
  duration?: InputMaybe<Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Stddev_Pop_Fields = {
  __typename?: 'article_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  feature_image_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article" */
export type Article_Stddev_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Stddev_Samp_Fields = {
  __typename?: 'article_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  feature_image_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article" */
export type Article_Stddev_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article" */
export type Article_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Stream_Cursor_Value_Input = {
  article_type?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  feature_date_from?: InputMaybe<Scalars['date']>;
  feature_date_till?: InputMaybe<Scalars['date']>;
  feature_image_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_series?: InputMaybe<Scalars['Boolean']>;
  publish_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "article_subscription_favorite_insights" */
export type Article_Subscription_Favorite_Insights = {
  __typename?: 'article_subscription_favorite_insights';
  /** An object relationship */
  package?: Maybe<Article_Subscription_Package>;
  package_id?: Maybe<Scalars['uuid']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "article_subscription_favorite_insights" */
export type Article_Subscription_Favorite_Insights_Aggregate = {
  __typename?: 'article_subscription_favorite_insights_aggregate';
  aggregate?: Maybe<Article_Subscription_Favorite_Insights_Aggregate_Fields>;
  nodes: Array<Article_Subscription_Favorite_Insights>;
};

/** aggregate fields of "article_subscription_favorite_insights" */
export type Article_Subscription_Favorite_Insights_Aggregate_Fields = {
  __typename?: 'article_subscription_favorite_insights_aggregate_fields';
  avg?: Maybe<Article_Subscription_Favorite_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Subscription_Favorite_Insights_Max_Fields>;
  min?: Maybe<Article_Subscription_Favorite_Insights_Min_Fields>;
  stddev?: Maybe<Article_Subscription_Favorite_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Subscription_Favorite_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Subscription_Favorite_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Subscription_Favorite_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Subscription_Favorite_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Subscription_Favorite_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Subscription_Favorite_Insights_Variance_Fields>;
};


/** aggregate fields of "article_subscription_favorite_insights" */
export type Article_Subscription_Favorite_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Subscription_Favorite_Insights_Avg_Fields = {
  __typename?: 'article_subscription_favorite_insights_avg_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_subscription_favorite_insights". All fields are combined with a logical 'AND'. */
export type Article_Subscription_Favorite_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Subscription_Favorite_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Bool_Exp>>;
  package?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
  package_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_favorites?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "article_subscription_favorite_insights" */
export type Article_Subscription_Favorite_Insights_Insert_Input = {
  package?: InputMaybe<Article_Subscription_Package_Obj_Rel_Insert_Input>;
  package_id?: InputMaybe<Scalars['uuid']>;
  total_favorites?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Subscription_Favorite_Insights_Max_Fields = {
  __typename?: 'article_subscription_favorite_insights_max_fields';
  package_id?: Maybe<Scalars['uuid']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Subscription_Favorite_Insights_Min_Fields = {
  __typename?: 'article_subscription_favorite_insights_min_fields';
  package_id?: Maybe<Scalars['uuid']>;
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** input type for inserting object relation for remote table "article_subscription_favorite_insights" */
export type Article_Subscription_Favorite_Insights_Obj_Rel_Insert_Input = {
  data: Article_Subscription_Favorite_Insights_Insert_Input;
};

/** Ordering options when selecting data from "article_subscription_favorite_insights". */
export type Article_Subscription_Favorite_Insights_Order_By = {
  package?: InputMaybe<Article_Subscription_Package_Order_By>;
  package_id?: InputMaybe<Order_By>;
  total_favorites?: InputMaybe<Order_By>;
};

/** select columns of table "article_subscription_favorite_insights" */
export enum Article_Subscription_Favorite_Insights_Select_Column {
  /** column name */
  PackageId = 'package_id',
  /** column name */
  TotalFavorites = 'total_favorites'
}

/** aggregate stddev on columns */
export type Article_Subscription_Favorite_Insights_Stddev_Fields = {
  __typename?: 'article_subscription_favorite_insights_stddev_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Subscription_Favorite_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_subscription_favorite_insights_stddev_pop_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Subscription_Favorite_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_subscription_favorite_insights_stddev_samp_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_subscription_favorite_insights" */
export type Article_Subscription_Favorite_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Subscription_Favorite_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Subscription_Favorite_Insights_Stream_Cursor_Value_Input = {
  package_id?: InputMaybe<Scalars['uuid']>;
  total_favorites?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Subscription_Favorite_Insights_Sum_Fields = {
  __typename?: 'article_subscription_favorite_insights_sum_fields';
  total_favorites?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Subscription_Favorite_Insights_Var_Pop_Fields = {
  __typename?: 'article_subscription_favorite_insights_var_pop_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Subscription_Favorite_Insights_Var_Samp_Fields = {
  __typename?: 'article_subscription_favorite_insights_var_samp_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Subscription_Favorite_Insights_Variance_Fields = {
  __typename?: 'article_subscription_favorite_insights_variance_fields';
  total_favorites?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "article_subscription_like_insights" */
export type Article_Subscription_Like_Insights = {
  __typename?: 'article_subscription_like_insights';
  /** An object relationship */
  package?: Maybe<Article_Subscription_Package>;
  package_id?: Maybe<Scalars['uuid']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "article_subscription_like_insights" */
export type Article_Subscription_Like_Insights_Aggregate = {
  __typename?: 'article_subscription_like_insights_aggregate';
  aggregate?: Maybe<Article_Subscription_Like_Insights_Aggregate_Fields>;
  nodes: Array<Article_Subscription_Like_Insights>;
};

/** aggregate fields of "article_subscription_like_insights" */
export type Article_Subscription_Like_Insights_Aggregate_Fields = {
  __typename?: 'article_subscription_like_insights_aggregate_fields';
  avg?: Maybe<Article_Subscription_Like_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Subscription_Like_Insights_Max_Fields>;
  min?: Maybe<Article_Subscription_Like_Insights_Min_Fields>;
  stddev?: Maybe<Article_Subscription_Like_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Subscription_Like_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Subscription_Like_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Subscription_Like_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Subscription_Like_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Subscription_Like_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Subscription_Like_Insights_Variance_Fields>;
};


/** aggregate fields of "article_subscription_like_insights" */
export type Article_Subscription_Like_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Subscription_Like_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Subscription_Like_Insights_Avg_Fields = {
  __typename?: 'article_subscription_like_insights_avg_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_subscription_like_insights". All fields are combined with a logical 'AND'. */
export type Article_Subscription_Like_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Subscription_Like_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Subscription_Like_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Subscription_Like_Insights_Bool_Exp>>;
  package?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
  package_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_likes?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "article_subscription_like_insights" */
export type Article_Subscription_Like_Insights_Insert_Input = {
  package?: InputMaybe<Article_Subscription_Package_Obj_Rel_Insert_Input>;
  package_id?: InputMaybe<Scalars['uuid']>;
  total_likes?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Subscription_Like_Insights_Max_Fields = {
  __typename?: 'article_subscription_like_insights_max_fields';
  package_id?: Maybe<Scalars['uuid']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Subscription_Like_Insights_Min_Fields = {
  __typename?: 'article_subscription_like_insights_min_fields';
  package_id?: Maybe<Scalars['uuid']>;
  total_likes?: Maybe<Scalars['bigint']>;
};

/** input type for inserting object relation for remote table "article_subscription_like_insights" */
export type Article_Subscription_Like_Insights_Obj_Rel_Insert_Input = {
  data: Article_Subscription_Like_Insights_Insert_Input;
};

/** Ordering options when selecting data from "article_subscription_like_insights". */
export type Article_Subscription_Like_Insights_Order_By = {
  package?: InputMaybe<Article_Subscription_Package_Order_By>;
  package_id?: InputMaybe<Order_By>;
  total_likes?: InputMaybe<Order_By>;
};

/** select columns of table "article_subscription_like_insights" */
export enum Article_Subscription_Like_Insights_Select_Column {
  /** column name */
  PackageId = 'package_id',
  /** column name */
  TotalLikes = 'total_likes'
}

/** aggregate stddev on columns */
export type Article_Subscription_Like_Insights_Stddev_Fields = {
  __typename?: 'article_subscription_like_insights_stddev_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Subscription_Like_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_subscription_like_insights_stddev_pop_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Subscription_Like_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_subscription_like_insights_stddev_samp_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_subscription_like_insights" */
export type Article_Subscription_Like_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Subscription_Like_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Subscription_Like_Insights_Stream_Cursor_Value_Input = {
  package_id?: InputMaybe<Scalars['uuid']>;
  total_likes?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Subscription_Like_Insights_Sum_Fields = {
  __typename?: 'article_subscription_like_insights_sum_fields';
  total_likes?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Subscription_Like_Insights_Var_Pop_Fields = {
  __typename?: 'article_subscription_like_insights_var_pop_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Subscription_Like_Insights_Var_Samp_Fields = {
  __typename?: 'article_subscription_like_insights_var_samp_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Subscription_Like_Insights_Variance_Fields = {
  __typename?: 'article_subscription_like_insights_variance_fields';
  total_likes?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_Package = {
  __typename?: 'article_subscription_package';
  /** An array relationship */
  article_subscriptions: Array<Article_Subscriptions>;
  /** An aggregate relationship */
  article_subscriptions_aggregate: Article_Subscriptions_Aggregate;
  description: Scalars['String'];
  discount_price: Scalars['float8'];
  /** An object relationship */
  favourites?: Maybe<Article_Subscription_Favorite_Insights>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_public: Scalars['Boolean'];
  is_public_for_organisation: Scalars['Boolean'];
  is_user_level_subscription: Scalars['Boolean'];
  /** An object relationship */
  likes?: Maybe<Article_Subscription_Like_Insights>;
  /** An array relationship */
  mutual_group_subscription_packages: Array<Mutual_Group_Subscription_Package>;
  /** An aggregate relationship */
  mutual_group_subscription_packages_aggregate: Mutual_Group_Subscription_Package_Aggregate;
  name: Scalars['String'];
  organisation_id?: Maybe<Scalars['Int']>;
  owner_team_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  series: Array<Series>;
  /** An aggregate relationship */
  series_aggregate: Series_Aggregate;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_owner_team?: Maybe<Shared_Entity>;
  /** An object relationship */
  shared_unit_price?: Maybe<Shared_Entity>;
  shared_unit_price_unit_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  subscription_package_highlights: Array<Subscription_Package_Highlights>;
  /** An aggregate relationship */
  subscription_package_highlights_aggregate: Subscription_Package_Highlights_Aggregate;
  unit_price: Scalars['float8'];
  unit_price_unit_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  user_subscription_packages: Array<User_Subscription_Package>;
  /** An aggregate relationship */
  user_subscription_packages_aggregate: User_Subscription_Package_Aggregate;
  /** An object relationship */
  views?: Maybe<Article_Subscription_View_Insights>;
};


/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_PackageArticle_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscriptions_Order_By>>;
  where?: InputMaybe<Article_Subscriptions_Bool_Exp>;
};


/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_PackageArticle_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscriptions_Order_By>>;
  where?: InputMaybe<Article_Subscriptions_Bool_Exp>;
};


/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_PackageMutual_Group_Subscription_PackagesArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Subscription_Package_Order_By>>;
  where?: InputMaybe<Mutual_Group_Subscription_Package_Bool_Exp>;
};


/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_PackageMutual_Group_Subscription_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Subscription_Package_Order_By>>;
  where?: InputMaybe<Mutual_Group_Subscription_Package_Bool_Exp>;
};


/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_PackageSeriesArgs = {
  distinct_on?: InputMaybe<Array<Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Order_By>>;
  where?: InputMaybe<Series_Bool_Exp>;
};


/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_PackageSeries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Order_By>>;
  where?: InputMaybe<Series_Bool_Exp>;
};


/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_PackageSubscription_Package_HighlightsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Package_Highlights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Package_Highlights_Order_By>>;
  where?: InputMaybe<Subscription_Package_Highlights_Bool_Exp>;
};


/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_PackageSubscription_Package_Highlights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Package_Highlights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Package_Highlights_Order_By>>;
  where?: InputMaybe<Subscription_Package_Highlights_Bool_Exp>;
};


/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_PackageUser_Subscription_PackagesArgs = {
  distinct_on?: InputMaybe<Array<User_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscription_Package_Order_By>>;
  where?: InputMaybe<User_Subscription_Package_Bool_Exp>;
};


/** columns and relationships of "article_subscription_package" */
export type Article_Subscription_PackageUser_Subscription_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscription_Package_Order_By>>;
  where?: InputMaybe<User_Subscription_Package_Bool_Exp>;
};

/** aggregated selection of "article_subscription_package" */
export type Article_Subscription_Package_Aggregate = {
  __typename?: 'article_subscription_package_aggregate';
  aggregate?: Maybe<Article_Subscription_Package_Aggregate_Fields>;
  nodes: Array<Article_Subscription_Package>;
};

/** aggregate fields of "article_subscription_package" */
export type Article_Subscription_Package_Aggregate_Fields = {
  __typename?: 'article_subscription_package_aggregate_fields';
  avg?: Maybe<Article_Subscription_Package_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Subscription_Package_Max_Fields>;
  min?: Maybe<Article_Subscription_Package_Min_Fields>;
  stddev?: Maybe<Article_Subscription_Package_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Subscription_Package_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Subscription_Package_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Subscription_Package_Sum_Fields>;
  var_pop?: Maybe<Article_Subscription_Package_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Subscription_Package_Var_Samp_Fields>;
  variance?: Maybe<Article_Subscription_Package_Variance_Fields>;
};


/** aggregate fields of "article_subscription_package" */
export type Article_Subscription_Package_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Subscription_Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Subscription_Package_Avg_Fields = {
  __typename?: 'article_subscription_package_avg_fields';
  discount_price?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  owner_team_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  shared_unit_price_unit_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_subscription_package". All fields are combined with a logical 'AND'. */
export type Article_Subscription_Package_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Subscription_Package_Bool_Exp>>;
  _not?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Subscription_Package_Bool_Exp>>;
  article_subscriptions?: InputMaybe<Article_Subscriptions_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discount_price?: InputMaybe<Float8_Comparison_Exp>;
  favourites?: InputMaybe<Article_Subscription_Favorite_Insights_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_public?: InputMaybe<Boolean_Comparison_Exp>;
  is_public_for_organisation?: InputMaybe<Boolean_Comparison_Exp>;
  is_user_level_subscription?: InputMaybe<Boolean_Comparison_Exp>;
  likes?: InputMaybe<Article_Subscription_Like_Insights_Bool_Exp>;
  mutual_group_subscription_packages?: InputMaybe<Mutual_Group_Subscription_Package_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  owner_team_id?: InputMaybe<Bigint_Comparison_Exp>;
  series?: InputMaybe<Series_Bool_Exp>;
  shared_organisation_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_owner_team?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_unit_price?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_unit_price_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  subscription_package_highlights?: InputMaybe<Subscription_Package_Highlights_Bool_Exp>;
  unit_price?: InputMaybe<Float8_Comparison_Exp>;
  unit_price_unit_id?: InputMaybe<String_Comparison_Exp>;
  user_subscription_packages?: InputMaybe<User_Subscription_Package_Bool_Exp>;
  views?: InputMaybe<Article_Subscription_View_Insights_Bool_Exp>;
};

/** unique or primary key constraints on table "article_subscription_package" */
export enum Article_Subscription_Package_Constraint {
  /** unique or primary key constraint on columns "name", "owner_team_id" */
  ArticleSubscriptionPackageNameOwnerTeamId_0602d934Uniq = 'article_subscription_package_name_owner_team_id_0602d934_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleSubscriptionPackagePkey = 'article_subscription_package_pkey'
}

/** input type for incrementing numeric columns in table "article_subscription_package" */
export type Article_Subscription_Package_Inc_Input = {
  discount_price?: InputMaybe<Scalars['float8']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  owner_team_id?: InputMaybe<Scalars['bigint']>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_price?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "article_subscription_package" */
export type Article_Subscription_Package_Insert_Input = {
  article_subscriptions?: InputMaybe<Article_Subscriptions_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  discount_price?: InputMaybe<Scalars['float8']>;
  favourites?: InputMaybe<Article_Subscription_Favorite_Insights_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  is_public_for_organisation?: InputMaybe<Scalars['Boolean']>;
  is_user_level_subscription?: InputMaybe<Scalars['Boolean']>;
  likes?: InputMaybe<Article_Subscription_Like_Insights_Obj_Rel_Insert_Input>;
  mutual_group_subscription_packages?: InputMaybe<Mutual_Group_Subscription_Package_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  owner_team_id?: InputMaybe<Scalars['bigint']>;
  series?: InputMaybe<Series_Arr_Rel_Insert_Input>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  shared_owner_team?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_unit_price?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_unit_price_unit_id?: InputMaybe<Scalars['bigint']>;
  subscription_package_highlights?: InputMaybe<Subscription_Package_Highlights_Arr_Rel_Insert_Input>;
  unit_price?: InputMaybe<Scalars['float8']>;
  unit_price_unit_id?: InputMaybe<Scalars['String']>;
  user_subscription_packages?: InputMaybe<User_Subscription_Package_Arr_Rel_Insert_Input>;
  views?: InputMaybe<Article_Subscription_View_Insights_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Article_Subscription_Package_Max_Fields = {
  __typename?: 'article_subscription_package_max_fields';
  description?: Maybe<Scalars['String']>;
  discount_price?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
  owner_team_id?: Maybe<Scalars['bigint']>;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_unit_id?: Maybe<Scalars['bigint']>;
  unit_price?: Maybe<Scalars['float8']>;
  unit_price_unit_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Article_Subscription_Package_Min_Fields = {
  __typename?: 'article_subscription_package_min_fields';
  description?: Maybe<Scalars['String']>;
  discount_price?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
  owner_team_id?: Maybe<Scalars['bigint']>;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_unit_id?: Maybe<Scalars['bigint']>;
  unit_price?: Maybe<Scalars['float8']>;
  unit_price_unit_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "article_subscription_package" */
export type Article_Subscription_Package_Mutation_Response = {
  __typename?: 'article_subscription_package_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Subscription_Package>;
};

/** input type for inserting object relation for remote table "article_subscription_package" */
export type Article_Subscription_Package_Obj_Rel_Insert_Input = {
  data: Article_Subscription_Package_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Subscription_Package_On_Conflict>;
};

/** on_conflict condition type for table "article_subscription_package" */
export type Article_Subscription_Package_On_Conflict = {
  constraint: Article_Subscription_Package_Constraint;
  update_columns?: Array<Article_Subscription_Package_Update_Column>;
  where?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
};

/** Ordering options when selecting data from "article_subscription_package". */
export type Article_Subscription_Package_Order_By = {
  article_subscriptions_aggregate?: InputMaybe<Article_Subscriptions_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  discount_price?: InputMaybe<Order_By>;
  favourites?: InputMaybe<Article_Subscription_Favorite_Insights_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_public?: InputMaybe<Order_By>;
  is_public_for_organisation?: InputMaybe<Order_By>;
  is_user_level_subscription?: InputMaybe<Order_By>;
  likes?: InputMaybe<Article_Subscription_Like_Insights_Order_By>;
  mutual_group_subscription_packages_aggregate?: InputMaybe<Mutual_Group_Subscription_Package_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  owner_team_id?: InputMaybe<Order_By>;
  series_aggregate?: InputMaybe<Series_Aggregate_Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  shared_owner_team?: InputMaybe<Shared_Entity_Order_By>;
  shared_unit_price?: InputMaybe<Shared_Entity_Order_By>;
  shared_unit_price_unit_id?: InputMaybe<Order_By>;
  subscription_package_highlights_aggregate?: InputMaybe<Subscription_Package_Highlights_Aggregate_Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_unit_id?: InputMaybe<Order_By>;
  user_subscription_packages_aggregate?: InputMaybe<User_Subscription_Package_Aggregate_Order_By>;
  views?: InputMaybe<Article_Subscription_View_Insights_Order_By>;
};

/** primary key columns input for table: article_subscription_package */
export type Article_Subscription_Package_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "article_subscription_package" */
export enum Article_Subscription_Package_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  IsPublicForOrganisation = 'is_public_for_organisation',
  /** column name */
  IsUserLevelSubscription = 'is_user_level_subscription',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  OwnerTeamId = 'owner_team_id',
  /** column name */
  SharedOrganisationId = 'shared_organisation_id',
  /** column name */
  SharedUnitPriceUnitId = 'shared_unit_price_unit_id',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceUnitId = 'unit_price_unit_id'
}

/** input type for updating data in table "article_subscription_package" */
export type Article_Subscription_Package_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  discount_price?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  is_public_for_organisation?: InputMaybe<Scalars['Boolean']>;
  is_user_level_subscription?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  owner_team_id?: InputMaybe<Scalars['bigint']>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_price?: InputMaybe<Scalars['float8']>;
  unit_price_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Article_Subscription_Package_Stddev_Fields = {
  __typename?: 'article_subscription_package_stddev_fields';
  discount_price?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  owner_team_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  shared_unit_price_unit_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Subscription_Package_Stddev_Pop_Fields = {
  __typename?: 'article_subscription_package_stddev_pop_fields';
  discount_price?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  owner_team_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  shared_unit_price_unit_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Subscription_Package_Stddev_Samp_Fields = {
  __typename?: 'article_subscription_package_stddev_samp_fields';
  discount_price?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  owner_team_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  shared_unit_price_unit_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_subscription_package" */
export type Article_Subscription_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Subscription_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Subscription_Package_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  discount_price?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  is_public_for_organisation?: InputMaybe<Scalars['Boolean']>;
  is_user_level_subscription?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  owner_team_id?: InputMaybe<Scalars['bigint']>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_price?: InputMaybe<Scalars['float8']>;
  unit_price_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Article_Subscription_Package_Sum_Fields = {
  __typename?: 'article_subscription_package_sum_fields';
  discount_price?: Maybe<Scalars['float8']>;
  organisation_id?: Maybe<Scalars['Int']>;
  owner_team_id?: Maybe<Scalars['bigint']>;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_unit_id?: Maybe<Scalars['bigint']>;
  unit_price?: Maybe<Scalars['float8']>;
};

/** update columns of table "article_subscription_package" */
export enum Article_Subscription_Package_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  IsPublicForOrganisation = 'is_public_for_organisation',
  /** column name */
  IsUserLevelSubscription = 'is_user_level_subscription',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  OwnerTeamId = 'owner_team_id',
  /** column name */
  SharedOrganisationId = 'shared_organisation_id',
  /** column name */
  SharedUnitPriceUnitId = 'shared_unit_price_unit_id',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceUnitId = 'unit_price_unit_id'
}

export type Article_Subscription_Package_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Subscription_Package_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Subscription_Package_Set_Input>;
  where: Article_Subscription_Package_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Subscription_Package_Var_Pop_Fields = {
  __typename?: 'article_subscription_package_var_pop_fields';
  discount_price?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  owner_team_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  shared_unit_price_unit_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Subscription_Package_Var_Samp_Fields = {
  __typename?: 'article_subscription_package_var_samp_fields';
  discount_price?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  owner_team_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  shared_unit_price_unit_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Subscription_Package_Variance_Fields = {
  __typename?: 'article_subscription_package_variance_fields';
  discount_price?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  owner_team_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  shared_unit_price_unit_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "article_subscription_view_insights" */
export type Article_Subscription_View_Insights = {
  __typename?: 'article_subscription_view_insights';
  /** An object relationship */
  package?: Maybe<Article_Subscription_Package>;
  package_id?: Maybe<Scalars['uuid']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "article_subscription_view_insights" */
export type Article_Subscription_View_Insights_Aggregate = {
  __typename?: 'article_subscription_view_insights_aggregate';
  aggregate?: Maybe<Article_Subscription_View_Insights_Aggregate_Fields>;
  nodes: Array<Article_Subscription_View_Insights>;
};

/** aggregate fields of "article_subscription_view_insights" */
export type Article_Subscription_View_Insights_Aggregate_Fields = {
  __typename?: 'article_subscription_view_insights_aggregate_fields';
  avg?: Maybe<Article_Subscription_View_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Subscription_View_Insights_Max_Fields>;
  min?: Maybe<Article_Subscription_View_Insights_Min_Fields>;
  stddev?: Maybe<Article_Subscription_View_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Subscription_View_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Subscription_View_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Subscription_View_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_Subscription_View_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Subscription_View_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_Subscription_View_Insights_Variance_Fields>;
};


/** aggregate fields of "article_subscription_view_insights" */
export type Article_Subscription_View_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Subscription_View_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_Subscription_View_Insights_Avg_Fields = {
  __typename?: 'article_subscription_view_insights_avg_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_subscription_view_insights". All fields are combined with a logical 'AND'. */
export type Article_Subscription_View_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Subscription_View_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_Subscription_View_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Subscription_View_Insights_Bool_Exp>>;
  package?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
  package_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_views?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "article_subscription_view_insights" */
export type Article_Subscription_View_Insights_Insert_Input = {
  package?: InputMaybe<Article_Subscription_Package_Obj_Rel_Insert_Input>;
  package_id?: InputMaybe<Scalars['uuid']>;
  total_views?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_Subscription_View_Insights_Max_Fields = {
  __typename?: 'article_subscription_view_insights_max_fields';
  package_id?: Maybe<Scalars['uuid']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_Subscription_View_Insights_Min_Fields = {
  __typename?: 'article_subscription_view_insights_min_fields';
  package_id?: Maybe<Scalars['uuid']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** input type for inserting object relation for remote table "article_subscription_view_insights" */
export type Article_Subscription_View_Insights_Obj_Rel_Insert_Input = {
  data: Article_Subscription_View_Insights_Insert_Input;
};

/** Ordering options when selecting data from "article_subscription_view_insights". */
export type Article_Subscription_View_Insights_Order_By = {
  package?: InputMaybe<Article_Subscription_Package_Order_By>;
  package_id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
};

/** select columns of table "article_subscription_view_insights" */
export enum Article_Subscription_View_Insights_Select_Column {
  /** column name */
  PackageId = 'package_id',
  /** column name */
  TotalViews = 'total_views'
}

/** aggregate stddev on columns */
export type Article_Subscription_View_Insights_Stddev_Fields = {
  __typename?: 'article_subscription_view_insights_stddev_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_Subscription_View_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_subscription_view_insights_stddev_pop_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_Subscription_View_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_subscription_view_insights_stddev_samp_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_subscription_view_insights" */
export type Article_Subscription_View_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Subscription_View_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Subscription_View_Insights_Stream_Cursor_Value_Input = {
  package_id?: InputMaybe<Scalars['uuid']>;
  total_views?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_Subscription_View_Insights_Sum_Fields = {
  __typename?: 'article_subscription_view_insights_sum_fields';
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_Subscription_View_Insights_Var_Pop_Fields = {
  __typename?: 'article_subscription_view_insights_var_pop_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_Subscription_View_Insights_Var_Samp_Fields = {
  __typename?: 'article_subscription_view_insights_var_samp_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_Subscription_View_Insights_Variance_Fields = {
  __typename?: 'article_subscription_view_insights_variance_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "article_subscriptions" */
export type Article_Subscriptions = {
  __typename?: 'article_subscriptions';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  id: Scalars['bigint'];
  package_id: Scalars['uuid'];
  /** An object relationship */
  subscription_package: Article_Subscription_Package;
};

/** aggregated selection of "article_subscriptions" */
export type Article_Subscriptions_Aggregate = {
  __typename?: 'article_subscriptions_aggregate';
  aggregate?: Maybe<Article_Subscriptions_Aggregate_Fields>;
  nodes: Array<Article_Subscriptions>;
};

/** aggregate fields of "article_subscriptions" */
export type Article_Subscriptions_Aggregate_Fields = {
  __typename?: 'article_subscriptions_aggregate_fields';
  avg?: Maybe<Article_Subscriptions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Subscriptions_Max_Fields>;
  min?: Maybe<Article_Subscriptions_Min_Fields>;
  stddev?: Maybe<Article_Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Subscriptions_Sum_Fields>;
  var_pop?: Maybe<Article_Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<Article_Subscriptions_Variance_Fields>;
};


/** aggregate fields of "article_subscriptions" */
export type Article_Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_subscriptions" */
export type Article_Subscriptions_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Subscriptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Subscriptions_Max_Order_By>;
  min?: InputMaybe<Article_Subscriptions_Min_Order_By>;
  stddev?: InputMaybe<Article_Subscriptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Subscriptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Subscriptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Subscriptions_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Subscriptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Subscriptions_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Subscriptions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_subscriptions" */
export type Article_Subscriptions_Arr_Rel_Insert_Input = {
  data: Array<Article_Subscriptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Subscriptions_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Subscriptions_Avg_Fields = {
  __typename?: 'article_subscriptions_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_subscriptions" */
export type Article_Subscriptions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_subscriptions". All fields are combined with a logical 'AND'. */
export type Article_Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Article_Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Subscriptions_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  package_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscription_package?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
};

/** unique or primary key constraints on table "article_subscriptions" */
export enum Article_Subscriptions_Constraint {
  /** unique or primary key constraint on columns "article_id", "package_id" */
  ArticleSubscriptionsArticleIdPackageId_35f1a73aUniq = 'article_subscriptions_article_id_package_id_35f1a73a_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleSubscriptionsPkey = 'article_subscriptions_pkey'
}

/** input type for incrementing numeric columns in table "article_subscriptions" */
export type Article_Subscriptions_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_subscriptions" */
export type Article_Subscriptions_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  package_id?: InputMaybe<Scalars['uuid']>;
  subscription_package?: InputMaybe<Article_Subscription_Package_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Article_Subscriptions_Max_Fields = {
  __typename?: 'article_subscriptions_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  package_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "article_subscriptions" */
export type Article_Subscriptions_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Subscriptions_Min_Fields = {
  __typename?: 'article_subscriptions_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  package_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "article_subscriptions" */
export type Article_Subscriptions_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_subscriptions" */
export type Article_Subscriptions_Mutation_Response = {
  __typename?: 'article_subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Subscriptions>;
};

/** on_conflict condition type for table "article_subscriptions" */
export type Article_Subscriptions_On_Conflict = {
  constraint: Article_Subscriptions_Constraint;
  update_columns?: Array<Article_Subscriptions_Update_Column>;
  where?: InputMaybe<Article_Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "article_subscriptions". */
export type Article_Subscriptions_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
  subscription_package?: InputMaybe<Article_Subscription_Package_Order_By>;
};

/** primary key columns input for table: article_subscriptions */
export type Article_Subscriptions_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_subscriptions" */
export enum Article_Subscriptions_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Id = 'id',
  /** column name */
  PackageId = 'package_id'
}

/** input type for updating data in table "article_subscriptions" */
export type Article_Subscriptions_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  package_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Article_Subscriptions_Stddev_Fields = {
  __typename?: 'article_subscriptions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_subscriptions" */
export type Article_Subscriptions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Subscriptions_Stddev_Pop_Fields = {
  __typename?: 'article_subscriptions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_subscriptions" */
export type Article_Subscriptions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Subscriptions_Stddev_Samp_Fields = {
  __typename?: 'article_subscriptions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_subscriptions" */
export type Article_Subscriptions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_subscriptions" */
export type Article_Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Subscriptions_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  package_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Article_Subscriptions_Sum_Fields = {
  __typename?: 'article_subscriptions_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_subscriptions" */
export type Article_Subscriptions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "article_subscriptions" */
export enum Article_Subscriptions_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Id = 'id',
  /** column name */
  PackageId = 'package_id'
}

export type Article_Subscriptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Subscriptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Subscriptions_Set_Input>;
  where: Article_Subscriptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Subscriptions_Var_Pop_Fields = {
  __typename?: 'article_subscriptions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_subscriptions" */
export type Article_Subscriptions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Subscriptions_Var_Samp_Fields = {
  __typename?: 'article_subscriptions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_subscriptions" */
export type Article_Subscriptions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Subscriptions_Variance_Fields = {
  __typename?: 'article_subscriptions_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_subscriptions" */
export type Article_Subscriptions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Article_Sum_Fields = {
  __typename?: 'article_sum_fields';
  duration?: Maybe<Scalars['Int']>;
  feature_image_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article" */
export type Article_Sum_Order_By = {
  duration?: InputMaybe<Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
};

/** update columns of table "article" */
export enum Article_Update_Column {
  /** column name */
  ArticleType = 'article_type',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  FeatureDateFrom = 'feature_date_from',
  /** column name */
  FeatureDateTill = 'feature_date_till',
  /** column name */
  FeatureImageId = 'feature_image_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSeries = 'is_series',
  /** column name */
  PublishDate = 'publish_date',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Article_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Set_Input>;
  where: Article_Bool_Exp;
};

/** columns and relationships of "article_user_group" */
export type Article_User_Group = {
  __typename?: 'article_user_group';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  group_id: Scalars['String'];
  id: Scalars['bigint'];
  mutual_group: Array<Mutual_Group>;
  shared_group_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "article_user_group" */
export type Article_User_GroupMutual_GroupArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp_Remote_Rel_Article_User_Groupmutual_Group>;
};

/** aggregated selection of "article_user_group" */
export type Article_User_Group_Aggregate = {
  __typename?: 'article_user_group_aggregate';
  aggregate?: Maybe<Article_User_Group_Aggregate_Fields>;
  nodes: Array<Article_User_Group>;
};

/** aggregate fields of "article_user_group" */
export type Article_User_Group_Aggregate_Fields = {
  __typename?: 'article_user_group_aggregate_fields';
  avg?: Maybe<Article_User_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_User_Group_Max_Fields>;
  min?: Maybe<Article_User_Group_Min_Fields>;
  stddev?: Maybe<Article_User_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Article_User_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_User_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Article_User_Group_Sum_Fields>;
  var_pop?: Maybe<Article_User_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Article_User_Group_Var_Samp_Fields>;
  variance?: Maybe<Article_User_Group_Variance_Fields>;
};


/** aggregate fields of "article_user_group" */
export type Article_User_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_User_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_user_group" */
export type Article_User_Group_Aggregate_Order_By = {
  avg?: InputMaybe<Article_User_Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_User_Group_Max_Order_By>;
  min?: InputMaybe<Article_User_Group_Min_Order_By>;
  stddev?: InputMaybe<Article_User_Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_User_Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_User_Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_User_Group_Sum_Order_By>;
  var_pop?: InputMaybe<Article_User_Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_User_Group_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_User_Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_user_group" */
export type Article_User_Group_Arr_Rel_Insert_Input = {
  data: Array<Article_User_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_User_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_User_Group_Avg_Fields = {
  __typename?: 'article_user_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_user_group" */
export type Article_User_Group_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_user_group". All fields are combined with a logical 'AND'. */
export type Article_User_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Article_User_Group_Bool_Exp>>;
  _not?: InputMaybe<Article_User_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Article_User_Group_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  group_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_group_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_user_group" */
export enum Article_User_Group_Constraint {
  /** unique or primary key constraint on columns "group_id", "article_id" */
  ArticleUserGroupArticleIdGroupId_3c1367f8Uniq = 'article_user_group_article_id_group_id_3c1367f8_uniq',
  /** unique or primary key constraint on columns "id" */
  ArticleUserGroupPkey = 'article_user_group_pkey'
}

/** input type for incrementing numeric columns in table "article_user_group" */
export type Article_User_Group_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "article_user_group" */
export type Article_User_Group_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Article_User_Group_Max_Fields = {
  __typename?: 'article_user_group_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  group_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "article_user_group" */
export type Article_User_Group_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_User_Group_Min_Fields = {
  __typename?: 'article_user_group_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  group_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "article_user_group" */
export type Article_User_Group_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_user_group" */
export type Article_User_Group_Mutation_Response = {
  __typename?: 'article_user_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_User_Group>;
};

/** on_conflict condition type for table "article_user_group" */
export type Article_User_Group_On_Conflict = {
  constraint: Article_User_Group_Constraint;
  update_columns?: Array<Article_User_Group_Update_Column>;
  where?: InputMaybe<Article_User_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "article_user_group". */
export type Article_User_Group_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_user_group */
export type Article_User_Group_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_user_group" */
export enum Article_User_Group_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedGroupId = 'shared_group_id'
}

/** input type for updating data in table "article_user_group" */
export type Article_User_Group_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Article_User_Group_Stddev_Fields = {
  __typename?: 'article_user_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_user_group" */
export type Article_User_Group_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_User_Group_Stddev_Pop_Fields = {
  __typename?: 'article_user_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_user_group" */
export type Article_User_Group_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_User_Group_Stddev_Samp_Fields = {
  __typename?: 'article_user_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_user_group" */
export type Article_User_Group_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_user_group" */
export type Article_User_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_User_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_User_Group_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_User_Group_Sum_Fields = {
  __typename?: 'article_user_group_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "article_user_group" */
export type Article_User_Group_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** update columns of table "article_user_group" */
export enum Article_User_Group_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedGroupId = 'shared_group_id'
}

export type Article_User_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_User_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_User_Group_Set_Input>;
  where: Article_User_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_User_Group_Var_Pop_Fields = {
  __typename?: 'article_user_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_user_group" */
export type Article_User_Group_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_User_Group_Var_Samp_Fields = {
  __typename?: 'article_user_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_user_group" */
export type Article_User_Group_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_User_Group_Variance_Fields = {
  __typename?: 'article_user_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_user_group" */
export type Article_User_Group_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Article_Var_Pop_Fields = {
  __typename?: 'article_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  feature_image_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article" */
export type Article_Var_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Var_Samp_Fields = {
  __typename?: 'article_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  feature_image_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article" */
export type Article_Var_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Variance_Fields = {
  __typename?: 'article_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  feature_image_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article" */
export type Article_Variance_Order_By = {
  duration?: InputMaybe<Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "article_view_insights" */
export type Article_View_Insights = {
  __typename?: 'article_view_insights';
  /** An object relationship */
  article?: Maybe<Article>;
  article_id?: Maybe<Scalars['uuid']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "article_view_insights" */
export type Article_View_Insights_Aggregate = {
  __typename?: 'article_view_insights_aggregate';
  aggregate?: Maybe<Article_View_Insights_Aggregate_Fields>;
  nodes: Array<Article_View_Insights>;
};

/** aggregate fields of "article_view_insights" */
export type Article_View_Insights_Aggregate_Fields = {
  __typename?: 'article_view_insights_aggregate_fields';
  avg?: Maybe<Article_View_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_View_Insights_Max_Fields>;
  min?: Maybe<Article_View_Insights_Min_Fields>;
  stddev?: Maybe<Article_View_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Article_View_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_View_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Article_View_Insights_Sum_Fields>;
  var_pop?: Maybe<Article_View_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Article_View_Insights_Var_Samp_Fields>;
  variance?: Maybe<Article_View_Insights_Variance_Fields>;
};


/** aggregate fields of "article_view_insights" */
export type Article_View_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_View_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Article_View_Insights_Avg_Fields = {
  __typename?: 'article_view_insights_avg_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "article_view_insights". All fields are combined with a logical 'AND'. */
export type Article_View_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Article_View_Insights_Bool_Exp>>;
  _not?: InputMaybe<Article_View_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Article_View_Insights_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_views?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Article_View_Insights_Max_Fields = {
  __typename?: 'article_view_insights_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Article_View_Insights_Min_Fields = {
  __typename?: 'article_view_insights_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  total_views?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "article_view_insights". */
export type Article_View_Insights_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
};

/** select columns of table "article_view_insights" */
export enum Article_View_Insights_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  TotalViews = 'total_views'
}

/** aggregate stddev on columns */
export type Article_View_Insights_Stddev_Fields = {
  __typename?: 'article_view_insights_stddev_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Article_View_Insights_Stddev_Pop_Fields = {
  __typename?: 'article_view_insights_stddev_pop_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Article_View_Insights_Stddev_Samp_Fields = {
  __typename?: 'article_view_insights_stddev_samp_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "article_view_insights" */
export type Article_View_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_View_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_View_Insights_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  total_views?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Article_View_Insights_Sum_Fields = {
  __typename?: 'article_view_insights_sum_fields';
  total_views?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Article_View_Insights_Var_Pop_Fields = {
  __typename?: 'article_view_insights_var_pop_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Article_View_Insights_Var_Samp_Fields = {
  __typename?: 'article_view_insights_var_samp_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Article_View_Insights_Variance_Fields = {
  __typename?: 'article_view_insights_variance_fields';
  total_views?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "article_views" */
export type Article_Views = {
  __typename?: 'article_views';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  current_viewtime: Scalars['Int'];
  id: Scalars['bigint'];
  is_viewed: Scalars['Boolean'];
  /** An object relationship */
  shared_user?: Maybe<Shared_Entity>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  total_duration: Scalars['Int'];
  user_id: Scalars['String'];
  view_date: Scalars['timestamptz'];
  view_device?: Maybe<Scalars['String']>;
};

/** aggregated selection of "article_views" */
export type Article_Views_Aggregate = {
  __typename?: 'article_views_aggregate';
  aggregate?: Maybe<Article_Views_Aggregate_Fields>;
  nodes: Array<Article_Views>;
};

/** aggregate fields of "article_views" */
export type Article_Views_Aggregate_Fields = {
  __typename?: 'article_views_aggregate_fields';
  avg?: Maybe<Article_Views_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Article_Views_Max_Fields>;
  min?: Maybe<Article_Views_Min_Fields>;
  stddev?: Maybe<Article_Views_Stddev_Fields>;
  stddev_pop?: Maybe<Article_Views_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Article_Views_Stddev_Samp_Fields>;
  sum?: Maybe<Article_Views_Sum_Fields>;
  var_pop?: Maybe<Article_Views_Var_Pop_Fields>;
  var_samp?: Maybe<Article_Views_Var_Samp_Fields>;
  variance?: Maybe<Article_Views_Variance_Fields>;
};


/** aggregate fields of "article_views" */
export type Article_Views_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Views_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "article_views" */
export type Article_Views_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Views_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Views_Max_Order_By>;
  min?: InputMaybe<Article_Views_Min_Order_By>;
  stddev?: InputMaybe<Article_Views_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Views_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Views_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Views_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Views_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Views_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Views_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "article_views" */
export type Article_Views_Arr_Rel_Insert_Input = {
  data: Array<Article_Views_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Views_On_Conflict>;
};

/** aggregate avg on columns */
export type Article_Views_Avg_Fields = {
  __typename?: 'article_views_avg_fields';
  current_viewtime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
  total_duration?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "article_views" */
export type Article_Views_Avg_Order_By = {
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "article_views". All fields are combined with a logical 'AND'. */
export type Article_Views_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Views_Bool_Exp>>;
  _not?: InputMaybe<Article_Views_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Views_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  current_viewtime?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_viewed?: InputMaybe<Boolean_Comparison_Exp>;
  shared_user?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_duration?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  view_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  view_device?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "article_views" */
export enum Article_Views_Constraint {
  /** unique or primary key constraint on columns "id" */
  ArticleViewsPkey = 'article_views_pkey',
  /** unique or primary key constraint on columns "user_id", "article_id" */
  ArticleViewsUserIdArticleId_840cd129Uniq = 'article_views_user_id_article_id_840cd129_uniq'
}

/** input type for incrementing numeric columns in table "article_views" */
export type Article_Views_Inc_Input = {
  current_viewtime?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  total_duration?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "article_views" */
export type Article_Views_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  current_viewtime?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_viewed?: InputMaybe<Scalars['Boolean']>;
  shared_user?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  total_duration?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['String']>;
  view_date?: InputMaybe<Scalars['timestamptz']>;
  view_device?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Article_Views_Max_Fields = {
  __typename?: 'article_views_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  current_viewtime?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  total_duration?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
  view_date?: Maybe<Scalars['timestamptz']>;
  view_device?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "article_views" */
export type Article_Views_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_date?: InputMaybe<Order_By>;
  view_device?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Article_Views_Min_Fields = {
  __typename?: 'article_views_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  current_viewtime?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  total_duration?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
  view_date?: Maybe<Scalars['timestamptz']>;
  view_device?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "article_views" */
export type Article_Views_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_date?: InputMaybe<Order_By>;
  view_device?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "article_views" */
export type Article_Views_Mutation_Response = {
  __typename?: 'article_views_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_Views>;
};

/** on_conflict condition type for table "article_views" */
export type Article_Views_On_Conflict = {
  constraint: Article_Views_Constraint;
  update_columns?: Array<Article_Views_Update_Column>;
  where?: InputMaybe<Article_Views_Bool_Exp>;
};

/** Ordering options when selecting data from "article_views". */
export type Article_Views_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_viewed?: InputMaybe<Order_By>;
  shared_user?: InputMaybe<Shared_Entity_Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_date?: InputMaybe<Order_By>;
  view_device?: InputMaybe<Order_By>;
};

/** primary key columns input for table: article_views */
export type Article_Views_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "article_views" */
export enum Article_Views_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CurrentViewtime = 'current_viewtime',
  /** column name */
  Id = 'id',
  /** column name */
  IsViewed = 'is_viewed',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  TotalDuration = 'total_duration',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ViewDate = 'view_date',
  /** column name */
  ViewDevice = 'view_device'
}

/** input type for updating data in table "article_views" */
export type Article_Views_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  current_viewtime?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_viewed?: InputMaybe<Scalars['Boolean']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  total_duration?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['String']>;
  view_date?: InputMaybe<Scalars['timestamptz']>;
  view_device?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Article_Views_Stddev_Fields = {
  __typename?: 'article_views_stddev_fields';
  current_viewtime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
  total_duration?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "article_views" */
export type Article_Views_Stddev_Order_By = {
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Article_Views_Stddev_Pop_Fields = {
  __typename?: 'article_views_stddev_pop_fields';
  current_viewtime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
  total_duration?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "article_views" */
export type Article_Views_Stddev_Pop_Order_By = {
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Article_Views_Stddev_Samp_Fields = {
  __typename?: 'article_views_stddev_samp_fields';
  current_viewtime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
  total_duration?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "article_views" */
export type Article_Views_Stddev_Samp_Order_By = {
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "article_views" */
export type Article_Views_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Views_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Views_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  current_viewtime?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_viewed?: InputMaybe<Scalars['Boolean']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  total_duration?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['String']>;
  view_date?: InputMaybe<Scalars['timestamptz']>;
  view_device?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Article_Views_Sum_Fields = {
  __typename?: 'article_views_sum_fields';
  current_viewtime?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  total_duration?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "article_views" */
export type Article_Views_Sum_Order_By = {
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
};

/** update columns of table "article_views" */
export enum Article_Views_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CurrentViewtime = 'current_viewtime',
  /** column name */
  Id = 'id',
  /** column name */
  IsViewed = 'is_viewed',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  TotalDuration = 'total_duration',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ViewDate = 'view_date',
  /** column name */
  ViewDevice = 'view_device'
}

export type Article_Views_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Views_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Views_Set_Input>;
  where: Article_Views_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Article_Views_Var_Pop_Fields = {
  __typename?: 'article_views_var_pop_fields';
  current_viewtime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
  total_duration?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "article_views" */
export type Article_Views_Var_Pop_Order_By = {
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Article_Views_Var_Samp_Fields = {
  __typename?: 'article_views_var_samp_fields';
  current_viewtime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
  total_duration?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "article_views" */
export type Article_Views_Var_Samp_Order_By = {
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Article_Views_Variance_Fields = {
  __typename?: 'article_views_variance_fields';
  current_viewtime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
  total_duration?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "article_views" */
export type Article_Views_Variance_Order_By = {
  current_viewtime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  total_duration?: InputMaybe<Order_By>;
};

/** columns and relationships of "assessment" */
export type Assessment = {
  __typename?: 'assessment';
  /** An array relationship */
  article_series: Array<Article_Series>;
  /** An aggregate relationship */
  article_series_aggregate: Article_Series_Aggregate;
  /** An array relationship */
  assessment_questions: Array<Assessment_Question>;
  /** An aggregate relationship */
  assessment_questions_aggregate: Assessment_Question_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_optional: Scalars['Boolean'];
  marks_cutoff: Scalars['smallint'];
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  series?: Maybe<Series>;
  series_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  /** An array relationship */
  user_assessment_attempts: Array<User_Assessment_Attempt>;
  /** An aggregate relationship */
  user_assessment_attempts_aggregate: User_Assessment_Attempt_Aggregate;
};


/** columns and relationships of "assessment" */
export type AssessmentArticle_SeriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


/** columns and relationships of "assessment" */
export type AssessmentArticle_Series_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


/** columns and relationships of "assessment" */
export type AssessmentAssessment_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Question_Order_By>>;
  where?: InputMaybe<Assessment_Question_Bool_Exp>;
};


/** columns and relationships of "assessment" */
export type AssessmentAssessment_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Question_Order_By>>;
  where?: InputMaybe<Assessment_Question_Bool_Exp>;
};


/** columns and relationships of "assessment" */
export type AssessmentUser_Assessment_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Attempt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Attempt_Order_By>>;
  where?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
};


/** columns and relationships of "assessment" */
export type AssessmentUser_Assessment_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Attempt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Attempt_Order_By>>;
  where?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
};

/** aggregated selection of "assessment" */
export type Assessment_Aggregate = {
  __typename?: 'assessment_aggregate';
  aggregate?: Maybe<Assessment_Aggregate_Fields>;
  nodes: Array<Assessment>;
};

/** aggregate fields of "assessment" */
export type Assessment_Aggregate_Fields = {
  __typename?: 'assessment_aggregate_fields';
  avg?: Maybe<Assessment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Assessment_Max_Fields>;
  min?: Maybe<Assessment_Min_Fields>;
  stddev?: Maybe<Assessment_Stddev_Fields>;
  stddev_pop?: Maybe<Assessment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assessment_Stddev_Samp_Fields>;
  sum?: Maybe<Assessment_Sum_Fields>;
  var_pop?: Maybe<Assessment_Var_Pop_Fields>;
  var_samp?: Maybe<Assessment_Var_Samp_Fields>;
  variance?: Maybe<Assessment_Variance_Fields>;
};


/** aggregate fields of "assessment" */
export type Assessment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assessment" */
export type Assessment_Aggregate_Order_By = {
  avg?: InputMaybe<Assessment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assessment_Max_Order_By>;
  min?: InputMaybe<Assessment_Min_Order_By>;
  stddev?: InputMaybe<Assessment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assessment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assessment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assessment_Sum_Order_By>;
  var_pop?: InputMaybe<Assessment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assessment_Var_Samp_Order_By>;
  variance?: InputMaybe<Assessment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assessment" */
export type Assessment_Arr_Rel_Insert_Input = {
  data: Array<Assessment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_On_Conflict>;
};

/** aggregate avg on columns */
export type Assessment_Avg_Fields = {
  __typename?: 'assessment_avg_fields';
  marks_cutoff?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "assessment" */
export type Assessment_Avg_Order_By = {
  marks_cutoff?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assessment". All fields are combined with a logical 'AND'. */
export type Assessment_Bool_Exp = {
  _and?: InputMaybe<Array<Assessment_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Bool_Exp>>;
  article_series?: InputMaybe<Article_Series_Bool_Exp>;
  assessment_questions?: InputMaybe<Assessment_Question_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_optional?: InputMaybe<Boolean_Comparison_Exp>;
  marks_cutoff?: InputMaybe<Smallint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  series?: InputMaybe<Series_Bool_Exp>;
  series_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user_assessment_attempts?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
};

/** unique or primary key constraints on table "assessment" */
export enum Assessment_Constraint {
  /** unique or primary key constraint on columns "name", "series_id" */
  AssessmentNameSeriesId_62e8aeefUniq = 'assessment_name_series_id_62e8aeef_uniq',
  /** unique or primary key constraint on columns "id" */
  AssessmentPkey = 'assessment_pkey'
}

/** input type for incrementing numeric columns in table "assessment" */
export type Assessment_Inc_Input = {
  marks_cutoff?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "assessment" */
export type Assessment_Insert_Input = {
  article_series?: InputMaybe<Article_Series_Arr_Rel_Insert_Input>;
  assessment_questions?: InputMaybe<Assessment_Question_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_optional?: InputMaybe<Scalars['Boolean']>;
  marks_cutoff?: InputMaybe<Scalars['smallint']>;
  name?: InputMaybe<Scalars['String']>;
  series?: InputMaybe<Series_Obj_Rel_Insert_Input>;
  series_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_assessment_attempts?: InputMaybe<User_Assessment_Attempt_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Assessment_Max_Fields = {
  __typename?: 'assessment_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  marks_cutoff?: Maybe<Scalars['smallint']>;
  name?: Maybe<Scalars['String']>;
  series_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "assessment" */
export type Assessment_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks_cutoff?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assessment_Min_Fields = {
  __typename?: 'assessment_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  marks_cutoff?: Maybe<Scalars['smallint']>;
  name?: Maybe<Scalars['String']>;
  series_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "assessment" */
export type Assessment_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marks_cutoff?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assessment" */
export type Assessment_Mutation_Response = {
  __typename?: 'assessment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment>;
};

/** input type for inserting object relation for remote table "assessment" */
export type Assessment_Obj_Rel_Insert_Input = {
  data: Assessment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_On_Conflict>;
};

/** on_conflict condition type for table "assessment" */
export type Assessment_On_Conflict = {
  constraint: Assessment_Constraint;
  update_columns?: Array<Assessment_Update_Column>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};

/** Ordering options when selecting data from "assessment". */
export type Assessment_Order_By = {
  article_series_aggregate?: InputMaybe<Article_Series_Aggregate_Order_By>;
  assessment_questions_aggregate?: InputMaybe<Assessment_Question_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_optional?: InputMaybe<Order_By>;
  marks_cutoff?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  series?: InputMaybe<Series_Order_By>;
  series_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_assessment_attempts_aggregate?: InputMaybe<User_Assessment_Attempt_Aggregate_Order_By>;
};

/** primary key columns input for table: assessment */
export type Assessment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "assessment_question" */
export type Assessment_Question = {
  __typename?: 'assessment_question';
  /** An array relationship */
  answer_choices: Array<Answer_Choice>;
  /** An aggregate relationship */
  answer_choices_aggregate: Answer_Choice_Aggregate;
  /** An object relationship */
  assessment: Assessment;
  assessment_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_optional: Scalars['Boolean'];
  mark?: Maybe<Scalars['smallint']>;
  order: Scalars['smallint'];
  question: Scalars['String'];
  question_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  /** An array relationship */
  user_assessment_question_responses: Array<User_Assessment_Question_Response>;
  /** An aggregate relationship */
  user_assessment_question_responses_aggregate: User_Assessment_Question_Response_Aggregate;
};


/** columns and relationships of "assessment_question" */
export type Assessment_QuestionAnswer_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Answer_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Answer_Choice_Order_By>>;
  where?: InputMaybe<Answer_Choice_Bool_Exp>;
};


/** columns and relationships of "assessment_question" */
export type Assessment_QuestionAnswer_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Answer_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Answer_Choice_Order_By>>;
  where?: InputMaybe<Answer_Choice_Bool_Exp>;
};


/** columns and relationships of "assessment_question" */
export type Assessment_QuestionUser_Assessment_Question_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Question_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Question_Response_Order_By>>;
  where?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};


/** columns and relationships of "assessment_question" */
export type Assessment_QuestionUser_Assessment_Question_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Question_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Question_Response_Order_By>>;
  where?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};

/** aggregated selection of "assessment_question" */
export type Assessment_Question_Aggregate = {
  __typename?: 'assessment_question_aggregate';
  aggregate?: Maybe<Assessment_Question_Aggregate_Fields>;
  nodes: Array<Assessment_Question>;
};

/** aggregate fields of "assessment_question" */
export type Assessment_Question_Aggregate_Fields = {
  __typename?: 'assessment_question_aggregate_fields';
  avg?: Maybe<Assessment_Question_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Assessment_Question_Max_Fields>;
  min?: Maybe<Assessment_Question_Min_Fields>;
  stddev?: Maybe<Assessment_Question_Stddev_Fields>;
  stddev_pop?: Maybe<Assessment_Question_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assessment_Question_Stddev_Samp_Fields>;
  sum?: Maybe<Assessment_Question_Sum_Fields>;
  var_pop?: Maybe<Assessment_Question_Var_Pop_Fields>;
  var_samp?: Maybe<Assessment_Question_Var_Samp_Fields>;
  variance?: Maybe<Assessment_Question_Variance_Fields>;
};


/** aggregate fields of "assessment_question" */
export type Assessment_Question_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assessment_question" */
export type Assessment_Question_Aggregate_Order_By = {
  avg?: InputMaybe<Assessment_Question_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assessment_Question_Max_Order_By>;
  min?: InputMaybe<Assessment_Question_Min_Order_By>;
  stddev?: InputMaybe<Assessment_Question_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assessment_Question_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assessment_Question_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assessment_Question_Sum_Order_By>;
  var_pop?: InputMaybe<Assessment_Question_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assessment_Question_Var_Samp_Order_By>;
  variance?: InputMaybe<Assessment_Question_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assessment_question" */
export type Assessment_Question_Arr_Rel_Insert_Input = {
  data: Array<Assessment_Question_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Question_On_Conflict>;
};

/** aggregate avg on columns */
export type Assessment_Question_Avg_Fields = {
  __typename?: 'assessment_question_avg_fields';
  mark?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "assessment_question" */
export type Assessment_Question_Avg_Order_By = {
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assessment_question". All fields are combined with a logical 'AND'. */
export type Assessment_Question_Bool_Exp = {
  _and?: InputMaybe<Array<Assessment_Question_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Question_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Question_Bool_Exp>>;
  answer_choices?: InputMaybe<Answer_Choice_Bool_Exp>;
  assessment?: InputMaybe<Assessment_Bool_Exp>;
  assessment_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_optional?: InputMaybe<Boolean_Comparison_Exp>;
  mark?: InputMaybe<Smallint_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  question_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user_assessment_question_responses?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};

/** unique or primary key constraints on table "assessment_question" */
export enum Assessment_Question_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssessmentQuestionPkey = 'assessment_question_pkey',
  /** unique or primary key constraint on columns "question_type", "assessment_id", "question", "order" */
  AssessmentQuestionQuestionAssessmentIdQ_076e3bb0Uniq = 'assessment_question_question_assessment_id_q_076e3bb0_uniq'
}

/** input type for incrementing numeric columns in table "assessment_question" */
export type Assessment_Question_Inc_Input = {
  mark?: InputMaybe<Scalars['smallint']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "assessment_question" */
export type Assessment_Question_Insert_Input = {
  answer_choices?: InputMaybe<Answer_Choice_Arr_Rel_Insert_Input>;
  assessment?: InputMaybe<Assessment_Obj_Rel_Insert_Input>;
  assessment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_optional?: InputMaybe<Scalars['Boolean']>;
  mark?: InputMaybe<Scalars['smallint']>;
  order?: InputMaybe<Scalars['smallint']>;
  question?: InputMaybe<Scalars['String']>;
  question_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_assessment_question_responses?: InputMaybe<User_Assessment_Question_Response_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Assessment_Question_Max_Fields = {
  __typename?: 'assessment_question_max_fields';
  assessment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  mark?: Maybe<Scalars['smallint']>;
  order?: Maybe<Scalars['smallint']>;
  question?: Maybe<Scalars['String']>;
  question_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "assessment_question" */
export type Assessment_Question_Max_Order_By = {
  assessment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assessment_Question_Min_Fields = {
  __typename?: 'assessment_question_min_fields';
  assessment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  mark?: Maybe<Scalars['smallint']>;
  order?: Maybe<Scalars['smallint']>;
  question?: Maybe<Scalars['String']>;
  question_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "assessment_question" */
export type Assessment_Question_Min_Order_By = {
  assessment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assessment_question" */
export type Assessment_Question_Mutation_Response = {
  __typename?: 'assessment_question_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment_Question>;
};

/** input type for inserting object relation for remote table "assessment_question" */
export type Assessment_Question_Obj_Rel_Insert_Input = {
  data: Assessment_Question_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Question_On_Conflict>;
};

/** on_conflict condition type for table "assessment_question" */
export type Assessment_Question_On_Conflict = {
  constraint: Assessment_Question_Constraint;
  update_columns?: Array<Assessment_Question_Update_Column>;
  where?: InputMaybe<Assessment_Question_Bool_Exp>;
};

/** Ordering options when selecting data from "assessment_question". */
export type Assessment_Question_Order_By = {
  answer_choices_aggregate?: InputMaybe<Answer_Choice_Aggregate_Order_By>;
  assessment?: InputMaybe<Assessment_Order_By>;
  assessment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_optional?: InputMaybe<Order_By>;
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_assessment_question_responses_aggregate?: InputMaybe<User_Assessment_Question_Response_Aggregate_Order_By>;
};

/** primary key columns input for table: assessment_question */
export type Assessment_Question_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "assessment_question" */
export enum Assessment_Question_Select_Column {
  /** column name */
  AssessmentId = 'assessment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOptional = 'is_optional',
  /** column name */
  Mark = 'mark',
  /** column name */
  Order = 'order',
  /** column name */
  Question = 'question',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "assessment_question" */
export type Assessment_Question_Set_Input = {
  assessment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_optional?: InputMaybe<Scalars['Boolean']>;
  mark?: InputMaybe<Scalars['smallint']>;
  order?: InputMaybe<Scalars['smallint']>;
  question?: InputMaybe<Scalars['String']>;
  question_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Assessment_Question_Stddev_Fields = {
  __typename?: 'assessment_question_stddev_fields';
  mark?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "assessment_question" */
export type Assessment_Question_Stddev_Order_By = {
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assessment_Question_Stddev_Pop_Fields = {
  __typename?: 'assessment_question_stddev_pop_fields';
  mark?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "assessment_question" */
export type Assessment_Question_Stddev_Pop_Order_By = {
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assessment_Question_Stddev_Samp_Fields = {
  __typename?: 'assessment_question_stddev_samp_fields';
  mark?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "assessment_question" */
export type Assessment_Question_Stddev_Samp_Order_By = {
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assessment_question" */
export type Assessment_Question_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Question_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Question_Stream_Cursor_Value_Input = {
  assessment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_optional?: InputMaybe<Scalars['Boolean']>;
  mark?: InputMaybe<Scalars['smallint']>;
  order?: InputMaybe<Scalars['smallint']>;
  question?: InputMaybe<Scalars['String']>;
  question_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Assessment_Question_Sum_Fields = {
  __typename?: 'assessment_question_sum_fields';
  mark?: Maybe<Scalars['smallint']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "assessment_question" */
export type Assessment_Question_Sum_Order_By = {
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "assessment_question" */
export enum Assessment_Question_Update_Column {
  /** column name */
  AssessmentId = 'assessment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOptional = 'is_optional',
  /** column name */
  Mark = 'mark',
  /** column name */
  Order = 'order',
  /** column name */
  Question = 'question',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Assessment_Question_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assessment_Question_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assessment_Question_Set_Input>;
  where: Assessment_Question_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assessment_Question_Var_Pop_Fields = {
  __typename?: 'assessment_question_var_pop_fields';
  mark?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "assessment_question" */
export type Assessment_Question_Var_Pop_Order_By = {
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assessment_Question_Var_Samp_Fields = {
  __typename?: 'assessment_question_var_samp_fields';
  mark?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "assessment_question" */
export type Assessment_Question_Var_Samp_Order_By = {
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assessment_Question_Variance_Fields = {
  __typename?: 'assessment_question_variance_fields';
  mark?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "assessment_question" */
export type Assessment_Question_Variance_Order_By = {
  mark?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** select columns of table "assessment" */
export enum Assessment_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOptional = 'is_optional',
  /** column name */
  MarksCutoff = 'marks_cutoff',
  /** column name */
  Name = 'name',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "assessment" */
export type Assessment_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_optional?: InputMaybe<Scalars['Boolean']>;
  marks_cutoff?: InputMaybe<Scalars['smallint']>;
  name?: InputMaybe<Scalars['String']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Assessment_Stddev_Fields = {
  __typename?: 'assessment_stddev_fields';
  marks_cutoff?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "assessment" */
export type Assessment_Stddev_Order_By = {
  marks_cutoff?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assessment_Stddev_Pop_Fields = {
  __typename?: 'assessment_stddev_pop_fields';
  marks_cutoff?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "assessment" */
export type Assessment_Stddev_Pop_Order_By = {
  marks_cutoff?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assessment_Stddev_Samp_Fields = {
  __typename?: 'assessment_stddev_samp_fields';
  marks_cutoff?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "assessment" */
export type Assessment_Stddev_Samp_Order_By = {
  marks_cutoff?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assessment" */
export type Assessment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_optional?: InputMaybe<Scalars['Boolean']>;
  marks_cutoff?: InputMaybe<Scalars['smallint']>;
  name?: InputMaybe<Scalars['String']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Assessment_Sum_Fields = {
  __typename?: 'assessment_sum_fields';
  marks_cutoff?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "assessment" */
export type Assessment_Sum_Order_By = {
  marks_cutoff?: InputMaybe<Order_By>;
};

/** update columns of table "assessment" */
export enum Assessment_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOptional = 'is_optional',
  /** column name */
  MarksCutoff = 'marks_cutoff',
  /** column name */
  Name = 'name',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Assessment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assessment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assessment_Set_Input>;
  where: Assessment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assessment_Var_Pop_Fields = {
  __typename?: 'assessment_var_pop_fields';
  marks_cutoff?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "assessment" */
export type Assessment_Var_Pop_Order_By = {
  marks_cutoff?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assessment_Var_Samp_Fields = {
  __typename?: 'assessment_var_samp_fields';
  marks_cutoff?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "assessment" */
export type Assessment_Var_Samp_Order_By = {
  marks_cutoff?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assessment_Variance_Fields = {
  __typename?: 'assessment_variance_fields';
  marks_cutoff?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "assessment" */
export type Assessment_Variance_Order_By = {
  marks_cutoff?: InputMaybe<Order_By>;
};

/** columns and relationships of "attribute" */
export type Attribute = {
  __typename?: 'attribute';
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  product_attributes: Array<Product_Attribute>;
  /** An aggregate relationship */
  product_attributes_aggregate: Product_Attribute_Aggregate;
};


/** columns and relationships of "attribute" */
export type AttributeProduct_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


/** columns and relationships of "attribute" */
export type AttributeProduct_Attributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};

/** aggregated selection of "attribute" */
export type Attribute_Aggregate = {
  __typename?: 'attribute_aggregate';
  aggregate?: Maybe<Attribute_Aggregate_Fields>;
  nodes: Array<Attribute>;
};

/** aggregate fields of "attribute" */
export type Attribute_Aggregate_Fields = {
  __typename?: 'attribute_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Attribute_Max_Fields>;
  min?: Maybe<Attribute_Min_Fields>;
};


/** aggregate fields of "attribute" */
export type Attribute_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Attribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "attribute". All fields are combined with a logical 'AND'. */
export type Attribute_Bool_Exp = {
  _and?: InputMaybe<Array<Attribute_Bool_Exp>>;
  _not?: InputMaybe<Attribute_Bool_Exp>;
  _or?: InputMaybe<Array<Attribute_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  product_attributes?: InputMaybe<Product_Attribute_Bool_Exp>;
};

/** columns and relationships of "attribute_choice" */
export type Attribute_Choice = {
  __typename?: 'attribute_choice';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An array relationship */
  product_attribute_choices: Array<Product_Attribute_Choice>;
  /** An aggregate relationship */
  product_attribute_choices_aggregate: Product_Attribute_Choice_Aggregate;
  text: Scalars['String'];
};


/** columns and relationships of "attribute_choice" */
export type Attribute_ChoiceProduct_Attribute_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Choice_Order_By>>;
  where?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
};


/** columns and relationships of "attribute_choice" */
export type Attribute_ChoiceProduct_Attribute_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Choice_Order_By>>;
  where?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
};

/** aggregated selection of "attribute_choice" */
export type Attribute_Choice_Aggregate = {
  __typename?: 'attribute_choice_aggregate';
  aggregate?: Maybe<Attribute_Choice_Aggregate_Fields>;
  nodes: Array<Attribute_Choice>;
};

/** aggregate fields of "attribute_choice" */
export type Attribute_Choice_Aggregate_Fields = {
  __typename?: 'attribute_choice_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Attribute_Choice_Max_Fields>;
  min?: Maybe<Attribute_Choice_Min_Fields>;
};


/** aggregate fields of "attribute_choice" */
export type Attribute_Choice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Attribute_Choice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "attribute_choice". All fields are combined with a logical 'AND'. */
export type Attribute_Choice_Bool_Exp = {
  _and?: InputMaybe<Array<Attribute_Choice_Bool_Exp>>;
  _not?: InputMaybe<Attribute_Choice_Bool_Exp>;
  _or?: InputMaybe<Array<Attribute_Choice_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  product_attribute_choices?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "attribute_choice" */
export enum Attribute_Choice_Constraint {
  /** unique or primary key constraint on columns "id" */
  AttributeChoicePkey = 'attribute_choice_pkey'
}

/** input type for inserting data into table "attribute_choice" */
export type Attribute_Choice_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_attribute_choices?: InputMaybe<Product_Attribute_Choice_Arr_Rel_Insert_Input>;
  text?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Attribute_Choice_Max_Fields = {
  __typename?: 'attribute_choice_max_fields';
  id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Attribute_Choice_Min_Fields = {
  __typename?: 'attribute_choice_min_fields';
  id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "attribute_choice" */
export type Attribute_Choice_Mutation_Response = {
  __typename?: 'attribute_choice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Attribute_Choice>;
};

/** input type for inserting object relation for remote table "attribute_choice" */
export type Attribute_Choice_Obj_Rel_Insert_Input = {
  data: Attribute_Choice_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Attribute_Choice_On_Conflict>;
};

/** on_conflict condition type for table "attribute_choice" */
export type Attribute_Choice_On_Conflict = {
  constraint: Attribute_Choice_Constraint;
  update_columns?: Array<Attribute_Choice_Update_Column>;
  where?: InputMaybe<Attribute_Choice_Bool_Exp>;
};

/** Ordering options when selecting data from "attribute_choice". */
export type Attribute_Choice_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  product_attribute_choices_aggregate?: InputMaybe<Product_Attribute_Choice_Aggregate_Order_By>;
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: attribute_choice */
export type Attribute_Choice_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "attribute_choice" */
export enum Attribute_Choice_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "attribute_choice" */
export type Attribute_Choice_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "attribute_choice" */
export type Attribute_Choice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attribute_Choice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attribute_Choice_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

/** update columns of table "attribute_choice" */
export enum Attribute_Choice_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Text = 'text'
}

export type Attribute_Choice_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Attribute_Choice_Set_Input>;
  where: Attribute_Choice_Bool_Exp;
};

/** unique or primary key constraints on table "attribute" */
export enum Attribute_Constraint {
  /** unique or primary key constraint on columns "id" */
  AttributePkey = 'attribute_pkey'
}

/** input type for inserting data into table "attribute" */
export type Attribute_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  product_attributes?: InputMaybe<Product_Attribute_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Attribute_Max_Fields = {
  __typename?: 'attribute_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Attribute_Min_Fields = {
  __typename?: 'attribute_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "attribute" */
export type Attribute_Mutation_Response = {
  __typename?: 'attribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Attribute>;
};

/** input type for inserting object relation for remote table "attribute" */
export type Attribute_Obj_Rel_Insert_Input = {
  data: Attribute_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Attribute_On_Conflict>;
};

/** on_conflict condition type for table "attribute" */
export type Attribute_On_Conflict = {
  constraint: Attribute_Constraint;
  update_columns?: Array<Attribute_Update_Column>;
  where?: InputMaybe<Attribute_Bool_Exp>;
};

/** Ordering options when selecting data from "attribute". */
export type Attribute_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_attributes_aggregate?: InputMaybe<Product_Attribute_Aggregate_Order_By>;
};

/** primary key columns input for table: attribute */
export type Attribute_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "attribute" */
export enum Attribute_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "attribute" */
export type Attribute_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "attribute" */
export type Attribute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attribute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attribute_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "attribute" */
export enum Attribute_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Attribute_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Attribute_Set_Input>;
  where: Attribute_Bool_Exp;
};

/** columns and relationships of "auth_group" */
export type Auth_Group = {
  __typename?: 'auth_group';
  /** An array relationship */
  base_users: Array<Base_User_Groups>;
  /** An aggregate relationship */
  base_users_aggregate: Base_User_Groups_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** columns and relationships of "auth_group" */
export type Auth_GroupBase_UsersArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


/** columns and relationships of "auth_group" */
export type Auth_GroupBase_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};

/** aggregated selection of "auth_group" */
export type Auth_Group_Aggregate = {
  __typename?: 'auth_group_aggregate';
  aggregate?: Maybe<Auth_Group_Aggregate_Fields>;
  nodes: Array<Auth_Group>;
};

/** aggregate fields of "auth_group" */
export type Auth_Group_Aggregate_Fields = {
  __typename?: 'auth_group_aggregate_fields';
  avg?: Maybe<Auth_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Auth_Group_Max_Fields>;
  min?: Maybe<Auth_Group_Min_Fields>;
  stddev?: Maybe<Auth_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Group_Sum_Fields>;
  var_pop?: Maybe<Auth_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Group_Var_Samp_Fields>;
  variance?: Maybe<Auth_Group_Variance_Fields>;
};


/** aggregate fields of "auth_group" */
export type Auth_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Auth_Group_Avg_Fields = {
  __typename?: 'auth_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "auth_group". All fields are combined with a logical 'AND'. */
export type Auth_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Group_Bool_Exp>>;
  _not?: InputMaybe<Auth_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Group_Bool_Exp>>;
  base_users?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth_group" */
export enum Auth_Group_Constraint {
  /** unique or primary key constraint on columns "name" */
  AuthGroupNameKey = 'auth_group_name_key',
  /** unique or primary key constraint on columns "id" */
  AuthGroupPkey = 'auth_group_pkey'
}

/** input type for incrementing numeric columns in table "auth_group" */
export type Auth_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth_group" */
export type Auth_Group_Insert_Input = {
  base_users?: InputMaybe<Base_User_Groups_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Auth_Group_Max_Fields = {
  __typename?: 'auth_group_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Auth_Group_Min_Fields = {
  __typename?: 'auth_group_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth_group" */
export type Auth_Group_Mutation_Response = {
  __typename?: 'auth_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Group>;
};

/** input type for inserting object relation for remote table "auth_group" */
export type Auth_Group_Obj_Rel_Insert_Input = {
  data: Auth_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};

/** on_conflict condition type for table "auth_group" */
export type Auth_Group_On_Conflict = {
  constraint: Auth_Group_Constraint;
  update_columns?: Array<Auth_Group_Update_Column>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "auth_group". */
export type Auth_Group_Order_By = {
  base_users_aggregate?: InputMaybe<Base_User_Groups_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** columns and relationships of "auth_group_permissions" */
export type Auth_Group_Permissions = {
  __typename?: 'auth_group_permissions';
  /** An object relationship */
  group: Auth_Group;
  group_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  permission: Auth_Permission;
  permission_id: Scalars['Int'];
};

/** aggregated selection of "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate = {
  __typename?: 'auth_group_permissions_aggregate';
  aggregate?: Maybe<Auth_Group_Permissions_Aggregate_Fields>;
  nodes: Array<Auth_Group_Permissions>;
};

/** aggregate fields of "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate_Fields = {
  __typename?: 'auth_group_permissions_aggregate_fields';
  avg?: Maybe<Auth_Group_Permissions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Auth_Group_Permissions_Max_Fields>;
  min?: Maybe<Auth_Group_Permissions_Min_Fields>;
  stddev?: Maybe<Auth_Group_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Group_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Group_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Group_Permissions_Sum_Fields>;
  var_pop?: Maybe<Auth_Group_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Group_Permissions_Var_Samp_Fields>;
  variance?: Maybe<Auth_Group_Permissions_Variance_Fields>;
};


/** aggregate fields of "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate_Order_By = {
  avg?: InputMaybe<Auth_Group_Permissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Group_Permissions_Max_Order_By>;
  min?: InputMaybe<Auth_Group_Permissions_Min_Order_By>;
  stddev?: InputMaybe<Auth_Group_Permissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Auth_Group_Permissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Auth_Group_Permissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Auth_Group_Permissions_Sum_Order_By>;
  var_pop?: InputMaybe<Auth_Group_Permissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Auth_Group_Permissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Auth_Group_Permissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth_group_permissions" */
export type Auth_Group_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Auth_Group_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Group_Permissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Auth_Group_Permissions_Avg_Fields = {
  __typename?: 'auth_group_permissions_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth_group_permissions". All fields are combined with a logical 'AND'. */
export type Auth_Group_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Group_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Group_Permissions_Bool_Exp>>;
  group?: InputMaybe<Auth_Group_Bool_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  permission?: InputMaybe<Auth_Permission_Bool_Exp>;
  permission_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth_group_permissions" */
export enum Auth_Group_Permissions_Constraint {
  /** unique or primary key constraint on columns "group_id", "permission_id" */
  AuthGroupPermissionsGroupIdPermissionId_0cd325b0Uniq = 'auth_group_permissions_group_id_permission_id_0cd325b0_uniq',
  /** unique or primary key constraint on columns "id" */
  AuthGroupPermissionsPkey = 'auth_group_permissions_pkey'
}

/** input type for incrementing numeric columns in table "auth_group_permissions" */
export type Auth_Group_Permissions_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth_group_permissions" */
export type Auth_Group_Permissions_Insert_Input = {
  group?: InputMaybe<Auth_Group_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission?: InputMaybe<Auth_Permission_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Auth_Group_Permissions_Max_Fields = {
  __typename?: 'auth_group_permissions_max_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Max_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Group_Permissions_Min_Fields = {
  __typename?: 'auth_group_permissions_min_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Min_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth_group_permissions" */
export type Auth_Group_Permissions_Mutation_Response = {
  __typename?: 'auth_group_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Group_Permissions>;
};

/** on_conflict condition type for table "auth_group_permissions" */
export type Auth_Group_Permissions_On_Conflict = {
  constraint: Auth_Group_Permissions_Constraint;
  update_columns?: Array<Auth_Group_Permissions_Update_Column>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "auth_group_permissions". */
export type Auth_Group_Permissions_Order_By = {
  group?: InputMaybe<Auth_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Auth_Permission_Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth_group_permissions */
export type Auth_Group_Permissions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "auth_group_permissions" */
export enum Auth_Group_Permissions_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id'
}

/** input type for updating data in table "auth_group_permissions" */
export type Auth_Group_Permissions_Set_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Auth_Group_Permissions_Stddev_Fields = {
  __typename?: 'auth_group_permissions_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Auth_Group_Permissions_Stddev_Pop_Fields = {
  __typename?: 'auth_group_permissions_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Auth_Group_Permissions_Stddev_Samp_Fields = {
  __typename?: 'auth_group_permissions_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "auth_group_permissions" */
export type Auth_Group_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Group_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Group_Permissions_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Auth_Group_Permissions_Sum_Fields = {
  __typename?: 'auth_group_permissions_sum_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** update columns of table "auth_group_permissions" */
export enum Auth_Group_Permissions_Update_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id'
}

export type Auth_Group_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Group_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Group_Permissions_Set_Input>;
  where: Auth_Group_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Group_Permissions_Var_Pop_Fields = {
  __typename?: 'auth_group_permissions_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Auth_Group_Permissions_Var_Samp_Fields = {
  __typename?: 'auth_group_permissions_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Auth_Group_Permissions_Variance_Fields = {
  __typename?: 'auth_group_permissions_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth_group */
export type Auth_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "auth_group" */
export enum Auth_Group_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "auth_group" */
export type Auth_Group_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Auth_Group_Stddev_Fields = {
  __typename?: 'auth_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Auth_Group_Stddev_Pop_Fields = {
  __typename?: 'auth_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Auth_Group_Stddev_Samp_Fields = {
  __typename?: 'auth_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "auth_group" */
export type Auth_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Group_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Auth_Group_Sum_Fields = {
  __typename?: 'auth_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "auth_group" */
export enum Auth_Group_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Auth_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Group_Set_Input>;
  where: Auth_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Group_Var_Pop_Fields = {
  __typename?: 'auth_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Auth_Group_Var_Samp_Fields = {
  __typename?: 'auth_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Auth_Group_Variance_Fields = {
  __typename?: 'auth_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "auth_permission" */
export type Auth_Permission = {
  __typename?: 'auth_permission';
  codename: Scalars['String'];
  /** An object relationship */
  content_type: Django_Content_Type;
  content_type_id: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  permitted_base_users: Array<Base_User_User_Permissions>;
  /** An aggregate relationship */
  permitted_base_users_aggregate: Base_User_User_Permissions_Aggregate;
  /** An array relationship */
  permitted_groups: Array<Auth_Group_Permissions>;
  /** An aggregate relationship */
  permitted_groups_aggregate: Auth_Group_Permissions_Aggregate;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionPermitted_Base_UsersArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionPermitted_Base_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionPermitted_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionPermitted_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};

/** aggregated selection of "auth_permission" */
export type Auth_Permission_Aggregate = {
  __typename?: 'auth_permission_aggregate';
  aggregate?: Maybe<Auth_Permission_Aggregate_Fields>;
  nodes: Array<Auth_Permission>;
};

/** aggregate fields of "auth_permission" */
export type Auth_Permission_Aggregate_Fields = {
  __typename?: 'auth_permission_aggregate_fields';
  avg?: Maybe<Auth_Permission_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Auth_Permission_Max_Fields>;
  min?: Maybe<Auth_Permission_Min_Fields>;
  stddev?: Maybe<Auth_Permission_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Permission_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Permission_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Permission_Sum_Fields>;
  var_pop?: Maybe<Auth_Permission_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Permission_Var_Samp_Fields>;
  variance?: Maybe<Auth_Permission_Variance_Fields>;
};


/** aggregate fields of "auth_permission" */
export type Auth_Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Auth_Permission_Avg_Fields = {
  __typename?: 'auth_permission_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "auth_permission". All fields are combined with a logical 'AND'. */
export type Auth_Permission_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Permission_Bool_Exp>>;
  _not?: InputMaybe<Auth_Permission_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Permission_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  permitted_base_users?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
  permitted_groups?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};

/** unique or primary key constraints on table "auth_permission" */
export enum Auth_Permission_Constraint {
  /** unique or primary key constraint on columns "codename", "content_type_id" */
  AuthPermissionContentTypeIdCodename_01ab375aUniq = 'auth_permission_content_type_id_codename_01ab375a_uniq',
  /** unique or primary key constraint on columns "id" */
  AuthPermissionPkey = 'auth_permission_pkey'
}

/** input type for incrementing numeric columns in table "auth_permission" */
export type Auth_Permission_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth_permission" */
export type Auth_Permission_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  permitted_base_users?: InputMaybe<Base_User_User_Permissions_Arr_Rel_Insert_Input>;
  permitted_groups?: InputMaybe<Auth_Group_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Auth_Permission_Max_Fields = {
  __typename?: 'auth_permission_max_fields';
  codename?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Auth_Permission_Min_Fields = {
  __typename?: 'auth_permission_min_fields';
  codename?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth_permission" */
export type Auth_Permission_Mutation_Response = {
  __typename?: 'auth_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Permission>;
};

/** input type for inserting object relation for remote table "auth_permission" */
export type Auth_Permission_Obj_Rel_Insert_Input = {
  data: Auth_Permission_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Permission_On_Conflict>;
};

/** on_conflict condition type for table "auth_permission" */
export type Auth_Permission_On_Conflict = {
  constraint: Auth_Permission_Constraint;
  update_columns?: Array<Auth_Permission_Update_Column>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "auth_permission". */
export type Auth_Permission_Order_By = {
  codename?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Django_Content_Type_Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  permitted_base_users_aggregate?: InputMaybe<Base_User_User_Permissions_Aggregate_Order_By>;
  permitted_groups_aggregate?: InputMaybe<Auth_Group_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: auth_permission */
export type Auth_Permission_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "auth_permission" */
export enum Auth_Permission_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "auth_permission" */
export type Auth_Permission_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Auth_Permission_Stddev_Fields = {
  __typename?: 'auth_permission_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Auth_Permission_Stddev_Pop_Fields = {
  __typename?: 'auth_permission_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Auth_Permission_Stddev_Samp_Fields = {
  __typename?: 'auth_permission_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "auth_permission" */
export type Auth_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Permission_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Auth_Permission_Sum_Fields = {
  __typename?: 'auth_permission_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "auth_permission" */
export enum Auth_Permission_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Auth_Permission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Permission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Permission_Set_Input>;
  where: Auth_Permission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Permission_Var_Pop_Fields = {
  __typename?: 'auth_permission_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Auth_Permission_Var_Samp_Fields = {
  __typename?: 'auth_permission_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Auth_Permission_Variance_Fields = {
  __typename?: 'auth_permission_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "base_user" */
export type Base_User = {
  __typename?: 'base_user';
  /** An array relationship */
  address_book: Array<Base_User_Address_Book>;
  /** An aggregate relationship */
  address_book_aggregate: Base_User_Address_Book_Aggregate;
  /** An array relationship */
  agents: Array<Agent>;
  /** An aggregate relationship */
  agents_aggregate: Agent_Aggregate;
  /** An array relationship */
  companies: Array<Base_User_Companies>;
  /** An aggregate relationship */
  companies_aggregate: Base_User_Companies_Aggregate;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_in?: Maybe<Department>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  current_address?: Maybe<Address>;
  current_address_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  current_department?: Maybe<Department>;
  current_department_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  data_consent?: Maybe<Media>;
  data_consent_id?: Maybe<Scalars['Int']>;
  date_joined: Scalars['timestamptz'];
  date_of_birth: Scalars['date'];
  /** An array relationship */
  departments: Array<Base_User_Departments>;
  /** An aggregate relationship */
  departments_aggregate: Base_User_Departments_Aggregate;
  /** An array relationship */
  devices: Array<Device>;
  /** An aggregate relationship */
  devices_aggregate: Device_Aggregate;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  education: Scalars['String'];
  email: Scalars['String'];
  external_reference_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  farms: Array<Farm>;
  /** An aggregate relationship */
  farms_aggregate: Farm_Aggregate;
  /** An array relationship */
  fields: Array<Field>;
  /** An aggregate relationship */
  fields_aggregate: Field_Aggregate;
  first_name: Scalars['String'];
  /** SQL Full Name of User */
  full_name?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  /** An array relationship */
  groups: Array<Base_User_Groups>;
  /** An aggregate relationship */
  groups_aggregate: Base_User_Groups_Aggregate;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_staff: Scalars['Boolean'];
  is_superuser: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  last_active_on_mobile?: Maybe<Scalars['timestamptz']>;
  last_active_on_web?: Maybe<Scalars['timestamptz']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name: Scalars['String'];
  metadata: Scalars['jsonb'];
  /** An array relationship */
  mutual_group_memberships: Array<Mutual_Group_Membership>;
  /** An aggregate relationship */
  mutual_group_memberships_aggregate: Mutual_Group_Membership_Aggregate;
  /** An array relationship */
  networks: Array<Base_User_Network>;
  /** An aggregate relationship */
  networks_aggregate: Base_User_Network_Aggregate;
  number: Scalars['String'];
  number_country_code: Scalars['String'];
  password: Scalars['String'];
  payment_details?: Maybe<Array<Maybe<PaymentDetailType>>>;
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  plot_crops: Array<Plot_Crop>;
  /** An aggregate relationship */
  plot_crops_aggregate: Plot_Crop_Aggregate;
  /** An array relationship */
  plots: Array<Plot>;
  /** An aggregate relationship */
  plots_aggregate: Plot_Aggregate;
  preferred_language: Scalars['String'];
  /** An object relationship */
  preferred_payment_option?: Maybe<Payment_Detail>;
  preferred_payment_option_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  reference_id: Scalars['String'];
  secondary_number: Scalars['String'];
  secondary_number_country_code: Scalars['String'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  username: Scalars['String'];
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "base_user" */
export type Base_UserAddress_BookArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserAddress_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserAgentsArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserAgents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserDepartments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserDevicesArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserDevices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "base_user" */
export type Base_UserFarmsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserFarms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserFieldsArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserGroupsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "base_user" */
export type Base_UserMutual_Group_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserMutual_Group_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserNetworksArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserPlot_CropsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserPlot_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserPlotsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserPlots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "base_user_address_book" */
export type Base_User_Address_Book = {
  __typename?: 'base_user_address_book';
  /** An object relationship */
  address: Address;
  address_id: Scalars['Int'];
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "base_user_address_book" */
export type Base_User_Address_Book_Aggregate = {
  __typename?: 'base_user_address_book_aggregate';
  aggregate?: Maybe<Base_User_Address_Book_Aggregate_Fields>;
  nodes: Array<Base_User_Address_Book>;
};

/** aggregate fields of "base_user_address_book" */
export type Base_User_Address_Book_Aggregate_Fields = {
  __typename?: 'base_user_address_book_aggregate_fields';
  avg?: Maybe<Base_User_Address_Book_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Address_Book_Max_Fields>;
  min?: Maybe<Base_User_Address_Book_Min_Fields>;
  stddev?: Maybe<Base_User_Address_Book_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Address_Book_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Address_Book_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Address_Book_Sum_Fields>;
  var_pop?: Maybe<Base_User_Address_Book_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Address_Book_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Address_Book_Variance_Fields>;
};


/** aggregate fields of "base_user_address_book" */
export type Base_User_Address_Book_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_address_book" */
export type Base_User_Address_Book_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Address_Book_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Address_Book_Max_Order_By>;
  min?: InputMaybe<Base_User_Address_Book_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Address_Book_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Address_Book_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Address_Book_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Address_Book_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Address_Book_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Address_Book_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Address_Book_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_address_book" */
export type Base_User_Address_Book_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Address_Book_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_Address_Book_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Address_Book_Avg_Fields = {
  __typename?: 'base_user_address_book_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_address_book". All fields are combined with a logical 'AND'. */
export type Base_User_Address_Book_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Address_Book_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Address_Book_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_address_book" */
export enum Base_User_Address_Book_Constraint {
  /** unique or primary key constraint on columns "baseuser_id", "address_id" */
  BaseUserAddressBookBaseuserIdAddressId_6bae516aUniq = 'base_user_address_book_baseuser_id_address_id_6bae516a_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserAddressBookPkey = 'base_user_address_book_pkey'
}

/** input type for incrementing numeric columns in table "base_user_address_book" */
export type Base_User_Address_Book_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_address_book" */
export type Base_User_Address_Book_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_Address_Book_Max_Fields = {
  __typename?: 'base_user_address_book_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Address_Book_Min_Fields = {
  __typename?: 'base_user_address_book_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_address_book" */
export type Base_User_Address_Book_Mutation_Response = {
  __typename?: 'base_user_address_book_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_Address_Book>;
};

/** on_conflict condition type for table "base_user_address_book" */
export type Base_User_Address_Book_On_Conflict = {
  constraint: Base_User_Address_Book_Constraint;
  update_columns?: Array<Base_User_Address_Book_Update_Column>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_address_book". */
export type Base_User_Address_Book_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_address_book */
export type Base_User_Address_Book_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_address_book" */
export enum Base_User_Address_Book_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "base_user_address_book" */
export type Base_User_Address_Book_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_Address_Book_Stddev_Fields = {
  __typename?: 'base_user_address_book_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Address_Book_Stddev_Pop_Fields = {
  __typename?: 'base_user_address_book_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Address_Book_Stddev_Samp_Fields = {
  __typename?: 'base_user_address_book_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_address_book" */
export type Base_User_Address_Book_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Address_Book_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Address_Book_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_Address_Book_Sum_Fields = {
  __typename?: 'base_user_address_book_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_address_book" */
export enum Base_User_Address_Book_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  Id = 'id'
}

export type Base_User_Address_Book_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Address_Book_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Address_Book_Set_Input>;
  where: Base_User_Address_Book_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_Address_Book_Var_Pop_Fields = {
  __typename?: 'base_user_address_book_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Address_Book_Var_Samp_Fields = {
  __typename?: 'base_user_address_book_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Address_Book_Variance_Fields = {
  __typename?: 'base_user_address_book_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregated selection of "base_user" */
export type Base_User_Aggregate = {
  __typename?: 'base_user_aggregate';
  aggregate?: Maybe<Base_User_Aggregate_Fields>;
  nodes: Array<Base_User>;
};

/** aggregate fields of "base_user" */
export type Base_User_Aggregate_Fields = {
  __typename?: 'base_user_aggregate_fields';
  avg?: Maybe<Base_User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Max_Fields>;
  min?: Maybe<Base_User_Min_Fields>;
  stddev?: Maybe<Base_User_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Sum_Fields>;
  var_pop?: Maybe<Base_User_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Variance_Fields>;
};


/** aggregate fields of "base_user" */
export type Base_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user" */
export type Base_User_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Max_Order_By>;
  min?: InputMaybe<Base_User_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Base_User_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "base_user" */
export type Base_User_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Avg_Fields = {
  __typename?: 'base_user_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user" */
export type Base_User_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Active_Ingredientcreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Active_Ingredientcreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Active_Ingredientupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Active_Ingredientupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Article_Author_Favorite_Insightsauthor = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Article_Author_Favorite_Insightsauthor>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Article_Author_Like_Insightsauthor = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Article_Author_Like_Insightsauthor>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Article_Author_View_Insightsauthor = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Article_Author_View_Insightsauthor>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Article_Authorsauthor = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Article_Authorsauthor>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Articlecreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Articlecreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Articleupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Articleupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Commentcreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Commentcreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Commentupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Commentupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Cost_Itemcreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Cost_Itemcreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Cost_Itemupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Cost_Itemupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Fileuploadcreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Fileuploadcreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Fileuploadupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Fileuploadupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Messagesender = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Messagesender>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Monitoring_Categorycreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Categorycreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Monitoring_Categoryupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Categoryupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Monitoring_Parametercreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Parametercreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Monitoring_Parameterupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Parameterupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Monitoring_Recordcreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Recordcreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Monitoring_Recordupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Recordupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Monitoring_Samplecreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Samplecreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Monitoring_Sampleupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Sampleupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Notification_Template_Distribution_Userreceiver = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Notification_Template_Distribution_Userreceiver>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Notificationreceiver = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Notificationreceiver>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Notificationsender = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Notificationsender>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Nutrientscreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Nutrientscreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Nutrientsupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Nutrientsupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Observation_Notificationreceiver = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Observation_Notificationreceiver>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Observation_Notificationsender = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Observation_Notificationsender>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Operationscreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Operationscreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Operationsupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Operationsupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Productscreator = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Productscreator>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Productsupdater = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Productsupdater>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Series_Authorsauthor = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Series_Authorsauthor>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Series_Favoritesuser = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Series_Favoritesuser>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Series_Likesuser = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Series_Likesuser>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Shared_Entityuser = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityuser>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Tradecreated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp_Remote_Rel_Tradecreated_By>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Tradeupdated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp_Remote_Rel_Tradeupdated_By>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "base_user_companies" */
export type Base_User_Companies = {
  __typename?: 'base_user_companies';
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "base_user_companies" */
export type Base_User_Companies_Aggregate = {
  __typename?: 'base_user_companies_aggregate';
  aggregate?: Maybe<Base_User_Companies_Aggregate_Fields>;
  nodes: Array<Base_User_Companies>;
};

/** aggregate fields of "base_user_companies" */
export type Base_User_Companies_Aggregate_Fields = {
  __typename?: 'base_user_companies_aggregate_fields';
  avg?: Maybe<Base_User_Companies_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Companies_Max_Fields>;
  min?: Maybe<Base_User_Companies_Min_Fields>;
  stddev?: Maybe<Base_User_Companies_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Companies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Companies_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Companies_Sum_Fields>;
  var_pop?: Maybe<Base_User_Companies_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Companies_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Companies_Variance_Fields>;
};


/** aggregate fields of "base_user_companies" */
export type Base_User_Companies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_companies" */
export type Base_User_Companies_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Companies_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Companies_Max_Order_By>;
  min?: InputMaybe<Base_User_Companies_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Companies_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Companies_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Companies_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Companies_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Companies_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Companies_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Companies_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_companies" */
export type Base_User_Companies_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Companies_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_Companies_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Companies_Avg_Fields = {
  __typename?: 'base_user_companies_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_companies" */
export type Base_User_Companies_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_companies". All fields are combined with a logical 'AND'. */
export type Base_User_Companies_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Companies_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Companies_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Companies_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_companies" */
export enum Base_User_Companies_Constraint {
  /** unique or primary key constraint on columns "baseuser_id", "company_id" */
  BaseUserCompaniesBaseuserIdCompanyId_69c93b6fUniq = 'base_user_companies_baseuser_id_company_id_69c93b6f_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserCompaniesPkey = 'base_user_companies_pkey'
}

/** input type for incrementing numeric columns in table "base_user_companies" */
export type Base_User_Companies_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_companies" */
export type Base_User_Companies_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_Companies_Max_Fields = {
  __typename?: 'base_user_companies_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_companies" */
export type Base_User_Companies_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Companies_Min_Fields = {
  __typename?: 'base_user_companies_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_companies" */
export type Base_User_Companies_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_companies" */
export type Base_User_Companies_Mutation_Response = {
  __typename?: 'base_user_companies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_Companies>;
};

/** on_conflict condition type for table "base_user_companies" */
export type Base_User_Companies_On_Conflict = {
  constraint: Base_User_Companies_Constraint;
  update_columns?: Array<Base_User_Companies_Update_Column>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_companies". */
export type Base_User_Companies_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_companies */
export type Base_User_Companies_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_companies" */
export enum Base_User_Companies_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "base_user_companies" */
export type Base_User_Companies_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_Companies_Stddev_Fields = {
  __typename?: 'base_user_companies_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_companies" */
export type Base_User_Companies_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Companies_Stddev_Pop_Fields = {
  __typename?: 'base_user_companies_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_companies" */
export type Base_User_Companies_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Companies_Stddev_Samp_Fields = {
  __typename?: 'base_user_companies_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_companies" */
export type Base_User_Companies_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_companies" */
export type Base_User_Companies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Companies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Companies_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_Companies_Sum_Fields = {
  __typename?: 'base_user_companies_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_companies" */
export type Base_User_Companies_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_companies" */
export enum Base_User_Companies_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

export type Base_User_Companies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Companies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Companies_Set_Input>;
  where: Base_User_Companies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_Companies_Var_Pop_Fields = {
  __typename?: 'base_user_companies_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_companies" */
export type Base_User_Companies_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Companies_Var_Samp_Fields = {
  __typename?: 'base_user_companies_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_companies" */
export type Base_User_Companies_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Companies_Variance_Fields = {
  __typename?: 'base_user_companies_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_companies" */
export type Base_User_Companies_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "base_user" */
export enum Base_User_Constraint {
  /** unique or primary key constraint on columns "data_consent_id" */
  BaseUserDataConsentIdKey = 'base_user_data_consent_id_key',
  /** unique or primary key constraint on columns "number" */
  BaseUserNumberKey = 'base_user_number_key',
  /** unique or primary key constraint on columns "id" */
  BaseUserPkey = 'base_user_pkey',
  /** unique or primary key constraint on columns "reference_id" */
  BaseUserReferenceIdKey = 'base_user_reference_id_key',
  /** unique or primary key constraint on columns "username" */
  BaseUserUsernameKey = 'base_user_username_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Base_User_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Base_User_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Base_User_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "base_user_departments" */
export type Base_User_Departments = {
  __typename?: 'base_user_departments';
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  /** An object relationship */
  department: Department;
  department_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "base_user_departments" */
export type Base_User_Departments_Aggregate = {
  __typename?: 'base_user_departments_aggregate';
  aggregate?: Maybe<Base_User_Departments_Aggregate_Fields>;
  nodes: Array<Base_User_Departments>;
};

/** aggregate fields of "base_user_departments" */
export type Base_User_Departments_Aggregate_Fields = {
  __typename?: 'base_user_departments_aggregate_fields';
  avg?: Maybe<Base_User_Departments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Departments_Max_Fields>;
  min?: Maybe<Base_User_Departments_Min_Fields>;
  stddev?: Maybe<Base_User_Departments_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Departments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Departments_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Departments_Sum_Fields>;
  var_pop?: Maybe<Base_User_Departments_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Departments_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Departments_Variance_Fields>;
};


/** aggregate fields of "base_user_departments" */
export type Base_User_Departments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_departments" */
export type Base_User_Departments_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Departments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Departments_Max_Order_By>;
  min?: InputMaybe<Base_User_Departments_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Departments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Departments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Departments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Departments_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Departments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Departments_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Departments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_departments" */
export type Base_User_Departments_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Departments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_Departments_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Departments_Avg_Fields = {
  __typename?: 'base_user_departments_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_departments" */
export type Base_User_Departments_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_departments". All fields are combined with a logical 'AND'. */
export type Base_User_Departments_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Departments_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Departments_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Departments_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  department_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_departments" */
export enum Base_User_Departments_Constraint {
  /** unique or primary key constraint on columns "department_id", "baseuser_id" */
  BaseUserDepartmentsBaseuserIdDepartmentId_5e55738fUniq = 'base_user_departments_baseuser_id_department_id_5e55738f_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserDepartmentsPkey = 'base_user_departments_pkey'
}

/** input type for incrementing numeric columns in table "base_user_departments" */
export type Base_User_Departments_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_departments" */
export type Base_User_Departments_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_Departments_Max_Fields = {
  __typename?: 'base_user_departments_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_departments" */
export type Base_User_Departments_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Departments_Min_Fields = {
  __typename?: 'base_user_departments_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_departments" */
export type Base_User_Departments_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_departments" */
export type Base_User_Departments_Mutation_Response = {
  __typename?: 'base_user_departments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_Departments>;
};

/** on_conflict condition type for table "base_user_departments" */
export type Base_User_Departments_On_Conflict = {
  constraint: Base_User_Departments_Constraint;
  update_columns?: Array<Base_User_Departments_Update_Column>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_departments". */
export type Base_User_Departments_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Department_Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_departments */
export type Base_User_Departments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_departments" */
export enum Base_User_Departments_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "base_user_departments" */
export type Base_User_Departments_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_Departments_Stddev_Fields = {
  __typename?: 'base_user_departments_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_departments" */
export type Base_User_Departments_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Departments_Stddev_Pop_Fields = {
  __typename?: 'base_user_departments_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_departments" */
export type Base_User_Departments_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Departments_Stddev_Samp_Fields = {
  __typename?: 'base_user_departments_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_departments" */
export type Base_User_Departments_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_departments" */
export type Base_User_Departments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Departments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Departments_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_Departments_Sum_Fields = {
  __typename?: 'base_user_departments_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_departments" */
export type Base_User_Departments_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_departments" */
export enum Base_User_Departments_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id'
}

export type Base_User_Departments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Departments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Departments_Set_Input>;
  where: Base_User_Departments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_Departments_Var_Pop_Fields = {
  __typename?: 'base_user_departments_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_departments" */
export type Base_User_Departments_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Departments_Var_Samp_Fields = {
  __typename?: 'base_user_departments_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_departments" */
export type Base_User_Departments_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Departments_Variance_Fields = {
  __typename?: 'base_user_departments_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_departments" */
export type Base_User_Departments_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "base_user_groups" */
export type Base_User_Groups = {
  __typename?: 'base_user_groups';
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  /** An object relationship */
  group: Auth_Group;
  group_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "base_user_groups" */
export type Base_User_Groups_Aggregate = {
  __typename?: 'base_user_groups_aggregate';
  aggregate?: Maybe<Base_User_Groups_Aggregate_Fields>;
  nodes: Array<Base_User_Groups>;
};

/** aggregate fields of "base_user_groups" */
export type Base_User_Groups_Aggregate_Fields = {
  __typename?: 'base_user_groups_aggregate_fields';
  avg?: Maybe<Base_User_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Groups_Max_Fields>;
  min?: Maybe<Base_User_Groups_Min_Fields>;
  stddev?: Maybe<Base_User_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Groups_Sum_Fields>;
  var_pop?: Maybe<Base_User_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Groups_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Groups_Variance_Fields>;
};


/** aggregate fields of "base_user_groups" */
export type Base_User_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_groups" */
export type Base_User_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Groups_Max_Order_By>;
  min?: InputMaybe<Base_User_Groups_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_groups" */
export type Base_User_Groups_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Groups_Avg_Fields = {
  __typename?: 'base_user_groups_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_groups" */
export type Base_User_Groups_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_groups". All fields are combined with a logical 'AND'. */
export type Base_User_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Groups_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Groups_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  group?: InputMaybe<Auth_Group_Bool_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_groups" */
export enum Base_User_Groups_Constraint {
  /** unique or primary key constraint on columns "group_id", "baseuser_id" */
  BaseUserGroupsBaseuserIdGroupId_15e6ae17Uniq = 'base_user_groups_baseuser_id_group_id_15e6ae17_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserGroupsPkey = 'base_user_groups_pkey'
}

/** input type for incrementing numeric columns in table "base_user_groups" */
export type Base_User_Groups_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_groups" */
export type Base_User_Groups_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Auth_Group_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_Groups_Max_Fields = {
  __typename?: 'base_user_groups_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_groups" */
export type Base_User_Groups_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Groups_Min_Fields = {
  __typename?: 'base_user_groups_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_groups" */
export type Base_User_Groups_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_groups" */
export type Base_User_Groups_Mutation_Response = {
  __typename?: 'base_user_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_Groups>;
};

/** on_conflict condition type for table "base_user_groups" */
export type Base_User_Groups_On_Conflict = {
  constraint: Base_User_Groups_Constraint;
  update_columns?: Array<Base_User_Groups_Update_Column>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_groups". */
export type Base_User_Groups_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Auth_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_groups */
export type Base_User_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_groups" */
export enum Base_User_Groups_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "base_user_groups" */
export type Base_User_Groups_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_Groups_Stddev_Fields = {
  __typename?: 'base_user_groups_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_groups" */
export type Base_User_Groups_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Groups_Stddev_Pop_Fields = {
  __typename?: 'base_user_groups_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_groups" */
export type Base_User_Groups_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Groups_Stddev_Samp_Fields = {
  __typename?: 'base_user_groups_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_groups" */
export type Base_User_Groups_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_groups" */
export type Base_User_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Groups_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_Groups_Sum_Fields = {
  __typename?: 'base_user_groups_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_groups" */
export type Base_User_Groups_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_groups" */
export enum Base_User_Groups_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id'
}

export type Base_User_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Groups_Set_Input>;
  where: Base_User_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_Groups_Var_Pop_Fields = {
  __typename?: 'base_user_groups_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_groups" */
export type Base_User_Groups_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Groups_Var_Samp_Fields = {
  __typename?: 'base_user_groups_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_groups" */
export type Base_User_Groups_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Groups_Variance_Fields = {
  __typename?: 'base_user_groups_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_groups" */
export type Base_User_Groups_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "base_user" */
export type Base_User_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  current_address_id?: InputMaybe<Scalars['Int']>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  preferred_payment_option_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user" */
export type Base_User_Insert_Input = {
  address_book?: InputMaybe<Base_User_Address_Book_Arr_Rel_Insert_Input>;
  agents?: InputMaybe<Agent_Arr_Rel_Insert_Input>;
  companies?: InputMaybe<Base_User_Companies_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  current_address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  current_address_id?: InputMaybe<Scalars['Int']>;
  current_department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  data_consent?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  departments?: InputMaybe<Base_User_Departments_Arr_Rel_Insert_Input>;
  devices?: InputMaybe<Device_Arr_Rel_Insert_Input>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  farms?: InputMaybe<Farm_Arr_Rel_Insert_Input>;
  fields?: InputMaybe<Field_Arr_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Base_User_Groups_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  last_active_on_mobile?: InputMaybe<Scalars['timestamptz']>;
  last_active_on_web?: InputMaybe<Scalars['timestamptz']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Arr_Rel_Insert_Input>;
  networks?: InputMaybe<Base_User_Network_Arr_Rel_Insert_Input>;
  number?: InputMaybe<Scalars['String']>;
  number_country_code?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  plot_crops?: InputMaybe<Plot_Crop_Arr_Rel_Insert_Input>;
  plots?: InputMaybe<Plot_Arr_Rel_Insert_Input>;
  preferred_language?: InputMaybe<Scalars['String']>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Obj_Rel_Insert_Input>;
  preferred_payment_option_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  reference_id?: InputMaybe<Scalars['String']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  secondary_number_country_code?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Base_User_Max_Fields = {
  __typename?: 'base_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  current_address_id?: Maybe<Scalars['Int']>;
  current_department_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  date_joined?: Maybe<Scalars['timestamptz']>;
  date_of_birth?: Maybe<Scalars['date']>;
  education?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_active_on_mobile?: Maybe<Scalars['timestamptz']>;
  last_active_on_web?: Maybe<Scalars['timestamptz']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  number_country_code?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  preferred_language?: Maybe<Scalars['String']>;
  preferred_payment_option_id?: Maybe<Scalars['Int']>;
  reference_id?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
  secondary_number_country_code?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "base_user" */
export type Base_User_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  date_joined?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  education?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active_on_mobile?: InputMaybe<Order_By>;
  last_active_on_web?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_country_code?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_language?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  secondary_number_country_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Min_Fields = {
  __typename?: 'base_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  current_address_id?: Maybe<Scalars['Int']>;
  current_department_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  date_joined?: Maybe<Scalars['timestamptz']>;
  date_of_birth?: Maybe<Scalars['date']>;
  education?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_active_on_mobile?: Maybe<Scalars['timestamptz']>;
  last_active_on_web?: Maybe<Scalars['timestamptz']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  number_country_code?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  preferred_language?: Maybe<Scalars['String']>;
  preferred_payment_option_id?: Maybe<Scalars['Int']>;
  reference_id?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
  secondary_number_country_code?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "base_user" */
export type Base_User_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  date_joined?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  education?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active_on_mobile?: InputMaybe<Order_By>;
  last_active_on_web?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_country_code?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_language?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  secondary_number_country_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user" */
export type Base_User_Mutation_Response = {
  __typename?: 'base_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User>;
};

/** columns and relationships of "base_user_network" */
export type Base_User_Network = {
  __typename?: 'base_user_network';
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
};

/** aggregated selection of "base_user_network" */
export type Base_User_Network_Aggregate = {
  __typename?: 'base_user_network_aggregate';
  aggregate?: Maybe<Base_User_Network_Aggregate_Fields>;
  nodes: Array<Base_User_Network>;
};

/** aggregate fields of "base_user_network" */
export type Base_User_Network_Aggregate_Fields = {
  __typename?: 'base_user_network_aggregate_fields';
  avg?: Maybe<Base_User_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Network_Max_Fields>;
  min?: Maybe<Base_User_Network_Min_Fields>;
  stddev?: Maybe<Base_User_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Network_Sum_Fields>;
  var_pop?: Maybe<Base_User_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Network_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Network_Variance_Fields>;
};


/** aggregate fields of "base_user_network" */
export type Base_User_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_network" */
export type Base_User_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Network_Max_Order_By>;
  min?: InputMaybe<Base_User_Network_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_network" */
export type Base_User_Network_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Network_Avg_Fields = {
  __typename?: 'base_user_network_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_network" */
export type Base_User_Network_Avg_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_network". All fields are combined with a logical 'AND'. */
export type Base_User_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Network_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Network_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_network" */
export enum Base_User_Network_Constraint {
  /** unique or primary key constraint on columns "base_user_id", "network_id" */
  BaseUserNetworkNetworkIdBaseUserId_17c4e15eUniq = 'base_user_network_network_id_base_user_id_17c4e15e_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserNetworkPkey = 'base_user_network_pkey'
}

/** input type for incrementing numeric columns in table "base_user_network" */
export type Base_User_Network_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_network" */
export type Base_User_Network_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_Network_Max_Fields = {
  __typename?: 'base_user_network_max_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_network" */
export type Base_User_Network_Max_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Network_Min_Fields = {
  __typename?: 'base_user_network_min_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_network" */
export type Base_User_Network_Min_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_network" */
export type Base_User_Network_Mutation_Response = {
  __typename?: 'base_user_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_Network>;
};

/** on_conflict condition type for table "base_user_network" */
export type Base_User_Network_On_Conflict = {
  constraint: Base_User_Network_Constraint;
  update_columns?: Array<Base_User_Network_Update_Column>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_network". */
export type Base_User_Network_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_network */
export type Base_User_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_network" */
export enum Base_User_Network_Select_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id'
}

/** input type for updating data in table "base_user_network" */
export type Base_User_Network_Set_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_Network_Stddev_Fields = {
  __typename?: 'base_user_network_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_network" */
export type Base_User_Network_Stddev_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Network_Stddev_Pop_Fields = {
  __typename?: 'base_user_network_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_network" */
export type Base_User_Network_Stddev_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Network_Stddev_Samp_Fields = {
  __typename?: 'base_user_network_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_network" */
export type Base_User_Network_Stddev_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_network" */
export type Base_User_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Network_Stream_Cursor_Value_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_Network_Sum_Fields = {
  __typename?: 'base_user_network_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_network" */
export type Base_User_Network_Sum_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_network" */
export enum Base_User_Network_Update_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id'
}

export type Base_User_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Network_Set_Input>;
  where: Base_User_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_Network_Var_Pop_Fields = {
  __typename?: 'base_user_network_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_network" */
export type Base_User_Network_Var_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Network_Var_Samp_Fields = {
  __typename?: 'base_user_network_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_network" */
export type Base_User_Network_Var_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Network_Variance_Fields = {
  __typename?: 'base_user_network_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_network" */
export type Base_User_Network_Variance_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "base_user" */
export type Base_User_Obj_Rel_Insert_Input = {
  data: Base_User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_On_Conflict>;
};

/** on_conflict condition type for table "base_user" */
export type Base_User_On_Conflict = {
  constraint: Base_User_Constraint;
  update_columns?: Array<Base_User_Update_Column>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user". */
export type Base_User_Order_By = {
  address_book_aggregate?: InputMaybe<Base_User_Address_Book_Aggregate_Order_By>;
  agents_aggregate?: InputMaybe<Agent_Aggregate_Order_By>;
  companies_aggregate?: InputMaybe<Base_User_Companies_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in?: InputMaybe<Department_Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address?: InputMaybe<Address_Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department?: InputMaybe<Department_Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent?: InputMaybe<Media_Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  date_joined?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  departments_aggregate?: InputMaybe<Base_User_Departments_Aggregate_Order_By>;
  devices_aggregate?: InputMaybe<Device_Aggregate_Order_By>;
  education?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  farms_aggregate?: InputMaybe<Farm_Aggregate_Order_By>;
  fields_aggregate?: InputMaybe<Field_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  groups_aggregate?: InputMaybe<Base_User_Groups_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_staff?: InputMaybe<Order_By>;
  is_superuser?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  last_active_on_mobile?: InputMaybe<Order_By>;
  last_active_on_web?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mutual_group_memberships_aggregate?: InputMaybe<Mutual_Group_Membership_Aggregate_Order_By>;
  networks_aggregate?: InputMaybe<Base_User_Network_Aggregate_Order_By>;
  number?: InputMaybe<Order_By>;
  number_country_code?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  plot_crops_aggregate?: InputMaybe<Plot_Crop_Aggregate_Order_By>;
  plots_aggregate?: InputMaybe<Plot_Aggregate_Order_By>;
  preferred_language?: InputMaybe<Order_By>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  secondary_number_country_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user */
export type Base_User_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Base_User_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "base_user" */
export enum Base_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CurrentAddressId = 'current_address_id',
  /** column name */
  CurrentDepartmentId = 'current_department_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Education = 'education',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsStaff = 'is_staff',
  /** column name */
  IsSuperuser = 'is_superuser',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LastActiveOnMobile = 'last_active_on_mobile',
  /** column name */
  LastActiveOnWeb = 'last_active_on_web',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Number = 'number',
  /** column name */
  NumberCountryCode = 'number_country_code',
  /** column name */
  Password = 'password',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PreferredLanguage = 'preferred_language',
  /** column name */
  PreferredPaymentOptionId = 'preferred_payment_option_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  SecondaryNumberCountryCode = 'secondary_number_country_code',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "base_user" */
export type Base_User_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  current_address_id?: InputMaybe<Scalars['Int']>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  last_active_on_mobile?: InputMaybe<Scalars['timestamptz']>;
  last_active_on_web?: InputMaybe<Scalars['timestamptz']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  number?: InputMaybe<Scalars['String']>;
  number_country_code?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  preferred_language?: InputMaybe<Scalars['String']>;
  preferred_payment_option_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  reference_id?: InputMaybe<Scalars['String']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  secondary_number_country_code?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Base_User_Stddev_Fields = {
  __typename?: 'base_user_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user" */
export type Base_User_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Stddev_Pop_Fields = {
  __typename?: 'base_user_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user" */
export type Base_User_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Stddev_Samp_Fields = {
  __typename?: 'base_user_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user" */
export type Base_User_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user" */
export type Base_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  current_address_id?: InputMaybe<Scalars['Int']>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  last_active_on_mobile?: InputMaybe<Scalars['timestamptz']>;
  last_active_on_web?: InputMaybe<Scalars['timestamptz']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  number?: InputMaybe<Scalars['String']>;
  number_country_code?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  preferred_language?: InputMaybe<Scalars['String']>;
  preferred_payment_option_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  reference_id?: InputMaybe<Scalars['String']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  secondary_number_country_code?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Base_User_Sum_Fields = {
  __typename?: 'base_user_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  current_address_id?: Maybe<Scalars['Int']>;
  current_department_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  preferred_payment_option_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user" */
export type Base_User_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user" */
export enum Base_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CurrentAddressId = 'current_address_id',
  /** column name */
  CurrentDepartmentId = 'current_department_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Education = 'education',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsStaff = 'is_staff',
  /** column name */
  IsSuperuser = 'is_superuser',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LastActiveOnMobile = 'last_active_on_mobile',
  /** column name */
  LastActiveOnWeb = 'last_active_on_web',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Number = 'number',
  /** column name */
  NumberCountryCode = 'number_country_code',
  /** column name */
  Password = 'password',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PreferredLanguage = 'preferred_language',
  /** column name */
  PreferredPaymentOptionId = 'preferred_payment_option_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  SecondaryNumberCountryCode = 'secondary_number_country_code',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Base_User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Base_User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Base_User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Base_User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Base_User_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Base_User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Set_Input>;
  where: Base_User_Bool_Exp;
};

/** columns and relationships of "base_user_user_permissions" */
export type Base_User_User_Permissions = {
  __typename?: 'base_user_user_permissions';
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  permission: Auth_Permission;
  permission_id: Scalars['Int'];
};

/** aggregated selection of "base_user_user_permissions" */
export type Base_User_User_Permissions_Aggregate = {
  __typename?: 'base_user_user_permissions_aggregate';
  aggregate?: Maybe<Base_User_User_Permissions_Aggregate_Fields>;
  nodes: Array<Base_User_User_Permissions>;
};

/** aggregate fields of "base_user_user_permissions" */
export type Base_User_User_Permissions_Aggregate_Fields = {
  __typename?: 'base_user_user_permissions_aggregate_fields';
  avg?: Maybe<Base_User_User_Permissions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_User_Permissions_Max_Fields>;
  min?: Maybe<Base_User_User_Permissions_Min_Fields>;
  stddev?: Maybe<Base_User_User_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_User_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_User_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_User_Permissions_Sum_Fields>;
  var_pop?: Maybe<Base_User_User_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_User_Permissions_Var_Samp_Fields>;
  variance?: Maybe<Base_User_User_Permissions_Variance_Fields>;
};


/** aggregate fields of "base_user_user_permissions" */
export type Base_User_User_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_User_Permissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_User_Permissions_Max_Order_By>;
  min?: InputMaybe<Base_User_User_Permissions_Min_Order_By>;
  stddev?: InputMaybe<Base_User_User_Permissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_User_Permissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_User_Permissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_User_Permissions_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_User_Permissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_User_Permissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_User_Permissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_user_permissions" */
export type Base_User_User_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Base_User_User_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_User_Permissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_User_Permissions_Avg_Fields = {
  __typename?: 'base_user_user_permissions_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_user_permissions". All fields are combined with a logical 'AND'. */
export type Base_User_User_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_User_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_User_Permissions_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  permission?: InputMaybe<Auth_Permission_Bool_Exp>;
  permission_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_user_permissions" */
export enum Base_User_User_Permissions_Constraint {
  /** unique or primary key constraint on columns "baseuser_id", "permission_id" */
  BaseUserUserPermissioBaseuserIdPermissionI_41dea9a5Uniq = 'base_user_user_permissio_baseuser_id_permission_i_41dea9a5_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserUserPermissionsPkey = 'base_user_user_permissions_pkey'
}

/** input type for incrementing numeric columns in table "base_user_user_permissions" */
export type Base_User_User_Permissions_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_user_permissions" */
export type Base_User_User_Permissions_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission?: InputMaybe<Auth_Permission_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_User_Permissions_Max_Fields = {
  __typename?: 'base_user_user_permissions_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_User_Permissions_Min_Fields = {
  __typename?: 'base_user_user_permissions_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_user_permissions" */
export type Base_User_User_Permissions_Mutation_Response = {
  __typename?: 'base_user_user_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_User_Permissions>;
};

/** on_conflict condition type for table "base_user_user_permissions" */
export type Base_User_User_Permissions_On_Conflict = {
  constraint: Base_User_User_Permissions_Constraint;
  update_columns?: Array<Base_User_User_Permissions_Update_Column>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_user_permissions". */
export type Base_User_User_Permissions_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Auth_Permission_Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_user_permissions */
export type Base_User_User_Permissions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_user_permissions" */
export enum Base_User_User_Permissions_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id'
}

/** input type for updating data in table "base_user_user_permissions" */
export type Base_User_User_Permissions_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_User_Permissions_Stddev_Fields = {
  __typename?: 'base_user_user_permissions_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_User_Permissions_Stddev_Pop_Fields = {
  __typename?: 'base_user_user_permissions_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_User_Permissions_Stddev_Samp_Fields = {
  __typename?: 'base_user_user_permissions_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_user_permissions" */
export type Base_User_User_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_User_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_User_Permissions_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_User_Permissions_Sum_Fields = {
  __typename?: 'base_user_user_permissions_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_user_permissions" */
export enum Base_User_User_Permissions_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id'
}

export type Base_User_User_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_User_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_User_Permissions_Set_Input>;
  where: Base_User_User_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_User_Permissions_Var_Pop_Fields = {
  __typename?: 'base_user_user_permissions_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_User_Permissions_Var_Samp_Fields = {
  __typename?: 'base_user_user_permissions_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_User_Permissions_Variance_Fields = {
  __typename?: 'base_user_user_permissions_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Base_User_Var_Pop_Fields = {
  __typename?: 'base_user_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user" */
export type Base_User_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Var_Samp_Fields = {
  __typename?: 'base_user_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user" */
export type Base_User_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Variance_Fields = {
  __typename?: 'base_user_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user" */
export type Base_User_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "business" */
export type Business = {
  __typename?: 'business';
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  alternate_email: Scalars['String'];
  codename: Scalars['String'];
  /** An array relationship */
  commodities_supplied: Array<Business_Commodities_Supplied>;
  /** An aggregate relationship */
  commodities_supplied_aggregate: Business_Commodities_Supplied_Aggregate;
  /** An array relationship */
  companies: Array<Business_Companies>;
  /** An aggregate relationship */
  companies_aggregate: Business_Companies_Aggregate;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  data_consent?: Maybe<Media>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  email: Scalars['String'];
  /** An array relationship */
  groups: Array<Business_Groups>;
  /** An aggregate relationship */
  groups_aggregate: Business_Groups_Aggregate;
  id: Scalars['Int'];
  incorporated_on?: Maybe<Scalars['date']>;
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  kind: Scalars['String'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Business_Network>;
  /** An aggregate relationship */
  networks_aggregate: Business_Network_Aggregate;
  number: Scalars['String'];
  payment_details?: Maybe<Array<Maybe<PaymentDetailType>>>;
  /** An object relationship */
  primary_poc?: Maybe<Base_User>;
  primary_poc_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  secondary_number: Scalars['String'];
  /** An array relationship */
  secondary_pocs: Array<Business_Secondary_Pocs>;
  /** An aggregate relationship */
  secondary_pocs_aggregate: Business_Secondary_Pocs_Aggregate;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "business" */
export type BusinessCommodities_SuppliedArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessCommodities_Supplied_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "business" */
export type BusinessGroupsArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "business" */
export type BusinessNetworksArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "business" */
export type BusinessSecondary_PocsArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessSecondary_Pocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};

/** aggregated selection of "business" */
export type Business_Aggregate = {
  __typename?: 'business_aggregate';
  aggregate?: Maybe<Business_Aggregate_Fields>;
  nodes: Array<Business>;
};

/** aggregate fields of "business" */
export type Business_Aggregate_Fields = {
  __typename?: 'business_aggregate_fields';
  avg?: Maybe<Business_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Max_Fields>;
  min?: Maybe<Business_Min_Fields>;
  stddev?: Maybe<Business_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Sum_Fields>;
  var_pop?: Maybe<Business_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Var_Samp_Fields>;
  variance?: Maybe<Business_Variance_Fields>;
};


/** aggregate fields of "business" */
export type Business_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Business_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Business_Avg_Fields = {
  __typename?: 'business_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "business". All fields are combined with a logical 'AND'. */
export type Business_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Bool_Exp>>;
  _not?: InputMaybe<Business_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  alternate_email?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  commodities_supplied?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
  companies?: InputMaybe<Business_Companies_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Business_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incorporated_on?: InputMaybe<Date_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Business_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  primary_poc?: InputMaybe<Base_User_Bool_Exp>;
  primary_poc_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_pocs?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "business_commodities_supplied" */
export type Business_Commodities_Supplied = {
  __typename?: 'business_commodities_supplied';
  /** An object relationship */
  business: Business;
  business_id: Scalars['Int'];
  /** An object relationship */
  commodity: Commodity;
  commodity_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "business_commodities_supplied" */
export type Business_Commodities_Supplied_Aggregate = {
  __typename?: 'business_commodities_supplied_aggregate';
  aggregate?: Maybe<Business_Commodities_Supplied_Aggregate_Fields>;
  nodes: Array<Business_Commodities_Supplied>;
};

/** aggregate fields of "business_commodities_supplied" */
export type Business_Commodities_Supplied_Aggregate_Fields = {
  __typename?: 'business_commodities_supplied_aggregate_fields';
  avg?: Maybe<Business_Commodities_Supplied_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Commodities_Supplied_Max_Fields>;
  min?: Maybe<Business_Commodities_Supplied_Min_Fields>;
  stddev?: Maybe<Business_Commodities_Supplied_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Commodities_Supplied_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Commodities_Supplied_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Commodities_Supplied_Sum_Fields>;
  var_pop?: Maybe<Business_Commodities_Supplied_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Commodities_Supplied_Var_Samp_Fields>;
  variance?: Maybe<Business_Commodities_Supplied_Variance_Fields>;
};


/** aggregate fields of "business_commodities_supplied" */
export type Business_Commodities_Supplied_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Commodities_Supplied_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Commodities_Supplied_Max_Order_By>;
  min?: InputMaybe<Business_Commodities_Supplied_Min_Order_By>;
  stddev?: InputMaybe<Business_Commodities_Supplied_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Commodities_Supplied_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Commodities_Supplied_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Commodities_Supplied_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Commodities_Supplied_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Commodities_Supplied_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Commodities_Supplied_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Arr_Rel_Insert_Input = {
  data: Array<Business_Commodities_Supplied_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Commodities_Supplied_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Commodities_Supplied_Avg_Fields = {
  __typename?: 'business_commodities_supplied_avg_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Avg_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_commodities_supplied". All fields are combined with a logical 'AND'. */
export type Business_Commodities_Supplied_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Commodities_Supplied_Bool_Exp>>;
  _not?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Commodities_Supplied_Bool_Exp>>;
  business?: InputMaybe<Business_Bool_Exp>;
  business_id?: InputMaybe<Int_Comparison_Exp>;
  commodity?: InputMaybe<Commodity_Bool_Exp>;
  commodity_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_commodities_supplied" */
export enum Business_Commodities_Supplied_Constraint {
  /** unique or primary key constraint on columns "business_id", "commodity_id" */
  BusinessCommoditiesSupBusinessIdCommodityId_0723bd2cUniq = 'business_commodities_sup_business_id_commodity_id_0723bd2c_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessCommoditiesSuppliedPkey = 'business_commodities_supplied_pkey'
}

/** input type for incrementing numeric columns in table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Inc_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Insert_Input = {
  business?: InputMaybe<Business_Obj_Rel_Insert_Input>;
  business_id?: InputMaybe<Scalars['Int']>;
  commodity?: InputMaybe<Commodity_Obj_Rel_Insert_Input>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Commodities_Supplied_Max_Fields = {
  __typename?: 'business_commodities_supplied_max_fields';
  business_id?: Maybe<Scalars['Int']>;
  commodity_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Max_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Commodities_Supplied_Min_Fields = {
  __typename?: 'business_commodities_supplied_min_fields';
  business_id?: Maybe<Scalars['Int']>;
  commodity_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Min_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Mutation_Response = {
  __typename?: 'business_commodities_supplied_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Commodities_Supplied>;
};

/** on_conflict condition type for table "business_commodities_supplied" */
export type Business_Commodities_Supplied_On_Conflict = {
  constraint: Business_Commodities_Supplied_Constraint;
  update_columns?: Array<Business_Commodities_Supplied_Update_Column>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};

/** Ordering options when selecting data from "business_commodities_supplied". */
export type Business_Commodities_Supplied_Order_By = {
  business?: InputMaybe<Business_Order_By>;
  business_id?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Commodity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_commodities_supplied */
export type Business_Commodities_Supplied_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_commodities_supplied" */
export enum Business_Commodities_Supplied_Select_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Set_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Commodities_Supplied_Stddev_Fields = {
  __typename?: 'business_commodities_supplied_stddev_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Stddev_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Commodities_Supplied_Stddev_Pop_Fields = {
  __typename?: 'business_commodities_supplied_stddev_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Stddev_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Commodities_Supplied_Stddev_Samp_Fields = {
  __typename?: 'business_commodities_supplied_stddev_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Stddev_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Commodities_Supplied_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Commodities_Supplied_Stream_Cursor_Value_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Commodities_Supplied_Sum_Fields = {
  __typename?: 'business_commodities_supplied_sum_fields';
  business_id?: Maybe<Scalars['Int']>;
  commodity_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Sum_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "business_commodities_supplied" */
export enum Business_Commodities_Supplied_Update_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  Id = 'id'
}

export type Business_Commodities_Supplied_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Commodities_Supplied_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Commodities_Supplied_Set_Input>;
  where: Business_Commodities_Supplied_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Commodities_Supplied_Var_Pop_Fields = {
  __typename?: 'business_commodities_supplied_var_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Var_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Commodities_Supplied_Var_Samp_Fields = {
  __typename?: 'business_commodities_supplied_var_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Var_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Commodities_Supplied_Variance_Fields = {
  __typename?: 'business_commodities_supplied_variance_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Variance_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "business_companies" */
export type Business_Companies = {
  __typename?: 'business_companies';
  /** An object relationship */
  business: Business;
  business_id: Scalars['Int'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "business_companies" */
export type Business_Companies_Aggregate = {
  __typename?: 'business_companies_aggregate';
  aggregate?: Maybe<Business_Companies_Aggregate_Fields>;
  nodes: Array<Business_Companies>;
};

/** aggregate fields of "business_companies" */
export type Business_Companies_Aggregate_Fields = {
  __typename?: 'business_companies_aggregate_fields';
  avg?: Maybe<Business_Companies_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Companies_Max_Fields>;
  min?: Maybe<Business_Companies_Min_Fields>;
  stddev?: Maybe<Business_Companies_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Companies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Companies_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Companies_Sum_Fields>;
  var_pop?: Maybe<Business_Companies_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Companies_Var_Samp_Fields>;
  variance?: Maybe<Business_Companies_Variance_Fields>;
};


/** aggregate fields of "business_companies" */
export type Business_Companies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Companies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_companies" */
export type Business_Companies_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Companies_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Companies_Max_Order_By>;
  min?: InputMaybe<Business_Companies_Min_Order_By>;
  stddev?: InputMaybe<Business_Companies_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Companies_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Companies_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Companies_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Companies_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Companies_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Companies_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_companies" */
export type Business_Companies_Arr_Rel_Insert_Input = {
  data: Array<Business_Companies_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Companies_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Companies_Avg_Fields = {
  __typename?: 'business_companies_avg_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_companies" */
export type Business_Companies_Avg_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_companies". All fields are combined with a logical 'AND'. */
export type Business_Companies_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Companies_Bool_Exp>>;
  _not?: InputMaybe<Business_Companies_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Companies_Bool_Exp>>;
  business?: InputMaybe<Business_Bool_Exp>;
  business_id?: InputMaybe<Int_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_companies" */
export enum Business_Companies_Constraint {
  /** unique or primary key constraint on columns "business_id", "company_id" */
  BusinessCompaniesBusinessIdCompanyId_67e79b00Uniq = 'business_companies_business_id_company_id_67e79b00_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessCompaniesPkey = 'business_companies_pkey'
}

/** input type for incrementing numeric columns in table "business_companies" */
export type Business_Companies_Inc_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_companies" */
export type Business_Companies_Insert_Input = {
  business?: InputMaybe<Business_Obj_Rel_Insert_Input>;
  business_id?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Companies_Max_Fields = {
  __typename?: 'business_companies_max_fields';
  business_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_companies" */
export type Business_Companies_Max_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Companies_Min_Fields = {
  __typename?: 'business_companies_min_fields';
  business_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_companies" */
export type Business_Companies_Min_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_companies" */
export type Business_Companies_Mutation_Response = {
  __typename?: 'business_companies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Companies>;
};

/** on_conflict condition type for table "business_companies" */
export type Business_Companies_On_Conflict = {
  constraint: Business_Companies_Constraint;
  update_columns?: Array<Business_Companies_Update_Column>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};

/** Ordering options when selecting data from "business_companies". */
export type Business_Companies_Order_By = {
  business?: InputMaybe<Business_Order_By>;
  business_id?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_companies */
export type Business_Companies_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_companies" */
export enum Business_Companies_Select_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "business_companies" */
export type Business_Companies_Set_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Companies_Stddev_Fields = {
  __typename?: 'business_companies_stddev_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_companies" */
export type Business_Companies_Stddev_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Companies_Stddev_Pop_Fields = {
  __typename?: 'business_companies_stddev_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_companies" */
export type Business_Companies_Stddev_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Companies_Stddev_Samp_Fields = {
  __typename?: 'business_companies_stddev_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_companies" */
export type Business_Companies_Stddev_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_companies" */
export type Business_Companies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Companies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Companies_Stream_Cursor_Value_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Companies_Sum_Fields = {
  __typename?: 'business_companies_sum_fields';
  business_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_companies" */
export type Business_Companies_Sum_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "business_companies" */
export enum Business_Companies_Update_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

export type Business_Companies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Companies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Companies_Set_Input>;
  where: Business_Companies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Companies_Var_Pop_Fields = {
  __typename?: 'business_companies_var_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_companies" */
export type Business_Companies_Var_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Companies_Var_Samp_Fields = {
  __typename?: 'business_companies_var_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_companies" */
export type Business_Companies_Var_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Companies_Variance_Fields = {
  __typename?: 'business_companies_variance_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_companies" */
export type Business_Companies_Variance_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "business" */
export enum Business_Constraint {
  /** unique or primary key constraint on columns "codename" */
  BusinessCodenameKey = 'business_codename_key',
  /** unique or primary key constraint on columns "data_consent_id" */
  BusinessDataConsentIdKey = 'business_data_consent_id_key',
  /** unique or primary key constraint on columns "id" */
  BusinessPkey = 'business_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Business_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Business_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Business_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "business_group" */
export type Business_Group = {
  __typename?: 'business_group';
  /** An array relationship */
  businesses: Array<Business_Groups>;
  /** An aggregate relationship */
  businesses_aggregate: Business_Groups_Aggregate;
  codename: Scalars['String'];
  description: Scalars['String'];
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Business_Group_Network>;
  /** An aggregate relationship */
  networks_aggregate: Business_Group_Network_Aggregate;
  /** An object relationship */
  parent_business?: Maybe<Business>;
  parent_business_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "business_group" */
export type Business_GroupBusinessesArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


/** columns and relationships of "business_group" */
export type Business_GroupBusinesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


/** columns and relationships of "business_group" */
export type Business_GroupDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "business_group" */
export type Business_GroupNetworksArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


/** columns and relationships of "business_group" */
export type Business_GroupNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};

/** aggregated selection of "business_group" */
export type Business_Group_Aggregate = {
  __typename?: 'business_group_aggregate';
  aggregate?: Maybe<Business_Group_Aggregate_Fields>;
  nodes: Array<Business_Group>;
};

/** aggregate fields of "business_group" */
export type Business_Group_Aggregate_Fields = {
  __typename?: 'business_group_aggregate_fields';
  avg?: Maybe<Business_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Group_Max_Fields>;
  min?: Maybe<Business_Group_Min_Fields>;
  stddev?: Maybe<Business_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Group_Sum_Fields>;
  var_pop?: Maybe<Business_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Group_Var_Samp_Fields>;
  variance?: Maybe<Business_Group_Variance_Fields>;
};


/** aggregate fields of "business_group" */
export type Business_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Business_Group_Avg_Fields = {
  __typename?: 'business_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "business_group". All fields are combined with a logical 'AND'. */
export type Business_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Group_Bool_Exp>>;
  _not?: InputMaybe<Business_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Group_Bool_Exp>>;
  businesses?: InputMaybe<Business_Groups_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Business_Group_Network_Bool_Exp>;
  parent_business?: InputMaybe<Business_Bool_Exp>;
  parent_business_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_group" */
export enum Business_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  BusinessGroupCodenameKey = 'business_group_codename_key',
  /** unique or primary key constraint on columns "id" */
  BusinessGroupPkey = 'business_group_pkey'
}

/** input type for incrementing numeric columns in table "business_group" */
export type Business_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  parent_business_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_group" */
export type Business_Group_Insert_Input = {
  businesses?: InputMaybe<Business_Groups_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Business_Group_Network_Arr_Rel_Insert_Input>;
  parent_business?: InputMaybe<Business_Obj_Rel_Insert_Input>;
  parent_business_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Group_Max_Fields = {
  __typename?: 'business_group_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_business_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Business_Group_Min_Fields = {
  __typename?: 'business_group_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_business_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "business_group" */
export type Business_Group_Mutation_Response = {
  __typename?: 'business_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Group>;
};

/** columns and relationships of "business_group_network" */
export type Business_Group_Network = {
  __typename?: 'business_group_network';
  business_group_id: Scalars['Int'];
  id: Scalars['Int'];
  network_id: Scalars['Int'];
};

/** aggregated selection of "business_group_network" */
export type Business_Group_Network_Aggregate = {
  __typename?: 'business_group_network_aggregate';
  aggregate?: Maybe<Business_Group_Network_Aggregate_Fields>;
  nodes: Array<Business_Group_Network>;
};

/** aggregate fields of "business_group_network" */
export type Business_Group_Network_Aggregate_Fields = {
  __typename?: 'business_group_network_aggregate_fields';
  avg?: Maybe<Business_Group_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Group_Network_Max_Fields>;
  min?: Maybe<Business_Group_Network_Min_Fields>;
  stddev?: Maybe<Business_Group_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Group_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Group_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Group_Network_Sum_Fields>;
  var_pop?: Maybe<Business_Group_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Group_Network_Var_Samp_Fields>;
  variance?: Maybe<Business_Group_Network_Variance_Fields>;
};


/** aggregate fields of "business_group_network" */
export type Business_Group_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_group_network" */
export type Business_Group_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Group_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Group_Network_Max_Order_By>;
  min?: InputMaybe<Business_Group_Network_Min_Order_By>;
  stddev?: InputMaybe<Business_Group_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Group_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Group_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Group_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Group_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Group_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Group_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_group_network" */
export type Business_Group_Network_Arr_Rel_Insert_Input = {
  data: Array<Business_Group_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Group_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Group_Network_Avg_Fields = {
  __typename?: 'business_group_network_avg_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_group_network" */
export type Business_Group_Network_Avg_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_group_network". All fields are combined with a logical 'AND'. */
export type Business_Group_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Group_Network_Bool_Exp>>;
  _not?: InputMaybe<Business_Group_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Group_Network_Bool_Exp>>;
  business_group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_group_network" */
export enum Business_Group_Network_Constraint {
  /** unique or primary key constraint on columns "business_group_id", "network_id" */
  BusinessGroupNetworkNetworkIdBusinessGrouD4e88bbbUniq = 'business_group_network_network_id_business_grou_d4e88bbb_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessGroupNetworkPkey = 'business_group_network_pkey'
}

/** input type for incrementing numeric columns in table "business_group_network" */
export type Business_Group_Network_Inc_Input = {
  business_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_group_network" */
export type Business_Group_Network_Insert_Input = {
  business_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Group_Network_Max_Fields = {
  __typename?: 'business_group_network_max_fields';
  business_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_group_network" */
export type Business_Group_Network_Max_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Group_Network_Min_Fields = {
  __typename?: 'business_group_network_min_fields';
  business_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_group_network" */
export type Business_Group_Network_Min_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_group_network" */
export type Business_Group_Network_Mutation_Response = {
  __typename?: 'business_group_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Group_Network>;
};

/** on_conflict condition type for table "business_group_network" */
export type Business_Group_Network_On_Conflict = {
  constraint: Business_Group_Network_Constraint;
  update_columns?: Array<Business_Group_Network_Update_Column>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "business_group_network". */
export type Business_Group_Network_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_group_network */
export type Business_Group_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_group_network" */
export enum Business_Group_Network_Select_Column {
  /** column name */
  BusinessGroupId = 'business_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id'
}

/** input type for updating data in table "business_group_network" */
export type Business_Group_Network_Set_Input = {
  business_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Group_Network_Stddev_Fields = {
  __typename?: 'business_group_network_stddev_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_group_network" */
export type Business_Group_Network_Stddev_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Group_Network_Stddev_Pop_Fields = {
  __typename?: 'business_group_network_stddev_pop_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_group_network" */
export type Business_Group_Network_Stddev_Pop_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Group_Network_Stddev_Samp_Fields = {
  __typename?: 'business_group_network_stddev_samp_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_group_network" */
export type Business_Group_Network_Stddev_Samp_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_group_network" */
export type Business_Group_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Group_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Group_Network_Stream_Cursor_Value_Input = {
  business_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Group_Network_Sum_Fields = {
  __typename?: 'business_group_network_sum_fields';
  business_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_group_network" */
export type Business_Group_Network_Sum_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "business_group_network" */
export enum Business_Group_Network_Update_Column {
  /** column name */
  BusinessGroupId = 'business_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id'
}

export type Business_Group_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Group_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Group_Network_Set_Input>;
  where: Business_Group_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Group_Network_Var_Pop_Fields = {
  __typename?: 'business_group_network_var_pop_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_group_network" */
export type Business_Group_Network_Var_Pop_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Group_Network_Var_Samp_Fields = {
  __typename?: 'business_group_network_var_samp_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_group_network" */
export type Business_Group_Network_Var_Samp_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Group_Network_Variance_Fields = {
  __typename?: 'business_group_network_variance_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_group_network" */
export type Business_Group_Network_Variance_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "business_group" */
export type Business_Group_Obj_Rel_Insert_Input = {
  data: Business_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Group_On_Conflict>;
};

/** on_conflict condition type for table "business_group" */
export type Business_Group_On_Conflict = {
  constraint: Business_Group_Constraint;
  update_columns?: Array<Business_Group_Update_Column>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "business_group". */
export type Business_Group_Order_By = {
  businesses_aggregate?: InputMaybe<Business_Groups_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Business_Group_Network_Aggregate_Order_By>;
  parent_business?: InputMaybe<Business_Order_By>;
  parent_business_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_group */
export type Business_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_group" */
export enum Business_Group_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ParentBusinessId = 'parent_business_id'
}

/** input type for updating data in table "business_group" */
export type Business_Group_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_business_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Group_Stddev_Fields = {
  __typename?: 'business_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Business_Group_Stddev_Pop_Fields = {
  __typename?: 'business_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Business_Group_Stddev_Samp_Fields = {
  __typename?: 'business_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "business_group" */
export type Business_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Group_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_business_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Group_Sum_Fields = {
  __typename?: 'business_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
  parent_business_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "business_group" */
export enum Business_Group_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ParentBusinessId = 'parent_business_id'
}

export type Business_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Group_Set_Input>;
  where: Business_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Group_Var_Pop_Fields = {
  __typename?: 'business_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Business_Group_Var_Samp_Fields = {
  __typename?: 'business_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Business_Group_Variance_Fields = {
  __typename?: 'business_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "business_groups" */
export type Business_Groups = {
  __typename?: 'business_groups';
  /** An object relationship */
  business: Business;
  /** An object relationship */
  business_group: Business_Group;
  business_id: Scalars['Int'];
  businessgroup_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "business_groups" */
export type Business_Groups_Aggregate = {
  __typename?: 'business_groups_aggregate';
  aggregate?: Maybe<Business_Groups_Aggregate_Fields>;
  nodes: Array<Business_Groups>;
};

/** aggregate fields of "business_groups" */
export type Business_Groups_Aggregate_Fields = {
  __typename?: 'business_groups_aggregate_fields';
  avg?: Maybe<Business_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Groups_Max_Fields>;
  min?: Maybe<Business_Groups_Min_Fields>;
  stddev?: Maybe<Business_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Groups_Sum_Fields>;
  var_pop?: Maybe<Business_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Groups_Var_Samp_Fields>;
  variance?: Maybe<Business_Groups_Variance_Fields>;
};


/** aggregate fields of "business_groups" */
export type Business_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_groups" */
export type Business_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Groups_Max_Order_By>;
  min?: InputMaybe<Business_Groups_Min_Order_By>;
  stddev?: InputMaybe<Business_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_groups" */
export type Business_Groups_Arr_Rel_Insert_Input = {
  data: Array<Business_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Groups_Avg_Fields = {
  __typename?: 'business_groups_avg_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_groups" */
export type Business_Groups_Avg_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_groups". All fields are combined with a logical 'AND'. */
export type Business_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Groups_Bool_Exp>>;
  _not?: InputMaybe<Business_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Groups_Bool_Exp>>;
  business?: InputMaybe<Business_Bool_Exp>;
  business_group?: InputMaybe<Business_Group_Bool_Exp>;
  business_id?: InputMaybe<Int_Comparison_Exp>;
  businessgroup_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_groups" */
export enum Business_Groups_Constraint {
  /** unique or primary key constraint on columns "business_id", "businessgroup_id" */
  BusinessGroupsBusinessIdBusinessgroupIdC612bb8cUniq = 'business_groups_business_id_businessgroup_id_c612bb8c_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessGroupsPkey = 'business_groups_pkey'
}

/** input type for incrementing numeric columns in table "business_groups" */
export type Business_Groups_Inc_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  businessgroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_groups" */
export type Business_Groups_Insert_Input = {
  business?: InputMaybe<Business_Obj_Rel_Insert_Input>;
  business_group?: InputMaybe<Business_Group_Obj_Rel_Insert_Input>;
  business_id?: InputMaybe<Scalars['Int']>;
  businessgroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Groups_Max_Fields = {
  __typename?: 'business_groups_max_fields';
  business_id?: Maybe<Scalars['Int']>;
  businessgroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_groups" */
export type Business_Groups_Max_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Groups_Min_Fields = {
  __typename?: 'business_groups_min_fields';
  business_id?: Maybe<Scalars['Int']>;
  businessgroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_groups" */
export type Business_Groups_Min_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_groups" */
export type Business_Groups_Mutation_Response = {
  __typename?: 'business_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Groups>;
};

/** on_conflict condition type for table "business_groups" */
export type Business_Groups_On_Conflict = {
  constraint: Business_Groups_Constraint;
  update_columns?: Array<Business_Groups_Update_Column>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "business_groups". */
export type Business_Groups_Order_By = {
  business?: InputMaybe<Business_Order_By>;
  business_group?: InputMaybe<Business_Group_Order_By>;
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_groups */
export type Business_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_groups" */
export enum Business_Groups_Select_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  BusinessgroupId = 'businessgroup_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "business_groups" */
export type Business_Groups_Set_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  businessgroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Groups_Stddev_Fields = {
  __typename?: 'business_groups_stddev_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_groups" */
export type Business_Groups_Stddev_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Groups_Stddev_Pop_Fields = {
  __typename?: 'business_groups_stddev_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_groups" */
export type Business_Groups_Stddev_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Groups_Stddev_Samp_Fields = {
  __typename?: 'business_groups_stddev_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_groups" */
export type Business_Groups_Stddev_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_groups" */
export type Business_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Groups_Stream_Cursor_Value_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  businessgroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Groups_Sum_Fields = {
  __typename?: 'business_groups_sum_fields';
  business_id?: Maybe<Scalars['Int']>;
  businessgroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_groups" */
export type Business_Groups_Sum_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "business_groups" */
export enum Business_Groups_Update_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  BusinessgroupId = 'businessgroup_id',
  /** column name */
  Id = 'id'
}

export type Business_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Groups_Set_Input>;
  where: Business_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Groups_Var_Pop_Fields = {
  __typename?: 'business_groups_var_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_groups" */
export type Business_Groups_Var_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Groups_Var_Samp_Fields = {
  __typename?: 'business_groups_var_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_groups" */
export type Business_Groups_Var_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Groups_Variance_Fields = {
  __typename?: 'business_groups_variance_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_groups" */
export type Business_Groups_Variance_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "business" */
export type Business_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  primary_poc_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business" */
export type Business_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  alternate_email?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  commodities_supplied?: InputMaybe<Business_Commodities_Supplied_Arr_Rel_Insert_Input>;
  companies?: InputMaybe<Business_Companies_Arr_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Business_Groups_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  incorporated_on?: InputMaybe<Scalars['date']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Business_Network_Arr_Rel_Insert_Input>;
  number?: InputMaybe<Scalars['String']>;
  primary_poc?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  primary_poc_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  secondary_pocs?: InputMaybe<Business_Secondary_Pocs_Arr_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Business_Max_Fields = {
  __typename?: 'business_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  alternate_email?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  incorporated_on?: Maybe<Scalars['date']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  primary_poc_id?: Maybe<Scalars['Int']>;
  secondary_number?: Maybe<Scalars['String']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Business_Min_Fields = {
  __typename?: 'business_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  alternate_email?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  incorporated_on?: Maybe<Scalars['date']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  primary_poc_id?: Maybe<Scalars['Int']>;
  secondary_number?: Maybe<Scalars['String']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "business" */
export type Business_Mutation_Response = {
  __typename?: 'business_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business>;
};

/** columns and relationships of "business_network" */
export type Business_Network = {
  __typename?: 'business_network';
  business_id: Scalars['Int'];
  id: Scalars['Int'];
  network_id: Scalars['Int'];
};

/** aggregated selection of "business_network" */
export type Business_Network_Aggregate = {
  __typename?: 'business_network_aggregate';
  aggregate?: Maybe<Business_Network_Aggregate_Fields>;
  nodes: Array<Business_Network>;
};

/** aggregate fields of "business_network" */
export type Business_Network_Aggregate_Fields = {
  __typename?: 'business_network_aggregate_fields';
  avg?: Maybe<Business_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Network_Max_Fields>;
  min?: Maybe<Business_Network_Min_Fields>;
  stddev?: Maybe<Business_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Network_Sum_Fields>;
  var_pop?: Maybe<Business_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Network_Var_Samp_Fields>;
  variance?: Maybe<Business_Network_Variance_Fields>;
};


/** aggregate fields of "business_network" */
export type Business_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_network" */
export type Business_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Network_Max_Order_By>;
  min?: InputMaybe<Business_Network_Min_Order_By>;
  stddev?: InputMaybe<Business_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_network" */
export type Business_Network_Arr_Rel_Insert_Input = {
  data: Array<Business_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Network_Avg_Fields = {
  __typename?: 'business_network_avg_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_network" */
export type Business_Network_Avg_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_network". All fields are combined with a logical 'AND'. */
export type Business_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Network_Bool_Exp>>;
  _not?: InputMaybe<Business_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Network_Bool_Exp>>;
  business_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_network" */
export enum Business_Network_Constraint {
  /** unique or primary key constraint on columns "business_id", "network_id" */
  BusinessNetworkNetworkIdBusinessId_7b858af5Uniq = 'business_network_network_id_business_id_7b858af5_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessNetworkPkey = 'business_network_pkey'
}

/** input type for incrementing numeric columns in table "business_network" */
export type Business_Network_Inc_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_network" */
export type Business_Network_Insert_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Network_Max_Fields = {
  __typename?: 'business_network_max_fields';
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_network" */
export type Business_Network_Max_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Network_Min_Fields = {
  __typename?: 'business_network_min_fields';
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_network" */
export type Business_Network_Min_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_network" */
export type Business_Network_Mutation_Response = {
  __typename?: 'business_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Network>;
};

/** on_conflict condition type for table "business_network" */
export type Business_Network_On_Conflict = {
  constraint: Business_Network_Constraint;
  update_columns?: Array<Business_Network_Update_Column>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "business_network". */
export type Business_Network_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_network */
export type Business_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_network" */
export enum Business_Network_Select_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id'
}

/** input type for updating data in table "business_network" */
export type Business_Network_Set_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Network_Stddev_Fields = {
  __typename?: 'business_network_stddev_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_network" */
export type Business_Network_Stddev_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Network_Stddev_Pop_Fields = {
  __typename?: 'business_network_stddev_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_network" */
export type Business_Network_Stddev_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Network_Stddev_Samp_Fields = {
  __typename?: 'business_network_stddev_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_network" */
export type Business_Network_Stddev_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_network" */
export type Business_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Network_Stream_Cursor_Value_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Network_Sum_Fields = {
  __typename?: 'business_network_sum_fields';
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_network" */
export type Business_Network_Sum_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "business_network" */
export enum Business_Network_Update_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id'
}

export type Business_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Network_Set_Input>;
  where: Business_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Network_Var_Pop_Fields = {
  __typename?: 'business_network_var_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_network" */
export type Business_Network_Var_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Network_Var_Samp_Fields = {
  __typename?: 'business_network_var_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_network" */
export type Business_Network_Var_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Network_Variance_Fields = {
  __typename?: 'business_network_variance_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_network" */
export type Business_Network_Variance_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "business" */
export type Business_Obj_Rel_Insert_Input = {
  data: Business_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_On_Conflict>;
};

/** on_conflict condition type for table "business" */
export type Business_On_Conflict = {
  constraint: Business_Constraint;
  update_columns?: Array<Business_Update_Column>;
  where?: InputMaybe<Business_Bool_Exp>;
};

/** Ordering options when selecting data from "business". */
export type Business_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  alternate_email?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  commodities_supplied_aggregate?: InputMaybe<Business_Commodities_Supplied_Aggregate_Order_By>;
  companies_aggregate?: InputMaybe<Business_Companies_Aggregate_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent?: InputMaybe<Media_Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  groups_aggregate?: InputMaybe<Business_Groups_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  incorporated_on?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Business_Network_Aggregate_Order_By>;
  number?: InputMaybe<Order_By>;
  primary_poc?: InputMaybe<Base_User_Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  secondary_pocs_aggregate?: InputMaybe<Business_Secondary_Pocs_Aggregate_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business */
export type Business_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Business_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "business_secondary_pocs" */
export type Business_Secondary_Pocs = {
  __typename?: 'business_secondary_pocs';
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  /** An object relationship */
  business: Business;
  business_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "business_secondary_pocs" */
export type Business_Secondary_Pocs_Aggregate = {
  __typename?: 'business_secondary_pocs_aggregate';
  aggregate?: Maybe<Business_Secondary_Pocs_Aggregate_Fields>;
  nodes: Array<Business_Secondary_Pocs>;
};

/** aggregate fields of "business_secondary_pocs" */
export type Business_Secondary_Pocs_Aggregate_Fields = {
  __typename?: 'business_secondary_pocs_aggregate_fields';
  avg?: Maybe<Business_Secondary_Pocs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Secondary_Pocs_Max_Fields>;
  min?: Maybe<Business_Secondary_Pocs_Min_Fields>;
  stddev?: Maybe<Business_Secondary_Pocs_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Secondary_Pocs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Secondary_Pocs_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Secondary_Pocs_Sum_Fields>;
  var_pop?: Maybe<Business_Secondary_Pocs_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Secondary_Pocs_Var_Samp_Fields>;
  variance?: Maybe<Business_Secondary_Pocs_Variance_Fields>;
};


/** aggregate fields of "business_secondary_pocs" */
export type Business_Secondary_Pocs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Secondary_Pocs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Secondary_Pocs_Max_Order_By>;
  min?: InputMaybe<Business_Secondary_Pocs_Min_Order_By>;
  stddev?: InputMaybe<Business_Secondary_Pocs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Secondary_Pocs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Secondary_Pocs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Secondary_Pocs_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Secondary_Pocs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Secondary_Pocs_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Secondary_Pocs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Arr_Rel_Insert_Input = {
  data: Array<Business_Secondary_Pocs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Secondary_Pocs_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Secondary_Pocs_Avg_Fields = {
  __typename?: 'business_secondary_pocs_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_secondary_pocs". All fields are combined with a logical 'AND'. */
export type Business_Secondary_Pocs_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Secondary_Pocs_Bool_Exp>>;
  _not?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Secondary_Pocs_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  business?: InputMaybe<Business_Bool_Exp>;
  business_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_secondary_pocs" */
export enum Business_Secondary_Pocs_Constraint {
  /** unique or primary key constraint on columns "business_id", "baseuser_id" */
  BusinessSecondaryPocsBusinessIdBaseuserId_3daa2e65Uniq = 'business_secondary_pocs_business_id_baseuser_id_3daa2e65_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessSecondaryPocsPkey = 'business_secondary_pocs_pkey'
}

/** input type for incrementing numeric columns in table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  business?: InputMaybe<Business_Obj_Rel_Insert_Input>;
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Secondary_Pocs_Max_Fields = {
  __typename?: 'business_secondary_pocs_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Secondary_Pocs_Min_Fields = {
  __typename?: 'business_secondary_pocs_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Mutation_Response = {
  __typename?: 'business_secondary_pocs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Secondary_Pocs>;
};

/** on_conflict condition type for table "business_secondary_pocs" */
export type Business_Secondary_Pocs_On_Conflict = {
  constraint: Business_Secondary_Pocs_Constraint;
  update_columns?: Array<Business_Secondary_Pocs_Update_Column>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};

/** Ordering options when selecting data from "business_secondary_pocs". */
export type Business_Secondary_Pocs_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  business?: InputMaybe<Business_Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_secondary_pocs */
export type Business_Secondary_Pocs_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_secondary_pocs" */
export enum Business_Secondary_Pocs_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Secondary_Pocs_Stddev_Fields = {
  __typename?: 'business_secondary_pocs_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Secondary_Pocs_Stddev_Pop_Fields = {
  __typename?: 'business_secondary_pocs_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Secondary_Pocs_Stddev_Samp_Fields = {
  __typename?: 'business_secondary_pocs_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Secondary_Pocs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Secondary_Pocs_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Secondary_Pocs_Sum_Fields = {
  __typename?: 'business_secondary_pocs_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "business_secondary_pocs" */
export enum Business_Secondary_Pocs_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  Id = 'id'
}

export type Business_Secondary_Pocs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Secondary_Pocs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Secondary_Pocs_Set_Input>;
  where: Business_Secondary_Pocs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Secondary_Pocs_Var_Pop_Fields = {
  __typename?: 'business_secondary_pocs_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Secondary_Pocs_Var_Samp_Fields = {
  __typename?: 'business_secondary_pocs_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Secondary_Pocs_Variance_Fields = {
  __typename?: 'business_secondary_pocs_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "business" */
export enum Business_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AlternateEmail = 'alternate_email',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IncorporatedOn = 'incorporated_on',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Kind = 'kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  PrimaryPocId = 'primary_poc_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "business" */
export type Business_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  alternate_email?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  incorporated_on?: InputMaybe<Scalars['date']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  primary_poc_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Business_Stddev_Fields = {
  __typename?: 'business_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Business_Stddev_Pop_Fields = {
  __typename?: 'business_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Business_Stddev_Samp_Fields = {
  __typename?: 'business_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "business" */
export type Business_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  alternate_email?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  incorporated_on?: InputMaybe<Scalars['date']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  primary_poc_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Business_Sum_Fields = {
  __typename?: 'business_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  primary_poc_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "business" */
export enum Business_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AlternateEmail = 'alternate_email',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IncorporatedOn = 'incorporated_on',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Kind = 'kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  PrimaryPocId = 'primary_poc_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Business_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Business_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Business_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Business_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Business_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Business_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Set_Input>;
  where: Business_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Var_Pop_Fields = {
  __typename?: 'business_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Business_Var_Samp_Fields = {
  __typename?: 'business_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Business_Variance_Fields = {
  __typename?: 'business_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "shared_entity" */
export type Care_Shared_Entity = {
  __typename?: 'care_shared_entity';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  group_id?: Maybe<Scalars['bigint']>;
  group_name: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  private_metadata: Scalars['jsonb'];
  /** An array relationship */
  product_crop_infestation_recommendations: Array<Product_Crop_Infestation_Recommendation>;
  /** An aggregate relationship */
  product_crop_infestation_recommendations_aggregate: Product_Crop_Infestation_Recommendation_Aggregate;
  /** An array relationship */
  product_infestations: Array<Product_Infestation>;
  /** An aggregate relationship */
  product_infestations_aggregate: Product_Infestation_Aggregate;
  reference_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "shared_entity" */
export type Care_Shared_EntityMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shared_entity" */
export type Care_Shared_EntityPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shared_entity" */
export type Care_Shared_EntityProduct_Crop_Infestation_RecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Care_Shared_EntityProduct_Crop_Infestation_Recommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Care_Shared_EntityProduct_InfestationsArgs = {
  distinct_on?: InputMaybe<Array<Product_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Infestation_Order_By>>;
  where?: InputMaybe<Product_Infestation_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Care_Shared_EntityProduct_Infestations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Infestation_Order_By>>;
  where?: InputMaybe<Product_Infestation_Bool_Exp>;
};

/** aggregated selection of "shared_entity" */
export type Care_Shared_Entity_Aggregate = {
  __typename?: 'care_shared_entity_aggregate';
  aggregate?: Maybe<Care_Shared_Entity_Aggregate_Fields>;
  nodes: Array<Care_Shared_Entity>;
};

/** aggregate fields of "shared_entity" */
export type Care_Shared_Entity_Aggregate_Fields = {
  __typename?: 'care_shared_entity_aggregate_fields';
  avg?: Maybe<Care_Shared_Entity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Care_Shared_Entity_Max_Fields>;
  min?: Maybe<Care_Shared_Entity_Min_Fields>;
  stddev?: Maybe<Care_Shared_Entity_Stddev_Fields>;
  stddev_pop?: Maybe<Care_Shared_Entity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Care_Shared_Entity_Stddev_Samp_Fields>;
  sum?: Maybe<Care_Shared_Entity_Sum_Fields>;
  var_pop?: Maybe<Care_Shared_Entity_Var_Pop_Fields>;
  var_samp?: Maybe<Care_Shared_Entity_Var_Samp_Fields>;
  variance?: Maybe<Care_Shared_Entity_Variance_Fields>;
};


/** aggregate fields of "shared_entity" */
export type Care_Shared_Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Care_Shared_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Care_Shared_Entity_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Care_Shared_Entity_Avg_Fields = {
  __typename?: 'care_shared_entity_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shared_entity". All fields are combined with a logical 'AND'. */
export type Care_Shared_Entity_Bool_Exp = {
  _and?: InputMaybe<Array<Care_Shared_Entity_Bool_Exp>>;
  _not?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Care_Shared_Entity_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Bigint_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  product_crop_infestation_recommendations?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
  product_infestations?: InputMaybe<Product_Infestation_Bool_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared_entity" */
export enum Care_Shared_Entity_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SharedEntityCodenameKey = 'shared_entity_codename_key',
  /** unique or primary key constraint on columns "reference_id", "group_name" */
  SharedEntityGroupNameReferenceId_4db210e6Uniq = 'shared_entity_group_name_reference_id_4db210e6_uniq',
  /** unique or primary key constraint on columns "id" */
  SharedEntityPkey = 'shared_entity_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Care_Shared_Entity_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Care_Shared_Entity_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Care_Shared_Entity_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "shared_entity" */
export type Care_Shared_Entity_Inc_Input = {
  group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "shared_entity" */
export type Care_Shared_Entity_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  group_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  product_crop_infestation_recommendations?: InputMaybe<Product_Crop_Infestation_Recommendation_Arr_Rel_Insert_Input>;
  product_infestations?: InputMaybe<Product_Infestation_Arr_Rel_Insert_Input>;
  reference_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Care_Shared_Entity_Max_Fields = {
  __typename?: 'care_shared_entity_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['bigint']>;
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Care_Shared_Entity_Min_Fields = {
  __typename?: 'care_shared_entity_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['bigint']>;
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shared_entity" */
export type Care_Shared_Entity_Mutation_Response = {
  __typename?: 'care_shared_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Care_Shared_Entity>;
};

/** input type for inserting object relation for remote table "shared_entity" */
export type Care_Shared_Entity_Obj_Rel_Insert_Input = {
  data: Care_Shared_Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Care_Shared_Entity_On_Conflict>;
};

/** on_conflict condition type for table "shared_entity" */
export type Care_Shared_Entity_On_Conflict = {
  constraint: Care_Shared_Entity_Constraint;
  update_columns?: Array<Care_Shared_Entity_Update_Column>;
  where?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "shared_entity". */
export type Care_Shared_Entity_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  product_crop_infestation_recommendations_aggregate?: InputMaybe<Product_Crop_Infestation_Recommendation_Aggregate_Order_By>;
  product_infestations_aggregate?: InputMaybe<Product_Infestation_Aggregate_Order_By>;
  reference_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared_entity */
export type Care_Shared_Entity_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Care_Shared_Entity_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shared_entity" */
export enum Care_Shared_Entity_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "shared_entity" */
export type Care_Shared_Entity_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  group_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Care_Shared_Entity_Stddev_Fields = {
  __typename?: 'care_shared_entity_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Care_Shared_Entity_Stddev_Pop_Fields = {
  __typename?: 'care_shared_entity_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Care_Shared_Entity_Stddev_Samp_Fields = {
  __typename?: 'care_shared_entity_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "care_shared_entity" */
export type Care_Shared_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Care_Shared_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Care_Shared_Entity_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  group_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Care_Shared_Entity_Sum_Fields = {
  __typename?: 'care_shared_entity_sum_fields';
  group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "shared_entity" */
export enum Care_Shared_Entity_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Care_Shared_Entity_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Care_Shared_Entity_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Care_Shared_Entity_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Care_Shared_Entity_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Care_Shared_Entity_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Care_Shared_Entity_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Care_Shared_Entity_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Care_Shared_Entity_Set_Input>;
  where: Care_Shared_Entity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Care_Shared_Entity_Var_Pop_Fields = {
  __typename?: 'care_shared_entity_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Care_Shared_Entity_Var_Samp_Fields = {
  __typename?: 'care_shared_entity_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Care_Shared_Entity_Variance_Fields = {
  __typename?: 'care_shared_entity_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "category" */
export type Category = {
  __typename?: 'category';
  attachment_id?: Maybe<Scalars['bigint']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  operation_key?: Maybe<Scalars['String']>;
  order: Scalars['smallint'];
  /** An object relationship */
  photo?: Maybe<Common_Fileupload>;
  /** An object relationship */
  product_class: Product_Class;
  product_class_id: Scalars['uuid'];
  /** An array relationship */
  subcategories: Array<Subcategory>;
  /** An aggregate relationship */
  subcategories_aggregate: Subcategory_Aggregate;
};


/** columns and relationships of "category" */
export type CategorySubcategoriesArgs = {
  distinct_on?: InputMaybe<Array<Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subcategory_Order_By>>;
  where?: InputMaybe<Subcategory_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategorySubcategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subcategory_Order_By>>;
  where?: InputMaybe<Subcategory_Bool_Exp>;
};

/** aggregated selection of "category" */
export type Category_Aggregate = {
  __typename?: 'category_aggregate';
  aggregate?: Maybe<Category_Aggregate_Fields>;
  nodes: Array<Category>;
};

/** aggregate fields of "category" */
export type Category_Aggregate_Fields = {
  __typename?: 'category_aggregate_fields';
  avg?: Maybe<Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Category_Max_Fields>;
  min?: Maybe<Category_Min_Fields>;
  stddev?: Maybe<Category_Stddev_Fields>;
  stddev_pop?: Maybe<Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Category_Stddev_Samp_Fields>;
  sum?: Maybe<Category_Sum_Fields>;
  var_pop?: Maybe<Category_Var_Pop_Fields>;
  var_samp?: Maybe<Category_Var_Samp_Fields>;
  variance?: Maybe<Category_Variance_Fields>;
};


/** aggregate fields of "category" */
export type Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "category" */
export type Category_Aggregate_Order_By = {
  avg?: InputMaybe<Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Category_Max_Order_By>;
  min?: InputMaybe<Category_Min_Order_By>;
  stddev?: InputMaybe<Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Category_Sum_Order_By>;
  var_pop?: InputMaybe<Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Category_Var_Samp_Order_By>;
  variance?: InputMaybe<Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "category" */
export type Category_Arr_Rel_Insert_Input = {
  data: Array<Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Category_Avg_Fields = {
  __typename?: 'category_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "category" */
export type Category_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "category". All fields are combined with a logical 'AND'. */
export type Category_Bool_Exp = {
  _and?: InputMaybe<Array<Category_Bool_Exp>>;
  _not?: InputMaybe<Category_Bool_Exp>;
  _or?: InputMaybe<Array<Category_Bool_Exp>>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  operation_key?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  photo?: InputMaybe<Common_Fileupload_Bool_Exp>;
  product_class?: InputMaybe<Product_Class_Bool_Exp>;
  product_class_id?: InputMaybe<Uuid_Comparison_Exp>;
  subcategories?: InputMaybe<Subcategory_Bool_Exp>;
};

/** unique or primary key constraints on table "category" */
export enum Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  CategoryPkey = 'category_pkey',
  /** unique or primary key constraint on columns "name", "product_class_id" */
  CategoryProductClassIdName_5dd34275Uniq = 'category_product_class_id_name_5dd34275_uniq'
}

/** input type for incrementing numeric columns in table "category" */
export type Category_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "category" */
export type Category_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  operation_key?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  photo?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  product_class?: InputMaybe<Product_Class_Obj_Rel_Insert_Input>;
  product_class_id?: InputMaybe<Scalars['uuid']>;
  subcategories?: InputMaybe<Subcategory_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Category_Max_Fields = {
  __typename?: 'category_max_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  operation_key?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_class_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "category" */
export type Category_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operation_key?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_class_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Category_Min_Fields = {
  __typename?: 'category_min_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  operation_key?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_class_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "category" */
export type Category_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operation_key?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_class_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "category" */
export type Category_Mutation_Response = {
  __typename?: 'category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Category>;
};

/** input type for inserting object relation for remote table "category" */
export type Category_Obj_Rel_Insert_Input = {
  data: Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_On_Conflict>;
};

/** on_conflict condition type for table "category" */
export type Category_On_Conflict = {
  constraint: Category_Constraint;
  update_columns?: Array<Category_Update_Column>;
  where?: InputMaybe<Category_Bool_Exp>;
};

/** Ordering options when selecting data from "category". */
export type Category_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operation_key?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  photo?: InputMaybe<Common_Fileupload_Order_By>;
  product_class?: InputMaybe<Product_Class_Order_By>;
  product_class_id?: InputMaybe<Order_By>;
  subcategories_aggregate?: InputMaybe<Subcategory_Aggregate_Order_By>;
};

/** primary key columns input for table: category */
export type Category_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "category" */
export enum Category_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OperationKey = 'operation_key',
  /** column name */
  Order = 'order',
  /** column name */
  ProductClassId = 'product_class_id'
}

/** input type for updating data in table "category" */
export type Category_Set_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  operation_key?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_class_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Category_Stddev_Fields = {
  __typename?: 'category_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "category" */
export type Category_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Category_Stddev_Pop_Fields = {
  __typename?: 'category_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "category" */
export type Category_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Category_Stddev_Samp_Fields = {
  __typename?: 'category_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "category" */
export type Category_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "category" */
export type Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Category_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  operation_key?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_class_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Category_Sum_Fields = {
  __typename?: 'category_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "category" */
export type Category_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "category" */
export enum Category_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OperationKey = 'operation_key',
  /** column name */
  Order = 'order',
  /** column name */
  ProductClassId = 'product_class_id'
}

export type Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Category_Set_Input>;
  where: Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Category_Var_Pop_Fields = {
  __typename?: 'category_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "category" */
export type Category_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Category_Var_Samp_Fields = {
  __typename?: 'category_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "category" */
export type Category_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Category_Variance_Fields = {
  __typename?: 'category_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "category" */
export type Category_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "certificate_issuer" */
export type Certificate_Issuer = {
  __typename?: 'certificate_issuer';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  /** An array relationship */
  certifications: Array<Certification>;
  /** An aggregate relationship */
  certifications_aggregate: Certification_Aggregate;
  city_village?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['geometry']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  loc_desc?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  post_code?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
};


/** columns and relationships of "certificate_issuer" */
export type Certificate_IssuerCertificationsArgs = {
  distinct_on?: InputMaybe<Array<Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certification_Order_By>>;
  where?: InputMaybe<Certification_Bool_Exp>;
};


/** columns and relationships of "certificate_issuer" */
export type Certificate_IssuerCertifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certification_Order_By>>;
  where?: InputMaybe<Certification_Bool_Exp>;
};

/** aggregated selection of "certificate_issuer" */
export type Certificate_Issuer_Aggregate = {
  __typename?: 'certificate_issuer_aggregate';
  aggregate?: Maybe<Certificate_Issuer_Aggregate_Fields>;
  nodes: Array<Certificate_Issuer>;
};

/** aggregate fields of "certificate_issuer" */
export type Certificate_Issuer_Aggregate_Fields = {
  __typename?: 'certificate_issuer_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Certificate_Issuer_Max_Fields>;
  min?: Maybe<Certificate_Issuer_Min_Fields>;
};


/** aggregate fields of "certificate_issuer" */
export type Certificate_Issuer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Certificate_Issuer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "certificate_issuer". All fields are combined with a logical 'AND'. */
export type Certificate_Issuer_Bool_Exp = {
  _and?: InputMaybe<Array<Certificate_Issuer_Bool_Exp>>;
  _not?: InputMaybe<Certificate_Issuer_Bool_Exp>;
  _or?: InputMaybe<Array<Certificate_Issuer_Bool_Exp>>;
  address_line1?: InputMaybe<String_Comparison_Exp>;
  address_line2?: InputMaybe<String_Comparison_Exp>;
  certifications?: InputMaybe<Certification_Bool_Exp>;
  city_village?: InputMaybe<String_Comparison_Exp>;
  coordinates?: InputMaybe<Geometry_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  loc_desc?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  post_code?: InputMaybe<String_Comparison_Exp>;
  raw_address?: InputMaybe<String_Comparison_Exp>;
  region_county?: InputMaybe<String_Comparison_Exp>;
  state_province?: InputMaybe<String_Comparison_Exp>;
  sub_region?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "certificate_issuer" */
export enum Certificate_Issuer_Constraint {
  /** unique or primary key constraint on columns "id" */
  CertificateIssuerPkey = 'certificate_issuer_pkey'
}

/** input type for inserting data into table "certificate_issuer" */
export type Certificate_Issuer_Insert_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Certification_Arr_Rel_Insert_Input>;
  city_village?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['geometry']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Certificate_Issuer_Max_Fields = {
  __typename?: 'certificate_issuer_max_fields';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  loc_desc?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Certificate_Issuer_Min_Fields = {
  __typename?: 'certificate_issuer_min_fields';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  loc_desc?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "certificate_issuer" */
export type Certificate_Issuer_Mutation_Response = {
  __typename?: 'certificate_issuer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Certificate_Issuer>;
};

/** input type for inserting object relation for remote table "certificate_issuer" */
export type Certificate_Issuer_Obj_Rel_Insert_Input = {
  data: Certificate_Issuer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Certificate_Issuer_On_Conflict>;
};

/** on_conflict condition type for table "certificate_issuer" */
export type Certificate_Issuer_On_Conflict = {
  constraint: Certificate_Issuer_Constraint;
  update_columns?: Array<Certificate_Issuer_Update_Column>;
  where?: InputMaybe<Certificate_Issuer_Bool_Exp>;
};

/** Ordering options when selecting data from "certificate_issuer". */
export type Certificate_Issuer_Order_By = {
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  certifications_aggregate?: InputMaybe<Certification_Aggregate_Order_By>;
  city_village?: InputMaybe<Order_By>;
  coordinates?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  loc_desc?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  post_code?: InputMaybe<Order_By>;
  raw_address?: InputMaybe<Order_By>;
  region_county?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  sub_region?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: certificate_issuer */
export type Certificate_Issuer_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "certificate_issuer" */
export enum Certificate_Issuer_Select_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  CityVillage = 'city_village',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocDesc = 'loc_desc',
  /** column name */
  Name = 'name',
  /** column name */
  PostCode = 'post_code',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  RegionCounty = 'region_county',
  /** column name */
  StateProvince = 'state_province',
  /** column name */
  SubRegion = 'sub_region',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "certificate_issuer" */
export type Certificate_Issuer_Set_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['geometry']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "certificate_issuer" */
export type Certificate_Issuer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Certificate_Issuer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Certificate_Issuer_Stream_Cursor_Value_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['geometry']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "certificate_issuer" */
export enum Certificate_Issuer_Update_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  CityVillage = 'city_village',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocDesc = 'loc_desc',
  /** column name */
  Name = 'name',
  /** column name */
  PostCode = 'post_code',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  RegionCounty = 'region_county',
  /** column name */
  StateProvince = 'state_province',
  /** column name */
  SubRegion = 'sub_region',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Certificate_Issuer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Certificate_Issuer_Set_Input>;
  where: Certificate_Issuer_Bool_Exp;
};

/** columns and relationships of "certification" */
export type Certification = {
  __typename?: 'certification';
  /** An object relationship */
  certificate_issuer: Certificate_Issuer;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  issuer_id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  product_certifications: Array<Product_Certification>;
  /** An aggregate relationship */
  product_certifications_aggregate: Product_Certification_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
};


/** columns and relationships of "certification" */
export type CertificationProduct_CertificationsArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Order_By>>;
  where?: InputMaybe<Product_Certification_Bool_Exp>;
};


/** columns and relationships of "certification" */
export type CertificationProduct_Certifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Order_By>>;
  where?: InputMaybe<Product_Certification_Bool_Exp>;
};

/** aggregated selection of "certification" */
export type Certification_Aggregate = {
  __typename?: 'certification_aggregate';
  aggregate?: Maybe<Certification_Aggregate_Fields>;
  nodes: Array<Certification>;
};

/** aggregate fields of "certification" */
export type Certification_Aggregate_Fields = {
  __typename?: 'certification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Certification_Max_Fields>;
  min?: Maybe<Certification_Min_Fields>;
};


/** aggregate fields of "certification" */
export type Certification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Certification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "certification" */
export type Certification_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Certification_Max_Order_By>;
  min?: InputMaybe<Certification_Min_Order_By>;
};

/** input type for inserting array relation for remote table "certification" */
export type Certification_Arr_Rel_Insert_Input = {
  data: Array<Certification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Certification_On_Conflict>;
};

/** Boolean expression to filter rows from the table "certification". All fields are combined with a logical 'AND'. */
export type Certification_Bool_Exp = {
  _and?: InputMaybe<Array<Certification_Bool_Exp>>;
  _not?: InputMaybe<Certification_Bool_Exp>;
  _or?: InputMaybe<Array<Certification_Bool_Exp>>;
  certificate_issuer?: InputMaybe<Certificate_Issuer_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  issuer_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  product_certifications?: InputMaybe<Product_Certification_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "certification" */
export enum Certification_Constraint {
  /** unique or primary key constraint on columns "id" */
  CertificationPkey = 'certification_pkey'
}

/** input type for inserting data into table "certification" */
export type Certification_Insert_Input = {
  certificate_issuer?: InputMaybe<Certificate_Issuer_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  issuer_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  product_certifications?: InputMaybe<Product_Certification_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Certification_Max_Fields = {
  __typename?: 'certification_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  issuer_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "certification" */
export type Certification_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Certification_Min_Fields = {
  __typename?: 'certification_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  issuer_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "certification" */
export type Certification_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "certification" */
export type Certification_Mutation_Response = {
  __typename?: 'certification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Certification>;
};

/** input type for inserting object relation for remote table "certification" */
export type Certification_Obj_Rel_Insert_Input = {
  data: Certification_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Certification_On_Conflict>;
};

/** on_conflict condition type for table "certification" */
export type Certification_On_Conflict = {
  constraint: Certification_Constraint;
  update_columns?: Array<Certification_Update_Column>;
  where?: InputMaybe<Certification_Bool_Exp>;
};

/** Ordering options when selecting data from "certification". */
export type Certification_Order_By = {
  certificate_issuer?: InputMaybe<Certificate_Issuer_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  issuer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_certifications_aggregate?: InputMaybe<Product_Certification_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: certification */
export type Certification_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "certification" */
export enum Certification_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IssuerId = 'issuer_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "certification" */
export type Certification_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  issuer_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "certification" */
export type Certification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Certification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Certification_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  issuer_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "certification" */
export enum Certification_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IssuerId = 'issuer_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Certification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Certification_Set_Input>;
  where: Certification_Bool_Exp;
};

/** columns and relationships of "comment" */
export type Comment = {
  __typename?: 'comment';
  /** An object relationship */
  article: Article;
  article_id: Scalars['uuid'];
  comment: Scalars['String'];
  /** An object relationship */
  commentByParentCommentId?: Maybe<Comment>;
  /** An array relationship */
  comments: Array<Comment>;
  /** An aggregate relationship */
  comments_aggregate: Comment_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_blocked: Scalars['Boolean'];
  parent_comment_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
};


/** columns and relationships of "comment" */
export type CommentCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


/** columns and relationships of "comment" */
export type CommentComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


/** columns and relationships of "comment" */
export type CommentCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Commentcreator>;
};


/** columns and relationships of "comment" */
export type CommentUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Commentupdater>;
};

/** aggregated selection of "comment" */
export type Comment_Aggregate = {
  __typename?: 'comment_aggregate';
  aggregate?: Maybe<Comment_Aggregate_Fields>;
  nodes: Array<Comment>;
};

/** aggregate fields of "comment" */
export type Comment_Aggregate_Fields = {
  __typename?: 'comment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Comment_Max_Fields>;
  min?: Maybe<Comment_Min_Fields>;
};


/** aggregate fields of "comment" */
export type Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "comment" */
export type Comment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comment_Max_Order_By>;
  min?: InputMaybe<Comment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "comment" */
export type Comment_Arr_Rel_Insert_Input = {
  data: Array<Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "comment". All fields are combined with a logical 'AND'. */
export type Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Comment_Bool_Exp>>;
  _not?: InputMaybe<Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Comment_Bool_Exp>>;
  article?: InputMaybe<Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  commentByParentCommentId?: InputMaybe<Comment_Bool_Exp>;
  comments?: InputMaybe<Comment_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  parent_comment_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "comment" */
export enum Comment_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommentPkey = 'comment_pkey'
}

/** input type for inserting data into table "comment" */
export type Comment_Insert_Input = {
  article?: InputMaybe<Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']>;
  comment?: InputMaybe<Scalars['String']>;
  commentByParentCommentId?: InputMaybe<Comment_Obj_Rel_Insert_Input>;
  comments?: InputMaybe<Comment_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  parent_comment_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Comment_Max_Fields = {
  __typename?: 'comment_max_fields';
  article_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  parent_comment_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "comment" */
export type Comment_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Comment_Min_Fields = {
  __typename?: 'comment_min_fields';
  article_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  parent_comment_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "comment" */
export type Comment_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "comment" */
export type Comment_Mutation_Response = {
  __typename?: 'comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Comment>;
};

/** input type for inserting object relation for remote table "comment" */
export type Comment_Obj_Rel_Insert_Input = {
  data: Comment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};

/** on_conflict condition type for table "comment" */
export type Comment_On_Conflict = {
  constraint: Comment_Constraint;
  update_columns?: Array<Comment_Update_Column>;
  where?: InputMaybe<Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "comment". */
export type Comment_Order_By = {
  article?: InputMaybe<Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  commentByParentCommentId?: InputMaybe<Comment_Order_By>;
  comments_aggregate?: InputMaybe<Comment_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_blocked?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: comment */
export type Comment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "comment" */
export enum Comment_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  ParentCommentId = 'parent_comment_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "comment" */
export type Comment_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  parent_comment_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "comment" */
export type Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comment_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  parent_comment_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "comment" */
export enum Comment_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  ParentCommentId = 'parent_comment_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Comment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comment_Set_Input>;
  where: Comment_Bool_Exp;
};

/** columns and relationships of "commodity" */
export type Commodity = {
  __typename?: 'commodity';
  codename: Scalars['String'];
  crop_id?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  /** An array relationship */
  varieties: Array<Commodity_Variety>;
  /** An aggregate relationship */
  varieties_aggregate: Commodity_Variety_Aggregate;
};


/** columns and relationships of "commodity" */
export type CommodityMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "commodity" */
export type CommodityPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "commodity" */
export type CommodityVarietiesArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


/** columns and relationships of "commodity" */
export type CommodityVarieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};

/** aggregated selection of "commodity" */
export type Commodity_Aggregate = {
  __typename?: 'commodity_aggregate';
  aggregate?: Maybe<Commodity_Aggregate_Fields>;
  nodes: Array<Commodity>;
};

/** aggregate fields of "commodity" */
export type Commodity_Aggregate_Fields = {
  __typename?: 'commodity_aggregate_fields';
  avg?: Maybe<Commodity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Commodity_Max_Fields>;
  min?: Maybe<Commodity_Min_Fields>;
  stddev?: Maybe<Commodity_Stddev_Fields>;
  stddev_pop?: Maybe<Commodity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Commodity_Stddev_Samp_Fields>;
  sum?: Maybe<Commodity_Sum_Fields>;
  var_pop?: Maybe<Commodity_Var_Pop_Fields>;
  var_samp?: Maybe<Commodity_Var_Samp_Fields>;
  variance?: Maybe<Commodity_Variance_Fields>;
};


/** aggregate fields of "commodity" */
export type Commodity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Commodity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "commodity" */
export type Commodity_Aggregate_Order_By = {
  avg?: InputMaybe<Commodity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Commodity_Max_Order_By>;
  min?: InputMaybe<Commodity_Min_Order_By>;
  stddev?: InputMaybe<Commodity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Commodity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Commodity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Commodity_Sum_Order_By>;
  var_pop?: InputMaybe<Commodity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Commodity_Var_Samp_Order_By>;
  variance?: InputMaybe<Commodity_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Commodity_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "commodity" */
export type Commodity_Arr_Rel_Insert_Input = {
  data: Array<Commodity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Commodity_On_Conflict>;
};

/** aggregate avg on columns */
export type Commodity_Avg_Fields = {
  __typename?: 'commodity_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "commodity" */
export type Commodity_Avg_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "commodity". All fields are combined with a logical 'AND'. */
export type Commodity_Bool_Exp = {
  _and?: InputMaybe<Array<Commodity_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "commodity". All fields are combined with a logical 'AND'. */
export type Commodity_Bool_Exp_Remote_Rel_Shared_Entitycommodity = {
  _and?: InputMaybe<Array<Commodity_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitycommodity>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "commodity". All fields are combined with a logical 'AND'. */
export type Commodity_Bool_Exp_Remote_Rel_Trade_Commoditycommodity = {
  _and?: InputMaybe<Array<Commodity_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Trade_Commoditycommodity>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
};

/** unique or primary key constraints on table "commodity" */
export enum Commodity_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CommodityCodenameKey = 'commodity_codename_key',
  /** unique or primary key constraint on columns "id" */
  CommodityPkey = 'commodity_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Commodity_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Commodity_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Commodity_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "commodity" */
export type Commodity_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "commodity" */
export type Commodity_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  varieties?: InputMaybe<Commodity_Variety_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Commodity_Max_Fields = {
  __typename?: 'commodity_max_fields';
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "commodity" */
export type Commodity_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Commodity_Min_Fields = {
  __typename?: 'commodity_min_fields';
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "commodity" */
export type Commodity_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "commodity" */
export type Commodity_Mutation_Response = {
  __typename?: 'commodity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Commodity>;
};

/** input type for inserting object relation for remote table "commodity" */
export type Commodity_Obj_Rel_Insert_Input = {
  data: Commodity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Commodity_On_Conflict>;
};

/** on_conflict condition type for table "commodity" */
export type Commodity_On_Conflict = {
  constraint: Commodity_Constraint;
  update_columns?: Array<Commodity_Update_Column>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};

/** Ordering options when selecting data from "commodity". */
export type Commodity_Order_By = {
  codename?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  varieties_aggregate?: InputMaybe<Commodity_Variety_Aggregate_Order_By>;
};

/** primary key columns input for table: commodity */
export type Commodity_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Commodity_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "commodity" */
export enum Commodity_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata'
}

/** input type for updating data in table "commodity" */
export type Commodity_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Commodity_Stddev_Fields = {
  __typename?: 'commodity_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "commodity" */
export type Commodity_Stddev_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Commodity_Stddev_Pop_Fields = {
  __typename?: 'commodity_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "commodity" */
export type Commodity_Stddev_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Commodity_Stddev_Samp_Fields = {
  __typename?: 'commodity_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "commodity" */
export type Commodity_Stddev_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "commodity" */
export type Commodity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Commodity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Commodity_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Commodity_Sum_Fields = {
  __typename?: 'commodity_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "commodity" */
export type Commodity_Sum_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** update columns of table "commodity" */
export enum Commodity_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata'
}

export type Commodity_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Commodity_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Commodity_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Commodity_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Commodity_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Commodity_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Commodity_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Commodity_Set_Input>;
  where: Commodity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Commodity_Var_Pop_Fields = {
  __typename?: 'commodity_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "commodity" */
export type Commodity_Var_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Commodity_Var_Samp_Fields = {
  __typename?: 'commodity_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "commodity" */
export type Commodity_Var_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Commodity_Variance_Fields = {
  __typename?: 'commodity_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "commodity" */
export type Commodity_Variance_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "commodity_variety" */
export type Commodity_Variety = {
  __typename?: 'commodity_variety';
  codename: Scalars['String'];
  /** An object relationship */
  commodity: Commodity;
  commodity_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  crop_variety?: Maybe<Crop_Variety>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  default_sku?: Maybe<Sku>;
  default_sku_id?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  /** An array relationship */
  grades: Array<Variety_Grade>;
  /** An aggregate relationship */
  grades_aggregate: Variety_Grade_Aggregate;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  primary_group?: Maybe<Variety_Group>;
  primary_group_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  /** An array relationship */
  secondary_groups: Array<Commodity_Variety_Secondary_Groups>;
  /** An aggregate relationship */
  secondary_groups_aggregate: Commodity_Variety_Secondary_Groups_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietyGradesArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietyGrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietyMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietyPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietySecondary_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietySecondary_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};

/** aggregated selection of "commodity_variety" */
export type Commodity_Variety_Aggregate = {
  __typename?: 'commodity_variety_aggregate';
  aggregate?: Maybe<Commodity_Variety_Aggregate_Fields>;
  nodes: Array<Commodity_Variety>;
};

/** aggregate fields of "commodity_variety" */
export type Commodity_Variety_Aggregate_Fields = {
  __typename?: 'commodity_variety_aggregate_fields';
  avg?: Maybe<Commodity_Variety_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Commodity_Variety_Max_Fields>;
  min?: Maybe<Commodity_Variety_Min_Fields>;
  stddev?: Maybe<Commodity_Variety_Stddev_Fields>;
  stddev_pop?: Maybe<Commodity_Variety_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Commodity_Variety_Stddev_Samp_Fields>;
  sum?: Maybe<Commodity_Variety_Sum_Fields>;
  var_pop?: Maybe<Commodity_Variety_Var_Pop_Fields>;
  var_samp?: Maybe<Commodity_Variety_Var_Samp_Fields>;
  variance?: Maybe<Commodity_Variety_Variance_Fields>;
};


/** aggregate fields of "commodity_variety" */
export type Commodity_Variety_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "commodity_variety" */
export type Commodity_Variety_Aggregate_Order_By = {
  avg?: InputMaybe<Commodity_Variety_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Commodity_Variety_Max_Order_By>;
  min?: InputMaybe<Commodity_Variety_Min_Order_By>;
  stddev?: InputMaybe<Commodity_Variety_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Commodity_Variety_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Commodity_Variety_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Commodity_Variety_Sum_Order_By>;
  var_pop?: InputMaybe<Commodity_Variety_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Commodity_Variety_Var_Samp_Order_By>;
  variance?: InputMaybe<Commodity_Variety_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Commodity_Variety_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "commodity_variety" */
export type Commodity_Variety_Arr_Rel_Insert_Input = {
  data: Array<Commodity_Variety_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Commodity_Variety_On_Conflict>;
};

/** aggregate avg on columns */
export type Commodity_Variety_Avg_Fields = {
  __typename?: 'commodity_variety_avg_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "commodity_variety" */
export type Commodity_Variety_Avg_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "commodity_variety". All fields are combined with a logical 'AND'. */
export type Commodity_Variety_Bool_Exp = {
  _and?: InputMaybe<Array<Commodity_Variety_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Variety_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Variety_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  commodity?: InputMaybe<Commodity_Bool_Exp>;
  commodity_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  default_sku?: InputMaybe<Sku_Bool_Exp>;
  default_sku_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  grades?: InputMaybe<Variety_Grade_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  primary_group?: InputMaybe<Variety_Group_Bool_Exp>;
  primary_group_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  secondary_groups?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "commodity_variety". All fields are combined with a logical 'AND'. */
export type Commodity_Variety_Bool_Exp_Remote_Rel_Shared_Entitycommodity_Variety = {
  _and?: InputMaybe<Array<Commodity_Variety_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Variety_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Variety_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitycommodity_Variety>;
  commodity?: InputMaybe<Commodity_Bool_Exp>;
  commodity_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  default_sku?: InputMaybe<Sku_Bool_Exp>;
  default_sku_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  grades?: InputMaybe<Variety_Grade_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  primary_group?: InputMaybe<Variety_Group_Bool_Exp>;
  primary_group_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  secondary_groups?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "commodity_variety" */
export enum Commodity_Variety_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CommodityVarietyCodenameKey = 'commodity_variety_codename_key',
  /** unique or primary key constraint on columns "name", "commodity_id" */
  CommodityVarietyNameCommodityId_334ca83bUniq = 'commodity_variety_name_commodity_id_334ca83b_uniq',
  /** unique or primary key constraint on columns "id" */
  CommodityVarietyPkey = 'commodity_variety_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Commodity_Variety_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Commodity_Variety_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Commodity_Variety_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "commodity_variety" */
export type Commodity_Variety_Inc_Input = {
  commodity_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  default_sku_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_group_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "commodity_variety" */
export type Commodity_Variety_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  commodity?: InputMaybe<Commodity_Obj_Rel_Insert_Input>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crop_variety?: InputMaybe<Crop_Variety_Obj_Rel_Insert_Input>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  default_sku?: InputMaybe<Sku_Obj_Rel_Insert_Input>;
  default_sku_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  grades?: InputMaybe<Variety_Grade_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_group?: InputMaybe<Variety_Group_Obj_Rel_Insert_Input>;
  primary_group_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  secondary_groups?: InputMaybe<Commodity_Variety_Secondary_Groups_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Commodity_Variety_Max_Fields = {
  __typename?: 'commodity_variety_max_fields';
  codename?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  default_sku_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_group_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "commodity_variety" */
export type Commodity_Variety_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Commodity_Variety_Min_Fields = {
  __typename?: 'commodity_variety_min_fields';
  codename?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  default_sku_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_group_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "commodity_variety" */
export type Commodity_Variety_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "commodity_variety" */
export type Commodity_Variety_Mutation_Response = {
  __typename?: 'commodity_variety_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Commodity_Variety>;
};

/** input type for inserting object relation for remote table "commodity_variety" */
export type Commodity_Variety_Obj_Rel_Insert_Input = {
  data: Commodity_Variety_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Commodity_Variety_On_Conflict>;
};

/** on_conflict condition type for table "commodity_variety" */
export type Commodity_Variety_On_Conflict = {
  constraint: Commodity_Variety_Constraint;
  update_columns?: Array<Commodity_Variety_Update_Column>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};

/** Ordering options when selecting data from "commodity_variety". */
export type Commodity_Variety_Order_By = {
  codename?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Commodity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_variety?: InputMaybe<Crop_Variety_Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku?: InputMaybe<Sku_Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  grades_aggregate?: InputMaybe<Variety_Grade_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group?: InputMaybe<Variety_Group_Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  secondary_groups_aggregate?: InputMaybe<Commodity_Variety_Secondary_Groups_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: commodity_variety */
export type Commodity_Variety_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Commodity_Variety_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups = {
  __typename?: 'commodity_variety_secondary_groups';
  /** An object relationship */
  commodity_variety: Commodity_Variety;
  commodityvariety_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  variety_group: Variety_Group;
  varietygroup_id: Scalars['Int'];
};

/** aggregated selection of "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Aggregate = {
  __typename?: 'commodity_variety_secondary_groups_aggregate';
  aggregate?: Maybe<Commodity_Variety_Secondary_Groups_Aggregate_Fields>;
  nodes: Array<Commodity_Variety_Secondary_Groups>;
};

/** aggregate fields of "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Aggregate_Fields = {
  __typename?: 'commodity_variety_secondary_groups_aggregate_fields';
  avg?: Maybe<Commodity_Variety_Secondary_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Commodity_Variety_Secondary_Groups_Max_Fields>;
  min?: Maybe<Commodity_Variety_Secondary_Groups_Min_Fields>;
  stddev?: Maybe<Commodity_Variety_Secondary_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Commodity_Variety_Secondary_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Commodity_Variety_Secondary_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Commodity_Variety_Secondary_Groups_Sum_Fields>;
  var_pop?: Maybe<Commodity_Variety_Secondary_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Commodity_Variety_Secondary_Groups_Var_Samp_Fields>;
  variance?: Maybe<Commodity_Variety_Secondary_Groups_Variance_Fields>;
};


/** aggregate fields of "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Commodity_Variety_Secondary_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Commodity_Variety_Secondary_Groups_Max_Order_By>;
  min?: InputMaybe<Commodity_Variety_Secondary_Groups_Min_Order_By>;
  stddev?: InputMaybe<Commodity_Variety_Secondary_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Commodity_Variety_Secondary_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Commodity_Variety_Secondary_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Commodity_Variety_Secondary_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Commodity_Variety_Secondary_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Commodity_Variety_Secondary_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Commodity_Variety_Secondary_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Arr_Rel_Insert_Input = {
  data: Array<Commodity_Variety_Secondary_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Commodity_Variety_Secondary_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Commodity_Variety_Secondary_Groups_Avg_Fields = {
  __typename?: 'commodity_variety_secondary_groups_avg_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Avg_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "commodity_variety_secondary_groups". All fields are combined with a logical 'AND'. */
export type Commodity_Variety_Secondary_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Bool_Exp>>;
  commodity_variety?: InputMaybe<Commodity_Variety_Bool_Exp>;
  commodityvariety_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  variety_group?: InputMaybe<Variety_Group_Bool_Exp>;
  varietygroup_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "commodity_variety_secondary_groups" */
export enum Commodity_Variety_Secondary_Groups_Constraint {
  /** unique or primary key constraint on columns "varietygroup_id", "commodityvariety_id" */
  CommodityVarietySecondCommodityvarietyIdVari_098d67c7Uniq = 'commodity_variety_second_commodityvariety_id_vari_098d67c7_uniq',
  /** unique or primary key constraint on columns "id" */
  CommodityVarietySecondaryGroupsPkey = 'commodity_variety_secondary_groups_pkey'
}

/** input type for incrementing numeric columns in table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Inc_Input = {
  commodityvariety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietygroup_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Insert_Input = {
  commodity_variety?: InputMaybe<Commodity_Variety_Obj_Rel_Insert_Input>;
  commodityvariety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  variety_group?: InputMaybe<Variety_Group_Obj_Rel_Insert_Input>;
  varietygroup_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Commodity_Variety_Secondary_Groups_Max_Fields = {
  __typename?: 'commodity_variety_secondary_groups_max_fields';
  commodityvariety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietygroup_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Max_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Commodity_Variety_Secondary_Groups_Min_Fields = {
  __typename?: 'commodity_variety_secondary_groups_min_fields';
  commodityvariety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietygroup_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Min_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Mutation_Response = {
  __typename?: 'commodity_variety_secondary_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Commodity_Variety_Secondary_Groups>;
};

/** on_conflict condition type for table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_On_Conflict = {
  constraint: Commodity_Variety_Secondary_Groups_Constraint;
  update_columns?: Array<Commodity_Variety_Secondary_Groups_Update_Column>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "commodity_variety_secondary_groups". */
export type Commodity_Variety_Secondary_Groups_Order_By = {
  commodity_variety?: InputMaybe<Commodity_Variety_Order_By>;
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  variety_group?: InputMaybe<Variety_Group_Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: commodity_variety_secondary_groups */
export type Commodity_Variety_Secondary_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "commodity_variety_secondary_groups" */
export enum Commodity_Variety_Secondary_Groups_Select_Column {
  /** column name */
  CommodityvarietyId = 'commodityvariety_id',
  /** column name */
  Id = 'id',
  /** column name */
  VarietygroupId = 'varietygroup_id'
}

/** input type for updating data in table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Set_Input = {
  commodityvariety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietygroup_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Commodity_Variety_Secondary_Groups_Stddev_Fields = {
  __typename?: 'commodity_variety_secondary_groups_stddev_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Stddev_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Commodity_Variety_Secondary_Groups_Stddev_Pop_Fields = {
  __typename?: 'commodity_variety_secondary_groups_stddev_pop_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Stddev_Pop_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Commodity_Variety_Secondary_Groups_Stddev_Samp_Fields = {
  __typename?: 'commodity_variety_secondary_groups_stddev_samp_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Stddev_Samp_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Commodity_Variety_Secondary_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Commodity_Variety_Secondary_Groups_Stream_Cursor_Value_Input = {
  commodityvariety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietygroup_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Commodity_Variety_Secondary_Groups_Sum_Fields = {
  __typename?: 'commodity_variety_secondary_groups_sum_fields';
  commodityvariety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietygroup_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Sum_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** update columns of table "commodity_variety_secondary_groups" */
export enum Commodity_Variety_Secondary_Groups_Update_Column {
  /** column name */
  CommodityvarietyId = 'commodityvariety_id',
  /** column name */
  Id = 'id',
  /** column name */
  VarietygroupId = 'varietygroup_id'
}

export type Commodity_Variety_Secondary_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Commodity_Variety_Secondary_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Commodity_Variety_Secondary_Groups_Set_Input>;
  where: Commodity_Variety_Secondary_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Commodity_Variety_Secondary_Groups_Var_Pop_Fields = {
  __typename?: 'commodity_variety_secondary_groups_var_pop_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Var_Pop_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Commodity_Variety_Secondary_Groups_Var_Samp_Fields = {
  __typename?: 'commodity_variety_secondary_groups_var_samp_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Var_Samp_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Commodity_Variety_Secondary_Groups_Variance_Fields = {
  __typename?: 'commodity_variety_secondary_groups_variance_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Variance_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** select columns of table "commodity_variety" */
export enum Commodity_Variety_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  DefaultSkuId = 'default_sku_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrimaryGroupId = 'primary_group_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "commodity_variety" */
export type Commodity_Variety_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  default_sku_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_group_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Commodity_Variety_Stddev_Fields = {
  __typename?: 'commodity_variety_stddev_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "commodity_variety" */
export type Commodity_Variety_Stddev_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Commodity_Variety_Stddev_Pop_Fields = {
  __typename?: 'commodity_variety_stddev_pop_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "commodity_variety" */
export type Commodity_Variety_Stddev_Pop_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Commodity_Variety_Stddev_Samp_Fields = {
  __typename?: 'commodity_variety_stddev_samp_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "commodity_variety" */
export type Commodity_Variety_Stddev_Samp_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "commodity_variety" */
export type Commodity_Variety_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Commodity_Variety_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Commodity_Variety_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  default_sku_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_group_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Commodity_Variety_Sum_Fields = {
  __typename?: 'commodity_variety_sum_fields';
  commodity_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  default_sku_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_group_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "commodity_variety" */
export type Commodity_Variety_Sum_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** update columns of table "commodity_variety" */
export enum Commodity_Variety_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  DefaultSkuId = 'default_sku_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrimaryGroupId = 'primary_group_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Commodity_Variety_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Commodity_Variety_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Commodity_Variety_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Commodity_Variety_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Commodity_Variety_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Commodity_Variety_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Commodity_Variety_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Commodity_Variety_Set_Input>;
  where: Commodity_Variety_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Commodity_Variety_Var_Pop_Fields = {
  __typename?: 'commodity_variety_var_pop_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "commodity_variety" */
export type Commodity_Variety_Var_Pop_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Commodity_Variety_Var_Samp_Fields = {
  __typename?: 'commodity_variety_var_samp_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "commodity_variety" */
export type Commodity_Variety_Var_Samp_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Commodity_Variety_Variance_Fields = {
  __typename?: 'commodity_variety_variance_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "commodity_variety" */
export type Commodity_Variety_Variance_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "common_fileupload" */
export type Common_Fileupload = {
  __typename?: 'common_fileupload';
  access: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  duration: Scalars['Int'];
  extension?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  is_encrypted: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  media_type: Scalars['String'];
  name: Scalars['String'];
  thumbnail_url?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  url: Scalars['String'];
};

/** aggregated selection of "common_fileupload" */
export type Common_Fileupload_Aggregate = {
  __typename?: 'common_fileupload_aggregate';
  aggregate?: Maybe<Common_Fileupload_Aggregate_Fields>;
  nodes: Array<Common_Fileupload>;
};

/** aggregate fields of "common_fileupload" */
export type Common_Fileupload_Aggregate_Fields = {
  __typename?: 'common_fileupload_aggregate_fields';
  avg?: Maybe<Common_Fileupload_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Common_Fileupload_Max_Fields>;
  min?: Maybe<Common_Fileupload_Min_Fields>;
  stddev?: Maybe<Common_Fileupload_Stddev_Fields>;
  stddev_pop?: Maybe<Common_Fileupload_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Common_Fileupload_Stddev_Samp_Fields>;
  sum?: Maybe<Common_Fileupload_Sum_Fields>;
  var_pop?: Maybe<Common_Fileupload_Var_Pop_Fields>;
  var_samp?: Maybe<Common_Fileupload_Var_Samp_Fields>;
  variance?: Maybe<Common_Fileupload_Variance_Fields>;
};


/** aggregate fields of "common_fileupload" */
export type Common_Fileupload_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Common_Fileupload_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Common_Fileupload_Avg_Fields = {
  __typename?: 'common_fileupload_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "common_fileupload". All fields are combined with a logical 'AND'. */
export type Common_Fileupload_Bool_Exp = {
  _and?: InputMaybe<Array<Common_Fileupload_Bool_Exp>>;
  _not?: InputMaybe<Common_Fileupload_Bool_Exp>;
  _or?: InputMaybe<Array<Common_Fileupload_Bool_Exp>>;
  access?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_encrypted?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  media_type?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  thumbnail_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "common_fileupload" */
export enum Common_Fileupload_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommonFileuploadPkey = 'common_fileupload_pkey'
}

/** input type for incrementing numeric columns in table "common_fileupload" */
export type Common_Fileupload_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "common_fileupload" */
export type Common_Fileupload_Insert_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  extension?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  media_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  thumbnail_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Common_Fileupload_Max_Fields = {
  __typename?: 'common_fileupload_max_fields';
  access?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  language?: Maybe<Scalars['String']>;
  media_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  thumbnail_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Common_Fileupload_Min_Fields = {
  __typename?: 'common_fileupload_min_fields';
  access?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  language?: Maybe<Scalars['String']>;
  media_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  thumbnail_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "common_fileupload" */
export type Common_Fileupload_Mutation_Response = {
  __typename?: 'common_fileupload_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Common_Fileupload>;
};

/** input type for inserting object relation for remote table "common_fileupload" */
export type Common_Fileupload_Obj_Rel_Insert_Input = {
  data: Common_Fileupload_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Common_Fileupload_On_Conflict>;
};

/** on_conflict condition type for table "common_fileupload" */
export type Common_Fileupload_On_Conflict = {
  constraint: Common_Fileupload_Constraint;
  update_columns?: Array<Common_Fileupload_Update_Column>;
  where?: InputMaybe<Common_Fileupload_Bool_Exp>;
};

/** Ordering options when selecting data from "common_fileupload". */
export type Common_Fileupload_Order_By = {
  access?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_encrypted?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  media_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  thumbnail_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: common_fileupload */
export type Common_Fileupload_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "common_fileupload" */
export enum Common_Fileupload_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  Extension = 'extension',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  Language = 'language',
  /** column name */
  MediaType = 'media_type',
  /** column name */
  Name = 'name',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "common_fileupload" */
export type Common_Fileupload_Set_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  extension?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  media_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  thumbnail_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Common_Fileupload_Stddev_Fields = {
  __typename?: 'common_fileupload_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Common_Fileupload_Stddev_Pop_Fields = {
  __typename?: 'common_fileupload_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Common_Fileupload_Stddev_Samp_Fields = {
  __typename?: 'common_fileupload_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "common_fileupload" */
export type Common_Fileupload_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Common_Fileupload_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Common_Fileupload_Stream_Cursor_Value_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  extension?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  media_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  thumbnail_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Common_Fileupload_Sum_Fields = {
  __typename?: 'common_fileupload_sum_fields';
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "common_fileupload" */
export enum Common_Fileupload_Update_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  Extension = 'extension',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  Language = 'language',
  /** column name */
  MediaType = 'media_type',
  /** column name */
  Name = 'name',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

export type Common_Fileupload_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Common_Fileupload_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Common_Fileupload_Set_Input>;
  where: Common_Fileupload_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Common_Fileupload_Var_Pop_Fields = {
  __typename?: 'common_fileupload_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Common_Fileupload_Var_Samp_Fields = {
  __typename?: 'common_fileupload_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Common_Fileupload_Variance_Fields = {
  __typename?: 'common_fileupload_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "company" */
export type Company = {
  __typename?: 'company';
  abbreviation: Scalars['String'];
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  agents: Array<Agent_Company>;
  /** An aggregate relationship */
  agents_aggregate: Agent_Company_Aggregate;
  /** An array relationship */
  base_user_companies: Array<Base_User_Companies>;
  /** An aggregate relationship */
  base_user_companies_aggregate: Base_User_Companies_Aggregate;
  codename: Scalars['String'];
  description: Scalars['String'];
  display_name: Scalars['String'];
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Network>;
  /** An aggregate relationship */
  networks_aggregate: Network_Aggregate;
  number?: Maybe<Scalars['String']>;
  /** An object relationship */
  organisation?: Maybe<Organisation>;
  organisation_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};


/** columns and relationships of "company" */
export type CompanyAgentsArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyAgents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyBase_User_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyBase_User_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "company" */
export type CompanyNetworksArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};

/** aggregated selection of "company" */
export type Company_Aggregate = {
  __typename?: 'company_aggregate';
  aggregate?: Maybe<Company_Aggregate_Fields>;
  nodes: Array<Company>;
};

/** aggregate fields of "company" */
export type Company_Aggregate_Fields = {
  __typename?: 'company_aggregate_fields';
  avg?: Maybe<Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Company_Max_Fields>;
  min?: Maybe<Company_Min_Fields>;
  stddev?: Maybe<Company_Stddev_Fields>;
  stddev_pop?: Maybe<Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Company_Stddev_Samp_Fields>;
  sum?: Maybe<Company_Sum_Fields>;
  var_pop?: Maybe<Company_Var_Pop_Fields>;
  var_samp?: Maybe<Company_Var_Samp_Fields>;
  variance?: Maybe<Company_Variance_Fields>;
};


/** aggregate fields of "company" */
export type Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company" */
export type Company_Aggregate_Order_By = {
  avg?: InputMaybe<Company_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Company_Max_Order_By>;
  min?: InputMaybe<Company_Min_Order_By>;
  stddev?: InputMaybe<Company_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Company_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Company_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Company_Sum_Order_By>;
  var_pop?: InputMaybe<Company_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Company_Var_Samp_Order_By>;
  variance?: InputMaybe<Company_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "company" */
export type Company_Arr_Rel_Insert_Input = {
  data: Array<Company_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Company_On_Conflict>;
};

/** aggregate avg on columns */
export type Company_Avg_Fields = {
  __typename?: 'company_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "company" */
export type Company_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type Company_Bool_Exp = {
  _and?: InputMaybe<Array<Company_Bool_Exp>>;
  _not?: InputMaybe<Company_Bool_Exp>;
  _or?: InputMaybe<Array<Company_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  agents?: InputMaybe<Agent_Company_Bool_Exp>;
  base_user_companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  purpose?: InputMaybe<String_Comparison_Exp>;
  tnc?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type Company_Bool_Exp_Remote_Rel_Shared_Entityfacilitator = {
  _and?: InputMaybe<Array<Company_Bool_Exp>>;
  _not?: InputMaybe<Company_Bool_Exp>;
  _or?: InputMaybe<Array<Company_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  agents?: InputMaybe<Agent_Company_Bool_Exp>;
  base_user_companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityfacilitator>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  purpose?: InputMaybe<String_Comparison_Exp>;
  tnc?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "company" */
export enum Company_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CompanyCodenameKey = 'company_codename_key',
  /** unique or primary key constraint on columns "name", "organisation_id" */
  CompanyNameOrganisationIdC0e88d5cUniq = 'company_name_organisation_id_c0e88d5c_uniq',
  /** unique or primary key constraint on columns "photo_id" */
  CompanyPhotoId_6586c362Uniq = 'company_photo_id_6586c362_uniq',
  /** unique or primary key constraint on columns "id" */
  CompanyPkey = 'company_pkey',
  /** unique or primary key constraint on columns "uid" */
  CompanyUidKey = 'company_uid_key'
}

/** input type for incrementing numeric columns in table "company" */
export type Company_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company" */
export type Company_Insert_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  agents?: InputMaybe<Agent_Company_Arr_Rel_Insert_Input>;
  base_user_companies?: InputMaybe<Base_User_Companies_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Network_Arr_Rel_Insert_Input>;
  number?: InputMaybe<Scalars['String']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Company_Max_Fields = {
  __typename?: 'company_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "company" */
export type Company_Max_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
  tnc?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Company_Min_Fields = {
  __typename?: 'company_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "company" */
export type Company_Min_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
  tnc?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "company" */
export type Company_Mutation_Response = {
  __typename?: 'company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company>;
};

/** input type for inserting object relation for remote table "company" */
export type Company_Obj_Rel_Insert_Input = {
  data: Company_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Company_On_Conflict>;
};

/** on_conflict condition type for table "company" */
export type Company_On_Conflict = {
  constraint: Company_Constraint;
  update_columns?: Array<Company_Update_Column>;
  where?: InputMaybe<Company_Bool_Exp>;
};

/** Ordering options when selecting data from "company". */
export type Company_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  agents_aggregate?: InputMaybe<Agent_Company_Aggregate_Order_By>;
  base_user_companies_aggregate?: InputMaybe<Base_User_Companies_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Network_Aggregate_Order_By>;
  number?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
  tnc?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: company */
export type Company_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "company" */
export enum Company_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  Tnc = 'tnc',
  /** column name */
  Uid = 'uid'
}

/** input type for updating data in table "company" */
export type Company_Set_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Company_Stddev_Fields = {
  __typename?: 'company_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "company" */
export type Company_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Company_Stddev_Pop_Fields = {
  __typename?: 'company_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "company" */
export type Company_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Company_Stddev_Samp_Fields = {
  __typename?: 'company_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "company" */
export type Company_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "company" */
export type Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Company_Sum_Fields = {
  __typename?: 'company_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "company" */
export type Company_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** update columns of table "company" */
export enum Company_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  Tnc = 'tnc',
  /** column name */
  Uid = 'uid'
}

export type Company_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Company_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Company_Set_Input>;
  where: Company_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Company_Var_Pop_Fields = {
  __typename?: 'company_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "company" */
export type Company_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Company_Var_Samp_Fields = {
  __typename?: 'company_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "company" */
export type Company_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Company_Variance_Fields = {
  __typename?: 'company_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "company" */
export type Company_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "cost_item" */
export type Cost_Item = {
  __typename?: 'cost_item';
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  item: Scalars['String'];
  /** An array relationship */
  operation_costs: Array<Operation_Cost>;
  /** An aggregate relationship */
  operation_costs_aggregate: Operation_Cost_Aggregate;
  transaction_key?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
};


/** columns and relationships of "cost_item" */
export type Cost_ItemCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Cost_Itemcreator>;
};


/** columns and relationships of "cost_item" */
export type Cost_ItemOperation_CostsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Order_By>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


/** columns and relationships of "cost_item" */
export type Cost_ItemOperation_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Order_By>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


/** columns and relationships of "cost_item" */
export type Cost_ItemUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Cost_Itemupdater>;
};

/** aggregated selection of "cost_item" */
export type Cost_Item_Aggregate = {
  __typename?: 'cost_item_aggregate';
  aggregate?: Maybe<Cost_Item_Aggregate_Fields>;
  nodes: Array<Cost_Item>;
};

/** aggregate fields of "cost_item" */
export type Cost_Item_Aggregate_Fields = {
  __typename?: 'cost_item_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Cost_Item_Max_Fields>;
  min?: Maybe<Cost_Item_Min_Fields>;
};


/** aggregate fields of "cost_item" */
export type Cost_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cost_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cost_item". All fields are combined with a logical 'AND'. */
export type Cost_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Cost_Item_Bool_Exp>>;
  _not?: InputMaybe<Cost_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Cost_Item_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  item?: InputMaybe<String_Comparison_Exp>;
  operation_costs?: InputMaybe<Operation_Cost_Bool_Exp>;
  transaction_key?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cost_item" */
export enum Cost_Item_Constraint {
  /** unique or primary key constraint on columns "item" */
  CostItemItemKey = 'cost_item_item_key',
  /** unique or primary key constraint on columns "id" */
  CostItemPkey = 'cost_item_pkey'
}

/** input type for inserting data into table "cost_item" */
export type Cost_Item_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  item?: InputMaybe<Scalars['String']>;
  operation_costs?: InputMaybe<Operation_Cost_Arr_Rel_Insert_Input>;
  transaction_key?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cost_Item_Max_Fields = {
  __typename?: 'cost_item_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  item?: Maybe<Scalars['String']>;
  transaction_key?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cost_Item_Min_Fields = {
  __typename?: 'cost_item_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  item?: Maybe<Scalars['String']>;
  transaction_key?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cost_item" */
export type Cost_Item_Mutation_Response = {
  __typename?: 'cost_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cost_Item>;
};

/** input type for inserting object relation for remote table "cost_item" */
export type Cost_Item_Obj_Rel_Insert_Input = {
  data: Cost_Item_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cost_Item_On_Conflict>;
};

/** on_conflict condition type for table "cost_item" */
export type Cost_Item_On_Conflict = {
  constraint: Cost_Item_Constraint;
  update_columns?: Array<Cost_Item_Update_Column>;
  where?: InputMaybe<Cost_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "cost_item". */
export type Cost_Item_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  item?: InputMaybe<Order_By>;
  operation_costs_aggregate?: InputMaybe<Operation_Cost_Aggregate_Order_By>;
  transaction_key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cost_item */
export type Cost_Item_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cost_item" */
export enum Cost_Item_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Item = 'item',
  /** column name */
  TransactionKey = 'transaction_key',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "cost_item" */
export type Cost_Item_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  item?: InputMaybe<Scalars['String']>;
  transaction_key?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cost_item" */
export type Cost_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cost_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cost_Item_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  item?: InputMaybe<Scalars['String']>;
  transaction_key?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cost_item" */
export enum Cost_Item_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Item = 'item',
  /** column name */
  TransactionKey = 'transaction_key',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Cost_Item_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cost_Item_Set_Input>;
  where: Cost_Item_Bool_Exp;
};

/** columns and relationships of "crop" */
export type Crop = {
  __typename?: 'crop';
  codename: Scalars['String'];
  /** An array relationship */
  commodities: Array<Commodity>;
  /** An aggregate relationship */
  commodities_aggregate: Commodity_Aggregate;
  description: Scalars['String'];
  group_id?: Maybe<Scalars['Int']>;
  hex_color_code: Scalars['String'];
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  varieties: Array<Crop_Variety>;
  /** An aggregate relationship */
  varieties_aggregate: Crop_Variety_Aggregate;
};


/** columns and relationships of "crop" */
export type CropCommoditiesArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


/** columns and relationships of "crop" */
export type CropCommodities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


/** columns and relationships of "crop" */
export type CropVarietiesArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


/** columns and relationships of "crop" */
export type CropVarieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** aggregated selection of "crop" */
export type Crop_Aggregate = {
  __typename?: 'crop_aggregate';
  aggregate?: Maybe<Crop_Aggregate_Fields>;
  nodes: Array<Crop>;
};

/** aggregate fields of "crop" */
export type Crop_Aggregate_Fields = {
  __typename?: 'crop_aggregate_fields';
  avg?: Maybe<Crop_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Max_Fields>;
  min?: Maybe<Crop_Min_Fields>;
  stddev?: Maybe<Crop_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Sum_Fields>;
  var_pop?: Maybe<Crop_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Var_Samp_Fields>;
  variance?: Maybe<Crop_Variance_Fields>;
};


/** aggregate fields of "crop" */
export type Crop_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Crop_Avg_Fields = {
  __typename?: 'crop_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop". All fields are combined with a logical 'AND'. */
export type Crop_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Bool_Exp>>;
  _not?: InputMaybe<Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  commodities?: InputMaybe<Commodity_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hex_color_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  varieties?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "crop". All fields are combined with a logical 'AND'. */
export type Crop_Bool_Exp_Remote_Rel_Article_Cropscrop = {
  _and?: InputMaybe<Array<Crop_Bool_Exp>>;
  _not?: InputMaybe<Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Article_Cropscrop>;
  commodities?: InputMaybe<Commodity_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hex_color_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  varieties?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "crop". All fields are combined with a logical 'AND'. */
export type Crop_Bool_Exp_Remote_Rel_Crop_Fertiliserscrop = {
  _and?: InputMaybe<Array<Crop_Bool_Exp>>;
  _not?: InputMaybe<Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Crop_Fertiliserscrop>;
  commodities?: InputMaybe<Commodity_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hex_color_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  varieties?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "crop". All fields are combined with a logical 'AND'. */
export type Crop_Bool_Exp_Remote_Rel_Crop_Operation_Methodscrop = {
  _and?: InputMaybe<Array<Crop_Bool_Exp>>;
  _not?: InputMaybe<Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Crop_Operation_Methodscrop>;
  commodities?: InputMaybe<Commodity_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hex_color_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  varieties?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "crop". All fields are combined with a logical 'AND'. */
export type Crop_Bool_Exp_Remote_Rel_Crop_Pesticidescrop = {
  _and?: InputMaybe<Array<Crop_Bool_Exp>>;
  _not?: InputMaybe<Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Crop_Pesticidescrop>;
  commodities?: InputMaybe<Commodity_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hex_color_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  varieties?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "crop". All fields are combined with a logical 'AND'. */
export type Crop_Bool_Exp_Remote_Rel_Cropmonitoring_Parametercrop = {
  _and?: InputMaybe<Array<Crop_Bool_Exp>>;
  _not?: InputMaybe<Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Cropmonitoring_Parametercrop>;
  commodities?: InputMaybe<Commodity_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hex_color_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  varieties?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "crop". All fields are combined with a logical 'AND'. */
export type Crop_Bool_Exp_Remote_Rel_Series_Cropscrop = {
  _and?: InputMaybe<Array<Crop_Bool_Exp>>;
  _not?: InputMaybe<Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Series_Cropscrop>;
  commodities?: InputMaybe<Commodity_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hex_color_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  varieties?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "crop". All fields are combined with a logical 'AND'. */
export type Crop_Bool_Exp_Remote_Rel_Shared_Entitycrop = {
  _and?: InputMaybe<Array<Crop_Bool_Exp>>;
  _not?: InputMaybe<Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitycrop>;
  commodities?: InputMaybe<Commodity_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hex_color_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  varieties?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** unique or primary key constraints on table "crop" */
export enum Crop_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CropCodenameKey = 'crop_codename_key',
  /** unique or primary key constraint on columns "id" */
  CropPkey = 'crop_pkey'
}

/** columns and relationships of "crop_fertilisers" */
export type Crop_Fertilisers = {
  __typename?: 'crop_fertilisers';
  crop: Array<Crop>;
  crop_id: Scalars['String'];
  fertiliser_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  products_fertiliser: Products_Fertiliser;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "crop_fertilisers" */
export type Crop_FertilisersCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp_Remote_Rel_Crop_Fertiliserscrop>;
};

/** aggregated selection of "crop_fertilisers" */
export type Crop_Fertilisers_Aggregate = {
  __typename?: 'crop_fertilisers_aggregate';
  aggregate?: Maybe<Crop_Fertilisers_Aggregate_Fields>;
  nodes: Array<Crop_Fertilisers>;
};

/** aggregate fields of "crop_fertilisers" */
export type Crop_Fertilisers_Aggregate_Fields = {
  __typename?: 'crop_fertilisers_aggregate_fields';
  avg?: Maybe<Crop_Fertilisers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Fertilisers_Max_Fields>;
  min?: Maybe<Crop_Fertilisers_Min_Fields>;
  stddev?: Maybe<Crop_Fertilisers_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Fertilisers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Fertilisers_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Fertilisers_Sum_Fields>;
  var_pop?: Maybe<Crop_Fertilisers_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Fertilisers_Var_Samp_Fields>;
  variance?: Maybe<Crop_Fertilisers_Variance_Fields>;
};


/** aggregate fields of "crop_fertilisers" */
export type Crop_Fertilisers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Fertilisers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "crop_fertilisers" */
export type Crop_Fertilisers_Aggregate_Order_By = {
  avg?: InputMaybe<Crop_Fertilisers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Fertilisers_Max_Order_By>;
  min?: InputMaybe<Crop_Fertilisers_Min_Order_By>;
  stddev?: InputMaybe<Crop_Fertilisers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crop_Fertilisers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crop_Fertilisers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crop_Fertilisers_Sum_Order_By>;
  var_pop?: InputMaybe<Crop_Fertilisers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crop_Fertilisers_Var_Samp_Order_By>;
  variance?: InputMaybe<Crop_Fertilisers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "crop_fertilisers" */
export type Crop_Fertilisers_Arr_Rel_Insert_Input = {
  data: Array<Crop_Fertilisers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Fertilisers_On_Conflict>;
};

/** aggregate avg on columns */
export type Crop_Fertilisers_Avg_Fields = {
  __typename?: 'crop_fertilisers_avg_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "crop_fertilisers" */
export type Crop_Fertilisers_Avg_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "crop_fertilisers". All fields are combined with a logical 'AND'. */
export type Crop_Fertilisers_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Fertilisers_Bool_Exp>>;
  _not?: InputMaybe<Crop_Fertilisers_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Fertilisers_Bool_Exp>>;
  crop_id?: InputMaybe<String_Comparison_Exp>;
  fertiliser_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Bool_Exp>;
  shared_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_fertilisers" */
export enum Crop_Fertilisers_Constraint {
  /** unique or primary key constraint on columns "fertiliser_id", "crop_id" */
  CropFertilisersCropIdFertilizerIdC6bfd082Uniq = 'crop_fertilisers_crop_id_fertilizer_id_c6bfd082_uniq',
  /** unique or primary key constraint on columns "id" */
  CropFertilisersPkey = 'crop_fertilisers_pkey'
}

/** input type for incrementing numeric columns in table "crop_fertilisers" */
export type Crop_Fertilisers_Inc_Input = {
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "crop_fertilisers" */
export type Crop_Fertilisers_Insert_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  fertiliser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Obj_Rel_Insert_Input>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Crop_Fertilisers_Max_Fields = {
  __typename?: 'crop_fertilisers_max_fields';
  crop_id?: Maybe<Scalars['String']>;
  fertiliser_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "crop_fertilisers" */
export type Crop_Fertilisers_Max_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  fertiliser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Fertilisers_Min_Fields = {
  __typename?: 'crop_fertilisers_min_fields';
  crop_id?: Maybe<Scalars['String']>;
  fertiliser_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "crop_fertilisers" */
export type Crop_Fertilisers_Min_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  fertiliser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_fertilisers" */
export type Crop_Fertilisers_Mutation_Response = {
  __typename?: 'crop_fertilisers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Fertilisers>;
};

/** on_conflict condition type for table "crop_fertilisers" */
export type Crop_Fertilisers_On_Conflict = {
  constraint: Crop_Fertilisers_Constraint;
  update_columns?: Array<Crop_Fertilisers_Update_Column>;
  where?: InputMaybe<Crop_Fertilisers_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_fertilisers". */
export type Crop_Fertilisers_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  fertiliser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_fertilisers */
export type Crop_Fertilisers_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "crop_fertilisers" */
export enum Crop_Fertilisers_Select_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  FertiliserId = 'fertiliser_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SharedCropId = 'shared_crop_id'
}

/** input type for updating data in table "crop_fertilisers" */
export type Crop_Fertilisers_Set_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  fertiliser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Crop_Fertilisers_Stddev_Fields = {
  __typename?: 'crop_fertilisers_stddev_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "crop_fertilisers" */
export type Crop_Fertilisers_Stddev_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Crop_Fertilisers_Stddev_Pop_Fields = {
  __typename?: 'crop_fertilisers_stddev_pop_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "crop_fertilisers" */
export type Crop_Fertilisers_Stddev_Pop_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Crop_Fertilisers_Stddev_Samp_Fields = {
  __typename?: 'crop_fertilisers_stddev_samp_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "crop_fertilisers" */
export type Crop_Fertilisers_Stddev_Samp_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "crop_fertilisers" */
export type Crop_Fertilisers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Fertilisers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Fertilisers_Stream_Cursor_Value_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  fertiliser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Crop_Fertilisers_Sum_Fields = {
  __typename?: 'crop_fertilisers_sum_fields';
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "crop_fertilisers" */
export type Crop_Fertilisers_Sum_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "crop_fertilisers" */
export enum Crop_Fertilisers_Update_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  FertiliserId = 'fertiliser_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SharedCropId = 'shared_crop_id'
}

export type Crop_Fertilisers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Fertilisers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Fertilisers_Set_Input>;
  where: Crop_Fertilisers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Fertilisers_Var_Pop_Fields = {
  __typename?: 'crop_fertilisers_var_pop_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "crop_fertilisers" */
export type Crop_Fertilisers_Var_Pop_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Crop_Fertilisers_Var_Samp_Fields = {
  __typename?: 'crop_fertilisers_var_samp_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "crop_fertilisers" */
export type Crop_Fertilisers_Var_Samp_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Crop_Fertilisers_Variance_Fields = {
  __typename?: 'crop_fertilisers_variance_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "crop_fertilisers" */
export type Crop_Fertilisers_Variance_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "crop_group" */
export type Crop_Group = {
  __typename?: 'crop_group';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_perennial: Scalars['Boolean'];
  name: Scalars['String'];
  photo_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "crop_group" */
export type Crop_Group_Aggregate = {
  __typename?: 'crop_group_aggregate';
  aggregate?: Maybe<Crop_Group_Aggregate_Fields>;
  nodes: Array<Crop_Group>;
};

/** aggregate fields of "crop_group" */
export type Crop_Group_Aggregate_Fields = {
  __typename?: 'crop_group_aggregate_fields';
  avg?: Maybe<Crop_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Group_Max_Fields>;
  min?: Maybe<Crop_Group_Min_Fields>;
  stddev?: Maybe<Crop_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Group_Sum_Fields>;
  var_pop?: Maybe<Crop_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Group_Var_Samp_Fields>;
  variance?: Maybe<Crop_Group_Variance_Fields>;
};


/** aggregate fields of "crop_group" */
export type Crop_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Crop_Group_Avg_Fields = {
  __typename?: 'crop_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop_group". All fields are combined with a logical 'AND'. */
export type Crop_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Group_Bool_Exp>>;
  _not?: InputMaybe<Crop_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Group_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_perennial?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "crop_group". All fields are combined with a logical 'AND'. */
export type Crop_Group_Bool_Exp_Remote_Rel_Article_Crop_Categoriescrop_Group = {
  _and?: InputMaybe<Array<Crop_Group_Bool_Exp>>;
  _not?: InputMaybe<Crop_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Group_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Article_Crop_Categoriescrop_Group>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_perennial?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_group" */
export enum Crop_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CropGroupCodenameKey = 'crop_group_codename_key',
  /** unique or primary key constraint on columns "name" */
  CropGroupNameKey = 'crop_group_name_key',
  /** unique or primary key constraint on columns "id" */
  CropGroupPkey = 'crop_group_pkey'
}

/** input type for incrementing numeric columns in table "crop_group" */
export type Crop_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_group" */
export type Crop_Group_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_perennial?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Crop_Group_Max_Fields = {
  __typename?: 'crop_group_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Crop_Group_Min_Fields = {
  __typename?: 'crop_group_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "crop_group" */
export type Crop_Group_Mutation_Response = {
  __typename?: 'crop_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Group>;
};

/** on_conflict condition type for table "crop_group" */
export type Crop_Group_On_Conflict = {
  constraint: Crop_Group_Constraint;
  update_columns?: Array<Crop_Group_Update_Column>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_group". */
export type Crop_Group_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_perennial?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_group */
export type Crop_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_group" */
export enum Crop_Group_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPerennial = 'is_perennial',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

/** input type for updating data in table "crop_group" */
export type Crop_Group_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_perennial?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Crop_Group_Stddev_Fields = {
  __typename?: 'crop_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Group_Stddev_Pop_Fields = {
  __typename?: 'crop_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Group_Stddev_Samp_Fields = {
  __typename?: 'crop_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop_group" */
export type Crop_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Group_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_perennial?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Crop_Group_Sum_Fields = {
  __typename?: 'crop_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop_group" */
export enum Crop_Group_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPerennial = 'is_perennial',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

export type Crop_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Group_Set_Input>;
  where: Crop_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Group_Var_Pop_Fields = {
  __typename?: 'crop_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Group_Var_Samp_Fields = {
  __typename?: 'crop_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Group_Variance_Fields = {
  __typename?: 'crop_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "crop" */
export type Crop_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "crop_infestation" */
export type Crop_Infestation = {
  __typename?: 'crop_infestation';
  affects?: Maybe<Scalars['String']>;
  biological_measures?: Maybe<Scalars['String']>;
  chemical_measures?: Maybe<Scalars['String']>;
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  /** An array relationship */
  crop_infestation_attachments: Array<Crop_Infestation_Attachment>;
  /** An aggregate relationship */
  crop_infestation_attachments_aggregate: Crop_Infestation_Attachment_Aggregate;
  cultural_measures?: Maybe<Scalars['String']>;
  damage_nature?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  infestation: Infestation;
  infestation_id: Scalars['Int'];
  infestation_period?: Maybe<Scalars['String']>;
  infestation_stage?: Maybe<Scalars['String']>;
  mechanical_measures?: Maybe<Scalars['String']>;
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  quality_impact?: Maybe<Scalars['String']>;
  quantity_impact?: Maybe<Scalars['String']>;
  scientific_name?: Maybe<Scalars['String']>;
  severity: Scalars['String'];
  symptoms?: Maybe<Scalars['String']>;
  weather_conditions?: Maybe<Scalars['String']>;
};


/** columns and relationships of "crop_infestation" */
export type Crop_InfestationCrop_Infestation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


/** columns and relationships of "crop_infestation" */
export type Crop_InfestationCrop_Infestation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};

/** aggregated selection of "crop_infestation" */
export type Crop_Infestation_Aggregate = {
  __typename?: 'crop_infestation_aggregate';
  aggregate?: Maybe<Crop_Infestation_Aggregate_Fields>;
  nodes: Array<Crop_Infestation>;
};

/** aggregate fields of "crop_infestation" */
export type Crop_Infestation_Aggregate_Fields = {
  __typename?: 'crop_infestation_aggregate_fields';
  avg?: Maybe<Crop_Infestation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Infestation_Max_Fields>;
  min?: Maybe<Crop_Infestation_Min_Fields>;
  stddev?: Maybe<Crop_Infestation_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Infestation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Infestation_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Infestation_Sum_Fields>;
  var_pop?: Maybe<Crop_Infestation_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Infestation_Var_Samp_Fields>;
  variance?: Maybe<Crop_Infestation_Variance_Fields>;
};


/** aggregate fields of "crop_infestation" */
export type Crop_Infestation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Infestation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "crop_infestation_attachment" */
export type Crop_Infestation_Attachment = {
  __typename?: 'crop_infestation_attachment';
  attachment_id: Scalars['Int'];
  /** An object relationship */
  crop_infestation: Crop_Infestation;
  crop_infestation_id: Scalars['Int'];
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  order: Scalars['smallint'];
  /** An object relationship */
  photo: Media;
};

/** aggregated selection of "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Aggregate = {
  __typename?: 'crop_infestation_attachment_aggregate';
  aggregate?: Maybe<Crop_Infestation_Attachment_Aggregate_Fields>;
  nodes: Array<Crop_Infestation_Attachment>;
};

/** aggregate fields of "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Aggregate_Fields = {
  __typename?: 'crop_infestation_attachment_aggregate_fields';
  avg?: Maybe<Crop_Infestation_Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Infestation_Attachment_Max_Fields>;
  min?: Maybe<Crop_Infestation_Attachment_Min_Fields>;
  stddev?: Maybe<Crop_Infestation_Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Infestation_Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Infestation_Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Infestation_Attachment_Sum_Fields>;
  var_pop?: Maybe<Crop_Infestation_Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Infestation_Attachment_Var_Samp_Fields>;
  variance?: Maybe<Crop_Infestation_Attachment_Variance_Fields>;
};


/** aggregate fields of "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Crop_Infestation_Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Infestation_Attachment_Max_Order_By>;
  min?: InputMaybe<Crop_Infestation_Attachment_Min_Order_By>;
  stddev?: InputMaybe<Crop_Infestation_Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crop_Infestation_Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crop_Infestation_Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crop_Infestation_Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Crop_Infestation_Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crop_Infestation_Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Crop_Infestation_Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Crop_Infestation_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Infestation_Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Crop_Infestation_Attachment_Avg_Fields = {
  __typename?: 'crop_infestation_attachment_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "crop_infestation_attachment". All fields are combined with a logical 'AND'. */
export type Crop_Infestation_Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Infestation_Attachment_Bool_Exp>>;
  _not?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Infestation_Attachment_Bool_Exp>>;
  attachment_id?: InputMaybe<Int_Comparison_Exp>;
  crop_infestation?: InputMaybe<Crop_Infestation_Bool_Exp>;
  crop_infestation_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
};

/** unique or primary key constraints on table "crop_infestation_attachment" */
export enum Crop_Infestation_Attachment_Constraint {
  /** unique or primary key constraint on columns "id" */
  CropInfestationAttachmentPkey = 'crop_infestation_attachment_pkey'
}

/** input type for incrementing numeric columns in table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['Int']>;
  crop_infestation_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['Int']>;
  crop_infestation?: InputMaybe<Crop_Infestation_Obj_Rel_Insert_Input>;
  crop_infestation_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Crop_Infestation_Attachment_Max_Fields = {
  __typename?: 'crop_infestation_attachment_max_fields';
  attachment_id?: Maybe<Scalars['Int']>;
  crop_infestation_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by max() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Infestation_Attachment_Min_Fields = {
  __typename?: 'crop_infestation_attachment_min_fields';
  attachment_id?: Maybe<Scalars['Int']>;
  crop_infestation_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by min() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Mutation_Response = {
  __typename?: 'crop_infestation_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Infestation_Attachment>;
};

/** on_conflict condition type for table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_On_Conflict = {
  constraint: Crop_Infestation_Attachment_Constraint;
  update_columns?: Array<Crop_Infestation_Attachment_Update_Column>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_infestation_attachment". */
export type Crop_Infestation_Attachment_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation?: InputMaybe<Crop_Infestation_Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
};

/** primary key columns input for table: crop_infestation_attachment */
export type Crop_Infestation_Attachment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_infestation_attachment" */
export enum Crop_Infestation_Attachment_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  CropInfestationId = 'crop_infestation_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Set_Input = {
  attachment_id?: InputMaybe<Scalars['Int']>;
  crop_infestation_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type Crop_Infestation_Attachment_Stddev_Fields = {
  __typename?: 'crop_infestation_attachment_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Crop_Infestation_Attachment_Stddev_Pop_Fields = {
  __typename?: 'crop_infestation_attachment_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Crop_Infestation_Attachment_Stddev_Samp_Fields = {
  __typename?: 'crop_infestation_attachment_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Infestation_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Infestation_Attachment_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['Int']>;
  crop_infestation_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type Crop_Infestation_Attachment_Sum_Fields = {
  __typename?: 'crop_infestation_attachment_sum_fields';
  attachment_id?: Maybe<Scalars['Int']>;
  crop_infestation_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "crop_infestation_attachment" */
export enum Crop_Infestation_Attachment_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  CropInfestationId = 'crop_infestation_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Order = 'order'
}

export type Crop_Infestation_Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Infestation_Attachment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Infestation_Attachment_Set_Input>;
  where: Crop_Infestation_Attachment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Infestation_Attachment_Var_Pop_Fields = {
  __typename?: 'crop_infestation_attachment_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Crop_Infestation_Attachment_Var_Samp_Fields = {
  __typename?: 'crop_infestation_attachment_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Crop_Infestation_Attachment_Variance_Fields = {
  __typename?: 'crop_infestation_attachment_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Crop_Infestation_Avg_Fields = {
  __typename?: 'crop_infestation_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop_infestation". All fields are combined with a logical 'AND'. */
export type Crop_Infestation_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Infestation_Bool_Exp>>;
  _not?: InputMaybe<Crop_Infestation_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Infestation_Bool_Exp>>;
  affects?: InputMaybe<String_Comparison_Exp>;
  biological_measures?: InputMaybe<String_Comparison_Exp>;
  chemical_measures?: InputMaybe<String_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  crop_infestation_attachments?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
  cultural_measures?: InputMaybe<String_Comparison_Exp>;
  damage_nature?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  infestation?: InputMaybe<Infestation_Bool_Exp>;
  infestation_id?: InputMaybe<Int_Comparison_Exp>;
  infestation_period?: InputMaybe<String_Comparison_Exp>;
  infestation_stage?: InputMaybe<String_Comparison_Exp>;
  mechanical_measures?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  quality_impact?: InputMaybe<String_Comparison_Exp>;
  quantity_impact?: InputMaybe<String_Comparison_Exp>;
  scientific_name?: InputMaybe<String_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
  symptoms?: InputMaybe<String_Comparison_Exp>;
  weather_conditions?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_infestation" */
export enum Crop_Infestation_Constraint {
  /** unique or primary key constraint on columns "crop_id", "infestation_id" */
  CropInfestationInfestationIdCropId_71b16159Uniq = 'crop_infestation_infestation_id_crop_id_71b16159_uniq',
  /** unique or primary key constraint on columns "id" */
  CropInfestationPkey = 'crop_infestation_pkey'
}

/** input type for incrementing numeric columns in table "crop_infestation" */
export type Crop_Infestation_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  infestation_id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_infestation" */
export type Crop_Infestation_Insert_Input = {
  affects?: InputMaybe<Scalars['String']>;
  biological_measures?: InputMaybe<Scalars['String']>;
  chemical_measures?: InputMaybe<Scalars['String']>;
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  crop_infestation_attachments?: InputMaybe<Crop_Infestation_Attachment_Arr_Rel_Insert_Input>;
  cultural_measures?: InputMaybe<Scalars['String']>;
  damage_nature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  infestation?: InputMaybe<Infestation_Obj_Rel_Insert_Input>;
  infestation_id?: InputMaybe<Scalars['Int']>;
  infestation_period?: InputMaybe<Scalars['String']>;
  infestation_stage?: InputMaybe<Scalars['String']>;
  mechanical_measures?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  quality_impact?: InputMaybe<Scalars['String']>;
  quantity_impact?: InputMaybe<Scalars['String']>;
  scientific_name?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  symptoms?: InputMaybe<Scalars['String']>;
  weather_conditions?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Crop_Infestation_Max_Fields = {
  __typename?: 'crop_infestation_max_fields';
  affects?: Maybe<Scalars['String']>;
  biological_measures?: Maybe<Scalars['String']>;
  chemical_measures?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  cultural_measures?: Maybe<Scalars['String']>;
  damage_nature?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  infestation_id?: Maybe<Scalars['Int']>;
  infestation_period?: Maybe<Scalars['String']>;
  infestation_stage?: Maybe<Scalars['String']>;
  mechanical_measures?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  quality_impact?: Maybe<Scalars['String']>;
  quantity_impact?: Maybe<Scalars['String']>;
  scientific_name?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  symptoms?: Maybe<Scalars['String']>;
  weather_conditions?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Crop_Infestation_Min_Fields = {
  __typename?: 'crop_infestation_min_fields';
  affects?: Maybe<Scalars['String']>;
  biological_measures?: Maybe<Scalars['String']>;
  chemical_measures?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  cultural_measures?: Maybe<Scalars['String']>;
  damage_nature?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  infestation_id?: Maybe<Scalars['Int']>;
  infestation_period?: Maybe<Scalars['String']>;
  infestation_stage?: Maybe<Scalars['String']>;
  mechanical_measures?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  quality_impact?: Maybe<Scalars['String']>;
  quantity_impact?: Maybe<Scalars['String']>;
  scientific_name?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  symptoms?: Maybe<Scalars['String']>;
  weather_conditions?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "crop_infestation" */
export type Crop_Infestation_Mutation_Response = {
  __typename?: 'crop_infestation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Infestation>;
};

/** input type for inserting object relation for remote table "crop_infestation" */
export type Crop_Infestation_Obj_Rel_Insert_Input = {
  data: Crop_Infestation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Infestation_On_Conflict>;
};

/** on_conflict condition type for table "crop_infestation" */
export type Crop_Infestation_On_Conflict = {
  constraint: Crop_Infestation_Constraint;
  update_columns?: Array<Crop_Infestation_Update_Column>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_infestation". */
export type Crop_Infestation_Order_By = {
  affects?: InputMaybe<Order_By>;
  biological_measures?: InputMaybe<Order_By>;
  chemical_measures?: InputMaybe<Order_By>;
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_attachments_aggregate?: InputMaybe<Crop_Infestation_Attachment_Aggregate_Order_By>;
  cultural_measures?: InputMaybe<Order_By>;
  damage_nature?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  infestation?: InputMaybe<Infestation_Order_By>;
  infestation_id?: InputMaybe<Order_By>;
  infestation_period?: InputMaybe<Order_By>;
  infestation_stage?: InputMaybe<Order_By>;
  mechanical_measures?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  quality_impact?: InputMaybe<Order_By>;
  quantity_impact?: InputMaybe<Order_By>;
  scientific_name?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  symptoms?: InputMaybe<Order_By>;
  weather_conditions?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_infestation */
export type Crop_Infestation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_infestation" */
export enum Crop_Infestation_Select_Column {
  /** column name */
  Affects = 'affects',
  /** column name */
  BiologicalMeasures = 'biological_measures',
  /** column name */
  ChemicalMeasures = 'chemical_measures',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CulturalMeasures = 'cultural_measures',
  /** column name */
  DamageNature = 'damage_nature',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  InfestationId = 'infestation_id',
  /** column name */
  InfestationPeriod = 'infestation_period',
  /** column name */
  InfestationStage = 'infestation_stage',
  /** column name */
  MechanicalMeasures = 'mechanical_measures',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  QualityImpact = 'quality_impact',
  /** column name */
  QuantityImpact = 'quantity_impact',
  /** column name */
  ScientificName = 'scientific_name',
  /** column name */
  Severity = 'severity',
  /** column name */
  Symptoms = 'symptoms',
  /** column name */
  WeatherConditions = 'weather_conditions'
}

/** input type for updating data in table "crop_infestation" */
export type Crop_Infestation_Set_Input = {
  affects?: InputMaybe<Scalars['String']>;
  biological_measures?: InputMaybe<Scalars['String']>;
  chemical_measures?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  cultural_measures?: InputMaybe<Scalars['String']>;
  damage_nature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  infestation_id?: InputMaybe<Scalars['Int']>;
  infestation_period?: InputMaybe<Scalars['String']>;
  infestation_stage?: InputMaybe<Scalars['String']>;
  mechanical_measures?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  quality_impact?: InputMaybe<Scalars['String']>;
  quantity_impact?: InputMaybe<Scalars['String']>;
  scientific_name?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  symptoms?: InputMaybe<Scalars['String']>;
  weather_conditions?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Crop_Infestation_Stddev_Fields = {
  __typename?: 'crop_infestation_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Infestation_Stddev_Pop_Fields = {
  __typename?: 'crop_infestation_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Infestation_Stddev_Samp_Fields = {
  __typename?: 'crop_infestation_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop_infestation" */
export type Crop_Infestation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Infestation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Infestation_Stream_Cursor_Value_Input = {
  affects?: InputMaybe<Scalars['String']>;
  biological_measures?: InputMaybe<Scalars['String']>;
  chemical_measures?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  cultural_measures?: InputMaybe<Scalars['String']>;
  damage_nature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  infestation_id?: InputMaybe<Scalars['Int']>;
  infestation_period?: InputMaybe<Scalars['String']>;
  infestation_stage?: InputMaybe<Scalars['String']>;
  mechanical_measures?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  quality_impact?: InputMaybe<Scalars['String']>;
  quantity_impact?: InputMaybe<Scalars['String']>;
  scientific_name?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  symptoms?: InputMaybe<Scalars['String']>;
  weather_conditions?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Crop_Infestation_Sum_Fields = {
  __typename?: 'crop_infestation_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  infestation_id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop_infestation" */
export enum Crop_Infestation_Update_Column {
  /** column name */
  Affects = 'affects',
  /** column name */
  BiologicalMeasures = 'biological_measures',
  /** column name */
  ChemicalMeasures = 'chemical_measures',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CulturalMeasures = 'cultural_measures',
  /** column name */
  DamageNature = 'damage_nature',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  InfestationId = 'infestation_id',
  /** column name */
  InfestationPeriod = 'infestation_period',
  /** column name */
  InfestationStage = 'infestation_stage',
  /** column name */
  MechanicalMeasures = 'mechanical_measures',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  QualityImpact = 'quality_impact',
  /** column name */
  QuantityImpact = 'quantity_impact',
  /** column name */
  ScientificName = 'scientific_name',
  /** column name */
  Severity = 'severity',
  /** column name */
  Symptoms = 'symptoms',
  /** column name */
  WeatherConditions = 'weather_conditions'
}

export type Crop_Infestation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Infestation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Infestation_Set_Input>;
  where: Crop_Infestation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Infestation_Var_Pop_Fields = {
  __typename?: 'crop_infestation_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Infestation_Var_Samp_Fields = {
  __typename?: 'crop_infestation_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Infestation_Variance_Fields = {
  __typename?: 'crop_infestation_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** input type for inserting data into table "crop" */
export type Crop_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  commodities?: InputMaybe<Commodity_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  hex_color_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  varieties?: InputMaybe<Crop_Variety_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Crop_Max_Fields = {
  __typename?: 'crop_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  hex_color_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "crop_milestone" */
export type Crop_Milestone = {
  __typename?: 'crop_milestone';
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  id: Scalars['Int'];
  ignore_crop_year: Scalars['Boolean'];
  image_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  milestone: Milestone;
  milestone_id: Scalars['Int'];
  order: Scalars['Int'];
};

/** aggregated selection of "crop_milestone" */
export type Crop_Milestone_Aggregate = {
  __typename?: 'crop_milestone_aggregate';
  aggregate?: Maybe<Crop_Milestone_Aggregate_Fields>;
  nodes: Array<Crop_Milestone>;
};

/** aggregate fields of "crop_milestone" */
export type Crop_Milestone_Aggregate_Fields = {
  __typename?: 'crop_milestone_aggregate_fields';
  avg?: Maybe<Crop_Milestone_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Milestone_Max_Fields>;
  min?: Maybe<Crop_Milestone_Min_Fields>;
  stddev?: Maybe<Crop_Milestone_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Milestone_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Milestone_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Milestone_Sum_Fields>;
  var_pop?: Maybe<Crop_Milestone_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Milestone_Var_Samp_Fields>;
  variance?: Maybe<Crop_Milestone_Variance_Fields>;
};


/** aggregate fields of "crop_milestone" */
export type Crop_Milestone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Milestone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Crop_Milestone_Avg_Fields = {
  __typename?: 'crop_milestone_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop_milestone". All fields are combined with a logical 'AND'. */
export type Crop_Milestone_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Milestone_Bool_Exp>>;
  _not?: InputMaybe<Crop_Milestone_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Milestone_Bool_Exp>>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  ignore_crop_year?: InputMaybe<Boolean_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  milestone?: InputMaybe<Milestone_Bool_Exp>;
  milestone_id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_milestone" */
export enum Crop_Milestone_Constraint {
  /** unique or primary key constraint on columns "id" */
  CropMilestonePkey = 'crop_milestone_pkey'
}

/** input type for incrementing numeric columns in table "crop_milestone" */
export type Crop_Milestone_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  milestone_id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_milestone" */
export type Crop_Milestone_Insert_Input = {
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ignore_crop_year?: InputMaybe<Scalars['Boolean']>;
  image_url?: InputMaybe<Scalars['String']>;
  milestone?: InputMaybe<Milestone_Obj_Rel_Insert_Input>;
  milestone_id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Crop_Milestone_Max_Fields = {
  __typename?: 'crop_milestone_max_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  milestone_id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Crop_Milestone_Min_Fields = {
  __typename?: 'crop_milestone_min_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  milestone_id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "crop_milestone" */
export type Crop_Milestone_Mutation_Response = {
  __typename?: 'crop_milestone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Milestone>;
};

/** input type for inserting object relation for remote table "crop_milestone" */
export type Crop_Milestone_Obj_Rel_Insert_Input = {
  data: Crop_Milestone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Milestone_On_Conflict>;
};

/** on_conflict condition type for table "crop_milestone" */
export type Crop_Milestone_On_Conflict = {
  constraint: Crop_Milestone_Constraint;
  update_columns?: Array<Crop_Milestone_Update_Column>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_milestone". */
export type Crop_Milestone_Order_By = {
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignore_crop_year?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  milestone?: InputMaybe<Milestone_Order_By>;
  milestone_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_milestone */
export type Crop_Milestone_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_milestone" */
export enum Crop_Milestone_Select_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoreCropYear = 'ignore_crop_year',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  MilestoneId = 'milestone_id',
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "crop_milestone" */
export type Crop_Milestone_Set_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ignore_crop_year?: InputMaybe<Scalars['Boolean']>;
  image_url?: InputMaybe<Scalars['String']>;
  milestone_id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Crop_Milestone_Stddev_Fields = {
  __typename?: 'crop_milestone_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Milestone_Stddev_Pop_Fields = {
  __typename?: 'crop_milestone_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Milestone_Stddev_Samp_Fields = {
  __typename?: 'crop_milestone_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop_milestone" */
export type Crop_Milestone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Milestone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Milestone_Stream_Cursor_Value_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ignore_crop_year?: InputMaybe<Scalars['Boolean']>;
  image_url?: InputMaybe<Scalars['String']>;
  milestone_id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Crop_Milestone_Sum_Fields = {
  __typename?: 'crop_milestone_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  milestone_id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop_milestone" */
export enum Crop_Milestone_Update_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoreCropYear = 'ignore_crop_year',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  MilestoneId = 'milestone_id',
  /** column name */
  Order = 'order'
}

export type Crop_Milestone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Milestone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Milestone_Set_Input>;
  where: Crop_Milestone_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Milestone_Var_Pop_Fields = {
  __typename?: 'crop_milestone_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Milestone_Var_Samp_Fields = {
  __typename?: 'crop_milestone_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Milestone_Variance_Fields = {
  __typename?: 'crop_milestone_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Crop_Min_Fields = {
  __typename?: 'crop_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  hex_color_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "crop" */
export type Crop_Mutation_Response = {
  __typename?: 'crop_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop>;
};

/** input type for inserting object relation for remote table "crop" */
export type Crop_Obj_Rel_Insert_Input = {
  data: Crop_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_On_Conflict>;
};

/** on_conflict condition type for table "crop" */
export type Crop_On_Conflict = {
  constraint: Crop_Constraint;
  update_columns?: Array<Crop_Update_Column>;
  where?: InputMaybe<Crop_Bool_Exp>;
};

/** columns and relationships of "crop_operation_methods" */
export type Crop_Operation_Methods = {
  __typename?: 'crop_operation_methods';
  crop: Array<Crop>;
  crop_id: Scalars['String'];
  grace_period_in_days?: Maybe<Scalars['Int']>;
  has_water_quantity: Scalars['Boolean'];
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  /** An object relationship */
  operation_method: Operation_Methods;
  operation_method_id: Scalars['uuid'];
  order: Scalars['smallint'];
  shared_crop_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "crop_operation_methods" */
export type Crop_Operation_MethodsCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp_Remote_Rel_Crop_Operation_Methodscrop>;
};

/** aggregated selection of "crop_operation_methods" */
export type Crop_Operation_Methods_Aggregate = {
  __typename?: 'crop_operation_methods_aggregate';
  aggregate?: Maybe<Crop_Operation_Methods_Aggregate_Fields>;
  nodes: Array<Crop_Operation_Methods>;
};

/** aggregate fields of "crop_operation_methods" */
export type Crop_Operation_Methods_Aggregate_Fields = {
  __typename?: 'crop_operation_methods_aggregate_fields';
  avg?: Maybe<Crop_Operation_Methods_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Operation_Methods_Max_Fields>;
  min?: Maybe<Crop_Operation_Methods_Min_Fields>;
  stddev?: Maybe<Crop_Operation_Methods_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Operation_Methods_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Operation_Methods_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Operation_Methods_Sum_Fields>;
  var_pop?: Maybe<Crop_Operation_Methods_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Operation_Methods_Var_Samp_Fields>;
  variance?: Maybe<Crop_Operation_Methods_Variance_Fields>;
};


/** aggregate fields of "crop_operation_methods" */
export type Crop_Operation_Methods_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Operation_Methods_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "crop_operation_methods" */
export type Crop_Operation_Methods_Aggregate_Order_By = {
  avg?: InputMaybe<Crop_Operation_Methods_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Operation_Methods_Max_Order_By>;
  min?: InputMaybe<Crop_Operation_Methods_Min_Order_By>;
  stddev?: InputMaybe<Crop_Operation_Methods_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crop_Operation_Methods_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crop_Operation_Methods_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crop_Operation_Methods_Sum_Order_By>;
  var_pop?: InputMaybe<Crop_Operation_Methods_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crop_Operation_Methods_Var_Samp_Order_By>;
  variance?: InputMaybe<Crop_Operation_Methods_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "crop_operation_methods" */
export type Crop_Operation_Methods_Arr_Rel_Insert_Input = {
  data: Array<Crop_Operation_Methods_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Operation_Methods_On_Conflict>;
};

/** aggregate avg on columns */
export type Crop_Operation_Methods_Avg_Fields = {
  __typename?: 'crop_operation_methods_avg_fields';
  grace_period_in_days?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "crop_operation_methods" */
export type Crop_Operation_Methods_Avg_Order_By = {
  grace_period_in_days?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "crop_operation_methods". All fields are combined with a logical 'AND'. */
export type Crop_Operation_Methods_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Operation_Methods_Bool_Exp>>;
  _not?: InputMaybe<Crop_Operation_Methods_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Operation_Methods_Bool_Exp>>;
  crop_id?: InputMaybe<String_Comparison_Exp>;
  grace_period_in_days?: InputMaybe<Int_Comparison_Exp>;
  has_water_quantity?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  operation_method?: InputMaybe<Operation_Methods_Bool_Exp>;
  operation_method_id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  shared_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_operation_methods" */
export enum Crop_Operation_Methods_Constraint {
  /** unique or primary key constraint on columns "crop_id", "operation_method_id" */
  CropOperationMethodsCropIdOperationMethodEc893238Uniq = 'crop_operation_methods_crop_id_operation_method_ec893238_uniq',
  /** unique or primary key constraint on columns "id" */
  CropOperationMethodsPkey = 'crop_operation_methods_pkey'
}

/** input type for incrementing numeric columns in table "crop_operation_methods" */
export type Crop_Operation_Methods_Inc_Input = {
  grace_period_in_days?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['smallint']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "crop_operation_methods" */
export type Crop_Operation_Methods_Insert_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  grace_period_in_days?: InputMaybe<Scalars['Int']>;
  has_water_quantity?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_method?: InputMaybe<Operation_Methods_Obj_Rel_Insert_Input>;
  operation_method_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Crop_Operation_Methods_Max_Fields = {
  __typename?: 'crop_operation_methods_max_fields';
  crop_id?: Maybe<Scalars['String']>;
  grace_period_in_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  operation_method_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "crop_operation_methods" */
export type Crop_Operation_Methods_Max_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  grace_period_in_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  operation_method_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Operation_Methods_Min_Fields = {
  __typename?: 'crop_operation_methods_min_fields';
  crop_id?: Maybe<Scalars['String']>;
  grace_period_in_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  operation_method_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "crop_operation_methods" */
export type Crop_Operation_Methods_Min_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  grace_period_in_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  operation_method_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_operation_methods" */
export type Crop_Operation_Methods_Mutation_Response = {
  __typename?: 'crop_operation_methods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Operation_Methods>;
};

/** on_conflict condition type for table "crop_operation_methods" */
export type Crop_Operation_Methods_On_Conflict = {
  constraint: Crop_Operation_Methods_Constraint;
  update_columns?: Array<Crop_Operation_Methods_Update_Column>;
  where?: InputMaybe<Crop_Operation_Methods_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_operation_methods". */
export type Crop_Operation_Methods_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  grace_period_in_days?: InputMaybe<Order_By>;
  has_water_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  operation_method?: InputMaybe<Operation_Methods_Order_By>;
  operation_method_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_operation_methods */
export type Crop_Operation_Methods_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "crop_operation_methods" */
export enum Crop_Operation_Methods_Select_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  GracePeriodInDays = 'grace_period_in_days',
  /** column name */
  HasWaterQuantity = 'has_water_quantity',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OperationMethodId = 'operation_method_id',
  /** column name */
  Order = 'order',
  /** column name */
  SharedCropId = 'shared_crop_id'
}

/** input type for updating data in table "crop_operation_methods" */
export type Crop_Operation_Methods_Set_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  grace_period_in_days?: InputMaybe<Scalars['Int']>;
  has_water_quantity?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_method_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Crop_Operation_Methods_Stddev_Fields = {
  __typename?: 'crop_operation_methods_stddev_fields';
  grace_period_in_days?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "crop_operation_methods" */
export type Crop_Operation_Methods_Stddev_Order_By = {
  grace_period_in_days?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Crop_Operation_Methods_Stddev_Pop_Fields = {
  __typename?: 'crop_operation_methods_stddev_pop_fields';
  grace_period_in_days?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "crop_operation_methods" */
export type Crop_Operation_Methods_Stddev_Pop_Order_By = {
  grace_period_in_days?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Crop_Operation_Methods_Stddev_Samp_Fields = {
  __typename?: 'crop_operation_methods_stddev_samp_fields';
  grace_period_in_days?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "crop_operation_methods" */
export type Crop_Operation_Methods_Stddev_Samp_Order_By = {
  grace_period_in_days?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "crop_operation_methods" */
export type Crop_Operation_Methods_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Operation_Methods_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Operation_Methods_Stream_Cursor_Value_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  grace_period_in_days?: InputMaybe<Scalars['Int']>;
  has_water_quantity?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_method_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Crop_Operation_Methods_Sum_Fields = {
  __typename?: 'crop_operation_methods_sum_fields';
  grace_period_in_days?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['smallint']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "crop_operation_methods" */
export type Crop_Operation_Methods_Sum_Order_By = {
  grace_period_in_days?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "crop_operation_methods" */
export enum Crop_Operation_Methods_Update_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  GracePeriodInDays = 'grace_period_in_days',
  /** column name */
  HasWaterQuantity = 'has_water_quantity',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OperationMethodId = 'operation_method_id',
  /** column name */
  Order = 'order',
  /** column name */
  SharedCropId = 'shared_crop_id'
}

export type Crop_Operation_Methods_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Operation_Methods_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Operation_Methods_Set_Input>;
  where: Crop_Operation_Methods_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Operation_Methods_Var_Pop_Fields = {
  __typename?: 'crop_operation_methods_var_pop_fields';
  grace_period_in_days?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "crop_operation_methods" */
export type Crop_Operation_Methods_Var_Pop_Order_By = {
  grace_period_in_days?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Crop_Operation_Methods_Var_Samp_Fields = {
  __typename?: 'crop_operation_methods_var_samp_fields';
  grace_period_in_days?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "crop_operation_methods" */
export type Crop_Operation_Methods_Var_Samp_Order_By = {
  grace_period_in_days?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Crop_Operation_Methods_Variance_Fields = {
  __typename?: 'crop_operation_methods_variance_fields';
  grace_period_in_days?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "crop_operation_methods" */
export type Crop_Operation_Methods_Variance_Order_By = {
  grace_period_in_days?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "crop". */
export type Crop_Order_By = {
  codename?: InputMaybe<Order_By>;
  commodities_aggregate?: InputMaybe<Commodity_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  hex_color_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  varieties_aggregate?: InputMaybe<Crop_Variety_Aggregate_Order_By>;
};

/** columns and relationships of "crop_pesticides" */
export type Crop_Pesticides = {
  __typename?: 'crop_pesticides';
  crop: Array<Crop>;
  crop_id: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  pesticide_id: Scalars['uuid'];
  /** An object relationship */
  products_pesticide: Products_Pesticide;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "crop_pesticides" */
export type Crop_PesticidesCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp_Remote_Rel_Crop_Pesticidescrop>;
};

/** aggregated selection of "crop_pesticides" */
export type Crop_Pesticides_Aggregate = {
  __typename?: 'crop_pesticides_aggregate';
  aggregate?: Maybe<Crop_Pesticides_Aggregate_Fields>;
  nodes: Array<Crop_Pesticides>;
};

/** aggregate fields of "crop_pesticides" */
export type Crop_Pesticides_Aggregate_Fields = {
  __typename?: 'crop_pesticides_aggregate_fields';
  avg?: Maybe<Crop_Pesticides_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Pesticides_Max_Fields>;
  min?: Maybe<Crop_Pesticides_Min_Fields>;
  stddev?: Maybe<Crop_Pesticides_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Pesticides_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Pesticides_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Pesticides_Sum_Fields>;
  var_pop?: Maybe<Crop_Pesticides_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Pesticides_Var_Samp_Fields>;
  variance?: Maybe<Crop_Pesticides_Variance_Fields>;
};


/** aggregate fields of "crop_pesticides" */
export type Crop_Pesticides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Pesticides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "crop_pesticides" */
export type Crop_Pesticides_Aggregate_Order_By = {
  avg?: InputMaybe<Crop_Pesticides_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Pesticides_Max_Order_By>;
  min?: InputMaybe<Crop_Pesticides_Min_Order_By>;
  stddev?: InputMaybe<Crop_Pesticides_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crop_Pesticides_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crop_Pesticides_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crop_Pesticides_Sum_Order_By>;
  var_pop?: InputMaybe<Crop_Pesticides_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crop_Pesticides_Var_Samp_Order_By>;
  variance?: InputMaybe<Crop_Pesticides_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "crop_pesticides" */
export type Crop_Pesticides_Arr_Rel_Insert_Input = {
  data: Array<Crop_Pesticides_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Pesticides_On_Conflict>;
};

/** aggregate avg on columns */
export type Crop_Pesticides_Avg_Fields = {
  __typename?: 'crop_pesticides_avg_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "crop_pesticides" */
export type Crop_Pesticides_Avg_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "crop_pesticides". All fields are combined with a logical 'AND'. */
export type Crop_Pesticides_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Pesticides_Bool_Exp>>;
  _not?: InputMaybe<Crop_Pesticides_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Pesticides_Bool_Exp>>;
  crop_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  pesticide_id?: InputMaybe<Uuid_Comparison_Exp>;
  products_pesticide?: InputMaybe<Products_Pesticide_Bool_Exp>;
  shared_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_pesticides" */
export enum Crop_Pesticides_Constraint {
  /** unique or primary key constraint on columns "pesticide_id", "crop_id" */
  CropPesticidesCropIdPesticideIdEa914828Uniq = 'crop_pesticides_crop_id_pesticide_id_ea914828_uniq',
  /** unique or primary key constraint on columns "id" */
  CropPesticidesPkey = 'crop_pesticides_pkey'
}

/** input type for incrementing numeric columns in table "crop_pesticides" */
export type Crop_Pesticides_Inc_Input = {
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "crop_pesticides" */
export type Crop_Pesticides_Insert_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  pesticide_id?: InputMaybe<Scalars['uuid']>;
  products_pesticide?: InputMaybe<Products_Pesticide_Obj_Rel_Insert_Input>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Crop_Pesticides_Max_Fields = {
  __typename?: 'crop_pesticides_max_fields';
  crop_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  pesticide_id?: Maybe<Scalars['uuid']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "crop_pesticides" */
export type Crop_Pesticides_Max_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pesticide_id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Pesticides_Min_Fields = {
  __typename?: 'crop_pesticides_min_fields';
  crop_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  pesticide_id?: Maybe<Scalars['uuid']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "crop_pesticides" */
export type Crop_Pesticides_Min_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pesticide_id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_pesticides" */
export type Crop_Pesticides_Mutation_Response = {
  __typename?: 'crop_pesticides_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Pesticides>;
};

/** on_conflict condition type for table "crop_pesticides" */
export type Crop_Pesticides_On_Conflict = {
  constraint: Crop_Pesticides_Constraint;
  update_columns?: Array<Crop_Pesticides_Update_Column>;
  where?: InputMaybe<Crop_Pesticides_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_pesticides". */
export type Crop_Pesticides_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  pesticide_id?: InputMaybe<Order_By>;
  products_pesticide?: InputMaybe<Products_Pesticide_Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_pesticides */
export type Crop_Pesticides_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "crop_pesticides" */
export enum Crop_Pesticides_Select_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PesticideId = 'pesticide_id',
  /** column name */
  SharedCropId = 'shared_crop_id'
}

/** input type for updating data in table "crop_pesticides" */
export type Crop_Pesticides_Set_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  pesticide_id?: InputMaybe<Scalars['uuid']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Crop_Pesticides_Stddev_Fields = {
  __typename?: 'crop_pesticides_stddev_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "crop_pesticides" */
export type Crop_Pesticides_Stddev_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Crop_Pesticides_Stddev_Pop_Fields = {
  __typename?: 'crop_pesticides_stddev_pop_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "crop_pesticides" */
export type Crop_Pesticides_Stddev_Pop_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Crop_Pesticides_Stddev_Samp_Fields = {
  __typename?: 'crop_pesticides_stddev_samp_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "crop_pesticides" */
export type Crop_Pesticides_Stddev_Samp_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "crop_pesticides" */
export type Crop_Pesticides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Pesticides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Pesticides_Stream_Cursor_Value_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  pesticide_id?: InputMaybe<Scalars['uuid']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Crop_Pesticides_Sum_Fields = {
  __typename?: 'crop_pesticides_sum_fields';
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "crop_pesticides" */
export type Crop_Pesticides_Sum_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "crop_pesticides" */
export enum Crop_Pesticides_Update_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PesticideId = 'pesticide_id',
  /** column name */
  SharedCropId = 'shared_crop_id'
}

export type Crop_Pesticides_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Pesticides_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Pesticides_Set_Input>;
  where: Crop_Pesticides_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Pesticides_Var_Pop_Fields = {
  __typename?: 'crop_pesticides_var_pop_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "crop_pesticides" */
export type Crop_Pesticides_Var_Pop_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Crop_Pesticides_Var_Samp_Fields = {
  __typename?: 'crop_pesticides_var_samp_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "crop_pesticides" */
export type Crop_Pesticides_Var_Samp_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Crop_Pesticides_Variance_Fields = {
  __typename?: 'crop_pesticides_variance_fields';
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "crop_pesticides" */
export type Crop_Pesticides_Variance_Order_By = {
  shared_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop */
export type Crop_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop" */
export enum Crop_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  HexColorCode = 'hex_color_code',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

/** input type for updating data in table "crop" */
export type Crop_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  hex_color_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Crop_Stddev_Fields = {
  __typename?: 'crop_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Stddev_Pop_Fields = {
  __typename?: 'crop_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Stddev_Samp_Fields = {
  __typename?: 'crop_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop" */
export type Crop_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  hex_color_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Crop_Sum_Fields = {
  __typename?: 'crop_sum_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop" */
export enum Crop_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  HexColorCode = 'hex_color_code',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

export type Crop_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Set_Input>;
  where: Crop_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Var_Pop_Fields = {
  __typename?: 'crop_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Var_Samp_Fields = {
  __typename?: 'crop_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Variance_Fields = {
  __typename?: 'crop_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "crop_variety" */
export type Crop_Variety = {
  __typename?: 'crop_variety';
  codename: Scalars['String'];
  /** An array relationship */
  commodity_varieties: Array<Commodity_Variety>;
  /** An aggregate relationship */
  commodity_varieties_aggregate: Commodity_Variety_Aggregate;
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  description: Scalars['String'];
  external_reference_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "crop_variety" */
export type Crop_VarietyCommodity_VarietiesArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


/** columns and relationships of "crop_variety" */
export type Crop_VarietyCommodity_Varieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};

/** aggregated selection of "crop_variety" */
export type Crop_Variety_Aggregate = {
  __typename?: 'crop_variety_aggregate';
  aggregate?: Maybe<Crop_Variety_Aggregate_Fields>;
  nodes: Array<Crop_Variety>;
};

/** aggregate fields of "crop_variety" */
export type Crop_Variety_Aggregate_Fields = {
  __typename?: 'crop_variety_aggregate_fields';
  avg?: Maybe<Crop_Variety_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Variety_Max_Fields>;
  min?: Maybe<Crop_Variety_Min_Fields>;
  stddev?: Maybe<Crop_Variety_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Variety_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Variety_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Variety_Sum_Fields>;
  var_pop?: Maybe<Crop_Variety_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Variety_Var_Samp_Fields>;
  variance?: Maybe<Crop_Variety_Variance_Fields>;
};


/** aggregate fields of "crop_variety" */
export type Crop_Variety_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "crop_variety" */
export type Crop_Variety_Aggregate_Order_By = {
  avg?: InputMaybe<Crop_Variety_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Variety_Max_Order_By>;
  min?: InputMaybe<Crop_Variety_Min_Order_By>;
  stddev?: InputMaybe<Crop_Variety_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crop_Variety_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crop_Variety_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crop_Variety_Sum_Order_By>;
  var_pop?: InputMaybe<Crop_Variety_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crop_Variety_Var_Samp_Order_By>;
  variance?: InputMaybe<Crop_Variety_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "crop_variety" */
export type Crop_Variety_Arr_Rel_Insert_Input = {
  data: Array<Crop_Variety_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Variety_On_Conflict>;
};

/** aggregate avg on columns */
export type Crop_Variety_Avg_Fields = {
  __typename?: 'crop_variety_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "crop_variety" */
export type Crop_Variety_Avg_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "crop_variety". All fields are combined with a logical 'AND'. */
export type Crop_Variety_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Variety_Bool_Exp>>;
  _not?: InputMaybe<Crop_Variety_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Variety_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  commodity_varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "crop_variety". All fields are combined with a logical 'AND'. */
export type Crop_Variety_Bool_Exp_Remote_Rel_Article_Crop_Varietiesvarieties = {
  _and?: InputMaybe<Array<Crop_Variety_Bool_Exp>>;
  _not?: InputMaybe<Crop_Variety_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Variety_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Article_Crop_Varietiesvarieties>;
  commodity_varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "crop_variety". All fields are combined with a logical 'AND'. */
export type Crop_Variety_Bool_Exp_Remote_Rel_Crop_Variety_Seedsvariety = {
  _and?: InputMaybe<Array<Crop_Variety_Bool_Exp>>;
  _not?: InputMaybe<Crop_Variety_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Variety_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Crop_Variety_Seedsvariety>;
  commodity_varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_variety" */
export enum Crop_Variety_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CropVarietyCodenameKey = 'crop_variety_codename_key',
  /** unique or primary key constraint on columns "name", "crop_id" */
  CropVarietyNameCropIdFdc9c1f4Uniq = 'crop_variety_name_crop_id_fdc9c1f4_uniq',
  /** unique or primary key constraint on columns "id" */
  CropVarietyPkey = 'crop_variety_pkey'
}

/** input type for incrementing numeric columns in table "crop_variety" */
export type Crop_Variety_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_variety" */
export type Crop_Variety_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  commodity_varieties?: InputMaybe<Commodity_Variety_Arr_Rel_Insert_Input>;
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Crop_Variety_Max_Fields = {
  __typename?: 'crop_variety_max_fields';
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "crop_variety" */
export type Crop_Variety_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Variety_Min_Fields = {
  __typename?: 'crop_variety_min_fields';
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "crop_variety" */
export type Crop_Variety_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_variety" */
export type Crop_Variety_Mutation_Response = {
  __typename?: 'crop_variety_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Variety>;
};

/** input type for inserting object relation for remote table "crop_variety" */
export type Crop_Variety_Obj_Rel_Insert_Input = {
  data: Crop_Variety_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Variety_On_Conflict>;
};

/** on_conflict condition type for table "crop_variety" */
export type Crop_Variety_On_Conflict = {
  constraint: Crop_Variety_Constraint;
  update_columns?: Array<Crop_Variety_Update_Column>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_variety". */
export type Crop_Variety_Order_By = {
  codename?: InputMaybe<Order_By>;
  commodity_varieties_aggregate?: InputMaybe<Commodity_Variety_Aggregate_Order_By>;
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_variety */
export type Crop_Variety_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "crop_variety_seeds" */
export type Crop_Variety_Seeds = {
  __typename?: 'crop_variety_seeds';
  crop_variety_id: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  seed: Seeds;
  seed_id: Scalars['uuid'];
  shared_crop_variety_id?: Maybe<Scalars['bigint']>;
  variety: Array<Crop_Variety>;
};


/** columns and relationships of "crop_variety_seeds" */
export type Crop_Variety_SeedsVarietyArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp_Remote_Rel_Crop_Variety_Seedsvariety>;
};

/** aggregated selection of "crop_variety_seeds" */
export type Crop_Variety_Seeds_Aggregate = {
  __typename?: 'crop_variety_seeds_aggregate';
  aggregate?: Maybe<Crop_Variety_Seeds_Aggregate_Fields>;
  nodes: Array<Crop_Variety_Seeds>;
};

/** aggregate fields of "crop_variety_seeds" */
export type Crop_Variety_Seeds_Aggregate_Fields = {
  __typename?: 'crop_variety_seeds_aggregate_fields';
  avg?: Maybe<Crop_Variety_Seeds_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Variety_Seeds_Max_Fields>;
  min?: Maybe<Crop_Variety_Seeds_Min_Fields>;
  stddev?: Maybe<Crop_Variety_Seeds_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Variety_Seeds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Variety_Seeds_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Variety_Seeds_Sum_Fields>;
  var_pop?: Maybe<Crop_Variety_Seeds_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Variety_Seeds_Var_Samp_Fields>;
  variance?: Maybe<Crop_Variety_Seeds_Variance_Fields>;
};


/** aggregate fields of "crop_variety_seeds" */
export type Crop_Variety_Seeds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Variety_Seeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Aggregate_Order_By = {
  avg?: InputMaybe<Crop_Variety_Seeds_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Variety_Seeds_Max_Order_By>;
  min?: InputMaybe<Crop_Variety_Seeds_Min_Order_By>;
  stddev?: InputMaybe<Crop_Variety_Seeds_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crop_Variety_Seeds_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crop_Variety_Seeds_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crop_Variety_Seeds_Sum_Order_By>;
  var_pop?: InputMaybe<Crop_Variety_Seeds_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crop_Variety_Seeds_Var_Samp_Order_By>;
  variance?: InputMaybe<Crop_Variety_Seeds_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Arr_Rel_Insert_Input = {
  data: Array<Crop_Variety_Seeds_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Variety_Seeds_On_Conflict>;
};

/** aggregate avg on columns */
export type Crop_Variety_Seeds_Avg_Fields = {
  __typename?: 'crop_variety_seeds_avg_fields';
  shared_crop_variety_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Avg_Order_By = {
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "crop_variety_seeds". All fields are combined with a logical 'AND'. */
export type Crop_Variety_Seeds_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Variety_Seeds_Bool_Exp>>;
  _not?: InputMaybe<Crop_Variety_Seeds_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Variety_Seeds_Bool_Exp>>;
  crop_variety_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  seed?: InputMaybe<Seeds_Bool_Exp>;
  seed_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_crop_variety_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_variety_seeds" */
export enum Crop_Variety_Seeds_Constraint {
  /** unique or primary key constraint on columns "seed_id", "crop_variety_id" */
  CropVarietySeedsCropVarietyIdSeedId_0ecc00abUniq = 'crop_variety_seeds_crop_variety_id_seed_id_0ecc00ab_uniq',
  /** unique or primary key constraint on columns "id" */
  CropVarietySeedsPkey = 'crop_variety_seeds_pkey'
}

/** input type for incrementing numeric columns in table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Inc_Input = {
  shared_crop_variety_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Insert_Input = {
  crop_variety_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  seed?: InputMaybe<Seeds_Obj_Rel_Insert_Input>;
  seed_id?: InputMaybe<Scalars['uuid']>;
  shared_crop_variety_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Crop_Variety_Seeds_Max_Fields = {
  __typename?: 'crop_variety_seeds_max_fields';
  crop_variety_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  seed_id?: Maybe<Scalars['uuid']>;
  shared_crop_variety_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Max_Order_By = {
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Variety_Seeds_Min_Fields = {
  __typename?: 'crop_variety_seeds_min_fields';
  crop_variety_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  seed_id?: Maybe<Scalars['uuid']>;
  shared_crop_variety_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Min_Order_By = {
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Mutation_Response = {
  __typename?: 'crop_variety_seeds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Variety_Seeds>;
};

/** on_conflict condition type for table "crop_variety_seeds" */
export type Crop_Variety_Seeds_On_Conflict = {
  constraint: Crop_Variety_Seeds_Constraint;
  update_columns?: Array<Crop_Variety_Seeds_Update_Column>;
  where?: InputMaybe<Crop_Variety_Seeds_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_variety_seeds". */
export type Crop_Variety_Seeds_Order_By = {
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  seed?: InputMaybe<Seeds_Order_By>;
  seed_id?: InputMaybe<Order_By>;
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_variety_seeds */
export type Crop_Variety_Seeds_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "crop_variety_seeds" */
export enum Crop_Variety_Seeds_Select_Column {
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  SharedCropVarietyId = 'shared_crop_variety_id'
}

/** input type for updating data in table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Set_Input = {
  crop_variety_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  seed_id?: InputMaybe<Scalars['uuid']>;
  shared_crop_variety_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Crop_Variety_Seeds_Stddev_Fields = {
  __typename?: 'crop_variety_seeds_stddev_fields';
  shared_crop_variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Stddev_Order_By = {
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Crop_Variety_Seeds_Stddev_Pop_Fields = {
  __typename?: 'crop_variety_seeds_stddev_pop_fields';
  shared_crop_variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Stddev_Pop_Order_By = {
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Crop_Variety_Seeds_Stddev_Samp_Fields = {
  __typename?: 'crop_variety_seeds_stddev_samp_fields';
  shared_crop_variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Stddev_Samp_Order_By = {
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Variety_Seeds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Variety_Seeds_Stream_Cursor_Value_Input = {
  crop_variety_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  seed_id?: InputMaybe<Scalars['uuid']>;
  shared_crop_variety_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Crop_Variety_Seeds_Sum_Fields = {
  __typename?: 'crop_variety_seeds_sum_fields';
  shared_crop_variety_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Sum_Order_By = {
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** update columns of table "crop_variety_seeds" */
export enum Crop_Variety_Seeds_Update_Column {
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  SharedCropVarietyId = 'shared_crop_variety_id'
}

export type Crop_Variety_Seeds_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Variety_Seeds_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Variety_Seeds_Set_Input>;
  where: Crop_Variety_Seeds_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Variety_Seeds_Var_Pop_Fields = {
  __typename?: 'crop_variety_seeds_var_pop_fields';
  shared_crop_variety_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Var_Pop_Order_By = {
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Crop_Variety_Seeds_Var_Samp_Fields = {
  __typename?: 'crop_variety_seeds_var_samp_fields';
  shared_crop_variety_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Var_Samp_Order_By = {
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Crop_Variety_Seeds_Variance_Fields = {
  __typename?: 'crop_variety_seeds_variance_fields';
  shared_crop_variety_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "crop_variety_seeds" */
export type Crop_Variety_Seeds_Variance_Order_By = {
  shared_crop_variety_id?: InputMaybe<Order_By>;
};

/** select columns of table "crop_variety" */
export enum Crop_Variety_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

/** input type for updating data in table "crop_variety" */
export type Crop_Variety_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Crop_Variety_Stddev_Fields = {
  __typename?: 'crop_variety_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "crop_variety" */
export type Crop_Variety_Stddev_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Crop_Variety_Stddev_Pop_Fields = {
  __typename?: 'crop_variety_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "crop_variety" */
export type Crop_Variety_Stddev_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Crop_Variety_Stddev_Samp_Fields = {
  __typename?: 'crop_variety_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "crop_variety" */
export type Crop_Variety_Stddev_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "crop_variety" */
export type Crop_Variety_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Variety_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Variety_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Crop_Variety_Sum_Fields = {
  __typename?: 'crop_variety_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "crop_variety" */
export type Crop_Variety_Sum_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** update columns of table "crop_variety" */
export enum Crop_Variety_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

export type Crop_Variety_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Variety_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Variety_Set_Input>;
  where: Crop_Variety_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Variety_Var_Pop_Fields = {
  __typename?: 'crop_variety_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "crop_variety" */
export type Crop_Variety_Var_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Crop_Variety_Var_Samp_Fields = {
  __typename?: 'crop_variety_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "crop_variety" */
export type Crop_Variety_Var_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Crop_Variety_Variance_Fields = {
  __typename?: 'crop_variety_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "crop_variety" */
export type Crop_Variety_Variance_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "crop_year" */
export type Crop_Year = {
  __typename?: 'crop_year';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "crop_year" */
export type Crop_Year_Aggregate = {
  __typename?: 'crop_year_aggregate';
  aggregate?: Maybe<Crop_Year_Aggregate_Fields>;
  nodes: Array<Crop_Year>;
};

/** aggregate fields of "crop_year" */
export type Crop_Year_Aggregate_Fields = {
  __typename?: 'crop_year_aggregate_fields';
  avg?: Maybe<Crop_Year_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Year_Max_Fields>;
  min?: Maybe<Crop_Year_Min_Fields>;
  stddev?: Maybe<Crop_Year_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Year_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Year_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Year_Sum_Fields>;
  var_pop?: Maybe<Crop_Year_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Year_Var_Samp_Fields>;
  variance?: Maybe<Crop_Year_Variance_Fields>;
};


/** aggregate fields of "crop_year" */
export type Crop_Year_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Year_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Crop_Year_Avg_Fields = {
  __typename?: 'crop_year_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop_year". All fields are combined with a logical 'AND'. */
export type Crop_Year_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Year_Bool_Exp>>;
  _not?: InputMaybe<Crop_Year_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Year_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_year" */
export enum Crop_Year_Constraint {
  /** unique or primary key constraint on columns "id" */
  CropYearPkey = 'crop_year_pkey'
}

/** input type for incrementing numeric columns in table "crop_year" */
export type Crop_Year_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_year" */
export type Crop_Year_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Crop_Year_Max_Fields = {
  __typename?: 'crop_year_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Crop_Year_Min_Fields = {
  __typename?: 'crop_year_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "crop_year" */
export type Crop_Year_Mutation_Response = {
  __typename?: 'crop_year_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Year>;
};

/** input type for inserting object relation for remote table "crop_year" */
export type Crop_Year_Obj_Rel_Insert_Input = {
  data: Crop_Year_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Year_On_Conflict>;
};

/** on_conflict condition type for table "crop_year" */
export type Crop_Year_On_Conflict = {
  constraint: Crop_Year_Constraint;
  update_columns?: Array<Crop_Year_Update_Column>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_year". */
export type Crop_Year_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_year */
export type Crop_Year_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_year" */
export enum Crop_Year_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "crop_year" */
export type Crop_Year_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Crop_Year_Stddev_Fields = {
  __typename?: 'crop_year_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Year_Stddev_Pop_Fields = {
  __typename?: 'crop_year_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Year_Stddev_Samp_Fields = {
  __typename?: 'crop_year_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop_year" */
export type Crop_Year_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Year_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Year_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Crop_Year_Sum_Fields = {
  __typename?: 'crop_year_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop_year" */
export enum Crop_Year_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Crop_Year_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Year_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Year_Set_Input>;
  where: Crop_Year_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Year_Var_Pop_Fields = {
  __typename?: 'crop_year_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Year_Var_Samp_Fields = {
  __typename?: 'crop_year_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Year_Variance_Fields = {
  __typename?: 'crop_year_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter = {
  __typename?: 'cropmonitoring_parameter';
  compute_avg: Scalars['Boolean'];
  compute_max: Scalars['Boolean'];
  compute_min: Scalars['Boolean'];
  compute_sum: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  crop: Array<Crop>;
  crop_id?: Maybe<Scalars['String']>;
  end_days?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  max_attachments_per_sample: Scalars['Int'];
  max_samples: Scalars['Int'];
  min_samples: Scalars['Int'];
  /** An object relationship */
  monitoring_parameter: Monitoring_Parameter;
  /** An array relationship */
  monitoring_samples: Array<Monitoring_Sample>;
  /** An aggregate relationship */
  monitoring_samples_aggregate: Monitoring_Sample_Aggregate;
  order: Scalars['Int'];
  parameter_id: Scalars['uuid'];
  shared_crop_id?: Maybe<Scalars['bigint']>;
  start_days?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
};


/** columns and relationships of "cropmonitoring_parameter" */
export type Cropmonitoring_ParameterCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp_Remote_Rel_Cropmonitoring_Parametercrop>;
};


/** columns and relationships of "cropmonitoring_parameter" */
export type Cropmonitoring_ParameterMonitoring_SamplesArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Sample_Order_By>>;
  where?: InputMaybe<Monitoring_Sample_Bool_Exp>;
};


/** columns and relationships of "cropmonitoring_parameter" */
export type Cropmonitoring_ParameterMonitoring_Samples_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Sample_Order_By>>;
  where?: InputMaybe<Monitoring_Sample_Bool_Exp>;
};

/** aggregated selection of "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Aggregate = {
  __typename?: 'cropmonitoring_parameter_aggregate';
  aggregate?: Maybe<Cropmonitoring_Parameter_Aggregate_Fields>;
  nodes: Array<Cropmonitoring_Parameter>;
};

/** aggregate fields of "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Aggregate_Fields = {
  __typename?: 'cropmonitoring_parameter_aggregate_fields';
  avg?: Maybe<Cropmonitoring_Parameter_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Cropmonitoring_Parameter_Max_Fields>;
  min?: Maybe<Cropmonitoring_Parameter_Min_Fields>;
  stddev?: Maybe<Cropmonitoring_Parameter_Stddev_Fields>;
  stddev_pop?: Maybe<Cropmonitoring_Parameter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cropmonitoring_Parameter_Stddev_Samp_Fields>;
  sum?: Maybe<Cropmonitoring_Parameter_Sum_Fields>;
  var_pop?: Maybe<Cropmonitoring_Parameter_Var_Pop_Fields>;
  var_samp?: Maybe<Cropmonitoring_Parameter_Var_Samp_Fields>;
  variance?: Maybe<Cropmonitoring_Parameter_Variance_Fields>;
};


/** aggregate fields of "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cropmonitoring_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Aggregate_Order_By = {
  avg?: InputMaybe<Cropmonitoring_Parameter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cropmonitoring_Parameter_Max_Order_By>;
  min?: InputMaybe<Cropmonitoring_Parameter_Min_Order_By>;
  stddev?: InputMaybe<Cropmonitoring_Parameter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cropmonitoring_Parameter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cropmonitoring_Parameter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cropmonitoring_Parameter_Sum_Order_By>;
  var_pop?: InputMaybe<Cropmonitoring_Parameter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cropmonitoring_Parameter_Var_Samp_Order_By>;
  variance?: InputMaybe<Cropmonitoring_Parameter_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Arr_Rel_Insert_Input = {
  data: Array<Cropmonitoring_Parameter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cropmonitoring_Parameter_On_Conflict>;
};

/** aggregate avg on columns */
export type Cropmonitoring_Parameter_Avg_Fields = {
  __typename?: 'cropmonitoring_parameter_avg_fields';
  end_days?: Maybe<Scalars['Float']>;
  max_attachments_per_sample?: Maybe<Scalars['Float']>;
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
  start_days?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Avg_Order_By = {
  end_days?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cropmonitoring_parameter". All fields are combined with a logical 'AND'. */
export type Cropmonitoring_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Cropmonitoring_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Cropmonitoring_Parameter_Bool_Exp>>;
  compute_avg?: InputMaybe<Boolean_Comparison_Exp>;
  compute_max?: InputMaybe<Boolean_Comparison_Exp>;
  compute_min?: InputMaybe<Boolean_Comparison_Exp>;
  compute_sum?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  crop_id?: InputMaybe<String_Comparison_Exp>;
  end_days?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_attachments_per_sample?: InputMaybe<Int_Comparison_Exp>;
  max_samples?: InputMaybe<Int_Comparison_Exp>;
  min_samples?: InputMaybe<Int_Comparison_Exp>;
  monitoring_parameter?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
  monitoring_samples?: InputMaybe<Monitoring_Sample_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  parameter_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  start_days?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cropmonitoring_parameter" */
export enum Cropmonitoring_Parameter_Constraint {
  /** unique or primary key constraint on columns "crop_id", "parameter_id" */
  CropmonitoringParameterCropIdParameterId_94dedc06Uniq = 'cropmonitoring_parameter_crop_id_parameter_id_94dedc06_uniq',
  /** unique or primary key constraint on columns "id" */
  CropmonitoringParameterPkey = 'cropmonitoring_parameter_pkey'
}

/** input type for incrementing numeric columns in table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Inc_Input = {
  end_days?: InputMaybe<Scalars['Int']>;
  max_attachments_per_sample?: InputMaybe<Scalars['Int']>;
  max_samples?: InputMaybe<Scalars['Int']>;
  min_samples?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
  start_days?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Insert_Input = {
  compute_avg?: InputMaybe<Scalars['Boolean']>;
  compute_max?: InputMaybe<Scalars['Boolean']>;
  compute_min?: InputMaybe<Scalars['Boolean']>;
  compute_sum?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['String']>;
  end_days?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_attachments_per_sample?: InputMaybe<Scalars['Int']>;
  max_samples?: InputMaybe<Scalars['Int']>;
  min_samples?: InputMaybe<Scalars['Int']>;
  monitoring_parameter?: InputMaybe<Monitoring_Parameter_Obj_Rel_Insert_Input>;
  monitoring_samples?: InputMaybe<Monitoring_Sample_Arr_Rel_Insert_Input>;
  order?: InputMaybe<Scalars['Int']>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
  start_days?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cropmonitoring_Parameter_Max_Fields = {
  __typename?: 'cropmonitoring_parameter_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['String']>;
  end_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  max_attachments_per_sample?: Maybe<Scalars['Int']>;
  max_samples?: Maybe<Scalars['Int']>;
  min_samples?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  parameter_id?: Maybe<Scalars['uuid']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
  start_days?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  end_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cropmonitoring_Parameter_Min_Fields = {
  __typename?: 'cropmonitoring_parameter_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['String']>;
  end_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  max_attachments_per_sample?: Maybe<Scalars['Int']>;
  max_samples?: Maybe<Scalars['Int']>;
  min_samples?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  parameter_id?: Maybe<Scalars['uuid']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
  start_days?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  end_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Mutation_Response = {
  __typename?: 'cropmonitoring_parameter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cropmonitoring_Parameter>;
};

/** input type for inserting object relation for remote table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Obj_Rel_Insert_Input = {
  data: Cropmonitoring_Parameter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cropmonitoring_Parameter_On_Conflict>;
};

/** on_conflict condition type for table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_On_Conflict = {
  constraint: Cropmonitoring_Parameter_Constraint;
  update_columns?: Array<Cropmonitoring_Parameter_Update_Column>;
  where?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
};

/** Ordering options when selecting data from "cropmonitoring_parameter". */
export type Cropmonitoring_Parameter_Order_By = {
  compute_avg?: InputMaybe<Order_By>;
  compute_max?: InputMaybe<Order_By>;
  compute_min?: InputMaybe<Order_By>;
  compute_sum?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  end_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  monitoring_parameter?: InputMaybe<Monitoring_Parameter_Order_By>;
  monitoring_samples_aggregate?: InputMaybe<Monitoring_Sample_Aggregate_Order_By>;
  order?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cropmonitoring_parameter */
export type Cropmonitoring_Parameter_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cropmonitoring_parameter" */
export enum Cropmonitoring_Parameter_Select_Column {
  /** column name */
  ComputeAvg = 'compute_avg',
  /** column name */
  ComputeMax = 'compute_max',
  /** column name */
  ComputeMin = 'compute_min',
  /** column name */
  ComputeSum = 'compute_sum',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  EndDays = 'end_days',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxAttachmentsPerSample = 'max_attachments_per_sample',
  /** column name */
  MaxSamples = 'max_samples',
  /** column name */
  MinSamples = 'min_samples',
  /** column name */
  Order = 'order',
  /** column name */
  ParameterId = 'parameter_id',
  /** column name */
  SharedCropId = 'shared_crop_id',
  /** column name */
  StartDays = 'start_days',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Set_Input = {
  compute_avg?: InputMaybe<Scalars['Boolean']>;
  compute_max?: InputMaybe<Scalars['Boolean']>;
  compute_min?: InputMaybe<Scalars['Boolean']>;
  compute_sum?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['String']>;
  end_days?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_attachments_per_sample?: InputMaybe<Scalars['Int']>;
  max_samples?: InputMaybe<Scalars['Int']>;
  min_samples?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
  start_days?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Cropmonitoring_Parameter_Stddev_Fields = {
  __typename?: 'cropmonitoring_parameter_stddev_fields';
  end_days?: Maybe<Scalars['Float']>;
  max_attachments_per_sample?: Maybe<Scalars['Float']>;
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
  start_days?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Stddev_Order_By = {
  end_days?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cropmonitoring_Parameter_Stddev_Pop_Fields = {
  __typename?: 'cropmonitoring_parameter_stddev_pop_fields';
  end_days?: Maybe<Scalars['Float']>;
  max_attachments_per_sample?: Maybe<Scalars['Float']>;
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
  start_days?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Stddev_Pop_Order_By = {
  end_days?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cropmonitoring_Parameter_Stddev_Samp_Fields = {
  __typename?: 'cropmonitoring_parameter_stddev_samp_fields';
  end_days?: Maybe<Scalars['Float']>;
  max_attachments_per_sample?: Maybe<Scalars['Float']>;
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
  start_days?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Stddev_Samp_Order_By = {
  end_days?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cropmonitoring_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cropmonitoring_Parameter_Stream_Cursor_Value_Input = {
  compute_avg?: InputMaybe<Scalars['Boolean']>;
  compute_max?: InputMaybe<Scalars['Boolean']>;
  compute_min?: InputMaybe<Scalars['Boolean']>;
  compute_sum?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['String']>;
  end_days?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_attachments_per_sample?: InputMaybe<Scalars['Int']>;
  max_samples?: InputMaybe<Scalars['Int']>;
  min_samples?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
  start_days?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Cropmonitoring_Parameter_Sum_Fields = {
  __typename?: 'cropmonitoring_parameter_sum_fields';
  end_days?: Maybe<Scalars['Int']>;
  max_attachments_per_sample?: Maybe<Scalars['Int']>;
  max_samples?: Maybe<Scalars['Int']>;
  min_samples?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
  start_days?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Sum_Order_By = {
  end_days?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
};

/** update columns of table "cropmonitoring_parameter" */
export enum Cropmonitoring_Parameter_Update_Column {
  /** column name */
  ComputeAvg = 'compute_avg',
  /** column name */
  ComputeMax = 'compute_max',
  /** column name */
  ComputeMin = 'compute_min',
  /** column name */
  ComputeSum = 'compute_sum',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  EndDays = 'end_days',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxAttachmentsPerSample = 'max_attachments_per_sample',
  /** column name */
  MaxSamples = 'max_samples',
  /** column name */
  MinSamples = 'min_samples',
  /** column name */
  Order = 'order',
  /** column name */
  ParameterId = 'parameter_id',
  /** column name */
  SharedCropId = 'shared_crop_id',
  /** column name */
  StartDays = 'start_days',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Cropmonitoring_Parameter_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cropmonitoring_Parameter_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cropmonitoring_Parameter_Set_Input>;
  where: Cropmonitoring_Parameter_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cropmonitoring_Parameter_Var_Pop_Fields = {
  __typename?: 'cropmonitoring_parameter_var_pop_fields';
  end_days?: Maybe<Scalars['Float']>;
  max_attachments_per_sample?: Maybe<Scalars['Float']>;
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
  start_days?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Var_Pop_Order_By = {
  end_days?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cropmonitoring_Parameter_Var_Samp_Fields = {
  __typename?: 'cropmonitoring_parameter_var_samp_fields';
  end_days?: Maybe<Scalars['Float']>;
  max_attachments_per_sample?: Maybe<Scalars['Float']>;
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
  start_days?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Var_Samp_Order_By = {
  end_days?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cropmonitoring_Parameter_Variance_Fields = {
  __typename?: 'cropmonitoring_parameter_variance_fields';
  end_days?: Maybe<Scalars['Float']>;
  max_attachments_per_sample?: Maybe<Scalars['Float']>;
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
  start_days?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cropmonitoring_parameter" */
export type Cropmonitoring_Parameter_Variance_Order_By = {
  end_days?: InputMaybe<Order_By>;
  max_attachments_per_sample?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
  start_days?: InputMaybe<Order_By>;
};

/** columns and relationships of "currency" */
export type Currency = {
  __typename?: 'currency';
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  operation_costs: Array<Operation_Cost>;
  /** An aggregate relationship */
  operation_costs_aggregate: Operation_Cost_Aggregate;
  /** An array relationship */
  operations_applied_fertilisers: Array<Operations_Applied_Fertiliser>;
  /** An aggregate relationship */
  operations_applied_fertilisers_aggregate: Operations_Applied_Fertiliser_Aggregate;
  /** An array relationship */
  operations_applied_pesticides: Array<Operations_Applied_Pesticide>;
  /** An aggregate relationship */
  operations_applied_pesticides_aggregate: Operations_Applied_Pesticide_Aggregate;
  /** An array relationship */
  operations_harvest_outputs: Array<Operations_Harvest_Output>;
  /** An aggregate relationship */
  operations_harvest_outputs_aggregate: Operations_Harvest_Output_Aggregate;
  short_name: Scalars['String'];
  symbol?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
};


/** columns and relationships of "currency" */
export type CurrencyOperation_CostsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Order_By>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyOperation_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Order_By>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyOperations_Applied_FertilisersArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyOperations_Applied_Fertilisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyOperations_Applied_PesticidesArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyOperations_Applied_Pesticides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyOperations_Harvest_OutputsArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Output_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Output_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyOperations_Harvest_Outputs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Output_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Output_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
};

/** aggregated selection of "currency" */
export type Currency_Aggregate = {
  __typename?: 'currency_aggregate';
  aggregate?: Maybe<Currency_Aggregate_Fields>;
  nodes: Array<Currency>;
};

/** aggregate fields of "currency" */
export type Currency_Aggregate_Fields = {
  __typename?: 'currency_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Currency_Max_Fields>;
  min?: Maybe<Currency_Min_Fields>;
};


/** aggregate fields of "currency" */
export type Currency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Currency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "currency". All fields are combined with a logical 'AND'. */
export type Currency_Bool_Exp = {
  _and?: InputMaybe<Array<Currency_Bool_Exp>>;
  _not?: InputMaybe<Currency_Bool_Exp>;
  _or?: InputMaybe<Array<Currency_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  operation_costs?: InputMaybe<Operation_Cost_Bool_Exp>;
  operations_applied_fertilisers?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
  operations_applied_pesticides?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
  operations_harvest_outputs?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  symbol?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "currency" */
export enum Currency_Constraint {
  /** unique or primary key constraint on columns "name" */
  CurrencyNameKey = 'currency_name_key',
  /** unique or primary key constraint on columns "id" */
  CurrencyPkey = 'currency_pkey'
}

/** input type for inserting data into table "currency" */
export type Currency_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  operation_costs?: InputMaybe<Operation_Cost_Arr_Rel_Insert_Input>;
  operations_applied_fertilisers?: InputMaybe<Operations_Applied_Fertiliser_Arr_Rel_Insert_Input>;
  operations_applied_pesticides?: InputMaybe<Operations_Applied_Pesticide_Arr_Rel_Insert_Input>;
  operations_harvest_outputs?: InputMaybe<Operations_Harvest_Output_Arr_Rel_Insert_Input>;
  short_name?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Currency_Max_Fields = {
  __typename?: 'currency_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Currency_Min_Fields = {
  __typename?: 'currency_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "currency" */
export type Currency_Mutation_Response = {
  __typename?: 'currency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Currency>;
};

/** input type for inserting object relation for remote table "currency" */
export type Currency_Obj_Rel_Insert_Input = {
  data: Currency_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Currency_On_Conflict>;
};

/** on_conflict condition type for table "currency" */
export type Currency_On_Conflict = {
  constraint: Currency_Constraint;
  update_columns?: Array<Currency_Update_Column>;
  where?: InputMaybe<Currency_Bool_Exp>;
};

/** Ordering options when selecting data from "currency". */
export type Currency_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operation_costs_aggregate?: InputMaybe<Operation_Cost_Aggregate_Order_By>;
  operations_applied_fertilisers_aggregate?: InputMaybe<Operations_Applied_Fertiliser_Aggregate_Order_By>;
  operations_applied_pesticides_aggregate?: InputMaybe<Operations_Applied_Pesticide_Aggregate_Order_By>;
  operations_harvest_outputs_aggregate?: InputMaybe<Operations_Harvest_Output_Aggregate_Order_By>;
  short_name?: InputMaybe<Order_By>;
  symbol?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: currency */
export type Currency_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "currency" */
export enum Currency_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Symbol = 'symbol',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "currency" */
export type Currency_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "currency" */
export type Currency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Currency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Currency_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "currency" */
export enum Currency_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Symbol = 'symbol',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Currency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Currency_Set_Input>;
  where: Currency_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "daily_actual_reading" */
export type Daily_Actual_Reading = {
  __typename?: 'daily_actual_reading';
  created_at: Scalars['timestamptz'];
  date: Scalars['date'];
  id: Scalars['bigint'];
  location_id: Scalars['uuid'];
  max_apparent_temperature?: Maybe<Scalars['float8']>;
  max_cloud_cover?: Maybe<Scalars['float8']>;
  max_delta_t?: Maybe<Scalars['float8']>;
  max_dew_point?: Maybe<Scalars['float8']>;
  max_pressure?: Maybe<Scalars['float8']>;
  max_relative_humidity?: Maybe<Scalars['float8']>;
  max_solar_radiation?: Maybe<Scalars['float8']>;
  max_temperature?: Maybe<Scalars['float8']>;
  max_wind_direction_deg?: Maybe<Scalars['float8']>;
  max_wind_speed?: Maybe<Scalars['float8']>;
  mean_apparent_temperature?: Maybe<Scalars['float8']>;
  mean_cloud_cover?: Maybe<Scalars['float8']>;
  mean_delta_t?: Maybe<Scalars['float8']>;
  mean_dew_point?: Maybe<Scalars['float8']>;
  mean_pressure?: Maybe<Scalars['float8']>;
  mean_relative_humidity?: Maybe<Scalars['float8']>;
  mean_solar_radiation?: Maybe<Scalars['float8']>;
  mean_temperature?: Maybe<Scalars['float8']>;
  mean_wind_direction_deg?: Maybe<Scalars['float8']>;
  mean_wind_speed?: Maybe<Scalars['float8']>;
  min_apparent_temperature?: Maybe<Scalars['float8']>;
  min_cloud_cover?: Maybe<Scalars['float8']>;
  min_delta_t?: Maybe<Scalars['float8']>;
  min_dew_point?: Maybe<Scalars['float8']>;
  min_pressure?: Maybe<Scalars['float8']>;
  min_relative_humidity?: Maybe<Scalars['float8']>;
  min_solar_radiation?: Maybe<Scalars['float8']>;
  min_temperature?: Maybe<Scalars['float8']>;
  min_wind_direction_deg?: Maybe<Scalars['float8']>;
  min_wind_speed?: Maybe<Scalars['float8']>;
  mode_weather_type?: Maybe<Scalars['String']>;
  mode_wind_direction?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  ref_et_hargreaves?: Maybe<Scalars['float8']>;
  ref_et_penman?: Maybe<Scalars['float8']>;
  sunrise?: Maybe<Scalars['time']>;
  sunset?: Maybe<Scalars['time']>;
  total_melted_snow_depth?: Maybe<Scalars['float8']>;
  total_precipitation?: Maybe<Scalars['float8']>;
  total_snow_depth?: Maybe<Scalars['float8']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  weather_location: Weather_Location;
};

/** aggregated selection of "daily_actual_reading" */
export type Daily_Actual_Reading_Aggregate = {
  __typename?: 'daily_actual_reading_aggregate';
  aggregate?: Maybe<Daily_Actual_Reading_Aggregate_Fields>;
  nodes: Array<Daily_Actual_Reading>;
};

/** aggregate fields of "daily_actual_reading" */
export type Daily_Actual_Reading_Aggregate_Fields = {
  __typename?: 'daily_actual_reading_aggregate_fields';
  avg?: Maybe<Daily_Actual_Reading_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Daily_Actual_Reading_Max_Fields>;
  min?: Maybe<Daily_Actual_Reading_Min_Fields>;
  stddev?: Maybe<Daily_Actual_Reading_Stddev_Fields>;
  stddev_pop?: Maybe<Daily_Actual_Reading_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Daily_Actual_Reading_Stddev_Samp_Fields>;
  sum?: Maybe<Daily_Actual_Reading_Sum_Fields>;
  var_pop?: Maybe<Daily_Actual_Reading_Var_Pop_Fields>;
  var_samp?: Maybe<Daily_Actual_Reading_Var_Samp_Fields>;
  variance?: Maybe<Daily_Actual_Reading_Variance_Fields>;
};


/** aggregate fields of "daily_actual_reading" */
export type Daily_Actual_Reading_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Daily_Actual_Reading_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "daily_actual_reading" */
export type Daily_Actual_Reading_Aggregate_Order_By = {
  avg?: InputMaybe<Daily_Actual_Reading_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Daily_Actual_Reading_Max_Order_By>;
  min?: InputMaybe<Daily_Actual_Reading_Min_Order_By>;
  stddev?: InputMaybe<Daily_Actual_Reading_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Daily_Actual_Reading_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Daily_Actual_Reading_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Daily_Actual_Reading_Sum_Order_By>;
  var_pop?: InputMaybe<Daily_Actual_Reading_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Daily_Actual_Reading_Var_Samp_Order_By>;
  variance?: InputMaybe<Daily_Actual_Reading_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "daily_actual_reading" */
export type Daily_Actual_Reading_Arr_Rel_Insert_Input = {
  data: Array<Daily_Actual_Reading_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Daily_Actual_Reading_On_Conflict>;
};

/** aggregate avg on columns */
export type Daily_Actual_Reading_Avg_Fields = {
  __typename?: 'daily_actual_reading_avg_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "daily_actual_reading" */
export type Daily_Actual_Reading_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "daily_actual_reading". All fields are combined with a logical 'AND'. */
export type Daily_Actual_Reading_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Actual_Reading_Bool_Exp>>;
  _not?: InputMaybe<Daily_Actual_Reading_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Actual_Reading_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  max_apparent_temperature?: InputMaybe<Float8_Comparison_Exp>;
  max_cloud_cover?: InputMaybe<Float8_Comparison_Exp>;
  max_delta_t?: InputMaybe<Float8_Comparison_Exp>;
  max_dew_point?: InputMaybe<Float8_Comparison_Exp>;
  max_pressure?: InputMaybe<Float8_Comparison_Exp>;
  max_relative_humidity?: InputMaybe<Float8_Comparison_Exp>;
  max_solar_radiation?: InputMaybe<Float8_Comparison_Exp>;
  max_temperature?: InputMaybe<Float8_Comparison_Exp>;
  max_wind_direction_deg?: InputMaybe<Float8_Comparison_Exp>;
  max_wind_speed?: InputMaybe<Float8_Comparison_Exp>;
  mean_apparent_temperature?: InputMaybe<Float8_Comparison_Exp>;
  mean_cloud_cover?: InputMaybe<Float8_Comparison_Exp>;
  mean_delta_t?: InputMaybe<Float8_Comparison_Exp>;
  mean_dew_point?: InputMaybe<Float8_Comparison_Exp>;
  mean_pressure?: InputMaybe<Float8_Comparison_Exp>;
  mean_relative_humidity?: InputMaybe<Float8_Comparison_Exp>;
  mean_solar_radiation?: InputMaybe<Float8_Comparison_Exp>;
  mean_temperature?: InputMaybe<Float8_Comparison_Exp>;
  mean_wind_direction_deg?: InputMaybe<Float8_Comparison_Exp>;
  mean_wind_speed?: InputMaybe<Float8_Comparison_Exp>;
  min_apparent_temperature?: InputMaybe<Float8_Comparison_Exp>;
  min_cloud_cover?: InputMaybe<Float8_Comparison_Exp>;
  min_delta_t?: InputMaybe<Float8_Comparison_Exp>;
  min_dew_point?: InputMaybe<Float8_Comparison_Exp>;
  min_pressure?: InputMaybe<Float8_Comparison_Exp>;
  min_relative_humidity?: InputMaybe<Float8_Comparison_Exp>;
  min_solar_radiation?: InputMaybe<Float8_Comparison_Exp>;
  min_temperature?: InputMaybe<Float8_Comparison_Exp>;
  min_wind_direction_deg?: InputMaybe<Float8_Comparison_Exp>;
  min_wind_speed?: InputMaybe<Float8_Comparison_Exp>;
  mode_weather_type?: InputMaybe<String_Comparison_Exp>;
  mode_wind_direction?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  ref_et_hargreaves?: InputMaybe<Float8_Comparison_Exp>;
  ref_et_penman?: InputMaybe<Float8_Comparison_Exp>;
  sunrise?: InputMaybe<Time_Comparison_Exp>;
  sunset?: InputMaybe<Time_Comparison_Exp>;
  total_melted_snow_depth?: InputMaybe<Float8_Comparison_Exp>;
  total_precipitation?: InputMaybe<Float8_Comparison_Exp>;
  total_snow_depth?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weather_location?: InputMaybe<Weather_Location_Bool_Exp>;
};

/** unique or primary key constraints on table "daily_actual_reading" */
export enum Daily_Actual_Reading_Constraint {
  /** unique or primary key constraint on columns "date", "provider", "location_id" */
  DailyActualReadingDateProviderLocationIdC9c4c0c2Uniq = 'daily_actual_reading_date_provider_location_id_c9c4c0c2_uniq',
  /** unique or primary key constraint on columns "id" */
  DailyActualReadingPkey = 'daily_actual_reading_pkey'
}

/** input type for incrementing numeric columns in table "daily_actual_reading" */
export type Daily_Actual_Reading_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  max_apparent_temperature?: InputMaybe<Scalars['float8']>;
  max_cloud_cover?: InputMaybe<Scalars['float8']>;
  max_delta_t?: InputMaybe<Scalars['float8']>;
  max_dew_point?: InputMaybe<Scalars['float8']>;
  max_pressure?: InputMaybe<Scalars['float8']>;
  max_relative_humidity?: InputMaybe<Scalars['float8']>;
  max_solar_radiation?: InputMaybe<Scalars['float8']>;
  max_temperature?: InputMaybe<Scalars['float8']>;
  max_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  max_wind_speed?: InputMaybe<Scalars['float8']>;
  mean_apparent_temperature?: InputMaybe<Scalars['float8']>;
  mean_cloud_cover?: InputMaybe<Scalars['float8']>;
  mean_delta_t?: InputMaybe<Scalars['float8']>;
  mean_dew_point?: InputMaybe<Scalars['float8']>;
  mean_pressure?: InputMaybe<Scalars['float8']>;
  mean_relative_humidity?: InputMaybe<Scalars['float8']>;
  mean_solar_radiation?: InputMaybe<Scalars['float8']>;
  mean_temperature?: InputMaybe<Scalars['float8']>;
  mean_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  mean_wind_speed?: InputMaybe<Scalars['float8']>;
  min_apparent_temperature?: InputMaybe<Scalars['float8']>;
  min_cloud_cover?: InputMaybe<Scalars['float8']>;
  min_delta_t?: InputMaybe<Scalars['float8']>;
  min_dew_point?: InputMaybe<Scalars['float8']>;
  min_pressure?: InputMaybe<Scalars['float8']>;
  min_relative_humidity?: InputMaybe<Scalars['float8']>;
  min_solar_radiation?: InputMaybe<Scalars['float8']>;
  min_temperature?: InputMaybe<Scalars['float8']>;
  min_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  min_wind_speed?: InputMaybe<Scalars['float8']>;
  ref_et_hargreaves?: InputMaybe<Scalars['float8']>;
  ref_et_penman?: InputMaybe<Scalars['float8']>;
  total_melted_snow_depth?: InputMaybe<Scalars['float8']>;
  total_precipitation?: InputMaybe<Scalars['float8']>;
  total_snow_depth?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "daily_actual_reading" */
export type Daily_Actual_Reading_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  max_apparent_temperature?: InputMaybe<Scalars['float8']>;
  max_cloud_cover?: InputMaybe<Scalars['float8']>;
  max_delta_t?: InputMaybe<Scalars['float8']>;
  max_dew_point?: InputMaybe<Scalars['float8']>;
  max_pressure?: InputMaybe<Scalars['float8']>;
  max_relative_humidity?: InputMaybe<Scalars['float8']>;
  max_solar_radiation?: InputMaybe<Scalars['float8']>;
  max_temperature?: InputMaybe<Scalars['float8']>;
  max_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  max_wind_speed?: InputMaybe<Scalars['float8']>;
  mean_apparent_temperature?: InputMaybe<Scalars['float8']>;
  mean_cloud_cover?: InputMaybe<Scalars['float8']>;
  mean_delta_t?: InputMaybe<Scalars['float8']>;
  mean_dew_point?: InputMaybe<Scalars['float8']>;
  mean_pressure?: InputMaybe<Scalars['float8']>;
  mean_relative_humidity?: InputMaybe<Scalars['float8']>;
  mean_solar_radiation?: InputMaybe<Scalars['float8']>;
  mean_temperature?: InputMaybe<Scalars['float8']>;
  mean_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  mean_wind_speed?: InputMaybe<Scalars['float8']>;
  min_apparent_temperature?: InputMaybe<Scalars['float8']>;
  min_cloud_cover?: InputMaybe<Scalars['float8']>;
  min_delta_t?: InputMaybe<Scalars['float8']>;
  min_dew_point?: InputMaybe<Scalars['float8']>;
  min_pressure?: InputMaybe<Scalars['float8']>;
  min_relative_humidity?: InputMaybe<Scalars['float8']>;
  min_solar_radiation?: InputMaybe<Scalars['float8']>;
  min_temperature?: InputMaybe<Scalars['float8']>;
  min_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  min_wind_speed?: InputMaybe<Scalars['float8']>;
  mode_weather_type?: InputMaybe<Scalars['String']>;
  mode_wind_direction?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  ref_et_hargreaves?: InputMaybe<Scalars['float8']>;
  ref_et_penman?: InputMaybe<Scalars['float8']>;
  sunrise?: InputMaybe<Scalars['time']>;
  sunset?: InputMaybe<Scalars['time']>;
  total_melted_snow_depth?: InputMaybe<Scalars['float8']>;
  total_precipitation?: InputMaybe<Scalars['float8']>;
  total_snow_depth?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weather_location?: InputMaybe<Weather_Location_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Daily_Actual_Reading_Max_Fields = {
  __typename?: 'daily_actual_reading_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  max_apparent_temperature?: Maybe<Scalars['float8']>;
  max_cloud_cover?: Maybe<Scalars['float8']>;
  max_delta_t?: Maybe<Scalars['float8']>;
  max_dew_point?: Maybe<Scalars['float8']>;
  max_pressure?: Maybe<Scalars['float8']>;
  max_relative_humidity?: Maybe<Scalars['float8']>;
  max_solar_radiation?: Maybe<Scalars['float8']>;
  max_temperature?: Maybe<Scalars['float8']>;
  max_wind_direction_deg?: Maybe<Scalars['float8']>;
  max_wind_speed?: Maybe<Scalars['float8']>;
  mean_apparent_temperature?: Maybe<Scalars['float8']>;
  mean_cloud_cover?: Maybe<Scalars['float8']>;
  mean_delta_t?: Maybe<Scalars['float8']>;
  mean_dew_point?: Maybe<Scalars['float8']>;
  mean_pressure?: Maybe<Scalars['float8']>;
  mean_relative_humidity?: Maybe<Scalars['float8']>;
  mean_solar_radiation?: Maybe<Scalars['float8']>;
  mean_temperature?: Maybe<Scalars['float8']>;
  mean_wind_direction_deg?: Maybe<Scalars['float8']>;
  mean_wind_speed?: Maybe<Scalars['float8']>;
  min_apparent_temperature?: Maybe<Scalars['float8']>;
  min_cloud_cover?: Maybe<Scalars['float8']>;
  min_delta_t?: Maybe<Scalars['float8']>;
  min_dew_point?: Maybe<Scalars['float8']>;
  min_pressure?: Maybe<Scalars['float8']>;
  min_relative_humidity?: Maybe<Scalars['float8']>;
  min_solar_radiation?: Maybe<Scalars['float8']>;
  min_temperature?: Maybe<Scalars['float8']>;
  min_wind_direction_deg?: Maybe<Scalars['float8']>;
  min_wind_speed?: Maybe<Scalars['float8']>;
  mode_weather_type?: Maybe<Scalars['String']>;
  mode_wind_direction?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  ref_et_hargreaves?: Maybe<Scalars['float8']>;
  ref_et_penman?: Maybe<Scalars['float8']>;
  total_melted_snow_depth?: Maybe<Scalars['float8']>;
  total_precipitation?: Maybe<Scalars['float8']>;
  total_snow_depth?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "daily_actual_reading" */
export type Daily_Actual_Reading_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  mode_weather_type?: InputMaybe<Order_By>;
  mode_wind_direction?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Daily_Actual_Reading_Min_Fields = {
  __typename?: 'daily_actual_reading_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  max_apparent_temperature?: Maybe<Scalars['float8']>;
  max_cloud_cover?: Maybe<Scalars['float8']>;
  max_delta_t?: Maybe<Scalars['float8']>;
  max_dew_point?: Maybe<Scalars['float8']>;
  max_pressure?: Maybe<Scalars['float8']>;
  max_relative_humidity?: Maybe<Scalars['float8']>;
  max_solar_radiation?: Maybe<Scalars['float8']>;
  max_temperature?: Maybe<Scalars['float8']>;
  max_wind_direction_deg?: Maybe<Scalars['float8']>;
  max_wind_speed?: Maybe<Scalars['float8']>;
  mean_apparent_temperature?: Maybe<Scalars['float8']>;
  mean_cloud_cover?: Maybe<Scalars['float8']>;
  mean_delta_t?: Maybe<Scalars['float8']>;
  mean_dew_point?: Maybe<Scalars['float8']>;
  mean_pressure?: Maybe<Scalars['float8']>;
  mean_relative_humidity?: Maybe<Scalars['float8']>;
  mean_solar_radiation?: Maybe<Scalars['float8']>;
  mean_temperature?: Maybe<Scalars['float8']>;
  mean_wind_direction_deg?: Maybe<Scalars['float8']>;
  mean_wind_speed?: Maybe<Scalars['float8']>;
  min_apparent_temperature?: Maybe<Scalars['float8']>;
  min_cloud_cover?: Maybe<Scalars['float8']>;
  min_delta_t?: Maybe<Scalars['float8']>;
  min_dew_point?: Maybe<Scalars['float8']>;
  min_pressure?: Maybe<Scalars['float8']>;
  min_relative_humidity?: Maybe<Scalars['float8']>;
  min_solar_radiation?: Maybe<Scalars['float8']>;
  min_temperature?: Maybe<Scalars['float8']>;
  min_wind_direction_deg?: Maybe<Scalars['float8']>;
  min_wind_speed?: Maybe<Scalars['float8']>;
  mode_weather_type?: Maybe<Scalars['String']>;
  mode_wind_direction?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  ref_et_hargreaves?: Maybe<Scalars['float8']>;
  ref_et_penman?: Maybe<Scalars['float8']>;
  total_melted_snow_depth?: Maybe<Scalars['float8']>;
  total_precipitation?: Maybe<Scalars['float8']>;
  total_snow_depth?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "daily_actual_reading" */
export type Daily_Actual_Reading_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  mode_weather_type?: InputMaybe<Order_By>;
  mode_wind_direction?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "daily_actual_reading" */
export type Daily_Actual_Reading_Mutation_Response = {
  __typename?: 'daily_actual_reading_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Daily_Actual_Reading>;
};

/** on_conflict condition type for table "daily_actual_reading" */
export type Daily_Actual_Reading_On_Conflict = {
  constraint: Daily_Actual_Reading_Constraint;
  update_columns?: Array<Daily_Actual_Reading_Update_Column>;
  where?: InputMaybe<Daily_Actual_Reading_Bool_Exp>;
};

/** Ordering options when selecting data from "daily_actual_reading". */
export type Daily_Actual_Reading_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  mode_weather_type?: InputMaybe<Order_By>;
  mode_wind_direction?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  sunrise?: InputMaybe<Order_By>;
  sunset?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weather_location?: InputMaybe<Weather_Location_Order_By>;
};

/** primary key columns input for table: daily_actual_reading */
export type Daily_Actual_Reading_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "daily_actual_reading" */
export enum Daily_Actual_Reading_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaxApparentTemperature = 'max_apparent_temperature',
  /** column name */
  MaxCloudCover = 'max_cloud_cover',
  /** column name */
  MaxDeltaT = 'max_delta_t',
  /** column name */
  MaxDewPoint = 'max_dew_point',
  /** column name */
  MaxPressure = 'max_pressure',
  /** column name */
  MaxRelativeHumidity = 'max_relative_humidity',
  /** column name */
  MaxSolarRadiation = 'max_solar_radiation',
  /** column name */
  MaxTemperature = 'max_temperature',
  /** column name */
  MaxWindDirectionDeg = 'max_wind_direction_deg',
  /** column name */
  MaxWindSpeed = 'max_wind_speed',
  /** column name */
  MeanApparentTemperature = 'mean_apparent_temperature',
  /** column name */
  MeanCloudCover = 'mean_cloud_cover',
  /** column name */
  MeanDeltaT = 'mean_delta_t',
  /** column name */
  MeanDewPoint = 'mean_dew_point',
  /** column name */
  MeanPressure = 'mean_pressure',
  /** column name */
  MeanRelativeHumidity = 'mean_relative_humidity',
  /** column name */
  MeanSolarRadiation = 'mean_solar_radiation',
  /** column name */
  MeanTemperature = 'mean_temperature',
  /** column name */
  MeanWindDirectionDeg = 'mean_wind_direction_deg',
  /** column name */
  MeanWindSpeed = 'mean_wind_speed',
  /** column name */
  MinApparentTemperature = 'min_apparent_temperature',
  /** column name */
  MinCloudCover = 'min_cloud_cover',
  /** column name */
  MinDeltaT = 'min_delta_t',
  /** column name */
  MinDewPoint = 'min_dew_point',
  /** column name */
  MinPressure = 'min_pressure',
  /** column name */
  MinRelativeHumidity = 'min_relative_humidity',
  /** column name */
  MinSolarRadiation = 'min_solar_radiation',
  /** column name */
  MinTemperature = 'min_temperature',
  /** column name */
  MinWindDirectionDeg = 'min_wind_direction_deg',
  /** column name */
  MinWindSpeed = 'min_wind_speed',
  /** column name */
  ModeWeatherType = 'mode_weather_type',
  /** column name */
  ModeWindDirection = 'mode_wind_direction',
  /** column name */
  Provider = 'provider',
  /** column name */
  RefEtHargreaves = 'ref_et_hargreaves',
  /** column name */
  RefEtPenman = 'ref_et_penman',
  /** column name */
  Sunrise = 'sunrise',
  /** column name */
  Sunset = 'sunset',
  /** column name */
  TotalMeltedSnowDepth = 'total_melted_snow_depth',
  /** column name */
  TotalPrecipitation = 'total_precipitation',
  /** column name */
  TotalSnowDepth = 'total_snow_depth',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "daily_actual_reading" */
export type Daily_Actual_Reading_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  max_apparent_temperature?: InputMaybe<Scalars['float8']>;
  max_cloud_cover?: InputMaybe<Scalars['float8']>;
  max_delta_t?: InputMaybe<Scalars['float8']>;
  max_dew_point?: InputMaybe<Scalars['float8']>;
  max_pressure?: InputMaybe<Scalars['float8']>;
  max_relative_humidity?: InputMaybe<Scalars['float8']>;
  max_solar_radiation?: InputMaybe<Scalars['float8']>;
  max_temperature?: InputMaybe<Scalars['float8']>;
  max_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  max_wind_speed?: InputMaybe<Scalars['float8']>;
  mean_apparent_temperature?: InputMaybe<Scalars['float8']>;
  mean_cloud_cover?: InputMaybe<Scalars['float8']>;
  mean_delta_t?: InputMaybe<Scalars['float8']>;
  mean_dew_point?: InputMaybe<Scalars['float8']>;
  mean_pressure?: InputMaybe<Scalars['float8']>;
  mean_relative_humidity?: InputMaybe<Scalars['float8']>;
  mean_solar_radiation?: InputMaybe<Scalars['float8']>;
  mean_temperature?: InputMaybe<Scalars['float8']>;
  mean_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  mean_wind_speed?: InputMaybe<Scalars['float8']>;
  min_apparent_temperature?: InputMaybe<Scalars['float8']>;
  min_cloud_cover?: InputMaybe<Scalars['float8']>;
  min_delta_t?: InputMaybe<Scalars['float8']>;
  min_dew_point?: InputMaybe<Scalars['float8']>;
  min_pressure?: InputMaybe<Scalars['float8']>;
  min_relative_humidity?: InputMaybe<Scalars['float8']>;
  min_solar_radiation?: InputMaybe<Scalars['float8']>;
  min_temperature?: InputMaybe<Scalars['float8']>;
  min_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  min_wind_speed?: InputMaybe<Scalars['float8']>;
  mode_weather_type?: InputMaybe<Scalars['String']>;
  mode_wind_direction?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  ref_et_hargreaves?: InputMaybe<Scalars['float8']>;
  ref_et_penman?: InputMaybe<Scalars['float8']>;
  sunrise?: InputMaybe<Scalars['time']>;
  sunset?: InputMaybe<Scalars['time']>;
  total_melted_snow_depth?: InputMaybe<Scalars['float8']>;
  total_precipitation?: InputMaybe<Scalars['float8']>;
  total_snow_depth?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Daily_Actual_Reading_Stddev_Fields = {
  __typename?: 'daily_actual_reading_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "daily_actual_reading" */
export type Daily_Actual_Reading_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Daily_Actual_Reading_Stddev_Pop_Fields = {
  __typename?: 'daily_actual_reading_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "daily_actual_reading" */
export type Daily_Actual_Reading_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Daily_Actual_Reading_Stddev_Samp_Fields = {
  __typename?: 'daily_actual_reading_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "daily_actual_reading" */
export type Daily_Actual_Reading_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "daily_actual_reading" */
export type Daily_Actual_Reading_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Daily_Actual_Reading_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Daily_Actual_Reading_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  max_apparent_temperature?: InputMaybe<Scalars['float8']>;
  max_cloud_cover?: InputMaybe<Scalars['float8']>;
  max_delta_t?: InputMaybe<Scalars['float8']>;
  max_dew_point?: InputMaybe<Scalars['float8']>;
  max_pressure?: InputMaybe<Scalars['float8']>;
  max_relative_humidity?: InputMaybe<Scalars['float8']>;
  max_solar_radiation?: InputMaybe<Scalars['float8']>;
  max_temperature?: InputMaybe<Scalars['float8']>;
  max_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  max_wind_speed?: InputMaybe<Scalars['float8']>;
  mean_apparent_temperature?: InputMaybe<Scalars['float8']>;
  mean_cloud_cover?: InputMaybe<Scalars['float8']>;
  mean_delta_t?: InputMaybe<Scalars['float8']>;
  mean_dew_point?: InputMaybe<Scalars['float8']>;
  mean_pressure?: InputMaybe<Scalars['float8']>;
  mean_relative_humidity?: InputMaybe<Scalars['float8']>;
  mean_solar_radiation?: InputMaybe<Scalars['float8']>;
  mean_temperature?: InputMaybe<Scalars['float8']>;
  mean_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  mean_wind_speed?: InputMaybe<Scalars['float8']>;
  min_apparent_temperature?: InputMaybe<Scalars['float8']>;
  min_cloud_cover?: InputMaybe<Scalars['float8']>;
  min_delta_t?: InputMaybe<Scalars['float8']>;
  min_dew_point?: InputMaybe<Scalars['float8']>;
  min_pressure?: InputMaybe<Scalars['float8']>;
  min_relative_humidity?: InputMaybe<Scalars['float8']>;
  min_solar_radiation?: InputMaybe<Scalars['float8']>;
  min_temperature?: InputMaybe<Scalars['float8']>;
  min_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  min_wind_speed?: InputMaybe<Scalars['float8']>;
  mode_weather_type?: InputMaybe<Scalars['String']>;
  mode_wind_direction?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  ref_et_hargreaves?: InputMaybe<Scalars['float8']>;
  ref_et_penman?: InputMaybe<Scalars['float8']>;
  sunrise?: InputMaybe<Scalars['time']>;
  sunset?: InputMaybe<Scalars['time']>;
  total_melted_snow_depth?: InputMaybe<Scalars['float8']>;
  total_precipitation?: InputMaybe<Scalars['float8']>;
  total_snow_depth?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Daily_Actual_Reading_Sum_Fields = {
  __typename?: 'daily_actual_reading_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  max_apparent_temperature?: Maybe<Scalars['float8']>;
  max_cloud_cover?: Maybe<Scalars['float8']>;
  max_delta_t?: Maybe<Scalars['float8']>;
  max_dew_point?: Maybe<Scalars['float8']>;
  max_pressure?: Maybe<Scalars['float8']>;
  max_relative_humidity?: Maybe<Scalars['float8']>;
  max_solar_radiation?: Maybe<Scalars['float8']>;
  max_temperature?: Maybe<Scalars['float8']>;
  max_wind_direction_deg?: Maybe<Scalars['float8']>;
  max_wind_speed?: Maybe<Scalars['float8']>;
  mean_apparent_temperature?: Maybe<Scalars['float8']>;
  mean_cloud_cover?: Maybe<Scalars['float8']>;
  mean_delta_t?: Maybe<Scalars['float8']>;
  mean_dew_point?: Maybe<Scalars['float8']>;
  mean_pressure?: Maybe<Scalars['float8']>;
  mean_relative_humidity?: Maybe<Scalars['float8']>;
  mean_solar_radiation?: Maybe<Scalars['float8']>;
  mean_temperature?: Maybe<Scalars['float8']>;
  mean_wind_direction_deg?: Maybe<Scalars['float8']>;
  mean_wind_speed?: Maybe<Scalars['float8']>;
  min_apparent_temperature?: Maybe<Scalars['float8']>;
  min_cloud_cover?: Maybe<Scalars['float8']>;
  min_delta_t?: Maybe<Scalars['float8']>;
  min_dew_point?: Maybe<Scalars['float8']>;
  min_pressure?: Maybe<Scalars['float8']>;
  min_relative_humidity?: Maybe<Scalars['float8']>;
  min_solar_radiation?: Maybe<Scalars['float8']>;
  min_temperature?: Maybe<Scalars['float8']>;
  min_wind_direction_deg?: Maybe<Scalars['float8']>;
  min_wind_speed?: Maybe<Scalars['float8']>;
  ref_et_hargreaves?: Maybe<Scalars['float8']>;
  ref_et_penman?: Maybe<Scalars['float8']>;
  total_melted_snow_depth?: Maybe<Scalars['float8']>;
  total_precipitation?: Maybe<Scalars['float8']>;
  total_snow_depth?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "daily_actual_reading" */
export type Daily_Actual_Reading_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** update columns of table "daily_actual_reading" */
export enum Daily_Actual_Reading_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaxApparentTemperature = 'max_apparent_temperature',
  /** column name */
  MaxCloudCover = 'max_cloud_cover',
  /** column name */
  MaxDeltaT = 'max_delta_t',
  /** column name */
  MaxDewPoint = 'max_dew_point',
  /** column name */
  MaxPressure = 'max_pressure',
  /** column name */
  MaxRelativeHumidity = 'max_relative_humidity',
  /** column name */
  MaxSolarRadiation = 'max_solar_radiation',
  /** column name */
  MaxTemperature = 'max_temperature',
  /** column name */
  MaxWindDirectionDeg = 'max_wind_direction_deg',
  /** column name */
  MaxWindSpeed = 'max_wind_speed',
  /** column name */
  MeanApparentTemperature = 'mean_apparent_temperature',
  /** column name */
  MeanCloudCover = 'mean_cloud_cover',
  /** column name */
  MeanDeltaT = 'mean_delta_t',
  /** column name */
  MeanDewPoint = 'mean_dew_point',
  /** column name */
  MeanPressure = 'mean_pressure',
  /** column name */
  MeanRelativeHumidity = 'mean_relative_humidity',
  /** column name */
  MeanSolarRadiation = 'mean_solar_radiation',
  /** column name */
  MeanTemperature = 'mean_temperature',
  /** column name */
  MeanWindDirectionDeg = 'mean_wind_direction_deg',
  /** column name */
  MeanWindSpeed = 'mean_wind_speed',
  /** column name */
  MinApparentTemperature = 'min_apparent_temperature',
  /** column name */
  MinCloudCover = 'min_cloud_cover',
  /** column name */
  MinDeltaT = 'min_delta_t',
  /** column name */
  MinDewPoint = 'min_dew_point',
  /** column name */
  MinPressure = 'min_pressure',
  /** column name */
  MinRelativeHumidity = 'min_relative_humidity',
  /** column name */
  MinSolarRadiation = 'min_solar_radiation',
  /** column name */
  MinTemperature = 'min_temperature',
  /** column name */
  MinWindDirectionDeg = 'min_wind_direction_deg',
  /** column name */
  MinWindSpeed = 'min_wind_speed',
  /** column name */
  ModeWeatherType = 'mode_weather_type',
  /** column name */
  ModeWindDirection = 'mode_wind_direction',
  /** column name */
  Provider = 'provider',
  /** column name */
  RefEtHargreaves = 'ref_et_hargreaves',
  /** column name */
  RefEtPenman = 'ref_et_penman',
  /** column name */
  Sunrise = 'sunrise',
  /** column name */
  Sunset = 'sunset',
  /** column name */
  TotalMeltedSnowDepth = 'total_melted_snow_depth',
  /** column name */
  TotalPrecipitation = 'total_precipitation',
  /** column name */
  TotalSnowDepth = 'total_snow_depth',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Daily_Actual_Reading_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Daily_Actual_Reading_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Daily_Actual_Reading_Set_Input>;
  where: Daily_Actual_Reading_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Daily_Actual_Reading_Var_Pop_Fields = {
  __typename?: 'daily_actual_reading_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "daily_actual_reading" */
export type Daily_Actual_Reading_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Daily_Actual_Reading_Var_Samp_Fields = {
  __typename?: 'daily_actual_reading_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "daily_actual_reading" */
export type Daily_Actual_Reading_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Daily_Actual_Reading_Variance_Fields = {
  __typename?: 'daily_actual_reading_variance_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "daily_actual_reading" */
export type Daily_Actual_Reading_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** columns and relationships of "daily_forecast_reading" */
export type Daily_Forecast_Reading = {
  __typename?: 'daily_forecast_reading';
  created_at: Scalars['timestamptz'];
  date: Scalars['date'];
  id: Scalars['bigint'];
  location_id: Scalars['uuid'];
  max_apparent_temperature?: Maybe<Scalars['float8']>;
  max_cloud_cover?: Maybe<Scalars['float8']>;
  max_delta_t?: Maybe<Scalars['float8']>;
  max_dew_point?: Maybe<Scalars['float8']>;
  max_pressure?: Maybe<Scalars['float8']>;
  max_relative_humidity?: Maybe<Scalars['float8']>;
  max_solar_radiation?: Maybe<Scalars['float8']>;
  max_temperature?: Maybe<Scalars['float8']>;
  max_wind_direction_deg?: Maybe<Scalars['float8']>;
  max_wind_speed?: Maybe<Scalars['float8']>;
  mean_apparent_temperature?: Maybe<Scalars['float8']>;
  mean_cloud_cover?: Maybe<Scalars['float8']>;
  mean_delta_t?: Maybe<Scalars['float8']>;
  mean_dew_point?: Maybe<Scalars['float8']>;
  mean_pressure?: Maybe<Scalars['float8']>;
  mean_relative_humidity?: Maybe<Scalars['float8']>;
  mean_solar_radiation?: Maybe<Scalars['float8']>;
  mean_temperature?: Maybe<Scalars['float8']>;
  mean_wind_direction_deg?: Maybe<Scalars['float8']>;
  mean_wind_speed?: Maybe<Scalars['float8']>;
  min_apparent_temperature?: Maybe<Scalars['float8']>;
  min_cloud_cover?: Maybe<Scalars['float8']>;
  min_delta_t?: Maybe<Scalars['float8']>;
  min_dew_point?: Maybe<Scalars['float8']>;
  min_pressure?: Maybe<Scalars['float8']>;
  min_relative_humidity?: Maybe<Scalars['float8']>;
  min_solar_radiation?: Maybe<Scalars['float8']>;
  min_temperature?: Maybe<Scalars['float8']>;
  min_wind_direction_deg?: Maybe<Scalars['float8']>;
  min_wind_speed?: Maybe<Scalars['float8']>;
  mode_weather_type?: Maybe<Scalars['String']>;
  mode_wind_direction?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  ref_et_hargreaves?: Maybe<Scalars['float8']>;
  ref_et_penman?: Maybe<Scalars['float8']>;
  sunrise?: Maybe<Scalars['time']>;
  sunset?: Maybe<Scalars['time']>;
  total_melted_snow_depth?: Maybe<Scalars['float8']>;
  total_precipitation?: Maybe<Scalars['float8']>;
  total_snow_depth?: Maybe<Scalars['float8']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  weather_location: Weather_Location;
};

/** aggregated selection of "daily_forecast_reading" */
export type Daily_Forecast_Reading_Aggregate = {
  __typename?: 'daily_forecast_reading_aggregate';
  aggregate?: Maybe<Daily_Forecast_Reading_Aggregate_Fields>;
  nodes: Array<Daily_Forecast_Reading>;
};

/** aggregate fields of "daily_forecast_reading" */
export type Daily_Forecast_Reading_Aggregate_Fields = {
  __typename?: 'daily_forecast_reading_aggregate_fields';
  avg?: Maybe<Daily_Forecast_Reading_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Daily_Forecast_Reading_Max_Fields>;
  min?: Maybe<Daily_Forecast_Reading_Min_Fields>;
  stddev?: Maybe<Daily_Forecast_Reading_Stddev_Fields>;
  stddev_pop?: Maybe<Daily_Forecast_Reading_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Daily_Forecast_Reading_Stddev_Samp_Fields>;
  sum?: Maybe<Daily_Forecast_Reading_Sum_Fields>;
  var_pop?: Maybe<Daily_Forecast_Reading_Var_Pop_Fields>;
  var_samp?: Maybe<Daily_Forecast_Reading_Var_Samp_Fields>;
  variance?: Maybe<Daily_Forecast_Reading_Variance_Fields>;
};


/** aggregate fields of "daily_forecast_reading" */
export type Daily_Forecast_Reading_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Daily_Forecast_Reading_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Aggregate_Order_By = {
  avg?: InputMaybe<Daily_Forecast_Reading_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Daily_Forecast_Reading_Max_Order_By>;
  min?: InputMaybe<Daily_Forecast_Reading_Min_Order_By>;
  stddev?: InputMaybe<Daily_Forecast_Reading_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Daily_Forecast_Reading_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Daily_Forecast_Reading_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Daily_Forecast_Reading_Sum_Order_By>;
  var_pop?: InputMaybe<Daily_Forecast_Reading_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Daily_Forecast_Reading_Var_Samp_Order_By>;
  variance?: InputMaybe<Daily_Forecast_Reading_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Arr_Rel_Insert_Input = {
  data: Array<Daily_Forecast_Reading_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Daily_Forecast_Reading_On_Conflict>;
};

/** aggregate avg on columns */
export type Daily_Forecast_Reading_Avg_Fields = {
  __typename?: 'daily_forecast_reading_avg_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "daily_forecast_reading". All fields are combined with a logical 'AND'. */
export type Daily_Forecast_Reading_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Forecast_Reading_Bool_Exp>>;
  _not?: InputMaybe<Daily_Forecast_Reading_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Forecast_Reading_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  max_apparent_temperature?: InputMaybe<Float8_Comparison_Exp>;
  max_cloud_cover?: InputMaybe<Float8_Comparison_Exp>;
  max_delta_t?: InputMaybe<Float8_Comparison_Exp>;
  max_dew_point?: InputMaybe<Float8_Comparison_Exp>;
  max_pressure?: InputMaybe<Float8_Comparison_Exp>;
  max_relative_humidity?: InputMaybe<Float8_Comparison_Exp>;
  max_solar_radiation?: InputMaybe<Float8_Comparison_Exp>;
  max_temperature?: InputMaybe<Float8_Comparison_Exp>;
  max_wind_direction_deg?: InputMaybe<Float8_Comparison_Exp>;
  max_wind_speed?: InputMaybe<Float8_Comparison_Exp>;
  mean_apparent_temperature?: InputMaybe<Float8_Comparison_Exp>;
  mean_cloud_cover?: InputMaybe<Float8_Comparison_Exp>;
  mean_delta_t?: InputMaybe<Float8_Comparison_Exp>;
  mean_dew_point?: InputMaybe<Float8_Comparison_Exp>;
  mean_pressure?: InputMaybe<Float8_Comparison_Exp>;
  mean_relative_humidity?: InputMaybe<Float8_Comparison_Exp>;
  mean_solar_radiation?: InputMaybe<Float8_Comparison_Exp>;
  mean_temperature?: InputMaybe<Float8_Comparison_Exp>;
  mean_wind_direction_deg?: InputMaybe<Float8_Comparison_Exp>;
  mean_wind_speed?: InputMaybe<Float8_Comparison_Exp>;
  min_apparent_temperature?: InputMaybe<Float8_Comparison_Exp>;
  min_cloud_cover?: InputMaybe<Float8_Comparison_Exp>;
  min_delta_t?: InputMaybe<Float8_Comparison_Exp>;
  min_dew_point?: InputMaybe<Float8_Comparison_Exp>;
  min_pressure?: InputMaybe<Float8_Comparison_Exp>;
  min_relative_humidity?: InputMaybe<Float8_Comparison_Exp>;
  min_solar_radiation?: InputMaybe<Float8_Comparison_Exp>;
  min_temperature?: InputMaybe<Float8_Comparison_Exp>;
  min_wind_direction_deg?: InputMaybe<Float8_Comparison_Exp>;
  min_wind_speed?: InputMaybe<Float8_Comparison_Exp>;
  mode_weather_type?: InputMaybe<String_Comparison_Exp>;
  mode_wind_direction?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  ref_et_hargreaves?: InputMaybe<Float8_Comparison_Exp>;
  ref_et_penman?: InputMaybe<Float8_Comparison_Exp>;
  sunrise?: InputMaybe<Time_Comparison_Exp>;
  sunset?: InputMaybe<Time_Comparison_Exp>;
  total_melted_snow_depth?: InputMaybe<Float8_Comparison_Exp>;
  total_precipitation?: InputMaybe<Float8_Comparison_Exp>;
  total_snow_depth?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weather_location?: InputMaybe<Weather_Location_Bool_Exp>;
};

/** unique or primary key constraints on table "daily_forecast_reading" */
export enum Daily_Forecast_Reading_Constraint {
  /** unique or primary key constraint on columns "date", "provider", "location_id" */
  DailyForecastReadingDateProviderLocationId_9acc6e5bUniq = 'daily_forecast_reading_date_provider_location_id_9acc6e5b_uniq',
  /** unique or primary key constraint on columns "id" */
  DailyForecastReadingPkey = 'daily_forecast_reading_pkey'
}

/** input type for incrementing numeric columns in table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  max_apparent_temperature?: InputMaybe<Scalars['float8']>;
  max_cloud_cover?: InputMaybe<Scalars['float8']>;
  max_delta_t?: InputMaybe<Scalars['float8']>;
  max_dew_point?: InputMaybe<Scalars['float8']>;
  max_pressure?: InputMaybe<Scalars['float8']>;
  max_relative_humidity?: InputMaybe<Scalars['float8']>;
  max_solar_radiation?: InputMaybe<Scalars['float8']>;
  max_temperature?: InputMaybe<Scalars['float8']>;
  max_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  max_wind_speed?: InputMaybe<Scalars['float8']>;
  mean_apparent_temperature?: InputMaybe<Scalars['float8']>;
  mean_cloud_cover?: InputMaybe<Scalars['float8']>;
  mean_delta_t?: InputMaybe<Scalars['float8']>;
  mean_dew_point?: InputMaybe<Scalars['float8']>;
  mean_pressure?: InputMaybe<Scalars['float8']>;
  mean_relative_humidity?: InputMaybe<Scalars['float8']>;
  mean_solar_radiation?: InputMaybe<Scalars['float8']>;
  mean_temperature?: InputMaybe<Scalars['float8']>;
  mean_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  mean_wind_speed?: InputMaybe<Scalars['float8']>;
  min_apparent_temperature?: InputMaybe<Scalars['float8']>;
  min_cloud_cover?: InputMaybe<Scalars['float8']>;
  min_delta_t?: InputMaybe<Scalars['float8']>;
  min_dew_point?: InputMaybe<Scalars['float8']>;
  min_pressure?: InputMaybe<Scalars['float8']>;
  min_relative_humidity?: InputMaybe<Scalars['float8']>;
  min_solar_radiation?: InputMaybe<Scalars['float8']>;
  min_temperature?: InputMaybe<Scalars['float8']>;
  min_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  min_wind_speed?: InputMaybe<Scalars['float8']>;
  ref_et_hargreaves?: InputMaybe<Scalars['float8']>;
  ref_et_penman?: InputMaybe<Scalars['float8']>;
  total_melted_snow_depth?: InputMaybe<Scalars['float8']>;
  total_precipitation?: InputMaybe<Scalars['float8']>;
  total_snow_depth?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  max_apparent_temperature?: InputMaybe<Scalars['float8']>;
  max_cloud_cover?: InputMaybe<Scalars['float8']>;
  max_delta_t?: InputMaybe<Scalars['float8']>;
  max_dew_point?: InputMaybe<Scalars['float8']>;
  max_pressure?: InputMaybe<Scalars['float8']>;
  max_relative_humidity?: InputMaybe<Scalars['float8']>;
  max_solar_radiation?: InputMaybe<Scalars['float8']>;
  max_temperature?: InputMaybe<Scalars['float8']>;
  max_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  max_wind_speed?: InputMaybe<Scalars['float8']>;
  mean_apparent_temperature?: InputMaybe<Scalars['float8']>;
  mean_cloud_cover?: InputMaybe<Scalars['float8']>;
  mean_delta_t?: InputMaybe<Scalars['float8']>;
  mean_dew_point?: InputMaybe<Scalars['float8']>;
  mean_pressure?: InputMaybe<Scalars['float8']>;
  mean_relative_humidity?: InputMaybe<Scalars['float8']>;
  mean_solar_radiation?: InputMaybe<Scalars['float8']>;
  mean_temperature?: InputMaybe<Scalars['float8']>;
  mean_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  mean_wind_speed?: InputMaybe<Scalars['float8']>;
  min_apparent_temperature?: InputMaybe<Scalars['float8']>;
  min_cloud_cover?: InputMaybe<Scalars['float8']>;
  min_delta_t?: InputMaybe<Scalars['float8']>;
  min_dew_point?: InputMaybe<Scalars['float8']>;
  min_pressure?: InputMaybe<Scalars['float8']>;
  min_relative_humidity?: InputMaybe<Scalars['float8']>;
  min_solar_radiation?: InputMaybe<Scalars['float8']>;
  min_temperature?: InputMaybe<Scalars['float8']>;
  min_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  min_wind_speed?: InputMaybe<Scalars['float8']>;
  mode_weather_type?: InputMaybe<Scalars['String']>;
  mode_wind_direction?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  ref_et_hargreaves?: InputMaybe<Scalars['float8']>;
  ref_et_penman?: InputMaybe<Scalars['float8']>;
  sunrise?: InputMaybe<Scalars['time']>;
  sunset?: InputMaybe<Scalars['time']>;
  total_melted_snow_depth?: InputMaybe<Scalars['float8']>;
  total_precipitation?: InputMaybe<Scalars['float8']>;
  total_snow_depth?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weather_location?: InputMaybe<Weather_Location_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Daily_Forecast_Reading_Max_Fields = {
  __typename?: 'daily_forecast_reading_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  max_apparent_temperature?: Maybe<Scalars['float8']>;
  max_cloud_cover?: Maybe<Scalars['float8']>;
  max_delta_t?: Maybe<Scalars['float8']>;
  max_dew_point?: Maybe<Scalars['float8']>;
  max_pressure?: Maybe<Scalars['float8']>;
  max_relative_humidity?: Maybe<Scalars['float8']>;
  max_solar_radiation?: Maybe<Scalars['float8']>;
  max_temperature?: Maybe<Scalars['float8']>;
  max_wind_direction_deg?: Maybe<Scalars['float8']>;
  max_wind_speed?: Maybe<Scalars['float8']>;
  mean_apparent_temperature?: Maybe<Scalars['float8']>;
  mean_cloud_cover?: Maybe<Scalars['float8']>;
  mean_delta_t?: Maybe<Scalars['float8']>;
  mean_dew_point?: Maybe<Scalars['float8']>;
  mean_pressure?: Maybe<Scalars['float8']>;
  mean_relative_humidity?: Maybe<Scalars['float8']>;
  mean_solar_radiation?: Maybe<Scalars['float8']>;
  mean_temperature?: Maybe<Scalars['float8']>;
  mean_wind_direction_deg?: Maybe<Scalars['float8']>;
  mean_wind_speed?: Maybe<Scalars['float8']>;
  min_apparent_temperature?: Maybe<Scalars['float8']>;
  min_cloud_cover?: Maybe<Scalars['float8']>;
  min_delta_t?: Maybe<Scalars['float8']>;
  min_dew_point?: Maybe<Scalars['float8']>;
  min_pressure?: Maybe<Scalars['float8']>;
  min_relative_humidity?: Maybe<Scalars['float8']>;
  min_solar_radiation?: Maybe<Scalars['float8']>;
  min_temperature?: Maybe<Scalars['float8']>;
  min_wind_direction_deg?: Maybe<Scalars['float8']>;
  min_wind_speed?: Maybe<Scalars['float8']>;
  mode_weather_type?: Maybe<Scalars['String']>;
  mode_wind_direction?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  ref_et_hargreaves?: Maybe<Scalars['float8']>;
  ref_et_penman?: Maybe<Scalars['float8']>;
  total_melted_snow_depth?: Maybe<Scalars['float8']>;
  total_precipitation?: Maybe<Scalars['float8']>;
  total_snow_depth?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  mode_weather_type?: InputMaybe<Order_By>;
  mode_wind_direction?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Daily_Forecast_Reading_Min_Fields = {
  __typename?: 'daily_forecast_reading_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  max_apparent_temperature?: Maybe<Scalars['float8']>;
  max_cloud_cover?: Maybe<Scalars['float8']>;
  max_delta_t?: Maybe<Scalars['float8']>;
  max_dew_point?: Maybe<Scalars['float8']>;
  max_pressure?: Maybe<Scalars['float8']>;
  max_relative_humidity?: Maybe<Scalars['float8']>;
  max_solar_radiation?: Maybe<Scalars['float8']>;
  max_temperature?: Maybe<Scalars['float8']>;
  max_wind_direction_deg?: Maybe<Scalars['float8']>;
  max_wind_speed?: Maybe<Scalars['float8']>;
  mean_apparent_temperature?: Maybe<Scalars['float8']>;
  mean_cloud_cover?: Maybe<Scalars['float8']>;
  mean_delta_t?: Maybe<Scalars['float8']>;
  mean_dew_point?: Maybe<Scalars['float8']>;
  mean_pressure?: Maybe<Scalars['float8']>;
  mean_relative_humidity?: Maybe<Scalars['float8']>;
  mean_solar_radiation?: Maybe<Scalars['float8']>;
  mean_temperature?: Maybe<Scalars['float8']>;
  mean_wind_direction_deg?: Maybe<Scalars['float8']>;
  mean_wind_speed?: Maybe<Scalars['float8']>;
  min_apparent_temperature?: Maybe<Scalars['float8']>;
  min_cloud_cover?: Maybe<Scalars['float8']>;
  min_delta_t?: Maybe<Scalars['float8']>;
  min_dew_point?: Maybe<Scalars['float8']>;
  min_pressure?: Maybe<Scalars['float8']>;
  min_relative_humidity?: Maybe<Scalars['float8']>;
  min_solar_radiation?: Maybe<Scalars['float8']>;
  min_temperature?: Maybe<Scalars['float8']>;
  min_wind_direction_deg?: Maybe<Scalars['float8']>;
  min_wind_speed?: Maybe<Scalars['float8']>;
  mode_weather_type?: Maybe<Scalars['String']>;
  mode_wind_direction?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  ref_et_hargreaves?: Maybe<Scalars['float8']>;
  ref_et_penman?: Maybe<Scalars['float8']>;
  total_melted_snow_depth?: Maybe<Scalars['float8']>;
  total_precipitation?: Maybe<Scalars['float8']>;
  total_snow_depth?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  mode_weather_type?: InputMaybe<Order_By>;
  mode_wind_direction?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Mutation_Response = {
  __typename?: 'daily_forecast_reading_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Daily_Forecast_Reading>;
};

/** on_conflict condition type for table "daily_forecast_reading" */
export type Daily_Forecast_Reading_On_Conflict = {
  constraint: Daily_Forecast_Reading_Constraint;
  update_columns?: Array<Daily_Forecast_Reading_Update_Column>;
  where?: InputMaybe<Daily_Forecast_Reading_Bool_Exp>;
};

/** Ordering options when selecting data from "daily_forecast_reading". */
export type Daily_Forecast_Reading_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  mode_weather_type?: InputMaybe<Order_By>;
  mode_wind_direction?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  sunrise?: InputMaybe<Order_By>;
  sunset?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weather_location?: InputMaybe<Weather_Location_Order_By>;
};

/** primary key columns input for table: daily_forecast_reading */
export type Daily_Forecast_Reading_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "daily_forecast_reading" */
export enum Daily_Forecast_Reading_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaxApparentTemperature = 'max_apparent_temperature',
  /** column name */
  MaxCloudCover = 'max_cloud_cover',
  /** column name */
  MaxDeltaT = 'max_delta_t',
  /** column name */
  MaxDewPoint = 'max_dew_point',
  /** column name */
  MaxPressure = 'max_pressure',
  /** column name */
  MaxRelativeHumidity = 'max_relative_humidity',
  /** column name */
  MaxSolarRadiation = 'max_solar_radiation',
  /** column name */
  MaxTemperature = 'max_temperature',
  /** column name */
  MaxWindDirectionDeg = 'max_wind_direction_deg',
  /** column name */
  MaxWindSpeed = 'max_wind_speed',
  /** column name */
  MeanApparentTemperature = 'mean_apparent_temperature',
  /** column name */
  MeanCloudCover = 'mean_cloud_cover',
  /** column name */
  MeanDeltaT = 'mean_delta_t',
  /** column name */
  MeanDewPoint = 'mean_dew_point',
  /** column name */
  MeanPressure = 'mean_pressure',
  /** column name */
  MeanRelativeHumidity = 'mean_relative_humidity',
  /** column name */
  MeanSolarRadiation = 'mean_solar_radiation',
  /** column name */
  MeanTemperature = 'mean_temperature',
  /** column name */
  MeanWindDirectionDeg = 'mean_wind_direction_deg',
  /** column name */
  MeanWindSpeed = 'mean_wind_speed',
  /** column name */
  MinApparentTemperature = 'min_apparent_temperature',
  /** column name */
  MinCloudCover = 'min_cloud_cover',
  /** column name */
  MinDeltaT = 'min_delta_t',
  /** column name */
  MinDewPoint = 'min_dew_point',
  /** column name */
  MinPressure = 'min_pressure',
  /** column name */
  MinRelativeHumidity = 'min_relative_humidity',
  /** column name */
  MinSolarRadiation = 'min_solar_radiation',
  /** column name */
  MinTemperature = 'min_temperature',
  /** column name */
  MinWindDirectionDeg = 'min_wind_direction_deg',
  /** column name */
  MinWindSpeed = 'min_wind_speed',
  /** column name */
  ModeWeatherType = 'mode_weather_type',
  /** column name */
  ModeWindDirection = 'mode_wind_direction',
  /** column name */
  Provider = 'provider',
  /** column name */
  RefEtHargreaves = 'ref_et_hargreaves',
  /** column name */
  RefEtPenman = 'ref_et_penman',
  /** column name */
  Sunrise = 'sunrise',
  /** column name */
  Sunset = 'sunset',
  /** column name */
  TotalMeltedSnowDepth = 'total_melted_snow_depth',
  /** column name */
  TotalPrecipitation = 'total_precipitation',
  /** column name */
  TotalSnowDepth = 'total_snow_depth',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  max_apparent_temperature?: InputMaybe<Scalars['float8']>;
  max_cloud_cover?: InputMaybe<Scalars['float8']>;
  max_delta_t?: InputMaybe<Scalars['float8']>;
  max_dew_point?: InputMaybe<Scalars['float8']>;
  max_pressure?: InputMaybe<Scalars['float8']>;
  max_relative_humidity?: InputMaybe<Scalars['float8']>;
  max_solar_radiation?: InputMaybe<Scalars['float8']>;
  max_temperature?: InputMaybe<Scalars['float8']>;
  max_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  max_wind_speed?: InputMaybe<Scalars['float8']>;
  mean_apparent_temperature?: InputMaybe<Scalars['float8']>;
  mean_cloud_cover?: InputMaybe<Scalars['float8']>;
  mean_delta_t?: InputMaybe<Scalars['float8']>;
  mean_dew_point?: InputMaybe<Scalars['float8']>;
  mean_pressure?: InputMaybe<Scalars['float8']>;
  mean_relative_humidity?: InputMaybe<Scalars['float8']>;
  mean_solar_radiation?: InputMaybe<Scalars['float8']>;
  mean_temperature?: InputMaybe<Scalars['float8']>;
  mean_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  mean_wind_speed?: InputMaybe<Scalars['float8']>;
  min_apparent_temperature?: InputMaybe<Scalars['float8']>;
  min_cloud_cover?: InputMaybe<Scalars['float8']>;
  min_delta_t?: InputMaybe<Scalars['float8']>;
  min_dew_point?: InputMaybe<Scalars['float8']>;
  min_pressure?: InputMaybe<Scalars['float8']>;
  min_relative_humidity?: InputMaybe<Scalars['float8']>;
  min_solar_radiation?: InputMaybe<Scalars['float8']>;
  min_temperature?: InputMaybe<Scalars['float8']>;
  min_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  min_wind_speed?: InputMaybe<Scalars['float8']>;
  mode_weather_type?: InputMaybe<Scalars['String']>;
  mode_wind_direction?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  ref_et_hargreaves?: InputMaybe<Scalars['float8']>;
  ref_et_penman?: InputMaybe<Scalars['float8']>;
  sunrise?: InputMaybe<Scalars['time']>;
  sunset?: InputMaybe<Scalars['time']>;
  total_melted_snow_depth?: InputMaybe<Scalars['float8']>;
  total_precipitation?: InputMaybe<Scalars['float8']>;
  total_snow_depth?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Daily_Forecast_Reading_Stddev_Fields = {
  __typename?: 'daily_forecast_reading_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Daily_Forecast_Reading_Stddev_Pop_Fields = {
  __typename?: 'daily_forecast_reading_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Daily_Forecast_Reading_Stddev_Samp_Fields = {
  __typename?: 'daily_forecast_reading_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Daily_Forecast_Reading_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Daily_Forecast_Reading_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  max_apparent_temperature?: InputMaybe<Scalars['float8']>;
  max_cloud_cover?: InputMaybe<Scalars['float8']>;
  max_delta_t?: InputMaybe<Scalars['float8']>;
  max_dew_point?: InputMaybe<Scalars['float8']>;
  max_pressure?: InputMaybe<Scalars['float8']>;
  max_relative_humidity?: InputMaybe<Scalars['float8']>;
  max_solar_radiation?: InputMaybe<Scalars['float8']>;
  max_temperature?: InputMaybe<Scalars['float8']>;
  max_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  max_wind_speed?: InputMaybe<Scalars['float8']>;
  mean_apparent_temperature?: InputMaybe<Scalars['float8']>;
  mean_cloud_cover?: InputMaybe<Scalars['float8']>;
  mean_delta_t?: InputMaybe<Scalars['float8']>;
  mean_dew_point?: InputMaybe<Scalars['float8']>;
  mean_pressure?: InputMaybe<Scalars['float8']>;
  mean_relative_humidity?: InputMaybe<Scalars['float8']>;
  mean_solar_radiation?: InputMaybe<Scalars['float8']>;
  mean_temperature?: InputMaybe<Scalars['float8']>;
  mean_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  mean_wind_speed?: InputMaybe<Scalars['float8']>;
  min_apparent_temperature?: InputMaybe<Scalars['float8']>;
  min_cloud_cover?: InputMaybe<Scalars['float8']>;
  min_delta_t?: InputMaybe<Scalars['float8']>;
  min_dew_point?: InputMaybe<Scalars['float8']>;
  min_pressure?: InputMaybe<Scalars['float8']>;
  min_relative_humidity?: InputMaybe<Scalars['float8']>;
  min_solar_radiation?: InputMaybe<Scalars['float8']>;
  min_temperature?: InputMaybe<Scalars['float8']>;
  min_wind_direction_deg?: InputMaybe<Scalars['float8']>;
  min_wind_speed?: InputMaybe<Scalars['float8']>;
  mode_weather_type?: InputMaybe<Scalars['String']>;
  mode_wind_direction?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  ref_et_hargreaves?: InputMaybe<Scalars['float8']>;
  ref_et_penman?: InputMaybe<Scalars['float8']>;
  sunrise?: InputMaybe<Scalars['time']>;
  sunset?: InputMaybe<Scalars['time']>;
  total_melted_snow_depth?: InputMaybe<Scalars['float8']>;
  total_precipitation?: InputMaybe<Scalars['float8']>;
  total_snow_depth?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Daily_Forecast_Reading_Sum_Fields = {
  __typename?: 'daily_forecast_reading_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  max_apparent_temperature?: Maybe<Scalars['float8']>;
  max_cloud_cover?: Maybe<Scalars['float8']>;
  max_delta_t?: Maybe<Scalars['float8']>;
  max_dew_point?: Maybe<Scalars['float8']>;
  max_pressure?: Maybe<Scalars['float8']>;
  max_relative_humidity?: Maybe<Scalars['float8']>;
  max_solar_radiation?: Maybe<Scalars['float8']>;
  max_temperature?: Maybe<Scalars['float8']>;
  max_wind_direction_deg?: Maybe<Scalars['float8']>;
  max_wind_speed?: Maybe<Scalars['float8']>;
  mean_apparent_temperature?: Maybe<Scalars['float8']>;
  mean_cloud_cover?: Maybe<Scalars['float8']>;
  mean_delta_t?: Maybe<Scalars['float8']>;
  mean_dew_point?: Maybe<Scalars['float8']>;
  mean_pressure?: Maybe<Scalars['float8']>;
  mean_relative_humidity?: Maybe<Scalars['float8']>;
  mean_solar_radiation?: Maybe<Scalars['float8']>;
  mean_temperature?: Maybe<Scalars['float8']>;
  mean_wind_direction_deg?: Maybe<Scalars['float8']>;
  mean_wind_speed?: Maybe<Scalars['float8']>;
  min_apparent_temperature?: Maybe<Scalars['float8']>;
  min_cloud_cover?: Maybe<Scalars['float8']>;
  min_delta_t?: Maybe<Scalars['float8']>;
  min_dew_point?: Maybe<Scalars['float8']>;
  min_pressure?: Maybe<Scalars['float8']>;
  min_relative_humidity?: Maybe<Scalars['float8']>;
  min_solar_radiation?: Maybe<Scalars['float8']>;
  min_temperature?: Maybe<Scalars['float8']>;
  min_wind_direction_deg?: Maybe<Scalars['float8']>;
  min_wind_speed?: Maybe<Scalars['float8']>;
  ref_et_hargreaves?: Maybe<Scalars['float8']>;
  ref_et_penman?: Maybe<Scalars['float8']>;
  total_melted_snow_depth?: Maybe<Scalars['float8']>;
  total_precipitation?: Maybe<Scalars['float8']>;
  total_snow_depth?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** update columns of table "daily_forecast_reading" */
export enum Daily_Forecast_Reading_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaxApparentTemperature = 'max_apparent_temperature',
  /** column name */
  MaxCloudCover = 'max_cloud_cover',
  /** column name */
  MaxDeltaT = 'max_delta_t',
  /** column name */
  MaxDewPoint = 'max_dew_point',
  /** column name */
  MaxPressure = 'max_pressure',
  /** column name */
  MaxRelativeHumidity = 'max_relative_humidity',
  /** column name */
  MaxSolarRadiation = 'max_solar_radiation',
  /** column name */
  MaxTemperature = 'max_temperature',
  /** column name */
  MaxWindDirectionDeg = 'max_wind_direction_deg',
  /** column name */
  MaxWindSpeed = 'max_wind_speed',
  /** column name */
  MeanApparentTemperature = 'mean_apparent_temperature',
  /** column name */
  MeanCloudCover = 'mean_cloud_cover',
  /** column name */
  MeanDeltaT = 'mean_delta_t',
  /** column name */
  MeanDewPoint = 'mean_dew_point',
  /** column name */
  MeanPressure = 'mean_pressure',
  /** column name */
  MeanRelativeHumidity = 'mean_relative_humidity',
  /** column name */
  MeanSolarRadiation = 'mean_solar_radiation',
  /** column name */
  MeanTemperature = 'mean_temperature',
  /** column name */
  MeanWindDirectionDeg = 'mean_wind_direction_deg',
  /** column name */
  MeanWindSpeed = 'mean_wind_speed',
  /** column name */
  MinApparentTemperature = 'min_apparent_temperature',
  /** column name */
  MinCloudCover = 'min_cloud_cover',
  /** column name */
  MinDeltaT = 'min_delta_t',
  /** column name */
  MinDewPoint = 'min_dew_point',
  /** column name */
  MinPressure = 'min_pressure',
  /** column name */
  MinRelativeHumidity = 'min_relative_humidity',
  /** column name */
  MinSolarRadiation = 'min_solar_radiation',
  /** column name */
  MinTemperature = 'min_temperature',
  /** column name */
  MinWindDirectionDeg = 'min_wind_direction_deg',
  /** column name */
  MinWindSpeed = 'min_wind_speed',
  /** column name */
  ModeWeatherType = 'mode_weather_type',
  /** column name */
  ModeWindDirection = 'mode_wind_direction',
  /** column name */
  Provider = 'provider',
  /** column name */
  RefEtHargreaves = 'ref_et_hargreaves',
  /** column name */
  RefEtPenman = 'ref_et_penman',
  /** column name */
  Sunrise = 'sunrise',
  /** column name */
  Sunset = 'sunset',
  /** column name */
  TotalMeltedSnowDepth = 'total_melted_snow_depth',
  /** column name */
  TotalPrecipitation = 'total_precipitation',
  /** column name */
  TotalSnowDepth = 'total_snow_depth',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Daily_Forecast_Reading_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Daily_Forecast_Reading_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Daily_Forecast_Reading_Set_Input>;
  where: Daily_Forecast_Reading_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Daily_Forecast_Reading_Var_Pop_Fields = {
  __typename?: 'daily_forecast_reading_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Daily_Forecast_Reading_Var_Samp_Fields = {
  __typename?: 'daily_forecast_reading_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Daily_Forecast_Reading_Variance_Fields = {
  __typename?: 'daily_forecast_reading_variance_fields';
  id?: Maybe<Scalars['Float']>;
  max_apparent_temperature?: Maybe<Scalars['Float']>;
  max_cloud_cover?: Maybe<Scalars['Float']>;
  max_delta_t?: Maybe<Scalars['Float']>;
  max_dew_point?: Maybe<Scalars['Float']>;
  max_pressure?: Maybe<Scalars['Float']>;
  max_relative_humidity?: Maybe<Scalars['Float']>;
  max_solar_radiation?: Maybe<Scalars['Float']>;
  max_temperature?: Maybe<Scalars['Float']>;
  max_wind_direction_deg?: Maybe<Scalars['Float']>;
  max_wind_speed?: Maybe<Scalars['Float']>;
  mean_apparent_temperature?: Maybe<Scalars['Float']>;
  mean_cloud_cover?: Maybe<Scalars['Float']>;
  mean_delta_t?: Maybe<Scalars['Float']>;
  mean_dew_point?: Maybe<Scalars['Float']>;
  mean_pressure?: Maybe<Scalars['Float']>;
  mean_relative_humidity?: Maybe<Scalars['Float']>;
  mean_solar_radiation?: Maybe<Scalars['Float']>;
  mean_temperature?: Maybe<Scalars['Float']>;
  mean_wind_direction_deg?: Maybe<Scalars['Float']>;
  mean_wind_speed?: Maybe<Scalars['Float']>;
  min_apparent_temperature?: Maybe<Scalars['Float']>;
  min_cloud_cover?: Maybe<Scalars['Float']>;
  min_delta_t?: Maybe<Scalars['Float']>;
  min_dew_point?: Maybe<Scalars['Float']>;
  min_pressure?: Maybe<Scalars['Float']>;
  min_relative_humidity?: Maybe<Scalars['Float']>;
  min_solar_radiation?: Maybe<Scalars['Float']>;
  min_temperature?: Maybe<Scalars['Float']>;
  min_wind_direction_deg?: Maybe<Scalars['Float']>;
  min_wind_speed?: Maybe<Scalars['Float']>;
  ref_et_hargreaves?: Maybe<Scalars['Float']>;
  ref_et_penman?: Maybe<Scalars['Float']>;
  total_melted_snow_depth?: Maybe<Scalars['Float']>;
  total_precipitation?: Maybe<Scalars['Float']>;
  total_snow_depth?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "daily_forecast_reading" */
export type Daily_Forecast_Reading_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  max_apparent_temperature?: InputMaybe<Order_By>;
  max_cloud_cover?: InputMaybe<Order_By>;
  max_delta_t?: InputMaybe<Order_By>;
  max_dew_point?: InputMaybe<Order_By>;
  max_pressure?: InputMaybe<Order_By>;
  max_relative_humidity?: InputMaybe<Order_By>;
  max_solar_radiation?: InputMaybe<Order_By>;
  max_temperature?: InputMaybe<Order_By>;
  max_wind_direction_deg?: InputMaybe<Order_By>;
  max_wind_speed?: InputMaybe<Order_By>;
  mean_apparent_temperature?: InputMaybe<Order_By>;
  mean_cloud_cover?: InputMaybe<Order_By>;
  mean_delta_t?: InputMaybe<Order_By>;
  mean_dew_point?: InputMaybe<Order_By>;
  mean_pressure?: InputMaybe<Order_By>;
  mean_relative_humidity?: InputMaybe<Order_By>;
  mean_solar_radiation?: InputMaybe<Order_By>;
  mean_temperature?: InputMaybe<Order_By>;
  mean_wind_direction_deg?: InputMaybe<Order_By>;
  mean_wind_speed?: InputMaybe<Order_By>;
  min_apparent_temperature?: InputMaybe<Order_By>;
  min_cloud_cover?: InputMaybe<Order_By>;
  min_delta_t?: InputMaybe<Order_By>;
  min_dew_point?: InputMaybe<Order_By>;
  min_pressure?: InputMaybe<Order_By>;
  min_relative_humidity?: InputMaybe<Order_By>;
  min_solar_radiation?: InputMaybe<Order_By>;
  min_temperature?: InputMaybe<Order_By>;
  min_wind_direction_deg?: InputMaybe<Order_By>;
  min_wind_speed?: InputMaybe<Order_By>;
  ref_et_hargreaves?: InputMaybe<Order_By>;
  ref_et_penman?: InputMaybe<Order_By>;
  total_melted_snow_depth?: InputMaybe<Order_By>;
  total_precipitation?: InputMaybe<Order_By>;
  total_snow_depth?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "department" */
export type Department = {
  __typename?: 'department';
  abbreviation: Scalars['String'];
  /** An array relationship */
  base_users: Array<Base_User>;
  /** An aggregate relationship */
  base_users_aggregate: Base_User_Aggregate;
  codename: Scalars['String'];
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  display_name: Scalars['String'];
  external_reference_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  photo_id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['String']>;
};


/** columns and relationships of "department" */
export type DepartmentBase_UsersArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


/** columns and relationships of "department" */
export type DepartmentBase_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};

/** aggregated selection of "department" */
export type Department_Aggregate = {
  __typename?: 'department_aggregate';
  aggregate?: Maybe<Department_Aggregate_Fields>;
  nodes: Array<Department>;
};

/** aggregate fields of "department" */
export type Department_Aggregate_Fields = {
  __typename?: 'department_aggregate_fields';
  avg?: Maybe<Department_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Department_Max_Fields>;
  min?: Maybe<Department_Min_Fields>;
  stddev?: Maybe<Department_Stddev_Fields>;
  stddev_pop?: Maybe<Department_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Department_Stddev_Samp_Fields>;
  sum?: Maybe<Department_Sum_Fields>;
  var_pop?: Maybe<Department_Var_Pop_Fields>;
  var_samp?: Maybe<Department_Var_Samp_Fields>;
  variance?: Maybe<Department_Variance_Fields>;
};


/** aggregate fields of "department" */
export type Department_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Department_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Department_Avg_Fields = {
  __typename?: 'department_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "department". All fields are combined with a logical 'AND'. */
export type Department_Bool_Exp = {
  _and?: InputMaybe<Array<Department_Bool_Exp>>;
  _not?: InputMaybe<Department_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  base_users?: InputMaybe<Base_User_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "department". All fields are combined with a logical 'AND'. */
export type Department_Bool_Exp_Remote_Rel_Shared_Entitydepartment = {
  _and?: InputMaybe<Array<Department_Bool_Exp>>;
  _not?: InputMaybe<Department_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  base_users?: InputMaybe<Base_User_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitydepartment>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "department" */
export enum Department_Constraint {
  /** unique or primary key constraint on columns "codename" */
  DepartmentCodenameKey = 'department_codename_key',
  /** unique or primary key constraint on columns "name", "company_id" */
  DepartmentNameCompanyIdE136414dUniq = 'department_name_company_id_e136414d_uniq',
  /** unique or primary key constraint on columns "photo_id" */
  DepartmentPhotoIdKey = 'department_photo_id_key',
  /** unique or primary key constraint on columns "id" */
  DepartmentPkey = 'department_pkey',
  /** unique or primary key constraint on columns "uid" */
  DepartmentUidKey = 'department_uid_key'
}

/** input type for incrementing numeric columns in table "department" */
export type Department_Inc_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "department" */
export type Department_Insert_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  base_users?: InputMaybe<Base_User_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Department_Max_Fields = {
  __typename?: 'department_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Department_Min_Fields = {
  __typename?: 'department_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "department" */
export type Department_Mutation_Response = {
  __typename?: 'department_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Department>;
};

/** input type for inserting object relation for remote table "department" */
export type Department_Obj_Rel_Insert_Input = {
  data: Department_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Department_On_Conflict>;
};

/** on_conflict condition type for table "department" */
export type Department_On_Conflict = {
  constraint: Department_Constraint;
  update_columns?: Array<Department_Update_Column>;
  where?: InputMaybe<Department_Bool_Exp>;
};

/** Ordering options when selecting data from "department". */
export type Department_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  base_users_aggregate?: InputMaybe<Base_User_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: department */
export type Department_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "department" */
export enum Department_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  Codename = 'codename',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  Uid = 'uid'
}

/** input type for updating data in table "department" */
export type Department_Set_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Department_Stddev_Fields = {
  __typename?: 'department_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Department_Stddev_Pop_Fields = {
  __typename?: 'department_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Department_Stddev_Samp_Fields = {
  __typename?: 'department_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "department" */
export type Department_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Department_Sum_Fields = {
  __typename?: 'department_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "department" */
export enum Department_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  Codename = 'codename',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  Uid = 'uid'
}

export type Department_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Department_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Department_Set_Input>;
  where: Department_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Department_Var_Pop_Fields = {
  __typename?: 'department_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Department_Var_Samp_Fields = {
  __typename?: 'department_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Department_Variance_Fields = {
  __typename?: 'department_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "device" */
export type Device = {
  __typename?: 'device';
  /** An object relationship */
  address?: Maybe<Address>;
  app_version?: Maybe<Scalars['String']>;
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  bundle_id?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  device_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  location_id?: Maybe<Scalars['Int']>;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  private_metadata: Scalars['jsonb'];
  token: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "device" */
export type DeviceMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "device" */
export type DevicePrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "device" */
export type Device_Aggregate = {
  __typename?: 'device_aggregate';
  aggregate?: Maybe<Device_Aggregate_Fields>;
  nodes: Array<Device>;
};

/** aggregate fields of "device" */
export type Device_Aggregate_Fields = {
  __typename?: 'device_aggregate_fields';
  avg?: Maybe<Device_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Device_Max_Fields>;
  min?: Maybe<Device_Min_Fields>;
  stddev?: Maybe<Device_Stddev_Fields>;
  stddev_pop?: Maybe<Device_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Device_Stddev_Samp_Fields>;
  sum?: Maybe<Device_Sum_Fields>;
  var_pop?: Maybe<Device_Var_Pop_Fields>;
  var_samp?: Maybe<Device_Var_Samp_Fields>;
  variance?: Maybe<Device_Variance_Fields>;
};


/** aggregate fields of "device" */
export type Device_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Device_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "device" */
export type Device_Aggregate_Order_By = {
  avg?: InputMaybe<Device_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Device_Max_Order_By>;
  min?: InputMaybe<Device_Min_Order_By>;
  stddev?: InputMaybe<Device_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Device_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Device_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Device_Sum_Order_By>;
  var_pop?: InputMaybe<Device_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Device_Var_Samp_Order_By>;
  variance?: InputMaybe<Device_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Device_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "device" */
export type Device_Arr_Rel_Insert_Input = {
  data: Array<Device_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Device_On_Conflict>;
};

/** aggregate avg on columns */
export type Device_Avg_Fields = {
  __typename?: 'device_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "device" */
export type Device_Avg_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "device". All fields are combined with a logical 'AND'. */
export type Device_Bool_Exp = {
  _and?: InputMaybe<Array<Device_Bool_Exp>>;
  _not?: InputMaybe<Device_Bool_Exp>;
  _or?: InputMaybe<Array<Device_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  bundle_id?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  device_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  location_id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "device" */
export enum Device_Constraint {
  /** unique or primary key constraint on columns "codename" */
  DeviceCodenameKey = 'device_codename_key',
  /** unique or primary key constraint on columns "id" */
  DevicePkey = 'device_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Device_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Device_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Device_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "device" */
export type Device_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  location_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "device" */
export type Device_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  app_version?: InputMaybe<Scalars['String']>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  device_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Device_Max_Fields = {
  __typename?: 'device_max_fields';
  app_version?: Maybe<Scalars['String']>;
  base_user_id?: Maybe<Scalars['Int']>;
  bundle_id?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  device_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "device" */
export type Device_Max_Order_By = {
  app_version?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  bundle_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Device_Min_Fields = {
  __typename?: 'device_min_fields';
  app_version?: Maybe<Scalars['String']>;
  base_user_id?: Maybe<Scalars['Int']>;
  bundle_id?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  device_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "device" */
export type Device_Min_Order_By = {
  app_version?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  bundle_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "device" */
export type Device_Mutation_Response = {
  __typename?: 'device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Device>;
};

/** on_conflict condition type for table "device" */
export type Device_On_Conflict = {
  constraint: Device_Constraint;
  update_columns?: Array<Device_Update_Column>;
  where?: InputMaybe<Device_Bool_Exp>;
};

/** Ordering options when selecting data from "device". */
export type Device_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  app_version?: InputMaybe<Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  bundle_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: device */
export type Device_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Device_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "device" */
export enum Device_Select_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  BundleId = 'bundle_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "device" */
export type Device_Set_Input = {
  app_version?: InputMaybe<Scalars['String']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  device_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Device_Stddev_Fields = {
  __typename?: 'device_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "device" */
export type Device_Stddev_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Device_Stddev_Pop_Fields = {
  __typename?: 'device_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "device" */
export type Device_Stddev_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Device_Stddev_Samp_Fields = {
  __typename?: 'device_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "device" */
export type Device_Stddev_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "device" */
export type Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Device_Stream_Cursor_Value_Input = {
  app_version?: InputMaybe<Scalars['String']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  device_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Device_Sum_Fields = {
  __typename?: 'device_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "device" */
export type Device_Sum_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** update columns of table "device" */
export enum Device_Update_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  BundleId = 'bundle_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Device_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Device_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Device_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Device_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Device_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Device_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Device_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Device_Set_Input>;
  where: Device_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Device_Var_Pop_Fields = {
  __typename?: 'device_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "device" */
export type Device_Var_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Device_Var_Samp_Fields = {
  __typename?: 'device_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "device" */
export type Device_Var_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Device_Variance_Fields = {
  __typename?: 'device_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "device" */
export type Device_Variance_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "django_content_type" */
export type Django_Content_Type = {
  __typename?: 'django_content_type';
  app_label: Scalars['String'];
  id: Scalars['Int'];
  model: Scalars['String'];
};

/** aggregated selection of "django_content_type" */
export type Django_Content_Type_Aggregate = {
  __typename?: 'django_content_type_aggregate';
  aggregate?: Maybe<Django_Content_Type_Aggregate_Fields>;
  nodes: Array<Django_Content_Type>;
};

/** aggregate fields of "django_content_type" */
export type Django_Content_Type_Aggregate_Fields = {
  __typename?: 'django_content_type_aggregate_fields';
  avg?: Maybe<Django_Content_Type_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Django_Content_Type_Max_Fields>;
  min?: Maybe<Django_Content_Type_Min_Fields>;
  stddev?: Maybe<Django_Content_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Django_Content_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Django_Content_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Django_Content_Type_Sum_Fields>;
  var_pop?: Maybe<Django_Content_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Django_Content_Type_Var_Samp_Fields>;
  variance?: Maybe<Django_Content_Type_Variance_Fields>;
};


/** aggregate fields of "django_content_type" */
export type Django_Content_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Django_Content_Type_Avg_Fields = {
  __typename?: 'django_content_type_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "django_content_type". All fields are combined with a logical 'AND'. */
export type Django_Content_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Django_Content_Type_Bool_Exp>>;
  _not?: InputMaybe<Django_Content_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Django_Content_Type_Bool_Exp>>;
  app_label?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "django_content_type" */
export enum Django_Content_Type_Constraint {
  /** unique or primary key constraint on columns "model", "app_label" */
  DjangoContentTypeAppLabelModel_76bd3d3bUniq = 'django_content_type_app_label_model_76bd3d3b_uniq',
  /** unique or primary key constraint on columns "id" */
  DjangoContentTypePkey = 'django_content_type_pkey'
}

/** input type for incrementing numeric columns in table "django_content_type" */
export type Django_Content_Type_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "django_content_type" */
export type Django_Content_Type_Insert_Input = {
  app_label?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Django_Content_Type_Max_Fields = {
  __typename?: 'django_content_type_max_fields';
  app_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Django_Content_Type_Min_Fields = {
  __typename?: 'django_content_type_min_fields';
  app_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "django_content_type" */
export type Django_Content_Type_Mutation_Response = {
  __typename?: 'django_content_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Django_Content_Type>;
};

/** input type for inserting object relation for remote table "django_content_type" */
export type Django_Content_Type_Obj_Rel_Insert_Input = {
  data: Django_Content_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Django_Content_Type_On_Conflict>;
};

/** on_conflict condition type for table "django_content_type" */
export type Django_Content_Type_On_Conflict = {
  constraint: Django_Content_Type_Constraint;
  update_columns?: Array<Django_Content_Type_Update_Column>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "django_content_type". */
export type Django_Content_Type_Order_By = {
  app_label?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
};

/** primary key columns input for table: django_content_type */
export type Django_Content_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "django_content_type" */
export enum Django_Content_Type_Select_Column {
  /** column name */
  AppLabel = 'app_label',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model'
}

/** input type for updating data in table "django_content_type" */
export type Django_Content_Type_Set_Input = {
  app_label?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Django_Content_Type_Stddev_Fields = {
  __typename?: 'django_content_type_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Django_Content_Type_Stddev_Pop_Fields = {
  __typename?: 'django_content_type_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Django_Content_Type_Stddev_Samp_Fields = {
  __typename?: 'django_content_type_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "django_content_type" */
export type Django_Content_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Django_Content_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Django_Content_Type_Stream_Cursor_Value_Input = {
  app_label?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Django_Content_Type_Sum_Fields = {
  __typename?: 'django_content_type_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "django_content_type" */
export enum Django_Content_Type_Update_Column {
  /** column name */
  AppLabel = 'app_label',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model'
}

export type Django_Content_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Django_Content_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Django_Content_Type_Set_Input>;
  where: Django_Content_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Django_Content_Type_Var_Pop_Fields = {
  __typename?: 'django_content_type_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Django_Content_Type_Var_Samp_Fields = {
  __typename?: 'django_content_type_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Django_Content_Type_Variance_Fields = {
  __typename?: 'django_content_type_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "document" */
export type Document = {
  __typename?: 'document';
  /** An array relationship */
  attachments: Array<Document_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Document_Attachments_Aggregate;
  /** An object relationship */
  content_type: Django_Content_Type;
  content_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** fetch data from the table: "document_data" */
  document_data: Array<Document_Data>;
  /** fetch aggregated fields from the table: "document_data" */
  document_data_aggregate: Document_Data_Aggregate;
  document_kind_id: Scalars['Int'];
  entity_data?: Maybe<Scalars['JSONString']>;
  id: Scalars['Int'];
  id_number: Scalars['String'];
  is_verified?: Maybe<Scalars['Boolean']>;
  issued_by: Scalars['String'];
  /** An object relationship */
  kind: Document_Kind;
  notes?: Maybe<Scalars['String']>;
  object_id: Scalars['Int'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  remarks: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
  valid_from?: Maybe<Scalars['date']>;
  valid_till?: Maybe<Scalars['date']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "document" */
export type DocumentAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentDocument_DataArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentDocument_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};

/** aggregated selection of "document" */
export type Document_Aggregate = {
  __typename?: 'document_aggregate';
  aggregate?: Maybe<Document_Aggregate_Fields>;
  nodes: Array<Document>;
};

/** aggregate fields of "document" */
export type Document_Aggregate_Fields = {
  __typename?: 'document_aggregate_fields';
  avg?: Maybe<Document_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Max_Fields>;
  min?: Maybe<Document_Min_Fields>;
  stddev?: Maybe<Document_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Sum_Fields>;
  var_pop?: Maybe<Document_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Var_Samp_Fields>;
  variance?: Maybe<Document_Variance_Fields>;
};


/** aggregate fields of "document" */
export type Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "document_attachments" */
export type Document_Attachments = {
  __typename?: 'document_attachments';
  /** An object relationship */
  attachment: Media;
  /** An object relationship */
  document: Document;
  document_id: Scalars['Int'];
  id: Scalars['Int'];
  media_id: Scalars['Int'];
};

/** aggregated selection of "document_attachments" */
export type Document_Attachments_Aggregate = {
  __typename?: 'document_attachments_aggregate';
  aggregate?: Maybe<Document_Attachments_Aggregate_Fields>;
  nodes: Array<Document_Attachments>;
};

/** aggregate fields of "document_attachments" */
export type Document_Attachments_Aggregate_Fields = {
  __typename?: 'document_attachments_aggregate_fields';
  avg?: Maybe<Document_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Attachments_Max_Fields>;
  min?: Maybe<Document_Attachments_Min_Fields>;
  stddev?: Maybe<Document_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Attachments_Sum_Fields>;
  var_pop?: Maybe<Document_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Document_Attachments_Variance_Fields>;
};


/** aggregate fields of "document_attachments" */
export type Document_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document_attachments" */
export type Document_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Attachments_Max_Order_By>;
  min?: InputMaybe<Document_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Document_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "document_attachments" */
export type Document_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Document_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Document_Attachments_Avg_Fields = {
  __typename?: 'document_attachments_avg_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "document_attachments" */
export type Document_Attachments_Avg_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "document_attachments". All fields are combined with a logical 'AND'. */
export type Document_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Document_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Attachments_Bool_Exp>>;
  attachment?: InputMaybe<Media_Bool_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  media_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_attachments" */
export enum Document_Attachments_Constraint {
  /** unique or primary key constraint on columns "document_id", "media_id" */
  DocumentAttachmentsDocumentIdMediaId_86b65b40Uniq = 'document_attachments_document_id_media_id_86b65b40_uniq',
  /** unique or primary key constraint on columns "id" */
  DocumentAttachmentsPkey = 'document_attachments_pkey'
}

/** input type for incrementing numeric columns in table "document_attachments" */
export type Document_Attachments_Inc_Input = {
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "document_attachments" */
export type Document_Attachments_Insert_Input = {
  attachment?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Document_Attachments_Max_Fields = {
  __typename?: 'document_attachments_max_fields';
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "document_attachments" */
export type Document_Attachments_Max_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Attachments_Min_Fields = {
  __typename?: 'document_attachments_min_fields';
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "document_attachments" */
export type Document_Attachments_Min_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "document_attachments" */
export type Document_Attachments_Mutation_Response = {
  __typename?: 'document_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Attachments>;
};

/** on_conflict condition type for table "document_attachments" */
export type Document_Attachments_On_Conflict = {
  constraint: Document_Attachments_Constraint;
  update_columns?: Array<Document_Attachments_Update_Column>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "document_attachments". */
export type Document_Attachments_Order_By = {
  attachment?: InputMaybe<Media_Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_attachments */
export type Document_Attachments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "document_attachments" */
export enum Document_Attachments_Select_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id'
}

/** input type for updating data in table "document_attachments" */
export type Document_Attachments_Set_Input = {
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Document_Attachments_Stddev_Fields = {
  __typename?: 'document_attachments_stddev_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "document_attachments" */
export type Document_Attachments_Stddev_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Document_Attachments_Stddev_Pop_Fields = {
  __typename?: 'document_attachments_stddev_pop_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "document_attachments" */
export type Document_Attachments_Stddev_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Document_Attachments_Stddev_Samp_Fields = {
  __typename?: 'document_attachments_stddev_samp_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "document_attachments" */
export type Document_Attachments_Stddev_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "document_attachments" */
export type Document_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Attachments_Stream_Cursor_Value_Input = {
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Document_Attachments_Sum_Fields = {
  __typename?: 'document_attachments_sum_fields';
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "document_attachments" */
export type Document_Attachments_Sum_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** update columns of table "document_attachments" */
export enum Document_Attachments_Update_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id'
}

export type Document_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Attachments_Set_Input>;
  where: Document_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Attachments_Var_Pop_Fields = {
  __typename?: 'document_attachments_var_pop_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "document_attachments" */
export type Document_Attachments_Var_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Document_Attachments_Var_Samp_Fields = {
  __typename?: 'document_attachments_var_samp_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "document_attachments" */
export type Document_Attachments_Var_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Document_Attachments_Variance_Fields = {
  __typename?: 'document_attachments_variance_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "document_attachments" */
export type Document_Attachments_Variance_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Document_Avg_Fields = {
  __typename?: 'document_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "document". All fields are combined with a logical 'AND'. */
export type Document_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Bool_Exp>>;
  _not?: InputMaybe<Document_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Bool_Exp>>;
  attachments?: InputMaybe<Document_Attachments_Bool_Exp>;
  content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  document_data?: InputMaybe<Document_Data_Bool_Exp>;
  document_kind_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  id_number?: InputMaybe<String_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  issued_by?: InputMaybe<String_Comparison_Exp>;
  kind?: InputMaybe<Document_Kind_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_till?: InputMaybe<Date_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "document" */
export enum Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentPkey = 'document_pkey'
}

/** columns and relationships of "document_data" */
export type Document_Data = {
  __typename?: 'document_data';
  created_at: Scalars['timestamptz'];
  data_field_id: Scalars['Int'];
  document_id: Scalars['Int'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  value: Scalars['String'];
};

/** aggregated selection of "document_data" */
export type Document_Data_Aggregate = {
  __typename?: 'document_data_aggregate';
  aggregate?: Maybe<Document_Data_Aggregate_Fields>;
  nodes: Array<Document_Data>;
};

/** aggregate fields of "document_data" */
export type Document_Data_Aggregate_Fields = {
  __typename?: 'document_data_aggregate_fields';
  avg?: Maybe<Document_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Data_Max_Fields>;
  min?: Maybe<Document_Data_Min_Fields>;
  stddev?: Maybe<Document_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Data_Sum_Fields>;
  var_pop?: Maybe<Document_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Data_Var_Samp_Fields>;
  variance?: Maybe<Document_Data_Variance_Fields>;
};


/** aggregate fields of "document_data" */
export type Document_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document_data" */
export type Document_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Data_Max_Order_By>;
  min?: InputMaybe<Document_Data_Min_Order_By>;
  stddev?: InputMaybe<Document_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Data_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "document_data" */
export type Document_Data_Arr_Rel_Insert_Input = {
  data: Array<Document_Data_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Data_On_Conflict>;
};

/** aggregate avg on columns */
export type Document_Data_Avg_Fields = {
  __typename?: 'document_data_avg_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "document_data" */
export type Document_Data_Avg_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "document_data". All fields are combined with a logical 'AND'. */
export type Document_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Data_Bool_Exp>>;
  _not?: InputMaybe<Document_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Data_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_field_id?: InputMaybe<Int_Comparison_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_data" */
export enum Document_Data_Constraint {
  /** unique or primary key constraint on columns "document_id", "data_field_id" */
  DocumentDataDocumentIdDataFieldIdE7adf0c8Uniq = 'document_data_document_id_data_field_id_e7adf0c8_uniq',
  /** unique or primary key constraint on columns "id" */
  DocumentDataPkey = 'document_data_pkey'
}

/** input type for incrementing numeric columns in table "document_data" */
export type Document_Data_Inc_Input = {
  data_field_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "document_data" */
export type Document_Data_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_field_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Data_Max_Fields = {
  __typename?: 'document_data_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  data_field_id?: Maybe<Scalars['Int']>;
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "document_data" */
export type Document_Data_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Data_Min_Fields = {
  __typename?: 'document_data_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  data_field_id?: Maybe<Scalars['Int']>;
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "document_data" */
export type Document_Data_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "document_data" */
export type Document_Data_Mutation_Response = {
  __typename?: 'document_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Data>;
};

/** on_conflict condition type for table "document_data" */
export type Document_Data_On_Conflict = {
  constraint: Document_Data_Constraint;
  update_columns?: Array<Document_Data_Update_Column>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "document_data". */
export type Document_Data_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_data */
export type Document_Data_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "document_data" */
export enum Document_Data_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataFieldId = 'data_field_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "document_data" */
export type Document_Data_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_field_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Document_Data_Stddev_Fields = {
  __typename?: 'document_data_stddev_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "document_data" */
export type Document_Data_Stddev_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Document_Data_Stddev_Pop_Fields = {
  __typename?: 'document_data_stddev_pop_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "document_data" */
export type Document_Data_Stddev_Pop_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Document_Data_Stddev_Samp_Fields = {
  __typename?: 'document_data_stddev_samp_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "document_data" */
export type Document_Data_Stddev_Samp_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "document_data" */
export type Document_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Data_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_field_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Document_Data_Sum_Fields = {
  __typename?: 'document_data_sum_fields';
  data_field_id?: Maybe<Scalars['Int']>;
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "document_data" */
export type Document_Data_Sum_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "document_data" */
export enum Document_Data_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataFieldId = 'data_field_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Document_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Data_Set_Input>;
  where: Document_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Data_Var_Pop_Fields = {
  __typename?: 'document_data_var_pop_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "document_data" */
export type Document_Data_Var_Pop_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Document_Data_Var_Samp_Fields = {
  __typename?: 'document_data_var_samp_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "document_data" */
export type Document_Data_Var_Samp_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Document_Data_Variance_Fields = {
  __typename?: 'document_data_variance_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "document_data" */
export type Document_Data_Variance_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "document" */
export type Document_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "document" */
export type Document_Insert_Input = {
  attachments?: InputMaybe<Document_Attachments_Arr_Rel_Insert_Input>;
  content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  document_data?: InputMaybe<Document_Data_Arr_Rel_Insert_Input>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  id_number?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  issued_by?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Document_Kind_Obj_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  object_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_till?: InputMaybe<Scalars['date']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "document_kind" */
export type Document_Kind = {
  __typename?: 'document_kind';
  /** An object relationship */
  allowed_content_type: Django_Content_Type;
  allowed_content_type_id: Scalars['Int'];
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  minimum_attachments?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** aggregated selection of "document_kind" */
export type Document_Kind_Aggregate = {
  __typename?: 'document_kind_aggregate';
  aggregate?: Maybe<Document_Kind_Aggregate_Fields>;
  nodes: Array<Document_Kind>;
};

/** aggregate fields of "document_kind" */
export type Document_Kind_Aggregate_Fields = {
  __typename?: 'document_kind_aggregate_fields';
  avg?: Maybe<Document_Kind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Kind_Max_Fields>;
  min?: Maybe<Document_Kind_Min_Fields>;
  stddev?: Maybe<Document_Kind_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Kind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Kind_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Kind_Sum_Fields>;
  var_pop?: Maybe<Document_Kind_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Kind_Var_Samp_Fields>;
  variance?: Maybe<Document_Kind_Variance_Fields>;
};


/** aggregate fields of "document_kind" */
export type Document_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Document_Kind_Avg_Fields = {
  __typename?: 'document_kind_avg_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "document_kind". All fields are combined with a logical 'AND'. */
export type Document_Kind_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Kind_Bool_Exp>>;
  _not?: InputMaybe<Document_Kind_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Kind_Bool_Exp>>;
  allowed_content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  allowed_content_type_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  minimum_attachments?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_kind" */
export enum Document_Kind_Constraint {
  /** unique or primary key constraint on columns "codename" */
  DocumentKindCodenameKey = 'document_kind_codename_key',
  /** unique or primary key constraint on columns "id" */
  DocumentKindPkey = 'document_kind_pkey'
}

/** columns and relationships of "document_kind_data_field" */
export type Document_Kind_Data_Field = {
  __typename?: 'document_kind_data_field';
  /** An object relationship */
  document_kind: Document_Kind;
  document_kind_id: Scalars['Int'];
  id: Scalars['Int'];
  input_type: Scalars['String'];
  is_active: Scalars['Boolean'];
  key: Scalars['String'];
  title: Scalars['String'];
};

/** aggregated selection of "document_kind_data_field" */
export type Document_Kind_Data_Field_Aggregate = {
  __typename?: 'document_kind_data_field_aggregate';
  aggregate?: Maybe<Document_Kind_Data_Field_Aggregate_Fields>;
  nodes: Array<Document_Kind_Data_Field>;
};

/** aggregate fields of "document_kind_data_field" */
export type Document_Kind_Data_Field_Aggregate_Fields = {
  __typename?: 'document_kind_data_field_aggregate_fields';
  avg?: Maybe<Document_Kind_Data_Field_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Kind_Data_Field_Max_Fields>;
  min?: Maybe<Document_Kind_Data_Field_Min_Fields>;
  stddev?: Maybe<Document_Kind_Data_Field_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Kind_Data_Field_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Kind_Data_Field_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Kind_Data_Field_Sum_Fields>;
  var_pop?: Maybe<Document_Kind_Data_Field_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Kind_Data_Field_Var_Samp_Fields>;
  variance?: Maybe<Document_Kind_Data_Field_Variance_Fields>;
};


/** aggregate fields of "document_kind_data_field" */
export type Document_Kind_Data_Field_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Kind_Data_Field_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Document_Kind_Data_Field_Avg_Fields = {
  __typename?: 'document_kind_data_field_avg_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "document_kind_data_field". All fields are combined with a logical 'AND'. */
export type Document_Kind_Data_Field_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Kind_Data_Field_Bool_Exp>>;
  _not?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Kind_Data_Field_Bool_Exp>>;
  document_kind?: InputMaybe<Document_Kind_Bool_Exp>;
  document_kind_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  input_type?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_kind_data_field" */
export enum Document_Kind_Data_Field_Constraint {
  /** unique or primary key constraint on columns "key", "document_kind_id" */
  DocumentKindDataFieldDocumentKindIdKey_0df7d8c3Uniq = 'document_kind_data_field_document_kind_id_key_0df7d8c3_uniq',
  /** unique or primary key constraint on columns "id" */
  DocumentKindDataFieldPkey = 'document_kind_data_field_pkey'
}

/** input type for incrementing numeric columns in table "document_kind_data_field" */
export type Document_Kind_Data_Field_Inc_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "document_kind_data_field" */
export type Document_Kind_Data_Field_Insert_Input = {
  document_kind?: InputMaybe<Document_Kind_Obj_Rel_Insert_Input>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  input_type?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Kind_Data_Field_Max_Fields = {
  __typename?: 'document_kind_data_field_max_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  input_type?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Kind_Data_Field_Min_Fields = {
  __typename?: 'document_kind_data_field_min_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  input_type?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "document_kind_data_field" */
export type Document_Kind_Data_Field_Mutation_Response = {
  __typename?: 'document_kind_data_field_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Kind_Data_Field>;
};

/** on_conflict condition type for table "document_kind_data_field" */
export type Document_Kind_Data_Field_On_Conflict = {
  constraint: Document_Kind_Data_Field_Constraint;
  update_columns?: Array<Document_Kind_Data_Field_Update_Column>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};

/** Ordering options when selecting data from "document_kind_data_field". */
export type Document_Kind_Data_Field_Order_By = {
  document_kind?: InputMaybe<Document_Kind_Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_type?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_kind_data_field */
export type Document_Kind_Data_Field_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "document_kind_data_field" */
export enum Document_Kind_Data_Field_Select_Column {
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputType = 'input_type',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "document_kind_data_field" */
export type Document_Kind_Data_Field_Set_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  input_type?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Document_Kind_Data_Field_Stddev_Fields = {
  __typename?: 'document_kind_data_field_stddev_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Kind_Data_Field_Stddev_Pop_Fields = {
  __typename?: 'document_kind_data_field_stddev_pop_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Kind_Data_Field_Stddev_Samp_Fields = {
  __typename?: 'document_kind_data_field_stddev_samp_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "document_kind_data_field" */
export type Document_Kind_Data_Field_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Kind_Data_Field_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Kind_Data_Field_Stream_Cursor_Value_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  input_type?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Document_Kind_Data_Field_Sum_Fields = {
  __typename?: 'document_kind_data_field_sum_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "document_kind_data_field" */
export enum Document_Kind_Data_Field_Update_Column {
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputType = 'input_type',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Title = 'title'
}

export type Document_Kind_Data_Field_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Kind_Data_Field_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Kind_Data_Field_Set_Input>;
  where: Document_Kind_Data_Field_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Kind_Data_Field_Var_Pop_Fields = {
  __typename?: 'document_kind_data_field_var_pop_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Kind_Data_Field_Var_Samp_Fields = {
  __typename?: 'document_kind_data_field_var_samp_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Kind_Data_Field_Variance_Fields = {
  __typename?: 'document_kind_data_field_variance_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "document_kind" */
export type Document_Kind_Inc_Input = {
  allowed_content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  minimum_attachments?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "document_kind" */
export type Document_Kind_Insert_Input = {
  allowed_content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  allowed_content_type_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  minimum_attachments?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Kind_Max_Fields = {
  __typename?: 'document_kind_max_fields';
  allowed_content_type_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  minimum_attachments?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Kind_Min_Fields = {
  __typename?: 'document_kind_min_fields';
  allowed_content_type_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  minimum_attachments?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "document_kind" */
export type Document_Kind_Mutation_Response = {
  __typename?: 'document_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Kind>;
};

/** input type for inserting object relation for remote table "document_kind" */
export type Document_Kind_Obj_Rel_Insert_Input = {
  data: Document_Kind_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Kind_On_Conflict>;
};

/** on_conflict condition type for table "document_kind" */
export type Document_Kind_On_Conflict = {
  constraint: Document_Kind_Constraint;
  update_columns?: Array<Document_Kind_Update_Column>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};

/** Ordering options when selecting data from "document_kind". */
export type Document_Kind_Order_By = {
  allowed_content_type?: InputMaybe<Django_Content_Type_Order_By>;
  allowed_content_type_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  minimum_attachments?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_kind */
export type Document_Kind_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "document_kind" */
export enum Document_Kind_Select_Column {
  /** column name */
  AllowedContentTypeId = 'allowed_content_type_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MinimumAttachments = 'minimum_attachments',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "document_kind" */
export type Document_Kind_Set_Input = {
  allowed_content_type_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  minimum_attachments?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Document_Kind_Stddev_Fields = {
  __typename?: 'document_kind_stddev_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Kind_Stddev_Pop_Fields = {
  __typename?: 'document_kind_stddev_pop_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Kind_Stddev_Samp_Fields = {
  __typename?: 'document_kind_stddev_samp_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "document_kind" */
export type Document_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Kind_Stream_Cursor_Value_Input = {
  allowed_content_type_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  minimum_attachments?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Document_Kind_Sum_Fields = {
  __typename?: 'document_kind_sum_fields';
  allowed_content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  minimum_attachments?: Maybe<Scalars['Int']>;
};

/** update columns of table "document_kind" */
export enum Document_Kind_Update_Column {
  /** column name */
  AllowedContentTypeId = 'allowed_content_type_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MinimumAttachments = 'minimum_attachments',
  /** column name */
  Name = 'name'
}

export type Document_Kind_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Kind_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Kind_Set_Input>;
  where: Document_Kind_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Kind_Var_Pop_Fields = {
  __typename?: 'document_kind_var_pop_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Kind_Var_Samp_Fields = {
  __typename?: 'document_kind_var_samp_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Kind_Variance_Fields = {
  __typename?: 'document_kind_variance_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Document_Max_Fields = {
  __typename?: 'document_max_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  id_number?: Maybe<Scalars['String']>;
  issued_by?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  object_id?: Maybe<Scalars['Int']>;
  remarks?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  valid_from?: Maybe<Scalars['date']>;
  valid_till?: Maybe<Scalars['date']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Document_Min_Fields = {
  __typename?: 'document_min_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  id_number?: Maybe<Scalars['String']>;
  issued_by?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  object_id?: Maybe<Scalars['Int']>;
  remarks?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  valid_from?: Maybe<Scalars['date']>;
  valid_till?: Maybe<Scalars['date']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "document" */
export type Document_Mutation_Response = {
  __typename?: 'document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document>;
};

/** input type for inserting object relation for remote table "document" */
export type Document_Obj_Rel_Insert_Input = {
  data: Document_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_On_Conflict>;
};

/** on_conflict condition type for table "document" */
export type Document_On_Conflict = {
  constraint: Document_Constraint;
  update_columns?: Array<Document_Update_Column>;
  where?: InputMaybe<Document_Bool_Exp>;
};

/** Ordering options when selecting data from "document". */
export type Document_Order_By = {
  attachments_aggregate?: InputMaybe<Document_Attachments_Aggregate_Order_By>;
  content_type?: InputMaybe<Django_Content_Type_Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_data_aggregate?: InputMaybe<Document_Data_Aggregate_Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_number?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  issued_by?: InputMaybe<Order_By>;
  kind?: InputMaybe<Document_Kind_Order_By>;
  notes?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document */
export type Document_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "document" */
export enum Document_Select_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  Id = 'id',
  /** column name */
  IdNumber = 'id_number',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  IssuedBy = 'issued_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "document" */
export type Document_Set_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  id_number?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  issued_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  object_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_till?: InputMaybe<Scalars['date']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Document_Stddev_Fields = {
  __typename?: 'document_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Stddev_Pop_Fields = {
  __typename?: 'document_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Stddev_Samp_Fields = {
  __typename?: 'document_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "document" */
export type Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Stream_Cursor_Value_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  id_number?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  issued_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  object_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_till?: InputMaybe<Scalars['date']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Document_Sum_Fields = {
  __typename?: 'document_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "document" */
export enum Document_Update_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  Id = 'id',
  /** column name */
  IdNumber = 'id_number',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  IssuedBy = 'issued_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Document_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Var_Pop_Fields = {
  __typename?: 'document_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Var_Samp_Fields = {
  __typename?: 'document_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Variance_Fields = {
  __typename?: 'document_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "drip_irrigation_system" */
export type Drip_Irrigation_System = {
  __typename?: 'drip_irrigation_system';
  emitter_capacity: Scalars['float8'];
  emitter_placement: Scalars['String'];
  emitter_spacing: Scalars['float8'];
  /** An object relationship */
  irrigation_system: Irrigation_System;
  irrigationsystem_ptr_id: Scalars['uuid'];
  lateral_spacing: Scalars['float8'];
  number_of_emitters: Scalars['Int'];
  number_of_laterals: Scalars['Int'];
  root_width: Scalars['float8'];
  type_of_lateral: Scalars['String'];
  wetting_area: Scalars['float8'];
};

/** aggregated selection of "drip_irrigation_system" */
export type Drip_Irrigation_System_Aggregate = {
  __typename?: 'drip_irrigation_system_aggregate';
  aggregate?: Maybe<Drip_Irrigation_System_Aggregate_Fields>;
  nodes: Array<Drip_Irrigation_System>;
};

/** aggregate fields of "drip_irrigation_system" */
export type Drip_Irrigation_System_Aggregate_Fields = {
  __typename?: 'drip_irrigation_system_aggregate_fields';
  avg?: Maybe<Drip_Irrigation_System_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Drip_Irrigation_System_Max_Fields>;
  min?: Maybe<Drip_Irrigation_System_Min_Fields>;
  stddev?: Maybe<Drip_Irrigation_System_Stddev_Fields>;
  stddev_pop?: Maybe<Drip_Irrigation_System_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Drip_Irrigation_System_Stddev_Samp_Fields>;
  sum?: Maybe<Drip_Irrigation_System_Sum_Fields>;
  var_pop?: Maybe<Drip_Irrigation_System_Var_Pop_Fields>;
  var_samp?: Maybe<Drip_Irrigation_System_Var_Samp_Fields>;
  variance?: Maybe<Drip_Irrigation_System_Variance_Fields>;
};


/** aggregate fields of "drip_irrigation_system" */
export type Drip_Irrigation_System_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Drip_Irrigation_System_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Drip_Irrigation_System_Avg_Fields = {
  __typename?: 'drip_irrigation_system_avg_fields';
  emitter_capacity?: Maybe<Scalars['Float']>;
  emitter_spacing?: Maybe<Scalars['Float']>;
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_emitters?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  root_width?: Maybe<Scalars['Float']>;
  wetting_area?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "drip_irrigation_system". All fields are combined with a logical 'AND'. */
export type Drip_Irrigation_System_Bool_Exp = {
  _and?: InputMaybe<Array<Drip_Irrigation_System_Bool_Exp>>;
  _not?: InputMaybe<Drip_Irrigation_System_Bool_Exp>;
  _or?: InputMaybe<Array<Drip_Irrigation_System_Bool_Exp>>;
  emitter_capacity?: InputMaybe<Float8_Comparison_Exp>;
  emitter_placement?: InputMaybe<String_Comparison_Exp>;
  emitter_spacing?: InputMaybe<Float8_Comparison_Exp>;
  irrigation_system?: InputMaybe<Irrigation_System_Bool_Exp>;
  irrigationsystem_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
  lateral_spacing?: InputMaybe<Float8_Comparison_Exp>;
  number_of_emitters?: InputMaybe<Int_Comparison_Exp>;
  number_of_laterals?: InputMaybe<Int_Comparison_Exp>;
  root_width?: InputMaybe<Float8_Comparison_Exp>;
  type_of_lateral?: InputMaybe<String_Comparison_Exp>;
  wetting_area?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "drip_irrigation_system" */
export enum Drip_Irrigation_System_Constraint {
  /** unique or primary key constraint on columns "irrigationsystem_ptr_id" */
  DripIrrigationSystemPkey = 'drip_irrigation_system_pkey'
}

/** input type for incrementing numeric columns in table "drip_irrigation_system" */
export type Drip_Irrigation_System_Inc_Input = {
  emitter_capacity?: InputMaybe<Scalars['float8']>;
  emitter_spacing?: InputMaybe<Scalars['float8']>;
  lateral_spacing?: InputMaybe<Scalars['float8']>;
  number_of_emitters?: InputMaybe<Scalars['Int']>;
  number_of_laterals?: InputMaybe<Scalars['Int']>;
  root_width?: InputMaybe<Scalars['float8']>;
  wetting_area?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "drip_irrigation_system" */
export type Drip_Irrigation_System_Insert_Input = {
  emitter_capacity?: InputMaybe<Scalars['float8']>;
  emitter_placement?: InputMaybe<Scalars['String']>;
  emitter_spacing?: InputMaybe<Scalars['float8']>;
  irrigation_system?: InputMaybe<Irrigation_System_Obj_Rel_Insert_Input>;
  irrigationsystem_ptr_id?: InputMaybe<Scalars['uuid']>;
  lateral_spacing?: InputMaybe<Scalars['float8']>;
  number_of_emitters?: InputMaybe<Scalars['Int']>;
  number_of_laterals?: InputMaybe<Scalars['Int']>;
  root_width?: InputMaybe<Scalars['float8']>;
  type_of_lateral?: InputMaybe<Scalars['String']>;
  wetting_area?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Drip_Irrigation_System_Max_Fields = {
  __typename?: 'drip_irrigation_system_max_fields';
  emitter_capacity?: Maybe<Scalars['float8']>;
  emitter_placement?: Maybe<Scalars['String']>;
  emitter_spacing?: Maybe<Scalars['float8']>;
  irrigationsystem_ptr_id?: Maybe<Scalars['uuid']>;
  lateral_spacing?: Maybe<Scalars['float8']>;
  number_of_emitters?: Maybe<Scalars['Int']>;
  number_of_laterals?: Maybe<Scalars['Int']>;
  root_width?: Maybe<Scalars['float8']>;
  type_of_lateral?: Maybe<Scalars['String']>;
  wetting_area?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Drip_Irrigation_System_Min_Fields = {
  __typename?: 'drip_irrigation_system_min_fields';
  emitter_capacity?: Maybe<Scalars['float8']>;
  emitter_placement?: Maybe<Scalars['String']>;
  emitter_spacing?: Maybe<Scalars['float8']>;
  irrigationsystem_ptr_id?: Maybe<Scalars['uuid']>;
  lateral_spacing?: Maybe<Scalars['float8']>;
  number_of_emitters?: Maybe<Scalars['Int']>;
  number_of_laterals?: Maybe<Scalars['Int']>;
  root_width?: Maybe<Scalars['float8']>;
  type_of_lateral?: Maybe<Scalars['String']>;
  wetting_area?: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "drip_irrigation_system" */
export type Drip_Irrigation_System_Mutation_Response = {
  __typename?: 'drip_irrigation_system_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Drip_Irrigation_System>;
};

/** input type for inserting object relation for remote table "drip_irrigation_system" */
export type Drip_Irrigation_System_Obj_Rel_Insert_Input = {
  data: Drip_Irrigation_System_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Drip_Irrigation_System_On_Conflict>;
};

/** on_conflict condition type for table "drip_irrigation_system" */
export type Drip_Irrigation_System_On_Conflict = {
  constraint: Drip_Irrigation_System_Constraint;
  update_columns?: Array<Drip_Irrigation_System_Update_Column>;
  where?: InputMaybe<Drip_Irrigation_System_Bool_Exp>;
};

/** Ordering options when selecting data from "drip_irrigation_system". */
export type Drip_Irrigation_System_Order_By = {
  emitter_capacity?: InputMaybe<Order_By>;
  emitter_placement?: InputMaybe<Order_By>;
  emitter_spacing?: InputMaybe<Order_By>;
  irrigation_system?: InputMaybe<Irrigation_System_Order_By>;
  irrigationsystem_ptr_id?: InputMaybe<Order_By>;
  lateral_spacing?: InputMaybe<Order_By>;
  number_of_emitters?: InputMaybe<Order_By>;
  number_of_laterals?: InputMaybe<Order_By>;
  root_width?: InputMaybe<Order_By>;
  type_of_lateral?: InputMaybe<Order_By>;
  wetting_area?: InputMaybe<Order_By>;
};

/** primary key columns input for table: drip_irrigation_system */
export type Drip_Irrigation_System_Pk_Columns_Input = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};

/** select columns of table "drip_irrigation_system" */
export enum Drip_Irrigation_System_Select_Column {
  /** column name */
  EmitterCapacity = 'emitter_capacity',
  /** column name */
  EmitterPlacement = 'emitter_placement',
  /** column name */
  EmitterSpacing = 'emitter_spacing',
  /** column name */
  IrrigationsystemPtrId = 'irrigationsystem_ptr_id',
  /** column name */
  LateralSpacing = 'lateral_spacing',
  /** column name */
  NumberOfEmitters = 'number_of_emitters',
  /** column name */
  NumberOfLaterals = 'number_of_laterals',
  /** column name */
  RootWidth = 'root_width',
  /** column name */
  TypeOfLateral = 'type_of_lateral',
  /** column name */
  WettingArea = 'wetting_area'
}

/** input type for updating data in table "drip_irrigation_system" */
export type Drip_Irrigation_System_Set_Input = {
  emitter_capacity?: InputMaybe<Scalars['float8']>;
  emitter_placement?: InputMaybe<Scalars['String']>;
  emitter_spacing?: InputMaybe<Scalars['float8']>;
  irrigationsystem_ptr_id?: InputMaybe<Scalars['uuid']>;
  lateral_spacing?: InputMaybe<Scalars['float8']>;
  number_of_emitters?: InputMaybe<Scalars['Int']>;
  number_of_laterals?: InputMaybe<Scalars['Int']>;
  root_width?: InputMaybe<Scalars['float8']>;
  type_of_lateral?: InputMaybe<Scalars['String']>;
  wetting_area?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Drip_Irrigation_System_Stddev_Fields = {
  __typename?: 'drip_irrigation_system_stddev_fields';
  emitter_capacity?: Maybe<Scalars['Float']>;
  emitter_spacing?: Maybe<Scalars['Float']>;
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_emitters?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  root_width?: Maybe<Scalars['Float']>;
  wetting_area?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Drip_Irrigation_System_Stddev_Pop_Fields = {
  __typename?: 'drip_irrigation_system_stddev_pop_fields';
  emitter_capacity?: Maybe<Scalars['Float']>;
  emitter_spacing?: Maybe<Scalars['Float']>;
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_emitters?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  root_width?: Maybe<Scalars['Float']>;
  wetting_area?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Drip_Irrigation_System_Stddev_Samp_Fields = {
  __typename?: 'drip_irrigation_system_stddev_samp_fields';
  emitter_capacity?: Maybe<Scalars['Float']>;
  emitter_spacing?: Maybe<Scalars['Float']>;
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_emitters?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  root_width?: Maybe<Scalars['Float']>;
  wetting_area?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "drip_irrigation_system" */
export type Drip_Irrigation_System_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Drip_Irrigation_System_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Drip_Irrigation_System_Stream_Cursor_Value_Input = {
  emitter_capacity?: InputMaybe<Scalars['float8']>;
  emitter_placement?: InputMaybe<Scalars['String']>;
  emitter_spacing?: InputMaybe<Scalars['float8']>;
  irrigationsystem_ptr_id?: InputMaybe<Scalars['uuid']>;
  lateral_spacing?: InputMaybe<Scalars['float8']>;
  number_of_emitters?: InputMaybe<Scalars['Int']>;
  number_of_laterals?: InputMaybe<Scalars['Int']>;
  root_width?: InputMaybe<Scalars['float8']>;
  type_of_lateral?: InputMaybe<Scalars['String']>;
  wetting_area?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Drip_Irrigation_System_Sum_Fields = {
  __typename?: 'drip_irrigation_system_sum_fields';
  emitter_capacity?: Maybe<Scalars['float8']>;
  emitter_spacing?: Maybe<Scalars['float8']>;
  lateral_spacing?: Maybe<Scalars['float8']>;
  number_of_emitters?: Maybe<Scalars['Int']>;
  number_of_laterals?: Maybe<Scalars['Int']>;
  root_width?: Maybe<Scalars['float8']>;
  wetting_area?: Maybe<Scalars['float8']>;
};

/** update columns of table "drip_irrigation_system" */
export enum Drip_Irrigation_System_Update_Column {
  /** column name */
  EmitterCapacity = 'emitter_capacity',
  /** column name */
  EmitterPlacement = 'emitter_placement',
  /** column name */
  EmitterSpacing = 'emitter_spacing',
  /** column name */
  IrrigationsystemPtrId = 'irrigationsystem_ptr_id',
  /** column name */
  LateralSpacing = 'lateral_spacing',
  /** column name */
  NumberOfEmitters = 'number_of_emitters',
  /** column name */
  NumberOfLaterals = 'number_of_laterals',
  /** column name */
  RootWidth = 'root_width',
  /** column name */
  TypeOfLateral = 'type_of_lateral',
  /** column name */
  WettingArea = 'wetting_area'
}

export type Drip_Irrigation_System_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Drip_Irrigation_System_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Drip_Irrigation_System_Set_Input>;
  where: Drip_Irrigation_System_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Drip_Irrigation_System_Var_Pop_Fields = {
  __typename?: 'drip_irrigation_system_var_pop_fields';
  emitter_capacity?: Maybe<Scalars['Float']>;
  emitter_spacing?: Maybe<Scalars['Float']>;
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_emitters?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  root_width?: Maybe<Scalars['Float']>;
  wetting_area?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Drip_Irrigation_System_Var_Samp_Fields = {
  __typename?: 'drip_irrigation_system_var_samp_fields';
  emitter_capacity?: Maybe<Scalars['Float']>;
  emitter_spacing?: Maybe<Scalars['Float']>;
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_emitters?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  root_width?: Maybe<Scalars['Float']>;
  wetting_area?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Drip_Irrigation_System_Variance_Fields = {
  __typename?: 'drip_irrigation_system_variance_fields';
  emitter_capacity?: Maybe<Scalars['Float']>;
  emitter_spacing?: Maybe<Scalars['Float']>;
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_emitters?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  root_width?: Maybe<Scalars['Float']>;
  wetting_area?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "expense" */
export type Expense = {
  __typename?: 'expense';
  amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  expense_parameter: Expense_Parameter;
  expense_parameter_id: Scalars['bigint'];
  id: Scalars['bigint'];
  kind: Scalars['String'];
  paid_by: Scalars['String'];
  /** An object relationship */
  receipt?: Maybe<Receipt>;
  /** An object relationship */
  trade?: Maybe<Trade>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  value: Scalars['numeric'];
};

/** aggregated selection of "expense" */
export type Expense_Aggregate = {
  __typename?: 'expense_aggregate';
  aggregate?: Maybe<Expense_Aggregate_Fields>;
  nodes: Array<Expense>;
};

/** aggregate fields of "expense" */
export type Expense_Aggregate_Fields = {
  __typename?: 'expense_aggregate_fields';
  avg?: Maybe<Expense_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Expense_Max_Fields>;
  min?: Maybe<Expense_Min_Fields>;
  stddev?: Maybe<Expense_Stddev_Fields>;
  stddev_pop?: Maybe<Expense_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Expense_Stddev_Samp_Fields>;
  sum?: Maybe<Expense_Sum_Fields>;
  var_pop?: Maybe<Expense_Var_Pop_Fields>;
  var_samp?: Maybe<Expense_Var_Samp_Fields>;
  variance?: Maybe<Expense_Variance_Fields>;
};


/** aggregate fields of "expense" */
export type Expense_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Expense_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "expense" */
export type Expense_Aggregate_Order_By = {
  avg?: InputMaybe<Expense_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Expense_Max_Order_By>;
  min?: InputMaybe<Expense_Min_Order_By>;
  stddev?: InputMaybe<Expense_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Expense_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Expense_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Expense_Sum_Order_By>;
  var_pop?: InputMaybe<Expense_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Expense_Var_Samp_Order_By>;
  variance?: InputMaybe<Expense_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "expense" */
export type Expense_Arr_Rel_Insert_Input = {
  data: Array<Expense_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Expense_On_Conflict>;
};

/** aggregate avg on columns */
export type Expense_Avg_Fields = {
  __typename?: 'expense_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "expense" */
export type Expense_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "expense". All fields are combined with a logical 'AND'. */
export type Expense_Bool_Exp = {
  _and?: InputMaybe<Array<Expense_Bool_Exp>>;
  _not?: InputMaybe<Expense_Bool_Exp>;
  _or?: InputMaybe<Array<Expense_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  expense_parameter?: InputMaybe<Expense_Parameter_Bool_Exp>;
  expense_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  paid_by?: InputMaybe<String_Comparison_Exp>;
  receipt?: InputMaybe<Receipt_Bool_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "expense" */
export enum Expense_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExpensePkey = 'expense_pkey'
}

/** input type for incrementing numeric columns in table "expense" */
export type Expense_Inc_Input = {
  expense_parameter_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "expense" */
export type Expense_Insert_Input = {
  expense_parameter_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  paid_by?: InputMaybe<Scalars['String']>;
  receipt?: InputMaybe<Receipt_Obj_Rel_Insert_Input>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Expense_Max_Fields = {
  __typename?: 'expense_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  paid_by?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "expense" */
export type Expense_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Expense_Min_Fields = {
  __typename?: 'expense_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  paid_by?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "expense" */
export type Expense_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "expense" */
export type Expense_Mutation_Response = {
  __typename?: 'expense_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Expense>;
};

/** on_conflict condition type for table "expense" */
export type Expense_On_Conflict = {
  constraint: Expense_Constraint;
  update_columns?: Array<Expense_Update_Column>;
  where?: InputMaybe<Expense_Bool_Exp>;
};

/** Ordering options when selecting data from "expense". */
export type Expense_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  expense_parameter?: InputMaybe<Expense_Parameter_Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  receipt?: InputMaybe<Receipt_Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "expense_parameter" */
export type Expense_Parameter = {
  __typename?: 'expense_parameter';
  codename: Scalars['String'];
  description: Scalars['String'];
  /** An array relationship */
  expenses: Array<Expense>;
  /** An aggregate relationship */
  expenses_aggregate: Expense_Aggregate;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};


/** columns and relationships of "expense_parameter" */
export type Expense_ParameterExpensesArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "expense_parameter" */
export type Expense_ParameterExpenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "expense_parameter". All fields are combined with a logical 'AND'. */
export type Expense_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Expense_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Expense_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Expense_Parameter_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expenses?: InputMaybe<Expense_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "expense_parameter". */
export type Expense_Parameter_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expenses_aggregate?: InputMaybe<Expense_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "expense_parameter" */
export enum Expense_Parameter_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "expense_parameter" */
export type Expense_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expense_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expense_Parameter_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: expense */
export type Expense_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "expense" */
export enum Expense_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  ExpenseParameterId = 'expense_parameter_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  PaidBy = 'paid_by',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "expense" */
export type Expense_Set_Input = {
  expense_parameter_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  paid_by?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Expense_Stddev_Fields = {
  __typename?: 'expense_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "expense" */
export type Expense_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Expense_Stddev_Pop_Fields = {
  __typename?: 'expense_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "expense" */
export type Expense_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Expense_Stddev_Samp_Fields = {
  __typename?: 'expense_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "expense" */
export type Expense_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "expense" */
export type Expense_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expense_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expense_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  expense_parameter_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  paid_by?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Expense_Sum_Fields = {
  __typename?: 'expense_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "expense" */
export type Expense_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "expense" */
export enum Expense_Update_Column {
  /** column name */
  ExpenseParameterId = 'expense_parameter_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  PaidBy = 'paid_by',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  Value = 'value'
}

export type Expense_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Expense_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Expense_Set_Input>;
  where: Expense_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Expense_Var_Pop_Fields = {
  __typename?: 'expense_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "expense" */
export type Expense_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Expense_Var_Samp_Fields = {
  __typename?: 'expense_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "expense" */
export type Expense_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Expense_Variance_Fields = {
  __typename?: 'expense_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "expense" */
export type Expense_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "external_reference" */
export type External_Reference = {
  __typename?: 'external_reference';
  /** An object relationship */
  content_type: Django_Content_Type;
  content_type_id: Scalars['Int'];
  external_app_id: Scalars['Int'];
  id: Scalars['Int'];
  metadata: Scalars['jsonb'];
  object_id: Scalars['Int'];
  private_metadata: Scalars['jsonb'];
  reference_id: Scalars['String'];
};


/** columns and relationships of "external_reference" */
export type External_ReferenceMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "external_reference" */
export type External_ReferencePrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "external_reference" */
export type External_Reference_Aggregate = {
  __typename?: 'external_reference_aggregate';
  aggregate?: Maybe<External_Reference_Aggregate_Fields>;
  nodes: Array<External_Reference>;
};

/** aggregate fields of "external_reference" */
export type External_Reference_Aggregate_Fields = {
  __typename?: 'external_reference_aggregate_fields';
  avg?: Maybe<External_Reference_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<External_Reference_Max_Fields>;
  min?: Maybe<External_Reference_Min_Fields>;
  stddev?: Maybe<External_Reference_Stddev_Fields>;
  stddev_pop?: Maybe<External_Reference_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<External_Reference_Stddev_Samp_Fields>;
  sum?: Maybe<External_Reference_Sum_Fields>;
  var_pop?: Maybe<External_Reference_Var_Pop_Fields>;
  var_samp?: Maybe<External_Reference_Var_Samp_Fields>;
  variance?: Maybe<External_Reference_Variance_Fields>;
};


/** aggregate fields of "external_reference" */
export type External_Reference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<External_Reference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type External_Reference_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type External_Reference_Avg_Fields = {
  __typename?: 'external_reference_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "external_reference". All fields are combined with a logical 'AND'. */
export type External_Reference_Bool_Exp = {
  _and?: InputMaybe<Array<External_Reference_Bool_Exp>>;
  _not?: InputMaybe<External_Reference_Bool_Exp>;
  _or?: InputMaybe<Array<External_Reference_Bool_Exp>>;
  content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  external_app_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "external_reference" */
export enum External_Reference_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExternalReferencePkey = 'external_reference_pkey',
  /** unique or primary key constraint on columns "reference_id", "external_app_id", "content_type_id", "object_id" */
  ExternalReferenceReferenceIdExternalAp_9d445e62Uniq = 'external_reference_reference_id_external_ap_9d445e62_uniq'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type External_Reference_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type External_Reference_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type External_Reference_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "external_reference" */
export type External_Reference_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  external_app_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "external_reference" */
export type External_Reference_Insert_Input = {
  content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  external_app_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type External_Reference_Max_Fields = {
  __typename?: 'external_reference_max_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  external_app_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  reference_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type External_Reference_Min_Fields = {
  __typename?: 'external_reference_min_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  external_app_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  reference_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "external_reference" */
export type External_Reference_Mutation_Response = {
  __typename?: 'external_reference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<External_Reference>;
};

/** on_conflict condition type for table "external_reference" */
export type External_Reference_On_Conflict = {
  constraint: External_Reference_Constraint;
  update_columns?: Array<External_Reference_Update_Column>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};

/** Ordering options when selecting data from "external_reference". */
export type External_Reference_Order_By = {
  content_type?: InputMaybe<Django_Content_Type_Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  external_app_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: external_reference */
export type External_Reference_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type External_Reference_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "external_reference" */
export enum External_Reference_Select_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  ExternalAppId = 'external_app_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id'
}

/** input type for updating data in table "external_reference" */
export type External_Reference_Set_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  external_app_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type External_Reference_Stddev_Fields = {
  __typename?: 'external_reference_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type External_Reference_Stddev_Pop_Fields = {
  __typename?: 'external_reference_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type External_Reference_Stddev_Samp_Fields = {
  __typename?: 'external_reference_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "external_reference" */
export type External_Reference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: External_Reference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type External_Reference_Stream_Cursor_Value_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  external_app_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type External_Reference_Sum_Fields = {
  __typename?: 'external_reference_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  external_app_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "external_reference" */
export enum External_Reference_Update_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  ExternalAppId = 'external_app_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id'
}

export type External_Reference_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<External_Reference_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<External_Reference_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<External_Reference_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<External_Reference_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<External_Reference_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<External_Reference_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<External_Reference_Set_Input>;
  where: External_Reference_Bool_Exp;
};

/** aggregate var_pop on columns */
export type External_Reference_Var_Pop_Fields = {
  __typename?: 'external_reference_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type External_Reference_Var_Samp_Fields = {
  __typename?: 'external_reference_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type External_Reference_Variance_Fields = {
  __typename?: 'external_reference_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "farm" */
export type Farm = {
  __typename?: 'farm';
  /** An object relationship */
  address: Address;
  address_id: Scalars['Int'];
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_in?: Maybe<Department>;
  created_in_id?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  external_reference_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  farmer: Base_User;
  farmer_id: Scalars['Int'];
  /** An array relationship */
  fields: Array<Field>;
  /** An aggregate relationship */
  fields_aggregate: Field_Aggregate;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Farm_Network>;
  /** An aggregate relationship */
  networks_aggregate: Farm_Network_Aggregate;
  notes?: Maybe<Scalars['String']>;
  private_metadata: Scalars['jsonb'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  remarks: Scalars['String'];
  tag: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "farm" */
export type FarmDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "farm" */
export type FarmFieldsArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "farm" */
export type FarmNetworksArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "farm" */
export type Farm_Aggregate = {
  __typename?: 'farm_aggregate';
  aggregate?: Maybe<Farm_Aggregate_Fields>;
  nodes: Array<Farm>;
};

/** aggregate fields of "farm" */
export type Farm_Aggregate_Fields = {
  __typename?: 'farm_aggregate_fields';
  avg?: Maybe<Farm_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Farm_Max_Fields>;
  min?: Maybe<Farm_Min_Fields>;
  stddev?: Maybe<Farm_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Sum_Fields>;
  var_pop?: Maybe<Farm_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Var_Samp_Fields>;
  variance?: Maybe<Farm_Variance_Fields>;
};


/** aggregate fields of "farm" */
export type Farm_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "farm" */
export type Farm_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Max_Order_By>;
  min?: InputMaybe<Farm_Min_Order_By>;
  stddev?: InputMaybe<Farm_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Farm_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "farm" */
export type Farm_Arr_Rel_Insert_Input = {
  data: Array<Farm_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Farm_On_Conflict>;
};

/** aggregate avg on columns */
export type Farm_Avg_Fields = {
  __typename?: 'farm_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "farm" */
export type Farm_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm". All fields are combined with a logical 'AND'. */
export type Farm_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Bool_Exp>>;
  _not?: InputMaybe<Farm_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Farm_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "farm". All fields are combined with a logical 'AND'. */
export type Farm_Bool_Exp_Remote_Rel_Shared_Entityfarm = {
  _and?: InputMaybe<Array<Farm_Bool_Exp>>;
  _not?: InputMaybe<Farm_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityfarm>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Farm_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "farm" */
export enum Farm_Constraint {
  /** unique or primary key constraint on columns "codename" */
  FarmCodenameKey = 'farm_codename_key',
  /** unique or primary key constraint on columns "id" */
  FarmPkey = 'farm_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Farm_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Farm_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Farm_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "farm" */
export type Farm_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "farm" */
export type Farm_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farmer?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  fields?: InputMaybe<Field_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Farm_Network_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Farm_Max_Fields = {
  __typename?: 'farm_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farmer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "farm" */
export type Farm_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Min_Fields = {
  __typename?: 'farm_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farmer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "farm" */
export type Farm_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "farm" */
export type Farm_Mutation_Response = {
  __typename?: 'farm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Farm>;
};

/** columns and relationships of "farm_network" */
export type Farm_Network = {
  __typename?: 'farm_network';
  /** An object relationship */
  farm: Farm;
  farm_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
};

/** aggregated selection of "farm_network" */
export type Farm_Network_Aggregate = {
  __typename?: 'farm_network_aggregate';
  aggregate?: Maybe<Farm_Network_Aggregate_Fields>;
  nodes: Array<Farm_Network>;
};

/** aggregate fields of "farm_network" */
export type Farm_Network_Aggregate_Fields = {
  __typename?: 'farm_network_aggregate_fields';
  avg?: Maybe<Farm_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Farm_Network_Max_Fields>;
  min?: Maybe<Farm_Network_Min_Fields>;
  stddev?: Maybe<Farm_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Network_Sum_Fields>;
  var_pop?: Maybe<Farm_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Network_Var_Samp_Fields>;
  variance?: Maybe<Farm_Network_Variance_Fields>;
};


/** aggregate fields of "farm_network" */
export type Farm_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "farm_network" */
export type Farm_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Network_Max_Order_By>;
  min?: InputMaybe<Farm_Network_Min_Order_By>;
  stddev?: InputMaybe<Farm_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "farm_network" */
export type Farm_Network_Arr_Rel_Insert_Input = {
  data: Array<Farm_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Farm_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Farm_Network_Avg_Fields = {
  __typename?: 'farm_network_avg_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "farm_network" */
export type Farm_Network_Avg_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_network". All fields are combined with a logical 'AND'. */
export type Farm_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Network_Bool_Exp>>;
  _not?: InputMaybe<Farm_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Network_Bool_Exp>>;
  farm?: InputMaybe<Farm_Bool_Exp>;
  farm_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "farm_network" */
export enum Farm_Network_Constraint {
  /** unique or primary key constraint on columns "network_id", "farm_id" */
  FarmNetworkNetworkIdFarmId_9abac404Uniq = 'farm_network_network_id_farm_id_9abac404_uniq',
  /** unique or primary key constraint on columns "id" */
  FarmNetworkPkey = 'farm_network_pkey'
}

/** input type for incrementing numeric columns in table "farm_network" */
export type Farm_Network_Inc_Input = {
  farm_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "farm_network" */
export type Farm_Network_Insert_Input = {
  farm?: InputMaybe<Farm_Obj_Rel_Insert_Input>;
  farm_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Farm_Network_Max_Fields = {
  __typename?: 'farm_network_max_fields';
  farm_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "farm_network" */
export type Farm_Network_Max_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Network_Min_Fields = {
  __typename?: 'farm_network_min_fields';
  farm_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "farm_network" */
export type Farm_Network_Min_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "farm_network" */
export type Farm_Network_Mutation_Response = {
  __typename?: 'farm_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Farm_Network>;
};

/** on_conflict condition type for table "farm_network" */
export type Farm_Network_On_Conflict = {
  constraint: Farm_Network_Constraint;
  update_columns?: Array<Farm_Network_Update_Column>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "farm_network". */
export type Farm_Network_Order_By = {
  farm?: InputMaybe<Farm_Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farm_network */
export type Farm_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "farm_network" */
export enum Farm_Network_Select_Column {
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id'
}

/** input type for updating data in table "farm_network" */
export type Farm_Network_Set_Input = {
  farm_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Farm_Network_Stddev_Fields = {
  __typename?: 'farm_network_stddev_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "farm_network" */
export type Farm_Network_Stddev_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Network_Stddev_Pop_Fields = {
  __typename?: 'farm_network_stddev_pop_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "farm_network" */
export type Farm_Network_Stddev_Pop_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Network_Stddev_Samp_Fields = {
  __typename?: 'farm_network_stddev_samp_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "farm_network" */
export type Farm_Network_Stddev_Samp_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_network" */
export type Farm_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Network_Stream_Cursor_Value_Input = {
  farm_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Farm_Network_Sum_Fields = {
  __typename?: 'farm_network_sum_fields';
  farm_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "farm_network" */
export type Farm_Network_Sum_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "farm_network" */
export enum Farm_Network_Update_Column {
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id'
}

export type Farm_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farm_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farm_Network_Set_Input>;
  where: Farm_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farm_Network_Var_Pop_Fields = {
  __typename?: 'farm_network_var_pop_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "farm_network" */
export type Farm_Network_Var_Pop_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Network_Var_Samp_Fields = {
  __typename?: 'farm_network_var_samp_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "farm_network" */
export type Farm_Network_Var_Samp_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Network_Variance_Fields = {
  __typename?: 'farm_network_variance_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "farm_network" */
export type Farm_Network_Variance_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "farm" */
export type Farm_Obj_Rel_Insert_Input = {
  data: Farm_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Farm_On_Conflict>;
};

/** on_conflict condition type for table "farm" */
export type Farm_On_Conflict = {
  constraint: Farm_Constraint;
  update_columns?: Array<Farm_Update_Column>;
  where?: InputMaybe<Farm_Bool_Exp>;
};

/** Ordering options when selecting data from "farm". */
export type Farm_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in?: InputMaybe<Department_Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmer?: InputMaybe<Base_User_Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  fields_aggregate?: InputMaybe<Field_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Farm_Network_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farm */
export type Farm_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Farm_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "farm" */
export enum Farm_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "farm" */
export type Farm_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Farm_Stddev_Fields = {
  __typename?: 'farm_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "farm" */
export type Farm_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Stddev_Pop_Fields = {
  __typename?: 'farm_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "farm" */
export type Farm_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Stddev_Samp_Fields = {
  __typename?: 'farm_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "farm" */
export type Farm_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm" */
export type Farm_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Farm_Sum_Fields = {
  __typename?: 'farm_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "farm" */
export type Farm_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "farm" */
export enum Farm_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Farm_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Farm_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Farm_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Farm_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Farm_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farm_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Farm_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farm_Set_Input>;
  where: Farm_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farm_Var_Pop_Fields = {
  __typename?: 'farm_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "farm" */
export type Farm_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Var_Samp_Fields = {
  __typename?: 'farm_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "farm" */
export type Farm_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Variance_Fields = {
  __typename?: 'farm_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "farm" */
export type Farm_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "field" */
export type Field = {
  __typename?: 'field';
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  area: Scalars['numeric'];
  area_catered: Scalars['geometry'];
  /** An object relationship */
  area_unit: Si_Unit;
  area_unit_id: Scalars['Int'];
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_in?: Maybe<Department>;
  created_in_id?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  external_reference_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  farm: Farm;
  farm_id: Scalars['Int'];
  /** An object relationship */
  farmer: Base_User;
  farmer_id: Scalars['Int'];
  /** An array relationship */
  field_weather_locations: Array<Field_Weather_Location>;
  /** An aggregate relationship */
  field_weather_locations_aggregate: Field_Weather_Location_Aggregate;
  gat_no?: Maybe<Scalars['String']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Field_Network>;
  /** An aggregate relationship */
  networks_aggregate: Field_Network_Aggregate;
  notes?: Maybe<Scalars['String']>;
  /** An array relationship */
  plots: Array<Plot>;
  /** An aggregate relationship */
  plots_aggregate: Plot_Aggregate;
  private_metadata: Scalars['jsonb'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  region?: Maybe<Region>;
  region_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  soil: Soil;
  soil_id: Scalars['Int'];
  tag: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "field" */
export type FieldField_Weather_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldField_Weather_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "field" */
export type FieldNetworksArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldPlotsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldPlots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "field" */
export type Field_Aggregate = {
  __typename?: 'field_aggregate';
  aggregate?: Maybe<Field_Aggregate_Fields>;
  nodes: Array<Field>;
};

/** aggregate fields of "field" */
export type Field_Aggregate_Fields = {
  __typename?: 'field_aggregate_fields';
  avg?: Maybe<Field_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Field_Max_Fields>;
  min?: Maybe<Field_Min_Fields>;
  stddev?: Maybe<Field_Stddev_Fields>;
  stddev_pop?: Maybe<Field_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Field_Stddev_Samp_Fields>;
  sum?: Maybe<Field_Sum_Fields>;
  var_pop?: Maybe<Field_Var_Pop_Fields>;
  var_samp?: Maybe<Field_Var_Samp_Fields>;
  variance?: Maybe<Field_Variance_Fields>;
};


/** aggregate fields of "field" */
export type Field_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "field" */
export type Field_Aggregate_Order_By = {
  avg?: InputMaybe<Field_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Max_Order_By>;
  min?: InputMaybe<Field_Min_Order_By>;
  stddev?: InputMaybe<Field_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Field_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Field_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Field_Sum_Order_By>;
  var_pop?: InputMaybe<Field_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Field_Var_Samp_Order_By>;
  variance?: InputMaybe<Field_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Field_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "field" */
export type Field_Arr_Rel_Insert_Input = {
  data: Array<Field_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_On_Conflict>;
};

/** aggregate avg on columns */
export type Field_Avg_Fields = {
  __typename?: 'field_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "field" */
export type Field_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "field". All fields are combined with a logical 'AND'. */
export type Field_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Bool_Exp>>;
  _not?: InputMaybe<Field_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_catered?: InputMaybe<Geometry_Comparison_Exp>;
  area_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farm?: InputMaybe<Farm_Bool_Exp>;
  farm_id?: InputMaybe<Int_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  field_weather_locations?: InputMaybe<Field_Weather_Location_Bool_Exp>;
  gat_no?: InputMaybe<String_Comparison_Exp>;
  geo_area_remark?: InputMaybe<Float8_Comparison_Exp>;
  geo_bound_area?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Field_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  soil?: InputMaybe<Soil_Bool_Exp>;
  soil_id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "field". All fields are combined with a logical 'AND'. */
export type Field_Bool_Exp_Remote_Rel_Shared_Entityfield = {
  _and?: InputMaybe<Array<Field_Bool_Exp>>;
  _not?: InputMaybe<Field_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_catered?: InputMaybe<Geometry_Comparison_Exp>;
  area_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityfield>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farm?: InputMaybe<Farm_Bool_Exp>;
  farm_id?: InputMaybe<Int_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  field_weather_locations?: InputMaybe<Field_Weather_Location_Bool_Exp>;
  gat_no?: InputMaybe<String_Comparison_Exp>;
  geo_area_remark?: InputMaybe<Float8_Comparison_Exp>;
  geo_bound_area?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Field_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  soil?: InputMaybe<Soil_Bool_Exp>;
  soil_id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "field" */
export enum Field_Constraint {
  /** unique or primary key constraint on columns "codename" */
  FieldCodenameKey = 'field_codename_key',
  /** unique or primary key constraint on columns "id" */
  FieldPkey = 'field_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Field_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Field_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Field_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "field" */
export type Field_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  area?: InputMaybe<Scalars['numeric']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  farm_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
  soil_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "field" */
export type Field_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farm?: InputMaybe<Farm_Obj_Rel_Insert_Input>;
  farm_id?: InputMaybe<Scalars['Int']>;
  farmer?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  field_weather_locations?: InputMaybe<Field_Weather_Location_Arr_Rel_Insert_Input>;
  gat_no?: InputMaybe<Scalars['String']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Field_Network_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  plots?: InputMaybe<Plot_Arr_Rel_Insert_Input>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  region_id?: InputMaybe<Scalars['Int']>;
  soil?: InputMaybe<Soil_Obj_Rel_Insert_Input>;
  soil_id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Field_Max_Fields = {
  __typename?: 'field_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farm_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  gat_no?: Maybe<Scalars['String']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  soil_id?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "field" */
export type Field_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  gat_no?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Min_Fields = {
  __typename?: 'field_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farm_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  gat_no?: Maybe<Scalars['String']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  soil_id?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "field" */
export type Field_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  gat_no?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field" */
export type Field_Mutation_Response = {
  __typename?: 'field_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Field>;
};

/** columns and relationships of "field_network" */
export type Field_Network = {
  __typename?: 'field_network';
  /** An object relationship */
  field: Field;
  field_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
};

/** aggregated selection of "field_network" */
export type Field_Network_Aggregate = {
  __typename?: 'field_network_aggregate';
  aggregate?: Maybe<Field_Network_Aggregate_Fields>;
  nodes: Array<Field_Network>;
};

/** aggregate fields of "field_network" */
export type Field_Network_Aggregate_Fields = {
  __typename?: 'field_network_aggregate_fields';
  avg?: Maybe<Field_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Field_Network_Max_Fields>;
  min?: Maybe<Field_Network_Min_Fields>;
  stddev?: Maybe<Field_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Field_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Field_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Field_Network_Sum_Fields>;
  var_pop?: Maybe<Field_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Field_Network_Var_Samp_Fields>;
  variance?: Maybe<Field_Network_Variance_Fields>;
};


/** aggregate fields of "field_network" */
export type Field_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "field_network" */
export type Field_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Field_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Network_Max_Order_By>;
  min?: InputMaybe<Field_Network_Min_Order_By>;
  stddev?: InputMaybe<Field_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Field_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Field_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Field_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Field_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Field_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Field_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "field_network" */
export type Field_Network_Arr_Rel_Insert_Input = {
  data: Array<Field_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Field_Network_Avg_Fields = {
  __typename?: 'field_network_avg_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "field_network" */
export type Field_Network_Avg_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "field_network". All fields are combined with a logical 'AND'. */
export type Field_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Network_Bool_Exp>>;
  _not?: InputMaybe<Field_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Network_Bool_Exp>>;
  field?: InputMaybe<Field_Bool_Exp>;
  field_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "field_network" */
export enum Field_Network_Constraint {
  /** unique or primary key constraint on columns "field_id", "network_id" */
  FieldNetworkNetworkIdFieldIdB222e0b4Uniq = 'field_network_network_id_field_id_b222e0b4_uniq',
  /** unique or primary key constraint on columns "id" */
  FieldNetworkPkey = 'field_network_pkey'
}

/** input type for incrementing numeric columns in table "field_network" */
export type Field_Network_Inc_Input = {
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "field_network" */
export type Field_Network_Insert_Input = {
  field?: InputMaybe<Field_Obj_Rel_Insert_Input>;
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Field_Network_Max_Fields = {
  __typename?: 'field_network_max_fields';
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "field_network" */
export type Field_Network_Max_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Network_Min_Fields = {
  __typename?: 'field_network_min_fields';
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "field_network" */
export type Field_Network_Min_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_network" */
export type Field_Network_Mutation_Response = {
  __typename?: 'field_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Network>;
};

/** on_conflict condition type for table "field_network" */
export type Field_Network_On_Conflict = {
  constraint: Field_Network_Constraint;
  update_columns?: Array<Field_Network_Update_Column>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "field_network". */
export type Field_Network_Order_By = {
  field?: InputMaybe<Field_Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: field_network */
export type Field_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "field_network" */
export enum Field_Network_Select_Column {
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id'
}

/** input type for updating data in table "field_network" */
export type Field_Network_Set_Input = {
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Field_Network_Stddev_Fields = {
  __typename?: 'field_network_stddev_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "field_network" */
export type Field_Network_Stddev_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Field_Network_Stddev_Pop_Fields = {
  __typename?: 'field_network_stddev_pop_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "field_network" */
export type Field_Network_Stddev_Pop_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Field_Network_Stddev_Samp_Fields = {
  __typename?: 'field_network_stddev_samp_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "field_network" */
export type Field_Network_Stddev_Samp_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "field_network" */
export type Field_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Network_Stream_Cursor_Value_Input = {
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Field_Network_Sum_Fields = {
  __typename?: 'field_network_sum_fields';
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "field_network" */
export type Field_Network_Sum_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "field_network" */
export enum Field_Network_Update_Column {
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id'
}

export type Field_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Field_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Network_Set_Input>;
  where: Field_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Field_Network_Var_Pop_Fields = {
  __typename?: 'field_network_var_pop_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "field_network" */
export type Field_Network_Var_Pop_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Field_Network_Var_Samp_Fields = {
  __typename?: 'field_network_var_samp_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "field_network" */
export type Field_Network_Var_Samp_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Field_Network_Variance_Fields = {
  __typename?: 'field_network_variance_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "field_network" */
export type Field_Network_Variance_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "field" */
export type Field_Obj_Rel_Insert_Input = {
  data: Field_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_On_Conflict>;
};

/** on_conflict condition type for table "field" */
export type Field_On_Conflict = {
  constraint: Field_Constraint;
  update_columns?: Array<Field_Update_Column>;
  where?: InputMaybe<Field_Bool_Exp>;
};

/** Ordering options when selecting data from "field". */
export type Field_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_catered?: InputMaybe<Order_By>;
  area_unit?: InputMaybe<Si_Unit_Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in?: InputMaybe<Department_Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farm?: InputMaybe<Farm_Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer?: InputMaybe<Base_User_Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_weather_locations_aggregate?: InputMaybe<Field_Weather_Location_Aggregate_Order_By>;
  gat_no?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Field_Network_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  plots_aggregate?: InputMaybe<Plot_Aggregate_Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  region?: InputMaybe<Region_Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil?: InputMaybe<Soil_Order_By>;
  soil_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: field */
export type Field_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Field_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "field" */
export enum Field_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Area = 'area',
  /** column name */
  AreaCatered = 'area_catered',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  GatNo = 'gat_no',
  /** column name */
  GeoAreaRemark = 'geo_area_remark',
  /** column name */
  GeoBoundArea = 'geo_bound_area',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SoilId = 'soil_id',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "field" */
export type Field_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farm_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  gat_no?: InputMaybe<Scalars['String']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region_id?: InputMaybe<Scalars['Int']>;
  soil_id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Field_Stddev_Fields = {
  __typename?: 'field_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "field" */
export type Field_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Field_Stddev_Pop_Fields = {
  __typename?: 'field_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "field" */
export type Field_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Field_Stddev_Samp_Fields = {
  __typename?: 'field_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "field" */
export type Field_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "field" */
export type Field_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farm_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  gat_no?: InputMaybe<Scalars['String']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region_id?: InputMaybe<Scalars['Int']>;
  soil_id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Field_Sum_Fields = {
  __typename?: 'field_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  farm_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  soil_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "field" */
export type Field_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "field" */
export enum Field_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Area = 'area',
  /** column name */
  AreaCatered = 'area_catered',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  GatNo = 'gat_no',
  /** column name */
  GeoAreaRemark = 'geo_area_remark',
  /** column name */
  GeoBoundArea = 'geo_bound_area',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SoilId = 'soil_id',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Field_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Field_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Field_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Field_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Field_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Field_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Field_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Set_Input>;
  where: Field_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Field_Var_Pop_Fields = {
  __typename?: 'field_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "field" */
export type Field_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Field_Var_Samp_Fields = {
  __typename?: 'field_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "field" */
export type Field_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Field_Variance_Fields = {
  __typename?: 'field_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "field" */
export type Field_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "field_weather_location" */
export type Field_Weather_Location = {
  __typename?: 'field_weather_location';
  /** An object relationship */
  field: Field;
  field_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  weather_reference: Weather_Reference;
  weather_reference_id: Scalars['Int'];
};

/** aggregated selection of "field_weather_location" */
export type Field_Weather_Location_Aggregate = {
  __typename?: 'field_weather_location_aggregate';
  aggregate?: Maybe<Field_Weather_Location_Aggregate_Fields>;
  nodes: Array<Field_Weather_Location>;
};

/** aggregate fields of "field_weather_location" */
export type Field_Weather_Location_Aggregate_Fields = {
  __typename?: 'field_weather_location_aggregate_fields';
  avg?: Maybe<Field_Weather_Location_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Field_Weather_Location_Max_Fields>;
  min?: Maybe<Field_Weather_Location_Min_Fields>;
  stddev?: Maybe<Field_Weather_Location_Stddev_Fields>;
  stddev_pop?: Maybe<Field_Weather_Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Field_Weather_Location_Stddev_Samp_Fields>;
  sum?: Maybe<Field_Weather_Location_Sum_Fields>;
  var_pop?: Maybe<Field_Weather_Location_Var_Pop_Fields>;
  var_samp?: Maybe<Field_Weather_Location_Var_Samp_Fields>;
  variance?: Maybe<Field_Weather_Location_Variance_Fields>;
};


/** aggregate fields of "field_weather_location" */
export type Field_Weather_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "field_weather_location" */
export type Field_Weather_Location_Aggregate_Order_By = {
  avg?: InputMaybe<Field_Weather_Location_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Weather_Location_Max_Order_By>;
  min?: InputMaybe<Field_Weather_Location_Min_Order_By>;
  stddev?: InputMaybe<Field_Weather_Location_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Field_Weather_Location_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Field_Weather_Location_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Field_Weather_Location_Sum_Order_By>;
  var_pop?: InputMaybe<Field_Weather_Location_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Field_Weather_Location_Var_Samp_Order_By>;
  variance?: InputMaybe<Field_Weather_Location_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "field_weather_location" */
export type Field_Weather_Location_Arr_Rel_Insert_Input = {
  data: Array<Field_Weather_Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Weather_Location_On_Conflict>;
};

/** aggregate avg on columns */
export type Field_Weather_Location_Avg_Fields = {
  __typename?: 'field_weather_location_avg_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "field_weather_location" */
export type Field_Weather_Location_Avg_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "field_weather_location". All fields are combined with a logical 'AND'. */
export type Field_Weather_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Weather_Location_Bool_Exp>>;
  _not?: InputMaybe<Field_Weather_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Weather_Location_Bool_Exp>>;
  field?: InputMaybe<Field_Bool_Exp>;
  field_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  weather_reference?: InputMaybe<Weather_Reference_Bool_Exp>;
  weather_reference_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "field_weather_location" */
export enum Field_Weather_Location_Constraint {
  /** unique or primary key constraint on columns "weather_reference_id", "field_id" */
  FieldWeatherLocationFieldIdWeatherReferen_36801bf1Uniq = 'field_weather_location_field_id_weather_referen_36801bf1_uniq',
  /** unique or primary key constraint on columns "id" */
  FieldWeatherLocationPkey = 'field_weather_location_pkey'
}

/** input type for incrementing numeric columns in table "field_weather_location" */
export type Field_Weather_Location_Inc_Input = {
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  weather_reference_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "field_weather_location" */
export type Field_Weather_Location_Insert_Input = {
  field?: InputMaybe<Field_Obj_Rel_Insert_Input>;
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  weather_reference?: InputMaybe<Weather_Reference_Obj_Rel_Insert_Input>;
  weather_reference_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Field_Weather_Location_Max_Fields = {
  __typename?: 'field_weather_location_max_fields';
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  weather_reference_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "field_weather_location" */
export type Field_Weather_Location_Max_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Weather_Location_Min_Fields = {
  __typename?: 'field_weather_location_min_fields';
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  weather_reference_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "field_weather_location" */
export type Field_Weather_Location_Min_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_weather_location" */
export type Field_Weather_Location_Mutation_Response = {
  __typename?: 'field_weather_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Weather_Location>;
};

/** on_conflict condition type for table "field_weather_location" */
export type Field_Weather_Location_On_Conflict = {
  constraint: Field_Weather_Location_Constraint;
  update_columns?: Array<Field_Weather_Location_Update_Column>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "field_weather_location". */
export type Field_Weather_Location_Order_By = {
  field?: InputMaybe<Field_Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference?: InputMaybe<Weather_Reference_Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: field_weather_location */
export type Field_Weather_Location_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "field_weather_location" */
export enum Field_Weather_Location_Select_Column {
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  WeatherReferenceId = 'weather_reference_id'
}

/** input type for updating data in table "field_weather_location" */
export type Field_Weather_Location_Set_Input = {
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  weather_reference_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Field_Weather_Location_Stddev_Fields = {
  __typename?: 'field_weather_location_stddev_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "field_weather_location" */
export type Field_Weather_Location_Stddev_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Field_Weather_Location_Stddev_Pop_Fields = {
  __typename?: 'field_weather_location_stddev_pop_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "field_weather_location" */
export type Field_Weather_Location_Stddev_Pop_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Field_Weather_Location_Stddev_Samp_Fields = {
  __typename?: 'field_weather_location_stddev_samp_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "field_weather_location" */
export type Field_Weather_Location_Stddev_Samp_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "field_weather_location" */
export type Field_Weather_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Weather_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Weather_Location_Stream_Cursor_Value_Input = {
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  weather_reference_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Field_Weather_Location_Sum_Fields = {
  __typename?: 'field_weather_location_sum_fields';
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  weather_reference_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "field_weather_location" */
export type Field_Weather_Location_Sum_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** update columns of table "field_weather_location" */
export enum Field_Weather_Location_Update_Column {
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  WeatherReferenceId = 'weather_reference_id'
}

export type Field_Weather_Location_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Field_Weather_Location_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Weather_Location_Set_Input>;
  where: Field_Weather_Location_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Field_Weather_Location_Var_Pop_Fields = {
  __typename?: 'field_weather_location_var_pop_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "field_weather_location" */
export type Field_Weather_Location_Var_Pop_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Field_Weather_Location_Var_Samp_Fields = {
  __typename?: 'field_weather_location_var_samp_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "field_weather_location" */
export type Field_Weather_Location_Var_Samp_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Field_Weather_Location_Variance_Fields = {
  __typename?: 'field_weather_location_variance_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "field_weather_location" */
export type Field_Weather_Location_Variance_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "fileupload" */
export type Fileupload = {
  __typename?: 'fileupload';
  access: Scalars['String'];
  /** An array relationship */
  article_attachments: Array<Article_Attachments>;
  /** An aggregate relationship */
  article_attachments_aggregate: Article_Attachments_Aggregate;
  /** An array relationship */
  articles: Array<Article>;
  /** An aggregate relationship */
  articles_aggregate: Article_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['String']>;
  creator: Array<Base_User>;
  duration: Scalars['Int'];
  extension?: Maybe<Scalars['String']>;
  geo_location?: Maybe<Scalars['geometry']>;
  id: Scalars['bigint'];
  is_encrypted: Scalars['Boolean'];
  media_type: Scalars['String'];
  /** An array relationship */
  monitoring_record_attachments: Array<Monitoring_Record_Attachments>;
  /** An aggregate relationship */
  monitoring_record_attachments_aggregate: Monitoring_Record_Attachments_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  operation_attachments: Array<Operation_Attachments>;
  /** An aggregate relationship */
  operation_attachments_aggregate: Operation_Attachments_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  updater: Array<Base_User>;
  url: Scalars['String'];
};


/** columns and relationships of "fileupload" */
export type FileuploadArticle_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Article_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Attachments_Order_By>>;
  where?: InputMaybe<Article_Attachments_Bool_Exp>;
};


/** columns and relationships of "fileupload" */
export type FileuploadArticle_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Attachments_Order_By>>;
  where?: InputMaybe<Article_Attachments_Bool_Exp>;
};


/** columns and relationships of "fileupload" */
export type FileuploadArticlesArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


/** columns and relationships of "fileupload" */
export type FileuploadArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


/** columns and relationships of "fileupload" */
export type FileuploadCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Fileuploadcreator>;
};


/** columns and relationships of "fileupload" */
export type FileuploadMonitoring_Record_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Attachments_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
};


/** columns and relationships of "fileupload" */
export type FileuploadMonitoring_Record_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Attachments_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
};


/** columns and relationships of "fileupload" */
export type FileuploadOperation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Attachments_Order_By>>;
  where?: InputMaybe<Operation_Attachments_Bool_Exp>;
};


/** columns and relationships of "fileupload" */
export type FileuploadOperation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Attachments_Order_By>>;
  where?: InputMaybe<Operation_Attachments_Bool_Exp>;
};


/** columns and relationships of "fileupload" */
export type FileuploadUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Fileuploadupdater>;
};

/** aggregated selection of "fileupload" */
export type Fileupload_Aggregate = {
  __typename?: 'fileupload_aggregate';
  aggregate?: Maybe<Fileupload_Aggregate_Fields>;
  nodes: Array<Fileupload>;
};

/** aggregate fields of "fileupload" */
export type Fileupload_Aggregate_Fields = {
  __typename?: 'fileupload_aggregate_fields';
  avg?: Maybe<Fileupload_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fileupload_Max_Fields>;
  min?: Maybe<Fileupload_Min_Fields>;
  stddev?: Maybe<Fileupload_Stddev_Fields>;
  stddev_pop?: Maybe<Fileupload_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fileupload_Stddev_Samp_Fields>;
  sum?: Maybe<Fileupload_Sum_Fields>;
  var_pop?: Maybe<Fileupload_Var_Pop_Fields>;
  var_samp?: Maybe<Fileupload_Var_Samp_Fields>;
  variance?: Maybe<Fileupload_Variance_Fields>;
};


/** aggregate fields of "fileupload" */
export type Fileupload_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fileupload_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fileupload_Avg_Fields = {
  __typename?: 'fileupload_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fileupload". All fields are combined with a logical 'AND'. */
export type Fileupload_Bool_Exp = {
  _and?: InputMaybe<Array<Fileupload_Bool_Exp>>;
  _not?: InputMaybe<Fileupload_Bool_Exp>;
  _or?: InputMaybe<Array<Fileupload_Bool_Exp>>;
  access?: InputMaybe<String_Comparison_Exp>;
  article_attachments?: InputMaybe<Article_Attachments_Bool_Exp>;
  articles?: InputMaybe<Article_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  geo_location?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_encrypted?: InputMaybe<Boolean_Comparison_Exp>;
  media_type?: InputMaybe<String_Comparison_Exp>;
  monitoring_record_attachments?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  operation_attachments?: InputMaybe<Operation_Attachments_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fileupload" */
export enum Fileupload_Constraint {
  /** unique or primary key constraint on columns "id" */
  FileuploadPkey = 'fileupload_pkey'
}

/** input type for incrementing numeric columns in table "fileupload" */
export type Fileupload_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "fileupload" */
export type Fileupload_Insert_Input = {
  access?: InputMaybe<Scalars['String']>;
  article_attachments?: InputMaybe<Article_Attachments_Arr_Rel_Insert_Input>;
  articles?: InputMaybe<Article_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  extension?: InputMaybe<Scalars['String']>;
  geo_location?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  media_type?: InputMaybe<Scalars['String']>;
  monitoring_record_attachments?: InputMaybe<Monitoring_Record_Attachments_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  operation_attachments?: InputMaybe<Operation_Attachments_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Fileupload_Max_Fields = {
  __typename?: 'fileupload_max_fields';
  access?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  media_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fileupload_Min_Fields = {
  __typename?: 'fileupload_min_fields';
  access?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  media_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "fileupload" */
export type Fileupload_Mutation_Response = {
  __typename?: 'fileupload_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fileupload>;
};

/** input type for inserting object relation for remote table "fileupload" */
export type Fileupload_Obj_Rel_Insert_Input = {
  data: Fileupload_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fileupload_On_Conflict>;
};

/** on_conflict condition type for table "fileupload" */
export type Fileupload_On_Conflict = {
  constraint: Fileupload_Constraint;
  update_columns?: Array<Fileupload_Update_Column>;
  where?: InputMaybe<Fileupload_Bool_Exp>;
};

/** Ordering options when selecting data from "fileupload". */
export type Fileupload_Order_By = {
  access?: InputMaybe<Order_By>;
  article_attachments_aggregate?: InputMaybe<Article_Attachments_Aggregate_Order_By>;
  articles_aggregate?: InputMaybe<Article_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  geo_location?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_encrypted?: InputMaybe<Order_By>;
  media_type?: InputMaybe<Order_By>;
  monitoring_record_attachments_aggregate?: InputMaybe<Monitoring_Record_Attachments_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  operation_attachments_aggregate?: InputMaybe<Operation_Attachments_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fileupload */
export type Fileupload_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "fileupload" */
export enum Fileupload_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  Extension = 'extension',
  /** column name */
  GeoLocation = 'geo_location',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  MediaType = 'media_type',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "fileupload" */
export type Fileupload_Set_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  extension?: InputMaybe<Scalars['String']>;
  geo_location?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  media_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Fileupload_Stddev_Fields = {
  __typename?: 'fileupload_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fileupload_Stddev_Pop_Fields = {
  __typename?: 'fileupload_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fileupload_Stddev_Samp_Fields = {
  __typename?: 'fileupload_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fileupload" */
export type Fileupload_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fileupload_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fileupload_Stream_Cursor_Value_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  extension?: InputMaybe<Scalars['String']>;
  geo_location?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  media_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fileupload_Sum_Fields = {
  __typename?: 'fileupload_sum_fields';
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "fileupload" */
export enum Fileupload_Update_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  Extension = 'extension',
  /** column name */
  GeoLocation = 'geo_location',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  MediaType = 'media_type',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

export type Fileupload_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fileupload_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fileupload_Set_Input>;
  where: Fileupload_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fileupload_Var_Pop_Fields = {
  __typename?: 'fileupload_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fileupload_Var_Samp_Fields = {
  __typename?: 'fileupload_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fileupload_Variance_Fields = {
  __typename?: 'fileupload_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "flood_irrigation_system" */
export type Flood_Irrigation_System = {
  __typename?: 'flood_irrigation_system';
  discharge_head: Scalars['float8'];
  discharge_rate: Scalars['float8'];
  /** An object relationship */
  irrigation_system: Irrigation_System;
  irrigationsystem_ptr_id: Scalars['uuid'];
  pump_power: Scalars['float8'];
};

/** aggregated selection of "flood_irrigation_system" */
export type Flood_Irrigation_System_Aggregate = {
  __typename?: 'flood_irrigation_system_aggregate';
  aggregate?: Maybe<Flood_Irrigation_System_Aggregate_Fields>;
  nodes: Array<Flood_Irrigation_System>;
};

/** aggregate fields of "flood_irrigation_system" */
export type Flood_Irrigation_System_Aggregate_Fields = {
  __typename?: 'flood_irrigation_system_aggregate_fields';
  avg?: Maybe<Flood_Irrigation_System_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Flood_Irrigation_System_Max_Fields>;
  min?: Maybe<Flood_Irrigation_System_Min_Fields>;
  stddev?: Maybe<Flood_Irrigation_System_Stddev_Fields>;
  stddev_pop?: Maybe<Flood_Irrigation_System_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Flood_Irrigation_System_Stddev_Samp_Fields>;
  sum?: Maybe<Flood_Irrigation_System_Sum_Fields>;
  var_pop?: Maybe<Flood_Irrigation_System_Var_Pop_Fields>;
  var_samp?: Maybe<Flood_Irrigation_System_Var_Samp_Fields>;
  variance?: Maybe<Flood_Irrigation_System_Variance_Fields>;
};


/** aggregate fields of "flood_irrigation_system" */
export type Flood_Irrigation_System_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Flood_Irrigation_System_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Flood_Irrigation_System_Avg_Fields = {
  __typename?: 'flood_irrigation_system_avg_fields';
  discharge_head?: Maybe<Scalars['Float']>;
  discharge_rate?: Maybe<Scalars['Float']>;
  pump_power?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "flood_irrigation_system". All fields are combined with a logical 'AND'. */
export type Flood_Irrigation_System_Bool_Exp = {
  _and?: InputMaybe<Array<Flood_Irrigation_System_Bool_Exp>>;
  _not?: InputMaybe<Flood_Irrigation_System_Bool_Exp>;
  _or?: InputMaybe<Array<Flood_Irrigation_System_Bool_Exp>>;
  discharge_head?: InputMaybe<Float8_Comparison_Exp>;
  discharge_rate?: InputMaybe<Float8_Comparison_Exp>;
  irrigation_system?: InputMaybe<Irrigation_System_Bool_Exp>;
  irrigationsystem_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
  pump_power?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "flood_irrigation_system" */
export enum Flood_Irrigation_System_Constraint {
  /** unique or primary key constraint on columns "irrigationsystem_ptr_id" */
  FloodIrrigationSystemPkey = 'flood_irrigation_system_pkey'
}

/** input type for incrementing numeric columns in table "flood_irrigation_system" */
export type Flood_Irrigation_System_Inc_Input = {
  discharge_head?: InputMaybe<Scalars['float8']>;
  discharge_rate?: InputMaybe<Scalars['float8']>;
  pump_power?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "flood_irrigation_system" */
export type Flood_Irrigation_System_Insert_Input = {
  discharge_head?: InputMaybe<Scalars['float8']>;
  discharge_rate?: InputMaybe<Scalars['float8']>;
  irrigation_system?: InputMaybe<Irrigation_System_Obj_Rel_Insert_Input>;
  irrigationsystem_ptr_id?: InputMaybe<Scalars['uuid']>;
  pump_power?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Flood_Irrigation_System_Max_Fields = {
  __typename?: 'flood_irrigation_system_max_fields';
  discharge_head?: Maybe<Scalars['float8']>;
  discharge_rate?: Maybe<Scalars['float8']>;
  irrigationsystem_ptr_id?: Maybe<Scalars['uuid']>;
  pump_power?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Flood_Irrigation_System_Min_Fields = {
  __typename?: 'flood_irrigation_system_min_fields';
  discharge_head?: Maybe<Scalars['float8']>;
  discharge_rate?: Maybe<Scalars['float8']>;
  irrigationsystem_ptr_id?: Maybe<Scalars['uuid']>;
  pump_power?: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "flood_irrigation_system" */
export type Flood_Irrigation_System_Mutation_Response = {
  __typename?: 'flood_irrigation_system_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Flood_Irrigation_System>;
};

/** input type for inserting object relation for remote table "flood_irrigation_system" */
export type Flood_Irrigation_System_Obj_Rel_Insert_Input = {
  data: Flood_Irrigation_System_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Flood_Irrigation_System_On_Conflict>;
};

/** on_conflict condition type for table "flood_irrigation_system" */
export type Flood_Irrigation_System_On_Conflict = {
  constraint: Flood_Irrigation_System_Constraint;
  update_columns?: Array<Flood_Irrigation_System_Update_Column>;
  where?: InputMaybe<Flood_Irrigation_System_Bool_Exp>;
};

/** Ordering options when selecting data from "flood_irrigation_system". */
export type Flood_Irrigation_System_Order_By = {
  discharge_head?: InputMaybe<Order_By>;
  discharge_rate?: InputMaybe<Order_By>;
  irrigation_system?: InputMaybe<Irrigation_System_Order_By>;
  irrigationsystem_ptr_id?: InputMaybe<Order_By>;
  pump_power?: InputMaybe<Order_By>;
};

/** primary key columns input for table: flood_irrigation_system */
export type Flood_Irrigation_System_Pk_Columns_Input = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};

/** select columns of table "flood_irrigation_system" */
export enum Flood_Irrigation_System_Select_Column {
  /** column name */
  DischargeHead = 'discharge_head',
  /** column name */
  DischargeRate = 'discharge_rate',
  /** column name */
  IrrigationsystemPtrId = 'irrigationsystem_ptr_id',
  /** column name */
  PumpPower = 'pump_power'
}

/** input type for updating data in table "flood_irrigation_system" */
export type Flood_Irrigation_System_Set_Input = {
  discharge_head?: InputMaybe<Scalars['float8']>;
  discharge_rate?: InputMaybe<Scalars['float8']>;
  irrigationsystem_ptr_id?: InputMaybe<Scalars['uuid']>;
  pump_power?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Flood_Irrigation_System_Stddev_Fields = {
  __typename?: 'flood_irrigation_system_stddev_fields';
  discharge_head?: Maybe<Scalars['Float']>;
  discharge_rate?: Maybe<Scalars['Float']>;
  pump_power?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Flood_Irrigation_System_Stddev_Pop_Fields = {
  __typename?: 'flood_irrigation_system_stddev_pop_fields';
  discharge_head?: Maybe<Scalars['Float']>;
  discharge_rate?: Maybe<Scalars['Float']>;
  pump_power?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Flood_Irrigation_System_Stddev_Samp_Fields = {
  __typename?: 'flood_irrigation_system_stddev_samp_fields';
  discharge_head?: Maybe<Scalars['Float']>;
  discharge_rate?: Maybe<Scalars['Float']>;
  pump_power?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "flood_irrigation_system" */
export type Flood_Irrigation_System_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flood_Irrigation_System_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Flood_Irrigation_System_Stream_Cursor_Value_Input = {
  discharge_head?: InputMaybe<Scalars['float8']>;
  discharge_rate?: InputMaybe<Scalars['float8']>;
  irrigationsystem_ptr_id?: InputMaybe<Scalars['uuid']>;
  pump_power?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Flood_Irrigation_System_Sum_Fields = {
  __typename?: 'flood_irrigation_system_sum_fields';
  discharge_head?: Maybe<Scalars['float8']>;
  discharge_rate?: Maybe<Scalars['float8']>;
  pump_power?: Maybe<Scalars['float8']>;
};

/** update columns of table "flood_irrigation_system" */
export enum Flood_Irrigation_System_Update_Column {
  /** column name */
  DischargeHead = 'discharge_head',
  /** column name */
  DischargeRate = 'discharge_rate',
  /** column name */
  IrrigationsystemPtrId = 'irrigationsystem_ptr_id',
  /** column name */
  PumpPower = 'pump_power'
}

export type Flood_Irrigation_System_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Flood_Irrigation_System_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Flood_Irrigation_System_Set_Input>;
  where: Flood_Irrigation_System_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Flood_Irrigation_System_Var_Pop_Fields = {
  __typename?: 'flood_irrigation_system_var_pop_fields';
  discharge_head?: Maybe<Scalars['Float']>;
  discharge_rate?: Maybe<Scalars['Float']>;
  pump_power?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Flood_Irrigation_System_Var_Samp_Fields = {
  __typename?: 'flood_irrigation_system_var_samp_fields';
  discharge_head?: Maybe<Scalars['Float']>;
  discharge_rate?: Maybe<Scalars['Float']>;
  pump_power?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Flood_Irrigation_System_Variance_Fields = {
  __typename?: 'flood_irrigation_system_variance_fields';
  discharge_head?: Maybe<Scalars['Float']>;
  discharge_rate?: Maybe<Scalars['Float']>;
  pump_power?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "forecast_reading" */
export type Forecast_Reading = {
  __typename?: 'forecast_reading';
  apparent_temperature?: Maybe<Scalars['float8']>;
  cloud_cover?: Maybe<Scalars['float8']>;
  created_at: Scalars['timestamptz'];
  date_time: Scalars['timestamptz'];
  delta_t?: Maybe<Scalars['float8']>;
  dew_point?: Maybe<Scalars['float8']>;
  id: Scalars['bigint'];
  location_id: Scalars['uuid'];
  melted_snow_depth?: Maybe<Scalars['float8']>;
  precip_prob?: Maybe<Scalars['float8']>;
  precipitation?: Maybe<Scalars['float8']>;
  pressure?: Maybe<Scalars['float8']>;
  provider: Scalars['String'];
  relative_humidity?: Maybe<Scalars['float8']>;
  snow_depth?: Maybe<Scalars['float8']>;
  solar_radiation?: Maybe<Scalars['float8']>;
  spray_decision: Scalars['Boolean'];
  temperature?: Maybe<Scalars['float8']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  weather_location: Weather_Location;
  weather_type?: Maybe<Scalars['String']>;
  wind_direction?: Maybe<Scalars['String']>;
  wind_direction_deg?: Maybe<Scalars['float8']>;
  wind_speed?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "forecast_reading" */
export type Forecast_Reading_Aggregate = {
  __typename?: 'forecast_reading_aggregate';
  aggregate?: Maybe<Forecast_Reading_Aggregate_Fields>;
  nodes: Array<Forecast_Reading>;
};

/** aggregate fields of "forecast_reading" */
export type Forecast_Reading_Aggregate_Fields = {
  __typename?: 'forecast_reading_aggregate_fields';
  avg?: Maybe<Forecast_Reading_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Forecast_Reading_Max_Fields>;
  min?: Maybe<Forecast_Reading_Min_Fields>;
  stddev?: Maybe<Forecast_Reading_Stddev_Fields>;
  stddev_pop?: Maybe<Forecast_Reading_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Forecast_Reading_Stddev_Samp_Fields>;
  sum?: Maybe<Forecast_Reading_Sum_Fields>;
  var_pop?: Maybe<Forecast_Reading_Var_Pop_Fields>;
  var_samp?: Maybe<Forecast_Reading_Var_Samp_Fields>;
  variance?: Maybe<Forecast_Reading_Variance_Fields>;
};


/** aggregate fields of "forecast_reading" */
export type Forecast_Reading_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Forecast_Reading_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "forecast_reading" */
export type Forecast_Reading_Aggregate_Order_By = {
  avg?: InputMaybe<Forecast_Reading_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Forecast_Reading_Max_Order_By>;
  min?: InputMaybe<Forecast_Reading_Min_Order_By>;
  stddev?: InputMaybe<Forecast_Reading_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Forecast_Reading_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Forecast_Reading_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Forecast_Reading_Sum_Order_By>;
  var_pop?: InputMaybe<Forecast_Reading_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Forecast_Reading_Var_Samp_Order_By>;
  variance?: InputMaybe<Forecast_Reading_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "forecast_reading" */
export type Forecast_Reading_Arr_Rel_Insert_Input = {
  data: Array<Forecast_Reading_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Forecast_Reading_On_Conflict>;
};

/** aggregate avg on columns */
export type Forecast_Reading_Avg_Fields = {
  __typename?: 'forecast_reading_avg_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "forecast_reading" */
export type Forecast_Reading_Avg_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "forecast_reading". All fields are combined with a logical 'AND'. */
export type Forecast_Reading_Bool_Exp = {
  _and?: InputMaybe<Array<Forecast_Reading_Bool_Exp>>;
  _not?: InputMaybe<Forecast_Reading_Bool_Exp>;
  _or?: InputMaybe<Array<Forecast_Reading_Bool_Exp>>;
  apparent_temperature?: InputMaybe<Float8_Comparison_Exp>;
  cloud_cover?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  delta_t?: InputMaybe<Float8_Comparison_Exp>;
  dew_point?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  melted_snow_depth?: InputMaybe<Float8_Comparison_Exp>;
  precip_prob?: InputMaybe<Float8_Comparison_Exp>;
  precipitation?: InputMaybe<Float8_Comparison_Exp>;
  pressure?: InputMaybe<Float8_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  relative_humidity?: InputMaybe<Float8_Comparison_Exp>;
  snow_depth?: InputMaybe<Float8_Comparison_Exp>;
  solar_radiation?: InputMaybe<Float8_Comparison_Exp>;
  spray_decision?: InputMaybe<Boolean_Comparison_Exp>;
  temperature?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weather_location?: InputMaybe<Weather_Location_Bool_Exp>;
  weather_type?: InputMaybe<String_Comparison_Exp>;
  wind_direction?: InputMaybe<String_Comparison_Exp>;
  wind_direction_deg?: InputMaybe<Float8_Comparison_Exp>;
  wind_speed?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "forecast_reading" */
export enum Forecast_Reading_Constraint {
  /** unique or primary key constraint on columns "date_time", "provider", "location_id" */
  ForecastReadingDateTimeProviderLocationId_25b4e647Uniq = 'forecast_reading_date_time_provider_location_id_25b4e647_uniq',
  /** unique or primary key constraint on columns "id" */
  ForecastReadingPkey = 'forecast_reading_pkey'
}

/** input type for incrementing numeric columns in table "forecast_reading" */
export type Forecast_Reading_Inc_Input = {
  apparent_temperature?: InputMaybe<Scalars['float8']>;
  cloud_cover?: InputMaybe<Scalars['float8']>;
  delta_t?: InputMaybe<Scalars['float8']>;
  dew_point?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  melted_snow_depth?: InputMaybe<Scalars['float8']>;
  precip_prob?: InputMaybe<Scalars['float8']>;
  precipitation?: InputMaybe<Scalars['float8']>;
  pressure?: InputMaybe<Scalars['float8']>;
  relative_humidity?: InputMaybe<Scalars['float8']>;
  snow_depth?: InputMaybe<Scalars['float8']>;
  solar_radiation?: InputMaybe<Scalars['float8']>;
  temperature?: InputMaybe<Scalars['float8']>;
  wind_direction_deg?: InputMaybe<Scalars['float8']>;
  wind_speed?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "forecast_reading" */
export type Forecast_Reading_Insert_Input = {
  apparent_temperature?: InputMaybe<Scalars['float8']>;
  cloud_cover?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_time?: InputMaybe<Scalars['timestamptz']>;
  delta_t?: InputMaybe<Scalars['float8']>;
  dew_point?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  melted_snow_depth?: InputMaybe<Scalars['float8']>;
  precip_prob?: InputMaybe<Scalars['float8']>;
  precipitation?: InputMaybe<Scalars['float8']>;
  pressure?: InputMaybe<Scalars['float8']>;
  provider?: InputMaybe<Scalars['String']>;
  relative_humidity?: InputMaybe<Scalars['float8']>;
  snow_depth?: InputMaybe<Scalars['float8']>;
  solar_radiation?: InputMaybe<Scalars['float8']>;
  spray_decision?: InputMaybe<Scalars['Boolean']>;
  temperature?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weather_location?: InputMaybe<Weather_Location_Obj_Rel_Insert_Input>;
  weather_type?: InputMaybe<Scalars['String']>;
  wind_direction?: InputMaybe<Scalars['String']>;
  wind_direction_deg?: InputMaybe<Scalars['float8']>;
  wind_speed?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Forecast_Reading_Max_Fields = {
  __typename?: 'forecast_reading_max_fields';
  apparent_temperature?: Maybe<Scalars['float8']>;
  cloud_cover?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  delta_t?: Maybe<Scalars['float8']>;
  dew_point?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  melted_snow_depth?: Maybe<Scalars['float8']>;
  precip_prob?: Maybe<Scalars['float8']>;
  precipitation?: Maybe<Scalars['float8']>;
  pressure?: Maybe<Scalars['float8']>;
  provider?: Maybe<Scalars['String']>;
  relative_humidity?: Maybe<Scalars['float8']>;
  snow_depth?: Maybe<Scalars['float8']>;
  solar_radiation?: Maybe<Scalars['float8']>;
  temperature?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weather_type?: Maybe<Scalars['String']>;
  wind_direction?: Maybe<Scalars['String']>;
  wind_direction_deg?: Maybe<Scalars['float8']>;
  wind_speed?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "forecast_reading" */
export type Forecast_Reading_Max_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_time?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weather_type?: InputMaybe<Order_By>;
  wind_direction?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Forecast_Reading_Min_Fields = {
  __typename?: 'forecast_reading_min_fields';
  apparent_temperature?: Maybe<Scalars['float8']>;
  cloud_cover?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  delta_t?: Maybe<Scalars['float8']>;
  dew_point?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  melted_snow_depth?: Maybe<Scalars['float8']>;
  precip_prob?: Maybe<Scalars['float8']>;
  precipitation?: Maybe<Scalars['float8']>;
  pressure?: Maybe<Scalars['float8']>;
  provider?: Maybe<Scalars['String']>;
  relative_humidity?: Maybe<Scalars['float8']>;
  snow_depth?: Maybe<Scalars['float8']>;
  solar_radiation?: Maybe<Scalars['float8']>;
  temperature?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weather_type?: Maybe<Scalars['String']>;
  wind_direction?: Maybe<Scalars['String']>;
  wind_direction_deg?: Maybe<Scalars['float8']>;
  wind_speed?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "forecast_reading" */
export type Forecast_Reading_Min_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_time?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weather_type?: InputMaybe<Order_By>;
  wind_direction?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "forecast_reading" */
export type Forecast_Reading_Mutation_Response = {
  __typename?: 'forecast_reading_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Forecast_Reading>;
};

/** on_conflict condition type for table "forecast_reading" */
export type Forecast_Reading_On_Conflict = {
  constraint: Forecast_Reading_Constraint;
  update_columns?: Array<Forecast_Reading_Update_Column>;
  where?: InputMaybe<Forecast_Reading_Bool_Exp>;
};

/** Ordering options when selecting data from "forecast_reading". */
export type Forecast_Reading_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_time?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  spray_decision?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weather_location?: InputMaybe<Weather_Location_Order_By>;
  weather_type?: InputMaybe<Order_By>;
  wind_direction?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** primary key columns input for table: forecast_reading */
export type Forecast_Reading_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "forecast_reading" */
export enum Forecast_Reading_Select_Column {
  /** column name */
  ApparentTemperature = 'apparent_temperature',
  /** column name */
  CloudCover = 'cloud_cover',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  DeltaT = 'delta_t',
  /** column name */
  DewPoint = 'dew_point',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MeltedSnowDepth = 'melted_snow_depth',
  /** column name */
  PrecipProb = 'precip_prob',
  /** column name */
  Precipitation = 'precipitation',
  /** column name */
  Pressure = 'pressure',
  /** column name */
  Provider = 'provider',
  /** column name */
  RelativeHumidity = 'relative_humidity',
  /** column name */
  SnowDepth = 'snow_depth',
  /** column name */
  SolarRadiation = 'solar_radiation',
  /** column name */
  SprayDecision = 'spray_decision',
  /** column name */
  Temperature = 'temperature',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeatherType = 'weather_type',
  /** column name */
  WindDirection = 'wind_direction',
  /** column name */
  WindDirectionDeg = 'wind_direction_deg',
  /** column name */
  WindSpeed = 'wind_speed'
}

/** input type for updating data in table "forecast_reading" */
export type Forecast_Reading_Set_Input = {
  apparent_temperature?: InputMaybe<Scalars['float8']>;
  cloud_cover?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_time?: InputMaybe<Scalars['timestamptz']>;
  delta_t?: InputMaybe<Scalars['float8']>;
  dew_point?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  melted_snow_depth?: InputMaybe<Scalars['float8']>;
  precip_prob?: InputMaybe<Scalars['float8']>;
  precipitation?: InputMaybe<Scalars['float8']>;
  pressure?: InputMaybe<Scalars['float8']>;
  provider?: InputMaybe<Scalars['String']>;
  relative_humidity?: InputMaybe<Scalars['float8']>;
  snow_depth?: InputMaybe<Scalars['float8']>;
  solar_radiation?: InputMaybe<Scalars['float8']>;
  spray_decision?: InputMaybe<Scalars['Boolean']>;
  temperature?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weather_type?: InputMaybe<Scalars['String']>;
  wind_direction?: InputMaybe<Scalars['String']>;
  wind_direction_deg?: InputMaybe<Scalars['float8']>;
  wind_speed?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Forecast_Reading_Stddev_Fields = {
  __typename?: 'forecast_reading_stddev_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "forecast_reading" */
export type Forecast_Reading_Stddev_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Forecast_Reading_Stddev_Pop_Fields = {
  __typename?: 'forecast_reading_stddev_pop_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "forecast_reading" */
export type Forecast_Reading_Stddev_Pop_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Forecast_Reading_Stddev_Samp_Fields = {
  __typename?: 'forecast_reading_stddev_samp_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "forecast_reading" */
export type Forecast_Reading_Stddev_Samp_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "forecast_reading" */
export type Forecast_Reading_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Forecast_Reading_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Forecast_Reading_Stream_Cursor_Value_Input = {
  apparent_temperature?: InputMaybe<Scalars['float8']>;
  cloud_cover?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_time?: InputMaybe<Scalars['timestamptz']>;
  delta_t?: InputMaybe<Scalars['float8']>;
  dew_point?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  melted_snow_depth?: InputMaybe<Scalars['float8']>;
  precip_prob?: InputMaybe<Scalars['float8']>;
  precipitation?: InputMaybe<Scalars['float8']>;
  pressure?: InputMaybe<Scalars['float8']>;
  provider?: InputMaybe<Scalars['String']>;
  relative_humidity?: InputMaybe<Scalars['float8']>;
  snow_depth?: InputMaybe<Scalars['float8']>;
  solar_radiation?: InputMaybe<Scalars['float8']>;
  spray_decision?: InputMaybe<Scalars['Boolean']>;
  temperature?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weather_type?: InputMaybe<Scalars['String']>;
  wind_direction?: InputMaybe<Scalars['String']>;
  wind_direction_deg?: InputMaybe<Scalars['float8']>;
  wind_speed?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Forecast_Reading_Sum_Fields = {
  __typename?: 'forecast_reading_sum_fields';
  apparent_temperature?: Maybe<Scalars['float8']>;
  cloud_cover?: Maybe<Scalars['float8']>;
  delta_t?: Maybe<Scalars['float8']>;
  dew_point?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  melted_snow_depth?: Maybe<Scalars['float8']>;
  precip_prob?: Maybe<Scalars['float8']>;
  precipitation?: Maybe<Scalars['float8']>;
  pressure?: Maybe<Scalars['float8']>;
  relative_humidity?: Maybe<Scalars['float8']>;
  snow_depth?: Maybe<Scalars['float8']>;
  solar_radiation?: Maybe<Scalars['float8']>;
  temperature?: Maybe<Scalars['float8']>;
  wind_direction_deg?: Maybe<Scalars['float8']>;
  wind_speed?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "forecast_reading" */
export type Forecast_Reading_Sum_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** update columns of table "forecast_reading" */
export enum Forecast_Reading_Update_Column {
  /** column name */
  ApparentTemperature = 'apparent_temperature',
  /** column name */
  CloudCover = 'cloud_cover',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  DeltaT = 'delta_t',
  /** column name */
  DewPoint = 'dew_point',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MeltedSnowDepth = 'melted_snow_depth',
  /** column name */
  PrecipProb = 'precip_prob',
  /** column name */
  Precipitation = 'precipitation',
  /** column name */
  Pressure = 'pressure',
  /** column name */
  Provider = 'provider',
  /** column name */
  RelativeHumidity = 'relative_humidity',
  /** column name */
  SnowDepth = 'snow_depth',
  /** column name */
  SolarRadiation = 'solar_radiation',
  /** column name */
  SprayDecision = 'spray_decision',
  /** column name */
  Temperature = 'temperature',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeatherType = 'weather_type',
  /** column name */
  WindDirection = 'wind_direction',
  /** column name */
  WindDirectionDeg = 'wind_direction_deg',
  /** column name */
  WindSpeed = 'wind_speed'
}

export type Forecast_Reading_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Forecast_Reading_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Forecast_Reading_Set_Input>;
  where: Forecast_Reading_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Forecast_Reading_Var_Pop_Fields = {
  __typename?: 'forecast_reading_var_pop_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "forecast_reading" */
export type Forecast_Reading_Var_Pop_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Forecast_Reading_Var_Samp_Fields = {
  __typename?: 'forecast_reading_var_samp_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "forecast_reading" */
export type Forecast_Reading_Var_Samp_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Forecast_Reading_Variance_Fields = {
  __typename?: 'forecast_reading_variance_fields';
  apparent_temperature?: Maybe<Scalars['Float']>;
  cloud_cover?: Maybe<Scalars['Float']>;
  delta_t?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  melted_snow_depth?: Maybe<Scalars['Float']>;
  precip_prob?: Maybe<Scalars['Float']>;
  precipitation?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  relative_humidity?: Maybe<Scalars['Float']>;
  snow_depth?: Maybe<Scalars['Float']>;
  solar_radiation?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  wind_direction_deg?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "forecast_reading" */
export type Forecast_Reading_Variance_Order_By = {
  apparent_temperature?: InputMaybe<Order_By>;
  cloud_cover?: InputMaybe<Order_By>;
  delta_t?: InputMaybe<Order_By>;
  dew_point?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  melted_snow_depth?: InputMaybe<Order_By>;
  precip_prob?: InputMaybe<Order_By>;
  precipitation?: InputMaybe<Order_By>;
  pressure?: InputMaybe<Order_By>;
  relative_humidity?: InputMaybe<Order_By>;
  snow_depth?: InputMaybe<Order_By>;
  solar_radiation?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  wind_direction_deg?: InputMaybe<Order_By>;
  wind_speed?: InputMaybe<Order_By>;
};

/** columns and relationships of "gateway" */
export type Gateway = {
  __typename?: 'gateway';
  activity_status: Scalars['String'];
  data_start_date: Scalars['date'];
  description?: Maybe<Scalars['String']>;
  frequency: Scalars['String'];
  /** An object relationship */
  gateway_status?: Maybe<Gateway_Status>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_public: Scalars['Boolean'];
  last_updated?: Maybe<Scalars['timestamptz']>;
  location_id: Scalars['uuid'];
  make_model?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  provider: Scalars['String'];
  provider_reference: Scalars['String'];
  /** An object relationship */
  weather_location: Weather_Location;
};

/** aggregated selection of "gateway" */
export type Gateway_Aggregate = {
  __typename?: 'gateway_aggregate';
  aggregate?: Maybe<Gateway_Aggregate_Fields>;
  nodes: Array<Gateway>;
};

/** aggregate fields of "gateway" */
export type Gateway_Aggregate_Fields = {
  __typename?: 'gateway_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Gateway_Max_Fields>;
  min?: Maybe<Gateway_Min_Fields>;
};


/** aggregate fields of "gateway" */
export type Gateway_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gateway_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gateway" */
export type Gateway_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gateway_Max_Order_By>;
  min?: InputMaybe<Gateway_Min_Order_By>;
};

/** input type for inserting array relation for remote table "gateway" */
export type Gateway_Arr_Rel_Insert_Input = {
  data: Array<Gateway_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gateway_On_Conflict>;
};

/** Boolean expression to filter rows from the table "gateway". All fields are combined with a logical 'AND'. */
export type Gateway_Bool_Exp = {
  _and?: InputMaybe<Array<Gateway_Bool_Exp>>;
  _not?: InputMaybe<Gateway_Bool_Exp>;
  _or?: InputMaybe<Array<Gateway_Bool_Exp>>;
  activity_status?: InputMaybe<String_Comparison_Exp>;
  data_start_date?: InputMaybe<Date_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  gateway_status?: InputMaybe<Gateway_Status_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_public?: InputMaybe<Boolean_Comparison_Exp>;
  last_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  make_model?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  provider_reference?: InputMaybe<String_Comparison_Exp>;
  weather_location?: InputMaybe<Weather_Location_Bool_Exp>;
};

/** columns and relationships of "gateway_configuration" */
export type Gateway_Configuration = {
  __typename?: 'gateway_configuration';
  /** An object relationship */
  gateway: Gateway;
  gateway_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  key: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "gateway_configuration" */
export type Gateway_Configuration_Aggregate = {
  __typename?: 'gateway_configuration_aggregate';
  aggregate?: Maybe<Gateway_Configuration_Aggregate_Fields>;
  nodes: Array<Gateway_Configuration>;
};

/** aggregate fields of "gateway_configuration" */
export type Gateway_Configuration_Aggregate_Fields = {
  __typename?: 'gateway_configuration_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Gateway_Configuration_Max_Fields>;
  min?: Maybe<Gateway_Configuration_Min_Fields>;
};


/** aggregate fields of "gateway_configuration" */
export type Gateway_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gateway_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "gateway_configuration". All fields are combined with a logical 'AND'. */
export type Gateway_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Gateway_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Gateway_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Gateway_Configuration_Bool_Exp>>;
  gateway?: InputMaybe<Gateway_Bool_Exp>;
  gateway_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gateway_configuration" */
export enum Gateway_Configuration_Constraint {
  /** unique or primary key constraint on columns "key", "gateway_id" */
  GatewayConfigurationGatewayIdKey_46e0eb38Uniq = 'gateway_configuration_gateway_id_key_46e0eb38_uniq',
  /** unique or primary key constraint on columns "id" */
  GatewayConfigurationPkey = 'gateway_configuration_pkey'
}

/** input type for inserting data into table "gateway_configuration" */
export type Gateway_Configuration_Insert_Input = {
  gateway?: InputMaybe<Gateway_Obj_Rel_Insert_Input>;
  gateway_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Gateway_Configuration_Max_Fields = {
  __typename?: 'gateway_configuration_max_fields';
  gateway_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Gateway_Configuration_Min_Fields = {
  __typename?: 'gateway_configuration_min_fields';
  gateway_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "gateway_configuration" */
export type Gateway_Configuration_Mutation_Response = {
  __typename?: 'gateway_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gateway_Configuration>;
};

/** on_conflict condition type for table "gateway_configuration" */
export type Gateway_Configuration_On_Conflict = {
  constraint: Gateway_Configuration_Constraint;
  update_columns?: Array<Gateway_Configuration_Update_Column>;
  where?: InputMaybe<Gateway_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "gateway_configuration". */
export type Gateway_Configuration_Order_By = {
  gateway?: InputMaybe<Gateway_Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gateway_configuration */
export type Gateway_Configuration_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "gateway_configuration" */
export enum Gateway_Configuration_Select_Column {
  /** column name */
  GatewayId = 'gateway_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "gateway_configuration" */
export type Gateway_Configuration_Set_Input = {
  gateway_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "gateway_configuration" */
export type Gateway_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gateway_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gateway_Configuration_Stream_Cursor_Value_Input = {
  gateway_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "gateway_configuration" */
export enum Gateway_Configuration_Update_Column {
  /** column name */
  GatewayId = 'gateway_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

export type Gateway_Configuration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gateway_Configuration_Set_Input>;
  where: Gateway_Configuration_Bool_Exp;
};

/** unique or primary key constraints on table "gateway" */
export enum Gateway_Constraint {
  /** unique or primary key constraint on columns "name", "provider", "location_id", "provider_reference" */
  GatewayNameProviderLocationI_60a01976Uniq = 'gateway_name_provider_location_i_60a01976_uniq',
  /** unique or primary key constraint on columns "id" */
  GatewayPkey = 'gateway_pkey'
}

/** input type for inserting data into table "gateway" */
export type Gateway_Insert_Input = {
  activity_status?: InputMaybe<Scalars['String']>;
  data_start_date?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  gateway_status?: InputMaybe<Gateway_Status_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  last_updated?: InputMaybe<Scalars['timestamptz']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  make_model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_reference?: InputMaybe<Scalars['String']>;
  weather_location?: InputMaybe<Weather_Location_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Gateway_Max_Fields = {
  __typename?: 'gateway_max_fields';
  activity_status?: Maybe<Scalars['String']>;
  data_start_date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
  location_id?: Maybe<Scalars['uuid']>;
  make_model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_reference?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "gateway" */
export type Gateway_Max_Order_By = {
  activity_status?: InputMaybe<Order_By>;
  data_start_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  make_model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_reference?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gateway_Min_Fields = {
  __typename?: 'gateway_min_fields';
  activity_status?: Maybe<Scalars['String']>;
  data_start_date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
  location_id?: Maybe<Scalars['uuid']>;
  make_model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_reference?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "gateway" */
export type Gateway_Min_Order_By = {
  activity_status?: InputMaybe<Order_By>;
  data_start_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  make_model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_reference?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gateway" */
export type Gateway_Mutation_Response = {
  __typename?: 'gateway_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gateway>;
};

/** input type for inserting object relation for remote table "gateway" */
export type Gateway_Obj_Rel_Insert_Input = {
  data: Gateway_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gateway_On_Conflict>;
};

/** on_conflict condition type for table "gateway" */
export type Gateway_On_Conflict = {
  constraint: Gateway_Constraint;
  update_columns?: Array<Gateway_Update_Column>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};

/** Ordering options when selecting data from "gateway". */
export type Gateway_Order_By = {
  activity_status?: InputMaybe<Order_By>;
  data_start_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  gateway_status?: InputMaybe<Gateway_Status_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_public?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  make_model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_reference?: InputMaybe<Order_By>;
  weather_location?: InputMaybe<Weather_Location_Order_By>;
};

/** primary key columns input for table: gateway */
export type Gateway_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "gateway" */
export enum Gateway_Select_Column {
  /** column name */
  ActivityStatus = 'activity_status',
  /** column name */
  DataStartDate = 'data_start_date',
  /** column name */
  Description = 'description',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MakeModel = 'make_model',
  /** column name */
  Name = 'name',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderReference = 'provider_reference'
}

/** input type for updating data in table "gateway" */
export type Gateway_Set_Input = {
  activity_status?: InputMaybe<Scalars['String']>;
  data_start_date?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  last_updated?: InputMaybe<Scalars['timestamptz']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  make_model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_reference?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "gateway_status" */
export type Gateway_Status = {
  __typename?: 'gateway_status';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  gateway: Gateway;
  gateway_id: Scalars['uuid'];
  id: Scalars['bigint'];
  missing_parameters?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "gateway_status" */
export type Gateway_Status_Aggregate = {
  __typename?: 'gateway_status_aggregate';
  aggregate?: Maybe<Gateway_Status_Aggregate_Fields>;
  nodes: Array<Gateway_Status>;
};

/** aggregate fields of "gateway_status" */
export type Gateway_Status_Aggregate_Fields = {
  __typename?: 'gateway_status_aggregate_fields';
  avg?: Maybe<Gateway_Status_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Gateway_Status_Max_Fields>;
  min?: Maybe<Gateway_Status_Min_Fields>;
  stddev?: Maybe<Gateway_Status_Stddev_Fields>;
  stddev_pop?: Maybe<Gateway_Status_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gateway_Status_Stddev_Samp_Fields>;
  sum?: Maybe<Gateway_Status_Sum_Fields>;
  var_pop?: Maybe<Gateway_Status_Var_Pop_Fields>;
  var_samp?: Maybe<Gateway_Status_Var_Samp_Fields>;
  variance?: Maybe<Gateway_Status_Variance_Fields>;
};


/** aggregate fields of "gateway_status" */
export type Gateway_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gateway_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Gateway_Status_Avg_Fields = {
  __typename?: 'gateway_status_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "gateway_status". All fields are combined with a logical 'AND'. */
export type Gateway_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Gateway_Status_Bool_Exp>>;
  _not?: InputMaybe<Gateway_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Gateway_Status_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  gateway?: InputMaybe<Gateway_Bool_Exp>;
  gateway_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  missing_parameters?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gateway_status" */
export enum Gateway_Status_Constraint {
  /** unique or primary key constraint on columns "gateway_id" */
  GatewayStatusGatewayIdKey = 'gateway_status_gateway_id_key',
  /** unique or primary key constraint on columns "id" */
  GatewayStatusPkey = 'gateway_status_pkey'
}

/** input type for incrementing numeric columns in table "gateway_status" */
export type Gateway_Status_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "gateway_status" */
export type Gateway_Status_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  gateway?: InputMaybe<Gateway_Obj_Rel_Insert_Input>;
  gateway_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  missing_parameters?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Gateway_Status_Max_Fields = {
  __typename?: 'gateway_status_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  gateway_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  missing_parameters?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Gateway_Status_Min_Fields = {
  __typename?: 'gateway_status_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  gateway_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  missing_parameters?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "gateway_status" */
export type Gateway_Status_Mutation_Response = {
  __typename?: 'gateway_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gateway_Status>;
};

/** input type for inserting object relation for remote table "gateway_status" */
export type Gateway_Status_Obj_Rel_Insert_Input = {
  data: Gateway_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gateway_Status_On_Conflict>;
};

/** on_conflict condition type for table "gateway_status" */
export type Gateway_Status_On_Conflict = {
  constraint: Gateway_Status_Constraint;
  update_columns?: Array<Gateway_Status_Update_Column>;
  where?: InputMaybe<Gateway_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "gateway_status". */
export type Gateway_Status_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  gateway?: InputMaybe<Gateway_Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  missing_parameters?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gateway_status */
export type Gateway_Status_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "gateway_status" */
export enum Gateway_Status_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  GatewayId = 'gateway_id',
  /** column name */
  Id = 'id',
  /** column name */
  MissingParameters = 'missing_parameters',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "gateway_status" */
export type Gateway_Status_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  gateway_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  missing_parameters?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Gateway_Status_Stddev_Fields = {
  __typename?: 'gateway_status_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Gateway_Status_Stddev_Pop_Fields = {
  __typename?: 'gateway_status_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Gateway_Status_Stddev_Samp_Fields = {
  __typename?: 'gateway_status_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "gateway_status" */
export type Gateway_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gateway_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gateway_Status_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  gateway_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  missing_parameters?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Gateway_Status_Sum_Fields = {
  __typename?: 'gateway_status_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "gateway_status" */
export enum Gateway_Status_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  GatewayId = 'gateway_id',
  /** column name */
  Id = 'id',
  /** column name */
  MissingParameters = 'missing_parameters',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Gateway_Status_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gateway_Status_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gateway_Status_Set_Input>;
  where: Gateway_Status_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Gateway_Status_Var_Pop_Fields = {
  __typename?: 'gateway_status_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Gateway_Status_Var_Samp_Fields = {
  __typename?: 'gateway_status_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Gateway_Status_Variance_Fields = {
  __typename?: 'gateway_status_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "gateway" */
export type Gateway_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gateway_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gateway_Stream_Cursor_Value_Input = {
  activity_status?: InputMaybe<Scalars['String']>;
  data_start_date?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  last_updated?: InputMaybe<Scalars['timestamptz']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  make_model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_reference?: InputMaybe<Scalars['String']>;
};

/** update columns of table "gateway" */
export enum Gateway_Update_Column {
  /** column name */
  ActivityStatus = 'activity_status',
  /** column name */
  DataStartDate = 'data_start_date',
  /** column name */
  Description = 'description',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MakeModel = 'make_model',
  /** column name */
  Name = 'name',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderReference = 'provider_reference'
}

export type Gateway_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gateway_Set_Input>;
  where: Gateway_Bool_Exp;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "grade_price" */
export type Grade_Price = {
  __typename?: 'grade_price';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  grade: Variety_Grade;
  grade_id: Scalars['Int'];
  id: Scalars['Int'];
  price: Scalars['numeric'];
  price_limit: Scalars['numeric'];
  /** An object relationship */
  price_unit: Sku;
  price_unit_id: Scalars['Int'];
  rejection: Scalars['numeric'];
  remark: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "grade_price" */
export type Grade_Price_Aggregate = {
  __typename?: 'grade_price_aggregate';
  aggregate?: Maybe<Grade_Price_Aggregate_Fields>;
  nodes: Array<Grade_Price>;
};

/** aggregate fields of "grade_price" */
export type Grade_Price_Aggregate_Fields = {
  __typename?: 'grade_price_aggregate_fields';
  avg?: Maybe<Grade_Price_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Grade_Price_Max_Fields>;
  min?: Maybe<Grade_Price_Min_Fields>;
  stddev?: Maybe<Grade_Price_Stddev_Fields>;
  stddev_pop?: Maybe<Grade_Price_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Grade_Price_Stddev_Samp_Fields>;
  sum?: Maybe<Grade_Price_Sum_Fields>;
  var_pop?: Maybe<Grade_Price_Var_Pop_Fields>;
  var_samp?: Maybe<Grade_Price_Var_Samp_Fields>;
  variance?: Maybe<Grade_Price_Variance_Fields>;
};


/** aggregate fields of "grade_price" */
export type Grade_Price_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grade_Price_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Grade_Price_Avg_Fields = {
  __typename?: 'grade_price_avg_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "grade_price". All fields are combined with a logical 'AND'. */
export type Grade_Price_Bool_Exp = {
  _and?: InputMaybe<Array<Grade_Price_Bool_Exp>>;
  _not?: InputMaybe<Grade_Price_Bool_Exp>;
  _or?: InputMaybe<Array<Grade_Price_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  grade?: InputMaybe<Variety_Grade_Bool_Exp>;
  grade_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  price_limit?: InputMaybe<Numeric_Comparison_Exp>;
  price_unit?: InputMaybe<Sku_Bool_Exp>;
  price_unit_id?: InputMaybe<Int_Comparison_Exp>;
  rejection?: InputMaybe<Numeric_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "grade_price" */
export enum Grade_Price_Constraint {
  /** unique or primary key constraint on columns "id" */
  GradePricePkey = 'grade_price_pkey'
}

/** input type for incrementing numeric columns in table "grade_price" */
export type Grade_Price_Inc_Input = {
  grade_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_limit?: InputMaybe<Scalars['numeric']>;
  price_unit_id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "grade_price" */
export type Grade_Price_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  grade?: InputMaybe<Variety_Grade_Obj_Rel_Insert_Input>;
  grade_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_limit?: InputMaybe<Scalars['numeric']>;
  price_unit?: InputMaybe<Sku_Obj_Rel_Insert_Input>;
  price_unit_id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Grade_Price_Max_Fields = {
  __typename?: 'grade_price_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  grade_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  price_limit?: Maybe<Scalars['numeric']>;
  price_unit_id?: Maybe<Scalars['Int']>;
  rejection?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Grade_Price_Min_Fields = {
  __typename?: 'grade_price_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  grade_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  price_limit?: Maybe<Scalars['numeric']>;
  price_unit_id?: Maybe<Scalars['Int']>;
  rejection?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "grade_price" */
export type Grade_Price_Mutation_Response = {
  __typename?: 'grade_price_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Grade_Price>;
};

/** on_conflict condition type for table "grade_price" */
export type Grade_Price_On_Conflict = {
  constraint: Grade_Price_Constraint;
  update_columns?: Array<Grade_Price_Update_Column>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};

/** Ordering options when selecting data from "grade_price". */
export type Grade_Price_Order_By = {
  created_at?: InputMaybe<Order_By>;
  grade?: InputMaybe<Variety_Grade_Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_limit?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Sku_Order_By>;
  price_unit_id?: InputMaybe<Order_By>;
  rejection?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grade_price */
export type Grade_Price_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "grade_price" */
export enum Grade_Price_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GradeId = 'grade_id',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceLimit = 'price_limit',
  /** column name */
  PriceUnitId = 'price_unit_id',
  /** column name */
  Rejection = 'rejection',
  /** column name */
  Remark = 'remark',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "grade_price" */
export type Grade_Price_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  grade_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_limit?: InputMaybe<Scalars['numeric']>;
  price_unit_id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Grade_Price_Stddev_Fields = {
  __typename?: 'grade_price_stddev_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Grade_Price_Stddev_Pop_Fields = {
  __typename?: 'grade_price_stddev_pop_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Grade_Price_Stddev_Samp_Fields = {
  __typename?: 'grade_price_stddev_samp_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "grade_price" */
export type Grade_Price_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grade_Price_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grade_Price_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  grade_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_limit?: InputMaybe<Scalars['numeric']>;
  price_unit_id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Grade_Price_Sum_Fields = {
  __typename?: 'grade_price_sum_fields';
  grade_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  price_limit?: Maybe<Scalars['numeric']>;
  price_unit_id?: Maybe<Scalars['Int']>;
  rejection?: Maybe<Scalars['numeric']>;
};

/** update columns of table "grade_price" */
export enum Grade_Price_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GradeId = 'grade_id',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceLimit = 'price_limit',
  /** column name */
  PriceUnitId = 'price_unit_id',
  /** column name */
  Rejection = 'rejection',
  /** column name */
  Remark = 'remark',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Grade_Price_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Grade_Price_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grade_Price_Set_Input>;
  where: Grade_Price_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Grade_Price_Var_Pop_Fields = {
  __typename?: 'grade_price_var_pop_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Grade_Price_Var_Samp_Fields = {
  __typename?: 'grade_price_var_samp_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Grade_Price_Variance_Fields = {
  __typename?: 'grade_price_variance_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "infestation" */
export type Infestation = {
  __typename?: 'infestation';
  category: Scalars['String'];
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  scientific_name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "infestation" */
export type Infestation_Aggregate = {
  __typename?: 'infestation_aggregate';
  aggregate?: Maybe<Infestation_Aggregate_Fields>;
  nodes: Array<Infestation>;
};

/** aggregate fields of "infestation" */
export type Infestation_Aggregate_Fields = {
  __typename?: 'infestation_aggregate_fields';
  avg?: Maybe<Infestation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Infestation_Max_Fields>;
  min?: Maybe<Infestation_Min_Fields>;
  stddev?: Maybe<Infestation_Stddev_Fields>;
  stddev_pop?: Maybe<Infestation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Infestation_Stddev_Samp_Fields>;
  sum?: Maybe<Infestation_Sum_Fields>;
  var_pop?: Maybe<Infestation_Var_Pop_Fields>;
  var_samp?: Maybe<Infestation_Var_Samp_Fields>;
  variance?: Maybe<Infestation_Variance_Fields>;
};


/** aggregate fields of "infestation" */
export type Infestation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Infestation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Infestation_Avg_Fields = {
  __typename?: 'infestation_avg_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "infestation". All fields are combined with a logical 'AND'. */
export type Infestation_Bool_Exp = {
  _and?: InputMaybe<Array<Infestation_Bool_Exp>>;
  _not?: InputMaybe<Infestation_Bool_Exp>;
  _or?: InputMaybe<Array<Infestation_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  scientific_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "infestation" */
export enum Infestation_Constraint {
  /** unique or primary key constraint on columns "codename" */
  InfestationCodenameKey = 'infestation_codename_key',
  /** unique or primary key constraint on columns "name", "category" */
  InfestationNameCategory_8ba9554bUniq = 'infestation_name_category_8ba9554b_uniq',
  /** unique or primary key constraint on columns "id" */
  InfestationPkey = 'infestation_pkey'
}

/** input type for incrementing numeric columns in table "infestation" */
export type Infestation_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "infestation" */
export type Infestation_Insert_Input = {
  category?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  scientific_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Infestation_Max_Fields = {
  __typename?: 'infestation_max_fields';
  category?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  scientific_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Infestation_Min_Fields = {
  __typename?: 'infestation_min_fields';
  category?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  scientific_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "infestation" */
export type Infestation_Mutation_Response = {
  __typename?: 'infestation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Infestation>;
};

/** input type for inserting object relation for remote table "infestation" */
export type Infestation_Obj_Rel_Insert_Input = {
  data: Infestation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Infestation_On_Conflict>;
};

/** on_conflict condition type for table "infestation" */
export type Infestation_On_Conflict = {
  constraint: Infestation_Constraint;
  update_columns?: Array<Infestation_Update_Column>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};

/** Ordering options when selecting data from "infestation". */
export type Infestation_Order_By = {
  category?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  scientific_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: infestation */
export type Infestation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "infestation" */
export enum Infestation_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  ScientificName = 'scientific_name'
}

/** input type for updating data in table "infestation" */
export type Infestation_Set_Input = {
  category?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  scientific_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Infestation_Stddev_Fields = {
  __typename?: 'infestation_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Infestation_Stddev_Pop_Fields = {
  __typename?: 'infestation_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Infestation_Stddev_Samp_Fields = {
  __typename?: 'infestation_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "infestation" */
export type Infestation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Infestation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Infestation_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  scientific_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Infestation_Sum_Fields = {
  __typename?: 'infestation_sum_fields';
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "infestation" */
export enum Infestation_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  ScientificName = 'scientific_name'
}

export type Infestation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Infestation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Infestation_Set_Input>;
  where: Infestation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Infestation_Var_Pop_Fields = {
  __typename?: 'infestation_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Infestation_Var_Samp_Fields = {
  __typename?: 'infestation_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Infestation_Variance_Fields = {
  __typename?: 'infestation_variance_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ingredient" */
export type Ingredient = {
  __typename?: 'ingredient';
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  short_name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "ingredient" */
export type Ingredient_Aggregate = {
  __typename?: 'ingredient_aggregate';
  aggregate?: Maybe<Ingredient_Aggregate_Fields>;
  nodes: Array<Ingredient>;
};

/** aggregate fields of "ingredient" */
export type Ingredient_Aggregate_Fields = {
  __typename?: 'ingredient_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ingredient_Max_Fields>;
  min?: Maybe<Ingredient_Min_Fields>;
};


/** aggregate fields of "ingredient" */
export type Ingredient_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ingredient_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ingredient". All fields are combined with a logical 'AND'. */
export type Ingredient_Bool_Exp = {
  _and?: InputMaybe<Array<Ingredient_Bool_Exp>>;
  _not?: InputMaybe<Ingredient_Bool_Exp>;
  _or?: InputMaybe<Array<Ingredient_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ingredient" */
export enum Ingredient_Constraint {
  /** unique or primary key constraint on columns "name", "type" */
  IngredientNameType_9ffd4333Uniq = 'ingredient_name_type_9ffd4333_uniq',
  /** unique or primary key constraint on columns "id" */
  IngredientPkey = 'ingredient_pkey'
}

/** input type for inserting data into table "ingredient" */
export type Ingredient_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ingredient_Max_Fields = {
  __typename?: 'ingredient_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ingredient_Min_Fields = {
  __typename?: 'ingredient_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ingredient" */
export type Ingredient_Mutation_Response = {
  __typename?: 'ingredient_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ingredient>;
};

/** input type for inserting object relation for remote table "ingredient" */
export type Ingredient_Obj_Rel_Insert_Input = {
  data: Ingredient_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ingredient_On_Conflict>;
};

/** on_conflict condition type for table "ingredient" */
export type Ingredient_On_Conflict = {
  constraint: Ingredient_Constraint;
  update_columns?: Array<Ingredient_Update_Column>;
  where?: InputMaybe<Ingredient_Bool_Exp>;
};

/** Ordering options when selecting data from "ingredient". */
export type Ingredient_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ingredient */
export type Ingredient_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ingredient" */
export enum Ingredient_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "ingredient" */
export type Ingredient_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ingredient" */
export type Ingredient_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ingredient_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ingredient_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ingredient" */
export enum Ingredient_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Type = 'type'
}

export type Ingredient_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ingredient_Set_Input>;
  where: Ingredient_Bool_Exp;
};

/** columns and relationships of "inst_sensor_reading" */
export type Inst_Sensor_Reading = {
  __typename?: 'inst_sensor_reading';
  created_at: Scalars['timestamptz'];
  date_time: Scalars['timestamptz'];
  id: Scalars['bigint'];
  location_id: Scalars['uuid'];
  /** An object relationship */
  sensor: Sensor;
  sensor_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  value?: Maybe<Scalars['float8']>;
  /** An object relationship */
  weather_location: Weather_Location;
};

/** aggregated selection of "inst_sensor_reading" */
export type Inst_Sensor_Reading_Aggregate = {
  __typename?: 'inst_sensor_reading_aggregate';
  aggregate?: Maybe<Inst_Sensor_Reading_Aggregate_Fields>;
  nodes: Array<Inst_Sensor_Reading>;
};

/** aggregate fields of "inst_sensor_reading" */
export type Inst_Sensor_Reading_Aggregate_Fields = {
  __typename?: 'inst_sensor_reading_aggregate_fields';
  avg?: Maybe<Inst_Sensor_Reading_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Inst_Sensor_Reading_Max_Fields>;
  min?: Maybe<Inst_Sensor_Reading_Min_Fields>;
  stddev?: Maybe<Inst_Sensor_Reading_Stddev_Fields>;
  stddev_pop?: Maybe<Inst_Sensor_Reading_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Inst_Sensor_Reading_Stddev_Samp_Fields>;
  sum?: Maybe<Inst_Sensor_Reading_Sum_Fields>;
  var_pop?: Maybe<Inst_Sensor_Reading_Var_Pop_Fields>;
  var_samp?: Maybe<Inst_Sensor_Reading_Var_Samp_Fields>;
  variance?: Maybe<Inst_Sensor_Reading_Variance_Fields>;
};


/** aggregate fields of "inst_sensor_reading" */
export type Inst_Sensor_Reading_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Inst_Sensor_Reading_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Aggregate_Order_By = {
  avg?: InputMaybe<Inst_Sensor_Reading_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Inst_Sensor_Reading_Max_Order_By>;
  min?: InputMaybe<Inst_Sensor_Reading_Min_Order_By>;
  stddev?: InputMaybe<Inst_Sensor_Reading_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Inst_Sensor_Reading_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Inst_Sensor_Reading_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Inst_Sensor_Reading_Sum_Order_By>;
  var_pop?: InputMaybe<Inst_Sensor_Reading_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Inst_Sensor_Reading_Var_Samp_Order_By>;
  variance?: InputMaybe<Inst_Sensor_Reading_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Arr_Rel_Insert_Input = {
  data: Array<Inst_Sensor_Reading_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Inst_Sensor_Reading_On_Conflict>;
};

/** aggregate avg on columns */
export type Inst_Sensor_Reading_Avg_Fields = {
  __typename?: 'inst_sensor_reading_avg_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "inst_sensor_reading". All fields are combined with a logical 'AND'. */
export type Inst_Sensor_Reading_Bool_Exp = {
  _and?: InputMaybe<Array<Inst_Sensor_Reading_Bool_Exp>>;
  _not?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
  _or?: InputMaybe<Array<Inst_Sensor_Reading_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  sensor?: InputMaybe<Sensor_Bool_Exp>;
  sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
  weather_location?: InputMaybe<Weather_Location_Bool_Exp>;
};

/** unique or primary key constraints on table "inst_sensor_reading" */
export enum Inst_Sensor_Reading_Constraint {
  /** unique or primary key constraint on columns "date_time", "location_id", "sensor_id" */
  InstSensorReadingDateTimeLocationIdSe_9f4a88a7Uniq = 'inst_sensor_reading_date_time_location_id_se_9f4a88a7_uniq',
  /** unique or primary key constraint on columns "id" */
  InstSensorReadingPkey = 'inst_sensor_reading_pkey'
}

/** input type for incrementing numeric columns in table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_time?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  sensor?: InputMaybe<Sensor_Obj_Rel_Insert_Input>;
  sensor_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
  weather_location?: InputMaybe<Weather_Location_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Inst_Sensor_Reading_Max_Fields = {
  __typename?: 'inst_sensor_reading_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  sensor_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Inst_Sensor_Reading_Min_Fields = {
  __typename?: 'inst_sensor_reading_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  date_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  sensor_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Mutation_Response = {
  __typename?: 'inst_sensor_reading_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Inst_Sensor_Reading>;
};

/** on_conflict condition type for table "inst_sensor_reading" */
export type Inst_Sensor_Reading_On_Conflict = {
  constraint: Inst_Sensor_Reading_Constraint;
  update_columns?: Array<Inst_Sensor_Reading_Update_Column>;
  where?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
};

/** Ordering options when selecting data from "inst_sensor_reading". */
export type Inst_Sensor_Reading_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  sensor?: InputMaybe<Sensor_Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  weather_location?: InputMaybe<Weather_Location_Order_By>;
};

/** primary key columns input for table: inst_sensor_reading */
export type Inst_Sensor_Reading_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "inst_sensor_reading" */
export enum Inst_Sensor_Reading_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_time?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  sensor_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Inst_Sensor_Reading_Stddev_Fields = {
  __typename?: 'inst_sensor_reading_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Inst_Sensor_Reading_Stddev_Pop_Fields = {
  __typename?: 'inst_sensor_reading_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Inst_Sensor_Reading_Stddev_Samp_Fields = {
  __typename?: 'inst_sensor_reading_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Inst_Sensor_Reading_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Inst_Sensor_Reading_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_time?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  sensor_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Inst_Sensor_Reading_Sum_Fields = {
  __typename?: 'inst_sensor_reading_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "inst_sensor_reading" */
export enum Inst_Sensor_Reading_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateTime = 'date_time',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Inst_Sensor_Reading_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Inst_Sensor_Reading_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Inst_Sensor_Reading_Set_Input>;
  where: Inst_Sensor_Reading_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Inst_Sensor_Reading_Var_Pop_Fields = {
  __typename?: 'inst_sensor_reading_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Inst_Sensor_Reading_Var_Samp_Fields = {
  __typename?: 'inst_sensor_reading_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Inst_Sensor_Reading_Variance_Fields = {
  __typename?: 'inst_sensor_reading_variance_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "inst_sensor_reading" */
export type Inst_Sensor_Reading_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "invoice" */
export type Invoice = {
  __typename?: 'invoice';
  /** An object relationship */
  buyer?: Maybe<Setu_Trade_Shared_Entity>;
  buyer_expense_amount?: Maybe<Scalars['numeric']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  current_status_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  id: Scalars['bigint'];
  standard_deduction?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code: Scalars['String'];
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "invoice" */
export type InvoiceTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};

/** aggregated selection of "invoice" */
export type Invoice_Aggregate = {
  __typename?: 'invoice_aggregate';
  aggregate?: Maybe<Invoice_Aggregate_Fields>;
  nodes: Array<Invoice>;
};

/** aggregate fields of "invoice" */
export type Invoice_Aggregate_Fields = {
  __typename?: 'invoice_aggregate_fields';
  avg?: Maybe<Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invoice_Max_Fields>;
  min?: Maybe<Invoice_Min_Fields>;
  stddev?: Maybe<Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Sum_Fields>;
  var_pop?: Maybe<Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Variance_Fields>;
};


/** aggregate fields of "invoice" */
export type Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Invoice_Avg_Fields = {
  __typename?: 'invoice_avg_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "invoice". All fields are combined with a logical 'AND'. */
export type Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Bool_Exp>>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  buyer_expense_amount?: InputMaybe<Numeric_Comparison_Exp>;
  buyer_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_payable_amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  current_status_id?: InputMaybe<String_Comparison_Exp>;
  deducted_amount?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  expense_amount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  standard_deduction?: InputMaybe<Numeric_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  tracking_code?: InputMaybe<String_Comparison_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Invoice_Max_Fields = {
  __typename?: 'invoice_max_fields';
  buyer_expense_amount?: Maybe<Scalars['numeric']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  current_status_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Invoice_Min_Fields = {
  __typename?: 'invoice_min_fields';
  buyer_expense_amount?: Maybe<Scalars['numeric']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  current_status_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "invoice" */
export type Invoice_Mutation_Response = {
  __typename?: 'invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice>;
};

/** Ordering options when selecting data from "invoice". */
export type Invoice_Order_By = {
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  current_status_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoice */
export type Invoice_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "invoice" */
export enum Invoice_Select_Column {
  /** column name */
  BuyerExpenseAmount = 'buyer_expense_amount',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  BuyerPayableAmount = 'buyer_payable_amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CurrentStatusId = 'current_status_id',
  /** column name */
  DeductedAmount = 'deducted_amount',
  /** column name */
  DeductedQuantity = 'deducted_quantity',
  /** column name */
  ExpenseAmount = 'expense_amount',
  /** column name */
  Id = 'id',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalQuantity = 'total_quantity',
  /** column name */
  TrackingCode = 'tracking_code',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "invoice" */
export type Invoice_Set_Input = {
  current_status_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Invoice_Stddev_Fields = {
  __typename?: 'invoice_stddev_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Stddev_Pop_Fields = {
  __typename?: 'invoice_stddev_pop_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Stddev_Samp_Fields = {
  __typename?: 'invoice_stddev_samp_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "invoice" */
export type Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Stream_Cursor_Value_Input = {
  buyer_expense_amount?: InputMaybe<Scalars['numeric']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_payable_amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  current_status_id?: InputMaybe<Scalars['String']>;
  deducted_amount?: InputMaybe<Scalars['numeric']>;
  deducted_quantity?: InputMaybe<Scalars['numeric']>;
  expense_amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_quantity?: InputMaybe<Scalars['numeric']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Invoice_Sum_Fields = {
  __typename?: 'invoice_sum_fields';
  buyer_expense_amount?: Maybe<Scalars['numeric']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
};

export type Invoice_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Set_Input>;
  where: Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoice_Var_Pop_Fields = {
  __typename?: 'invoice_var_pop_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Invoice_Var_Samp_Fields = {
  __typename?: 'invoice_var_samp_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Invoice_Variance_Fields = {
  __typename?: 'invoice_variance_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "irrigation_system" */
export type Irrigation_System = {
  __typename?: 'irrigation_system';
  application_efficiency: Scalars['float8'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  drip_irrigation_system?: Maybe<Drip_Irrigation_System>;
  /** An object relationship */
  flood_irrigation_system?: Maybe<Flood_Irrigation_System>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  plot_id: Scalars['String'];
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  sprinkler_irrigation_system?: Maybe<Sprinkler_Irrigation_System>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
};

/** aggregated selection of "irrigation_system" */
export type Irrigation_System_Aggregate = {
  __typename?: 'irrigation_system_aggregate';
  aggregate?: Maybe<Irrigation_System_Aggregate_Fields>;
  nodes: Array<Irrigation_System>;
};

/** aggregate fields of "irrigation_system" */
export type Irrigation_System_Aggregate_Fields = {
  __typename?: 'irrigation_system_aggregate_fields';
  avg?: Maybe<Irrigation_System_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Irrigation_System_Max_Fields>;
  min?: Maybe<Irrigation_System_Min_Fields>;
  stddev?: Maybe<Irrigation_System_Stddev_Fields>;
  stddev_pop?: Maybe<Irrigation_System_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Irrigation_System_Stddev_Samp_Fields>;
  sum?: Maybe<Irrigation_System_Sum_Fields>;
  var_pop?: Maybe<Irrigation_System_Var_Pop_Fields>;
  var_samp?: Maybe<Irrigation_System_Var_Samp_Fields>;
  variance?: Maybe<Irrigation_System_Variance_Fields>;
};


/** aggregate fields of "irrigation_system" */
export type Irrigation_System_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Irrigation_System_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Irrigation_System_Avg_Fields = {
  __typename?: 'irrigation_system_avg_fields';
  application_efficiency?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "irrigation_system". All fields are combined with a logical 'AND'. */
export type Irrigation_System_Bool_Exp = {
  _and?: InputMaybe<Array<Irrigation_System_Bool_Exp>>;
  _not?: InputMaybe<Irrigation_System_Bool_Exp>;
  _or?: InputMaybe<Array<Irrigation_System_Bool_Exp>>;
  application_efficiency?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  drip_irrigation_system?: InputMaybe<Drip_Irrigation_System_Bool_Exp>;
  flood_irrigation_system?: InputMaybe<Flood_Irrigation_System_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  plot_id?: InputMaybe<String_Comparison_Exp>;
  polymorphic_ctype_id?: InputMaybe<Int_Comparison_Exp>;
  sprinkler_irrigation_system?: InputMaybe<Sprinkler_Irrigation_System_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "irrigation_system" */
export enum Irrigation_System_Constraint {
  /** unique or primary key constraint on columns "id" */
  IrrigationSystemPkey = 'irrigation_system_pkey'
}

/** input type for incrementing numeric columns in table "irrigation_system" */
export type Irrigation_System_Inc_Input = {
  application_efficiency?: InputMaybe<Scalars['float8']>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "irrigation_system" */
export type Irrigation_System_Insert_Input = {
  application_efficiency?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  drip_irrigation_system?: InputMaybe<Drip_Irrigation_System_Obj_Rel_Insert_Input>;
  flood_irrigation_system?: InputMaybe<Flood_Irrigation_System_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_id?: InputMaybe<Scalars['String']>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  sprinkler_irrigation_system?: InputMaybe<Sprinkler_Irrigation_System_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Irrigation_System_Max_Fields = {
  __typename?: 'irrigation_system_max_fields';
  application_efficiency?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  plot_id?: Maybe<Scalars['String']>;
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Irrigation_System_Min_Fields = {
  __typename?: 'irrigation_system_min_fields';
  application_efficiency?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  plot_id?: Maybe<Scalars['String']>;
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "irrigation_system" */
export type Irrigation_System_Mutation_Response = {
  __typename?: 'irrigation_system_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Irrigation_System>;
};

/** input type for inserting object relation for remote table "irrigation_system" */
export type Irrigation_System_Obj_Rel_Insert_Input = {
  data: Irrigation_System_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Irrigation_System_On_Conflict>;
};

/** on_conflict condition type for table "irrigation_system" */
export type Irrigation_System_On_Conflict = {
  constraint: Irrigation_System_Constraint;
  update_columns?: Array<Irrigation_System_Update_Column>;
  where?: InputMaybe<Irrigation_System_Bool_Exp>;
};

/** Ordering options when selecting data from "irrigation_system". */
export type Irrigation_System_Order_By = {
  application_efficiency?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  drip_irrigation_system?: InputMaybe<Drip_Irrigation_System_Order_By>;
  flood_irrigation_system?: InputMaybe<Flood_Irrigation_System_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  sprinkler_irrigation_system?: InputMaybe<Sprinkler_Irrigation_System_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: irrigation_system */
export type Irrigation_System_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "irrigation_system" */
export enum Irrigation_System_Select_Column {
  /** column name */
  ApplicationEfficiency = 'application_efficiency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  PolymorphicCtypeId = 'polymorphic_ctype_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "irrigation_system" */
export type Irrigation_System_Set_Input = {
  application_efficiency?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_id?: InputMaybe<Scalars['String']>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Irrigation_System_Stddev_Fields = {
  __typename?: 'irrigation_system_stddev_fields';
  application_efficiency?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Irrigation_System_Stddev_Pop_Fields = {
  __typename?: 'irrigation_system_stddev_pop_fields';
  application_efficiency?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Irrigation_System_Stddev_Samp_Fields = {
  __typename?: 'irrigation_system_stddev_samp_fields';
  application_efficiency?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "irrigation_system" */
export type Irrigation_System_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Irrigation_System_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Irrigation_System_Stream_Cursor_Value_Input = {
  application_efficiency?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_id?: InputMaybe<Scalars['String']>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Irrigation_System_Sum_Fields = {
  __typename?: 'irrigation_system_sum_fields';
  application_efficiency?: Maybe<Scalars['float8']>;
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "irrigation_system" */
export enum Irrigation_System_Update_Column {
  /** column name */
  ApplicationEfficiency = 'application_efficiency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  PolymorphicCtypeId = 'polymorphic_ctype_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Irrigation_System_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Irrigation_System_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Irrigation_System_Set_Input>;
  where: Irrigation_System_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Irrigation_System_Var_Pop_Fields = {
  __typename?: 'irrigation_system_var_pop_fields';
  application_efficiency?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Irrigation_System_Var_Samp_Fields = {
  __typename?: 'irrigation_system_var_samp_fields';
  application_efficiency?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Irrigation_System_Variance_Fields = {
  __typename?: 'irrigation_system_variance_fields';
  application_efficiency?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "location_subscription" */
export type Location_Subscription = {
  __typename?: 'location_subscription';
  data_last_updated?: Maybe<Scalars['timestamptz']>;
  end_date: Scalars['date'];
  historic_data: Scalars['Boolean'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  location_id: Scalars['uuid'];
  service: Scalars['String'];
  start_date: Scalars['date'];
  /** An object relationship */
  weather_location: Weather_Location;
};

/** aggregated selection of "location_subscription" */
export type Location_Subscription_Aggregate = {
  __typename?: 'location_subscription_aggregate';
  aggregate?: Maybe<Location_Subscription_Aggregate_Fields>;
  nodes: Array<Location_Subscription>;
};

/** aggregate fields of "location_subscription" */
export type Location_Subscription_Aggregate_Fields = {
  __typename?: 'location_subscription_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Location_Subscription_Max_Fields>;
  min?: Maybe<Location_Subscription_Min_Fields>;
};


/** aggregate fields of "location_subscription" */
export type Location_Subscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Location_Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "location_subscription" */
export type Location_Subscription_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Location_Subscription_Max_Order_By>;
  min?: InputMaybe<Location_Subscription_Min_Order_By>;
};

/** input type for inserting array relation for remote table "location_subscription" */
export type Location_Subscription_Arr_Rel_Insert_Input = {
  data: Array<Location_Subscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_Subscription_On_Conflict>;
};

/** Boolean expression to filter rows from the table "location_subscription". All fields are combined with a logical 'AND'. */
export type Location_Subscription_Bool_Exp = {
  _and?: InputMaybe<Array<Location_Subscription_Bool_Exp>>;
  _not?: InputMaybe<Location_Subscription_Bool_Exp>;
  _or?: InputMaybe<Array<Location_Subscription_Bool_Exp>>;
  data_last_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  historic_data?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  service?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  weather_location?: InputMaybe<Weather_Location_Bool_Exp>;
};

/** unique or primary key constraints on table "location_subscription" */
export enum Location_Subscription_Constraint {
  /** unique or primary key constraint on columns "service", "location_id" */
  LocationSubscriptionLocationIdService_9605bde6Uniq = 'location_subscription_location_id_service_9605bde6_uniq',
  /** unique or primary key constraint on columns "id" */
  LocationSubscriptionPkey = 'location_subscription_pkey'
}

/** input type for inserting data into table "location_subscription" */
export type Location_Subscription_Insert_Input = {
  data_last_updated?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  historic_data?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  service?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  weather_location?: InputMaybe<Weather_Location_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Location_Subscription_Max_Fields = {
  __typename?: 'location_subscription_max_fields';
  data_last_updated?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  service?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "location_subscription" */
export type Location_Subscription_Max_Order_By = {
  data_last_updated?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Location_Subscription_Min_Fields = {
  __typename?: 'location_subscription_min_fields';
  data_last_updated?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  service?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "location_subscription" */
export type Location_Subscription_Min_Order_By = {
  data_last_updated?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "location_subscription" */
export type Location_Subscription_Mutation_Response = {
  __typename?: 'location_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Location_Subscription>;
};

/** on_conflict condition type for table "location_subscription" */
export type Location_Subscription_On_Conflict = {
  constraint: Location_Subscription_Constraint;
  update_columns?: Array<Location_Subscription_Update_Column>;
  where?: InputMaybe<Location_Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "location_subscription". */
export type Location_Subscription_Order_By = {
  data_last_updated?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  historic_data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  weather_location?: InputMaybe<Weather_Location_Order_By>;
};

/** primary key columns input for table: location_subscription */
export type Location_Subscription_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "location_subscription" */
export enum Location_Subscription_Select_Column {
  /** column name */
  DataLastUpdated = 'data_last_updated',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  HistoricData = 'historic_data',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Service = 'service',
  /** column name */
  StartDate = 'start_date'
}

/** input type for updating data in table "location_subscription" */
export type Location_Subscription_Set_Input = {
  data_last_updated?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  historic_data?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  service?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
};

/** Streaming cursor of the table "location_subscription" */
export type Location_Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Location_Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Location_Subscription_Stream_Cursor_Value_Input = {
  data_last_updated?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  historic_data?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  service?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
};

/** update columns of table "location_subscription" */
export enum Location_Subscription_Update_Column {
  /** column name */
  DataLastUpdated = 'data_last_updated',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  HistoricData = 'historic_data',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Service = 'service',
  /** column name */
  StartDate = 'start_date'
}

export type Location_Subscription_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Location_Subscription_Set_Input>;
  where: Location_Subscription_Bool_Exp;
};

/** columns and relationships of "main_section" */
export type Main_Section = {
  __typename?: 'main_section';
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  product_mainsections: Array<Product_Mainsection>;
  /** An aggregate relationship */
  product_mainsections_aggregate: Product_Mainsection_Aggregate;
};


/** columns and relationships of "main_section" */
export type Main_SectionProduct_MainsectionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Bool_Exp>;
};


/** columns and relationships of "main_section" */
export type Main_SectionProduct_Mainsections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Bool_Exp>;
};

/** aggregated selection of "main_section" */
export type Main_Section_Aggregate = {
  __typename?: 'main_section_aggregate';
  aggregate?: Maybe<Main_Section_Aggregate_Fields>;
  nodes: Array<Main_Section>;
};

/** aggregate fields of "main_section" */
export type Main_Section_Aggregate_Fields = {
  __typename?: 'main_section_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Main_Section_Max_Fields>;
  min?: Maybe<Main_Section_Min_Fields>;
};


/** aggregate fields of "main_section" */
export type Main_Section_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Main_Section_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "main_section". All fields are combined with a logical 'AND'. */
export type Main_Section_Bool_Exp = {
  _and?: InputMaybe<Array<Main_Section_Bool_Exp>>;
  _not?: InputMaybe<Main_Section_Bool_Exp>;
  _or?: InputMaybe<Array<Main_Section_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  product_mainsections?: InputMaybe<Product_Mainsection_Bool_Exp>;
};

/** unique or primary key constraints on table "main_section" */
export enum Main_Section_Constraint {
  /** unique or primary key constraint on columns "id" */
  MainSectionPkey = 'main_section_pkey'
}

/** input type for inserting data into table "main_section" */
export type Main_Section_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  product_mainsections?: InputMaybe<Product_Mainsection_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Main_Section_Max_Fields = {
  __typename?: 'main_section_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Main_Section_Min_Fields = {
  __typename?: 'main_section_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "main_section" */
export type Main_Section_Mutation_Response = {
  __typename?: 'main_section_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Main_Section>;
};

/** input type for inserting object relation for remote table "main_section" */
export type Main_Section_Obj_Rel_Insert_Input = {
  data: Main_Section_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Main_Section_On_Conflict>;
};

/** on_conflict condition type for table "main_section" */
export type Main_Section_On_Conflict = {
  constraint: Main_Section_Constraint;
  update_columns?: Array<Main_Section_Update_Column>;
  where?: InputMaybe<Main_Section_Bool_Exp>;
};

/** Ordering options when selecting data from "main_section". */
export type Main_Section_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_mainsections_aggregate?: InputMaybe<Product_Mainsection_Aggregate_Order_By>;
};

/** primary key columns input for table: main_section */
export type Main_Section_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "main_section" */
export enum Main_Section_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "main_section" */
export type Main_Section_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "main_section" */
export type Main_Section_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Main_Section_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Main_Section_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "main_section" */
export enum Main_Section_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Main_Section_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Main_Section_Set_Input>;
  where: Main_Section_Bool_Exp;
};

/** columns and relationships of "manufacturer" */
export type Manufacturer = {
  __typename?: 'manufacturer';
  /** An object relationship */
  advertisement?: Maybe<Common_Fileupload>;
  advertisement_id?: Maybe<Scalars['bigint']>;
  description: Scalars['String'];
  display_name: Scalars['String'];
  gst_number?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  logo?: Maybe<Common_Fileupload>;
  logo_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  manufacturing_facilities: Array<Manufacturing_Facility>;
  /** An aggregate relationship */
  manufacturing_facilities_aggregate: Manufacturing_Facility_Aggregate;
  name: Scalars['String'];
};


/** columns and relationships of "manufacturer" */
export type ManufacturerManufacturing_FacilitiesArgs = {
  distinct_on?: InputMaybe<Array<Manufacturing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturing_Facility_Order_By>>;
  where?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
};


/** columns and relationships of "manufacturer" */
export type ManufacturerManufacturing_Facilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturing_Facility_Order_By>>;
  where?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
};

/** aggregated selection of "manufacturer" */
export type Manufacturer_Aggregate = {
  __typename?: 'manufacturer_aggregate';
  aggregate?: Maybe<Manufacturer_Aggregate_Fields>;
  nodes: Array<Manufacturer>;
};

/** aggregate fields of "manufacturer" */
export type Manufacturer_Aggregate_Fields = {
  __typename?: 'manufacturer_aggregate_fields';
  avg?: Maybe<Manufacturer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Manufacturer_Max_Fields>;
  min?: Maybe<Manufacturer_Min_Fields>;
  stddev?: Maybe<Manufacturer_Stddev_Fields>;
  stddev_pop?: Maybe<Manufacturer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Manufacturer_Stddev_Samp_Fields>;
  sum?: Maybe<Manufacturer_Sum_Fields>;
  var_pop?: Maybe<Manufacturer_Var_Pop_Fields>;
  var_samp?: Maybe<Manufacturer_Var_Samp_Fields>;
  variance?: Maybe<Manufacturer_Variance_Fields>;
};


/** aggregate fields of "manufacturer" */
export type Manufacturer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Manufacturer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Manufacturer_Avg_Fields = {
  __typename?: 'manufacturer_avg_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "manufacturer". All fields are combined with a logical 'AND'. */
export type Manufacturer_Bool_Exp = {
  _and?: InputMaybe<Array<Manufacturer_Bool_Exp>>;
  _not?: InputMaybe<Manufacturer_Bool_Exp>;
  _or?: InputMaybe<Array<Manufacturer_Bool_Exp>>;
  advertisement?: InputMaybe<Common_Fileupload_Bool_Exp>;
  advertisement_id?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  gst_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  logo?: InputMaybe<Common_Fileupload_Bool_Exp>;
  logo_id?: InputMaybe<Bigint_Comparison_Exp>;
  manufacturing_facilities?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "manufacturer" */
export enum Manufacturer_Constraint {
  /** unique or primary key constraint on columns "display_name", "name" */
  ManufacturerNameDisplayName_590b177aUniq = 'manufacturer_name_display_name_590b177a_uniq',
  /** unique or primary key constraint on columns "id" */
  ManufacturerPkey = 'manufacturer_pkey'
}

/** input type for incrementing numeric columns in table "manufacturer" */
export type Manufacturer_Inc_Input = {
  advertisement_id?: InputMaybe<Scalars['bigint']>;
  logo_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "manufacturer" */
export type Manufacturer_Insert_Input = {
  advertisement?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  advertisement_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  gst_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  logo_id?: InputMaybe<Scalars['bigint']>;
  manufacturing_facilities?: InputMaybe<Manufacturing_Facility_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Manufacturer_Max_Fields = {
  __typename?: 'manufacturer_max_fields';
  advertisement_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  gst_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logo_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Manufacturer_Min_Fields = {
  __typename?: 'manufacturer_min_fields';
  advertisement_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  gst_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logo_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "manufacturer" */
export type Manufacturer_Mutation_Response = {
  __typename?: 'manufacturer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Manufacturer>;
};

/** input type for inserting object relation for remote table "manufacturer" */
export type Manufacturer_Obj_Rel_Insert_Input = {
  data: Manufacturer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Manufacturer_On_Conflict>;
};

/** on_conflict condition type for table "manufacturer" */
export type Manufacturer_On_Conflict = {
  constraint: Manufacturer_Constraint;
  update_columns?: Array<Manufacturer_Update_Column>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};

/** Ordering options when selecting data from "manufacturer". */
export type Manufacturer_Order_By = {
  advertisement?: InputMaybe<Common_Fileupload_Order_By>;
  advertisement_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  logo?: InputMaybe<Common_Fileupload_Order_By>;
  logo_id?: InputMaybe<Order_By>;
  manufacturing_facilities_aggregate?: InputMaybe<Manufacturing_Facility_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: manufacturer */
export type Manufacturer_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "manufacturer" */
export enum Manufacturer_Select_Column {
  /** column name */
  AdvertisementId = 'advertisement_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  GstNumber = 'gst_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "manufacturer" */
export type Manufacturer_Set_Input = {
  advertisement_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  gst_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  logo_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Manufacturer_Stddev_Fields = {
  __typename?: 'manufacturer_stddev_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Manufacturer_Stddev_Pop_Fields = {
  __typename?: 'manufacturer_stddev_pop_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Manufacturer_Stddev_Samp_Fields = {
  __typename?: 'manufacturer_stddev_samp_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "manufacturer" */
export type Manufacturer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Manufacturer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Manufacturer_Stream_Cursor_Value_Input = {
  advertisement_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  gst_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  logo_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Manufacturer_Sum_Fields = {
  __typename?: 'manufacturer_sum_fields';
  advertisement_id?: Maybe<Scalars['bigint']>;
  logo_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "manufacturer" */
export enum Manufacturer_Update_Column {
  /** column name */
  AdvertisementId = 'advertisement_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  GstNumber = 'gst_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  Name = 'name'
}

export type Manufacturer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Manufacturer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Manufacturer_Set_Input>;
  where: Manufacturer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Manufacturer_Var_Pop_Fields = {
  __typename?: 'manufacturer_var_pop_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Manufacturer_Var_Samp_Fields = {
  __typename?: 'manufacturer_var_samp_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Manufacturer_Variance_Fields = {
  __typename?: 'manufacturer_variance_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "manufacturing_facility" */
export type Manufacturing_Facility = {
  __typename?: 'manufacturing_facility';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['geometry']>;
  country?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  loc_desc?: Maybe<Scalars['String']>;
  /** An object relationship */
  manufacturer: Manufacturer;
  manufacturer_id: Scalars['uuid'];
  name: Scalars['String'];
  post_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  products: Array<Product>;
  /** An aggregate relationship */
  products_aggregate: Product_Aggregate;
  raw_address?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
};


/** columns and relationships of "manufacturing_facility" */
export type Manufacturing_FacilityProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "manufacturing_facility" */
export type Manufacturing_FacilityProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "manufacturing_facility" */
export type Manufacturing_Facility_Aggregate = {
  __typename?: 'manufacturing_facility_aggregate';
  aggregate?: Maybe<Manufacturing_Facility_Aggregate_Fields>;
  nodes: Array<Manufacturing_Facility>;
};

/** aggregate fields of "manufacturing_facility" */
export type Manufacturing_Facility_Aggregate_Fields = {
  __typename?: 'manufacturing_facility_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Manufacturing_Facility_Max_Fields>;
  min?: Maybe<Manufacturing_Facility_Min_Fields>;
};


/** aggregate fields of "manufacturing_facility" */
export type Manufacturing_Facility_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Manufacturing_Facility_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manufacturing_facility" */
export type Manufacturing_Facility_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Manufacturing_Facility_Max_Order_By>;
  min?: InputMaybe<Manufacturing_Facility_Min_Order_By>;
};

/** input type for inserting array relation for remote table "manufacturing_facility" */
export type Manufacturing_Facility_Arr_Rel_Insert_Input = {
  data: Array<Manufacturing_Facility_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Manufacturing_Facility_On_Conflict>;
};

/** Boolean expression to filter rows from the table "manufacturing_facility". All fields are combined with a logical 'AND'. */
export type Manufacturing_Facility_Bool_Exp = {
  _and?: InputMaybe<Array<Manufacturing_Facility_Bool_Exp>>;
  _not?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
  _or?: InputMaybe<Array<Manufacturing_Facility_Bool_Exp>>;
  address_line1?: InputMaybe<String_Comparison_Exp>;
  address_line2?: InputMaybe<String_Comparison_Exp>;
  city_village?: InputMaybe<String_Comparison_Exp>;
  coordinates?: InputMaybe<Geometry_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  loc_desc?: InputMaybe<String_Comparison_Exp>;
  manufacturer?: InputMaybe<Manufacturer_Bool_Exp>;
  manufacturer_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  post_code?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Product_Bool_Exp>;
  raw_address?: InputMaybe<String_Comparison_Exp>;
  region_county?: InputMaybe<String_Comparison_Exp>;
  state_province?: InputMaybe<String_Comparison_Exp>;
  sub_region?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "manufacturing_facility" */
export enum Manufacturing_Facility_Constraint {
  /** unique or primary key constraint on columns "id" */
  ManufacturingFacilityPkey = 'manufacturing_facility_pkey'
}

/** input type for inserting data into table "manufacturing_facility" */
export type Manufacturing_Facility_Insert_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['geometry']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Manufacturer_Obj_Rel_Insert_Input>;
  manufacturer_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  raw_address?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Manufacturing_Facility_Max_Fields = {
  __typename?: 'manufacturing_facility_max_fields';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  loc_desc?: Maybe<Scalars['String']>;
  manufacturer_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "manufacturing_facility" */
export type Manufacturing_Facility_Max_Order_By = {
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_village?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loc_desc?: InputMaybe<Order_By>;
  manufacturer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  post_code?: InputMaybe<Order_By>;
  raw_address?: InputMaybe<Order_By>;
  region_county?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  sub_region?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Manufacturing_Facility_Min_Fields = {
  __typename?: 'manufacturing_facility_min_fields';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  loc_desc?: Maybe<Scalars['String']>;
  manufacturer_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "manufacturing_facility" */
export type Manufacturing_Facility_Min_Order_By = {
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_village?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loc_desc?: InputMaybe<Order_By>;
  manufacturer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  post_code?: InputMaybe<Order_By>;
  raw_address?: InputMaybe<Order_By>;
  region_county?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  sub_region?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "manufacturing_facility" */
export type Manufacturing_Facility_Mutation_Response = {
  __typename?: 'manufacturing_facility_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Manufacturing_Facility>;
};

/** input type for inserting object relation for remote table "manufacturing_facility" */
export type Manufacturing_Facility_Obj_Rel_Insert_Input = {
  data: Manufacturing_Facility_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Manufacturing_Facility_On_Conflict>;
};

/** on_conflict condition type for table "manufacturing_facility" */
export type Manufacturing_Facility_On_Conflict = {
  constraint: Manufacturing_Facility_Constraint;
  update_columns?: Array<Manufacturing_Facility_Update_Column>;
  where?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
};

/** Ordering options when selecting data from "manufacturing_facility". */
export type Manufacturing_Facility_Order_By = {
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_village?: InputMaybe<Order_By>;
  coordinates?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  loc_desc?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Manufacturer_Order_By>;
  manufacturer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  post_code?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  raw_address?: InputMaybe<Order_By>;
  region_county?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  sub_region?: InputMaybe<Order_By>;
};

/** primary key columns input for table: manufacturing_facility */
export type Manufacturing_Facility_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "manufacturing_facility" */
export enum Manufacturing_Facility_Select_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  CityVillage = 'city_village',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocDesc = 'loc_desc',
  /** column name */
  ManufacturerId = 'manufacturer_id',
  /** column name */
  Name = 'name',
  /** column name */
  PostCode = 'post_code',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  RegionCounty = 'region_county',
  /** column name */
  StateProvince = 'state_province',
  /** column name */
  SubRegion = 'sub_region'
}

/** input type for updating data in table "manufacturing_facility" */
export type Manufacturing_Facility_Set_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['geometry']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  manufacturer_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "manufacturing_facility" */
export type Manufacturing_Facility_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Manufacturing_Facility_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Manufacturing_Facility_Stream_Cursor_Value_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['geometry']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  manufacturer_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
};

/** update columns of table "manufacturing_facility" */
export enum Manufacturing_Facility_Update_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  CityVillage = 'city_village',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocDesc = 'loc_desc',
  /** column name */
  ManufacturerId = 'manufacturer_id',
  /** column name */
  Name = 'name',
  /** column name */
  PostCode = 'post_code',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  RegionCounty = 'region_county',
  /** column name */
  StateProvince = 'state_province',
  /** column name */
  SubRegion = 'sub_region'
}

export type Manufacturing_Facility_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Manufacturing_Facility_Set_Input>;
  where: Manufacturing_Facility_Bool_Exp;
};

/** columns and relationships of "market" */
export type Market = {
  __typename?: 'market';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['uuid'];
  region_id: Scalars['uuid'];
  /** An object relationship */
  trade_region: Trade_Region;
};

/** aggregated selection of "market" */
export type Market_Aggregate = {
  __typename?: 'market_aggregate';
  aggregate?: Maybe<Market_Aggregate_Fields>;
  nodes: Array<Market>;
};

/** aggregate fields of "market" */
export type Market_Aggregate_Fields = {
  __typename?: 'market_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Market_Max_Fields>;
  min?: Maybe<Market_Min_Fields>;
};


/** aggregate fields of "market" */
export type Market_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Market_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "market" */
export type Market_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Market_Max_Order_By>;
  min?: InputMaybe<Market_Min_Order_By>;
};

/** input type for inserting array relation for remote table "market" */
export type Market_Arr_Rel_Insert_Input = {
  data: Array<Market_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Market_On_Conflict>;
};

/** Boolean expression to filter rows from the table "market". All fields are combined with a logical 'AND'. */
export type Market_Bool_Exp = {
  _and?: InputMaybe<Array<Market_Bool_Exp>>;
  _not?: InputMaybe<Market_Bool_Exp>;
  _or?: InputMaybe<Array<Market_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  trade_region?: InputMaybe<Trade_Region_Bool_Exp>;
};

/** unique or primary key constraints on table "market" */
export enum Market_Constraint {
  /** unique or primary key constraint on columns "id" */
  MarketPkey = 'market_pkey',
  /** unique or primary key constraint on columns "name", "provider_id", "region_id" */
  MarketRegionIdNameProviderId_3f9d77acUniq = 'market_region_id_name_provider_id_3f9d77ac_uniq'
}

/** input type for inserting data into table "market" */
export type Market_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  region_id?: InputMaybe<Scalars['uuid']>;
  trade_region?: InputMaybe<Trade_Region_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Market_Max_Fields = {
  __typename?: 'market_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  region_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "market" */
export type Market_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Market_Min_Fields = {
  __typename?: 'market_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  region_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "market" */
export type Market_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "market" */
export type Market_Mutation_Response = {
  __typename?: 'market_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Market>;
};

/** input type for inserting object relation for remote table "market" */
export type Market_Obj_Rel_Insert_Input = {
  data: Market_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Market_On_Conflict>;
};

/** on_conflict condition type for table "market" */
export type Market_On_Conflict = {
  constraint: Market_Constraint;
  update_columns?: Array<Market_Update_Column>;
  where?: InputMaybe<Market_Bool_Exp>;
};

/** Ordering options when selecting data from "market". */
export type Market_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  trade_region?: InputMaybe<Trade_Region_Order_By>;
};

/** primary key columns input for table: market */
export type Market_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "market" */
export enum Market_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RegionId = 'region_id'
}

/** input type for updating data in table "market" */
export type Market_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  region_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "market" */
export type Market_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Market_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Market_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  region_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "market" */
export enum Market_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RegionId = 'region_id'
}

export type Market_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Market_Set_Input>;
  where: Market_Bool_Exp;
};

/** columns and relationships of "marketer" */
export type Marketer = {
  __typename?: 'marketer';
  /** An object relationship */
  advertisement?: Maybe<Common_Fileupload>;
  advertisement_id?: Maybe<Scalars['bigint']>;
  description: Scalars['String'];
  display_name: Scalars['String'];
  gst_number?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  logo?: Maybe<Common_Fileupload>;
  logo_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  marketing_facilities: Array<Marketing_Facility>;
  /** An aggregate relationship */
  marketing_facilities_aggregate: Marketing_Facility_Aggregate;
  name: Scalars['String'];
};


/** columns and relationships of "marketer" */
export type MarketerMarketing_FacilitiesArgs = {
  distinct_on?: InputMaybe<Array<Marketing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Marketing_Facility_Order_By>>;
  where?: InputMaybe<Marketing_Facility_Bool_Exp>;
};


/** columns and relationships of "marketer" */
export type MarketerMarketing_Facilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marketing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Marketing_Facility_Order_By>>;
  where?: InputMaybe<Marketing_Facility_Bool_Exp>;
};

/** aggregated selection of "marketer" */
export type Marketer_Aggregate = {
  __typename?: 'marketer_aggregate';
  aggregate?: Maybe<Marketer_Aggregate_Fields>;
  nodes: Array<Marketer>;
};

/** aggregate fields of "marketer" */
export type Marketer_Aggregate_Fields = {
  __typename?: 'marketer_aggregate_fields';
  avg?: Maybe<Marketer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Marketer_Max_Fields>;
  min?: Maybe<Marketer_Min_Fields>;
  stddev?: Maybe<Marketer_Stddev_Fields>;
  stddev_pop?: Maybe<Marketer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Marketer_Stddev_Samp_Fields>;
  sum?: Maybe<Marketer_Sum_Fields>;
  var_pop?: Maybe<Marketer_Var_Pop_Fields>;
  var_samp?: Maybe<Marketer_Var_Samp_Fields>;
  variance?: Maybe<Marketer_Variance_Fields>;
};


/** aggregate fields of "marketer" */
export type Marketer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Marketer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Marketer_Avg_Fields = {
  __typename?: 'marketer_avg_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "marketer". All fields are combined with a logical 'AND'. */
export type Marketer_Bool_Exp = {
  _and?: InputMaybe<Array<Marketer_Bool_Exp>>;
  _not?: InputMaybe<Marketer_Bool_Exp>;
  _or?: InputMaybe<Array<Marketer_Bool_Exp>>;
  advertisement?: InputMaybe<Common_Fileupload_Bool_Exp>;
  advertisement_id?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  gst_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  logo?: InputMaybe<Common_Fileupload_Bool_Exp>;
  logo_id?: InputMaybe<Bigint_Comparison_Exp>;
  marketing_facilities?: InputMaybe<Marketing_Facility_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "marketer" */
export enum Marketer_Constraint {
  /** unique or primary key constraint on columns "display_name", "name" */
  MarketerNameDisplayName_640c1eddUniq = 'marketer_name_display_name_640c1edd_uniq',
  /** unique or primary key constraint on columns "id" */
  MarketerPkey = 'marketer_pkey'
}

/** input type for incrementing numeric columns in table "marketer" */
export type Marketer_Inc_Input = {
  advertisement_id?: InputMaybe<Scalars['bigint']>;
  logo_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "marketer" */
export type Marketer_Insert_Input = {
  advertisement?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  advertisement_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  gst_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  logo_id?: InputMaybe<Scalars['bigint']>;
  marketing_facilities?: InputMaybe<Marketing_Facility_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Marketer_Max_Fields = {
  __typename?: 'marketer_max_fields';
  advertisement_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  gst_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logo_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Marketer_Min_Fields = {
  __typename?: 'marketer_min_fields';
  advertisement_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  gst_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logo_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "marketer" */
export type Marketer_Mutation_Response = {
  __typename?: 'marketer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Marketer>;
};

/** input type for inserting object relation for remote table "marketer" */
export type Marketer_Obj_Rel_Insert_Input = {
  data: Marketer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Marketer_On_Conflict>;
};

/** on_conflict condition type for table "marketer" */
export type Marketer_On_Conflict = {
  constraint: Marketer_Constraint;
  update_columns?: Array<Marketer_Update_Column>;
  where?: InputMaybe<Marketer_Bool_Exp>;
};

/** Ordering options when selecting data from "marketer". */
export type Marketer_Order_By = {
  advertisement?: InputMaybe<Common_Fileupload_Order_By>;
  advertisement_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  logo?: InputMaybe<Common_Fileupload_Order_By>;
  logo_id?: InputMaybe<Order_By>;
  marketing_facilities_aggregate?: InputMaybe<Marketing_Facility_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: marketer */
export type Marketer_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "marketer" */
export enum Marketer_Select_Column {
  /** column name */
  AdvertisementId = 'advertisement_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  GstNumber = 'gst_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "marketer" */
export type Marketer_Set_Input = {
  advertisement_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  gst_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  logo_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Marketer_Stddev_Fields = {
  __typename?: 'marketer_stddev_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Marketer_Stddev_Pop_Fields = {
  __typename?: 'marketer_stddev_pop_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Marketer_Stddev_Samp_Fields = {
  __typename?: 'marketer_stddev_samp_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "marketer" */
export type Marketer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketer_Stream_Cursor_Value_Input = {
  advertisement_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  gst_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  logo_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Marketer_Sum_Fields = {
  __typename?: 'marketer_sum_fields';
  advertisement_id?: Maybe<Scalars['bigint']>;
  logo_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "marketer" */
export enum Marketer_Update_Column {
  /** column name */
  AdvertisementId = 'advertisement_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  GstNumber = 'gst_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  Name = 'name'
}

export type Marketer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Marketer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Marketer_Set_Input>;
  where: Marketer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Marketer_Var_Pop_Fields = {
  __typename?: 'marketer_var_pop_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Marketer_Var_Samp_Fields = {
  __typename?: 'marketer_var_samp_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Marketer_Variance_Fields = {
  __typename?: 'marketer_variance_fields';
  advertisement_id?: Maybe<Scalars['Float']>;
  logo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "marketing_facility" */
export type Marketing_Facility = {
  __typename?: 'marketing_facility';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['geometry']>;
  country?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  loc_desc?: Maybe<Scalars['String']>;
  /** An object relationship */
  marketer: Marketer;
  marketer_id: Scalars['uuid'];
  name: Scalars['String'];
  post_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  products: Array<Product>;
  /** An aggregate relationship */
  products_aggregate: Product_Aggregate;
  raw_address?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
};


/** columns and relationships of "marketing_facility" */
export type Marketing_FacilityProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "marketing_facility" */
export type Marketing_FacilityProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "marketing_facility" */
export type Marketing_Facility_Aggregate = {
  __typename?: 'marketing_facility_aggregate';
  aggregate?: Maybe<Marketing_Facility_Aggregate_Fields>;
  nodes: Array<Marketing_Facility>;
};

/** aggregate fields of "marketing_facility" */
export type Marketing_Facility_Aggregate_Fields = {
  __typename?: 'marketing_facility_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Marketing_Facility_Max_Fields>;
  min?: Maybe<Marketing_Facility_Min_Fields>;
};


/** aggregate fields of "marketing_facility" */
export type Marketing_Facility_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Marketing_Facility_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "marketing_facility" */
export type Marketing_Facility_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Marketing_Facility_Max_Order_By>;
  min?: InputMaybe<Marketing_Facility_Min_Order_By>;
};

/** input type for inserting array relation for remote table "marketing_facility" */
export type Marketing_Facility_Arr_Rel_Insert_Input = {
  data: Array<Marketing_Facility_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Marketing_Facility_On_Conflict>;
};

/** Boolean expression to filter rows from the table "marketing_facility". All fields are combined with a logical 'AND'. */
export type Marketing_Facility_Bool_Exp = {
  _and?: InputMaybe<Array<Marketing_Facility_Bool_Exp>>;
  _not?: InputMaybe<Marketing_Facility_Bool_Exp>;
  _or?: InputMaybe<Array<Marketing_Facility_Bool_Exp>>;
  address_line1?: InputMaybe<String_Comparison_Exp>;
  address_line2?: InputMaybe<String_Comparison_Exp>;
  city_village?: InputMaybe<String_Comparison_Exp>;
  coordinates?: InputMaybe<Geometry_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  loc_desc?: InputMaybe<String_Comparison_Exp>;
  marketer?: InputMaybe<Marketer_Bool_Exp>;
  marketer_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  post_code?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Product_Bool_Exp>;
  raw_address?: InputMaybe<String_Comparison_Exp>;
  region_county?: InputMaybe<String_Comparison_Exp>;
  state_province?: InputMaybe<String_Comparison_Exp>;
  sub_region?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "marketing_facility" */
export enum Marketing_Facility_Constraint {
  /** unique or primary key constraint on columns "id" */
  MarketingFacilityPkey = 'marketing_facility_pkey'
}

/** input type for inserting data into table "marketing_facility" */
export type Marketing_Facility_Insert_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['geometry']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  marketer?: InputMaybe<Marketer_Obj_Rel_Insert_Input>;
  marketer_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  raw_address?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Marketing_Facility_Max_Fields = {
  __typename?: 'marketing_facility_max_fields';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  loc_desc?: Maybe<Scalars['String']>;
  marketer_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "marketing_facility" */
export type Marketing_Facility_Max_Order_By = {
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_village?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loc_desc?: InputMaybe<Order_By>;
  marketer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  post_code?: InputMaybe<Order_By>;
  raw_address?: InputMaybe<Order_By>;
  region_county?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  sub_region?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Marketing_Facility_Min_Fields = {
  __typename?: 'marketing_facility_min_fields';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  loc_desc?: Maybe<Scalars['String']>;
  marketer_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "marketing_facility" */
export type Marketing_Facility_Min_Order_By = {
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_village?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loc_desc?: InputMaybe<Order_By>;
  marketer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  post_code?: InputMaybe<Order_By>;
  raw_address?: InputMaybe<Order_By>;
  region_county?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  sub_region?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "marketing_facility" */
export type Marketing_Facility_Mutation_Response = {
  __typename?: 'marketing_facility_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Marketing_Facility>;
};

/** input type for inserting object relation for remote table "marketing_facility" */
export type Marketing_Facility_Obj_Rel_Insert_Input = {
  data: Marketing_Facility_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Marketing_Facility_On_Conflict>;
};

/** on_conflict condition type for table "marketing_facility" */
export type Marketing_Facility_On_Conflict = {
  constraint: Marketing_Facility_Constraint;
  update_columns?: Array<Marketing_Facility_Update_Column>;
  where?: InputMaybe<Marketing_Facility_Bool_Exp>;
};

/** Ordering options when selecting data from "marketing_facility". */
export type Marketing_Facility_Order_By = {
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_village?: InputMaybe<Order_By>;
  coordinates?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  loc_desc?: InputMaybe<Order_By>;
  marketer?: InputMaybe<Marketer_Order_By>;
  marketer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  post_code?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  raw_address?: InputMaybe<Order_By>;
  region_county?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  sub_region?: InputMaybe<Order_By>;
};

/** primary key columns input for table: marketing_facility */
export type Marketing_Facility_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "marketing_facility" */
export enum Marketing_Facility_Select_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  CityVillage = 'city_village',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocDesc = 'loc_desc',
  /** column name */
  MarketerId = 'marketer_id',
  /** column name */
  Name = 'name',
  /** column name */
  PostCode = 'post_code',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  RegionCounty = 'region_county',
  /** column name */
  StateProvince = 'state_province',
  /** column name */
  SubRegion = 'sub_region'
}

/** input type for updating data in table "marketing_facility" */
export type Marketing_Facility_Set_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['geometry']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  marketer_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "marketing_facility" */
export type Marketing_Facility_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketing_Facility_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketing_Facility_Stream_Cursor_Value_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['geometry']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  marketer_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
};

/** update columns of table "marketing_facility" */
export enum Marketing_Facility_Update_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  CityVillage = 'city_village',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocDesc = 'loc_desc',
  /** column name */
  MarketerId = 'marketer_id',
  /** column name */
  Name = 'name',
  /** column name */
  PostCode = 'post_code',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  RegionCounty = 'region_county',
  /** column name */
  StateProvince = 'state_province',
  /** column name */
  SubRegion = 'sub_region'
}

export type Marketing_Facility_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Marketing_Facility_Set_Input>;
  where: Marketing_Facility_Bool_Exp;
};

/** columns and relationships of "measure_of" */
export type Measure_Of = {
  __typename?: 'measure_of';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  units: Array<Unit>;
  /** An aggregate relationship */
  units_aggregate: Unit_Aggregate;
};


/** columns and relationships of "measure_of" */
export type Measure_OfUnitsArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


/** columns and relationships of "measure_of" */
export type Measure_OfUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};

/** aggregated selection of "measure_of" */
export type Measure_Of_Aggregate = {
  __typename?: 'measure_of_aggregate';
  aggregate?: Maybe<Measure_Of_Aggregate_Fields>;
  nodes: Array<Measure_Of>;
};

/** aggregate fields of "measure_of" */
export type Measure_Of_Aggregate_Fields = {
  __typename?: 'measure_of_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Measure_Of_Max_Fields>;
  min?: Maybe<Measure_Of_Min_Fields>;
};


/** aggregate fields of "measure_of" */
export type Measure_Of_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Measure_Of_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "measure_of". All fields are combined with a logical 'AND'. */
export type Measure_Of_Bool_Exp = {
  _and?: InputMaybe<Array<Measure_Of_Bool_Exp>>;
  _not?: InputMaybe<Measure_Of_Bool_Exp>;
  _or?: InputMaybe<Array<Measure_Of_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  units?: InputMaybe<Unit_Bool_Exp>;
};

/** unique or primary key constraints on table "measure_of" */
export enum Measure_Of_Constraint {
  /** unique or primary key constraint on columns "name" */
  MeasureOfNameKey = 'measure_of_name_key',
  /** unique or primary key constraint on columns "id" */
  MeasureOfPkey = 'measure_of_pkey'
}

/** input type for inserting data into table "measure_of" */
export type Measure_Of_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Unit_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Measure_Of_Max_Fields = {
  __typename?: 'measure_of_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Measure_Of_Min_Fields = {
  __typename?: 'measure_of_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "measure_of" */
export type Measure_Of_Mutation_Response = {
  __typename?: 'measure_of_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Measure_Of>;
};

/** input type for inserting object relation for remote table "measure_of" */
export type Measure_Of_Obj_Rel_Insert_Input = {
  data: Measure_Of_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Measure_Of_On_Conflict>;
};

/** on_conflict condition type for table "measure_of" */
export type Measure_Of_On_Conflict = {
  constraint: Measure_Of_Constraint;
  update_columns?: Array<Measure_Of_Update_Column>;
  where?: InputMaybe<Measure_Of_Bool_Exp>;
};

/** Ordering options when selecting data from "measure_of". */
export type Measure_Of_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  units_aggregate?: InputMaybe<Unit_Aggregate_Order_By>;
};

/** primary key columns input for table: measure_of */
export type Measure_Of_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "measure_of" */
export enum Measure_Of_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "measure_of" */
export type Measure_Of_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "measure_of" */
export type Measure_Of_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Measure_Of_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Measure_Of_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "measure_of" */
export enum Measure_Of_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Measure_Of_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Measure_Of_Set_Input>;
  where: Measure_Of_Bool_Exp;
};

/** columns and relationships of "media" */
export type Media = {
  __typename?: 'media';
  access: Scalars['String'];
  created_at: Scalars['timestamptz'];
  etag?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_encrypted: Scalars['Boolean'];
  /** An object relationship */
  location?: Maybe<Address>;
  location_id?: Maybe<Scalars['Int']>;
  media_kind: Scalars['String'];
  mime_type?: Maybe<Scalars['String']>;
  signed_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  thumbnail?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  url: Scalars['String'];
};


/** columns and relationships of "media" */
export type MediaThumbnailArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "media" */
export type Media_Aggregate = {
  __typename?: 'media_aggregate';
  aggregate?: Maybe<Media_Aggregate_Fields>;
  nodes: Array<Media>;
};

/** aggregate fields of "media" */
export type Media_Aggregate_Fields = {
  __typename?: 'media_aggregate_fields';
  avg?: Maybe<Media_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Media_Max_Fields>;
  min?: Maybe<Media_Min_Fields>;
  stddev?: Maybe<Media_Stddev_Fields>;
  stddev_pop?: Maybe<Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Media_Stddev_Samp_Fields>;
  sum?: Maybe<Media_Sum_Fields>;
  var_pop?: Maybe<Media_Var_Pop_Fields>;
  var_samp?: Maybe<Media_Var_Samp_Fields>;
  variance?: Maybe<Media_Variance_Fields>;
};


/** aggregate fields of "media" */
export type Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Media_Append_Input = {
  thumbnail?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Media_Avg_Fields = {
  __typename?: 'media_avg_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "media". All fields are combined with a logical 'AND'. */
export type Media_Bool_Exp = {
  _and?: InputMaybe<Array<Media_Bool_Exp>>;
  _not?: InputMaybe<Media_Bool_Exp>;
  _or?: InputMaybe<Array<Media_Bool_Exp>>;
  access?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_encrypted?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Address_Bool_Exp>;
  location_id?: InputMaybe<Int_Comparison_Exp>;
  media_kind?: InputMaybe<String_Comparison_Exp>;
  mime_type?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  thumbnail?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "media" */
export enum Media_Constraint {
  /** unique or primary key constraint on columns "id" */
  MediaPkey = 'media_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Media_Delete_At_Path_Input = {
  thumbnail?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Media_Delete_Elem_Input = {
  thumbnail?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Media_Delete_Key_Input = {
  thumbnail?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "media" */
export type Media_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  location_id?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "media" */
export type Media_Insert_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['Int']>;
  media_kind?: InputMaybe<Scalars['String']>;
  mime_type?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Media_Max_Fields = {
  __typename?: 'media_max_fields';
  access?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
  media_kind?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Media_Min_Fields = {
  __typename?: 'media_min_fields';
  access?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
  media_kind?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "media" */
export type Media_Mutation_Response = {
  __typename?: 'media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Media>;
};

/** input type for inserting object relation for remote table "media" */
export type Media_Obj_Rel_Insert_Input = {
  data: Media_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Media_On_Conflict>;
};

/** on_conflict condition type for table "media" */
export type Media_On_Conflict = {
  constraint: Media_Constraint;
  update_columns?: Array<Media_Update_Column>;
  where?: InputMaybe<Media_Bool_Exp>;
};

/** Ordering options when selecting data from "media". */
export type Media_Order_By = {
  access?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_encrypted?: InputMaybe<Order_By>;
  location?: InputMaybe<Address_Order_By>;
  location_id?: InputMaybe<Order_By>;
  media_kind?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  thumbnail?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: media */
export type Media_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Media_Prepend_Input = {
  thumbnail?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "media" */
export enum Media_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MediaKind = 'media_kind',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  Size = 'size',
  /** column name */
  Thumbnail = 'thumbnail',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "media" */
export type Media_Set_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  media_kind?: InputMaybe<Scalars['String']>;
  mime_type?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Media_Stddev_Fields = {
  __typename?: 'media_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Media_Stddev_Pop_Fields = {
  __typename?: 'media_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Media_Stddev_Samp_Fields = {
  __typename?: 'media_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "media" */
export type Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Media_Stream_Cursor_Value_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  media_kind?: InputMaybe<Scalars['String']>;
  mime_type?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Media_Sum_Fields = {
  __typename?: 'media_sum_fields';
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

/** update columns of table "media" */
export enum Media_Update_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MediaKind = 'media_kind',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  Size = 'size',
  /** column name */
  Thumbnail = 'thumbnail',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type Media_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Media_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Media_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Media_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Media_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Media_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Media_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Media_Set_Input>;
  where: Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Media_Var_Pop_Fields = {
  __typename?: 'media_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Media_Var_Samp_Fields = {
  __typename?: 'media_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Media_Variance_Fields = {
  __typename?: 'media_variance_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "message" */
export type Message = {
  __typename?: 'message';
  action?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_addressor: Scalars['Boolean'];
  is_seen: Scalars['Boolean'];
  notification_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  recommended_products: Array<Recommended_Product>;
  /** An aggregate relationship */
  recommended_products_aggregate: Recommended_Product_Aggregate;
  sender: Array<Base_User>;
  sender_id: Scalars['String'];
  sent_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  thread?: Maybe<Thread>;
  thread_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "message" */
export type MessageRecommended_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Recommended_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommended_Product_Order_By>>;
  where?: InputMaybe<Recommended_Product_Bool_Exp>;
};


/** columns and relationships of "message" */
export type MessageRecommended_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recommended_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommended_Product_Order_By>>;
  where?: InputMaybe<Recommended_Product_Bool_Exp>;
};


/** columns and relationships of "message" */
export type MessageSenderArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Messagesender>;
};

/** aggregated selection of "message" */
export type Message_Aggregate = {
  __typename?: 'message_aggregate';
  aggregate?: Maybe<Message_Aggregate_Fields>;
  nodes: Array<Message>;
};

/** aggregate fields of "message" */
export type Message_Aggregate_Fields = {
  __typename?: 'message_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Message_Max_Fields>;
  min?: Maybe<Message_Min_Fields>;
};


/** aggregate fields of "message" */
export type Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "message" */
export type Message_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Message_Max_Order_By>;
  min?: InputMaybe<Message_Min_Order_By>;
};

/** input type for inserting array relation for remote table "message" */
export type Message_Arr_Rel_Insert_Input = {
  data: Array<Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Message_On_Conflict>;
};

/** Boolean expression to filter rows from the table "message". All fields are combined with a logical 'AND'. */
export type Message_Bool_Exp = {
  _and?: InputMaybe<Array<Message_Bool_Exp>>;
  _not?: InputMaybe<Message_Bool_Exp>;
  _or?: InputMaybe<Array<Message_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_addressor?: InputMaybe<Boolean_Comparison_Exp>;
  is_seen?: InputMaybe<Boolean_Comparison_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  recommended_products?: InputMaybe<Recommended_Product_Bool_Exp>;
  sender_id?: InputMaybe<String_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  thread?: InputMaybe<Thread_Bool_Exp>;
  thread_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "message" */
export enum Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagePkey = 'message_pkey'
}

/** input type for inserting data into table "message" */
export type Message_Insert_Input = {
  action?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_addressor?: InputMaybe<Scalars['Boolean']>;
  is_seen?: InputMaybe<Scalars['Boolean']>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  recommended_products?: InputMaybe<Recommended_Product_Arr_Rel_Insert_Input>;
  sender_id?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  thread?: InputMaybe<Thread_Obj_Rel_Insert_Input>;
  thread_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Message_Max_Fields = {
  __typename?: 'message_max_fields';
  action?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notification_id?: Maybe<Scalars['uuid']>;
  sender_id?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  thread_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "message" */
export type Message_Max_Order_By = {
  action?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Message_Min_Fields = {
  __typename?: 'message_min_fields';
  action?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notification_id?: Maybe<Scalars['uuid']>;
  sender_id?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  thread_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "message" */
export type Message_Min_Order_By = {
  action?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "message" */
export type Message_Mutation_Response = {
  __typename?: 'message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Message>;
};

/** input type for inserting object relation for remote table "message" */
export type Message_Obj_Rel_Insert_Input = {
  data: Message_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Message_On_Conflict>;
};

/** on_conflict condition type for table "message" */
export type Message_On_Conflict = {
  constraint: Message_Constraint;
  update_columns?: Array<Message_Update_Column>;
  where?: InputMaybe<Message_Bool_Exp>;
};

/** Ordering options when selecting data from "message". */
export type Message_Order_By = {
  action?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_addressor?: InputMaybe<Order_By>;
  is_seen?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  recommended_products_aggregate?: InputMaybe<Recommended_Product_Aggregate_Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  thread?: InputMaybe<Thread_Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: message */
export type Message_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "message" */
export enum Message_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAddressor = 'is_addressor',
  /** column name */
  IsSeen = 'is_seen',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "message" */
export type Message_Set_Input = {
  action?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_addressor?: InputMaybe<Scalars['Boolean']>;
  is_seen?: InputMaybe<Scalars['Boolean']>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  sender_id?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  thread_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "message" */
export type Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Message_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_addressor?: InputMaybe<Scalars['Boolean']>;
  is_seen?: InputMaybe<Scalars['Boolean']>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  sender_id?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  thread_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "message" */
export enum Message_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAddressor = 'is_addressor',
  /** column name */
  IsSeen = 'is_seen',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

export type Message_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Message_Set_Input>;
  where: Message_Bool_Exp;
};

/** columns and relationships of "milestone" */
export type Milestone = {
  __typename?: 'milestone';
  date_format: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  kind: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "milestone" */
export type Milestone_Aggregate = {
  __typename?: 'milestone_aggregate';
  aggregate?: Maybe<Milestone_Aggregate_Fields>;
  nodes: Array<Milestone>;
};

/** aggregate fields of "milestone" */
export type Milestone_Aggregate_Fields = {
  __typename?: 'milestone_aggregate_fields';
  avg?: Maybe<Milestone_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Milestone_Max_Fields>;
  min?: Maybe<Milestone_Min_Fields>;
  stddev?: Maybe<Milestone_Stddev_Fields>;
  stddev_pop?: Maybe<Milestone_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Milestone_Stddev_Samp_Fields>;
  sum?: Maybe<Milestone_Sum_Fields>;
  var_pop?: Maybe<Milestone_Var_Pop_Fields>;
  var_samp?: Maybe<Milestone_Var_Samp_Fields>;
  variance?: Maybe<Milestone_Variance_Fields>;
};


/** aggregate fields of "milestone" */
export type Milestone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Milestone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Milestone_Avg_Fields = {
  __typename?: 'milestone_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "milestone". All fields are combined with a logical 'AND'. */
export type Milestone_Bool_Exp = {
  _and?: InputMaybe<Array<Milestone_Bool_Exp>>;
  _not?: InputMaybe<Milestone_Bool_Exp>;
  _or?: InputMaybe<Array<Milestone_Bool_Exp>>;
  date_format?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "milestone" */
export enum Milestone_Constraint {
  /** unique or primary key constraint on columns "id" */
  MilestonePkey = 'milestone_pkey'
}

/** input type for incrementing numeric columns in table "milestone" */
export type Milestone_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "milestone" */
export type Milestone_Insert_Input = {
  date_format?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Milestone_Max_Fields = {
  __typename?: 'milestone_max_fields';
  date_format?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Milestone_Min_Fields = {
  __typename?: 'milestone_min_fields';
  date_format?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "milestone" */
export type Milestone_Mutation_Response = {
  __typename?: 'milestone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Milestone>;
};

/** input type for inserting object relation for remote table "milestone" */
export type Milestone_Obj_Rel_Insert_Input = {
  data: Milestone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Milestone_On_Conflict>;
};

/** on_conflict condition type for table "milestone" */
export type Milestone_On_Conflict = {
  constraint: Milestone_Constraint;
  update_columns?: Array<Milestone_Update_Column>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};

/** Ordering options when selecting data from "milestone". */
export type Milestone_Order_By = {
  date_format?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: milestone */
export type Milestone_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "milestone" */
export enum Milestone_Select_Column {
  /** column name */
  DateFormat = 'date_format',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "milestone" */
export type Milestone_Set_Input = {
  date_format?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Milestone_Stddev_Fields = {
  __typename?: 'milestone_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Milestone_Stddev_Pop_Fields = {
  __typename?: 'milestone_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Milestone_Stddev_Samp_Fields = {
  __typename?: 'milestone_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "milestone" */
export type Milestone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Milestone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Milestone_Stream_Cursor_Value_Input = {
  date_format?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Milestone_Sum_Fields = {
  __typename?: 'milestone_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "milestone" */
export enum Milestone_Update_Column {
  /** column name */
  DateFormat = 'date_format',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name'
}

export type Milestone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Milestone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Milestone_Set_Input>;
  where: Milestone_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Milestone_Var_Pop_Fields = {
  __typename?: 'milestone_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Milestone_Var_Samp_Fields = {
  __typename?: 'milestone_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Milestone_Variance_Fields = {
  __typename?: 'milestone_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "monitoring_category" */
export type Monitoring_Category = {
  __typename?: 'monitoring_category';
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  description: Scalars['String'];
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  /** An array relationship */
  monitoring_subcategories: Array<Monitoring_Subcategory>;
  /** An aggregate relationship */
  monitoring_subcategories_aggregate: Monitoring_Subcategory_Aggregate;
  name: Scalars['String'];
  order: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
};


/** columns and relationships of "monitoring_category" */
export type Monitoring_CategoryCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Monitoring_Categorycreator>;
};


/** columns and relationships of "monitoring_category" */
export type Monitoring_CategoryMonitoring_SubcategoriesArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Subcategory_Order_By>>;
  where?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
};


/** columns and relationships of "monitoring_category" */
export type Monitoring_CategoryMonitoring_Subcategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Subcategory_Order_By>>;
  where?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
};


/** columns and relationships of "monitoring_category" */
export type Monitoring_CategoryUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Monitoring_Categoryupdater>;
};

/** aggregated selection of "monitoring_category" */
export type Monitoring_Category_Aggregate = {
  __typename?: 'monitoring_category_aggregate';
  aggregate?: Maybe<Monitoring_Category_Aggregate_Fields>;
  nodes: Array<Monitoring_Category>;
};

/** aggregate fields of "monitoring_category" */
export type Monitoring_Category_Aggregate_Fields = {
  __typename?: 'monitoring_category_aggregate_fields';
  avg?: Maybe<Monitoring_Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Monitoring_Category_Max_Fields>;
  min?: Maybe<Monitoring_Category_Min_Fields>;
  stddev?: Maybe<Monitoring_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Monitoring_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Monitoring_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Monitoring_Category_Sum_Fields>;
  var_pop?: Maybe<Monitoring_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Monitoring_Category_Var_Samp_Fields>;
  variance?: Maybe<Monitoring_Category_Variance_Fields>;
};


/** aggregate fields of "monitoring_category" */
export type Monitoring_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Monitoring_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Monitoring_Category_Avg_Fields = {
  __typename?: 'monitoring_category_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "monitoring_category". All fields are combined with a logical 'AND'. */
export type Monitoring_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Monitoring_Category_Bool_Exp>>;
  _not?: InputMaybe<Monitoring_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Monitoring_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  monitoring_subcategories?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "monitoring_category" */
export enum Monitoring_Category_Constraint {
  /** unique or primary key constraint on columns "name" */
  MonitoringCategoryNameC8c6a6e7Uniq = 'monitoring_category_name_c8c6a6e7_uniq',
  /** unique or primary key constraint on columns "id" */
  MonitoringCategoryPkey = 'monitoring_category_pkey'
}

/** input type for incrementing numeric columns in table "monitoring_category" */
export type Monitoring_Category_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "monitoring_category" */
export type Monitoring_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  monitoring_subcategories?: InputMaybe<Monitoring_Subcategory_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Monitoring_Category_Max_Fields = {
  __typename?: 'monitoring_category_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Monitoring_Category_Min_Fields = {
  __typename?: 'monitoring_category_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "monitoring_category" */
export type Monitoring_Category_Mutation_Response = {
  __typename?: 'monitoring_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Monitoring_Category>;
};

/** input type for inserting object relation for remote table "monitoring_category" */
export type Monitoring_Category_Obj_Rel_Insert_Input = {
  data: Monitoring_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitoring_Category_On_Conflict>;
};

/** on_conflict condition type for table "monitoring_category" */
export type Monitoring_Category_On_Conflict = {
  constraint: Monitoring_Category_Constraint;
  update_columns?: Array<Monitoring_Category_Update_Column>;
  where?: InputMaybe<Monitoring_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "monitoring_category". */
export type Monitoring_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  monitoring_subcategories_aggregate?: InputMaybe<Monitoring_Subcategory_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: monitoring_category */
export type Monitoring_Category_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "monitoring_category" */
export enum Monitoring_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "monitoring_category" */
export type Monitoring_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Monitoring_Category_Stddev_Fields = {
  __typename?: 'monitoring_category_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Monitoring_Category_Stddev_Pop_Fields = {
  __typename?: 'monitoring_category_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Monitoring_Category_Stddev_Samp_Fields = {
  __typename?: 'monitoring_category_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "monitoring_category" */
export type Monitoring_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Monitoring_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Monitoring_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Monitoring_Category_Sum_Fields = {
  __typename?: 'monitoring_category_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "monitoring_category" */
export enum Monitoring_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Monitoring_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Monitoring_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Monitoring_Category_Set_Input>;
  where: Monitoring_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Monitoring_Category_Var_Pop_Fields = {
  __typename?: 'monitoring_category_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Monitoring_Category_Var_Samp_Fields = {
  __typename?: 'monitoring_category_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Monitoring_Category_Variance_Fields = {
  __typename?: 'monitoring_category_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "monitoring_parameter" */
export type Monitoring_Parameter = {
  __typename?: 'monitoring_parameter';
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  /** An array relationship */
  cropmonitoring_parameters: Array<Cropmonitoring_Parameter>;
  /** An aggregate relationship */
  cropmonitoring_parameters_aggregate: Cropmonitoring_Parameter_Aggregate;
  data_type: Scalars['String'];
  default_aggregation?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  max_samples: Scalars['Int'];
  min_samples: Scalars['Int'];
  /** An array relationship */
  monitoring_parameter_choices: Array<Monitoring_Parameter_Choices>;
  /** An aggregate relationship */
  monitoring_parameter_choices_aggregate: Monitoring_Parameter_Choices_Aggregate;
  /** An array relationship */
  monitoring_parameter_unit_choices: Array<Monitoring_Parameter_Unit_Choices>;
  /** An aggregate relationship */
  monitoring_parameter_unit_choices_aggregate: Monitoring_Parameter_Unit_Choices_Aggregate;
  /** An object relationship */
  monitoring_subcategory?: Maybe<Monitoring_Subcategory>;
  name: Scalars['String'];
  subcategory_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
};


/** columns and relationships of "monitoring_parameter" */
export type Monitoring_ParameterCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Monitoring_Parametercreator>;
};


/** columns and relationships of "monitoring_parameter" */
export type Monitoring_ParameterCropmonitoring_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Cropmonitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cropmonitoring_Parameter_Order_By>>;
  where?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
};


/** columns and relationships of "monitoring_parameter" */
export type Monitoring_ParameterCropmonitoring_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cropmonitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cropmonitoring_Parameter_Order_By>>;
  where?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
};


/** columns and relationships of "monitoring_parameter" */
export type Monitoring_ParameterMonitoring_Parameter_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Choices_Bool_Exp>;
};


/** columns and relationships of "monitoring_parameter" */
export type Monitoring_ParameterMonitoring_Parameter_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Choices_Bool_Exp>;
};


/** columns and relationships of "monitoring_parameter" */
export type Monitoring_ParameterMonitoring_Parameter_Unit_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Unit_Choices_Bool_Exp>;
};


/** columns and relationships of "monitoring_parameter" */
export type Monitoring_ParameterMonitoring_Parameter_Unit_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Unit_Choices_Bool_Exp>;
};


/** columns and relationships of "monitoring_parameter" */
export type Monitoring_ParameterUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Monitoring_Parameterupdater>;
};

/** aggregated selection of "monitoring_parameter" */
export type Monitoring_Parameter_Aggregate = {
  __typename?: 'monitoring_parameter_aggregate';
  aggregate?: Maybe<Monitoring_Parameter_Aggregate_Fields>;
  nodes: Array<Monitoring_Parameter>;
};

/** aggregate fields of "monitoring_parameter" */
export type Monitoring_Parameter_Aggregate_Fields = {
  __typename?: 'monitoring_parameter_aggregate_fields';
  avg?: Maybe<Monitoring_Parameter_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Monitoring_Parameter_Max_Fields>;
  min?: Maybe<Monitoring_Parameter_Min_Fields>;
  stddev?: Maybe<Monitoring_Parameter_Stddev_Fields>;
  stddev_pop?: Maybe<Monitoring_Parameter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Monitoring_Parameter_Stddev_Samp_Fields>;
  sum?: Maybe<Monitoring_Parameter_Sum_Fields>;
  var_pop?: Maybe<Monitoring_Parameter_Var_Pop_Fields>;
  var_samp?: Maybe<Monitoring_Parameter_Var_Samp_Fields>;
  variance?: Maybe<Monitoring_Parameter_Variance_Fields>;
};


/** aggregate fields of "monitoring_parameter" */
export type Monitoring_Parameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Monitoring_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "monitoring_parameter" */
export type Monitoring_Parameter_Aggregate_Order_By = {
  avg?: InputMaybe<Monitoring_Parameter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Monitoring_Parameter_Max_Order_By>;
  min?: InputMaybe<Monitoring_Parameter_Min_Order_By>;
  stddev?: InputMaybe<Monitoring_Parameter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Monitoring_Parameter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Monitoring_Parameter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Monitoring_Parameter_Sum_Order_By>;
  var_pop?: InputMaybe<Monitoring_Parameter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Monitoring_Parameter_Var_Samp_Order_By>;
  variance?: InputMaybe<Monitoring_Parameter_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "monitoring_parameter" */
export type Monitoring_Parameter_Arr_Rel_Insert_Input = {
  data: Array<Monitoring_Parameter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitoring_Parameter_On_Conflict>;
};

/** aggregate avg on columns */
export type Monitoring_Parameter_Avg_Fields = {
  __typename?: 'monitoring_parameter_avg_fields';
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "monitoring_parameter" */
export type Monitoring_Parameter_Avg_Order_By = {
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "monitoring_parameter". All fields are combined with a logical 'AND'. */
export type Monitoring_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Monitoring_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Monitoring_Parameter_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  cropmonitoring_parameters?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
  data_type?: InputMaybe<String_Comparison_Exp>;
  default_aggregation?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_samples?: InputMaybe<Int_Comparison_Exp>;
  min_samples?: InputMaybe<Int_Comparison_Exp>;
  monitoring_parameter_choices?: InputMaybe<Monitoring_Parameter_Choices_Bool_Exp>;
  monitoring_parameter_unit_choices?: InputMaybe<Monitoring_Parameter_Unit_Choices_Bool_Exp>;
  monitoring_subcategory?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  subcategory_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices = {
  __typename?: 'monitoring_parameter_choices';
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  monitoring_parameter: Monitoring_Parameter;
  order: Scalars['Int'];
  parameter_id: Scalars['uuid'];
  value: Scalars['String'];
};

/** aggregated selection of "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Aggregate = {
  __typename?: 'monitoring_parameter_choices_aggregate';
  aggregate?: Maybe<Monitoring_Parameter_Choices_Aggregate_Fields>;
  nodes: Array<Monitoring_Parameter_Choices>;
};

/** aggregate fields of "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Aggregate_Fields = {
  __typename?: 'monitoring_parameter_choices_aggregate_fields';
  avg?: Maybe<Monitoring_Parameter_Choices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Monitoring_Parameter_Choices_Max_Fields>;
  min?: Maybe<Monitoring_Parameter_Choices_Min_Fields>;
  stddev?: Maybe<Monitoring_Parameter_Choices_Stddev_Fields>;
  stddev_pop?: Maybe<Monitoring_Parameter_Choices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Monitoring_Parameter_Choices_Stddev_Samp_Fields>;
  sum?: Maybe<Monitoring_Parameter_Choices_Sum_Fields>;
  var_pop?: Maybe<Monitoring_Parameter_Choices_Var_Pop_Fields>;
  var_samp?: Maybe<Monitoring_Parameter_Choices_Var_Samp_Fields>;
  variance?: Maybe<Monitoring_Parameter_Choices_Variance_Fields>;
};


/** aggregate fields of "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Monitoring_Parameter_Choices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Aggregate_Order_By = {
  avg?: InputMaybe<Monitoring_Parameter_Choices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Monitoring_Parameter_Choices_Max_Order_By>;
  min?: InputMaybe<Monitoring_Parameter_Choices_Min_Order_By>;
  stddev?: InputMaybe<Monitoring_Parameter_Choices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Monitoring_Parameter_Choices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Monitoring_Parameter_Choices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Monitoring_Parameter_Choices_Sum_Order_By>;
  var_pop?: InputMaybe<Monitoring_Parameter_Choices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Monitoring_Parameter_Choices_Var_Samp_Order_By>;
  variance?: InputMaybe<Monitoring_Parameter_Choices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Arr_Rel_Insert_Input = {
  data: Array<Monitoring_Parameter_Choices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitoring_Parameter_Choices_On_Conflict>;
};

/** aggregate avg on columns */
export type Monitoring_Parameter_Choices_Avg_Fields = {
  __typename?: 'monitoring_parameter_choices_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "monitoring_parameter_choices". All fields are combined with a logical 'AND'. */
export type Monitoring_Parameter_Choices_Bool_Exp = {
  _and?: InputMaybe<Array<Monitoring_Parameter_Choices_Bool_Exp>>;
  _not?: InputMaybe<Monitoring_Parameter_Choices_Bool_Exp>;
  _or?: InputMaybe<Array<Monitoring_Parameter_Choices_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  monitoring_parameter?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  parameter_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "monitoring_parameter_choices" */
export enum Monitoring_Parameter_Choices_Constraint {
  /** unique or primary key constraint on columns "order", "parameter_id", "value" */
  MonitoringParameterChoParameterIdOrderValueBdb7f908Uniq = 'monitoring_parameter_cho_parameter_id_order_value_bdb7f908_uniq',
  /** unique or primary key constraint on columns "id" */
  MonitoringParameterChoicesPkey = 'monitoring_parameter_choices_pkey'
}

/** input type for incrementing numeric columns in table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  monitoring_parameter?: InputMaybe<Monitoring_Parameter_Obj_Rel_Insert_Input>;
  order?: InputMaybe<Scalars['Int']>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Monitoring_Parameter_Choices_Max_Fields = {
  __typename?: 'monitoring_parameter_choices_max_fields';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  parameter_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Max_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Monitoring_Parameter_Choices_Min_Fields = {
  __typename?: 'monitoring_parameter_choices_min_fields';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  parameter_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Min_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Mutation_Response = {
  __typename?: 'monitoring_parameter_choices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Monitoring_Parameter_Choices>;
};

/** on_conflict condition type for table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_On_Conflict = {
  constraint: Monitoring_Parameter_Choices_Constraint;
  update_columns?: Array<Monitoring_Parameter_Choices_Update_Column>;
  where?: InputMaybe<Monitoring_Parameter_Choices_Bool_Exp>;
};

/** Ordering options when selecting data from "monitoring_parameter_choices". */
export type Monitoring_Parameter_Choices_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  monitoring_parameter?: InputMaybe<Monitoring_Parameter_Order_By>;
  order?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: monitoring_parameter_choices */
export type Monitoring_Parameter_Choices_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "monitoring_parameter_choices" */
export enum Monitoring_Parameter_Choices_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  ParameterId = 'parameter_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Monitoring_Parameter_Choices_Stddev_Fields = {
  __typename?: 'monitoring_parameter_choices_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Monitoring_Parameter_Choices_Stddev_Pop_Fields = {
  __typename?: 'monitoring_parameter_choices_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Monitoring_Parameter_Choices_Stddev_Samp_Fields = {
  __typename?: 'monitoring_parameter_choices_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Monitoring_Parameter_Choices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Monitoring_Parameter_Choices_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Monitoring_Parameter_Choices_Sum_Fields = {
  __typename?: 'monitoring_parameter_choices_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "monitoring_parameter_choices" */
export enum Monitoring_Parameter_Choices_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  ParameterId = 'parameter_id',
  /** column name */
  Value = 'value'
}

export type Monitoring_Parameter_Choices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Monitoring_Parameter_Choices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Monitoring_Parameter_Choices_Set_Input>;
  where: Monitoring_Parameter_Choices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Monitoring_Parameter_Choices_Var_Pop_Fields = {
  __typename?: 'monitoring_parameter_choices_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Monitoring_Parameter_Choices_Var_Samp_Fields = {
  __typename?: 'monitoring_parameter_choices_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Monitoring_Parameter_Choices_Variance_Fields = {
  __typename?: 'monitoring_parameter_choices_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "monitoring_parameter_choices" */
export type Monitoring_Parameter_Choices_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "monitoring_parameter" */
export enum Monitoring_Parameter_Constraint {
  /** unique or primary key constraint on columns "name", "subcategory_id" */
  MonitoringParameterNameSubcategoryId_92a15fc9Uniq = 'monitoring_parameter_name_subcategory_id_92a15fc9_uniq',
  /** unique or primary key constraint on columns "id" */
  MonitoringParameterPkey = 'monitoring_parameter_pkey'
}

/** input type for incrementing numeric columns in table "monitoring_parameter" */
export type Monitoring_Parameter_Inc_Input = {
  max_samples?: InputMaybe<Scalars['Int']>;
  min_samples?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "monitoring_parameter" */
export type Monitoring_Parameter_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  cropmonitoring_parameters?: InputMaybe<Cropmonitoring_Parameter_Arr_Rel_Insert_Input>;
  data_type?: InputMaybe<Scalars['String']>;
  default_aggregation?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_samples?: InputMaybe<Scalars['Int']>;
  min_samples?: InputMaybe<Scalars['Int']>;
  monitoring_parameter_choices?: InputMaybe<Monitoring_Parameter_Choices_Arr_Rel_Insert_Input>;
  monitoring_parameter_unit_choices?: InputMaybe<Monitoring_Parameter_Unit_Choices_Arr_Rel_Insert_Input>;
  monitoring_subcategory?: InputMaybe<Monitoring_Subcategory_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  subcategory_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Monitoring_Parameter_Max_Fields = {
  __typename?: 'monitoring_parameter_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  data_type?: Maybe<Scalars['String']>;
  default_aggregation?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  max_samples?: Maybe<Scalars['Int']>;
  min_samples?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  subcategory_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "monitoring_parameter" */
export type Monitoring_Parameter_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  data_type?: InputMaybe<Order_By>;
  default_aggregation?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subcategory_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Monitoring_Parameter_Min_Fields = {
  __typename?: 'monitoring_parameter_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  data_type?: Maybe<Scalars['String']>;
  default_aggregation?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  max_samples?: Maybe<Scalars['Int']>;
  min_samples?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  subcategory_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "monitoring_parameter" */
export type Monitoring_Parameter_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  data_type?: InputMaybe<Order_By>;
  default_aggregation?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subcategory_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "monitoring_parameter" */
export type Monitoring_Parameter_Mutation_Response = {
  __typename?: 'monitoring_parameter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Monitoring_Parameter>;
};

/** input type for inserting object relation for remote table "monitoring_parameter" */
export type Monitoring_Parameter_Obj_Rel_Insert_Input = {
  data: Monitoring_Parameter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitoring_Parameter_On_Conflict>;
};

/** on_conflict condition type for table "monitoring_parameter" */
export type Monitoring_Parameter_On_Conflict = {
  constraint: Monitoring_Parameter_Constraint;
  update_columns?: Array<Monitoring_Parameter_Update_Column>;
  where?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
};

/** Ordering options when selecting data from "monitoring_parameter". */
export type Monitoring_Parameter_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  cropmonitoring_parameters_aggregate?: InputMaybe<Cropmonitoring_Parameter_Aggregate_Order_By>;
  data_type?: InputMaybe<Order_By>;
  default_aggregation?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
  monitoring_parameter_choices_aggregate?: InputMaybe<Monitoring_Parameter_Choices_Aggregate_Order_By>;
  monitoring_parameter_unit_choices_aggregate?: InputMaybe<Monitoring_Parameter_Unit_Choices_Aggregate_Order_By>;
  monitoring_subcategory?: InputMaybe<Monitoring_Subcategory_Order_By>;
  name?: InputMaybe<Order_By>;
  subcategory_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: monitoring_parameter */
export type Monitoring_Parameter_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "monitoring_parameter" */
export enum Monitoring_Parameter_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataType = 'data_type',
  /** column name */
  DefaultAggregation = 'default_aggregation',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxSamples = 'max_samples',
  /** column name */
  MinSamples = 'min_samples',
  /** column name */
  Name = 'name',
  /** column name */
  SubcategoryId = 'subcategory_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "monitoring_parameter" */
export type Monitoring_Parameter_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  data_type?: InputMaybe<Scalars['String']>;
  default_aggregation?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_samples?: InputMaybe<Scalars['Int']>;
  min_samples?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  subcategory_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Monitoring_Parameter_Stddev_Fields = {
  __typename?: 'monitoring_parameter_stddev_fields';
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "monitoring_parameter" */
export type Monitoring_Parameter_Stddev_Order_By = {
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Monitoring_Parameter_Stddev_Pop_Fields = {
  __typename?: 'monitoring_parameter_stddev_pop_fields';
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "monitoring_parameter" */
export type Monitoring_Parameter_Stddev_Pop_Order_By = {
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Monitoring_Parameter_Stddev_Samp_Fields = {
  __typename?: 'monitoring_parameter_stddev_samp_fields';
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "monitoring_parameter" */
export type Monitoring_Parameter_Stddev_Samp_Order_By = {
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "monitoring_parameter" */
export type Monitoring_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Monitoring_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Monitoring_Parameter_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  data_type?: InputMaybe<Scalars['String']>;
  default_aggregation?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_samples?: InputMaybe<Scalars['Int']>;
  min_samples?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  subcategory_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Monitoring_Parameter_Sum_Fields = {
  __typename?: 'monitoring_parameter_sum_fields';
  max_samples?: Maybe<Scalars['Int']>;
  min_samples?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "monitoring_parameter" */
export type Monitoring_Parameter_Sum_Order_By = {
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
};

/** columns and relationships of "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices = {
  __typename?: 'monitoring_parameter_unit_choices';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  monitoring_parameter: Monitoring_Parameter;
  parameter_id: Scalars['uuid'];
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit: Array<Si_Unit>;
  unit_id: Scalars['String'];
};


/** columns and relationships of "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_ChoicesUnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Monitoring_Parameter_Unit_Choicesunit>;
};

/** aggregated selection of "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Aggregate = {
  __typename?: 'monitoring_parameter_unit_choices_aggregate';
  aggregate?: Maybe<Monitoring_Parameter_Unit_Choices_Aggregate_Fields>;
  nodes: Array<Monitoring_Parameter_Unit_Choices>;
};

/** aggregate fields of "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Aggregate_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_aggregate_fields';
  avg?: Maybe<Monitoring_Parameter_Unit_Choices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Monitoring_Parameter_Unit_Choices_Max_Fields>;
  min?: Maybe<Monitoring_Parameter_Unit_Choices_Min_Fields>;
  stddev?: Maybe<Monitoring_Parameter_Unit_Choices_Stddev_Fields>;
  stddev_pop?: Maybe<Monitoring_Parameter_Unit_Choices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Monitoring_Parameter_Unit_Choices_Stddev_Samp_Fields>;
  sum?: Maybe<Monitoring_Parameter_Unit_Choices_Sum_Fields>;
  var_pop?: Maybe<Monitoring_Parameter_Unit_Choices_Var_Pop_Fields>;
  var_samp?: Maybe<Monitoring_Parameter_Unit_Choices_Var_Samp_Fields>;
  variance?: Maybe<Monitoring_Parameter_Unit_Choices_Variance_Fields>;
};


/** aggregate fields of "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Aggregate_Order_By = {
  avg?: InputMaybe<Monitoring_Parameter_Unit_Choices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Monitoring_Parameter_Unit_Choices_Max_Order_By>;
  min?: InputMaybe<Monitoring_Parameter_Unit_Choices_Min_Order_By>;
  stddev?: InputMaybe<Monitoring_Parameter_Unit_Choices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Monitoring_Parameter_Unit_Choices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Monitoring_Parameter_Unit_Choices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Monitoring_Parameter_Unit_Choices_Sum_Order_By>;
  var_pop?: InputMaybe<Monitoring_Parameter_Unit_Choices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Monitoring_Parameter_Unit_Choices_Var_Samp_Order_By>;
  variance?: InputMaybe<Monitoring_Parameter_Unit_Choices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Arr_Rel_Insert_Input = {
  data: Array<Monitoring_Parameter_Unit_Choices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitoring_Parameter_Unit_Choices_On_Conflict>;
};

/** aggregate avg on columns */
export type Monitoring_Parameter_Unit_Choices_Avg_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_avg_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Avg_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "monitoring_parameter_unit_choices". All fields are combined with a logical 'AND'. */
export type Monitoring_Parameter_Unit_Choices_Bool_Exp = {
  _and?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Bool_Exp>>;
  _not?: InputMaybe<Monitoring_Parameter_Unit_Choices_Bool_Exp>;
  _or?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  monitoring_parameter?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
  parameter_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "monitoring_parameter_unit_choices" */
export enum Monitoring_Parameter_Unit_Choices_Constraint {
  /** unique or primary key constraint on columns "unit_id", "parameter_id" */
  MonitoringParameterUniParameterIdUnitId_579c0ca5Uniq = 'monitoring_parameter_uni_parameter_id_unit_id_579c0ca5_uniq',
  /** unique or primary key constraint on columns "id" */
  MonitoringParameterUnitChoicesPkey = 'monitoring_parameter_unit_choices_pkey'
}

/** input type for incrementing numeric columns in table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Inc_Input = {
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  monitoring_parameter?: InputMaybe<Monitoring_Parameter_Obj_Rel_Insert_Input>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Monitoring_Parameter_Unit_Choices_Max_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_max_fields';
  id?: Maybe<Scalars['uuid']>;
  parameter_id?: Maybe<Scalars['uuid']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Monitoring_Parameter_Unit_Choices_Min_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_min_fields';
  id?: Maybe<Scalars['uuid']>;
  parameter_id?: Maybe<Scalars['uuid']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Mutation_Response = {
  __typename?: 'monitoring_parameter_unit_choices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Monitoring_Parameter_Unit_Choices>;
};

/** on_conflict condition type for table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_On_Conflict = {
  constraint: Monitoring_Parameter_Unit_Choices_Constraint;
  update_columns?: Array<Monitoring_Parameter_Unit_Choices_Update_Column>;
  where?: InputMaybe<Monitoring_Parameter_Unit_Choices_Bool_Exp>;
};

/** Ordering options when selecting data from "monitoring_parameter_unit_choices". */
export type Monitoring_Parameter_Unit_Choices_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  monitoring_parameter?: InputMaybe<Monitoring_Parameter_Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: monitoring_parameter_unit_choices */
export type Monitoring_Parameter_Unit_Choices_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "monitoring_parameter_unit_choices" */
export enum Monitoring_Parameter_Unit_Choices_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ParameterId = 'parameter_id',
  /** column name */
  SharedUnitId = 'shared_unit_id',
  /** column name */
  UnitId = 'unit_id'
}

/** input type for updating data in table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Monitoring_Parameter_Unit_Choices_Stddev_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_stddev_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Stddev_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Monitoring_Parameter_Unit_Choices_Stddev_Pop_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_stddev_pop_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Stddev_Pop_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Monitoring_Parameter_Unit_Choices_Stddev_Samp_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_stddev_samp_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Stddev_Samp_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Monitoring_Parameter_Unit_Choices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Monitoring_Parameter_Unit_Choices_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Monitoring_Parameter_Unit_Choices_Sum_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_sum_fields';
  shared_unit_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Sum_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** update columns of table "monitoring_parameter_unit_choices" */
export enum Monitoring_Parameter_Unit_Choices_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ParameterId = 'parameter_id',
  /** column name */
  SharedUnitId = 'shared_unit_id',
  /** column name */
  UnitId = 'unit_id'
}

export type Monitoring_Parameter_Unit_Choices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Monitoring_Parameter_Unit_Choices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Monitoring_Parameter_Unit_Choices_Set_Input>;
  where: Monitoring_Parameter_Unit_Choices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Monitoring_Parameter_Unit_Choices_Var_Pop_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_var_pop_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Var_Pop_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Monitoring_Parameter_Unit_Choices_Var_Samp_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_var_samp_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Var_Samp_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Monitoring_Parameter_Unit_Choices_Variance_Fields = {
  __typename?: 'monitoring_parameter_unit_choices_variance_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "monitoring_parameter_unit_choices" */
export type Monitoring_Parameter_Unit_Choices_Variance_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** update columns of table "monitoring_parameter" */
export enum Monitoring_Parameter_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataType = 'data_type',
  /** column name */
  DefaultAggregation = 'default_aggregation',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxSamples = 'max_samples',
  /** column name */
  MinSamples = 'min_samples',
  /** column name */
  Name = 'name',
  /** column name */
  SubcategoryId = 'subcategory_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Monitoring_Parameter_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Monitoring_Parameter_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Monitoring_Parameter_Set_Input>;
  where: Monitoring_Parameter_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Monitoring_Parameter_Var_Pop_Fields = {
  __typename?: 'monitoring_parameter_var_pop_fields';
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "monitoring_parameter" */
export type Monitoring_Parameter_Var_Pop_Order_By = {
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Monitoring_Parameter_Var_Samp_Fields = {
  __typename?: 'monitoring_parameter_var_samp_fields';
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "monitoring_parameter" */
export type Monitoring_Parameter_Var_Samp_Order_By = {
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Monitoring_Parameter_Variance_Fields = {
  __typename?: 'monitoring_parameter_variance_fields';
  max_samples?: Maybe<Scalars['Float']>;
  min_samples?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "monitoring_parameter" */
export type Monitoring_Parameter_Variance_Order_By = {
  max_samples?: InputMaybe<Order_By>;
  min_samples?: InputMaybe<Order_By>;
};

/** columns and relationships of "monitoring_record" */
export type Monitoring_Record = {
  __typename?: 'monitoring_record';
  _avg?: Maybe<Scalars['float8']>;
  _max?: Maybe<Scalars['float8']>;
  _min?: Maybe<Scalars['float8']>;
  _sum?: Maybe<Scalars['float8']>;
  aggregated_value?: Maybe<Scalars['String']>;
  aggregated_value_unit: Array<Si_Unit>;
  aggregated_value_unit_id?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  crop_parameter_id?: Maybe<Scalars['uuid']>;
  crop_year?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_accurate_location: Scalars['Boolean'];
  is_active: Scalars['Boolean'];
  is_applied: Scalars['Boolean'];
  location?: Maybe<Scalars['geometry']>;
  /** An array relationship */
  monitoring_record_attachments: Array<Monitoring_Record_Attachments>;
  /** An aggregate relationship */
  monitoring_record_attachments_aggregate: Monitoring_Record_Attachments_Aggregate;
  /** An array relationship */
  monitoring_samples: Array<Monitoring_Sample>;
  /** An aggregate relationship */
  monitoring_samples_aggregate: Monitoring_Sample_Aggregate;
  notes?: Maybe<Scalars['String']>;
  notify: Scalars['Boolean'];
  /** An array relationship */
  observation_notifications: Array<Observation_Notification>;
  /** An aggregate relationship */
  observation_notifications_aggregate: Observation_Notification_Aggregate;
  /** An object relationship */
  parameter?: Maybe<Cropmonitoring_Parameter>;
  percent_field_cover?: Maybe<Scalars['float8']>;
  planned_observation_id?: Maybe<Scalars['uuid']>;
  plot: Array<Plot>;
  plot_crop: Array<Plot_Crop>;
  plot_crop_id?: Maybe<Scalars['String']>;
  plot_id?: Maybe<Scalars['String']>;
  primary_growth_stage: Array<Primary_Growth_Stage>;
  primary_growth_stage_id?: Maybe<Scalars['String']>;
  record_date: Scalars['timestamptz'];
  reporting_value?: Maybe<Scalars['String']>;
  secondary_growth_stage: Array<Secondary_Growth_Stage>;
  secondary_growth_stage_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  shared_aggregated_value_unit?: Maybe<Shared_Entity>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_plot?: Maybe<Shared_Entity>;
  /** An object relationship */
  shared_plot_crop?: Maybe<Shared_Entity>;
  shared_plot_crop_id?: Maybe<Scalars['bigint']>;
  shared_plot_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_primary_growth_stage?: Maybe<Shared_Entity>;
  shared_primary_growth_stage_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_secondary_growth_stage?: Maybe<Shared_Entity>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  threads: Array<Thread>;
  /** An aggregate relationship */
  threads_aggregate: Thread_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
  voice_note_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordAggregated_Value_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Monitoring_Recordaggregated_Value_Unit>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Monitoring_Recordcreator>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordMonitoring_Record_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Attachments_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordMonitoring_Record_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Attachments_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordMonitoring_SamplesArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Sample_Order_By>>;
  where?: InputMaybe<Monitoring_Sample_Bool_Exp>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordMonitoring_Samples_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Sample_Order_By>>;
  where?: InputMaybe<Monitoring_Sample_Bool_Exp>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordObservation_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Observation_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Observation_Notification_Order_By>>;
  where?: InputMaybe<Observation_Notification_Bool_Exp>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordObservation_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Observation_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Observation_Notification_Order_By>>;
  where?: InputMaybe<Observation_Notification_Bool_Exp>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordPlotArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp_Remote_Rel_Monitoring_Recordplot>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp_Remote_Rel_Monitoring_Recordplot_Crop>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordPrimary_Growth_StageArgs = {
  distinct_on?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Primary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp_Remote_Rel_Monitoring_Recordprimary_Growth_Stage>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordSecondary_Growth_StageArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp_Remote_Rel_Monitoring_Recordsecondary_Growth_Stage>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordThreadsArgs = {
  distinct_on?: InputMaybe<Array<Thread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Thread_Order_By>>;
  where?: InputMaybe<Thread_Bool_Exp>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordThreads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Thread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Thread_Order_By>>;
  where?: InputMaybe<Thread_Bool_Exp>;
};


/** columns and relationships of "monitoring_record" */
export type Monitoring_RecordUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Monitoring_Recordupdater>;
};

/** aggregated selection of "monitoring_record" */
export type Monitoring_Record_Aggregate = {
  __typename?: 'monitoring_record_aggregate';
  aggregate?: Maybe<Monitoring_Record_Aggregate_Fields>;
  nodes: Array<Monitoring_Record>;
};

/** aggregate fields of "monitoring_record" */
export type Monitoring_Record_Aggregate_Fields = {
  __typename?: 'monitoring_record_aggregate_fields';
  avg?: Maybe<Monitoring_Record_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Monitoring_Record_Max_Fields>;
  min?: Maybe<Monitoring_Record_Min_Fields>;
  stddev?: Maybe<Monitoring_Record_Stddev_Fields>;
  stddev_pop?: Maybe<Monitoring_Record_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Monitoring_Record_Stddev_Samp_Fields>;
  sum?: Maybe<Monitoring_Record_Sum_Fields>;
  var_pop?: Maybe<Monitoring_Record_Var_Pop_Fields>;
  var_samp?: Maybe<Monitoring_Record_Var_Samp_Fields>;
  variance?: Maybe<Monitoring_Record_Variance_Fields>;
};


/** aggregate fields of "monitoring_record" */
export type Monitoring_Record_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Monitoring_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "monitoring_record_attachments" */
export type Monitoring_Record_Attachments = {
  __typename?: 'monitoring_record_attachments';
  /** An object relationship */
  fileupload: Fileupload;
  fileupload_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  monitoring_record: Monitoring_Record;
  monitoringrecord_id: Scalars['uuid'];
};

/** aggregated selection of "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Aggregate = {
  __typename?: 'monitoring_record_attachments_aggregate';
  aggregate?: Maybe<Monitoring_Record_Attachments_Aggregate_Fields>;
  nodes: Array<Monitoring_Record_Attachments>;
};

/** aggregate fields of "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Aggregate_Fields = {
  __typename?: 'monitoring_record_attachments_aggregate_fields';
  avg?: Maybe<Monitoring_Record_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Monitoring_Record_Attachments_Max_Fields>;
  min?: Maybe<Monitoring_Record_Attachments_Min_Fields>;
  stddev?: Maybe<Monitoring_Record_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Monitoring_Record_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Monitoring_Record_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Monitoring_Record_Attachments_Sum_Fields>;
  var_pop?: Maybe<Monitoring_Record_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Monitoring_Record_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Monitoring_Record_Attachments_Variance_Fields>;
};


/** aggregate fields of "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Monitoring_Record_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Monitoring_Record_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Monitoring_Record_Attachments_Max_Order_By>;
  min?: InputMaybe<Monitoring_Record_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Monitoring_Record_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Monitoring_Record_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Monitoring_Record_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Monitoring_Record_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Monitoring_Record_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Monitoring_Record_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Monitoring_Record_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Monitoring_Record_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitoring_Record_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Monitoring_Record_Attachments_Avg_Fields = {
  __typename?: 'monitoring_record_attachments_avg_fields';
  fileupload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Avg_Order_By = {
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "monitoring_record_attachments". All fields are combined with a logical 'AND'. */
export type Monitoring_Record_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Monitoring_Record_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Monitoring_Record_Attachments_Bool_Exp>>;
  fileupload?: InputMaybe<Fileupload_Bool_Exp>;
  fileupload_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  monitoring_record?: InputMaybe<Monitoring_Record_Bool_Exp>;
  monitoringrecord_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "monitoring_record_attachments" */
export enum Monitoring_Record_Attachments_Constraint {
  /** unique or primary key constraint on columns "fileupload_id", "monitoringrecord_id" */
  MonitoringRecordAttachMonitoringrecordIdFile_7761ec92Uniq = 'monitoring_record_attach_monitoringrecord_id_file_7761ec92_uniq',
  /** unique or primary key constraint on columns "id" */
  MonitoringRecordAttachmentsPkey = 'monitoring_record_attachments_pkey'
}

/** input type for incrementing numeric columns in table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Inc_Input = {
  fileupload_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Insert_Input = {
  fileupload?: InputMaybe<Fileupload_Obj_Rel_Insert_Input>;
  fileupload_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  monitoring_record?: InputMaybe<Monitoring_Record_Obj_Rel_Insert_Input>;
  monitoringrecord_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Monitoring_Record_Attachments_Max_Fields = {
  __typename?: 'monitoring_record_attachments_max_fields';
  fileupload_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  monitoringrecord_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Max_Order_By = {
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitoringrecord_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Monitoring_Record_Attachments_Min_Fields = {
  __typename?: 'monitoring_record_attachments_min_fields';
  fileupload_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  monitoringrecord_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Min_Order_By = {
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitoringrecord_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Mutation_Response = {
  __typename?: 'monitoring_record_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Monitoring_Record_Attachments>;
};

/** on_conflict condition type for table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_On_Conflict = {
  constraint: Monitoring_Record_Attachments_Constraint;
  update_columns?: Array<Monitoring_Record_Attachments_Update_Column>;
  where?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "monitoring_record_attachments". */
export type Monitoring_Record_Attachments_Order_By = {
  fileupload?: InputMaybe<Fileupload_Order_By>;
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitoring_record?: InputMaybe<Monitoring_Record_Order_By>;
  monitoringrecord_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: monitoring_record_attachments */
export type Monitoring_Record_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "monitoring_record_attachments" */
export enum Monitoring_Record_Attachments_Select_Column {
  /** column name */
  FileuploadId = 'fileupload_id',
  /** column name */
  Id = 'id',
  /** column name */
  MonitoringrecordId = 'monitoringrecord_id'
}

/** input type for updating data in table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Set_Input = {
  fileupload_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  monitoringrecord_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Monitoring_Record_Attachments_Stddev_Fields = {
  __typename?: 'monitoring_record_attachments_stddev_fields';
  fileupload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Stddev_Order_By = {
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Monitoring_Record_Attachments_Stddev_Pop_Fields = {
  __typename?: 'monitoring_record_attachments_stddev_pop_fields';
  fileupload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Stddev_Pop_Order_By = {
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Monitoring_Record_Attachments_Stddev_Samp_Fields = {
  __typename?: 'monitoring_record_attachments_stddev_samp_fields';
  fileupload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Stddev_Samp_Order_By = {
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Monitoring_Record_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Monitoring_Record_Attachments_Stream_Cursor_Value_Input = {
  fileupload_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  monitoringrecord_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Monitoring_Record_Attachments_Sum_Fields = {
  __typename?: 'monitoring_record_attachments_sum_fields';
  fileupload_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Sum_Order_By = {
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "monitoring_record_attachments" */
export enum Monitoring_Record_Attachments_Update_Column {
  /** column name */
  FileuploadId = 'fileupload_id',
  /** column name */
  Id = 'id',
  /** column name */
  MonitoringrecordId = 'monitoringrecord_id'
}

export type Monitoring_Record_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Monitoring_Record_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Monitoring_Record_Attachments_Set_Input>;
  where: Monitoring_Record_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Monitoring_Record_Attachments_Var_Pop_Fields = {
  __typename?: 'monitoring_record_attachments_var_pop_fields';
  fileupload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Var_Pop_Order_By = {
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Monitoring_Record_Attachments_Var_Samp_Fields = {
  __typename?: 'monitoring_record_attachments_var_samp_fields';
  fileupload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Var_Samp_Order_By = {
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Monitoring_Record_Attachments_Variance_Fields = {
  __typename?: 'monitoring_record_attachments_variance_fields';
  fileupload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "monitoring_record_attachments" */
export type Monitoring_Record_Attachments_Variance_Order_By = {
  fileupload_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Monitoring_Record_Avg_Fields = {
  __typename?: 'monitoring_record_avg_fields';
  _avg?: Maybe<Scalars['Float']>;
  _max?: Maybe<Scalars['Float']>;
  _min?: Maybe<Scalars['Float']>;
  _sum?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "monitoring_record". All fields are combined with a logical 'AND'. */
export type Monitoring_Record_Bool_Exp = {
  _and?: InputMaybe<Array<Monitoring_Record_Bool_Exp>>;
  _avg?: InputMaybe<Float8_Comparison_Exp>;
  _max?: InputMaybe<Float8_Comparison_Exp>;
  _min?: InputMaybe<Float8_Comparison_Exp>;
  _not?: InputMaybe<Monitoring_Record_Bool_Exp>;
  _or?: InputMaybe<Array<Monitoring_Record_Bool_Exp>>;
  _sum?: InputMaybe<Float8_Comparison_Exp>;
  aggregated_value?: InputMaybe<String_Comparison_Exp>;
  aggregated_value_unit_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  crop_parameter_id?: InputMaybe<Uuid_Comparison_Exp>;
  crop_year?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_accurate_location?: InputMaybe<Boolean_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_applied?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Geometry_Comparison_Exp>;
  monitoring_record_attachments?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
  monitoring_samples?: InputMaybe<Monitoring_Sample_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  notify?: InputMaybe<Boolean_Comparison_Exp>;
  observation_notifications?: InputMaybe<Observation_Notification_Bool_Exp>;
  parameter?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
  percent_field_cover?: InputMaybe<Float8_Comparison_Exp>;
  planned_observation_id?: InputMaybe<Uuid_Comparison_Exp>;
  plot_crop_id?: InputMaybe<String_Comparison_Exp>;
  plot_id?: InputMaybe<String_Comparison_Exp>;
  primary_growth_stage_id?: InputMaybe<String_Comparison_Exp>;
  record_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  reporting_value?: InputMaybe<String_Comparison_Exp>;
  secondary_growth_stage_id?: InputMaybe<String_Comparison_Exp>;
  shared_aggregated_value_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_aggregated_value_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_plot?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_plot_crop?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_plot_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_plot_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_primary_growth_stage?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_primary_growth_stage_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_secondary_growth_stage?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_secondary_growth_stage_id?: InputMaybe<Bigint_Comparison_Exp>;
  threads?: InputMaybe<Thread_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  voice_note_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "monitoring_record" */
export enum Monitoring_Record_Constraint {
  /** unique or primary key constraint on columns "id" */
  MonitoringRecordPkey = 'monitoring_record_pkey'
}

/** input type for incrementing numeric columns in table "monitoring_record" */
export type Monitoring_Record_Inc_Input = {
  _avg?: InputMaybe<Scalars['float8']>;
  _max?: InputMaybe<Scalars['float8']>;
  _min?: InputMaybe<Scalars['float8']>;
  _sum?: InputMaybe<Scalars['float8']>;
  percent_field_cover?: InputMaybe<Scalars['float8']>;
  shared_aggregated_value_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_id?: InputMaybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  voice_note_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "monitoring_record" */
export type Monitoring_Record_Insert_Input = {
  _avg?: InputMaybe<Scalars['float8']>;
  _max?: InputMaybe<Scalars['float8']>;
  _min?: InputMaybe<Scalars['float8']>;
  _sum?: InputMaybe<Scalars['float8']>;
  aggregated_value?: InputMaybe<Scalars['String']>;
  aggregated_value_unit_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_parameter_id?: InputMaybe<Scalars['uuid']>;
  crop_year?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_accurate_location?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_applied?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geometry']>;
  monitoring_record_attachments?: InputMaybe<Monitoring_Record_Attachments_Arr_Rel_Insert_Input>;
  monitoring_samples?: InputMaybe<Monitoring_Sample_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  notify?: InputMaybe<Scalars['Boolean']>;
  observation_notifications?: InputMaybe<Observation_Notification_Arr_Rel_Insert_Input>;
  parameter?: InputMaybe<Cropmonitoring_Parameter_Obj_Rel_Insert_Input>;
  percent_field_cover?: InputMaybe<Scalars['float8']>;
  planned_observation_id?: InputMaybe<Scalars['uuid']>;
  plot_crop_id?: InputMaybe<Scalars['String']>;
  plot_id?: InputMaybe<Scalars['String']>;
  primary_growth_stage_id?: InputMaybe<Scalars['String']>;
  record_date?: InputMaybe<Scalars['timestamptz']>;
  reporting_value?: InputMaybe<Scalars['String']>;
  secondary_growth_stage_id?: InputMaybe<Scalars['String']>;
  shared_aggregated_value_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_aggregated_value_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_plot?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_plot_crop?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_id?: InputMaybe<Scalars['bigint']>;
  shared_primary_growth_stage?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_primary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  shared_secondary_growth_stage?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_secondary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  threads?: InputMaybe<Thread_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  voice_note_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Monitoring_Record_Max_Fields = {
  __typename?: 'monitoring_record_max_fields';
  _avg?: Maybe<Scalars['float8']>;
  _max?: Maybe<Scalars['float8']>;
  _min?: Maybe<Scalars['float8']>;
  _sum?: Maybe<Scalars['float8']>;
  aggregated_value?: Maybe<Scalars['String']>;
  aggregated_value_unit_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  crop_parameter_id?: Maybe<Scalars['uuid']>;
  crop_year?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  percent_field_cover?: Maybe<Scalars['float8']>;
  planned_observation_id?: Maybe<Scalars['uuid']>;
  plot_crop_id?: Maybe<Scalars['String']>;
  plot_id?: Maybe<Scalars['String']>;
  primary_growth_stage_id?: Maybe<Scalars['String']>;
  record_date?: Maybe<Scalars['timestamptz']>;
  reporting_value?: Maybe<Scalars['String']>;
  secondary_growth_stage_id?: Maybe<Scalars['String']>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['bigint']>;
  shared_plot_crop_id?: Maybe<Scalars['bigint']>;
  shared_plot_id?: Maybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  voice_note_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Monitoring_Record_Min_Fields = {
  __typename?: 'monitoring_record_min_fields';
  _avg?: Maybe<Scalars['float8']>;
  _max?: Maybe<Scalars['float8']>;
  _min?: Maybe<Scalars['float8']>;
  _sum?: Maybe<Scalars['float8']>;
  aggregated_value?: Maybe<Scalars['String']>;
  aggregated_value_unit_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  crop_parameter_id?: Maybe<Scalars['uuid']>;
  crop_year?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  percent_field_cover?: Maybe<Scalars['float8']>;
  planned_observation_id?: Maybe<Scalars['uuid']>;
  plot_crop_id?: Maybe<Scalars['String']>;
  plot_id?: Maybe<Scalars['String']>;
  primary_growth_stage_id?: Maybe<Scalars['String']>;
  record_date?: Maybe<Scalars['timestamptz']>;
  reporting_value?: Maybe<Scalars['String']>;
  secondary_growth_stage_id?: Maybe<Scalars['String']>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['bigint']>;
  shared_plot_crop_id?: Maybe<Scalars['bigint']>;
  shared_plot_id?: Maybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  voice_note_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "monitoring_record" */
export type Monitoring_Record_Mutation_Response = {
  __typename?: 'monitoring_record_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Monitoring_Record>;
};

/** input type for inserting object relation for remote table "monitoring_record" */
export type Monitoring_Record_Obj_Rel_Insert_Input = {
  data: Monitoring_Record_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitoring_Record_On_Conflict>;
};

/** on_conflict condition type for table "monitoring_record" */
export type Monitoring_Record_On_Conflict = {
  constraint: Monitoring_Record_Constraint;
  update_columns?: Array<Monitoring_Record_Update_Column>;
  where?: InputMaybe<Monitoring_Record_Bool_Exp>;
};

/** Ordering options when selecting data from "monitoring_record". */
export type Monitoring_Record_Order_By = {
  _avg?: InputMaybe<Order_By>;
  _max?: InputMaybe<Order_By>;
  _min?: InputMaybe<Order_By>;
  _sum?: InputMaybe<Order_By>;
  aggregated_value?: InputMaybe<Order_By>;
  aggregated_value_unit_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_parameter_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_accurate_location?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_applied?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  monitoring_record_attachments_aggregate?: InputMaybe<Monitoring_Record_Attachments_Aggregate_Order_By>;
  monitoring_samples_aggregate?: InputMaybe<Monitoring_Sample_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  notify?: InputMaybe<Order_By>;
  observation_notifications_aggregate?: InputMaybe<Observation_Notification_Aggregate_Order_By>;
  parameter?: InputMaybe<Cropmonitoring_Parameter_Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  planned_observation_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
  record_date?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  secondary_growth_stage_id?: InputMaybe<Order_By>;
  shared_aggregated_value_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_aggregated_value_unit_id?: InputMaybe<Order_By>;
  shared_plot?: InputMaybe<Shared_Entity_Order_By>;
  shared_plot_crop?: InputMaybe<Shared_Entity_Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage?: InputMaybe<Shared_Entity_Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage?: InputMaybe<Shared_Entity_Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  threads_aggregate?: InputMaybe<Thread_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: monitoring_record */
export type Monitoring_Record_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "monitoring_record" */
export enum Monitoring_Record_Select_Column {
  /** column name */
  Avg = '_avg',
  /** column name */
  Max = '_max',
  /** column name */
  Min = '_min',
  /** column name */
  Sum = '_sum',
  /** column name */
  AggregatedValue = 'aggregated_value',
  /** column name */
  AggregatedValueUnitId = 'aggregated_value_unit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropParameterId = 'crop_parameter_id',
  /** column name */
  CropYear = 'crop_year',
  /** column name */
  Id = 'id',
  /** column name */
  IsAccurateLocation = 'is_accurate_location',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApplied = 'is_applied',
  /** column name */
  Location = 'location',
  /** column name */
  Notes = 'notes',
  /** column name */
  Notify = 'notify',
  /** column name */
  PercentFieldCover = 'percent_field_cover',
  /** column name */
  PlannedObservationId = 'planned_observation_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  PrimaryGrowthStageId = 'primary_growth_stage_id',
  /** column name */
  RecordDate = 'record_date',
  /** column name */
  ReportingValue = 'reporting_value',
  /** column name */
  SecondaryGrowthStageId = 'secondary_growth_stage_id',
  /** column name */
  SharedAggregatedValueUnitId = 'shared_aggregated_value_unit_id',
  /** column name */
  SharedPlotCropId = 'shared_plot_crop_id',
  /** column name */
  SharedPlotId = 'shared_plot_id',
  /** column name */
  SharedPrimaryGrowthStageId = 'shared_primary_growth_stage_id',
  /** column name */
  SharedSecondaryGrowthStageId = 'shared_secondary_growth_stage_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VoiceNoteId = 'voice_note_id'
}

/** input type for updating data in table "monitoring_record" */
export type Monitoring_Record_Set_Input = {
  _avg?: InputMaybe<Scalars['float8']>;
  _max?: InputMaybe<Scalars['float8']>;
  _min?: InputMaybe<Scalars['float8']>;
  _sum?: InputMaybe<Scalars['float8']>;
  aggregated_value?: InputMaybe<Scalars['String']>;
  aggregated_value_unit_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_parameter_id?: InputMaybe<Scalars['uuid']>;
  crop_year?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_accurate_location?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_applied?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geometry']>;
  notes?: InputMaybe<Scalars['String']>;
  notify?: InputMaybe<Scalars['Boolean']>;
  percent_field_cover?: InputMaybe<Scalars['float8']>;
  planned_observation_id?: InputMaybe<Scalars['uuid']>;
  plot_crop_id?: InputMaybe<Scalars['String']>;
  plot_id?: InputMaybe<Scalars['String']>;
  primary_growth_stage_id?: InputMaybe<Scalars['String']>;
  record_date?: InputMaybe<Scalars['timestamptz']>;
  reporting_value?: InputMaybe<Scalars['String']>;
  secondary_growth_stage_id?: InputMaybe<Scalars['String']>;
  shared_aggregated_value_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_id?: InputMaybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  voice_note_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Monitoring_Record_Stddev_Fields = {
  __typename?: 'monitoring_record_stddev_fields';
  _avg?: Maybe<Scalars['Float']>;
  _max?: Maybe<Scalars['Float']>;
  _min?: Maybe<Scalars['Float']>;
  _sum?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Monitoring_Record_Stddev_Pop_Fields = {
  __typename?: 'monitoring_record_stddev_pop_fields';
  _avg?: Maybe<Scalars['Float']>;
  _max?: Maybe<Scalars['Float']>;
  _min?: Maybe<Scalars['Float']>;
  _sum?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Monitoring_Record_Stddev_Samp_Fields = {
  __typename?: 'monitoring_record_stddev_samp_fields';
  _avg?: Maybe<Scalars['Float']>;
  _max?: Maybe<Scalars['Float']>;
  _min?: Maybe<Scalars['Float']>;
  _sum?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "monitoring_record" */
export type Monitoring_Record_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Monitoring_Record_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Monitoring_Record_Stream_Cursor_Value_Input = {
  _avg?: InputMaybe<Scalars['float8']>;
  _max?: InputMaybe<Scalars['float8']>;
  _min?: InputMaybe<Scalars['float8']>;
  _sum?: InputMaybe<Scalars['float8']>;
  aggregated_value?: InputMaybe<Scalars['String']>;
  aggregated_value_unit_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_parameter_id?: InputMaybe<Scalars['uuid']>;
  crop_year?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_accurate_location?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_applied?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geometry']>;
  notes?: InputMaybe<Scalars['String']>;
  notify?: InputMaybe<Scalars['Boolean']>;
  percent_field_cover?: InputMaybe<Scalars['float8']>;
  planned_observation_id?: InputMaybe<Scalars['uuid']>;
  plot_crop_id?: InputMaybe<Scalars['String']>;
  plot_id?: InputMaybe<Scalars['String']>;
  primary_growth_stage_id?: InputMaybe<Scalars['String']>;
  record_date?: InputMaybe<Scalars['timestamptz']>;
  reporting_value?: InputMaybe<Scalars['String']>;
  secondary_growth_stage_id?: InputMaybe<Scalars['String']>;
  shared_aggregated_value_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_id?: InputMaybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  voice_note_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Monitoring_Record_Sum_Fields = {
  __typename?: 'monitoring_record_sum_fields';
  _avg?: Maybe<Scalars['float8']>;
  _max?: Maybe<Scalars['float8']>;
  _min?: Maybe<Scalars['float8']>;
  _sum?: Maybe<Scalars['float8']>;
  percent_field_cover?: Maybe<Scalars['float8']>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['bigint']>;
  shared_plot_crop_id?: Maybe<Scalars['bigint']>;
  shared_plot_id?: Maybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['bigint']>;
  voice_note_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "monitoring_record" */
export enum Monitoring_Record_Update_Column {
  /** column name */
  Avg = '_avg',
  /** column name */
  Max = '_max',
  /** column name */
  Min = '_min',
  /** column name */
  Sum = '_sum',
  /** column name */
  AggregatedValue = 'aggregated_value',
  /** column name */
  AggregatedValueUnitId = 'aggregated_value_unit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropParameterId = 'crop_parameter_id',
  /** column name */
  CropYear = 'crop_year',
  /** column name */
  Id = 'id',
  /** column name */
  IsAccurateLocation = 'is_accurate_location',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApplied = 'is_applied',
  /** column name */
  Location = 'location',
  /** column name */
  Notes = 'notes',
  /** column name */
  Notify = 'notify',
  /** column name */
  PercentFieldCover = 'percent_field_cover',
  /** column name */
  PlannedObservationId = 'planned_observation_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  PrimaryGrowthStageId = 'primary_growth_stage_id',
  /** column name */
  RecordDate = 'record_date',
  /** column name */
  ReportingValue = 'reporting_value',
  /** column name */
  SecondaryGrowthStageId = 'secondary_growth_stage_id',
  /** column name */
  SharedAggregatedValueUnitId = 'shared_aggregated_value_unit_id',
  /** column name */
  SharedPlotCropId = 'shared_plot_crop_id',
  /** column name */
  SharedPlotId = 'shared_plot_id',
  /** column name */
  SharedPrimaryGrowthStageId = 'shared_primary_growth_stage_id',
  /** column name */
  SharedSecondaryGrowthStageId = 'shared_secondary_growth_stage_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VoiceNoteId = 'voice_note_id'
}

export type Monitoring_Record_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Monitoring_Record_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Monitoring_Record_Set_Input>;
  where: Monitoring_Record_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Monitoring_Record_Var_Pop_Fields = {
  __typename?: 'monitoring_record_var_pop_fields';
  _avg?: Maybe<Scalars['Float']>;
  _max?: Maybe<Scalars['Float']>;
  _min?: Maybe<Scalars['Float']>;
  _sum?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Monitoring_Record_Var_Samp_Fields = {
  __typename?: 'monitoring_record_var_samp_fields';
  _avg?: Maybe<Scalars['Float']>;
  _max?: Maybe<Scalars['Float']>;
  _min?: Maybe<Scalars['Float']>;
  _sum?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Monitoring_Record_Variance_Fields = {
  __typename?: 'monitoring_record_variance_fields';
  _avg?: Maybe<Scalars['Float']>;
  _max?: Maybe<Scalars['Float']>;
  _min?: Maybe<Scalars['Float']>;
  _sum?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  shared_aggregated_value_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "monitoring_sample" */
export type Monitoring_Sample = {
  __typename?: 'monitoring_sample';
  _choice_id?: Maybe<Scalars['uuid']>;
  _date?: Maybe<Scalars['date']>;
  _float?: Maybe<Scalars['float8']>;
  _int?: Maybe<Scalars['Int']>;
  _text?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  crop_parameter_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  cropmonitoring_parameter?: Maybe<Cropmonitoring_Parameter>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  monitoring_record: Monitoring_Record;
  notes?: Maybe<Scalars['String']>;
  observation_id: Scalars['uuid'];
  reporting_value?: Maybe<Scalars['float8']>;
  sample_no: Scalars['Int'];
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit: Array<Si_Unit>;
  unit_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
};


/** columns and relationships of "monitoring_sample" */
export type Monitoring_SampleCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Monitoring_Samplecreator>;
};


/** columns and relationships of "monitoring_sample" */
export type Monitoring_SampleUnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Monitoring_Sampleunit>;
};


/** columns and relationships of "monitoring_sample" */
export type Monitoring_SampleUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Monitoring_Sampleupdater>;
};

/** aggregated selection of "monitoring_sample" */
export type Monitoring_Sample_Aggregate = {
  __typename?: 'monitoring_sample_aggregate';
  aggregate?: Maybe<Monitoring_Sample_Aggregate_Fields>;
  nodes: Array<Monitoring_Sample>;
};

/** aggregate fields of "monitoring_sample" */
export type Monitoring_Sample_Aggregate_Fields = {
  __typename?: 'monitoring_sample_aggregate_fields';
  avg?: Maybe<Monitoring_Sample_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Monitoring_Sample_Max_Fields>;
  min?: Maybe<Monitoring_Sample_Min_Fields>;
  stddev?: Maybe<Monitoring_Sample_Stddev_Fields>;
  stddev_pop?: Maybe<Monitoring_Sample_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Monitoring_Sample_Stddev_Samp_Fields>;
  sum?: Maybe<Monitoring_Sample_Sum_Fields>;
  var_pop?: Maybe<Monitoring_Sample_Var_Pop_Fields>;
  var_samp?: Maybe<Monitoring_Sample_Var_Samp_Fields>;
  variance?: Maybe<Monitoring_Sample_Variance_Fields>;
};


/** aggregate fields of "monitoring_sample" */
export type Monitoring_Sample_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Monitoring_Sample_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "monitoring_sample" */
export type Monitoring_Sample_Aggregate_Order_By = {
  avg?: InputMaybe<Monitoring_Sample_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Monitoring_Sample_Max_Order_By>;
  min?: InputMaybe<Monitoring_Sample_Min_Order_By>;
  stddev?: InputMaybe<Monitoring_Sample_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Monitoring_Sample_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Monitoring_Sample_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Monitoring_Sample_Sum_Order_By>;
  var_pop?: InputMaybe<Monitoring_Sample_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Monitoring_Sample_Var_Samp_Order_By>;
  variance?: InputMaybe<Monitoring_Sample_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "monitoring_sample" */
export type Monitoring_Sample_Arr_Rel_Insert_Input = {
  data: Array<Monitoring_Sample_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitoring_Sample_On_Conflict>;
};

/** aggregate avg on columns */
export type Monitoring_Sample_Avg_Fields = {
  __typename?: 'monitoring_sample_avg_fields';
  _float?: Maybe<Scalars['Float']>;
  _int?: Maybe<Scalars['Float']>;
  reporting_value?: Maybe<Scalars['Float']>;
  sample_no?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "monitoring_sample" */
export type Monitoring_Sample_Avg_Order_By = {
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "monitoring_sample". All fields are combined with a logical 'AND'. */
export type Monitoring_Sample_Bool_Exp = {
  _and?: InputMaybe<Array<Monitoring_Sample_Bool_Exp>>;
  _choice_id?: InputMaybe<Uuid_Comparison_Exp>;
  _date?: InputMaybe<Date_Comparison_Exp>;
  _float?: InputMaybe<Float8_Comparison_Exp>;
  _int?: InputMaybe<Int_Comparison_Exp>;
  _not?: InputMaybe<Monitoring_Sample_Bool_Exp>;
  _or?: InputMaybe<Array<Monitoring_Sample_Bool_Exp>>;
  _text?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  crop_parameter_id?: InputMaybe<Uuid_Comparison_Exp>;
  cropmonitoring_parameter?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  monitoring_record?: InputMaybe<Monitoring_Record_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  observation_id?: InputMaybe<Uuid_Comparison_Exp>;
  reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  sample_no?: InputMaybe<Int_Comparison_Exp>;
  shared_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  unit_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "monitoring_sample" */
export enum Monitoring_Sample_Constraint {
  /** unique or primary key constraint on columns "observation_id", "crop_parameter_id", "sample_no" */
  MonitoringSampleObservationIdCropParaF9d1594bUniq = 'monitoring_sample_observation_id_crop_para_f9d1594b_uniq',
  /** unique or primary key constraint on columns "id" */
  MonitoringSamplePkey = 'monitoring_sample_pkey'
}

/** input type for incrementing numeric columns in table "monitoring_sample" */
export type Monitoring_Sample_Inc_Input = {
  _float?: InputMaybe<Scalars['float8']>;
  _int?: InputMaybe<Scalars['Int']>;
  reporting_value?: InputMaybe<Scalars['float8']>;
  sample_no?: InputMaybe<Scalars['Int']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "monitoring_sample" */
export type Monitoring_Sample_Insert_Input = {
  _choice_id?: InputMaybe<Scalars['uuid']>;
  _date?: InputMaybe<Scalars['date']>;
  _float?: InputMaybe<Scalars['float8']>;
  _int?: InputMaybe<Scalars['Int']>;
  _text?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_parameter_id?: InputMaybe<Scalars['uuid']>;
  cropmonitoring_parameter?: InputMaybe<Cropmonitoring_Parameter_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  monitoring_record?: InputMaybe<Monitoring_Record_Obj_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  observation_id?: InputMaybe<Scalars['uuid']>;
  reporting_value?: InputMaybe<Scalars['float8']>;
  sample_no?: InputMaybe<Scalars['Int']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Monitoring_Sample_Max_Fields = {
  __typename?: 'monitoring_sample_max_fields';
  _choice_id?: Maybe<Scalars['uuid']>;
  _date?: Maybe<Scalars['date']>;
  _float?: Maybe<Scalars['float8']>;
  _int?: Maybe<Scalars['Int']>;
  _text?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  crop_parameter_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['uuid']>;
  reporting_value?: Maybe<Scalars['float8']>;
  sample_no?: Maybe<Scalars['Int']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "monitoring_sample" */
export type Monitoring_Sample_Max_Order_By = {
  _choice_id?: InputMaybe<Order_By>;
  _date?: InputMaybe<Order_By>;
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  _text?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Monitoring_Sample_Min_Fields = {
  __typename?: 'monitoring_sample_min_fields';
  _choice_id?: Maybe<Scalars['uuid']>;
  _date?: Maybe<Scalars['date']>;
  _float?: Maybe<Scalars['float8']>;
  _int?: Maybe<Scalars['Int']>;
  _text?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  crop_parameter_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['uuid']>;
  reporting_value?: Maybe<Scalars['float8']>;
  sample_no?: Maybe<Scalars['Int']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "monitoring_sample" */
export type Monitoring_Sample_Min_Order_By = {
  _choice_id?: InputMaybe<Order_By>;
  _date?: InputMaybe<Order_By>;
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  _text?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "monitoring_sample" */
export type Monitoring_Sample_Mutation_Response = {
  __typename?: 'monitoring_sample_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Monitoring_Sample>;
};

/** on_conflict condition type for table "monitoring_sample" */
export type Monitoring_Sample_On_Conflict = {
  constraint: Monitoring_Sample_Constraint;
  update_columns?: Array<Monitoring_Sample_Update_Column>;
  where?: InputMaybe<Monitoring_Sample_Bool_Exp>;
};

/** Ordering options when selecting data from "monitoring_sample". */
export type Monitoring_Sample_Order_By = {
  _choice_id?: InputMaybe<Order_By>;
  _date?: InputMaybe<Order_By>;
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  _text?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_parameter_id?: InputMaybe<Order_By>;
  cropmonitoring_parameter?: InputMaybe<Cropmonitoring_Parameter_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  monitoring_record?: InputMaybe<Monitoring_Record_Order_By>;
  notes?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: monitoring_sample */
export type Monitoring_Sample_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "monitoring_sample" */
export enum Monitoring_Sample_Select_Column {
  /** column name */
  ChoiceId = '_choice_id',
  /** column name */
  Date = '_date',
  /** column name */
  Float = '_float',
  /** column name */
  Int = '_int',
  /** column name */
  Text = '_text',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropParameterId = 'crop_parameter_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Notes = 'notes',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  ReportingValue = 'reporting_value',
  /** column name */
  SampleNo = 'sample_no',
  /** column name */
  SharedUnitId = 'shared_unit_id',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "monitoring_sample" */
export type Monitoring_Sample_Set_Input = {
  _choice_id?: InputMaybe<Scalars['uuid']>;
  _date?: InputMaybe<Scalars['date']>;
  _float?: InputMaybe<Scalars['float8']>;
  _int?: InputMaybe<Scalars['Int']>;
  _text?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_parameter_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  observation_id?: InputMaybe<Scalars['uuid']>;
  reporting_value?: InputMaybe<Scalars['float8']>;
  sample_no?: InputMaybe<Scalars['Int']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Monitoring_Sample_Stddev_Fields = {
  __typename?: 'monitoring_sample_stddev_fields';
  _float?: Maybe<Scalars['Float']>;
  _int?: Maybe<Scalars['Float']>;
  reporting_value?: Maybe<Scalars['Float']>;
  sample_no?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "monitoring_sample" */
export type Monitoring_Sample_Stddev_Order_By = {
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Monitoring_Sample_Stddev_Pop_Fields = {
  __typename?: 'monitoring_sample_stddev_pop_fields';
  _float?: Maybe<Scalars['Float']>;
  _int?: Maybe<Scalars['Float']>;
  reporting_value?: Maybe<Scalars['Float']>;
  sample_no?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "monitoring_sample" */
export type Monitoring_Sample_Stddev_Pop_Order_By = {
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Monitoring_Sample_Stddev_Samp_Fields = {
  __typename?: 'monitoring_sample_stddev_samp_fields';
  _float?: Maybe<Scalars['Float']>;
  _int?: Maybe<Scalars['Float']>;
  reporting_value?: Maybe<Scalars['Float']>;
  sample_no?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "monitoring_sample" */
export type Monitoring_Sample_Stddev_Samp_Order_By = {
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "monitoring_sample" */
export type Monitoring_Sample_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Monitoring_Sample_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Monitoring_Sample_Stream_Cursor_Value_Input = {
  _choice_id?: InputMaybe<Scalars['uuid']>;
  _date?: InputMaybe<Scalars['date']>;
  _float?: InputMaybe<Scalars['float8']>;
  _int?: InputMaybe<Scalars['Int']>;
  _text?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_parameter_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  observation_id?: InputMaybe<Scalars['uuid']>;
  reporting_value?: InputMaybe<Scalars['float8']>;
  sample_no?: InputMaybe<Scalars['Int']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Monitoring_Sample_Sum_Fields = {
  __typename?: 'monitoring_sample_sum_fields';
  _float?: Maybe<Scalars['float8']>;
  _int?: Maybe<Scalars['Int']>;
  reporting_value?: Maybe<Scalars['float8']>;
  sample_no?: Maybe<Scalars['Int']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "monitoring_sample" */
export type Monitoring_Sample_Sum_Order_By = {
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** update columns of table "monitoring_sample" */
export enum Monitoring_Sample_Update_Column {
  /** column name */
  ChoiceId = '_choice_id',
  /** column name */
  Date = '_date',
  /** column name */
  Float = '_float',
  /** column name */
  Int = '_int',
  /** column name */
  Text = '_text',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropParameterId = 'crop_parameter_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Notes = 'notes',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  ReportingValue = 'reporting_value',
  /** column name */
  SampleNo = 'sample_no',
  /** column name */
  SharedUnitId = 'shared_unit_id',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Monitoring_Sample_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Monitoring_Sample_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Monitoring_Sample_Set_Input>;
  where: Monitoring_Sample_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Monitoring_Sample_Var_Pop_Fields = {
  __typename?: 'monitoring_sample_var_pop_fields';
  _float?: Maybe<Scalars['Float']>;
  _int?: Maybe<Scalars['Float']>;
  reporting_value?: Maybe<Scalars['Float']>;
  sample_no?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "monitoring_sample" */
export type Monitoring_Sample_Var_Pop_Order_By = {
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Monitoring_Sample_Var_Samp_Fields = {
  __typename?: 'monitoring_sample_var_samp_fields';
  _float?: Maybe<Scalars['Float']>;
  _int?: Maybe<Scalars['Float']>;
  reporting_value?: Maybe<Scalars['Float']>;
  sample_no?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "monitoring_sample" */
export type Monitoring_Sample_Var_Samp_Order_By = {
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Monitoring_Sample_Variance_Fields = {
  __typename?: 'monitoring_sample_variance_fields';
  _float?: Maybe<Scalars['Float']>;
  _int?: Maybe<Scalars['Float']>;
  reporting_value?: Maybe<Scalars['Float']>;
  sample_no?: Maybe<Scalars['Float']>;
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "monitoring_sample" */
export type Monitoring_Sample_Variance_Order_By = {
  _float?: InputMaybe<Order_By>;
  _int?: InputMaybe<Order_By>;
  reporting_value?: InputMaybe<Order_By>;
  sample_no?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "monitoring_subcategory" */
export type Monitoring_Subcategory = {
  __typename?: 'monitoring_subcategory';
  category_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  /** An object relationship */
  monitoring_category: Monitoring_Category;
  /** An array relationship */
  monitoring_parameters: Array<Monitoring_Parameter>;
  /** An aggregate relationship */
  monitoring_parameters_aggregate: Monitoring_Parameter_Aggregate;
  name: Scalars['String'];
  order: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
};


/** columns and relationships of "monitoring_subcategory" */
export type Monitoring_SubcategoryMonitoring_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
};


/** columns and relationships of "monitoring_subcategory" */
export type Monitoring_SubcategoryMonitoring_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
};

/** aggregated selection of "monitoring_subcategory" */
export type Monitoring_Subcategory_Aggregate = {
  __typename?: 'monitoring_subcategory_aggregate';
  aggregate?: Maybe<Monitoring_Subcategory_Aggregate_Fields>;
  nodes: Array<Monitoring_Subcategory>;
};

/** aggregate fields of "monitoring_subcategory" */
export type Monitoring_Subcategory_Aggregate_Fields = {
  __typename?: 'monitoring_subcategory_aggregate_fields';
  avg?: Maybe<Monitoring_Subcategory_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Monitoring_Subcategory_Max_Fields>;
  min?: Maybe<Monitoring_Subcategory_Min_Fields>;
  stddev?: Maybe<Monitoring_Subcategory_Stddev_Fields>;
  stddev_pop?: Maybe<Monitoring_Subcategory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Monitoring_Subcategory_Stddev_Samp_Fields>;
  sum?: Maybe<Monitoring_Subcategory_Sum_Fields>;
  var_pop?: Maybe<Monitoring_Subcategory_Var_Pop_Fields>;
  var_samp?: Maybe<Monitoring_Subcategory_Var_Samp_Fields>;
  variance?: Maybe<Monitoring_Subcategory_Variance_Fields>;
};


/** aggregate fields of "monitoring_subcategory" */
export type Monitoring_Subcategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Monitoring_Subcategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Aggregate_Order_By = {
  avg?: InputMaybe<Monitoring_Subcategory_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Monitoring_Subcategory_Max_Order_By>;
  min?: InputMaybe<Monitoring_Subcategory_Min_Order_By>;
  stddev?: InputMaybe<Monitoring_Subcategory_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Monitoring_Subcategory_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Monitoring_Subcategory_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Monitoring_Subcategory_Sum_Order_By>;
  var_pop?: InputMaybe<Monitoring_Subcategory_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Monitoring_Subcategory_Var_Samp_Order_By>;
  variance?: InputMaybe<Monitoring_Subcategory_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "monitoring_subcategory" */
export type Monitoring_Subcategory_Arr_Rel_Insert_Input = {
  data: Array<Monitoring_Subcategory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitoring_Subcategory_On_Conflict>;
};

/** aggregate avg on columns */
export type Monitoring_Subcategory_Avg_Fields = {
  __typename?: 'monitoring_subcategory_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "monitoring_subcategory". All fields are combined with a logical 'AND'. */
export type Monitoring_Subcategory_Bool_Exp = {
  _and?: InputMaybe<Array<Monitoring_Subcategory_Bool_Exp>>;
  _not?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
  _or?: InputMaybe<Array<Monitoring_Subcategory_Bool_Exp>>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  monitoring_category?: InputMaybe<Monitoring_Category_Bool_Exp>;
  monitoring_parameters?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "monitoring_subcategory" */
export enum Monitoring_Subcategory_Constraint {
  /** unique or primary key constraint on columns "name", "category_id" */
  MonitoringSubcategoryNameCategoryId_6bc9e7dfUniq = 'monitoring_subcategory_name_category_id_6bc9e7df_uniq',
  /** unique or primary key constraint on columns "id" */
  MonitoringSubcategoryPkey = 'monitoring_subcategory_pkey'
}

/** input type for incrementing numeric columns in table "monitoring_subcategory" */
export type Monitoring_Subcategory_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "monitoring_subcategory" */
export type Monitoring_Subcategory_Insert_Input = {
  category_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  monitoring_category?: InputMaybe<Monitoring_Category_Obj_Rel_Insert_Input>;
  monitoring_parameters?: InputMaybe<Monitoring_Parameter_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Monitoring_Subcategory_Max_Fields = {
  __typename?: 'monitoring_subcategory_max_fields';
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Monitoring_Subcategory_Min_Fields = {
  __typename?: 'monitoring_subcategory_min_fields';
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "monitoring_subcategory" */
export type Monitoring_Subcategory_Mutation_Response = {
  __typename?: 'monitoring_subcategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Monitoring_Subcategory>;
};

/** input type for inserting object relation for remote table "monitoring_subcategory" */
export type Monitoring_Subcategory_Obj_Rel_Insert_Input = {
  data: Monitoring_Subcategory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitoring_Subcategory_On_Conflict>;
};

/** on_conflict condition type for table "monitoring_subcategory" */
export type Monitoring_Subcategory_On_Conflict = {
  constraint: Monitoring_Subcategory_Constraint;
  update_columns?: Array<Monitoring_Subcategory_Update_Column>;
  where?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
};

/** Ordering options when selecting data from "monitoring_subcategory". */
export type Monitoring_Subcategory_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  monitoring_category?: InputMaybe<Monitoring_Category_Order_By>;
  monitoring_parameters_aggregate?: InputMaybe<Monitoring_Parameter_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: monitoring_subcategory */
export type Monitoring_Subcategory_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "monitoring_subcategory" */
export enum Monitoring_Subcategory_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "monitoring_subcategory" */
export type Monitoring_Subcategory_Set_Input = {
  category_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Monitoring_Subcategory_Stddev_Fields = {
  __typename?: 'monitoring_subcategory_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Monitoring_Subcategory_Stddev_Pop_Fields = {
  __typename?: 'monitoring_subcategory_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Monitoring_Subcategory_Stddev_Samp_Fields = {
  __typename?: 'monitoring_subcategory_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "monitoring_subcategory" */
export type Monitoring_Subcategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Monitoring_Subcategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Monitoring_Subcategory_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Monitoring_Subcategory_Sum_Fields = {
  __typename?: 'monitoring_subcategory_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "monitoring_subcategory" */
export enum Monitoring_Subcategory_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Monitoring_Subcategory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Monitoring_Subcategory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Monitoring_Subcategory_Set_Input>;
  where: Monitoring_Subcategory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Monitoring_Subcategory_Var_Pop_Fields = {
  __typename?: 'monitoring_subcategory_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Monitoring_Subcategory_Var_Samp_Fields = {
  __typename?: 'monitoring_subcategory_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Monitoring_Subcategory_Variance_Fields = {
  __typename?: 'monitoring_subcategory_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "monitoring_subcategory" */
export type Monitoring_Subcategory_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  accept_terms_and_conditions?: Maybe<AcceptingTermsAndConditions>;
  add_update_base_user?: Maybe<AddUpdateBaseUser>;
  add_update_dock_detail?: Maybe<AddUpdateDockDetailMutation>;
  add_update_order_transaction?: Maybe<AddUpdateOrderTransactionMutation>;
  add_update_receipt?: Maybe<AddUpdateReceipt>;
  add_update_trip_detail?: Maybe<UpdateTripDetailsMutation>;
  agent_login?: Maybe<AgentLogin>;
  broadcast_consents?: Maybe<BroadcastConsents>;
  bulk_update_base_user_companies?: Maybe<BulkUpdateBaseUserCompaniesMutation>;
  bulk_update_order?: Maybe<BulkUpdateOrderMutation>;
  create_agronomist_plot_crop_diary?: Maybe<CreateAgronomistPlotCropDiaryMutation>;
  create_expenses_config?: Maybe<CreateExpenseConfigMutation>;
  create_notification?: Maybe<CreateNotification>;
  /**
   * {
   *   "plot_crop_id": "",
   *   "record_date": "",
   *   "notes": "Notes",
   *   "attachments": [1, 2],
   *   "observations": [
   *     {
   *       "parameter_id": ""
   *       "recorded_value": "",
   *       "recorded_unit_id": "",
   *       "attachments": [2, 4],
   *       "notes": ""
   *     },
   *     {
   *       "parameter_id": ""
   *       "recorded_value": "",
   *       "recorded_unit_id": "",
   *       "attachments": []
   *     },
   *   ]
   * }
   */
  create_observation?: Maybe<CreateObservationMutation>;
  create_operation?: Maybe<CreateOperationMutation>;
  create_tnc_config?: Maybe<CreateTncConfigMutation>;
  /** delete data from the table: "action_log" */
  delete_action_log?: Maybe<Action_Log_Mutation_Response>;
  /** delete single row from the table: "action_log" */
  delete_action_log_by_pk?: Maybe<Action_Log>;
  /** delete data from the table: "active_ingredient" */
  delete_active_ingredient?: Maybe<Active_Ingredient_Mutation_Response>;
  /** delete single row from the table: "active_ingredient" */
  delete_active_ingredient_by_pk?: Maybe<Active_Ingredient>;
  /** delete data from the table: "actual_reading" */
  delete_actual_reading?: Maybe<Actual_Reading_Mutation_Response>;
  /** delete single row from the table: "actual_reading" */
  delete_actual_reading_by_pk?: Maybe<Actual_Reading>;
  /** delete data from the table: "address" */
  delete_address?: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "address" */
  delete_address_by_pk?: Maybe<Address>;
  /** delete data from the table: "advice_author_followers" */
  delete_advice_author_followers?: Maybe<Advice_Author_Followers_Mutation_Response>;
  /** delete single row from the table: "advice_author_followers" */
  delete_advice_author_followers_by_pk?: Maybe<Advice_Author_Followers>;
  /** delete data from the table: "advice_authors" */
  delete_advice_authors?: Maybe<Advice_Authors_Mutation_Response>;
  /** delete single row from the table: "advice_authors" */
  delete_advice_authors_by_pk?: Maybe<Advice_Authors>;
  /** delete data from the table: "agent" */
  delete_agent?: Maybe<Agent_Mutation_Response>;
  /** delete single row from the table: "agent" */
  delete_agent_by_pk?: Maybe<Agent>;
  /** delete data from the table: "agent_company" */
  delete_agent_company?: Maybe<Agent_Company_Mutation_Response>;
  /** delete single row from the table: "agent_company" */
  delete_agent_company_by_pk?: Maybe<Agent_Company>;
  /** delete data from the table: "answer_choice" */
  delete_answer_choice?: Maybe<Answer_Choice_Mutation_Response>;
  /** delete single row from the table: "answer_choice" */
  delete_answer_choice_by_pk?: Maybe<Answer_Choice>;
  /** delete data from the table: "application_product_unit" */
  delete_application_product_unit?: Maybe<Application_Product_Unit_Mutation_Response>;
  /** delete single row from the table: "application_product_unit" */
  delete_application_product_unit_by_pk?: Maybe<Application_Product_Unit>;
  /** delete data from the table: "article" */
  delete_article?: Maybe<Article_Mutation_Response>;
  /** delete data from the table: "article_attachments" */
  delete_article_attachments?: Maybe<Article_Attachments_Mutation_Response>;
  /** delete single row from the table: "article_attachments" */
  delete_article_attachments_by_pk?: Maybe<Article_Attachments>;
  /** delete data from the table: "article_authors" */
  delete_article_authors?: Maybe<Article_Authors_Mutation_Response>;
  /** delete single row from the table: "article_authors" */
  delete_article_authors_by_pk?: Maybe<Article_Authors>;
  /** delete single row from the table: "article" */
  delete_article_by_pk?: Maybe<Article>;
  /** delete data from the table: "article_categories" */
  delete_article_categories?: Maybe<Article_Categories_Mutation_Response>;
  /** delete single row from the table: "article_categories" */
  delete_article_categories_by_pk?: Maybe<Article_Categories>;
  /** delete data from the table: "article_category" */
  delete_article_category?: Maybe<Article_Category_Mutation_Response>;
  /** delete single row from the table: "article_category" */
  delete_article_category_by_pk?: Maybe<Article_Category>;
  /** delete data from the table: "article_crop_categories" */
  delete_article_crop_categories?: Maybe<Article_Crop_Categories_Mutation_Response>;
  /** delete single row from the table: "article_crop_categories" */
  delete_article_crop_categories_by_pk?: Maybe<Article_Crop_Categories>;
  /** delete data from the table: "article_crop_varieties" */
  delete_article_crop_varieties?: Maybe<Article_Crop_Varieties_Mutation_Response>;
  /** delete single row from the table: "article_crop_varieties" */
  delete_article_crop_varieties_by_pk?: Maybe<Article_Crop_Varieties>;
  /** delete data from the table: "article_crops" */
  delete_article_crops?: Maybe<Article_Crops_Mutation_Response>;
  /** delete single row from the table: "article_crops" */
  delete_article_crops_by_pk?: Maybe<Article_Crops>;
  /** delete data from the table: "article_favorites" */
  delete_article_favorites?: Maybe<Article_Favorites_Mutation_Response>;
  /** delete single row from the table: "article_favorites" */
  delete_article_favorites_by_pk?: Maybe<Article_Favorites>;
  /** delete data from the table: "article_likes" */
  delete_article_likes?: Maybe<Article_Likes_Mutation_Response>;
  /** delete single row from the table: "article_likes" */
  delete_article_likes_by_pk?: Maybe<Article_Likes>;
  /** delete data from the table: "article_regions" */
  delete_article_regions?: Maybe<Article_Regions_Mutation_Response>;
  /** delete single row from the table: "article_regions" */
  delete_article_regions_by_pk?: Maybe<Article_Regions>;
  /** delete data from the table: "article_series" */
  delete_article_series?: Maybe<Article_Series_Mutation_Response>;
  /** delete single row from the table: "article_series" */
  delete_article_series_by_pk?: Maybe<Article_Series>;
  /** delete data from the table: "article_subscription_package" */
  delete_article_subscription_package?: Maybe<Article_Subscription_Package_Mutation_Response>;
  /** delete single row from the table: "article_subscription_package" */
  delete_article_subscription_package_by_pk?: Maybe<Article_Subscription_Package>;
  /** delete data from the table: "article_subscriptions" */
  delete_article_subscriptions?: Maybe<Article_Subscriptions_Mutation_Response>;
  /** delete single row from the table: "article_subscriptions" */
  delete_article_subscriptions_by_pk?: Maybe<Article_Subscriptions>;
  /** delete data from the table: "article_user_group" */
  delete_article_user_group?: Maybe<Article_User_Group_Mutation_Response>;
  /** delete single row from the table: "article_user_group" */
  delete_article_user_group_by_pk?: Maybe<Article_User_Group>;
  /** delete data from the table: "article_views" */
  delete_article_views?: Maybe<Article_Views_Mutation_Response>;
  /** delete single row from the table: "article_views" */
  delete_article_views_by_pk?: Maybe<Article_Views>;
  /** delete data from the table: "assessment" */
  delete_assessment?: Maybe<Assessment_Mutation_Response>;
  /** delete single row from the table: "assessment" */
  delete_assessment_by_pk?: Maybe<Assessment>;
  /** delete data from the table: "assessment_question" */
  delete_assessment_question?: Maybe<Assessment_Question_Mutation_Response>;
  /** delete single row from the table: "assessment_question" */
  delete_assessment_question_by_pk?: Maybe<Assessment_Question>;
  /** delete data from the table: "attribute" */
  delete_attribute?: Maybe<Attribute_Mutation_Response>;
  /** delete single row from the table: "attribute" */
  delete_attribute_by_pk?: Maybe<Attribute>;
  /** delete data from the table: "attribute_choice" */
  delete_attribute_choice?: Maybe<Attribute_Choice_Mutation_Response>;
  /** delete single row from the table: "attribute_choice" */
  delete_attribute_choice_by_pk?: Maybe<Attribute_Choice>;
  /** delete data from the table: "auth_group" */
  delete_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** delete single row from the table: "auth_group" */
  delete_auth_group_by_pk?: Maybe<Auth_Group>;
  /** delete data from the table: "auth_group_permissions" */
  delete_auth_group_permissions?: Maybe<Auth_Group_Permissions_Mutation_Response>;
  /** delete single row from the table: "auth_group_permissions" */
  delete_auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** delete data from the table: "auth_permission" */
  delete_auth_permission?: Maybe<Auth_Permission_Mutation_Response>;
  /** delete single row from the table: "auth_permission" */
  delete_auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** delete data from the table: "base_user" */
  delete_base_user?: Maybe<Base_User_Mutation_Response>;
  /** delete data from the table: "base_user_address_book" */
  delete_base_user_address_book?: Maybe<Base_User_Address_Book_Mutation_Response>;
  /** delete single row from the table: "base_user_address_book" */
  delete_base_user_address_book_by_pk?: Maybe<Base_User_Address_Book>;
  /** delete single row from the table: "base_user" */
  delete_base_user_by_pk?: Maybe<Base_User>;
  /** delete data from the table: "base_user_companies" */
  delete_base_user_companies?: Maybe<Base_User_Companies_Mutation_Response>;
  /** delete single row from the table: "base_user_companies" */
  delete_base_user_companies_by_pk?: Maybe<Base_User_Companies>;
  /** delete data from the table: "base_user_departments" */
  delete_base_user_departments?: Maybe<Base_User_Departments_Mutation_Response>;
  /** delete single row from the table: "base_user_departments" */
  delete_base_user_departments_by_pk?: Maybe<Base_User_Departments>;
  /** delete data from the table: "base_user_groups" */
  delete_base_user_groups?: Maybe<Base_User_Groups_Mutation_Response>;
  /** delete single row from the table: "base_user_groups" */
  delete_base_user_groups_by_pk?: Maybe<Base_User_Groups>;
  /** delete data from the table: "base_user_network" */
  delete_base_user_network?: Maybe<Base_User_Network_Mutation_Response>;
  /** delete single row from the table: "base_user_network" */
  delete_base_user_network_by_pk?: Maybe<Base_User_Network>;
  /** delete data from the table: "base_user_user_permissions" */
  delete_base_user_user_permissions?: Maybe<Base_User_User_Permissions_Mutation_Response>;
  /** delete single row from the table: "base_user_user_permissions" */
  delete_base_user_user_permissions_by_pk?: Maybe<Base_User_User_Permissions>;
  /** delete data from the table: "business" */
  delete_business?: Maybe<Business_Mutation_Response>;
  /** delete single row from the table: "business" */
  delete_business_by_pk?: Maybe<Business>;
  /** delete data from the table: "business_commodities_supplied" */
  delete_business_commodities_supplied?: Maybe<Business_Commodities_Supplied_Mutation_Response>;
  /** delete single row from the table: "business_commodities_supplied" */
  delete_business_commodities_supplied_by_pk?: Maybe<Business_Commodities_Supplied>;
  /** delete data from the table: "business_companies" */
  delete_business_companies?: Maybe<Business_Companies_Mutation_Response>;
  /** delete single row from the table: "business_companies" */
  delete_business_companies_by_pk?: Maybe<Business_Companies>;
  /** delete data from the table: "business_group" */
  delete_business_group?: Maybe<Business_Group_Mutation_Response>;
  /** delete single row from the table: "business_group" */
  delete_business_group_by_pk?: Maybe<Business_Group>;
  /** delete data from the table: "business_group_network" */
  delete_business_group_network?: Maybe<Business_Group_Network_Mutation_Response>;
  /** delete single row from the table: "business_group_network" */
  delete_business_group_network_by_pk?: Maybe<Business_Group_Network>;
  /** delete data from the table: "business_groups" */
  delete_business_groups?: Maybe<Business_Groups_Mutation_Response>;
  /** delete single row from the table: "business_groups" */
  delete_business_groups_by_pk?: Maybe<Business_Groups>;
  /** delete data from the table: "business_network" */
  delete_business_network?: Maybe<Business_Network_Mutation_Response>;
  /** delete single row from the table: "business_network" */
  delete_business_network_by_pk?: Maybe<Business_Network>;
  /** delete data from the table: "business_secondary_pocs" */
  delete_business_secondary_pocs?: Maybe<Business_Secondary_Pocs_Mutation_Response>;
  /** delete single row from the table: "business_secondary_pocs" */
  delete_business_secondary_pocs_by_pk?: Maybe<Business_Secondary_Pocs>;
  /** delete single row from the table: "shared_entity" */
  delete_by_pk_care_shared_entity?: Maybe<Care_Shared_Entity>;
  /** delete data from the table: "shared_entity" */
  delete_care_shared_entity?: Maybe<Care_Shared_Entity_Mutation_Response>;
  /** delete data from the table: "category" */
  delete_category?: Maybe<Category_Mutation_Response>;
  /** delete single row from the table: "category" */
  delete_category_by_pk?: Maybe<Category>;
  /** delete data from the table: "certificate_issuer" */
  delete_certificate_issuer?: Maybe<Certificate_Issuer_Mutation_Response>;
  /** delete single row from the table: "certificate_issuer" */
  delete_certificate_issuer_by_pk?: Maybe<Certificate_Issuer>;
  /** delete data from the table: "certification" */
  delete_certification?: Maybe<Certification_Mutation_Response>;
  /** delete single row from the table: "certification" */
  delete_certification_by_pk?: Maybe<Certification>;
  /** delete data from the table: "comment" */
  delete_comment?: Maybe<Comment_Mutation_Response>;
  /** delete single row from the table: "comment" */
  delete_comment_by_pk?: Maybe<Comment>;
  /** delete data from the table: "commodity" */
  delete_commodity?: Maybe<Commodity_Mutation_Response>;
  /** delete single row from the table: "commodity" */
  delete_commodity_by_pk?: Maybe<Commodity>;
  /** delete data from the table: "commodity_variety" */
  delete_commodity_variety?: Maybe<Commodity_Variety_Mutation_Response>;
  /** delete single row from the table: "commodity_variety" */
  delete_commodity_variety_by_pk?: Maybe<Commodity_Variety>;
  /** delete data from the table: "commodity_variety_secondary_groups" */
  delete_commodity_variety_secondary_groups?: Maybe<Commodity_Variety_Secondary_Groups_Mutation_Response>;
  /** delete single row from the table: "commodity_variety_secondary_groups" */
  delete_commodity_variety_secondary_groups_by_pk?: Maybe<Commodity_Variety_Secondary_Groups>;
  /** delete data from the table: "common_fileupload" */
  delete_common_fileupload?: Maybe<Common_Fileupload_Mutation_Response>;
  /** delete single row from the table: "common_fileupload" */
  delete_common_fileupload_by_pk?: Maybe<Common_Fileupload>;
  /** delete data from the table: "company" */
  delete_company?: Maybe<Company_Mutation_Response>;
  /** delete single row from the table: "company" */
  delete_company_by_pk?: Maybe<Company>;
  /** delete data from the table: "cost_item" */
  delete_cost_item?: Maybe<Cost_Item_Mutation_Response>;
  /** delete single row from the table: "cost_item" */
  delete_cost_item_by_pk?: Maybe<Cost_Item>;
  /** delete data from the table: "crop" */
  delete_crop?: Maybe<Crop_Mutation_Response>;
  /** delete single row from the table: "crop" */
  delete_crop_by_pk?: Maybe<Crop>;
  /** delete data from the table: "crop_fertilisers" */
  delete_crop_fertilisers?: Maybe<Crop_Fertilisers_Mutation_Response>;
  /** delete single row from the table: "crop_fertilisers" */
  delete_crop_fertilisers_by_pk?: Maybe<Crop_Fertilisers>;
  /** delete data from the table: "crop_group" */
  delete_crop_group?: Maybe<Crop_Group_Mutation_Response>;
  /** delete single row from the table: "crop_group" */
  delete_crop_group_by_pk?: Maybe<Crop_Group>;
  /** delete data from the table: "crop_infestation" */
  delete_crop_infestation?: Maybe<Crop_Infestation_Mutation_Response>;
  /** delete data from the table: "crop_infestation_attachment" */
  delete_crop_infestation_attachment?: Maybe<Crop_Infestation_Attachment_Mutation_Response>;
  /** delete single row from the table: "crop_infestation_attachment" */
  delete_crop_infestation_attachment_by_pk?: Maybe<Crop_Infestation_Attachment>;
  /** delete single row from the table: "crop_infestation" */
  delete_crop_infestation_by_pk?: Maybe<Crop_Infestation>;
  /** delete data from the table: "crop_milestone" */
  delete_crop_milestone?: Maybe<Crop_Milestone_Mutation_Response>;
  /** delete single row from the table: "crop_milestone" */
  delete_crop_milestone_by_pk?: Maybe<Crop_Milestone>;
  /** delete data from the table: "crop_operation_methods" */
  delete_crop_operation_methods?: Maybe<Crop_Operation_Methods_Mutation_Response>;
  /** delete single row from the table: "crop_operation_methods" */
  delete_crop_operation_methods_by_pk?: Maybe<Crop_Operation_Methods>;
  /** delete data from the table: "crop_pesticides" */
  delete_crop_pesticides?: Maybe<Crop_Pesticides_Mutation_Response>;
  /** delete single row from the table: "crop_pesticides" */
  delete_crop_pesticides_by_pk?: Maybe<Crop_Pesticides>;
  /** delete data from the table: "crop_variety" */
  delete_crop_variety?: Maybe<Crop_Variety_Mutation_Response>;
  /** delete single row from the table: "crop_variety" */
  delete_crop_variety_by_pk?: Maybe<Crop_Variety>;
  /** delete data from the table: "crop_variety_seeds" */
  delete_crop_variety_seeds?: Maybe<Crop_Variety_Seeds_Mutation_Response>;
  /** delete single row from the table: "crop_variety_seeds" */
  delete_crop_variety_seeds_by_pk?: Maybe<Crop_Variety_Seeds>;
  /** delete data from the table: "crop_year" */
  delete_crop_year?: Maybe<Crop_Year_Mutation_Response>;
  /** delete single row from the table: "crop_year" */
  delete_crop_year_by_pk?: Maybe<Crop_Year>;
  /** delete data from the table: "cropmonitoring_parameter" */
  delete_cropmonitoring_parameter?: Maybe<Cropmonitoring_Parameter_Mutation_Response>;
  /** delete single row from the table: "cropmonitoring_parameter" */
  delete_cropmonitoring_parameter_by_pk?: Maybe<Cropmonitoring_Parameter>;
  /** delete data from the table: "currency" */
  delete_currency?: Maybe<Currency_Mutation_Response>;
  /** delete single row from the table: "currency" */
  delete_currency_by_pk?: Maybe<Currency>;
  /** delete data from the table: "daily_actual_reading" */
  delete_daily_actual_reading?: Maybe<Daily_Actual_Reading_Mutation_Response>;
  /** delete single row from the table: "daily_actual_reading" */
  delete_daily_actual_reading_by_pk?: Maybe<Daily_Actual_Reading>;
  /** delete data from the table: "daily_forecast_reading" */
  delete_daily_forecast_reading?: Maybe<Daily_Forecast_Reading_Mutation_Response>;
  /** delete single row from the table: "daily_forecast_reading" */
  delete_daily_forecast_reading_by_pk?: Maybe<Daily_Forecast_Reading>;
  /** delete data from the table: "department" */
  delete_department?: Maybe<Department_Mutation_Response>;
  /** delete single row from the table: "department" */
  delete_department_by_pk?: Maybe<Department>;
  /** delete data from the table: "device" */
  delete_device?: Maybe<Device_Mutation_Response>;
  /** delete single row from the table: "device" */
  delete_device_by_pk?: Maybe<Device>;
  /** delete data from the table: "django_content_type" */
  delete_django_content_type?: Maybe<Django_Content_Type_Mutation_Response>;
  /** delete single row from the table: "django_content_type" */
  delete_django_content_type_by_pk?: Maybe<Django_Content_Type>;
  /** delete data from the table: "document" */
  delete_document?: Maybe<Document_Mutation_Response>;
  /** delete data from the table: "document_attachments" */
  delete_document_attachments?: Maybe<Document_Attachments_Mutation_Response>;
  /** delete single row from the table: "document_attachments" */
  delete_document_attachments_by_pk?: Maybe<Document_Attachments>;
  /** delete single row from the table: "document" */
  delete_document_by_pk?: Maybe<Document>;
  /** delete data from the table: "document_data" */
  delete_document_data?: Maybe<Document_Data_Mutation_Response>;
  /** delete single row from the table: "document_data" */
  delete_document_data_by_pk?: Maybe<Document_Data>;
  /** delete data from the table: "document_kind" */
  delete_document_kind?: Maybe<Document_Kind_Mutation_Response>;
  /** delete single row from the table: "document_kind" */
  delete_document_kind_by_pk?: Maybe<Document_Kind>;
  /** delete data from the table: "document_kind_data_field" */
  delete_document_kind_data_field?: Maybe<Document_Kind_Data_Field_Mutation_Response>;
  /** delete single row from the table: "document_kind_data_field" */
  delete_document_kind_data_field_by_pk?: Maybe<Document_Kind_Data_Field>;
  /** delete data from the table: "drip_irrigation_system" */
  delete_drip_irrigation_system?: Maybe<Drip_Irrigation_System_Mutation_Response>;
  /** delete single row from the table: "drip_irrigation_system" */
  delete_drip_irrigation_system_by_pk?: Maybe<Drip_Irrigation_System>;
  /** delete data from the table: "expense" */
  delete_expense?: Maybe<Expense_Mutation_Response>;
  /** delete single row from the table: "expense" */
  delete_expense_by_pk?: Maybe<Expense>;
  /** delete data from the table: "external_reference" */
  delete_external_reference?: Maybe<External_Reference_Mutation_Response>;
  /** delete single row from the table: "external_reference" */
  delete_external_reference_by_pk?: Maybe<External_Reference>;
  /** delete data from the table: "farm" */
  delete_farm?: Maybe<Farm_Mutation_Response>;
  /** delete single row from the table: "farm" */
  delete_farm_by_pk?: Maybe<Farm>;
  /** delete data from the table: "farm_network" */
  delete_farm_network?: Maybe<Farm_Network_Mutation_Response>;
  /** delete single row from the table: "farm_network" */
  delete_farm_network_by_pk?: Maybe<Farm_Network>;
  /** delete data from the table: "field" */
  delete_field?: Maybe<Field_Mutation_Response>;
  /** delete single row from the table: "field" */
  delete_field_by_pk?: Maybe<Field>;
  /** delete data from the table: "field_network" */
  delete_field_network?: Maybe<Field_Network_Mutation_Response>;
  /** delete single row from the table: "field_network" */
  delete_field_network_by_pk?: Maybe<Field_Network>;
  /** delete data from the table: "field_weather_location" */
  delete_field_weather_location?: Maybe<Field_Weather_Location_Mutation_Response>;
  /** delete single row from the table: "field_weather_location" */
  delete_field_weather_location_by_pk?: Maybe<Field_Weather_Location>;
  /** delete data from the table: "fileupload" */
  delete_fileupload?: Maybe<Fileupload_Mutation_Response>;
  /** delete single row from the table: "fileupload" */
  delete_fileupload_by_pk?: Maybe<Fileupload>;
  /** delete data from the table: "flood_irrigation_system" */
  delete_flood_irrigation_system?: Maybe<Flood_Irrigation_System_Mutation_Response>;
  /** delete single row from the table: "flood_irrigation_system" */
  delete_flood_irrigation_system_by_pk?: Maybe<Flood_Irrigation_System>;
  /** delete data from the table: "forecast_reading" */
  delete_forecast_reading?: Maybe<Forecast_Reading_Mutation_Response>;
  /** delete single row from the table: "forecast_reading" */
  delete_forecast_reading_by_pk?: Maybe<Forecast_Reading>;
  /** delete data from the table: "gateway" */
  delete_gateway?: Maybe<Gateway_Mutation_Response>;
  /** delete single row from the table: "gateway" */
  delete_gateway_by_pk?: Maybe<Gateway>;
  /** delete data from the table: "gateway_configuration" */
  delete_gateway_configuration?: Maybe<Gateway_Configuration_Mutation_Response>;
  /** delete single row from the table: "gateway_configuration" */
  delete_gateway_configuration_by_pk?: Maybe<Gateway_Configuration>;
  /** delete data from the table: "gateway_status" */
  delete_gateway_status?: Maybe<Gateway_Status_Mutation_Response>;
  /** delete single row from the table: "gateway_status" */
  delete_gateway_status_by_pk?: Maybe<Gateway_Status>;
  /** delete data from the table: "grade_price" */
  delete_grade_price?: Maybe<Grade_Price_Mutation_Response>;
  /** delete single row from the table: "grade_price" */
  delete_grade_price_by_pk?: Maybe<Grade_Price>;
  /** delete data from the table: "infestation" */
  delete_infestation?: Maybe<Infestation_Mutation_Response>;
  /** delete single row from the table: "infestation" */
  delete_infestation_by_pk?: Maybe<Infestation>;
  /** delete data from the table: "ingredient" */
  delete_ingredient?: Maybe<Ingredient_Mutation_Response>;
  /** delete single row from the table: "ingredient" */
  delete_ingredient_by_pk?: Maybe<Ingredient>;
  /** delete data from the table: "inst_sensor_reading" */
  delete_inst_sensor_reading?: Maybe<Inst_Sensor_Reading_Mutation_Response>;
  /** delete single row from the table: "inst_sensor_reading" */
  delete_inst_sensor_reading_by_pk?: Maybe<Inst_Sensor_Reading>;
  /** delete data from the table: "irrigation_system" */
  delete_irrigation_system?: Maybe<Irrigation_System_Mutation_Response>;
  /** delete single row from the table: "irrigation_system" */
  delete_irrigation_system_by_pk?: Maybe<Irrigation_System>;
  /** delete data from the table: "location_subscription" */
  delete_location_subscription?: Maybe<Location_Subscription_Mutation_Response>;
  /** delete single row from the table: "location_subscription" */
  delete_location_subscription_by_pk?: Maybe<Location_Subscription>;
  /** delete data from the table: "main_section" */
  delete_main_section?: Maybe<Main_Section_Mutation_Response>;
  /** delete single row from the table: "main_section" */
  delete_main_section_by_pk?: Maybe<Main_Section>;
  /** delete data from the table: "manufacturer" */
  delete_manufacturer?: Maybe<Manufacturer_Mutation_Response>;
  /** delete single row from the table: "manufacturer" */
  delete_manufacturer_by_pk?: Maybe<Manufacturer>;
  /** delete data from the table: "manufacturing_facility" */
  delete_manufacturing_facility?: Maybe<Manufacturing_Facility_Mutation_Response>;
  /** delete single row from the table: "manufacturing_facility" */
  delete_manufacturing_facility_by_pk?: Maybe<Manufacturing_Facility>;
  /** delete data from the table: "market" */
  delete_market?: Maybe<Market_Mutation_Response>;
  /** delete single row from the table: "market" */
  delete_market_by_pk?: Maybe<Market>;
  /** delete data from the table: "marketer" */
  delete_marketer?: Maybe<Marketer_Mutation_Response>;
  /** delete single row from the table: "marketer" */
  delete_marketer_by_pk?: Maybe<Marketer>;
  /** delete data from the table: "marketing_facility" */
  delete_marketing_facility?: Maybe<Marketing_Facility_Mutation_Response>;
  /** delete single row from the table: "marketing_facility" */
  delete_marketing_facility_by_pk?: Maybe<Marketing_Facility>;
  /** delete data from the table: "measure_of" */
  delete_measure_of?: Maybe<Measure_Of_Mutation_Response>;
  /** delete single row from the table: "measure_of" */
  delete_measure_of_by_pk?: Maybe<Measure_Of>;
  /** delete data from the table: "media" */
  delete_media?: Maybe<Media_Mutation_Response>;
  /** delete single row from the table: "media" */
  delete_media_by_pk?: Maybe<Media>;
  /** delete data from the table: "message" */
  delete_message?: Maybe<Message_Mutation_Response>;
  /** delete single row from the table: "message" */
  delete_message_by_pk?: Maybe<Message>;
  /** delete data from the table: "milestone" */
  delete_milestone?: Maybe<Milestone_Mutation_Response>;
  /** delete single row from the table: "milestone" */
  delete_milestone_by_pk?: Maybe<Milestone>;
  /** delete data from the table: "monitoring_category" */
  delete_monitoring_category?: Maybe<Monitoring_Category_Mutation_Response>;
  /** delete single row from the table: "monitoring_category" */
  delete_monitoring_category_by_pk?: Maybe<Monitoring_Category>;
  /** delete data from the table: "monitoring_parameter" */
  delete_monitoring_parameter?: Maybe<Monitoring_Parameter_Mutation_Response>;
  /** delete single row from the table: "monitoring_parameter" */
  delete_monitoring_parameter_by_pk?: Maybe<Monitoring_Parameter>;
  /** delete data from the table: "monitoring_parameter_choices" */
  delete_monitoring_parameter_choices?: Maybe<Monitoring_Parameter_Choices_Mutation_Response>;
  /** delete single row from the table: "monitoring_parameter_choices" */
  delete_monitoring_parameter_choices_by_pk?: Maybe<Monitoring_Parameter_Choices>;
  /** delete data from the table: "monitoring_parameter_unit_choices" */
  delete_monitoring_parameter_unit_choices?: Maybe<Monitoring_Parameter_Unit_Choices_Mutation_Response>;
  /** delete single row from the table: "monitoring_parameter_unit_choices" */
  delete_monitoring_parameter_unit_choices_by_pk?: Maybe<Monitoring_Parameter_Unit_Choices>;
  /** delete data from the table: "monitoring_record" */
  delete_monitoring_record?: Maybe<Monitoring_Record_Mutation_Response>;
  /** delete data from the table: "monitoring_record_attachments" */
  delete_monitoring_record_attachments?: Maybe<Monitoring_Record_Attachments_Mutation_Response>;
  /** delete single row from the table: "monitoring_record_attachments" */
  delete_monitoring_record_attachments_by_pk?: Maybe<Monitoring_Record_Attachments>;
  /** delete single row from the table: "monitoring_record" */
  delete_monitoring_record_by_pk?: Maybe<Monitoring_Record>;
  /** delete data from the table: "monitoring_sample" */
  delete_monitoring_sample?: Maybe<Monitoring_Sample_Mutation_Response>;
  /** delete single row from the table: "monitoring_sample" */
  delete_monitoring_sample_by_pk?: Maybe<Monitoring_Sample>;
  /** delete data from the table: "monitoring_subcategory" */
  delete_monitoring_subcategory?: Maybe<Monitoring_Subcategory_Mutation_Response>;
  /** delete single row from the table: "monitoring_subcategory" */
  delete_monitoring_subcategory_by_pk?: Maybe<Monitoring_Subcategory>;
  /** delete data from the table: "mutual_group" */
  delete_mutual_group?: Maybe<Mutual_Group_Mutation_Response>;
  /** delete single row from the table: "mutual_group" */
  delete_mutual_group_by_pk?: Maybe<Mutual_Group>;
  /** delete data from the table: "mutual_group_membership" */
  delete_mutual_group_membership?: Maybe<Mutual_Group_Membership_Mutation_Response>;
  /** delete single row from the table: "mutual_group_membership" */
  delete_mutual_group_membership_by_pk?: Maybe<Mutual_Group_Membership>;
  /** delete data from the table: "mutual_group_network" */
  delete_mutual_group_network?: Maybe<Mutual_Group_Network_Mutation_Response>;
  /** delete single row from the table: "mutual_group_network" */
  delete_mutual_group_network_by_pk?: Maybe<Mutual_Group_Network>;
  /** delete data from the table: "mutual_group_role" */
  delete_mutual_group_role?: Maybe<Mutual_Group_Role_Mutation_Response>;
  /** delete single row from the table: "mutual_group_role" */
  delete_mutual_group_role_by_pk?: Maybe<Mutual_Group_Role>;
  /** delete data from the table: "mutual_group_subscription_package" */
  delete_mutual_group_subscription_package?: Maybe<Mutual_Group_Subscription_Package_Mutation_Response>;
  /** delete single row from the table: "mutual_group_subscription_package" */
  delete_mutual_group_subscription_package_by_pk?: Maybe<Mutual_Group_Subscription_Package>;
  /** delete data from the table: "mutual_group_weather_station" */
  delete_mutual_group_weather_station?: Maybe<Mutual_Group_Weather_Station_Mutation_Response>;
  /** delete single row from the table: "mutual_group_weather_station" */
  delete_mutual_group_weather_station_by_pk?: Maybe<Mutual_Group_Weather_Station>;
  /** delete data from the table: "network" */
  delete_network?: Maybe<Network_Mutation_Response>;
  /** delete single row from the table: "network" */
  delete_network_by_pk?: Maybe<Network>;
  /** delete data from the table: "notification" */
  delete_notification?: Maybe<Notification_Mutation_Response>;
  /** delete single row from the table: "notification" */
  delete_notification_by_pk?: Maybe<Notification>;
  /** delete data from the table: "notification_category" */
  delete_notification_category?: Maybe<Notification_Category_Mutation_Response>;
  /** delete single row from the table: "notification_category" */
  delete_notification_category_by_pk?: Maybe<Notification_Category>;
  /** delete data from the table: "notification_template" */
  delete_notification_template?: Maybe<Notification_Template_Mutation_Response>;
  /** delete single row from the table: "notification_template" */
  delete_notification_template_by_pk?: Maybe<Notification_Template>;
  /** delete data from the table: "notification_template_distribution_region" */
  delete_notification_template_distribution_region?: Maybe<Notification_Template_Distribution_Region_Mutation_Response>;
  /** delete single row from the table: "notification_template_distribution_region" */
  delete_notification_template_distribution_region_by_pk?: Maybe<Notification_Template_Distribution_Region>;
  /** delete data from the table: "notification_template_distribution_team" */
  delete_notification_template_distribution_team?: Maybe<Notification_Template_Distribution_Team_Mutation_Response>;
  /** delete single row from the table: "notification_template_distribution_team" */
  delete_notification_template_distribution_team_by_pk?: Maybe<Notification_Template_Distribution_Team>;
  /** delete data from the table: "notification_template_distribution_user" */
  delete_notification_template_distribution_user?: Maybe<Notification_Template_Distribution_User_Mutation_Response>;
  /** delete single row from the table: "notification_template_distribution_user" */
  delete_notification_template_distribution_user_by_pk?: Maybe<Notification_Template_Distribution_User>;
  /** delete data from the table: "nutrients" */
  delete_nutrients?: Maybe<Nutrients_Mutation_Response>;
  /** delete single row from the table: "nutrients" */
  delete_nutrients_by_pk?: Maybe<Nutrients>;
  /** delete data from the table: "observation_notification" */
  delete_observation_notification?: Maybe<Observation_Notification_Mutation_Response>;
  /** delete single row from the table: "observation_notification" */
  delete_observation_notification_by_pk?: Maybe<Observation_Notification>;
  /** delete data from the table: "operation_attachments" */
  delete_operation_attachments?: Maybe<Operation_Attachments_Mutation_Response>;
  /** delete single row from the table: "operation_attachments" */
  delete_operation_attachments_by_pk?: Maybe<Operation_Attachments>;
  /** delete data from the table: "operation_cost" */
  delete_operation_cost?: Maybe<Operation_Cost_Mutation_Response>;
  /** delete single row from the table: "operation_cost" */
  delete_operation_cost_by_pk?: Maybe<Operation_Cost>;
  /** delete data from the table: "operation_methods" */
  delete_operation_methods?: Maybe<Operation_Methods_Mutation_Response>;
  /** delete single row from the table: "operation_methods" */
  delete_operation_methods_by_pk?: Maybe<Operation_Methods>;
  /** delete data from the table: "operation_product_types" */
  delete_operation_product_types?: Maybe<Operation_Product_Types_Mutation_Response>;
  /** delete single row from the table: "operation_product_types" */
  delete_operation_product_types_by_pk?: Maybe<Operation_Product_Types>;
  /** delete data from the table: "operations" */
  delete_operations?: Maybe<Operations_Mutation_Response>;
  /** delete data from the table: "operations_applied_fertiliser" */
  delete_operations_applied_fertiliser?: Maybe<Operations_Applied_Fertiliser_Mutation_Response>;
  /** delete single row from the table: "operations_applied_fertiliser" */
  delete_operations_applied_fertiliser_by_pk?: Maybe<Operations_Applied_Fertiliser>;
  /** delete data from the table: "operations_applied_pesticide" */
  delete_operations_applied_pesticide?: Maybe<Operations_Applied_Pesticide_Mutation_Response>;
  /** delete single row from the table: "operations_applied_pesticide" */
  delete_operations_applied_pesticide_by_pk?: Maybe<Operations_Applied_Pesticide>;
  /** delete single row from the table: "operations" */
  delete_operations_by_pk?: Maybe<Operations>;
  /** delete data from the table: "operations_fertiliser" */
  delete_operations_fertiliser?: Maybe<Operations_Fertiliser_Mutation_Response>;
  /** delete single row from the table: "operations_fertiliser" */
  delete_operations_fertiliser_by_pk?: Maybe<Operations_Fertiliser>;
  /** delete data from the table: "operations_harvest" */
  delete_operations_harvest?: Maybe<Operations_Harvest_Mutation_Response>;
  /** delete single row from the table: "operations_harvest" */
  delete_operations_harvest_by_pk?: Maybe<Operations_Harvest>;
  /** delete data from the table: "operations_harvest_output" */
  delete_operations_harvest_output?: Maybe<Operations_Harvest_Output_Mutation_Response>;
  /** delete single row from the table: "operations_harvest_output" */
  delete_operations_harvest_output_by_pk?: Maybe<Operations_Harvest_Output>;
  /** delete data from the table: "operations_interculture" */
  delete_operations_interculture?: Maybe<Operations_Interculture_Mutation_Response>;
  /** delete single row from the table: "operations_interculture" */
  delete_operations_interculture_by_pk?: Maybe<Operations_Interculture>;
  /** delete data from the table: "operations_irrigation" */
  delete_operations_irrigation?: Maybe<Operations_Irrigation_Mutation_Response>;
  /** delete single row from the table: "operations_irrigation" */
  delete_operations_irrigation_by_pk?: Maybe<Operations_Irrigation>;
  /** delete data from the table: "operations_land_prep" */
  delete_operations_land_prep?: Maybe<Operations_Land_Prep_Mutation_Response>;
  /** delete single row from the table: "operations_land_prep" */
  delete_operations_land_prep_by_pk?: Maybe<Operations_Land_Prep>;
  /** delete data from the table: "operations_pesticide" */
  delete_operations_pesticide?: Maybe<Operations_Pesticide_Mutation_Response>;
  /** delete single row from the table: "operations_pesticide" */
  delete_operations_pesticide_by_pk?: Maybe<Operations_Pesticide>;
  /** delete data from the table: "operations_sowing" */
  delete_operations_sowing?: Maybe<Operations_Sowing_Mutation_Response>;
  /** delete single row from the table: "operations_sowing" */
  delete_operations_sowing_by_pk?: Maybe<Operations_Sowing>;
  /** delete data from the table: "organisation" */
  delete_organisation?: Maybe<Organisation_Mutation_Response>;
  /** delete single row from the table: "organisation" */
  delete_organisation_by_pk?: Maybe<Organisation>;
  /** delete data from the table: "organisation_document_kind" */
  delete_organisation_document_kind?: Maybe<Organisation_Document_Kind_Mutation_Response>;
  /** delete single row from the table: "organisation_document_kind" */
  delete_organisation_document_kind_by_pk?: Maybe<Organisation_Document_Kind>;
  /** delete data from the table: "organisation_preferences" */
  delete_organisation_preferences?: Maybe<Organisation_Preferences_Mutation_Response>;
  /** delete single row from the table: "organisation_preferences" */
  delete_organisation_preferences_by_pk?: Maybe<Organisation_Preferences>;
  /** delete data from the table: "organisation_season" */
  delete_organisation_season?: Maybe<Organisation_Season_Mutation_Response>;
  /** delete single row from the table: "organisation_season" */
  delete_organisation_season_by_pk?: Maybe<Organisation_Season>;
  /** delete data from the table: "payment_detail" */
  delete_payment_detail?: Maybe<Payment_Detail_Mutation_Response>;
  /** delete data from the table: "payment_detail_attachments" */
  delete_payment_detail_attachments?: Maybe<Payment_Detail_Attachments_Mutation_Response>;
  /** delete single row from the table: "payment_detail_attachments" */
  delete_payment_detail_attachments_by_pk?: Maybe<Payment_Detail_Attachments>;
  /** delete single row from the table: "payment_detail" */
  delete_payment_detail_by_pk?: Maybe<Payment_Detail>;
  /** delete data from the table: "payment_method" */
  delete_payment_method?: Maybe<Payment_Method_Mutation_Response>;
  /** delete single row from the table: "payment_method" */
  delete_payment_method_by_pk?: Maybe<Payment_Method>;
  /** delete data from the table: "plot" */
  delete_plot?: Maybe<Plot_Mutation_Response>;
  /** delete single row from the table: "plot" */
  delete_plot_by_pk?: Maybe<Plot>;
  /** delete data from the table: "plot_crop" */
  delete_plot_crop?: Maybe<Plot_Crop_Mutation_Response>;
  /** delete data from the table: "plot_crop_agent" */
  delete_plot_crop_agent?: Maybe<Plot_Crop_Agent_Mutation_Response>;
  /** delete single row from the table: "plot_crop_agent" */
  delete_plot_crop_agent_by_pk?: Maybe<Plot_Crop_Agent>;
  /** delete single row from the table: "plot_crop" */
  delete_plot_crop_by_pk?: Maybe<Plot_Crop>;
  /** delete data from the table: "plot_crop_milestone" */
  delete_plot_crop_milestone?: Maybe<Plot_Crop_Milestone_Mutation_Response>;
  /** delete single row from the table: "plot_crop_milestone" */
  delete_plot_crop_milestone_by_pk?: Maybe<Plot_Crop_Milestone>;
  /** delete data from the table: "plot_crop_network" */
  delete_plot_crop_network?: Maybe<Plot_Crop_Network_Mutation_Response>;
  /** delete single row from the table: "plot_crop_network" */
  delete_plot_crop_network_by_pk?: Maybe<Plot_Crop_Network>;
  /** delete data from the table: "plot_network" */
  delete_plot_network?: Maybe<Plot_Network_Mutation_Response>;
  /** delete single row from the table: "plot_network" */
  delete_plot_network_by_pk?: Maybe<Plot_Network>;
  /** delete data from the table: "plot_status" */
  delete_plot_status?: Maybe<Plot_Status_Mutation_Response>;
  /** delete single row from the table: "plot_status" */
  delete_plot_status_by_pk?: Maybe<Plot_Status>;
  /** delete data from the table: "primary_growth_stage" */
  delete_primary_growth_stage?: Maybe<Primary_Growth_Stage_Mutation_Response>;
  /** delete single row from the table: "primary_growth_stage" */
  delete_primary_growth_stage_by_pk?: Maybe<Primary_Growth_Stage>;
  /** delete data from the table: "product" */
  delete_product?: Maybe<Product_Mutation_Response>;
  /** delete data from the table: "product_attachment" */
  delete_product_attachment?: Maybe<Product_Attachment_Mutation_Response>;
  /** delete single row from the table: "product_attachment" */
  delete_product_attachment_by_pk?: Maybe<Product_Attachment>;
  /** delete data from the table: "product_attribute" */
  delete_product_attribute?: Maybe<Product_Attribute_Mutation_Response>;
  /** delete single row from the table: "product_attribute" */
  delete_product_attribute_by_pk?: Maybe<Product_Attribute>;
  /** delete data from the table: "product_attribute_choice" */
  delete_product_attribute_choice?: Maybe<Product_Attribute_Choice_Mutation_Response>;
  /** delete single row from the table: "product_attribute_choice" */
  delete_product_attribute_choice_by_pk?: Maybe<Product_Attribute_Choice>;
  /** delete single row from the table: "product" */
  delete_product_by_pk?: Maybe<Product>;
  /** delete data from the table: "product_certification" */
  delete_product_certification?: Maybe<Product_Certification_Mutation_Response>;
  /** delete data from the table: "product_certification_attachment" */
  delete_product_certification_attachment?: Maybe<Product_Certification_Attachment_Mutation_Response>;
  /** delete single row from the table: "product_certification_attachment" */
  delete_product_certification_attachment_by_pk?: Maybe<Product_Certification_Attachment>;
  /** delete single row from the table: "product_certification" */
  delete_product_certification_by_pk?: Maybe<Product_Certification>;
  /** delete data from the table: "product_class" */
  delete_product_class?: Maybe<Product_Class_Mutation_Response>;
  /** delete single row from the table: "product_class" */
  delete_product_class_by_pk?: Maybe<Product_Class>;
  /** delete data from the table: "product_composition" */
  delete_product_composition?: Maybe<Product_Composition_Mutation_Response>;
  /** delete single row from the table: "product_composition" */
  delete_product_composition_by_pk?: Maybe<Product_Composition>;
  /** delete data from the table: "product_crop_association" */
  delete_product_crop_association?: Maybe<Product_Crop_Association_Mutation_Response>;
  /** delete single row from the table: "product_crop_association" */
  delete_product_crop_association_by_pk?: Maybe<Product_Crop_Association>;
  /** delete data from the table: "product_crop_infestation_recommendation" */
  delete_product_crop_infestation_recommendation?: Maybe<Product_Crop_Infestation_Recommendation_Mutation_Response>;
  /** delete single row from the table: "product_crop_infestation_recommendation" */
  delete_product_crop_infestation_recommendation_by_pk?: Maybe<Product_Crop_Infestation_Recommendation>;
  /** delete data from the table: "product_crop_nutrition_recommendation" */
  delete_product_crop_nutrition_recommendation?: Maybe<Product_Crop_Nutrition_Recommendation_Mutation_Response>;
  /** delete single row from the table: "product_crop_nutrition_recommendation" */
  delete_product_crop_nutrition_recommendation_by_pk?: Maybe<Product_Crop_Nutrition_Recommendation>;
  /** delete data from the table: "product_favourite" */
  delete_product_favourite?: Maybe<Product_Favourite_Mutation_Response>;
  /** delete single row from the table: "product_favourite" */
  delete_product_favourite_by_pk?: Maybe<Product_Favourite>;
  /** delete data from the table: "product_infestation" */
  delete_product_infestation?: Maybe<Product_Infestation_Mutation_Response>;
  /** delete single row from the table: "product_infestation" */
  delete_product_infestation_by_pk?: Maybe<Product_Infestation>;
  /** delete data from the table: "product_mainsection" */
  delete_product_mainsection?: Maybe<Product_Mainsection_Mutation_Response>;
  /** delete data from the table: "product_mainsection_attachment" */
  delete_product_mainsection_attachment?: Maybe<Product_Mainsection_Attachment_Mutation_Response>;
  /** delete single row from the table: "product_mainsection_attachment" */
  delete_product_mainsection_attachment_by_pk?: Maybe<Product_Mainsection_Attachment>;
  /** delete single row from the table: "product_mainsection" */
  delete_product_mainsection_by_pk?: Maybe<Product_Mainsection>;
  /** delete data from the table: "product_purchased" */
  delete_product_purchased?: Maybe<Product_Purchased_Mutation_Response>;
  /** delete single row from the table: "product_purchased" */
  delete_product_purchased_by_pk?: Maybe<Product_Purchased>;
  /** delete data from the table: "product_section" */
  delete_product_section?: Maybe<Product_Section_Mutation_Response>;
  /** delete data from the table: "product_section_attachment" */
  delete_product_section_attachment?: Maybe<Product_Section_Attachment_Mutation_Response>;
  /** delete single row from the table: "product_section_attachment" */
  delete_product_section_attachment_by_pk?: Maybe<Product_Section_Attachment>;
  /** delete single row from the table: "product_section" */
  delete_product_section_by_pk?: Maybe<Product_Section>;
  /** delete data from the table: "product_sku" */
  delete_product_sku?: Maybe<Product_Sku_Mutation_Response>;
  /** delete single row from the table: "product_sku" */
  delete_product_sku_by_pk?: Maybe<Product_Sku>;
  /** delete data from the table: "product_subsection" */
  delete_product_subsection?: Maybe<Product_Subsection_Mutation_Response>;
  /** delete data from the table: "product_subsection_attachment" */
  delete_product_subsection_attachment?: Maybe<Product_Subsection_Attachment_Mutation_Response>;
  /** delete single row from the table: "product_subsection_attachment" */
  delete_product_subsection_attachment_by_pk?: Maybe<Product_Subsection_Attachment>;
  /** delete single row from the table: "product_subsection" */
  delete_product_subsection_by_pk?: Maybe<Product_Subsection>;
  /** delete data from the table: "product_view" */
  delete_product_view?: Maybe<Product_View_Mutation_Response>;
  /** delete single row from the table: "product_view" */
  delete_product_view_by_pk?: Maybe<Product_View>;
  /** delete data from the table: "products" */
  delete_products?: Maybe<Products_Mutation_Response>;
  /** delete single row from the table: "products" */
  delete_products_by_pk?: Maybe<Products>;
  /** delete data from the table: "products_fertiliser" */
  delete_products_fertiliser?: Maybe<Products_Fertiliser_Mutation_Response>;
  /** delete single row from the table: "products_fertiliser" */
  delete_products_fertiliser_by_pk?: Maybe<Products_Fertiliser>;
  /** delete data from the table: "products_fertiliser_contents" */
  delete_products_fertiliser_contents?: Maybe<Products_Fertiliser_Contents_Mutation_Response>;
  /** delete single row from the table: "products_fertiliser_contents" */
  delete_products_fertiliser_contents_by_pk?: Maybe<Products_Fertiliser_Contents>;
  /** delete data from the table: "products_fertiliser_units" */
  delete_products_fertiliser_units?: Maybe<Products_Fertiliser_Units_Mutation_Response>;
  /** delete single row from the table: "products_fertiliser_units" */
  delete_products_fertiliser_units_by_pk?: Maybe<Products_Fertiliser_Units>;
  /** delete data from the table: "products_pesticide" */
  delete_products_pesticide?: Maybe<Products_Pesticide_Mutation_Response>;
  /** delete single row from the table: "products_pesticide" */
  delete_products_pesticide_by_pk?: Maybe<Products_Pesticide>;
  /** delete data from the table: "products_pesticide_contents" */
  delete_products_pesticide_contents?: Maybe<Products_Pesticide_Contents_Mutation_Response>;
  /** delete single row from the table: "products_pesticide_contents" */
  delete_products_pesticide_contents_by_pk?: Maybe<Products_Pesticide_Contents>;
  /** delete data from the table: "products_pesticide_units" */
  delete_products_pesticide_units?: Maybe<Products_Pesticide_Units_Mutation_Response>;
  /** delete single row from the table: "products_pesticide_units" */
  delete_products_pesticide_units_by_pk?: Maybe<Products_Pesticide_Units>;
  /** delete data from the table: "provider" */
  delete_provider?: Maybe<Provider_Mutation_Response>;
  /** delete single row from the table: "provider" */
  delete_provider_by_pk?: Maybe<Provider>;
  /** delete data from the table: "receipt" */
  delete_receipt?: Maybe<Receipt_Mutation_Response>;
  /** delete single row from the table: "receipt" */
  delete_receipt_by_pk?: Maybe<Receipt>;
  /** delete data from the table: "recommended_product" */
  delete_recommended_product?: Maybe<Recommended_Product_Mutation_Response>;
  /** delete single row from the table: "recommended_product" */
  delete_recommended_product_by_pk?: Maybe<Recommended_Product>;
  /** delete data from the table: "region" */
  delete_region?: Maybe<Region_Mutation_Response>;
  /** delete single row from the table: "region" */
  delete_region_by_pk?: Maybe<Region>;
  /** delete data from the table: "region_group" */
  delete_region_group?: Maybe<Region_Group_Mutation_Response>;
  /** delete single row from the table: "region_group" */
  delete_region_group_by_pk?: Maybe<Region_Group>;
  /** delete data from the table: "reward_configuration" */
  delete_reward_configuration?: Maybe<Reward_Configuration_Mutation_Response>;
  /** delete single row from the table: "reward_configuration" */
  delete_reward_configuration_by_pk?: Maybe<Reward_Configuration>;
  /** delete data from the table: "sap_si" */
  delete_sap_si?: Maybe<Sap_Si_Mutation_Response>;
  /** delete single row from the table: "sap_si" */
  delete_sap_si_by_pk?: Maybe<Sap_Si>;
  /** delete data from the table: "sap_si_map" */
  delete_sap_si_map?: Maybe<Sap_Si_Map_Mutation_Response>;
  /** delete single row from the table: "sap_si_map" */
  delete_sap_si_map_by_pk?: Maybe<Sap_Si_Map>;
  /** delete data from the table: "secondary_growth_stage" */
  delete_secondary_growth_stage?: Maybe<Secondary_Growth_Stage_Mutation_Response>;
  /** delete single row from the table: "secondary_growth_stage" */
  delete_secondary_growth_stage_by_pk?: Maybe<Secondary_Growth_Stage>;
  /** delete data from the table: "section" */
  delete_section?: Maybe<Section_Mutation_Response>;
  /** delete single row from the table: "section" */
  delete_section_by_pk?: Maybe<Section>;
  /** delete data from the table: "seeds" */
  delete_seeds?: Maybe<Seeds_Mutation_Response>;
  /** delete single row from the table: "seeds" */
  delete_seeds_by_pk?: Maybe<Seeds>;
  /** delete data from the table: "sellable_item" */
  delete_sellable_item?: Maybe<Sellable_Item_Mutation_Response>;
  /** delete single row from the table: "sellable_item" */
  delete_sellable_item_by_pk?: Maybe<Sellable_Item>;
  /** delete data from the table: "sellable_item_stock" */
  delete_sellable_item_stock?: Maybe<Sellable_Item_Stock_Mutation_Response>;
  /** delete single row from the table: "sellable_item_stock" */
  delete_sellable_item_stock_by_pk?: Maybe<Sellable_Item_Stock>;
  /** delete data from the table: "sensor" */
  delete_sensor?: Maybe<Sensor_Mutation_Response>;
  /** delete single row from the table: "sensor" */
  delete_sensor_by_pk?: Maybe<Sensor>;
  /** delete data from the table: "sensor_parameter" */
  delete_sensor_parameter?: Maybe<Sensor_Parameter_Mutation_Response>;
  /** delete single row from the table: "sensor_parameter" */
  delete_sensor_parameter_by_pk?: Maybe<Sensor_Parameter>;
  /** delete data from the table: "series" */
  delete_series?: Maybe<Series_Mutation_Response>;
  /** delete data from the table: "series_authors" */
  delete_series_authors?: Maybe<Series_Authors_Mutation_Response>;
  /** delete single row from the table: "series_authors" */
  delete_series_authors_by_pk?: Maybe<Series_Authors>;
  /** delete single row from the table: "series" */
  delete_series_by_pk?: Maybe<Series>;
  /** delete data from the table: "series_category" */
  delete_series_category?: Maybe<Series_Category_Mutation_Response>;
  /** delete single row from the table: "series_category" */
  delete_series_category_by_pk?: Maybe<Series_Category>;
  /** delete data from the table: "series_crops" */
  delete_series_crops?: Maybe<Series_Crops_Mutation_Response>;
  /** delete single row from the table: "series_crops" */
  delete_series_crops_by_pk?: Maybe<Series_Crops>;
  /** delete data from the table: "series_favorites" */
  delete_series_favorites?: Maybe<Series_Favorites_Mutation_Response>;
  /** delete single row from the table: "series_favorites" */
  delete_series_favorites_by_pk?: Maybe<Series_Favorites>;
  /** delete data from the table: "series_likes" */
  delete_series_likes?: Maybe<Series_Likes_Mutation_Response>;
  /** delete single row from the table: "series_likes" */
  delete_series_likes_by_pk?: Maybe<Series_Likes>;
  /** delete data from the table: "setu_weather_user" */
  delete_setu_weather_user?: Maybe<Setu_Weather_User_Mutation_Response>;
  /** delete single row from the table: "setu_weather_user" */
  delete_setu_weather_user_by_pk?: Maybe<Setu_Weather_User>;
  /** delete data from the table: "shared_entity" */
  delete_shared_entity?: Maybe<Shared_Entity_Mutation_Response>;
  /** delete single row from the table: "shared_entity" */
  delete_shared_entity_by_pk?: Maybe<Shared_Entity>;
  /** delete data from the table: "si_unit" */
  delete_si_unit?: Maybe<Si_Unit_Mutation_Response>;
  /** delete single row from the table: "si_unit" */
  delete_si_unit_by_pk?: Maybe<Si_Unit>;
  /** delete data from the table: "si_unit_measure" */
  delete_si_unit_measure?: Maybe<Si_Unit_Measure_Mutation_Response>;
  /** delete single row from the table: "si_unit_measure" */
  delete_si_unit_measure_by_pk?: Maybe<Si_Unit_Measure>;
  /** delete data from the table: "sku" */
  delete_sku?: Maybe<Sku_Mutation_Response>;
  /** delete single row from the table: "sku" */
  delete_sku_by_pk?: Maybe<Sku>;
  /** delete data from the table: "sku_kind" */
  delete_sku_kind?: Maybe<Sku_Kind_Mutation_Response>;
  /** delete single row from the table: "sku_kind" */
  delete_sku_kind_by_pk?: Maybe<Sku_Kind>;
  /** delete data from the table: "soil" */
  delete_soil?: Maybe<Soil_Mutation_Response>;
  /** delete single row from the table: "soil" */
  delete_soil_by_pk?: Maybe<Soil>;
  /** delete data from the table: "sprinkler_irrigation_system" */
  delete_sprinkler_irrigation_system?: Maybe<Sprinkler_Irrigation_System_Mutation_Response>;
  /** delete single row from the table: "sprinkler_irrigation_system" */
  delete_sprinkler_irrigation_system_by_pk?: Maybe<Sprinkler_Irrigation_System>;
  /** delete data from the table: "sub_section" */
  delete_sub_section?: Maybe<Sub_Section_Mutation_Response>;
  /** delete single row from the table: "sub_section" */
  delete_sub_section_by_pk?: Maybe<Sub_Section>;
  /** delete data from the table: "subcategory" */
  delete_subcategory?: Maybe<Subcategory_Mutation_Response>;
  /** delete single row from the table: "subcategory" */
  delete_subcategory_by_pk?: Maybe<Subcategory>;
  /** delete data from the table: "subscription_package_highlights" */
  delete_subscription_package_highlights?: Maybe<Subscription_Package_Highlights_Mutation_Response>;
  /** delete single row from the table: "subscription_package_highlights" */
  delete_subscription_package_highlights_by_pk?: Maybe<Subscription_Package_Highlights>;
  /** delete data from the table: "summary_sensor_reading" */
  delete_summary_sensor_reading?: Maybe<Summary_Sensor_Reading_Mutation_Response>;
  /** delete single row from the table: "summary_sensor_reading" */
  delete_summary_sensor_reading_by_pk?: Maybe<Summary_Sensor_Reading>;
  /** delete data from the table: "thread" */
  delete_thread?: Maybe<Thread_Mutation_Response>;
  /** delete single row from the table: "thread" */
  delete_thread_by_pk?: Maybe<Thread>;
  /** delete data from the table: "trade" */
  delete_trade?: Maybe<Trade_Mutation_Response>;
  /** delete single row from the table: "trade" */
  delete_trade_by_pk?: Maybe<Trade>;
  /** delete data from the table: "trade_commodity" */
  delete_trade_commodity?: Maybe<Trade_Commodity_Mutation_Response>;
  /** delete single row from the table: "trade_commodity" */
  delete_trade_commodity_by_pk?: Maybe<Trade_Commodity>;
  /** delete data from the table: "trade_item" */
  delete_trade_item?: Maybe<Trade_Item_Mutation_Response>;
  /** delete single row from the table: "trade_item" */
  delete_trade_item_by_pk?: Maybe<Trade_Item>;
  /** delete data from the table: "trade_region" */
  delete_trade_region?: Maybe<Trade_Region_Mutation_Response>;
  /** delete single row from the table: "trade_region" */
  delete_trade_region_by_pk?: Maybe<Trade_Region>;
  /** delete data from the table: "trade_transaction" */
  delete_trade_transaction?: Maybe<Trade_Transaction_Mutation_Response>;
  /** delete single row from the table: "trade_transaction" */
  delete_trade_transaction_by_pk?: Maybe<Trade_Transaction>;
  /** delete data from the table: "trade_transaction_summary" */
  delete_trade_transaction_summary?: Maybe<Trade_Transaction_Summary_Mutation_Response>;
  /** delete single row from the table: "trade_transaction_summary" */
  delete_trade_transaction_summary_by_pk?: Maybe<Trade_Transaction_Summary>;
  /** delete data from the table: "trade_unit" */
  delete_trade_unit?: Maybe<Trade_Unit_Mutation_Response>;
  /** delete single row from the table: "trade_unit" */
  delete_trade_unit_by_pk?: Maybe<Trade_Unit>;
  /** delete data from the table: "transaction_trend" */
  delete_transaction_trend?: Maybe<Transaction_Trend_Mutation_Response>;
  /** delete single row from the table: "transaction_trend" */
  delete_transaction_trend_by_pk?: Maybe<Transaction_Trend>;
  /** delete data from the table: "unit" */
  delete_unit?: Maybe<Unit_Mutation_Response>;
  /** delete single row from the table: "unit" */
  delete_unit_by_pk?: Maybe<Unit>;
  /** delete data from the table: "user_answer_choices" */
  delete_user_answer_choices?: Maybe<User_Answer_Choices_Mutation_Response>;
  /** delete single row from the table: "user_answer_choices" */
  delete_user_answer_choices_by_pk?: Maybe<User_Answer_Choices>;
  /** delete data from the table: "user_assessment_attempt" */
  delete_user_assessment_attempt?: Maybe<User_Assessment_Attempt_Mutation_Response>;
  /** delete single row from the table: "user_assessment_attempt" */
  delete_user_assessment_attempt_by_pk?: Maybe<User_Assessment_Attempt>;
  /** delete data from the table: "user_assessment_question_response" */
  delete_user_assessment_question_response?: Maybe<User_Assessment_Question_Response_Mutation_Response>;
  /** delete single row from the table: "user_assessment_question_response" */
  delete_user_assessment_question_response_by_pk?: Maybe<User_Assessment_Question_Response>;
  /** delete data from the table: "user_reward_history" */
  delete_user_reward_history?: Maybe<User_Reward_History_Mutation_Response>;
  /** delete single row from the table: "user_reward_history" */
  delete_user_reward_history_by_pk?: Maybe<User_Reward_History>;
  /** delete data from the table: "user_subscription_package" */
  delete_user_subscription_package?: Maybe<User_Subscription_Package_Mutation_Response>;
  /** delete single row from the table: "user_subscription_package" */
  delete_user_subscription_package_by_pk?: Maybe<User_Subscription_Package>;
  /** delete data from the table: "variety_grade" */
  delete_variety_grade?: Maybe<Variety_Grade_Mutation_Response>;
  /** delete single row from the table: "variety_grade" */
  delete_variety_grade_by_pk?: Maybe<Variety_Grade>;
  /** delete data from the table: "variety_grade_photos" */
  delete_variety_grade_photos?: Maybe<Variety_Grade_Photos_Mutation_Response>;
  /** delete single row from the table: "variety_grade_photos" */
  delete_variety_grade_photos_by_pk?: Maybe<Variety_Grade_Photos>;
  /** delete data from the table: "variety_group" */
  delete_variety_group?: Maybe<Variety_Group_Mutation_Response>;
  /** delete single row from the table: "variety_group" */
  delete_variety_group_by_pk?: Maybe<Variety_Group>;
  /** delete data from the table: "weather_location" */
  delete_weather_location?: Maybe<Weather_Location_Mutation_Response>;
  /** delete single row from the table: "weather_location" */
  delete_weather_location_by_pk?: Maybe<Weather_Location>;
  /** delete data from the table: "weather_reference" */
  delete_weather_reference?: Maybe<Weather_Reference_Mutation_Response>;
  /** delete single row from the table: "weather_reference" */
  delete_weather_reference_by_pk?: Maybe<Weather_Reference>;
  generate_agent_token?: Maybe<GenerateAgentToken>;
  generate_base_user_token?: Maybe<GenerateBaseUserToken>;
  generate_generic_token?: Maybe<GenerateGenericToken>;
  generate_invoices?: Maybe<GenerateInvoiceMutation>;
  generate_otp?: Maybe<GenerateOtp>;
  generate_trade_otp?: Maybe<GenerateTradeOtp>;
  /** insert data into the table: "action_log" */
  insert_action_log?: Maybe<Action_Log_Mutation_Response>;
  /** insert a single row into the table: "action_log" */
  insert_action_log_one?: Maybe<Action_Log>;
  /** insert data into the table: "active_ingredient" */
  insert_active_ingredient?: Maybe<Active_Ingredient_Mutation_Response>;
  /** insert a single row into the table: "active_ingredient" */
  insert_active_ingredient_one?: Maybe<Active_Ingredient>;
  /** insert data into the table: "actual_reading" */
  insert_actual_reading?: Maybe<Actual_Reading_Mutation_Response>;
  /** insert a single row into the table: "actual_reading" */
  insert_actual_reading_one?: Maybe<Actual_Reading>;
  /** insert data into the table: "address" */
  insert_address?: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_address_one?: Maybe<Address>;
  /** insert data into the table: "advice_author_followers" */
  insert_advice_author_followers?: Maybe<Advice_Author_Followers_Mutation_Response>;
  /** insert a single row into the table: "advice_author_followers" */
  insert_advice_author_followers_one?: Maybe<Advice_Author_Followers>;
  /** insert data into the table: "advice_authors" */
  insert_advice_authors?: Maybe<Advice_Authors_Mutation_Response>;
  /** insert a single row into the table: "advice_authors" */
  insert_advice_authors_one?: Maybe<Advice_Authors>;
  /** insert data into the table: "agent" */
  insert_agent?: Maybe<Agent_Mutation_Response>;
  /** insert data into the table: "agent_company" */
  insert_agent_company?: Maybe<Agent_Company_Mutation_Response>;
  /** insert a single row into the table: "agent_company" */
  insert_agent_company_one?: Maybe<Agent_Company>;
  /** insert a single row into the table: "agent" */
  insert_agent_one?: Maybe<Agent>;
  /** insert data into the table: "answer_choice" */
  insert_answer_choice?: Maybe<Answer_Choice_Mutation_Response>;
  /** insert a single row into the table: "answer_choice" */
  insert_answer_choice_one?: Maybe<Answer_Choice>;
  /** insert data into the table: "application_product_unit" */
  insert_application_product_unit?: Maybe<Application_Product_Unit_Mutation_Response>;
  /** insert a single row into the table: "application_product_unit" */
  insert_application_product_unit_one?: Maybe<Application_Product_Unit>;
  /** insert data into the table: "article" */
  insert_article?: Maybe<Article_Mutation_Response>;
  /** insert data into the table: "article_attachments" */
  insert_article_attachments?: Maybe<Article_Attachments_Mutation_Response>;
  /** insert a single row into the table: "article_attachments" */
  insert_article_attachments_one?: Maybe<Article_Attachments>;
  /** insert data into the table: "article_authors" */
  insert_article_authors?: Maybe<Article_Authors_Mutation_Response>;
  /** insert a single row into the table: "article_authors" */
  insert_article_authors_one?: Maybe<Article_Authors>;
  /** insert data into the table: "article_categories" */
  insert_article_categories?: Maybe<Article_Categories_Mutation_Response>;
  /** insert a single row into the table: "article_categories" */
  insert_article_categories_one?: Maybe<Article_Categories>;
  /** insert data into the table: "article_category" */
  insert_article_category?: Maybe<Article_Category_Mutation_Response>;
  /** insert a single row into the table: "article_category" */
  insert_article_category_one?: Maybe<Article_Category>;
  /** insert data into the table: "article_crop_categories" */
  insert_article_crop_categories?: Maybe<Article_Crop_Categories_Mutation_Response>;
  /** insert a single row into the table: "article_crop_categories" */
  insert_article_crop_categories_one?: Maybe<Article_Crop_Categories>;
  /** insert data into the table: "article_crop_varieties" */
  insert_article_crop_varieties?: Maybe<Article_Crop_Varieties_Mutation_Response>;
  /** insert a single row into the table: "article_crop_varieties" */
  insert_article_crop_varieties_one?: Maybe<Article_Crop_Varieties>;
  /** insert data into the table: "article_crops" */
  insert_article_crops?: Maybe<Article_Crops_Mutation_Response>;
  /** insert a single row into the table: "article_crops" */
  insert_article_crops_one?: Maybe<Article_Crops>;
  /** insert data into the table: "article_favorites" */
  insert_article_favorites?: Maybe<Article_Favorites_Mutation_Response>;
  /** insert a single row into the table: "article_favorites" */
  insert_article_favorites_one?: Maybe<Article_Favorites>;
  /** insert data into the table: "article_likes" */
  insert_article_likes?: Maybe<Article_Likes_Mutation_Response>;
  /** insert a single row into the table: "article_likes" */
  insert_article_likes_one?: Maybe<Article_Likes>;
  /** insert a single row into the table: "article" */
  insert_article_one?: Maybe<Article>;
  /** insert data into the table: "article_regions" */
  insert_article_regions?: Maybe<Article_Regions_Mutation_Response>;
  /** insert a single row into the table: "article_regions" */
  insert_article_regions_one?: Maybe<Article_Regions>;
  /** insert data into the table: "article_series" */
  insert_article_series?: Maybe<Article_Series_Mutation_Response>;
  /** insert a single row into the table: "article_series" */
  insert_article_series_one?: Maybe<Article_Series>;
  /** insert data into the table: "article_subscription_package" */
  insert_article_subscription_package?: Maybe<Article_Subscription_Package_Mutation_Response>;
  /** insert a single row into the table: "article_subscription_package" */
  insert_article_subscription_package_one?: Maybe<Article_Subscription_Package>;
  /** insert data into the table: "article_subscriptions" */
  insert_article_subscriptions?: Maybe<Article_Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "article_subscriptions" */
  insert_article_subscriptions_one?: Maybe<Article_Subscriptions>;
  /** insert data into the table: "article_user_group" */
  insert_article_user_group?: Maybe<Article_User_Group_Mutation_Response>;
  /** insert a single row into the table: "article_user_group" */
  insert_article_user_group_one?: Maybe<Article_User_Group>;
  /** insert data into the table: "article_views" */
  insert_article_views?: Maybe<Article_Views_Mutation_Response>;
  /** insert a single row into the table: "article_views" */
  insert_article_views_one?: Maybe<Article_Views>;
  /** insert data into the table: "assessment" */
  insert_assessment?: Maybe<Assessment_Mutation_Response>;
  /** insert a single row into the table: "assessment" */
  insert_assessment_one?: Maybe<Assessment>;
  /** insert data into the table: "assessment_question" */
  insert_assessment_question?: Maybe<Assessment_Question_Mutation_Response>;
  /** insert a single row into the table: "assessment_question" */
  insert_assessment_question_one?: Maybe<Assessment_Question>;
  /** insert data into the table: "attribute" */
  insert_attribute?: Maybe<Attribute_Mutation_Response>;
  /** insert data into the table: "attribute_choice" */
  insert_attribute_choice?: Maybe<Attribute_Choice_Mutation_Response>;
  /** insert a single row into the table: "attribute_choice" */
  insert_attribute_choice_one?: Maybe<Attribute_Choice>;
  /** insert a single row into the table: "attribute" */
  insert_attribute_one?: Maybe<Attribute>;
  /** insert data into the table: "auth_group" */
  insert_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** insert a single row into the table: "auth_group" */
  insert_auth_group_one?: Maybe<Auth_Group>;
  /** insert data into the table: "auth_group_permissions" */
  insert_auth_group_permissions?: Maybe<Auth_Group_Permissions_Mutation_Response>;
  /** insert a single row into the table: "auth_group_permissions" */
  insert_auth_group_permissions_one?: Maybe<Auth_Group_Permissions>;
  /** insert data into the table: "auth_permission" */
  insert_auth_permission?: Maybe<Auth_Permission_Mutation_Response>;
  /** insert a single row into the table: "auth_permission" */
  insert_auth_permission_one?: Maybe<Auth_Permission>;
  /** insert data into the table: "base_user" */
  insert_base_user?: Maybe<Base_User_Mutation_Response>;
  /** insert data into the table: "base_user_address_book" */
  insert_base_user_address_book?: Maybe<Base_User_Address_Book_Mutation_Response>;
  /** insert a single row into the table: "base_user_address_book" */
  insert_base_user_address_book_one?: Maybe<Base_User_Address_Book>;
  /** insert data into the table: "base_user_companies" */
  insert_base_user_companies?: Maybe<Base_User_Companies_Mutation_Response>;
  /** insert a single row into the table: "base_user_companies" */
  insert_base_user_companies_one?: Maybe<Base_User_Companies>;
  /** insert data into the table: "base_user_departments" */
  insert_base_user_departments?: Maybe<Base_User_Departments_Mutation_Response>;
  /** insert a single row into the table: "base_user_departments" */
  insert_base_user_departments_one?: Maybe<Base_User_Departments>;
  /** insert data into the table: "base_user_groups" */
  insert_base_user_groups?: Maybe<Base_User_Groups_Mutation_Response>;
  /** insert a single row into the table: "base_user_groups" */
  insert_base_user_groups_one?: Maybe<Base_User_Groups>;
  /** insert data into the table: "base_user_network" */
  insert_base_user_network?: Maybe<Base_User_Network_Mutation_Response>;
  /** insert a single row into the table: "base_user_network" */
  insert_base_user_network_one?: Maybe<Base_User_Network>;
  /** insert a single row into the table: "base_user" */
  insert_base_user_one?: Maybe<Base_User>;
  /** insert data into the table: "base_user_user_permissions" */
  insert_base_user_user_permissions?: Maybe<Base_User_User_Permissions_Mutation_Response>;
  /** insert a single row into the table: "base_user_user_permissions" */
  insert_base_user_user_permissions_one?: Maybe<Base_User_User_Permissions>;
  /** insert data into the table: "business" */
  insert_business?: Maybe<Business_Mutation_Response>;
  /** insert data into the table: "business_commodities_supplied" */
  insert_business_commodities_supplied?: Maybe<Business_Commodities_Supplied_Mutation_Response>;
  /** insert a single row into the table: "business_commodities_supplied" */
  insert_business_commodities_supplied_one?: Maybe<Business_Commodities_Supplied>;
  /** insert data into the table: "business_companies" */
  insert_business_companies?: Maybe<Business_Companies_Mutation_Response>;
  /** insert a single row into the table: "business_companies" */
  insert_business_companies_one?: Maybe<Business_Companies>;
  /** insert data into the table: "business_group" */
  insert_business_group?: Maybe<Business_Group_Mutation_Response>;
  /** insert data into the table: "business_group_network" */
  insert_business_group_network?: Maybe<Business_Group_Network_Mutation_Response>;
  /** insert a single row into the table: "business_group_network" */
  insert_business_group_network_one?: Maybe<Business_Group_Network>;
  /** insert a single row into the table: "business_group" */
  insert_business_group_one?: Maybe<Business_Group>;
  /** insert data into the table: "business_groups" */
  insert_business_groups?: Maybe<Business_Groups_Mutation_Response>;
  /** insert a single row into the table: "business_groups" */
  insert_business_groups_one?: Maybe<Business_Groups>;
  /** insert data into the table: "business_network" */
  insert_business_network?: Maybe<Business_Network_Mutation_Response>;
  /** insert a single row into the table: "business_network" */
  insert_business_network_one?: Maybe<Business_Network>;
  /** insert a single row into the table: "business" */
  insert_business_one?: Maybe<Business>;
  /** insert data into the table: "business_secondary_pocs" */
  insert_business_secondary_pocs?: Maybe<Business_Secondary_Pocs_Mutation_Response>;
  /** insert a single row into the table: "business_secondary_pocs" */
  insert_business_secondary_pocs_one?: Maybe<Business_Secondary_Pocs>;
  /** insert data into the table: "shared_entity" */
  insert_care_shared_entity?: Maybe<Care_Shared_Entity_Mutation_Response>;
  /** insert a single row into the table: "shared_entity" */
  insert_care_shared_entity_one?: Maybe<Care_Shared_Entity>;
  /** insert data into the table: "category" */
  insert_category?: Maybe<Category_Mutation_Response>;
  /** insert a single row into the table: "category" */
  insert_category_one?: Maybe<Category>;
  /** insert data into the table: "certificate_issuer" */
  insert_certificate_issuer?: Maybe<Certificate_Issuer_Mutation_Response>;
  /** insert a single row into the table: "certificate_issuer" */
  insert_certificate_issuer_one?: Maybe<Certificate_Issuer>;
  /** insert data into the table: "certification" */
  insert_certification?: Maybe<Certification_Mutation_Response>;
  /** insert a single row into the table: "certification" */
  insert_certification_one?: Maybe<Certification>;
  /** insert data into the table: "comment" */
  insert_comment?: Maybe<Comment_Mutation_Response>;
  /** insert a single row into the table: "comment" */
  insert_comment_one?: Maybe<Comment>;
  /** insert data into the table: "commodity" */
  insert_commodity?: Maybe<Commodity_Mutation_Response>;
  /** insert a single row into the table: "commodity" */
  insert_commodity_one?: Maybe<Commodity>;
  /** insert data into the table: "commodity_variety" */
  insert_commodity_variety?: Maybe<Commodity_Variety_Mutation_Response>;
  /** insert a single row into the table: "commodity_variety" */
  insert_commodity_variety_one?: Maybe<Commodity_Variety>;
  /** insert data into the table: "commodity_variety_secondary_groups" */
  insert_commodity_variety_secondary_groups?: Maybe<Commodity_Variety_Secondary_Groups_Mutation_Response>;
  /** insert a single row into the table: "commodity_variety_secondary_groups" */
  insert_commodity_variety_secondary_groups_one?: Maybe<Commodity_Variety_Secondary_Groups>;
  /** insert data into the table: "common_fileupload" */
  insert_common_fileupload?: Maybe<Common_Fileupload_Mutation_Response>;
  /** insert a single row into the table: "common_fileupload" */
  insert_common_fileupload_one?: Maybe<Common_Fileupload>;
  /** insert data into the table: "company" */
  insert_company?: Maybe<Company_Mutation_Response>;
  /** insert a single row into the table: "company" */
  insert_company_one?: Maybe<Company>;
  /** insert data into the table: "cost_item" */
  insert_cost_item?: Maybe<Cost_Item_Mutation_Response>;
  /** insert a single row into the table: "cost_item" */
  insert_cost_item_one?: Maybe<Cost_Item>;
  /** insert data into the table: "crop" */
  insert_crop?: Maybe<Crop_Mutation_Response>;
  /** insert data into the table: "crop_fertilisers" */
  insert_crop_fertilisers?: Maybe<Crop_Fertilisers_Mutation_Response>;
  /** insert a single row into the table: "crop_fertilisers" */
  insert_crop_fertilisers_one?: Maybe<Crop_Fertilisers>;
  /** insert data into the table: "crop_group" */
  insert_crop_group?: Maybe<Crop_Group_Mutation_Response>;
  /** insert a single row into the table: "crop_group" */
  insert_crop_group_one?: Maybe<Crop_Group>;
  /** insert data into the table: "crop_infestation" */
  insert_crop_infestation?: Maybe<Crop_Infestation_Mutation_Response>;
  /** insert data into the table: "crop_infestation_attachment" */
  insert_crop_infestation_attachment?: Maybe<Crop_Infestation_Attachment_Mutation_Response>;
  /** insert a single row into the table: "crop_infestation_attachment" */
  insert_crop_infestation_attachment_one?: Maybe<Crop_Infestation_Attachment>;
  /** insert a single row into the table: "crop_infestation" */
  insert_crop_infestation_one?: Maybe<Crop_Infestation>;
  /** insert data into the table: "crop_milestone" */
  insert_crop_milestone?: Maybe<Crop_Milestone_Mutation_Response>;
  /** insert a single row into the table: "crop_milestone" */
  insert_crop_milestone_one?: Maybe<Crop_Milestone>;
  /** insert a single row into the table: "crop" */
  insert_crop_one?: Maybe<Crop>;
  /** insert data into the table: "crop_operation_methods" */
  insert_crop_operation_methods?: Maybe<Crop_Operation_Methods_Mutation_Response>;
  /** insert a single row into the table: "crop_operation_methods" */
  insert_crop_operation_methods_one?: Maybe<Crop_Operation_Methods>;
  /** insert data into the table: "crop_pesticides" */
  insert_crop_pesticides?: Maybe<Crop_Pesticides_Mutation_Response>;
  /** insert a single row into the table: "crop_pesticides" */
  insert_crop_pesticides_one?: Maybe<Crop_Pesticides>;
  /** insert data into the table: "crop_variety" */
  insert_crop_variety?: Maybe<Crop_Variety_Mutation_Response>;
  /** insert a single row into the table: "crop_variety" */
  insert_crop_variety_one?: Maybe<Crop_Variety>;
  /** insert data into the table: "crop_variety_seeds" */
  insert_crop_variety_seeds?: Maybe<Crop_Variety_Seeds_Mutation_Response>;
  /** insert a single row into the table: "crop_variety_seeds" */
  insert_crop_variety_seeds_one?: Maybe<Crop_Variety_Seeds>;
  /** insert data into the table: "crop_year" */
  insert_crop_year?: Maybe<Crop_Year_Mutation_Response>;
  /** insert a single row into the table: "crop_year" */
  insert_crop_year_one?: Maybe<Crop_Year>;
  /** insert data into the table: "cropmonitoring_parameter" */
  insert_cropmonitoring_parameter?: Maybe<Cropmonitoring_Parameter_Mutation_Response>;
  /** insert a single row into the table: "cropmonitoring_parameter" */
  insert_cropmonitoring_parameter_one?: Maybe<Cropmonitoring_Parameter>;
  /** insert data into the table: "currency" */
  insert_currency?: Maybe<Currency_Mutation_Response>;
  /** insert a single row into the table: "currency" */
  insert_currency_one?: Maybe<Currency>;
  /** insert data into the table: "daily_actual_reading" */
  insert_daily_actual_reading?: Maybe<Daily_Actual_Reading_Mutation_Response>;
  /** insert a single row into the table: "daily_actual_reading" */
  insert_daily_actual_reading_one?: Maybe<Daily_Actual_Reading>;
  /** insert data into the table: "daily_forecast_reading" */
  insert_daily_forecast_reading?: Maybe<Daily_Forecast_Reading_Mutation_Response>;
  /** insert a single row into the table: "daily_forecast_reading" */
  insert_daily_forecast_reading_one?: Maybe<Daily_Forecast_Reading>;
  /** insert data into the table: "department" */
  insert_department?: Maybe<Department_Mutation_Response>;
  /** insert a single row into the table: "department" */
  insert_department_one?: Maybe<Department>;
  /** insert data into the table: "device" */
  insert_device?: Maybe<Device_Mutation_Response>;
  /** insert a single row into the table: "device" */
  insert_device_one?: Maybe<Device>;
  /** insert data into the table: "django_content_type" */
  insert_django_content_type?: Maybe<Django_Content_Type_Mutation_Response>;
  /** insert a single row into the table: "django_content_type" */
  insert_django_content_type_one?: Maybe<Django_Content_Type>;
  /** insert data into the table: "document" */
  insert_document?: Maybe<Document_Mutation_Response>;
  /** insert data into the table: "document_attachments" */
  insert_document_attachments?: Maybe<Document_Attachments_Mutation_Response>;
  /** insert a single row into the table: "document_attachments" */
  insert_document_attachments_one?: Maybe<Document_Attachments>;
  /** insert data into the table: "document_data" */
  insert_document_data?: Maybe<Document_Data_Mutation_Response>;
  /** insert a single row into the table: "document_data" */
  insert_document_data_one?: Maybe<Document_Data>;
  /** insert data into the table: "document_kind" */
  insert_document_kind?: Maybe<Document_Kind_Mutation_Response>;
  /** insert data into the table: "document_kind_data_field" */
  insert_document_kind_data_field?: Maybe<Document_Kind_Data_Field_Mutation_Response>;
  /** insert a single row into the table: "document_kind_data_field" */
  insert_document_kind_data_field_one?: Maybe<Document_Kind_Data_Field>;
  /** insert a single row into the table: "document_kind" */
  insert_document_kind_one?: Maybe<Document_Kind>;
  /** insert a single row into the table: "document" */
  insert_document_one?: Maybe<Document>;
  /** insert data into the table: "drip_irrigation_system" */
  insert_drip_irrigation_system?: Maybe<Drip_Irrigation_System_Mutation_Response>;
  /** insert a single row into the table: "drip_irrigation_system" */
  insert_drip_irrigation_system_one?: Maybe<Drip_Irrigation_System>;
  /** insert data into the table: "expense" */
  insert_expense?: Maybe<Expense_Mutation_Response>;
  /** insert a single row into the table: "expense" */
  insert_expense_one?: Maybe<Expense>;
  /** insert data into the table: "external_reference" */
  insert_external_reference?: Maybe<External_Reference_Mutation_Response>;
  /** insert a single row into the table: "external_reference" */
  insert_external_reference_one?: Maybe<External_Reference>;
  /** insert data into the table: "farm" */
  insert_farm?: Maybe<Farm_Mutation_Response>;
  /** insert data into the table: "farm_network" */
  insert_farm_network?: Maybe<Farm_Network_Mutation_Response>;
  /** insert a single row into the table: "farm_network" */
  insert_farm_network_one?: Maybe<Farm_Network>;
  /** insert a single row into the table: "farm" */
  insert_farm_one?: Maybe<Farm>;
  /** insert data into the table: "field" */
  insert_field?: Maybe<Field_Mutation_Response>;
  /** insert data into the table: "field_network" */
  insert_field_network?: Maybe<Field_Network_Mutation_Response>;
  /** insert a single row into the table: "field_network" */
  insert_field_network_one?: Maybe<Field_Network>;
  /** insert a single row into the table: "field" */
  insert_field_one?: Maybe<Field>;
  /** insert data into the table: "field_weather_location" */
  insert_field_weather_location?: Maybe<Field_Weather_Location_Mutation_Response>;
  /** insert a single row into the table: "field_weather_location" */
  insert_field_weather_location_one?: Maybe<Field_Weather_Location>;
  /** insert data into the table: "fileupload" */
  insert_fileupload?: Maybe<Fileupload_Mutation_Response>;
  /** insert a single row into the table: "fileupload" */
  insert_fileupload_one?: Maybe<Fileupload>;
  /** insert data into the table: "flood_irrigation_system" */
  insert_flood_irrigation_system?: Maybe<Flood_Irrigation_System_Mutation_Response>;
  /** insert a single row into the table: "flood_irrigation_system" */
  insert_flood_irrigation_system_one?: Maybe<Flood_Irrigation_System>;
  /** insert data into the table: "forecast_reading" */
  insert_forecast_reading?: Maybe<Forecast_Reading_Mutation_Response>;
  /** insert a single row into the table: "forecast_reading" */
  insert_forecast_reading_one?: Maybe<Forecast_Reading>;
  /** insert data into the table: "gateway" */
  insert_gateway?: Maybe<Gateway_Mutation_Response>;
  /** insert data into the table: "gateway_configuration" */
  insert_gateway_configuration?: Maybe<Gateway_Configuration_Mutation_Response>;
  /** insert a single row into the table: "gateway_configuration" */
  insert_gateway_configuration_one?: Maybe<Gateway_Configuration>;
  /** insert a single row into the table: "gateway" */
  insert_gateway_one?: Maybe<Gateway>;
  /** insert data into the table: "gateway_status" */
  insert_gateway_status?: Maybe<Gateway_Status_Mutation_Response>;
  /** insert a single row into the table: "gateway_status" */
  insert_gateway_status_one?: Maybe<Gateway_Status>;
  /** insert data into the table: "grade_price" */
  insert_grade_price?: Maybe<Grade_Price_Mutation_Response>;
  /** insert a single row into the table: "grade_price" */
  insert_grade_price_one?: Maybe<Grade_Price>;
  /** insert data into the table: "infestation" */
  insert_infestation?: Maybe<Infestation_Mutation_Response>;
  /** insert a single row into the table: "infestation" */
  insert_infestation_one?: Maybe<Infestation>;
  /** insert data into the table: "ingredient" */
  insert_ingredient?: Maybe<Ingredient_Mutation_Response>;
  /** insert a single row into the table: "ingredient" */
  insert_ingredient_one?: Maybe<Ingredient>;
  /** insert data into the table: "inst_sensor_reading" */
  insert_inst_sensor_reading?: Maybe<Inst_Sensor_Reading_Mutation_Response>;
  /** insert a single row into the table: "inst_sensor_reading" */
  insert_inst_sensor_reading_one?: Maybe<Inst_Sensor_Reading>;
  /** insert data into the table: "irrigation_system" */
  insert_irrigation_system?: Maybe<Irrigation_System_Mutation_Response>;
  /** insert a single row into the table: "irrigation_system" */
  insert_irrigation_system_one?: Maybe<Irrigation_System>;
  /** insert data into the table: "location_subscription" */
  insert_location_subscription?: Maybe<Location_Subscription_Mutation_Response>;
  /** insert a single row into the table: "location_subscription" */
  insert_location_subscription_one?: Maybe<Location_Subscription>;
  /** insert data into the table: "main_section" */
  insert_main_section?: Maybe<Main_Section_Mutation_Response>;
  /** insert a single row into the table: "main_section" */
  insert_main_section_one?: Maybe<Main_Section>;
  /** insert data into the table: "manufacturer" */
  insert_manufacturer?: Maybe<Manufacturer_Mutation_Response>;
  /** insert a single row into the table: "manufacturer" */
  insert_manufacturer_one?: Maybe<Manufacturer>;
  /** insert data into the table: "manufacturing_facility" */
  insert_manufacturing_facility?: Maybe<Manufacturing_Facility_Mutation_Response>;
  /** insert a single row into the table: "manufacturing_facility" */
  insert_manufacturing_facility_one?: Maybe<Manufacturing_Facility>;
  /** insert data into the table: "market" */
  insert_market?: Maybe<Market_Mutation_Response>;
  /** insert a single row into the table: "market" */
  insert_market_one?: Maybe<Market>;
  /** insert data into the table: "marketer" */
  insert_marketer?: Maybe<Marketer_Mutation_Response>;
  /** insert a single row into the table: "marketer" */
  insert_marketer_one?: Maybe<Marketer>;
  /** insert data into the table: "marketing_facility" */
  insert_marketing_facility?: Maybe<Marketing_Facility_Mutation_Response>;
  /** insert a single row into the table: "marketing_facility" */
  insert_marketing_facility_one?: Maybe<Marketing_Facility>;
  /** insert data into the table: "measure_of" */
  insert_measure_of?: Maybe<Measure_Of_Mutation_Response>;
  /** insert a single row into the table: "measure_of" */
  insert_measure_of_one?: Maybe<Measure_Of>;
  /** insert data into the table: "media" */
  insert_media?: Maybe<Media_Mutation_Response>;
  /** insert a single row into the table: "media" */
  insert_media_one?: Maybe<Media>;
  /** insert data into the table: "message" */
  insert_message?: Maybe<Message_Mutation_Response>;
  /** insert a single row into the table: "message" */
  insert_message_one?: Maybe<Message>;
  /** insert data into the table: "milestone" */
  insert_milestone?: Maybe<Milestone_Mutation_Response>;
  /** insert a single row into the table: "milestone" */
  insert_milestone_one?: Maybe<Milestone>;
  /** insert data into the table: "monitoring_category" */
  insert_monitoring_category?: Maybe<Monitoring_Category_Mutation_Response>;
  /** insert a single row into the table: "monitoring_category" */
  insert_monitoring_category_one?: Maybe<Monitoring_Category>;
  /** insert data into the table: "monitoring_parameter" */
  insert_monitoring_parameter?: Maybe<Monitoring_Parameter_Mutation_Response>;
  /** insert data into the table: "monitoring_parameter_choices" */
  insert_monitoring_parameter_choices?: Maybe<Monitoring_Parameter_Choices_Mutation_Response>;
  /** insert a single row into the table: "monitoring_parameter_choices" */
  insert_monitoring_parameter_choices_one?: Maybe<Monitoring_Parameter_Choices>;
  /** insert a single row into the table: "monitoring_parameter" */
  insert_monitoring_parameter_one?: Maybe<Monitoring_Parameter>;
  /** insert data into the table: "monitoring_parameter_unit_choices" */
  insert_monitoring_parameter_unit_choices?: Maybe<Monitoring_Parameter_Unit_Choices_Mutation_Response>;
  /** insert a single row into the table: "monitoring_parameter_unit_choices" */
  insert_monitoring_parameter_unit_choices_one?: Maybe<Monitoring_Parameter_Unit_Choices>;
  /** insert data into the table: "monitoring_record" */
  insert_monitoring_record?: Maybe<Monitoring_Record_Mutation_Response>;
  /** insert data into the table: "monitoring_record_attachments" */
  insert_monitoring_record_attachments?: Maybe<Monitoring_Record_Attachments_Mutation_Response>;
  /** insert a single row into the table: "monitoring_record_attachments" */
  insert_monitoring_record_attachments_one?: Maybe<Monitoring_Record_Attachments>;
  /** insert a single row into the table: "monitoring_record" */
  insert_monitoring_record_one?: Maybe<Monitoring_Record>;
  /** insert data into the table: "monitoring_sample" */
  insert_monitoring_sample?: Maybe<Monitoring_Sample_Mutation_Response>;
  /** insert a single row into the table: "monitoring_sample" */
  insert_monitoring_sample_one?: Maybe<Monitoring_Sample>;
  /** insert data into the table: "monitoring_subcategory" */
  insert_monitoring_subcategory?: Maybe<Monitoring_Subcategory_Mutation_Response>;
  /** insert a single row into the table: "monitoring_subcategory" */
  insert_monitoring_subcategory_one?: Maybe<Monitoring_Subcategory>;
  /** insert data into the table: "mutual_group" */
  insert_mutual_group?: Maybe<Mutual_Group_Mutation_Response>;
  /** insert data into the table: "mutual_group_membership" */
  insert_mutual_group_membership?: Maybe<Mutual_Group_Membership_Mutation_Response>;
  /** insert a single row into the table: "mutual_group_membership" */
  insert_mutual_group_membership_one?: Maybe<Mutual_Group_Membership>;
  /** insert data into the table: "mutual_group_network" */
  insert_mutual_group_network?: Maybe<Mutual_Group_Network_Mutation_Response>;
  /** insert a single row into the table: "mutual_group_network" */
  insert_mutual_group_network_one?: Maybe<Mutual_Group_Network>;
  /** insert a single row into the table: "mutual_group" */
  insert_mutual_group_one?: Maybe<Mutual_Group>;
  /** insert data into the table: "mutual_group_role" */
  insert_mutual_group_role?: Maybe<Mutual_Group_Role_Mutation_Response>;
  /** insert a single row into the table: "mutual_group_role" */
  insert_mutual_group_role_one?: Maybe<Mutual_Group_Role>;
  /** insert data into the table: "mutual_group_subscription_package" */
  insert_mutual_group_subscription_package?: Maybe<Mutual_Group_Subscription_Package_Mutation_Response>;
  /** insert a single row into the table: "mutual_group_subscription_package" */
  insert_mutual_group_subscription_package_one?: Maybe<Mutual_Group_Subscription_Package>;
  /** insert data into the table: "mutual_group_weather_station" */
  insert_mutual_group_weather_station?: Maybe<Mutual_Group_Weather_Station_Mutation_Response>;
  /** insert a single row into the table: "mutual_group_weather_station" */
  insert_mutual_group_weather_station_one?: Maybe<Mutual_Group_Weather_Station>;
  /** insert data into the table: "network" */
  insert_network?: Maybe<Network_Mutation_Response>;
  /** insert a single row into the table: "network" */
  insert_network_one?: Maybe<Network>;
  /** insert data into the table: "notification" */
  insert_notification?: Maybe<Notification_Mutation_Response>;
  /** insert data into the table: "notification_category" */
  insert_notification_category?: Maybe<Notification_Category_Mutation_Response>;
  /** insert a single row into the table: "notification_category" */
  insert_notification_category_one?: Maybe<Notification_Category>;
  /** insert a single row into the table: "notification" */
  insert_notification_one?: Maybe<Notification>;
  /** insert data into the table: "notification_template" */
  insert_notification_template?: Maybe<Notification_Template_Mutation_Response>;
  /** insert data into the table: "notification_template_distribution_region" */
  insert_notification_template_distribution_region?: Maybe<Notification_Template_Distribution_Region_Mutation_Response>;
  /** insert a single row into the table: "notification_template_distribution_region" */
  insert_notification_template_distribution_region_one?: Maybe<Notification_Template_Distribution_Region>;
  /** insert data into the table: "notification_template_distribution_team" */
  insert_notification_template_distribution_team?: Maybe<Notification_Template_Distribution_Team_Mutation_Response>;
  /** insert a single row into the table: "notification_template_distribution_team" */
  insert_notification_template_distribution_team_one?: Maybe<Notification_Template_Distribution_Team>;
  /** insert data into the table: "notification_template_distribution_user" */
  insert_notification_template_distribution_user?: Maybe<Notification_Template_Distribution_User_Mutation_Response>;
  /** insert a single row into the table: "notification_template_distribution_user" */
  insert_notification_template_distribution_user_one?: Maybe<Notification_Template_Distribution_User>;
  /** insert a single row into the table: "notification_template" */
  insert_notification_template_one?: Maybe<Notification_Template>;
  /** insert data into the table: "nutrients" */
  insert_nutrients?: Maybe<Nutrients_Mutation_Response>;
  /** insert a single row into the table: "nutrients" */
  insert_nutrients_one?: Maybe<Nutrients>;
  /** insert data into the table: "observation_notification" */
  insert_observation_notification?: Maybe<Observation_Notification_Mutation_Response>;
  /** insert a single row into the table: "observation_notification" */
  insert_observation_notification_one?: Maybe<Observation_Notification>;
  /** insert data into the table: "operation_attachments" */
  insert_operation_attachments?: Maybe<Operation_Attachments_Mutation_Response>;
  /** insert a single row into the table: "operation_attachments" */
  insert_operation_attachments_one?: Maybe<Operation_Attachments>;
  /** insert data into the table: "operation_cost" */
  insert_operation_cost?: Maybe<Operation_Cost_Mutation_Response>;
  /** insert a single row into the table: "operation_cost" */
  insert_operation_cost_one?: Maybe<Operation_Cost>;
  /** insert data into the table: "operation_methods" */
  insert_operation_methods?: Maybe<Operation_Methods_Mutation_Response>;
  /** insert a single row into the table: "operation_methods" */
  insert_operation_methods_one?: Maybe<Operation_Methods>;
  /** insert data into the table: "operation_product_types" */
  insert_operation_product_types?: Maybe<Operation_Product_Types_Mutation_Response>;
  /** insert a single row into the table: "operation_product_types" */
  insert_operation_product_types_one?: Maybe<Operation_Product_Types>;
  /** insert data into the table: "operations" */
  insert_operations?: Maybe<Operations_Mutation_Response>;
  /** insert data into the table: "operations_applied_fertiliser" */
  insert_operations_applied_fertiliser?: Maybe<Operations_Applied_Fertiliser_Mutation_Response>;
  /** insert a single row into the table: "operations_applied_fertiliser" */
  insert_operations_applied_fertiliser_one?: Maybe<Operations_Applied_Fertiliser>;
  /** insert data into the table: "operations_applied_pesticide" */
  insert_operations_applied_pesticide?: Maybe<Operations_Applied_Pesticide_Mutation_Response>;
  /** insert a single row into the table: "operations_applied_pesticide" */
  insert_operations_applied_pesticide_one?: Maybe<Operations_Applied_Pesticide>;
  /** insert data into the table: "operations_fertiliser" */
  insert_operations_fertiliser?: Maybe<Operations_Fertiliser_Mutation_Response>;
  /** insert a single row into the table: "operations_fertiliser" */
  insert_operations_fertiliser_one?: Maybe<Operations_Fertiliser>;
  /** insert data into the table: "operations_harvest" */
  insert_operations_harvest?: Maybe<Operations_Harvest_Mutation_Response>;
  /** insert a single row into the table: "operations_harvest" */
  insert_operations_harvest_one?: Maybe<Operations_Harvest>;
  /** insert data into the table: "operations_harvest_output" */
  insert_operations_harvest_output?: Maybe<Operations_Harvest_Output_Mutation_Response>;
  /** insert a single row into the table: "operations_harvest_output" */
  insert_operations_harvest_output_one?: Maybe<Operations_Harvest_Output>;
  /** insert data into the table: "operations_interculture" */
  insert_operations_interculture?: Maybe<Operations_Interculture_Mutation_Response>;
  /** insert a single row into the table: "operations_interculture" */
  insert_operations_interculture_one?: Maybe<Operations_Interculture>;
  /** insert data into the table: "operations_irrigation" */
  insert_operations_irrigation?: Maybe<Operations_Irrigation_Mutation_Response>;
  /** insert a single row into the table: "operations_irrigation" */
  insert_operations_irrigation_one?: Maybe<Operations_Irrigation>;
  /** insert data into the table: "operations_land_prep" */
  insert_operations_land_prep?: Maybe<Operations_Land_Prep_Mutation_Response>;
  /** insert a single row into the table: "operations_land_prep" */
  insert_operations_land_prep_one?: Maybe<Operations_Land_Prep>;
  /** insert a single row into the table: "operations" */
  insert_operations_one?: Maybe<Operations>;
  /** insert data into the table: "operations_pesticide" */
  insert_operations_pesticide?: Maybe<Operations_Pesticide_Mutation_Response>;
  /** insert a single row into the table: "operations_pesticide" */
  insert_operations_pesticide_one?: Maybe<Operations_Pesticide>;
  /** insert data into the table: "operations_sowing" */
  insert_operations_sowing?: Maybe<Operations_Sowing_Mutation_Response>;
  /** insert a single row into the table: "operations_sowing" */
  insert_operations_sowing_one?: Maybe<Operations_Sowing>;
  /** insert data into the table: "organisation" */
  insert_organisation?: Maybe<Organisation_Mutation_Response>;
  /** insert data into the table: "organisation_document_kind" */
  insert_organisation_document_kind?: Maybe<Organisation_Document_Kind_Mutation_Response>;
  /** insert a single row into the table: "organisation_document_kind" */
  insert_organisation_document_kind_one?: Maybe<Organisation_Document_Kind>;
  /** insert a single row into the table: "organisation" */
  insert_organisation_one?: Maybe<Organisation>;
  /** insert data into the table: "organisation_preferences" */
  insert_organisation_preferences?: Maybe<Organisation_Preferences_Mutation_Response>;
  /** insert a single row into the table: "organisation_preferences" */
  insert_organisation_preferences_one?: Maybe<Organisation_Preferences>;
  /** insert data into the table: "organisation_season" */
  insert_organisation_season?: Maybe<Organisation_Season_Mutation_Response>;
  /** insert a single row into the table: "organisation_season" */
  insert_organisation_season_one?: Maybe<Organisation_Season>;
  /** insert data into the table: "payment_detail" */
  insert_payment_detail?: Maybe<Payment_Detail_Mutation_Response>;
  /** insert data into the table: "payment_detail_attachments" */
  insert_payment_detail_attachments?: Maybe<Payment_Detail_Attachments_Mutation_Response>;
  /** insert a single row into the table: "payment_detail_attachments" */
  insert_payment_detail_attachments_one?: Maybe<Payment_Detail_Attachments>;
  /** insert a single row into the table: "payment_detail" */
  insert_payment_detail_one?: Maybe<Payment_Detail>;
  /** insert data into the table: "payment_method" */
  insert_payment_method?: Maybe<Payment_Method_Mutation_Response>;
  /** insert a single row into the table: "payment_method" */
  insert_payment_method_one?: Maybe<Payment_Method>;
  /** insert data into the table: "plot" */
  insert_plot?: Maybe<Plot_Mutation_Response>;
  /** insert data into the table: "plot_crop" */
  insert_plot_crop?: Maybe<Plot_Crop_Mutation_Response>;
  /** insert data into the table: "plot_crop_agent" */
  insert_plot_crop_agent?: Maybe<Plot_Crop_Agent_Mutation_Response>;
  /** insert a single row into the table: "plot_crop_agent" */
  insert_plot_crop_agent_one?: Maybe<Plot_Crop_Agent>;
  /** insert data into the table: "plot_crop_milestone" */
  insert_plot_crop_milestone?: Maybe<Plot_Crop_Milestone_Mutation_Response>;
  /** insert a single row into the table: "plot_crop_milestone" */
  insert_plot_crop_milestone_one?: Maybe<Plot_Crop_Milestone>;
  /** insert data into the table: "plot_crop_network" */
  insert_plot_crop_network?: Maybe<Plot_Crop_Network_Mutation_Response>;
  /** insert a single row into the table: "plot_crop_network" */
  insert_plot_crop_network_one?: Maybe<Plot_Crop_Network>;
  /** insert a single row into the table: "plot_crop" */
  insert_plot_crop_one?: Maybe<Plot_Crop>;
  /** insert data into the table: "plot_network" */
  insert_plot_network?: Maybe<Plot_Network_Mutation_Response>;
  /** insert a single row into the table: "plot_network" */
  insert_plot_network_one?: Maybe<Plot_Network>;
  /** insert a single row into the table: "plot" */
  insert_plot_one?: Maybe<Plot>;
  /** insert data into the table: "plot_status" */
  insert_plot_status?: Maybe<Plot_Status_Mutation_Response>;
  /** insert a single row into the table: "plot_status" */
  insert_plot_status_one?: Maybe<Plot_Status>;
  /** insert data into the table: "primary_growth_stage" */
  insert_primary_growth_stage?: Maybe<Primary_Growth_Stage_Mutation_Response>;
  /** insert a single row into the table: "primary_growth_stage" */
  insert_primary_growth_stage_one?: Maybe<Primary_Growth_Stage>;
  /** insert data into the table: "product" */
  insert_product?: Maybe<Product_Mutation_Response>;
  /** insert data into the table: "product_attachment" */
  insert_product_attachment?: Maybe<Product_Attachment_Mutation_Response>;
  /** insert a single row into the table: "product_attachment" */
  insert_product_attachment_one?: Maybe<Product_Attachment>;
  /** insert data into the table: "product_attribute" */
  insert_product_attribute?: Maybe<Product_Attribute_Mutation_Response>;
  /** insert data into the table: "product_attribute_choice" */
  insert_product_attribute_choice?: Maybe<Product_Attribute_Choice_Mutation_Response>;
  /** insert a single row into the table: "product_attribute_choice" */
  insert_product_attribute_choice_one?: Maybe<Product_Attribute_Choice>;
  /** insert a single row into the table: "product_attribute" */
  insert_product_attribute_one?: Maybe<Product_Attribute>;
  /** insert data into the table: "product_certification" */
  insert_product_certification?: Maybe<Product_Certification_Mutation_Response>;
  /** insert data into the table: "product_certification_attachment" */
  insert_product_certification_attachment?: Maybe<Product_Certification_Attachment_Mutation_Response>;
  /** insert a single row into the table: "product_certification_attachment" */
  insert_product_certification_attachment_one?: Maybe<Product_Certification_Attachment>;
  /** insert a single row into the table: "product_certification" */
  insert_product_certification_one?: Maybe<Product_Certification>;
  /** insert data into the table: "product_class" */
  insert_product_class?: Maybe<Product_Class_Mutation_Response>;
  /** insert a single row into the table: "product_class" */
  insert_product_class_one?: Maybe<Product_Class>;
  /** insert data into the table: "product_composition" */
  insert_product_composition?: Maybe<Product_Composition_Mutation_Response>;
  /** insert a single row into the table: "product_composition" */
  insert_product_composition_one?: Maybe<Product_Composition>;
  /** insert data into the table: "product_crop_association" */
  insert_product_crop_association?: Maybe<Product_Crop_Association_Mutation_Response>;
  /** insert a single row into the table: "product_crop_association" */
  insert_product_crop_association_one?: Maybe<Product_Crop_Association>;
  /** insert data into the table: "product_crop_infestation_recommendation" */
  insert_product_crop_infestation_recommendation?: Maybe<Product_Crop_Infestation_Recommendation_Mutation_Response>;
  /** insert a single row into the table: "product_crop_infestation_recommendation" */
  insert_product_crop_infestation_recommendation_one?: Maybe<Product_Crop_Infestation_Recommendation>;
  /** insert data into the table: "product_crop_nutrition_recommendation" */
  insert_product_crop_nutrition_recommendation?: Maybe<Product_Crop_Nutrition_Recommendation_Mutation_Response>;
  /** insert a single row into the table: "product_crop_nutrition_recommendation" */
  insert_product_crop_nutrition_recommendation_one?: Maybe<Product_Crop_Nutrition_Recommendation>;
  /** insert data into the table: "product_favourite" */
  insert_product_favourite?: Maybe<Product_Favourite_Mutation_Response>;
  /** insert a single row into the table: "product_favourite" */
  insert_product_favourite_one?: Maybe<Product_Favourite>;
  /** insert data into the table: "product_infestation" */
  insert_product_infestation?: Maybe<Product_Infestation_Mutation_Response>;
  /** insert a single row into the table: "product_infestation" */
  insert_product_infestation_one?: Maybe<Product_Infestation>;
  /** insert data into the table: "product_mainsection" */
  insert_product_mainsection?: Maybe<Product_Mainsection_Mutation_Response>;
  /** insert data into the table: "product_mainsection_attachment" */
  insert_product_mainsection_attachment?: Maybe<Product_Mainsection_Attachment_Mutation_Response>;
  /** insert a single row into the table: "product_mainsection_attachment" */
  insert_product_mainsection_attachment_one?: Maybe<Product_Mainsection_Attachment>;
  /** insert a single row into the table: "product_mainsection" */
  insert_product_mainsection_one?: Maybe<Product_Mainsection>;
  /** insert a single row into the table: "product" */
  insert_product_one?: Maybe<Product>;
  /** insert data into the table: "product_purchased" */
  insert_product_purchased?: Maybe<Product_Purchased_Mutation_Response>;
  /** insert a single row into the table: "product_purchased" */
  insert_product_purchased_one?: Maybe<Product_Purchased>;
  /** insert data into the table: "product_section" */
  insert_product_section?: Maybe<Product_Section_Mutation_Response>;
  /** insert data into the table: "product_section_attachment" */
  insert_product_section_attachment?: Maybe<Product_Section_Attachment_Mutation_Response>;
  /** insert a single row into the table: "product_section_attachment" */
  insert_product_section_attachment_one?: Maybe<Product_Section_Attachment>;
  /** insert a single row into the table: "product_section" */
  insert_product_section_one?: Maybe<Product_Section>;
  /** insert data into the table: "product_sku" */
  insert_product_sku?: Maybe<Product_Sku_Mutation_Response>;
  /** insert a single row into the table: "product_sku" */
  insert_product_sku_one?: Maybe<Product_Sku>;
  /** insert data into the table: "product_subsection" */
  insert_product_subsection?: Maybe<Product_Subsection_Mutation_Response>;
  /** insert data into the table: "product_subsection_attachment" */
  insert_product_subsection_attachment?: Maybe<Product_Subsection_Attachment_Mutation_Response>;
  /** insert a single row into the table: "product_subsection_attachment" */
  insert_product_subsection_attachment_one?: Maybe<Product_Subsection_Attachment>;
  /** insert a single row into the table: "product_subsection" */
  insert_product_subsection_one?: Maybe<Product_Subsection>;
  /** insert data into the table: "product_view" */
  insert_product_view?: Maybe<Product_View_Mutation_Response>;
  /** insert a single row into the table: "product_view" */
  insert_product_view_one?: Maybe<Product_View>;
  /** insert data into the table: "products" */
  insert_products?: Maybe<Products_Mutation_Response>;
  /** insert data into the table: "products_fertiliser" */
  insert_products_fertiliser?: Maybe<Products_Fertiliser_Mutation_Response>;
  /** insert data into the table: "products_fertiliser_contents" */
  insert_products_fertiliser_contents?: Maybe<Products_Fertiliser_Contents_Mutation_Response>;
  /** insert a single row into the table: "products_fertiliser_contents" */
  insert_products_fertiliser_contents_one?: Maybe<Products_Fertiliser_Contents>;
  /** insert a single row into the table: "products_fertiliser" */
  insert_products_fertiliser_one?: Maybe<Products_Fertiliser>;
  /** insert data into the table: "products_fertiliser_units" */
  insert_products_fertiliser_units?: Maybe<Products_Fertiliser_Units_Mutation_Response>;
  /** insert a single row into the table: "products_fertiliser_units" */
  insert_products_fertiliser_units_one?: Maybe<Products_Fertiliser_Units>;
  /** insert a single row into the table: "products" */
  insert_products_one?: Maybe<Products>;
  /** insert data into the table: "products_pesticide" */
  insert_products_pesticide?: Maybe<Products_Pesticide_Mutation_Response>;
  /** insert data into the table: "products_pesticide_contents" */
  insert_products_pesticide_contents?: Maybe<Products_Pesticide_Contents_Mutation_Response>;
  /** insert a single row into the table: "products_pesticide_contents" */
  insert_products_pesticide_contents_one?: Maybe<Products_Pesticide_Contents>;
  /** insert a single row into the table: "products_pesticide" */
  insert_products_pesticide_one?: Maybe<Products_Pesticide>;
  /** insert data into the table: "products_pesticide_units" */
  insert_products_pesticide_units?: Maybe<Products_Pesticide_Units_Mutation_Response>;
  /** insert a single row into the table: "products_pesticide_units" */
  insert_products_pesticide_units_one?: Maybe<Products_Pesticide_Units>;
  /** insert data into the table: "provider" */
  insert_provider?: Maybe<Provider_Mutation_Response>;
  /** insert a single row into the table: "provider" */
  insert_provider_one?: Maybe<Provider>;
  /** insert data into the table: "receipt" */
  insert_receipt?: Maybe<Receipt_Mutation_Response>;
  /** insert a single row into the table: "receipt" */
  insert_receipt_one?: Maybe<Receipt>;
  /** insert data into the table: "recommended_product" */
  insert_recommended_product?: Maybe<Recommended_Product_Mutation_Response>;
  /** insert a single row into the table: "recommended_product" */
  insert_recommended_product_one?: Maybe<Recommended_Product>;
  /** insert data into the table: "region" */
  insert_region?: Maybe<Region_Mutation_Response>;
  /** insert data into the table: "region_group" */
  insert_region_group?: Maybe<Region_Group_Mutation_Response>;
  /** insert a single row into the table: "region_group" */
  insert_region_group_one?: Maybe<Region_Group>;
  /** insert a single row into the table: "region" */
  insert_region_one?: Maybe<Region>;
  /** insert data into the table: "reward_configuration" */
  insert_reward_configuration?: Maybe<Reward_Configuration_Mutation_Response>;
  /** insert a single row into the table: "reward_configuration" */
  insert_reward_configuration_one?: Maybe<Reward_Configuration>;
  /** insert data into the table: "sap_si" */
  insert_sap_si?: Maybe<Sap_Si_Mutation_Response>;
  /** insert data into the table: "sap_si_map" */
  insert_sap_si_map?: Maybe<Sap_Si_Map_Mutation_Response>;
  /** insert a single row into the table: "sap_si_map" */
  insert_sap_si_map_one?: Maybe<Sap_Si_Map>;
  /** insert a single row into the table: "sap_si" */
  insert_sap_si_one?: Maybe<Sap_Si>;
  /** insert data into the table: "secondary_growth_stage" */
  insert_secondary_growth_stage?: Maybe<Secondary_Growth_Stage_Mutation_Response>;
  /** insert a single row into the table: "secondary_growth_stage" */
  insert_secondary_growth_stage_one?: Maybe<Secondary_Growth_Stage>;
  /** insert data into the table: "section" */
  insert_section?: Maybe<Section_Mutation_Response>;
  /** insert a single row into the table: "section" */
  insert_section_one?: Maybe<Section>;
  /** insert data into the table: "seeds" */
  insert_seeds?: Maybe<Seeds_Mutation_Response>;
  /** insert a single row into the table: "seeds" */
  insert_seeds_one?: Maybe<Seeds>;
  /** insert data into the table: "sellable_item" */
  insert_sellable_item?: Maybe<Sellable_Item_Mutation_Response>;
  /** insert a single row into the table: "sellable_item" */
  insert_sellable_item_one?: Maybe<Sellable_Item>;
  /** insert data into the table: "sellable_item_stock" */
  insert_sellable_item_stock?: Maybe<Sellable_Item_Stock_Mutation_Response>;
  /** insert a single row into the table: "sellable_item_stock" */
  insert_sellable_item_stock_one?: Maybe<Sellable_Item_Stock>;
  /** insert data into the table: "sensor" */
  insert_sensor?: Maybe<Sensor_Mutation_Response>;
  /** insert a single row into the table: "sensor" */
  insert_sensor_one?: Maybe<Sensor>;
  /** insert data into the table: "sensor_parameter" */
  insert_sensor_parameter?: Maybe<Sensor_Parameter_Mutation_Response>;
  /** insert a single row into the table: "sensor_parameter" */
  insert_sensor_parameter_one?: Maybe<Sensor_Parameter>;
  /** insert data into the table: "series" */
  insert_series?: Maybe<Series_Mutation_Response>;
  /** insert data into the table: "series_authors" */
  insert_series_authors?: Maybe<Series_Authors_Mutation_Response>;
  /** insert a single row into the table: "series_authors" */
  insert_series_authors_one?: Maybe<Series_Authors>;
  /** insert data into the table: "series_category" */
  insert_series_category?: Maybe<Series_Category_Mutation_Response>;
  /** insert a single row into the table: "series_category" */
  insert_series_category_one?: Maybe<Series_Category>;
  /** insert data into the table: "series_crops" */
  insert_series_crops?: Maybe<Series_Crops_Mutation_Response>;
  /** insert a single row into the table: "series_crops" */
  insert_series_crops_one?: Maybe<Series_Crops>;
  /** insert data into the table: "series_favorites" */
  insert_series_favorites?: Maybe<Series_Favorites_Mutation_Response>;
  /** insert a single row into the table: "series_favorites" */
  insert_series_favorites_one?: Maybe<Series_Favorites>;
  /** insert data into the table: "series_likes" */
  insert_series_likes?: Maybe<Series_Likes_Mutation_Response>;
  /** insert a single row into the table: "series_likes" */
  insert_series_likes_one?: Maybe<Series_Likes>;
  /** insert a single row into the table: "series" */
  insert_series_one?: Maybe<Series>;
  /** insert data into the table: "shared_entity" */
  insert_setu_trade_shared_entity?: Maybe<Setu_Trade_Shared_Entity_Mutation_Response>;
  /** insert a single row into the table: "shared_entity" */
  insert_setu_trade_shared_entity_one?: Maybe<Setu_Trade_Shared_Entity>;
  /** insert data into the table: "setu_weather_user" */
  insert_setu_weather_user?: Maybe<Setu_Weather_User_Mutation_Response>;
  /** insert a single row into the table: "setu_weather_user" */
  insert_setu_weather_user_one?: Maybe<Setu_Weather_User>;
  /** insert data into the table: "shared_entity" */
  insert_shared_entity?: Maybe<Shared_Entity_Mutation_Response>;
  /** insert a single row into the table: "shared_entity" */
  insert_shared_entity_one?: Maybe<Shared_Entity>;
  /** insert data into the table: "si_unit" */
  insert_si_unit?: Maybe<Si_Unit_Mutation_Response>;
  /** insert data into the table: "si_unit_measure" */
  insert_si_unit_measure?: Maybe<Si_Unit_Measure_Mutation_Response>;
  /** insert a single row into the table: "si_unit_measure" */
  insert_si_unit_measure_one?: Maybe<Si_Unit_Measure>;
  /** insert a single row into the table: "si_unit" */
  insert_si_unit_one?: Maybe<Si_Unit>;
  /** insert data into the table: "sku" */
  insert_sku?: Maybe<Sku_Mutation_Response>;
  /** insert data into the table: "sku_kind" */
  insert_sku_kind?: Maybe<Sku_Kind_Mutation_Response>;
  /** insert a single row into the table: "sku_kind" */
  insert_sku_kind_one?: Maybe<Sku_Kind>;
  /** insert a single row into the table: "sku" */
  insert_sku_one?: Maybe<Sku>;
  /** insert data into the table: "soil" */
  insert_soil?: Maybe<Soil_Mutation_Response>;
  /** insert a single row into the table: "soil" */
  insert_soil_one?: Maybe<Soil>;
  /** insert data into the table: "sprinkler_irrigation_system" */
  insert_sprinkler_irrigation_system?: Maybe<Sprinkler_Irrigation_System_Mutation_Response>;
  /** insert a single row into the table: "sprinkler_irrigation_system" */
  insert_sprinkler_irrigation_system_one?: Maybe<Sprinkler_Irrigation_System>;
  /** insert data into the table: "sub_section" */
  insert_sub_section?: Maybe<Sub_Section_Mutation_Response>;
  /** insert a single row into the table: "sub_section" */
  insert_sub_section_one?: Maybe<Sub_Section>;
  /** insert data into the table: "subcategory" */
  insert_subcategory?: Maybe<Subcategory_Mutation_Response>;
  /** insert a single row into the table: "subcategory" */
  insert_subcategory_one?: Maybe<Subcategory>;
  /** insert data into the table: "subscription_package_highlights" */
  insert_subscription_package_highlights?: Maybe<Subscription_Package_Highlights_Mutation_Response>;
  /** insert a single row into the table: "subscription_package_highlights" */
  insert_subscription_package_highlights_one?: Maybe<Subscription_Package_Highlights>;
  /** insert data into the table: "summary_sensor_reading" */
  insert_summary_sensor_reading?: Maybe<Summary_Sensor_Reading_Mutation_Response>;
  /** insert a single row into the table: "summary_sensor_reading" */
  insert_summary_sensor_reading_one?: Maybe<Summary_Sensor_Reading>;
  /** insert data into the table: "thread" */
  insert_thread?: Maybe<Thread_Mutation_Response>;
  /** insert a single row into the table: "thread" */
  insert_thread_one?: Maybe<Thread>;
  /** insert data into the table: "trade" */
  insert_trade?: Maybe<Trade_Mutation_Response>;
  /** insert data into the table: "trade_commodity" */
  insert_trade_commodity?: Maybe<Trade_Commodity_Mutation_Response>;
  /** insert a single row into the table: "trade_commodity" */
  insert_trade_commodity_one?: Maybe<Trade_Commodity>;
  /** insert data into the table: "trade_item" */
  insert_trade_item?: Maybe<Trade_Item_Mutation_Response>;
  /** insert a single row into the table: "trade_item" */
  insert_trade_item_one?: Maybe<Trade_Item>;
  /** insert a single row into the table: "trade" */
  insert_trade_one?: Maybe<Trade>;
  /** insert data into the table: "trade_region" */
  insert_trade_region?: Maybe<Trade_Region_Mutation_Response>;
  /** insert a single row into the table: "trade_region" */
  insert_trade_region_one?: Maybe<Trade_Region>;
  /** insert data into the table: "trade_transaction" */
  insert_trade_transaction?: Maybe<Trade_Transaction_Mutation_Response>;
  /** insert a single row into the table: "trade_transaction" */
  insert_trade_transaction_one?: Maybe<Trade_Transaction>;
  /** insert data into the table: "trade_transaction_summary" */
  insert_trade_transaction_summary?: Maybe<Trade_Transaction_Summary_Mutation_Response>;
  /** insert a single row into the table: "trade_transaction_summary" */
  insert_trade_transaction_summary_one?: Maybe<Trade_Transaction_Summary>;
  /** insert data into the table: "trade_unit" */
  insert_trade_unit?: Maybe<Trade_Unit_Mutation_Response>;
  /** insert a single row into the table: "trade_unit" */
  insert_trade_unit_one?: Maybe<Trade_Unit>;
  /** insert data into the table: "transaction_trend" */
  insert_transaction_trend?: Maybe<Transaction_Trend_Mutation_Response>;
  /** insert a single row into the table: "transaction_trend" */
  insert_transaction_trend_one?: Maybe<Transaction_Trend>;
  /** insert data into the table: "unit" */
  insert_unit?: Maybe<Unit_Mutation_Response>;
  /** insert a single row into the table: "unit" */
  insert_unit_one?: Maybe<Unit>;
  /** insert data into the table: "user_answer_choices" */
  insert_user_answer_choices?: Maybe<User_Answer_Choices_Mutation_Response>;
  /** insert a single row into the table: "user_answer_choices" */
  insert_user_answer_choices_one?: Maybe<User_Answer_Choices>;
  /** insert data into the table: "user_assessment_attempt" */
  insert_user_assessment_attempt?: Maybe<User_Assessment_Attempt_Mutation_Response>;
  /** insert a single row into the table: "user_assessment_attempt" */
  insert_user_assessment_attempt_one?: Maybe<User_Assessment_Attempt>;
  /** insert data into the table: "user_assessment_question_response" */
  insert_user_assessment_question_response?: Maybe<User_Assessment_Question_Response_Mutation_Response>;
  /** insert a single row into the table: "user_assessment_question_response" */
  insert_user_assessment_question_response_one?: Maybe<User_Assessment_Question_Response>;
  /** insert data into the table: "user_reward_history" */
  insert_user_reward_history?: Maybe<User_Reward_History_Mutation_Response>;
  /** insert a single row into the table: "user_reward_history" */
  insert_user_reward_history_one?: Maybe<User_Reward_History>;
  /** insert data into the table: "user_subscription_package" */
  insert_user_subscription_package?: Maybe<User_Subscription_Package_Mutation_Response>;
  /** insert a single row into the table: "user_subscription_package" */
  insert_user_subscription_package_one?: Maybe<User_Subscription_Package>;
  /** insert data into the table: "variety_grade" */
  insert_variety_grade?: Maybe<Variety_Grade_Mutation_Response>;
  /** insert a single row into the table: "variety_grade" */
  insert_variety_grade_one?: Maybe<Variety_Grade>;
  /** insert data into the table: "variety_grade_photos" */
  insert_variety_grade_photos?: Maybe<Variety_Grade_Photos_Mutation_Response>;
  /** insert a single row into the table: "variety_grade_photos" */
  insert_variety_grade_photos_one?: Maybe<Variety_Grade_Photos>;
  /** insert data into the table: "variety_group" */
  insert_variety_group?: Maybe<Variety_Group_Mutation_Response>;
  /** insert a single row into the table: "variety_group" */
  insert_variety_group_one?: Maybe<Variety_Group>;
  /** insert data into the table: "weather_location" */
  insert_weather_location?: Maybe<Weather_Location_Mutation_Response>;
  /** insert a single row into the table: "weather_location" */
  insert_weather_location_one?: Maybe<Weather_Location>;
  /** insert data into the table: "weather_reference" */
  insert_weather_reference?: Maybe<Weather_Reference_Mutation_Response>;
  /** insert a single row into the table: "weather_reference" */
  insert_weather_reference_one?: Maybe<Weather_Reference>;
  login?: Maybe<Login>;
  place_order?: Maybe<PlaceOrder>;
  record_crop_milestone?: Maybe<RecordCropMilestone>;
  record_expense?: Maybe<RecordExpenseMutation>;
  record_expense_v2?: Maybe<RecordExpenseMutationV2>;
  record_growth_stage?: Maybe<RecordGrowthStage>;
  record_income?: Maybe<RecordIncomeMutation>;
  record_income_v2?: Maybe<RecordIncomeMutationV2>;
  refresh_token?: Maybe<Refresh>;
  refresh_token_setu?: Maybe<Refresh>;
  send_notification?: Maybe<SendNotification>;
  set_base_user_fields?: Maybe<SetBaseUserFieldsMutation>;
  set_budget?: Maybe<SetBudgetMutation>;
  set_budget_v2?: Maybe<SetBudgetMutationV2>;
  set_business_fields?: Maybe<SetBusinessFieldsMutation>;
  set_document_attachments?: Maybe<SetDocumentAttachmentsMutation>;
  set_payment_detail_attachments?: Maybe<SetPaymentDetailAttachmentsMutation>;
  /** Obtain JSON Web Token mutation */
  token_auth_setu?: Maybe<ObtainJsonWebToken>;
  /** update data of the table: "action_log" */
  update_action_log?: Maybe<Action_Log_Mutation_Response>;
  /** update single row of the table: "action_log" */
  update_action_log_by_pk?: Maybe<Action_Log>;
  /** update multiples rows of table: "action_log" */
  update_action_log_many?: Maybe<Array<Maybe<Action_Log_Mutation_Response>>>;
  /** update data of the table: "active_ingredient" */
  update_active_ingredient?: Maybe<Active_Ingredient_Mutation_Response>;
  /** update single row of the table: "active_ingredient" */
  update_active_ingredient_by_pk?: Maybe<Active_Ingredient>;
  /** update multiples rows of table: "active_ingredient" */
  update_active_ingredient_many?: Maybe<Array<Maybe<Active_Ingredient_Mutation_Response>>>;
  /** update data of the table: "actual_reading" */
  update_actual_reading?: Maybe<Actual_Reading_Mutation_Response>;
  /** update single row of the table: "actual_reading" */
  update_actual_reading_by_pk?: Maybe<Actual_Reading>;
  /** update multiples rows of table: "actual_reading" */
  update_actual_reading_many?: Maybe<Array<Maybe<Actual_Reading_Mutation_Response>>>;
  /** update data of the table: "address" */
  update_address?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<Address>;
  /** update multiples rows of table: "address" */
  update_address_many?: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update data of the table: "advice_author_followers" */
  update_advice_author_followers?: Maybe<Advice_Author_Followers_Mutation_Response>;
  /** update single row of the table: "advice_author_followers" */
  update_advice_author_followers_by_pk?: Maybe<Advice_Author_Followers>;
  /** update multiples rows of table: "advice_author_followers" */
  update_advice_author_followers_many?: Maybe<Array<Maybe<Advice_Author_Followers_Mutation_Response>>>;
  /** update data of the table: "advice_authors" */
  update_advice_authors?: Maybe<Advice_Authors_Mutation_Response>;
  /** update single row of the table: "advice_authors" */
  update_advice_authors_by_pk?: Maybe<Advice_Authors>;
  /** update multiples rows of table: "advice_authors" */
  update_advice_authors_many?: Maybe<Array<Maybe<Advice_Authors_Mutation_Response>>>;
  /** update data of the table: "agent" */
  update_agent?: Maybe<Agent_Mutation_Response>;
  /** update single row of the table: "agent" */
  update_agent_by_pk?: Maybe<Agent>;
  /** update data of the table: "agent_company" */
  update_agent_company?: Maybe<Agent_Company_Mutation_Response>;
  /** update single row of the table: "agent_company" */
  update_agent_company_by_pk?: Maybe<Agent_Company>;
  /** update multiples rows of table: "agent_company" */
  update_agent_company_many?: Maybe<Array<Maybe<Agent_Company_Mutation_Response>>>;
  /** update multiples rows of table: "agent" */
  update_agent_many?: Maybe<Array<Maybe<Agent_Mutation_Response>>>;
  /** update data of the table: "answer_choice" */
  update_answer_choice?: Maybe<Answer_Choice_Mutation_Response>;
  /** update single row of the table: "answer_choice" */
  update_answer_choice_by_pk?: Maybe<Answer_Choice>;
  /** update multiples rows of table: "answer_choice" */
  update_answer_choice_many?: Maybe<Array<Maybe<Answer_Choice_Mutation_Response>>>;
  /** update data of the table: "application_product_unit" */
  update_application_product_unit?: Maybe<Application_Product_Unit_Mutation_Response>;
  /** update single row of the table: "application_product_unit" */
  update_application_product_unit_by_pk?: Maybe<Application_Product_Unit>;
  /** update multiples rows of table: "application_product_unit" */
  update_application_product_unit_many?: Maybe<Array<Maybe<Application_Product_Unit_Mutation_Response>>>;
  /** update data of the table: "article" */
  update_article?: Maybe<Article_Mutation_Response>;
  /** update data of the table: "article_attachments" */
  update_article_attachments?: Maybe<Article_Attachments_Mutation_Response>;
  /** update single row of the table: "article_attachments" */
  update_article_attachments_by_pk?: Maybe<Article_Attachments>;
  /** update multiples rows of table: "article_attachments" */
  update_article_attachments_many?: Maybe<Array<Maybe<Article_Attachments_Mutation_Response>>>;
  /** update data of the table: "article_authors" */
  update_article_authors?: Maybe<Article_Authors_Mutation_Response>;
  /** update single row of the table: "article_authors" */
  update_article_authors_by_pk?: Maybe<Article_Authors>;
  /** update multiples rows of table: "article_authors" */
  update_article_authors_many?: Maybe<Array<Maybe<Article_Authors_Mutation_Response>>>;
  /** update single row of the table: "article" */
  update_article_by_pk?: Maybe<Article>;
  /** update data of the table: "article_categories" */
  update_article_categories?: Maybe<Article_Categories_Mutation_Response>;
  /** update single row of the table: "article_categories" */
  update_article_categories_by_pk?: Maybe<Article_Categories>;
  /** update multiples rows of table: "article_categories" */
  update_article_categories_many?: Maybe<Array<Maybe<Article_Categories_Mutation_Response>>>;
  /** update data of the table: "article_category" */
  update_article_category?: Maybe<Article_Category_Mutation_Response>;
  /** update single row of the table: "article_category" */
  update_article_category_by_pk?: Maybe<Article_Category>;
  /** update multiples rows of table: "article_category" */
  update_article_category_many?: Maybe<Array<Maybe<Article_Category_Mutation_Response>>>;
  /** update data of the table: "article_crop_categories" */
  update_article_crop_categories?: Maybe<Article_Crop_Categories_Mutation_Response>;
  /** update single row of the table: "article_crop_categories" */
  update_article_crop_categories_by_pk?: Maybe<Article_Crop_Categories>;
  /** update multiples rows of table: "article_crop_categories" */
  update_article_crop_categories_many?: Maybe<Array<Maybe<Article_Crop_Categories_Mutation_Response>>>;
  /** update data of the table: "article_crop_varieties" */
  update_article_crop_varieties?: Maybe<Article_Crop_Varieties_Mutation_Response>;
  /** update single row of the table: "article_crop_varieties" */
  update_article_crop_varieties_by_pk?: Maybe<Article_Crop_Varieties>;
  /** update multiples rows of table: "article_crop_varieties" */
  update_article_crop_varieties_many?: Maybe<Array<Maybe<Article_Crop_Varieties_Mutation_Response>>>;
  /** update data of the table: "article_crops" */
  update_article_crops?: Maybe<Article_Crops_Mutation_Response>;
  /** update single row of the table: "article_crops" */
  update_article_crops_by_pk?: Maybe<Article_Crops>;
  /** update multiples rows of table: "article_crops" */
  update_article_crops_many?: Maybe<Array<Maybe<Article_Crops_Mutation_Response>>>;
  /** update data of the table: "article_favorites" */
  update_article_favorites?: Maybe<Article_Favorites_Mutation_Response>;
  /** update single row of the table: "article_favorites" */
  update_article_favorites_by_pk?: Maybe<Article_Favorites>;
  /** update multiples rows of table: "article_favorites" */
  update_article_favorites_many?: Maybe<Array<Maybe<Article_Favorites_Mutation_Response>>>;
  /** update data of the table: "article_likes" */
  update_article_likes?: Maybe<Article_Likes_Mutation_Response>;
  /** update single row of the table: "article_likes" */
  update_article_likes_by_pk?: Maybe<Article_Likes>;
  /** update multiples rows of table: "article_likes" */
  update_article_likes_many?: Maybe<Array<Maybe<Article_Likes_Mutation_Response>>>;
  /** update multiples rows of table: "article" */
  update_article_many?: Maybe<Array<Maybe<Article_Mutation_Response>>>;
  /** update data of the table: "article_regions" */
  update_article_regions?: Maybe<Article_Regions_Mutation_Response>;
  /** update single row of the table: "article_regions" */
  update_article_regions_by_pk?: Maybe<Article_Regions>;
  /** update multiples rows of table: "article_regions" */
  update_article_regions_many?: Maybe<Array<Maybe<Article_Regions_Mutation_Response>>>;
  /** update data of the table: "article_series" */
  update_article_series?: Maybe<Article_Series_Mutation_Response>;
  /** update single row of the table: "article_series" */
  update_article_series_by_pk?: Maybe<Article_Series>;
  /** update multiples rows of table: "article_series" */
  update_article_series_many?: Maybe<Array<Maybe<Article_Series_Mutation_Response>>>;
  /** update data of the table: "article_subscription_package" */
  update_article_subscription_package?: Maybe<Article_Subscription_Package_Mutation_Response>;
  /** update single row of the table: "article_subscription_package" */
  update_article_subscription_package_by_pk?: Maybe<Article_Subscription_Package>;
  /** update multiples rows of table: "article_subscription_package" */
  update_article_subscription_package_many?: Maybe<Array<Maybe<Article_Subscription_Package_Mutation_Response>>>;
  /** update data of the table: "article_subscriptions" */
  update_article_subscriptions?: Maybe<Article_Subscriptions_Mutation_Response>;
  /** update single row of the table: "article_subscriptions" */
  update_article_subscriptions_by_pk?: Maybe<Article_Subscriptions>;
  /** update multiples rows of table: "article_subscriptions" */
  update_article_subscriptions_many?: Maybe<Array<Maybe<Article_Subscriptions_Mutation_Response>>>;
  /** update data of the table: "article_user_group" */
  update_article_user_group?: Maybe<Article_User_Group_Mutation_Response>;
  /** update single row of the table: "article_user_group" */
  update_article_user_group_by_pk?: Maybe<Article_User_Group>;
  /** update multiples rows of table: "article_user_group" */
  update_article_user_group_many?: Maybe<Array<Maybe<Article_User_Group_Mutation_Response>>>;
  /** update data of the table: "article_views" */
  update_article_views?: Maybe<Article_Views_Mutation_Response>;
  /** update single row of the table: "article_views" */
  update_article_views_by_pk?: Maybe<Article_Views>;
  /** update multiples rows of table: "article_views" */
  update_article_views_many?: Maybe<Array<Maybe<Article_Views_Mutation_Response>>>;
  /** update data of the table: "assessment" */
  update_assessment?: Maybe<Assessment_Mutation_Response>;
  /** update single row of the table: "assessment" */
  update_assessment_by_pk?: Maybe<Assessment>;
  /** update multiples rows of table: "assessment" */
  update_assessment_many?: Maybe<Array<Maybe<Assessment_Mutation_Response>>>;
  /** update data of the table: "assessment_question" */
  update_assessment_question?: Maybe<Assessment_Question_Mutation_Response>;
  /** update single row of the table: "assessment_question" */
  update_assessment_question_by_pk?: Maybe<Assessment_Question>;
  /** update multiples rows of table: "assessment_question" */
  update_assessment_question_many?: Maybe<Array<Maybe<Assessment_Question_Mutation_Response>>>;
  /** update data of the table: "attribute" */
  update_attribute?: Maybe<Attribute_Mutation_Response>;
  /** update single row of the table: "attribute" */
  update_attribute_by_pk?: Maybe<Attribute>;
  /** update data of the table: "attribute_choice" */
  update_attribute_choice?: Maybe<Attribute_Choice_Mutation_Response>;
  /** update single row of the table: "attribute_choice" */
  update_attribute_choice_by_pk?: Maybe<Attribute_Choice>;
  /** update multiples rows of table: "attribute_choice" */
  update_attribute_choice_many?: Maybe<Array<Maybe<Attribute_Choice_Mutation_Response>>>;
  /** update multiples rows of table: "attribute" */
  update_attribute_many?: Maybe<Array<Maybe<Attribute_Mutation_Response>>>;
  /** update data of the table: "auth_group" */
  update_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** update single row of the table: "auth_group" */
  update_auth_group_by_pk?: Maybe<Auth_Group>;
  /** update multiples rows of table: "auth_group" */
  update_auth_group_many?: Maybe<Array<Maybe<Auth_Group_Mutation_Response>>>;
  /** update data of the table: "auth_group_permissions" */
  update_auth_group_permissions?: Maybe<Auth_Group_Permissions_Mutation_Response>;
  /** update single row of the table: "auth_group_permissions" */
  update_auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** update multiples rows of table: "auth_group_permissions" */
  update_auth_group_permissions_many?: Maybe<Array<Maybe<Auth_Group_Permissions_Mutation_Response>>>;
  /** update data of the table: "auth_permission" */
  update_auth_permission?: Maybe<Auth_Permission_Mutation_Response>;
  /** update single row of the table: "auth_permission" */
  update_auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** update multiples rows of table: "auth_permission" */
  update_auth_permission_many?: Maybe<Array<Maybe<Auth_Permission_Mutation_Response>>>;
  /** update data of the table: "base_user" */
  update_base_user?: Maybe<Base_User_Mutation_Response>;
  /** update data of the table: "base_user_address_book" */
  update_base_user_address_book?: Maybe<Base_User_Address_Book_Mutation_Response>;
  /** update single row of the table: "base_user_address_book" */
  update_base_user_address_book_by_pk?: Maybe<Base_User_Address_Book>;
  /** update multiples rows of table: "base_user_address_book" */
  update_base_user_address_book_many?: Maybe<Array<Maybe<Base_User_Address_Book_Mutation_Response>>>;
  /** update single row of the table: "base_user" */
  update_base_user_by_pk?: Maybe<Base_User>;
  /** update data of the table: "base_user_companies" */
  update_base_user_companies?: Maybe<Base_User_Companies_Mutation_Response>;
  /** update single row of the table: "base_user_companies" */
  update_base_user_companies_by_pk?: Maybe<Base_User_Companies>;
  /** update multiples rows of table: "base_user_companies" */
  update_base_user_companies_many?: Maybe<Array<Maybe<Base_User_Companies_Mutation_Response>>>;
  /** update data of the table: "base_user_departments" */
  update_base_user_departments?: Maybe<Base_User_Departments_Mutation_Response>;
  /** update single row of the table: "base_user_departments" */
  update_base_user_departments_by_pk?: Maybe<Base_User_Departments>;
  /** update multiples rows of table: "base_user_departments" */
  update_base_user_departments_many?: Maybe<Array<Maybe<Base_User_Departments_Mutation_Response>>>;
  /** update data of the table: "base_user_groups" */
  update_base_user_groups?: Maybe<Base_User_Groups_Mutation_Response>;
  /** update single row of the table: "base_user_groups" */
  update_base_user_groups_by_pk?: Maybe<Base_User_Groups>;
  /** update multiples rows of table: "base_user_groups" */
  update_base_user_groups_many?: Maybe<Array<Maybe<Base_User_Groups_Mutation_Response>>>;
  /** update multiples rows of table: "base_user" */
  update_base_user_many?: Maybe<Array<Maybe<Base_User_Mutation_Response>>>;
  /** update data of the table: "base_user_network" */
  update_base_user_network?: Maybe<Base_User_Network_Mutation_Response>;
  /** update single row of the table: "base_user_network" */
  update_base_user_network_by_pk?: Maybe<Base_User_Network>;
  /** update multiples rows of table: "base_user_network" */
  update_base_user_network_many?: Maybe<Array<Maybe<Base_User_Network_Mutation_Response>>>;
  /** update data of the table: "base_user_user_permissions" */
  update_base_user_user_permissions?: Maybe<Base_User_User_Permissions_Mutation_Response>;
  /** update single row of the table: "base_user_user_permissions" */
  update_base_user_user_permissions_by_pk?: Maybe<Base_User_User_Permissions>;
  /** update multiples rows of table: "base_user_user_permissions" */
  update_base_user_user_permissions_many?: Maybe<Array<Maybe<Base_User_User_Permissions_Mutation_Response>>>;
  update_booking_status?: Maybe<UpdateBookingStatus>;
  /** update data of the table: "business" */
  update_business?: Maybe<Business_Mutation_Response>;
  /** update single row of the table: "business" */
  update_business_by_pk?: Maybe<Business>;
  /** update data of the table: "business_commodities_supplied" */
  update_business_commodities_supplied?: Maybe<Business_Commodities_Supplied_Mutation_Response>;
  /** update single row of the table: "business_commodities_supplied" */
  update_business_commodities_supplied_by_pk?: Maybe<Business_Commodities_Supplied>;
  /** update multiples rows of table: "business_commodities_supplied" */
  update_business_commodities_supplied_many?: Maybe<Array<Maybe<Business_Commodities_Supplied_Mutation_Response>>>;
  /** update data of the table: "business_companies" */
  update_business_companies?: Maybe<Business_Companies_Mutation_Response>;
  /** update single row of the table: "business_companies" */
  update_business_companies_by_pk?: Maybe<Business_Companies>;
  /** update multiples rows of table: "business_companies" */
  update_business_companies_many?: Maybe<Array<Maybe<Business_Companies_Mutation_Response>>>;
  /** update data of the table: "business_group" */
  update_business_group?: Maybe<Business_Group_Mutation_Response>;
  /** update single row of the table: "business_group" */
  update_business_group_by_pk?: Maybe<Business_Group>;
  /** update multiples rows of table: "business_group" */
  update_business_group_many?: Maybe<Array<Maybe<Business_Group_Mutation_Response>>>;
  /** update data of the table: "business_group_network" */
  update_business_group_network?: Maybe<Business_Group_Network_Mutation_Response>;
  /** update single row of the table: "business_group_network" */
  update_business_group_network_by_pk?: Maybe<Business_Group_Network>;
  /** update multiples rows of table: "business_group_network" */
  update_business_group_network_many?: Maybe<Array<Maybe<Business_Group_Network_Mutation_Response>>>;
  /** update data of the table: "business_groups" */
  update_business_groups?: Maybe<Business_Groups_Mutation_Response>;
  /** update single row of the table: "business_groups" */
  update_business_groups_by_pk?: Maybe<Business_Groups>;
  /** update multiples rows of table: "business_groups" */
  update_business_groups_many?: Maybe<Array<Maybe<Business_Groups_Mutation_Response>>>;
  /** update multiples rows of table: "business" */
  update_business_many?: Maybe<Array<Maybe<Business_Mutation_Response>>>;
  /** update data of the table: "business_network" */
  update_business_network?: Maybe<Business_Network_Mutation_Response>;
  /** update single row of the table: "business_network" */
  update_business_network_by_pk?: Maybe<Business_Network>;
  /** update multiples rows of table: "business_network" */
  update_business_network_many?: Maybe<Array<Maybe<Business_Network_Mutation_Response>>>;
  /** update data of the table: "business_secondary_pocs" */
  update_business_secondary_pocs?: Maybe<Business_Secondary_Pocs_Mutation_Response>;
  /** update single row of the table: "business_secondary_pocs" */
  update_business_secondary_pocs_by_pk?: Maybe<Business_Secondary_Pocs>;
  /** update multiples rows of table: "business_secondary_pocs" */
  update_business_secondary_pocs_many?: Maybe<Array<Maybe<Business_Secondary_Pocs_Mutation_Response>>>;
  /** update single row of the table: "shared_entity" */
  update_by_pk_care_shared_entity?: Maybe<Care_Shared_Entity>;
  /** update single row of the table: "shared_entity" */
  update_by_pk_setu_trade_shared_entity?: Maybe<Setu_Trade_Shared_Entity>;
  /** update data of the table: "shared_entity" */
  update_care_shared_entity?: Maybe<Care_Shared_Entity_Mutation_Response>;
  /** update multiples rows of table: "shared_entity" */
  update_care_shared_entity_many?: Maybe<Array<Maybe<Care_Shared_Entity_Mutation_Response>>>;
  /** update data of the table: "category" */
  update_category?: Maybe<Category_Mutation_Response>;
  /** update single row of the table: "category" */
  update_category_by_pk?: Maybe<Category>;
  /** update multiples rows of table: "category" */
  update_category_many?: Maybe<Array<Maybe<Category_Mutation_Response>>>;
  /** update data of the table: "certificate_issuer" */
  update_certificate_issuer?: Maybe<Certificate_Issuer_Mutation_Response>;
  /** update single row of the table: "certificate_issuer" */
  update_certificate_issuer_by_pk?: Maybe<Certificate_Issuer>;
  /** update multiples rows of table: "certificate_issuer" */
  update_certificate_issuer_many?: Maybe<Array<Maybe<Certificate_Issuer_Mutation_Response>>>;
  /** update data of the table: "certification" */
  update_certification?: Maybe<Certification_Mutation_Response>;
  /** update single row of the table: "certification" */
  update_certification_by_pk?: Maybe<Certification>;
  /** update multiples rows of table: "certification" */
  update_certification_many?: Maybe<Array<Maybe<Certification_Mutation_Response>>>;
  /** update data of the table: "comment" */
  update_comment?: Maybe<Comment_Mutation_Response>;
  /** update single row of the table: "comment" */
  update_comment_by_pk?: Maybe<Comment>;
  /** update multiples rows of table: "comment" */
  update_comment_many?: Maybe<Array<Maybe<Comment_Mutation_Response>>>;
  /** update data of the table: "commodity" */
  update_commodity?: Maybe<Commodity_Mutation_Response>;
  /** update single row of the table: "commodity" */
  update_commodity_by_pk?: Maybe<Commodity>;
  /** update multiples rows of table: "commodity" */
  update_commodity_many?: Maybe<Array<Maybe<Commodity_Mutation_Response>>>;
  /** update data of the table: "commodity_variety" */
  update_commodity_variety?: Maybe<Commodity_Variety_Mutation_Response>;
  /** update single row of the table: "commodity_variety" */
  update_commodity_variety_by_pk?: Maybe<Commodity_Variety>;
  /** update multiples rows of table: "commodity_variety" */
  update_commodity_variety_many?: Maybe<Array<Maybe<Commodity_Variety_Mutation_Response>>>;
  /** update data of the table: "commodity_variety_secondary_groups" */
  update_commodity_variety_secondary_groups?: Maybe<Commodity_Variety_Secondary_Groups_Mutation_Response>;
  /** update single row of the table: "commodity_variety_secondary_groups" */
  update_commodity_variety_secondary_groups_by_pk?: Maybe<Commodity_Variety_Secondary_Groups>;
  /** update multiples rows of table: "commodity_variety_secondary_groups" */
  update_commodity_variety_secondary_groups_many?: Maybe<Array<Maybe<Commodity_Variety_Secondary_Groups_Mutation_Response>>>;
  /** update data of the table: "common_fileupload" */
  update_common_fileupload?: Maybe<Common_Fileupload_Mutation_Response>;
  /** update single row of the table: "common_fileupload" */
  update_common_fileupload_by_pk?: Maybe<Common_Fileupload>;
  /** update multiples rows of table: "common_fileupload" */
  update_common_fileupload_many?: Maybe<Array<Maybe<Common_Fileupload_Mutation_Response>>>;
  /** update data of the table: "company" */
  update_company?: Maybe<Company_Mutation_Response>;
  /** update single row of the table: "company" */
  update_company_by_pk?: Maybe<Company>;
  /** update multiples rows of table: "company" */
  update_company_many?: Maybe<Array<Maybe<Company_Mutation_Response>>>;
  /** update data of the table: "cost_item" */
  update_cost_item?: Maybe<Cost_Item_Mutation_Response>;
  /** update single row of the table: "cost_item" */
  update_cost_item_by_pk?: Maybe<Cost_Item>;
  /** update multiples rows of table: "cost_item" */
  update_cost_item_many?: Maybe<Array<Maybe<Cost_Item_Mutation_Response>>>;
  /** update data of the table: "crop" */
  update_crop?: Maybe<Crop_Mutation_Response>;
  /** update single row of the table: "crop" */
  update_crop_by_pk?: Maybe<Crop>;
  /** update data of the table: "crop_fertilisers" */
  update_crop_fertilisers?: Maybe<Crop_Fertilisers_Mutation_Response>;
  /** update single row of the table: "crop_fertilisers" */
  update_crop_fertilisers_by_pk?: Maybe<Crop_Fertilisers>;
  /** update multiples rows of table: "crop_fertilisers" */
  update_crop_fertilisers_many?: Maybe<Array<Maybe<Crop_Fertilisers_Mutation_Response>>>;
  /** update data of the table: "crop_group" */
  update_crop_group?: Maybe<Crop_Group_Mutation_Response>;
  /** update single row of the table: "crop_group" */
  update_crop_group_by_pk?: Maybe<Crop_Group>;
  /** update multiples rows of table: "crop_group" */
  update_crop_group_many?: Maybe<Array<Maybe<Crop_Group_Mutation_Response>>>;
  /** update data of the table: "crop_infestation" */
  update_crop_infestation?: Maybe<Crop_Infestation_Mutation_Response>;
  /** update data of the table: "crop_infestation_attachment" */
  update_crop_infestation_attachment?: Maybe<Crop_Infestation_Attachment_Mutation_Response>;
  /** update single row of the table: "crop_infestation_attachment" */
  update_crop_infestation_attachment_by_pk?: Maybe<Crop_Infestation_Attachment>;
  /** update multiples rows of table: "crop_infestation_attachment" */
  update_crop_infestation_attachment_many?: Maybe<Array<Maybe<Crop_Infestation_Attachment_Mutation_Response>>>;
  /** update single row of the table: "crop_infestation" */
  update_crop_infestation_by_pk?: Maybe<Crop_Infestation>;
  /** update multiples rows of table: "crop_infestation" */
  update_crop_infestation_many?: Maybe<Array<Maybe<Crop_Infestation_Mutation_Response>>>;
  /** update multiples rows of table: "crop" */
  update_crop_many?: Maybe<Array<Maybe<Crop_Mutation_Response>>>;
  /** update data of the table: "crop_milestone" */
  update_crop_milestone?: Maybe<Crop_Milestone_Mutation_Response>;
  /** update single row of the table: "crop_milestone" */
  update_crop_milestone_by_pk?: Maybe<Crop_Milestone>;
  /** update multiples rows of table: "crop_milestone" */
  update_crop_milestone_many?: Maybe<Array<Maybe<Crop_Milestone_Mutation_Response>>>;
  /** update data of the table: "crop_operation_methods" */
  update_crop_operation_methods?: Maybe<Crop_Operation_Methods_Mutation_Response>;
  /** update single row of the table: "crop_operation_methods" */
  update_crop_operation_methods_by_pk?: Maybe<Crop_Operation_Methods>;
  /** update multiples rows of table: "crop_operation_methods" */
  update_crop_operation_methods_many?: Maybe<Array<Maybe<Crop_Operation_Methods_Mutation_Response>>>;
  /** update data of the table: "crop_pesticides" */
  update_crop_pesticides?: Maybe<Crop_Pesticides_Mutation_Response>;
  /** update single row of the table: "crop_pesticides" */
  update_crop_pesticides_by_pk?: Maybe<Crop_Pesticides>;
  /** update multiples rows of table: "crop_pesticides" */
  update_crop_pesticides_many?: Maybe<Array<Maybe<Crop_Pesticides_Mutation_Response>>>;
  /** update data of the table: "crop_variety" */
  update_crop_variety?: Maybe<Crop_Variety_Mutation_Response>;
  /** update single row of the table: "crop_variety" */
  update_crop_variety_by_pk?: Maybe<Crop_Variety>;
  /** update multiples rows of table: "crop_variety" */
  update_crop_variety_many?: Maybe<Array<Maybe<Crop_Variety_Mutation_Response>>>;
  /** update data of the table: "crop_variety_seeds" */
  update_crop_variety_seeds?: Maybe<Crop_Variety_Seeds_Mutation_Response>;
  /** update single row of the table: "crop_variety_seeds" */
  update_crop_variety_seeds_by_pk?: Maybe<Crop_Variety_Seeds>;
  /** update multiples rows of table: "crop_variety_seeds" */
  update_crop_variety_seeds_many?: Maybe<Array<Maybe<Crop_Variety_Seeds_Mutation_Response>>>;
  /** update data of the table: "crop_year" */
  update_crop_year?: Maybe<Crop_Year_Mutation_Response>;
  /** update single row of the table: "crop_year" */
  update_crop_year_by_pk?: Maybe<Crop_Year>;
  /** update multiples rows of table: "crop_year" */
  update_crop_year_many?: Maybe<Array<Maybe<Crop_Year_Mutation_Response>>>;
  /** update data of the table: "cropmonitoring_parameter" */
  update_cropmonitoring_parameter?: Maybe<Cropmonitoring_Parameter_Mutation_Response>;
  /** update single row of the table: "cropmonitoring_parameter" */
  update_cropmonitoring_parameter_by_pk?: Maybe<Cropmonitoring_Parameter>;
  /** update multiples rows of table: "cropmonitoring_parameter" */
  update_cropmonitoring_parameter_many?: Maybe<Array<Maybe<Cropmonitoring_Parameter_Mutation_Response>>>;
  /** update data of the table: "currency" */
  update_currency?: Maybe<Currency_Mutation_Response>;
  /** update single row of the table: "currency" */
  update_currency_by_pk?: Maybe<Currency>;
  /** update multiples rows of table: "currency" */
  update_currency_many?: Maybe<Array<Maybe<Currency_Mutation_Response>>>;
  /** update data of the table: "daily_actual_reading" */
  update_daily_actual_reading?: Maybe<Daily_Actual_Reading_Mutation_Response>;
  /** update single row of the table: "daily_actual_reading" */
  update_daily_actual_reading_by_pk?: Maybe<Daily_Actual_Reading>;
  /** update multiples rows of table: "daily_actual_reading" */
  update_daily_actual_reading_many?: Maybe<Array<Maybe<Daily_Actual_Reading_Mutation_Response>>>;
  /** update data of the table: "daily_forecast_reading" */
  update_daily_forecast_reading?: Maybe<Daily_Forecast_Reading_Mutation_Response>;
  /** update single row of the table: "daily_forecast_reading" */
  update_daily_forecast_reading_by_pk?: Maybe<Daily_Forecast_Reading>;
  /** update multiples rows of table: "daily_forecast_reading" */
  update_daily_forecast_reading_many?: Maybe<Array<Maybe<Daily_Forecast_Reading_Mutation_Response>>>;
  /** update data of the table: "department" */
  update_department?: Maybe<Department_Mutation_Response>;
  /** update single row of the table: "department" */
  update_department_by_pk?: Maybe<Department>;
  /** update multiples rows of table: "department" */
  update_department_many?: Maybe<Array<Maybe<Department_Mutation_Response>>>;
  /** update data of the table: "device" */
  update_device?: Maybe<Device_Mutation_Response>;
  /** update single row of the table: "device" */
  update_device_by_pk?: Maybe<Device>;
  /** update multiples rows of table: "device" */
  update_device_many?: Maybe<Array<Maybe<Device_Mutation_Response>>>;
  /** update data of the table: "django_content_type" */
  update_django_content_type?: Maybe<Django_Content_Type_Mutation_Response>;
  /** update single row of the table: "django_content_type" */
  update_django_content_type_by_pk?: Maybe<Django_Content_Type>;
  /** update multiples rows of table: "django_content_type" */
  update_django_content_type_many?: Maybe<Array<Maybe<Django_Content_Type_Mutation_Response>>>;
  /** update data of the table: "document" */
  update_document?: Maybe<Document_Mutation_Response>;
  /** update data of the table: "document_attachments" */
  update_document_attachments?: Maybe<Document_Attachments_Mutation_Response>;
  /** update single row of the table: "document_attachments" */
  update_document_attachments_by_pk?: Maybe<Document_Attachments>;
  /** update multiples rows of table: "document_attachments" */
  update_document_attachments_many?: Maybe<Array<Maybe<Document_Attachments_Mutation_Response>>>;
  /** update single row of the table: "document" */
  update_document_by_pk?: Maybe<Document>;
  /** update data of the table: "document_data" */
  update_document_data?: Maybe<Document_Data_Mutation_Response>;
  /** update single row of the table: "document_data" */
  update_document_data_by_pk?: Maybe<Document_Data>;
  /** update multiples rows of table: "document_data" */
  update_document_data_many?: Maybe<Array<Maybe<Document_Data_Mutation_Response>>>;
  /** update data of the table: "document_kind" */
  update_document_kind?: Maybe<Document_Kind_Mutation_Response>;
  /** update single row of the table: "document_kind" */
  update_document_kind_by_pk?: Maybe<Document_Kind>;
  /** update data of the table: "document_kind_data_field" */
  update_document_kind_data_field?: Maybe<Document_Kind_Data_Field_Mutation_Response>;
  /** update single row of the table: "document_kind_data_field" */
  update_document_kind_data_field_by_pk?: Maybe<Document_Kind_Data_Field>;
  /** update multiples rows of table: "document_kind_data_field" */
  update_document_kind_data_field_many?: Maybe<Array<Maybe<Document_Kind_Data_Field_Mutation_Response>>>;
  /** update multiples rows of table: "document_kind" */
  update_document_kind_many?: Maybe<Array<Maybe<Document_Kind_Mutation_Response>>>;
  /** update multiples rows of table: "document" */
  update_document_many?: Maybe<Array<Maybe<Document_Mutation_Response>>>;
  /** update data of the table: "drip_irrigation_system" */
  update_drip_irrigation_system?: Maybe<Drip_Irrigation_System_Mutation_Response>;
  /** update single row of the table: "drip_irrigation_system" */
  update_drip_irrigation_system_by_pk?: Maybe<Drip_Irrigation_System>;
  /** update multiples rows of table: "drip_irrigation_system" */
  update_drip_irrigation_system_many?: Maybe<Array<Maybe<Drip_Irrigation_System_Mutation_Response>>>;
  /** update data of the table: "expense" */
  update_expense?: Maybe<Expense_Mutation_Response>;
  /** update single row of the table: "expense" */
  update_expense_by_pk?: Maybe<Expense>;
  /** update multiples rows of table: "expense" */
  update_expense_many?: Maybe<Array<Maybe<Expense_Mutation_Response>>>;
  /** update data of the table: "external_reference" */
  update_external_reference?: Maybe<External_Reference_Mutation_Response>;
  /** update single row of the table: "external_reference" */
  update_external_reference_by_pk?: Maybe<External_Reference>;
  /** update multiples rows of table: "external_reference" */
  update_external_reference_many?: Maybe<Array<Maybe<External_Reference_Mutation_Response>>>;
  /** update data of the table: "farm" */
  update_farm?: Maybe<Farm_Mutation_Response>;
  /** update single row of the table: "farm" */
  update_farm_by_pk?: Maybe<Farm>;
  /** update multiples rows of table: "farm" */
  update_farm_many?: Maybe<Array<Maybe<Farm_Mutation_Response>>>;
  /** update data of the table: "farm_network" */
  update_farm_network?: Maybe<Farm_Network_Mutation_Response>;
  /** update single row of the table: "farm_network" */
  update_farm_network_by_pk?: Maybe<Farm_Network>;
  /** update multiples rows of table: "farm_network" */
  update_farm_network_many?: Maybe<Array<Maybe<Farm_Network_Mutation_Response>>>;
  /** update data of the table: "field" */
  update_field?: Maybe<Field_Mutation_Response>;
  /** update single row of the table: "field" */
  update_field_by_pk?: Maybe<Field>;
  /** update multiples rows of table: "field" */
  update_field_many?: Maybe<Array<Maybe<Field_Mutation_Response>>>;
  /** update data of the table: "field_network" */
  update_field_network?: Maybe<Field_Network_Mutation_Response>;
  /** update single row of the table: "field_network" */
  update_field_network_by_pk?: Maybe<Field_Network>;
  /** update multiples rows of table: "field_network" */
  update_field_network_many?: Maybe<Array<Maybe<Field_Network_Mutation_Response>>>;
  /** update data of the table: "field_weather_location" */
  update_field_weather_location?: Maybe<Field_Weather_Location_Mutation_Response>;
  /** update single row of the table: "field_weather_location" */
  update_field_weather_location_by_pk?: Maybe<Field_Weather_Location>;
  /** update multiples rows of table: "field_weather_location" */
  update_field_weather_location_many?: Maybe<Array<Maybe<Field_Weather_Location_Mutation_Response>>>;
  /** update data of the table: "fileupload" */
  update_fileupload?: Maybe<Fileupload_Mutation_Response>;
  /** update single row of the table: "fileupload" */
  update_fileupload_by_pk?: Maybe<Fileupload>;
  /** update multiples rows of table: "fileupload" */
  update_fileupload_many?: Maybe<Array<Maybe<Fileupload_Mutation_Response>>>;
  /** update data of the table: "flood_irrigation_system" */
  update_flood_irrigation_system?: Maybe<Flood_Irrigation_System_Mutation_Response>;
  /** update single row of the table: "flood_irrigation_system" */
  update_flood_irrigation_system_by_pk?: Maybe<Flood_Irrigation_System>;
  /** update multiples rows of table: "flood_irrigation_system" */
  update_flood_irrigation_system_many?: Maybe<Array<Maybe<Flood_Irrigation_System_Mutation_Response>>>;
  /** update data of the table: "forecast_reading" */
  update_forecast_reading?: Maybe<Forecast_Reading_Mutation_Response>;
  /** update single row of the table: "forecast_reading" */
  update_forecast_reading_by_pk?: Maybe<Forecast_Reading>;
  /** update multiples rows of table: "forecast_reading" */
  update_forecast_reading_many?: Maybe<Array<Maybe<Forecast_Reading_Mutation_Response>>>;
  /** update data of the table: "gateway" */
  update_gateway?: Maybe<Gateway_Mutation_Response>;
  /** update single row of the table: "gateway" */
  update_gateway_by_pk?: Maybe<Gateway>;
  /** update data of the table: "gateway_configuration" */
  update_gateway_configuration?: Maybe<Gateway_Configuration_Mutation_Response>;
  /** update single row of the table: "gateway_configuration" */
  update_gateway_configuration_by_pk?: Maybe<Gateway_Configuration>;
  /** update multiples rows of table: "gateway_configuration" */
  update_gateway_configuration_many?: Maybe<Array<Maybe<Gateway_Configuration_Mutation_Response>>>;
  /** update multiples rows of table: "gateway" */
  update_gateway_many?: Maybe<Array<Maybe<Gateway_Mutation_Response>>>;
  /** update data of the table: "gateway_status" */
  update_gateway_status?: Maybe<Gateway_Status_Mutation_Response>;
  /** update single row of the table: "gateway_status" */
  update_gateway_status_by_pk?: Maybe<Gateway_Status>;
  /** update multiples rows of table: "gateway_status" */
  update_gateway_status_many?: Maybe<Array<Maybe<Gateway_Status_Mutation_Response>>>;
  /** update data of the table: "grade_price" */
  update_grade_price?: Maybe<Grade_Price_Mutation_Response>;
  /** update single row of the table: "grade_price" */
  update_grade_price_by_pk?: Maybe<Grade_Price>;
  /** update multiples rows of table: "grade_price" */
  update_grade_price_many?: Maybe<Array<Maybe<Grade_Price_Mutation_Response>>>;
  /** update data of the table: "infestation" */
  update_infestation?: Maybe<Infestation_Mutation_Response>;
  /** update single row of the table: "infestation" */
  update_infestation_by_pk?: Maybe<Infestation>;
  /** update multiples rows of table: "infestation" */
  update_infestation_many?: Maybe<Array<Maybe<Infestation_Mutation_Response>>>;
  /** update data of the table: "ingredient" */
  update_ingredient?: Maybe<Ingredient_Mutation_Response>;
  /** update single row of the table: "ingredient" */
  update_ingredient_by_pk?: Maybe<Ingredient>;
  /** update multiples rows of table: "ingredient" */
  update_ingredient_many?: Maybe<Array<Maybe<Ingredient_Mutation_Response>>>;
  /** update data of the table: "inst_sensor_reading" */
  update_inst_sensor_reading?: Maybe<Inst_Sensor_Reading_Mutation_Response>;
  /** update single row of the table: "inst_sensor_reading" */
  update_inst_sensor_reading_by_pk?: Maybe<Inst_Sensor_Reading>;
  /** update multiples rows of table: "inst_sensor_reading" */
  update_inst_sensor_reading_many?: Maybe<Array<Maybe<Inst_Sensor_Reading_Mutation_Response>>>;
  /** update data of the table: "invoice" */
  update_invoice?: Maybe<Invoice_Mutation_Response>;
  /** update single row of the table: "invoice" */
  update_invoice_by_pk?: Maybe<Invoice>;
  /** update multiples rows of table: "invoice" */
  update_invoice_many?: Maybe<Array<Maybe<Invoice_Mutation_Response>>>;
  /** update data of the table: "irrigation_system" */
  update_irrigation_system?: Maybe<Irrigation_System_Mutation_Response>;
  /** update single row of the table: "irrigation_system" */
  update_irrigation_system_by_pk?: Maybe<Irrigation_System>;
  /** update multiples rows of table: "irrigation_system" */
  update_irrigation_system_many?: Maybe<Array<Maybe<Irrigation_System_Mutation_Response>>>;
  /** update data of the table: "location_subscription" */
  update_location_subscription?: Maybe<Location_Subscription_Mutation_Response>;
  /** update single row of the table: "location_subscription" */
  update_location_subscription_by_pk?: Maybe<Location_Subscription>;
  /** update multiples rows of table: "location_subscription" */
  update_location_subscription_many?: Maybe<Array<Maybe<Location_Subscription_Mutation_Response>>>;
  /** update data of the table: "main_section" */
  update_main_section?: Maybe<Main_Section_Mutation_Response>;
  /** update single row of the table: "main_section" */
  update_main_section_by_pk?: Maybe<Main_Section>;
  /** update multiples rows of table: "main_section" */
  update_main_section_many?: Maybe<Array<Maybe<Main_Section_Mutation_Response>>>;
  /** update data of the table: "manufacturer" */
  update_manufacturer?: Maybe<Manufacturer_Mutation_Response>;
  /** update single row of the table: "manufacturer" */
  update_manufacturer_by_pk?: Maybe<Manufacturer>;
  /** update multiples rows of table: "manufacturer" */
  update_manufacturer_many?: Maybe<Array<Maybe<Manufacturer_Mutation_Response>>>;
  /** update data of the table: "manufacturing_facility" */
  update_manufacturing_facility?: Maybe<Manufacturing_Facility_Mutation_Response>;
  /** update single row of the table: "manufacturing_facility" */
  update_manufacturing_facility_by_pk?: Maybe<Manufacturing_Facility>;
  /** update multiples rows of table: "manufacturing_facility" */
  update_manufacturing_facility_many?: Maybe<Array<Maybe<Manufacturing_Facility_Mutation_Response>>>;
  /** update data of the table: "market" */
  update_market?: Maybe<Market_Mutation_Response>;
  /** update single row of the table: "market" */
  update_market_by_pk?: Maybe<Market>;
  /** update multiples rows of table: "market" */
  update_market_many?: Maybe<Array<Maybe<Market_Mutation_Response>>>;
  /** update data of the table: "marketer" */
  update_marketer?: Maybe<Marketer_Mutation_Response>;
  /** update single row of the table: "marketer" */
  update_marketer_by_pk?: Maybe<Marketer>;
  /** update multiples rows of table: "marketer" */
  update_marketer_many?: Maybe<Array<Maybe<Marketer_Mutation_Response>>>;
  /** update data of the table: "marketing_facility" */
  update_marketing_facility?: Maybe<Marketing_Facility_Mutation_Response>;
  /** update single row of the table: "marketing_facility" */
  update_marketing_facility_by_pk?: Maybe<Marketing_Facility>;
  /** update multiples rows of table: "marketing_facility" */
  update_marketing_facility_many?: Maybe<Array<Maybe<Marketing_Facility_Mutation_Response>>>;
  /** update data of the table: "measure_of" */
  update_measure_of?: Maybe<Measure_Of_Mutation_Response>;
  /** update single row of the table: "measure_of" */
  update_measure_of_by_pk?: Maybe<Measure_Of>;
  /** update multiples rows of table: "measure_of" */
  update_measure_of_many?: Maybe<Array<Maybe<Measure_Of_Mutation_Response>>>;
  /** update data of the table: "media" */
  update_media?: Maybe<Media_Mutation_Response>;
  /** update single row of the table: "media" */
  update_media_by_pk?: Maybe<Media>;
  /** update multiples rows of table: "media" */
  update_media_many?: Maybe<Array<Maybe<Media_Mutation_Response>>>;
  /** update data of the table: "message" */
  update_message?: Maybe<Message_Mutation_Response>;
  /** update single row of the table: "message" */
  update_message_by_pk?: Maybe<Message>;
  /** update multiples rows of table: "message" */
  update_message_many?: Maybe<Array<Maybe<Message_Mutation_Response>>>;
  /** update data of the table: "milestone" */
  update_milestone?: Maybe<Milestone_Mutation_Response>;
  /** update single row of the table: "milestone" */
  update_milestone_by_pk?: Maybe<Milestone>;
  /** update multiples rows of table: "milestone" */
  update_milestone_many?: Maybe<Array<Maybe<Milestone_Mutation_Response>>>;
  /** update data of the table: "monitoring_category" */
  update_monitoring_category?: Maybe<Monitoring_Category_Mutation_Response>;
  /** update single row of the table: "monitoring_category" */
  update_monitoring_category_by_pk?: Maybe<Monitoring_Category>;
  /** update multiples rows of table: "monitoring_category" */
  update_monitoring_category_many?: Maybe<Array<Maybe<Monitoring_Category_Mutation_Response>>>;
  /** update data of the table: "monitoring_parameter" */
  update_monitoring_parameter?: Maybe<Monitoring_Parameter_Mutation_Response>;
  /** update single row of the table: "monitoring_parameter" */
  update_monitoring_parameter_by_pk?: Maybe<Monitoring_Parameter>;
  /** update data of the table: "monitoring_parameter_choices" */
  update_monitoring_parameter_choices?: Maybe<Monitoring_Parameter_Choices_Mutation_Response>;
  /** update single row of the table: "monitoring_parameter_choices" */
  update_monitoring_parameter_choices_by_pk?: Maybe<Monitoring_Parameter_Choices>;
  /** update multiples rows of table: "monitoring_parameter_choices" */
  update_monitoring_parameter_choices_many?: Maybe<Array<Maybe<Monitoring_Parameter_Choices_Mutation_Response>>>;
  /** update multiples rows of table: "monitoring_parameter" */
  update_monitoring_parameter_many?: Maybe<Array<Maybe<Monitoring_Parameter_Mutation_Response>>>;
  /** update data of the table: "monitoring_parameter_unit_choices" */
  update_monitoring_parameter_unit_choices?: Maybe<Monitoring_Parameter_Unit_Choices_Mutation_Response>;
  /** update single row of the table: "monitoring_parameter_unit_choices" */
  update_monitoring_parameter_unit_choices_by_pk?: Maybe<Monitoring_Parameter_Unit_Choices>;
  /** update multiples rows of table: "monitoring_parameter_unit_choices" */
  update_monitoring_parameter_unit_choices_many?: Maybe<Array<Maybe<Monitoring_Parameter_Unit_Choices_Mutation_Response>>>;
  /** update data of the table: "monitoring_record" */
  update_monitoring_record?: Maybe<Monitoring_Record_Mutation_Response>;
  /** update data of the table: "monitoring_record_attachments" */
  update_monitoring_record_attachments?: Maybe<Monitoring_Record_Attachments_Mutation_Response>;
  /** update single row of the table: "monitoring_record_attachments" */
  update_monitoring_record_attachments_by_pk?: Maybe<Monitoring_Record_Attachments>;
  /** update multiples rows of table: "monitoring_record_attachments" */
  update_monitoring_record_attachments_many?: Maybe<Array<Maybe<Monitoring_Record_Attachments_Mutation_Response>>>;
  /** update single row of the table: "monitoring_record" */
  update_monitoring_record_by_pk?: Maybe<Monitoring_Record>;
  /** update multiples rows of table: "monitoring_record" */
  update_monitoring_record_many?: Maybe<Array<Maybe<Monitoring_Record_Mutation_Response>>>;
  /** update data of the table: "monitoring_sample" */
  update_monitoring_sample?: Maybe<Monitoring_Sample_Mutation_Response>;
  /** update single row of the table: "monitoring_sample" */
  update_monitoring_sample_by_pk?: Maybe<Monitoring_Sample>;
  /** update multiples rows of table: "monitoring_sample" */
  update_monitoring_sample_many?: Maybe<Array<Maybe<Monitoring_Sample_Mutation_Response>>>;
  /** update data of the table: "monitoring_subcategory" */
  update_monitoring_subcategory?: Maybe<Monitoring_Subcategory_Mutation_Response>;
  /** update single row of the table: "monitoring_subcategory" */
  update_monitoring_subcategory_by_pk?: Maybe<Monitoring_Subcategory>;
  /** update multiples rows of table: "monitoring_subcategory" */
  update_monitoring_subcategory_many?: Maybe<Array<Maybe<Monitoring_Subcategory_Mutation_Response>>>;
  /** update data of the table: "mutual_group" */
  update_mutual_group?: Maybe<Mutual_Group_Mutation_Response>;
  /** update single row of the table: "mutual_group" */
  update_mutual_group_by_pk?: Maybe<Mutual_Group>;
  /** update multiples rows of table: "mutual_group" */
  update_mutual_group_many?: Maybe<Array<Maybe<Mutual_Group_Mutation_Response>>>;
  /** update data of the table: "mutual_group_membership" */
  update_mutual_group_membership?: Maybe<Mutual_Group_Membership_Mutation_Response>;
  /** update single row of the table: "mutual_group_membership" */
  update_mutual_group_membership_by_pk?: Maybe<Mutual_Group_Membership>;
  /** update multiples rows of table: "mutual_group_membership" */
  update_mutual_group_membership_many?: Maybe<Array<Maybe<Mutual_Group_Membership_Mutation_Response>>>;
  /** update data of the table: "mutual_group_network" */
  update_mutual_group_network?: Maybe<Mutual_Group_Network_Mutation_Response>;
  /** update single row of the table: "mutual_group_network" */
  update_mutual_group_network_by_pk?: Maybe<Mutual_Group_Network>;
  /** update multiples rows of table: "mutual_group_network" */
  update_mutual_group_network_many?: Maybe<Array<Maybe<Mutual_Group_Network_Mutation_Response>>>;
  /** update data of the table: "mutual_group_role" */
  update_mutual_group_role?: Maybe<Mutual_Group_Role_Mutation_Response>;
  /** update single row of the table: "mutual_group_role" */
  update_mutual_group_role_by_pk?: Maybe<Mutual_Group_Role>;
  /** update multiples rows of table: "mutual_group_role" */
  update_mutual_group_role_many?: Maybe<Array<Maybe<Mutual_Group_Role_Mutation_Response>>>;
  /** update data of the table: "mutual_group_subscription_package" */
  update_mutual_group_subscription_package?: Maybe<Mutual_Group_Subscription_Package_Mutation_Response>;
  /** update single row of the table: "mutual_group_subscription_package" */
  update_mutual_group_subscription_package_by_pk?: Maybe<Mutual_Group_Subscription_Package>;
  /** update multiples rows of table: "mutual_group_subscription_package" */
  update_mutual_group_subscription_package_many?: Maybe<Array<Maybe<Mutual_Group_Subscription_Package_Mutation_Response>>>;
  /** update data of the table: "mutual_group_weather_station" */
  update_mutual_group_weather_station?: Maybe<Mutual_Group_Weather_Station_Mutation_Response>;
  /** update single row of the table: "mutual_group_weather_station" */
  update_mutual_group_weather_station_by_pk?: Maybe<Mutual_Group_Weather_Station>;
  /** update multiples rows of table: "mutual_group_weather_station" */
  update_mutual_group_weather_station_many?: Maybe<Array<Maybe<Mutual_Group_Weather_Station_Mutation_Response>>>;
  /** update data of the table: "network" */
  update_network?: Maybe<Network_Mutation_Response>;
  /** update single row of the table: "network" */
  update_network_by_pk?: Maybe<Network>;
  /** update multiples rows of table: "network" */
  update_network_many?: Maybe<Array<Maybe<Network_Mutation_Response>>>;
  /** update data of the table: "notification" */
  update_notification?: Maybe<Notification_Mutation_Response>;
  /** update single row of the table: "notification" */
  update_notification_by_pk?: Maybe<Notification>;
  /** update data of the table: "notification_category" */
  update_notification_category?: Maybe<Notification_Category_Mutation_Response>;
  /** update single row of the table: "notification_category" */
  update_notification_category_by_pk?: Maybe<Notification_Category>;
  /** update multiples rows of table: "notification_category" */
  update_notification_category_many?: Maybe<Array<Maybe<Notification_Category_Mutation_Response>>>;
  /** update multiples rows of table: "notification" */
  update_notification_many?: Maybe<Array<Maybe<Notification_Mutation_Response>>>;
  /** update data of the table: "notification_template" */
  update_notification_template?: Maybe<Notification_Template_Mutation_Response>;
  /** update single row of the table: "notification_template" */
  update_notification_template_by_pk?: Maybe<Notification_Template>;
  /** update data of the table: "notification_template_distribution_region" */
  update_notification_template_distribution_region?: Maybe<Notification_Template_Distribution_Region_Mutation_Response>;
  /** update single row of the table: "notification_template_distribution_region" */
  update_notification_template_distribution_region_by_pk?: Maybe<Notification_Template_Distribution_Region>;
  /** update multiples rows of table: "notification_template_distribution_region" */
  update_notification_template_distribution_region_many?: Maybe<Array<Maybe<Notification_Template_Distribution_Region_Mutation_Response>>>;
  /** update data of the table: "notification_template_distribution_team" */
  update_notification_template_distribution_team?: Maybe<Notification_Template_Distribution_Team_Mutation_Response>;
  /** update single row of the table: "notification_template_distribution_team" */
  update_notification_template_distribution_team_by_pk?: Maybe<Notification_Template_Distribution_Team>;
  /** update multiples rows of table: "notification_template_distribution_team" */
  update_notification_template_distribution_team_many?: Maybe<Array<Maybe<Notification_Template_Distribution_Team_Mutation_Response>>>;
  /** update data of the table: "notification_template_distribution_user" */
  update_notification_template_distribution_user?: Maybe<Notification_Template_Distribution_User_Mutation_Response>;
  /** update single row of the table: "notification_template_distribution_user" */
  update_notification_template_distribution_user_by_pk?: Maybe<Notification_Template_Distribution_User>;
  /** update multiples rows of table: "notification_template_distribution_user" */
  update_notification_template_distribution_user_many?: Maybe<Array<Maybe<Notification_Template_Distribution_User_Mutation_Response>>>;
  /** update multiples rows of table: "notification_template" */
  update_notification_template_many?: Maybe<Array<Maybe<Notification_Template_Mutation_Response>>>;
  /** update data of the table: "nutrients" */
  update_nutrients?: Maybe<Nutrients_Mutation_Response>;
  /** update single row of the table: "nutrients" */
  update_nutrients_by_pk?: Maybe<Nutrients>;
  /** update multiples rows of table: "nutrients" */
  update_nutrients_many?: Maybe<Array<Maybe<Nutrients_Mutation_Response>>>;
  /** update data of the table: "observation_notification" */
  update_observation_notification?: Maybe<Observation_Notification_Mutation_Response>;
  /** update single row of the table: "observation_notification" */
  update_observation_notification_by_pk?: Maybe<Observation_Notification>;
  /** update multiples rows of table: "observation_notification" */
  update_observation_notification_many?: Maybe<Array<Maybe<Observation_Notification_Mutation_Response>>>;
  /** update data of the table: "operation_attachments" */
  update_operation_attachments?: Maybe<Operation_Attachments_Mutation_Response>;
  /** update single row of the table: "operation_attachments" */
  update_operation_attachments_by_pk?: Maybe<Operation_Attachments>;
  /** update multiples rows of table: "operation_attachments" */
  update_operation_attachments_many?: Maybe<Array<Maybe<Operation_Attachments_Mutation_Response>>>;
  /** update data of the table: "operation_cost" */
  update_operation_cost?: Maybe<Operation_Cost_Mutation_Response>;
  /** update single row of the table: "operation_cost" */
  update_operation_cost_by_pk?: Maybe<Operation_Cost>;
  /** update multiples rows of table: "operation_cost" */
  update_operation_cost_many?: Maybe<Array<Maybe<Operation_Cost_Mutation_Response>>>;
  /** update data of the table: "operation_methods" */
  update_operation_methods?: Maybe<Operation_Methods_Mutation_Response>;
  /** update single row of the table: "operation_methods" */
  update_operation_methods_by_pk?: Maybe<Operation_Methods>;
  /** update multiples rows of table: "operation_methods" */
  update_operation_methods_many?: Maybe<Array<Maybe<Operation_Methods_Mutation_Response>>>;
  /** update data of the table: "operation_product_types" */
  update_operation_product_types?: Maybe<Operation_Product_Types_Mutation_Response>;
  /** update single row of the table: "operation_product_types" */
  update_operation_product_types_by_pk?: Maybe<Operation_Product_Types>;
  /** update multiples rows of table: "operation_product_types" */
  update_operation_product_types_many?: Maybe<Array<Maybe<Operation_Product_Types_Mutation_Response>>>;
  /** update data of the table: "operations" */
  update_operations?: Maybe<Operations_Mutation_Response>;
  /** update data of the table: "operations_applied_fertiliser" */
  update_operations_applied_fertiliser?: Maybe<Operations_Applied_Fertiliser_Mutation_Response>;
  /** update single row of the table: "operations_applied_fertiliser" */
  update_operations_applied_fertiliser_by_pk?: Maybe<Operations_Applied_Fertiliser>;
  /** update multiples rows of table: "operations_applied_fertiliser" */
  update_operations_applied_fertiliser_many?: Maybe<Array<Maybe<Operations_Applied_Fertiliser_Mutation_Response>>>;
  /** update data of the table: "operations_applied_pesticide" */
  update_operations_applied_pesticide?: Maybe<Operations_Applied_Pesticide_Mutation_Response>;
  /** update single row of the table: "operations_applied_pesticide" */
  update_operations_applied_pesticide_by_pk?: Maybe<Operations_Applied_Pesticide>;
  /** update multiples rows of table: "operations_applied_pesticide" */
  update_operations_applied_pesticide_many?: Maybe<Array<Maybe<Operations_Applied_Pesticide_Mutation_Response>>>;
  /** update single row of the table: "operations" */
  update_operations_by_pk?: Maybe<Operations>;
  /** update data of the table: "operations_fertiliser" */
  update_operations_fertiliser?: Maybe<Operations_Fertiliser_Mutation_Response>;
  /** update single row of the table: "operations_fertiliser" */
  update_operations_fertiliser_by_pk?: Maybe<Operations_Fertiliser>;
  /** update multiples rows of table: "operations_fertiliser" */
  update_operations_fertiliser_many?: Maybe<Array<Maybe<Operations_Fertiliser_Mutation_Response>>>;
  /** update data of the table: "operations_harvest" */
  update_operations_harvest?: Maybe<Operations_Harvest_Mutation_Response>;
  /** update single row of the table: "operations_harvest" */
  update_operations_harvest_by_pk?: Maybe<Operations_Harvest>;
  /** update multiples rows of table: "operations_harvest" */
  update_operations_harvest_many?: Maybe<Array<Maybe<Operations_Harvest_Mutation_Response>>>;
  /** update data of the table: "operations_harvest_output" */
  update_operations_harvest_output?: Maybe<Operations_Harvest_Output_Mutation_Response>;
  /** update single row of the table: "operations_harvest_output" */
  update_operations_harvest_output_by_pk?: Maybe<Operations_Harvest_Output>;
  /** update multiples rows of table: "operations_harvest_output" */
  update_operations_harvest_output_many?: Maybe<Array<Maybe<Operations_Harvest_Output_Mutation_Response>>>;
  /** update data of the table: "operations_interculture" */
  update_operations_interculture?: Maybe<Operations_Interculture_Mutation_Response>;
  /** update single row of the table: "operations_interculture" */
  update_operations_interculture_by_pk?: Maybe<Operations_Interculture>;
  /** update multiples rows of table: "operations_interculture" */
  update_operations_interculture_many?: Maybe<Array<Maybe<Operations_Interculture_Mutation_Response>>>;
  /** update data of the table: "operations_irrigation" */
  update_operations_irrigation?: Maybe<Operations_Irrigation_Mutation_Response>;
  /** update single row of the table: "operations_irrigation" */
  update_operations_irrigation_by_pk?: Maybe<Operations_Irrigation>;
  /** update multiples rows of table: "operations_irrigation" */
  update_operations_irrigation_many?: Maybe<Array<Maybe<Operations_Irrigation_Mutation_Response>>>;
  /** update data of the table: "operations_land_prep" */
  update_operations_land_prep?: Maybe<Operations_Land_Prep_Mutation_Response>;
  /** update single row of the table: "operations_land_prep" */
  update_operations_land_prep_by_pk?: Maybe<Operations_Land_Prep>;
  /** update multiples rows of table: "operations_land_prep" */
  update_operations_land_prep_many?: Maybe<Array<Maybe<Operations_Land_Prep_Mutation_Response>>>;
  /** update multiples rows of table: "operations" */
  update_operations_many?: Maybe<Array<Maybe<Operations_Mutation_Response>>>;
  /** update data of the table: "operations_pesticide" */
  update_operations_pesticide?: Maybe<Operations_Pesticide_Mutation_Response>;
  /** update single row of the table: "operations_pesticide" */
  update_operations_pesticide_by_pk?: Maybe<Operations_Pesticide>;
  /** update multiples rows of table: "operations_pesticide" */
  update_operations_pesticide_many?: Maybe<Array<Maybe<Operations_Pesticide_Mutation_Response>>>;
  /** update data of the table: "operations_sowing" */
  update_operations_sowing?: Maybe<Operations_Sowing_Mutation_Response>;
  /** update single row of the table: "operations_sowing" */
  update_operations_sowing_by_pk?: Maybe<Operations_Sowing>;
  /** update multiples rows of table: "operations_sowing" */
  update_operations_sowing_many?: Maybe<Array<Maybe<Operations_Sowing_Mutation_Response>>>;
  /** update data of the table: "organisation" */
  update_organisation?: Maybe<Organisation_Mutation_Response>;
  /** update single row of the table: "organisation" */
  update_organisation_by_pk?: Maybe<Organisation>;
  /** update data of the table: "organisation_document_kind" */
  update_organisation_document_kind?: Maybe<Organisation_Document_Kind_Mutation_Response>;
  /** update single row of the table: "organisation_document_kind" */
  update_organisation_document_kind_by_pk?: Maybe<Organisation_Document_Kind>;
  /** update multiples rows of table: "organisation_document_kind" */
  update_organisation_document_kind_many?: Maybe<Array<Maybe<Organisation_Document_Kind_Mutation_Response>>>;
  /** update multiples rows of table: "organisation" */
  update_organisation_many?: Maybe<Array<Maybe<Organisation_Mutation_Response>>>;
  /** update data of the table: "organisation_preferences" */
  update_organisation_preferences?: Maybe<Organisation_Preferences_Mutation_Response>;
  /** update single row of the table: "organisation_preferences" */
  update_organisation_preferences_by_pk?: Maybe<Organisation_Preferences>;
  /** update multiples rows of table: "organisation_preferences" */
  update_organisation_preferences_many?: Maybe<Array<Maybe<Organisation_Preferences_Mutation_Response>>>;
  /** update data of the table: "organisation_season" */
  update_organisation_season?: Maybe<Organisation_Season_Mutation_Response>;
  /** update single row of the table: "organisation_season" */
  update_organisation_season_by_pk?: Maybe<Organisation_Season>;
  /** update multiples rows of table: "organisation_season" */
  update_organisation_season_many?: Maybe<Array<Maybe<Organisation_Season_Mutation_Response>>>;
  update_password?: Maybe<UpdatePasswordMutation>;
  /** update data of the table: "payment_detail" */
  update_payment_detail?: Maybe<Payment_Detail_Mutation_Response>;
  /** update data of the table: "payment_detail_attachments" */
  update_payment_detail_attachments?: Maybe<Payment_Detail_Attachments_Mutation_Response>;
  /** update single row of the table: "payment_detail_attachments" */
  update_payment_detail_attachments_by_pk?: Maybe<Payment_Detail_Attachments>;
  /** update multiples rows of table: "payment_detail_attachments" */
  update_payment_detail_attachments_many?: Maybe<Array<Maybe<Payment_Detail_Attachments_Mutation_Response>>>;
  /** update single row of the table: "payment_detail" */
  update_payment_detail_by_pk?: Maybe<Payment_Detail>;
  /** update multiples rows of table: "payment_detail" */
  update_payment_detail_many?: Maybe<Array<Maybe<Payment_Detail_Mutation_Response>>>;
  /** update data of the table: "payment_method" */
  update_payment_method?: Maybe<Payment_Method_Mutation_Response>;
  /** update single row of the table: "payment_method" */
  update_payment_method_by_pk?: Maybe<Payment_Method>;
  /** update multiples rows of table: "payment_method" */
  update_payment_method_many?: Maybe<Array<Maybe<Payment_Method_Mutation_Response>>>;
  /** update data of the table: "plot" */
  update_plot?: Maybe<Plot_Mutation_Response>;
  /** update single row of the table: "plot" */
  update_plot_by_pk?: Maybe<Plot>;
  /** update data of the table: "plot_crop" */
  update_plot_crop?: Maybe<Plot_Crop_Mutation_Response>;
  /** update data of the table: "plot_crop_agent" */
  update_plot_crop_agent?: Maybe<Plot_Crop_Agent_Mutation_Response>;
  /** update single row of the table: "plot_crop_agent" */
  update_plot_crop_agent_by_pk?: Maybe<Plot_Crop_Agent>;
  /** update multiples rows of table: "plot_crop_agent" */
  update_plot_crop_agent_many?: Maybe<Array<Maybe<Plot_Crop_Agent_Mutation_Response>>>;
  /** update single row of the table: "plot_crop" */
  update_plot_crop_by_pk?: Maybe<Plot_Crop>;
  /** update multiples rows of table: "plot_crop" */
  update_plot_crop_many?: Maybe<Array<Maybe<Plot_Crop_Mutation_Response>>>;
  /** update data of the table: "plot_crop_milestone" */
  update_plot_crop_milestone?: Maybe<Plot_Crop_Milestone_Mutation_Response>;
  /** update single row of the table: "plot_crop_milestone" */
  update_plot_crop_milestone_by_pk?: Maybe<Plot_Crop_Milestone>;
  /** update multiples rows of table: "plot_crop_milestone" */
  update_plot_crop_milestone_many?: Maybe<Array<Maybe<Plot_Crop_Milestone_Mutation_Response>>>;
  /** update data of the table: "plot_crop_network" */
  update_plot_crop_network?: Maybe<Plot_Crop_Network_Mutation_Response>;
  /** update single row of the table: "plot_crop_network" */
  update_plot_crop_network_by_pk?: Maybe<Plot_Crop_Network>;
  /** update multiples rows of table: "plot_crop_network" */
  update_plot_crop_network_many?: Maybe<Array<Maybe<Plot_Crop_Network_Mutation_Response>>>;
  /** update multiples rows of table: "plot" */
  update_plot_many?: Maybe<Array<Maybe<Plot_Mutation_Response>>>;
  /** update data of the table: "plot_network" */
  update_plot_network?: Maybe<Plot_Network_Mutation_Response>;
  /** update single row of the table: "plot_network" */
  update_plot_network_by_pk?: Maybe<Plot_Network>;
  /** update multiples rows of table: "plot_network" */
  update_plot_network_many?: Maybe<Array<Maybe<Plot_Network_Mutation_Response>>>;
  /** update data of the table: "plot_status" */
  update_plot_status?: Maybe<Plot_Status_Mutation_Response>;
  /** update single row of the table: "plot_status" */
  update_plot_status_by_pk?: Maybe<Plot_Status>;
  /** update multiples rows of table: "plot_status" */
  update_plot_status_many?: Maybe<Array<Maybe<Plot_Status_Mutation_Response>>>;
  /** update data of the table: "primary_growth_stage" */
  update_primary_growth_stage?: Maybe<Primary_Growth_Stage_Mutation_Response>;
  /** update single row of the table: "primary_growth_stage" */
  update_primary_growth_stage_by_pk?: Maybe<Primary_Growth_Stage>;
  /** update multiples rows of table: "primary_growth_stage" */
  update_primary_growth_stage_many?: Maybe<Array<Maybe<Primary_Growth_Stage_Mutation_Response>>>;
  /** update data of the table: "product" */
  update_product?: Maybe<Product_Mutation_Response>;
  /** update data of the table: "product_attachment" */
  update_product_attachment?: Maybe<Product_Attachment_Mutation_Response>;
  /** update single row of the table: "product_attachment" */
  update_product_attachment_by_pk?: Maybe<Product_Attachment>;
  /** update multiples rows of table: "product_attachment" */
  update_product_attachment_many?: Maybe<Array<Maybe<Product_Attachment_Mutation_Response>>>;
  /** update data of the table: "product_attribute" */
  update_product_attribute?: Maybe<Product_Attribute_Mutation_Response>;
  /** update single row of the table: "product_attribute" */
  update_product_attribute_by_pk?: Maybe<Product_Attribute>;
  /** update data of the table: "product_attribute_choice" */
  update_product_attribute_choice?: Maybe<Product_Attribute_Choice_Mutation_Response>;
  /** update single row of the table: "product_attribute_choice" */
  update_product_attribute_choice_by_pk?: Maybe<Product_Attribute_Choice>;
  /** update multiples rows of table: "product_attribute_choice" */
  update_product_attribute_choice_many?: Maybe<Array<Maybe<Product_Attribute_Choice_Mutation_Response>>>;
  /** update multiples rows of table: "product_attribute" */
  update_product_attribute_many?: Maybe<Array<Maybe<Product_Attribute_Mutation_Response>>>;
  /** update single row of the table: "product" */
  update_product_by_pk?: Maybe<Product>;
  /** update data of the table: "product_certification" */
  update_product_certification?: Maybe<Product_Certification_Mutation_Response>;
  /** update data of the table: "product_certification_attachment" */
  update_product_certification_attachment?: Maybe<Product_Certification_Attachment_Mutation_Response>;
  /** update single row of the table: "product_certification_attachment" */
  update_product_certification_attachment_by_pk?: Maybe<Product_Certification_Attachment>;
  /** update multiples rows of table: "product_certification_attachment" */
  update_product_certification_attachment_many?: Maybe<Array<Maybe<Product_Certification_Attachment_Mutation_Response>>>;
  /** update single row of the table: "product_certification" */
  update_product_certification_by_pk?: Maybe<Product_Certification>;
  /** update multiples rows of table: "product_certification" */
  update_product_certification_many?: Maybe<Array<Maybe<Product_Certification_Mutation_Response>>>;
  /** update data of the table: "product_class" */
  update_product_class?: Maybe<Product_Class_Mutation_Response>;
  /** update single row of the table: "product_class" */
  update_product_class_by_pk?: Maybe<Product_Class>;
  /** update multiples rows of table: "product_class" */
  update_product_class_many?: Maybe<Array<Maybe<Product_Class_Mutation_Response>>>;
  /** update data of the table: "product_composition" */
  update_product_composition?: Maybe<Product_Composition_Mutation_Response>;
  /** update single row of the table: "product_composition" */
  update_product_composition_by_pk?: Maybe<Product_Composition>;
  /** update multiples rows of table: "product_composition" */
  update_product_composition_many?: Maybe<Array<Maybe<Product_Composition_Mutation_Response>>>;
  /** update data of the table: "product_crop_association" */
  update_product_crop_association?: Maybe<Product_Crop_Association_Mutation_Response>;
  /** update single row of the table: "product_crop_association" */
  update_product_crop_association_by_pk?: Maybe<Product_Crop_Association>;
  /** update multiples rows of table: "product_crop_association" */
  update_product_crop_association_many?: Maybe<Array<Maybe<Product_Crop_Association_Mutation_Response>>>;
  /** update data of the table: "product_crop_infestation_recommendation" */
  update_product_crop_infestation_recommendation?: Maybe<Product_Crop_Infestation_Recommendation_Mutation_Response>;
  /** update single row of the table: "product_crop_infestation_recommendation" */
  update_product_crop_infestation_recommendation_by_pk?: Maybe<Product_Crop_Infestation_Recommendation>;
  /** update multiples rows of table: "product_crop_infestation_recommendation" */
  update_product_crop_infestation_recommendation_many?: Maybe<Array<Maybe<Product_Crop_Infestation_Recommendation_Mutation_Response>>>;
  /** update data of the table: "product_crop_nutrition_recommendation" */
  update_product_crop_nutrition_recommendation?: Maybe<Product_Crop_Nutrition_Recommendation_Mutation_Response>;
  /** update single row of the table: "product_crop_nutrition_recommendation" */
  update_product_crop_nutrition_recommendation_by_pk?: Maybe<Product_Crop_Nutrition_Recommendation>;
  /** update multiples rows of table: "product_crop_nutrition_recommendation" */
  update_product_crop_nutrition_recommendation_many?: Maybe<Array<Maybe<Product_Crop_Nutrition_Recommendation_Mutation_Response>>>;
  /** update data of the table: "product_favourite" */
  update_product_favourite?: Maybe<Product_Favourite_Mutation_Response>;
  /** update single row of the table: "product_favourite" */
  update_product_favourite_by_pk?: Maybe<Product_Favourite>;
  /** update multiples rows of table: "product_favourite" */
  update_product_favourite_many?: Maybe<Array<Maybe<Product_Favourite_Mutation_Response>>>;
  /** update data of the table: "product_infestation" */
  update_product_infestation?: Maybe<Product_Infestation_Mutation_Response>;
  /** update single row of the table: "product_infestation" */
  update_product_infestation_by_pk?: Maybe<Product_Infestation>;
  /** update multiples rows of table: "product_infestation" */
  update_product_infestation_many?: Maybe<Array<Maybe<Product_Infestation_Mutation_Response>>>;
  /** update data of the table: "product_mainsection" */
  update_product_mainsection?: Maybe<Product_Mainsection_Mutation_Response>;
  /** update data of the table: "product_mainsection_attachment" */
  update_product_mainsection_attachment?: Maybe<Product_Mainsection_Attachment_Mutation_Response>;
  /** update single row of the table: "product_mainsection_attachment" */
  update_product_mainsection_attachment_by_pk?: Maybe<Product_Mainsection_Attachment>;
  /** update multiples rows of table: "product_mainsection_attachment" */
  update_product_mainsection_attachment_many?: Maybe<Array<Maybe<Product_Mainsection_Attachment_Mutation_Response>>>;
  /** update single row of the table: "product_mainsection" */
  update_product_mainsection_by_pk?: Maybe<Product_Mainsection>;
  /** update multiples rows of table: "product_mainsection" */
  update_product_mainsection_many?: Maybe<Array<Maybe<Product_Mainsection_Mutation_Response>>>;
  /** update multiples rows of table: "product" */
  update_product_many?: Maybe<Array<Maybe<Product_Mutation_Response>>>;
  /** update data of the table: "product_purchased" */
  update_product_purchased?: Maybe<Product_Purchased_Mutation_Response>;
  /** update single row of the table: "product_purchased" */
  update_product_purchased_by_pk?: Maybe<Product_Purchased>;
  /** update multiples rows of table: "product_purchased" */
  update_product_purchased_many?: Maybe<Array<Maybe<Product_Purchased_Mutation_Response>>>;
  /** update data of the table: "product_section" */
  update_product_section?: Maybe<Product_Section_Mutation_Response>;
  /** update data of the table: "product_section_attachment" */
  update_product_section_attachment?: Maybe<Product_Section_Attachment_Mutation_Response>;
  /** update single row of the table: "product_section_attachment" */
  update_product_section_attachment_by_pk?: Maybe<Product_Section_Attachment>;
  /** update multiples rows of table: "product_section_attachment" */
  update_product_section_attachment_many?: Maybe<Array<Maybe<Product_Section_Attachment_Mutation_Response>>>;
  /** update single row of the table: "product_section" */
  update_product_section_by_pk?: Maybe<Product_Section>;
  /** update multiples rows of table: "product_section" */
  update_product_section_many?: Maybe<Array<Maybe<Product_Section_Mutation_Response>>>;
  /** update data of the table: "product_sku" */
  update_product_sku?: Maybe<Product_Sku_Mutation_Response>;
  /** update single row of the table: "product_sku" */
  update_product_sku_by_pk?: Maybe<Product_Sku>;
  /** update multiples rows of table: "product_sku" */
  update_product_sku_many?: Maybe<Array<Maybe<Product_Sku_Mutation_Response>>>;
  /** update data of the table: "product_subsection" */
  update_product_subsection?: Maybe<Product_Subsection_Mutation_Response>;
  /** update data of the table: "product_subsection_attachment" */
  update_product_subsection_attachment?: Maybe<Product_Subsection_Attachment_Mutation_Response>;
  /** update single row of the table: "product_subsection_attachment" */
  update_product_subsection_attachment_by_pk?: Maybe<Product_Subsection_Attachment>;
  /** update multiples rows of table: "product_subsection_attachment" */
  update_product_subsection_attachment_many?: Maybe<Array<Maybe<Product_Subsection_Attachment_Mutation_Response>>>;
  /** update single row of the table: "product_subsection" */
  update_product_subsection_by_pk?: Maybe<Product_Subsection>;
  /** update multiples rows of table: "product_subsection" */
  update_product_subsection_many?: Maybe<Array<Maybe<Product_Subsection_Mutation_Response>>>;
  /** update data of the table: "product_view" */
  update_product_view?: Maybe<Product_View_Mutation_Response>;
  /** update single row of the table: "product_view" */
  update_product_view_by_pk?: Maybe<Product_View>;
  /** update multiples rows of table: "product_view" */
  update_product_view_many?: Maybe<Array<Maybe<Product_View_Mutation_Response>>>;
  /** update data of the table: "products" */
  update_products?: Maybe<Products_Mutation_Response>;
  /** update single row of the table: "products" */
  update_products_by_pk?: Maybe<Products>;
  /** update data of the table: "products_fertiliser" */
  update_products_fertiliser?: Maybe<Products_Fertiliser_Mutation_Response>;
  /** update single row of the table: "products_fertiliser" */
  update_products_fertiliser_by_pk?: Maybe<Products_Fertiliser>;
  /** update data of the table: "products_fertiliser_contents" */
  update_products_fertiliser_contents?: Maybe<Products_Fertiliser_Contents_Mutation_Response>;
  /** update single row of the table: "products_fertiliser_contents" */
  update_products_fertiliser_contents_by_pk?: Maybe<Products_Fertiliser_Contents>;
  /** update multiples rows of table: "products_fertiliser_contents" */
  update_products_fertiliser_contents_many?: Maybe<Array<Maybe<Products_Fertiliser_Contents_Mutation_Response>>>;
  /** update multiples rows of table: "products_fertiliser" */
  update_products_fertiliser_many?: Maybe<Array<Maybe<Products_Fertiliser_Mutation_Response>>>;
  /** update data of the table: "products_fertiliser_units" */
  update_products_fertiliser_units?: Maybe<Products_Fertiliser_Units_Mutation_Response>;
  /** update single row of the table: "products_fertiliser_units" */
  update_products_fertiliser_units_by_pk?: Maybe<Products_Fertiliser_Units>;
  /** update multiples rows of table: "products_fertiliser_units" */
  update_products_fertiliser_units_many?: Maybe<Array<Maybe<Products_Fertiliser_Units_Mutation_Response>>>;
  /** update multiples rows of table: "products" */
  update_products_many?: Maybe<Array<Maybe<Products_Mutation_Response>>>;
  /** update data of the table: "products_pesticide" */
  update_products_pesticide?: Maybe<Products_Pesticide_Mutation_Response>;
  /** update single row of the table: "products_pesticide" */
  update_products_pesticide_by_pk?: Maybe<Products_Pesticide>;
  /** update data of the table: "products_pesticide_contents" */
  update_products_pesticide_contents?: Maybe<Products_Pesticide_Contents_Mutation_Response>;
  /** update single row of the table: "products_pesticide_contents" */
  update_products_pesticide_contents_by_pk?: Maybe<Products_Pesticide_Contents>;
  /** update multiples rows of table: "products_pesticide_contents" */
  update_products_pesticide_contents_many?: Maybe<Array<Maybe<Products_Pesticide_Contents_Mutation_Response>>>;
  /** update multiples rows of table: "products_pesticide" */
  update_products_pesticide_many?: Maybe<Array<Maybe<Products_Pesticide_Mutation_Response>>>;
  /** update data of the table: "products_pesticide_units" */
  update_products_pesticide_units?: Maybe<Products_Pesticide_Units_Mutation_Response>;
  /** update single row of the table: "products_pesticide_units" */
  update_products_pesticide_units_by_pk?: Maybe<Products_Pesticide_Units>;
  /** update multiples rows of table: "products_pesticide_units" */
  update_products_pesticide_units_many?: Maybe<Array<Maybe<Products_Pesticide_Units_Mutation_Response>>>;
  /** update data of the table: "provider" */
  update_provider?: Maybe<Provider_Mutation_Response>;
  /** update single row of the table: "provider" */
  update_provider_by_pk?: Maybe<Provider>;
  /** update multiples rows of table: "provider" */
  update_provider_many?: Maybe<Array<Maybe<Provider_Mutation_Response>>>;
  /** update data of the table: "receipt" */
  update_receipt?: Maybe<Receipt_Mutation_Response>;
  /** update single row of the table: "receipt" */
  update_receipt_by_pk?: Maybe<Receipt>;
  /** update multiples rows of table: "receipt" */
  update_receipt_many?: Maybe<Array<Maybe<Receipt_Mutation_Response>>>;
  /** update data of the table: "recommended_product" */
  update_recommended_product?: Maybe<Recommended_Product_Mutation_Response>;
  /** update single row of the table: "recommended_product" */
  update_recommended_product_by_pk?: Maybe<Recommended_Product>;
  /** update multiples rows of table: "recommended_product" */
  update_recommended_product_many?: Maybe<Array<Maybe<Recommended_Product_Mutation_Response>>>;
  /** update data of the table: "region" */
  update_region?: Maybe<Region_Mutation_Response>;
  /** update single row of the table: "region" */
  update_region_by_pk?: Maybe<Region>;
  /** update data of the table: "region_group" */
  update_region_group?: Maybe<Region_Group_Mutation_Response>;
  /** update single row of the table: "region_group" */
  update_region_group_by_pk?: Maybe<Region_Group>;
  /** update multiples rows of table: "region_group" */
  update_region_group_many?: Maybe<Array<Maybe<Region_Group_Mutation_Response>>>;
  /** update multiples rows of table: "region" */
  update_region_many?: Maybe<Array<Maybe<Region_Mutation_Response>>>;
  /** update data of the table: "reward_configuration" */
  update_reward_configuration?: Maybe<Reward_Configuration_Mutation_Response>;
  /** update single row of the table: "reward_configuration" */
  update_reward_configuration_by_pk?: Maybe<Reward_Configuration>;
  /** update multiples rows of table: "reward_configuration" */
  update_reward_configuration_many?: Maybe<Array<Maybe<Reward_Configuration_Mutation_Response>>>;
  /** update data of the table: "sap_si" */
  update_sap_si?: Maybe<Sap_Si_Mutation_Response>;
  /** update single row of the table: "sap_si" */
  update_sap_si_by_pk?: Maybe<Sap_Si>;
  /** update multiples rows of table: "sap_si" */
  update_sap_si_many?: Maybe<Array<Maybe<Sap_Si_Mutation_Response>>>;
  /** update data of the table: "sap_si_map" */
  update_sap_si_map?: Maybe<Sap_Si_Map_Mutation_Response>;
  /** update single row of the table: "sap_si_map" */
  update_sap_si_map_by_pk?: Maybe<Sap_Si_Map>;
  /** update multiples rows of table: "sap_si_map" */
  update_sap_si_map_many?: Maybe<Array<Maybe<Sap_Si_Map_Mutation_Response>>>;
  /** update data of the table: "secondary_growth_stage" */
  update_secondary_growth_stage?: Maybe<Secondary_Growth_Stage_Mutation_Response>;
  /** update single row of the table: "secondary_growth_stage" */
  update_secondary_growth_stage_by_pk?: Maybe<Secondary_Growth_Stage>;
  /** update multiples rows of table: "secondary_growth_stage" */
  update_secondary_growth_stage_many?: Maybe<Array<Maybe<Secondary_Growth_Stage_Mutation_Response>>>;
  /** update data of the table: "section" */
  update_section?: Maybe<Section_Mutation_Response>;
  /** update single row of the table: "section" */
  update_section_by_pk?: Maybe<Section>;
  /** update multiples rows of table: "section" */
  update_section_many?: Maybe<Array<Maybe<Section_Mutation_Response>>>;
  /** update data of the table: "seeds" */
  update_seeds?: Maybe<Seeds_Mutation_Response>;
  /** update single row of the table: "seeds" */
  update_seeds_by_pk?: Maybe<Seeds>;
  /** update multiples rows of table: "seeds" */
  update_seeds_many?: Maybe<Array<Maybe<Seeds_Mutation_Response>>>;
  /** update data of the table: "sellable_item" */
  update_sellable_item?: Maybe<Sellable_Item_Mutation_Response>;
  /** update single row of the table: "sellable_item" */
  update_sellable_item_by_pk?: Maybe<Sellable_Item>;
  /** update multiples rows of table: "sellable_item" */
  update_sellable_item_many?: Maybe<Array<Maybe<Sellable_Item_Mutation_Response>>>;
  /** update data of the table: "sellable_item_stock" */
  update_sellable_item_stock?: Maybe<Sellable_Item_Stock_Mutation_Response>;
  /** update single row of the table: "sellable_item_stock" */
  update_sellable_item_stock_by_pk?: Maybe<Sellable_Item_Stock>;
  /** update multiples rows of table: "sellable_item_stock" */
  update_sellable_item_stock_many?: Maybe<Array<Maybe<Sellable_Item_Stock_Mutation_Response>>>;
  /** update data of the table: "sensor" */
  update_sensor?: Maybe<Sensor_Mutation_Response>;
  /** update single row of the table: "sensor" */
  update_sensor_by_pk?: Maybe<Sensor>;
  /** update multiples rows of table: "sensor" */
  update_sensor_many?: Maybe<Array<Maybe<Sensor_Mutation_Response>>>;
  /** update data of the table: "sensor_parameter" */
  update_sensor_parameter?: Maybe<Sensor_Parameter_Mutation_Response>;
  /** update single row of the table: "sensor_parameter" */
  update_sensor_parameter_by_pk?: Maybe<Sensor_Parameter>;
  /** update multiples rows of table: "sensor_parameter" */
  update_sensor_parameter_many?: Maybe<Array<Maybe<Sensor_Parameter_Mutation_Response>>>;
  /** update data of the table: "series" */
  update_series?: Maybe<Series_Mutation_Response>;
  /** update data of the table: "series_authors" */
  update_series_authors?: Maybe<Series_Authors_Mutation_Response>;
  /** update single row of the table: "series_authors" */
  update_series_authors_by_pk?: Maybe<Series_Authors>;
  /** update multiples rows of table: "series_authors" */
  update_series_authors_many?: Maybe<Array<Maybe<Series_Authors_Mutation_Response>>>;
  /** update single row of the table: "series" */
  update_series_by_pk?: Maybe<Series>;
  /** update data of the table: "series_category" */
  update_series_category?: Maybe<Series_Category_Mutation_Response>;
  /** update single row of the table: "series_category" */
  update_series_category_by_pk?: Maybe<Series_Category>;
  /** update multiples rows of table: "series_category" */
  update_series_category_many?: Maybe<Array<Maybe<Series_Category_Mutation_Response>>>;
  /** update data of the table: "series_crops" */
  update_series_crops?: Maybe<Series_Crops_Mutation_Response>;
  /** update single row of the table: "series_crops" */
  update_series_crops_by_pk?: Maybe<Series_Crops>;
  /** update multiples rows of table: "series_crops" */
  update_series_crops_many?: Maybe<Array<Maybe<Series_Crops_Mutation_Response>>>;
  /** update data of the table: "series_favorites" */
  update_series_favorites?: Maybe<Series_Favorites_Mutation_Response>;
  /** update single row of the table: "series_favorites" */
  update_series_favorites_by_pk?: Maybe<Series_Favorites>;
  /** update multiples rows of table: "series_favorites" */
  update_series_favorites_many?: Maybe<Array<Maybe<Series_Favorites_Mutation_Response>>>;
  /** update data of the table: "series_likes" */
  update_series_likes?: Maybe<Series_Likes_Mutation_Response>;
  /** update single row of the table: "series_likes" */
  update_series_likes_by_pk?: Maybe<Series_Likes>;
  /** update multiples rows of table: "series_likes" */
  update_series_likes_many?: Maybe<Array<Maybe<Series_Likes_Mutation_Response>>>;
  /** update multiples rows of table: "series" */
  update_series_many?: Maybe<Array<Maybe<Series_Mutation_Response>>>;
  /** update data of the table: "shared_entity" */
  update_setu_trade_shared_entity?: Maybe<Setu_Trade_Shared_Entity_Mutation_Response>;
  /** update multiples rows of table: "shared_entity" */
  update_setu_trade_shared_entity_many?: Maybe<Array<Maybe<Setu_Trade_Shared_Entity_Mutation_Response>>>;
  /** update data of the table: "setu_weather_user" */
  update_setu_weather_user?: Maybe<Setu_Weather_User_Mutation_Response>;
  /** update single row of the table: "setu_weather_user" */
  update_setu_weather_user_by_pk?: Maybe<Setu_Weather_User>;
  /** update multiples rows of table: "setu_weather_user" */
  update_setu_weather_user_many?: Maybe<Array<Maybe<Setu_Weather_User_Mutation_Response>>>;
  /** update data of the table: "shared_entity" */
  update_shared_entity?: Maybe<Shared_Entity_Mutation_Response>;
  /** update single row of the table: "shared_entity" */
  update_shared_entity_by_pk?: Maybe<Shared_Entity>;
  /** update multiples rows of table: "shared_entity" */
  update_shared_entity_many?: Maybe<Array<Maybe<Shared_Entity_Mutation_Response>>>;
  /** update data of the table: "si_unit" */
  update_si_unit?: Maybe<Si_Unit_Mutation_Response>;
  /** update single row of the table: "si_unit" */
  update_si_unit_by_pk?: Maybe<Si_Unit>;
  /** update multiples rows of table: "si_unit" */
  update_si_unit_many?: Maybe<Array<Maybe<Si_Unit_Mutation_Response>>>;
  /** update data of the table: "si_unit_measure" */
  update_si_unit_measure?: Maybe<Si_Unit_Measure_Mutation_Response>;
  /** update single row of the table: "si_unit_measure" */
  update_si_unit_measure_by_pk?: Maybe<Si_Unit_Measure>;
  /** update multiples rows of table: "si_unit_measure" */
  update_si_unit_measure_many?: Maybe<Array<Maybe<Si_Unit_Measure_Mutation_Response>>>;
  /** update data of the table: "sku" */
  update_sku?: Maybe<Sku_Mutation_Response>;
  /** update single row of the table: "sku" */
  update_sku_by_pk?: Maybe<Sku>;
  /** update data of the table: "sku_kind" */
  update_sku_kind?: Maybe<Sku_Kind_Mutation_Response>;
  /** update single row of the table: "sku_kind" */
  update_sku_kind_by_pk?: Maybe<Sku_Kind>;
  /** update multiples rows of table: "sku_kind" */
  update_sku_kind_many?: Maybe<Array<Maybe<Sku_Kind_Mutation_Response>>>;
  /** update multiples rows of table: "sku" */
  update_sku_many?: Maybe<Array<Maybe<Sku_Mutation_Response>>>;
  /** update data of the table: "soil" */
  update_soil?: Maybe<Soil_Mutation_Response>;
  /** update single row of the table: "soil" */
  update_soil_by_pk?: Maybe<Soil>;
  /** update multiples rows of table: "soil" */
  update_soil_many?: Maybe<Array<Maybe<Soil_Mutation_Response>>>;
  /** update data of the table: "sprinkler_irrigation_system" */
  update_sprinkler_irrigation_system?: Maybe<Sprinkler_Irrigation_System_Mutation_Response>;
  /** update single row of the table: "sprinkler_irrigation_system" */
  update_sprinkler_irrigation_system_by_pk?: Maybe<Sprinkler_Irrigation_System>;
  /** update multiples rows of table: "sprinkler_irrigation_system" */
  update_sprinkler_irrigation_system_many?: Maybe<Array<Maybe<Sprinkler_Irrigation_System_Mutation_Response>>>;
  /** update data of the table: "sub_section" */
  update_sub_section?: Maybe<Sub_Section_Mutation_Response>;
  /** update single row of the table: "sub_section" */
  update_sub_section_by_pk?: Maybe<Sub_Section>;
  /** update multiples rows of table: "sub_section" */
  update_sub_section_many?: Maybe<Array<Maybe<Sub_Section_Mutation_Response>>>;
  /** update data of the table: "subcategory" */
  update_subcategory?: Maybe<Subcategory_Mutation_Response>;
  /** update single row of the table: "subcategory" */
  update_subcategory_by_pk?: Maybe<Subcategory>;
  /** update multiples rows of table: "subcategory" */
  update_subcategory_many?: Maybe<Array<Maybe<Subcategory_Mutation_Response>>>;
  /** update data of the table: "subscription_package_highlights" */
  update_subscription_package_highlights?: Maybe<Subscription_Package_Highlights_Mutation_Response>;
  /** update single row of the table: "subscription_package_highlights" */
  update_subscription_package_highlights_by_pk?: Maybe<Subscription_Package_Highlights>;
  /** update multiples rows of table: "subscription_package_highlights" */
  update_subscription_package_highlights_many?: Maybe<Array<Maybe<Subscription_Package_Highlights_Mutation_Response>>>;
  /** update data of the table: "summary_sensor_reading" */
  update_summary_sensor_reading?: Maybe<Summary_Sensor_Reading_Mutation_Response>;
  /** update single row of the table: "summary_sensor_reading" */
  update_summary_sensor_reading_by_pk?: Maybe<Summary_Sensor_Reading>;
  /** update multiples rows of table: "summary_sensor_reading" */
  update_summary_sensor_reading_many?: Maybe<Array<Maybe<Summary_Sensor_Reading_Mutation_Response>>>;
  /** update data of the table: "thread" */
  update_thread?: Maybe<Thread_Mutation_Response>;
  /** update single row of the table: "thread" */
  update_thread_by_pk?: Maybe<Thread>;
  /** update multiples rows of table: "thread" */
  update_thread_many?: Maybe<Array<Maybe<Thread_Mutation_Response>>>;
  /** update data of the table: "trade" */
  update_trade?: Maybe<Trade_Mutation_Response>;
  update_trade_amounts?: Maybe<UpdateTradeAmountMutation>;
  /** update single row of the table: "trade" */
  update_trade_by_pk?: Maybe<Trade>;
  /** update data of the table: "trade_commodity" */
  update_trade_commodity?: Maybe<Trade_Commodity_Mutation_Response>;
  /** update single row of the table: "trade_commodity" */
  update_trade_commodity_by_pk?: Maybe<Trade_Commodity>;
  /** update multiples rows of table: "trade_commodity" */
  update_trade_commodity_many?: Maybe<Array<Maybe<Trade_Commodity_Mutation_Response>>>;
  /** update data of the table: "trade_item" */
  update_trade_item?: Maybe<Trade_Item_Mutation_Response>;
  /** update single row of the table: "trade_item" */
  update_trade_item_by_pk?: Maybe<Trade_Item>;
  /** update multiples rows of table: "trade_item" */
  update_trade_item_many?: Maybe<Array<Maybe<Trade_Item_Mutation_Response>>>;
  /** update multiples rows of table: "trade" */
  update_trade_many?: Maybe<Array<Maybe<Trade_Mutation_Response>>>;
  /** update data of the table: "trade_region" */
  update_trade_region?: Maybe<Trade_Region_Mutation_Response>;
  /** update single row of the table: "trade_region" */
  update_trade_region_by_pk?: Maybe<Trade_Region>;
  /** update multiples rows of table: "trade_region" */
  update_trade_region_many?: Maybe<Array<Maybe<Trade_Region_Mutation_Response>>>;
  /** update data of the table: "trade_transaction" */
  update_trade_transaction?: Maybe<Trade_Transaction_Mutation_Response>;
  /** update single row of the table: "trade_transaction" */
  update_trade_transaction_by_pk?: Maybe<Trade_Transaction>;
  /** update multiples rows of table: "trade_transaction" */
  update_trade_transaction_many?: Maybe<Array<Maybe<Trade_Transaction_Mutation_Response>>>;
  /** update data of the table: "trade_transaction_summary" */
  update_trade_transaction_summary?: Maybe<Trade_Transaction_Summary_Mutation_Response>;
  /** update single row of the table: "trade_transaction_summary" */
  update_trade_transaction_summary_by_pk?: Maybe<Trade_Transaction_Summary>;
  /** update multiples rows of table: "trade_transaction_summary" */
  update_trade_transaction_summary_many?: Maybe<Array<Maybe<Trade_Transaction_Summary_Mutation_Response>>>;
  /** update data of the table: "trade_unit" */
  update_trade_unit?: Maybe<Trade_Unit_Mutation_Response>;
  /** update single row of the table: "trade_unit" */
  update_trade_unit_by_pk?: Maybe<Trade_Unit>;
  /** update multiples rows of table: "trade_unit" */
  update_trade_unit_many?: Maybe<Array<Maybe<Trade_Unit_Mutation_Response>>>;
  /** update data of the table: "transaction_trend" */
  update_transaction_trend?: Maybe<Transaction_Trend_Mutation_Response>;
  /** update single row of the table: "transaction_trend" */
  update_transaction_trend_by_pk?: Maybe<Transaction_Trend>;
  /** update multiples rows of table: "transaction_trend" */
  update_transaction_trend_many?: Maybe<Array<Maybe<Transaction_Trend_Mutation_Response>>>;
  /** update data of the table: "unit" */
  update_unit?: Maybe<Unit_Mutation_Response>;
  /** update single row of the table: "unit" */
  update_unit_by_pk?: Maybe<Unit>;
  /** update multiples rows of table: "unit" */
  update_unit_many?: Maybe<Array<Maybe<Unit_Mutation_Response>>>;
  /** update data of the table: "user_answer_choices" */
  update_user_answer_choices?: Maybe<User_Answer_Choices_Mutation_Response>;
  /** update single row of the table: "user_answer_choices" */
  update_user_answer_choices_by_pk?: Maybe<User_Answer_Choices>;
  /** update multiples rows of table: "user_answer_choices" */
  update_user_answer_choices_many?: Maybe<Array<Maybe<User_Answer_Choices_Mutation_Response>>>;
  /** update data of the table: "user_assessment_attempt" */
  update_user_assessment_attempt?: Maybe<User_Assessment_Attempt_Mutation_Response>;
  /** update single row of the table: "user_assessment_attempt" */
  update_user_assessment_attempt_by_pk?: Maybe<User_Assessment_Attempt>;
  /** update multiples rows of table: "user_assessment_attempt" */
  update_user_assessment_attempt_many?: Maybe<Array<Maybe<User_Assessment_Attempt_Mutation_Response>>>;
  /** update data of the table: "user_assessment_question_response" */
  update_user_assessment_question_response?: Maybe<User_Assessment_Question_Response_Mutation_Response>;
  /** update single row of the table: "user_assessment_question_response" */
  update_user_assessment_question_response_by_pk?: Maybe<User_Assessment_Question_Response>;
  /** update multiples rows of table: "user_assessment_question_response" */
  update_user_assessment_question_response_many?: Maybe<Array<Maybe<User_Assessment_Question_Response_Mutation_Response>>>;
  /** update data of the table: "user_reward_history" */
  update_user_reward_history?: Maybe<User_Reward_History_Mutation_Response>;
  /** update single row of the table: "user_reward_history" */
  update_user_reward_history_by_pk?: Maybe<User_Reward_History>;
  /** update multiples rows of table: "user_reward_history" */
  update_user_reward_history_many?: Maybe<Array<Maybe<User_Reward_History_Mutation_Response>>>;
  /** update data of the table: "user_subscription_package" */
  update_user_subscription_package?: Maybe<User_Subscription_Package_Mutation_Response>;
  /** update single row of the table: "user_subscription_package" */
  update_user_subscription_package_by_pk?: Maybe<User_Subscription_Package>;
  /** update multiples rows of table: "user_subscription_package" */
  update_user_subscription_package_many?: Maybe<Array<Maybe<User_Subscription_Package_Mutation_Response>>>;
  /** update data of the table: "variety_grade" */
  update_variety_grade?: Maybe<Variety_Grade_Mutation_Response>;
  /** update single row of the table: "variety_grade" */
  update_variety_grade_by_pk?: Maybe<Variety_Grade>;
  /** update multiples rows of table: "variety_grade" */
  update_variety_grade_many?: Maybe<Array<Maybe<Variety_Grade_Mutation_Response>>>;
  /** update data of the table: "variety_grade_photos" */
  update_variety_grade_photos?: Maybe<Variety_Grade_Photos_Mutation_Response>;
  /** update single row of the table: "variety_grade_photos" */
  update_variety_grade_photos_by_pk?: Maybe<Variety_Grade_Photos>;
  /** update multiples rows of table: "variety_grade_photos" */
  update_variety_grade_photos_many?: Maybe<Array<Maybe<Variety_Grade_Photos_Mutation_Response>>>;
  /** update data of the table: "variety_group" */
  update_variety_group?: Maybe<Variety_Group_Mutation_Response>;
  /** update single row of the table: "variety_group" */
  update_variety_group_by_pk?: Maybe<Variety_Group>;
  /** update multiples rows of table: "variety_group" */
  update_variety_group_many?: Maybe<Array<Maybe<Variety_Group_Mutation_Response>>>;
  /** update data of the table: "weather_location" */
  update_weather_location?: Maybe<Weather_Location_Mutation_Response>;
  /** update single row of the table: "weather_location" */
  update_weather_location_by_pk?: Maybe<Weather_Location>;
  /** update multiples rows of table: "weather_location" */
  update_weather_location_many?: Maybe<Array<Maybe<Weather_Location_Mutation_Response>>>;
  /** update data of the table: "weather_reference" */
  update_weather_reference?: Maybe<Weather_Reference_Mutation_Response>;
  /** update single row of the table: "weather_reference" */
  update_weather_reference_by_pk?: Maybe<Weather_Reference>;
  /** update multiples rows of table: "weather_reference" */
  update_weather_reference_many?: Maybe<Array<Maybe<Weather_Reference_Mutation_Response>>>;
  upsert_intercultural_operation?: Maybe<UpsertInterculturalOperationMutation>;
  verify_otp?: Maybe<VerifyOtp>;
  verify_token?: Maybe<Verify>;
  verify_token_setu?: Maybe<Verify>;
  verify_trade_otp?: Maybe<VerifyTradeOtp>;
};


/** mutation root */
export type Mutation_RootAccept_Terms_And_ConditionsArgs = {
  plot_crop_id: Scalars['String'];
  pop_config_id?: InputMaybe<Scalars['String']>;
  terms_and_conditions_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootAdd_Update_Base_UserArgs = {
  base_user?: InputMaybe<BaseUserInput>;
  create_team?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Dock_DetailArgs = {
  dock_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  supervisor_id?: InputMaybe<Scalars['ID']>;
  trip_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Order_TransactionArgs = {
  amount: Scalars['Float'];
  attachment?: InputMaybe<MediaGlInput>;
  id?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<Scalars['GenericScalar']>;
  order_id: Scalars['ID'];
  order_status?: InputMaybe<Scalars['String']>;
  payment_method?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  trip_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootAdd_Update_ReceiptArgs = {
  input?: InputMaybe<ReceiptInput>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Trip_DetailArgs = {
  date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  trip?: InputMaybe<Scalars['ID']>;
  vehicle_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootAgent_LoginArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


/** mutation root */
export type Mutation_RootBroadcast_ConsentsArgs = {
  send_to_buyer?: InputMaybe<Scalars['Boolean']>;
  send_to_seller?: InputMaybe<Scalars['Boolean']>;
  trade_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootBulk_Update_Base_User_CompaniesArgs = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  users: Array<InputMaybe<Scalars['ID']>>;
};


/** mutation root */
export type Mutation_RootBulk_Update_OrderArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreate_Agronomist_Plot_Crop_DiaryArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  location?: InputMaybe<LonLatInput>;
  notes: Scalars['String'];
  organisation_id?: InputMaybe<Scalars['String']>;
  plot_crop_id: Scalars['String'];
  record_datetime?: InputMaybe<Scalars['DateTime']>;
  share_with_grower?: InputMaybe<Scalars['Boolean']>;
  voice_note?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type Mutation_RootCreate_Expenses_ConfigArgs = {
  department_id: Scalars['Int'];
  expenses_config: Array<InputMaybe<ExpensesConfigSchema>>;
  trade_kind: Scalars['String'];
  trade_mode: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreate_NotificationArgs = {
  body?: InputMaybe<Scalars['String']>;
  broadcast_datetime: Scalars['DateTime'];
  category_id: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  image_url?: InputMaybe<Scalars['String']>;
  network_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  record_id?: InputMaybe<Scalars['String']>;
  region_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  team_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  user_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** mutation root */
export type Mutation_RootCreate_ObservationArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  crop_year?: InputMaybe<Scalars['String']>;
  is_applied?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<LonLatInput>;
  notes?: InputMaybe<Scalars['String']>;
  observations: Array<InputMaybe<SampleRecordType>>;
  planned_activity_id?: InputMaybe<Scalars['String']>;
  plot_crop_id: Scalars['String'];
  private_notes?: InputMaybe<Scalars['String']>;
  private_voice_note?: InputMaybe<Scalars['Int']>;
  record_date: Scalars['DateTime'];
  share_with_grower?: InputMaybe<Scalars['Boolean']>;
  voice_note?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type Mutation_RootCreate_OperationArgs = {
  applied_products?: InputMaybe<Array<InputMaybe<AppliedProductsOperationSchema>>>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  crop_year?: InputMaybe<Scalars['String']>;
  duration: DurationSchema;
  harvest?: InputMaybe<HarvestOperationSchema>;
  is_applied?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<OperationLonLatInput>;
  method_id: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  other_applied_products?: InputMaybe<Array<InputMaybe<OtherAppliedProductsOperationSchema>>>;
  planned_activity_id?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
  start_datetime: Scalars['DateTime'];
  voice_note?: InputMaybe<Scalars['Int']>;
  water_used?: InputMaybe<WaterUsedOperationSchema>;
};


/** mutation root */
export type Mutation_RootCreate_Tnc_ConfigArgs = {
  conditions: Scalars['String'];
  department_id: Scalars['Int'];
  trade_kind: Scalars['String'];
  trade_mode: Scalars['String'];
  trade_party: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Action_LogArgs = {
  where: Action_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Action_Log_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Active_IngredientArgs = {
  where: Active_Ingredient_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Active_Ingredient_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Actual_ReadingArgs = {
  where: Actual_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Actual_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Advice_Author_FollowersArgs = {
  where: Advice_Author_Followers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Advice_Author_Followers_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Advice_AuthorsArgs = {
  where: Advice_Authors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Advice_Authors_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_AgentArgs = {
  where: Agent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agent_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agent_CompanyArgs = {
  where: Agent_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agent_Company_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Answer_ChoiceArgs = {
  where: Answer_Choice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Answer_Choice_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Application_Product_UnitArgs = {
  where: Application_Product_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Application_Product_Unit_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_ArticleArgs = {
  where: Article_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_AttachmentsArgs = {
  where: Article_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_AuthorsArgs = {
  where: Article_Authors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Authors_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Article_CategoriesArgs = {
  where: Article_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Categories_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_CategoryArgs = {
  where: Article_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Article_Crop_CategoriesArgs = {
  where: Article_Crop_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Crop_Categories_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_Crop_VarietiesArgs = {
  where: Article_Crop_Varieties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Crop_Varieties_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_CropsArgs = {
  where: Article_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Crops_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_FavoritesArgs = {
  where: Article_Favorites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Favorites_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_LikesArgs = {
  where: Article_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Likes_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_RegionsArgs = {
  where: Article_Regions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Regions_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_SeriesArgs = {
  where: Article_Series_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Series_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Article_Subscription_PackageArgs = {
  where: Article_Subscription_Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Subscription_Package_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Article_SubscriptionsArgs = {
  where: Article_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Subscriptions_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_User_GroupArgs = {
  where: Article_User_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_User_Group_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Article_ViewsArgs = {
  where: Article_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Article_Views_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_AssessmentArgs = {
  where: Assessment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Assessment_QuestionArgs = {
  where: Assessment_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Question_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_AttributeArgs = {
  where: Attribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Attribute_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Attribute_ChoiceArgs = {
  where: Attribute_Choice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Attribute_Choice_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_GroupArgs = {
  where: Auth_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Group_PermissionsArgs = {
  where: Auth_Group_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Group_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_PermissionArgs = {
  where: Auth_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Permission_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_UserArgs = {
  where: Base_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Address_BookArgs = {
  where: Base_User_Address_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Address_Book_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_CompaniesArgs = {
  where: Base_User_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_DepartmentsArgs = {
  where: Base_User_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Departments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_GroupsArgs = {
  where: Base_User_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_NetworkArgs = {
  where: Base_User_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_User_PermissionsArgs = {
  where: Base_User_User_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_User_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BusinessArgs = {
  where: Business_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_Commodities_SuppliedArgs = {
  where: Business_Commodities_Supplied_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Commodities_Supplied_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_CompaniesArgs = {
  where: Business_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_GroupArgs = {
  where: Business_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_Group_NetworkArgs = {
  where: Business_Group_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_GroupsArgs = {
  where: Business_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_NetworkArgs = {
  where: Business_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_Secondary_PocsArgs = {
  where: Business_Secondary_Pocs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Secondary_Pocs_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_By_Pk_Care_Shared_EntityArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Care_Shared_EntityArgs = {
  where: Care_Shared_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CategoryArgs = {
  where: Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Certificate_IssuerArgs = {
  where: Certificate_Issuer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Certificate_Issuer_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CertificationArgs = {
  where: Certification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Certification_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CommentArgs = {
  where: Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Comment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CommodityArgs = {
  where: Commodity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Commodity_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Commodity_VarietyArgs = {
  where: Commodity_Variety_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Commodity_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Commodity_Variety_Secondary_GroupsArgs = {
  where: Commodity_Variety_Secondary_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Commodity_Variety_Secondary_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Common_FileuploadArgs = {
  where: Common_Fileupload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Common_Fileupload_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyArgs = {
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Cost_ItemArgs = {
  where: Cost_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cost_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CropArgs = {
  where: Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_FertilisersArgs = {
  where: Crop_Fertilisers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Fertilisers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_GroupArgs = {
  where: Crop_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_InfestationArgs = {
  where: Crop_Infestation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Infestation_AttachmentArgs = {
  where: Crop_Infestation_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Infestation_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_Infestation_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_MilestoneArgs = {
  where: Crop_Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_Operation_MethodsArgs = {
  where: Crop_Operation_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Operation_Methods_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_PesticidesArgs = {
  where: Crop_Pesticides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Pesticides_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_VarietyArgs = {
  where: Crop_Variety_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_Variety_SeedsArgs = {
  where: Crop_Variety_Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Variety_Seeds_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_YearArgs = {
  where: Crop_Year_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Year_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Cropmonitoring_ParameterArgs = {
  where: Cropmonitoring_Parameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cropmonitoring_Parameter_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CurrencyArgs = {
  where: Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Currency_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Daily_Actual_ReadingArgs = {
  where: Daily_Actual_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Daily_Actual_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Daily_Forecast_ReadingArgs = {
  where: Daily_Forecast_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Daily_Forecast_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_DepartmentArgs = {
  where: Department_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Department_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DeviceArgs = {
  where: Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Device_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Django_Content_TypeArgs = {
  where: Django_Content_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Django_Content_Type_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentArgs = {
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_AttachmentsArgs = {
  where: Document_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_DataArgs = {
  where: Document_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Data_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_KindArgs = {
  where: Document_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Kind_Data_FieldArgs = {
  where: Document_Kind_Data_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Kind_Data_Field_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Drip_Irrigation_SystemArgs = {
  where: Drip_Irrigation_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Drip_Irrigation_System_By_PkArgs = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ExpenseArgs = {
  where: Expense_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Expense_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_External_ReferenceArgs = {
  where: External_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_External_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FarmArgs = {
  where: Farm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farm_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Farm_NetworkArgs = {
  where: Farm_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farm_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FieldArgs = {
  where: Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Field_NetworkArgs = {
  where: Field_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Field_Weather_LocationArgs = {
  where: Field_Weather_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_Weather_Location_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FileuploadArgs = {
  where: Fileupload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fileupload_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Flood_Irrigation_SystemArgs = {
  where: Flood_Irrigation_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flood_Irrigation_System_By_PkArgs = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Forecast_ReadingArgs = {
  where: Forecast_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Forecast_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_GatewayArgs = {
  where: Gateway_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gateway_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Gateway_ConfigurationArgs = {
  where: Gateway_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gateway_Configuration_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Gateway_StatusArgs = {
  where: Gateway_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gateway_Status_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Grade_PriceArgs = {
  where: Grade_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grade_Price_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InfestationArgs = {
  where: Infestation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Infestation_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_IngredientArgs = {
  where: Ingredient_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ingredient_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Inst_Sensor_ReadingArgs = {
  where: Inst_Sensor_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Inst_Sensor_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Irrigation_SystemArgs = {
  where: Irrigation_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Irrigation_System_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Location_SubscriptionArgs = {
  where: Location_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Location_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Main_SectionArgs = {
  where: Main_Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Main_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ManufacturerArgs = {
  where: Manufacturer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manufacturer_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Manufacturing_FacilityArgs = {
  where: Manufacturing_Facility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manufacturing_Facility_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MarketArgs = {
  where: Market_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Market_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MarketerArgs = {
  where: Marketer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Marketer_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Marketing_FacilityArgs = {
  where: Marketing_Facility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Marketing_Facility_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Measure_OfArgs = {
  where: Measure_Of_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Measure_Of_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MediaArgs = {
  where: Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Media_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_MessageArgs = {
  where: Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MilestoneArgs = {
  where: Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_CategoryArgs = {
  where: Monitoring_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_ParameterArgs = {
  where: Monitoring_Parameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Parameter_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Parameter_ChoicesArgs = {
  where: Monitoring_Parameter_Choices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Parameter_Choices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Parameter_Unit_ChoicesArgs = {
  where: Monitoring_Parameter_Unit_Choices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Parameter_Unit_Choices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_RecordArgs = {
  where: Monitoring_Record_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Record_AttachmentsArgs = {
  where: Monitoring_Record_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Record_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Record_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_SampleArgs = {
  where: Monitoring_Sample_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Sample_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_SubcategoryArgs = {
  where: Monitoring_Subcategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Monitoring_Subcategory_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_GroupArgs = {
  where: Mutual_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_MembershipArgs = {
  where: Mutual_Group_Membership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Membership_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_NetworkArgs = {
  where: Mutual_Group_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_RoleArgs = {
  where: Mutual_Group_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Role_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Subscription_PackageArgs = {
  where: Mutual_Group_Subscription_Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Subscription_Package_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Weather_StationArgs = {
  where: Mutual_Group_Weather_Station_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Weather_Station_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_NetworkArgs = {
  where: Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationArgs = {
  where: Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_CategoryArgs = {
  where: Notification_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_TemplateArgs = {
  where: Notification_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Template_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_Template_Distribution_RegionArgs = {
  where: Notification_Template_Distribution_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Template_Distribution_Region_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_Template_Distribution_TeamArgs = {
  where: Notification_Template_Distribution_Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Template_Distribution_Team_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_Template_Distribution_UserArgs = {
  where: Notification_Template_Distribution_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Template_Distribution_User_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_NutrientsArgs = {
  where: Nutrients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nutrients_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Observation_NotificationArgs = {
  where: Observation_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Observation_Notification_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operation_AttachmentsArgs = {
  where: Operation_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Operation_CostArgs = {
  where: Operation_Cost_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operation_Cost_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operation_MethodsArgs = {
  where: Operation_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operation_Methods_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operation_Product_TypesArgs = {
  where: Operation_Product_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operation_Product_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_OperationsArgs = {
  where: Operations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Applied_FertiliserArgs = {
  where: Operations_Applied_Fertiliser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Applied_Fertiliser_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_Applied_PesticideArgs = {
  where: Operations_Applied_Pesticide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Applied_Pesticide_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_FertiliserArgs = {
  where: Operations_Fertiliser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Fertiliser_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_HarvestArgs = {
  where: Operations_Harvest_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Harvest_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_Harvest_OutputArgs = {
  where: Operations_Harvest_Output_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Harvest_Output_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_IntercultureArgs = {
  where: Operations_Interculture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Interculture_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_IrrigationArgs = {
  where: Operations_Irrigation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Irrigation_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_Land_PrepArgs = {
  where: Operations_Land_Prep_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Land_Prep_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_PesticideArgs = {
  where: Operations_Pesticide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Pesticide_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_SowingArgs = {
  where: Operations_Sowing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_Sowing_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_OrganisationArgs = {
  where: Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Document_KindArgs = {
  where: Organisation_Document_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Document_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_PreferencesArgs = {
  where: Organisation_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Preferences_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_SeasonArgs = {
  where: Organisation_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Season_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_DetailArgs = {
  where: Payment_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Detail_AttachmentsArgs = {
  where: Payment_Detail_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Detail_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_MethodArgs = {
  where: Payment_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Method_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PlotArgs = {
  where: Plot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_CropArgs = {
  where: Plot_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_AgentArgs = {
  where: Plot_Crop_Agent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Agent_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_MilestoneArgs = {
  where: Plot_Crop_Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_NetworkArgs = {
  where: Plot_Crop_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_NetworkArgs = {
  where: Plot_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_StatusArgs = {
  where: Plot_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Status_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Primary_Growth_StageArgs = {
  where: Primary_Growth_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Primary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ProductArgs = {
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_AttachmentArgs = {
  where: Product_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_AttributeArgs = {
  where: Product_Attribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Attribute_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Attribute_ChoiceArgs = {
  where: Product_Attribute_Choice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Attribute_Choice_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_CertificationArgs = {
  where: Product_Certification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Certification_AttachmentArgs = {
  where: Product_Certification_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Certification_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Certification_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_ClassArgs = {
  where: Product_Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Class_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_CompositionArgs = {
  where: Product_Composition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Composition_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Crop_AssociationArgs = {
  where: Product_Crop_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Crop_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Crop_Infestation_RecommendationArgs = {
  where: Product_Crop_Infestation_Recommendation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Crop_Infestation_Recommendation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Crop_Nutrition_RecommendationArgs = {
  where: Product_Crop_Nutrition_Recommendation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Crop_Nutrition_Recommendation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_FavouriteArgs = {
  where: Product_Favourite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Favourite_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_InfestationArgs = {
  where: Product_Infestation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Infestation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_MainsectionArgs = {
  where: Product_Mainsection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Mainsection_AttachmentArgs = {
  where: Product_Mainsection_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Mainsection_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Mainsection_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_PurchasedArgs = {
  where: Product_Purchased_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Purchased_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_SectionArgs = {
  where: Product_Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Section_AttachmentArgs = {
  where: Product_Section_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Section_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_SkuArgs = {
  where: Product_Sku_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Sku_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_SubsectionArgs = {
  where: Product_Subsection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Subsection_AttachmentArgs = {
  where: Product_Subsection_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Subsection_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Subsection_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_ViewArgs = {
  where: Product_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_View_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProductsArgs = {
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Products_FertiliserArgs = {
  where: Products_Fertiliser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_Fertiliser_By_PkArgs = {
  baseproduct_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Products_Fertiliser_ContentsArgs = {
  where: Products_Fertiliser_Contents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_Fertiliser_Contents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Products_Fertiliser_UnitsArgs = {
  where: Products_Fertiliser_Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_Fertiliser_Units_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Products_PesticideArgs = {
  where: Products_Pesticide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_Pesticide_By_PkArgs = {
  baseproduct_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Products_Pesticide_ContentsArgs = {
  where: Products_Pesticide_Contents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_Pesticide_Contents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Products_Pesticide_UnitsArgs = {
  where: Products_Pesticide_Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_Pesticide_Units_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProviderArgs = {
  where: Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ReceiptArgs = {
  where: Receipt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Receipt_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Recommended_ProductArgs = {
  where: Recommended_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Recommended_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RegionArgs = {
  where: Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Region_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Region_GroupArgs = {
  where: Region_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Region_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Reward_ConfigurationArgs = {
  where: Reward_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reward_Configuration_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sap_SiArgs = {
  where: Sap_Si_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sap_Si_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Sap_Si_MapArgs = {
  where: Sap_Si_Map_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sap_Si_Map_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Secondary_Growth_StageArgs = {
  where: Secondary_Growth_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Secondary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SectionArgs = {
  where: Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SeedsArgs = {
  where: Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seeds_By_PkArgs = {
  baseproduct_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sellable_ItemArgs = {
  where: Sellable_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sellable_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sellable_Item_StockArgs = {
  where: Sellable_Item_Stock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sellable_Item_Stock_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SensorArgs = {
  where: Sensor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sensor_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sensor_ParameterArgs = {
  where: Sensor_Parameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sensor_Parameter_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SeriesArgs = {
  where: Series_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Series_AuthorsArgs = {
  where: Series_Authors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Series_Authors_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Series_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Series_CategoryArgs = {
  where: Series_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Series_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Series_CropsArgs = {
  where: Series_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Series_Crops_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Series_FavoritesArgs = {
  where: Series_Favorites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Series_Favorites_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Series_LikesArgs = {
  where: Series_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Series_Likes_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Setu_Weather_UserArgs = {
  where: Setu_Weather_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Setu_Weather_User_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Shared_EntityArgs = {
  where: Shared_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shared_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Si_UnitArgs = {
  where: Si_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Si_Unit_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Si_Unit_MeasureArgs = {
  where: Si_Unit_Measure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Si_Unit_Measure_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SkuArgs = {
  where: Sku_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sku_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Sku_KindArgs = {
  where: Sku_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sku_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SoilArgs = {
  where: Soil_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Soil_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Sprinkler_Irrigation_SystemArgs = {
  where: Sprinkler_Irrigation_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sprinkler_Irrigation_System_By_PkArgs = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sub_SectionArgs = {
  where: Sub_Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sub_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SubcategoryArgs = {
  where: Subcategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subcategory_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Package_HighlightsArgs = {
  where: Subscription_Package_Highlights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Package_Highlights_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Summary_Sensor_ReadingArgs = {
  where: Summary_Sensor_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Summary_Sensor_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_ThreadArgs = {
  where: Thread_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Thread_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TradeArgs = {
  where: Trade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trade_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Trade_CommodityArgs = {
  where: Trade_Commodity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trade_Commodity_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trade_ItemArgs = {
  where: Trade_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trade_Item_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Trade_RegionArgs = {
  where: Trade_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trade_Region_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trade_TransactionArgs = {
  where: Trade_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trade_Transaction_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trade_Transaction_SummaryArgs = {
  where: Trade_Transaction_Summary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trade_Transaction_Summary_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trade_UnitArgs = {
  where: Trade_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trade_Unit_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Transaction_TrendArgs = {
  where: Transaction_Trend_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transaction_Trend_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UnitArgs = {
  where: Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unit_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Answer_ChoicesArgs = {
  where: User_Answer_Choices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Answer_Choices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Assessment_AttemptArgs = {
  where: User_Assessment_Attempt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Assessment_Attempt_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Assessment_Question_ResponseArgs = {
  where: User_Assessment_Question_Response_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Assessment_Question_Response_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Reward_HistoryArgs = {
  where: User_Reward_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Reward_History_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Subscription_PackageArgs = {
  where: User_Subscription_Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Subscription_Package_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Variety_GradeArgs = {
  where: Variety_Grade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variety_Grade_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Variety_Grade_PhotosArgs = {
  where: Variety_Grade_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variety_Grade_Photos_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Variety_GroupArgs = {
  where: Variety_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variety_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Weather_LocationArgs = {
  where: Weather_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Weather_Location_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Weather_ReferenceArgs = {
  where: Weather_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Weather_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootGenerate_Agent_TokenArgs = {
  agent_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootGenerate_Generic_TokenArgs = {
  agent_id?: InputMaybe<Scalars['ID']>;
  role?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootGenerate_InvoicesArgs = {
  department_id?: InputMaybe<Scalars['ID']>;
  trade_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/** mutation root */
export type Mutation_RootGenerate_OtpArgs = {
  extra_variables?: InputMaybe<Scalars['GenericScalar']>;
  number: Scalars['String'];
  provider_uid?: InputMaybe<Scalars['String']>;
  template_uid?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootGenerate_Trade_OtpArgs = {
  token?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootInsert_Action_LogArgs = {
  objects: Array<Action_Log_Insert_Input>;
  on_conflict?: InputMaybe<Action_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Action_Log_OneArgs = {
  object: Action_Log_Insert_Input;
  on_conflict?: InputMaybe<Action_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Active_IngredientArgs = {
  objects: Array<Active_Ingredient_Insert_Input>;
  on_conflict?: InputMaybe<Active_Ingredient_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Active_Ingredient_OneArgs = {
  object: Active_Ingredient_Insert_Input;
  on_conflict?: InputMaybe<Active_Ingredient_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Actual_ReadingArgs = {
  objects: Array<Actual_Reading_Insert_Input>;
  on_conflict?: InputMaybe<Actual_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Actual_Reading_OneArgs = {
  object: Actual_Reading_Insert_Input;
  on_conflict?: InputMaybe<Actual_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advice_Author_FollowersArgs = {
  objects: Array<Advice_Author_Followers_Insert_Input>;
  on_conflict?: InputMaybe<Advice_Author_Followers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advice_Author_Followers_OneArgs = {
  object: Advice_Author_Followers_Insert_Input;
  on_conflict?: InputMaybe<Advice_Author_Followers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advice_AuthorsArgs = {
  objects: Array<Advice_Authors_Insert_Input>;
  on_conflict?: InputMaybe<Advice_Authors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advice_Authors_OneArgs = {
  object: Advice_Authors_Insert_Input;
  on_conflict?: InputMaybe<Advice_Authors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AgentArgs = {
  objects: Array<Agent_Insert_Input>;
  on_conflict?: InputMaybe<Agent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_CompanyArgs = {
  objects: Array<Agent_Company_Insert_Input>;
  on_conflict?: InputMaybe<Agent_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_Company_OneArgs = {
  object: Agent_Company_Insert_Input;
  on_conflict?: InputMaybe<Agent_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_OneArgs = {
  object: Agent_Insert_Input;
  on_conflict?: InputMaybe<Agent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Answer_ChoiceArgs = {
  objects: Array<Answer_Choice_Insert_Input>;
  on_conflict?: InputMaybe<Answer_Choice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Answer_Choice_OneArgs = {
  object: Answer_Choice_Insert_Input;
  on_conflict?: InputMaybe<Answer_Choice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_Product_UnitArgs = {
  objects: Array<Application_Product_Unit_Insert_Input>;
  on_conflict?: InputMaybe<Application_Product_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_Product_Unit_OneArgs = {
  object: Application_Product_Unit_Insert_Input;
  on_conflict?: InputMaybe<Application_Product_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ArticleArgs = {
  objects: Array<Article_Insert_Input>;
  on_conflict?: InputMaybe<Article_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_AttachmentsArgs = {
  objects: Array<Article_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Article_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Attachments_OneArgs = {
  object: Article_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Article_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_AuthorsArgs = {
  objects: Array<Article_Authors_Insert_Input>;
  on_conflict?: InputMaybe<Article_Authors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Authors_OneArgs = {
  object: Article_Authors_Insert_Input;
  on_conflict?: InputMaybe<Article_Authors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_CategoriesArgs = {
  objects: Array<Article_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Article_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Categories_OneArgs = {
  object: Article_Categories_Insert_Input;
  on_conflict?: InputMaybe<Article_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_CategoryArgs = {
  objects: Array<Article_Category_Insert_Input>;
  on_conflict?: InputMaybe<Article_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Category_OneArgs = {
  object: Article_Category_Insert_Input;
  on_conflict?: InputMaybe<Article_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Crop_CategoriesArgs = {
  objects: Array<Article_Crop_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Article_Crop_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Crop_Categories_OneArgs = {
  object: Article_Crop_Categories_Insert_Input;
  on_conflict?: InputMaybe<Article_Crop_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Crop_VarietiesArgs = {
  objects: Array<Article_Crop_Varieties_Insert_Input>;
  on_conflict?: InputMaybe<Article_Crop_Varieties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Crop_Varieties_OneArgs = {
  object: Article_Crop_Varieties_Insert_Input;
  on_conflict?: InputMaybe<Article_Crop_Varieties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_CropsArgs = {
  objects: Array<Article_Crops_Insert_Input>;
  on_conflict?: InputMaybe<Article_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Crops_OneArgs = {
  object: Article_Crops_Insert_Input;
  on_conflict?: InputMaybe<Article_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_FavoritesArgs = {
  objects: Array<Article_Favorites_Insert_Input>;
  on_conflict?: InputMaybe<Article_Favorites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Favorites_OneArgs = {
  object: Article_Favorites_Insert_Input;
  on_conflict?: InputMaybe<Article_Favorites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_LikesArgs = {
  objects: Array<Article_Likes_Insert_Input>;
  on_conflict?: InputMaybe<Article_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Likes_OneArgs = {
  object: Article_Likes_Insert_Input;
  on_conflict?: InputMaybe<Article_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_OneArgs = {
  object: Article_Insert_Input;
  on_conflict?: InputMaybe<Article_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_RegionsArgs = {
  objects: Array<Article_Regions_Insert_Input>;
  on_conflict?: InputMaybe<Article_Regions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Regions_OneArgs = {
  object: Article_Regions_Insert_Input;
  on_conflict?: InputMaybe<Article_Regions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_SeriesArgs = {
  objects: Array<Article_Series_Insert_Input>;
  on_conflict?: InputMaybe<Article_Series_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Series_OneArgs = {
  object: Article_Series_Insert_Input;
  on_conflict?: InputMaybe<Article_Series_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Subscription_PackageArgs = {
  objects: Array<Article_Subscription_Package_Insert_Input>;
  on_conflict?: InputMaybe<Article_Subscription_Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Subscription_Package_OneArgs = {
  object: Article_Subscription_Package_Insert_Input;
  on_conflict?: InputMaybe<Article_Subscription_Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_SubscriptionsArgs = {
  objects: Array<Article_Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<Article_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Subscriptions_OneArgs = {
  object: Article_Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<Article_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_User_GroupArgs = {
  objects: Array<Article_User_Group_Insert_Input>;
  on_conflict?: InputMaybe<Article_User_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_User_Group_OneArgs = {
  object: Article_User_Group_Insert_Input;
  on_conflict?: InputMaybe<Article_User_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_ViewsArgs = {
  objects: Array<Article_Views_Insert_Input>;
  on_conflict?: InputMaybe<Article_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Article_Views_OneArgs = {
  object: Article_Views_Insert_Input;
  on_conflict?: InputMaybe<Article_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AssessmentArgs = {
  objects: Array<Assessment_Insert_Input>;
  on_conflict?: InputMaybe<Assessment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_OneArgs = {
  object: Assessment_Insert_Input;
  on_conflict?: InputMaybe<Assessment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_QuestionArgs = {
  objects: Array<Assessment_Question_Insert_Input>;
  on_conflict?: InputMaybe<Assessment_Question_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_Question_OneArgs = {
  object: Assessment_Question_Insert_Input;
  on_conflict?: InputMaybe<Assessment_Question_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeArgs = {
  objects: Array<Attribute_Insert_Input>;
  on_conflict?: InputMaybe<Attribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attribute_ChoiceArgs = {
  objects: Array<Attribute_Choice_Insert_Input>;
  on_conflict?: InputMaybe<Attribute_Choice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attribute_Choice_OneArgs = {
  object: Attribute_Choice_Insert_Input;
  on_conflict?: InputMaybe<Attribute_Choice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attribute_OneArgs = {
  object: Attribute_Insert_Input;
  on_conflict?: InputMaybe<Attribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_GroupArgs = {
  objects: Array<Auth_Group_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Group_OneArgs = {
  object: Auth_Group_Insert_Input;
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Group_PermissionsArgs = {
  objects: Array<Auth_Group_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Group_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Group_Permissions_OneArgs = {
  object: Auth_Group_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Auth_Group_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_PermissionArgs = {
  objects: Array<Auth_Permission_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Permission_OneArgs = {
  object: Auth_Permission_Insert_Input;
  on_conflict?: InputMaybe<Auth_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_UserArgs = {
  objects: Array<Base_User_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Address_BookArgs = {
  objects: Array<Base_User_Address_Book_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_Address_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Address_Book_OneArgs = {
  object: Base_User_Address_Book_Insert_Input;
  on_conflict?: InputMaybe<Base_User_Address_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_CompaniesArgs = {
  objects: Array<Base_User_Companies_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Companies_OneArgs = {
  object: Base_User_Companies_Insert_Input;
  on_conflict?: InputMaybe<Base_User_Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_DepartmentsArgs = {
  objects: Array<Base_User_Departments_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Departments_OneArgs = {
  object: Base_User_Departments_Insert_Input;
  on_conflict?: InputMaybe<Base_User_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_GroupsArgs = {
  objects: Array<Base_User_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Groups_OneArgs = {
  object: Base_User_Groups_Insert_Input;
  on_conflict?: InputMaybe<Base_User_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_NetworkArgs = {
  objects: Array<Base_User_Network_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Network_OneArgs = {
  object: Base_User_Network_Insert_Input;
  on_conflict?: InputMaybe<Base_User_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_OneArgs = {
  object: Base_User_Insert_Input;
  on_conflict?: InputMaybe<Base_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_User_PermissionsArgs = {
  objects: Array<Base_User_User_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_User_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_User_Permissions_OneArgs = {
  object: Base_User_User_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Base_User_User_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BusinessArgs = {
  objects: Array<Business_Insert_Input>;
  on_conflict?: InputMaybe<Business_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Commodities_SuppliedArgs = {
  objects: Array<Business_Commodities_Supplied_Insert_Input>;
  on_conflict?: InputMaybe<Business_Commodities_Supplied_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Commodities_Supplied_OneArgs = {
  object: Business_Commodities_Supplied_Insert_Input;
  on_conflict?: InputMaybe<Business_Commodities_Supplied_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_CompaniesArgs = {
  objects: Array<Business_Companies_Insert_Input>;
  on_conflict?: InputMaybe<Business_Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Companies_OneArgs = {
  object: Business_Companies_Insert_Input;
  on_conflict?: InputMaybe<Business_Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_GroupArgs = {
  objects: Array<Business_Group_Insert_Input>;
  on_conflict?: InputMaybe<Business_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Group_NetworkArgs = {
  objects: Array<Business_Group_Network_Insert_Input>;
  on_conflict?: InputMaybe<Business_Group_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Group_Network_OneArgs = {
  object: Business_Group_Network_Insert_Input;
  on_conflict?: InputMaybe<Business_Group_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Group_OneArgs = {
  object: Business_Group_Insert_Input;
  on_conflict?: InputMaybe<Business_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_GroupsArgs = {
  objects: Array<Business_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Business_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Groups_OneArgs = {
  object: Business_Groups_Insert_Input;
  on_conflict?: InputMaybe<Business_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_NetworkArgs = {
  objects: Array<Business_Network_Insert_Input>;
  on_conflict?: InputMaybe<Business_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Network_OneArgs = {
  object: Business_Network_Insert_Input;
  on_conflict?: InputMaybe<Business_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_OneArgs = {
  object: Business_Insert_Input;
  on_conflict?: InputMaybe<Business_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Secondary_PocsArgs = {
  objects: Array<Business_Secondary_Pocs_Insert_Input>;
  on_conflict?: InputMaybe<Business_Secondary_Pocs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Secondary_Pocs_OneArgs = {
  object: Business_Secondary_Pocs_Insert_Input;
  on_conflict?: InputMaybe<Business_Secondary_Pocs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Care_Shared_EntityArgs = {
  objects: Array<Care_Shared_Entity_Insert_Input>;
  on_conflict?: InputMaybe<Care_Shared_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Care_Shared_Entity_OneArgs = {
  object: Care_Shared_Entity_Insert_Input;
  on_conflict?: InputMaybe<Care_Shared_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CategoryArgs = {
  objects: Array<Category_Insert_Input>;
  on_conflict?: InputMaybe<Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_OneArgs = {
  object: Category_Insert_Input;
  on_conflict?: InputMaybe<Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certificate_IssuerArgs = {
  objects: Array<Certificate_Issuer_Insert_Input>;
  on_conflict?: InputMaybe<Certificate_Issuer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certificate_Issuer_OneArgs = {
  object: Certificate_Issuer_Insert_Input;
  on_conflict?: InputMaybe<Certificate_Issuer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CertificationArgs = {
  objects: Array<Certification_Insert_Input>;
  on_conflict?: InputMaybe<Certification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certification_OneArgs = {
  object: Certification_Insert_Input;
  on_conflict?: InputMaybe<Certification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommentArgs = {
  objects: Array<Comment_Insert_Input>;
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comment_OneArgs = {
  object: Comment_Insert_Input;
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommodityArgs = {
  objects: Array<Commodity_Insert_Input>;
  on_conflict?: InputMaybe<Commodity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_OneArgs = {
  object: Commodity_Insert_Input;
  on_conflict?: InputMaybe<Commodity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_VarietyArgs = {
  objects: Array<Commodity_Variety_Insert_Input>;
  on_conflict?: InputMaybe<Commodity_Variety_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_Variety_OneArgs = {
  object: Commodity_Variety_Insert_Input;
  on_conflict?: InputMaybe<Commodity_Variety_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_Variety_Secondary_GroupsArgs = {
  objects: Array<Commodity_Variety_Secondary_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Commodity_Variety_Secondary_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_Variety_Secondary_Groups_OneArgs = {
  object: Commodity_Variety_Secondary_Groups_Insert_Input;
  on_conflict?: InputMaybe<Commodity_Variety_Secondary_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Common_FileuploadArgs = {
  objects: Array<Common_Fileupload_Insert_Input>;
  on_conflict?: InputMaybe<Common_Fileupload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Common_Fileupload_OneArgs = {
  object: Common_Fileupload_Insert_Input;
  on_conflict?: InputMaybe<Common_Fileupload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyArgs = {
  objects: Array<Company_Insert_Input>;
  on_conflict?: InputMaybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_OneArgs = {
  object: Company_Insert_Input;
  on_conflict?: InputMaybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cost_ItemArgs = {
  objects: Array<Cost_Item_Insert_Input>;
  on_conflict?: InputMaybe<Cost_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cost_Item_OneArgs = {
  object: Cost_Item_Insert_Input;
  on_conflict?: InputMaybe<Cost_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CropArgs = {
  objects: Array<Crop_Insert_Input>;
  on_conflict?: InputMaybe<Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_FertilisersArgs = {
  objects: Array<Crop_Fertilisers_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Fertilisers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Fertilisers_OneArgs = {
  object: Crop_Fertilisers_Insert_Input;
  on_conflict?: InputMaybe<Crop_Fertilisers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_GroupArgs = {
  objects: Array<Crop_Group_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Group_OneArgs = {
  object: Crop_Group_Insert_Input;
  on_conflict?: InputMaybe<Crop_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_InfestationArgs = {
  objects: Array<Crop_Infestation_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Infestation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Infestation_AttachmentArgs = {
  objects: Array<Crop_Infestation_Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Infestation_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Infestation_Attachment_OneArgs = {
  object: Crop_Infestation_Attachment_Insert_Input;
  on_conflict?: InputMaybe<Crop_Infestation_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Infestation_OneArgs = {
  object: Crop_Infestation_Insert_Input;
  on_conflict?: InputMaybe<Crop_Infestation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_MilestoneArgs = {
  objects: Array<Crop_Milestone_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Milestone_OneArgs = {
  object: Crop_Milestone_Insert_Input;
  on_conflict?: InputMaybe<Crop_Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_OneArgs = {
  object: Crop_Insert_Input;
  on_conflict?: InputMaybe<Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Operation_MethodsArgs = {
  objects: Array<Crop_Operation_Methods_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Operation_Methods_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Operation_Methods_OneArgs = {
  object: Crop_Operation_Methods_Insert_Input;
  on_conflict?: InputMaybe<Crop_Operation_Methods_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_PesticidesArgs = {
  objects: Array<Crop_Pesticides_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Pesticides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Pesticides_OneArgs = {
  object: Crop_Pesticides_Insert_Input;
  on_conflict?: InputMaybe<Crop_Pesticides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_VarietyArgs = {
  objects: Array<Crop_Variety_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Variety_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Variety_OneArgs = {
  object: Crop_Variety_Insert_Input;
  on_conflict?: InputMaybe<Crop_Variety_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Variety_SeedsArgs = {
  objects: Array<Crop_Variety_Seeds_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Variety_Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Variety_Seeds_OneArgs = {
  object: Crop_Variety_Seeds_Insert_Input;
  on_conflict?: InputMaybe<Crop_Variety_Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_YearArgs = {
  objects: Array<Crop_Year_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Year_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Year_OneArgs = {
  object: Crop_Year_Insert_Input;
  on_conflict?: InputMaybe<Crop_Year_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cropmonitoring_ParameterArgs = {
  objects: Array<Cropmonitoring_Parameter_Insert_Input>;
  on_conflict?: InputMaybe<Cropmonitoring_Parameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cropmonitoring_Parameter_OneArgs = {
  object: Cropmonitoring_Parameter_Insert_Input;
  on_conflict?: InputMaybe<Cropmonitoring_Parameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CurrencyArgs = {
  objects: Array<Currency_Insert_Input>;
  on_conflict?: InputMaybe<Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Currency_OneArgs = {
  object: Currency_Insert_Input;
  on_conflict?: InputMaybe<Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Daily_Actual_ReadingArgs = {
  objects: Array<Daily_Actual_Reading_Insert_Input>;
  on_conflict?: InputMaybe<Daily_Actual_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Daily_Actual_Reading_OneArgs = {
  object: Daily_Actual_Reading_Insert_Input;
  on_conflict?: InputMaybe<Daily_Actual_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Daily_Forecast_ReadingArgs = {
  objects: Array<Daily_Forecast_Reading_Insert_Input>;
  on_conflict?: InputMaybe<Daily_Forecast_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Daily_Forecast_Reading_OneArgs = {
  object: Daily_Forecast_Reading_Insert_Input;
  on_conflict?: InputMaybe<Daily_Forecast_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DepartmentArgs = {
  objects: Array<Department_Insert_Input>;
  on_conflict?: InputMaybe<Department_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_OneArgs = {
  object: Department_Insert_Input;
  on_conflict?: InputMaybe<Department_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DeviceArgs = {
  objects: Array<Device_Insert_Input>;
  on_conflict?: InputMaybe<Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Device_OneArgs = {
  object: Device_Insert_Input;
  on_conflict?: InputMaybe<Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Django_Content_TypeArgs = {
  objects: Array<Django_Content_Type_Insert_Input>;
  on_conflict?: InputMaybe<Django_Content_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Django_Content_Type_OneArgs = {
  object: Django_Content_Type_Insert_Input;
  on_conflict?: InputMaybe<Django_Content_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentArgs = {
  objects: Array<Document_Insert_Input>;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_AttachmentsArgs = {
  objects: Array<Document_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Document_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Attachments_OneArgs = {
  object: Document_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Document_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_DataArgs = {
  objects: Array<Document_Data_Insert_Input>;
  on_conflict?: InputMaybe<Document_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Data_OneArgs = {
  object: Document_Data_Insert_Input;
  on_conflict?: InputMaybe<Document_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_KindArgs = {
  objects: Array<Document_Kind_Insert_Input>;
  on_conflict?: InputMaybe<Document_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Kind_Data_FieldArgs = {
  objects: Array<Document_Kind_Data_Field_Insert_Input>;
  on_conflict?: InputMaybe<Document_Kind_Data_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Kind_Data_Field_OneArgs = {
  object: Document_Kind_Data_Field_Insert_Input;
  on_conflict?: InputMaybe<Document_Kind_Data_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Kind_OneArgs = {
  object: Document_Kind_Insert_Input;
  on_conflict?: InputMaybe<Document_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_OneArgs = {
  object: Document_Insert_Input;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Drip_Irrigation_SystemArgs = {
  objects: Array<Drip_Irrigation_System_Insert_Input>;
  on_conflict?: InputMaybe<Drip_Irrigation_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Drip_Irrigation_System_OneArgs = {
  object: Drip_Irrigation_System_Insert_Input;
  on_conflict?: InputMaybe<Drip_Irrigation_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExpenseArgs = {
  objects: Array<Expense_Insert_Input>;
  on_conflict?: InputMaybe<Expense_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expense_OneArgs = {
  object: Expense_Insert_Input;
  on_conflict?: InputMaybe<Expense_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_ReferenceArgs = {
  objects: Array<External_Reference_Insert_Input>;
  on_conflict?: InputMaybe<External_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_Reference_OneArgs = {
  object: External_Reference_Insert_Input;
  on_conflict?: InputMaybe<External_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FarmArgs = {
  objects: Array<Farm_Insert_Input>;
  on_conflict?: InputMaybe<Farm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farm_NetworkArgs = {
  objects: Array<Farm_Network_Insert_Input>;
  on_conflict?: InputMaybe<Farm_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farm_Network_OneArgs = {
  object: Farm_Network_Insert_Input;
  on_conflict?: InputMaybe<Farm_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farm_OneArgs = {
  object: Farm_Insert_Input;
  on_conflict?: InputMaybe<Farm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FieldArgs = {
  objects: Array<Field_Insert_Input>;
  on_conflict?: InputMaybe<Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_NetworkArgs = {
  objects: Array<Field_Network_Insert_Input>;
  on_conflict?: InputMaybe<Field_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Network_OneArgs = {
  object: Field_Network_Insert_Input;
  on_conflict?: InputMaybe<Field_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_OneArgs = {
  object: Field_Insert_Input;
  on_conflict?: InputMaybe<Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Weather_LocationArgs = {
  objects: Array<Field_Weather_Location_Insert_Input>;
  on_conflict?: InputMaybe<Field_Weather_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Weather_Location_OneArgs = {
  object: Field_Weather_Location_Insert_Input;
  on_conflict?: InputMaybe<Field_Weather_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileuploadArgs = {
  objects: Array<Fileupload_Insert_Input>;
  on_conflict?: InputMaybe<Fileupload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fileupload_OneArgs = {
  object: Fileupload_Insert_Input;
  on_conflict?: InputMaybe<Fileupload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flood_Irrigation_SystemArgs = {
  objects: Array<Flood_Irrigation_System_Insert_Input>;
  on_conflict?: InputMaybe<Flood_Irrigation_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flood_Irrigation_System_OneArgs = {
  object: Flood_Irrigation_System_Insert_Input;
  on_conflict?: InputMaybe<Flood_Irrigation_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Forecast_ReadingArgs = {
  objects: Array<Forecast_Reading_Insert_Input>;
  on_conflict?: InputMaybe<Forecast_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Forecast_Reading_OneArgs = {
  object: Forecast_Reading_Insert_Input;
  on_conflict?: InputMaybe<Forecast_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GatewayArgs = {
  objects: Array<Gateway_Insert_Input>;
  on_conflict?: InputMaybe<Gateway_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gateway_ConfigurationArgs = {
  objects: Array<Gateway_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<Gateway_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gateway_Configuration_OneArgs = {
  object: Gateway_Configuration_Insert_Input;
  on_conflict?: InputMaybe<Gateway_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gateway_OneArgs = {
  object: Gateway_Insert_Input;
  on_conflict?: InputMaybe<Gateway_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gateway_StatusArgs = {
  objects: Array<Gateway_Status_Insert_Input>;
  on_conflict?: InputMaybe<Gateway_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gateway_Status_OneArgs = {
  object: Gateway_Status_Insert_Input;
  on_conflict?: InputMaybe<Gateway_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_PriceArgs = {
  objects: Array<Grade_Price_Insert_Input>;
  on_conflict?: InputMaybe<Grade_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_Price_OneArgs = {
  object: Grade_Price_Insert_Input;
  on_conflict?: InputMaybe<Grade_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InfestationArgs = {
  objects: Array<Infestation_Insert_Input>;
  on_conflict?: InputMaybe<Infestation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Infestation_OneArgs = {
  object: Infestation_Insert_Input;
  on_conflict?: InputMaybe<Infestation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IngredientArgs = {
  objects: Array<Ingredient_Insert_Input>;
  on_conflict?: InputMaybe<Ingredient_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ingredient_OneArgs = {
  object: Ingredient_Insert_Input;
  on_conflict?: InputMaybe<Ingredient_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Inst_Sensor_ReadingArgs = {
  objects: Array<Inst_Sensor_Reading_Insert_Input>;
  on_conflict?: InputMaybe<Inst_Sensor_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Inst_Sensor_Reading_OneArgs = {
  object: Inst_Sensor_Reading_Insert_Input;
  on_conflict?: InputMaybe<Inst_Sensor_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Irrigation_SystemArgs = {
  objects: Array<Irrigation_System_Insert_Input>;
  on_conflict?: InputMaybe<Irrigation_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Irrigation_System_OneArgs = {
  object: Irrigation_System_Insert_Input;
  on_conflict?: InputMaybe<Irrigation_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_SubscriptionArgs = {
  objects: Array<Location_Subscription_Insert_Input>;
  on_conflict?: InputMaybe<Location_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_Subscription_OneArgs = {
  object: Location_Subscription_Insert_Input;
  on_conflict?: InputMaybe<Location_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Main_SectionArgs = {
  objects: Array<Main_Section_Insert_Input>;
  on_conflict?: InputMaybe<Main_Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Main_Section_OneArgs = {
  object: Main_Section_Insert_Input;
  on_conflict?: InputMaybe<Main_Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ManufacturerArgs = {
  objects: Array<Manufacturer_Insert_Input>;
  on_conflict?: InputMaybe<Manufacturer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manufacturer_OneArgs = {
  object: Manufacturer_Insert_Input;
  on_conflict?: InputMaybe<Manufacturer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manufacturing_FacilityArgs = {
  objects: Array<Manufacturing_Facility_Insert_Input>;
  on_conflict?: InputMaybe<Manufacturing_Facility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manufacturing_Facility_OneArgs = {
  object: Manufacturing_Facility_Insert_Input;
  on_conflict?: InputMaybe<Manufacturing_Facility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MarketArgs = {
  objects: Array<Market_Insert_Input>;
  on_conflict?: InputMaybe<Market_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Market_OneArgs = {
  object: Market_Insert_Input;
  on_conflict?: InputMaybe<Market_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MarketerArgs = {
  objects: Array<Marketer_Insert_Input>;
  on_conflict?: InputMaybe<Marketer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Marketer_OneArgs = {
  object: Marketer_Insert_Input;
  on_conflict?: InputMaybe<Marketer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Marketing_FacilityArgs = {
  objects: Array<Marketing_Facility_Insert_Input>;
  on_conflict?: InputMaybe<Marketing_Facility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Marketing_Facility_OneArgs = {
  object: Marketing_Facility_Insert_Input;
  on_conflict?: InputMaybe<Marketing_Facility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Measure_OfArgs = {
  objects: Array<Measure_Of_Insert_Input>;
  on_conflict?: InputMaybe<Measure_Of_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Measure_Of_OneArgs = {
  object: Measure_Of_Insert_Input;
  on_conflict?: InputMaybe<Measure_Of_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MediaArgs = {
  objects: Array<Media_Insert_Input>;
  on_conflict?: InputMaybe<Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Media_OneArgs = {
  object: Media_Insert_Input;
  on_conflict?: InputMaybe<Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MessageArgs = {
  objects: Array<Message_Insert_Input>;
  on_conflict?: InputMaybe<Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Message_OneArgs = {
  object: Message_Insert_Input;
  on_conflict?: InputMaybe<Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MilestoneArgs = {
  objects: Array<Milestone_Insert_Input>;
  on_conflict?: InputMaybe<Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Milestone_OneArgs = {
  object: Milestone_Insert_Input;
  on_conflict?: InputMaybe<Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_CategoryArgs = {
  objects: Array<Monitoring_Category_Insert_Input>;
  on_conflict?: InputMaybe<Monitoring_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Category_OneArgs = {
  object: Monitoring_Category_Insert_Input;
  on_conflict?: InputMaybe<Monitoring_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_ParameterArgs = {
  objects: Array<Monitoring_Parameter_Insert_Input>;
  on_conflict?: InputMaybe<Monitoring_Parameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Parameter_ChoicesArgs = {
  objects: Array<Monitoring_Parameter_Choices_Insert_Input>;
  on_conflict?: InputMaybe<Monitoring_Parameter_Choices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Parameter_Choices_OneArgs = {
  object: Monitoring_Parameter_Choices_Insert_Input;
  on_conflict?: InputMaybe<Monitoring_Parameter_Choices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Parameter_OneArgs = {
  object: Monitoring_Parameter_Insert_Input;
  on_conflict?: InputMaybe<Monitoring_Parameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Parameter_Unit_ChoicesArgs = {
  objects: Array<Monitoring_Parameter_Unit_Choices_Insert_Input>;
  on_conflict?: InputMaybe<Monitoring_Parameter_Unit_Choices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Parameter_Unit_Choices_OneArgs = {
  object: Monitoring_Parameter_Unit_Choices_Insert_Input;
  on_conflict?: InputMaybe<Monitoring_Parameter_Unit_Choices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_RecordArgs = {
  objects: Array<Monitoring_Record_Insert_Input>;
  on_conflict?: InputMaybe<Monitoring_Record_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Record_AttachmentsArgs = {
  objects: Array<Monitoring_Record_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Monitoring_Record_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Record_Attachments_OneArgs = {
  object: Monitoring_Record_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Monitoring_Record_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Record_OneArgs = {
  object: Monitoring_Record_Insert_Input;
  on_conflict?: InputMaybe<Monitoring_Record_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_SampleArgs = {
  objects: Array<Monitoring_Sample_Insert_Input>;
  on_conflict?: InputMaybe<Monitoring_Sample_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Sample_OneArgs = {
  object: Monitoring_Sample_Insert_Input;
  on_conflict?: InputMaybe<Monitoring_Sample_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_SubcategoryArgs = {
  objects: Array<Monitoring_Subcategory_Insert_Input>;
  on_conflict?: InputMaybe<Monitoring_Subcategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitoring_Subcategory_OneArgs = {
  object: Monitoring_Subcategory_Insert_Input;
  on_conflict?: InputMaybe<Monitoring_Subcategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_GroupArgs = {
  objects: Array<Mutual_Group_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_MembershipArgs = {
  objects: Array<Mutual_Group_Membership_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_Membership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Membership_OneArgs = {
  object: Mutual_Group_Membership_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_Membership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_NetworkArgs = {
  objects: Array<Mutual_Group_Network_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Network_OneArgs = {
  object: Mutual_Group_Network_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_OneArgs = {
  object: Mutual_Group_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_RoleArgs = {
  objects: Array<Mutual_Group_Role_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Role_OneArgs = {
  object: Mutual_Group_Role_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Subscription_PackageArgs = {
  objects: Array<Mutual_Group_Subscription_Package_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_Subscription_Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Subscription_Package_OneArgs = {
  object: Mutual_Group_Subscription_Package_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_Subscription_Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Weather_StationArgs = {
  objects: Array<Mutual_Group_Weather_Station_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_Weather_Station_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Weather_Station_OneArgs = {
  object: Mutual_Group_Weather_Station_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_Weather_Station_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NetworkArgs = {
  objects: Array<Network_Insert_Input>;
  on_conflict?: InputMaybe<Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Network_OneArgs = {
  object: Network_Insert_Input;
  on_conflict?: InputMaybe<Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationArgs = {
  objects: Array<Notification_Insert_Input>;
  on_conflict?: InputMaybe<Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_CategoryArgs = {
  objects: Array<Notification_Category_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Category_OneArgs = {
  object: Notification_Category_Insert_Input;
  on_conflict?: InputMaybe<Notification_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_OneArgs = {
  object: Notification_Insert_Input;
  on_conflict?: InputMaybe<Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_TemplateArgs = {
  objects: Array<Notification_Template_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Template_Distribution_RegionArgs = {
  objects: Array<Notification_Template_Distribution_Region_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Template_Distribution_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Template_Distribution_Region_OneArgs = {
  object: Notification_Template_Distribution_Region_Insert_Input;
  on_conflict?: InputMaybe<Notification_Template_Distribution_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Template_Distribution_TeamArgs = {
  objects: Array<Notification_Template_Distribution_Team_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Template_Distribution_Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Template_Distribution_Team_OneArgs = {
  object: Notification_Template_Distribution_Team_Insert_Input;
  on_conflict?: InputMaybe<Notification_Template_Distribution_Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Template_Distribution_UserArgs = {
  objects: Array<Notification_Template_Distribution_User_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Template_Distribution_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Template_Distribution_User_OneArgs = {
  object: Notification_Template_Distribution_User_Insert_Input;
  on_conflict?: InputMaybe<Notification_Template_Distribution_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Template_OneArgs = {
  object: Notification_Template_Insert_Input;
  on_conflict?: InputMaybe<Notification_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NutrientsArgs = {
  objects: Array<Nutrients_Insert_Input>;
  on_conflict?: InputMaybe<Nutrients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nutrients_OneArgs = {
  object: Nutrients_Insert_Input;
  on_conflict?: InputMaybe<Nutrients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Observation_NotificationArgs = {
  objects: Array<Observation_Notification_Insert_Input>;
  on_conflict?: InputMaybe<Observation_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Observation_Notification_OneArgs = {
  object: Observation_Notification_Insert_Input;
  on_conflict?: InputMaybe<Observation_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_AttachmentsArgs = {
  objects: Array<Operation_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Operation_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_Attachments_OneArgs = {
  object: Operation_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Operation_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_CostArgs = {
  objects: Array<Operation_Cost_Insert_Input>;
  on_conflict?: InputMaybe<Operation_Cost_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_Cost_OneArgs = {
  object: Operation_Cost_Insert_Input;
  on_conflict?: InputMaybe<Operation_Cost_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_MethodsArgs = {
  objects: Array<Operation_Methods_Insert_Input>;
  on_conflict?: InputMaybe<Operation_Methods_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_Methods_OneArgs = {
  object: Operation_Methods_Insert_Input;
  on_conflict?: InputMaybe<Operation_Methods_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_Product_TypesArgs = {
  objects: Array<Operation_Product_Types_Insert_Input>;
  on_conflict?: InputMaybe<Operation_Product_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_Product_Types_OneArgs = {
  object: Operation_Product_Types_Insert_Input;
  on_conflict?: InputMaybe<Operation_Product_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OperationsArgs = {
  objects: Array<Operations_Insert_Input>;
  on_conflict?: InputMaybe<Operations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Applied_FertiliserArgs = {
  objects: Array<Operations_Applied_Fertiliser_Insert_Input>;
  on_conflict?: InputMaybe<Operations_Applied_Fertiliser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Applied_Fertiliser_OneArgs = {
  object: Operations_Applied_Fertiliser_Insert_Input;
  on_conflict?: InputMaybe<Operations_Applied_Fertiliser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Applied_PesticideArgs = {
  objects: Array<Operations_Applied_Pesticide_Insert_Input>;
  on_conflict?: InputMaybe<Operations_Applied_Pesticide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Applied_Pesticide_OneArgs = {
  object: Operations_Applied_Pesticide_Insert_Input;
  on_conflict?: InputMaybe<Operations_Applied_Pesticide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_FertiliserArgs = {
  objects: Array<Operations_Fertiliser_Insert_Input>;
  on_conflict?: InputMaybe<Operations_Fertiliser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Fertiliser_OneArgs = {
  object: Operations_Fertiliser_Insert_Input;
  on_conflict?: InputMaybe<Operations_Fertiliser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_HarvestArgs = {
  objects: Array<Operations_Harvest_Insert_Input>;
  on_conflict?: InputMaybe<Operations_Harvest_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Harvest_OneArgs = {
  object: Operations_Harvest_Insert_Input;
  on_conflict?: InputMaybe<Operations_Harvest_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Harvest_OutputArgs = {
  objects: Array<Operations_Harvest_Output_Insert_Input>;
  on_conflict?: InputMaybe<Operations_Harvest_Output_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Harvest_Output_OneArgs = {
  object: Operations_Harvest_Output_Insert_Input;
  on_conflict?: InputMaybe<Operations_Harvest_Output_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_IntercultureArgs = {
  objects: Array<Operations_Interculture_Insert_Input>;
  on_conflict?: InputMaybe<Operations_Interculture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Interculture_OneArgs = {
  object: Operations_Interculture_Insert_Input;
  on_conflict?: InputMaybe<Operations_Interculture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_IrrigationArgs = {
  objects: Array<Operations_Irrigation_Insert_Input>;
  on_conflict?: InputMaybe<Operations_Irrigation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Irrigation_OneArgs = {
  object: Operations_Irrigation_Insert_Input;
  on_conflict?: InputMaybe<Operations_Irrigation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Land_PrepArgs = {
  objects: Array<Operations_Land_Prep_Insert_Input>;
  on_conflict?: InputMaybe<Operations_Land_Prep_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Land_Prep_OneArgs = {
  object: Operations_Land_Prep_Insert_Input;
  on_conflict?: InputMaybe<Operations_Land_Prep_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_OneArgs = {
  object: Operations_Insert_Input;
  on_conflict?: InputMaybe<Operations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_PesticideArgs = {
  objects: Array<Operations_Pesticide_Insert_Input>;
  on_conflict?: InputMaybe<Operations_Pesticide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Pesticide_OneArgs = {
  object: Operations_Pesticide_Insert_Input;
  on_conflict?: InputMaybe<Operations_Pesticide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_SowingArgs = {
  objects: Array<Operations_Sowing_Insert_Input>;
  on_conflict?: InputMaybe<Operations_Sowing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Sowing_OneArgs = {
  object: Operations_Sowing_Insert_Input;
  on_conflict?: InputMaybe<Operations_Sowing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationArgs = {
  objects: Array<Organisation_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Document_KindArgs = {
  objects: Array<Organisation_Document_Kind_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Document_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Document_Kind_OneArgs = {
  object: Organisation_Document_Kind_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Document_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_OneArgs = {
  object: Organisation_Insert_Input;
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_PreferencesArgs = {
  objects: Array<Organisation_Preferences_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Preferences_OneArgs = {
  object: Organisation_Preferences_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_SeasonArgs = {
  objects: Array<Organisation_Season_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Season_OneArgs = {
  object: Organisation_Season_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_DetailArgs = {
  objects: Array<Payment_Detail_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Detail_AttachmentsArgs = {
  objects: Array<Payment_Detail_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Detail_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Detail_Attachments_OneArgs = {
  object: Payment_Detail_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Payment_Detail_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Detail_OneArgs = {
  object: Payment_Detail_Insert_Input;
  on_conflict?: InputMaybe<Payment_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_MethodArgs = {
  objects: Array<Payment_Method_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Method_OneArgs = {
  object: Payment_Method_Insert_Input;
  on_conflict?: InputMaybe<Payment_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlotArgs = {
  objects: Array<Plot_Insert_Input>;
  on_conflict?: InputMaybe<Plot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_CropArgs = {
  objects: Array<Plot_Crop_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_AgentArgs = {
  objects: Array<Plot_Crop_Agent_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_Agent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Agent_OneArgs = {
  object: Plot_Crop_Agent_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_Agent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_MilestoneArgs = {
  objects: Array<Plot_Crop_Milestone_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Milestone_OneArgs = {
  object: Plot_Crop_Milestone_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_NetworkArgs = {
  objects: Array<Plot_Crop_Network_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Network_OneArgs = {
  object: Plot_Crop_Network_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_OneArgs = {
  object: Plot_Crop_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_NetworkArgs = {
  objects: Array<Plot_Network_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Network_OneArgs = {
  object: Plot_Network_Insert_Input;
  on_conflict?: InputMaybe<Plot_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_OneArgs = {
  object: Plot_Insert_Input;
  on_conflict?: InputMaybe<Plot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_StatusArgs = {
  objects: Array<Plot_Status_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Status_OneArgs = {
  object: Plot_Status_Insert_Input;
  on_conflict?: InputMaybe<Plot_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Primary_Growth_StageArgs = {
  objects: Array<Primary_Growth_Stage_Insert_Input>;
  on_conflict?: InputMaybe<Primary_Growth_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Primary_Growth_Stage_OneArgs = {
  object: Primary_Growth_Stage_Insert_Input;
  on_conflict?: InputMaybe<Primary_Growth_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductArgs = {
  objects: Array<Product_Insert_Input>;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_AttachmentArgs = {
  objects: Array<Product_Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Product_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Attachment_OneArgs = {
  object: Product_Attachment_Insert_Input;
  on_conflict?: InputMaybe<Product_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_AttributeArgs = {
  objects: Array<Product_Attribute_Insert_Input>;
  on_conflict?: InputMaybe<Product_Attribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Attribute_ChoiceArgs = {
  objects: Array<Product_Attribute_Choice_Insert_Input>;
  on_conflict?: InputMaybe<Product_Attribute_Choice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Attribute_Choice_OneArgs = {
  object: Product_Attribute_Choice_Insert_Input;
  on_conflict?: InputMaybe<Product_Attribute_Choice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Attribute_OneArgs = {
  object: Product_Attribute_Insert_Input;
  on_conflict?: InputMaybe<Product_Attribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_CertificationArgs = {
  objects: Array<Product_Certification_Insert_Input>;
  on_conflict?: InputMaybe<Product_Certification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Certification_AttachmentArgs = {
  objects: Array<Product_Certification_Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Product_Certification_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Certification_Attachment_OneArgs = {
  object: Product_Certification_Attachment_Insert_Input;
  on_conflict?: InputMaybe<Product_Certification_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Certification_OneArgs = {
  object: Product_Certification_Insert_Input;
  on_conflict?: InputMaybe<Product_Certification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_ClassArgs = {
  objects: Array<Product_Class_Insert_Input>;
  on_conflict?: InputMaybe<Product_Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Class_OneArgs = {
  object: Product_Class_Insert_Input;
  on_conflict?: InputMaybe<Product_Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_CompositionArgs = {
  objects: Array<Product_Composition_Insert_Input>;
  on_conflict?: InputMaybe<Product_Composition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Composition_OneArgs = {
  object: Product_Composition_Insert_Input;
  on_conflict?: InputMaybe<Product_Composition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Crop_AssociationArgs = {
  objects: Array<Product_Crop_Association_Insert_Input>;
  on_conflict?: InputMaybe<Product_Crop_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Crop_Association_OneArgs = {
  object: Product_Crop_Association_Insert_Input;
  on_conflict?: InputMaybe<Product_Crop_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Crop_Infestation_RecommendationArgs = {
  objects: Array<Product_Crop_Infestation_Recommendation_Insert_Input>;
  on_conflict?: InputMaybe<Product_Crop_Infestation_Recommendation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Crop_Infestation_Recommendation_OneArgs = {
  object: Product_Crop_Infestation_Recommendation_Insert_Input;
  on_conflict?: InputMaybe<Product_Crop_Infestation_Recommendation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Crop_Nutrition_RecommendationArgs = {
  objects: Array<Product_Crop_Nutrition_Recommendation_Insert_Input>;
  on_conflict?: InputMaybe<Product_Crop_Nutrition_Recommendation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Crop_Nutrition_Recommendation_OneArgs = {
  object: Product_Crop_Nutrition_Recommendation_Insert_Input;
  on_conflict?: InputMaybe<Product_Crop_Nutrition_Recommendation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_FavouriteArgs = {
  objects: Array<Product_Favourite_Insert_Input>;
  on_conflict?: InputMaybe<Product_Favourite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Favourite_OneArgs = {
  object: Product_Favourite_Insert_Input;
  on_conflict?: InputMaybe<Product_Favourite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_InfestationArgs = {
  objects: Array<Product_Infestation_Insert_Input>;
  on_conflict?: InputMaybe<Product_Infestation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Infestation_OneArgs = {
  object: Product_Infestation_Insert_Input;
  on_conflict?: InputMaybe<Product_Infestation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_MainsectionArgs = {
  objects: Array<Product_Mainsection_Insert_Input>;
  on_conflict?: InputMaybe<Product_Mainsection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Mainsection_AttachmentArgs = {
  objects: Array<Product_Mainsection_Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Product_Mainsection_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Mainsection_Attachment_OneArgs = {
  object: Product_Mainsection_Attachment_Insert_Input;
  on_conflict?: InputMaybe<Product_Mainsection_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Mainsection_OneArgs = {
  object: Product_Mainsection_Insert_Input;
  on_conflict?: InputMaybe<Product_Mainsection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_OneArgs = {
  object: Product_Insert_Input;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_PurchasedArgs = {
  objects: Array<Product_Purchased_Insert_Input>;
  on_conflict?: InputMaybe<Product_Purchased_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Purchased_OneArgs = {
  object: Product_Purchased_Insert_Input;
  on_conflict?: InputMaybe<Product_Purchased_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_SectionArgs = {
  objects: Array<Product_Section_Insert_Input>;
  on_conflict?: InputMaybe<Product_Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Section_AttachmentArgs = {
  objects: Array<Product_Section_Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Product_Section_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Section_Attachment_OneArgs = {
  object: Product_Section_Attachment_Insert_Input;
  on_conflict?: InputMaybe<Product_Section_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Section_OneArgs = {
  object: Product_Section_Insert_Input;
  on_conflict?: InputMaybe<Product_Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_SkuArgs = {
  objects: Array<Product_Sku_Insert_Input>;
  on_conflict?: InputMaybe<Product_Sku_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Sku_OneArgs = {
  object: Product_Sku_Insert_Input;
  on_conflict?: InputMaybe<Product_Sku_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_SubsectionArgs = {
  objects: Array<Product_Subsection_Insert_Input>;
  on_conflict?: InputMaybe<Product_Subsection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Subsection_AttachmentArgs = {
  objects: Array<Product_Subsection_Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Product_Subsection_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Subsection_Attachment_OneArgs = {
  object: Product_Subsection_Attachment_Insert_Input;
  on_conflict?: InputMaybe<Product_Subsection_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Subsection_OneArgs = {
  object: Product_Subsection_Insert_Input;
  on_conflict?: InputMaybe<Product_Subsection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_ViewArgs = {
  objects: Array<Product_View_Insert_Input>;
  on_conflict?: InputMaybe<Product_View_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_View_OneArgs = {
  object: Product_View_Insert_Input;
  on_conflict?: InputMaybe<Product_View_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductsArgs = {
  objects: Array<Products_Insert_Input>;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_FertiliserArgs = {
  objects: Array<Products_Fertiliser_Insert_Input>;
  on_conflict?: InputMaybe<Products_Fertiliser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_Fertiliser_ContentsArgs = {
  objects: Array<Products_Fertiliser_Contents_Insert_Input>;
  on_conflict?: InputMaybe<Products_Fertiliser_Contents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_Fertiliser_Contents_OneArgs = {
  object: Products_Fertiliser_Contents_Insert_Input;
  on_conflict?: InputMaybe<Products_Fertiliser_Contents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_Fertiliser_OneArgs = {
  object: Products_Fertiliser_Insert_Input;
  on_conflict?: InputMaybe<Products_Fertiliser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_Fertiliser_UnitsArgs = {
  objects: Array<Products_Fertiliser_Units_Insert_Input>;
  on_conflict?: InputMaybe<Products_Fertiliser_Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_Fertiliser_Units_OneArgs = {
  object: Products_Fertiliser_Units_Insert_Input;
  on_conflict?: InputMaybe<Products_Fertiliser_Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_OneArgs = {
  object: Products_Insert_Input;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_PesticideArgs = {
  objects: Array<Products_Pesticide_Insert_Input>;
  on_conflict?: InputMaybe<Products_Pesticide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_Pesticide_ContentsArgs = {
  objects: Array<Products_Pesticide_Contents_Insert_Input>;
  on_conflict?: InputMaybe<Products_Pesticide_Contents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_Pesticide_Contents_OneArgs = {
  object: Products_Pesticide_Contents_Insert_Input;
  on_conflict?: InputMaybe<Products_Pesticide_Contents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_Pesticide_OneArgs = {
  object: Products_Pesticide_Insert_Input;
  on_conflict?: InputMaybe<Products_Pesticide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_Pesticide_UnitsArgs = {
  objects: Array<Products_Pesticide_Units_Insert_Input>;
  on_conflict?: InputMaybe<Products_Pesticide_Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_Pesticide_Units_OneArgs = {
  object: Products_Pesticide_Units_Insert_Input;
  on_conflict?: InputMaybe<Products_Pesticide_Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderArgs = {
  objects: Array<Provider_Insert_Input>;
  on_conflict?: InputMaybe<Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_OneArgs = {
  object: Provider_Insert_Input;
  on_conflict?: InputMaybe<Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReceiptArgs = {
  objects: Array<Receipt_Insert_Input>;
  on_conflict?: InputMaybe<Receipt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Receipt_OneArgs = {
  object: Receipt_Insert_Input;
  on_conflict?: InputMaybe<Receipt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recommended_ProductArgs = {
  objects: Array<Recommended_Product_Insert_Input>;
  on_conflict?: InputMaybe<Recommended_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recommended_Product_OneArgs = {
  object: Recommended_Product_Insert_Input;
  on_conflict?: InputMaybe<Recommended_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RegionArgs = {
  objects: Array<Region_Insert_Input>;
  on_conflict?: InputMaybe<Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Region_GroupArgs = {
  objects: Array<Region_Group_Insert_Input>;
  on_conflict?: InputMaybe<Region_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Region_Group_OneArgs = {
  object: Region_Group_Insert_Input;
  on_conflict?: InputMaybe<Region_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Region_OneArgs = {
  object: Region_Insert_Input;
  on_conflict?: InputMaybe<Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reward_ConfigurationArgs = {
  objects: Array<Reward_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<Reward_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reward_Configuration_OneArgs = {
  object: Reward_Configuration_Insert_Input;
  on_conflict?: InputMaybe<Reward_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sap_SiArgs = {
  objects: Array<Sap_Si_Insert_Input>;
  on_conflict?: InputMaybe<Sap_Si_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sap_Si_MapArgs = {
  objects: Array<Sap_Si_Map_Insert_Input>;
  on_conflict?: InputMaybe<Sap_Si_Map_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sap_Si_Map_OneArgs = {
  object: Sap_Si_Map_Insert_Input;
  on_conflict?: InputMaybe<Sap_Si_Map_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sap_Si_OneArgs = {
  object: Sap_Si_Insert_Input;
  on_conflict?: InputMaybe<Sap_Si_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Secondary_Growth_StageArgs = {
  objects: Array<Secondary_Growth_Stage_Insert_Input>;
  on_conflict?: InputMaybe<Secondary_Growth_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Secondary_Growth_Stage_OneArgs = {
  object: Secondary_Growth_Stage_Insert_Input;
  on_conflict?: InputMaybe<Secondary_Growth_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SectionArgs = {
  objects: Array<Section_Insert_Input>;
  on_conflict?: InputMaybe<Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Section_OneArgs = {
  object: Section_Insert_Input;
  on_conflict?: InputMaybe<Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SeedsArgs = {
  objects: Array<Seeds_Insert_Input>;
  on_conflict?: InputMaybe<Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seeds_OneArgs = {
  object: Seeds_Insert_Input;
  on_conflict?: InputMaybe<Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sellable_ItemArgs = {
  objects: Array<Sellable_Item_Insert_Input>;
  on_conflict?: InputMaybe<Sellable_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sellable_Item_OneArgs = {
  object: Sellable_Item_Insert_Input;
  on_conflict?: InputMaybe<Sellable_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sellable_Item_StockArgs = {
  objects: Array<Sellable_Item_Stock_Insert_Input>;
  on_conflict?: InputMaybe<Sellable_Item_Stock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sellable_Item_Stock_OneArgs = {
  object: Sellable_Item_Stock_Insert_Input;
  on_conflict?: InputMaybe<Sellable_Item_Stock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SensorArgs = {
  objects: Array<Sensor_Insert_Input>;
  on_conflict?: InputMaybe<Sensor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sensor_OneArgs = {
  object: Sensor_Insert_Input;
  on_conflict?: InputMaybe<Sensor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sensor_ParameterArgs = {
  objects: Array<Sensor_Parameter_Insert_Input>;
  on_conflict?: InputMaybe<Sensor_Parameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sensor_Parameter_OneArgs = {
  object: Sensor_Parameter_Insert_Input;
  on_conflict?: InputMaybe<Sensor_Parameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SeriesArgs = {
  objects: Array<Series_Insert_Input>;
  on_conflict?: InputMaybe<Series_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_AuthorsArgs = {
  objects: Array<Series_Authors_Insert_Input>;
  on_conflict?: InputMaybe<Series_Authors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_Authors_OneArgs = {
  object: Series_Authors_Insert_Input;
  on_conflict?: InputMaybe<Series_Authors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_CategoryArgs = {
  objects: Array<Series_Category_Insert_Input>;
  on_conflict?: InputMaybe<Series_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_Category_OneArgs = {
  object: Series_Category_Insert_Input;
  on_conflict?: InputMaybe<Series_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_CropsArgs = {
  objects: Array<Series_Crops_Insert_Input>;
  on_conflict?: InputMaybe<Series_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_Crops_OneArgs = {
  object: Series_Crops_Insert_Input;
  on_conflict?: InputMaybe<Series_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_FavoritesArgs = {
  objects: Array<Series_Favorites_Insert_Input>;
  on_conflict?: InputMaybe<Series_Favorites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_Favorites_OneArgs = {
  object: Series_Favorites_Insert_Input;
  on_conflict?: InputMaybe<Series_Favorites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_LikesArgs = {
  objects: Array<Series_Likes_Insert_Input>;
  on_conflict?: InputMaybe<Series_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_Likes_OneArgs = {
  object: Series_Likes_Insert_Input;
  on_conflict?: InputMaybe<Series_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_OneArgs = {
  object: Series_Insert_Input;
  on_conflict?: InputMaybe<Series_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Setu_Trade_Shared_EntityArgs = {
  objects: Array<Setu_Trade_Shared_Entity_Insert_Input>;
  on_conflict?: InputMaybe<Setu_Trade_Shared_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Setu_Trade_Shared_Entity_OneArgs = {
  object: Setu_Trade_Shared_Entity_Insert_Input;
  on_conflict?: InputMaybe<Setu_Trade_Shared_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Setu_Weather_UserArgs = {
  objects: Array<Setu_Weather_User_Insert_Input>;
  on_conflict?: InputMaybe<Setu_Weather_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Setu_Weather_User_OneArgs = {
  object: Setu_Weather_User_Insert_Input;
  on_conflict?: InputMaybe<Setu_Weather_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shared_EntityArgs = {
  objects: Array<Shared_Entity_Insert_Input>;
  on_conflict?: InputMaybe<Shared_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shared_Entity_OneArgs = {
  object: Shared_Entity_Insert_Input;
  on_conflict?: InputMaybe<Shared_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Si_UnitArgs = {
  objects: Array<Si_Unit_Insert_Input>;
  on_conflict?: InputMaybe<Si_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Si_Unit_MeasureArgs = {
  objects: Array<Si_Unit_Measure_Insert_Input>;
  on_conflict?: InputMaybe<Si_Unit_Measure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Si_Unit_Measure_OneArgs = {
  object: Si_Unit_Measure_Insert_Input;
  on_conflict?: InputMaybe<Si_Unit_Measure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Si_Unit_OneArgs = {
  object: Si_Unit_Insert_Input;
  on_conflict?: InputMaybe<Si_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SkuArgs = {
  objects: Array<Sku_Insert_Input>;
  on_conflict?: InputMaybe<Sku_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sku_KindArgs = {
  objects: Array<Sku_Kind_Insert_Input>;
  on_conflict?: InputMaybe<Sku_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sku_Kind_OneArgs = {
  object: Sku_Kind_Insert_Input;
  on_conflict?: InputMaybe<Sku_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sku_OneArgs = {
  object: Sku_Insert_Input;
  on_conflict?: InputMaybe<Sku_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SoilArgs = {
  objects: Array<Soil_Insert_Input>;
  on_conflict?: InputMaybe<Soil_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Soil_OneArgs = {
  object: Soil_Insert_Input;
  on_conflict?: InputMaybe<Soil_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sprinkler_Irrigation_SystemArgs = {
  objects: Array<Sprinkler_Irrigation_System_Insert_Input>;
  on_conflict?: InputMaybe<Sprinkler_Irrigation_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sprinkler_Irrigation_System_OneArgs = {
  object: Sprinkler_Irrigation_System_Insert_Input;
  on_conflict?: InputMaybe<Sprinkler_Irrigation_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sub_SectionArgs = {
  objects: Array<Sub_Section_Insert_Input>;
  on_conflict?: InputMaybe<Sub_Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sub_Section_OneArgs = {
  object: Sub_Section_Insert_Input;
  on_conflict?: InputMaybe<Sub_Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubcategoryArgs = {
  objects: Array<Subcategory_Insert_Input>;
  on_conflict?: InputMaybe<Subcategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subcategory_OneArgs = {
  object: Subcategory_Insert_Input;
  on_conflict?: InputMaybe<Subcategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Package_HighlightsArgs = {
  objects: Array<Subscription_Package_Highlights_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Package_Highlights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Package_Highlights_OneArgs = {
  object: Subscription_Package_Highlights_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Package_Highlights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Summary_Sensor_ReadingArgs = {
  objects: Array<Summary_Sensor_Reading_Insert_Input>;
  on_conflict?: InputMaybe<Summary_Sensor_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Summary_Sensor_Reading_OneArgs = {
  object: Summary_Sensor_Reading_Insert_Input;
  on_conflict?: InputMaybe<Summary_Sensor_Reading_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ThreadArgs = {
  objects: Array<Thread_Insert_Input>;
  on_conflict?: InputMaybe<Thread_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_OneArgs = {
  object: Thread_Insert_Input;
  on_conflict?: InputMaybe<Thread_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TradeArgs = {
  objects: Array<Trade_Insert_Input>;
  on_conflict?: InputMaybe<Trade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_CommodityArgs = {
  objects: Array<Trade_Commodity_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Commodity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Commodity_OneArgs = {
  object: Trade_Commodity_Insert_Input;
  on_conflict?: InputMaybe<Trade_Commodity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_ItemArgs = {
  objects: Array<Trade_Item_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Item_OneArgs = {
  object: Trade_Item_Insert_Input;
  on_conflict?: InputMaybe<Trade_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_OneArgs = {
  object: Trade_Insert_Input;
  on_conflict?: InputMaybe<Trade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_RegionArgs = {
  objects: Array<Trade_Region_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Region_OneArgs = {
  object: Trade_Region_Insert_Input;
  on_conflict?: InputMaybe<Trade_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_TransactionArgs = {
  objects: Array<Trade_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Transaction_OneArgs = {
  object: Trade_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Trade_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Transaction_SummaryArgs = {
  objects: Array<Trade_Transaction_Summary_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Transaction_Summary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Transaction_Summary_OneArgs = {
  object: Trade_Transaction_Summary_Insert_Input;
  on_conflict?: InputMaybe<Trade_Transaction_Summary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_UnitArgs = {
  objects: Array<Trade_Unit_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Unit_OneArgs = {
  object: Trade_Unit_Insert_Input;
  on_conflict?: InputMaybe<Trade_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_TrendArgs = {
  objects: Array<Transaction_Trend_Insert_Input>;
  on_conflict?: InputMaybe<Transaction_Trend_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_Trend_OneArgs = {
  object: Transaction_Trend_Insert_Input;
  on_conflict?: InputMaybe<Transaction_Trend_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UnitArgs = {
  objects: Array<Unit_Insert_Input>;
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_OneArgs = {
  object: Unit_Insert_Input;
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Answer_ChoicesArgs = {
  objects: Array<User_Answer_Choices_Insert_Input>;
  on_conflict?: InputMaybe<User_Answer_Choices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Answer_Choices_OneArgs = {
  object: User_Answer_Choices_Insert_Input;
  on_conflict?: InputMaybe<User_Answer_Choices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Assessment_AttemptArgs = {
  objects: Array<User_Assessment_Attempt_Insert_Input>;
  on_conflict?: InputMaybe<User_Assessment_Attempt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Assessment_Attempt_OneArgs = {
  object: User_Assessment_Attempt_Insert_Input;
  on_conflict?: InputMaybe<User_Assessment_Attempt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Assessment_Question_ResponseArgs = {
  objects: Array<User_Assessment_Question_Response_Insert_Input>;
  on_conflict?: InputMaybe<User_Assessment_Question_Response_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Assessment_Question_Response_OneArgs = {
  object: User_Assessment_Question_Response_Insert_Input;
  on_conflict?: InputMaybe<User_Assessment_Question_Response_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Reward_HistoryArgs = {
  objects: Array<User_Reward_History_Insert_Input>;
  on_conflict?: InputMaybe<User_Reward_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Reward_History_OneArgs = {
  object: User_Reward_History_Insert_Input;
  on_conflict?: InputMaybe<User_Reward_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Subscription_PackageArgs = {
  objects: Array<User_Subscription_Package_Insert_Input>;
  on_conflict?: InputMaybe<User_Subscription_Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Subscription_Package_OneArgs = {
  object: User_Subscription_Package_Insert_Input;
  on_conflict?: InputMaybe<User_Subscription_Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_GradeArgs = {
  objects: Array<Variety_Grade_Insert_Input>;
  on_conflict?: InputMaybe<Variety_Grade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Grade_OneArgs = {
  object: Variety_Grade_Insert_Input;
  on_conflict?: InputMaybe<Variety_Grade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Grade_PhotosArgs = {
  objects: Array<Variety_Grade_Photos_Insert_Input>;
  on_conflict?: InputMaybe<Variety_Grade_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Grade_Photos_OneArgs = {
  object: Variety_Grade_Photos_Insert_Input;
  on_conflict?: InputMaybe<Variety_Grade_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_GroupArgs = {
  objects: Array<Variety_Group_Insert_Input>;
  on_conflict?: InputMaybe<Variety_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Group_OneArgs = {
  object: Variety_Group_Insert_Input;
  on_conflict?: InputMaybe<Variety_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_LocationArgs = {
  objects: Array<Weather_Location_Insert_Input>;
  on_conflict?: InputMaybe<Weather_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_Location_OneArgs = {
  object: Weather_Location_Insert_Input;
  on_conflict?: InputMaybe<Weather_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_ReferenceArgs = {
  objects: Array<Weather_Reference_Insert_Input>;
  on_conflict?: InputMaybe<Weather_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_Reference_OneArgs = {
  object: Weather_Reference_Insert_Input;
  on_conflict?: InputMaybe<Weather_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLoginArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


/** mutation root */
export type Mutation_RootPlace_OrderArgs = {
  billing_address?: InputMaybe<AddressGlInput>;
  discount_id?: InputMaybe<Scalars['ID']>;
  estimated_delivery?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  order_category?: InputMaybe<Scalars['String']>;
  order_items: Array<InputMaybe<OrderItemStockInput>>;
  payment_method?: InputMaybe<Scalars['String']>;
  pickup_slots?: InputMaybe<Array<InputMaybe<OrderPickupSlotInput>>>;
  poc_name?: InputMaybe<Scalars['String']>;
  poc_number?: InputMaybe<Scalars['String']>;
  shipping_address?: InputMaybe<AddressGlInput>;
  shipping_method: Scalars['String'];
  source_stock?: InputMaybe<Scalars['String']>;
  target_dc_id?: InputMaybe<Scalars['ID']>;
  user_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootRecord_Crop_MilestoneArgs = {
  crop_year?: InputMaybe<Scalars['Int']>;
  milestones: Array<InputMaybe<BulkMilestoneRecordInputType>>;
  plot_crop_codename: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRecord_ExpenseArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  is_actual?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
  purposes: Array<InputMaybe<PurposeExpenseType>>;
  record_date: Scalars['Date'];
  recorded_by_reference_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRecord_Expense_V2Args = {
  activity_id?: InputMaybe<Scalars['String']>;
  activity_name?: InputMaybe<Scalars['String']>;
  activity_type?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  from_date?: InputMaybe<Scalars['Date']>;
  is_actual?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
  purposes: Array<InputMaybe<PurposeExpenseType>>;
  record_date: Scalars['Date'];
  recorded_by_reference_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRecord_Growth_StageArgs = {
  date: Scalars['Date'];
  growth_stage_id: Scalars['Int'];
  plot_crop_codename: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRecord_IncomeArgs = {
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  is_actual?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
  purpose?: InputMaybe<Scalars['String']>;
  record_date: Scalars['Date'];
};


/** mutation root */
export type Mutation_RootRecord_Income_V2Args = {
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  from_date?: InputMaybe<Scalars['Date']>;
  is_actual?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
  purpose?: InputMaybe<Scalars['String']>;
  record_date: Scalars['Date'];
};


/** mutation root */
export type Mutation_RootRefresh_TokenArgs = {
  refresh_token?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRefresh_Token_SetuArgs = {
  refresh_token?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootSend_NotificationArgs = {
  broadcast_time?: InputMaybe<Scalars['DateTime']>;
  content?: InputMaybe<NotificationContent>;
  data_variables?: InputMaybe<Scalars['JSONString']>;
  extra_variables?: InputMaybe<Scalars['JSONString']>;
  filters?: InputMaybe<Array<InputMaybe<NotificationTemplateFilter>>>;
  provider_uid: Scalars['String'];
  provider_variables?: InputMaybe<Scalars['JSONString']>;
  template_uid?: InputMaybe<Scalars['String']>;
  user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user_query_uid?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootSet_Base_User_FieldsArgs = {
  base_user_id?: InputMaybe<Scalars['ID']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/** mutation root */
export type Mutation_RootSet_BudgetArgs = {
  amount: Scalars['Float'];
  plot_crop_codename: Scalars['String'];
  record_date: Scalars['Date'];
};


/** mutation root */
export type Mutation_RootSet_Budget_V2Args = {
  amount: Scalars['Float'];
  plot_crop_codename: Scalars['String'];
  record_date: Scalars['Date'];
};


/** mutation root */
export type Mutation_RootSet_Business_FieldsArgs = {
  business_id?: InputMaybe<Scalars['ID']>;
  commodities_supplied?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  secondary_pocs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/** mutation root */
export type Mutation_RootSet_Document_AttachmentsArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  document_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootSet_Payment_Detail_AttachmentsArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  payment_detail_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootToken_Auth_SetuArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_Action_LogArgs = {
  _append?: InputMaybe<Action_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Action_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Action_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Action_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Action_Log_Inc_Input>;
  _prepend?: InputMaybe<Action_Log_Prepend_Input>;
  _set?: InputMaybe<Action_Log_Set_Input>;
  where: Action_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Action_Log_By_PkArgs = {
  _append?: InputMaybe<Action_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Action_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Action_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Action_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Action_Log_Inc_Input>;
  _prepend?: InputMaybe<Action_Log_Prepend_Input>;
  _set?: InputMaybe<Action_Log_Set_Input>;
  pk_columns: Action_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Action_Log_ManyArgs = {
  updates: Array<Action_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Active_IngredientArgs = {
  _set?: InputMaybe<Active_Ingredient_Set_Input>;
  where: Active_Ingredient_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Active_Ingredient_By_PkArgs = {
  _set?: InputMaybe<Active_Ingredient_Set_Input>;
  pk_columns: Active_Ingredient_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Active_Ingredient_ManyArgs = {
  updates: Array<Active_Ingredient_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Actual_ReadingArgs = {
  _inc?: InputMaybe<Actual_Reading_Inc_Input>;
  _set?: InputMaybe<Actual_Reading_Set_Input>;
  where: Actual_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Actual_Reading_By_PkArgs = {
  _inc?: InputMaybe<Actual_Reading_Inc_Input>;
  _set?: InputMaybe<Actual_Reading_Set_Input>;
  pk_columns: Actual_Reading_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Actual_Reading_ManyArgs = {
  updates: Array<Actual_Reading_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Advice_Author_FollowersArgs = {
  _inc?: InputMaybe<Advice_Author_Followers_Inc_Input>;
  _set?: InputMaybe<Advice_Author_Followers_Set_Input>;
  where: Advice_Author_Followers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Advice_Author_Followers_By_PkArgs = {
  _inc?: InputMaybe<Advice_Author_Followers_Inc_Input>;
  _set?: InputMaybe<Advice_Author_Followers_Set_Input>;
  pk_columns: Advice_Author_Followers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Advice_Author_Followers_ManyArgs = {
  updates: Array<Advice_Author_Followers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Advice_AuthorsArgs = {
  _inc?: InputMaybe<Advice_Authors_Inc_Input>;
  _set?: InputMaybe<Advice_Authors_Set_Input>;
  where: Advice_Authors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Advice_Authors_By_PkArgs = {
  _inc?: InputMaybe<Advice_Authors_Inc_Input>;
  _set?: InputMaybe<Advice_Authors_Set_Input>;
  pk_columns: Advice_Authors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Advice_Authors_ManyArgs = {
  updates: Array<Advice_Authors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AgentArgs = {
  _inc?: InputMaybe<Agent_Inc_Input>;
  _set?: InputMaybe<Agent_Set_Input>;
  where: Agent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_By_PkArgs = {
  _inc?: InputMaybe<Agent_Inc_Input>;
  _set?: InputMaybe<Agent_Set_Input>;
  pk_columns: Agent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_CompanyArgs = {
  _inc?: InputMaybe<Agent_Company_Inc_Input>;
  _set?: InputMaybe<Agent_Company_Set_Input>;
  where: Agent_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Company_By_PkArgs = {
  _inc?: InputMaybe<Agent_Company_Inc_Input>;
  _set?: InputMaybe<Agent_Company_Set_Input>;
  pk_columns: Agent_Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Company_ManyArgs = {
  updates: Array<Agent_Company_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_ManyArgs = {
  updates: Array<Agent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Answer_ChoiceArgs = {
  _inc?: InputMaybe<Answer_Choice_Inc_Input>;
  _set?: InputMaybe<Answer_Choice_Set_Input>;
  where: Answer_Choice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Answer_Choice_By_PkArgs = {
  _inc?: InputMaybe<Answer_Choice_Inc_Input>;
  _set?: InputMaybe<Answer_Choice_Set_Input>;
  pk_columns: Answer_Choice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Answer_Choice_ManyArgs = {
  updates: Array<Answer_Choice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Product_UnitArgs = {
  _inc?: InputMaybe<Application_Product_Unit_Inc_Input>;
  _set?: InputMaybe<Application_Product_Unit_Set_Input>;
  where: Application_Product_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Product_Unit_By_PkArgs = {
  _inc?: InputMaybe<Application_Product_Unit_Inc_Input>;
  _set?: InputMaybe<Application_Product_Unit_Set_Input>;
  pk_columns: Application_Product_Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Product_Unit_ManyArgs = {
  updates: Array<Application_Product_Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ArticleArgs = {
  _inc?: InputMaybe<Article_Inc_Input>;
  _set?: InputMaybe<Article_Set_Input>;
  where: Article_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_AttachmentsArgs = {
  _inc?: InputMaybe<Article_Attachments_Inc_Input>;
  _set?: InputMaybe<Article_Attachments_Set_Input>;
  where: Article_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Article_Attachments_Inc_Input>;
  _set?: InputMaybe<Article_Attachments_Set_Input>;
  pk_columns: Article_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Attachments_ManyArgs = {
  updates: Array<Article_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_AuthorsArgs = {
  _inc?: InputMaybe<Article_Authors_Inc_Input>;
  _set?: InputMaybe<Article_Authors_Set_Input>;
  where: Article_Authors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Authors_By_PkArgs = {
  _inc?: InputMaybe<Article_Authors_Inc_Input>;
  _set?: InputMaybe<Article_Authors_Set_Input>;
  pk_columns: Article_Authors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Authors_ManyArgs = {
  updates: Array<Article_Authors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_By_PkArgs = {
  _inc?: InputMaybe<Article_Inc_Input>;
  _set?: InputMaybe<Article_Set_Input>;
  pk_columns: Article_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_CategoriesArgs = {
  _inc?: InputMaybe<Article_Categories_Inc_Input>;
  _set?: InputMaybe<Article_Categories_Set_Input>;
  where: Article_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Categories_By_PkArgs = {
  _inc?: InputMaybe<Article_Categories_Inc_Input>;
  _set?: InputMaybe<Article_Categories_Set_Input>;
  pk_columns: Article_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Categories_ManyArgs = {
  updates: Array<Article_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_CategoryArgs = {
  _inc?: InputMaybe<Article_Category_Inc_Input>;
  _set?: InputMaybe<Article_Category_Set_Input>;
  where: Article_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Category_By_PkArgs = {
  _inc?: InputMaybe<Article_Category_Inc_Input>;
  _set?: InputMaybe<Article_Category_Set_Input>;
  pk_columns: Article_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Category_ManyArgs = {
  updates: Array<Article_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Crop_CategoriesArgs = {
  _inc?: InputMaybe<Article_Crop_Categories_Inc_Input>;
  _set?: InputMaybe<Article_Crop_Categories_Set_Input>;
  where: Article_Crop_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Crop_Categories_By_PkArgs = {
  _inc?: InputMaybe<Article_Crop_Categories_Inc_Input>;
  _set?: InputMaybe<Article_Crop_Categories_Set_Input>;
  pk_columns: Article_Crop_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Crop_Categories_ManyArgs = {
  updates: Array<Article_Crop_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Crop_VarietiesArgs = {
  _inc?: InputMaybe<Article_Crop_Varieties_Inc_Input>;
  _set?: InputMaybe<Article_Crop_Varieties_Set_Input>;
  where: Article_Crop_Varieties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Crop_Varieties_By_PkArgs = {
  _inc?: InputMaybe<Article_Crop_Varieties_Inc_Input>;
  _set?: InputMaybe<Article_Crop_Varieties_Set_Input>;
  pk_columns: Article_Crop_Varieties_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Crop_Varieties_ManyArgs = {
  updates: Array<Article_Crop_Varieties_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_CropsArgs = {
  _inc?: InputMaybe<Article_Crops_Inc_Input>;
  _set?: InputMaybe<Article_Crops_Set_Input>;
  where: Article_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Crops_By_PkArgs = {
  _inc?: InputMaybe<Article_Crops_Inc_Input>;
  _set?: InputMaybe<Article_Crops_Set_Input>;
  pk_columns: Article_Crops_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Crops_ManyArgs = {
  updates: Array<Article_Crops_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_FavoritesArgs = {
  _inc?: InputMaybe<Article_Favorites_Inc_Input>;
  _set?: InputMaybe<Article_Favorites_Set_Input>;
  where: Article_Favorites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Favorites_By_PkArgs = {
  _inc?: InputMaybe<Article_Favorites_Inc_Input>;
  _set?: InputMaybe<Article_Favorites_Set_Input>;
  pk_columns: Article_Favorites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Favorites_ManyArgs = {
  updates: Array<Article_Favorites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_LikesArgs = {
  _inc?: InputMaybe<Article_Likes_Inc_Input>;
  _set?: InputMaybe<Article_Likes_Set_Input>;
  where: Article_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Likes_By_PkArgs = {
  _inc?: InputMaybe<Article_Likes_Inc_Input>;
  _set?: InputMaybe<Article_Likes_Set_Input>;
  pk_columns: Article_Likes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Likes_ManyArgs = {
  updates: Array<Article_Likes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_ManyArgs = {
  updates: Array<Article_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_RegionsArgs = {
  _inc?: InputMaybe<Article_Regions_Inc_Input>;
  _set?: InputMaybe<Article_Regions_Set_Input>;
  where: Article_Regions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Regions_By_PkArgs = {
  _inc?: InputMaybe<Article_Regions_Inc_Input>;
  _set?: InputMaybe<Article_Regions_Set_Input>;
  pk_columns: Article_Regions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Regions_ManyArgs = {
  updates: Array<Article_Regions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_SeriesArgs = {
  _inc?: InputMaybe<Article_Series_Inc_Input>;
  _set?: InputMaybe<Article_Series_Set_Input>;
  where: Article_Series_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Series_By_PkArgs = {
  _inc?: InputMaybe<Article_Series_Inc_Input>;
  _set?: InputMaybe<Article_Series_Set_Input>;
  pk_columns: Article_Series_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Series_ManyArgs = {
  updates: Array<Article_Series_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Subscription_PackageArgs = {
  _inc?: InputMaybe<Article_Subscription_Package_Inc_Input>;
  _set?: InputMaybe<Article_Subscription_Package_Set_Input>;
  where: Article_Subscription_Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Subscription_Package_By_PkArgs = {
  _inc?: InputMaybe<Article_Subscription_Package_Inc_Input>;
  _set?: InputMaybe<Article_Subscription_Package_Set_Input>;
  pk_columns: Article_Subscription_Package_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Subscription_Package_ManyArgs = {
  updates: Array<Article_Subscription_Package_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_SubscriptionsArgs = {
  _inc?: InputMaybe<Article_Subscriptions_Inc_Input>;
  _set?: InputMaybe<Article_Subscriptions_Set_Input>;
  where: Article_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Subscriptions_By_PkArgs = {
  _inc?: InputMaybe<Article_Subscriptions_Inc_Input>;
  _set?: InputMaybe<Article_Subscriptions_Set_Input>;
  pk_columns: Article_Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Subscriptions_ManyArgs = {
  updates: Array<Article_Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_User_GroupArgs = {
  _inc?: InputMaybe<Article_User_Group_Inc_Input>;
  _set?: InputMaybe<Article_User_Group_Set_Input>;
  where: Article_User_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_User_Group_By_PkArgs = {
  _inc?: InputMaybe<Article_User_Group_Inc_Input>;
  _set?: InputMaybe<Article_User_Group_Set_Input>;
  pk_columns: Article_User_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_User_Group_ManyArgs = {
  updates: Array<Article_User_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Article_ViewsArgs = {
  _inc?: InputMaybe<Article_Views_Inc_Input>;
  _set?: InputMaybe<Article_Views_Set_Input>;
  where: Article_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Views_By_PkArgs = {
  _inc?: InputMaybe<Article_Views_Inc_Input>;
  _set?: InputMaybe<Article_Views_Set_Input>;
  pk_columns: Article_Views_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Article_Views_ManyArgs = {
  updates: Array<Article_Views_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssessmentArgs = {
  _inc?: InputMaybe<Assessment_Inc_Input>;
  _set?: InputMaybe<Assessment_Set_Input>;
  where: Assessment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_By_PkArgs = {
  _inc?: InputMaybe<Assessment_Inc_Input>;
  _set?: InputMaybe<Assessment_Set_Input>;
  pk_columns: Assessment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_ManyArgs = {
  updates: Array<Assessment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_QuestionArgs = {
  _inc?: InputMaybe<Assessment_Question_Inc_Input>;
  _set?: InputMaybe<Assessment_Question_Set_Input>;
  where: Assessment_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Question_By_PkArgs = {
  _inc?: InputMaybe<Assessment_Question_Inc_Input>;
  _set?: InputMaybe<Assessment_Question_Set_Input>;
  pk_columns: Assessment_Question_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Question_ManyArgs = {
  updates: Array<Assessment_Question_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeArgs = {
  _set?: InputMaybe<Attribute_Set_Input>;
  where: Attribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Attribute_By_PkArgs = {
  _set?: InputMaybe<Attribute_Set_Input>;
  pk_columns: Attribute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Attribute_ChoiceArgs = {
  _set?: InputMaybe<Attribute_Choice_Set_Input>;
  where: Attribute_Choice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Attribute_Choice_By_PkArgs = {
  _set?: InputMaybe<Attribute_Choice_Set_Input>;
  pk_columns: Attribute_Choice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Attribute_Choice_ManyArgs = {
  updates: Array<Attribute_Choice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Attribute_ManyArgs = {
  updates: Array<Attribute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_GroupArgs = {
  _inc?: InputMaybe<Auth_Group_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Set_Input>;
  where: Auth_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_By_PkArgs = {
  _inc?: InputMaybe<Auth_Group_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Set_Input>;
  pk_columns: Auth_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_ManyArgs = {
  updates: Array<Auth_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_PermissionsArgs = {
  _inc?: InputMaybe<Auth_Group_Permissions_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Permissions_Set_Input>;
  where: Auth_Group_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Auth_Group_Permissions_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Permissions_Set_Input>;
  pk_columns: Auth_Group_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_Permissions_ManyArgs = {
  updates: Array<Auth_Group_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_PermissionArgs = {
  _inc?: InputMaybe<Auth_Permission_Inc_Input>;
  _set?: InputMaybe<Auth_Permission_Set_Input>;
  where: Auth_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Permission_By_PkArgs = {
  _inc?: InputMaybe<Auth_Permission_Inc_Input>;
  _set?: InputMaybe<Auth_Permission_Set_Input>;
  pk_columns: Auth_Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Permission_ManyArgs = {
  updates: Array<Auth_Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_UserArgs = {
  _append?: InputMaybe<Base_User_Append_Input>;
  _delete_at_path?: InputMaybe<Base_User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Base_User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Base_User_Delete_Key_Input>;
  _inc?: InputMaybe<Base_User_Inc_Input>;
  _prepend?: InputMaybe<Base_User_Prepend_Input>;
  _set?: InputMaybe<Base_User_Set_Input>;
  where: Base_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Address_BookArgs = {
  _inc?: InputMaybe<Base_User_Address_Book_Inc_Input>;
  _set?: InputMaybe<Base_User_Address_Book_Set_Input>;
  where: Base_User_Address_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Address_Book_By_PkArgs = {
  _inc?: InputMaybe<Base_User_Address_Book_Inc_Input>;
  _set?: InputMaybe<Base_User_Address_Book_Set_Input>;
  pk_columns: Base_User_Address_Book_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Address_Book_ManyArgs = {
  updates: Array<Base_User_Address_Book_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_By_PkArgs = {
  _append?: InputMaybe<Base_User_Append_Input>;
  _delete_at_path?: InputMaybe<Base_User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Base_User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Base_User_Delete_Key_Input>;
  _inc?: InputMaybe<Base_User_Inc_Input>;
  _prepend?: InputMaybe<Base_User_Prepend_Input>;
  _set?: InputMaybe<Base_User_Set_Input>;
  pk_columns: Base_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_CompaniesArgs = {
  _inc?: InputMaybe<Base_User_Companies_Inc_Input>;
  _set?: InputMaybe<Base_User_Companies_Set_Input>;
  where: Base_User_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Companies_By_PkArgs = {
  _inc?: InputMaybe<Base_User_Companies_Inc_Input>;
  _set?: InputMaybe<Base_User_Companies_Set_Input>;
  pk_columns: Base_User_Companies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Companies_ManyArgs = {
  updates: Array<Base_User_Companies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_DepartmentsArgs = {
  _inc?: InputMaybe<Base_User_Departments_Inc_Input>;
  _set?: InputMaybe<Base_User_Departments_Set_Input>;
  where: Base_User_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Departments_By_PkArgs = {
  _inc?: InputMaybe<Base_User_Departments_Inc_Input>;
  _set?: InputMaybe<Base_User_Departments_Set_Input>;
  pk_columns: Base_User_Departments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Departments_ManyArgs = {
  updates: Array<Base_User_Departments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_GroupsArgs = {
  _inc?: InputMaybe<Base_User_Groups_Inc_Input>;
  _set?: InputMaybe<Base_User_Groups_Set_Input>;
  where: Base_User_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Groups_By_PkArgs = {
  _inc?: InputMaybe<Base_User_Groups_Inc_Input>;
  _set?: InputMaybe<Base_User_Groups_Set_Input>;
  pk_columns: Base_User_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Groups_ManyArgs = {
  updates: Array<Base_User_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_ManyArgs = {
  updates: Array<Base_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_NetworkArgs = {
  _inc?: InputMaybe<Base_User_Network_Inc_Input>;
  _set?: InputMaybe<Base_User_Network_Set_Input>;
  where: Base_User_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Network_By_PkArgs = {
  _inc?: InputMaybe<Base_User_Network_Inc_Input>;
  _set?: InputMaybe<Base_User_Network_Set_Input>;
  pk_columns: Base_User_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Network_ManyArgs = {
  updates: Array<Base_User_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_User_PermissionsArgs = {
  _inc?: InputMaybe<Base_User_User_Permissions_Inc_Input>;
  _set?: InputMaybe<Base_User_User_Permissions_Set_Input>;
  where: Base_User_User_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_User_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Base_User_User_Permissions_Inc_Input>;
  _set?: InputMaybe<Base_User_User_Permissions_Set_Input>;
  pk_columns: Base_User_User_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_User_Permissions_ManyArgs = {
  updates: Array<Base_User_User_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_StatusArgs = {
  approval_status: Scalars['String'];
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootUpdate_BusinessArgs = {
  _append?: InputMaybe<Business_Append_Input>;
  _delete_at_path?: InputMaybe<Business_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Business_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Business_Delete_Key_Input>;
  _inc?: InputMaybe<Business_Inc_Input>;
  _prepend?: InputMaybe<Business_Prepend_Input>;
  _set?: InputMaybe<Business_Set_Input>;
  where: Business_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_By_PkArgs = {
  _append?: InputMaybe<Business_Append_Input>;
  _delete_at_path?: InputMaybe<Business_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Business_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Business_Delete_Key_Input>;
  _inc?: InputMaybe<Business_Inc_Input>;
  _prepend?: InputMaybe<Business_Prepend_Input>;
  _set?: InputMaybe<Business_Set_Input>;
  pk_columns: Business_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Commodities_SuppliedArgs = {
  _inc?: InputMaybe<Business_Commodities_Supplied_Inc_Input>;
  _set?: InputMaybe<Business_Commodities_Supplied_Set_Input>;
  where: Business_Commodities_Supplied_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Commodities_Supplied_By_PkArgs = {
  _inc?: InputMaybe<Business_Commodities_Supplied_Inc_Input>;
  _set?: InputMaybe<Business_Commodities_Supplied_Set_Input>;
  pk_columns: Business_Commodities_Supplied_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Commodities_Supplied_ManyArgs = {
  updates: Array<Business_Commodities_Supplied_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_CompaniesArgs = {
  _inc?: InputMaybe<Business_Companies_Inc_Input>;
  _set?: InputMaybe<Business_Companies_Set_Input>;
  where: Business_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Companies_By_PkArgs = {
  _inc?: InputMaybe<Business_Companies_Inc_Input>;
  _set?: InputMaybe<Business_Companies_Set_Input>;
  pk_columns: Business_Companies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Companies_ManyArgs = {
  updates: Array<Business_Companies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_GroupArgs = {
  _inc?: InputMaybe<Business_Group_Inc_Input>;
  _set?: InputMaybe<Business_Group_Set_Input>;
  where: Business_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Group_By_PkArgs = {
  _inc?: InputMaybe<Business_Group_Inc_Input>;
  _set?: InputMaybe<Business_Group_Set_Input>;
  pk_columns: Business_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Group_ManyArgs = {
  updates: Array<Business_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Group_NetworkArgs = {
  _inc?: InputMaybe<Business_Group_Network_Inc_Input>;
  _set?: InputMaybe<Business_Group_Network_Set_Input>;
  where: Business_Group_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Group_Network_By_PkArgs = {
  _inc?: InputMaybe<Business_Group_Network_Inc_Input>;
  _set?: InputMaybe<Business_Group_Network_Set_Input>;
  pk_columns: Business_Group_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Group_Network_ManyArgs = {
  updates: Array<Business_Group_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_GroupsArgs = {
  _inc?: InputMaybe<Business_Groups_Inc_Input>;
  _set?: InputMaybe<Business_Groups_Set_Input>;
  where: Business_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Groups_By_PkArgs = {
  _inc?: InputMaybe<Business_Groups_Inc_Input>;
  _set?: InputMaybe<Business_Groups_Set_Input>;
  pk_columns: Business_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Groups_ManyArgs = {
  updates: Array<Business_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_ManyArgs = {
  updates: Array<Business_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_NetworkArgs = {
  _inc?: InputMaybe<Business_Network_Inc_Input>;
  _set?: InputMaybe<Business_Network_Set_Input>;
  where: Business_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Network_By_PkArgs = {
  _inc?: InputMaybe<Business_Network_Inc_Input>;
  _set?: InputMaybe<Business_Network_Set_Input>;
  pk_columns: Business_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Network_ManyArgs = {
  updates: Array<Business_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Secondary_PocsArgs = {
  _inc?: InputMaybe<Business_Secondary_Pocs_Inc_Input>;
  _set?: InputMaybe<Business_Secondary_Pocs_Set_Input>;
  where: Business_Secondary_Pocs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Secondary_Pocs_By_PkArgs = {
  _inc?: InputMaybe<Business_Secondary_Pocs_Inc_Input>;
  _set?: InputMaybe<Business_Secondary_Pocs_Set_Input>;
  pk_columns: Business_Secondary_Pocs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Secondary_Pocs_ManyArgs = {
  updates: Array<Business_Secondary_Pocs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_By_Pk_Care_Shared_EntityArgs = {
  _append?: InputMaybe<Care_Shared_Entity_Append_Input>;
  _delete_at_path?: InputMaybe<Care_Shared_Entity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Care_Shared_Entity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Care_Shared_Entity_Delete_Key_Input>;
  _inc?: InputMaybe<Care_Shared_Entity_Inc_Input>;
  _prepend?: InputMaybe<Care_Shared_Entity_Prepend_Input>;
  _set?: InputMaybe<Care_Shared_Entity_Set_Input>;
  pk_columns: Care_Shared_Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_By_Pk_Setu_Trade_Shared_EntityArgs = {
  _set?: InputMaybe<Setu_Trade_Shared_Entity_Set_Input>;
  pk_columns: Setu_Trade_Shared_Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Care_Shared_EntityArgs = {
  _append?: InputMaybe<Care_Shared_Entity_Append_Input>;
  _delete_at_path?: InputMaybe<Care_Shared_Entity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Care_Shared_Entity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Care_Shared_Entity_Delete_Key_Input>;
  _inc?: InputMaybe<Care_Shared_Entity_Inc_Input>;
  _prepend?: InputMaybe<Care_Shared_Entity_Prepend_Input>;
  _set?: InputMaybe<Care_Shared_Entity_Set_Input>;
  where: Care_Shared_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Care_Shared_Entity_ManyArgs = {
  updates: Array<Care_Shared_Entity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CategoryArgs = {
  _inc?: InputMaybe<Category_Inc_Input>;
  _set?: InputMaybe<Category_Set_Input>;
  where: Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Category_By_PkArgs = {
  _inc?: InputMaybe<Category_Inc_Input>;
  _set?: InputMaybe<Category_Set_Input>;
  pk_columns: Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Category_ManyArgs = {
  updates: Array<Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_IssuerArgs = {
  _set?: InputMaybe<Certificate_Issuer_Set_Input>;
  where: Certificate_Issuer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Issuer_By_PkArgs = {
  _set?: InputMaybe<Certificate_Issuer_Set_Input>;
  pk_columns: Certificate_Issuer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Issuer_ManyArgs = {
  updates: Array<Certificate_Issuer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CertificationArgs = {
  _set?: InputMaybe<Certification_Set_Input>;
  where: Certification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Certification_By_PkArgs = {
  _set?: InputMaybe<Certification_Set_Input>;
  pk_columns: Certification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Certification_ManyArgs = {
  updates: Array<Certification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CommentArgs = {
  _set?: InputMaybe<Comment_Set_Input>;
  where: Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comment_By_PkArgs = {
  _set?: InputMaybe<Comment_Set_Input>;
  pk_columns: Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Comment_ManyArgs = {
  updates: Array<Comment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CommodityArgs = {
  _append?: InputMaybe<Commodity_Append_Input>;
  _delete_at_path?: InputMaybe<Commodity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Commodity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Commodity_Delete_Key_Input>;
  _inc?: InputMaybe<Commodity_Inc_Input>;
  _prepend?: InputMaybe<Commodity_Prepend_Input>;
  _set?: InputMaybe<Commodity_Set_Input>;
  where: Commodity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_By_PkArgs = {
  _append?: InputMaybe<Commodity_Append_Input>;
  _delete_at_path?: InputMaybe<Commodity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Commodity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Commodity_Delete_Key_Input>;
  _inc?: InputMaybe<Commodity_Inc_Input>;
  _prepend?: InputMaybe<Commodity_Prepend_Input>;
  _set?: InputMaybe<Commodity_Set_Input>;
  pk_columns: Commodity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_ManyArgs = {
  updates: Array<Commodity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_VarietyArgs = {
  _append?: InputMaybe<Commodity_Variety_Append_Input>;
  _delete_at_path?: InputMaybe<Commodity_Variety_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Commodity_Variety_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Commodity_Variety_Delete_Key_Input>;
  _inc?: InputMaybe<Commodity_Variety_Inc_Input>;
  _prepend?: InputMaybe<Commodity_Variety_Prepend_Input>;
  _set?: InputMaybe<Commodity_Variety_Set_Input>;
  where: Commodity_Variety_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Variety_By_PkArgs = {
  _append?: InputMaybe<Commodity_Variety_Append_Input>;
  _delete_at_path?: InputMaybe<Commodity_Variety_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Commodity_Variety_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Commodity_Variety_Delete_Key_Input>;
  _inc?: InputMaybe<Commodity_Variety_Inc_Input>;
  _prepend?: InputMaybe<Commodity_Variety_Prepend_Input>;
  _set?: InputMaybe<Commodity_Variety_Set_Input>;
  pk_columns: Commodity_Variety_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Variety_ManyArgs = {
  updates: Array<Commodity_Variety_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Variety_Secondary_GroupsArgs = {
  _inc?: InputMaybe<Commodity_Variety_Secondary_Groups_Inc_Input>;
  _set?: InputMaybe<Commodity_Variety_Secondary_Groups_Set_Input>;
  where: Commodity_Variety_Secondary_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Variety_Secondary_Groups_By_PkArgs = {
  _inc?: InputMaybe<Commodity_Variety_Secondary_Groups_Inc_Input>;
  _set?: InputMaybe<Commodity_Variety_Secondary_Groups_Set_Input>;
  pk_columns: Commodity_Variety_Secondary_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Variety_Secondary_Groups_ManyArgs = {
  updates: Array<Commodity_Variety_Secondary_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Common_FileuploadArgs = {
  _inc?: InputMaybe<Common_Fileupload_Inc_Input>;
  _set?: InputMaybe<Common_Fileupload_Set_Input>;
  where: Common_Fileupload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Common_Fileupload_By_PkArgs = {
  _inc?: InputMaybe<Common_Fileupload_Inc_Input>;
  _set?: InputMaybe<Common_Fileupload_Set_Input>;
  pk_columns: Common_Fileupload_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Common_Fileupload_ManyArgs = {
  updates: Array<Common_Fileupload_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyArgs = {
  _inc?: InputMaybe<Company_Inc_Input>;
  _set?: InputMaybe<Company_Set_Input>;
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_By_PkArgs = {
  _inc?: InputMaybe<Company_Inc_Input>;
  _set?: InputMaybe<Company_Set_Input>;
  pk_columns: Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_ManyArgs = {
  updates: Array<Company_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cost_ItemArgs = {
  _set?: InputMaybe<Cost_Item_Set_Input>;
  where: Cost_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cost_Item_By_PkArgs = {
  _set?: InputMaybe<Cost_Item_Set_Input>;
  pk_columns: Cost_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cost_Item_ManyArgs = {
  updates: Array<Cost_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CropArgs = {
  _inc?: InputMaybe<Crop_Inc_Input>;
  _set?: InputMaybe<Crop_Set_Input>;
  where: Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_By_PkArgs = {
  _inc?: InputMaybe<Crop_Inc_Input>;
  _set?: InputMaybe<Crop_Set_Input>;
  pk_columns: Crop_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_FertilisersArgs = {
  _inc?: InputMaybe<Crop_Fertilisers_Inc_Input>;
  _set?: InputMaybe<Crop_Fertilisers_Set_Input>;
  where: Crop_Fertilisers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Fertilisers_By_PkArgs = {
  _inc?: InputMaybe<Crop_Fertilisers_Inc_Input>;
  _set?: InputMaybe<Crop_Fertilisers_Set_Input>;
  pk_columns: Crop_Fertilisers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Fertilisers_ManyArgs = {
  updates: Array<Crop_Fertilisers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_GroupArgs = {
  _inc?: InputMaybe<Crop_Group_Inc_Input>;
  _set?: InputMaybe<Crop_Group_Set_Input>;
  where: Crop_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Group_By_PkArgs = {
  _inc?: InputMaybe<Crop_Group_Inc_Input>;
  _set?: InputMaybe<Crop_Group_Set_Input>;
  pk_columns: Crop_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Group_ManyArgs = {
  updates: Array<Crop_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_InfestationArgs = {
  _inc?: InputMaybe<Crop_Infestation_Inc_Input>;
  _set?: InputMaybe<Crop_Infestation_Set_Input>;
  where: Crop_Infestation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Infestation_AttachmentArgs = {
  _inc?: InputMaybe<Crop_Infestation_Attachment_Inc_Input>;
  _set?: InputMaybe<Crop_Infestation_Attachment_Set_Input>;
  where: Crop_Infestation_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Infestation_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Crop_Infestation_Attachment_Inc_Input>;
  _set?: InputMaybe<Crop_Infestation_Attachment_Set_Input>;
  pk_columns: Crop_Infestation_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Infestation_Attachment_ManyArgs = {
  updates: Array<Crop_Infestation_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Infestation_By_PkArgs = {
  _inc?: InputMaybe<Crop_Infestation_Inc_Input>;
  _set?: InputMaybe<Crop_Infestation_Set_Input>;
  pk_columns: Crop_Infestation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Infestation_ManyArgs = {
  updates: Array<Crop_Infestation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_ManyArgs = {
  updates: Array<Crop_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_MilestoneArgs = {
  _inc?: InputMaybe<Crop_Milestone_Inc_Input>;
  _set?: InputMaybe<Crop_Milestone_Set_Input>;
  where: Crop_Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Milestone_By_PkArgs = {
  _inc?: InputMaybe<Crop_Milestone_Inc_Input>;
  _set?: InputMaybe<Crop_Milestone_Set_Input>;
  pk_columns: Crop_Milestone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Milestone_ManyArgs = {
  updates: Array<Crop_Milestone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Operation_MethodsArgs = {
  _inc?: InputMaybe<Crop_Operation_Methods_Inc_Input>;
  _set?: InputMaybe<Crop_Operation_Methods_Set_Input>;
  where: Crop_Operation_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Operation_Methods_By_PkArgs = {
  _inc?: InputMaybe<Crop_Operation_Methods_Inc_Input>;
  _set?: InputMaybe<Crop_Operation_Methods_Set_Input>;
  pk_columns: Crop_Operation_Methods_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Operation_Methods_ManyArgs = {
  updates: Array<Crop_Operation_Methods_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_PesticidesArgs = {
  _inc?: InputMaybe<Crop_Pesticides_Inc_Input>;
  _set?: InputMaybe<Crop_Pesticides_Set_Input>;
  where: Crop_Pesticides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Pesticides_By_PkArgs = {
  _inc?: InputMaybe<Crop_Pesticides_Inc_Input>;
  _set?: InputMaybe<Crop_Pesticides_Set_Input>;
  pk_columns: Crop_Pesticides_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Pesticides_ManyArgs = {
  updates: Array<Crop_Pesticides_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_VarietyArgs = {
  _inc?: InputMaybe<Crop_Variety_Inc_Input>;
  _set?: InputMaybe<Crop_Variety_Set_Input>;
  where: Crop_Variety_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Variety_By_PkArgs = {
  _inc?: InputMaybe<Crop_Variety_Inc_Input>;
  _set?: InputMaybe<Crop_Variety_Set_Input>;
  pk_columns: Crop_Variety_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Variety_ManyArgs = {
  updates: Array<Crop_Variety_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Variety_SeedsArgs = {
  _inc?: InputMaybe<Crop_Variety_Seeds_Inc_Input>;
  _set?: InputMaybe<Crop_Variety_Seeds_Set_Input>;
  where: Crop_Variety_Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Variety_Seeds_By_PkArgs = {
  _inc?: InputMaybe<Crop_Variety_Seeds_Inc_Input>;
  _set?: InputMaybe<Crop_Variety_Seeds_Set_Input>;
  pk_columns: Crop_Variety_Seeds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Variety_Seeds_ManyArgs = {
  updates: Array<Crop_Variety_Seeds_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_YearArgs = {
  _inc?: InputMaybe<Crop_Year_Inc_Input>;
  _set?: InputMaybe<Crop_Year_Set_Input>;
  where: Crop_Year_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Year_By_PkArgs = {
  _inc?: InputMaybe<Crop_Year_Inc_Input>;
  _set?: InputMaybe<Crop_Year_Set_Input>;
  pk_columns: Crop_Year_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Year_ManyArgs = {
  updates: Array<Crop_Year_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cropmonitoring_ParameterArgs = {
  _inc?: InputMaybe<Cropmonitoring_Parameter_Inc_Input>;
  _set?: InputMaybe<Cropmonitoring_Parameter_Set_Input>;
  where: Cropmonitoring_Parameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cropmonitoring_Parameter_By_PkArgs = {
  _inc?: InputMaybe<Cropmonitoring_Parameter_Inc_Input>;
  _set?: InputMaybe<Cropmonitoring_Parameter_Set_Input>;
  pk_columns: Cropmonitoring_Parameter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cropmonitoring_Parameter_ManyArgs = {
  updates: Array<Cropmonitoring_Parameter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CurrencyArgs = {
  _set?: InputMaybe<Currency_Set_Input>;
  where: Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_By_PkArgs = {
  _set?: InputMaybe<Currency_Set_Input>;
  pk_columns: Currency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_ManyArgs = {
  updates: Array<Currency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Daily_Actual_ReadingArgs = {
  _inc?: InputMaybe<Daily_Actual_Reading_Inc_Input>;
  _set?: InputMaybe<Daily_Actual_Reading_Set_Input>;
  where: Daily_Actual_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Daily_Actual_Reading_By_PkArgs = {
  _inc?: InputMaybe<Daily_Actual_Reading_Inc_Input>;
  _set?: InputMaybe<Daily_Actual_Reading_Set_Input>;
  pk_columns: Daily_Actual_Reading_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Daily_Actual_Reading_ManyArgs = {
  updates: Array<Daily_Actual_Reading_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Daily_Forecast_ReadingArgs = {
  _inc?: InputMaybe<Daily_Forecast_Reading_Inc_Input>;
  _set?: InputMaybe<Daily_Forecast_Reading_Set_Input>;
  where: Daily_Forecast_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Daily_Forecast_Reading_By_PkArgs = {
  _inc?: InputMaybe<Daily_Forecast_Reading_Inc_Input>;
  _set?: InputMaybe<Daily_Forecast_Reading_Set_Input>;
  pk_columns: Daily_Forecast_Reading_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Daily_Forecast_Reading_ManyArgs = {
  updates: Array<Daily_Forecast_Reading_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DepartmentArgs = {
  _inc?: InputMaybe<Department_Inc_Input>;
  _set?: InputMaybe<Department_Set_Input>;
  where: Department_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Department_By_PkArgs = {
  _inc?: InputMaybe<Department_Inc_Input>;
  _set?: InputMaybe<Department_Set_Input>;
  pk_columns: Department_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Department_ManyArgs = {
  updates: Array<Department_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DeviceArgs = {
  _append?: InputMaybe<Device_Append_Input>;
  _delete_at_path?: InputMaybe<Device_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Device_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Device_Delete_Key_Input>;
  _inc?: InputMaybe<Device_Inc_Input>;
  _prepend?: InputMaybe<Device_Prepend_Input>;
  _set?: InputMaybe<Device_Set_Input>;
  where: Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Device_By_PkArgs = {
  _append?: InputMaybe<Device_Append_Input>;
  _delete_at_path?: InputMaybe<Device_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Device_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Device_Delete_Key_Input>;
  _inc?: InputMaybe<Device_Inc_Input>;
  _prepend?: InputMaybe<Device_Prepend_Input>;
  _set?: InputMaybe<Device_Set_Input>;
  pk_columns: Device_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Device_ManyArgs = {
  updates: Array<Device_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Django_Content_TypeArgs = {
  _inc?: InputMaybe<Django_Content_Type_Inc_Input>;
  _set?: InputMaybe<Django_Content_Type_Set_Input>;
  where: Django_Content_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Django_Content_Type_By_PkArgs = {
  _inc?: InputMaybe<Django_Content_Type_Inc_Input>;
  _set?: InputMaybe<Django_Content_Type_Set_Input>;
  pk_columns: Django_Content_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Django_Content_Type_ManyArgs = {
  updates: Array<Django_Content_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentArgs = {
  _inc?: InputMaybe<Document_Inc_Input>;
  _set?: InputMaybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_AttachmentsArgs = {
  _inc?: InputMaybe<Document_Attachments_Inc_Input>;
  _set?: InputMaybe<Document_Attachments_Set_Input>;
  where: Document_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Document_Attachments_Inc_Input>;
  _set?: InputMaybe<Document_Attachments_Set_Input>;
  pk_columns: Document_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Attachments_ManyArgs = {
  updates: Array<Document_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_By_PkArgs = {
  _inc?: InputMaybe<Document_Inc_Input>;
  _set?: InputMaybe<Document_Set_Input>;
  pk_columns: Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_DataArgs = {
  _inc?: InputMaybe<Document_Data_Inc_Input>;
  _set?: InputMaybe<Document_Data_Set_Input>;
  where: Document_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Data_By_PkArgs = {
  _inc?: InputMaybe<Document_Data_Inc_Input>;
  _set?: InputMaybe<Document_Data_Set_Input>;
  pk_columns: Document_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Data_ManyArgs = {
  updates: Array<Document_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_KindArgs = {
  _inc?: InputMaybe<Document_Kind_Inc_Input>;
  _set?: InputMaybe<Document_Kind_Set_Input>;
  where: Document_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Kind_By_PkArgs = {
  _inc?: InputMaybe<Document_Kind_Inc_Input>;
  _set?: InputMaybe<Document_Kind_Set_Input>;
  pk_columns: Document_Kind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Kind_Data_FieldArgs = {
  _inc?: InputMaybe<Document_Kind_Data_Field_Inc_Input>;
  _set?: InputMaybe<Document_Kind_Data_Field_Set_Input>;
  where: Document_Kind_Data_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Kind_Data_Field_By_PkArgs = {
  _inc?: InputMaybe<Document_Kind_Data_Field_Inc_Input>;
  _set?: InputMaybe<Document_Kind_Data_Field_Set_Input>;
  pk_columns: Document_Kind_Data_Field_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Kind_Data_Field_ManyArgs = {
  updates: Array<Document_Kind_Data_Field_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Kind_ManyArgs = {
  updates: Array<Document_Kind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_ManyArgs = {
  updates: Array<Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Drip_Irrigation_SystemArgs = {
  _inc?: InputMaybe<Drip_Irrigation_System_Inc_Input>;
  _set?: InputMaybe<Drip_Irrigation_System_Set_Input>;
  where: Drip_Irrigation_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Drip_Irrigation_System_By_PkArgs = {
  _inc?: InputMaybe<Drip_Irrigation_System_Inc_Input>;
  _set?: InputMaybe<Drip_Irrigation_System_Set_Input>;
  pk_columns: Drip_Irrigation_System_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Drip_Irrigation_System_ManyArgs = {
  updates: Array<Drip_Irrigation_System_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExpenseArgs = {
  _inc?: InputMaybe<Expense_Inc_Input>;
  _set?: InputMaybe<Expense_Set_Input>;
  where: Expense_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Expense_By_PkArgs = {
  _inc?: InputMaybe<Expense_Inc_Input>;
  _set?: InputMaybe<Expense_Set_Input>;
  pk_columns: Expense_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Expense_ManyArgs = {
  updates: Array<Expense_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_External_ReferenceArgs = {
  _append?: InputMaybe<External_Reference_Append_Input>;
  _delete_at_path?: InputMaybe<External_Reference_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Reference_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Reference_Delete_Key_Input>;
  _inc?: InputMaybe<External_Reference_Inc_Input>;
  _prepend?: InputMaybe<External_Reference_Prepend_Input>;
  _set?: InputMaybe<External_Reference_Set_Input>;
  where: External_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_External_Reference_By_PkArgs = {
  _append?: InputMaybe<External_Reference_Append_Input>;
  _delete_at_path?: InputMaybe<External_Reference_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Reference_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Reference_Delete_Key_Input>;
  _inc?: InputMaybe<External_Reference_Inc_Input>;
  _prepend?: InputMaybe<External_Reference_Prepend_Input>;
  _set?: InputMaybe<External_Reference_Set_Input>;
  pk_columns: External_Reference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_External_Reference_ManyArgs = {
  updates: Array<External_Reference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FarmArgs = {
  _append?: InputMaybe<Farm_Append_Input>;
  _delete_at_path?: InputMaybe<Farm_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Farm_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Farm_Delete_Key_Input>;
  _inc?: InputMaybe<Farm_Inc_Input>;
  _prepend?: InputMaybe<Farm_Prepend_Input>;
  _set?: InputMaybe<Farm_Set_Input>;
  where: Farm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_By_PkArgs = {
  _append?: InputMaybe<Farm_Append_Input>;
  _delete_at_path?: InputMaybe<Farm_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Farm_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Farm_Delete_Key_Input>;
  _inc?: InputMaybe<Farm_Inc_Input>;
  _prepend?: InputMaybe<Farm_Prepend_Input>;
  _set?: InputMaybe<Farm_Set_Input>;
  pk_columns: Farm_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_ManyArgs = {
  updates: Array<Farm_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_NetworkArgs = {
  _inc?: InputMaybe<Farm_Network_Inc_Input>;
  _set?: InputMaybe<Farm_Network_Set_Input>;
  where: Farm_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_Network_By_PkArgs = {
  _inc?: InputMaybe<Farm_Network_Inc_Input>;
  _set?: InputMaybe<Farm_Network_Set_Input>;
  pk_columns: Farm_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_Network_ManyArgs = {
  updates: Array<Farm_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FieldArgs = {
  _append?: InputMaybe<Field_Append_Input>;
  _delete_at_path?: InputMaybe<Field_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Field_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Field_Delete_Key_Input>;
  _inc?: InputMaybe<Field_Inc_Input>;
  _prepend?: InputMaybe<Field_Prepend_Input>;
  _set?: InputMaybe<Field_Set_Input>;
  where: Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_By_PkArgs = {
  _append?: InputMaybe<Field_Append_Input>;
  _delete_at_path?: InputMaybe<Field_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Field_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Field_Delete_Key_Input>;
  _inc?: InputMaybe<Field_Inc_Input>;
  _prepend?: InputMaybe<Field_Prepend_Input>;
  _set?: InputMaybe<Field_Set_Input>;
  pk_columns: Field_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_ManyArgs = {
  updates: Array<Field_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Field_NetworkArgs = {
  _inc?: InputMaybe<Field_Network_Inc_Input>;
  _set?: InputMaybe<Field_Network_Set_Input>;
  where: Field_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Network_By_PkArgs = {
  _inc?: InputMaybe<Field_Network_Inc_Input>;
  _set?: InputMaybe<Field_Network_Set_Input>;
  pk_columns: Field_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Network_ManyArgs = {
  updates: Array<Field_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Weather_LocationArgs = {
  _inc?: InputMaybe<Field_Weather_Location_Inc_Input>;
  _set?: InputMaybe<Field_Weather_Location_Set_Input>;
  where: Field_Weather_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Weather_Location_By_PkArgs = {
  _inc?: InputMaybe<Field_Weather_Location_Inc_Input>;
  _set?: InputMaybe<Field_Weather_Location_Set_Input>;
  pk_columns: Field_Weather_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Weather_Location_ManyArgs = {
  updates: Array<Field_Weather_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FileuploadArgs = {
  _inc?: InputMaybe<Fileupload_Inc_Input>;
  _set?: InputMaybe<Fileupload_Set_Input>;
  where: Fileupload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fileupload_By_PkArgs = {
  _inc?: InputMaybe<Fileupload_Inc_Input>;
  _set?: InputMaybe<Fileupload_Set_Input>;
  pk_columns: Fileupload_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fileupload_ManyArgs = {
  updates: Array<Fileupload_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Flood_Irrigation_SystemArgs = {
  _inc?: InputMaybe<Flood_Irrigation_System_Inc_Input>;
  _set?: InputMaybe<Flood_Irrigation_System_Set_Input>;
  where: Flood_Irrigation_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flood_Irrigation_System_By_PkArgs = {
  _inc?: InputMaybe<Flood_Irrigation_System_Inc_Input>;
  _set?: InputMaybe<Flood_Irrigation_System_Set_Input>;
  pk_columns: Flood_Irrigation_System_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flood_Irrigation_System_ManyArgs = {
  updates: Array<Flood_Irrigation_System_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Forecast_ReadingArgs = {
  _inc?: InputMaybe<Forecast_Reading_Inc_Input>;
  _set?: InputMaybe<Forecast_Reading_Set_Input>;
  where: Forecast_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Forecast_Reading_By_PkArgs = {
  _inc?: InputMaybe<Forecast_Reading_Inc_Input>;
  _set?: InputMaybe<Forecast_Reading_Set_Input>;
  pk_columns: Forecast_Reading_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Forecast_Reading_ManyArgs = {
  updates: Array<Forecast_Reading_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GatewayArgs = {
  _set?: InputMaybe<Gateway_Set_Input>;
  where: Gateway_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gateway_By_PkArgs = {
  _set?: InputMaybe<Gateway_Set_Input>;
  pk_columns: Gateway_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gateway_ConfigurationArgs = {
  _set?: InputMaybe<Gateway_Configuration_Set_Input>;
  where: Gateway_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gateway_Configuration_By_PkArgs = {
  _set?: InputMaybe<Gateway_Configuration_Set_Input>;
  pk_columns: Gateway_Configuration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gateway_Configuration_ManyArgs = {
  updates: Array<Gateway_Configuration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gateway_ManyArgs = {
  updates: Array<Gateway_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gateway_StatusArgs = {
  _inc?: InputMaybe<Gateway_Status_Inc_Input>;
  _set?: InputMaybe<Gateway_Status_Set_Input>;
  where: Gateway_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gateway_Status_By_PkArgs = {
  _inc?: InputMaybe<Gateway_Status_Inc_Input>;
  _set?: InputMaybe<Gateway_Status_Set_Input>;
  pk_columns: Gateway_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gateway_Status_ManyArgs = {
  updates: Array<Gateway_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_PriceArgs = {
  _inc?: InputMaybe<Grade_Price_Inc_Input>;
  _set?: InputMaybe<Grade_Price_Set_Input>;
  where: Grade_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Price_By_PkArgs = {
  _inc?: InputMaybe<Grade_Price_Inc_Input>;
  _set?: InputMaybe<Grade_Price_Set_Input>;
  pk_columns: Grade_Price_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Price_ManyArgs = {
  updates: Array<Grade_Price_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InfestationArgs = {
  _inc?: InputMaybe<Infestation_Inc_Input>;
  _set?: InputMaybe<Infestation_Set_Input>;
  where: Infestation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Infestation_By_PkArgs = {
  _inc?: InputMaybe<Infestation_Inc_Input>;
  _set?: InputMaybe<Infestation_Set_Input>;
  pk_columns: Infestation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Infestation_ManyArgs = {
  updates: Array<Infestation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IngredientArgs = {
  _set?: InputMaybe<Ingredient_Set_Input>;
  where: Ingredient_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ingredient_By_PkArgs = {
  _set?: InputMaybe<Ingredient_Set_Input>;
  pk_columns: Ingredient_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ingredient_ManyArgs = {
  updates: Array<Ingredient_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Inst_Sensor_ReadingArgs = {
  _inc?: InputMaybe<Inst_Sensor_Reading_Inc_Input>;
  _set?: InputMaybe<Inst_Sensor_Reading_Set_Input>;
  where: Inst_Sensor_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Inst_Sensor_Reading_By_PkArgs = {
  _inc?: InputMaybe<Inst_Sensor_Reading_Inc_Input>;
  _set?: InputMaybe<Inst_Sensor_Reading_Set_Input>;
  pk_columns: Inst_Sensor_Reading_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Inst_Sensor_Reading_ManyArgs = {
  updates: Array<Inst_Sensor_Reading_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoiceArgs = {
  _set?: InputMaybe<Invoice_Set_Input>;
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_By_PkArgs = {
  _set?: InputMaybe<Invoice_Set_Input>;
  pk_columns: Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_ManyArgs = {
  updates: Array<Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Irrigation_SystemArgs = {
  _inc?: InputMaybe<Irrigation_System_Inc_Input>;
  _set?: InputMaybe<Irrigation_System_Set_Input>;
  where: Irrigation_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Irrigation_System_By_PkArgs = {
  _inc?: InputMaybe<Irrigation_System_Inc_Input>;
  _set?: InputMaybe<Irrigation_System_Set_Input>;
  pk_columns: Irrigation_System_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Irrigation_System_ManyArgs = {
  updates: Array<Irrigation_System_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Location_SubscriptionArgs = {
  _set?: InputMaybe<Location_Subscription_Set_Input>;
  where: Location_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Subscription_By_PkArgs = {
  _set?: InputMaybe<Location_Subscription_Set_Input>;
  pk_columns: Location_Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Subscription_ManyArgs = {
  updates: Array<Location_Subscription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Main_SectionArgs = {
  _set?: InputMaybe<Main_Section_Set_Input>;
  where: Main_Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Main_Section_By_PkArgs = {
  _set?: InputMaybe<Main_Section_Set_Input>;
  pk_columns: Main_Section_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Main_Section_ManyArgs = {
  updates: Array<Main_Section_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ManufacturerArgs = {
  _inc?: InputMaybe<Manufacturer_Inc_Input>;
  _set?: InputMaybe<Manufacturer_Set_Input>;
  where: Manufacturer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_By_PkArgs = {
  _inc?: InputMaybe<Manufacturer_Inc_Input>;
  _set?: InputMaybe<Manufacturer_Set_Input>;
  pk_columns: Manufacturer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_ManyArgs = {
  updates: Array<Manufacturer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturing_FacilityArgs = {
  _set?: InputMaybe<Manufacturing_Facility_Set_Input>;
  where: Manufacturing_Facility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturing_Facility_By_PkArgs = {
  _set?: InputMaybe<Manufacturing_Facility_Set_Input>;
  pk_columns: Manufacturing_Facility_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturing_Facility_ManyArgs = {
  updates: Array<Manufacturing_Facility_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MarketArgs = {
  _set?: InputMaybe<Market_Set_Input>;
  where: Market_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Market_By_PkArgs = {
  _set?: InputMaybe<Market_Set_Input>;
  pk_columns: Market_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Market_ManyArgs = {
  updates: Array<Market_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MarketerArgs = {
  _inc?: InputMaybe<Marketer_Inc_Input>;
  _set?: InputMaybe<Marketer_Set_Input>;
  where: Marketer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Marketer_By_PkArgs = {
  _inc?: InputMaybe<Marketer_Inc_Input>;
  _set?: InputMaybe<Marketer_Set_Input>;
  pk_columns: Marketer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Marketer_ManyArgs = {
  updates: Array<Marketer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Marketing_FacilityArgs = {
  _set?: InputMaybe<Marketing_Facility_Set_Input>;
  where: Marketing_Facility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Marketing_Facility_By_PkArgs = {
  _set?: InputMaybe<Marketing_Facility_Set_Input>;
  pk_columns: Marketing_Facility_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Marketing_Facility_ManyArgs = {
  updates: Array<Marketing_Facility_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Measure_OfArgs = {
  _set?: InputMaybe<Measure_Of_Set_Input>;
  where: Measure_Of_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Measure_Of_By_PkArgs = {
  _set?: InputMaybe<Measure_Of_Set_Input>;
  pk_columns: Measure_Of_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Measure_Of_ManyArgs = {
  updates: Array<Measure_Of_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MediaArgs = {
  _append?: InputMaybe<Media_Append_Input>;
  _delete_at_path?: InputMaybe<Media_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Media_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Media_Delete_Key_Input>;
  _inc?: InputMaybe<Media_Inc_Input>;
  _prepend?: InputMaybe<Media_Prepend_Input>;
  _set?: InputMaybe<Media_Set_Input>;
  where: Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Media_By_PkArgs = {
  _append?: InputMaybe<Media_Append_Input>;
  _delete_at_path?: InputMaybe<Media_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Media_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Media_Delete_Key_Input>;
  _inc?: InputMaybe<Media_Inc_Input>;
  _prepend?: InputMaybe<Media_Prepend_Input>;
  _set?: InputMaybe<Media_Set_Input>;
  pk_columns: Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Media_ManyArgs = {
  updates: Array<Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MessageArgs = {
  _set?: InputMaybe<Message_Set_Input>;
  where: Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Message_By_PkArgs = {
  _set?: InputMaybe<Message_Set_Input>;
  pk_columns: Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Message_ManyArgs = {
  updates: Array<Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MilestoneArgs = {
  _inc?: InputMaybe<Milestone_Inc_Input>;
  _set?: InputMaybe<Milestone_Set_Input>;
  where: Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Milestone_By_PkArgs = {
  _inc?: InputMaybe<Milestone_Inc_Input>;
  _set?: InputMaybe<Milestone_Set_Input>;
  pk_columns: Milestone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Milestone_ManyArgs = {
  updates: Array<Milestone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_CategoryArgs = {
  _inc?: InputMaybe<Monitoring_Category_Inc_Input>;
  _set?: InputMaybe<Monitoring_Category_Set_Input>;
  where: Monitoring_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Category_By_PkArgs = {
  _inc?: InputMaybe<Monitoring_Category_Inc_Input>;
  _set?: InputMaybe<Monitoring_Category_Set_Input>;
  pk_columns: Monitoring_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Category_ManyArgs = {
  updates: Array<Monitoring_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_ParameterArgs = {
  _inc?: InputMaybe<Monitoring_Parameter_Inc_Input>;
  _set?: InputMaybe<Monitoring_Parameter_Set_Input>;
  where: Monitoring_Parameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Parameter_By_PkArgs = {
  _inc?: InputMaybe<Monitoring_Parameter_Inc_Input>;
  _set?: InputMaybe<Monitoring_Parameter_Set_Input>;
  pk_columns: Monitoring_Parameter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Parameter_ChoicesArgs = {
  _inc?: InputMaybe<Monitoring_Parameter_Choices_Inc_Input>;
  _set?: InputMaybe<Monitoring_Parameter_Choices_Set_Input>;
  where: Monitoring_Parameter_Choices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Parameter_Choices_By_PkArgs = {
  _inc?: InputMaybe<Monitoring_Parameter_Choices_Inc_Input>;
  _set?: InputMaybe<Monitoring_Parameter_Choices_Set_Input>;
  pk_columns: Monitoring_Parameter_Choices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Parameter_Choices_ManyArgs = {
  updates: Array<Monitoring_Parameter_Choices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Parameter_ManyArgs = {
  updates: Array<Monitoring_Parameter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Parameter_Unit_ChoicesArgs = {
  _inc?: InputMaybe<Monitoring_Parameter_Unit_Choices_Inc_Input>;
  _set?: InputMaybe<Monitoring_Parameter_Unit_Choices_Set_Input>;
  where: Monitoring_Parameter_Unit_Choices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Parameter_Unit_Choices_By_PkArgs = {
  _inc?: InputMaybe<Monitoring_Parameter_Unit_Choices_Inc_Input>;
  _set?: InputMaybe<Monitoring_Parameter_Unit_Choices_Set_Input>;
  pk_columns: Monitoring_Parameter_Unit_Choices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Parameter_Unit_Choices_ManyArgs = {
  updates: Array<Monitoring_Parameter_Unit_Choices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_RecordArgs = {
  _inc?: InputMaybe<Monitoring_Record_Inc_Input>;
  _set?: InputMaybe<Monitoring_Record_Set_Input>;
  where: Monitoring_Record_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Record_AttachmentsArgs = {
  _inc?: InputMaybe<Monitoring_Record_Attachments_Inc_Input>;
  _set?: InputMaybe<Monitoring_Record_Attachments_Set_Input>;
  where: Monitoring_Record_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Record_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Monitoring_Record_Attachments_Inc_Input>;
  _set?: InputMaybe<Monitoring_Record_Attachments_Set_Input>;
  pk_columns: Monitoring_Record_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Record_Attachments_ManyArgs = {
  updates: Array<Monitoring_Record_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Record_By_PkArgs = {
  _inc?: InputMaybe<Monitoring_Record_Inc_Input>;
  _set?: InputMaybe<Monitoring_Record_Set_Input>;
  pk_columns: Monitoring_Record_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Record_ManyArgs = {
  updates: Array<Monitoring_Record_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_SampleArgs = {
  _inc?: InputMaybe<Monitoring_Sample_Inc_Input>;
  _set?: InputMaybe<Monitoring_Sample_Set_Input>;
  where: Monitoring_Sample_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Sample_By_PkArgs = {
  _inc?: InputMaybe<Monitoring_Sample_Inc_Input>;
  _set?: InputMaybe<Monitoring_Sample_Set_Input>;
  pk_columns: Monitoring_Sample_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Sample_ManyArgs = {
  updates: Array<Monitoring_Sample_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_SubcategoryArgs = {
  _inc?: InputMaybe<Monitoring_Subcategory_Inc_Input>;
  _set?: InputMaybe<Monitoring_Subcategory_Set_Input>;
  where: Monitoring_Subcategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Subcategory_By_PkArgs = {
  _inc?: InputMaybe<Monitoring_Subcategory_Inc_Input>;
  _set?: InputMaybe<Monitoring_Subcategory_Set_Input>;
  pk_columns: Monitoring_Subcategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Monitoring_Subcategory_ManyArgs = {
  updates: Array<Monitoring_Subcategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_GroupArgs = {
  _inc?: InputMaybe<Mutual_Group_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Set_Input>;
  where: Mutual_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Set_Input>;
  pk_columns: Mutual_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_ManyArgs = {
  updates: Array<Mutual_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_MembershipArgs = {
  _inc?: InputMaybe<Mutual_Group_Membership_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Membership_Set_Input>;
  where: Mutual_Group_Membership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Membership_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Membership_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Membership_Set_Input>;
  pk_columns: Mutual_Group_Membership_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Membership_ManyArgs = {
  updates: Array<Mutual_Group_Membership_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_NetworkArgs = {
  _inc?: InputMaybe<Mutual_Group_Network_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Network_Set_Input>;
  where: Mutual_Group_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Network_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Network_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Network_Set_Input>;
  pk_columns: Mutual_Group_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Network_ManyArgs = {
  updates: Array<Mutual_Group_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_RoleArgs = {
  _inc?: InputMaybe<Mutual_Group_Role_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Role_Set_Input>;
  where: Mutual_Group_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Role_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Role_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Role_Set_Input>;
  pk_columns: Mutual_Group_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Role_ManyArgs = {
  updates: Array<Mutual_Group_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Subscription_PackageArgs = {
  _inc?: InputMaybe<Mutual_Group_Subscription_Package_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Subscription_Package_Set_Input>;
  where: Mutual_Group_Subscription_Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Subscription_Package_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Subscription_Package_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Subscription_Package_Set_Input>;
  pk_columns: Mutual_Group_Subscription_Package_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Subscription_Package_ManyArgs = {
  updates: Array<Mutual_Group_Subscription_Package_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Weather_StationArgs = {
  _inc?: InputMaybe<Mutual_Group_Weather_Station_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Weather_Station_Set_Input>;
  where: Mutual_Group_Weather_Station_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Weather_Station_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Weather_Station_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Weather_Station_Set_Input>;
  pk_columns: Mutual_Group_Weather_Station_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Weather_Station_ManyArgs = {
  updates: Array<Mutual_Group_Weather_Station_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NetworkArgs = {
  _inc?: InputMaybe<Network_Inc_Input>;
  _set?: InputMaybe<Network_Set_Input>;
  where: Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Network_By_PkArgs = {
  _inc?: InputMaybe<Network_Inc_Input>;
  _set?: InputMaybe<Network_Set_Input>;
  pk_columns: Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Network_ManyArgs = {
  updates: Array<Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationArgs = {
  _set?: InputMaybe<Notification_Set_Input>;
  where: Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_By_PkArgs = {
  _set?: InputMaybe<Notification_Set_Input>;
  pk_columns: Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_CategoryArgs = {
  _set?: InputMaybe<Notification_Category_Set_Input>;
  where: Notification_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Category_By_PkArgs = {
  _set?: InputMaybe<Notification_Category_Set_Input>;
  pk_columns: Notification_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Category_ManyArgs = {
  updates: Array<Notification_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_ManyArgs = {
  updates: Array<Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_TemplateArgs = {
  _inc?: InputMaybe<Notification_Template_Inc_Input>;
  _set?: InputMaybe<Notification_Template_Set_Input>;
  where: Notification_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_By_PkArgs = {
  _inc?: InputMaybe<Notification_Template_Inc_Input>;
  _set?: InputMaybe<Notification_Template_Set_Input>;
  pk_columns: Notification_Template_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_Distribution_RegionArgs = {
  _inc?: InputMaybe<Notification_Template_Distribution_Region_Inc_Input>;
  _set?: InputMaybe<Notification_Template_Distribution_Region_Set_Input>;
  where: Notification_Template_Distribution_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_Distribution_Region_By_PkArgs = {
  _inc?: InputMaybe<Notification_Template_Distribution_Region_Inc_Input>;
  _set?: InputMaybe<Notification_Template_Distribution_Region_Set_Input>;
  pk_columns: Notification_Template_Distribution_Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_Distribution_Region_ManyArgs = {
  updates: Array<Notification_Template_Distribution_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_Distribution_TeamArgs = {
  _inc?: InputMaybe<Notification_Template_Distribution_Team_Inc_Input>;
  _set?: InputMaybe<Notification_Template_Distribution_Team_Set_Input>;
  where: Notification_Template_Distribution_Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_Distribution_Team_By_PkArgs = {
  _inc?: InputMaybe<Notification_Template_Distribution_Team_Inc_Input>;
  _set?: InputMaybe<Notification_Template_Distribution_Team_Set_Input>;
  pk_columns: Notification_Template_Distribution_Team_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_Distribution_Team_ManyArgs = {
  updates: Array<Notification_Template_Distribution_Team_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_Distribution_UserArgs = {
  _inc?: InputMaybe<Notification_Template_Distribution_User_Inc_Input>;
  _set?: InputMaybe<Notification_Template_Distribution_User_Set_Input>;
  where: Notification_Template_Distribution_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_Distribution_User_By_PkArgs = {
  _inc?: InputMaybe<Notification_Template_Distribution_User_Inc_Input>;
  _set?: InputMaybe<Notification_Template_Distribution_User_Set_Input>;
  pk_columns: Notification_Template_Distribution_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_Distribution_User_ManyArgs = {
  updates: Array<Notification_Template_Distribution_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Template_ManyArgs = {
  updates: Array<Notification_Template_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NutrientsArgs = {
  _set?: InputMaybe<Nutrients_Set_Input>;
  where: Nutrients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nutrients_By_PkArgs = {
  _set?: InputMaybe<Nutrients_Set_Input>;
  pk_columns: Nutrients_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nutrients_ManyArgs = {
  updates: Array<Nutrients_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Observation_NotificationArgs = {
  _set?: InputMaybe<Observation_Notification_Set_Input>;
  where: Observation_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Observation_Notification_By_PkArgs = {
  _set?: InputMaybe<Observation_Notification_Set_Input>;
  pk_columns: Observation_Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Observation_Notification_ManyArgs = {
  updates: Array<Observation_Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_AttachmentsArgs = {
  _inc?: InputMaybe<Operation_Attachments_Inc_Input>;
  _set?: InputMaybe<Operation_Attachments_Set_Input>;
  where: Operation_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Operation_Attachments_Inc_Input>;
  _set?: InputMaybe<Operation_Attachments_Set_Input>;
  pk_columns: Operation_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Attachments_ManyArgs = {
  updates: Array<Operation_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_CostArgs = {
  _inc?: InputMaybe<Operation_Cost_Inc_Input>;
  _set?: InputMaybe<Operation_Cost_Set_Input>;
  where: Operation_Cost_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Cost_By_PkArgs = {
  _inc?: InputMaybe<Operation_Cost_Inc_Input>;
  _set?: InputMaybe<Operation_Cost_Set_Input>;
  pk_columns: Operation_Cost_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Cost_ManyArgs = {
  updates: Array<Operation_Cost_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_MethodsArgs = {
  _set?: InputMaybe<Operation_Methods_Set_Input>;
  where: Operation_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Methods_By_PkArgs = {
  _set?: InputMaybe<Operation_Methods_Set_Input>;
  pk_columns: Operation_Methods_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Methods_ManyArgs = {
  updates: Array<Operation_Methods_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Product_TypesArgs = {
  _set?: InputMaybe<Operation_Product_Types_Set_Input>;
  where: Operation_Product_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Product_Types_By_PkArgs = {
  _set?: InputMaybe<Operation_Product_Types_Set_Input>;
  pk_columns: Operation_Product_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Product_Types_ManyArgs = {
  updates: Array<Operation_Product_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OperationsArgs = {
  _inc?: InputMaybe<Operations_Inc_Input>;
  _set?: InputMaybe<Operations_Set_Input>;
  where: Operations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Applied_FertiliserArgs = {
  _inc?: InputMaybe<Operations_Applied_Fertiliser_Inc_Input>;
  _set?: InputMaybe<Operations_Applied_Fertiliser_Set_Input>;
  where: Operations_Applied_Fertiliser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Applied_Fertiliser_By_PkArgs = {
  _inc?: InputMaybe<Operations_Applied_Fertiliser_Inc_Input>;
  _set?: InputMaybe<Operations_Applied_Fertiliser_Set_Input>;
  pk_columns: Operations_Applied_Fertiliser_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Applied_Fertiliser_ManyArgs = {
  updates: Array<Operations_Applied_Fertiliser_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Applied_PesticideArgs = {
  _inc?: InputMaybe<Operations_Applied_Pesticide_Inc_Input>;
  _set?: InputMaybe<Operations_Applied_Pesticide_Set_Input>;
  where: Operations_Applied_Pesticide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Applied_Pesticide_By_PkArgs = {
  _inc?: InputMaybe<Operations_Applied_Pesticide_Inc_Input>;
  _set?: InputMaybe<Operations_Applied_Pesticide_Set_Input>;
  pk_columns: Operations_Applied_Pesticide_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Applied_Pesticide_ManyArgs = {
  updates: Array<Operations_Applied_Pesticide_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_By_PkArgs = {
  _inc?: InputMaybe<Operations_Inc_Input>;
  _set?: InputMaybe<Operations_Set_Input>;
  pk_columns: Operations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_FertiliserArgs = {
  _inc?: InputMaybe<Operations_Fertiliser_Inc_Input>;
  _set?: InputMaybe<Operations_Fertiliser_Set_Input>;
  where: Operations_Fertiliser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Fertiliser_By_PkArgs = {
  _inc?: InputMaybe<Operations_Fertiliser_Inc_Input>;
  _set?: InputMaybe<Operations_Fertiliser_Set_Input>;
  pk_columns: Operations_Fertiliser_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Fertiliser_ManyArgs = {
  updates: Array<Operations_Fertiliser_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_HarvestArgs = {
  _inc?: InputMaybe<Operations_Harvest_Inc_Input>;
  _set?: InputMaybe<Operations_Harvest_Set_Input>;
  where: Operations_Harvest_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Harvest_By_PkArgs = {
  _inc?: InputMaybe<Operations_Harvest_Inc_Input>;
  _set?: InputMaybe<Operations_Harvest_Set_Input>;
  pk_columns: Operations_Harvest_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Harvest_ManyArgs = {
  updates: Array<Operations_Harvest_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Harvest_OutputArgs = {
  _inc?: InputMaybe<Operations_Harvest_Output_Inc_Input>;
  _set?: InputMaybe<Operations_Harvest_Output_Set_Input>;
  where: Operations_Harvest_Output_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Harvest_Output_By_PkArgs = {
  _inc?: InputMaybe<Operations_Harvest_Output_Inc_Input>;
  _set?: InputMaybe<Operations_Harvest_Output_Set_Input>;
  pk_columns: Operations_Harvest_Output_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Harvest_Output_ManyArgs = {
  updates: Array<Operations_Harvest_Output_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_IntercultureArgs = {
  _inc?: InputMaybe<Operations_Interculture_Inc_Input>;
  _set?: InputMaybe<Operations_Interculture_Set_Input>;
  where: Operations_Interculture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Interculture_By_PkArgs = {
  _inc?: InputMaybe<Operations_Interculture_Inc_Input>;
  _set?: InputMaybe<Operations_Interculture_Set_Input>;
  pk_columns: Operations_Interculture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Interculture_ManyArgs = {
  updates: Array<Operations_Interculture_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_IrrigationArgs = {
  _inc?: InputMaybe<Operations_Irrigation_Inc_Input>;
  _set?: InputMaybe<Operations_Irrigation_Set_Input>;
  where: Operations_Irrigation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Irrigation_By_PkArgs = {
  _inc?: InputMaybe<Operations_Irrigation_Inc_Input>;
  _set?: InputMaybe<Operations_Irrigation_Set_Input>;
  pk_columns: Operations_Irrigation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Irrigation_ManyArgs = {
  updates: Array<Operations_Irrigation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Land_PrepArgs = {
  _set?: InputMaybe<Operations_Land_Prep_Set_Input>;
  where: Operations_Land_Prep_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Land_Prep_By_PkArgs = {
  _set?: InputMaybe<Operations_Land_Prep_Set_Input>;
  pk_columns: Operations_Land_Prep_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Land_Prep_ManyArgs = {
  updates: Array<Operations_Land_Prep_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_ManyArgs = {
  updates: Array<Operations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_PesticideArgs = {
  _inc?: InputMaybe<Operations_Pesticide_Inc_Input>;
  _set?: InputMaybe<Operations_Pesticide_Set_Input>;
  where: Operations_Pesticide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Pesticide_By_PkArgs = {
  _inc?: InputMaybe<Operations_Pesticide_Inc_Input>;
  _set?: InputMaybe<Operations_Pesticide_Set_Input>;
  pk_columns: Operations_Pesticide_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Pesticide_ManyArgs = {
  updates: Array<Operations_Pesticide_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_SowingArgs = {
  _inc?: InputMaybe<Operations_Sowing_Inc_Input>;
  _set?: InputMaybe<Operations_Sowing_Set_Input>;
  where: Operations_Sowing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Sowing_By_PkArgs = {
  _inc?: InputMaybe<Operations_Sowing_Inc_Input>;
  _set?: InputMaybe<Operations_Sowing_Set_Input>;
  pk_columns: Operations_Sowing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Sowing_ManyArgs = {
  updates: Array<Operations_Sowing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganisationArgs = {
  _append?: InputMaybe<Organisation_Append_Input>;
  _delete_at_path?: InputMaybe<Organisation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organisation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organisation_Delete_Key_Input>;
  _inc?: InputMaybe<Organisation_Inc_Input>;
  _prepend?: InputMaybe<Organisation_Prepend_Input>;
  _set?: InputMaybe<Organisation_Set_Input>;
  where: Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_By_PkArgs = {
  _append?: InputMaybe<Organisation_Append_Input>;
  _delete_at_path?: InputMaybe<Organisation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organisation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organisation_Delete_Key_Input>;
  _inc?: InputMaybe<Organisation_Inc_Input>;
  _prepend?: InputMaybe<Organisation_Prepend_Input>;
  _set?: InputMaybe<Organisation_Set_Input>;
  pk_columns: Organisation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Document_KindArgs = {
  _inc?: InputMaybe<Organisation_Document_Kind_Inc_Input>;
  _set?: InputMaybe<Organisation_Document_Kind_Set_Input>;
  where: Organisation_Document_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Document_Kind_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Document_Kind_Inc_Input>;
  _set?: InputMaybe<Organisation_Document_Kind_Set_Input>;
  pk_columns: Organisation_Document_Kind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Document_Kind_ManyArgs = {
  updates: Array<Organisation_Document_Kind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_ManyArgs = {
  updates: Array<Organisation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_PreferencesArgs = {
  _inc?: InputMaybe<Organisation_Preferences_Inc_Input>;
  _set?: InputMaybe<Organisation_Preferences_Set_Input>;
  where: Organisation_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Preferences_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Preferences_Inc_Input>;
  _set?: InputMaybe<Organisation_Preferences_Set_Input>;
  pk_columns: Organisation_Preferences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Preferences_ManyArgs = {
  updates: Array<Organisation_Preferences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_SeasonArgs = {
  _inc?: InputMaybe<Organisation_Season_Inc_Input>;
  _set?: InputMaybe<Organisation_Season_Set_Input>;
  where: Organisation_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Season_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Season_Inc_Input>;
  _set?: InputMaybe<Organisation_Season_Set_Input>;
  pk_columns: Organisation_Season_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Season_ManyArgs = {
  updates: Array<Organisation_Season_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PasswordArgs = {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_Payment_DetailArgs = {
  _inc?: InputMaybe<Payment_Detail_Inc_Input>;
  _set?: InputMaybe<Payment_Detail_Set_Input>;
  where: Payment_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Detail_AttachmentsArgs = {
  _inc?: InputMaybe<Payment_Detail_Attachments_Inc_Input>;
  _set?: InputMaybe<Payment_Detail_Attachments_Set_Input>;
  where: Payment_Detail_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Detail_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Payment_Detail_Attachments_Inc_Input>;
  _set?: InputMaybe<Payment_Detail_Attachments_Set_Input>;
  pk_columns: Payment_Detail_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Detail_Attachments_ManyArgs = {
  updates: Array<Payment_Detail_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Detail_By_PkArgs = {
  _inc?: InputMaybe<Payment_Detail_Inc_Input>;
  _set?: InputMaybe<Payment_Detail_Set_Input>;
  pk_columns: Payment_Detail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Detail_ManyArgs = {
  updates: Array<Payment_Detail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_MethodArgs = {
  _inc?: InputMaybe<Payment_Method_Inc_Input>;
  _set?: InputMaybe<Payment_Method_Set_Input>;
  where: Payment_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Method_By_PkArgs = {
  _inc?: InputMaybe<Payment_Method_Inc_Input>;
  _set?: InputMaybe<Payment_Method_Set_Input>;
  pk_columns: Payment_Method_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Method_ManyArgs = {
  updates: Array<Payment_Method_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlotArgs = {
  _append?: InputMaybe<Plot_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Inc_Input>;
  _prepend?: InputMaybe<Plot_Prepend_Input>;
  _set?: InputMaybe<Plot_Set_Input>;
  where: Plot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_By_PkArgs = {
  _append?: InputMaybe<Plot_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Inc_Input>;
  _prepend?: InputMaybe<Plot_Prepend_Input>;
  _set?: InputMaybe<Plot_Set_Input>;
  pk_columns: Plot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_CropArgs = {
  _append?: InputMaybe<Plot_Crop_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Crop_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Crop_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Crop_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Crop_Inc_Input>;
  _prepend?: InputMaybe<Plot_Crop_Prepend_Input>;
  _set?: InputMaybe<Plot_Crop_Set_Input>;
  where: Plot_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_AgentArgs = {
  _inc?: InputMaybe<Plot_Crop_Agent_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Agent_Set_Input>;
  where: Plot_Crop_Agent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Agent_By_PkArgs = {
  _inc?: InputMaybe<Plot_Crop_Agent_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Agent_Set_Input>;
  pk_columns: Plot_Crop_Agent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Agent_ManyArgs = {
  updates: Array<Plot_Crop_Agent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_By_PkArgs = {
  _append?: InputMaybe<Plot_Crop_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Crop_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Crop_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Crop_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Crop_Inc_Input>;
  _prepend?: InputMaybe<Plot_Crop_Prepend_Input>;
  _set?: InputMaybe<Plot_Crop_Set_Input>;
  pk_columns: Plot_Crop_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_ManyArgs = {
  updates: Array<Plot_Crop_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_MilestoneArgs = {
  _inc?: InputMaybe<Plot_Crop_Milestone_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Milestone_Set_Input>;
  where: Plot_Crop_Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Milestone_By_PkArgs = {
  _inc?: InputMaybe<Plot_Crop_Milestone_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Milestone_Set_Input>;
  pk_columns: Plot_Crop_Milestone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Milestone_ManyArgs = {
  updates: Array<Plot_Crop_Milestone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_NetworkArgs = {
  _inc?: InputMaybe<Plot_Crop_Network_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Network_Set_Input>;
  where: Plot_Crop_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Network_By_PkArgs = {
  _inc?: InputMaybe<Plot_Crop_Network_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Network_Set_Input>;
  pk_columns: Plot_Crop_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Network_ManyArgs = {
  updates: Array<Plot_Crop_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_ManyArgs = {
  updates: Array<Plot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_NetworkArgs = {
  _inc?: InputMaybe<Plot_Network_Inc_Input>;
  _set?: InputMaybe<Plot_Network_Set_Input>;
  where: Plot_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Network_By_PkArgs = {
  _inc?: InputMaybe<Plot_Network_Inc_Input>;
  _set?: InputMaybe<Plot_Network_Set_Input>;
  pk_columns: Plot_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Network_ManyArgs = {
  updates: Array<Plot_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_StatusArgs = {
  _append?: InputMaybe<Plot_Status_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Status_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Status_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Status_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Status_Inc_Input>;
  _prepend?: InputMaybe<Plot_Status_Prepend_Input>;
  _set?: InputMaybe<Plot_Status_Set_Input>;
  where: Plot_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_By_PkArgs = {
  _append?: InputMaybe<Plot_Status_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Status_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Status_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Status_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Status_Inc_Input>;
  _prepend?: InputMaybe<Plot_Status_Prepend_Input>;
  _set?: InputMaybe<Plot_Status_Set_Input>;
  pk_columns: Plot_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_ManyArgs = {
  updates: Array<Plot_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Primary_Growth_StageArgs = {
  _inc?: InputMaybe<Primary_Growth_Stage_Inc_Input>;
  _set?: InputMaybe<Primary_Growth_Stage_Set_Input>;
  where: Primary_Growth_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Primary_Growth_Stage_By_PkArgs = {
  _inc?: InputMaybe<Primary_Growth_Stage_Inc_Input>;
  _set?: InputMaybe<Primary_Growth_Stage_Set_Input>;
  pk_columns: Primary_Growth_Stage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Primary_Growth_Stage_ManyArgs = {
  updates: Array<Primary_Growth_Stage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductArgs = {
  _inc?: InputMaybe<Product_Inc_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_AttachmentArgs = {
  _inc?: InputMaybe<Product_Attachment_Inc_Input>;
  _set?: InputMaybe<Product_Attachment_Set_Input>;
  where: Product_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Product_Attachment_Inc_Input>;
  _set?: InputMaybe<Product_Attachment_Set_Input>;
  pk_columns: Product_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Attachment_ManyArgs = {
  updates: Array<Product_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_AttributeArgs = {
  _inc?: InputMaybe<Product_Attribute_Inc_Input>;
  _set?: InputMaybe<Product_Attribute_Set_Input>;
  where: Product_Attribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Attribute_By_PkArgs = {
  _inc?: InputMaybe<Product_Attribute_Inc_Input>;
  _set?: InputMaybe<Product_Attribute_Set_Input>;
  pk_columns: Product_Attribute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Attribute_ChoiceArgs = {
  _inc?: InputMaybe<Product_Attribute_Choice_Inc_Input>;
  _set?: InputMaybe<Product_Attribute_Choice_Set_Input>;
  where: Product_Attribute_Choice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Attribute_Choice_By_PkArgs = {
  _inc?: InputMaybe<Product_Attribute_Choice_Inc_Input>;
  _set?: InputMaybe<Product_Attribute_Choice_Set_Input>;
  pk_columns: Product_Attribute_Choice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Attribute_Choice_ManyArgs = {
  updates: Array<Product_Attribute_Choice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Attribute_ManyArgs = {
  updates: Array<Product_Attribute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_By_PkArgs = {
  _inc?: InputMaybe<Product_Inc_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  pk_columns: Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_CertificationArgs = {
  _inc?: InputMaybe<Product_Certification_Inc_Input>;
  _set?: InputMaybe<Product_Certification_Set_Input>;
  where: Product_Certification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Certification_AttachmentArgs = {
  _inc?: InputMaybe<Product_Certification_Attachment_Inc_Input>;
  _set?: InputMaybe<Product_Certification_Attachment_Set_Input>;
  where: Product_Certification_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Certification_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Product_Certification_Attachment_Inc_Input>;
  _set?: InputMaybe<Product_Certification_Attachment_Set_Input>;
  pk_columns: Product_Certification_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Certification_Attachment_ManyArgs = {
  updates: Array<Product_Certification_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Certification_By_PkArgs = {
  _inc?: InputMaybe<Product_Certification_Inc_Input>;
  _set?: InputMaybe<Product_Certification_Set_Input>;
  pk_columns: Product_Certification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Certification_ManyArgs = {
  updates: Array<Product_Certification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ClassArgs = {
  _set?: InputMaybe<Product_Class_Set_Input>;
  where: Product_Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Class_By_PkArgs = {
  _set?: InputMaybe<Product_Class_Set_Input>;
  pk_columns: Product_Class_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Class_ManyArgs = {
  updates: Array<Product_Class_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_CompositionArgs = {
  _inc?: InputMaybe<Product_Composition_Inc_Input>;
  _set?: InputMaybe<Product_Composition_Set_Input>;
  where: Product_Composition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Composition_By_PkArgs = {
  _inc?: InputMaybe<Product_Composition_Inc_Input>;
  _set?: InputMaybe<Product_Composition_Set_Input>;
  pk_columns: Product_Composition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Composition_ManyArgs = {
  updates: Array<Product_Composition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Crop_AssociationArgs = {
  _inc?: InputMaybe<Product_Crop_Association_Inc_Input>;
  _set?: InputMaybe<Product_Crop_Association_Set_Input>;
  where: Product_Crop_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Crop_Association_By_PkArgs = {
  _inc?: InputMaybe<Product_Crop_Association_Inc_Input>;
  _set?: InputMaybe<Product_Crop_Association_Set_Input>;
  pk_columns: Product_Crop_Association_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Crop_Association_ManyArgs = {
  updates: Array<Product_Crop_Association_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Crop_Infestation_RecommendationArgs = {
  _inc?: InputMaybe<Product_Crop_Infestation_Recommendation_Inc_Input>;
  _set?: InputMaybe<Product_Crop_Infestation_Recommendation_Set_Input>;
  where: Product_Crop_Infestation_Recommendation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Crop_Infestation_Recommendation_By_PkArgs = {
  _inc?: InputMaybe<Product_Crop_Infestation_Recommendation_Inc_Input>;
  _set?: InputMaybe<Product_Crop_Infestation_Recommendation_Set_Input>;
  pk_columns: Product_Crop_Infestation_Recommendation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Crop_Infestation_Recommendation_ManyArgs = {
  updates: Array<Product_Crop_Infestation_Recommendation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Crop_Nutrition_RecommendationArgs = {
  _inc?: InputMaybe<Product_Crop_Nutrition_Recommendation_Inc_Input>;
  _set?: InputMaybe<Product_Crop_Nutrition_Recommendation_Set_Input>;
  where: Product_Crop_Nutrition_Recommendation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Crop_Nutrition_Recommendation_By_PkArgs = {
  _inc?: InputMaybe<Product_Crop_Nutrition_Recommendation_Inc_Input>;
  _set?: InputMaybe<Product_Crop_Nutrition_Recommendation_Set_Input>;
  pk_columns: Product_Crop_Nutrition_Recommendation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Crop_Nutrition_Recommendation_ManyArgs = {
  updates: Array<Product_Crop_Nutrition_Recommendation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_FavouriteArgs = {
  _inc?: InputMaybe<Product_Favourite_Inc_Input>;
  _set?: InputMaybe<Product_Favourite_Set_Input>;
  where: Product_Favourite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Favourite_By_PkArgs = {
  _inc?: InputMaybe<Product_Favourite_Inc_Input>;
  _set?: InputMaybe<Product_Favourite_Set_Input>;
  pk_columns: Product_Favourite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Favourite_ManyArgs = {
  updates: Array<Product_Favourite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_InfestationArgs = {
  _inc?: InputMaybe<Product_Infestation_Inc_Input>;
  _set?: InputMaybe<Product_Infestation_Set_Input>;
  where: Product_Infestation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Infestation_By_PkArgs = {
  _inc?: InputMaybe<Product_Infestation_Inc_Input>;
  _set?: InputMaybe<Product_Infestation_Set_Input>;
  pk_columns: Product_Infestation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Infestation_ManyArgs = {
  updates: Array<Product_Infestation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_MainsectionArgs = {
  _inc?: InputMaybe<Product_Mainsection_Inc_Input>;
  _set?: InputMaybe<Product_Mainsection_Set_Input>;
  where: Product_Mainsection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Mainsection_AttachmentArgs = {
  _inc?: InputMaybe<Product_Mainsection_Attachment_Inc_Input>;
  _set?: InputMaybe<Product_Mainsection_Attachment_Set_Input>;
  where: Product_Mainsection_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Mainsection_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Product_Mainsection_Attachment_Inc_Input>;
  _set?: InputMaybe<Product_Mainsection_Attachment_Set_Input>;
  pk_columns: Product_Mainsection_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Mainsection_Attachment_ManyArgs = {
  updates: Array<Product_Mainsection_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Mainsection_By_PkArgs = {
  _inc?: InputMaybe<Product_Mainsection_Inc_Input>;
  _set?: InputMaybe<Product_Mainsection_Set_Input>;
  pk_columns: Product_Mainsection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Mainsection_ManyArgs = {
  updates: Array<Product_Mainsection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: Array<Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_PurchasedArgs = {
  _inc?: InputMaybe<Product_Purchased_Inc_Input>;
  _set?: InputMaybe<Product_Purchased_Set_Input>;
  where: Product_Purchased_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Purchased_By_PkArgs = {
  _inc?: InputMaybe<Product_Purchased_Inc_Input>;
  _set?: InputMaybe<Product_Purchased_Set_Input>;
  pk_columns: Product_Purchased_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Purchased_ManyArgs = {
  updates: Array<Product_Purchased_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_SectionArgs = {
  _inc?: InputMaybe<Product_Section_Inc_Input>;
  _set?: InputMaybe<Product_Section_Set_Input>;
  where: Product_Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Section_AttachmentArgs = {
  _inc?: InputMaybe<Product_Section_Attachment_Inc_Input>;
  _set?: InputMaybe<Product_Section_Attachment_Set_Input>;
  where: Product_Section_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Section_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Product_Section_Attachment_Inc_Input>;
  _set?: InputMaybe<Product_Section_Attachment_Set_Input>;
  pk_columns: Product_Section_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Section_Attachment_ManyArgs = {
  updates: Array<Product_Section_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Section_By_PkArgs = {
  _inc?: InputMaybe<Product_Section_Inc_Input>;
  _set?: InputMaybe<Product_Section_Set_Input>;
  pk_columns: Product_Section_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Section_ManyArgs = {
  updates: Array<Product_Section_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_SkuArgs = {
  _inc?: InputMaybe<Product_Sku_Inc_Input>;
  _set?: InputMaybe<Product_Sku_Set_Input>;
  where: Product_Sku_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Sku_By_PkArgs = {
  _inc?: InputMaybe<Product_Sku_Inc_Input>;
  _set?: InputMaybe<Product_Sku_Set_Input>;
  pk_columns: Product_Sku_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Sku_ManyArgs = {
  updates: Array<Product_Sku_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_SubsectionArgs = {
  _inc?: InputMaybe<Product_Subsection_Inc_Input>;
  _set?: InputMaybe<Product_Subsection_Set_Input>;
  where: Product_Subsection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Subsection_AttachmentArgs = {
  _inc?: InputMaybe<Product_Subsection_Attachment_Inc_Input>;
  _set?: InputMaybe<Product_Subsection_Attachment_Set_Input>;
  where: Product_Subsection_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Subsection_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Product_Subsection_Attachment_Inc_Input>;
  _set?: InputMaybe<Product_Subsection_Attachment_Set_Input>;
  pk_columns: Product_Subsection_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Subsection_Attachment_ManyArgs = {
  updates: Array<Product_Subsection_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Subsection_By_PkArgs = {
  _inc?: InputMaybe<Product_Subsection_Inc_Input>;
  _set?: InputMaybe<Product_Subsection_Set_Input>;
  pk_columns: Product_Subsection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Subsection_ManyArgs = {
  updates: Array<Product_Subsection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ViewArgs = {
  _inc?: InputMaybe<Product_View_Inc_Input>;
  _set?: InputMaybe<Product_View_Set_Input>;
  where: Product_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_View_By_PkArgs = {
  _inc?: InputMaybe<Product_View_Inc_Input>;
  _set?: InputMaybe<Product_View_Set_Input>;
  pk_columns: Product_View_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_View_ManyArgs = {
  updates: Array<Product_View_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductsArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_By_PkArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  pk_columns: Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_FertiliserArgs = {
  _set?: InputMaybe<Products_Fertiliser_Set_Input>;
  where: Products_Fertiliser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Fertiliser_By_PkArgs = {
  _set?: InputMaybe<Products_Fertiliser_Set_Input>;
  pk_columns: Products_Fertiliser_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Fertiliser_ContentsArgs = {
  _inc?: InputMaybe<Products_Fertiliser_Contents_Inc_Input>;
  _set?: InputMaybe<Products_Fertiliser_Contents_Set_Input>;
  where: Products_Fertiliser_Contents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Fertiliser_Contents_By_PkArgs = {
  _inc?: InputMaybe<Products_Fertiliser_Contents_Inc_Input>;
  _set?: InputMaybe<Products_Fertiliser_Contents_Set_Input>;
  pk_columns: Products_Fertiliser_Contents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Fertiliser_Contents_ManyArgs = {
  updates: Array<Products_Fertiliser_Contents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Fertiliser_ManyArgs = {
  updates: Array<Products_Fertiliser_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Fertiliser_UnitsArgs = {
  _inc?: InputMaybe<Products_Fertiliser_Units_Inc_Input>;
  _set?: InputMaybe<Products_Fertiliser_Units_Set_Input>;
  where: Products_Fertiliser_Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Fertiliser_Units_By_PkArgs = {
  _inc?: InputMaybe<Products_Fertiliser_Units_Inc_Input>;
  _set?: InputMaybe<Products_Fertiliser_Units_Set_Input>;
  pk_columns: Products_Fertiliser_Units_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Fertiliser_Units_ManyArgs = {
  updates: Array<Products_Fertiliser_Units_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Products_ManyArgs = {
  updates: Array<Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Products_PesticideArgs = {
  _set?: InputMaybe<Products_Pesticide_Set_Input>;
  where: Products_Pesticide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Pesticide_By_PkArgs = {
  _set?: InputMaybe<Products_Pesticide_Set_Input>;
  pk_columns: Products_Pesticide_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Pesticide_ContentsArgs = {
  _inc?: InputMaybe<Products_Pesticide_Contents_Inc_Input>;
  _set?: InputMaybe<Products_Pesticide_Contents_Set_Input>;
  where: Products_Pesticide_Contents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Pesticide_Contents_By_PkArgs = {
  _inc?: InputMaybe<Products_Pesticide_Contents_Inc_Input>;
  _set?: InputMaybe<Products_Pesticide_Contents_Set_Input>;
  pk_columns: Products_Pesticide_Contents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Pesticide_Contents_ManyArgs = {
  updates: Array<Products_Pesticide_Contents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Pesticide_ManyArgs = {
  updates: Array<Products_Pesticide_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Pesticide_UnitsArgs = {
  _inc?: InputMaybe<Products_Pesticide_Units_Inc_Input>;
  _set?: InputMaybe<Products_Pesticide_Units_Set_Input>;
  where: Products_Pesticide_Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Pesticide_Units_By_PkArgs = {
  _inc?: InputMaybe<Products_Pesticide_Units_Inc_Input>;
  _set?: InputMaybe<Products_Pesticide_Units_Set_Input>;
  pk_columns: Products_Pesticide_Units_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_Pesticide_Units_ManyArgs = {
  updates: Array<Products_Pesticide_Units_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderArgs = {
  _set?: InputMaybe<Provider_Set_Input>;
  where: Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_By_PkArgs = {
  _set?: InputMaybe<Provider_Set_Input>;
  pk_columns: Provider_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_ManyArgs = {
  updates: Array<Provider_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReceiptArgs = {
  _inc?: InputMaybe<Receipt_Inc_Input>;
  _set?: InputMaybe<Receipt_Set_Input>;
  where: Receipt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Receipt_By_PkArgs = {
  _inc?: InputMaybe<Receipt_Inc_Input>;
  _set?: InputMaybe<Receipt_Set_Input>;
  pk_columns: Receipt_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Receipt_ManyArgs = {
  updates: Array<Receipt_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Recommended_ProductArgs = {
  _inc?: InputMaybe<Recommended_Product_Inc_Input>;
  _set?: InputMaybe<Recommended_Product_Set_Input>;
  where: Recommended_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Recommended_Product_By_PkArgs = {
  _inc?: InputMaybe<Recommended_Product_Inc_Input>;
  _set?: InputMaybe<Recommended_Product_Set_Input>;
  pk_columns: Recommended_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Recommended_Product_ManyArgs = {
  updates: Array<Recommended_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RegionArgs = {
  _inc?: InputMaybe<Region_Inc_Input>;
  _set?: InputMaybe<Region_Set_Input>;
  where: Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Region_By_PkArgs = {
  _inc?: InputMaybe<Region_Inc_Input>;
  _set?: InputMaybe<Region_Set_Input>;
  pk_columns: Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Region_GroupArgs = {
  _inc?: InputMaybe<Region_Group_Inc_Input>;
  _set?: InputMaybe<Region_Group_Set_Input>;
  where: Region_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Region_Group_By_PkArgs = {
  _inc?: InputMaybe<Region_Group_Inc_Input>;
  _set?: InputMaybe<Region_Group_Set_Input>;
  pk_columns: Region_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Region_Group_ManyArgs = {
  updates: Array<Region_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Region_ManyArgs = {
  updates: Array<Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reward_ConfigurationArgs = {
  _inc?: InputMaybe<Reward_Configuration_Inc_Input>;
  _set?: InputMaybe<Reward_Configuration_Set_Input>;
  where: Reward_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reward_Configuration_By_PkArgs = {
  _inc?: InputMaybe<Reward_Configuration_Inc_Input>;
  _set?: InputMaybe<Reward_Configuration_Set_Input>;
  pk_columns: Reward_Configuration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reward_Configuration_ManyArgs = {
  updates: Array<Reward_Configuration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sap_SiArgs = {
  _inc?: InputMaybe<Sap_Si_Inc_Input>;
  _set?: InputMaybe<Sap_Si_Set_Input>;
  where: Sap_Si_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sap_Si_By_PkArgs = {
  _inc?: InputMaybe<Sap_Si_Inc_Input>;
  _set?: InputMaybe<Sap_Si_Set_Input>;
  pk_columns: Sap_Si_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sap_Si_ManyArgs = {
  updates: Array<Sap_Si_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sap_Si_MapArgs = {
  _inc?: InputMaybe<Sap_Si_Map_Inc_Input>;
  _set?: InputMaybe<Sap_Si_Map_Set_Input>;
  where: Sap_Si_Map_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sap_Si_Map_By_PkArgs = {
  _inc?: InputMaybe<Sap_Si_Map_Inc_Input>;
  _set?: InputMaybe<Sap_Si_Map_Set_Input>;
  pk_columns: Sap_Si_Map_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sap_Si_Map_ManyArgs = {
  updates: Array<Sap_Si_Map_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Secondary_Growth_StageArgs = {
  _inc?: InputMaybe<Secondary_Growth_Stage_Inc_Input>;
  _set?: InputMaybe<Secondary_Growth_Stage_Set_Input>;
  where: Secondary_Growth_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Secondary_Growth_Stage_By_PkArgs = {
  _inc?: InputMaybe<Secondary_Growth_Stage_Inc_Input>;
  _set?: InputMaybe<Secondary_Growth_Stage_Set_Input>;
  pk_columns: Secondary_Growth_Stage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Secondary_Growth_Stage_ManyArgs = {
  updates: Array<Secondary_Growth_Stage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SectionArgs = {
  _set?: InputMaybe<Section_Set_Input>;
  where: Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Section_By_PkArgs = {
  _set?: InputMaybe<Section_Set_Input>;
  pk_columns: Section_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Section_ManyArgs = {
  updates: Array<Section_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SeedsArgs = {
  _set?: InputMaybe<Seeds_Set_Input>;
  where: Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seeds_By_PkArgs = {
  _set?: InputMaybe<Seeds_Set_Input>;
  pk_columns: Seeds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seeds_ManyArgs = {
  updates: Array<Seeds_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sellable_ItemArgs = {
  _inc?: InputMaybe<Sellable_Item_Inc_Input>;
  _set?: InputMaybe<Sellable_Item_Set_Input>;
  where: Sellable_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sellable_Item_By_PkArgs = {
  _inc?: InputMaybe<Sellable_Item_Inc_Input>;
  _set?: InputMaybe<Sellable_Item_Set_Input>;
  pk_columns: Sellable_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sellable_Item_ManyArgs = {
  updates: Array<Sellable_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sellable_Item_StockArgs = {
  _inc?: InputMaybe<Sellable_Item_Stock_Inc_Input>;
  _set?: InputMaybe<Sellable_Item_Stock_Set_Input>;
  where: Sellable_Item_Stock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sellable_Item_Stock_By_PkArgs = {
  _inc?: InputMaybe<Sellable_Item_Stock_Inc_Input>;
  _set?: InputMaybe<Sellable_Item_Stock_Set_Input>;
  pk_columns: Sellable_Item_Stock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sellable_Item_Stock_ManyArgs = {
  updates: Array<Sellable_Item_Stock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SensorArgs = {
  _set?: InputMaybe<Sensor_Set_Input>;
  where: Sensor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sensor_By_PkArgs = {
  _set?: InputMaybe<Sensor_Set_Input>;
  pk_columns: Sensor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sensor_ManyArgs = {
  updates: Array<Sensor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sensor_ParameterArgs = {
  _set?: InputMaybe<Sensor_Parameter_Set_Input>;
  where: Sensor_Parameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sensor_Parameter_By_PkArgs = {
  _set?: InputMaybe<Sensor_Parameter_Set_Input>;
  pk_columns: Sensor_Parameter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sensor_Parameter_ManyArgs = {
  updates: Array<Sensor_Parameter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SeriesArgs = {
  _inc?: InputMaybe<Series_Inc_Input>;
  _set?: InputMaybe<Series_Set_Input>;
  where: Series_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Series_AuthorsArgs = {
  _inc?: InputMaybe<Series_Authors_Inc_Input>;
  _set?: InputMaybe<Series_Authors_Set_Input>;
  where: Series_Authors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Authors_By_PkArgs = {
  _inc?: InputMaybe<Series_Authors_Inc_Input>;
  _set?: InputMaybe<Series_Authors_Set_Input>;
  pk_columns: Series_Authors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Authors_ManyArgs = {
  updates: Array<Series_Authors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Series_By_PkArgs = {
  _inc?: InputMaybe<Series_Inc_Input>;
  _set?: InputMaybe<Series_Set_Input>;
  pk_columns: Series_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Series_CategoryArgs = {
  _set?: InputMaybe<Series_Category_Set_Input>;
  where: Series_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Category_By_PkArgs = {
  _set?: InputMaybe<Series_Category_Set_Input>;
  pk_columns: Series_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Category_ManyArgs = {
  updates: Array<Series_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Series_CropsArgs = {
  _inc?: InputMaybe<Series_Crops_Inc_Input>;
  _set?: InputMaybe<Series_Crops_Set_Input>;
  where: Series_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Crops_By_PkArgs = {
  _inc?: InputMaybe<Series_Crops_Inc_Input>;
  _set?: InputMaybe<Series_Crops_Set_Input>;
  pk_columns: Series_Crops_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Crops_ManyArgs = {
  updates: Array<Series_Crops_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Series_FavoritesArgs = {
  _inc?: InputMaybe<Series_Favorites_Inc_Input>;
  _set?: InputMaybe<Series_Favorites_Set_Input>;
  where: Series_Favorites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Favorites_By_PkArgs = {
  _inc?: InputMaybe<Series_Favorites_Inc_Input>;
  _set?: InputMaybe<Series_Favorites_Set_Input>;
  pk_columns: Series_Favorites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Favorites_ManyArgs = {
  updates: Array<Series_Favorites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Series_LikesArgs = {
  _inc?: InputMaybe<Series_Likes_Inc_Input>;
  _set?: InputMaybe<Series_Likes_Set_Input>;
  where: Series_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Likes_By_PkArgs = {
  _inc?: InputMaybe<Series_Likes_Inc_Input>;
  _set?: InputMaybe<Series_Likes_Set_Input>;
  pk_columns: Series_Likes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Likes_ManyArgs = {
  updates: Array<Series_Likes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Series_ManyArgs = {
  updates: Array<Series_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Setu_Trade_Shared_EntityArgs = {
  _set?: InputMaybe<Setu_Trade_Shared_Entity_Set_Input>;
  where: Setu_Trade_Shared_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Setu_Trade_Shared_Entity_ManyArgs = {
  updates: Array<Setu_Trade_Shared_Entity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Setu_Weather_UserArgs = {
  _inc?: InputMaybe<Setu_Weather_User_Inc_Input>;
  _set?: InputMaybe<Setu_Weather_User_Set_Input>;
  where: Setu_Weather_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Setu_Weather_User_By_PkArgs = {
  _inc?: InputMaybe<Setu_Weather_User_Inc_Input>;
  _set?: InputMaybe<Setu_Weather_User_Set_Input>;
  pk_columns: Setu_Weather_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Setu_Weather_User_ManyArgs = {
  updates: Array<Setu_Weather_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shared_EntityArgs = {
  _append?: InputMaybe<Shared_Entity_Append_Input>;
  _delete_at_path?: InputMaybe<Shared_Entity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shared_Entity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shared_Entity_Delete_Key_Input>;
  _inc?: InputMaybe<Shared_Entity_Inc_Input>;
  _prepend?: InputMaybe<Shared_Entity_Prepend_Input>;
  _set?: InputMaybe<Shared_Entity_Set_Input>;
  where: Shared_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shared_Entity_By_PkArgs = {
  _append?: InputMaybe<Shared_Entity_Append_Input>;
  _delete_at_path?: InputMaybe<Shared_Entity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shared_Entity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shared_Entity_Delete_Key_Input>;
  _inc?: InputMaybe<Shared_Entity_Inc_Input>;
  _prepend?: InputMaybe<Shared_Entity_Prepend_Input>;
  _set?: InputMaybe<Shared_Entity_Set_Input>;
  pk_columns: Shared_Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shared_Entity_ManyArgs = {
  updates: Array<Shared_Entity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Si_UnitArgs = {
  _inc?: InputMaybe<Si_Unit_Inc_Input>;
  _set?: InputMaybe<Si_Unit_Set_Input>;
  where: Si_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Si_Unit_By_PkArgs = {
  _inc?: InputMaybe<Si_Unit_Inc_Input>;
  _set?: InputMaybe<Si_Unit_Set_Input>;
  pk_columns: Si_Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Si_Unit_ManyArgs = {
  updates: Array<Si_Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Si_Unit_MeasureArgs = {
  _inc?: InputMaybe<Si_Unit_Measure_Inc_Input>;
  _set?: InputMaybe<Si_Unit_Measure_Set_Input>;
  where: Si_Unit_Measure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Si_Unit_Measure_By_PkArgs = {
  _inc?: InputMaybe<Si_Unit_Measure_Inc_Input>;
  _set?: InputMaybe<Si_Unit_Measure_Set_Input>;
  pk_columns: Si_Unit_Measure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Si_Unit_Measure_ManyArgs = {
  updates: Array<Si_Unit_Measure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SkuArgs = {
  _inc?: InputMaybe<Sku_Inc_Input>;
  _set?: InputMaybe<Sku_Set_Input>;
  where: Sku_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sku_By_PkArgs = {
  _inc?: InputMaybe<Sku_Inc_Input>;
  _set?: InputMaybe<Sku_Set_Input>;
  pk_columns: Sku_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sku_KindArgs = {
  _inc?: InputMaybe<Sku_Kind_Inc_Input>;
  _set?: InputMaybe<Sku_Kind_Set_Input>;
  where: Sku_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sku_Kind_By_PkArgs = {
  _inc?: InputMaybe<Sku_Kind_Inc_Input>;
  _set?: InputMaybe<Sku_Kind_Set_Input>;
  pk_columns: Sku_Kind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sku_Kind_ManyArgs = {
  updates: Array<Sku_Kind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sku_ManyArgs = {
  updates: Array<Sku_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SoilArgs = {
  _inc?: InputMaybe<Soil_Inc_Input>;
  _set?: InputMaybe<Soil_Set_Input>;
  where: Soil_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Soil_By_PkArgs = {
  _inc?: InputMaybe<Soil_Inc_Input>;
  _set?: InputMaybe<Soil_Set_Input>;
  pk_columns: Soil_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Soil_ManyArgs = {
  updates: Array<Soil_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sprinkler_Irrigation_SystemArgs = {
  _inc?: InputMaybe<Sprinkler_Irrigation_System_Inc_Input>;
  _set?: InputMaybe<Sprinkler_Irrigation_System_Set_Input>;
  where: Sprinkler_Irrigation_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sprinkler_Irrigation_System_By_PkArgs = {
  _inc?: InputMaybe<Sprinkler_Irrigation_System_Inc_Input>;
  _set?: InputMaybe<Sprinkler_Irrigation_System_Set_Input>;
  pk_columns: Sprinkler_Irrigation_System_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sprinkler_Irrigation_System_ManyArgs = {
  updates: Array<Sprinkler_Irrigation_System_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sub_SectionArgs = {
  _set?: InputMaybe<Sub_Section_Set_Input>;
  where: Sub_Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sub_Section_By_PkArgs = {
  _set?: InputMaybe<Sub_Section_Set_Input>;
  pk_columns: Sub_Section_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sub_Section_ManyArgs = {
  updates: Array<Sub_Section_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubcategoryArgs = {
  _inc?: InputMaybe<Subcategory_Inc_Input>;
  _set?: InputMaybe<Subcategory_Set_Input>;
  where: Subcategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subcategory_By_PkArgs = {
  _inc?: InputMaybe<Subcategory_Inc_Input>;
  _set?: InputMaybe<Subcategory_Set_Input>;
  pk_columns: Subcategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subcategory_ManyArgs = {
  updates: Array<Subcategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Package_HighlightsArgs = {
  _inc?: InputMaybe<Subscription_Package_Highlights_Inc_Input>;
  _set?: InputMaybe<Subscription_Package_Highlights_Set_Input>;
  where: Subscription_Package_Highlights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Package_Highlights_By_PkArgs = {
  _inc?: InputMaybe<Subscription_Package_Highlights_Inc_Input>;
  _set?: InputMaybe<Subscription_Package_Highlights_Set_Input>;
  pk_columns: Subscription_Package_Highlights_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Package_Highlights_ManyArgs = {
  updates: Array<Subscription_Package_Highlights_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Summary_Sensor_ReadingArgs = {
  _inc?: InputMaybe<Summary_Sensor_Reading_Inc_Input>;
  _set?: InputMaybe<Summary_Sensor_Reading_Set_Input>;
  where: Summary_Sensor_Reading_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Summary_Sensor_Reading_By_PkArgs = {
  _inc?: InputMaybe<Summary_Sensor_Reading_Inc_Input>;
  _set?: InputMaybe<Summary_Sensor_Reading_Set_Input>;
  pk_columns: Summary_Sensor_Reading_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Summary_Sensor_Reading_ManyArgs = {
  updates: Array<Summary_Sensor_Reading_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ThreadArgs = {
  _set?: InputMaybe<Thread_Set_Input>;
  where: Thread_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_By_PkArgs = {
  _set?: InputMaybe<Thread_Set_Input>;
  pk_columns: Thread_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_ManyArgs = {
  updates: Array<Thread_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TradeArgs = {
  _inc?: InputMaybe<Trade_Inc_Input>;
  _set?: InputMaybe<Trade_Set_Input>;
  where: Trade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_AmountsArgs = {
  trade_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_By_PkArgs = {
  _inc?: InputMaybe<Trade_Inc_Input>;
  _set?: InputMaybe<Trade_Set_Input>;
  pk_columns: Trade_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_CommodityArgs = {
  _set?: InputMaybe<Trade_Commodity_Set_Input>;
  where: Trade_Commodity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Commodity_By_PkArgs = {
  _set?: InputMaybe<Trade_Commodity_Set_Input>;
  pk_columns: Trade_Commodity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Commodity_ManyArgs = {
  updates: Array<Trade_Commodity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_ItemArgs = {
  _inc?: InputMaybe<Trade_Item_Inc_Input>;
  _set?: InputMaybe<Trade_Item_Set_Input>;
  where: Trade_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Item_By_PkArgs = {
  _inc?: InputMaybe<Trade_Item_Inc_Input>;
  _set?: InputMaybe<Trade_Item_Set_Input>;
  pk_columns: Trade_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Item_ManyArgs = {
  updates: Array<Trade_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_ManyArgs = {
  updates: Array<Trade_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_RegionArgs = {
  _set?: InputMaybe<Trade_Region_Set_Input>;
  where: Trade_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Region_By_PkArgs = {
  _set?: InputMaybe<Trade_Region_Set_Input>;
  pk_columns: Trade_Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Region_ManyArgs = {
  updates: Array<Trade_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_TransactionArgs = {
  _inc?: InputMaybe<Trade_Transaction_Inc_Input>;
  _set?: InputMaybe<Trade_Transaction_Set_Input>;
  where: Trade_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Trade_Transaction_Inc_Input>;
  _set?: InputMaybe<Trade_Transaction_Set_Input>;
  pk_columns: Trade_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Transaction_ManyArgs = {
  updates: Array<Trade_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Transaction_SummaryArgs = {
  _inc?: InputMaybe<Trade_Transaction_Summary_Inc_Input>;
  _set?: InputMaybe<Trade_Transaction_Summary_Set_Input>;
  where: Trade_Transaction_Summary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Transaction_Summary_By_PkArgs = {
  _inc?: InputMaybe<Trade_Transaction_Summary_Inc_Input>;
  _set?: InputMaybe<Trade_Transaction_Summary_Set_Input>;
  pk_columns: Trade_Transaction_Summary_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Transaction_Summary_ManyArgs = {
  updates: Array<Trade_Transaction_Summary_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_UnitArgs = {
  _set?: InputMaybe<Trade_Unit_Set_Input>;
  where: Trade_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Unit_By_PkArgs = {
  _set?: InputMaybe<Trade_Unit_Set_Input>;
  pk_columns: Trade_Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Unit_ManyArgs = {
  updates: Array<Trade_Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_TrendArgs = {
  _inc?: InputMaybe<Transaction_Trend_Inc_Input>;
  _set?: InputMaybe<Transaction_Trend_Set_Input>;
  where: Transaction_Trend_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_Trend_By_PkArgs = {
  _inc?: InputMaybe<Transaction_Trend_Inc_Input>;
  _set?: InputMaybe<Transaction_Trend_Set_Input>;
  pk_columns: Transaction_Trend_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_Trend_ManyArgs = {
  updates: Array<Transaction_Trend_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UnitArgs = {
  _set?: InputMaybe<Unit_Set_Input>;
  where: Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_By_PkArgs = {
  _set?: InputMaybe<Unit_Set_Input>;
  pk_columns: Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_ManyArgs = {
  updates: Array<Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Answer_ChoicesArgs = {
  _set?: InputMaybe<User_Answer_Choices_Set_Input>;
  where: User_Answer_Choices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Answer_Choices_By_PkArgs = {
  _set?: InputMaybe<User_Answer_Choices_Set_Input>;
  pk_columns: User_Answer_Choices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Answer_Choices_ManyArgs = {
  updates: Array<User_Answer_Choices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assessment_AttemptArgs = {
  _inc?: InputMaybe<User_Assessment_Attempt_Inc_Input>;
  _set?: InputMaybe<User_Assessment_Attempt_Set_Input>;
  where: User_Assessment_Attempt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assessment_Attempt_By_PkArgs = {
  _inc?: InputMaybe<User_Assessment_Attempt_Inc_Input>;
  _set?: InputMaybe<User_Assessment_Attempt_Set_Input>;
  pk_columns: User_Assessment_Attempt_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assessment_Attempt_ManyArgs = {
  updates: Array<User_Assessment_Attempt_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assessment_Question_ResponseArgs = {
  _inc?: InputMaybe<User_Assessment_Question_Response_Inc_Input>;
  _set?: InputMaybe<User_Assessment_Question_Response_Set_Input>;
  where: User_Assessment_Question_Response_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assessment_Question_Response_By_PkArgs = {
  _inc?: InputMaybe<User_Assessment_Question_Response_Inc_Input>;
  _set?: InputMaybe<User_Assessment_Question_Response_Set_Input>;
  pk_columns: User_Assessment_Question_Response_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Assessment_Question_Response_ManyArgs = {
  updates: Array<User_Assessment_Question_Response_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Reward_HistoryArgs = {
  _inc?: InputMaybe<User_Reward_History_Inc_Input>;
  _set?: InputMaybe<User_Reward_History_Set_Input>;
  where: User_Reward_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Reward_History_By_PkArgs = {
  _inc?: InputMaybe<User_Reward_History_Inc_Input>;
  _set?: InputMaybe<User_Reward_History_Set_Input>;
  pk_columns: User_Reward_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Reward_History_ManyArgs = {
  updates: Array<User_Reward_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Subscription_PackageArgs = {
  _inc?: InputMaybe<User_Subscription_Package_Inc_Input>;
  _set?: InputMaybe<User_Subscription_Package_Set_Input>;
  where: User_Subscription_Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Subscription_Package_By_PkArgs = {
  _inc?: InputMaybe<User_Subscription_Package_Inc_Input>;
  _set?: InputMaybe<User_Subscription_Package_Set_Input>;
  pk_columns: User_Subscription_Package_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Subscription_Package_ManyArgs = {
  updates: Array<User_Subscription_Package_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_GradeArgs = {
  _inc?: InputMaybe<Variety_Grade_Inc_Input>;
  _set?: InputMaybe<Variety_Grade_Set_Input>;
  where: Variety_Grade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Grade_By_PkArgs = {
  _inc?: InputMaybe<Variety_Grade_Inc_Input>;
  _set?: InputMaybe<Variety_Grade_Set_Input>;
  pk_columns: Variety_Grade_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Grade_ManyArgs = {
  updates: Array<Variety_Grade_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Grade_PhotosArgs = {
  _inc?: InputMaybe<Variety_Grade_Photos_Inc_Input>;
  _set?: InputMaybe<Variety_Grade_Photos_Set_Input>;
  where: Variety_Grade_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Grade_Photos_By_PkArgs = {
  _inc?: InputMaybe<Variety_Grade_Photos_Inc_Input>;
  _set?: InputMaybe<Variety_Grade_Photos_Set_Input>;
  pk_columns: Variety_Grade_Photos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Grade_Photos_ManyArgs = {
  updates: Array<Variety_Grade_Photos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_GroupArgs = {
  _append?: InputMaybe<Variety_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Variety_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Variety_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Variety_Group_Delete_Key_Input>;
  _inc?: InputMaybe<Variety_Group_Inc_Input>;
  _prepend?: InputMaybe<Variety_Group_Prepend_Input>;
  _set?: InputMaybe<Variety_Group_Set_Input>;
  where: Variety_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Group_By_PkArgs = {
  _append?: InputMaybe<Variety_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Variety_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Variety_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Variety_Group_Delete_Key_Input>;
  _inc?: InputMaybe<Variety_Group_Inc_Input>;
  _prepend?: InputMaybe<Variety_Group_Prepend_Input>;
  _set?: InputMaybe<Variety_Group_Set_Input>;
  pk_columns: Variety_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Group_ManyArgs = {
  updates: Array<Variety_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_LocationArgs = {
  _inc?: InputMaybe<Weather_Location_Inc_Input>;
  _set?: InputMaybe<Weather_Location_Set_Input>;
  where: Weather_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Location_By_PkArgs = {
  _inc?: InputMaybe<Weather_Location_Inc_Input>;
  _set?: InputMaybe<Weather_Location_Set_Input>;
  pk_columns: Weather_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Location_ManyArgs = {
  updates: Array<Weather_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_ReferenceArgs = {
  _inc?: InputMaybe<Weather_Reference_Inc_Input>;
  _set?: InputMaybe<Weather_Reference_Set_Input>;
  where: Weather_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Reference_By_PkArgs = {
  _inc?: InputMaybe<Weather_Reference_Inc_Input>;
  _set?: InputMaybe<Weather_Reference_Set_Input>;
  pk_columns: Weather_Reference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Reference_ManyArgs = {
  updates: Array<Weather_Reference_Updates>;
};


/** mutation root */
export type Mutation_RootUpsert_Intercultural_OperationArgs = {
  method_id: Scalars['String'];
  operation_id?: InputMaybe<Scalars['String']>;
  plot_crop_id: Scalars['String'];
  plot_id: Scalars['String'];
  record_date: Scalars['DateTime'];
  recorded_by_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootVerify_OtpArgs = {
  number: Scalars['String'];
  otp: Scalars['String'];
};


/** mutation root */
export type Mutation_RootVerify_TokenArgs = {
  token?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootVerify_Token_SetuArgs = {
  token?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootVerify_Trade_OtpArgs = {
  otp: Scalars['String'];
  token: Scalars['String'];
};

/** columns and relationships of "mutual_group" */
export type Mutual_Group = {
  __typename?: 'mutual_group';
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  codename: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  department?: Maybe<Department>;
  description: Scalars['String'];
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  external_reference_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  mutual_group_memberships: Array<Mutual_Group_Membership>;
  /** An aggregate relationship */
  mutual_group_memberships_aggregate: Mutual_Group_Membership_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Mutual_Group_Network>;
  /** An aggregate relationship */
  networks_aggregate: Mutual_Group_Network_Aggregate;
  /** An object relationship */
  photo?: Maybe<Media>;
  quality_checked?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  region?: Maybe<Region>;
  region_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupMutual_Group_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupMutual_Group_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupNetworksArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};

/** aggregated selection of "mutual_group" */
export type Mutual_Group_Aggregate = {
  __typename?: 'mutual_group_aggregate';
  aggregate?: Maybe<Mutual_Group_Aggregate_Fields>;
  nodes: Array<Mutual_Group>;
};

/** aggregate fields of "mutual_group" */
export type Mutual_Group_Aggregate_Fields = {
  __typename?: 'mutual_group_aggregate_fields';
  avg?: Maybe<Mutual_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Max_Fields>;
  min?: Maybe<Mutual_Group_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Variance_Fields>;
};


/** aggregate fields of "mutual_group" */
export type Mutual_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mutual_group" */
export type Mutual_Group_Aggregate_Order_By = {
  avg?: InputMaybe<Mutual_Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mutual_Group_Max_Order_By>;
  min?: InputMaybe<Mutual_Group_Min_Order_By>;
  stddev?: InputMaybe<Mutual_Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mutual_Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mutual_Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mutual_Group_Sum_Order_By>;
  var_pop?: InputMaybe<Mutual_Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mutual_Group_Var_Samp_Order_By>;
  variance?: InputMaybe<Mutual_Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mutual_group" */
export type Mutual_Group_Arr_Rel_Insert_Input = {
  data: Array<Mutual_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Mutual_Group_Avg_Fields = {
  __typename?: 'mutual_group_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mutual_group" */
export type Mutual_Group_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mutual_group". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "mutual_group". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Bool_Exp_Remote_Rel_Article_Categorymutual_Group = {
  _and?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Article_Categorymutual_Group>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "mutual_group". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Bool_Exp_Remote_Rel_Article_User_Groupmutual_Group = {
  _and?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Article_User_Groupmutual_Group>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "mutual_group". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Bool_Exp_Remote_Rel_Mutual_Group_Subscription_Packagemutual_Group = {
  _and?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Mutual_Group_Subscription_Packagemutual_Group>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "mutual_group". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Bool_Exp_Remote_Rel_Notification_Template_Distribution_Teamteam = {
  _and?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Notification_Template_Distribution_Teamteam>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "mutual_group". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Bool_Exp_Remote_Rel_Shared_Entityowner_Team = {
  _and?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityowner_Team>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group" */
export enum Mutual_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  MutualGroupCodenameKey = 'mutual_group_codename_key',
  /** unique or primary key constraint on columns "data_consent_id" */
  MutualGroupDataConsentIdKey = 'mutual_group_data_consent_id_key',
  /** unique or primary key constraint on columns "id" */
  MutualGroupPkey = 'mutual_group_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group" */
export type Mutual_Group_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutual_group" */
export type Mutual_Group_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Mutual_Group_Network_Arr_Rel_Insert_Input>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  region_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Mutual_Group_Max_Fields = {
  __typename?: 'mutual_group_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "mutual_group" */
export type Mutual_Group_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** columns and relationships of "mutual_group_membership" */
export type Mutual_Group_Membership = {
  __typename?: 'mutual_group_membership';
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  mutual_group: Mutual_Group;
  mutual_group_id: Scalars['Int'];
  /** An object relationship */
  mutual_group_role: Mutual_Group_Role;
  mutual_group_role_id: Scalars['Int'];
  remark: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "mutual_group_membership" */
export type Mutual_Group_Membership_Aggregate = {
  __typename?: 'mutual_group_membership_aggregate';
  aggregate?: Maybe<Mutual_Group_Membership_Aggregate_Fields>;
  nodes: Array<Mutual_Group_Membership>;
};

/** aggregate fields of "mutual_group_membership" */
export type Mutual_Group_Membership_Aggregate_Fields = {
  __typename?: 'mutual_group_membership_aggregate_fields';
  avg?: Maybe<Mutual_Group_Membership_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Membership_Max_Fields>;
  min?: Maybe<Mutual_Group_Membership_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Membership_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Membership_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Membership_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Membership_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Membership_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Membership_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Membership_Variance_Fields>;
};


/** aggregate fields of "mutual_group_membership" */
export type Mutual_Group_Membership_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mutual_group_membership" */
export type Mutual_Group_Membership_Aggregate_Order_By = {
  avg?: InputMaybe<Mutual_Group_Membership_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mutual_Group_Membership_Max_Order_By>;
  min?: InputMaybe<Mutual_Group_Membership_Min_Order_By>;
  stddev?: InputMaybe<Mutual_Group_Membership_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mutual_Group_Membership_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mutual_Group_Membership_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mutual_Group_Membership_Sum_Order_By>;
  var_pop?: InputMaybe<Mutual_Group_Membership_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mutual_Group_Membership_Var_Samp_Order_By>;
  variance?: InputMaybe<Mutual_Group_Membership_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mutual_group_membership" */
export type Mutual_Group_Membership_Arr_Rel_Insert_Input = {
  data: Array<Mutual_Group_Membership_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_Membership_On_Conflict>;
};

/** aggregate avg on columns */
export type Mutual_Group_Membership_Avg_Fields = {
  __typename?: 'mutual_group_membership_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Avg_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mutual_group_membership". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Membership_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Membership_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Membership_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group?: InputMaybe<Mutual_Group_Bool_Exp>;
  mutual_group_id?: InputMaybe<Int_Comparison_Exp>;
  mutual_group_role?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
  mutual_group_role_id?: InputMaybe<Int_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group_membership" */
export enum Mutual_Group_Membership_Constraint {
  /** unique or primary key constraint on columns "mutual_group_role_id", "base_user_id", "mutual_group_id" */
  MutualGroupMembershipBaseUserIdMutualGrou_58a16353Uniq = 'mutual_group_membership_base_user_id_mutual_grou_58a16353_uniq',
  /** unique or primary key constraint on columns "id" */
  MutualGroupMembershipPkey = 'mutual_group_membership_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group_membership" */
export type Mutual_Group_Membership_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  mutual_group_role_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutual_group_membership" */
export type Mutual_Group_Membership_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group?: InputMaybe<Mutual_Group_Obj_Rel_Insert_Input>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  mutual_group_role?: InputMaybe<Mutual_Group_Role_Obj_Rel_Insert_Input>;
  mutual_group_role_id?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Mutual_Group_Membership_Max_Fields = {
  __typename?: 'mutual_group_membership_max_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  mutual_group_role_id?: Maybe<Scalars['Int']>;
  remark?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Max_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mutual_Group_Membership_Min_Fields = {
  __typename?: 'mutual_group_membership_min_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  mutual_group_role_id?: Maybe<Scalars['Int']>;
  remark?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Min_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mutual_group_membership" */
export type Mutual_Group_Membership_Mutation_Response = {
  __typename?: 'mutual_group_membership_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group_Membership>;
};

/** on_conflict condition type for table "mutual_group_membership" */
export type Mutual_Group_Membership_On_Conflict = {
  constraint: Mutual_Group_Membership_Constraint;
  update_columns?: Array<Mutual_Group_Membership_Update_Column>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group_membership". */
export type Mutual_Group_Membership_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mutual_group?: InputMaybe<Mutual_Group_Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role?: InputMaybe<Mutual_Group_Role_Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group_membership */
export type Mutual_Group_Membership_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "mutual_group_membership" */
export enum Mutual_Group_Membership_Select_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  MutualGroupRoleId = 'mutual_group_role_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mutual_group_membership" */
export type Mutual_Group_Membership_Set_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  mutual_group_role_id?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Membership_Stddev_Fields = {
  __typename?: 'mutual_group_membership_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Stddev_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Membership_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_membership_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Stddev_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Membership_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_membership_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Stddev_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mutual_group_membership" */
export type Mutual_Group_Membership_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Membership_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Membership_Stream_Cursor_Value_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  mutual_group_role_id?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Mutual_Group_Membership_Sum_Fields = {
  __typename?: 'mutual_group_membership_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  mutual_group_role_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Sum_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** update columns of table "mutual_group_membership" */
export enum Mutual_Group_Membership_Update_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  MutualGroupRoleId = 'mutual_group_role_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Mutual_Group_Membership_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Membership_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Membership_Set_Input>;
  where: Mutual_Group_Membership_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Membership_Var_Pop_Fields = {
  __typename?: 'mutual_group_membership_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Var_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Membership_Var_Samp_Fields = {
  __typename?: 'mutual_group_membership_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Var_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mutual_Group_Membership_Variance_Fields = {
  __typename?: 'mutual_group_membership_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Variance_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mutual_Group_Min_Fields = {
  __typename?: 'mutual_group_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "mutual_group" */
export type Mutual_Group_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mutual_group" */
export type Mutual_Group_Mutation_Response = {
  __typename?: 'mutual_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group>;
};

/** columns and relationships of "mutual_group_network" */
export type Mutual_Group_Network = {
  __typename?: 'mutual_group_network';
  id: Scalars['Int'];
  /** An object relationship */
  mutual_group: Mutual_Group;
  mutual_group_id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
};

/** aggregated selection of "mutual_group_network" */
export type Mutual_Group_Network_Aggregate = {
  __typename?: 'mutual_group_network_aggregate';
  aggregate?: Maybe<Mutual_Group_Network_Aggregate_Fields>;
  nodes: Array<Mutual_Group_Network>;
};

/** aggregate fields of "mutual_group_network" */
export type Mutual_Group_Network_Aggregate_Fields = {
  __typename?: 'mutual_group_network_aggregate_fields';
  avg?: Maybe<Mutual_Group_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Network_Max_Fields>;
  min?: Maybe<Mutual_Group_Network_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Network_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Network_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Network_Variance_Fields>;
};


/** aggregate fields of "mutual_group_network" */
export type Mutual_Group_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mutual_group_network" */
export type Mutual_Group_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Mutual_Group_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mutual_Group_Network_Max_Order_By>;
  min?: InputMaybe<Mutual_Group_Network_Min_Order_By>;
  stddev?: InputMaybe<Mutual_Group_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mutual_Group_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mutual_Group_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mutual_Group_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Mutual_Group_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mutual_Group_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Mutual_Group_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mutual_group_network" */
export type Mutual_Group_Network_Arr_Rel_Insert_Input = {
  data: Array<Mutual_Group_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Mutual_Group_Network_Avg_Fields = {
  __typename?: 'mutual_group_network_avg_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mutual_group_network". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Network_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Network_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  mutual_group?: InputMaybe<Mutual_Group_Bool_Exp>;
  mutual_group_id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group_network" */
export enum Mutual_Group_Network_Constraint {
  /** unique or primary key constraint on columns "network_id", "mutual_group_id" */
  MutualGroupNetworkNetworkIdMutualGroupId_51f8b9abUniq = 'mutual_group_network_network_id_mutual_group_id_51f8b9ab_uniq',
  /** unique or primary key constraint on columns "id" */
  MutualGroupNetworkPkey = 'mutual_group_network_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group_network" */
export type Mutual_Group_Network_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutual_group_network" */
export type Mutual_Group_Network_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  mutual_group?: InputMaybe<Mutual_Group_Obj_Rel_Insert_Input>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Mutual_Group_Network_Max_Fields = {
  __typename?: 'mutual_group_network_max_fields';
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mutual_Group_Network_Min_Fields = {
  __typename?: 'mutual_group_network_min_fields';
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mutual_group_network" */
export type Mutual_Group_Network_Mutation_Response = {
  __typename?: 'mutual_group_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group_Network>;
};

/** on_conflict condition type for table "mutual_group_network" */
export type Mutual_Group_Network_On_Conflict = {
  constraint: Mutual_Group_Network_Constraint;
  update_columns?: Array<Mutual_Group_Network_Update_Column>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group_network". */
export type Mutual_Group_Network_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group?: InputMaybe<Mutual_Group_Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group_network */
export type Mutual_Group_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "mutual_group_network" */
export enum Mutual_Group_Network_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  NetworkId = 'network_id'
}

/** input type for updating data in table "mutual_group_network" */
export type Mutual_Group_Network_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Network_Stddev_Fields = {
  __typename?: 'mutual_group_network_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Network_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_network_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Network_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_network_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mutual_group_network" */
export type Mutual_Group_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Network_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Mutual_Group_Network_Sum_Fields = {
  __typename?: 'mutual_group_network_sum_fields';
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "mutual_group_network" */
export enum Mutual_Group_Network_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  NetworkId = 'network_id'
}

export type Mutual_Group_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Network_Set_Input>;
  where: Mutual_Group_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Network_Var_Pop_Fields = {
  __typename?: 'mutual_group_network_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Network_Var_Samp_Fields = {
  __typename?: 'mutual_group_network_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mutual_Group_Network_Variance_Fields = {
  __typename?: 'mutual_group_network_variance_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "mutual_group" */
export type Mutual_Group_Obj_Rel_Insert_Input = {
  data: Mutual_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_On_Conflict>;
};

/** on_conflict condition type for table "mutual_group" */
export type Mutual_Group_On_Conflict = {
  constraint: Mutual_Group_Constraint;
  update_columns?: Array<Mutual_Group_Update_Column>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group". */
export type Mutual_Group_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Department_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  mutual_group_memberships_aggregate?: InputMaybe<Mutual_Group_Membership_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Mutual_Group_Network_Aggregate_Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  region?: InputMaybe<Region_Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group */
export type Mutual_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "mutual_group_role" */
export type Mutual_Group_Role = {
  __typename?: 'mutual_group_role';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An array relationship */
  mutual_group_memberships: Array<Mutual_Group_Membership>;
  /** An aggregate relationship */
  mutual_group_memberships_aggregate: Mutual_Group_Membership_Aggregate;
  name: Scalars['String'];
};


/** columns and relationships of "mutual_group_role" */
export type Mutual_Group_RoleMutual_Group_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


/** columns and relationships of "mutual_group_role" */
export type Mutual_Group_RoleMutual_Group_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};

/** aggregated selection of "mutual_group_role" */
export type Mutual_Group_Role_Aggregate = {
  __typename?: 'mutual_group_role_aggregate';
  aggregate?: Maybe<Mutual_Group_Role_Aggregate_Fields>;
  nodes: Array<Mutual_Group_Role>;
};

/** aggregate fields of "mutual_group_role" */
export type Mutual_Group_Role_Aggregate_Fields = {
  __typename?: 'mutual_group_role_aggregate_fields';
  avg?: Maybe<Mutual_Group_Role_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Role_Max_Fields>;
  min?: Maybe<Mutual_Group_Role_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Role_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Role_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Role_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Role_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Role_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Role_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Role_Variance_Fields>;
};


/** aggregate fields of "mutual_group_role" */
export type Mutual_Group_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mutual_Group_Role_Avg_Fields = {
  __typename?: 'mutual_group_role_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mutual_group_role". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Role_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Role_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Role_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group_role" */
export enum Mutual_Group_Role_Constraint {
  /** unique or primary key constraint on columns "codename" */
  MutualGroupRoleCodenameKey = 'mutual_group_role_codename_key',
  /** unique or primary key constraint on columns "id" */
  MutualGroupRolePkey = 'mutual_group_role_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group_role" */
export type Mutual_Group_Role_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutual_group_role" */
export type Mutual_Group_Role_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Mutual_Group_Role_Max_Fields = {
  __typename?: 'mutual_group_role_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mutual_Group_Role_Min_Fields = {
  __typename?: 'mutual_group_role_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "mutual_group_role" */
export type Mutual_Group_Role_Mutation_Response = {
  __typename?: 'mutual_group_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group_Role>;
};

/** input type for inserting object relation for remote table "mutual_group_role" */
export type Mutual_Group_Role_Obj_Rel_Insert_Input = {
  data: Mutual_Group_Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_Role_On_Conflict>;
};

/** on_conflict condition type for table "mutual_group_role" */
export type Mutual_Group_Role_On_Conflict = {
  constraint: Mutual_Group_Role_Constraint;
  update_columns?: Array<Mutual_Group_Role_Update_Column>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group_role". */
export type Mutual_Group_Role_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mutual_group_memberships_aggregate?: InputMaybe<Mutual_Group_Membership_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group_role */
export type Mutual_Group_Role_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "mutual_group_role" */
export enum Mutual_Group_Role_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "mutual_group_role" */
export type Mutual_Group_Role_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Role_Stddev_Fields = {
  __typename?: 'mutual_group_role_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Role_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_role_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Role_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_role_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mutual_group_role" */
export type Mutual_Group_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Role_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mutual_Group_Role_Sum_Fields = {
  __typename?: 'mutual_group_role_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "mutual_group_role" */
export enum Mutual_Group_Role_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Mutual_Group_Role_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Role_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Role_Set_Input>;
  where: Mutual_Group_Role_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Role_Var_Pop_Fields = {
  __typename?: 'mutual_group_role_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Role_Var_Samp_Fields = {
  __typename?: 'mutual_group_role_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mutual_Group_Role_Variance_Fields = {
  __typename?: 'mutual_group_role_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** select columns of table "mutual_group" */
export enum Mutual_Group_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "mutual_group" */
export type Mutual_Group_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Stddev_Fields = {
  __typename?: 'mutual_group_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mutual_group" */
export type Mutual_Group_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mutual_group" */
export type Mutual_Group_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mutual_group" */
export type Mutual_Group_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mutual_group" */
export type Mutual_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package = {
  __typename?: 'mutual_group_subscription_package';
  /** An object relationship */
  article_subscription_package: Article_Subscription_Package;
  group_id: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  mutual_group: Array<Mutual_Group>;
  shared_group_id?: Maybe<Scalars['bigint']>;
  subscription_package_id: Scalars['uuid'];
  valid_from?: Maybe<Scalars['date']>;
  valid_to?: Maybe<Scalars['date']>;
};


/** columns and relationships of "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_PackageMutual_GroupArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp_Remote_Rel_Mutual_Group_Subscription_Packagemutual_Group>;
};

/** aggregated selection of "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Aggregate = {
  __typename?: 'mutual_group_subscription_package_aggregate';
  aggregate?: Maybe<Mutual_Group_Subscription_Package_Aggregate_Fields>;
  nodes: Array<Mutual_Group_Subscription_Package>;
};

/** aggregate fields of "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Aggregate_Fields = {
  __typename?: 'mutual_group_subscription_package_aggregate_fields';
  avg?: Maybe<Mutual_Group_Subscription_Package_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Subscription_Package_Max_Fields>;
  min?: Maybe<Mutual_Group_Subscription_Package_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Subscription_Package_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Subscription_Package_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Subscription_Package_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Subscription_Package_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Subscription_Package_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Subscription_Package_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Subscription_Package_Variance_Fields>;
};


/** aggregate fields of "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Subscription_Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Aggregate_Order_By = {
  avg?: InputMaybe<Mutual_Group_Subscription_Package_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mutual_Group_Subscription_Package_Max_Order_By>;
  min?: InputMaybe<Mutual_Group_Subscription_Package_Min_Order_By>;
  stddev?: InputMaybe<Mutual_Group_Subscription_Package_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mutual_Group_Subscription_Package_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mutual_Group_Subscription_Package_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mutual_Group_Subscription_Package_Sum_Order_By>;
  var_pop?: InputMaybe<Mutual_Group_Subscription_Package_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mutual_Group_Subscription_Package_Var_Samp_Order_By>;
  variance?: InputMaybe<Mutual_Group_Subscription_Package_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Arr_Rel_Insert_Input = {
  data: Array<Mutual_Group_Subscription_Package_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_Subscription_Package_On_Conflict>;
};

/** aggregate avg on columns */
export type Mutual_Group_Subscription_Package_Avg_Fields = {
  __typename?: 'mutual_group_subscription_package_avg_fields';
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Avg_Order_By = {
  shared_group_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mutual_group_subscription_package". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Subscription_Package_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Subscription_Package_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Subscription_Package_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Subscription_Package_Bool_Exp>>;
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
  group_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  shared_group_id?: InputMaybe<Bigint_Comparison_Exp>;
  subscription_package_id?: InputMaybe<Uuid_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group_subscription_package" */
export enum Mutual_Group_Subscription_Package_Constraint {
  /** unique or primary key constraint on columns "group_id", "subscription_package_id" */
  MutualGroupSubscriptioSubscriptionPackageIdA82d621bUniq = 'mutual_group_subscriptio_subscription_package_id__a82d621b_uniq',
  /** unique or primary key constraint on columns "id" */
  MutualGroupSubscriptionPackagePkey = 'mutual_group_subscription_package_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Inc_Input = {
  shared_group_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Insert_Input = {
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Mutual_Group_Subscription_Package_Max_Fields = {
  __typename?: 'mutual_group_subscription_package_max_fields';
  group_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
  subscription_package_id?: Maybe<Scalars['uuid']>;
  valid_from?: Maybe<Scalars['date']>;
  valid_to?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Max_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mutual_Group_Subscription_Package_Min_Fields = {
  __typename?: 'mutual_group_subscription_package_min_fields';
  group_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
  subscription_package_id?: Maybe<Scalars['uuid']>;
  valid_from?: Maybe<Scalars['date']>;
  valid_to?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Min_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Mutation_Response = {
  __typename?: 'mutual_group_subscription_package_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group_Subscription_Package>;
};

/** on_conflict condition type for table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_On_Conflict = {
  constraint: Mutual_Group_Subscription_Package_Constraint;
  update_columns?: Array<Mutual_Group_Subscription_Package_Update_Column>;
  where?: InputMaybe<Mutual_Group_Subscription_Package_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group_subscription_package". */
export type Mutual_Group_Subscription_Package_Order_By = {
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group_subscription_package */
export type Mutual_Group_Subscription_Package_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "mutual_group_subscription_package" */
export enum Mutual_Group_Subscription_Package_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SharedGroupId = 'shared_group_id',
  /** column name */
  SubscriptionPackageId = 'subscription_package_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** input type for updating data in table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Set_Input = {
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Subscription_Package_Stddev_Fields = {
  __typename?: 'mutual_group_subscription_package_stddev_fields';
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Stddev_Order_By = {
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Subscription_Package_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_subscription_package_stddev_pop_fields';
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Stddev_Pop_Order_By = {
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Subscription_Package_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_subscription_package_stddev_samp_fields';
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Stddev_Samp_Order_By = {
  shared_group_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Subscription_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Subscription_Package_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Mutual_Group_Subscription_Package_Sum_Fields = {
  __typename?: 'mutual_group_subscription_package_sum_fields';
  shared_group_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Sum_Order_By = {
  shared_group_id?: InputMaybe<Order_By>;
};

/** update columns of table "mutual_group_subscription_package" */
export enum Mutual_Group_Subscription_Package_Update_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SharedGroupId = 'shared_group_id',
  /** column name */
  SubscriptionPackageId = 'subscription_package_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

export type Mutual_Group_Subscription_Package_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Subscription_Package_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Subscription_Package_Set_Input>;
  where: Mutual_Group_Subscription_Package_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Subscription_Package_Var_Pop_Fields = {
  __typename?: 'mutual_group_subscription_package_var_pop_fields';
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Var_Pop_Order_By = {
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Subscription_Package_Var_Samp_Fields = {
  __typename?: 'mutual_group_subscription_package_var_samp_fields';
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Var_Samp_Order_By = {
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mutual_Group_Subscription_Package_Variance_Fields = {
  __typename?: 'mutual_group_subscription_package_variance_fields';
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mutual_group_subscription_package" */
export type Mutual_Group_Subscription_Package_Variance_Order_By = {
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mutual_Group_Sum_Fields = {
  __typename?: 'mutual_group_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "mutual_group" */
export type Mutual_Group_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "mutual_group" */
export enum Mutual_Group_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Mutual_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Set_Input>;
  where: Mutual_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Var_Pop_Fields = {
  __typename?: 'mutual_group_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mutual_group" */
export type Mutual_Group_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Var_Samp_Fields = {
  __typename?: 'mutual_group_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mutual_group" */
export type Mutual_Group_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mutual_Group_Variance_Fields = {
  __typename?: 'mutual_group_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mutual_group" */
export type Mutual_Group_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station = {
  __typename?: 'mutual_group_weather_station';
  /** An object relationship */
  base_user?: Maybe<Base_User>;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  department?: Maybe<Department>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_public: Scalars['Boolean'];
  location_text?: Maybe<Scalars['String']>;
  /** An object relationship */
  mutual_group?: Maybe<Mutual_Group>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
  weather_station_id: Scalars['String'];
};

/** aggregated selection of "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Aggregate = {
  __typename?: 'mutual_group_weather_station_aggregate';
  aggregate?: Maybe<Mutual_Group_Weather_Station_Aggregate_Fields>;
  nodes: Array<Mutual_Group_Weather_Station>;
};

/** aggregate fields of "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Aggregate_Fields = {
  __typename?: 'mutual_group_weather_station_aggregate_fields';
  avg?: Maybe<Mutual_Group_Weather_Station_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Weather_Station_Max_Fields>;
  min?: Maybe<Mutual_Group_Weather_Station_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Weather_Station_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Weather_Station_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Weather_Station_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Weather_Station_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Weather_Station_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Weather_Station_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Weather_Station_Variance_Fields>;
};


/** aggregate fields of "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Weather_Station_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mutual_Group_Weather_Station_Avg_Fields = {
  __typename?: 'mutual_group_weather_station_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mutual_group_weather_station". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Weather_Station_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Weather_Station_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Weather_Station_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_public?: InputMaybe<Boolean_Comparison_Exp>;
  location_text?: InputMaybe<String_Comparison_Exp>;
  mutual_group?: InputMaybe<Mutual_Group_Bool_Exp>;
  mutual_group_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  weather_station_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group_weather_station" */
export enum Mutual_Group_Weather_Station_Constraint {
  /** unique or primary key constraint on columns "weather_station_id", "mutual_group_id" */
  MutualGroupWeatherStaWeatherStationIdMutua_250bb7deUniq = 'mutual_group_weather_sta_weather_station_id_mutua_250bb7de_uniq',
  /** unique or primary key constraint on columns "weather_station_id", "network_id" */
  MutualGroupWeatherStaWeatherStationIdNetwo_0849e1eaUniq = 'mutual_group_weather_sta_weather_station_id_netwo_0849e1ea_uniq',
  /** unique or primary key constraint on columns "id" */
  MutualGroupWeatherStationPkey = 'mutual_group_weather_station_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  location_text?: InputMaybe<Scalars['String']>;
  mutual_group?: InputMaybe<Mutual_Group_Obj_Rel_Insert_Input>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  network_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  weather_station_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Mutual_Group_Weather_Station_Max_Fields = {
  __typename?: 'mutual_group_weather_station_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location_text?: Maybe<Scalars['String']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  weather_station_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mutual_Group_Weather_Station_Min_Fields = {
  __typename?: 'mutual_group_weather_station_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location_text?: Maybe<Scalars['String']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  weather_station_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Mutation_Response = {
  __typename?: 'mutual_group_weather_station_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group_Weather_Station>;
};

/** on_conflict condition type for table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_On_Conflict = {
  constraint: Mutual_Group_Weather_Station_Constraint;
  update_columns?: Array<Mutual_Group_Weather_Station_Update_Column>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group_weather_station". */
export type Mutual_Group_Weather_Station_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Department_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_public?: InputMaybe<Order_By>;
  location_text?: InputMaybe<Order_By>;
  mutual_group?: InputMaybe<Mutual_Group_Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group_weather_station */
export type Mutual_Group_Weather_Station_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "mutual_group_weather_station" */
export enum Mutual_Group_Weather_Station_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  LocationText = 'location_text',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WeatherStationId = 'weather_station_id'
}

/** input type for updating data in table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  location_text?: InputMaybe<Scalars['String']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  network_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  weather_station_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Weather_Station_Stddev_Fields = {
  __typename?: 'mutual_group_weather_station_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Weather_Station_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_weather_station_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Weather_Station_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_weather_station_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Weather_Station_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Weather_Station_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  location_text?: InputMaybe<Scalars['String']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  network_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  weather_station_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mutual_Group_Weather_Station_Sum_Fields = {
  __typename?: 'mutual_group_weather_station_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "mutual_group_weather_station" */
export enum Mutual_Group_Weather_Station_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  LocationText = 'location_text',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WeatherStationId = 'weather_station_id'
}

export type Mutual_Group_Weather_Station_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Weather_Station_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Weather_Station_Set_Input>;
  where: Mutual_Group_Weather_Station_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Weather_Station_Var_Pop_Fields = {
  __typename?: 'mutual_group_weather_station_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Weather_Station_Var_Samp_Fields = {
  __typename?: 'mutual_group_weather_station_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mutual_Group_Weather_Station_Variance_Fields = {
  __typename?: 'mutual_group_weather_station_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "network" */
export type Network = {
  __typename?: 'network';
  /** An array relationship */
  business_groups: Array<Business_Group_Network>;
  /** An aggregate relationship */
  business_groups_aggregate: Business_Group_Network_Aggregate;
  /** An array relationship */
  businesses: Array<Business_Network>;
  /** An aggregate relationship */
  businesses_aggregate: Business_Network_Aggregate;
  codename: Scalars['String'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  description: Scalars['String'];
  /** An array relationship */
  farms: Array<Farm_Network>;
  /** An aggregate relationship */
  farms_aggregate: Farm_Network_Aggregate;
  /** An array relationship */
  fields: Array<Field_Network>;
  /** An aggregate relationship */
  fields_aggregate: Field_Network_Aggregate;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An array relationship */
  mutual_groups: Array<Mutual_Group_Network>;
  /** An aggregate relationship */
  mutual_groups_aggregate: Mutual_Group_Network_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  plot_crop_networks: Array<Plot_Crop_Network>;
  /** An aggregate relationship */
  plot_crop_networks_aggregate: Plot_Crop_Network_Aggregate;
  /** An array relationship */
  plots: Array<Plot_Network>;
  /** An aggregate relationship */
  plots_aggregate: Plot_Network_Aggregate;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "network" */
export type NetworkBusiness_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkBusiness_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkBusinessesArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkBusinesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkFarmsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkFarms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkFieldsArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkMutual_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkMutual_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkPlot_Crop_NetworksArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkPlot_Crop_Networks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkPlotsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkPlots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};

/** aggregated selection of "network" */
export type Network_Aggregate = {
  __typename?: 'network_aggregate';
  aggregate?: Maybe<Network_Aggregate_Fields>;
  nodes: Array<Network>;
};

/** aggregate fields of "network" */
export type Network_Aggregate_Fields = {
  __typename?: 'network_aggregate_fields';
  avg?: Maybe<Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Network_Max_Fields>;
  min?: Maybe<Network_Min_Fields>;
  stddev?: Maybe<Network_Stddev_Fields>;
  stddev_pop?: Maybe<Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Network_Stddev_Samp_Fields>;
  sum?: Maybe<Network_Sum_Fields>;
  var_pop?: Maybe<Network_Var_Pop_Fields>;
  var_samp?: Maybe<Network_Var_Samp_Fields>;
  variance?: Maybe<Network_Variance_Fields>;
};


/** aggregate fields of "network" */
export type Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "network" */
export type Network_Aggregate_Order_By = {
  avg?: InputMaybe<Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Network_Max_Order_By>;
  min?: InputMaybe<Network_Min_Order_By>;
  stddev?: InputMaybe<Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Network_Sum_Order_By>;
  var_pop?: InputMaybe<Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "network" */
export type Network_Arr_Rel_Insert_Input = {
  data: Array<Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Network_Avg_Fields = {
  __typename?: 'network_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "network" */
export type Network_Avg_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "network". All fields are combined with a logical 'AND'. */
export type Network_Bool_Exp = {
  _and?: InputMaybe<Array<Network_Bool_Exp>>;
  _not?: InputMaybe<Network_Bool_Exp>;
  _or?: InputMaybe<Array<Network_Bool_Exp>>;
  business_groups?: InputMaybe<Business_Group_Network_Bool_Exp>;
  businesses?: InputMaybe<Business_Network_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Network_Bool_Exp>;
  fields?: InputMaybe<Field_Network_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_groups?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  plot_crop_networks?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  plots?: InputMaybe<Plot_Network_Bool_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_till?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "network" */
export enum Network_Constraint {
  /** unique or primary key constraint on columns "codename" */
  NetworkCodenameKey = 'network_codename_key',
  /** unique or primary key constraint on columns "name", "valid_till", "valid_from", "company_id" */
  NetworkNameCompanyIdValidFromValidTill_012f49eaUniq = 'network_name_company_id_valid_from_valid_till_012f49ea_uniq',
  /** unique or primary key constraint on columns "id" */
  NetworkPkey = 'network_pkey'
}

/** input type for incrementing numeric columns in table "network" */
export type Network_Inc_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "network" */
export type Network_Insert_Input = {
  business_groups?: InputMaybe<Business_Group_Network_Arr_Rel_Insert_Input>;
  businesses?: InputMaybe<Business_Network_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farms?: InputMaybe<Farm_Network_Arr_Rel_Insert_Input>;
  fields?: InputMaybe<Field_Network_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_groups?: InputMaybe<Mutual_Group_Network_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  plot_crop_networks?: InputMaybe<Plot_Crop_Network_Arr_Rel_Insert_Input>;
  plots?: InputMaybe<Plot_Network_Arr_Rel_Insert_Input>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Network_Max_Fields = {
  __typename?: 'network_max_fields';
  codename?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "network" */
export type Network_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Network_Min_Fields = {
  __typename?: 'network_min_fields';
  codename?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "network" */
export type Network_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "network" */
export type Network_Mutation_Response = {
  __typename?: 'network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Network>;
};

/** input type for inserting object relation for remote table "network" */
export type Network_Obj_Rel_Insert_Input = {
  data: Network_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Network_On_Conflict>;
};

/** on_conflict condition type for table "network" */
export type Network_On_Conflict = {
  constraint: Network_Constraint;
  update_columns?: Array<Network_Update_Column>;
  where?: InputMaybe<Network_Bool_Exp>;
};

/** Ordering options when selecting data from "network". */
export type Network_Order_By = {
  business_groups_aggregate?: InputMaybe<Business_Group_Network_Aggregate_Order_By>;
  businesses_aggregate?: InputMaybe<Business_Network_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farms_aggregate?: InputMaybe<Farm_Network_Aggregate_Order_By>;
  fields_aggregate?: InputMaybe<Field_Network_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mutual_groups_aggregate?: InputMaybe<Mutual_Group_Network_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  plot_crop_networks_aggregate?: InputMaybe<Plot_Crop_Network_Aggregate_Order_By>;
  plots_aggregate?: InputMaybe<Plot_Network_Aggregate_Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
};

/** primary key columns input for table: network */
export type Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "network" */
export enum Network_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till'
}

/** input type for updating data in table "network" */
export type Network_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Network_Stddev_Fields = {
  __typename?: 'network_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "network" */
export type Network_Stddev_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Network_Stddev_Pop_Fields = {
  __typename?: 'network_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "network" */
export type Network_Stddev_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Network_Stddev_Samp_Fields = {
  __typename?: 'network_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "network" */
export type Network_Stddev_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "network" */
export type Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Network_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Network_Sum_Fields = {
  __typename?: 'network_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "network" */
export type Network_Sum_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "network" */
export enum Network_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till'
}

export type Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Network_Set_Input>;
  where: Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Network_Var_Pop_Fields = {
  __typename?: 'network_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "network" */
export type Network_Var_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Network_Var_Samp_Fields = {
  __typename?: 'network_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "network" */
export type Network_Var_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Network_Variance_Fields = {
  __typename?: 'network_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "network" */
export type Network_Variance_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification" */
export type Notification = {
  __typename?: 'notification';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_seen: Scalars['Boolean'];
  /** An object relationship */
  notification_template: Notification_Template;
  receiver: Array<Base_User>;
  receiver_id: Scalars['String'];
  record_id?: Maybe<Scalars['String']>;
  sender: Array<Base_User>;
  sender_id: Scalars['String'];
  sent_at?: Maybe<Scalars['timestamptz']>;
  template_id: Scalars['uuid'];
  title: Scalars['String'];
};


/** columns and relationships of "notification" */
export type NotificationReceiverArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Notificationreceiver>;
};


/** columns and relationships of "notification" */
export type NotificationSenderArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Notificationsender>;
};

/** aggregated selection of "notification" */
export type Notification_Aggregate = {
  __typename?: 'notification_aggregate';
  aggregate?: Maybe<Notification_Aggregate_Fields>;
  nodes: Array<Notification>;
};

/** aggregate fields of "notification" */
export type Notification_Aggregate_Fields = {
  __typename?: 'notification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Max_Fields>;
  min?: Maybe<Notification_Min_Fields>;
};


/** aggregate fields of "notification" */
export type Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification" */
export type Notification_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Max_Order_By>;
  min?: InputMaybe<Notification_Min_Order_By>;
};

/** input type for inserting array relation for remote table "notification" */
export type Notification_Arr_Rel_Insert_Input = {
  data: Array<Notification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_On_Conflict>;
};

/** Boolean expression to filter rows from the table "notification". All fields are combined with a logical 'AND'. */
export type Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Bool_Exp>>;
  _not?: InputMaybe<Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_seen?: InputMaybe<Boolean_Comparison_Exp>;
  notification_template?: InputMaybe<Notification_Template_Bool_Exp>;
  receiver_id?: InputMaybe<String_Comparison_Exp>;
  record_id?: InputMaybe<String_Comparison_Exp>;
  sender_id?: InputMaybe<String_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  template_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "notification_category" */
export type Notification_Category = {
  __typename?: 'notification_category';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** aggregated selection of "notification_category" */
export type Notification_Category_Aggregate = {
  __typename?: 'notification_category_aggregate';
  aggregate?: Maybe<Notification_Category_Aggregate_Fields>;
  nodes: Array<Notification_Category>;
};

/** aggregate fields of "notification_category" */
export type Notification_Category_Aggregate_Fields = {
  __typename?: 'notification_category_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Category_Max_Fields>;
  min?: Maybe<Notification_Category_Min_Fields>;
};


/** aggregate fields of "notification_category" */
export type Notification_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_category". All fields are combined with a logical 'AND'. */
export type Notification_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Category_Bool_Exp>>;
  _not?: InputMaybe<Notification_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Category_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_category" */
export enum Notification_Category_Constraint {
  /** unique or primary key constraint on columns "name" */
  NotificationCategoryNameKey = 'notification_category_name_key',
  /** unique or primary key constraint on columns "id" */
  NotificationCategoryPkey = 'notification_category_pkey'
}

/** input type for inserting data into table "notification_category" */
export type Notification_Category_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_Category_Max_Fields = {
  __typename?: 'notification_category_max_fields';
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_Category_Min_Fields = {
  __typename?: 'notification_category_min_fields';
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_category" */
export type Notification_Category_Mutation_Response = {
  __typename?: 'notification_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Category>;
};

/** input type for inserting object relation for remote table "notification_category" */
export type Notification_Category_Obj_Rel_Insert_Input = {
  data: Notification_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Category_On_Conflict>;
};

/** on_conflict condition type for table "notification_category" */
export type Notification_Category_On_Conflict = {
  constraint: Notification_Category_Constraint;
  update_columns?: Array<Notification_Category_Update_Column>;
  where?: InputMaybe<Notification_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_category". */
export type Notification_Category_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_category */
export type Notification_Category_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "notification_category" */
export enum Notification_Category_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "notification_category" */
export type Notification_Category_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_category" */
export type Notification_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Category_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_category" */
export enum Notification_Category_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name'
}

export type Notification_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Category_Set_Input>;
  where: Notification_Category_Bool_Exp;
};

/** unique or primary key constraints on table "notification" */
export enum Notification_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationPkey = 'notification_pkey',
  /** unique or primary key constraint on columns "receiver_id", "sent_at" */
  NotificationReceiverIdSentAtA4f3e157Uniq = 'notification_receiver_id_sent_at_a4f3e157_uniq'
}

/** input type for inserting data into table "notification" */
export type Notification_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_seen?: InputMaybe<Scalars['Boolean']>;
  notification_template?: InputMaybe<Notification_Template_Obj_Rel_Insert_Input>;
  receiver_id?: InputMaybe<Scalars['String']>;
  record_id?: InputMaybe<Scalars['String']>;
  sender_id?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  template_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_Max_Fields = {
  __typename?: 'notification_max_fields';
  id?: Maybe<Scalars['uuid']>;
  receiver_id?: Maybe<Scalars['String']>;
  record_id?: Maybe<Scalars['String']>;
  sender_id?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  template_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "notification" */
export type Notification_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  record_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notification_Min_Fields = {
  __typename?: 'notification_min_fields';
  id?: Maybe<Scalars['uuid']>;
  receiver_id?: Maybe<Scalars['String']>;
  record_id?: Maybe<Scalars['String']>;
  sender_id?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  template_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "notification" */
export type Notification_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  record_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification" */
export type Notification_Mutation_Response = {
  __typename?: 'notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification>;
};

/** on_conflict condition type for table "notification" */
export type Notification_On_Conflict = {
  constraint: Notification_Constraint;
  update_columns?: Array<Notification_Update_Column>;
  where?: InputMaybe<Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "notification". */
export type Notification_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_seen?: InputMaybe<Order_By>;
  notification_template?: InputMaybe<Notification_Template_Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  record_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification */
export type Notification_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "notification" */
export enum Notification_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSeen = 'is_seen',
  /** column name */
  ReceiverId = 'receiver_id',
  /** column name */
  RecordId = 'record_id',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "notification" */
export type Notification_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_seen?: InputMaybe<Scalars['Boolean']>;
  receiver_id?: InputMaybe<Scalars['String']>;
  record_id?: InputMaybe<Scalars['String']>;
  sender_id?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  template_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification" */
export type Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_seen?: InputMaybe<Scalars['Boolean']>;
  receiver_id?: InputMaybe<Scalars['String']>;
  record_id?: InputMaybe<Scalars['String']>;
  sender_id?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  template_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "notification_template" */
export type Notification_Template = {
  __typename?: 'notification_template';
  body?: Maybe<Scalars['String']>;
  broadcast_datetime: Scalars['timestamptz'];
  broadcaster_id: Scalars['String'];
  category_id: Scalars['uuid'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  feature_image?: Maybe<Fileupload>;
  feature_image_id?: Maybe<Scalars['bigint']>;
  feature_image_url?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  notification_category: Notification_Category;
  /** An array relationship */
  notifications: Array<Notification>;
  /** An aggregate relationship */
  notifications_aggregate: Notification_Aggregate;
  record_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  regions: Array<Notification_Template_Distribution_Region>;
  /** An aggregate relationship */
  regions_aggregate: Notification_Template_Distribution_Region_Aggregate;
  /** An object relationship */
  shared_broadcaster?: Maybe<Shared_Entity>;
  shared_broadcaster_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  teams: Array<Notification_Template_Distribution_Team>;
  /** An aggregate relationship */
  teams_aggregate: Notification_Template_Distribution_Team_Aggregate;
  title: Scalars['String'];
  /** An array relationship */
  users: Array<Notification_Template_Distribution_User>;
  /** An aggregate relationship */
  users_aggregate: Notification_Template_Distribution_User_Aggregate;
};


/** columns and relationships of "notification_template" */
export type Notification_TemplateNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


/** columns and relationships of "notification_template" */
export type Notification_TemplateNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


/** columns and relationships of "notification_template" */
export type Notification_TemplateRegionsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Region_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Region_Bool_Exp>;
};


/** columns and relationships of "notification_template" */
export type Notification_TemplateRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Region_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Region_Bool_Exp>;
};


/** columns and relationships of "notification_template" */
export type Notification_TemplateTeamsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Team_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Team_Bool_Exp>;
};


/** columns and relationships of "notification_template" */
export type Notification_TemplateTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Team_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Team_Bool_Exp>;
};


/** columns and relationships of "notification_template" */
export type Notification_TemplateUsersArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_User_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_User_Bool_Exp>;
};


/** columns and relationships of "notification_template" */
export type Notification_TemplateUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_User_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_User_Bool_Exp>;
};

/** aggregated selection of "notification_template" */
export type Notification_Template_Aggregate = {
  __typename?: 'notification_template_aggregate';
  aggregate?: Maybe<Notification_Template_Aggregate_Fields>;
  nodes: Array<Notification_Template>;
};

/** aggregate fields of "notification_template" */
export type Notification_Template_Aggregate_Fields = {
  __typename?: 'notification_template_aggregate_fields';
  avg?: Maybe<Notification_Template_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notification_Template_Max_Fields>;
  min?: Maybe<Notification_Template_Min_Fields>;
  stddev?: Maybe<Notification_Template_Stddev_Fields>;
  stddev_pop?: Maybe<Notification_Template_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notification_Template_Stddev_Samp_Fields>;
  sum?: Maybe<Notification_Template_Sum_Fields>;
  var_pop?: Maybe<Notification_Template_Var_Pop_Fields>;
  var_samp?: Maybe<Notification_Template_Var_Samp_Fields>;
  variance?: Maybe<Notification_Template_Variance_Fields>;
};


/** aggregate fields of "notification_template" */
export type Notification_Template_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Notification_Template_Avg_Fields = {
  __typename?: 'notification_template_avg_fields';
  feature_image_id?: Maybe<Scalars['Float']>;
  shared_broadcaster_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_template". All fields are combined with a logical 'AND'. */
export type Notification_Template_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Template_Bool_Exp>>;
  _not?: InputMaybe<Notification_Template_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Template_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  broadcast_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  broadcaster_id?: InputMaybe<String_Comparison_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  feature_image?: InputMaybe<Fileupload_Bool_Exp>;
  feature_image_id?: InputMaybe<Bigint_Comparison_Exp>;
  feature_image_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  notification_category?: InputMaybe<Notification_Category_Bool_Exp>;
  notifications?: InputMaybe<Notification_Bool_Exp>;
  record_id?: InputMaybe<String_Comparison_Exp>;
  regions?: InputMaybe<Notification_Template_Distribution_Region_Bool_Exp>;
  shared_broadcaster?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_broadcaster_id?: InputMaybe<Bigint_Comparison_Exp>;
  teams?: InputMaybe<Notification_Template_Distribution_Team_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<Notification_Template_Distribution_User_Bool_Exp>;
};

/** unique or primary key constraints on table "notification_template" */
export enum Notification_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationTemplatePkey = 'notification_template_pkey'
}

/** columns and relationships of "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region = {
  __typename?: 'notification_template_distribution_region';
  id: Scalars['bigint'];
  /** An object relationship */
  notification_template: Notification_Template;
  region: Array<Region>;
  region_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  shared_region?: Maybe<Shared_Entity>;
  shared_region_id?: Maybe<Scalars['bigint']>;
  template_id: Scalars['uuid'];
};


/** columns and relationships of "notification_template_distribution_region" */
export type Notification_Template_Distribution_RegionRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp_Remote_Rel_Notification_Template_Distribution_Regionregion>;
};

/** aggregated selection of "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Aggregate = {
  __typename?: 'notification_template_distribution_region_aggregate';
  aggregate?: Maybe<Notification_Template_Distribution_Region_Aggregate_Fields>;
  nodes: Array<Notification_Template_Distribution_Region>;
};

/** aggregate fields of "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Aggregate_Fields = {
  __typename?: 'notification_template_distribution_region_aggregate_fields';
  avg?: Maybe<Notification_Template_Distribution_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notification_Template_Distribution_Region_Max_Fields>;
  min?: Maybe<Notification_Template_Distribution_Region_Min_Fields>;
  stddev?: Maybe<Notification_Template_Distribution_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Notification_Template_Distribution_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notification_Template_Distribution_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Notification_Template_Distribution_Region_Sum_Fields>;
  var_pop?: Maybe<Notification_Template_Distribution_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Notification_Template_Distribution_Region_Var_Samp_Fields>;
  variance?: Maybe<Notification_Template_Distribution_Region_Variance_Fields>;
};


/** aggregate fields of "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Template_Distribution_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Aggregate_Order_By = {
  avg?: InputMaybe<Notification_Template_Distribution_Region_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Template_Distribution_Region_Max_Order_By>;
  min?: InputMaybe<Notification_Template_Distribution_Region_Min_Order_By>;
  stddev?: InputMaybe<Notification_Template_Distribution_Region_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Notification_Template_Distribution_Region_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Notification_Template_Distribution_Region_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Notification_Template_Distribution_Region_Sum_Order_By>;
  var_pop?: InputMaybe<Notification_Template_Distribution_Region_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Notification_Template_Distribution_Region_Var_Samp_Order_By>;
  variance?: InputMaybe<Notification_Template_Distribution_Region_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Arr_Rel_Insert_Input = {
  data: Array<Notification_Template_Distribution_Region_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Template_Distribution_Region_On_Conflict>;
};

/** aggregate avg on columns */
export type Notification_Template_Distribution_Region_Avg_Fields = {
  __typename?: 'notification_template_distribution_region_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notification_template_distribution_region". All fields are combined with a logical 'AND'. */
export type Notification_Template_Distribution_Region_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Template_Distribution_Region_Bool_Exp>>;
  _not?: InputMaybe<Notification_Template_Distribution_Region_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Template_Distribution_Region_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  notification_template?: InputMaybe<Notification_Template_Bool_Exp>;
  region_id?: InputMaybe<String_Comparison_Exp>;
  shared_region?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_region_id?: InputMaybe<Bigint_Comparison_Exp>;
  template_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_template_distribution_region" */
export enum Notification_Template_Distribution_Region_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationTemplateDistributionRegionPkey = 'notification_template_distribution_region_pkey'
}

/** input type for incrementing numeric columns in table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_region_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  notification_template?: InputMaybe<Notification_Template_Obj_Rel_Insert_Input>;
  region_id?: InputMaybe<Scalars['String']>;
  shared_region?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_region_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Notification_Template_Distribution_Region_Max_Fields = {
  __typename?: 'notification_template_distribution_region_max_fields';
  id?: Maybe<Scalars['bigint']>;
  region_id?: Maybe<Scalars['String']>;
  shared_region_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notification_Template_Distribution_Region_Min_Fields = {
  __typename?: 'notification_template_distribution_region_min_fields';
  id?: Maybe<Scalars['bigint']>;
  region_id?: Maybe<Scalars['String']>;
  shared_region_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Mutation_Response = {
  __typename?: 'notification_template_distribution_region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Template_Distribution_Region>;
};

/** on_conflict condition type for table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_On_Conflict = {
  constraint: Notification_Template_Distribution_Region_Constraint;
  update_columns?: Array<Notification_Template_Distribution_Region_Update_Column>;
  where?: InputMaybe<Notification_Template_Distribution_Region_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_template_distribution_region". */
export type Notification_Template_Distribution_Region_Order_By = {
  id?: InputMaybe<Order_By>;
  notification_template?: InputMaybe<Notification_Template_Order_By>;
  region_id?: InputMaybe<Order_By>;
  shared_region?: InputMaybe<Shared_Entity_Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_template_distribution_region */
export type Notification_Template_Distribution_Region_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "notification_template_distribution_region" */
export enum Notification_Template_Distribution_Region_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SharedRegionId = 'shared_region_id',
  /** column name */
  TemplateId = 'template_id'
}

/** input type for updating data in table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  region_id?: InputMaybe<Scalars['String']>;
  shared_region_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Notification_Template_Distribution_Region_Stddev_Fields = {
  __typename?: 'notification_template_distribution_region_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Notification_Template_Distribution_Region_Stddev_Pop_Fields = {
  __typename?: 'notification_template_distribution_region_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Notification_Template_Distribution_Region_Stddev_Samp_Fields = {
  __typename?: 'notification_template_distribution_region_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Template_Distribution_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Template_Distribution_Region_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  region_id?: InputMaybe<Scalars['String']>;
  shared_region_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Notification_Template_Distribution_Region_Sum_Fields = {
  __typename?: 'notification_template_distribution_region_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_region_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** update columns of table "notification_template_distribution_region" */
export enum Notification_Template_Distribution_Region_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SharedRegionId = 'shared_region_id',
  /** column name */
  TemplateId = 'template_id'
}

export type Notification_Template_Distribution_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notification_Template_Distribution_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Template_Distribution_Region_Set_Input>;
  where: Notification_Template_Distribution_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notification_Template_Distribution_Region_Var_Pop_Fields = {
  __typename?: 'notification_template_distribution_region_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Notification_Template_Distribution_Region_Var_Samp_Fields = {
  __typename?: 'notification_template_distribution_region_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Notification_Template_Distribution_Region_Variance_Fields = {
  __typename?: 'notification_template_distribution_region_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_region_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notification_template_distribution_region" */
export type Notification_Template_Distribution_Region_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_region_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team = {
  __typename?: 'notification_template_distribution_team';
  group_id?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  /** An object relationship */
  notification_template: Notification_Template;
  /** An object relationship */
  shared_group?: Maybe<Shared_Entity>;
  shared_group_id?: Maybe<Scalars['bigint']>;
  team: Array<Mutual_Group>;
  template_id: Scalars['uuid'];
};


/** columns and relationships of "notification_template_distribution_team" */
export type Notification_Template_Distribution_TeamTeamArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp_Remote_Rel_Notification_Template_Distribution_Teamteam>;
};

/** aggregated selection of "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Aggregate = {
  __typename?: 'notification_template_distribution_team_aggregate';
  aggregate?: Maybe<Notification_Template_Distribution_Team_Aggregate_Fields>;
  nodes: Array<Notification_Template_Distribution_Team>;
};

/** aggregate fields of "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Aggregate_Fields = {
  __typename?: 'notification_template_distribution_team_aggregate_fields';
  avg?: Maybe<Notification_Template_Distribution_Team_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notification_Template_Distribution_Team_Max_Fields>;
  min?: Maybe<Notification_Template_Distribution_Team_Min_Fields>;
  stddev?: Maybe<Notification_Template_Distribution_Team_Stddev_Fields>;
  stddev_pop?: Maybe<Notification_Template_Distribution_Team_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notification_Template_Distribution_Team_Stddev_Samp_Fields>;
  sum?: Maybe<Notification_Template_Distribution_Team_Sum_Fields>;
  var_pop?: Maybe<Notification_Template_Distribution_Team_Var_Pop_Fields>;
  var_samp?: Maybe<Notification_Template_Distribution_Team_Var_Samp_Fields>;
  variance?: Maybe<Notification_Template_Distribution_Team_Variance_Fields>;
};


/** aggregate fields of "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Template_Distribution_Team_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Aggregate_Order_By = {
  avg?: InputMaybe<Notification_Template_Distribution_Team_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Template_Distribution_Team_Max_Order_By>;
  min?: InputMaybe<Notification_Template_Distribution_Team_Min_Order_By>;
  stddev?: InputMaybe<Notification_Template_Distribution_Team_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Notification_Template_Distribution_Team_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Notification_Template_Distribution_Team_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Notification_Template_Distribution_Team_Sum_Order_By>;
  var_pop?: InputMaybe<Notification_Template_Distribution_Team_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Notification_Template_Distribution_Team_Var_Samp_Order_By>;
  variance?: InputMaybe<Notification_Template_Distribution_Team_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Arr_Rel_Insert_Input = {
  data: Array<Notification_Template_Distribution_Team_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Template_Distribution_Team_On_Conflict>;
};

/** aggregate avg on columns */
export type Notification_Template_Distribution_Team_Avg_Fields = {
  __typename?: 'notification_template_distribution_team_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notification_template_distribution_team". All fields are combined with a logical 'AND'. */
export type Notification_Template_Distribution_Team_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Template_Distribution_Team_Bool_Exp>>;
  _not?: InputMaybe<Notification_Template_Distribution_Team_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Template_Distribution_Team_Bool_Exp>>;
  group_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  notification_template?: InputMaybe<Notification_Template_Bool_Exp>;
  shared_group?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_group_id?: InputMaybe<Bigint_Comparison_Exp>;
  template_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_template_distribution_team" */
export enum Notification_Template_Distribution_Team_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationTemplateDistributionTeamPkey = 'notification_template_distribution_team_pkey'
}

/** input type for incrementing numeric columns in table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Insert_Input = {
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  notification_template?: InputMaybe<Notification_Template_Obj_Rel_Insert_Input>;
  shared_group?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Notification_Template_Distribution_Team_Max_Fields = {
  __typename?: 'notification_template_distribution_team_max_fields';
  group_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Max_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notification_Template_Distribution_Team_Min_Fields = {
  __typename?: 'notification_template_distribution_team_min_fields';
  group_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Min_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Mutation_Response = {
  __typename?: 'notification_template_distribution_team_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Template_Distribution_Team>;
};

/** on_conflict condition type for table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_On_Conflict = {
  constraint: Notification_Template_Distribution_Team_Constraint;
  update_columns?: Array<Notification_Template_Distribution_Team_Update_Column>;
  where?: InputMaybe<Notification_Template_Distribution_Team_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_template_distribution_team". */
export type Notification_Template_Distribution_Team_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_template?: InputMaybe<Notification_Template_Order_By>;
  shared_group?: InputMaybe<Shared_Entity_Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_template_distribution_team */
export type Notification_Template_Distribution_Team_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "notification_template_distribution_team" */
export enum Notification_Template_Distribution_Team_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedGroupId = 'shared_group_id',
  /** column name */
  TemplateId = 'template_id'
}

/** input type for updating data in table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Set_Input = {
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Notification_Template_Distribution_Team_Stddev_Fields = {
  __typename?: 'notification_template_distribution_team_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Notification_Template_Distribution_Team_Stddev_Pop_Fields = {
  __typename?: 'notification_template_distribution_team_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Notification_Template_Distribution_Team_Stddev_Samp_Fields = {
  __typename?: 'notification_template_distribution_team_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Template_Distribution_Team_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Template_Distribution_Team_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_group_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Notification_Template_Distribution_Team_Sum_Fields = {
  __typename?: 'notification_template_distribution_team_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_group_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** update columns of table "notification_template_distribution_team" */
export enum Notification_Template_Distribution_Team_Update_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedGroupId = 'shared_group_id',
  /** column name */
  TemplateId = 'template_id'
}

export type Notification_Template_Distribution_Team_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notification_Template_Distribution_Team_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Template_Distribution_Team_Set_Input>;
  where: Notification_Template_Distribution_Team_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notification_Template_Distribution_Team_Var_Pop_Fields = {
  __typename?: 'notification_template_distribution_team_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Notification_Template_Distribution_Team_Var_Samp_Fields = {
  __typename?: 'notification_template_distribution_team_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Notification_Template_Distribution_Team_Variance_Fields = {
  __typename?: 'notification_template_distribution_team_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_group_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notification_template_distribution_team" */
export type Notification_Template_Distribution_Team_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_group_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification_template_distribution_user" */
export type Notification_Template_Distribution_User = {
  __typename?: 'notification_template_distribution_user';
  id: Scalars['bigint'];
  /** An object relationship */
  notification_template: Notification_Template;
  receiver: Array<Base_User>;
  /** An object relationship */
  shared_user?: Maybe<Shared_Entity>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  template_id: Scalars['uuid'];
  user_id: Scalars['String'];
};


/** columns and relationships of "notification_template_distribution_user" */
export type Notification_Template_Distribution_UserReceiverArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Notification_Template_Distribution_Userreceiver>;
};

/** aggregated selection of "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Aggregate = {
  __typename?: 'notification_template_distribution_user_aggregate';
  aggregate?: Maybe<Notification_Template_Distribution_User_Aggregate_Fields>;
  nodes: Array<Notification_Template_Distribution_User>;
};

/** aggregate fields of "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Aggregate_Fields = {
  __typename?: 'notification_template_distribution_user_aggregate_fields';
  avg?: Maybe<Notification_Template_Distribution_User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notification_Template_Distribution_User_Max_Fields>;
  min?: Maybe<Notification_Template_Distribution_User_Min_Fields>;
  stddev?: Maybe<Notification_Template_Distribution_User_Stddev_Fields>;
  stddev_pop?: Maybe<Notification_Template_Distribution_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notification_Template_Distribution_User_Stddev_Samp_Fields>;
  sum?: Maybe<Notification_Template_Distribution_User_Sum_Fields>;
  var_pop?: Maybe<Notification_Template_Distribution_User_Var_Pop_Fields>;
  var_samp?: Maybe<Notification_Template_Distribution_User_Var_Samp_Fields>;
  variance?: Maybe<Notification_Template_Distribution_User_Variance_Fields>;
};


/** aggregate fields of "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Template_Distribution_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Aggregate_Order_By = {
  avg?: InputMaybe<Notification_Template_Distribution_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Template_Distribution_User_Max_Order_By>;
  min?: InputMaybe<Notification_Template_Distribution_User_Min_Order_By>;
  stddev?: InputMaybe<Notification_Template_Distribution_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Notification_Template_Distribution_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Notification_Template_Distribution_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Notification_Template_Distribution_User_Sum_Order_By>;
  var_pop?: InputMaybe<Notification_Template_Distribution_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Notification_Template_Distribution_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Notification_Template_Distribution_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Arr_Rel_Insert_Input = {
  data: Array<Notification_Template_Distribution_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Template_Distribution_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Notification_Template_Distribution_User_Avg_Fields = {
  __typename?: 'notification_template_distribution_user_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notification_template_distribution_user". All fields are combined with a logical 'AND'. */
export type Notification_Template_Distribution_User_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Template_Distribution_User_Bool_Exp>>;
  _not?: InputMaybe<Notification_Template_Distribution_User_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Template_Distribution_User_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  notification_template?: InputMaybe<Notification_Template_Bool_Exp>;
  shared_user?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  template_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_template_distribution_user" */
export enum Notification_Template_Distribution_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationTemplateDistributionUserPkey = 'notification_template_distribution_user_pkey'
}

/** input type for incrementing numeric columns in table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  notification_template?: InputMaybe<Notification_Template_Obj_Rel_Insert_Input>;
  shared_user?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_Template_Distribution_User_Max_Fields = {
  __typename?: 'notification_template_distribution_user_max_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notification_Template_Distribution_User_Min_Fields = {
  __typename?: 'notification_template_distribution_user_min_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Mutation_Response = {
  __typename?: 'notification_template_distribution_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Template_Distribution_User>;
};

/** on_conflict condition type for table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_On_Conflict = {
  constraint: Notification_Template_Distribution_User_Constraint;
  update_columns?: Array<Notification_Template_Distribution_User_Update_Column>;
  where?: InputMaybe<Notification_Template_Distribution_User_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_template_distribution_user". */
export type Notification_Template_Distribution_User_Order_By = {
  id?: InputMaybe<Order_By>;
  notification_template?: InputMaybe<Notification_Template_Order_By>;
  shared_user?: InputMaybe<Shared_Entity_Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_template_distribution_user */
export type Notification_Template_Distribution_User_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "notification_template_distribution_user" */
export enum Notification_Template_Distribution_User_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Notification_Template_Distribution_User_Stddev_Fields = {
  __typename?: 'notification_template_distribution_user_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Notification_Template_Distribution_User_Stddev_Pop_Fields = {
  __typename?: 'notification_template_distribution_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Notification_Template_Distribution_User_Stddev_Samp_Fields = {
  __typename?: 'notification_template_distribution_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Template_Distribution_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Template_Distribution_User_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Notification_Template_Distribution_User_Sum_Fields = {
  __typename?: 'notification_template_distribution_user_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** update columns of table "notification_template_distribution_user" */
export enum Notification_Template_Distribution_User_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UserId = 'user_id'
}

export type Notification_Template_Distribution_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notification_Template_Distribution_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Template_Distribution_User_Set_Input>;
  where: Notification_Template_Distribution_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notification_Template_Distribution_User_Var_Pop_Fields = {
  __typename?: 'notification_template_distribution_user_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Notification_Template_Distribution_User_Var_Samp_Fields = {
  __typename?: 'notification_template_distribution_user_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Notification_Template_Distribution_User_Variance_Fields = {
  __typename?: 'notification_template_distribution_user_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notification_template_distribution_user" */
export type Notification_Template_Distribution_User_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "notification_template" */
export type Notification_Template_Inc_Input = {
  feature_image_id?: InputMaybe<Scalars['bigint']>;
  shared_broadcaster_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_template" */
export type Notification_Template_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  broadcast_datetime?: InputMaybe<Scalars['timestamptz']>;
  broadcaster_id?: InputMaybe<Scalars['String']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  feature_image?: InputMaybe<Fileupload_Obj_Rel_Insert_Input>;
  feature_image_id?: InputMaybe<Scalars['bigint']>;
  feature_image_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  notification_category?: InputMaybe<Notification_Category_Obj_Rel_Insert_Input>;
  notifications?: InputMaybe<Notification_Arr_Rel_Insert_Input>;
  record_id?: InputMaybe<Scalars['String']>;
  regions?: InputMaybe<Notification_Template_Distribution_Region_Arr_Rel_Insert_Input>;
  shared_broadcaster?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_broadcaster_id?: InputMaybe<Scalars['bigint']>;
  teams?: InputMaybe<Notification_Template_Distribution_Team_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Notification_Template_Distribution_User_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Notification_Template_Max_Fields = {
  __typename?: 'notification_template_max_fields';
  body?: Maybe<Scalars['String']>;
  broadcast_datetime?: Maybe<Scalars['timestamptz']>;
  broadcaster_id?: Maybe<Scalars['String']>;
  category_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  feature_image_id?: Maybe<Scalars['bigint']>;
  feature_image_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  record_id?: Maybe<Scalars['String']>;
  shared_broadcaster_id?: Maybe<Scalars['bigint']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_Template_Min_Fields = {
  __typename?: 'notification_template_min_fields';
  body?: Maybe<Scalars['String']>;
  broadcast_datetime?: Maybe<Scalars['timestamptz']>;
  broadcaster_id?: Maybe<Scalars['String']>;
  category_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  feature_image_id?: Maybe<Scalars['bigint']>;
  feature_image_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  record_id?: Maybe<Scalars['String']>;
  shared_broadcaster_id?: Maybe<Scalars['bigint']>;
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_template" */
export type Notification_Template_Mutation_Response = {
  __typename?: 'notification_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Template>;
};

/** input type for inserting object relation for remote table "notification_template" */
export type Notification_Template_Obj_Rel_Insert_Input = {
  data: Notification_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Template_On_Conflict>;
};

/** on_conflict condition type for table "notification_template" */
export type Notification_Template_On_Conflict = {
  constraint: Notification_Template_Constraint;
  update_columns?: Array<Notification_Template_Update_Column>;
  where?: InputMaybe<Notification_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_template". */
export type Notification_Template_Order_By = {
  body?: InputMaybe<Order_By>;
  broadcast_datetime?: InputMaybe<Order_By>;
  broadcaster_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  feature_image?: InputMaybe<Fileupload_Order_By>;
  feature_image_id?: InputMaybe<Order_By>;
  feature_image_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  notification_category?: InputMaybe<Notification_Category_Order_By>;
  notifications_aggregate?: InputMaybe<Notification_Aggregate_Order_By>;
  record_id?: InputMaybe<Order_By>;
  regions_aggregate?: InputMaybe<Notification_Template_Distribution_Region_Aggregate_Order_By>;
  shared_broadcaster?: InputMaybe<Shared_Entity_Order_By>;
  shared_broadcaster_id?: InputMaybe<Order_By>;
  teams_aggregate?: InputMaybe<Notification_Template_Distribution_Team_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Notification_Template_Distribution_User_Aggregate_Order_By>;
};

/** primary key columns input for table: notification_template */
export type Notification_Template_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "notification_template" */
export enum Notification_Template_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  BroadcastDatetime = 'broadcast_datetime',
  /** column name */
  BroadcasterId = 'broadcaster_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Description = 'description',
  /** column name */
  FeatureImageId = 'feature_image_id',
  /** column name */
  FeatureImageUrl = 'feature_image_url',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  RecordId = 'record_id',
  /** column name */
  SharedBroadcasterId = 'shared_broadcaster_id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "notification_template" */
export type Notification_Template_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  broadcast_datetime?: InputMaybe<Scalars['timestamptz']>;
  broadcaster_id?: InputMaybe<Scalars['String']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  feature_image_id?: InputMaybe<Scalars['bigint']>;
  feature_image_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  record_id?: InputMaybe<Scalars['String']>;
  shared_broadcaster_id?: InputMaybe<Scalars['bigint']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Notification_Template_Stddev_Fields = {
  __typename?: 'notification_template_stddev_fields';
  feature_image_id?: Maybe<Scalars['Float']>;
  shared_broadcaster_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Notification_Template_Stddev_Pop_Fields = {
  __typename?: 'notification_template_stddev_pop_fields';
  feature_image_id?: Maybe<Scalars['Float']>;
  shared_broadcaster_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Notification_Template_Stddev_Samp_Fields = {
  __typename?: 'notification_template_stddev_samp_fields';
  feature_image_id?: Maybe<Scalars['Float']>;
  shared_broadcaster_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notification_template" */
export type Notification_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Template_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  broadcast_datetime?: InputMaybe<Scalars['timestamptz']>;
  broadcaster_id?: InputMaybe<Scalars['String']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  feature_image_id?: InputMaybe<Scalars['bigint']>;
  feature_image_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  record_id?: InputMaybe<Scalars['String']>;
  shared_broadcaster_id?: InputMaybe<Scalars['bigint']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Notification_Template_Sum_Fields = {
  __typename?: 'notification_template_sum_fields';
  feature_image_id?: Maybe<Scalars['bigint']>;
  shared_broadcaster_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "notification_template" */
export enum Notification_Template_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  BroadcastDatetime = 'broadcast_datetime',
  /** column name */
  BroadcasterId = 'broadcaster_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Description = 'description',
  /** column name */
  FeatureImageId = 'feature_image_id',
  /** column name */
  FeatureImageUrl = 'feature_image_url',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  RecordId = 'record_id',
  /** column name */
  SharedBroadcasterId = 'shared_broadcaster_id',
  /** column name */
  Title = 'title'
}

export type Notification_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notification_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Template_Set_Input>;
  where: Notification_Template_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notification_Template_Var_Pop_Fields = {
  __typename?: 'notification_template_var_pop_fields';
  feature_image_id?: Maybe<Scalars['Float']>;
  shared_broadcaster_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Notification_Template_Var_Samp_Fields = {
  __typename?: 'notification_template_var_samp_fields';
  feature_image_id?: Maybe<Scalars['Float']>;
  shared_broadcaster_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Notification_Template_Variance_Fields = {
  __typename?: 'notification_template_variance_fields';
  feature_image_id?: Maybe<Scalars['Float']>;
  shared_broadcaster_id?: Maybe<Scalars['Float']>;
};

/** update columns of table "notification" */
export enum Notification_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSeen = 'is_seen',
  /** column name */
  ReceiverId = 'receiver_id',
  /** column name */
  RecordId = 'record_id',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  Title = 'title'
}

export type Notification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Set_Input>;
  where: Notification_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "nutrients" */
export type Nutrients = {
  __typename?: 'nutrients';
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  id: Scalars['uuid'];
  ingredient_type: Scalars['String'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  products_fertiliser_contents: Array<Products_Fertiliser_Contents>;
  /** An aggregate relationship */
  products_fertiliser_contents_aggregate: Products_Fertiliser_Contents_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
};


/** columns and relationships of "nutrients" */
export type NutrientsCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Nutrientscreator>;
};


/** columns and relationships of "nutrients" */
export type NutrientsProducts_Fertiliser_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Contents_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
};


/** columns and relationships of "nutrients" */
export type NutrientsProducts_Fertiliser_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Contents_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
};


/** columns and relationships of "nutrients" */
export type NutrientsUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Nutrientsupdater>;
};

/** aggregated selection of "nutrients" */
export type Nutrients_Aggregate = {
  __typename?: 'nutrients_aggregate';
  aggregate?: Maybe<Nutrients_Aggregate_Fields>;
  nodes: Array<Nutrients>;
};

/** aggregate fields of "nutrients" */
export type Nutrients_Aggregate_Fields = {
  __typename?: 'nutrients_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nutrients_Max_Fields>;
  min?: Maybe<Nutrients_Min_Fields>;
};


/** aggregate fields of "nutrients" */
export type Nutrients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nutrients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "nutrients". All fields are combined with a logical 'AND'. */
export type Nutrients_Bool_Exp = {
  _and?: InputMaybe<Array<Nutrients_Bool_Exp>>;
  _not?: InputMaybe<Nutrients_Bool_Exp>;
  _or?: InputMaybe<Array<Nutrients_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ingredient_type?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  products_fertiliser_contents?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "nutrients" */
export enum Nutrients_Constraint {
  /** unique or primary key constraint on columns "name" */
  NutrientsNameKey = 'nutrients_name_key',
  /** unique or primary key constraint on columns "id" */
  NutrientsPkey = 'nutrients_pkey'
}

/** input type for inserting data into table "nutrients" */
export type Nutrients_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ingredient_type?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  products_fertiliser_contents?: InputMaybe<Products_Fertiliser_Contents_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Nutrients_Max_Fields = {
  __typename?: 'nutrients_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ingredient_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Nutrients_Min_Fields = {
  __typename?: 'nutrients_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ingredient_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "nutrients" */
export type Nutrients_Mutation_Response = {
  __typename?: 'nutrients_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nutrients>;
};

/** input type for inserting object relation for remote table "nutrients" */
export type Nutrients_Obj_Rel_Insert_Input = {
  data: Nutrients_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Nutrients_On_Conflict>;
};

/** on_conflict condition type for table "nutrients" */
export type Nutrients_On_Conflict = {
  constraint: Nutrients_Constraint;
  update_columns?: Array<Nutrients_Update_Column>;
  where?: InputMaybe<Nutrients_Bool_Exp>;
};

/** Ordering options when selecting data from "nutrients". */
export type Nutrients_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ingredient_type?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  products_fertiliser_contents_aggregate?: InputMaybe<Products_Fertiliser_Contents_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nutrients */
export type Nutrients_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "nutrients" */
export enum Nutrients_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IngredientType = 'ingredient_type',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "nutrients" */
export type Nutrients_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ingredient_type?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "nutrients" */
export type Nutrients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nutrients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nutrients_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ingredient_type?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "nutrients" */
export enum Nutrients_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IngredientType = 'ingredient_type',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Nutrients_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nutrients_Set_Input>;
  where: Nutrients_Bool_Exp;
};

/** columns and relationships of "observation_notification" */
export type Observation_Notification = {
  __typename?: 'observation_notification';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_seen: Scalars['Boolean'];
  /** An object relationship */
  monitoring_record: Monitoring_Record;
  observation_id: Scalars['uuid'];
  receiver: Array<Base_User>;
  receiver_id: Scalars['String'];
  sender: Array<Base_User>;
  sender_id: Scalars['String'];
  sent_at?: Maybe<Scalars['timestamptz']>;
  title: Scalars['String'];
};


/** columns and relationships of "observation_notification" */
export type Observation_NotificationReceiverArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Observation_Notificationreceiver>;
};


/** columns and relationships of "observation_notification" */
export type Observation_NotificationSenderArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Observation_Notificationsender>;
};

/** aggregated selection of "observation_notification" */
export type Observation_Notification_Aggregate = {
  __typename?: 'observation_notification_aggregate';
  aggregate?: Maybe<Observation_Notification_Aggregate_Fields>;
  nodes: Array<Observation_Notification>;
};

/** aggregate fields of "observation_notification" */
export type Observation_Notification_Aggregate_Fields = {
  __typename?: 'observation_notification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Observation_Notification_Max_Fields>;
  min?: Maybe<Observation_Notification_Min_Fields>;
};


/** aggregate fields of "observation_notification" */
export type Observation_Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Observation_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "observation_notification" */
export type Observation_Notification_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Observation_Notification_Max_Order_By>;
  min?: InputMaybe<Observation_Notification_Min_Order_By>;
};

/** input type for inserting array relation for remote table "observation_notification" */
export type Observation_Notification_Arr_Rel_Insert_Input = {
  data: Array<Observation_Notification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Observation_Notification_On_Conflict>;
};

/** Boolean expression to filter rows from the table "observation_notification". All fields are combined with a logical 'AND'. */
export type Observation_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Observation_Notification_Bool_Exp>>;
  _not?: InputMaybe<Observation_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Observation_Notification_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_seen?: InputMaybe<Boolean_Comparison_Exp>;
  monitoring_record?: InputMaybe<Monitoring_Record_Bool_Exp>;
  observation_id?: InputMaybe<Uuid_Comparison_Exp>;
  receiver_id?: InputMaybe<String_Comparison_Exp>;
  sender_id?: InputMaybe<String_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "observation_notification" */
export enum Observation_Notification_Constraint {
  /** unique or primary key constraint on columns "id" */
  ObservationNotificationPkey = 'observation_notification_pkey',
  /** unique or primary key constraint on columns "observation_id", "receiver_id", "sent_at" */
  ObservationNotificationReceiverIdSentAtObse_4bc32d0eUniq = 'observation_notification_receiver_id_sent_at_obse_4bc32d0e_uniq'
}

/** input type for inserting data into table "observation_notification" */
export type Observation_Notification_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_seen?: InputMaybe<Scalars['Boolean']>;
  monitoring_record?: InputMaybe<Monitoring_Record_Obj_Rel_Insert_Input>;
  observation_id?: InputMaybe<Scalars['uuid']>;
  receiver_id?: InputMaybe<Scalars['String']>;
  sender_id?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Observation_Notification_Max_Fields = {
  __typename?: 'observation_notification_max_fields';
  id?: Maybe<Scalars['uuid']>;
  observation_id?: Maybe<Scalars['uuid']>;
  receiver_id?: Maybe<Scalars['String']>;
  sender_id?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "observation_notification" */
export type Observation_Notification_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Observation_Notification_Min_Fields = {
  __typename?: 'observation_notification_min_fields';
  id?: Maybe<Scalars['uuid']>;
  observation_id?: Maybe<Scalars['uuid']>;
  receiver_id?: Maybe<Scalars['String']>;
  sender_id?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "observation_notification" */
export type Observation_Notification_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "observation_notification" */
export type Observation_Notification_Mutation_Response = {
  __typename?: 'observation_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Observation_Notification>;
};

/** on_conflict condition type for table "observation_notification" */
export type Observation_Notification_On_Conflict = {
  constraint: Observation_Notification_Constraint;
  update_columns?: Array<Observation_Notification_Update_Column>;
  where?: InputMaybe<Observation_Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "observation_notification". */
export type Observation_Notification_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_seen?: InputMaybe<Order_By>;
  monitoring_record?: InputMaybe<Monitoring_Record_Order_By>;
  observation_id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: observation_notification */
export type Observation_Notification_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "observation_notification" */
export enum Observation_Notification_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSeen = 'is_seen',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  ReceiverId = 'receiver_id',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "observation_notification" */
export type Observation_Notification_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_seen?: InputMaybe<Scalars['Boolean']>;
  observation_id?: InputMaybe<Scalars['uuid']>;
  receiver_id?: InputMaybe<Scalars['String']>;
  sender_id?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "observation_notification" */
export type Observation_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Observation_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Observation_Notification_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_seen?: InputMaybe<Scalars['Boolean']>;
  observation_id?: InputMaybe<Scalars['uuid']>;
  receiver_id?: InputMaybe<Scalars['String']>;
  sender_id?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
};

/** update columns of table "observation_notification" */
export enum Observation_Notification_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSeen = 'is_seen',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  ReceiverId = 'receiver_id',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Title = 'title'
}

export type Observation_Notification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Observation_Notification_Set_Input>;
  where: Observation_Notification_Bool_Exp;
};

/** columns and relationships of "operation_attachments" */
export type Operation_Attachments = {
  __typename?: 'operation_attachments';
  attachment_id: Scalars['bigint'];
  /** An object relationship */
  fileupload: Fileupload;
  id: Scalars['bigint'];
  /** An object relationship */
  operation: Operations;
  operation_id: Scalars['uuid'];
};

/** aggregated selection of "operation_attachments" */
export type Operation_Attachments_Aggregate = {
  __typename?: 'operation_attachments_aggregate';
  aggregate?: Maybe<Operation_Attachments_Aggregate_Fields>;
  nodes: Array<Operation_Attachments>;
};

/** aggregate fields of "operation_attachments" */
export type Operation_Attachments_Aggregate_Fields = {
  __typename?: 'operation_attachments_aggregate_fields';
  avg?: Maybe<Operation_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operation_Attachments_Max_Fields>;
  min?: Maybe<Operation_Attachments_Min_Fields>;
  stddev?: Maybe<Operation_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Operation_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operation_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Operation_Attachments_Sum_Fields>;
  var_pop?: Maybe<Operation_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Operation_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Operation_Attachments_Variance_Fields>;
};


/** aggregate fields of "operation_attachments" */
export type Operation_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operation_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operation_attachments" */
export type Operation_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Operation_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operation_Attachments_Max_Order_By>;
  min?: InputMaybe<Operation_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Operation_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operation_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operation_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operation_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Operation_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operation_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Operation_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operation_attachments" */
export type Operation_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Operation_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operation_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Operation_Attachments_Avg_Fields = {
  __typename?: 'operation_attachments_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operation_attachments" */
export type Operation_Attachments_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operation_attachments". All fields are combined with a logical 'AND'. */
export type Operation_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Operation_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Operation_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Operation_Attachments_Bool_Exp>>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  fileupload?: InputMaybe<Fileupload_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operation_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "operation_attachments" */
export enum Operation_Attachments_Constraint {
  /** unique or primary key constraint on columns "attachment_id", "operation_id" */
  OperationAttachmentsOperationIdAttachment_8abc86f8Uniq = 'operation_attachments_operation_id_attachment_8abc86f8_uniq',
  /** unique or primary key constraint on columns "id" */
  OperationAttachmentsPkey = 'operation_attachments_pkey'
}

/** input type for incrementing numeric columns in table "operation_attachments" */
export type Operation_Attachments_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "operation_attachments" */
export type Operation_Attachments_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  fileupload?: InputMaybe<Fileupload_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operation_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Operation_Attachments_Max_Fields = {
  __typename?: 'operation_attachments_max_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  operation_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "operation_attachments" */
export type Operation_Attachments_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operation_Attachments_Min_Fields = {
  __typename?: 'operation_attachments_min_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  operation_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "operation_attachments" */
export type Operation_Attachments_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operation_attachments" */
export type Operation_Attachments_Mutation_Response = {
  __typename?: 'operation_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operation_Attachments>;
};

/** on_conflict condition type for table "operation_attachments" */
export type Operation_Attachments_On_Conflict = {
  constraint: Operation_Attachments_Constraint;
  update_columns?: Array<Operation_Attachments_Update_Column>;
  where?: InputMaybe<Operation_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "operation_attachments". */
export type Operation_Attachments_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  fileupload?: InputMaybe<Fileupload_Order_By>;
  id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operation_attachments */
export type Operation_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "operation_attachments" */
export enum Operation_Attachments_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  OperationId = 'operation_id'
}

/** input type for updating data in table "operation_attachments" */
export type Operation_Attachments_Set_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Operation_Attachments_Stddev_Fields = {
  __typename?: 'operation_attachments_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operation_attachments" */
export type Operation_Attachments_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operation_Attachments_Stddev_Pop_Fields = {
  __typename?: 'operation_attachments_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operation_attachments" */
export type Operation_Attachments_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operation_Attachments_Stddev_Samp_Fields = {
  __typename?: 'operation_attachments_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operation_attachments" */
export type Operation_Attachments_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operation_attachments" */
export type Operation_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operation_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operation_Attachments_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Operation_Attachments_Sum_Fields = {
  __typename?: 'operation_attachments_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "operation_attachments" */
export type Operation_Attachments_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "operation_attachments" */
export enum Operation_Attachments_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  OperationId = 'operation_id'
}

export type Operation_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operation_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operation_Attachments_Set_Input>;
  where: Operation_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operation_Attachments_Var_Pop_Fields = {
  __typename?: 'operation_attachments_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operation_attachments" */
export type Operation_Attachments_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operation_Attachments_Var_Samp_Fields = {
  __typename?: 'operation_attachments_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operation_attachments" */
export type Operation_Attachments_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operation_Attachments_Variance_Fields = {
  __typename?: 'operation_attachments_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operation_attachments" */
export type Operation_Attachments_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "operation_cost" */
export type Operation_Cost = {
  __typename?: 'operation_cost';
  /** An object relationship */
  cost_item: Cost_Item;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_migrated: Scalars['Boolean'];
  item_id: Scalars['uuid'];
  no_of_units?: Maybe<Scalars['Int']>;
  /** An object relationship */
  operation: Operations;
  operation_id: Scalars['uuid'];
  price_reporting_value?: Maybe<Scalars['float8']>;
  /** An object relationship */
  shared_unit_price_quantity_unit?: Maybe<Shared_Entity>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
};

/** aggregated selection of "operation_cost" */
export type Operation_Cost_Aggregate = {
  __typename?: 'operation_cost_aggregate';
  aggregate?: Maybe<Operation_Cost_Aggregate_Fields>;
  nodes: Array<Operation_Cost>;
};

/** aggregate fields of "operation_cost" */
export type Operation_Cost_Aggregate_Fields = {
  __typename?: 'operation_cost_aggregate_fields';
  avg?: Maybe<Operation_Cost_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operation_Cost_Max_Fields>;
  min?: Maybe<Operation_Cost_Min_Fields>;
  stddev?: Maybe<Operation_Cost_Stddev_Fields>;
  stddev_pop?: Maybe<Operation_Cost_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operation_Cost_Stddev_Samp_Fields>;
  sum?: Maybe<Operation_Cost_Sum_Fields>;
  var_pop?: Maybe<Operation_Cost_Var_Pop_Fields>;
  var_samp?: Maybe<Operation_Cost_Var_Samp_Fields>;
  variance?: Maybe<Operation_Cost_Variance_Fields>;
};


/** aggregate fields of "operation_cost" */
export type Operation_Cost_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operation_cost" */
export type Operation_Cost_Aggregate_Order_By = {
  avg?: InputMaybe<Operation_Cost_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operation_Cost_Max_Order_By>;
  min?: InputMaybe<Operation_Cost_Min_Order_By>;
  stddev?: InputMaybe<Operation_Cost_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operation_Cost_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operation_Cost_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operation_Cost_Sum_Order_By>;
  var_pop?: InputMaybe<Operation_Cost_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operation_Cost_Var_Samp_Order_By>;
  variance?: InputMaybe<Operation_Cost_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operation_cost" */
export type Operation_Cost_Arr_Rel_Insert_Input = {
  data: Array<Operation_Cost_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operation_Cost_On_Conflict>;
};

/** aggregate avg on columns */
export type Operation_Cost_Avg_Fields = {
  __typename?: 'operation_cost_avg_fields';
  no_of_units?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operation_cost" */
export type Operation_Cost_Avg_Order_By = {
  no_of_units?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operation_cost". All fields are combined with a logical 'AND'. */
export type Operation_Cost_Bool_Exp = {
  _and?: InputMaybe<Array<Operation_Cost_Bool_Exp>>;
  _not?: InputMaybe<Operation_Cost_Bool_Exp>;
  _or?: InputMaybe<Array<Operation_Cost_Bool_Exp>>;
  cost_item?: InputMaybe<Cost_Item_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_migrated?: InputMaybe<Boolean_Comparison_Exp>;
  item_id?: InputMaybe<Uuid_Comparison_Exp>;
  no_of_units?: InputMaybe<Int_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operation_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_cost?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price_quantity_unit_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "operation_cost" */
export enum Operation_Cost_Constraint {
  /** unique or primary key constraint on columns "id" */
  OperationCostPkey = 'operation_cost_pkey'
}

/** input type for incrementing numeric columns in table "operation_cost" */
export type Operation_Cost_Inc_Input = {
  no_of_units?: InputMaybe<Scalars['Int']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operation_cost" */
export type Operation_Cost_Insert_Input = {
  cost_item?: InputMaybe<Cost_Item_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_migrated?: InputMaybe<Scalars['Boolean']>;
  item_id?: InputMaybe<Scalars['uuid']>;
  no_of_units?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "operation_cost_item" */
export type Operation_Cost_Item = {
  __typename?: 'operation_cost_item';
  item?: Maybe<Scalars['String']>;
  plot_id?: Maybe<Scalars['String']>;
  times?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "operation_cost_item" */
export type Operation_Cost_Item_Aggregate = {
  __typename?: 'operation_cost_item_aggregate';
  aggregate?: Maybe<Operation_Cost_Item_Aggregate_Fields>;
  nodes: Array<Operation_Cost_Item>;
};

/** aggregate fields of "operation_cost_item" */
export type Operation_Cost_Item_Aggregate_Fields = {
  __typename?: 'operation_cost_item_aggregate_fields';
  avg?: Maybe<Operation_Cost_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operation_Cost_Item_Max_Fields>;
  min?: Maybe<Operation_Cost_Item_Min_Fields>;
  stddev?: Maybe<Operation_Cost_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Operation_Cost_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operation_Cost_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Operation_Cost_Item_Sum_Fields>;
  var_pop?: Maybe<Operation_Cost_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Operation_Cost_Item_Var_Samp_Fields>;
  variance?: Maybe<Operation_Cost_Item_Variance_Fields>;
};


/** aggregate fields of "operation_cost_item" */
export type Operation_Cost_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operation_Cost_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Operation_Cost_Item_Avg_Fields = {
  __typename?: 'operation_cost_item_avg_fields';
  times?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operation_cost_item". All fields are combined with a logical 'AND'. */
export type Operation_Cost_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Operation_Cost_Item_Bool_Exp>>;
  _not?: InputMaybe<Operation_Cost_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Operation_Cost_Item_Bool_Exp>>;
  item?: InputMaybe<String_Comparison_Exp>;
  plot_id?: InputMaybe<String_Comparison_Exp>;
  times?: InputMaybe<Bigint_Comparison_Exp>;
  total_cost?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Operation_Cost_Item_Max_Fields = {
  __typename?: 'operation_cost_item_max_fields';
  item?: Maybe<Scalars['String']>;
  plot_id?: Maybe<Scalars['String']>;
  times?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Operation_Cost_Item_Min_Fields = {
  __typename?: 'operation_cost_item_min_fields';
  item?: Maybe<Scalars['String']>;
  plot_id?: Maybe<Scalars['String']>;
  times?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "operation_cost_item". */
export type Operation_Cost_Item_Order_By = {
  item?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  times?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** select columns of table "operation_cost_item" */
export enum Operation_Cost_Item_Select_Column {
  /** column name */
  Item = 'item',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  Times = 'times',
  /** column name */
  TotalCost = 'total_cost'
}

/** aggregate stddev on columns */
export type Operation_Cost_Item_Stddev_Fields = {
  __typename?: 'operation_cost_item_stddev_fields';
  times?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Operation_Cost_Item_Stddev_Pop_Fields = {
  __typename?: 'operation_cost_item_stddev_pop_fields';
  times?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Operation_Cost_Item_Stddev_Samp_Fields = {
  __typename?: 'operation_cost_item_stddev_samp_fields';
  times?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "operation_cost_item" */
export type Operation_Cost_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operation_Cost_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operation_Cost_Item_Stream_Cursor_Value_Input = {
  item?: InputMaybe<Scalars['String']>;
  plot_id?: InputMaybe<Scalars['String']>;
  times?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Operation_Cost_Item_Sum_Fields = {
  __typename?: 'operation_cost_item_sum_fields';
  times?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Operation_Cost_Item_Var_Pop_Fields = {
  __typename?: 'operation_cost_item_var_pop_fields';
  times?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Operation_Cost_Item_Var_Samp_Fields = {
  __typename?: 'operation_cost_item_var_samp_fields';
  times?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Operation_Cost_Item_Variance_Fields = {
  __typename?: 'operation_cost_item_variance_fields';
  times?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Operation_Cost_Max_Fields = {
  __typename?: 'operation_cost_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  item_id?: Maybe<Scalars['uuid']>;
  no_of_units?: Maybe<Scalars['Int']>;
  operation_id?: Maybe<Scalars['uuid']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "operation_cost" */
export type Operation_Cost_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_id?: InputMaybe<Order_By>;
  no_of_units?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operation_Cost_Min_Fields = {
  __typename?: 'operation_cost_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  item_id?: Maybe<Scalars['uuid']>;
  no_of_units?: Maybe<Scalars['Int']>;
  operation_id?: Maybe<Scalars['uuid']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "operation_cost" */
export type Operation_Cost_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_id?: InputMaybe<Order_By>;
  no_of_units?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operation_cost" */
export type Operation_Cost_Mutation_Response = {
  __typename?: 'operation_cost_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operation_Cost>;
};

/** on_conflict condition type for table "operation_cost" */
export type Operation_Cost_On_Conflict = {
  constraint: Operation_Cost_Constraint;
  update_columns?: Array<Operation_Cost_Update_Column>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};

/** Ordering options when selecting data from "operation_cost". */
export type Operation_Cost_Order_By = {
  cost_item?: InputMaybe<Cost_Item_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_migrated?: InputMaybe<Order_By>;
  item_id?: InputMaybe<Order_By>;
  no_of_units?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operation_id?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operation_cost */
export type Operation_Cost_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operation_cost" */
export enum Operation_Cost_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsMigrated = 'is_migrated',
  /** column name */
  ItemId = 'item_id',
  /** column name */
  NoOfUnits = 'no_of_units',
  /** column name */
  OperationId = 'operation_id',
  /** column name */
  PriceReportingValue = 'price_reporting_value',
  /** column name */
  SharedUnitPriceQuantityUnitId = 'shared_unit_price_quantity_unit_id',
  /** column name */
  TotalCost = 'total_cost',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceQuantityUnitId = 'unit_price_quantity_unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "operation_cost" */
export type Operation_Cost_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_migrated?: InputMaybe<Scalars['Boolean']>;
  item_id?: InputMaybe<Scalars['uuid']>;
  no_of_units?: InputMaybe<Scalars['Int']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Operation_Cost_Stddev_Fields = {
  __typename?: 'operation_cost_stddev_fields';
  no_of_units?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operation_cost" */
export type Operation_Cost_Stddev_Order_By = {
  no_of_units?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operation_Cost_Stddev_Pop_Fields = {
  __typename?: 'operation_cost_stddev_pop_fields';
  no_of_units?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operation_cost" */
export type Operation_Cost_Stddev_Pop_Order_By = {
  no_of_units?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operation_Cost_Stddev_Samp_Fields = {
  __typename?: 'operation_cost_stddev_samp_fields';
  no_of_units?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operation_cost" */
export type Operation_Cost_Stddev_Samp_Order_By = {
  no_of_units?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operation_cost" */
export type Operation_Cost_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operation_Cost_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operation_Cost_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_migrated?: InputMaybe<Scalars['Boolean']>;
  item_id?: InputMaybe<Scalars['uuid']>;
  no_of_units?: InputMaybe<Scalars['Int']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Operation_Cost_Sum_Fields = {
  __typename?: 'operation_cost_sum_fields';
  no_of_units?: Maybe<Scalars['Int']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "operation_cost" */
export type Operation_Cost_Sum_Order_By = {
  no_of_units?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** update columns of table "operation_cost" */
export enum Operation_Cost_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsMigrated = 'is_migrated',
  /** column name */
  ItemId = 'item_id',
  /** column name */
  NoOfUnits = 'no_of_units',
  /** column name */
  OperationId = 'operation_id',
  /** column name */
  PriceReportingValue = 'price_reporting_value',
  /** column name */
  SharedUnitPriceQuantityUnitId = 'shared_unit_price_quantity_unit_id',
  /** column name */
  TotalCost = 'total_cost',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceQuantityUnitId = 'unit_price_quantity_unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Operation_Cost_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operation_Cost_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operation_Cost_Set_Input>;
  where: Operation_Cost_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operation_Cost_Var_Pop_Fields = {
  __typename?: 'operation_cost_var_pop_fields';
  no_of_units?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operation_cost" */
export type Operation_Cost_Var_Pop_Order_By = {
  no_of_units?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operation_Cost_Var_Samp_Fields = {
  __typename?: 'operation_cost_var_samp_fields';
  no_of_units?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operation_cost" */
export type Operation_Cost_Var_Samp_Order_By = {
  no_of_units?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operation_Cost_Variance_Fields = {
  __typename?: 'operation_cost_variance_fields';
  no_of_units?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operation_cost" */
export type Operation_Cost_Variance_Order_By = {
  no_of_units?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "operation_methods" */
export type Operation_Methods = {
  __typename?: 'operation_methods';
  all_crops: Scalars['Boolean'];
  /** An array relationship */
  crop_operation_methods: Array<Crop_Operation_Methods>;
  /** An aggregate relationship */
  crop_operation_methods_aggregate: Crop_Operation_Methods_Aggregate;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  operation_type: Scalars['String'];
  /** An array relationship */
  operations_fertilisers: Array<Operations_Fertiliser>;
  /** An aggregate relationship */
  operations_fertilisers_aggregate: Operations_Fertiliser_Aggregate;
  /** An array relationship */
  operations_intercultures: Array<Operations_Interculture>;
  /** An aggregate relationship */
  operations_intercultures_aggregate: Operations_Interculture_Aggregate;
  /** An array relationship */
  operations_irrigations: Array<Operations_Irrigation>;
  /** An aggregate relationship */
  operations_irrigations_aggregate: Operations_Irrigation_Aggregate;
  /** An array relationship */
  operations_land_preps: Array<Operations_Land_Prep>;
  /** An aggregate relationship */
  operations_land_preps_aggregate: Operations_Land_Prep_Aggregate;
  /** An array relationship */
  operations_pesticides: Array<Operations_Pesticide>;
  /** An aggregate relationship */
  operations_pesticides_aggregate: Operations_Pesticide_Aggregate;
  /** An array relationship */
  operations_sowings: Array<Operations_Sowing>;
  /** An aggregate relationship */
  operations_sowings_aggregate: Operations_Sowing_Aggregate;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsCrop_Operation_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Operation_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Operation_Methods_Order_By>>;
  where?: InputMaybe<Crop_Operation_Methods_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsCrop_Operation_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Operation_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Operation_Methods_Order_By>>;
  where?: InputMaybe<Crop_Operation_Methods_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_FertilisersArgs = {
  distinct_on?: InputMaybe<Array<Operations_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_Fertilisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_InterculturesArgs = {
  distinct_on?: InputMaybe<Array<Operations_Interculture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Interculture_Order_By>>;
  where?: InputMaybe<Operations_Interculture_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_Intercultures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Interculture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Interculture_Order_By>>;
  where?: InputMaybe<Operations_Interculture_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_IrrigationsArgs = {
  distinct_on?: InputMaybe<Array<Operations_Irrigation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Irrigation_Order_By>>;
  where?: InputMaybe<Operations_Irrigation_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_Irrigations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Irrigation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Irrigation_Order_By>>;
  where?: InputMaybe<Operations_Irrigation_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_Land_PrepsArgs = {
  distinct_on?: InputMaybe<Array<Operations_Land_Prep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Land_Prep_Order_By>>;
  where?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_Land_Preps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Land_Prep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Land_Prep_Order_By>>;
  where?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_PesticidesArgs = {
  distinct_on?: InputMaybe<Array<Operations_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Pesticide_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_Pesticides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Pesticide_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_SowingsArgs = {
  distinct_on?: InputMaybe<Array<Operations_Sowing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Sowing_Order_By>>;
  where?: InputMaybe<Operations_Sowing_Bool_Exp>;
};


/** columns and relationships of "operation_methods" */
export type Operation_MethodsOperations_Sowings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Sowing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Sowing_Order_By>>;
  where?: InputMaybe<Operations_Sowing_Bool_Exp>;
};

/** aggregated selection of "operation_methods" */
export type Operation_Methods_Aggregate = {
  __typename?: 'operation_methods_aggregate';
  aggregate?: Maybe<Operation_Methods_Aggregate_Fields>;
  nodes: Array<Operation_Methods>;
};

/** aggregate fields of "operation_methods" */
export type Operation_Methods_Aggregate_Fields = {
  __typename?: 'operation_methods_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Operation_Methods_Max_Fields>;
  min?: Maybe<Operation_Methods_Min_Fields>;
};


/** aggregate fields of "operation_methods" */
export type Operation_Methods_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operation_Methods_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "operation_methods". All fields are combined with a logical 'AND'. */
export type Operation_Methods_Bool_Exp = {
  _and?: InputMaybe<Array<Operation_Methods_Bool_Exp>>;
  _not?: InputMaybe<Operation_Methods_Bool_Exp>;
  _or?: InputMaybe<Array<Operation_Methods_Bool_Exp>>;
  all_crops?: InputMaybe<Boolean_Comparison_Exp>;
  crop_operation_methods?: InputMaybe<Crop_Operation_Methods_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  operation_type?: InputMaybe<String_Comparison_Exp>;
  operations_fertilisers?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
  operations_intercultures?: InputMaybe<Operations_Interculture_Bool_Exp>;
  operations_irrigations?: InputMaybe<Operations_Irrigation_Bool_Exp>;
  operations_land_preps?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
  operations_pesticides?: InputMaybe<Operations_Pesticide_Bool_Exp>;
  operations_sowings?: InputMaybe<Operations_Sowing_Bool_Exp>;
};

/** unique or primary key constraints on table "operation_methods" */
export enum Operation_Methods_Constraint {
  /** unique or primary key constraint on columns "name", "operation_type" */
  OperationMethodsOperationTypeNameD71a9ec6Uniq = 'operation_methods_operation_type_name_d71a9ec6_uniq',
  /** unique or primary key constraint on columns "id" */
  OperationMethodsPkey = 'operation_methods_pkey'
}

/** input type for inserting data into table "operation_methods" */
export type Operation_Methods_Insert_Input = {
  all_crops?: InputMaybe<Scalars['Boolean']>;
  crop_operation_methods?: InputMaybe<Crop_Operation_Methods_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  operation_type?: InputMaybe<Scalars['String']>;
  operations_fertilisers?: InputMaybe<Operations_Fertiliser_Arr_Rel_Insert_Input>;
  operations_intercultures?: InputMaybe<Operations_Interculture_Arr_Rel_Insert_Input>;
  operations_irrigations?: InputMaybe<Operations_Irrigation_Arr_Rel_Insert_Input>;
  operations_land_preps?: InputMaybe<Operations_Land_Prep_Arr_Rel_Insert_Input>;
  operations_pesticides?: InputMaybe<Operations_Pesticide_Arr_Rel_Insert_Input>;
  operations_sowings?: InputMaybe<Operations_Sowing_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Operation_Methods_Max_Fields = {
  __typename?: 'operation_methods_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  operation_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Operation_Methods_Min_Fields = {
  __typename?: 'operation_methods_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  operation_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "operation_methods" */
export type Operation_Methods_Mutation_Response = {
  __typename?: 'operation_methods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operation_Methods>;
};

/** input type for inserting object relation for remote table "operation_methods" */
export type Operation_Methods_Obj_Rel_Insert_Input = {
  data: Operation_Methods_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operation_Methods_On_Conflict>;
};

/** on_conflict condition type for table "operation_methods" */
export type Operation_Methods_On_Conflict = {
  constraint: Operation_Methods_Constraint;
  update_columns?: Array<Operation_Methods_Update_Column>;
  where?: InputMaybe<Operation_Methods_Bool_Exp>;
};

/** Ordering options when selecting data from "operation_methods". */
export type Operation_Methods_Order_By = {
  all_crops?: InputMaybe<Order_By>;
  crop_operation_methods_aggregate?: InputMaybe<Crop_Operation_Methods_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operation_type?: InputMaybe<Order_By>;
  operations_fertilisers_aggregate?: InputMaybe<Operations_Fertiliser_Aggregate_Order_By>;
  operations_intercultures_aggregate?: InputMaybe<Operations_Interculture_Aggregate_Order_By>;
  operations_irrigations_aggregate?: InputMaybe<Operations_Irrigation_Aggregate_Order_By>;
  operations_land_preps_aggregate?: InputMaybe<Operations_Land_Prep_Aggregate_Order_By>;
  operations_pesticides_aggregate?: InputMaybe<Operations_Pesticide_Aggregate_Order_By>;
  operations_sowings_aggregate?: InputMaybe<Operations_Sowing_Aggregate_Order_By>;
};

/** primary key columns input for table: operation_methods */
export type Operation_Methods_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operation_methods" */
export enum Operation_Methods_Select_Column {
  /** column name */
  AllCrops = 'all_crops',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OperationType = 'operation_type'
}

/** input type for updating data in table "operation_methods" */
export type Operation_Methods_Set_Input = {
  all_crops?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  operation_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "operation_methods" */
export type Operation_Methods_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operation_Methods_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operation_Methods_Stream_Cursor_Value_Input = {
  all_crops?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  operation_type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "operation_methods" */
export enum Operation_Methods_Update_Column {
  /** column name */
  AllCrops = 'all_crops',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OperationType = 'operation_type'
}

export type Operation_Methods_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operation_Methods_Set_Input>;
  where: Operation_Methods_Bool_Exp;
};

/** columns and relationships of "operation_product_types" */
export type Operation_Product_Types = {
  __typename?: 'operation_product_types';
  care_reference_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  operation_type: Scalars['String'];
  /** An array relationship */
  products: Array<Products>;
  /** An aggregate relationship */
  products_aggregate: Products_Aggregate;
};


/** columns and relationships of "operation_product_types" */
export type Operation_Product_TypesProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


/** columns and relationships of "operation_product_types" */
export type Operation_Product_TypesProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};

/** aggregated selection of "operation_product_types" */
export type Operation_Product_Types_Aggregate = {
  __typename?: 'operation_product_types_aggregate';
  aggregate?: Maybe<Operation_Product_Types_Aggregate_Fields>;
  nodes: Array<Operation_Product_Types>;
};

/** aggregate fields of "operation_product_types" */
export type Operation_Product_Types_Aggregate_Fields = {
  __typename?: 'operation_product_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Operation_Product_Types_Max_Fields>;
  min?: Maybe<Operation_Product_Types_Min_Fields>;
};


/** aggregate fields of "operation_product_types" */
export type Operation_Product_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operation_Product_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "operation_product_types". All fields are combined with a logical 'AND'. */
export type Operation_Product_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Operation_Product_Types_Bool_Exp>>;
  _not?: InputMaybe<Operation_Product_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Operation_Product_Types_Bool_Exp>>;
  care_reference_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  operation_type?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Products_Bool_Exp>;
};

/** unique or primary key constraints on table "operation_product_types" */
export enum Operation_Product_Types_Constraint {
  /** unique or primary key constraint on columns "name", "operation_type" */
  OperationProductTypesOperationTypeName_40e967faUniq = 'operation_product_types_operation_type_name_40e967fa_uniq',
  /** unique or primary key constraint on columns "id" */
  OperationProductTypesPkey = 'operation_product_types_pkey'
}

/** input type for inserting data into table "operation_product_types" */
export type Operation_Product_Types_Insert_Input = {
  care_reference_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  operation_type?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Products_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Operation_Product_Types_Max_Fields = {
  __typename?: 'operation_product_types_max_fields';
  care_reference_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  operation_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Operation_Product_Types_Min_Fields = {
  __typename?: 'operation_product_types_min_fields';
  care_reference_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  operation_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "operation_product_types" */
export type Operation_Product_Types_Mutation_Response = {
  __typename?: 'operation_product_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operation_Product_Types>;
};

/** input type for inserting object relation for remote table "operation_product_types" */
export type Operation_Product_Types_Obj_Rel_Insert_Input = {
  data: Operation_Product_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operation_Product_Types_On_Conflict>;
};

/** on_conflict condition type for table "operation_product_types" */
export type Operation_Product_Types_On_Conflict = {
  constraint: Operation_Product_Types_Constraint;
  update_columns?: Array<Operation_Product_Types_Update_Column>;
  where?: InputMaybe<Operation_Product_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "operation_product_types". */
export type Operation_Product_Types_Order_By = {
  care_reference_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operation_type?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Products_Aggregate_Order_By>;
};

/** primary key columns input for table: operation_product_types */
export type Operation_Product_Types_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operation_product_types" */
export enum Operation_Product_Types_Select_Column {
  /** column name */
  CareReferenceId = 'care_reference_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OperationType = 'operation_type'
}

/** input type for updating data in table "operation_product_types" */
export type Operation_Product_Types_Set_Input = {
  care_reference_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  operation_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "operation_product_types" */
export type Operation_Product_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operation_Product_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operation_Product_Types_Stream_Cursor_Value_Input = {
  care_reference_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  operation_type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "operation_product_types" */
export enum Operation_Product_Types_Update_Column {
  /** column name */
  CareReferenceId = 'care_reference_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OperationType = 'operation_type'
}

export type Operation_Product_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operation_Product_Types_Set_Input>;
  where: Operation_Product_Types_Bool_Exp;
};

/** columns and relationships of "operations" */
export type Operations = {
  __typename?: 'operations';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  area_unit_id?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  crop_year?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_applied: Scalars['Boolean'];
  location?: Maybe<Scalars['geometry']>;
  notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  operation?: Maybe<Operations>;
  /** An array relationship */
  operation_attachments: Array<Operation_Attachments>;
  /** An aggregate relationship */
  operation_attachments_aggregate: Operation_Attachments_Aggregate;
  /** An array relationship */
  operation_costs: Array<Operation_Cost>;
  /** An aggregate relationship */
  operation_costs_aggregate: Operation_Cost_Aggregate;
  /** An array relationship */
  operations: Array<Operations>;
  /** An aggregate relationship */
  operations_aggregate: Operations_Aggregate;
  /** An object relationship */
  operations_fertiliser?: Maybe<Operations_Fertiliser>;
  /** An object relationship */
  operations_harvest?: Maybe<Operations_Harvest>;
  /** An object relationship */
  operations_interculture?: Maybe<Operations_Interculture>;
  /** An object relationship */
  operations_irrigation?: Maybe<Operations_Irrigation>;
  /** An object relationship */
  operations_land_prep?: Maybe<Operations_Land_Prep>;
  /** An object relationship */
  operations_pesticide?: Maybe<Operations_Pesticide>;
  /** An object relationship */
  operations_sowing?: Maybe<Operations_Sowing>;
  percent_field_cover?: Maybe<Scalars['float8']>;
  planned_operation_id?: Maybe<Scalars['uuid']>;
  plot: Array<Plot>;
  plot_crop: Array<Plot_Crop>;
  plot_crop_id?: Maybe<Scalars['String']>;
  plot_id: Scalars['String'];
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  primary_growth_stage_id?: Maybe<Scalars['String']>;
  secondary_growth_stage_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  shared_area_unit?: Maybe<Shared_Entity>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_plot?: Maybe<Shared_Entity>;
  /** An object relationship */
  shared_plot_crop?: Maybe<Shared_Entity>;
  shared_plot_crop_id?: Maybe<Scalars['bigint']>;
  shared_plot_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_primary_growth_stage?: Maybe<Shared_Entity>;
  shared_primary_growth_stage_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_secondary_growth_stage?: Maybe<Shared_Entity>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['bigint']>;
  start_date: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
  voice_note_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "operations" */
export type OperationsCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Operationscreator>;
};


/** columns and relationships of "operations" */
export type OperationsOperation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Attachments_Order_By>>;
  where?: InputMaybe<Operation_Attachments_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsOperation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Attachments_Order_By>>;
  where?: InputMaybe<Operation_Attachments_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsOperation_CostsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Order_By>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsOperation_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Order_By>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsOperationsArgs = {
  distinct_on?: InputMaybe<Array<Operations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Order_By>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsOperations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Order_By>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsPlotArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp_Remote_Rel_Operationsplot>;
};


/** columns and relationships of "operations" */
export type OperationsPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp_Remote_Rel_Operationsplot_Crop>;
};


/** columns and relationships of "operations" */
export type OperationsUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Operationsupdater>;
};

/** aggregated selection of "operations" */
export type Operations_Aggregate = {
  __typename?: 'operations_aggregate';
  aggregate?: Maybe<Operations_Aggregate_Fields>;
  nodes: Array<Operations>;
};

/** aggregate fields of "operations" */
export type Operations_Aggregate_Fields = {
  __typename?: 'operations_aggregate_fields';
  avg?: Maybe<Operations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Max_Fields>;
  min?: Maybe<Operations_Min_Fields>;
  stddev?: Maybe<Operations_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Sum_Fields>;
  var_pop?: Maybe<Operations_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Var_Samp_Fields>;
  variance?: Maybe<Operations_Variance_Fields>;
};


/** aggregate fields of "operations" */
export type Operations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations" */
export type Operations_Aggregate_Order_By = {
  avg?: InputMaybe<Operations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operations_Max_Order_By>;
  min?: InputMaybe<Operations_Min_Order_By>;
  stddev?: InputMaybe<Operations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operations_Sum_Order_By>;
  var_pop?: InputMaybe<Operations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operations_Var_Samp_Order_By>;
  variance?: InputMaybe<Operations_Variance_Order_By>;
};

/** columns and relationships of "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser = {
  __typename?: 'operations_applied_fertiliser';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  area_unit_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  operation_id: Scalars['uuid'];
  /** An object relationship */
  operations_fertiliser: Operations_Fertiliser;
  price_reporting_value?: Maybe<Scalars['float8']>;
  /** An object relationship */
  product?: Maybe<Products>;
  product_id: Scalars['uuid'];
  /** An object relationship */
  products_fertiliser: Products_Fertiliser;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit: Array<Si_Unit>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  shared_area_unit?: Maybe<Shared_Entity>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_quantity_unit?: Maybe<Shared_Entity>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_unit_price_quantity_unit?: Maybe<Shared_Entity>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "operations_applied_fertiliser" */
export type Operations_Applied_FertiliserQuantity_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Operations_Applied_Fertiliserquantity_Unit>;
};

/** aggregated selection of "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Aggregate = {
  __typename?: 'operations_applied_fertiliser_aggregate';
  aggregate?: Maybe<Operations_Applied_Fertiliser_Aggregate_Fields>;
  nodes: Array<Operations_Applied_Fertiliser>;
};

/** aggregate fields of "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Aggregate_Fields = {
  __typename?: 'operations_applied_fertiliser_aggregate_fields';
  avg?: Maybe<Operations_Applied_Fertiliser_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Applied_Fertiliser_Max_Fields>;
  min?: Maybe<Operations_Applied_Fertiliser_Min_Fields>;
  stddev?: Maybe<Operations_Applied_Fertiliser_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Applied_Fertiliser_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Applied_Fertiliser_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Applied_Fertiliser_Sum_Fields>;
  var_pop?: Maybe<Operations_Applied_Fertiliser_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Applied_Fertiliser_Var_Samp_Fields>;
  variance?: Maybe<Operations_Applied_Fertiliser_Variance_Fields>;
};


/** aggregate fields of "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Aggregate_Order_By = {
  avg?: InputMaybe<Operations_Applied_Fertiliser_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operations_Applied_Fertiliser_Max_Order_By>;
  min?: InputMaybe<Operations_Applied_Fertiliser_Min_Order_By>;
  stddev?: InputMaybe<Operations_Applied_Fertiliser_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operations_Applied_Fertiliser_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operations_Applied_Fertiliser_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operations_Applied_Fertiliser_Sum_Order_By>;
  var_pop?: InputMaybe<Operations_Applied_Fertiliser_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operations_Applied_Fertiliser_Var_Samp_Order_By>;
  variance?: InputMaybe<Operations_Applied_Fertiliser_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Arr_Rel_Insert_Input = {
  data: Array<Operations_Applied_Fertiliser_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Applied_Fertiliser_On_Conflict>;
};

/** aggregate avg on columns */
export type Operations_Applied_Fertiliser_Avg_Fields = {
  __typename?: 'operations_applied_fertiliser_avg_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Avg_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations_applied_fertiliser". All fields are combined with a logical 'AND'. */
export type Operations_Applied_Fertiliser_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Applied_Fertiliser_Bool_Exp>>;
  _not?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Applied_Fertiliser_Bool_Exp>>;
  application_area?: InputMaybe<Float8_Comparison_Exp>;
  area_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  area_unit_id?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  operation_id?: InputMaybe<Uuid_Comparison_Exp>;
  operations_fertiliser?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
  price_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Bool_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  quantity_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  quantity_unit_id?: InputMaybe<String_Comparison_Exp>;
  shared_area_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_area_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_cost?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price_quantity_unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations_applied_fertiliser" */
export enum Operations_Applied_Fertiliser_Constraint {
  /** unique or primary key constraint on columns "id" */
  OperationsAppliedFertiliserPkey = 'operations_applied_fertiliser_pkey'
}

/** input type for incrementing numeric columns in table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Inc_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Insert_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  area_unit_id?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  operations_fertiliser?: InputMaybe<Operations_Fertiliser_Obj_Rel_Insert_Input>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Obj_Rel_Insert_Input>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_area_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Operations_Applied_Fertiliser_Max_Fields = {
  __typename?: 'operations_applied_fertiliser_max_fields';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  area_unit_id?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  operation_id?: Maybe<Scalars['uuid']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  product_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Max_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operations_Applied_Fertiliser_Min_Fields = {
  __typename?: 'operations_applied_fertiliser_min_fields';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  area_unit_id?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  operation_id?: Maybe<Scalars['uuid']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  product_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Min_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Mutation_Response = {
  __typename?: 'operations_applied_fertiliser_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Applied_Fertiliser>;
};

/** on_conflict condition type for table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_On_Conflict = {
  constraint: Operations_Applied_Fertiliser_Constraint;
  update_columns?: Array<Operations_Applied_Fertiliser_Update_Column>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};

/** Ordering options when selecting data from "operations_applied_fertiliser". */
export type Operations_Applied_Fertiliser_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  operations_fertiliser?: InputMaybe<Operations_Fertiliser_Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_area_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations_applied_fertiliser */
export type Operations_Applied_Fertiliser_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations_applied_fertiliser" */
export enum Operations_Applied_Fertiliser_Select_Column {
  /** column name */
  ApplicationArea = 'application_area',
  /** column name */
  AreaReportingValue = 'area_reporting_value',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OperationId = 'operation_id',
  /** column name */
  PriceReportingValue = 'price_reporting_value',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityReportingValue = 'quantity_reporting_value',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SharedAreaUnitId = 'shared_area_unit_id',
  /** column name */
  SharedQuantityUnitId = 'shared_quantity_unit_id',
  /** column name */
  SharedUnitPriceQuantityUnitId = 'shared_unit_price_quantity_unit_id',
  /** column name */
  TotalCost = 'total_cost',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceQuantityUnitId = 'unit_price_quantity_unit_id'
}

/** input type for updating data in table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Set_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  area_unit_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Operations_Applied_Fertiliser_Stddev_Fields = {
  __typename?: 'operations_applied_fertiliser_stddev_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Stddev_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operations_Applied_Fertiliser_Stddev_Pop_Fields = {
  __typename?: 'operations_applied_fertiliser_stddev_pop_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Stddev_Pop_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operations_Applied_Fertiliser_Stddev_Samp_Fields = {
  __typename?: 'operations_applied_fertiliser_stddev_samp_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Stddev_Samp_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Applied_Fertiliser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Applied_Fertiliser_Stream_Cursor_Value_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  area_unit_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Operations_Applied_Fertiliser_Sum_Fields = {
  __typename?: 'operations_applied_fertiliser_sum_fields';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Sum_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** update columns of table "operations_applied_fertiliser" */
export enum Operations_Applied_Fertiliser_Update_Column {
  /** column name */
  ApplicationArea = 'application_area',
  /** column name */
  AreaReportingValue = 'area_reporting_value',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OperationId = 'operation_id',
  /** column name */
  PriceReportingValue = 'price_reporting_value',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityReportingValue = 'quantity_reporting_value',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SharedAreaUnitId = 'shared_area_unit_id',
  /** column name */
  SharedQuantityUnitId = 'shared_quantity_unit_id',
  /** column name */
  SharedUnitPriceQuantityUnitId = 'shared_unit_price_quantity_unit_id',
  /** column name */
  TotalCost = 'total_cost',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceQuantityUnitId = 'unit_price_quantity_unit_id'
}

export type Operations_Applied_Fertiliser_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Applied_Fertiliser_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Applied_Fertiliser_Set_Input>;
  where: Operations_Applied_Fertiliser_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Applied_Fertiliser_Var_Pop_Fields = {
  __typename?: 'operations_applied_fertiliser_var_pop_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Var_Pop_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operations_Applied_Fertiliser_Var_Samp_Fields = {
  __typename?: 'operations_applied_fertiliser_var_samp_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Var_Samp_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operations_Applied_Fertiliser_Variance_Fields = {
  __typename?: 'operations_applied_fertiliser_variance_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations_applied_fertiliser" */
export type Operations_Applied_Fertiliser_Variance_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations_applied_pesticide" */
export type Operations_Applied_Pesticide = {
  __typename?: 'operations_applied_pesticide';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  area_unit_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  operation_id: Scalars['uuid'];
  /** An object relationship */
  operations_pesticide: Operations_Pesticide;
  price_reporting_value?: Maybe<Scalars['float8']>;
  /** An object relationship */
  product?: Maybe<Products>;
  product_id: Scalars['uuid'];
  /** An object relationship */
  products_pesticide: Products_Pesticide;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit: Array<Si_Unit>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  shared_area_unit?: Maybe<Shared_Entity>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_quantity_unit?: Maybe<Shared_Entity>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_unit_price_quantity_unit?: Maybe<Shared_Entity>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "operations_applied_pesticide" */
export type Operations_Applied_PesticideQuantity_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Operations_Applied_Pesticidequantity_Unit>;
};

/** aggregated selection of "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Aggregate = {
  __typename?: 'operations_applied_pesticide_aggregate';
  aggregate?: Maybe<Operations_Applied_Pesticide_Aggregate_Fields>;
  nodes: Array<Operations_Applied_Pesticide>;
};

/** aggregate fields of "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Aggregate_Fields = {
  __typename?: 'operations_applied_pesticide_aggregate_fields';
  avg?: Maybe<Operations_Applied_Pesticide_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Applied_Pesticide_Max_Fields>;
  min?: Maybe<Operations_Applied_Pesticide_Min_Fields>;
  stddev?: Maybe<Operations_Applied_Pesticide_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Applied_Pesticide_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Applied_Pesticide_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Applied_Pesticide_Sum_Fields>;
  var_pop?: Maybe<Operations_Applied_Pesticide_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Applied_Pesticide_Var_Samp_Fields>;
  variance?: Maybe<Operations_Applied_Pesticide_Variance_Fields>;
};


/** aggregate fields of "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Aggregate_Order_By = {
  avg?: InputMaybe<Operations_Applied_Pesticide_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operations_Applied_Pesticide_Max_Order_By>;
  min?: InputMaybe<Operations_Applied_Pesticide_Min_Order_By>;
  stddev?: InputMaybe<Operations_Applied_Pesticide_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operations_Applied_Pesticide_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operations_Applied_Pesticide_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operations_Applied_Pesticide_Sum_Order_By>;
  var_pop?: InputMaybe<Operations_Applied_Pesticide_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operations_Applied_Pesticide_Var_Samp_Order_By>;
  variance?: InputMaybe<Operations_Applied_Pesticide_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Arr_Rel_Insert_Input = {
  data: Array<Operations_Applied_Pesticide_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Applied_Pesticide_On_Conflict>;
};

/** aggregate avg on columns */
export type Operations_Applied_Pesticide_Avg_Fields = {
  __typename?: 'operations_applied_pesticide_avg_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Avg_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations_applied_pesticide". All fields are combined with a logical 'AND'. */
export type Operations_Applied_Pesticide_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Applied_Pesticide_Bool_Exp>>;
  _not?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Applied_Pesticide_Bool_Exp>>;
  application_area?: InputMaybe<Float8_Comparison_Exp>;
  area_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  area_unit_id?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  operation_id?: InputMaybe<Uuid_Comparison_Exp>;
  operations_pesticide?: InputMaybe<Operations_Pesticide_Bool_Exp>;
  price_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  products_pesticide?: InputMaybe<Products_Pesticide_Bool_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  quantity_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  quantity_unit_id?: InputMaybe<String_Comparison_Exp>;
  shared_area_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_area_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_cost?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price_quantity_unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations_applied_pesticide" */
export enum Operations_Applied_Pesticide_Constraint {
  /** unique or primary key constraint on columns "id" */
  OperationsAppliedPesticidePkey = 'operations_applied_pesticide_pkey'
}

/** input type for incrementing numeric columns in table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Inc_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Insert_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  area_unit_id?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  operations_pesticide?: InputMaybe<Operations_Pesticide_Obj_Rel_Insert_Input>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  products_pesticide?: InputMaybe<Products_Pesticide_Obj_Rel_Insert_Input>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_area_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Operations_Applied_Pesticide_Max_Fields = {
  __typename?: 'operations_applied_pesticide_max_fields';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  area_unit_id?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  operation_id?: Maybe<Scalars['uuid']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  product_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Max_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operations_Applied_Pesticide_Min_Fields = {
  __typename?: 'operations_applied_pesticide_min_fields';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  area_unit_id?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  operation_id?: Maybe<Scalars['uuid']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  product_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Min_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Mutation_Response = {
  __typename?: 'operations_applied_pesticide_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Applied_Pesticide>;
};

/** on_conflict condition type for table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_On_Conflict = {
  constraint: Operations_Applied_Pesticide_Constraint;
  update_columns?: Array<Operations_Applied_Pesticide_Update_Column>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};

/** Ordering options when selecting data from "operations_applied_pesticide". */
export type Operations_Applied_Pesticide_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  operations_pesticide?: InputMaybe<Operations_Pesticide_Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  products_pesticide?: InputMaybe<Products_Pesticide_Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_area_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations_applied_pesticide */
export type Operations_Applied_Pesticide_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations_applied_pesticide" */
export enum Operations_Applied_Pesticide_Select_Column {
  /** column name */
  ApplicationArea = 'application_area',
  /** column name */
  AreaReportingValue = 'area_reporting_value',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OperationId = 'operation_id',
  /** column name */
  PriceReportingValue = 'price_reporting_value',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityReportingValue = 'quantity_reporting_value',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SharedAreaUnitId = 'shared_area_unit_id',
  /** column name */
  SharedQuantityUnitId = 'shared_quantity_unit_id',
  /** column name */
  SharedUnitPriceQuantityUnitId = 'shared_unit_price_quantity_unit_id',
  /** column name */
  TotalCost = 'total_cost',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceQuantityUnitId = 'unit_price_quantity_unit_id'
}

/** input type for updating data in table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Set_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  area_unit_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Operations_Applied_Pesticide_Stddev_Fields = {
  __typename?: 'operations_applied_pesticide_stddev_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Stddev_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operations_Applied_Pesticide_Stddev_Pop_Fields = {
  __typename?: 'operations_applied_pesticide_stddev_pop_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Stddev_Pop_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operations_Applied_Pesticide_Stddev_Samp_Fields = {
  __typename?: 'operations_applied_pesticide_stddev_samp_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Stddev_Samp_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Applied_Pesticide_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Applied_Pesticide_Stream_Cursor_Value_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  area_unit_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_cost?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Operations_Applied_Pesticide_Sum_Fields = {
  __typename?: 'operations_applied_pesticide_sum_fields';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_cost?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Sum_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** update columns of table "operations_applied_pesticide" */
export enum Operations_Applied_Pesticide_Update_Column {
  /** column name */
  ApplicationArea = 'application_area',
  /** column name */
  AreaReportingValue = 'area_reporting_value',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OperationId = 'operation_id',
  /** column name */
  PriceReportingValue = 'price_reporting_value',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityReportingValue = 'quantity_reporting_value',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SharedAreaUnitId = 'shared_area_unit_id',
  /** column name */
  SharedQuantityUnitId = 'shared_quantity_unit_id',
  /** column name */
  SharedUnitPriceQuantityUnitId = 'shared_unit_price_quantity_unit_id',
  /** column name */
  TotalCost = 'total_cost',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceQuantityUnitId = 'unit_price_quantity_unit_id'
}

export type Operations_Applied_Pesticide_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Applied_Pesticide_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Applied_Pesticide_Set_Input>;
  where: Operations_Applied_Pesticide_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Applied_Pesticide_Var_Pop_Fields = {
  __typename?: 'operations_applied_pesticide_var_pop_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Var_Pop_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operations_Applied_Pesticide_Var_Samp_Fields = {
  __typename?: 'operations_applied_pesticide_var_samp_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Var_Samp_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operations_Applied_Pesticide_Variance_Fields = {
  __typename?: 'operations_applied_pesticide_variance_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations_applied_pesticide" */
export type Operations_Applied_Pesticide_Variance_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** input type for inserting array relation for remote table "operations" */
export type Operations_Arr_Rel_Insert_Input = {
  data: Array<Operations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_On_Conflict>;
};

/** aggregate avg on columns */
export type Operations_Avg_Fields = {
  __typename?: 'operations_avg_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations" */
export type Operations_Avg_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations". All fields are combined with a logical 'AND'. */
export type Operations_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Bool_Exp>>;
  _not?: InputMaybe<Operations_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Bool_Exp>>;
  application_area?: InputMaybe<Float8_Comparison_Exp>;
  area_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  area_unit_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  crop_year?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_applied?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Geometry_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operation_attachments?: InputMaybe<Operation_Attachments_Bool_Exp>;
  operation_costs?: InputMaybe<Operation_Cost_Bool_Exp>;
  operations?: InputMaybe<Operations_Bool_Exp>;
  operations_fertiliser?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
  operations_harvest?: InputMaybe<Operations_Harvest_Bool_Exp>;
  operations_interculture?: InputMaybe<Operations_Interculture_Bool_Exp>;
  operations_irrigation?: InputMaybe<Operations_Irrigation_Bool_Exp>;
  operations_land_prep?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
  operations_pesticide?: InputMaybe<Operations_Pesticide_Bool_Exp>;
  operations_sowing?: InputMaybe<Operations_Sowing_Bool_Exp>;
  percent_field_cover?: InputMaybe<Float8_Comparison_Exp>;
  planned_operation_id?: InputMaybe<Uuid_Comparison_Exp>;
  plot_crop_id?: InputMaybe<String_Comparison_Exp>;
  plot_id?: InputMaybe<String_Comparison_Exp>;
  polymorphic_ctype_id?: InputMaybe<Int_Comparison_Exp>;
  primary_growth_stage_id?: InputMaybe<String_Comparison_Exp>;
  secondary_growth_stage_id?: InputMaybe<String_Comparison_Exp>;
  shared_area_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_area_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_plot?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_plot_crop?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_plot_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_plot_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_primary_growth_stage?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_primary_growth_stage_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_secondary_growth_stage?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_secondary_growth_stage_id?: InputMaybe<Bigint_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  voice_note_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations" */
export enum Operations_Constraint {
  /** unique or primary key constraint on columns "id" */
  OperationsPkey = 'operations_pkey'
}

/** columns and relationships of "operations_fertiliser" */
export type Operations_Fertiliser = {
  __typename?: 'operations_fertiliser';
  method_id: Scalars['uuid'];
  /** An object relationship */
  operation: Operations;
  /** An object relationship */
  operation_method: Operation_Methods;
  operation_ptr_id: Scalars['uuid'];
  /** An array relationship */
  operations_applied_fertilisers: Array<Operations_Applied_Fertiliser>;
  /** An aggregate relationship */
  operations_applied_fertilisers_aggregate: Operations_Applied_Fertiliser_Aggregate;
  /** An object relationship */
  shared_water_used_unit?: Maybe<Shared_Entity>;
  shared_water_used_unit_id?: Maybe<Scalars['bigint']>;
  water_used?: Maybe<Scalars['float8']>;
  water_used_unit_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "operations_fertiliser" */
export type Operations_FertiliserOperations_Applied_FertilisersArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};


/** columns and relationships of "operations_fertiliser" */
export type Operations_FertiliserOperations_Applied_Fertilisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};

/** aggregated selection of "operations_fertiliser" */
export type Operations_Fertiliser_Aggregate = {
  __typename?: 'operations_fertiliser_aggregate';
  aggregate?: Maybe<Operations_Fertiliser_Aggregate_Fields>;
  nodes: Array<Operations_Fertiliser>;
};

/** aggregate fields of "operations_fertiliser" */
export type Operations_Fertiliser_Aggregate_Fields = {
  __typename?: 'operations_fertiliser_aggregate_fields';
  avg?: Maybe<Operations_Fertiliser_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Fertiliser_Max_Fields>;
  min?: Maybe<Operations_Fertiliser_Min_Fields>;
  stddev?: Maybe<Operations_Fertiliser_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Fertiliser_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Fertiliser_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Fertiliser_Sum_Fields>;
  var_pop?: Maybe<Operations_Fertiliser_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Fertiliser_Var_Samp_Fields>;
  variance?: Maybe<Operations_Fertiliser_Variance_Fields>;
};


/** aggregate fields of "operations_fertiliser" */
export type Operations_Fertiliser_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Fertiliser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations_fertiliser" */
export type Operations_Fertiliser_Aggregate_Order_By = {
  avg?: InputMaybe<Operations_Fertiliser_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operations_Fertiliser_Max_Order_By>;
  min?: InputMaybe<Operations_Fertiliser_Min_Order_By>;
  stddev?: InputMaybe<Operations_Fertiliser_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operations_Fertiliser_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operations_Fertiliser_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operations_Fertiliser_Sum_Order_By>;
  var_pop?: InputMaybe<Operations_Fertiliser_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operations_Fertiliser_Var_Samp_Order_By>;
  variance?: InputMaybe<Operations_Fertiliser_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations_fertiliser" */
export type Operations_Fertiliser_Arr_Rel_Insert_Input = {
  data: Array<Operations_Fertiliser_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Fertiliser_On_Conflict>;
};

/** aggregate avg on columns */
export type Operations_Fertiliser_Avg_Fields = {
  __typename?: 'operations_fertiliser_avg_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations_fertiliser" */
export type Operations_Fertiliser_Avg_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations_fertiliser". All fields are combined with a logical 'AND'. */
export type Operations_Fertiliser_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Fertiliser_Bool_Exp>>;
  _not?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Fertiliser_Bool_Exp>>;
  method_id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operation_method?: InputMaybe<Operation_Methods_Bool_Exp>;
  operation_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
  operations_applied_fertilisers?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
  shared_water_used_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_water_used_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  water_used?: InputMaybe<Float8_Comparison_Exp>;
  water_used_unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations_fertiliser" */
export enum Operations_Fertiliser_Constraint {
  /** unique or primary key constraint on columns "operation_ptr_id" */
  OperationsFertiliserPkey = 'operations_fertiliser_pkey'
}

/** input type for incrementing numeric columns in table "operations_fertiliser" */
export type Operations_Fertiliser_Inc_Input = {
  shared_water_used_unit_id?: InputMaybe<Scalars['bigint']>;
  water_used?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "operations_fertiliser" */
export type Operations_Fertiliser_Insert_Input = {
  method_id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operation_method?: InputMaybe<Operation_Methods_Obj_Rel_Insert_Input>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  operations_applied_fertilisers?: InputMaybe<Operations_Applied_Fertiliser_Arr_Rel_Insert_Input>;
  shared_water_used_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_water_used_unit_id?: InputMaybe<Scalars['bigint']>;
  water_used?: InputMaybe<Scalars['float8']>;
  water_used_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Operations_Fertiliser_Max_Fields = {
  __typename?: 'operations_fertiliser_max_fields';
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
  shared_water_used_unit_id?: Maybe<Scalars['bigint']>;
  water_used?: Maybe<Scalars['float8']>;
  water_used_unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "operations_fertiliser" */
export type Operations_Fertiliser_Max_Order_By = {
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
  water_used_unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operations_Fertiliser_Min_Fields = {
  __typename?: 'operations_fertiliser_min_fields';
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
  shared_water_used_unit_id?: Maybe<Scalars['bigint']>;
  water_used?: Maybe<Scalars['float8']>;
  water_used_unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "operations_fertiliser" */
export type Operations_Fertiliser_Min_Order_By = {
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
  water_used_unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations_fertiliser" */
export type Operations_Fertiliser_Mutation_Response = {
  __typename?: 'operations_fertiliser_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Fertiliser>;
};

/** input type for inserting object relation for remote table "operations_fertiliser" */
export type Operations_Fertiliser_Obj_Rel_Insert_Input = {
  data: Operations_Fertiliser_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Fertiliser_On_Conflict>;
};

/** on_conflict condition type for table "operations_fertiliser" */
export type Operations_Fertiliser_On_Conflict = {
  constraint: Operations_Fertiliser_Constraint;
  update_columns?: Array<Operations_Fertiliser_Update_Column>;
  where?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
};

/** Ordering options when selecting data from "operations_fertiliser". */
export type Operations_Fertiliser_Order_By = {
  method_id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operation_method?: InputMaybe<Operation_Methods_Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
  operations_applied_fertilisers_aggregate?: InputMaybe<Operations_Applied_Fertiliser_Aggregate_Order_By>;
  shared_water_used_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
  water_used_unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations_fertiliser */
export type Operations_Fertiliser_Pk_Columns_Input = {
  operation_ptr_id: Scalars['uuid'];
};

/** select columns of table "operations_fertiliser" */
export enum Operations_Fertiliser_Select_Column {
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id',
  /** column name */
  SharedWaterUsedUnitId = 'shared_water_used_unit_id',
  /** column name */
  WaterUsed = 'water_used',
  /** column name */
  WaterUsedUnitId = 'water_used_unit_id'
}

/** input type for updating data in table "operations_fertiliser" */
export type Operations_Fertiliser_Set_Input = {
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  shared_water_used_unit_id?: InputMaybe<Scalars['bigint']>;
  water_used?: InputMaybe<Scalars['float8']>;
  water_used_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Operations_Fertiliser_Stddev_Fields = {
  __typename?: 'operations_fertiliser_stddev_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations_fertiliser" */
export type Operations_Fertiliser_Stddev_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operations_Fertiliser_Stddev_Pop_Fields = {
  __typename?: 'operations_fertiliser_stddev_pop_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations_fertiliser" */
export type Operations_Fertiliser_Stddev_Pop_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operations_Fertiliser_Stddev_Samp_Fields = {
  __typename?: 'operations_fertiliser_stddev_samp_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations_fertiliser" */
export type Operations_Fertiliser_Stddev_Samp_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operations_fertiliser" */
export type Operations_Fertiliser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Fertiliser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Fertiliser_Stream_Cursor_Value_Input = {
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  shared_water_used_unit_id?: InputMaybe<Scalars['bigint']>;
  water_used?: InputMaybe<Scalars['float8']>;
  water_used_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Operations_Fertiliser_Sum_Fields = {
  __typename?: 'operations_fertiliser_sum_fields';
  shared_water_used_unit_id?: Maybe<Scalars['bigint']>;
  water_used?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "operations_fertiliser" */
export type Operations_Fertiliser_Sum_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** update columns of table "operations_fertiliser" */
export enum Operations_Fertiliser_Update_Column {
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id',
  /** column name */
  SharedWaterUsedUnitId = 'shared_water_used_unit_id',
  /** column name */
  WaterUsed = 'water_used',
  /** column name */
  WaterUsedUnitId = 'water_used_unit_id'
}

export type Operations_Fertiliser_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Fertiliser_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Fertiliser_Set_Input>;
  where: Operations_Fertiliser_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Fertiliser_Var_Pop_Fields = {
  __typename?: 'operations_fertiliser_var_pop_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations_fertiliser" */
export type Operations_Fertiliser_Var_Pop_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operations_Fertiliser_Var_Samp_Fields = {
  __typename?: 'operations_fertiliser_var_samp_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations_fertiliser" */
export type Operations_Fertiliser_Var_Samp_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operations_Fertiliser_Variance_Fields = {
  __typename?: 'operations_fertiliser_variance_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations_fertiliser" */
export type Operations_Fertiliser_Variance_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations_harvest" */
export type Operations_Harvest = {
  __typename?: 'operations_harvest';
  is_final: Scalars['Boolean'];
  method_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  operation: Operations;
  /** An object relationship */
  operation_method?: Maybe<Operation_Methods>;
  operation_ptr_id: Scalars['uuid'];
  /** An array relationship */
  operations_harvest_outputs: Array<Operations_Harvest_Output>;
  /** An aggregate relationship */
  operations_harvest_outputs_aggregate: Operations_Harvest_Output_Aggregate;
  produce_type?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit: Array<Si_Unit>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  shared_quantity_unit?: Maybe<Shared_Entity>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "operations_harvest" */
export type Operations_HarvestOperations_Harvest_OutputsArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Output_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Output_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
};


/** columns and relationships of "operations_harvest" */
export type Operations_HarvestOperations_Harvest_Outputs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Output_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Output_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
};


/** columns and relationships of "operations_harvest" */
export type Operations_HarvestQuantity_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Operations_Harvestquantity_Unit>;
};

/** aggregated selection of "operations_harvest" */
export type Operations_Harvest_Aggregate = {
  __typename?: 'operations_harvest_aggregate';
  aggregate?: Maybe<Operations_Harvest_Aggregate_Fields>;
  nodes: Array<Operations_Harvest>;
};

/** aggregate fields of "operations_harvest" */
export type Operations_Harvest_Aggregate_Fields = {
  __typename?: 'operations_harvest_aggregate_fields';
  avg?: Maybe<Operations_Harvest_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Harvest_Max_Fields>;
  min?: Maybe<Operations_Harvest_Min_Fields>;
  stddev?: Maybe<Operations_Harvest_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Harvest_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Harvest_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Harvest_Sum_Fields>;
  var_pop?: Maybe<Operations_Harvest_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Harvest_Var_Samp_Fields>;
  variance?: Maybe<Operations_Harvest_Variance_Fields>;
};


/** aggregate fields of "operations_harvest" */
export type Operations_Harvest_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Harvest_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Operations_Harvest_Avg_Fields = {
  __typename?: 'operations_harvest_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations_harvest". All fields are combined with a logical 'AND'. */
export type Operations_Harvest_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Harvest_Bool_Exp>>;
  _not?: InputMaybe<Operations_Harvest_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Harvest_Bool_Exp>>;
  is_final?: InputMaybe<Boolean_Comparison_Exp>;
  method_id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operation_method?: InputMaybe<Operation_Methods_Bool_Exp>;
  operation_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
  operations_harvest_outputs?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
  produce_type?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  quantity_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  quantity_unit_id?: InputMaybe<String_Comparison_Exp>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations_harvest" */
export enum Operations_Harvest_Constraint {
  /** unique or primary key constraint on columns "operation_ptr_id" */
  OperationsHarvestPkey = 'operations_harvest_pkey'
}

/** input type for incrementing numeric columns in table "operations_harvest" */
export type Operations_Harvest_Inc_Input = {
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "operations_harvest" */
export type Operations_Harvest_Insert_Input = {
  is_final?: InputMaybe<Scalars['Boolean']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operation_method?: InputMaybe<Operation_Methods_Obj_Rel_Insert_Input>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  operations_harvest_outputs?: InputMaybe<Operations_Harvest_Output_Arr_Rel_Insert_Input>;
  produce_type?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Operations_Harvest_Max_Fields = {
  __typename?: 'operations_harvest_max_fields';
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
  produce_type?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Operations_Harvest_Min_Fields = {
  __typename?: 'operations_harvest_min_fields';
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
  produce_type?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "operations_harvest" */
export type Operations_Harvest_Mutation_Response = {
  __typename?: 'operations_harvest_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Harvest>;
};

/** input type for inserting object relation for remote table "operations_harvest" */
export type Operations_Harvest_Obj_Rel_Insert_Input = {
  data: Operations_Harvest_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Harvest_On_Conflict>;
};

/** on_conflict condition type for table "operations_harvest" */
export type Operations_Harvest_On_Conflict = {
  constraint: Operations_Harvest_Constraint;
  update_columns?: Array<Operations_Harvest_Update_Column>;
  where?: InputMaybe<Operations_Harvest_Bool_Exp>;
};

/** Ordering options when selecting data from "operations_harvest". */
export type Operations_Harvest_Order_By = {
  is_final?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operation_method?: InputMaybe<Operation_Methods_Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
  operations_harvest_outputs_aggregate?: InputMaybe<Operations_Harvest_Output_Aggregate_Order_By>;
  produce_type?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations_harvest_output" */
export type Operations_Harvest_Output = {
  __typename?: 'operations_harvest_output';
  /** An object relationship */
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  operation_id: Scalars['uuid'];
  /** An object relationship */
  operations_harvest: Operations_Harvest;
  price_reporting_value?: Maybe<Scalars['float8']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  shared_quantity_unit?: Maybe<Shared_Entity>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  shared_unit_price_quantity_unit?: Maybe<Shared_Entity>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_value?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "operations_harvest_output" */
export type Operations_Harvest_Output_Aggregate = {
  __typename?: 'operations_harvest_output_aggregate';
  aggregate?: Maybe<Operations_Harvest_Output_Aggregate_Fields>;
  nodes: Array<Operations_Harvest_Output>;
};

/** aggregate fields of "operations_harvest_output" */
export type Operations_Harvest_Output_Aggregate_Fields = {
  __typename?: 'operations_harvest_output_aggregate_fields';
  avg?: Maybe<Operations_Harvest_Output_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Harvest_Output_Max_Fields>;
  min?: Maybe<Operations_Harvest_Output_Min_Fields>;
  stddev?: Maybe<Operations_Harvest_Output_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Harvest_Output_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Harvest_Output_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Harvest_Output_Sum_Fields>;
  var_pop?: Maybe<Operations_Harvest_Output_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Harvest_Output_Var_Samp_Fields>;
  variance?: Maybe<Operations_Harvest_Output_Variance_Fields>;
};


/** aggregate fields of "operations_harvest_output" */
export type Operations_Harvest_Output_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Harvest_Output_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations_harvest_output" */
export type Operations_Harvest_Output_Aggregate_Order_By = {
  avg?: InputMaybe<Operations_Harvest_Output_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operations_Harvest_Output_Max_Order_By>;
  min?: InputMaybe<Operations_Harvest_Output_Min_Order_By>;
  stddev?: InputMaybe<Operations_Harvest_Output_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operations_Harvest_Output_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operations_Harvest_Output_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operations_Harvest_Output_Sum_Order_By>;
  var_pop?: InputMaybe<Operations_Harvest_Output_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operations_Harvest_Output_Var_Samp_Order_By>;
  variance?: InputMaybe<Operations_Harvest_Output_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations_harvest_output" */
export type Operations_Harvest_Output_Arr_Rel_Insert_Input = {
  data: Array<Operations_Harvest_Output_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Harvest_Output_On_Conflict>;
};

/** aggregate avg on columns */
export type Operations_Harvest_Output_Avg_Fields = {
  __typename?: 'operations_harvest_output_avg_fields';
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations_harvest_output" */
export type Operations_Harvest_Output_Avg_Order_By = {
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations_harvest_output". All fields are combined with a logical 'AND'. */
export type Operations_Harvest_Output_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Harvest_Output_Bool_Exp>>;
  _not?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Harvest_Output_Bool_Exp>>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  operation_id?: InputMaybe<Uuid_Comparison_Exp>;
  operations_harvest?: InputMaybe<Operations_Harvest_Bool_Exp>;
  price_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  quantity_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  quantity_unit_id?: InputMaybe<String_Comparison_Exp>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_value?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price_quantity_unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations_harvest_output" */
export enum Operations_Harvest_Output_Constraint {
  /** unique or primary key constraint on columns "id" */
  OperationsHarvestOutputPkey = 'operations_harvest_output_pkey'
}

/** input type for incrementing numeric columns in table "operations_harvest_output" */
export type Operations_Harvest_Output_Inc_Input = {
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_value?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations_harvest_output" */
export type Operations_Harvest_Output_Insert_Input = {
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  operations_harvest?: InputMaybe<Operations_Harvest_Obj_Rel_Insert_Input>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_value?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Operations_Harvest_Output_Max_Fields = {
  __typename?: 'operations_harvest_output_max_fields';
  currency_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  operation_id?: Maybe<Scalars['uuid']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_value?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "operations_harvest_output" */
export type Operations_Harvest_Output_Max_Order_By = {
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operations_Harvest_Output_Min_Fields = {
  __typename?: 'operations_harvest_output_min_fields';
  currency_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  operation_id?: Maybe<Scalars['uuid']>;
  price_reporting_value?: Maybe<Scalars['float8']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_value?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "operations_harvest_output" */
export type Operations_Harvest_Output_Min_Order_By = {
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations_harvest_output" */
export type Operations_Harvest_Output_Mutation_Response = {
  __typename?: 'operations_harvest_output_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Harvest_Output>;
};

/** on_conflict condition type for table "operations_harvest_output" */
export type Operations_Harvest_Output_On_Conflict = {
  constraint: Operations_Harvest_Output_Constraint;
  update_columns?: Array<Operations_Harvest_Output_Update_Column>;
  where?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
};

/** Ordering options when selecting data from "operations_harvest_output". */
export type Operations_Harvest_Output_Order_By = {
  currency?: InputMaybe<Currency_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  operation_id?: InputMaybe<Order_By>;
  operations_harvest?: InputMaybe<Operations_Harvest_Order_By>;
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_quantity_unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations_harvest_output */
export type Operations_Harvest_Output_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations_harvest_output" */
export enum Operations_Harvest_Output_Select_Column {
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OperationId = 'operation_id',
  /** column name */
  PriceReportingValue = 'price_reporting_value',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityReportingValue = 'quantity_reporting_value',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SharedQuantityUnitId = 'shared_quantity_unit_id',
  /** column name */
  SharedUnitPriceQuantityUnitId = 'shared_unit_price_quantity_unit_id',
  /** column name */
  TotalValue = 'total_value',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceQuantityUnitId = 'unit_price_quantity_unit_id'
}

/** input type for updating data in table "operations_harvest_output" */
export type Operations_Harvest_Output_Set_Input = {
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_value?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Operations_Harvest_Output_Stddev_Fields = {
  __typename?: 'operations_harvest_output_stddev_fields';
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations_harvest_output" */
export type Operations_Harvest_Output_Stddev_Order_By = {
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operations_Harvest_Output_Stddev_Pop_Fields = {
  __typename?: 'operations_harvest_output_stddev_pop_fields';
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations_harvest_output" */
export type Operations_Harvest_Output_Stddev_Pop_Order_By = {
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operations_Harvest_Output_Stddev_Samp_Fields = {
  __typename?: 'operations_harvest_output_stddev_samp_fields';
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations_harvest_output" */
export type Operations_Harvest_Output_Stddev_Samp_Order_By = {
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operations_harvest_output" */
export type Operations_Harvest_Output_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Harvest_Output_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Harvest_Output_Stream_Cursor_Value_Input = {
  currency_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  operation_id?: InputMaybe<Scalars['uuid']>;
  price_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  total_value?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  unit_price_quantity_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Operations_Harvest_Output_Sum_Fields = {
  __typename?: 'operations_harvest_output_sum_fields';
  price_reporting_value?: Maybe<Scalars['float8']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['bigint']>;
  total_value?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "operations_harvest_output" */
export type Operations_Harvest_Output_Sum_Order_By = {
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** update columns of table "operations_harvest_output" */
export enum Operations_Harvest_Output_Update_Column {
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OperationId = 'operation_id',
  /** column name */
  PriceReportingValue = 'price_reporting_value',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityReportingValue = 'quantity_reporting_value',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SharedQuantityUnitId = 'shared_quantity_unit_id',
  /** column name */
  SharedUnitPriceQuantityUnitId = 'shared_unit_price_quantity_unit_id',
  /** column name */
  TotalValue = 'total_value',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceQuantityUnitId = 'unit_price_quantity_unit_id'
}

export type Operations_Harvest_Output_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Harvest_Output_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Harvest_Output_Set_Input>;
  where: Operations_Harvest_Output_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Harvest_Output_Var_Pop_Fields = {
  __typename?: 'operations_harvest_output_var_pop_fields';
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations_harvest_output" */
export type Operations_Harvest_Output_Var_Pop_Order_By = {
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operations_Harvest_Output_Var_Samp_Fields = {
  __typename?: 'operations_harvest_output_var_samp_fields';
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations_harvest_output" */
export type Operations_Harvest_Output_Var_Samp_Order_By = {
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operations_Harvest_Output_Variance_Fields = {
  __typename?: 'operations_harvest_output_variance_fields';
  price_reporting_value?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
  shared_unit_price_quantity_unit_id?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations_harvest_output" */
export type Operations_Harvest_Output_Variance_Order_By = {
  price_reporting_value?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
  shared_unit_price_quantity_unit_id?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations_harvest */
export type Operations_Harvest_Pk_Columns_Input = {
  operation_ptr_id: Scalars['uuid'];
};

/** select columns of table "operations_harvest" */
export enum Operations_Harvest_Select_Column {
  /** column name */
  IsFinal = 'is_final',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id',
  /** column name */
  ProduceType = 'produce_type',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityReportingValue = 'quantity_reporting_value',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SharedQuantityUnitId = 'shared_quantity_unit_id'
}

/** input type for updating data in table "operations_harvest" */
export type Operations_Harvest_Set_Input = {
  is_final?: InputMaybe<Scalars['Boolean']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  produce_type?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Operations_Harvest_Stddev_Fields = {
  __typename?: 'operations_harvest_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Operations_Harvest_Stddev_Pop_Fields = {
  __typename?: 'operations_harvest_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Operations_Harvest_Stddev_Samp_Fields = {
  __typename?: 'operations_harvest_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "operations_harvest" */
export type Operations_Harvest_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Harvest_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Harvest_Stream_Cursor_Value_Input = {
  is_final?: InputMaybe<Scalars['Boolean']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  produce_type?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Operations_Harvest_Sum_Fields = {
  __typename?: 'operations_harvest_sum_fields';
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "operations_harvest" */
export enum Operations_Harvest_Update_Column {
  /** column name */
  IsFinal = 'is_final',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id',
  /** column name */
  ProduceType = 'produce_type',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityReportingValue = 'quantity_reporting_value',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SharedQuantityUnitId = 'shared_quantity_unit_id'
}

export type Operations_Harvest_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Harvest_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Harvest_Set_Input>;
  where: Operations_Harvest_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Harvest_Var_Pop_Fields = {
  __typename?: 'operations_harvest_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Operations_Harvest_Var_Samp_Fields = {
  __typename?: 'operations_harvest_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Operations_Harvest_Variance_Fields = {
  __typename?: 'operations_harvest_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "operations" */
export type Operations_Inc_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  percent_field_cover?: InputMaybe<Scalars['float8']>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_id?: InputMaybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  voice_note_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "operations" */
export type Operations_Insert_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  area_unit_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_year?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_applied?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geometry']>;
  notes?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operation_attachments?: InputMaybe<Operation_Attachments_Arr_Rel_Insert_Input>;
  operation_costs?: InputMaybe<Operation_Cost_Arr_Rel_Insert_Input>;
  operations?: InputMaybe<Operations_Arr_Rel_Insert_Input>;
  operations_fertiliser?: InputMaybe<Operations_Fertiliser_Obj_Rel_Insert_Input>;
  operations_harvest?: InputMaybe<Operations_Harvest_Obj_Rel_Insert_Input>;
  operations_interculture?: InputMaybe<Operations_Interculture_Obj_Rel_Insert_Input>;
  operations_irrigation?: InputMaybe<Operations_Irrigation_Obj_Rel_Insert_Input>;
  operations_land_prep?: InputMaybe<Operations_Land_Prep_Obj_Rel_Insert_Input>;
  operations_pesticide?: InputMaybe<Operations_Pesticide_Obj_Rel_Insert_Input>;
  operations_sowing?: InputMaybe<Operations_Sowing_Obj_Rel_Insert_Input>;
  percent_field_cover?: InputMaybe<Scalars['float8']>;
  planned_operation_id?: InputMaybe<Scalars['uuid']>;
  plot_crop_id?: InputMaybe<Scalars['String']>;
  plot_id?: InputMaybe<Scalars['String']>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage_id?: InputMaybe<Scalars['String']>;
  secondary_growth_stage_id?: InputMaybe<Scalars['String']>;
  shared_area_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_plot?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_plot_crop?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_id?: InputMaybe<Scalars['bigint']>;
  shared_primary_growth_stage?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_primary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  shared_secondary_growth_stage?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_secondary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  voice_note_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "operations_interculture" */
export type Operations_Interculture = {
  __typename?: 'operations_interculture';
  depth?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['Int']>;
  method_id: Scalars['uuid'];
  /** An object relationship */
  operation: Operations;
  /** An object relationship */
  operation_method: Operation_Methods;
  operation_ptr_id: Scalars['uuid'];
};

/** aggregated selection of "operations_interculture" */
export type Operations_Interculture_Aggregate = {
  __typename?: 'operations_interculture_aggregate';
  aggregate?: Maybe<Operations_Interculture_Aggregate_Fields>;
  nodes: Array<Operations_Interculture>;
};

/** aggregate fields of "operations_interculture" */
export type Operations_Interculture_Aggregate_Fields = {
  __typename?: 'operations_interculture_aggregate_fields';
  avg?: Maybe<Operations_Interculture_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Interculture_Max_Fields>;
  min?: Maybe<Operations_Interculture_Min_Fields>;
  stddev?: Maybe<Operations_Interculture_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Interculture_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Interculture_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Interculture_Sum_Fields>;
  var_pop?: Maybe<Operations_Interculture_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Interculture_Var_Samp_Fields>;
  variance?: Maybe<Operations_Interculture_Variance_Fields>;
};


/** aggregate fields of "operations_interculture" */
export type Operations_Interculture_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Interculture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations_interculture" */
export type Operations_Interculture_Aggregate_Order_By = {
  avg?: InputMaybe<Operations_Interculture_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operations_Interculture_Max_Order_By>;
  min?: InputMaybe<Operations_Interculture_Min_Order_By>;
  stddev?: InputMaybe<Operations_Interculture_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operations_Interculture_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operations_Interculture_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operations_Interculture_Sum_Order_By>;
  var_pop?: InputMaybe<Operations_Interculture_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operations_Interculture_Var_Samp_Order_By>;
  variance?: InputMaybe<Operations_Interculture_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations_interculture" */
export type Operations_Interculture_Arr_Rel_Insert_Input = {
  data: Array<Operations_Interculture_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Interculture_On_Conflict>;
};

/** aggregate avg on columns */
export type Operations_Interculture_Avg_Fields = {
  __typename?: 'operations_interculture_avg_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations_interculture" */
export type Operations_Interculture_Avg_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations_interculture". All fields are combined with a logical 'AND'. */
export type Operations_Interculture_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Interculture_Bool_Exp>>;
  _not?: InputMaybe<Operations_Interculture_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Interculture_Bool_Exp>>;
  depth?: InputMaybe<Float8_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  method_id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operation_method?: InputMaybe<Operation_Methods_Bool_Exp>;
  operation_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations_interculture" */
export enum Operations_Interculture_Constraint {
  /** unique or primary key constraint on columns "operation_ptr_id" */
  OperationsInterculturePkey = 'operations_interculture_pkey'
}

/** input type for incrementing numeric columns in table "operations_interculture" */
export type Operations_Interculture_Inc_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  duration?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "operations_interculture" */
export type Operations_Interculture_Insert_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  duration?: InputMaybe<Scalars['Int']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operation_method?: InputMaybe<Operation_Methods_Obj_Rel_Insert_Input>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Operations_Interculture_Max_Fields = {
  __typename?: 'operations_interculture_max_fields';
  depth?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['Int']>;
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "operations_interculture" */
export type Operations_Interculture_Max_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operations_Interculture_Min_Fields = {
  __typename?: 'operations_interculture_min_fields';
  depth?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['Int']>;
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "operations_interculture" */
export type Operations_Interculture_Min_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations_interculture" */
export type Operations_Interculture_Mutation_Response = {
  __typename?: 'operations_interculture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Interculture>;
};

/** input type for inserting object relation for remote table "operations_interculture" */
export type Operations_Interculture_Obj_Rel_Insert_Input = {
  data: Operations_Interculture_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Interculture_On_Conflict>;
};

/** on_conflict condition type for table "operations_interculture" */
export type Operations_Interculture_On_Conflict = {
  constraint: Operations_Interculture_Constraint;
  update_columns?: Array<Operations_Interculture_Update_Column>;
  where?: InputMaybe<Operations_Interculture_Bool_Exp>;
};

/** Ordering options when selecting data from "operations_interculture". */
export type Operations_Interculture_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operation_method?: InputMaybe<Operation_Methods_Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations_interculture */
export type Operations_Interculture_Pk_Columns_Input = {
  operation_ptr_id: Scalars['uuid'];
};

/** select columns of table "operations_interculture" */
export enum Operations_Interculture_Select_Column {
  /** column name */
  Depth = 'depth',
  /** column name */
  Duration = 'duration',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id'
}

/** input type for updating data in table "operations_interculture" */
export type Operations_Interculture_Set_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  duration?: InputMaybe<Scalars['Int']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Operations_Interculture_Stddev_Fields = {
  __typename?: 'operations_interculture_stddev_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations_interculture" */
export type Operations_Interculture_Stddev_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operations_Interculture_Stddev_Pop_Fields = {
  __typename?: 'operations_interculture_stddev_pop_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations_interculture" */
export type Operations_Interculture_Stddev_Pop_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operations_Interculture_Stddev_Samp_Fields = {
  __typename?: 'operations_interculture_stddev_samp_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations_interculture" */
export type Operations_Interculture_Stddev_Samp_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operations_interculture" */
export type Operations_Interculture_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Interculture_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Interculture_Stream_Cursor_Value_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  duration?: InputMaybe<Scalars['Int']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Operations_Interculture_Sum_Fields = {
  __typename?: 'operations_interculture_sum_fields';
  depth?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "operations_interculture" */
export type Operations_Interculture_Sum_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** update columns of table "operations_interculture" */
export enum Operations_Interculture_Update_Column {
  /** column name */
  Depth = 'depth',
  /** column name */
  Duration = 'duration',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id'
}

export type Operations_Interculture_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Interculture_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Interculture_Set_Input>;
  where: Operations_Interculture_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Interculture_Var_Pop_Fields = {
  __typename?: 'operations_interculture_var_pop_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations_interculture" */
export type Operations_Interculture_Var_Pop_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operations_Interculture_Var_Samp_Fields = {
  __typename?: 'operations_interculture_var_samp_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations_interculture" */
export type Operations_Interculture_Var_Samp_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operations_Interculture_Variance_Fields = {
  __typename?: 'operations_interculture_variance_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations_interculture" */
export type Operations_Interculture_Variance_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations_irrigation" */
export type Operations_Irrigation = {
  __typename?: 'operations_irrigation';
  depth?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['Int']>;
  method_id: Scalars['uuid'];
  /** An object relationship */
  operation: Operations;
  /** An object relationship */
  operation_method: Operation_Methods;
  operation_ptr_id: Scalars['uuid'];
};

/** aggregated selection of "operations_irrigation" */
export type Operations_Irrigation_Aggregate = {
  __typename?: 'operations_irrigation_aggregate';
  aggregate?: Maybe<Operations_Irrigation_Aggregate_Fields>;
  nodes: Array<Operations_Irrigation>;
};

/** aggregate fields of "operations_irrigation" */
export type Operations_Irrigation_Aggregate_Fields = {
  __typename?: 'operations_irrigation_aggregate_fields';
  avg?: Maybe<Operations_Irrigation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Irrigation_Max_Fields>;
  min?: Maybe<Operations_Irrigation_Min_Fields>;
  stddev?: Maybe<Operations_Irrigation_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Irrigation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Irrigation_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Irrigation_Sum_Fields>;
  var_pop?: Maybe<Operations_Irrigation_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Irrigation_Var_Samp_Fields>;
  variance?: Maybe<Operations_Irrigation_Variance_Fields>;
};


/** aggregate fields of "operations_irrigation" */
export type Operations_Irrigation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Irrigation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations_irrigation" */
export type Operations_Irrigation_Aggregate_Order_By = {
  avg?: InputMaybe<Operations_Irrigation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operations_Irrigation_Max_Order_By>;
  min?: InputMaybe<Operations_Irrigation_Min_Order_By>;
  stddev?: InputMaybe<Operations_Irrigation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operations_Irrigation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operations_Irrigation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operations_Irrigation_Sum_Order_By>;
  var_pop?: InputMaybe<Operations_Irrigation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operations_Irrigation_Var_Samp_Order_By>;
  variance?: InputMaybe<Operations_Irrigation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations_irrigation" */
export type Operations_Irrigation_Arr_Rel_Insert_Input = {
  data: Array<Operations_Irrigation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Irrigation_On_Conflict>;
};

/** aggregate avg on columns */
export type Operations_Irrigation_Avg_Fields = {
  __typename?: 'operations_irrigation_avg_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations_irrigation" */
export type Operations_Irrigation_Avg_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations_irrigation". All fields are combined with a logical 'AND'. */
export type Operations_Irrigation_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Irrigation_Bool_Exp>>;
  _not?: InputMaybe<Operations_Irrigation_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Irrigation_Bool_Exp>>;
  depth?: InputMaybe<Float8_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  method_id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operation_method?: InputMaybe<Operation_Methods_Bool_Exp>;
  operation_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations_irrigation" */
export enum Operations_Irrigation_Constraint {
  /** unique or primary key constraint on columns "operation_ptr_id" */
  OperationsIrrigationPkey = 'operations_irrigation_pkey'
}

/** input type for incrementing numeric columns in table "operations_irrigation" */
export type Operations_Irrigation_Inc_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  duration?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "operations_irrigation" */
export type Operations_Irrigation_Insert_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  duration?: InputMaybe<Scalars['Int']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operation_method?: InputMaybe<Operation_Methods_Obj_Rel_Insert_Input>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Operations_Irrigation_Max_Fields = {
  __typename?: 'operations_irrigation_max_fields';
  depth?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['Int']>;
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "operations_irrigation" */
export type Operations_Irrigation_Max_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operations_Irrigation_Min_Fields = {
  __typename?: 'operations_irrigation_min_fields';
  depth?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['Int']>;
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "operations_irrigation" */
export type Operations_Irrigation_Min_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations_irrigation" */
export type Operations_Irrigation_Mutation_Response = {
  __typename?: 'operations_irrigation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Irrigation>;
};

/** input type for inserting object relation for remote table "operations_irrigation" */
export type Operations_Irrigation_Obj_Rel_Insert_Input = {
  data: Operations_Irrigation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Irrigation_On_Conflict>;
};

/** on_conflict condition type for table "operations_irrigation" */
export type Operations_Irrigation_On_Conflict = {
  constraint: Operations_Irrigation_Constraint;
  update_columns?: Array<Operations_Irrigation_Update_Column>;
  where?: InputMaybe<Operations_Irrigation_Bool_Exp>;
};

/** Ordering options when selecting data from "operations_irrigation". */
export type Operations_Irrigation_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operation_method?: InputMaybe<Operation_Methods_Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations_irrigation */
export type Operations_Irrigation_Pk_Columns_Input = {
  operation_ptr_id: Scalars['uuid'];
};

/** select columns of table "operations_irrigation" */
export enum Operations_Irrigation_Select_Column {
  /** column name */
  Depth = 'depth',
  /** column name */
  Duration = 'duration',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id'
}

/** input type for updating data in table "operations_irrigation" */
export type Operations_Irrigation_Set_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  duration?: InputMaybe<Scalars['Int']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Operations_Irrigation_Stddev_Fields = {
  __typename?: 'operations_irrigation_stddev_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations_irrigation" */
export type Operations_Irrigation_Stddev_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operations_Irrigation_Stddev_Pop_Fields = {
  __typename?: 'operations_irrigation_stddev_pop_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations_irrigation" */
export type Operations_Irrigation_Stddev_Pop_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operations_Irrigation_Stddev_Samp_Fields = {
  __typename?: 'operations_irrigation_stddev_samp_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations_irrigation" */
export type Operations_Irrigation_Stddev_Samp_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operations_irrigation" */
export type Operations_Irrigation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Irrigation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Irrigation_Stream_Cursor_Value_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  duration?: InputMaybe<Scalars['Int']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Operations_Irrigation_Sum_Fields = {
  __typename?: 'operations_irrigation_sum_fields';
  depth?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "operations_irrigation" */
export type Operations_Irrigation_Sum_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** update columns of table "operations_irrigation" */
export enum Operations_Irrigation_Update_Column {
  /** column name */
  Depth = 'depth',
  /** column name */
  Duration = 'duration',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id'
}

export type Operations_Irrigation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Irrigation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Irrigation_Set_Input>;
  where: Operations_Irrigation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Irrigation_Var_Pop_Fields = {
  __typename?: 'operations_irrigation_var_pop_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations_irrigation" */
export type Operations_Irrigation_Var_Pop_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operations_Irrigation_Var_Samp_Fields = {
  __typename?: 'operations_irrigation_var_samp_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations_irrigation" */
export type Operations_Irrigation_Var_Samp_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operations_Irrigation_Variance_Fields = {
  __typename?: 'operations_irrigation_variance_fields';
  depth?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations_irrigation" */
export type Operations_Irrigation_Variance_Order_By = {
  depth?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations_land_prep" */
export type Operations_Land_Prep = {
  __typename?: 'operations_land_prep';
  method_id: Scalars['uuid'];
  /** An object relationship */
  operation: Operations;
  /** An object relationship */
  operation_method: Operation_Methods;
  operation_ptr_id: Scalars['uuid'];
};

/** aggregated selection of "operations_land_prep" */
export type Operations_Land_Prep_Aggregate = {
  __typename?: 'operations_land_prep_aggregate';
  aggregate?: Maybe<Operations_Land_Prep_Aggregate_Fields>;
  nodes: Array<Operations_Land_Prep>;
};

/** aggregate fields of "operations_land_prep" */
export type Operations_Land_Prep_Aggregate_Fields = {
  __typename?: 'operations_land_prep_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Operations_Land_Prep_Max_Fields>;
  min?: Maybe<Operations_Land_Prep_Min_Fields>;
};


/** aggregate fields of "operations_land_prep" */
export type Operations_Land_Prep_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Land_Prep_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations_land_prep" */
export type Operations_Land_Prep_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operations_Land_Prep_Max_Order_By>;
  min?: InputMaybe<Operations_Land_Prep_Min_Order_By>;
};

/** input type for inserting array relation for remote table "operations_land_prep" */
export type Operations_Land_Prep_Arr_Rel_Insert_Input = {
  data: Array<Operations_Land_Prep_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Land_Prep_On_Conflict>;
};

/** Boolean expression to filter rows from the table "operations_land_prep". All fields are combined with a logical 'AND'. */
export type Operations_Land_Prep_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Land_Prep_Bool_Exp>>;
  _not?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Land_Prep_Bool_Exp>>;
  method_id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operation_method?: InputMaybe<Operation_Methods_Bool_Exp>;
  operation_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations_land_prep" */
export enum Operations_Land_Prep_Constraint {
  /** unique or primary key constraint on columns "operation_ptr_id" */
  OperationsLandPrepPkey = 'operations_land_prep_pkey'
}

/** input type for inserting data into table "operations_land_prep" */
export type Operations_Land_Prep_Insert_Input = {
  method_id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operation_method?: InputMaybe<Operation_Methods_Obj_Rel_Insert_Input>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Operations_Land_Prep_Max_Fields = {
  __typename?: 'operations_land_prep_max_fields';
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "operations_land_prep" */
export type Operations_Land_Prep_Max_Order_By = {
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operations_Land_Prep_Min_Fields = {
  __typename?: 'operations_land_prep_min_fields';
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "operations_land_prep" */
export type Operations_Land_Prep_Min_Order_By = {
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations_land_prep" */
export type Operations_Land_Prep_Mutation_Response = {
  __typename?: 'operations_land_prep_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Land_Prep>;
};

/** input type for inserting object relation for remote table "operations_land_prep" */
export type Operations_Land_Prep_Obj_Rel_Insert_Input = {
  data: Operations_Land_Prep_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Land_Prep_On_Conflict>;
};

/** on_conflict condition type for table "operations_land_prep" */
export type Operations_Land_Prep_On_Conflict = {
  constraint: Operations_Land_Prep_Constraint;
  update_columns?: Array<Operations_Land_Prep_Update_Column>;
  where?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
};

/** Ordering options when selecting data from "operations_land_prep". */
export type Operations_Land_Prep_Order_By = {
  method_id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operation_method?: InputMaybe<Operation_Methods_Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations_land_prep */
export type Operations_Land_Prep_Pk_Columns_Input = {
  operation_ptr_id: Scalars['uuid'];
};

/** select columns of table "operations_land_prep" */
export enum Operations_Land_Prep_Select_Column {
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id'
}

/** input type for updating data in table "operations_land_prep" */
export type Operations_Land_Prep_Set_Input = {
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "operations_land_prep" */
export type Operations_Land_Prep_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Land_Prep_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Land_Prep_Stream_Cursor_Value_Input = {
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "operations_land_prep" */
export enum Operations_Land_Prep_Update_Column {
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id'
}

export type Operations_Land_Prep_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Land_Prep_Set_Input>;
  where: Operations_Land_Prep_Bool_Exp;
};

/** aggregate max on columns */
export type Operations_Max_Fields = {
  __typename?: 'operations_max_fields';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  area_unit_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  crop_year?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  percent_field_cover?: Maybe<Scalars['float8']>;
  planned_operation_id?: Maybe<Scalars['uuid']>;
  plot_crop_id?: Maybe<Scalars['String']>;
  plot_id?: Maybe<Scalars['String']>;
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  primary_growth_stage_id?: Maybe<Scalars['String']>;
  secondary_growth_stage_id?: Maybe<Scalars['String']>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  shared_plot_crop_id?: Maybe<Scalars['bigint']>;
  shared_plot_id?: Maybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['bigint']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  voice_note_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "operations" */
export type Operations_Max_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  planned_operation_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
  secondary_growth_stage_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operations_Min_Fields = {
  __typename?: 'operations_min_fields';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  area_unit_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  crop_year?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  percent_field_cover?: Maybe<Scalars['float8']>;
  planned_operation_id?: Maybe<Scalars['uuid']>;
  plot_crop_id?: Maybe<Scalars['String']>;
  plot_id?: Maybe<Scalars['String']>;
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  primary_growth_stage_id?: Maybe<Scalars['String']>;
  secondary_growth_stage_id?: Maybe<Scalars['String']>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  shared_plot_crop_id?: Maybe<Scalars['bigint']>;
  shared_plot_id?: Maybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['bigint']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  voice_note_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "operations" */
export type Operations_Min_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  planned_operation_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
  secondary_growth_stage_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations" */
export type Operations_Mutation_Response = {
  __typename?: 'operations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations>;
};

/** input type for inserting object relation for remote table "operations" */
export type Operations_Obj_Rel_Insert_Input = {
  data: Operations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_On_Conflict>;
};

/** on_conflict condition type for table "operations" */
export type Operations_On_Conflict = {
  constraint: Operations_Constraint;
  update_columns?: Array<Operations_Update_Column>;
  where?: InputMaybe<Operations_Bool_Exp>;
};

/** Ordering options when selecting data from "operations". */
export type Operations_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_applied?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operation_attachments_aggregate?: InputMaybe<Operation_Attachments_Aggregate_Order_By>;
  operation_costs_aggregate?: InputMaybe<Operation_Cost_Aggregate_Order_By>;
  operations_aggregate?: InputMaybe<Operations_Aggregate_Order_By>;
  operations_fertiliser?: InputMaybe<Operations_Fertiliser_Order_By>;
  operations_harvest?: InputMaybe<Operations_Harvest_Order_By>;
  operations_interculture?: InputMaybe<Operations_Interculture_Order_By>;
  operations_irrigation?: InputMaybe<Operations_Irrigation_Order_By>;
  operations_land_prep?: InputMaybe<Operations_Land_Prep_Order_By>;
  operations_pesticide?: InputMaybe<Operations_Pesticide_Order_By>;
  operations_sowing?: InputMaybe<Operations_Sowing_Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  planned_operation_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
  secondary_growth_stage_id?: InputMaybe<Order_By>;
  shared_area_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot?: InputMaybe<Shared_Entity_Order_By>;
  shared_plot_crop?: InputMaybe<Shared_Entity_Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage?: InputMaybe<Shared_Entity_Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage?: InputMaybe<Shared_Entity_Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations_pesticide" */
export type Operations_Pesticide = {
  __typename?: 'operations_pesticide';
  method_id: Scalars['uuid'];
  /** An object relationship */
  operation: Operations;
  /** An object relationship */
  operation_method: Operation_Methods;
  operation_ptr_id: Scalars['uuid'];
  /** An array relationship */
  operations_applied_pesticides: Array<Operations_Applied_Pesticide>;
  /** An aggregate relationship */
  operations_applied_pesticides_aggregate: Operations_Applied_Pesticide_Aggregate;
  /** An object relationship */
  shared_water_used_unit?: Maybe<Shared_Entity>;
  shared_water_used_unit_id?: Maybe<Scalars['bigint']>;
  spray_type?: Maybe<Scalars['String']>;
  water_used?: Maybe<Scalars['float8']>;
  water_used_unit_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "operations_pesticide" */
export type Operations_PesticideOperations_Applied_PesticidesArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};


/** columns and relationships of "operations_pesticide" */
export type Operations_PesticideOperations_Applied_Pesticides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};

/** aggregated selection of "operations_pesticide" */
export type Operations_Pesticide_Aggregate = {
  __typename?: 'operations_pesticide_aggregate';
  aggregate?: Maybe<Operations_Pesticide_Aggregate_Fields>;
  nodes: Array<Operations_Pesticide>;
};

/** aggregate fields of "operations_pesticide" */
export type Operations_Pesticide_Aggregate_Fields = {
  __typename?: 'operations_pesticide_aggregate_fields';
  avg?: Maybe<Operations_Pesticide_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Pesticide_Max_Fields>;
  min?: Maybe<Operations_Pesticide_Min_Fields>;
  stddev?: Maybe<Operations_Pesticide_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Pesticide_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Pesticide_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Pesticide_Sum_Fields>;
  var_pop?: Maybe<Operations_Pesticide_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Pesticide_Var_Samp_Fields>;
  variance?: Maybe<Operations_Pesticide_Variance_Fields>;
};


/** aggregate fields of "operations_pesticide" */
export type Operations_Pesticide_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Pesticide_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations_pesticide" */
export type Operations_Pesticide_Aggregate_Order_By = {
  avg?: InputMaybe<Operations_Pesticide_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operations_Pesticide_Max_Order_By>;
  min?: InputMaybe<Operations_Pesticide_Min_Order_By>;
  stddev?: InputMaybe<Operations_Pesticide_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operations_Pesticide_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operations_Pesticide_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operations_Pesticide_Sum_Order_By>;
  var_pop?: InputMaybe<Operations_Pesticide_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operations_Pesticide_Var_Samp_Order_By>;
  variance?: InputMaybe<Operations_Pesticide_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations_pesticide" */
export type Operations_Pesticide_Arr_Rel_Insert_Input = {
  data: Array<Operations_Pesticide_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Pesticide_On_Conflict>;
};

/** aggregate avg on columns */
export type Operations_Pesticide_Avg_Fields = {
  __typename?: 'operations_pesticide_avg_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations_pesticide" */
export type Operations_Pesticide_Avg_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations_pesticide". All fields are combined with a logical 'AND'. */
export type Operations_Pesticide_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Pesticide_Bool_Exp>>;
  _not?: InputMaybe<Operations_Pesticide_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Pesticide_Bool_Exp>>;
  method_id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operation_method?: InputMaybe<Operation_Methods_Bool_Exp>;
  operation_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
  operations_applied_pesticides?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
  shared_water_used_unit?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_water_used_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  spray_type?: InputMaybe<String_Comparison_Exp>;
  water_used?: InputMaybe<Float8_Comparison_Exp>;
  water_used_unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations_pesticide" */
export enum Operations_Pesticide_Constraint {
  /** unique or primary key constraint on columns "operation_ptr_id" */
  OperationsPesticidePkey = 'operations_pesticide_pkey'
}

/** input type for incrementing numeric columns in table "operations_pesticide" */
export type Operations_Pesticide_Inc_Input = {
  shared_water_used_unit_id?: InputMaybe<Scalars['bigint']>;
  water_used?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "operations_pesticide" */
export type Operations_Pesticide_Insert_Input = {
  method_id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operation_method?: InputMaybe<Operation_Methods_Obj_Rel_Insert_Input>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  operations_applied_pesticides?: InputMaybe<Operations_Applied_Pesticide_Arr_Rel_Insert_Input>;
  shared_water_used_unit?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_water_used_unit_id?: InputMaybe<Scalars['bigint']>;
  spray_type?: InputMaybe<Scalars['String']>;
  water_used?: InputMaybe<Scalars['float8']>;
  water_used_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Operations_Pesticide_Max_Fields = {
  __typename?: 'operations_pesticide_max_fields';
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
  shared_water_used_unit_id?: Maybe<Scalars['bigint']>;
  spray_type?: Maybe<Scalars['String']>;
  water_used?: Maybe<Scalars['float8']>;
  water_used_unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "operations_pesticide" */
export type Operations_Pesticide_Max_Order_By = {
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  spray_type?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
  water_used_unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operations_Pesticide_Min_Fields = {
  __typename?: 'operations_pesticide_min_fields';
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
  shared_water_used_unit_id?: Maybe<Scalars['bigint']>;
  spray_type?: Maybe<Scalars['String']>;
  water_used?: Maybe<Scalars['float8']>;
  water_used_unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "operations_pesticide" */
export type Operations_Pesticide_Min_Order_By = {
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  spray_type?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
  water_used_unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations_pesticide" */
export type Operations_Pesticide_Mutation_Response = {
  __typename?: 'operations_pesticide_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Pesticide>;
};

/** input type for inserting object relation for remote table "operations_pesticide" */
export type Operations_Pesticide_Obj_Rel_Insert_Input = {
  data: Operations_Pesticide_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Pesticide_On_Conflict>;
};

/** on_conflict condition type for table "operations_pesticide" */
export type Operations_Pesticide_On_Conflict = {
  constraint: Operations_Pesticide_Constraint;
  update_columns?: Array<Operations_Pesticide_Update_Column>;
  where?: InputMaybe<Operations_Pesticide_Bool_Exp>;
};

/** Ordering options when selecting data from "operations_pesticide". */
export type Operations_Pesticide_Order_By = {
  method_id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operation_method?: InputMaybe<Operation_Methods_Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
  operations_applied_pesticides_aggregate?: InputMaybe<Operations_Applied_Pesticide_Aggregate_Order_By>;
  shared_water_used_unit?: InputMaybe<Shared_Entity_Order_By>;
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  spray_type?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
  water_used_unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations_pesticide */
export type Operations_Pesticide_Pk_Columns_Input = {
  operation_ptr_id: Scalars['uuid'];
};

/** select columns of table "operations_pesticide" */
export enum Operations_Pesticide_Select_Column {
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id',
  /** column name */
  SharedWaterUsedUnitId = 'shared_water_used_unit_id',
  /** column name */
  SprayType = 'spray_type',
  /** column name */
  WaterUsed = 'water_used',
  /** column name */
  WaterUsedUnitId = 'water_used_unit_id'
}

/** input type for updating data in table "operations_pesticide" */
export type Operations_Pesticide_Set_Input = {
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  shared_water_used_unit_id?: InputMaybe<Scalars['bigint']>;
  spray_type?: InputMaybe<Scalars['String']>;
  water_used?: InputMaybe<Scalars['float8']>;
  water_used_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Operations_Pesticide_Stddev_Fields = {
  __typename?: 'operations_pesticide_stddev_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations_pesticide" */
export type Operations_Pesticide_Stddev_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operations_Pesticide_Stddev_Pop_Fields = {
  __typename?: 'operations_pesticide_stddev_pop_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations_pesticide" */
export type Operations_Pesticide_Stddev_Pop_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operations_Pesticide_Stddev_Samp_Fields = {
  __typename?: 'operations_pesticide_stddev_samp_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations_pesticide" */
export type Operations_Pesticide_Stddev_Samp_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operations_pesticide" */
export type Operations_Pesticide_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Pesticide_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Pesticide_Stream_Cursor_Value_Input = {
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  shared_water_used_unit_id?: InputMaybe<Scalars['bigint']>;
  spray_type?: InputMaybe<Scalars['String']>;
  water_used?: InputMaybe<Scalars['float8']>;
  water_used_unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Operations_Pesticide_Sum_Fields = {
  __typename?: 'operations_pesticide_sum_fields';
  shared_water_used_unit_id?: Maybe<Scalars['bigint']>;
  water_used?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "operations_pesticide" */
export type Operations_Pesticide_Sum_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** update columns of table "operations_pesticide" */
export enum Operations_Pesticide_Update_Column {
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id',
  /** column name */
  SharedWaterUsedUnitId = 'shared_water_used_unit_id',
  /** column name */
  SprayType = 'spray_type',
  /** column name */
  WaterUsed = 'water_used',
  /** column name */
  WaterUsedUnitId = 'water_used_unit_id'
}

export type Operations_Pesticide_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Pesticide_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Pesticide_Set_Input>;
  where: Operations_Pesticide_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Pesticide_Var_Pop_Fields = {
  __typename?: 'operations_pesticide_var_pop_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations_pesticide" */
export type Operations_Pesticide_Var_Pop_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operations_Pesticide_Var_Samp_Fields = {
  __typename?: 'operations_pesticide_var_samp_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations_pesticide" */
export type Operations_Pesticide_Var_Samp_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operations_Pesticide_Variance_Fields = {
  __typename?: 'operations_pesticide_variance_fields';
  shared_water_used_unit_id?: Maybe<Scalars['Float']>;
  water_used?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations_pesticide" */
export type Operations_Pesticide_Variance_Order_By = {
  shared_water_used_unit_id?: InputMaybe<Order_By>;
  water_used?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations */
export type Operations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations" */
export enum Operations_Select_Column {
  /** column name */
  ApplicationArea = 'application_area',
  /** column name */
  AreaReportingValue = 'area_reporting_value',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropYear = 'crop_year',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApplied = 'is_applied',
  /** column name */
  Location = 'location',
  /** column name */
  Notes = 'notes',
  /** column name */
  PercentFieldCover = 'percent_field_cover',
  /** column name */
  PlannedOperationId = 'planned_operation_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  PolymorphicCtypeId = 'polymorphic_ctype_id',
  /** column name */
  PrimaryGrowthStageId = 'primary_growth_stage_id',
  /** column name */
  SecondaryGrowthStageId = 'secondary_growth_stage_id',
  /** column name */
  SharedAreaUnitId = 'shared_area_unit_id',
  /** column name */
  SharedPlotCropId = 'shared_plot_crop_id',
  /** column name */
  SharedPlotId = 'shared_plot_id',
  /** column name */
  SharedPrimaryGrowthStageId = 'shared_primary_growth_stage_id',
  /** column name */
  SharedSecondaryGrowthStageId = 'shared_secondary_growth_stage_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VoiceNoteId = 'voice_note_id'
}

/** input type for updating data in table "operations" */
export type Operations_Set_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  area_unit_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_year?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_applied?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geometry']>;
  notes?: InputMaybe<Scalars['String']>;
  percent_field_cover?: InputMaybe<Scalars['float8']>;
  planned_operation_id?: InputMaybe<Scalars['uuid']>;
  plot_crop_id?: InputMaybe<Scalars['String']>;
  plot_id?: InputMaybe<Scalars['String']>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage_id?: InputMaybe<Scalars['String']>;
  secondary_growth_stage_id?: InputMaybe<Scalars['String']>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_id?: InputMaybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  voice_note_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "operations_sowing" */
export type Operations_Sowing = {
  __typename?: 'operations_sowing';
  depth?: Maybe<Scalars['float8']>;
  method_id: Scalars['uuid'];
  /** An object relationship */
  operation: Operations;
  /** An object relationship */
  operation_method: Operation_Methods;
  operation_ptr_id: Scalars['uuid'];
  plant_spacing?: Maybe<Scalars['float8']>;
  row_spacing?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "operations_sowing" */
export type Operations_Sowing_Aggregate = {
  __typename?: 'operations_sowing_aggregate';
  aggregate?: Maybe<Operations_Sowing_Aggregate_Fields>;
  nodes: Array<Operations_Sowing>;
};

/** aggregate fields of "operations_sowing" */
export type Operations_Sowing_Aggregate_Fields = {
  __typename?: 'operations_sowing_aggregate_fields';
  avg?: Maybe<Operations_Sowing_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Sowing_Max_Fields>;
  min?: Maybe<Operations_Sowing_Min_Fields>;
  stddev?: Maybe<Operations_Sowing_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Sowing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Sowing_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Sowing_Sum_Fields>;
  var_pop?: Maybe<Operations_Sowing_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Sowing_Var_Samp_Fields>;
  variance?: Maybe<Operations_Sowing_Variance_Fields>;
};


/** aggregate fields of "operations_sowing" */
export type Operations_Sowing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Sowing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations_sowing" */
export type Operations_Sowing_Aggregate_Order_By = {
  avg?: InputMaybe<Operations_Sowing_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operations_Sowing_Max_Order_By>;
  min?: InputMaybe<Operations_Sowing_Min_Order_By>;
  stddev?: InputMaybe<Operations_Sowing_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operations_Sowing_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operations_Sowing_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operations_Sowing_Sum_Order_By>;
  var_pop?: InputMaybe<Operations_Sowing_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operations_Sowing_Var_Samp_Order_By>;
  variance?: InputMaybe<Operations_Sowing_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations_sowing" */
export type Operations_Sowing_Arr_Rel_Insert_Input = {
  data: Array<Operations_Sowing_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Sowing_On_Conflict>;
};

/** aggregate avg on columns */
export type Operations_Sowing_Avg_Fields = {
  __typename?: 'operations_sowing_avg_fields';
  depth?: Maybe<Scalars['Float']>;
  plant_spacing?: Maybe<Scalars['Float']>;
  row_spacing?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations_sowing" */
export type Operations_Sowing_Avg_Order_By = {
  depth?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations_sowing". All fields are combined with a logical 'AND'. */
export type Operations_Sowing_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Sowing_Bool_Exp>>;
  _not?: InputMaybe<Operations_Sowing_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Sowing_Bool_Exp>>;
  depth?: InputMaybe<Float8_Comparison_Exp>;
  method_id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operation_method?: InputMaybe<Operation_Methods_Bool_Exp>;
  operation_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
  plant_spacing?: InputMaybe<Float8_Comparison_Exp>;
  row_spacing?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations_sowing" */
export enum Operations_Sowing_Constraint {
  /** unique or primary key constraint on columns "operation_ptr_id" */
  OperationsSowingPkey = 'operations_sowing_pkey'
}

/** input type for incrementing numeric columns in table "operations_sowing" */
export type Operations_Sowing_Inc_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  plant_spacing?: InputMaybe<Scalars['float8']>;
  row_spacing?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "operations_sowing" */
export type Operations_Sowing_Insert_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operation_method?: InputMaybe<Operation_Methods_Obj_Rel_Insert_Input>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  plant_spacing?: InputMaybe<Scalars['float8']>;
  row_spacing?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Operations_Sowing_Max_Fields = {
  __typename?: 'operations_sowing_max_fields';
  depth?: Maybe<Scalars['float8']>;
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
  plant_spacing?: Maybe<Scalars['float8']>;
  row_spacing?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "operations_sowing" */
export type Operations_Sowing_Max_Order_By = {
  depth?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operations_Sowing_Min_Fields = {
  __typename?: 'operations_sowing_min_fields';
  depth?: Maybe<Scalars['float8']>;
  method_id?: Maybe<Scalars['uuid']>;
  operation_ptr_id?: Maybe<Scalars['uuid']>;
  plant_spacing?: Maybe<Scalars['float8']>;
  row_spacing?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "operations_sowing" */
export type Operations_Sowing_Min_Order_By = {
  depth?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations_sowing" */
export type Operations_Sowing_Mutation_Response = {
  __typename?: 'operations_sowing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Sowing>;
};

/** input type for inserting object relation for remote table "operations_sowing" */
export type Operations_Sowing_Obj_Rel_Insert_Input = {
  data: Operations_Sowing_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_Sowing_On_Conflict>;
};

/** on_conflict condition type for table "operations_sowing" */
export type Operations_Sowing_On_Conflict = {
  constraint: Operations_Sowing_Constraint;
  update_columns?: Array<Operations_Sowing_Update_Column>;
  where?: InputMaybe<Operations_Sowing_Bool_Exp>;
};

/** Ordering options when selecting data from "operations_sowing". */
export type Operations_Sowing_Order_By = {
  depth?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operation_method?: InputMaybe<Operation_Methods_Order_By>;
  operation_ptr_id?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations_sowing */
export type Operations_Sowing_Pk_Columns_Input = {
  operation_ptr_id: Scalars['uuid'];
};

/** select columns of table "operations_sowing" */
export enum Operations_Sowing_Select_Column {
  /** column name */
  Depth = 'depth',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id',
  /** column name */
  PlantSpacing = 'plant_spacing',
  /** column name */
  RowSpacing = 'row_spacing'
}

/** input type for updating data in table "operations_sowing" */
export type Operations_Sowing_Set_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  plant_spacing?: InputMaybe<Scalars['float8']>;
  row_spacing?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Operations_Sowing_Stddev_Fields = {
  __typename?: 'operations_sowing_stddev_fields';
  depth?: Maybe<Scalars['Float']>;
  plant_spacing?: Maybe<Scalars['Float']>;
  row_spacing?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations_sowing" */
export type Operations_Sowing_Stddev_Order_By = {
  depth?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operations_Sowing_Stddev_Pop_Fields = {
  __typename?: 'operations_sowing_stddev_pop_fields';
  depth?: Maybe<Scalars['Float']>;
  plant_spacing?: Maybe<Scalars['Float']>;
  row_spacing?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations_sowing" */
export type Operations_Sowing_Stddev_Pop_Order_By = {
  depth?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operations_Sowing_Stddev_Samp_Fields = {
  __typename?: 'operations_sowing_stddev_samp_fields';
  depth?: Maybe<Scalars['Float']>;
  plant_spacing?: Maybe<Scalars['Float']>;
  row_spacing?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations_sowing" */
export type Operations_Sowing_Stddev_Samp_Order_By = {
  depth?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operations_sowing" */
export type Operations_Sowing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Sowing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Sowing_Stream_Cursor_Value_Input = {
  depth?: InputMaybe<Scalars['float8']>;
  method_id?: InputMaybe<Scalars['uuid']>;
  operation_ptr_id?: InputMaybe<Scalars['uuid']>;
  plant_spacing?: InputMaybe<Scalars['float8']>;
  row_spacing?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Operations_Sowing_Sum_Fields = {
  __typename?: 'operations_sowing_sum_fields';
  depth?: Maybe<Scalars['float8']>;
  plant_spacing?: Maybe<Scalars['float8']>;
  row_spacing?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "operations_sowing" */
export type Operations_Sowing_Sum_Order_By = {
  depth?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** update columns of table "operations_sowing" */
export enum Operations_Sowing_Update_Column {
  /** column name */
  Depth = 'depth',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  OperationPtrId = 'operation_ptr_id',
  /** column name */
  PlantSpacing = 'plant_spacing',
  /** column name */
  RowSpacing = 'row_spacing'
}

export type Operations_Sowing_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Sowing_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Sowing_Set_Input>;
  where: Operations_Sowing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Sowing_Var_Pop_Fields = {
  __typename?: 'operations_sowing_var_pop_fields';
  depth?: Maybe<Scalars['Float']>;
  plant_spacing?: Maybe<Scalars['Float']>;
  row_spacing?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations_sowing" */
export type Operations_Sowing_Var_Pop_Order_By = {
  depth?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operations_Sowing_Var_Samp_Fields = {
  __typename?: 'operations_sowing_var_samp_fields';
  depth?: Maybe<Scalars['Float']>;
  plant_spacing?: Maybe<Scalars['Float']>;
  row_spacing?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations_sowing" */
export type Operations_Sowing_Var_Samp_Order_By = {
  depth?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operations_Sowing_Variance_Fields = {
  __typename?: 'operations_sowing_variance_fields';
  depth?: Maybe<Scalars['Float']>;
  plant_spacing?: Maybe<Scalars['Float']>;
  row_spacing?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations_sowing" */
export type Operations_Sowing_Variance_Order_By = {
  depth?: InputMaybe<Order_By>;
  plant_spacing?: InputMaybe<Order_By>;
  row_spacing?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Operations_Stddev_Fields = {
  __typename?: 'operations_stddev_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations" */
export type Operations_Stddev_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operations_Stddev_Pop_Fields = {
  __typename?: 'operations_stddev_pop_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations" */
export type Operations_Stddev_Pop_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operations_Stddev_Samp_Fields = {
  __typename?: 'operations_stddev_samp_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations" */
export type Operations_Stddev_Samp_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operations" */
export type Operations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Stream_Cursor_Value_Input = {
  application_area?: InputMaybe<Scalars['float8']>;
  area_reporting_value?: InputMaybe<Scalars['float8']>;
  area_unit_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  crop_year?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_applied?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geometry']>;
  notes?: InputMaybe<Scalars['String']>;
  percent_field_cover?: InputMaybe<Scalars['float8']>;
  planned_operation_id?: InputMaybe<Scalars['uuid']>;
  plot_crop_id?: InputMaybe<Scalars['String']>;
  plot_id?: InputMaybe<Scalars['String']>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage_id?: InputMaybe<Scalars['String']>;
  secondary_growth_stage_id?: InputMaybe<Scalars['String']>;
  shared_area_unit_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  shared_plot_id?: InputMaybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: InputMaybe<Scalars['bigint']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  voice_note_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Operations_Sum_Fields = {
  __typename?: 'operations_sum_fields';
  application_area?: Maybe<Scalars['float8']>;
  area_reporting_value?: Maybe<Scalars['float8']>;
  percent_field_cover?: Maybe<Scalars['float8']>;
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  shared_area_unit_id?: Maybe<Scalars['bigint']>;
  shared_plot_crop_id?: Maybe<Scalars['bigint']>;
  shared_plot_id?: Maybe<Scalars['bigint']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['bigint']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['bigint']>;
  voice_note_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "operations" */
export type Operations_Sum_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** update columns of table "operations" */
export enum Operations_Update_Column {
  /** column name */
  ApplicationArea = 'application_area',
  /** column name */
  AreaReportingValue = 'area_reporting_value',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropYear = 'crop_year',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApplied = 'is_applied',
  /** column name */
  Location = 'location',
  /** column name */
  Notes = 'notes',
  /** column name */
  PercentFieldCover = 'percent_field_cover',
  /** column name */
  PlannedOperationId = 'planned_operation_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  PolymorphicCtypeId = 'polymorphic_ctype_id',
  /** column name */
  PrimaryGrowthStageId = 'primary_growth_stage_id',
  /** column name */
  SecondaryGrowthStageId = 'secondary_growth_stage_id',
  /** column name */
  SharedAreaUnitId = 'shared_area_unit_id',
  /** column name */
  SharedPlotCropId = 'shared_plot_crop_id',
  /** column name */
  SharedPlotId = 'shared_plot_id',
  /** column name */
  SharedPrimaryGrowthStageId = 'shared_primary_growth_stage_id',
  /** column name */
  SharedSecondaryGrowthStageId = 'shared_secondary_growth_stage_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VoiceNoteId = 'voice_note_id'
}

export type Operations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Set_Input>;
  where: Operations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Var_Pop_Fields = {
  __typename?: 'operations_var_pop_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations" */
export type Operations_Var_Pop_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operations_Var_Samp_Fields = {
  __typename?: 'operations_var_samp_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations" */
export type Operations_Var_Samp_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operations_Variance_Fields = {
  __typename?: 'operations_variance_fields';
  application_area?: Maybe<Scalars['Float']>;
  area_reporting_value?: Maybe<Scalars['Float']>;
  percent_field_cover?: Maybe<Scalars['Float']>;
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_area_unit_id?: Maybe<Scalars['Float']>;
  shared_plot_crop_id?: Maybe<Scalars['Float']>;
  shared_plot_id?: Maybe<Scalars['Float']>;
  shared_primary_growth_stage_id?: Maybe<Scalars['Float']>;
  shared_secondary_growth_stage_id?: Maybe<Scalars['Float']>;
  voice_note_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations" */
export type Operations_Variance_Order_By = {
  application_area?: InputMaybe<Order_By>;
  area_reporting_value?: InputMaybe<Order_By>;
  percent_field_cover?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_area_unit_id?: InputMaybe<Order_By>;
  shared_plot_crop_id?: InputMaybe<Order_By>;
  shared_plot_id?: InputMaybe<Order_By>;
  shared_primary_growth_stage_id?: InputMaybe<Order_By>;
  shared_secondary_growth_stage_id?: InputMaybe<Order_By>;
  voice_note_id?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "organisation" */
export type Organisation = {
  __typename?: 'organisation';
  abbreviation: Scalars['String'];
  /** An object relationship */
  address: Address;
  address_id: Scalars['Int'];
  codename: Scalars['String'];
  /** An array relationship */
  companies: Array<Company>;
  /** An aggregate relationship */
  companies_aggregate: Company_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  display_name: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  organisation_document_kinds: Array<Organisation_Document_Kind>;
  /** An aggregate relationship */
  organisation_document_kinds_aggregate: Organisation_Document_Kind_Aggregate;
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "organisation" */
export type OrganisationCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_Document_KindsArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_Document_Kinds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "organisation" */
export type Organisation_Aggregate = {
  __typename?: 'organisation_aggregate';
  aggregate?: Maybe<Organisation_Aggregate_Fields>;
  nodes: Array<Organisation>;
};

/** aggregate fields of "organisation" */
export type Organisation_Aggregate_Fields = {
  __typename?: 'organisation_aggregate_fields';
  avg?: Maybe<Organisation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Max_Fields>;
  min?: Maybe<Organisation_Min_Fields>;
  stddev?: Maybe<Organisation_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Sum_Fields>;
  var_pop?: Maybe<Organisation_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Variance_Fields>;
};


/** aggregate fields of "organisation" */
export type Organisation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organisation_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Organisation_Avg_Fields = {
  __typename?: 'organisation_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organisation". All fields are combined with a logical 'AND'. */
export type Organisation_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Company_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_document_kinds?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  tnc?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation" */
export enum Organisation_Constraint {
  /** unique or primary key constraint on columns "address_id" */
  OrganisationAddressIdKey = 'organisation_address_id_key',
  /** unique or primary key constraint on columns "codename" */
  OrganisationCodenameKey = 'organisation_codename_key',
  /** unique or primary key constraint on columns "name", "abbreviation", "address_id" */
  OrganisationNameAbbreviationAddressId_90c82dfeUniq = 'organisation_name_abbreviation_address_id_90c82dfe_uniq',
  /** unique or primary key constraint on columns "photo_id" */
  OrganisationPhotoIdKey = 'organisation_photo_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganisationPkey = 'organisation_pkey',
  /** unique or primary key constraint on columns "uid" */
  OrganisationUidKey = 'organisation_uid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organisation_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organisation_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organisation_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "organisation_document_kind" */
export type Organisation_Document_Kind = {
  __typename?: 'organisation_document_kind';
  /** An object relationship */
  document_kind: Document_Kind;
  document_kind_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
};

/** aggregated selection of "organisation_document_kind" */
export type Organisation_Document_Kind_Aggregate = {
  __typename?: 'organisation_document_kind_aggregate';
  aggregate?: Maybe<Organisation_Document_Kind_Aggregate_Fields>;
  nodes: Array<Organisation_Document_Kind>;
};

/** aggregate fields of "organisation_document_kind" */
export type Organisation_Document_Kind_Aggregate_Fields = {
  __typename?: 'organisation_document_kind_aggregate_fields';
  avg?: Maybe<Organisation_Document_Kind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Document_Kind_Max_Fields>;
  min?: Maybe<Organisation_Document_Kind_Min_Fields>;
  stddev?: Maybe<Organisation_Document_Kind_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Document_Kind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Document_Kind_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Document_Kind_Sum_Fields>;
  var_pop?: Maybe<Organisation_Document_Kind_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Document_Kind_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Document_Kind_Variance_Fields>;
};


/** aggregate fields of "organisation_document_kind" */
export type Organisation_Document_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organisation_document_kind" */
export type Organisation_Document_Kind_Aggregate_Order_By = {
  avg?: InputMaybe<Organisation_Document_Kind_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Document_Kind_Max_Order_By>;
  min?: InputMaybe<Organisation_Document_Kind_Min_Order_By>;
  stddev?: InputMaybe<Organisation_Document_Kind_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organisation_Document_Kind_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organisation_Document_Kind_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organisation_Document_Kind_Sum_Order_By>;
  var_pop?: InputMaybe<Organisation_Document_Kind_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organisation_Document_Kind_Var_Samp_Order_By>;
  variance?: InputMaybe<Organisation_Document_Kind_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_document_kind" */
export type Organisation_Document_Kind_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Document_Kind_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Document_Kind_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Document_Kind_Avg_Fields = {
  __typename?: 'organisation_document_kind_avg_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Avg_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_document_kind". All fields are combined with a logical 'AND'. */
export type Organisation_Document_Kind_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Document_Kind_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Document_Kind_Bool_Exp>>;
  document_kind?: InputMaybe<Document_Kind_Bool_Exp>;
  document_kind_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_document_kind" */
export enum Organisation_Document_Kind_Constraint {
  /** unique or primary key constraint on columns "document_kind_id", "organisation_id" */
  OrganisationDocumentKiOrganisationIdDocument_4449ee3fUniq = 'organisation_document_ki_organisation_id_document_4449ee3f_uniq',
  /** unique or primary key constraint on columns "id" */
  OrganisationDocumentKindPkey = 'organisation_document_kind_pkey'
}

/** input type for incrementing numeric columns in table "organisation_document_kind" */
export type Organisation_Document_Kind_Inc_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation_document_kind" */
export type Organisation_Document_Kind_Insert_Input = {
  document_kind?: InputMaybe<Document_Kind_Obj_Rel_Insert_Input>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Organisation_Document_Kind_Max_Fields = {
  __typename?: 'organisation_document_kind_max_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Max_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Document_Kind_Min_Fields = {
  __typename?: 'organisation_document_kind_min_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Min_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_document_kind" */
export type Organisation_Document_Kind_Mutation_Response = {
  __typename?: 'organisation_document_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Document_Kind>;
};

/** on_conflict condition type for table "organisation_document_kind" */
export type Organisation_Document_Kind_On_Conflict = {
  constraint: Organisation_Document_Kind_Constraint;
  update_columns?: Array<Organisation_Document_Kind_Update_Column>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_document_kind". */
export type Organisation_Document_Kind_Order_By = {
  document_kind?: InputMaybe<Document_Kind_Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_document_kind */
export type Organisation_Document_Kind_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "organisation_document_kind" */
export enum Organisation_Document_Kind_Select_Column {
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id'
}

/** input type for updating data in table "organisation_document_kind" */
export type Organisation_Document_Kind_Set_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Organisation_Document_Kind_Stddev_Fields = {
  __typename?: 'organisation_document_kind_stddev_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Stddev_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Document_Kind_Stddev_Pop_Fields = {
  __typename?: 'organisation_document_kind_stddev_pop_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Stddev_Pop_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Document_Kind_Stddev_Samp_Fields = {
  __typename?: 'organisation_document_kind_stddev_samp_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Stddev_Samp_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organisation_document_kind" */
export type Organisation_Document_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Document_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Document_Kind_Stream_Cursor_Value_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Organisation_Document_Kind_Sum_Fields = {
  __typename?: 'organisation_document_kind_sum_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Sum_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** update columns of table "organisation_document_kind" */
export enum Organisation_Document_Kind_Update_Column {
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id'
}

export type Organisation_Document_Kind_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Document_Kind_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Document_Kind_Set_Input>;
  where: Organisation_Document_Kind_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Document_Kind_Var_Pop_Fields = {
  __typename?: 'organisation_document_kind_var_pop_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Var_Pop_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Document_Kind_Var_Samp_Fields = {
  __typename?: 'organisation_document_kind_var_samp_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Var_Samp_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Document_Kind_Variance_Fields = {
  __typename?: 'organisation_document_kind_variance_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Variance_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "organisation" */
export type Organisation_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation" */
export type Organisation_Insert_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Company_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_document_kinds?: InputMaybe<Organisation_Document_Kind_Arr_Rel_Insert_Input>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Organisation_Max_Fields = {
  __typename?: 'organisation_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Organisation_Min_Fields = {
  __typename?: 'organisation_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "organisation" */
export type Organisation_Mutation_Response = {
  __typename?: 'organisation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation>;
};

/** input type for inserting object relation for remote table "organisation" */
export type Organisation_Obj_Rel_Insert_Input = {
  data: Organisation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};

/** on_conflict condition type for table "organisation" */
export type Organisation_On_Conflict = {
  constraint: Organisation_Constraint;
  update_columns?: Array<Organisation_Update_Column>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation". */
export type Organisation_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  companies_aggregate?: InputMaybe<Company_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_document_kinds_aggregate?: InputMaybe<Organisation_Document_Kind_Aggregate_Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  tnc?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation */
export type Organisation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "organisation_preferences" */
export type Organisation_Preferences = {
  __typename?: 'organisation_preferences';
  farm_suffix: Scalars['String'];
  field_suffix: Scalars['String'];
  id: Scalars['Int'];
  organisation_id: Scalars['Int'];
  plot_crop_suffix: Scalars['String'];
  plot_suffix: Scalars['String'];
};

/** aggregated selection of "organisation_preferences" */
export type Organisation_Preferences_Aggregate = {
  __typename?: 'organisation_preferences_aggregate';
  aggregate?: Maybe<Organisation_Preferences_Aggregate_Fields>;
  nodes: Array<Organisation_Preferences>;
};

/** aggregate fields of "organisation_preferences" */
export type Organisation_Preferences_Aggregate_Fields = {
  __typename?: 'organisation_preferences_aggregate_fields';
  avg?: Maybe<Organisation_Preferences_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Preferences_Max_Fields>;
  min?: Maybe<Organisation_Preferences_Min_Fields>;
  stddev?: Maybe<Organisation_Preferences_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Preferences_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Preferences_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Preferences_Sum_Fields>;
  var_pop?: Maybe<Organisation_Preferences_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Preferences_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Preferences_Variance_Fields>;
};


/** aggregate fields of "organisation_preferences" */
export type Organisation_Preferences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Preferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Organisation_Preferences_Avg_Fields = {
  __typename?: 'organisation_preferences_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organisation_preferences". All fields are combined with a logical 'AND'. */
export type Organisation_Preferences_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Preferences_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Preferences_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Preferences_Bool_Exp>>;
  farm_suffix?: InputMaybe<String_Comparison_Exp>;
  field_suffix?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crop_suffix?: InputMaybe<String_Comparison_Exp>;
  plot_suffix?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_preferences" */
export enum Organisation_Preferences_Constraint {
  /** unique or primary key constraint on columns "organisation_id" */
  OrganisationPreferencesOrganisationIdKey = 'organisation_preferences_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganisationPreferencesPkey = 'organisation_preferences_pkey'
}

/** input type for incrementing numeric columns in table "organisation_preferences" */
export type Organisation_Preferences_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation_preferences" */
export type Organisation_Preferences_Insert_Input = {
  farm_suffix?: InputMaybe<Scalars['String']>;
  field_suffix?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot_crop_suffix?: InputMaybe<Scalars['String']>;
  plot_suffix?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Organisation_Preferences_Max_Fields = {
  __typename?: 'organisation_preferences_max_fields';
  farm_suffix?: Maybe<Scalars['String']>;
  field_suffix?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  plot_crop_suffix?: Maybe<Scalars['String']>;
  plot_suffix?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Organisation_Preferences_Min_Fields = {
  __typename?: 'organisation_preferences_min_fields';
  farm_suffix?: Maybe<Scalars['String']>;
  field_suffix?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  plot_crop_suffix?: Maybe<Scalars['String']>;
  plot_suffix?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "organisation_preferences" */
export type Organisation_Preferences_Mutation_Response = {
  __typename?: 'organisation_preferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Preferences>;
};

/** on_conflict condition type for table "organisation_preferences" */
export type Organisation_Preferences_On_Conflict = {
  constraint: Organisation_Preferences_Constraint;
  update_columns?: Array<Organisation_Preferences_Update_Column>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_preferences". */
export type Organisation_Preferences_Order_By = {
  farm_suffix?: InputMaybe<Order_By>;
  field_suffix?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_crop_suffix?: InputMaybe<Order_By>;
  plot_suffix?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_preferences */
export type Organisation_Preferences_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "organisation_preferences" */
export enum Organisation_Preferences_Select_Column {
  /** column name */
  FarmSuffix = 'farm_suffix',
  /** column name */
  FieldSuffix = 'field_suffix',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PlotCropSuffix = 'plot_crop_suffix',
  /** column name */
  PlotSuffix = 'plot_suffix'
}

/** input type for updating data in table "organisation_preferences" */
export type Organisation_Preferences_Set_Input = {
  farm_suffix?: InputMaybe<Scalars['String']>;
  field_suffix?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot_crop_suffix?: InputMaybe<Scalars['String']>;
  plot_suffix?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Organisation_Preferences_Stddev_Fields = {
  __typename?: 'organisation_preferences_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Preferences_Stddev_Pop_Fields = {
  __typename?: 'organisation_preferences_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Preferences_Stddev_Samp_Fields = {
  __typename?: 'organisation_preferences_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organisation_preferences" */
export type Organisation_Preferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Preferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Preferences_Stream_Cursor_Value_Input = {
  farm_suffix?: InputMaybe<Scalars['String']>;
  field_suffix?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot_crop_suffix?: InputMaybe<Scalars['String']>;
  plot_suffix?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Organisation_Preferences_Sum_Fields = {
  __typename?: 'organisation_preferences_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "organisation_preferences" */
export enum Organisation_Preferences_Update_Column {
  /** column name */
  FarmSuffix = 'farm_suffix',
  /** column name */
  FieldSuffix = 'field_suffix',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PlotCropSuffix = 'plot_crop_suffix',
  /** column name */
  PlotSuffix = 'plot_suffix'
}

export type Organisation_Preferences_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Preferences_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Preferences_Set_Input>;
  where: Organisation_Preferences_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Preferences_Var_Pop_Fields = {
  __typename?: 'organisation_preferences_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Organisation_Preferences_Var_Samp_Fields = {
  __typename?: 'organisation_preferences_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Organisation_Preferences_Variance_Fields = {
  __typename?: 'organisation_preferences_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organisation_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "organisation_season" */
export type Organisation_Season = {
  __typename?: 'organisation_season';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
};

/** aggregated selection of "organisation_season" */
export type Organisation_Season_Aggregate = {
  __typename?: 'organisation_season_aggregate';
  aggregate?: Maybe<Organisation_Season_Aggregate_Fields>;
  nodes: Array<Organisation_Season>;
};

/** aggregate fields of "organisation_season" */
export type Organisation_Season_Aggregate_Fields = {
  __typename?: 'organisation_season_aggregate_fields';
  avg?: Maybe<Organisation_Season_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Season_Max_Fields>;
  min?: Maybe<Organisation_Season_Min_Fields>;
  stddev?: Maybe<Organisation_Season_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Season_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Season_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Season_Sum_Fields>;
  var_pop?: Maybe<Organisation_Season_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Season_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Season_Variance_Fields>;
};


/** aggregate fields of "organisation_season" */
export type Organisation_Season_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Season_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Organisation_Season_Avg_Fields = {
  __typename?: 'organisation_season_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organisation_season". All fields are combined with a logical 'AND'. */
export type Organisation_Season_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Season_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Season_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Season_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_season" */
export enum Organisation_Season_Constraint {
  /** unique or primary key constraint on columns "codename" */
  OrganisationSeasonCodenameKey = 'organisation_season_codename_key',
  /** unique or primary key constraint on columns "id" */
  OrganisationSeasonPkey = 'organisation_season_pkey'
}

/** input type for incrementing numeric columns in table "organisation_season" */
export type Organisation_Season_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation_season" */
export type Organisation_Season_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Organisation_Season_Max_Fields = {
  __typename?: 'organisation_season_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Organisation_Season_Min_Fields = {
  __typename?: 'organisation_season_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "organisation_season" */
export type Organisation_Season_Mutation_Response = {
  __typename?: 'organisation_season_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Season>;
};

/** on_conflict condition type for table "organisation_season" */
export type Organisation_Season_On_Conflict = {
  constraint: Organisation_Season_Constraint;
  update_columns?: Array<Organisation_Season_Update_Column>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_season". */
export type Organisation_Season_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_season */
export type Organisation_Season_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "organisation_season" */
export enum Organisation_Season_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id'
}

/** input type for updating data in table "organisation_season" */
export type Organisation_Season_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Organisation_Season_Stddev_Fields = {
  __typename?: 'organisation_season_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Season_Stddev_Pop_Fields = {
  __typename?: 'organisation_season_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Season_Stddev_Samp_Fields = {
  __typename?: 'organisation_season_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organisation_season" */
export type Organisation_Season_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Season_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Season_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Organisation_Season_Sum_Fields = {
  __typename?: 'organisation_season_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "organisation_season" */
export enum Organisation_Season_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id'
}

export type Organisation_Season_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Season_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Season_Set_Input>;
  where: Organisation_Season_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Season_Var_Pop_Fields = {
  __typename?: 'organisation_season_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Organisation_Season_Var_Samp_Fields = {
  __typename?: 'organisation_season_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Organisation_Season_Variance_Fields = {
  __typename?: 'organisation_season_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** select columns of table "organisation" */
export enum Organisation_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Tnc = 'tnc',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "organisation" */
export type Organisation_Set_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Organisation_Stddev_Fields = {
  __typename?: 'organisation_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Stddev_Pop_Fields = {
  __typename?: 'organisation_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Stddev_Samp_Fields = {
  __typename?: 'organisation_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organisation" */
export type Organisation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Organisation_Sum_Fields = {
  __typename?: 'organisation_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "organisation" */
export enum Organisation_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Tnc = 'tnc',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Organisation_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organisation_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organisation_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organisation_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organisation_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organisation_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Set_Input>;
  where: Organisation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Var_Pop_Fields = {
  __typename?: 'organisation_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Organisation_Var_Samp_Fields = {
  __typename?: 'organisation_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Organisation_Variance_Fields = {
  __typename?: 'organisation_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "payment_detail" */
export type Payment_Detail = {
  __typename?: 'payment_detail';
  account_holder_name: Scalars['String'];
  account_number: Scalars['String'];
  /** An array relationship */
  attachments: Array<Payment_Detail_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Payment_Detail_Attachments_Aggregate;
  bank_name: Scalars['String'];
  branch_name: Scalars['String'];
  /** An object relationship */
  content_type: Django_Content_Type;
  content_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  ifsc_code: Scalars['String'];
  is_verified?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  method: Payment_Method;
  method_id: Scalars['Int'];
  object_id: Scalars['Int'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "payment_detail" */
export type Payment_DetailAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


/** columns and relationships of "payment_detail" */
export type Payment_DetailAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};

/** aggregated selection of "payment_detail" */
export type Payment_Detail_Aggregate = {
  __typename?: 'payment_detail_aggregate';
  aggregate?: Maybe<Payment_Detail_Aggregate_Fields>;
  nodes: Array<Payment_Detail>;
};

/** aggregate fields of "payment_detail" */
export type Payment_Detail_Aggregate_Fields = {
  __typename?: 'payment_detail_aggregate_fields';
  avg?: Maybe<Payment_Detail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Detail_Max_Fields>;
  min?: Maybe<Payment_Detail_Min_Fields>;
  stddev?: Maybe<Payment_Detail_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Detail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Detail_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Detail_Sum_Fields>;
  var_pop?: Maybe<Payment_Detail_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Detail_Var_Samp_Fields>;
  variance?: Maybe<Payment_Detail_Variance_Fields>;
};


/** aggregate fields of "payment_detail" */
export type Payment_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "payment_detail_attachments" */
export type Payment_Detail_Attachments = {
  __typename?: 'payment_detail_attachments';
  /** An object relationship */
  attachment: Media;
  id: Scalars['Int'];
  media_id: Scalars['Int'];
  /** An object relationship */
  payment_detail: Payment_Detail;
  paymentdetail_id: Scalars['Int'];
};

/** aggregated selection of "payment_detail_attachments" */
export type Payment_Detail_Attachments_Aggregate = {
  __typename?: 'payment_detail_attachments_aggregate';
  aggregate?: Maybe<Payment_Detail_Attachments_Aggregate_Fields>;
  nodes: Array<Payment_Detail_Attachments>;
};

/** aggregate fields of "payment_detail_attachments" */
export type Payment_Detail_Attachments_Aggregate_Fields = {
  __typename?: 'payment_detail_attachments_aggregate_fields';
  avg?: Maybe<Payment_Detail_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Detail_Attachments_Max_Fields>;
  min?: Maybe<Payment_Detail_Attachments_Min_Fields>;
  stddev?: Maybe<Payment_Detail_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Detail_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Detail_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Detail_Attachments_Sum_Fields>;
  var_pop?: Maybe<Payment_Detail_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Detail_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Payment_Detail_Attachments_Variance_Fields>;
};


/** aggregate fields of "payment_detail_attachments" */
export type Payment_Detail_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Detail_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Detail_Attachments_Max_Order_By>;
  min?: InputMaybe<Payment_Detail_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Payment_Detail_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Detail_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Detail_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Detail_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Detail_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Detail_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Detail_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Payment_Detail_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Detail_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Detail_Attachments_Avg_Fields = {
  __typename?: 'payment_detail_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_detail_attachments". All fields are combined with a logical 'AND'. */
export type Payment_Detail_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Detail_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Detail_Attachments_Bool_Exp>>;
  attachment?: InputMaybe<Media_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  media_id?: InputMaybe<Int_Comparison_Exp>;
  payment_detail?: InputMaybe<Payment_Detail_Bool_Exp>;
  paymentdetail_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_detail_attachments" */
export enum Payment_Detail_Attachments_Constraint {
  /** unique or primary key constraint on columns "media_id", "paymentdetail_id" */
  PaymentDetailAttachmenPaymentdetailIdMediaI_891b8897Uniq = 'payment_detail_attachmen_paymentdetail_id_media_i_891b8897_uniq',
  /** unique or primary key constraint on columns "id" */
  PaymentDetailAttachmentsPkey = 'payment_detail_attachments_pkey'
}

/** input type for incrementing numeric columns in table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  paymentdetail_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Insert_Input = {
  attachment?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  payment_detail?: InputMaybe<Payment_Detail_Obj_Rel_Insert_Input>;
  paymentdetail_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Payment_Detail_Attachments_Max_Fields = {
  __typename?: 'payment_detail_attachments_max_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  paymentdetail_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Detail_Attachments_Min_Fields = {
  __typename?: 'payment_detail_attachments_min_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  paymentdetail_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Mutation_Response = {
  __typename?: 'payment_detail_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Detail_Attachments>;
};

/** on_conflict condition type for table "payment_detail_attachments" */
export type Payment_Detail_Attachments_On_Conflict = {
  constraint: Payment_Detail_Attachments_Constraint;
  update_columns?: Array<Payment_Detail_Attachments_Update_Column>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_detail_attachments". */
export type Payment_Detail_Attachments_Order_By = {
  attachment?: InputMaybe<Media_Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  payment_detail?: InputMaybe<Payment_Detail_Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_detail_attachments */
export type Payment_Detail_Attachments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "payment_detail_attachments" */
export enum Payment_Detail_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  PaymentdetailId = 'paymentdetail_id'
}

/** input type for updating data in table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  paymentdetail_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Payment_Detail_Attachments_Stddev_Fields = {
  __typename?: 'payment_detail_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Detail_Attachments_Stddev_Pop_Fields = {
  __typename?: 'payment_detail_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Detail_Attachments_Stddev_Samp_Fields = {
  __typename?: 'payment_detail_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Detail_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Detail_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  paymentdetail_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Payment_Detail_Attachments_Sum_Fields = {
  __typename?: 'payment_detail_attachments_sum_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  paymentdetail_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** update columns of table "payment_detail_attachments" */
export enum Payment_Detail_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  PaymentdetailId = 'paymentdetail_id'
}

export type Payment_Detail_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Detail_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Detail_Attachments_Set_Input>;
  where: Payment_Detail_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Detail_Attachments_Var_Pop_Fields = {
  __typename?: 'payment_detail_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Detail_Attachments_Var_Samp_Fields = {
  __typename?: 'payment_detail_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Detail_Attachments_Variance_Fields = {
  __typename?: 'payment_detail_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Payment_Detail_Avg_Fields = {
  __typename?: 'payment_detail_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "payment_detail". All fields are combined with a logical 'AND'. */
export type Payment_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Detail_Bool_Exp>>;
  _not?: InputMaybe<Payment_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Detail_Bool_Exp>>;
  account_holder_name?: InputMaybe<String_Comparison_Exp>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  attachments?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
  bank_name?: InputMaybe<String_Comparison_Exp>;
  branch_name?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  ifsc_code?: InputMaybe<String_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  method?: InputMaybe<Payment_Method_Bool_Exp>;
  method_id?: InputMaybe<Int_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_detail" */
export enum Payment_Detail_Constraint {
  /** unique or primary key constraint on columns "account_number", "ifsc_code" */
  PaymentDetailAccountNumberIfscCodeB7a708d5Uniq = 'payment_detail_account_number_ifsc_code_b7a708d5_uniq',
  /** unique or primary key constraint on columns "id" */
  PaymentDetailPkey = 'payment_detail_pkey'
}

/** input type for incrementing numeric columns in table "payment_detail" */
export type Payment_Detail_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  method_id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "payment_detail" */
export type Payment_Detail_Insert_Input = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Payment_Detail_Attachments_Arr_Rel_Insert_Input>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<Payment_Method_Obj_Rel_Insert_Input>;
  method_id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Payment_Detail_Max_Fields = {
  __typename?: 'payment_detail_max_fields';
  account_holder_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  ifsc_code?: Maybe<Scalars['String']>;
  method_id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Payment_Detail_Min_Fields = {
  __typename?: 'payment_detail_min_fields';
  account_holder_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  ifsc_code?: Maybe<Scalars['String']>;
  method_id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "payment_detail" */
export type Payment_Detail_Mutation_Response = {
  __typename?: 'payment_detail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Detail>;
};

/** input type for inserting object relation for remote table "payment_detail" */
export type Payment_Detail_Obj_Rel_Insert_Input = {
  data: Payment_Detail_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Detail_On_Conflict>;
};

/** on_conflict condition type for table "payment_detail" */
export type Payment_Detail_On_Conflict = {
  constraint: Payment_Detail_Constraint;
  update_columns?: Array<Payment_Detail_Update_Column>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_detail". */
export type Payment_Detail_Order_By = {
  account_holder_name?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Payment_Detail_Attachments_Aggregate_Order_By>;
  bank_name?: InputMaybe<Order_By>;
  branch_name?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Django_Content_Type_Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  method?: InputMaybe<Payment_Method_Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_detail */
export type Payment_Detail_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "payment_detail" */
export enum Payment_Detail_Select_Column {
  /** column name */
  AccountHolderName = 'account_holder_name',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  BranchName = 'branch_name',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  IfscCode = 'ifsc_code',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "payment_detail" */
export type Payment_Detail_Set_Input = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  method_id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Payment_Detail_Stddev_Fields = {
  __typename?: 'payment_detail_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Payment_Detail_Stddev_Pop_Fields = {
  __typename?: 'payment_detail_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Payment_Detail_Stddev_Samp_Fields = {
  __typename?: 'payment_detail_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "payment_detail" */
export type Payment_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Detail_Stream_Cursor_Value_Input = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  method_id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Payment_Detail_Sum_Fields = {
  __typename?: 'payment_detail_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  method_id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "payment_detail" */
export enum Payment_Detail_Update_Column {
  /** column name */
  AccountHolderName = 'account_holder_name',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  BranchName = 'branch_name',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  IfscCode = 'ifsc_code',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Payment_Detail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Detail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Detail_Set_Input>;
  where: Payment_Detail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Detail_Var_Pop_Fields = {
  __typename?: 'payment_detail_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Payment_Detail_Var_Samp_Fields = {
  __typename?: 'payment_detail_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Payment_Detail_Variance_Fields = {
  __typename?: 'payment_detail_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "payment_method" */
export type Payment_Method = {
  __typename?: 'payment_method';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "payment_method" */
export type Payment_Method_Aggregate = {
  __typename?: 'payment_method_aggregate';
  aggregate?: Maybe<Payment_Method_Aggregate_Fields>;
  nodes: Array<Payment_Method>;
};

/** aggregate fields of "payment_method" */
export type Payment_Method_Aggregate_Fields = {
  __typename?: 'payment_method_aggregate_fields';
  avg?: Maybe<Payment_Method_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Method_Max_Fields>;
  min?: Maybe<Payment_Method_Min_Fields>;
  stddev?: Maybe<Payment_Method_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Method_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Method_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Method_Sum_Fields>;
  var_pop?: Maybe<Payment_Method_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Method_Var_Samp_Fields>;
  variance?: Maybe<Payment_Method_Variance_Fields>;
};


/** aggregate fields of "payment_method" */
export type Payment_Method_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Payment_Method_Avg_Fields = {
  __typename?: 'payment_method_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "payment_method". All fields are combined with a logical 'AND'. */
export type Payment_Method_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Method_Bool_Exp>>;
  _not?: InputMaybe<Payment_Method_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Method_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_method" */
export enum Payment_Method_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PaymentMethodCodenameKey = 'payment_method_codename_key',
  /** unique or primary key constraint on columns "id" */
  PaymentMethodPkey = 'payment_method_pkey'
}

/** input type for incrementing numeric columns in table "payment_method" */
export type Payment_Method_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "payment_method" */
export type Payment_Method_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Payment_Method_Max_Fields = {
  __typename?: 'payment_method_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Payment_Method_Min_Fields = {
  __typename?: 'payment_method_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "payment_method" */
export type Payment_Method_Mutation_Response = {
  __typename?: 'payment_method_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Method>;
};

/** input type for inserting object relation for remote table "payment_method" */
export type Payment_Method_Obj_Rel_Insert_Input = {
  data: Payment_Method_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Method_On_Conflict>;
};

/** on_conflict condition type for table "payment_method" */
export type Payment_Method_On_Conflict = {
  constraint: Payment_Method_Constraint;
  update_columns?: Array<Payment_Method_Update_Column>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_method". */
export type Payment_Method_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_method */
export type Payment_Method_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "payment_method" */
export enum Payment_Method_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "payment_method" */
export type Payment_Method_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Payment_Method_Stddev_Fields = {
  __typename?: 'payment_method_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Payment_Method_Stddev_Pop_Fields = {
  __typename?: 'payment_method_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Payment_Method_Stddev_Samp_Fields = {
  __typename?: 'payment_method_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "payment_method" */
export type Payment_Method_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Method_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Method_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Payment_Method_Sum_Fields = {
  __typename?: 'payment_method_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "payment_method" */
export enum Payment_Method_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Payment_Method_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Method_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Method_Set_Input>;
  where: Payment_Method_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Method_Var_Pop_Fields = {
  __typename?: 'payment_method_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Payment_Method_Var_Samp_Fields = {
  __typename?: 'payment_method_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Payment_Method_Variance_Fields = {
  __typename?: 'payment_method_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "plot" */
export type Plot = {
  __typename?: 'plot';
  area?: Maybe<Scalars['numeric']>;
  area_catered: Scalars['geometry'];
  /** An object relationship */
  area_unit?: Maybe<Si_Unit>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_in?: Maybe<Department>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  crops: Array<Plot_Crop>;
  /** An aggregate relationship */
  crops_aggregate: Plot_Crop_Aggregate;
  description: Scalars['String'];
  external_reference_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  farmer: Base_User;
  farmer_id: Scalars['Int'];
  /** An object relationship */
  field: Field;
  field_id: Scalars['Int'];
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Plot_Network>;
  /** An aggregate relationship */
  networks_aggregate: Plot_Network_Aggregate;
  notes?: Maybe<Scalars['String']>;
  private_metadata: Scalars['jsonb'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  tag: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "plot" */
export type PlotCropsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


/** columns and relationships of "plot" */
export type PlotCrops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


/** columns and relationships of "plot" */
export type PlotMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot" */
export type PlotNetworksArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


/** columns and relationships of "plot" */
export type PlotNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


/** columns and relationships of "plot" */
export type PlotPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "plot" */
export type Plot_Aggregate = {
  __typename?: 'plot_aggregate';
  aggregate?: Maybe<Plot_Aggregate_Fields>;
  nodes: Array<Plot>;
};

/** aggregate fields of "plot" */
export type Plot_Aggregate_Fields = {
  __typename?: 'plot_aggregate_fields';
  avg?: Maybe<Plot_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Max_Fields>;
  min?: Maybe<Plot_Min_Fields>;
  stddev?: Maybe<Plot_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Sum_Fields>;
  var_pop?: Maybe<Plot_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Var_Samp_Fields>;
  variance?: Maybe<Plot_Variance_Fields>;
};


/** aggregate fields of "plot" */
export type Plot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot" */
export type Plot_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Max_Order_By>;
  min?: InputMaybe<Plot_Min_Order_By>;
  stddev?: InputMaybe<Plot_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Plot_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "plot" */
export type Plot_Arr_Rel_Insert_Input = {
  data: Array<Plot_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Avg_Fields = {
  __typename?: 'plot_avg_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot" */
export type Plot_Avg_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot". All fields are combined with a logical 'AND'. */
export type Plot_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Bool_Exp>>;
  _not?: InputMaybe<Plot_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Bool_Exp>>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_catered?: InputMaybe<Geometry_Comparison_Exp>;
  area_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  field?: InputMaybe<Field_Bool_Exp>;
  field_id?: InputMaybe<Int_Comparison_Exp>;
  geo_area_remark?: InputMaybe<Float8_Comparison_Exp>;
  geo_bound_area?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "plot". All fields are combined with a logical 'AND'. */
export type Plot_Bool_Exp_Remote_Rel_Monitoring_Recordplot = {
  _and?: InputMaybe<Array<Plot_Bool_Exp>>;
  _not?: InputMaybe<Plot_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Bool_Exp>>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_catered?: InputMaybe<Geometry_Comparison_Exp>;
  area_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Recordplot>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  field?: InputMaybe<Field_Bool_Exp>;
  field_id?: InputMaybe<Int_Comparison_Exp>;
  geo_area_remark?: InputMaybe<Float8_Comparison_Exp>;
  geo_bound_area?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "plot". All fields are combined with a logical 'AND'. */
export type Plot_Bool_Exp_Remote_Rel_Operationsplot = {
  _and?: InputMaybe<Array<Plot_Bool_Exp>>;
  _not?: InputMaybe<Plot_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Bool_Exp>>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_catered?: InputMaybe<Geometry_Comparison_Exp>;
  area_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Operationsplot>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  field?: InputMaybe<Field_Bool_Exp>;
  field_id?: InputMaybe<Int_Comparison_Exp>;
  geo_area_remark?: InputMaybe<Float8_Comparison_Exp>;
  geo_bound_area?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "plot". All fields are combined with a logical 'AND'. */
export type Plot_Bool_Exp_Remote_Rel_Shared_Entityplot = {
  _and?: InputMaybe<Array<Plot_Bool_Exp>>;
  _not?: InputMaybe<Plot_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Bool_Exp>>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_catered?: InputMaybe<Geometry_Comparison_Exp>;
  area_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityplot>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  field?: InputMaybe<Field_Bool_Exp>;
  field_id?: InputMaybe<Int_Comparison_Exp>;
  geo_area_remark?: InputMaybe<Float8_Comparison_Exp>;
  geo_bound_area?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot" */
export enum Plot_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PlotCodenameKey = 'plot_codename_key',
  /** unique or primary key constraint on columns "id" */
  PlotPkey = 'plot_pkey'
}

/** columns and relationships of "plot_crop" */
export type Plot_Crop = {
  __typename?: 'plot_crop';
  /** An array relationship */
  agents: Array<Plot_Crop_Agent>;
  /** An aggregate relationship */
  agents_aggregate: Plot_Crop_Agent_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_in?: Maybe<Department>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  /** An object relationship */
  crop_variety?: Maybe<Crop_Variety>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  crop_year?: Maybe<Scalars['Int']>;
  /** An object relationship */
  current_crop_year?: Maybe<Crop_Year>;
  current_crop_year_id?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  estd_harvest_quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  estd_harvest_quantity_unit?: Maybe<Si_Unit>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  estd_harvesting_date?: Maybe<Scalars['date']>;
  estd_sowing_date?: Maybe<Scalars['date']>;
  external_reference_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  farmer: Base_User;
  farmer_id: Scalars['Int'];
  growing_cycle: Scalars['Int'];
  harvest_quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  harvest_quantity_unit?: Maybe<Si_Unit>;
  harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  harvesting_date?: Maybe<Scalars['date']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_seed: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Plot_Crop_Network>;
  /** An aggregate relationship */
  networks_aggregate: Plot_Crop_Network_Aggregate;
  notes?: Maybe<Scalars['String']>;
  p2p_distance?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  p2p_distance_unit?: Maybe<Si_Unit>;
  p2p_distance_unit_id?: Maybe<Scalars['Int']>;
  plant_count: Scalars['Int'];
  /** An object relationship */
  plot: Plot;
  plot_id: Scalars['Int'];
  private_metadata: Scalars['jsonb'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  r2r_distance?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  r2r_distance_unit?: Maybe<Si_Unit>;
  r2r_distance_unit_id?: Maybe<Scalars['Int']>;
  sowing_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  status: Plot_Status;
  status_id: Scalars['Int'];
  tag: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropAgentsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropAgents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropNetworksArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "plot_crop_agent" */
export type Plot_Crop_Agent = {
  __typename?: 'plot_crop_agent';
  /** An object relationship */
  agent: Agent;
  agent_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  plot_crop: Plot_Crop;
  plot_crop_id: Scalars['Int'];
};

/** aggregated selection of "plot_crop_agent" */
export type Plot_Crop_Agent_Aggregate = {
  __typename?: 'plot_crop_agent_aggregate';
  aggregate?: Maybe<Plot_Crop_Agent_Aggregate_Fields>;
  nodes: Array<Plot_Crop_Agent>;
};

/** aggregate fields of "plot_crop_agent" */
export type Plot_Crop_Agent_Aggregate_Fields = {
  __typename?: 'plot_crop_agent_aggregate_fields';
  avg?: Maybe<Plot_Crop_Agent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Agent_Max_Fields>;
  min?: Maybe<Plot_Crop_Agent_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Agent_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Agent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Agent_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Agent_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Agent_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Agent_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Agent_Variance_Fields>;
};


/** aggregate fields of "plot_crop_agent" */
export type Plot_Crop_Agent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_crop_agent" */
export type Plot_Crop_Agent_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Crop_Agent_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Crop_Agent_Max_Order_By>;
  min?: InputMaybe<Plot_Crop_Agent_Min_Order_By>;
  stddev?: InputMaybe<Plot_Crop_Agent_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Crop_Agent_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Crop_Agent_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Crop_Agent_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Crop_Agent_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Crop_Agent_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Crop_Agent_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_crop_agent" */
export type Plot_Crop_Agent_Arr_Rel_Insert_Input = {
  data: Array<Plot_Crop_Agent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_Agent_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Crop_Agent_Avg_Fields = {
  __typename?: 'plot_crop_agent_avg_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Avg_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_crop_agent". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Agent_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Agent_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Agent_Bool_Exp>>;
  agent?: InputMaybe<Agent_Bool_Exp>;
  agent_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  plot_crop?: InputMaybe<Plot_Crop_Bool_Exp>;
  plot_crop_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop_agent" */
export enum Plot_Crop_Agent_Constraint {
  /** unique or primary key constraint on columns "agent_id", "plot_crop_id" */
  PlotCropAgentAgentIdPlotCropIdC0ad918bUniq = 'plot_crop_agent_agent_id_plot_crop_id_c0ad918b_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotCropAgentPkey = 'plot_crop_agent_pkey'
}

/** input type for incrementing numeric columns in table "plot_crop_agent" */
export type Plot_Crop_Agent_Inc_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop_agent" */
export type Plot_Crop_Agent_Insert_Input = {
  agent?: InputMaybe<Agent_Obj_Rel_Insert_Input>;
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop?: InputMaybe<Plot_Crop_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Crop_Agent_Max_Fields = {
  __typename?: 'plot_crop_agent_max_fields';
  agent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Max_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Crop_Agent_Min_Fields = {
  __typename?: 'plot_crop_agent_min_fields';
  agent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Min_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_crop_agent" */
export type Plot_Crop_Agent_Mutation_Response = {
  __typename?: 'plot_crop_agent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop_Agent>;
};

/** on_conflict condition type for table "plot_crop_agent" */
export type Plot_Crop_Agent_On_Conflict = {
  constraint: Plot_Crop_Agent_Constraint;
  update_columns?: Array<Plot_Crop_Agent_Update_Column>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop_agent". */
export type Plot_Crop_Agent_Order_By = {
  agent?: InputMaybe<Agent_Order_By>;
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Plot_Crop_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop_agent */
export type Plot_Crop_Agent_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_crop_agent" */
export enum Plot_Crop_Agent_Select_Column {
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

/** input type for updating data in table "plot_crop_agent" */
export type Plot_Crop_Agent_Set_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Agent_Stddev_Fields = {
  __typename?: 'plot_crop_agent_stddev_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Stddev_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Agent_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_agent_stddev_pop_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Stddev_Pop_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Agent_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_agent_stddev_samp_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Stddev_Samp_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_crop_agent" */
export type Plot_Crop_Agent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Agent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Agent_Stream_Cursor_Value_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Agent_Sum_Fields = {
  __typename?: 'plot_crop_agent_sum_fields';
  agent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Sum_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_crop_agent" */
export enum Plot_Crop_Agent_Update_Column {
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

export type Plot_Crop_Agent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Agent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Agent_Set_Input>;
  where: Plot_Crop_Agent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Agent_Var_Pop_Fields = {
  __typename?: 'plot_crop_agent_var_pop_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Var_Pop_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Agent_Var_Samp_Fields = {
  __typename?: 'plot_crop_agent_var_samp_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Var_Samp_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Crop_Agent_Variance_Fields = {
  __typename?: 'plot_crop_agent_variance_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Variance_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregated selection of "plot_crop" */
export type Plot_Crop_Aggregate = {
  __typename?: 'plot_crop_aggregate';
  aggregate?: Maybe<Plot_Crop_Aggregate_Fields>;
  nodes: Array<Plot_Crop>;
};

/** aggregate fields of "plot_crop" */
export type Plot_Crop_Aggregate_Fields = {
  __typename?: 'plot_crop_aggregate_fields';
  avg?: Maybe<Plot_Crop_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Max_Fields>;
  min?: Maybe<Plot_Crop_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Variance_Fields>;
};


/** aggregate fields of "plot_crop" */
export type Plot_Crop_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_crop" */
export type Plot_Crop_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Crop_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Crop_Max_Order_By>;
  min?: InputMaybe<Plot_Crop_Min_Order_By>;
  stddev?: InputMaybe<Plot_Crop_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Crop_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Crop_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Crop_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Crop_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Crop_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Crop_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Plot_Crop_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "plot_crop" */
export type Plot_Crop_Arr_Rel_Insert_Input = {
  data: Array<Plot_Crop_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Crop_Avg_Fields = {
  __typename?: 'plot_crop_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_crop" */
export type Plot_Crop_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_crop". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  agents?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Int_Comparison_Exp>;
  current_crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  current_crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  estd_harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  estd_harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  estd_harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  estd_sowing_date?: InputMaybe<Date_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  growing_cycle?: InputMaybe<Int_Comparison_Exp>;
  harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_seed?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  p2p_distance?: InputMaybe<Numeric_Comparison_Exp>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  p2p_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  plant_count?: InputMaybe<Int_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  r2r_distance?: InputMaybe<Numeric_Comparison_Exp>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  r2r_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  sowing_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Plot_Status_Bool_Exp>;
  status_id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "plot_crop". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Bool_Exp_Remote_Rel_Monitoring_Recordplot_Crop = {
  _and?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  agents?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Recordplot_Crop>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Int_Comparison_Exp>;
  current_crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  current_crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  estd_harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  estd_harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  estd_harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  estd_sowing_date?: InputMaybe<Date_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  growing_cycle?: InputMaybe<Int_Comparison_Exp>;
  harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_seed?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  p2p_distance?: InputMaybe<Numeric_Comparison_Exp>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  p2p_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  plant_count?: InputMaybe<Int_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  r2r_distance?: InputMaybe<Numeric_Comparison_Exp>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  r2r_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  sowing_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Plot_Status_Bool_Exp>;
  status_id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "plot_crop". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Bool_Exp_Remote_Rel_Operationsplot_Crop = {
  _and?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  agents?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Operationsplot_Crop>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Int_Comparison_Exp>;
  current_crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  current_crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  estd_harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  estd_harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  estd_harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  estd_sowing_date?: InputMaybe<Date_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  growing_cycle?: InputMaybe<Int_Comparison_Exp>;
  harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_seed?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  p2p_distance?: InputMaybe<Numeric_Comparison_Exp>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  p2p_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  plant_count?: InputMaybe<Int_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  r2r_distance?: InputMaybe<Numeric_Comparison_Exp>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  r2r_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  sowing_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Plot_Status_Bool_Exp>;
  status_id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "plot_crop". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Bool_Exp_Remote_Rel_Shared_Entityplot_Crop = {
  _and?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  agents?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityplot_Crop>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Int_Comparison_Exp>;
  current_crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  current_crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  estd_harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  estd_harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  estd_harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  estd_sowing_date?: InputMaybe<Date_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  growing_cycle?: InputMaybe<Int_Comparison_Exp>;
  harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_seed?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  p2p_distance?: InputMaybe<Numeric_Comparison_Exp>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  p2p_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  plant_count?: InputMaybe<Int_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  r2r_distance?: InputMaybe<Numeric_Comparison_Exp>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  r2r_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  sowing_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Plot_Status_Bool_Exp>;
  status_id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "plot_crop". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Bool_Exp_Remote_Rel_Threadplot_Crop = {
  _and?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  agents?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Threadplot_Crop>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Int_Comparison_Exp>;
  current_crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  current_crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  estd_harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  estd_harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  estd_harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  estd_sowing_date?: InputMaybe<Date_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  growing_cycle?: InputMaybe<Int_Comparison_Exp>;
  harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_seed?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  p2p_distance?: InputMaybe<Numeric_Comparison_Exp>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  p2p_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  plant_count?: InputMaybe<Int_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  r2r_distance?: InputMaybe<Numeric_Comparison_Exp>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  r2r_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  sowing_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Plot_Status_Bool_Exp>;
  status_id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop" */
export enum Plot_Crop_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PlotCropCodenameKey = 'plot_crop_codename_key',
  /** unique or primary key constraint on columns "id" */
  PlotCropPkey = 'plot_crop_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Plot_Crop_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Plot_Crop_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Plot_Crop_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "plot_crop" */
export type Plot_Crop_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Scalars['Int']>;
  current_crop_year_id?: InputMaybe<Scalars['Int']>;
  estd_harvest_quantity?: InputMaybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  growing_cycle?: InputMaybe<Scalars['Int']>;
  harvest_quantity?: InputMaybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  p2p_distance?: InputMaybe<Scalars['numeric']>;
  p2p_distance_unit_id?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
  r2r_distance?: InputMaybe<Scalars['numeric']>;
  r2r_distance_unit_id?: InputMaybe<Scalars['Int']>;
  status_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop" */
export type Plot_Crop_Insert_Input = {
  agents?: InputMaybe<Plot_Crop_Agent_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  crop_variety?: InputMaybe<Crop_Variety_Obj_Rel_Insert_Input>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Scalars['Int']>;
  current_crop_year?: InputMaybe<Crop_Year_Obj_Rel_Insert_Input>;
  current_crop_year_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  estd_harvest_quantity?: InputMaybe<Scalars['numeric']>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  estd_harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  estd_harvesting_date?: InputMaybe<Scalars['date']>;
  estd_sowing_date?: InputMaybe<Scalars['date']>;
  farmer?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  growing_cycle?: InputMaybe<Scalars['Int']>;
  harvest_quantity?: InputMaybe<Scalars['numeric']>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  harvesting_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_seed?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Plot_Crop_Network_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  p2p_distance?: InputMaybe<Scalars['numeric']>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  p2p_distance_unit_id?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  plot?: InputMaybe<Plot_Obj_Rel_Insert_Input>;
  plot_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  r2r_distance?: InputMaybe<Scalars['numeric']>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  r2r_distance_unit_id?: InputMaybe<Scalars['Int']>;
  sowing_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Plot_Status_Obj_Rel_Insert_Input>;
  status_id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Plot_Crop_Max_Fields = {
  __typename?: 'plot_crop_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  crop_year?: Maybe<Scalars['Int']>;
  current_crop_year_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  estd_harvest_quantity?: Maybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  estd_harvesting_date?: Maybe<Scalars['date']>;
  estd_sowing_date?: Maybe<Scalars['date']>;
  farmer_id?: Maybe<Scalars['Int']>;
  growing_cycle?: Maybe<Scalars['Int']>;
  harvest_quantity?: Maybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  harvesting_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  p2p_distance?: Maybe<Scalars['numeric']>;
  p2p_distance_unit_id?: Maybe<Scalars['Int']>;
  plant_count?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
  r2r_distance?: Maybe<Scalars['numeric']>;
  r2r_distance_unit_id?: Maybe<Scalars['Int']>;
  sowing_date?: Maybe<Scalars['date']>;
  status_id?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "plot_crop" */
export type Plot_Crop_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  estd_harvesting_date?: InputMaybe<Order_By>;
  estd_sowing_date?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  harvesting_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  sowing_date?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** columns and relationships of "plot_crop_milestone" */
export type Plot_Crop_Milestone = {
  __typename?: 'plot_crop_milestone';
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  crop_milestone: Crop_Milestone;
  crop_milestone_id: Scalars['Int'];
  /** An object relationship */
  crop_year: Crop_Year;
  crop_year_id: Scalars['Int'];
  date: Scalars['date'];
  id: Scalars['Int'];
  /** An object relationship */
  plot_crop: Plot_Crop;
  plot_crop_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "plot_crop_milestone" */
export type Plot_Crop_Milestone_Aggregate = {
  __typename?: 'plot_crop_milestone_aggregate';
  aggregate?: Maybe<Plot_Crop_Milestone_Aggregate_Fields>;
  nodes: Array<Plot_Crop_Milestone>;
};

/** aggregate fields of "plot_crop_milestone" */
export type Plot_Crop_Milestone_Aggregate_Fields = {
  __typename?: 'plot_crop_milestone_aggregate_fields';
  avg?: Maybe<Plot_Crop_Milestone_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Milestone_Max_Fields>;
  min?: Maybe<Plot_Crop_Milestone_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Milestone_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Milestone_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Milestone_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Milestone_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Milestone_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Milestone_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Milestone_Variance_Fields>;
};


/** aggregate fields of "plot_crop_milestone" */
export type Plot_Crop_Milestone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Milestone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Plot_Crop_Milestone_Avg_Fields = {
  __typename?: 'plot_crop_milestone_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "plot_crop_milestone". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Milestone_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Milestone_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Milestone_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crop_milestone?: InputMaybe<Crop_Milestone_Bool_Exp>;
  crop_milestone_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  plot_crop?: InputMaybe<Plot_Crop_Bool_Exp>;
  plot_crop_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop_milestone" */
export enum Plot_Crop_Milestone_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlotCropMilestonePkey = 'plot_crop_milestone_pkey',
  /** unique or primary key constraint on columns "crop_milestone_id", "crop_year_id", "plot_crop_id" */
  PlotCropMilestonePlotCropIdCropMilest_8e9ba356Uniq = 'plot_crop_milestone_plot_crop_id_crop_milest_8e9ba356_uniq'
}

/** input type for incrementing numeric columns in table "plot_crop_milestone" */
export type Plot_Crop_Milestone_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_milestone_id?: InputMaybe<Scalars['Int']>;
  crop_year_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop_milestone" */
export type Plot_Crop_Milestone_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_milestone?: InputMaybe<Crop_Milestone_Obj_Rel_Insert_Input>;
  crop_milestone_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Crop_Year_Obj_Rel_Insert_Input>;
  crop_year_id?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop?: InputMaybe<Plot_Crop_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Crop_Milestone_Max_Fields = {
  __typename?: 'plot_crop_milestone_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_milestone_id?: Maybe<Scalars['Int']>;
  crop_year_id?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Plot_Crop_Milestone_Min_Fields = {
  __typename?: 'plot_crop_milestone_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_milestone_id?: Maybe<Scalars['Int']>;
  crop_year_id?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "plot_crop_milestone" */
export type Plot_Crop_Milestone_Mutation_Response = {
  __typename?: 'plot_crop_milestone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop_Milestone>;
};

/** on_conflict condition type for table "plot_crop_milestone" */
export type Plot_Crop_Milestone_On_Conflict = {
  constraint: Plot_Crop_Milestone_Constraint;
  update_columns?: Array<Plot_Crop_Milestone_Update_Column>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop_milestone". */
export type Plot_Crop_Milestone_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_milestone?: InputMaybe<Crop_Milestone_Order_By>;
  crop_milestone_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Crop_Year_Order_By>;
  crop_year_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Plot_Crop_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop_milestone */
export type Plot_Crop_Milestone_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_crop_milestone" */
export enum Plot_Crop_Milestone_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CropMilestoneId = 'crop_milestone_id',
  /** column name */
  CropYearId = 'crop_year_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "plot_crop_milestone" */
export type Plot_Crop_Milestone_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_milestone_id?: InputMaybe<Scalars['Int']>;
  crop_year_id?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Milestone_Stddev_Fields = {
  __typename?: 'plot_crop_milestone_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Milestone_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_milestone_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Milestone_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_milestone_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "plot_crop_milestone" */
export type Plot_Crop_Milestone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Milestone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Milestone_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_milestone_id?: InputMaybe<Scalars['Int']>;
  crop_year_id?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Milestone_Sum_Fields = {
  __typename?: 'plot_crop_milestone_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_milestone_id?: Maybe<Scalars['Int']>;
  crop_year_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "plot_crop_milestone" */
export enum Plot_Crop_Milestone_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CropMilestoneId = 'crop_milestone_id',
  /** column name */
  CropYearId = 'crop_year_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Plot_Crop_Milestone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Milestone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Milestone_Set_Input>;
  where: Plot_Crop_Milestone_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Milestone_Var_Pop_Fields = {
  __typename?: 'plot_crop_milestone_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Milestone_Var_Samp_Fields = {
  __typename?: 'plot_crop_milestone_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Plot_Crop_Milestone_Variance_Fields = {
  __typename?: 'plot_crop_milestone_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Plot_Crop_Min_Fields = {
  __typename?: 'plot_crop_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  crop_year?: Maybe<Scalars['Int']>;
  current_crop_year_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  estd_harvest_quantity?: Maybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  estd_harvesting_date?: Maybe<Scalars['date']>;
  estd_sowing_date?: Maybe<Scalars['date']>;
  farmer_id?: Maybe<Scalars['Int']>;
  growing_cycle?: Maybe<Scalars['Int']>;
  harvest_quantity?: Maybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  harvesting_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  p2p_distance?: Maybe<Scalars['numeric']>;
  p2p_distance_unit_id?: Maybe<Scalars['Int']>;
  plant_count?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
  r2r_distance?: Maybe<Scalars['numeric']>;
  r2r_distance_unit_id?: Maybe<Scalars['Int']>;
  sowing_date?: Maybe<Scalars['date']>;
  status_id?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "plot_crop" */
export type Plot_Crop_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  estd_harvesting_date?: InputMaybe<Order_By>;
  estd_sowing_date?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  harvesting_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  sowing_date?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_crop" */
export type Plot_Crop_Mutation_Response = {
  __typename?: 'plot_crop_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop>;
};

/** columns and relationships of "plot_crop_network" */
export type Plot_Crop_Network = {
  __typename?: 'plot_crop_network';
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
  /** An object relationship */
  plot_crop: Plot_Crop;
  plot_crop_id: Scalars['Int'];
};

/** aggregated selection of "plot_crop_network" */
export type Plot_Crop_Network_Aggregate = {
  __typename?: 'plot_crop_network_aggregate';
  aggregate?: Maybe<Plot_Crop_Network_Aggregate_Fields>;
  nodes: Array<Plot_Crop_Network>;
};

/** aggregate fields of "plot_crop_network" */
export type Plot_Crop_Network_Aggregate_Fields = {
  __typename?: 'plot_crop_network_aggregate_fields';
  avg?: Maybe<Plot_Crop_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Network_Max_Fields>;
  min?: Maybe<Plot_Crop_Network_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Network_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Network_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Network_Variance_Fields>;
};


/** aggregate fields of "plot_crop_network" */
export type Plot_Crop_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_crop_network" */
export type Plot_Crop_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Crop_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Crop_Network_Max_Order_By>;
  min?: InputMaybe<Plot_Crop_Network_Min_Order_By>;
  stddev?: InputMaybe<Plot_Crop_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Crop_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Crop_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Crop_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Crop_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Crop_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Crop_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_crop_network" */
export type Plot_Crop_Network_Arr_Rel_Insert_Input = {
  data: Array<Plot_Crop_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Crop_Network_Avg_Fields = {
  __typename?: 'plot_crop_network_avg_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_crop_network". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Network_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Network_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crop?: InputMaybe<Plot_Crop_Bool_Exp>;
  plot_crop_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop_network" */
export enum Plot_Crop_Network_Constraint {
  /** unique or primary key constraint on columns "plot_crop_id", "network_id" */
  PlotCropNetworkNetworkIdPlotCropId_907e1999Uniq = 'plot_crop_network_network_id_plot_crop_id_907e1999_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotCropNetworkPkey = 'plot_crop_network_pkey'
}

/** input type for incrementing numeric columns in table "plot_crop_network" */
export type Plot_Crop_Network_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop_network" */
export type Plot_Crop_Network_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_crop?: InputMaybe<Plot_Crop_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Crop_Network_Max_Fields = {
  __typename?: 'plot_crop_network_max_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Crop_Network_Min_Fields = {
  __typename?: 'plot_crop_network_min_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_crop_network" */
export type Plot_Crop_Network_Mutation_Response = {
  __typename?: 'plot_crop_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop_Network>;
};

/** on_conflict condition type for table "plot_crop_network" */
export type Plot_Crop_Network_On_Conflict = {
  constraint: Plot_Crop_Network_Constraint;
  update_columns?: Array<Plot_Crop_Network_Update_Column>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop_network". */
export type Plot_Crop_Network_Order_By = {
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Plot_Crop_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop_network */
export type Plot_Crop_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_crop_network" */
export enum Plot_Crop_Network_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

/** input type for updating data in table "plot_crop_network" */
export type Plot_Crop_Network_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Network_Stddev_Fields = {
  __typename?: 'plot_crop_network_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Network_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_network_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Network_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_network_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_crop_network" */
export type Plot_Crop_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Network_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Network_Sum_Fields = {
  __typename?: 'plot_crop_network_sum_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_crop_network" */
export enum Plot_Crop_Network_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

export type Plot_Crop_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Network_Set_Input>;
  where: Plot_Crop_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Network_Var_Pop_Fields = {
  __typename?: 'plot_crop_network_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Network_Var_Samp_Fields = {
  __typename?: 'plot_crop_network_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Crop_Network_Variance_Fields = {
  __typename?: 'plot_crop_network_variance_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "plot_crop" */
export type Plot_Crop_Obj_Rel_Insert_Input = {
  data: Plot_Crop_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_On_Conflict>;
};

/** on_conflict condition type for table "plot_crop" */
export type Plot_Crop_On_Conflict = {
  constraint: Plot_Crop_Constraint;
  update_columns?: Array<Plot_Crop_Update_Column>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop". */
export type Plot_Crop_Order_By = {
  agents_aggregate?: InputMaybe<Plot_Crop_Agent_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in?: InputMaybe<Department_Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety?: InputMaybe<Crop_Variety_Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year?: InputMaybe<Crop_Year_Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  estd_harvesting_date?: InputMaybe<Order_By>;
  estd_sowing_date?: InputMaybe<Order_By>;
  farmer?: InputMaybe<Base_User_Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  harvesting_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_seed?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Plot_Crop_Network_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot?: InputMaybe<Plot_Order_By>;
  plot_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  sowing_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Plot_Status_Order_By>;
  status_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop */
export type Plot_Crop_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Plot_Crop_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "plot_crop" */
export enum Plot_Crop_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  CropYear = 'crop_year',
  /** column name */
  CurrentCropYearId = 'current_crop_year_id',
  /** column name */
  Description = 'description',
  /** column name */
  EstdHarvestQuantity = 'estd_harvest_quantity',
  /** column name */
  EstdHarvestQuantityUnitId = 'estd_harvest_quantity_unit_id',
  /** column name */
  EstdHarvestingDate = 'estd_harvesting_date',
  /** column name */
  EstdSowingDate = 'estd_sowing_date',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  GrowingCycle = 'growing_cycle',
  /** column name */
  HarvestQuantity = 'harvest_quantity',
  /** column name */
  HarvestQuantityUnitId = 'harvest_quantity_unit_id',
  /** column name */
  HarvestingDate = 'harvesting_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsSeed = 'is_seed',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  P2pDistance = 'p2p_distance',
  /** column name */
  P2pDistanceUnitId = 'p2p_distance_unit_id',
  /** column name */
  PlantCount = 'plant_count',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  R2rDistance = 'r2r_distance',
  /** column name */
  R2rDistanceUnitId = 'r2r_distance_unit_id',
  /** column name */
  SowingDate = 'sowing_date',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "plot_crop" */
export type Plot_Crop_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Scalars['Int']>;
  current_crop_year_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  estd_harvest_quantity?: InputMaybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  estd_harvesting_date?: InputMaybe<Scalars['date']>;
  estd_sowing_date?: InputMaybe<Scalars['date']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  growing_cycle?: InputMaybe<Scalars['Int']>;
  harvest_quantity?: InputMaybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  harvesting_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_seed?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  p2p_distance?: InputMaybe<Scalars['numeric']>;
  p2p_distance_unit_id?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  r2r_distance?: InputMaybe<Scalars['numeric']>;
  r2r_distance_unit_id?: InputMaybe<Scalars['Int']>;
  sowing_date?: InputMaybe<Scalars['date']>;
  status_id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Stddev_Fields = {
  __typename?: 'plot_crop_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_crop" */
export type Plot_Crop_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_crop" */
export type Plot_Crop_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_crop" */
export type Plot_Crop_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_crop" */
export type Plot_Crop_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Scalars['Int']>;
  current_crop_year_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  estd_harvest_quantity?: InputMaybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  estd_harvesting_date?: InputMaybe<Scalars['date']>;
  estd_sowing_date?: InputMaybe<Scalars['date']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  growing_cycle?: InputMaybe<Scalars['Int']>;
  harvest_quantity?: InputMaybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  harvesting_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_seed?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  p2p_distance?: InputMaybe<Scalars['numeric']>;
  p2p_distance_unit_id?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  r2r_distance?: InputMaybe<Scalars['numeric']>;
  r2r_distance_unit_id?: InputMaybe<Scalars['Int']>;
  sowing_date?: InputMaybe<Scalars['date']>;
  status_id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Sum_Fields = {
  __typename?: 'plot_crop_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  crop_year?: Maybe<Scalars['Int']>;
  current_crop_year_id?: Maybe<Scalars['Int']>;
  estd_harvest_quantity?: Maybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  growing_cycle?: Maybe<Scalars['Int']>;
  harvest_quantity?: Maybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  p2p_distance?: Maybe<Scalars['numeric']>;
  p2p_distance_unit_id?: Maybe<Scalars['Int']>;
  plant_count?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
  r2r_distance?: Maybe<Scalars['numeric']>;
  r2r_distance_unit_id?: Maybe<Scalars['Int']>;
  status_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_crop" */
export type Plot_Crop_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_crop" */
export enum Plot_Crop_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  CropYear = 'crop_year',
  /** column name */
  CurrentCropYearId = 'current_crop_year_id',
  /** column name */
  Description = 'description',
  /** column name */
  EstdHarvestQuantity = 'estd_harvest_quantity',
  /** column name */
  EstdHarvestQuantityUnitId = 'estd_harvest_quantity_unit_id',
  /** column name */
  EstdHarvestingDate = 'estd_harvesting_date',
  /** column name */
  EstdSowingDate = 'estd_sowing_date',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  GrowingCycle = 'growing_cycle',
  /** column name */
  HarvestQuantity = 'harvest_quantity',
  /** column name */
  HarvestQuantityUnitId = 'harvest_quantity_unit_id',
  /** column name */
  HarvestingDate = 'harvesting_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsSeed = 'is_seed',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  P2pDistance = 'p2p_distance',
  /** column name */
  P2pDistanceUnitId = 'p2p_distance_unit_id',
  /** column name */
  PlantCount = 'plant_count',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  R2rDistance = 'r2r_distance',
  /** column name */
  R2rDistanceUnitId = 'r2r_distance_unit_id',
  /** column name */
  SowingDate = 'sowing_date',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Plot_Crop_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Plot_Crop_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Plot_Crop_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Plot_Crop_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Plot_Crop_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Plot_Crop_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Set_Input>;
  where: Plot_Crop_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Var_Pop_Fields = {
  __typename?: 'plot_crop_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_crop" */
export type Plot_Crop_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Var_Samp_Fields = {
  __typename?: 'plot_crop_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_crop" */
export type Plot_Crop_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Crop_Variance_Fields = {
  __typename?: 'plot_crop_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_crop" */
export type Plot_Crop_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Plot_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Plot_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Plot_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "plot" */
export type Plot_Inc_Input = {
  area?: InputMaybe<Scalars['numeric']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  field_id?: InputMaybe<Scalars['Int']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot" */
export type Plot_Insert_Input = {
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crops?: InputMaybe<Plot_Crop_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  farmer?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<Field_Obj_Rel_Insert_Input>;
  field_id?: InputMaybe<Scalars['Int']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Plot_Network_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Plot_Max_Fields = {
  __typename?: 'plot_max_fields';
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farmer_id?: Maybe<Scalars['Int']>;
  field_id?: Maybe<Scalars['Int']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "plot" */
export type Plot_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Min_Fields = {
  __typename?: 'plot_min_fields';
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farmer_id?: Maybe<Scalars['Int']>;
  field_id?: Maybe<Scalars['Int']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "plot" */
export type Plot_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot" */
export type Plot_Mutation_Response = {
  __typename?: 'plot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot>;
};

/** columns and relationships of "plot_network" */
export type Plot_Network = {
  __typename?: 'plot_network';
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
  /** An object relationship */
  plot: Plot;
  plot_id: Scalars['Int'];
};

/** aggregated selection of "plot_network" */
export type Plot_Network_Aggregate = {
  __typename?: 'plot_network_aggregate';
  aggregate?: Maybe<Plot_Network_Aggregate_Fields>;
  nodes: Array<Plot_Network>;
};

/** aggregate fields of "plot_network" */
export type Plot_Network_Aggregate_Fields = {
  __typename?: 'plot_network_aggregate_fields';
  avg?: Maybe<Plot_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Network_Max_Fields>;
  min?: Maybe<Plot_Network_Min_Fields>;
  stddev?: Maybe<Plot_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Network_Sum_Fields>;
  var_pop?: Maybe<Plot_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Network_Var_Samp_Fields>;
  variance?: Maybe<Plot_Network_Variance_Fields>;
};


/** aggregate fields of "plot_network" */
export type Plot_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_network" */
export type Plot_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Network_Max_Order_By>;
  min?: InputMaybe<Plot_Network_Min_Order_By>;
  stddev?: InputMaybe<Plot_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_network" */
export type Plot_Network_Arr_Rel_Insert_Input = {
  data: Array<Plot_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Network_Avg_Fields = {
  __typename?: 'plot_network_avg_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_network" */
export type Plot_Network_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_network". All fields are combined with a logical 'AND'. */
export type Plot_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Network_Bool_Exp>>;
  _not?: InputMaybe<Plot_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Network_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_network" */
export enum Plot_Network_Constraint {
  /** unique or primary key constraint on columns "plot_id", "network_id" */
  PlotNetworkNetworkIdPlotIdEfce5249Uniq = 'plot_network_network_id_plot_id_efce5249_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotNetworkPkey = 'plot_network_pkey'
}

/** input type for incrementing numeric columns in table "plot_network" */
export type Plot_Network_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_network" */
export type Plot_Network_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot?: InputMaybe<Plot_Obj_Rel_Insert_Input>;
  plot_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Network_Max_Fields = {
  __typename?: 'plot_network_max_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_network" */
export type Plot_Network_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Network_Min_Fields = {
  __typename?: 'plot_network_min_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_network" */
export type Plot_Network_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_network" */
export type Plot_Network_Mutation_Response = {
  __typename?: 'plot_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Network>;
};

/** on_conflict condition type for table "plot_network" */
export type Plot_Network_On_Conflict = {
  constraint: Plot_Network_Constraint;
  update_columns?: Array<Plot_Network_Update_Column>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_network". */
export type Plot_Network_Order_By = {
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot?: InputMaybe<Plot_Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_network */
export type Plot_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_network" */
export enum Plot_Network_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  PlotId = 'plot_id'
}

/** input type for updating data in table "plot_network" */
export type Plot_Network_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Network_Stddev_Fields = {
  __typename?: 'plot_network_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_network" */
export type Plot_Network_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Network_Stddev_Pop_Fields = {
  __typename?: 'plot_network_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_network" */
export type Plot_Network_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Network_Stddev_Samp_Fields = {
  __typename?: 'plot_network_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_network" */
export type Plot_Network_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_network" */
export type Plot_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Network_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Network_Sum_Fields = {
  __typename?: 'plot_network_sum_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_network" */
export type Plot_Network_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_network" */
export enum Plot_Network_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  PlotId = 'plot_id'
}

export type Plot_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Network_Set_Input>;
  where: Plot_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Network_Var_Pop_Fields = {
  __typename?: 'plot_network_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_network" */
export type Plot_Network_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Network_Var_Samp_Fields = {
  __typename?: 'plot_network_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_network" */
export type Plot_Network_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Network_Variance_Fields = {
  __typename?: 'plot_network_variance_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_network" */
export type Plot_Network_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "plot" */
export type Plot_Obj_Rel_Insert_Input = {
  data: Plot_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_On_Conflict>;
};

/** on_conflict condition type for table "plot" */
export type Plot_On_Conflict = {
  constraint: Plot_Constraint;
  update_columns?: Array<Plot_Update_Column>;
  where?: InputMaybe<Plot_Bool_Exp>;
};

/** Ordering options when selecting data from "plot". */
export type Plot_Order_By = {
  area?: InputMaybe<Order_By>;
  area_catered?: InputMaybe<Order_By>;
  area_unit?: InputMaybe<Si_Unit_Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in?: InputMaybe<Department_Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crops_aggregate?: InputMaybe<Plot_Crop_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  farmer?: InputMaybe<Base_User_Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Field_Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Plot_Network_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot */
export type Plot_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Plot_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "plot_risk_24hour" */
export type Plot_Risk_24hour = {
  __typename?: 'plot_risk_24hour';
  _text?: Maybe<Scalars['String']>;
  total_plots?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "plot_risk_24hour" */
export type Plot_Risk_24hour_Aggregate = {
  __typename?: 'plot_risk_24hour_aggregate';
  aggregate?: Maybe<Plot_Risk_24hour_Aggregate_Fields>;
  nodes: Array<Plot_Risk_24hour>;
};

/** aggregate fields of "plot_risk_24hour" */
export type Plot_Risk_24hour_Aggregate_Fields = {
  __typename?: 'plot_risk_24hour_aggregate_fields';
  avg?: Maybe<Plot_Risk_24hour_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Risk_24hour_Max_Fields>;
  min?: Maybe<Plot_Risk_24hour_Min_Fields>;
  stddev?: Maybe<Plot_Risk_24hour_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Risk_24hour_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Risk_24hour_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Risk_24hour_Sum_Fields>;
  var_pop?: Maybe<Plot_Risk_24hour_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Risk_24hour_Var_Samp_Fields>;
  variance?: Maybe<Plot_Risk_24hour_Variance_Fields>;
};


/** aggregate fields of "plot_risk_24hour" */
export type Plot_Risk_24hour_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Risk_24hour_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Plot_Risk_24hour_Avg_Fields = {
  __typename?: 'plot_risk_24hour_avg_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "plot_risk_24hour". All fields are combined with a logical 'AND'. */
export type Plot_Risk_24hour_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Risk_24hour_Bool_Exp>>;
  _not?: InputMaybe<Plot_Risk_24hour_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Risk_24hour_Bool_Exp>>;
  _text?: InputMaybe<String_Comparison_Exp>;
  total_plots?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Plot_Risk_24hour_Max_Fields = {
  __typename?: 'plot_risk_24hour_max_fields';
  _text?: Maybe<Scalars['String']>;
  total_plots?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Plot_Risk_24hour_Min_Fields = {
  __typename?: 'plot_risk_24hour_min_fields';
  _text?: Maybe<Scalars['String']>;
  total_plots?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "plot_risk_24hour". */
export type Plot_Risk_24hour_Order_By = {
  _text?: InputMaybe<Order_By>;
  total_plots?: InputMaybe<Order_By>;
};

/** select columns of table "plot_risk_24hour" */
export enum Plot_Risk_24hour_Select_Column {
  /** column name */
  Text = '_text',
  /** column name */
  TotalPlots = 'total_plots'
}

/** aggregate stddev on columns */
export type Plot_Risk_24hour_Stddev_Fields = {
  __typename?: 'plot_risk_24hour_stddev_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Plot_Risk_24hour_Stddev_Pop_Fields = {
  __typename?: 'plot_risk_24hour_stddev_pop_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Plot_Risk_24hour_Stddev_Samp_Fields = {
  __typename?: 'plot_risk_24hour_stddev_samp_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "plot_risk_24hour" */
export type Plot_Risk_24hour_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Risk_24hour_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Risk_24hour_Stream_Cursor_Value_Input = {
  _text?: InputMaybe<Scalars['String']>;
  total_plots?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Plot_Risk_24hour_Sum_Fields = {
  __typename?: 'plot_risk_24hour_sum_fields';
  total_plots?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Plot_Risk_24hour_Var_Pop_Fields = {
  __typename?: 'plot_risk_24hour_var_pop_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Plot_Risk_24hour_Var_Samp_Fields = {
  __typename?: 'plot_risk_24hour_var_samp_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Plot_Risk_24hour_Variance_Fields = {
  __typename?: 'plot_risk_24hour_variance_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "plot_risk_total" */
export type Plot_Risk_Total = {
  __typename?: 'plot_risk_total';
  _text?: Maybe<Scalars['String']>;
  total_plots?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "plot_risk_total" */
export type Plot_Risk_Total_Aggregate = {
  __typename?: 'plot_risk_total_aggregate';
  aggregate?: Maybe<Plot_Risk_Total_Aggregate_Fields>;
  nodes: Array<Plot_Risk_Total>;
};

/** aggregate fields of "plot_risk_total" */
export type Plot_Risk_Total_Aggregate_Fields = {
  __typename?: 'plot_risk_total_aggregate_fields';
  avg?: Maybe<Plot_Risk_Total_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Risk_Total_Max_Fields>;
  min?: Maybe<Plot_Risk_Total_Min_Fields>;
  stddev?: Maybe<Plot_Risk_Total_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Risk_Total_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Risk_Total_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Risk_Total_Sum_Fields>;
  var_pop?: Maybe<Plot_Risk_Total_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Risk_Total_Var_Samp_Fields>;
  variance?: Maybe<Plot_Risk_Total_Variance_Fields>;
};


/** aggregate fields of "plot_risk_total" */
export type Plot_Risk_Total_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Risk_Total_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Plot_Risk_Total_Avg_Fields = {
  __typename?: 'plot_risk_total_avg_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "plot_risk_total". All fields are combined with a logical 'AND'. */
export type Plot_Risk_Total_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Risk_Total_Bool_Exp>>;
  _not?: InputMaybe<Plot_Risk_Total_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Risk_Total_Bool_Exp>>;
  _text?: InputMaybe<String_Comparison_Exp>;
  total_plots?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Plot_Risk_Total_Max_Fields = {
  __typename?: 'plot_risk_total_max_fields';
  _text?: Maybe<Scalars['String']>;
  total_plots?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Plot_Risk_Total_Min_Fields = {
  __typename?: 'plot_risk_total_min_fields';
  _text?: Maybe<Scalars['String']>;
  total_plots?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "plot_risk_total". */
export type Plot_Risk_Total_Order_By = {
  _text?: InputMaybe<Order_By>;
  total_plots?: InputMaybe<Order_By>;
};

/** select columns of table "plot_risk_total" */
export enum Plot_Risk_Total_Select_Column {
  /** column name */
  Text = '_text',
  /** column name */
  TotalPlots = 'total_plots'
}

/** aggregate stddev on columns */
export type Plot_Risk_Total_Stddev_Fields = {
  __typename?: 'plot_risk_total_stddev_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Plot_Risk_Total_Stddev_Pop_Fields = {
  __typename?: 'plot_risk_total_stddev_pop_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Plot_Risk_Total_Stddev_Samp_Fields = {
  __typename?: 'plot_risk_total_stddev_samp_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "plot_risk_total" */
export type Plot_Risk_Total_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Risk_Total_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Risk_Total_Stream_Cursor_Value_Input = {
  _text?: InputMaybe<Scalars['String']>;
  total_plots?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Plot_Risk_Total_Sum_Fields = {
  __typename?: 'plot_risk_total_sum_fields';
  total_plots?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Plot_Risk_Total_Var_Pop_Fields = {
  __typename?: 'plot_risk_total_var_pop_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Plot_Risk_Total_Var_Samp_Fields = {
  __typename?: 'plot_risk_total_var_samp_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Plot_Risk_Total_Variance_Fields = {
  __typename?: 'plot_risk_total_variance_fields';
  total_plots?: Maybe<Scalars['Float']>;
};

/** select columns of table "plot" */
export enum Plot_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  AreaCatered = 'area_catered',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  GeoAreaRemark = 'geo_area_remark',
  /** column name */
  GeoBoundArea = 'geo_bound_area',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "plot" */
export type Plot_Set_Input = {
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  field_id?: InputMaybe<Scalars['Int']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "plot_status" */
export type Plot_Status = {
  __typename?: 'plot_status';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  private_metadata: Scalars['jsonb'];
  purpose?: Maybe<Scalars['String']>;
};


/** columns and relationships of "plot_status" */
export type Plot_StatusMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot_status" */
export type Plot_StatusPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "plot_status" */
export type Plot_Status_Aggregate = {
  __typename?: 'plot_status_aggregate';
  aggregate?: Maybe<Plot_Status_Aggregate_Fields>;
  nodes: Array<Plot_Status>;
};

/** aggregate fields of "plot_status" */
export type Plot_Status_Aggregate_Fields = {
  __typename?: 'plot_status_aggregate_fields';
  avg?: Maybe<Plot_Status_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Status_Max_Fields>;
  min?: Maybe<Plot_Status_Min_Fields>;
  stddev?: Maybe<Plot_Status_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Status_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Status_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Status_Sum_Fields>;
  var_pop?: Maybe<Plot_Status_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Status_Var_Samp_Fields>;
  variance?: Maybe<Plot_Status_Variance_Fields>;
};


/** aggregate fields of "plot_status" */
export type Plot_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Plot_Status_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Plot_Status_Avg_Fields = {
  __typename?: 'plot_status_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "plot_status". All fields are combined with a logical 'AND'. */
export type Plot_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Status_Bool_Exp>>;
  _not?: InputMaybe<Plot_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Status_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  purpose?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_status" */
export enum Plot_Status_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PlotStatusCodenameKey = 'plot_status_codename_key',
  /** unique or primary key constraint on columns "id" */
  PlotStatusPkey = 'plot_status_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Plot_Status_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Plot_Status_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Plot_Status_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "plot_status" */
export type Plot_Status_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_status" */
export type Plot_Status_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Plot_Status_Max_Fields = {
  __typename?: 'plot_status_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Plot_Status_Min_Fields = {
  __typename?: 'plot_status_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "plot_status" */
export type Plot_Status_Mutation_Response = {
  __typename?: 'plot_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Status>;
};

/** input type for inserting object relation for remote table "plot_status" */
export type Plot_Status_Obj_Rel_Insert_Input = {
  data: Plot_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Status_On_Conflict>;
};

/** on_conflict condition type for table "plot_status" */
export type Plot_Status_On_Conflict = {
  constraint: Plot_Status_Constraint;
  update_columns?: Array<Plot_Status_Update_Column>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_status". */
export type Plot_Status_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_status */
export type Plot_Status_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Plot_Status_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "plot_status" */
export enum Plot_Status_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Purpose = 'purpose'
}

/** input type for updating data in table "plot_status" */
export type Plot_Status_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Plot_Status_Stddev_Fields = {
  __typename?: 'plot_status_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Plot_Status_Stddev_Pop_Fields = {
  __typename?: 'plot_status_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Plot_Status_Stddev_Samp_Fields = {
  __typename?: 'plot_status_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "plot_status" */
export type Plot_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Status_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Plot_Status_Sum_Fields = {
  __typename?: 'plot_status_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "plot_status" */
export enum Plot_Status_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Purpose = 'purpose'
}

export type Plot_Status_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Plot_Status_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Plot_Status_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Plot_Status_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Plot_Status_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Status_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Plot_Status_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Status_Set_Input>;
  where: Plot_Status_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Status_Var_Pop_Fields = {
  __typename?: 'plot_status_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Plot_Status_Var_Samp_Fields = {
  __typename?: 'plot_status_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Plot_Status_Variance_Fields = {
  __typename?: 'plot_status_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Plot_Stddev_Fields = {
  __typename?: 'plot_stddev_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot" */
export type Plot_Stddev_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Stddev_Pop_Fields = {
  __typename?: 'plot_stddev_pop_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot" */
export type Plot_Stddev_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Stddev_Samp_Fields = {
  __typename?: 'plot_stddev_samp_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot" */
export type Plot_Stddev_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot" */
export type Plot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  field_id?: InputMaybe<Scalars['Int']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Plot_Sum_Fields = {
  __typename?: 'plot_sum_fields';
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  field_id?: Maybe<Scalars['Int']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot" */
export type Plot_Sum_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot" */
export enum Plot_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  AreaCatered = 'area_catered',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  GeoAreaRemark = 'geo_area_remark',
  /** column name */
  GeoBoundArea = 'geo_bound_area',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Plot_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Plot_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Plot_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Plot_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Plot_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Plot_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Set_Input>;
  where: Plot_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Var_Pop_Fields = {
  __typename?: 'plot_var_pop_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot" */
export type Plot_Var_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Var_Samp_Fields = {
  __typename?: 'plot_var_samp_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot" */
export type Plot_Var_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Variance_Fields = {
  __typename?: 'plot_variance_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot" */
export type Plot_Variance_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "primary_growth_stage" */
export type Primary_Growth_Stage = {
  __typename?: 'primary_growth_stage';
  base_stage: Scalars['String'];
  code: Scalars['String'];
  codename: Scalars['String'];
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  max_days_after: Scalars['Int'];
  min_days_after: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  secondary_growth_stages: Array<Secondary_Growth_Stage>;
  /** An aggregate relationship */
  secondary_growth_stages_aggregate: Secondary_Growth_Stage_Aggregate;
};


/** columns and relationships of "primary_growth_stage" */
export type Primary_Growth_StageSecondary_Growth_StagesArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


/** columns and relationships of "primary_growth_stage" */
export type Primary_Growth_StageSecondary_Growth_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};

/** aggregated selection of "primary_growth_stage" */
export type Primary_Growth_Stage_Aggregate = {
  __typename?: 'primary_growth_stage_aggregate';
  aggregate?: Maybe<Primary_Growth_Stage_Aggregate_Fields>;
  nodes: Array<Primary_Growth_Stage>;
};

/** aggregate fields of "primary_growth_stage" */
export type Primary_Growth_Stage_Aggregate_Fields = {
  __typename?: 'primary_growth_stage_aggregate_fields';
  avg?: Maybe<Primary_Growth_Stage_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Primary_Growth_Stage_Max_Fields>;
  min?: Maybe<Primary_Growth_Stage_Min_Fields>;
  stddev?: Maybe<Primary_Growth_Stage_Stddev_Fields>;
  stddev_pop?: Maybe<Primary_Growth_Stage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Primary_Growth_Stage_Stddev_Samp_Fields>;
  sum?: Maybe<Primary_Growth_Stage_Sum_Fields>;
  var_pop?: Maybe<Primary_Growth_Stage_Var_Pop_Fields>;
  var_samp?: Maybe<Primary_Growth_Stage_Var_Samp_Fields>;
  variance?: Maybe<Primary_Growth_Stage_Variance_Fields>;
};


/** aggregate fields of "primary_growth_stage" */
export type Primary_Growth_Stage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Primary_Growth_Stage_Avg_Fields = {
  __typename?: 'primary_growth_stage_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "primary_growth_stage". All fields are combined with a logical 'AND'. */
export type Primary_Growth_Stage_Bool_Exp = {
  _and?: InputMaybe<Array<Primary_Growth_Stage_Bool_Exp>>;
  _not?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Primary_Growth_Stage_Bool_Exp>>;
  base_stage?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_days_after?: InputMaybe<Int_Comparison_Exp>;
  min_days_after?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  secondary_growth_stages?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "primary_growth_stage". All fields are combined with a logical 'AND'. */
export type Primary_Growth_Stage_Bool_Exp_Remote_Rel_Monitoring_Recordprimary_Growth_Stage = {
  _and?: InputMaybe<Array<Primary_Growth_Stage_Bool_Exp>>;
  _not?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Primary_Growth_Stage_Bool_Exp>>;
  base_stage?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Recordprimary_Growth_Stage>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_days_after?: InputMaybe<Int_Comparison_Exp>;
  min_days_after?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  secondary_growth_stages?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};

/** unique or primary key constraints on table "primary_growth_stage" */
export enum Primary_Growth_Stage_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PrimaryGrowthStageCodenameKey = 'primary_growth_stage_codename_key',
  /** unique or primary key constraint on columns "crop_id", "code" */
  PrimaryGrowthStageCropIdCode_390ea762Uniq = 'primary_growth_stage_crop_id_code_390ea762_uniq',
  /** unique or primary key constraint on columns "id" */
  PrimaryGrowthStagePkey = 'primary_growth_stage_pkey'
}

/** input type for incrementing numeric columns in table "primary_growth_stage" */
export type Primary_Growth_Stage_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "primary_growth_stage" */
export type Primary_Growth_Stage_Insert_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  secondary_growth_stages?: InputMaybe<Secondary_Growth_Stage_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Primary_Growth_Stage_Max_Fields = {
  __typename?: 'primary_growth_stage_max_fields';
  base_stage?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Primary_Growth_Stage_Min_Fields = {
  __typename?: 'primary_growth_stage_min_fields';
  base_stage?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "primary_growth_stage" */
export type Primary_Growth_Stage_Mutation_Response = {
  __typename?: 'primary_growth_stage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Primary_Growth_Stage>;
};

/** input type for inserting object relation for remote table "primary_growth_stage" */
export type Primary_Growth_Stage_Obj_Rel_Insert_Input = {
  data: Primary_Growth_Stage_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Primary_Growth_Stage_On_Conflict>;
};

/** on_conflict condition type for table "primary_growth_stage" */
export type Primary_Growth_Stage_On_Conflict = {
  constraint: Primary_Growth_Stage_Constraint;
  update_columns?: Array<Primary_Growth_Stage_Update_Column>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};

/** Ordering options when selecting data from "primary_growth_stage". */
export type Primary_Growth_Stage_Order_By = {
  base_stage?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  secondary_growth_stages_aggregate?: InputMaybe<Secondary_Growth_Stage_Aggregate_Order_By>;
};

/** primary key columns input for table: primary_growth_stage */
export type Primary_Growth_Stage_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "primary_growth_stage" */
export enum Primary_Growth_Stage_Select_Column {
  /** column name */
  BaseStage = 'base_stage',
  /** column name */
  Code = 'code',
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxDaysAfter = 'max_days_after',
  /** column name */
  MinDaysAfter = 'min_days_after',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

/** input type for updating data in table "primary_growth_stage" */
export type Primary_Growth_Stage_Set_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Primary_Growth_Stage_Stddev_Fields = {
  __typename?: 'primary_growth_stage_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Primary_Growth_Stage_Stddev_Pop_Fields = {
  __typename?: 'primary_growth_stage_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Primary_Growth_Stage_Stddev_Samp_Fields = {
  __typename?: 'primary_growth_stage_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "primary_growth_stage" */
export type Primary_Growth_Stage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Primary_Growth_Stage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Primary_Growth_Stage_Stream_Cursor_Value_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Primary_Growth_Stage_Sum_Fields = {
  __typename?: 'primary_growth_stage_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "primary_growth_stage" */
export enum Primary_Growth_Stage_Update_Column {
  /** column name */
  BaseStage = 'base_stage',
  /** column name */
  Code = 'code',
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxDaysAfter = 'max_days_after',
  /** column name */
  MinDaysAfter = 'min_days_after',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

export type Primary_Growth_Stage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Primary_Growth_Stage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Primary_Growth_Stage_Set_Input>;
  where: Primary_Growth_Stage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Primary_Growth_Stage_Var_Pop_Fields = {
  __typename?: 'primary_growth_stage_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Primary_Growth_Stage_Var_Samp_Fields = {
  __typename?: 'primary_growth_stage_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Primary_Growth_Stage_Variance_Fields = {
  __typename?: 'primary_growth_stage_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "produce_insights" */
export type Produce_Insights = {
  __typename?: 'produce_insights';
  plot_id?: Maybe<Scalars['String']>;
  produce_type?: Maybe<Scalars['String']>;
  total_quantity?: Maybe<Scalars['float8']>;
  total_value?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "produce_insights" */
export type Produce_Insights_Aggregate = {
  __typename?: 'produce_insights_aggregate';
  aggregate?: Maybe<Produce_Insights_Aggregate_Fields>;
  nodes: Array<Produce_Insights>;
};

/** aggregate fields of "produce_insights" */
export type Produce_Insights_Aggregate_Fields = {
  __typename?: 'produce_insights_aggregate_fields';
  avg?: Maybe<Produce_Insights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Produce_Insights_Max_Fields>;
  min?: Maybe<Produce_Insights_Min_Fields>;
  stddev?: Maybe<Produce_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<Produce_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Produce_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<Produce_Insights_Sum_Fields>;
  var_pop?: Maybe<Produce_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<Produce_Insights_Var_Samp_Fields>;
  variance?: Maybe<Produce_Insights_Variance_Fields>;
};


/** aggregate fields of "produce_insights" */
export type Produce_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Produce_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Produce_Insights_Avg_Fields = {
  __typename?: 'produce_insights_avg_fields';
  total_quantity?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "produce_insights". All fields are combined with a logical 'AND'. */
export type Produce_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<Produce_Insights_Bool_Exp>>;
  _not?: InputMaybe<Produce_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<Produce_Insights_Bool_Exp>>;
  plot_id?: InputMaybe<String_Comparison_Exp>;
  produce_type?: InputMaybe<String_Comparison_Exp>;
  total_quantity?: InputMaybe<Float8_Comparison_Exp>;
  total_value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Produce_Insights_Max_Fields = {
  __typename?: 'produce_insights_max_fields';
  plot_id?: Maybe<Scalars['String']>;
  produce_type?: Maybe<Scalars['String']>;
  total_quantity?: Maybe<Scalars['float8']>;
  total_value?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Produce_Insights_Min_Fields = {
  __typename?: 'produce_insights_min_fields';
  plot_id?: Maybe<Scalars['String']>;
  produce_type?: Maybe<Scalars['String']>;
  total_quantity?: Maybe<Scalars['float8']>;
  total_value?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "produce_insights". */
export type Produce_Insights_Order_By = {
  plot_id?: InputMaybe<Order_By>;
  produce_type?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  total_value?: InputMaybe<Order_By>;
};

/** select columns of table "produce_insights" */
export enum Produce_Insights_Select_Column {
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  ProduceType = 'produce_type',
  /** column name */
  TotalQuantity = 'total_quantity',
  /** column name */
  TotalValue = 'total_value'
}

/** aggregate stddev on columns */
export type Produce_Insights_Stddev_Fields = {
  __typename?: 'produce_insights_stddev_fields';
  total_quantity?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Produce_Insights_Stddev_Pop_Fields = {
  __typename?: 'produce_insights_stddev_pop_fields';
  total_quantity?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Produce_Insights_Stddev_Samp_Fields = {
  __typename?: 'produce_insights_stddev_samp_fields';
  total_quantity?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "produce_insights" */
export type Produce_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Produce_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Produce_Insights_Stream_Cursor_Value_Input = {
  plot_id?: InputMaybe<Scalars['String']>;
  produce_type?: InputMaybe<Scalars['String']>;
  total_quantity?: InputMaybe<Scalars['float8']>;
  total_value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Produce_Insights_Sum_Fields = {
  __typename?: 'produce_insights_sum_fields';
  total_quantity?: Maybe<Scalars['float8']>;
  total_value?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Produce_Insights_Var_Pop_Fields = {
  __typename?: 'produce_insights_var_pop_fields';
  total_quantity?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Produce_Insights_Var_Samp_Fields = {
  __typename?: 'produce_insights_var_samp_fields';
  total_quantity?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Produce_Insights_Variance_Fields = {
  __typename?: 'produce_insights_variance_fields';
  total_quantity?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "product" */
export type Product = {
  __typename?: 'product';
  /** An array relationship */
  applicable_units: Array<Application_Product_Unit>;
  /** An aggregate relationship */
  applicable_units_aggregate: Application_Product_Unit_Aggregate;
  composition_text?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  /** An object relationship */
  featured_image?: Maybe<Common_Fileupload>;
  featured_image_id?: Maybe<Scalars['bigint']>;
  formulation_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  manufactured_by_id: Scalars['uuid'];
  /** An object relationship */
  manufacturing_facility: Manufacturing_Facility;
  marketed_by_id: Scalars['uuid'];
  /** An object relationship */
  marketing_facility: Marketing_Facility;
  media_upload_complete: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  product_attachments: Array<Product_Attachment>;
  /** An aggregate relationship */
  product_attachments_aggregate: Product_Attachment_Aggregate;
  /** An array relationship */
  product_certifications: Array<Product_Certification>;
  /** An aggregate relationship */
  product_certifications_aggregate: Product_Certification_Aggregate;
  /** An array relationship */
  product_compositions: Array<Product_Composition>;
  /** An aggregate relationship */
  product_compositions_aggregate: Product_Composition_Aggregate;
  /** An array relationship */
  product_crop_association_recommendation: Array<Product_Crop_Association>;
  /** An aggregate relationship */
  product_crop_association_recommendation_aggregate: Product_Crop_Association_Aggregate;
  /** An array relationship */
  product_crop_associations: Array<Product_Crop_Association>;
  /** An aggregate relationship */
  product_crop_associations_aggregate: Product_Crop_Association_Aggregate;
  /** An array relationship */
  product_crop_infestation_recommendations: Array<Product_Crop_Infestation_Recommendation>;
  /** An aggregate relationship */
  product_crop_infestation_recommendations_aggregate: Product_Crop_Infestation_Recommendation_Aggregate;
  /** An array relationship */
  product_crop_nutrition_recommendations: Array<Product_Crop_Nutrition_Recommendation>;
  /** An aggregate relationship */
  product_crop_nutrition_recommendations_aggregate: Product_Crop_Nutrition_Recommendation_Aggregate;
  /** An array relationship */
  product_favourites: Array<Product_Favourite>;
  /** An aggregate relationship */
  product_favourites_aggregate: Product_Favourite_Aggregate;
  /** An array relationship */
  product_infestations: Array<Product_Infestation>;
  /** An aggregate relationship */
  product_infestations_aggregate: Product_Infestation_Aggregate;
  /** An array relationship */
  product_mainsections: Array<Product_Mainsection>;
  /** An aggregate relationship */
  product_mainsections_aggregate: Product_Mainsection_Aggregate;
  /** An array relationship */
  product_purchased: Array<Product_Purchased>;
  /** An aggregate relationship */
  product_purchased_aggregate: Product_Purchased_Aggregate;
  /** An array relationship */
  product_views: Array<Product_View>;
  /** An aggregate relationship */
  product_views_aggregate: Product_View_Aggregate;
  /** An array relationship */
  sellable_items: Array<Sellable_Item>;
  /** An aggregate relationship */
  sellable_items_aggregate: Sellable_Item_Aggregate;
  status: Scalars['String'];
  /** An object relationship */
  subcategory: Subcategory;
  subcategory_id: Scalars['uuid'];
  translation_complete: Scalars['Boolean'];
};


/** columns and relationships of "product" */
export type ProductApplicable_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Application_Product_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Product_Unit_Order_By>>;
  where?: InputMaybe<Application_Product_Unit_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductApplicable_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Product_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Product_Unit_Order_By>>;
  where?: InputMaybe<Application_Product_Unit_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Product_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attachment_Order_By>>;
  where?: InputMaybe<Product_Attachment_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attachment_Order_By>>;
  where?: InputMaybe<Product_Attachment_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_CertificationsArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Order_By>>;
  where?: InputMaybe<Product_Certification_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Certifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Order_By>>;
  where?: InputMaybe<Product_Certification_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_CompositionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Composition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Composition_Order_By>>;
  where?: InputMaybe<Product_Composition_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Compositions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Composition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Composition_Order_By>>;
  where?: InputMaybe<Product_Composition_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Crop_Association_RecommendationArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Association_Order_By>>;
  where?: InputMaybe<Product_Crop_Association_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Crop_Association_Recommendation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Association_Order_By>>;
  where?: InputMaybe<Product_Crop_Association_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Crop_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Association_Order_By>>;
  where?: InputMaybe<Product_Crop_Association_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Crop_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Association_Order_By>>;
  where?: InputMaybe<Product_Crop_Association_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Crop_Infestation_RecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Crop_Infestation_Recommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Crop_Nutrition_RecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Nutrition_Recommendation_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Crop_Nutrition_Recommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Nutrition_Recommendation_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_FavouritesArgs = {
  distinct_on?: InputMaybe<Array<Product_Favourite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Favourite_Order_By>>;
  where?: InputMaybe<Product_Favourite_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Favourites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Favourite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Favourite_Order_By>>;
  where?: InputMaybe<Product_Favourite_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_InfestationsArgs = {
  distinct_on?: InputMaybe<Array<Product_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Infestation_Order_By>>;
  where?: InputMaybe<Product_Infestation_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Infestations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Infestation_Order_By>>;
  where?: InputMaybe<Product_Infestation_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_MainsectionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Mainsections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_PurchasedArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchased_Order_By>>;
  where?: InputMaybe<Product_Purchased_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Purchased_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchased_Order_By>>;
  where?: InputMaybe<Product_Purchased_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_View_Order_By>>;
  where?: InputMaybe<Product_View_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_View_Order_By>>;
  where?: InputMaybe<Product_View_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductSellable_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Order_By>>;
  where?: InputMaybe<Sellable_Item_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductSellable_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Order_By>>;
  where?: InputMaybe<Sellable_Item_Bool_Exp>;
};

/** aggregated selection of "product" */
export type Product_Aggregate = {
  __typename?: 'product_aggregate';
  aggregate?: Maybe<Product_Aggregate_Fields>;
  nodes: Array<Product>;
};

/** aggregate fields of "product" */
export type Product_Aggregate_Fields = {
  __typename?: 'product_aggregate_fields';
  avg?: Maybe<Product_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Max_Fields>;
  min?: Maybe<Product_Min_Fields>;
  stddev?: Maybe<Product_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Sum_Fields>;
  var_pop?: Maybe<Product_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Var_Samp_Fields>;
  variance?: Maybe<Product_Variance_Fields>;
};


/** aggregate fields of "product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product" */
export type Product_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Max_Order_By>;
  min?: InputMaybe<Product_Min_Order_By>;
  stddev?: InputMaybe<Product_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product" */
export type Product_Arr_Rel_Insert_Input = {
  data: Array<Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** columns and relationships of "product_attachment" */
export type Product_Attachment = {
  __typename?: 'product_attachment';
  attachment_id: Scalars['bigint'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  order: Scalars['smallint'];
  /** An object relationship */
  photo: Common_Fileupload;
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid'];
};

/** aggregated selection of "product_attachment" */
export type Product_Attachment_Aggregate = {
  __typename?: 'product_attachment_aggregate';
  aggregate?: Maybe<Product_Attachment_Aggregate_Fields>;
  nodes: Array<Product_Attachment>;
};

/** aggregate fields of "product_attachment" */
export type Product_Attachment_Aggregate_Fields = {
  __typename?: 'product_attachment_aggregate_fields';
  avg?: Maybe<Product_Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Attachment_Max_Fields>;
  min?: Maybe<Product_Attachment_Min_Fields>;
  stddev?: Maybe<Product_Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Attachment_Sum_Fields>;
  var_pop?: Maybe<Product_Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Attachment_Var_Samp_Fields>;
  variance?: Maybe<Product_Attachment_Variance_Fields>;
};


/** aggregate fields of "product_attachment" */
export type Product_Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_attachment" */
export type Product_Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Attachment_Max_Order_By>;
  min?: InputMaybe<Product_Attachment_Min_Order_By>;
  stddev?: InputMaybe<Product_Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_attachment" */
export type Product_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Product_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Attachment_Avg_Fields = {
  __typename?: 'product_attachment_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_attachment" */
export type Product_Attachment_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_attachment". All fields are combined with a logical 'AND'. */
export type Product_Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Attachment_Bool_Exp>>;
  _not?: InputMaybe<Product_Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Attachment_Bool_Exp>>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  photo?: InputMaybe<Common_Fileupload_Bool_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_attachment" */
export enum Product_Attachment_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductAttachmentPkey = 'product_attachment_pkey'
}

/** input type for incrementing numeric columns in table "product_attachment" */
export type Product_Attachment_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "product_attachment" */
export type Product_Attachment_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  photo?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Product_Attachment_Max_Fields = {
  __typename?: 'product_attachment_max_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product_attachment" */
export type Product_Attachment_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Attachment_Min_Fields = {
  __typename?: 'product_attachment_min_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product_attachment" */
export type Product_Attachment_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_attachment" */
export type Product_Attachment_Mutation_Response = {
  __typename?: 'product_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Attachment>;
};

/** on_conflict condition type for table "product_attachment" */
export type Product_Attachment_On_Conflict = {
  constraint: Product_Attachment_Constraint;
  update_columns?: Array<Product_Attachment_Update_Column>;
  where?: InputMaybe<Product_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "product_attachment". */
export type Product_Attachment_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  photo?: InputMaybe<Common_Fileupload_Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_attachment */
export type Product_Attachment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_attachment" */
export enum Product_Attachment_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Language = 'language',
  /** column name */
  Order = 'order',
  /** column name */
  ProductId = 'product_id'
}

/** input type for updating data in table "product_attachment" */
export type Product_Attachment_Set_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Product_Attachment_Stddev_Fields = {
  __typename?: 'product_attachment_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_attachment" */
export type Product_Attachment_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Attachment_Stddev_Pop_Fields = {
  __typename?: 'product_attachment_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_attachment" */
export type Product_Attachment_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Attachment_Stddev_Samp_Fields = {
  __typename?: 'product_attachment_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_attachment" */
export type Product_Attachment_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_attachment" */
export type Product_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Attachment_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Product_Attachment_Sum_Fields = {
  __typename?: 'product_attachment_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "product_attachment" */
export type Product_Attachment_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_attachment" */
export enum Product_Attachment_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Language = 'language',
  /** column name */
  Order = 'order',
  /** column name */
  ProductId = 'product_id'
}

export type Product_Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Attachment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Attachment_Set_Input>;
  where: Product_Attachment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Attachment_Var_Pop_Fields = {
  __typename?: 'product_attachment_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_attachment" */
export type Product_Attachment_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Attachment_Var_Samp_Fields = {
  __typename?: 'product_attachment_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_attachment" */
export type Product_Attachment_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Attachment_Variance_Fields = {
  __typename?: 'product_attachment_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_attachment" */
export type Product_Attachment_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_attribute" */
export type Product_Attribute = {
  __typename?: 'product_attribute';
  /** An object relationship */
  attribute: Attribute;
  attribute_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  main_section_id?: Maybe<Scalars['uuid']>;
  order: Scalars['smallint'];
  /** An array relationship */
  product_attribute_choices: Array<Product_Attribute_Choice>;
  /** An aggregate relationship */
  product_attribute_choices_aggregate: Product_Attribute_Choice_Aggregate;
  /** An object relationship */
  product_mainsection?: Maybe<Product_Mainsection>;
  /** An object relationship */
  product_section?: Maybe<Product_Section>;
  /** An object relationship */
  product_subsection?: Maybe<Product_Subsection>;
  section_id?: Maybe<Scalars['uuid']>;
  subsection_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};


/** columns and relationships of "product_attribute" */
export type Product_AttributeProduct_Attribute_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Choice_Order_By>>;
  where?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
};


/** columns and relationships of "product_attribute" */
export type Product_AttributeProduct_Attribute_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Choice_Order_By>>;
  where?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
};

/** aggregated selection of "product_attribute" */
export type Product_Attribute_Aggregate = {
  __typename?: 'product_attribute_aggregate';
  aggregate?: Maybe<Product_Attribute_Aggregate_Fields>;
  nodes: Array<Product_Attribute>;
};

/** aggregate fields of "product_attribute" */
export type Product_Attribute_Aggregate_Fields = {
  __typename?: 'product_attribute_aggregate_fields';
  avg?: Maybe<Product_Attribute_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Attribute_Max_Fields>;
  min?: Maybe<Product_Attribute_Min_Fields>;
  stddev?: Maybe<Product_Attribute_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Attribute_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Attribute_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Attribute_Sum_Fields>;
  var_pop?: Maybe<Product_Attribute_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Attribute_Var_Samp_Fields>;
  variance?: Maybe<Product_Attribute_Variance_Fields>;
};


/** aggregate fields of "product_attribute" */
export type Product_Attribute_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_attribute" */
export type Product_Attribute_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Attribute_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Attribute_Max_Order_By>;
  min?: InputMaybe<Product_Attribute_Min_Order_By>;
  stddev?: InputMaybe<Product_Attribute_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Attribute_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Attribute_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Attribute_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Attribute_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Attribute_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Attribute_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_attribute" */
export type Product_Attribute_Arr_Rel_Insert_Input = {
  data: Array<Product_Attribute_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Attribute_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Attribute_Avg_Fields = {
  __typename?: 'product_attribute_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_attribute" */
export type Product_Attribute_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_attribute". All fields are combined with a logical 'AND'. */
export type Product_Attribute_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Attribute_Bool_Exp>>;
  _not?: InputMaybe<Product_Attribute_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Attribute_Bool_Exp>>;
  attribute?: InputMaybe<Attribute_Bool_Exp>;
  attribute_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  main_section_id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  product_attribute_choices?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
  product_mainsection?: InputMaybe<Product_Mainsection_Bool_Exp>;
  product_section?: InputMaybe<Product_Section_Bool_Exp>;
  product_subsection?: InputMaybe<Product_Subsection_Bool_Exp>;
  section_id?: InputMaybe<Uuid_Comparison_Exp>;
  subsection_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "product_attribute_choice" */
export type Product_Attribute_Choice = {
  __typename?: 'product_attribute_choice';
  /** An object relationship */
  attribute_choice: Attribute_Choice;
  choice_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  order: Scalars['smallint'];
  /** An object relationship */
  product_attribute: Product_Attribute;
  product_attribute_id: Scalars['uuid'];
};

/** aggregated selection of "product_attribute_choice" */
export type Product_Attribute_Choice_Aggregate = {
  __typename?: 'product_attribute_choice_aggregate';
  aggregate?: Maybe<Product_Attribute_Choice_Aggregate_Fields>;
  nodes: Array<Product_Attribute_Choice>;
};

/** aggregate fields of "product_attribute_choice" */
export type Product_Attribute_Choice_Aggregate_Fields = {
  __typename?: 'product_attribute_choice_aggregate_fields';
  avg?: Maybe<Product_Attribute_Choice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Attribute_Choice_Max_Fields>;
  min?: Maybe<Product_Attribute_Choice_Min_Fields>;
  stddev?: Maybe<Product_Attribute_Choice_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Attribute_Choice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Attribute_Choice_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Attribute_Choice_Sum_Fields>;
  var_pop?: Maybe<Product_Attribute_Choice_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Attribute_Choice_Var_Samp_Fields>;
  variance?: Maybe<Product_Attribute_Choice_Variance_Fields>;
};


/** aggregate fields of "product_attribute_choice" */
export type Product_Attribute_Choice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Attribute_Choice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_attribute_choice" */
export type Product_Attribute_Choice_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Attribute_Choice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Attribute_Choice_Max_Order_By>;
  min?: InputMaybe<Product_Attribute_Choice_Min_Order_By>;
  stddev?: InputMaybe<Product_Attribute_Choice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Attribute_Choice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Attribute_Choice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Attribute_Choice_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Attribute_Choice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Attribute_Choice_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Attribute_Choice_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_attribute_choice" */
export type Product_Attribute_Choice_Arr_Rel_Insert_Input = {
  data: Array<Product_Attribute_Choice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Attribute_Choice_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Attribute_Choice_Avg_Fields = {
  __typename?: 'product_attribute_choice_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_attribute_choice" */
export type Product_Attribute_Choice_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_attribute_choice". All fields are combined with a logical 'AND'. */
export type Product_Attribute_Choice_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Attribute_Choice_Bool_Exp>>;
  _not?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Attribute_Choice_Bool_Exp>>;
  attribute_choice?: InputMaybe<Attribute_Choice_Bool_Exp>;
  choice_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  product_attribute?: InputMaybe<Product_Attribute_Bool_Exp>;
  product_attribute_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_attribute_choice" */
export enum Product_Attribute_Choice_Constraint {
  /** unique or primary key constraint on columns "choice_id", "product_attribute_id" */
  ProductAttributeChoiceChoiceIdProductAttribF80ffe8cUniq = 'product_attribute_choice_choice_id_product_attrib_f80ffe8c_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductAttributeChoicePkey = 'product_attribute_choice_pkey'
}

/** input type for incrementing numeric columns in table "product_attribute_choice" */
export type Product_Attribute_Choice_Inc_Input = {
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "product_attribute_choice" */
export type Product_Attribute_Choice_Insert_Input = {
  attribute_choice?: InputMaybe<Attribute_Choice_Obj_Rel_Insert_Input>;
  choice_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_attribute?: InputMaybe<Product_Attribute_Obj_Rel_Insert_Input>;
  product_attribute_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Product_Attribute_Choice_Max_Fields = {
  __typename?: 'product_attribute_choice_max_fields';
  choice_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  product_attribute_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product_attribute_choice" */
export type Product_Attribute_Choice_Max_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_attribute_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Attribute_Choice_Min_Fields = {
  __typename?: 'product_attribute_choice_min_fields';
  choice_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  product_attribute_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product_attribute_choice" */
export type Product_Attribute_Choice_Min_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_attribute_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_attribute_choice" */
export type Product_Attribute_Choice_Mutation_Response = {
  __typename?: 'product_attribute_choice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Attribute_Choice>;
};

/** on_conflict condition type for table "product_attribute_choice" */
export type Product_Attribute_Choice_On_Conflict = {
  constraint: Product_Attribute_Choice_Constraint;
  update_columns?: Array<Product_Attribute_Choice_Update_Column>;
  where?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
};

/** Ordering options when selecting data from "product_attribute_choice". */
export type Product_Attribute_Choice_Order_By = {
  attribute_choice?: InputMaybe<Attribute_Choice_Order_By>;
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_attribute?: InputMaybe<Product_Attribute_Order_By>;
  product_attribute_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_attribute_choice */
export type Product_Attribute_Choice_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_attribute_choice" */
export enum Product_Attribute_Choice_Select_Column {
  /** column name */
  ChoiceId = 'choice_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  ProductAttributeId = 'product_attribute_id'
}

/** input type for updating data in table "product_attribute_choice" */
export type Product_Attribute_Choice_Set_Input = {
  choice_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_attribute_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Product_Attribute_Choice_Stddev_Fields = {
  __typename?: 'product_attribute_choice_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_attribute_choice" */
export type Product_Attribute_Choice_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Attribute_Choice_Stddev_Pop_Fields = {
  __typename?: 'product_attribute_choice_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_attribute_choice" */
export type Product_Attribute_Choice_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Attribute_Choice_Stddev_Samp_Fields = {
  __typename?: 'product_attribute_choice_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_attribute_choice" */
export type Product_Attribute_Choice_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_attribute_choice" */
export type Product_Attribute_Choice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Attribute_Choice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Attribute_Choice_Stream_Cursor_Value_Input = {
  choice_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_attribute_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Product_Attribute_Choice_Sum_Fields = {
  __typename?: 'product_attribute_choice_sum_fields';
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "product_attribute_choice" */
export type Product_Attribute_Choice_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_attribute_choice" */
export enum Product_Attribute_Choice_Update_Column {
  /** column name */
  ChoiceId = 'choice_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  ProductAttributeId = 'product_attribute_id'
}

export type Product_Attribute_Choice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Attribute_Choice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Attribute_Choice_Set_Input>;
  where: Product_Attribute_Choice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Attribute_Choice_Var_Pop_Fields = {
  __typename?: 'product_attribute_choice_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_attribute_choice" */
export type Product_Attribute_Choice_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Attribute_Choice_Var_Samp_Fields = {
  __typename?: 'product_attribute_choice_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_attribute_choice" */
export type Product_Attribute_Choice_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Attribute_Choice_Variance_Fields = {
  __typename?: 'product_attribute_choice_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_attribute_choice" */
export type Product_Attribute_Choice_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "product_attribute" */
export enum Product_Attribute_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductAttributePkey = 'product_attribute_pkey'
}

/** input type for incrementing numeric columns in table "product_attribute" */
export type Product_Attribute_Inc_Input = {
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "product_attribute" */
export type Product_Attribute_Insert_Input = {
  attribute?: InputMaybe<Attribute_Obj_Rel_Insert_Input>;
  attribute_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  main_section_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_attribute_choices?: InputMaybe<Product_Attribute_Choice_Arr_Rel_Insert_Input>;
  product_mainsection?: InputMaybe<Product_Mainsection_Obj_Rel_Insert_Input>;
  product_section?: InputMaybe<Product_Section_Obj_Rel_Insert_Input>;
  product_subsection?: InputMaybe<Product_Subsection_Obj_Rel_Insert_Input>;
  section_id?: InputMaybe<Scalars['uuid']>;
  subsection_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Attribute_Max_Fields = {
  __typename?: 'product_attribute_max_fields';
  attribute_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  main_section_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  section_id?: Maybe<Scalars['uuid']>;
  subsection_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_attribute" */
export type Product_Attribute_Max_Order_By = {
  attribute_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  main_section_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  subsection_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Attribute_Min_Fields = {
  __typename?: 'product_attribute_min_fields';
  attribute_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  main_section_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  section_id?: Maybe<Scalars['uuid']>;
  subsection_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_attribute" */
export type Product_Attribute_Min_Order_By = {
  attribute_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  main_section_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  subsection_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_attribute" */
export type Product_Attribute_Mutation_Response = {
  __typename?: 'product_attribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Attribute>;
};

/** input type for inserting object relation for remote table "product_attribute" */
export type Product_Attribute_Obj_Rel_Insert_Input = {
  data: Product_Attribute_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Attribute_On_Conflict>;
};

/** on_conflict condition type for table "product_attribute" */
export type Product_Attribute_On_Conflict = {
  constraint: Product_Attribute_Constraint;
  update_columns?: Array<Product_Attribute_Update_Column>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};

/** Ordering options when selecting data from "product_attribute". */
export type Product_Attribute_Order_By = {
  attribute?: InputMaybe<Attribute_Order_By>;
  attribute_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  main_section_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_attribute_choices_aggregate?: InputMaybe<Product_Attribute_Choice_Aggregate_Order_By>;
  product_mainsection?: InputMaybe<Product_Mainsection_Order_By>;
  product_section?: InputMaybe<Product_Section_Order_By>;
  product_subsection?: InputMaybe<Product_Subsection_Order_By>;
  section_id?: InputMaybe<Order_By>;
  subsection_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_attribute */
export type Product_Attribute_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_attribute" */
export enum Product_Attribute_Select_Column {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MainSectionId = 'main_section_id',
  /** column name */
  Order = 'order',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  SubsectionId = 'subsection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "product_attribute" */
export type Product_Attribute_Set_Input = {
  attribute_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  main_section_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  section_id?: InputMaybe<Scalars['uuid']>;
  subsection_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Attribute_Stddev_Fields = {
  __typename?: 'product_attribute_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_attribute" */
export type Product_Attribute_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Attribute_Stddev_Pop_Fields = {
  __typename?: 'product_attribute_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_attribute" */
export type Product_Attribute_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Attribute_Stddev_Samp_Fields = {
  __typename?: 'product_attribute_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_attribute" */
export type Product_Attribute_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_attribute" */
export type Product_Attribute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Attribute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Attribute_Stream_Cursor_Value_Input = {
  attribute_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  main_section_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  section_id?: InputMaybe<Scalars['uuid']>;
  subsection_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_Attribute_Sum_Fields = {
  __typename?: 'product_attribute_sum_fields';
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "product_attribute" */
export type Product_Attribute_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_attribute" */
export enum Product_Attribute_Update_Column {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MainSectionId = 'main_section_id',
  /** column name */
  Order = 'order',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  SubsectionId = 'subsection_id',
  /** column name */
  Value = 'value'
}

export type Product_Attribute_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Attribute_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Attribute_Set_Input>;
  where: Product_Attribute_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Attribute_Var_Pop_Fields = {
  __typename?: 'product_attribute_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_attribute" */
export type Product_Attribute_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Attribute_Var_Samp_Fields = {
  __typename?: 'product_attribute_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_attribute" */
export type Product_Attribute_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Attribute_Variance_Fields = {
  __typename?: 'product_attribute_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_attribute" */
export type Product_Attribute_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Product_Avg_Fields = {
  __typename?: 'product_avg_fields';
  featured_image_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product" */
export type Product_Avg_Order_By = {
  featured_image_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bool_Exp>>;
  _not?: InputMaybe<Product_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bool_Exp>>;
  applicable_units?: InputMaybe<Application_Product_Unit_Bool_Exp>;
  composition_text?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  featured_image?: InputMaybe<Common_Fileupload_Bool_Exp>;
  featured_image_id?: InputMaybe<Bigint_Comparison_Exp>;
  formulation_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  manufactured_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  manufacturing_facility?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
  marketed_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  marketing_facility?: InputMaybe<Marketing_Facility_Bool_Exp>;
  media_upload_complete?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  product_attachments?: InputMaybe<Product_Attachment_Bool_Exp>;
  product_certifications?: InputMaybe<Product_Certification_Bool_Exp>;
  product_compositions?: InputMaybe<Product_Composition_Bool_Exp>;
  product_crop_association_recommendation?: InputMaybe<Product_Crop_Association_Bool_Exp>;
  product_crop_associations?: InputMaybe<Product_Crop_Association_Bool_Exp>;
  product_crop_infestation_recommendations?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
  product_crop_nutrition_recommendations?: InputMaybe<Product_Crop_Nutrition_Recommendation_Bool_Exp>;
  product_favourites?: InputMaybe<Product_Favourite_Bool_Exp>;
  product_infestations?: InputMaybe<Product_Infestation_Bool_Exp>;
  product_mainsections?: InputMaybe<Product_Mainsection_Bool_Exp>;
  product_purchased?: InputMaybe<Product_Purchased_Bool_Exp>;
  product_views?: InputMaybe<Product_View_Bool_Exp>;
  sellable_items?: InputMaybe<Sellable_Item_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subcategory?: InputMaybe<Subcategory_Bool_Exp>;
  subcategory_id?: InputMaybe<Uuid_Comparison_Exp>;
  translation_complete?: InputMaybe<Boolean_Comparison_Exp>;
};

/** columns and relationships of "product_certification" */
export type Product_Certification = {
  __typename?: 'product_certification';
  /** An object relationship */
  certification: Certification;
  certification_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  issue_date: Scalars['date'];
  name: Scalars['String'];
  order: Scalars['smallint'];
  /** An object relationship */
  product: Product;
  /** An array relationship */
  product_certification_attachments: Array<Product_Certification_Attachment>;
  /** An aggregate relationship */
  product_certification_attachments_aggregate: Product_Certification_Attachment_Aggregate;
  product_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  valid_till_date?: Maybe<Scalars['date']>;
};


/** columns and relationships of "product_certification" */
export type Product_CertificationProduct_Certification_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Attachment_Order_By>>;
  where?: InputMaybe<Product_Certification_Attachment_Bool_Exp>;
};


/** columns and relationships of "product_certification" */
export type Product_CertificationProduct_Certification_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Attachment_Order_By>>;
  where?: InputMaybe<Product_Certification_Attachment_Bool_Exp>;
};

/** aggregated selection of "product_certification" */
export type Product_Certification_Aggregate = {
  __typename?: 'product_certification_aggregate';
  aggregate?: Maybe<Product_Certification_Aggregate_Fields>;
  nodes: Array<Product_Certification>;
};

/** aggregate fields of "product_certification" */
export type Product_Certification_Aggregate_Fields = {
  __typename?: 'product_certification_aggregate_fields';
  avg?: Maybe<Product_Certification_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Certification_Max_Fields>;
  min?: Maybe<Product_Certification_Min_Fields>;
  stddev?: Maybe<Product_Certification_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Certification_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Certification_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Certification_Sum_Fields>;
  var_pop?: Maybe<Product_Certification_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Certification_Var_Samp_Fields>;
  variance?: Maybe<Product_Certification_Variance_Fields>;
};


/** aggregate fields of "product_certification" */
export type Product_Certification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Certification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_certification" */
export type Product_Certification_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Certification_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Certification_Max_Order_By>;
  min?: InputMaybe<Product_Certification_Min_Order_By>;
  stddev?: InputMaybe<Product_Certification_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Certification_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Certification_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Certification_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Certification_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Certification_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Certification_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_certification" */
export type Product_Certification_Arr_Rel_Insert_Input = {
  data: Array<Product_Certification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Certification_On_Conflict>;
};

/** columns and relationships of "product_certification_attachment" */
export type Product_Certification_Attachment = {
  __typename?: 'product_certification_attachment';
  attachment_id: Scalars['bigint'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  order: Scalars['smallint'];
  /** An object relationship */
  photo: Common_Fileupload;
  product_certificate_id: Scalars['uuid'];
  /** An object relationship */
  product_certification: Product_Certification;
};

/** aggregated selection of "product_certification_attachment" */
export type Product_Certification_Attachment_Aggregate = {
  __typename?: 'product_certification_attachment_aggregate';
  aggregate?: Maybe<Product_Certification_Attachment_Aggregate_Fields>;
  nodes: Array<Product_Certification_Attachment>;
};

/** aggregate fields of "product_certification_attachment" */
export type Product_Certification_Attachment_Aggregate_Fields = {
  __typename?: 'product_certification_attachment_aggregate_fields';
  avg?: Maybe<Product_Certification_Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Certification_Attachment_Max_Fields>;
  min?: Maybe<Product_Certification_Attachment_Min_Fields>;
  stddev?: Maybe<Product_Certification_Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Certification_Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Certification_Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Certification_Attachment_Sum_Fields>;
  var_pop?: Maybe<Product_Certification_Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Certification_Attachment_Var_Samp_Fields>;
  variance?: Maybe<Product_Certification_Attachment_Variance_Fields>;
};


/** aggregate fields of "product_certification_attachment" */
export type Product_Certification_Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Certification_Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_certification_attachment" */
export type Product_Certification_Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Certification_Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Certification_Attachment_Max_Order_By>;
  min?: InputMaybe<Product_Certification_Attachment_Min_Order_By>;
  stddev?: InputMaybe<Product_Certification_Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Certification_Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Certification_Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Certification_Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Certification_Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Certification_Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Certification_Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_certification_attachment" */
export type Product_Certification_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Product_Certification_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Certification_Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Certification_Attachment_Avg_Fields = {
  __typename?: 'product_certification_attachment_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_certification_attachment" */
export type Product_Certification_Attachment_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_certification_attachment". All fields are combined with a logical 'AND'. */
export type Product_Certification_Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Certification_Attachment_Bool_Exp>>;
  _not?: InputMaybe<Product_Certification_Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Certification_Attachment_Bool_Exp>>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  photo?: InputMaybe<Common_Fileupload_Bool_Exp>;
  product_certificate_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_certification?: InputMaybe<Product_Certification_Bool_Exp>;
};

/** unique or primary key constraints on table "product_certification_attachment" */
export enum Product_Certification_Attachment_Constraint {
  /** unique or primary key constraint on columns "product_certificate_id", "order" */
  ProductsProductcertificProductCertificateIdOB7ca9521Uniq = 'products_productcertific_product_certificate_id_o_b7ca9521_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductsProductcertificateattachmentsPkey = 'products_productcertificateattachments_pkey'
}

/** input type for incrementing numeric columns in table "product_certification_attachment" */
export type Product_Certification_Attachment_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "product_certification_attachment" */
export type Product_Certification_Attachment_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  photo?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  product_certificate_id?: InputMaybe<Scalars['uuid']>;
  product_certification?: InputMaybe<Product_Certification_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Product_Certification_Attachment_Max_Fields = {
  __typename?: 'product_certification_attachment_max_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  product_certificate_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product_certification_attachment" */
export type Product_Certification_Attachment_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_certificate_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Certification_Attachment_Min_Fields = {
  __typename?: 'product_certification_attachment_min_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  product_certificate_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product_certification_attachment" */
export type Product_Certification_Attachment_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_certificate_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_certification_attachment" */
export type Product_Certification_Attachment_Mutation_Response = {
  __typename?: 'product_certification_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Certification_Attachment>;
};

/** on_conflict condition type for table "product_certification_attachment" */
export type Product_Certification_Attachment_On_Conflict = {
  constraint: Product_Certification_Attachment_Constraint;
  update_columns?: Array<Product_Certification_Attachment_Update_Column>;
  where?: InputMaybe<Product_Certification_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "product_certification_attachment". */
export type Product_Certification_Attachment_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  photo?: InputMaybe<Common_Fileupload_Order_By>;
  product_certificate_id?: InputMaybe<Order_By>;
  product_certification?: InputMaybe<Product_Certification_Order_By>;
};

/** primary key columns input for table: product_certification_attachment */
export type Product_Certification_Attachment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_certification_attachment" */
export enum Product_Certification_Attachment_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  ProductCertificateId = 'product_certificate_id'
}

/** input type for updating data in table "product_certification_attachment" */
export type Product_Certification_Attachment_Set_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_certificate_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Product_Certification_Attachment_Stddev_Fields = {
  __typename?: 'product_certification_attachment_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_certification_attachment" */
export type Product_Certification_Attachment_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Certification_Attachment_Stddev_Pop_Fields = {
  __typename?: 'product_certification_attachment_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_certification_attachment" */
export type Product_Certification_Attachment_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Certification_Attachment_Stddev_Samp_Fields = {
  __typename?: 'product_certification_attachment_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_certification_attachment" */
export type Product_Certification_Attachment_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_certification_attachment" */
export type Product_Certification_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Certification_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Certification_Attachment_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_certificate_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Product_Certification_Attachment_Sum_Fields = {
  __typename?: 'product_certification_attachment_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "product_certification_attachment" */
export type Product_Certification_Attachment_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_certification_attachment" */
export enum Product_Certification_Attachment_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  ProductCertificateId = 'product_certificate_id'
}

export type Product_Certification_Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Certification_Attachment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Certification_Attachment_Set_Input>;
  where: Product_Certification_Attachment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Certification_Attachment_Var_Pop_Fields = {
  __typename?: 'product_certification_attachment_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_certification_attachment" */
export type Product_Certification_Attachment_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Certification_Attachment_Var_Samp_Fields = {
  __typename?: 'product_certification_attachment_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_certification_attachment" */
export type Product_Certification_Attachment_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Certification_Attachment_Variance_Fields = {
  __typename?: 'product_certification_attachment_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_certification_attachment" */
export type Product_Certification_Attachment_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Product_Certification_Avg_Fields = {
  __typename?: 'product_certification_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_certification" */
export type Product_Certification_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_certification". All fields are combined with a logical 'AND'. */
export type Product_Certification_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Certification_Bool_Exp>>;
  _not?: InputMaybe<Product_Certification_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Certification_Bool_Exp>>;
  certification?: InputMaybe<Certification_Bool_Exp>;
  certification_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  issue_date?: InputMaybe<Date_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_certification_attachments?: InputMaybe<Product_Certification_Attachment_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  valid_till_date?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_certification" */
export enum Product_Certification_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductCertificationPkey = 'product_certification_pkey',
  /** unique or primary key constraint on columns "certification_id", "product_id" */
  ProductCertificationProductIdCertificationIdC1e6e554Uniq = 'product_certification_product_id_certification_id_c1e6e554_uniq'
}

/** input type for incrementing numeric columns in table "product_certification" */
export type Product_Certification_Inc_Input = {
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "product_certification" */
export type Product_Certification_Insert_Input = {
  certification?: InputMaybe<Certification_Obj_Rel_Insert_Input>;
  certification_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  issue_date?: InputMaybe<Scalars['date']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_certification_attachments?: InputMaybe<Product_Certification_Attachment_Arr_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  valid_till_date?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Product_Certification_Max_Fields = {
  __typename?: 'product_certification_max_fields';
  certification_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  issue_date?: Maybe<Scalars['date']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  valid_till_date?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "product_certification" */
export type Product_Certification_Max_Order_By = {
  certification_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_till_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Certification_Min_Fields = {
  __typename?: 'product_certification_min_fields';
  certification_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  issue_date?: Maybe<Scalars['date']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  valid_till_date?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "product_certification" */
export type Product_Certification_Min_Order_By = {
  certification_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_till_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_certification" */
export type Product_Certification_Mutation_Response = {
  __typename?: 'product_certification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Certification>;
};

/** input type for inserting object relation for remote table "product_certification" */
export type Product_Certification_Obj_Rel_Insert_Input = {
  data: Product_Certification_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Certification_On_Conflict>;
};

/** on_conflict condition type for table "product_certification" */
export type Product_Certification_On_Conflict = {
  constraint: Product_Certification_Constraint;
  update_columns?: Array<Product_Certification_Update_Column>;
  where?: InputMaybe<Product_Certification_Bool_Exp>;
};

/** Ordering options when selecting data from "product_certification". */
export type Product_Certification_Order_By = {
  certification?: InputMaybe<Certification_Order_By>;
  certification_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_certification_attachments_aggregate?: InputMaybe<Product_Certification_Attachment_Aggregate_Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_till_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_certification */
export type Product_Certification_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_certification" */
export enum Product_Certification_Select_Column {
  /** column name */
  CertificationId = 'certification_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidTillDate = 'valid_till_date'
}

/** input type for updating data in table "product_certification" */
export type Product_Certification_Set_Input = {
  certification_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  issue_date?: InputMaybe<Scalars['date']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  valid_till_date?: InputMaybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type Product_Certification_Stddev_Fields = {
  __typename?: 'product_certification_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_certification" */
export type Product_Certification_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Certification_Stddev_Pop_Fields = {
  __typename?: 'product_certification_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_certification" */
export type Product_Certification_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Certification_Stddev_Samp_Fields = {
  __typename?: 'product_certification_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_certification" */
export type Product_Certification_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_certification" */
export type Product_Certification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Certification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Certification_Stream_Cursor_Value_Input = {
  certification_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  issue_date?: InputMaybe<Scalars['date']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  valid_till_date?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Product_Certification_Sum_Fields = {
  __typename?: 'product_certification_sum_fields';
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "product_certification" */
export type Product_Certification_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_certification" */
export enum Product_Certification_Update_Column {
  /** column name */
  CertificationId = 'certification_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidTillDate = 'valid_till_date'
}

export type Product_Certification_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Certification_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Certification_Set_Input>;
  where: Product_Certification_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Certification_Var_Pop_Fields = {
  __typename?: 'product_certification_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_certification" */
export type Product_Certification_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Certification_Var_Samp_Fields = {
  __typename?: 'product_certification_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_certification" */
export type Product_Certification_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Certification_Variance_Fields = {
  __typename?: 'product_certification_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_certification" */
export type Product_Certification_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_class" */
export type Product_Class = {
  __typename?: 'product_class';
  /** An array relationship */
  categories: Array<Category>;
  /** An aggregate relationship */
  categories_aggregate: Category_Aggregate;
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};


/** columns and relationships of "product_class" */
export type Product_ClassCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


/** columns and relationships of "product_class" */
export type Product_ClassCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};

/** aggregated selection of "product_class" */
export type Product_Class_Aggregate = {
  __typename?: 'product_class_aggregate';
  aggregate?: Maybe<Product_Class_Aggregate_Fields>;
  nodes: Array<Product_Class>;
};

/** aggregate fields of "product_class" */
export type Product_Class_Aggregate_Fields = {
  __typename?: 'product_class_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Product_Class_Max_Fields>;
  min?: Maybe<Product_Class_Min_Fields>;
};


/** aggregate fields of "product_class" */
export type Product_Class_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Class_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "product_class". All fields are combined with a logical 'AND'. */
export type Product_Class_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Class_Bool_Exp>>;
  _not?: InputMaybe<Product_Class_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Class_Bool_Exp>>;
  categories?: InputMaybe<Category_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_class" */
export enum Product_Class_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductClassPkey = 'product_class_pkey'
}

/** input type for inserting data into table "product_class" */
export type Product_Class_Insert_Input = {
  categories?: InputMaybe<Category_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Class_Max_Fields = {
  __typename?: 'product_class_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Product_Class_Min_Fields = {
  __typename?: 'product_class_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "product_class" */
export type Product_Class_Mutation_Response = {
  __typename?: 'product_class_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Class>;
};

/** input type for inserting object relation for remote table "product_class" */
export type Product_Class_Obj_Rel_Insert_Input = {
  data: Product_Class_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Class_On_Conflict>;
};

/** on_conflict condition type for table "product_class" */
export type Product_Class_On_Conflict = {
  constraint: Product_Class_Constraint;
  update_columns?: Array<Product_Class_Update_Column>;
  where?: InputMaybe<Product_Class_Bool_Exp>;
};

/** Ordering options when selecting data from "product_class". */
export type Product_Class_Order_By = {
  categories_aggregate?: InputMaybe<Category_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_class */
export type Product_Class_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_class" */
export enum Product_Class_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "product_class" */
export type Product_Class_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "product_class" */
export type Product_Class_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Class_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Class_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "product_class" */
export enum Product_Class_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Product_Class_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Class_Set_Input>;
  where: Product_Class_Bool_Exp;
};

/** columns and relationships of "product_composition" */
export type Product_Composition = {
  __typename?: 'product_composition';
  content: Scalars['float8'];
  /** An object relationship */
  content_unit?: Maybe<Care_Shared_Entity>;
  content_unit_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  /** An object relationship */
  ingredient: Ingredient;
  ingredient_id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid'];
};

/** aggregated selection of "product_composition" */
export type Product_Composition_Aggregate = {
  __typename?: 'product_composition_aggregate';
  aggregate?: Maybe<Product_Composition_Aggregate_Fields>;
  nodes: Array<Product_Composition>;
};

/** aggregate fields of "product_composition" */
export type Product_Composition_Aggregate_Fields = {
  __typename?: 'product_composition_aggregate_fields';
  avg?: Maybe<Product_Composition_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Composition_Max_Fields>;
  min?: Maybe<Product_Composition_Min_Fields>;
  stddev?: Maybe<Product_Composition_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Composition_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Composition_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Composition_Sum_Fields>;
  var_pop?: Maybe<Product_Composition_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Composition_Var_Samp_Fields>;
  variance?: Maybe<Product_Composition_Variance_Fields>;
};


/** aggregate fields of "product_composition" */
export type Product_Composition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Composition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_composition" */
export type Product_Composition_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Composition_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Composition_Max_Order_By>;
  min?: InputMaybe<Product_Composition_Min_Order_By>;
  stddev?: InputMaybe<Product_Composition_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Composition_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Composition_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Composition_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Composition_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Composition_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Composition_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_composition" */
export type Product_Composition_Arr_Rel_Insert_Input = {
  data: Array<Product_Composition_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Composition_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Composition_Avg_Fields = {
  __typename?: 'product_composition_avg_fields';
  content?: Maybe<Scalars['Float']>;
  content_unit_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_composition" */
export type Product_Composition_Avg_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_composition". All fields are combined with a logical 'AND'. */
export type Product_Composition_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Composition_Bool_Exp>>;
  _not?: InputMaybe<Product_Composition_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Composition_Bool_Exp>>;
  content?: InputMaybe<Float8_Comparison_Exp>;
  content_unit?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  content_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ingredient?: InputMaybe<Ingredient_Bool_Exp>;
  ingredient_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_composition" */
export enum Product_Composition_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductCompositionPkey = 'product_composition_pkey',
  /** unique or primary key constraint on columns "product_id", "ingredient_id" */
  ProductCompositionProductIdIngredientId_84f115fdUniq = 'product_composition_product_id_ingredient_id_84f115fd_uniq'
}

/** input type for incrementing numeric columns in table "product_composition" */
export type Product_Composition_Inc_Input = {
  content?: InputMaybe<Scalars['float8']>;
  content_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "product_composition" */
export type Product_Composition_Insert_Input = {
  content?: InputMaybe<Scalars['float8']>;
  content_unit?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  content_unit_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  ingredient?: InputMaybe<Ingredient_Obj_Rel_Insert_Input>;
  ingredient_id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Product_Composition_Max_Fields = {
  __typename?: 'product_composition_max_fields';
  content?: Maybe<Scalars['float8']>;
  content_unit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  ingredient_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product_composition" */
export type Product_Composition_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ingredient_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Composition_Min_Fields = {
  __typename?: 'product_composition_min_fields';
  content?: Maybe<Scalars['float8']>;
  content_unit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  ingredient_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product_composition" */
export type Product_Composition_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ingredient_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_composition" */
export type Product_Composition_Mutation_Response = {
  __typename?: 'product_composition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Composition>;
};

/** on_conflict condition type for table "product_composition" */
export type Product_Composition_On_Conflict = {
  constraint: Product_Composition_Constraint;
  update_columns?: Array<Product_Composition_Update_Column>;
  where?: InputMaybe<Product_Composition_Bool_Exp>;
};

/** Ordering options when selecting data from "product_composition". */
export type Product_Composition_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit?: InputMaybe<Care_Shared_Entity_Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ingredient?: InputMaybe<Ingredient_Order_By>;
  ingredient_id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_composition */
export type Product_Composition_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_composition" */
export enum Product_Composition_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  ContentUnitId = 'content_unit_id',
  /** column name */
  Id = 'id',
  /** column name */
  IngredientId = 'ingredient_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id'
}

/** input type for updating data in table "product_composition" */
export type Product_Composition_Set_Input = {
  content?: InputMaybe<Scalars['float8']>;
  content_unit_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  ingredient_id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Product_Composition_Stddev_Fields = {
  __typename?: 'product_composition_stddev_fields';
  content?: Maybe<Scalars['Float']>;
  content_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_composition" */
export type Product_Composition_Stddev_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Composition_Stddev_Pop_Fields = {
  __typename?: 'product_composition_stddev_pop_fields';
  content?: Maybe<Scalars['Float']>;
  content_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_composition" */
export type Product_Composition_Stddev_Pop_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Composition_Stddev_Samp_Fields = {
  __typename?: 'product_composition_stddev_samp_fields';
  content?: Maybe<Scalars['Float']>;
  content_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_composition" */
export type Product_Composition_Stddev_Samp_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_composition" */
export type Product_Composition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Composition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Composition_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['float8']>;
  content_unit_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  ingredient_id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Product_Composition_Sum_Fields = {
  __typename?: 'product_composition_sum_fields';
  content?: Maybe<Scalars['float8']>;
  content_unit_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "product_composition" */
export type Product_Composition_Sum_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
};

/** update columns of table "product_composition" */
export enum Product_Composition_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  ContentUnitId = 'content_unit_id',
  /** column name */
  Id = 'id',
  /** column name */
  IngredientId = 'ingredient_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id'
}

export type Product_Composition_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Composition_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Composition_Set_Input>;
  where: Product_Composition_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Composition_Var_Pop_Fields = {
  __typename?: 'product_composition_var_pop_fields';
  content?: Maybe<Scalars['Float']>;
  content_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_composition" */
export type Product_Composition_Var_Pop_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Composition_Var_Samp_Fields = {
  __typename?: 'product_composition_var_samp_fields';
  content?: Maybe<Scalars['Float']>;
  content_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_composition" */
export type Product_Composition_Var_Samp_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Composition_Variance_Fields = {
  __typename?: 'product_composition_variance_fields';
  content?: Maybe<Scalars['Float']>;
  content_unit_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_composition" */
export type Product_Composition_Variance_Order_By = {
  content?: InputMaybe<Order_By>;
  content_unit_id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "product" */
export enum Product_Constraint {
  /** unique or primary key constraint on columns "name", "subcategory_id", "marketed_by_id" */
  ProductNameSubcategoryIdMarketedByIdBc917bb2Uniq = 'product_name_subcategory_id_marketed_by_id_bc917bb2_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductPkey = 'product_pkey'
}

/** columns and relationships of "product_crop_association" */
export type Product_Crop_Association = {
  __typename?: 'product_crop_association';
  association_type: Scalars['String'];
  /** An object relationship */
  crop?: Maybe<Care_Shared_Entity>;
  /** An object relationship */
  crop_group?: Maybe<Care_Shared_Entity>;
  crop_group_id?: Maybe<Scalars['bigint']>;
  crop_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid'];
};

/** aggregated selection of "product_crop_association" */
export type Product_Crop_Association_Aggregate = {
  __typename?: 'product_crop_association_aggregate';
  aggregate?: Maybe<Product_Crop_Association_Aggregate_Fields>;
  nodes: Array<Product_Crop_Association>;
};

/** aggregate fields of "product_crop_association" */
export type Product_Crop_Association_Aggregate_Fields = {
  __typename?: 'product_crop_association_aggregate_fields';
  avg?: Maybe<Product_Crop_Association_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Crop_Association_Max_Fields>;
  min?: Maybe<Product_Crop_Association_Min_Fields>;
  stddev?: Maybe<Product_Crop_Association_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Crop_Association_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Crop_Association_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Crop_Association_Sum_Fields>;
  var_pop?: Maybe<Product_Crop_Association_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Crop_Association_Var_Samp_Fields>;
  variance?: Maybe<Product_Crop_Association_Variance_Fields>;
};


/** aggregate fields of "product_crop_association" */
export type Product_Crop_Association_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Crop_Association_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_crop_association" */
export type Product_Crop_Association_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Crop_Association_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Crop_Association_Max_Order_By>;
  min?: InputMaybe<Product_Crop_Association_Min_Order_By>;
  stddev?: InputMaybe<Product_Crop_Association_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Crop_Association_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Crop_Association_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Crop_Association_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Crop_Association_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Crop_Association_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Crop_Association_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_crop_association" */
export type Product_Crop_Association_Arr_Rel_Insert_Input = {
  data: Array<Product_Crop_Association_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Crop_Association_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Crop_Association_Avg_Fields = {
  __typename?: 'product_crop_association_avg_fields';
  crop_group_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_crop_association" */
export type Product_Crop_Association_Avg_Order_By = {
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_crop_association". All fields are combined with a logical 'AND'. */
export type Product_Crop_Association_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Crop_Association_Bool_Exp>>;
  _not?: InputMaybe<Product_Crop_Association_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Crop_Association_Bool_Exp>>;
  association_type?: InputMaybe<String_Comparison_Exp>;
  crop?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  crop_group?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  crop_group_id?: InputMaybe<Bigint_Comparison_Exp>;
  crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_crop_association" */
export enum Product_Crop_Association_Constraint {
  /** unique or primary key constraint on columns "crop_id", "product_id", "association_type" */
  ProductCropAssociationCropIdProductIdAssocA8a83bcdUniq = 'product_crop_association_crop_id_product_id_assoc_a8a83bcd_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductCropAssociationPkey = 'product_crop_association_pkey'
}

/** input type for incrementing numeric columns in table "product_crop_association" */
export type Product_Crop_Association_Inc_Input = {
  crop_group_id?: InputMaybe<Scalars['bigint']>;
  crop_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "product_crop_association" */
export type Product_Crop_Association_Insert_Input = {
  association_type?: InputMaybe<Scalars['String']>;
  crop?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  crop_group?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  crop_group_id?: InputMaybe<Scalars['bigint']>;
  crop_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Product_Crop_Association_Max_Fields = {
  __typename?: 'product_crop_association_max_fields';
  association_type?: Maybe<Scalars['String']>;
  crop_group_id?: Maybe<Scalars['bigint']>;
  crop_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product_crop_association" */
export type Product_Crop_Association_Max_Order_By = {
  association_type?: InputMaybe<Order_By>;
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Crop_Association_Min_Fields = {
  __typename?: 'product_crop_association_min_fields';
  association_type?: Maybe<Scalars['String']>;
  crop_group_id?: Maybe<Scalars['bigint']>;
  crop_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product_crop_association" */
export type Product_Crop_Association_Min_Order_By = {
  association_type?: InputMaybe<Order_By>;
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_crop_association" */
export type Product_Crop_Association_Mutation_Response = {
  __typename?: 'product_crop_association_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Crop_Association>;
};

/** on_conflict condition type for table "product_crop_association" */
export type Product_Crop_Association_On_Conflict = {
  constraint: Product_Crop_Association_Constraint;
  update_columns?: Array<Product_Crop_Association_Update_Column>;
  where?: InputMaybe<Product_Crop_Association_Bool_Exp>;
};

/** Ordering options when selecting data from "product_crop_association". */
export type Product_Crop_Association_Order_By = {
  association_type?: InputMaybe<Order_By>;
  crop?: InputMaybe<Care_Shared_Entity_Order_By>;
  crop_group?: InputMaybe<Care_Shared_Entity_Order_By>;
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_crop_association */
export type Product_Crop_Association_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_crop_association" */
export enum Product_Crop_Association_Select_Column {
  /** column name */
  AssociationType = 'association_type',
  /** column name */
  CropGroupId = 'crop_group_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id'
}

/** input type for updating data in table "product_crop_association" */
export type Product_Crop_Association_Set_Input = {
  association_type?: InputMaybe<Scalars['String']>;
  crop_group_id?: InputMaybe<Scalars['bigint']>;
  crop_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Product_Crop_Association_Stddev_Fields = {
  __typename?: 'product_crop_association_stddev_fields';
  crop_group_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_crop_association" */
export type Product_Crop_Association_Stddev_Order_By = {
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Crop_Association_Stddev_Pop_Fields = {
  __typename?: 'product_crop_association_stddev_pop_fields';
  crop_group_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_crop_association" */
export type Product_Crop_Association_Stddev_Pop_Order_By = {
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Crop_Association_Stddev_Samp_Fields = {
  __typename?: 'product_crop_association_stddev_samp_fields';
  crop_group_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_crop_association" */
export type Product_Crop_Association_Stddev_Samp_Order_By = {
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_crop_association" */
export type Product_Crop_Association_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Crop_Association_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Crop_Association_Stream_Cursor_Value_Input = {
  association_type?: InputMaybe<Scalars['String']>;
  crop_group_id?: InputMaybe<Scalars['bigint']>;
  crop_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Product_Crop_Association_Sum_Fields = {
  __typename?: 'product_crop_association_sum_fields';
  crop_group_id?: Maybe<Scalars['bigint']>;
  crop_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "product_crop_association" */
export type Product_Crop_Association_Sum_Order_By = {
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "product_crop_association" */
export enum Product_Crop_Association_Update_Column {
  /** column name */
  AssociationType = 'association_type',
  /** column name */
  CropGroupId = 'crop_group_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id'
}

export type Product_Crop_Association_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Crop_Association_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Crop_Association_Set_Input>;
  where: Product_Crop_Association_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Crop_Association_Var_Pop_Fields = {
  __typename?: 'product_crop_association_var_pop_fields';
  crop_group_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_crop_association" */
export type Product_Crop_Association_Var_Pop_Order_By = {
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Crop_Association_Var_Samp_Fields = {
  __typename?: 'product_crop_association_var_samp_fields';
  crop_group_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_crop_association" */
export type Product_Crop_Association_Var_Samp_Order_By = {
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Crop_Association_Variance_Fields = {
  __typename?: 'product_crop_association_variance_fields';
  crop_group_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_crop_association" */
export type Product_Crop_Association_Variance_Order_By = {
  crop_group_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation = {
  __typename?: 'product_crop_infestation_recommendation';
  ai_dosage?: Maybe<Scalars['String']>;
  /** An object relationship */
  crop?: Maybe<Care_Shared_Entity>;
  crop_id?: Maybe<Scalars['bigint']>;
  crop_infestation_id?: Maybe<Scalars['bigint']>;
  dilution?: Maybe<Scalars['String']>;
  dosage: Scalars['String'];
  equipment?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  infestation?: Maybe<Care_Shared_Entity>;
  is_active: Scalars['Boolean'];
  method?: Maybe<Scalars['String']>;
  phi?: Maybe<Scalars['String']>;
  /** An object relationship */
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['uuid']>;
  stage?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** aggregated selection of "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Aggregate = {
  __typename?: 'product_crop_infestation_recommendation_aggregate';
  aggregate?: Maybe<Product_Crop_Infestation_Recommendation_Aggregate_Fields>;
  nodes: Array<Product_Crop_Infestation_Recommendation>;
};

/** aggregate fields of "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Aggregate_Fields = {
  __typename?: 'product_crop_infestation_recommendation_aggregate_fields';
  avg?: Maybe<Product_Crop_Infestation_Recommendation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Crop_Infestation_Recommendation_Max_Fields>;
  min?: Maybe<Product_Crop_Infestation_Recommendation_Min_Fields>;
  stddev?: Maybe<Product_Crop_Infestation_Recommendation_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Crop_Infestation_Recommendation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Crop_Infestation_Recommendation_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Crop_Infestation_Recommendation_Sum_Fields>;
  var_pop?: Maybe<Product_Crop_Infestation_Recommendation_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Crop_Infestation_Recommendation_Var_Samp_Fields>;
  variance?: Maybe<Product_Crop_Infestation_Recommendation_Variance_Fields>;
};


/** aggregate fields of "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Crop_Infestation_Recommendation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Crop_Infestation_Recommendation_Max_Order_By>;
  min?: InputMaybe<Product_Crop_Infestation_Recommendation_Min_Order_By>;
  stddev?: InputMaybe<Product_Crop_Infestation_Recommendation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Crop_Infestation_Recommendation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Crop_Infestation_Recommendation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Crop_Infestation_Recommendation_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Crop_Infestation_Recommendation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Crop_Infestation_Recommendation_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Crop_Infestation_Recommendation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Arr_Rel_Insert_Input = {
  data: Array<Product_Crop_Infestation_Recommendation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Crop_Infestation_Recommendation_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Crop_Infestation_Recommendation_Avg_Fields = {
  __typename?: 'product_crop_infestation_recommendation_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Avg_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_crop_infestation_recommendation". All fields are combined with a logical 'AND'. */
export type Product_Crop_Infestation_Recommendation_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Bool_Exp>>;
  _not?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Bool_Exp>>;
  ai_dosage?: InputMaybe<String_Comparison_Exp>;
  crop?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  crop_infestation_id?: InputMaybe<Bigint_Comparison_Exp>;
  dilution?: InputMaybe<String_Comparison_Exp>;
  dosage?: InputMaybe<String_Comparison_Exp>;
  equipment?: InputMaybe<String_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  infestation?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  method?: InputMaybe<String_Comparison_Exp>;
  phi?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  stage?: InputMaybe<String_Comparison_Exp>;
  timing?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_crop_infestation_recommendation" */
export enum Product_Crop_Infestation_Recommendation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductsProductcropprotectionrecommendationPkey = 'products_productcropprotectionrecommendation_pkey'
}

/** input type for incrementing numeric columns in table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Inc_Input = {
  crop_id?: InputMaybe<Scalars['bigint']>;
  crop_infestation_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Insert_Input = {
  ai_dosage?: InputMaybe<Scalars['String']>;
  crop?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['bigint']>;
  crop_infestation_id?: InputMaybe<Scalars['bigint']>;
  dilution?: InputMaybe<Scalars['String']>;
  dosage?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  infestation?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<Scalars['String']>;
  phi?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  stage?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Crop_Infestation_Recommendation_Max_Fields = {
  __typename?: 'product_crop_infestation_recommendation_max_fields';
  ai_dosage?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['bigint']>;
  crop_infestation_id?: Maybe<Scalars['bigint']>;
  dilution?: Maybe<Scalars['String']>;
  dosage?: Maybe<Scalars['String']>;
  equipment?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  method?: Maybe<Scalars['String']>;
  phi?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['uuid']>;
  stage?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Max_Order_By = {
  ai_dosage?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  dilution?: InputMaybe<Order_By>;
  dosage?: InputMaybe<Order_By>;
  equipment?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  phi?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  timing?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Crop_Infestation_Recommendation_Min_Fields = {
  __typename?: 'product_crop_infestation_recommendation_min_fields';
  ai_dosage?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['bigint']>;
  crop_infestation_id?: Maybe<Scalars['bigint']>;
  dilution?: Maybe<Scalars['String']>;
  dosage?: Maybe<Scalars['String']>;
  equipment?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  method?: Maybe<Scalars['String']>;
  phi?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['uuid']>;
  stage?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Min_Order_By = {
  ai_dosage?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  dilution?: InputMaybe<Order_By>;
  dosage?: InputMaybe<Order_By>;
  equipment?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  phi?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  timing?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Mutation_Response = {
  __typename?: 'product_crop_infestation_recommendation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Crop_Infestation_Recommendation>;
};

/** on_conflict condition type for table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_On_Conflict = {
  constraint: Product_Crop_Infestation_Recommendation_Constraint;
  update_columns?: Array<Product_Crop_Infestation_Recommendation_Update_Column>;
  where?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
};

/** Ordering options when selecting data from "product_crop_infestation_recommendation". */
export type Product_Crop_Infestation_Recommendation_Order_By = {
  ai_dosage?: InputMaybe<Order_By>;
  crop?: InputMaybe<Care_Shared_Entity_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  dilution?: InputMaybe<Order_By>;
  dosage?: InputMaybe<Order_By>;
  equipment?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  infestation?: InputMaybe<Care_Shared_Entity_Order_By>;
  is_active?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  phi?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  timing?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_crop_infestation_recommendation */
export type Product_Crop_Infestation_Recommendation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_crop_infestation_recommendation" */
export enum Product_Crop_Infestation_Recommendation_Select_Column {
  /** column name */
  AiDosage = 'ai_dosage',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropInfestationId = 'crop_infestation_id',
  /** column name */
  Dilution = 'dilution',
  /** column name */
  Dosage = 'dosage',
  /** column name */
  Equipment = 'equipment',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Method = 'method',
  /** column name */
  Phi = 'phi',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Stage = 'stage',
  /** column name */
  Timing = 'timing'
}

/** input type for updating data in table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Set_Input = {
  ai_dosage?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['bigint']>;
  crop_infestation_id?: InputMaybe<Scalars['bigint']>;
  dilution?: InputMaybe<Scalars['String']>;
  dosage?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<Scalars['String']>;
  phi?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  stage?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Crop_Infestation_Recommendation_Stddev_Fields = {
  __typename?: 'product_crop_infestation_recommendation_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Stddev_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Crop_Infestation_Recommendation_Stddev_Pop_Fields = {
  __typename?: 'product_crop_infestation_recommendation_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Stddev_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Crop_Infestation_Recommendation_Stddev_Samp_Fields = {
  __typename?: 'product_crop_infestation_recommendation_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Stddev_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Crop_Infestation_Recommendation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Crop_Infestation_Recommendation_Stream_Cursor_Value_Input = {
  ai_dosage?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['bigint']>;
  crop_infestation_id?: InputMaybe<Scalars['bigint']>;
  dilution?: InputMaybe<Scalars['String']>;
  dosage?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<Scalars['String']>;
  phi?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  stage?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_Crop_Infestation_Recommendation_Sum_Fields = {
  __typename?: 'product_crop_infestation_recommendation_sum_fields';
  crop_id?: Maybe<Scalars['bigint']>;
  crop_infestation_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Sum_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
};

/** update columns of table "product_crop_infestation_recommendation" */
export enum Product_Crop_Infestation_Recommendation_Update_Column {
  /** column name */
  AiDosage = 'ai_dosage',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropInfestationId = 'crop_infestation_id',
  /** column name */
  Dilution = 'dilution',
  /** column name */
  Dosage = 'dosage',
  /** column name */
  Equipment = 'equipment',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Method = 'method',
  /** column name */
  Phi = 'phi',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Stage = 'stage',
  /** column name */
  Timing = 'timing'
}

export type Product_Crop_Infestation_Recommendation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Crop_Infestation_Recommendation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Crop_Infestation_Recommendation_Set_Input>;
  where: Product_Crop_Infestation_Recommendation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Crop_Infestation_Recommendation_Var_Pop_Fields = {
  __typename?: 'product_crop_infestation_recommendation_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Var_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Crop_Infestation_Recommendation_Var_Samp_Fields = {
  __typename?: 'product_crop_infestation_recommendation_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Var_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Crop_Infestation_Recommendation_Variance_Fields = {
  __typename?: 'product_crop_infestation_recommendation_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_crop_infestation_recommendation" */
export type Product_Crop_Infestation_Recommendation_Variance_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation = {
  __typename?: 'product_crop_nutrition_recommendation';
  ai_dosage?: Maybe<Scalars['String']>;
  /** An object relationship */
  crop?: Maybe<Care_Shared_Entity>;
  crop_id?: Maybe<Scalars['bigint']>;
  dilution?: Maybe<Scalars['String']>;
  dosage?: Maybe<Scalars['String']>;
  equipment?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  method?: Maybe<Scalars['String']>;
  phi?: Maybe<Scalars['String']>;
  /** An object relationship */
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['uuid']>;
  purpose: Scalars['String'];
  stage?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** aggregated selection of "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Aggregate = {
  __typename?: 'product_crop_nutrition_recommendation_aggregate';
  aggregate?: Maybe<Product_Crop_Nutrition_Recommendation_Aggregate_Fields>;
  nodes: Array<Product_Crop_Nutrition_Recommendation>;
};

/** aggregate fields of "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Aggregate_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_aggregate_fields';
  avg?: Maybe<Product_Crop_Nutrition_Recommendation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Crop_Nutrition_Recommendation_Max_Fields>;
  min?: Maybe<Product_Crop_Nutrition_Recommendation_Min_Fields>;
  stddev?: Maybe<Product_Crop_Nutrition_Recommendation_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Crop_Nutrition_Recommendation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Crop_Nutrition_Recommendation_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Crop_Nutrition_Recommendation_Sum_Fields>;
  var_pop?: Maybe<Product_Crop_Nutrition_Recommendation_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Crop_Nutrition_Recommendation_Var_Samp_Fields>;
  variance?: Maybe<Product_Crop_Nutrition_Recommendation_Variance_Fields>;
};


/** aggregate fields of "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Crop_Nutrition_Recommendation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Crop_Nutrition_Recommendation_Max_Order_By>;
  min?: InputMaybe<Product_Crop_Nutrition_Recommendation_Min_Order_By>;
  stddev?: InputMaybe<Product_Crop_Nutrition_Recommendation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Crop_Nutrition_Recommendation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Crop_Nutrition_Recommendation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Crop_Nutrition_Recommendation_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Crop_Nutrition_Recommendation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Crop_Nutrition_Recommendation_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Crop_Nutrition_Recommendation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Arr_Rel_Insert_Input = {
  data: Array<Product_Crop_Nutrition_Recommendation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Crop_Nutrition_Recommendation_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Crop_Nutrition_Recommendation_Avg_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Avg_Order_By = {
  crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_crop_nutrition_recommendation". All fields are combined with a logical 'AND'. */
export type Product_Crop_Nutrition_Recommendation_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Bool_Exp>>;
  _not?: InputMaybe<Product_Crop_Nutrition_Recommendation_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Bool_Exp>>;
  ai_dosage?: InputMaybe<String_Comparison_Exp>;
  crop?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  dilution?: InputMaybe<String_Comparison_Exp>;
  dosage?: InputMaybe<String_Comparison_Exp>;
  equipment?: InputMaybe<String_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  method?: InputMaybe<String_Comparison_Exp>;
  phi?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  purpose?: InputMaybe<String_Comparison_Exp>;
  stage?: InputMaybe<String_Comparison_Exp>;
  timing?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_crop_nutrition_recommendation" */
export enum Product_Crop_Nutrition_Recommendation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductCropNutritionRecommendationPkey = 'product_crop_nutrition_recommendation_pkey'
}

/** input type for incrementing numeric columns in table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Inc_Input = {
  crop_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Insert_Input = {
  ai_dosage?: InputMaybe<Scalars['String']>;
  crop?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['bigint']>;
  dilution?: InputMaybe<Scalars['String']>;
  dosage?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<Scalars['String']>;
  phi?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  purpose?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Crop_Nutrition_Recommendation_Max_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_max_fields';
  ai_dosage?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['bigint']>;
  dilution?: Maybe<Scalars['String']>;
  dosage?: Maybe<Scalars['String']>;
  equipment?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  method?: Maybe<Scalars['String']>;
  phi?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['uuid']>;
  purpose?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Max_Order_By = {
  ai_dosage?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  dilution?: InputMaybe<Order_By>;
  dosage?: InputMaybe<Order_By>;
  equipment?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  phi?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  timing?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Crop_Nutrition_Recommendation_Min_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_min_fields';
  ai_dosage?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['bigint']>;
  dilution?: Maybe<Scalars['String']>;
  dosage?: Maybe<Scalars['String']>;
  equipment?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  method?: Maybe<Scalars['String']>;
  phi?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['uuid']>;
  purpose?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Min_Order_By = {
  ai_dosage?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  dilution?: InputMaybe<Order_By>;
  dosage?: InputMaybe<Order_By>;
  equipment?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  phi?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  timing?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Mutation_Response = {
  __typename?: 'product_crop_nutrition_recommendation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Crop_Nutrition_Recommendation>;
};

/** on_conflict condition type for table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_On_Conflict = {
  constraint: Product_Crop_Nutrition_Recommendation_Constraint;
  update_columns?: Array<Product_Crop_Nutrition_Recommendation_Update_Column>;
  where?: InputMaybe<Product_Crop_Nutrition_Recommendation_Bool_Exp>;
};

/** Ordering options when selecting data from "product_crop_nutrition_recommendation". */
export type Product_Crop_Nutrition_Recommendation_Order_By = {
  ai_dosage?: InputMaybe<Order_By>;
  crop?: InputMaybe<Care_Shared_Entity_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  dilution?: InputMaybe<Order_By>;
  dosage?: InputMaybe<Order_By>;
  equipment?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  phi?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  timing?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_crop_nutrition_recommendation */
export type Product_Crop_Nutrition_Recommendation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_crop_nutrition_recommendation" */
export enum Product_Crop_Nutrition_Recommendation_Select_Column {
  /** column name */
  AiDosage = 'ai_dosage',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Dilution = 'dilution',
  /** column name */
  Dosage = 'dosage',
  /** column name */
  Equipment = 'equipment',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Method = 'method',
  /** column name */
  Phi = 'phi',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  Stage = 'stage',
  /** column name */
  Timing = 'timing'
}

/** input type for updating data in table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Set_Input = {
  ai_dosage?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['bigint']>;
  dilution?: InputMaybe<Scalars['String']>;
  dosage?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<Scalars['String']>;
  phi?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  purpose?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Crop_Nutrition_Recommendation_Stddev_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Stddev_Order_By = {
  crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Crop_Nutrition_Recommendation_Stddev_Pop_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Stddev_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Crop_Nutrition_Recommendation_Stddev_Samp_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Stddev_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Crop_Nutrition_Recommendation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Crop_Nutrition_Recommendation_Stream_Cursor_Value_Input = {
  ai_dosage?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['bigint']>;
  dilution?: InputMaybe<Scalars['String']>;
  dosage?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<Scalars['String']>;
  phi?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  purpose?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_Crop_Nutrition_Recommendation_Sum_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_sum_fields';
  crop_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Sum_Order_By = {
  crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "product_crop_nutrition_recommendation" */
export enum Product_Crop_Nutrition_Recommendation_Update_Column {
  /** column name */
  AiDosage = 'ai_dosage',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Dilution = 'dilution',
  /** column name */
  Dosage = 'dosage',
  /** column name */
  Equipment = 'equipment',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Method = 'method',
  /** column name */
  Phi = 'phi',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  Stage = 'stage',
  /** column name */
  Timing = 'timing'
}

export type Product_Crop_Nutrition_Recommendation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Crop_Nutrition_Recommendation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Crop_Nutrition_Recommendation_Set_Input>;
  where: Product_Crop_Nutrition_Recommendation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Crop_Nutrition_Recommendation_Var_Pop_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Var_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Crop_Nutrition_Recommendation_Var_Samp_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Var_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Crop_Nutrition_Recommendation_Variance_Fields = {
  __typename?: 'product_crop_nutrition_recommendation_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_crop_nutrition_recommendation" */
export type Product_Crop_Nutrition_Recommendation_Variance_Order_By = {
  crop_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_favourite" */
export type Product_Favourite = {
  __typename?: 'product_favourite';
  /** An object relationship */
  consumer?: Maybe<Care_Shared_Entity>;
  consumer_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  sellable_stock?: Maybe<Sellable_Item_Stock>;
  sellable_stock_id?: Maybe<Scalars['uuid']>;
  store_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "product_favourite" */
export type Product_Favourite_Aggregate = {
  __typename?: 'product_favourite_aggregate';
  aggregate?: Maybe<Product_Favourite_Aggregate_Fields>;
  nodes: Array<Product_Favourite>;
};

/** aggregate fields of "product_favourite" */
export type Product_Favourite_Aggregate_Fields = {
  __typename?: 'product_favourite_aggregate_fields';
  avg?: Maybe<Product_Favourite_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Favourite_Max_Fields>;
  min?: Maybe<Product_Favourite_Min_Fields>;
  stddev?: Maybe<Product_Favourite_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Favourite_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Favourite_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Favourite_Sum_Fields>;
  var_pop?: Maybe<Product_Favourite_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Favourite_Var_Samp_Fields>;
  variance?: Maybe<Product_Favourite_Variance_Fields>;
};


/** aggregate fields of "product_favourite" */
export type Product_Favourite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Favourite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_favourite" */
export type Product_Favourite_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Favourite_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Favourite_Max_Order_By>;
  min?: InputMaybe<Product_Favourite_Min_Order_By>;
  stddev?: InputMaybe<Product_Favourite_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Favourite_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Favourite_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Favourite_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Favourite_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Favourite_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Favourite_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_favourite" */
export type Product_Favourite_Arr_Rel_Insert_Input = {
  data: Array<Product_Favourite_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Favourite_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Favourite_Avg_Fields = {
  __typename?: 'product_favourite_avg_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_favourite" */
export type Product_Favourite_Avg_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_favourite". All fields are combined with a logical 'AND'. */
export type Product_Favourite_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Favourite_Bool_Exp>>;
  _not?: InputMaybe<Product_Favourite_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Favourite_Bool_Exp>>;
  consumer?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  consumer_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  sellable_stock?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
  sellable_stock_id?: InputMaybe<Uuid_Comparison_Exp>;
  store_id?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_favourite" */
export enum Product_Favourite_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductFavouritePkey = 'product_favourite_pkey',
  /** unique or primary key constraint on columns "store_id", "sellable_stock_id", "user_id", "product_id" */
  ProductFavouriteUserIdProductIdSella_9d4275caUniq = 'product_favourite_user_id_product_id_sella_9d4275ca_uniq'
}

/** input type for incrementing numeric columns in table "product_favourite" */
export type Product_Favourite_Inc_Input = {
  consumer_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "product_favourite" */
export type Product_Favourite_Insert_Input = {
  consumer?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  consumer_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_stock?: InputMaybe<Sellable_Item_Stock_Obj_Rel_Insert_Input>;
  sellable_stock_id?: InputMaybe<Scalars['uuid']>;
  store_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Favourite_Max_Fields = {
  __typename?: 'product_favourite_max_fields';
  consumer_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
  sellable_stock_id?: Maybe<Scalars['uuid']>;
  store_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_favourite" */
export type Product_Favourite_Max_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_stock_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Favourite_Min_Fields = {
  __typename?: 'product_favourite_min_fields';
  consumer_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
  sellable_stock_id?: Maybe<Scalars['uuid']>;
  store_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_favourite" */
export type Product_Favourite_Min_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_stock_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_favourite" */
export type Product_Favourite_Mutation_Response = {
  __typename?: 'product_favourite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Favourite>;
};

/** on_conflict condition type for table "product_favourite" */
export type Product_Favourite_On_Conflict = {
  constraint: Product_Favourite_Constraint;
  update_columns?: Array<Product_Favourite_Update_Column>;
  where?: InputMaybe<Product_Favourite_Bool_Exp>;
};

/** Ordering options when selecting data from "product_favourite". */
export type Product_Favourite_Order_By = {
  consumer?: InputMaybe<Care_Shared_Entity_Order_By>;
  consumer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_stock?: InputMaybe<Sellable_Item_Stock_Order_By>;
  sellable_stock_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_favourite */
export type Product_Favourite_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_favourite" */
export enum Product_Favourite_Select_Column {
  /** column name */
  ConsumerId = 'consumer_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  SellableStockId = 'sellable_stock_id',
  /** column name */
  StoreId = 'store_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "product_favourite" */
export type Product_Favourite_Set_Input = {
  consumer_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_stock_id?: InputMaybe<Scalars['uuid']>;
  store_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Favourite_Stddev_Fields = {
  __typename?: 'product_favourite_stddev_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_favourite" */
export type Product_Favourite_Stddev_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Favourite_Stddev_Pop_Fields = {
  __typename?: 'product_favourite_stddev_pop_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_favourite" */
export type Product_Favourite_Stddev_Pop_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Favourite_Stddev_Samp_Fields = {
  __typename?: 'product_favourite_stddev_samp_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_favourite" */
export type Product_Favourite_Stddev_Samp_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_favourite" */
export type Product_Favourite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Favourite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Favourite_Stream_Cursor_Value_Input = {
  consumer_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_stock_id?: InputMaybe<Scalars['uuid']>;
  store_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_Favourite_Sum_Fields = {
  __typename?: 'product_favourite_sum_fields';
  consumer_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "product_favourite" */
export type Product_Favourite_Sum_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** update columns of table "product_favourite" */
export enum Product_Favourite_Update_Column {
  /** column name */
  ConsumerId = 'consumer_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  SellableStockId = 'sellable_stock_id',
  /** column name */
  StoreId = 'store_id',
  /** column name */
  UserId = 'user_id'
}

export type Product_Favourite_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Favourite_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Favourite_Set_Input>;
  where: Product_Favourite_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Favourite_Var_Pop_Fields = {
  __typename?: 'product_favourite_var_pop_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_favourite" */
export type Product_Favourite_Var_Pop_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Favourite_Var_Samp_Fields = {
  __typename?: 'product_favourite_var_samp_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_favourite" */
export type Product_Favourite_Var_Samp_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Favourite_Variance_Fields = {
  __typename?: 'product_favourite_variance_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_favourite" */
export type Product_Favourite_Variance_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "product" */
export type Product_Inc_Input = {
  featured_image_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "product_infestation" */
export type Product_Infestation = {
  __typename?: 'product_infestation';
  association_type: Scalars['String'];
  id: Scalars['uuid'];
  infestation_id?: Maybe<Scalars['bigint']>;
  is_active: Scalars['Boolean'];
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid'];
  /** An object relationship */
  shared_entity?: Maybe<Care_Shared_Entity>;
  symptoms?: Maybe<Scalars['String']>;
};

/** aggregated selection of "product_infestation" */
export type Product_Infestation_Aggregate = {
  __typename?: 'product_infestation_aggregate';
  aggregate?: Maybe<Product_Infestation_Aggregate_Fields>;
  nodes: Array<Product_Infestation>;
};

/** aggregate fields of "product_infestation" */
export type Product_Infestation_Aggregate_Fields = {
  __typename?: 'product_infestation_aggregate_fields';
  avg?: Maybe<Product_Infestation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Infestation_Max_Fields>;
  min?: Maybe<Product_Infestation_Min_Fields>;
  stddev?: Maybe<Product_Infestation_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Infestation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Infestation_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Infestation_Sum_Fields>;
  var_pop?: Maybe<Product_Infestation_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Infestation_Var_Samp_Fields>;
  variance?: Maybe<Product_Infestation_Variance_Fields>;
};


/** aggregate fields of "product_infestation" */
export type Product_Infestation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Infestation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_infestation" */
export type Product_Infestation_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Infestation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Infestation_Max_Order_By>;
  min?: InputMaybe<Product_Infestation_Min_Order_By>;
  stddev?: InputMaybe<Product_Infestation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Infestation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Infestation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Infestation_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Infestation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Infestation_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Infestation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_infestation" */
export type Product_Infestation_Arr_Rel_Insert_Input = {
  data: Array<Product_Infestation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Infestation_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Infestation_Avg_Fields = {
  __typename?: 'product_infestation_avg_fields';
  infestation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_infestation" */
export type Product_Infestation_Avg_Order_By = {
  infestation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_infestation". All fields are combined with a logical 'AND'. */
export type Product_Infestation_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Infestation_Bool_Exp>>;
  _not?: InputMaybe<Product_Infestation_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Infestation_Bool_Exp>>;
  association_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  infestation_id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_entity?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  symptoms?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_infestation" */
export enum Product_Infestation_Constraint {
  /** unique or primary key constraint on columns "infestation_id", "product_id", "association_type" */
  ProductInfestationInfestationIdProductIA07668a5Uniq = 'product_infestation_infestation_id_product_i_a07668a5_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductInfestationPkey = 'product_infestation_pkey'
}

/** input type for incrementing numeric columns in table "product_infestation" */
export type Product_Infestation_Inc_Input = {
  infestation_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "product_infestation" */
export type Product_Infestation_Insert_Input = {
  association_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  infestation_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  shared_entity?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  symptoms?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Infestation_Max_Fields = {
  __typename?: 'product_infestation_max_fields';
  association_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  infestation_id?: Maybe<Scalars['bigint']>;
  product_id?: Maybe<Scalars['uuid']>;
  symptoms?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_infestation" */
export type Product_Infestation_Max_Order_By = {
  association_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  infestation_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  symptoms?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Infestation_Min_Fields = {
  __typename?: 'product_infestation_min_fields';
  association_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  infestation_id?: Maybe<Scalars['bigint']>;
  product_id?: Maybe<Scalars['uuid']>;
  symptoms?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_infestation" */
export type Product_Infestation_Min_Order_By = {
  association_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  infestation_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  symptoms?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_infestation" */
export type Product_Infestation_Mutation_Response = {
  __typename?: 'product_infestation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Infestation>;
};

/** on_conflict condition type for table "product_infestation" */
export type Product_Infestation_On_Conflict = {
  constraint: Product_Infestation_Constraint;
  update_columns?: Array<Product_Infestation_Update_Column>;
  where?: InputMaybe<Product_Infestation_Bool_Exp>;
};

/** Ordering options when selecting data from "product_infestation". */
export type Product_Infestation_Order_By = {
  association_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  infestation_id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  shared_entity?: InputMaybe<Care_Shared_Entity_Order_By>;
  symptoms?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_infestation */
export type Product_Infestation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_infestation" */
export enum Product_Infestation_Select_Column {
  /** column name */
  AssociationType = 'association_type',
  /** column name */
  Id = 'id',
  /** column name */
  InfestationId = 'infestation_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Symptoms = 'symptoms'
}

/** input type for updating data in table "product_infestation" */
export type Product_Infestation_Set_Input = {
  association_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  infestation_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  symptoms?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Infestation_Stddev_Fields = {
  __typename?: 'product_infestation_stddev_fields';
  infestation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_infestation" */
export type Product_Infestation_Stddev_Order_By = {
  infestation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Infestation_Stddev_Pop_Fields = {
  __typename?: 'product_infestation_stddev_pop_fields';
  infestation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_infestation" */
export type Product_Infestation_Stddev_Pop_Order_By = {
  infestation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Infestation_Stddev_Samp_Fields = {
  __typename?: 'product_infestation_stddev_samp_fields';
  infestation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_infestation" */
export type Product_Infestation_Stddev_Samp_Order_By = {
  infestation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_infestation" */
export type Product_Infestation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Infestation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Infestation_Stream_Cursor_Value_Input = {
  association_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  infestation_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  symptoms?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_Infestation_Sum_Fields = {
  __typename?: 'product_infestation_sum_fields';
  infestation_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "product_infestation" */
export type Product_Infestation_Sum_Order_By = {
  infestation_id?: InputMaybe<Order_By>;
};

/** update columns of table "product_infestation" */
export enum Product_Infestation_Update_Column {
  /** column name */
  AssociationType = 'association_type',
  /** column name */
  Id = 'id',
  /** column name */
  InfestationId = 'infestation_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Symptoms = 'symptoms'
}

export type Product_Infestation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Infestation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Infestation_Set_Input>;
  where: Product_Infestation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Infestation_Var_Pop_Fields = {
  __typename?: 'product_infestation_var_pop_fields';
  infestation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_infestation" */
export type Product_Infestation_Var_Pop_Order_By = {
  infestation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Infestation_Var_Samp_Fields = {
  __typename?: 'product_infestation_var_samp_fields';
  infestation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_infestation" */
export type Product_Infestation_Var_Samp_Order_By = {
  infestation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Infestation_Variance_Fields = {
  __typename?: 'product_infestation_variance_fields';
  infestation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_infestation" */
export type Product_Infestation_Variance_Order_By = {
  infestation_id?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "product" */
export type Product_Insert_Input = {
  applicable_units?: InputMaybe<Application_Product_Unit_Arr_Rel_Insert_Input>;
  composition_text?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featured_image?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  featured_image_id?: InputMaybe<Scalars['bigint']>;
  formulation_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  manufactured_by_id?: InputMaybe<Scalars['uuid']>;
  manufacturing_facility?: InputMaybe<Manufacturing_Facility_Obj_Rel_Insert_Input>;
  marketed_by_id?: InputMaybe<Scalars['uuid']>;
  marketing_facility?: InputMaybe<Marketing_Facility_Obj_Rel_Insert_Input>;
  media_upload_complete?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  product_attachments?: InputMaybe<Product_Attachment_Arr_Rel_Insert_Input>;
  product_certifications?: InputMaybe<Product_Certification_Arr_Rel_Insert_Input>;
  product_compositions?: InputMaybe<Product_Composition_Arr_Rel_Insert_Input>;
  product_crop_association_recommendation?: InputMaybe<Product_Crop_Association_Arr_Rel_Insert_Input>;
  product_crop_associations?: InputMaybe<Product_Crop_Association_Arr_Rel_Insert_Input>;
  product_crop_infestation_recommendations?: InputMaybe<Product_Crop_Infestation_Recommendation_Arr_Rel_Insert_Input>;
  product_crop_nutrition_recommendations?: InputMaybe<Product_Crop_Nutrition_Recommendation_Arr_Rel_Insert_Input>;
  product_favourites?: InputMaybe<Product_Favourite_Arr_Rel_Insert_Input>;
  product_infestations?: InputMaybe<Product_Infestation_Arr_Rel_Insert_Input>;
  product_mainsections?: InputMaybe<Product_Mainsection_Arr_Rel_Insert_Input>;
  product_purchased?: InputMaybe<Product_Purchased_Arr_Rel_Insert_Input>;
  product_views?: InputMaybe<Product_View_Arr_Rel_Insert_Input>;
  sellable_items?: InputMaybe<Sellable_Item_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Subcategory_Obj_Rel_Insert_Input>;
  subcategory_id?: InputMaybe<Scalars['uuid']>;
  translation_complete?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "product_mainsection" */
export type Product_Mainsection = {
  __typename?: 'product_mainsection';
  display_as: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  main_section: Main_Section;
  main_section_id: Scalars['uuid'];
  order: Scalars['smallint'];
  /** An object relationship */
  product: Product;
  /** An array relationship */
  product_attributes: Array<Product_Attribute>;
  /** An aggregate relationship */
  product_attributes_aggregate: Product_Attribute_Aggregate;
  product_id: Scalars['uuid'];
  /** An array relationship */
  product_mainsection_attachments: Array<Product_Mainsection_Attachment>;
  /** An aggregate relationship */
  product_mainsection_attachments_aggregate: Product_Mainsection_Attachment_Aggregate;
  /** An array relationship */
  product_sections: Array<Product_Section>;
  /** An aggregate relationship */
  product_sections_aggregate: Product_Section_Aggregate;
  value?: Maybe<Scalars['String']>;
};


/** columns and relationships of "product_mainsection" */
export type Product_MainsectionProduct_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


/** columns and relationships of "product_mainsection" */
export type Product_MainsectionProduct_Attributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


/** columns and relationships of "product_mainsection" */
export type Product_MainsectionProduct_Mainsection_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Attachment_Bool_Exp>;
};


/** columns and relationships of "product_mainsection" */
export type Product_MainsectionProduct_Mainsection_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Attachment_Bool_Exp>;
};


/** columns and relationships of "product_mainsection" */
export type Product_MainsectionProduct_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Order_By>>;
  where?: InputMaybe<Product_Section_Bool_Exp>;
};


/** columns and relationships of "product_mainsection" */
export type Product_MainsectionProduct_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Order_By>>;
  where?: InputMaybe<Product_Section_Bool_Exp>;
};

/** aggregated selection of "product_mainsection" */
export type Product_Mainsection_Aggregate = {
  __typename?: 'product_mainsection_aggregate';
  aggregate?: Maybe<Product_Mainsection_Aggregate_Fields>;
  nodes: Array<Product_Mainsection>;
};

/** aggregate fields of "product_mainsection" */
export type Product_Mainsection_Aggregate_Fields = {
  __typename?: 'product_mainsection_aggregate_fields';
  avg?: Maybe<Product_Mainsection_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Mainsection_Max_Fields>;
  min?: Maybe<Product_Mainsection_Min_Fields>;
  stddev?: Maybe<Product_Mainsection_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Mainsection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Mainsection_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Mainsection_Sum_Fields>;
  var_pop?: Maybe<Product_Mainsection_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Mainsection_Var_Samp_Fields>;
  variance?: Maybe<Product_Mainsection_Variance_Fields>;
};


/** aggregate fields of "product_mainsection" */
export type Product_Mainsection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Mainsection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_mainsection" */
export type Product_Mainsection_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Mainsection_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Mainsection_Max_Order_By>;
  min?: InputMaybe<Product_Mainsection_Min_Order_By>;
  stddev?: InputMaybe<Product_Mainsection_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Mainsection_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Mainsection_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Mainsection_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Mainsection_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Mainsection_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Mainsection_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_mainsection" */
export type Product_Mainsection_Arr_Rel_Insert_Input = {
  data: Array<Product_Mainsection_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Mainsection_On_Conflict>;
};

/** columns and relationships of "product_mainsection_attachment" */
export type Product_Mainsection_Attachment = {
  __typename?: 'product_mainsection_attachment';
  attachment_id: Scalars['bigint'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  order: Scalars['smallint'];
  /** An object relationship */
  photo: Common_Fileupload;
  product_main_section_id: Scalars['uuid'];
  /** An object relationship */
  product_mainsection: Product_Mainsection;
};

/** aggregated selection of "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Aggregate = {
  __typename?: 'product_mainsection_attachment_aggregate';
  aggregate?: Maybe<Product_Mainsection_Attachment_Aggregate_Fields>;
  nodes: Array<Product_Mainsection_Attachment>;
};

/** aggregate fields of "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Aggregate_Fields = {
  __typename?: 'product_mainsection_attachment_aggregate_fields';
  avg?: Maybe<Product_Mainsection_Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Mainsection_Attachment_Max_Fields>;
  min?: Maybe<Product_Mainsection_Attachment_Min_Fields>;
  stddev?: Maybe<Product_Mainsection_Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Mainsection_Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Mainsection_Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Mainsection_Attachment_Sum_Fields>;
  var_pop?: Maybe<Product_Mainsection_Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Mainsection_Attachment_Var_Samp_Fields>;
  variance?: Maybe<Product_Mainsection_Attachment_Variance_Fields>;
};


/** aggregate fields of "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Mainsection_Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Mainsection_Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Mainsection_Attachment_Max_Order_By>;
  min?: InputMaybe<Product_Mainsection_Attachment_Min_Order_By>;
  stddev?: InputMaybe<Product_Mainsection_Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Mainsection_Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Mainsection_Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Mainsection_Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Mainsection_Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Mainsection_Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Mainsection_Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Product_Mainsection_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Mainsection_Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Mainsection_Attachment_Avg_Fields = {
  __typename?: 'product_mainsection_attachment_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_mainsection_attachment". All fields are combined with a logical 'AND'. */
export type Product_Mainsection_Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Mainsection_Attachment_Bool_Exp>>;
  _not?: InputMaybe<Product_Mainsection_Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Mainsection_Attachment_Bool_Exp>>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  photo?: InputMaybe<Common_Fileupload_Bool_Exp>;
  product_main_section_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_mainsection?: InputMaybe<Product_Mainsection_Bool_Exp>;
};

/** unique or primary key constraints on table "product_mainsection_attachment" */
export enum Product_Mainsection_Attachment_Constraint {
  /** unique or primary key constraint on columns "product_main_section_id", "order" */
  ProductMainsectionAttaProductMainSectionIdB802bb65Uniq = 'product_mainsection_atta_product_main_section_id__b802bb65_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductMainsectionAttachmentPkey = 'product_mainsection_attachment_pkey'
}

/** input type for incrementing numeric columns in table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  photo?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  product_main_section_id?: InputMaybe<Scalars['uuid']>;
  product_mainsection?: InputMaybe<Product_Mainsection_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Product_Mainsection_Attachment_Max_Fields = {
  __typename?: 'product_mainsection_attachment_max_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_main_section_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_main_section_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Mainsection_Attachment_Min_Fields = {
  __typename?: 'product_mainsection_attachment_min_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_main_section_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_main_section_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Mutation_Response = {
  __typename?: 'product_mainsection_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Mainsection_Attachment>;
};

/** on_conflict condition type for table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_On_Conflict = {
  constraint: Product_Mainsection_Attachment_Constraint;
  update_columns?: Array<Product_Mainsection_Attachment_Update_Column>;
  where?: InputMaybe<Product_Mainsection_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "product_mainsection_attachment". */
export type Product_Mainsection_Attachment_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  photo?: InputMaybe<Common_Fileupload_Order_By>;
  product_main_section_id?: InputMaybe<Order_By>;
  product_mainsection?: InputMaybe<Product_Mainsection_Order_By>;
};

/** primary key columns input for table: product_mainsection_attachment */
export type Product_Mainsection_Attachment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_mainsection_attachment" */
export enum Product_Mainsection_Attachment_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Language = 'language',
  /** column name */
  Order = 'order',
  /** column name */
  ProductMainSectionId = 'product_main_section_id'
}

/** input type for updating data in table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Set_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_main_section_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Product_Mainsection_Attachment_Stddev_Fields = {
  __typename?: 'product_mainsection_attachment_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Mainsection_Attachment_Stddev_Pop_Fields = {
  __typename?: 'product_mainsection_attachment_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Mainsection_Attachment_Stddev_Samp_Fields = {
  __typename?: 'product_mainsection_attachment_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Mainsection_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Mainsection_Attachment_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_main_section_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Product_Mainsection_Attachment_Sum_Fields = {
  __typename?: 'product_mainsection_attachment_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_mainsection_attachment" */
export enum Product_Mainsection_Attachment_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Language = 'language',
  /** column name */
  Order = 'order',
  /** column name */
  ProductMainSectionId = 'product_main_section_id'
}

export type Product_Mainsection_Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Mainsection_Attachment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Mainsection_Attachment_Set_Input>;
  where: Product_Mainsection_Attachment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Mainsection_Attachment_Var_Pop_Fields = {
  __typename?: 'product_mainsection_attachment_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Mainsection_Attachment_Var_Samp_Fields = {
  __typename?: 'product_mainsection_attachment_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Mainsection_Attachment_Variance_Fields = {
  __typename?: 'product_mainsection_attachment_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_mainsection_attachment" */
export type Product_Mainsection_Attachment_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Product_Mainsection_Avg_Fields = {
  __typename?: 'product_mainsection_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_mainsection" */
export type Product_Mainsection_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_mainsection". All fields are combined with a logical 'AND'. */
export type Product_Mainsection_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Mainsection_Bool_Exp>>;
  _not?: InputMaybe<Product_Mainsection_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Mainsection_Bool_Exp>>;
  display_as?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  main_section?: InputMaybe<Main_Section_Bool_Exp>;
  main_section_id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_attributes?: InputMaybe<Product_Attribute_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_mainsection_attachments?: InputMaybe<Product_Mainsection_Attachment_Bool_Exp>;
  product_sections?: InputMaybe<Product_Section_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_mainsection" */
export enum Product_Mainsection_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductMainsectionPkey = 'product_mainsection_pkey',
  /** unique or primary key constraint on columns "product_id", "main_section_id" */
  ProductMainsectionProductIdMainSectionId_9efdafbaUniq = 'product_mainsection_product_id_main_section_id_9efdafba_uniq'
}

/** input type for incrementing numeric columns in table "product_mainsection" */
export type Product_Mainsection_Inc_Input = {
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "product_mainsection" */
export type Product_Mainsection_Insert_Input = {
  display_as?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  main_section?: InputMaybe<Main_Section_Obj_Rel_Insert_Input>;
  main_section_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_attributes?: InputMaybe<Product_Attribute_Arr_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  product_mainsection_attachments?: InputMaybe<Product_Mainsection_Attachment_Arr_Rel_Insert_Input>;
  product_sections?: InputMaybe<Product_Section_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Mainsection_Max_Fields = {
  __typename?: 'product_mainsection_max_fields';
  display_as?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  main_section_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  product_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_mainsection" */
export type Product_Mainsection_Max_Order_By = {
  display_as?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  main_section_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Mainsection_Min_Fields = {
  __typename?: 'product_mainsection_min_fields';
  display_as?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  main_section_id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  product_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_mainsection" */
export type Product_Mainsection_Min_Order_By = {
  display_as?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  main_section_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_mainsection" */
export type Product_Mainsection_Mutation_Response = {
  __typename?: 'product_mainsection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Mainsection>;
};

/** input type for inserting object relation for remote table "product_mainsection" */
export type Product_Mainsection_Obj_Rel_Insert_Input = {
  data: Product_Mainsection_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Mainsection_On_Conflict>;
};

/** on_conflict condition type for table "product_mainsection" */
export type Product_Mainsection_On_Conflict = {
  constraint: Product_Mainsection_Constraint;
  update_columns?: Array<Product_Mainsection_Update_Column>;
  where?: InputMaybe<Product_Mainsection_Bool_Exp>;
};

/** Ordering options when selecting data from "product_mainsection". */
export type Product_Mainsection_Order_By = {
  display_as?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  main_section?: InputMaybe<Main_Section_Order_By>;
  main_section_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_attributes_aggregate?: InputMaybe<Product_Attribute_Aggregate_Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_mainsection_attachments_aggregate?: InputMaybe<Product_Mainsection_Attachment_Aggregate_Order_By>;
  product_sections_aggregate?: InputMaybe<Product_Section_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_mainsection */
export type Product_Mainsection_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_mainsection" */
export enum Product_Mainsection_Select_Column {
  /** column name */
  DisplayAs = 'display_as',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MainSectionId = 'main_section_id',
  /** column name */
  Order = 'order',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "product_mainsection" */
export type Product_Mainsection_Set_Input = {
  display_as?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  main_section_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Mainsection_Stddev_Fields = {
  __typename?: 'product_mainsection_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_mainsection" */
export type Product_Mainsection_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Mainsection_Stddev_Pop_Fields = {
  __typename?: 'product_mainsection_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_mainsection" */
export type Product_Mainsection_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Mainsection_Stddev_Samp_Fields = {
  __typename?: 'product_mainsection_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_mainsection" */
export type Product_Mainsection_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_mainsection" */
export type Product_Mainsection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Mainsection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Mainsection_Stream_Cursor_Value_Input = {
  display_as?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  main_section_id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_Mainsection_Sum_Fields = {
  __typename?: 'product_mainsection_sum_fields';
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "product_mainsection" */
export type Product_Mainsection_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_mainsection" */
export enum Product_Mainsection_Update_Column {
  /** column name */
  DisplayAs = 'display_as',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MainSectionId = 'main_section_id',
  /** column name */
  Order = 'order',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Value = 'value'
}

export type Product_Mainsection_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Mainsection_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Mainsection_Set_Input>;
  where: Product_Mainsection_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Mainsection_Var_Pop_Fields = {
  __typename?: 'product_mainsection_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_mainsection" */
export type Product_Mainsection_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Mainsection_Var_Samp_Fields = {
  __typename?: 'product_mainsection_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_mainsection" */
export type Product_Mainsection_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Mainsection_Variance_Fields = {
  __typename?: 'product_mainsection_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_mainsection" */
export type Product_Mainsection_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Product_Max_Fields = {
  __typename?: 'product_max_fields';
  composition_text?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featured_image_id?: Maybe<Scalars['bigint']>;
  formulation_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  manufactured_by_id?: Maybe<Scalars['uuid']>;
  marketed_by_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subcategory_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product" */
export type Product_Max_Order_By = {
  composition_text?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  formulation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufactured_by_id?: InputMaybe<Order_By>;
  marketed_by_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subcategory_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Min_Fields = {
  __typename?: 'product_min_fields';
  composition_text?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featured_image_id?: Maybe<Scalars['bigint']>;
  formulation_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  manufactured_by_id?: Maybe<Scalars['uuid']>;
  marketed_by_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subcategory_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product" */
export type Product_Min_Order_By = {
  composition_text?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  formulation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufactured_by_id?: InputMaybe<Order_By>;
  marketed_by_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subcategory_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product" */
export type Product_Mutation_Response = {
  __typename?: 'product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product>;
};

/** input type for inserting object relation for remote table "product" */
export type Product_Obj_Rel_Insert_Input = {
  data: Product_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** on_conflict condition type for table "product" */
export type Product_On_Conflict = {
  constraint: Product_Constraint;
  update_columns?: Array<Product_Update_Column>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  applicable_units_aggregate?: InputMaybe<Application_Product_Unit_Aggregate_Order_By>;
  composition_text?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  featured_image?: InputMaybe<Common_Fileupload_Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  formulation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  manufactured_by_id?: InputMaybe<Order_By>;
  manufacturing_facility?: InputMaybe<Manufacturing_Facility_Order_By>;
  marketed_by_id?: InputMaybe<Order_By>;
  marketing_facility?: InputMaybe<Marketing_Facility_Order_By>;
  media_upload_complete?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_attachments_aggregate?: InputMaybe<Product_Attachment_Aggregate_Order_By>;
  product_certifications_aggregate?: InputMaybe<Product_Certification_Aggregate_Order_By>;
  product_compositions_aggregate?: InputMaybe<Product_Composition_Aggregate_Order_By>;
  product_crop_association_recommendation_aggregate?: InputMaybe<Product_Crop_Association_Aggregate_Order_By>;
  product_crop_associations_aggregate?: InputMaybe<Product_Crop_Association_Aggregate_Order_By>;
  product_crop_infestation_recommendations_aggregate?: InputMaybe<Product_Crop_Infestation_Recommendation_Aggregate_Order_By>;
  product_crop_nutrition_recommendations_aggregate?: InputMaybe<Product_Crop_Nutrition_Recommendation_Aggregate_Order_By>;
  product_favourites_aggregate?: InputMaybe<Product_Favourite_Aggregate_Order_By>;
  product_infestations_aggregate?: InputMaybe<Product_Infestation_Aggregate_Order_By>;
  product_mainsections_aggregate?: InputMaybe<Product_Mainsection_Aggregate_Order_By>;
  product_purchased_aggregate?: InputMaybe<Product_Purchased_Aggregate_Order_By>;
  product_views_aggregate?: InputMaybe<Product_View_Aggregate_Order_By>;
  sellable_items_aggregate?: InputMaybe<Sellable_Item_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  subcategory?: InputMaybe<Subcategory_Order_By>;
  subcategory_id?: InputMaybe<Order_By>;
  translation_complete?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product */
export type Product_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "product_purchased" */
export type Product_Purchased = {
  __typename?: 'product_purchased';
  /** An object relationship */
  consumer?: Maybe<Care_Shared_Entity>;
  consumer_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  item_quantity: Scalars['Int'];
  /** An object relationship */
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  sellable_stock?: Maybe<Sellable_Item_Stock>;
  sellable_stock_id?: Maybe<Scalars['uuid']>;
  store_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "product_purchased" */
export type Product_Purchased_Aggregate = {
  __typename?: 'product_purchased_aggregate';
  aggregate?: Maybe<Product_Purchased_Aggregate_Fields>;
  nodes: Array<Product_Purchased>;
};

/** aggregate fields of "product_purchased" */
export type Product_Purchased_Aggregate_Fields = {
  __typename?: 'product_purchased_aggregate_fields';
  avg?: Maybe<Product_Purchased_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Purchased_Max_Fields>;
  min?: Maybe<Product_Purchased_Min_Fields>;
  stddev?: Maybe<Product_Purchased_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Purchased_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Purchased_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Purchased_Sum_Fields>;
  var_pop?: Maybe<Product_Purchased_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Purchased_Var_Samp_Fields>;
  variance?: Maybe<Product_Purchased_Variance_Fields>;
};


/** aggregate fields of "product_purchased" */
export type Product_Purchased_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Purchased_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_purchased" */
export type Product_Purchased_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Purchased_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Purchased_Max_Order_By>;
  min?: InputMaybe<Product_Purchased_Min_Order_By>;
  stddev?: InputMaybe<Product_Purchased_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Purchased_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Purchased_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Purchased_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Purchased_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Purchased_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Purchased_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_purchased" */
export type Product_Purchased_Arr_Rel_Insert_Input = {
  data: Array<Product_Purchased_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Purchased_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Purchased_Avg_Fields = {
  __typename?: 'product_purchased_avg_fields';
  consumer_id?: Maybe<Scalars['Float']>;
  item_quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_purchased" */
export type Product_Purchased_Avg_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_purchased". All fields are combined with a logical 'AND'. */
export type Product_Purchased_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Purchased_Bool_Exp>>;
  _not?: InputMaybe<Product_Purchased_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Purchased_Bool_Exp>>;
  consumer?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  consumer_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  item_quantity?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  sellable_stock?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
  sellable_stock_id?: InputMaybe<Uuid_Comparison_Exp>;
  store_id?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_purchased" */
export enum Product_Purchased_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPurchasedPkey = 'product_purchased_pkey'
}

/** input type for incrementing numeric columns in table "product_purchased" */
export type Product_Purchased_Inc_Input = {
  consumer_id?: InputMaybe<Scalars['bigint']>;
  item_quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_purchased" */
export type Product_Purchased_Insert_Input = {
  consumer?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  consumer_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  item_quantity?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_stock?: InputMaybe<Sellable_Item_Stock_Obj_Rel_Insert_Input>;
  sellable_stock_id?: InputMaybe<Scalars['uuid']>;
  store_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Purchased_Max_Fields = {
  __typename?: 'product_purchased_max_fields';
  consumer_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  item_quantity?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['uuid']>;
  sellable_stock_id?: Maybe<Scalars['uuid']>;
  store_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_purchased" */
export type Product_Purchased_Max_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_stock_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Purchased_Min_Fields = {
  __typename?: 'product_purchased_min_fields';
  consumer_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  item_quantity?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['uuid']>;
  sellable_stock_id?: Maybe<Scalars['uuid']>;
  store_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_purchased" */
export type Product_Purchased_Min_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_stock_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_purchased" */
export type Product_Purchased_Mutation_Response = {
  __typename?: 'product_purchased_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Purchased>;
};

/** on_conflict condition type for table "product_purchased" */
export type Product_Purchased_On_Conflict = {
  constraint: Product_Purchased_Constraint;
  update_columns?: Array<Product_Purchased_Update_Column>;
  where?: InputMaybe<Product_Purchased_Bool_Exp>;
};

/** Ordering options when selecting data from "product_purchased". */
export type Product_Purchased_Order_By = {
  consumer?: InputMaybe<Care_Shared_Entity_Order_By>;
  consumer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_stock?: InputMaybe<Sellable_Item_Stock_Order_By>;
  sellable_stock_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_purchased */
export type Product_Purchased_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_purchased" */
export enum Product_Purchased_Select_Column {
  /** column name */
  ConsumerId = 'consumer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ItemQuantity = 'item_quantity',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  SellableStockId = 'sellable_stock_id',
  /** column name */
  StoreId = 'store_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "product_purchased" */
export type Product_Purchased_Set_Input = {
  consumer_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  item_quantity?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_stock_id?: InputMaybe<Scalars['uuid']>;
  store_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Purchased_Stddev_Fields = {
  __typename?: 'product_purchased_stddev_fields';
  consumer_id?: Maybe<Scalars['Float']>;
  item_quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_purchased" */
export type Product_Purchased_Stddev_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Purchased_Stddev_Pop_Fields = {
  __typename?: 'product_purchased_stddev_pop_fields';
  consumer_id?: Maybe<Scalars['Float']>;
  item_quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_purchased" */
export type Product_Purchased_Stddev_Pop_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Purchased_Stddev_Samp_Fields = {
  __typename?: 'product_purchased_stddev_samp_fields';
  consumer_id?: Maybe<Scalars['Float']>;
  item_quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_purchased" */
export type Product_Purchased_Stddev_Samp_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_purchased" */
export type Product_Purchased_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Purchased_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Purchased_Stream_Cursor_Value_Input = {
  consumer_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  item_quantity?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_stock_id?: InputMaybe<Scalars['uuid']>;
  store_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_Purchased_Sum_Fields = {
  __typename?: 'product_purchased_sum_fields';
  consumer_id?: Maybe<Scalars['bigint']>;
  item_quantity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product_purchased" */
export type Product_Purchased_Sum_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
};

/** update columns of table "product_purchased" */
export enum Product_Purchased_Update_Column {
  /** column name */
  ConsumerId = 'consumer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ItemQuantity = 'item_quantity',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  SellableStockId = 'sellable_stock_id',
  /** column name */
  StoreId = 'store_id',
  /** column name */
  UserId = 'user_id'
}

export type Product_Purchased_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Purchased_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Purchased_Set_Input>;
  where: Product_Purchased_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Purchased_Var_Pop_Fields = {
  __typename?: 'product_purchased_var_pop_fields';
  consumer_id?: Maybe<Scalars['Float']>;
  item_quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_purchased" */
export type Product_Purchased_Var_Pop_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Purchased_Var_Samp_Fields = {
  __typename?: 'product_purchased_var_samp_fields';
  consumer_id?: Maybe<Scalars['Float']>;
  item_quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_purchased" */
export type Product_Purchased_Var_Samp_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Purchased_Variance_Fields = {
  __typename?: 'product_purchased_variance_fields';
  consumer_id?: Maybe<Scalars['Float']>;
  item_quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_purchased" */
export type Product_Purchased_Variance_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  item_quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_section" */
export type Product_Section = {
  __typename?: 'product_section';
  display_as: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  order: Scalars['Int'];
  /** An array relationship */
  product_attributes: Array<Product_Attribute>;
  /** An aggregate relationship */
  product_attributes_aggregate: Product_Attribute_Aggregate;
  product_main_section_id: Scalars['uuid'];
  /** An object relationship */
  product_mainsection: Product_Mainsection;
  /** An array relationship */
  product_section_attachments: Array<Product_Section_Attachment>;
  /** An aggregate relationship */
  product_section_attachments_aggregate: Product_Section_Attachment_Aggregate;
  /** An array relationship */
  product_subsections: Array<Product_Subsection>;
  /** An aggregate relationship */
  product_subsections_aggregate: Product_Subsection_Aggregate;
  /** An object relationship */
  section: Section;
  section_id: Scalars['uuid'];
  value?: Maybe<Scalars['String']>;
};


/** columns and relationships of "product_section" */
export type Product_SectionProduct_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


/** columns and relationships of "product_section" */
export type Product_SectionProduct_Attributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


/** columns and relationships of "product_section" */
export type Product_SectionProduct_Section_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Attachment_Order_By>>;
  where?: InputMaybe<Product_Section_Attachment_Bool_Exp>;
};


/** columns and relationships of "product_section" */
export type Product_SectionProduct_Section_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Attachment_Order_By>>;
  where?: InputMaybe<Product_Section_Attachment_Bool_Exp>;
};


/** columns and relationships of "product_section" */
export type Product_SectionProduct_SubsectionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Order_By>>;
  where?: InputMaybe<Product_Subsection_Bool_Exp>;
};


/** columns and relationships of "product_section" */
export type Product_SectionProduct_Subsections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Order_By>>;
  where?: InputMaybe<Product_Subsection_Bool_Exp>;
};

/** aggregated selection of "product_section" */
export type Product_Section_Aggregate = {
  __typename?: 'product_section_aggregate';
  aggregate?: Maybe<Product_Section_Aggregate_Fields>;
  nodes: Array<Product_Section>;
};

/** aggregate fields of "product_section" */
export type Product_Section_Aggregate_Fields = {
  __typename?: 'product_section_aggregate_fields';
  avg?: Maybe<Product_Section_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Section_Max_Fields>;
  min?: Maybe<Product_Section_Min_Fields>;
  stddev?: Maybe<Product_Section_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Section_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Section_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Section_Sum_Fields>;
  var_pop?: Maybe<Product_Section_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Section_Var_Samp_Fields>;
  variance?: Maybe<Product_Section_Variance_Fields>;
};


/** aggregate fields of "product_section" */
export type Product_Section_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Section_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_section" */
export type Product_Section_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Section_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Section_Max_Order_By>;
  min?: InputMaybe<Product_Section_Min_Order_By>;
  stddev?: InputMaybe<Product_Section_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Section_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Section_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Section_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Section_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Section_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Section_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_section" */
export type Product_Section_Arr_Rel_Insert_Input = {
  data: Array<Product_Section_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Section_On_Conflict>;
};

/** columns and relationships of "product_section_attachment" */
export type Product_Section_Attachment = {
  __typename?: 'product_section_attachment';
  attachment_id: Scalars['bigint'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  order: Scalars['smallint'];
  /** An object relationship */
  photo: Common_Fileupload;
  /** An object relationship */
  product_section: Product_Section;
  product_section_id: Scalars['uuid'];
};

/** aggregated selection of "product_section_attachment" */
export type Product_Section_Attachment_Aggregate = {
  __typename?: 'product_section_attachment_aggregate';
  aggregate?: Maybe<Product_Section_Attachment_Aggregate_Fields>;
  nodes: Array<Product_Section_Attachment>;
};

/** aggregate fields of "product_section_attachment" */
export type Product_Section_Attachment_Aggregate_Fields = {
  __typename?: 'product_section_attachment_aggregate_fields';
  avg?: Maybe<Product_Section_Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Section_Attachment_Max_Fields>;
  min?: Maybe<Product_Section_Attachment_Min_Fields>;
  stddev?: Maybe<Product_Section_Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Section_Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Section_Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Section_Attachment_Sum_Fields>;
  var_pop?: Maybe<Product_Section_Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Section_Attachment_Var_Samp_Fields>;
  variance?: Maybe<Product_Section_Attachment_Variance_Fields>;
};


/** aggregate fields of "product_section_attachment" */
export type Product_Section_Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Section_Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_section_attachment" */
export type Product_Section_Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Section_Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Section_Attachment_Max_Order_By>;
  min?: InputMaybe<Product_Section_Attachment_Min_Order_By>;
  stddev?: InputMaybe<Product_Section_Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Section_Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Section_Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Section_Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Section_Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Section_Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Section_Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_section_attachment" */
export type Product_Section_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Product_Section_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Section_Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Section_Attachment_Avg_Fields = {
  __typename?: 'product_section_attachment_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_section_attachment" */
export type Product_Section_Attachment_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_section_attachment". All fields are combined with a logical 'AND'. */
export type Product_Section_Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Section_Attachment_Bool_Exp>>;
  _not?: InputMaybe<Product_Section_Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Section_Attachment_Bool_Exp>>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  photo?: InputMaybe<Common_Fileupload_Bool_Exp>;
  product_section?: InputMaybe<Product_Section_Bool_Exp>;
  product_section_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_section_attachment" */
export enum Product_Section_Attachment_Constraint {
  /** unique or primary key constraint on columns "product_section_id", "order" */
  ProductSectionAttachmeProductSectionIdOrder_17f47e2aUniq = 'product_section_attachme_product_section_id_order_17f47e2a_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductSectionAttachmentPkey = 'product_section_attachment_pkey'
}

/** input type for incrementing numeric columns in table "product_section_attachment" */
export type Product_Section_Attachment_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "product_section_attachment" */
export type Product_Section_Attachment_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  photo?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  product_section?: InputMaybe<Product_Section_Obj_Rel_Insert_Input>;
  product_section_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Product_Section_Attachment_Max_Fields = {
  __typename?: 'product_section_attachment_max_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_section_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product_section_attachment" */
export type Product_Section_Attachment_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_section_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Section_Attachment_Min_Fields = {
  __typename?: 'product_section_attachment_min_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_section_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product_section_attachment" */
export type Product_Section_Attachment_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_section_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_section_attachment" */
export type Product_Section_Attachment_Mutation_Response = {
  __typename?: 'product_section_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Section_Attachment>;
};

/** on_conflict condition type for table "product_section_attachment" */
export type Product_Section_Attachment_On_Conflict = {
  constraint: Product_Section_Attachment_Constraint;
  update_columns?: Array<Product_Section_Attachment_Update_Column>;
  where?: InputMaybe<Product_Section_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "product_section_attachment". */
export type Product_Section_Attachment_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  photo?: InputMaybe<Common_Fileupload_Order_By>;
  product_section?: InputMaybe<Product_Section_Order_By>;
  product_section_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_section_attachment */
export type Product_Section_Attachment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_section_attachment" */
export enum Product_Section_Attachment_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Language = 'language',
  /** column name */
  Order = 'order',
  /** column name */
  ProductSectionId = 'product_section_id'
}

/** input type for updating data in table "product_section_attachment" */
export type Product_Section_Attachment_Set_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_section_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Product_Section_Attachment_Stddev_Fields = {
  __typename?: 'product_section_attachment_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_section_attachment" */
export type Product_Section_Attachment_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Section_Attachment_Stddev_Pop_Fields = {
  __typename?: 'product_section_attachment_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_section_attachment" */
export type Product_Section_Attachment_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Section_Attachment_Stddev_Samp_Fields = {
  __typename?: 'product_section_attachment_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_section_attachment" */
export type Product_Section_Attachment_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_section_attachment" */
export type Product_Section_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Section_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Section_Attachment_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_section_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Product_Section_Attachment_Sum_Fields = {
  __typename?: 'product_section_attachment_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "product_section_attachment" */
export type Product_Section_Attachment_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_section_attachment" */
export enum Product_Section_Attachment_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Language = 'language',
  /** column name */
  Order = 'order',
  /** column name */
  ProductSectionId = 'product_section_id'
}

export type Product_Section_Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Section_Attachment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Section_Attachment_Set_Input>;
  where: Product_Section_Attachment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Section_Attachment_Var_Pop_Fields = {
  __typename?: 'product_section_attachment_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_section_attachment" */
export type Product_Section_Attachment_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Section_Attachment_Var_Samp_Fields = {
  __typename?: 'product_section_attachment_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_section_attachment" */
export type Product_Section_Attachment_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Section_Attachment_Variance_Fields = {
  __typename?: 'product_section_attachment_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_section_attachment" */
export type Product_Section_Attachment_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Product_Section_Avg_Fields = {
  __typename?: 'product_section_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_section" */
export type Product_Section_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_section". All fields are combined with a logical 'AND'. */
export type Product_Section_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Section_Bool_Exp>>;
  _not?: InputMaybe<Product_Section_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Section_Bool_Exp>>;
  display_as?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  product_attributes?: InputMaybe<Product_Attribute_Bool_Exp>;
  product_main_section_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_mainsection?: InputMaybe<Product_Mainsection_Bool_Exp>;
  product_section_attachments?: InputMaybe<Product_Section_Attachment_Bool_Exp>;
  product_subsections?: InputMaybe<Product_Subsection_Bool_Exp>;
  section?: InputMaybe<Section_Bool_Exp>;
  section_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_section" */
export enum Product_Section_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductSectionPkey = 'product_section_pkey',
  /** unique or primary key constraint on columns "section_id", "product_main_section_id" */
  ProductSectionProductMainSectionId_01f2ea17Uniq = 'product_section_product_main_section_id__01f2ea17_uniq'
}

/** input type for incrementing numeric columns in table "product_section" */
export type Product_Section_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_section" */
export type Product_Section_Insert_Input = {
  display_as?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  product_attributes?: InputMaybe<Product_Attribute_Arr_Rel_Insert_Input>;
  product_main_section_id?: InputMaybe<Scalars['uuid']>;
  product_mainsection?: InputMaybe<Product_Mainsection_Obj_Rel_Insert_Input>;
  product_section_attachments?: InputMaybe<Product_Section_Attachment_Arr_Rel_Insert_Input>;
  product_subsections?: InputMaybe<Product_Subsection_Arr_Rel_Insert_Input>;
  section?: InputMaybe<Section_Obj_Rel_Insert_Input>;
  section_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Section_Max_Fields = {
  __typename?: 'product_section_max_fields';
  display_as?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  product_main_section_id?: Maybe<Scalars['uuid']>;
  section_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_section" */
export type Product_Section_Max_Order_By = {
  display_as?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_main_section_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Section_Min_Fields = {
  __typename?: 'product_section_min_fields';
  display_as?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  product_main_section_id?: Maybe<Scalars['uuid']>;
  section_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_section" */
export type Product_Section_Min_Order_By = {
  display_as?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_main_section_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_section" */
export type Product_Section_Mutation_Response = {
  __typename?: 'product_section_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Section>;
};

/** input type for inserting object relation for remote table "product_section" */
export type Product_Section_Obj_Rel_Insert_Input = {
  data: Product_Section_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Section_On_Conflict>;
};

/** on_conflict condition type for table "product_section" */
export type Product_Section_On_Conflict = {
  constraint: Product_Section_Constraint;
  update_columns?: Array<Product_Section_Update_Column>;
  where?: InputMaybe<Product_Section_Bool_Exp>;
};

/** Ordering options when selecting data from "product_section". */
export type Product_Section_Order_By = {
  display_as?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_attributes_aggregate?: InputMaybe<Product_Attribute_Aggregate_Order_By>;
  product_main_section_id?: InputMaybe<Order_By>;
  product_mainsection?: InputMaybe<Product_Mainsection_Order_By>;
  product_section_attachments_aggregate?: InputMaybe<Product_Section_Attachment_Aggregate_Order_By>;
  product_subsections_aggregate?: InputMaybe<Product_Subsection_Aggregate_Order_By>;
  section?: InputMaybe<Section_Order_By>;
  section_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_section */
export type Product_Section_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_section" */
export enum Product_Section_Select_Column {
  /** column name */
  DisplayAs = 'display_as',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  ProductMainSectionId = 'product_main_section_id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "product_section" */
export type Product_Section_Set_Input = {
  display_as?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  product_main_section_id?: InputMaybe<Scalars['uuid']>;
  section_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Section_Stddev_Fields = {
  __typename?: 'product_section_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_section" */
export type Product_Section_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Section_Stddev_Pop_Fields = {
  __typename?: 'product_section_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_section" */
export type Product_Section_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Section_Stddev_Samp_Fields = {
  __typename?: 'product_section_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_section" */
export type Product_Section_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_section" */
export type Product_Section_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Section_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Section_Stream_Cursor_Value_Input = {
  display_as?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  product_main_section_id?: InputMaybe<Scalars['uuid']>;
  section_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_Section_Sum_Fields = {
  __typename?: 'product_section_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product_section" */
export type Product_Section_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_section" */
export enum Product_Section_Update_Column {
  /** column name */
  DisplayAs = 'display_as',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  ProductMainSectionId = 'product_main_section_id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  Value = 'value'
}

export type Product_Section_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Section_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Section_Set_Input>;
  where: Product_Section_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Section_Var_Pop_Fields = {
  __typename?: 'product_section_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_section" */
export type Product_Section_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Section_Var_Samp_Fields = {
  __typename?: 'product_section_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_section" */
export type Product_Section_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Section_Variance_Fields = {
  __typename?: 'product_section_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_section" */
export type Product_Section_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** select columns of table "product" */
export enum Product_Select_Column {
  /** column name */
  CompositionText = 'composition_text',
  /** column name */
  Description = 'description',
  /** column name */
  FeaturedImageId = 'featured_image_id',
  /** column name */
  FormulationId = 'formulation_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ManufacturedById = 'manufactured_by_id',
  /** column name */
  MarketedById = 'marketed_by_id',
  /** column name */
  MediaUploadComplete = 'media_upload_complete',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  SubcategoryId = 'subcategory_id',
  /** column name */
  TranslationComplete = 'translation_complete'
}

/** input type for updating data in table "product" */
export type Product_Set_Input = {
  composition_text?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featured_image_id?: InputMaybe<Scalars['bigint']>;
  formulation_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  manufactured_by_id?: InputMaybe<Scalars['uuid']>;
  marketed_by_id?: InputMaybe<Scalars['uuid']>;
  media_upload_complete?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subcategory_id?: InputMaybe<Scalars['uuid']>;
  translation_complete?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "product_sku" */
export type Product_Sku = {
  __typename?: 'product_sku';
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  quantity: Scalars['float8'];
  /** An object relationship */
  quantity_unit?: Maybe<Care_Shared_Entity>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  sellable_items: Array<Sellable_Item>;
  /** An aggregate relationship */
  sellable_items_aggregate: Sellable_Item_Aggregate;
  short_name?: Maybe<Scalars['String']>;
};


/** columns and relationships of "product_sku" */
export type Product_SkuSellable_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Order_By>>;
  where?: InputMaybe<Sellable_Item_Bool_Exp>;
};


/** columns and relationships of "product_sku" */
export type Product_SkuSellable_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Order_By>>;
  where?: InputMaybe<Sellable_Item_Bool_Exp>;
};

/** aggregated selection of "product_sku" */
export type Product_Sku_Aggregate = {
  __typename?: 'product_sku_aggregate';
  aggregate?: Maybe<Product_Sku_Aggregate_Fields>;
  nodes: Array<Product_Sku>;
};

/** aggregate fields of "product_sku" */
export type Product_Sku_Aggregate_Fields = {
  __typename?: 'product_sku_aggregate_fields';
  avg?: Maybe<Product_Sku_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Sku_Max_Fields>;
  min?: Maybe<Product_Sku_Min_Fields>;
  stddev?: Maybe<Product_Sku_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Sku_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Sku_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Sku_Sum_Fields>;
  var_pop?: Maybe<Product_Sku_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Sku_Var_Samp_Fields>;
  variance?: Maybe<Product_Sku_Variance_Fields>;
};


/** aggregate fields of "product_sku" */
export type Product_Sku_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Sku_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Product_Sku_Avg_Fields = {
  __typename?: 'product_sku_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "product_sku". All fields are combined with a logical 'AND'. */
export type Product_Sku_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Sku_Bool_Exp>>;
  _not?: InputMaybe<Product_Sku_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Sku_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  quantity_unit?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  sellable_items?: InputMaybe<Sellable_Item_Bool_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_sku" */
export enum Product_Sku_Constraint {
  /** unique or primary key constraint on columns "name", "quantity", "quantity_unit_id" */
  ProductSkuNameQuantityQuantityUnitId_50def979Uniq = 'product_sku_name_quantity_quantity_unit_id_50def979_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductSkuPkey = 'product_sku_pkey'
}

/** input type for incrementing numeric columns in table "product_sku" */
export type Product_Sku_Inc_Input = {
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "product_sku" */
export type Product_Sku_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_unit?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  sellable_items?: InputMaybe<Sellable_Item_Arr_Rel_Insert_Input>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Sku_Max_Fields = {
  __typename?: 'product_sku_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  short_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Product_Sku_Min_Fields = {
  __typename?: 'product_sku_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  short_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "product_sku" */
export type Product_Sku_Mutation_Response = {
  __typename?: 'product_sku_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Sku>;
};

/** input type for inserting object relation for remote table "product_sku" */
export type Product_Sku_Obj_Rel_Insert_Input = {
  data: Product_Sku_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Sku_On_Conflict>;
};

/** on_conflict condition type for table "product_sku" */
export type Product_Sku_On_Conflict = {
  constraint: Product_Sku_Constraint;
  update_columns?: Array<Product_Sku_Update_Column>;
  where?: InputMaybe<Product_Sku_Bool_Exp>;
};

/** Ordering options when selecting data from "product_sku". */
export type Product_Sku_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Care_Shared_Entity_Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  sellable_items_aggregate?: InputMaybe<Sellable_Item_Aggregate_Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_sku */
export type Product_Sku_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_sku" */
export enum Product_Sku_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  ShortName = 'short_name'
}

/** input type for updating data in table "product_sku" */
export type Product_Sku_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Sku_Stddev_Fields = {
  __typename?: 'product_sku_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Product_Sku_Stddev_Pop_Fields = {
  __typename?: 'product_sku_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Product_Sku_Stddev_Samp_Fields = {
  __typename?: 'product_sku_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "product_sku" */
export type Product_Sku_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Sku_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Sku_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_Sku_Sum_Fields = {
  __typename?: 'product_sku_sum_fields';
  quantity?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "product_sku" */
export enum Product_Sku_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  ShortName = 'short_name'
}

export type Product_Sku_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Sku_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Sku_Set_Input>;
  where: Product_Sku_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Sku_Var_Pop_Fields = {
  __typename?: 'product_sku_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Product_Sku_Var_Samp_Fields = {
  __typename?: 'product_sku_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Product_Sku_Variance_Fields = {
  __typename?: 'product_sku_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Product_Stddev_Fields = {
  __typename?: 'product_stddev_fields';
  featured_image_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product" */
export type Product_Stddev_Order_By = {
  featured_image_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Stddev_Pop_Fields = {
  __typename?: 'product_stddev_pop_fields';
  featured_image_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product" */
export type Product_Stddev_Pop_Order_By = {
  featured_image_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Stddev_Samp_Fields = {
  __typename?: 'product_stddev_samp_fields';
  featured_image_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product" */
export type Product_Stddev_Samp_Order_By = {
  featured_image_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  composition_text?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featured_image_id?: InputMaybe<Scalars['bigint']>;
  formulation_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  manufactured_by_id?: InputMaybe<Scalars['uuid']>;
  marketed_by_id?: InputMaybe<Scalars['uuid']>;
  media_upload_complete?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subcategory_id?: InputMaybe<Scalars['uuid']>;
  translation_complete?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "product_subsection" */
export type Product_Subsection = {
  __typename?: 'product_subsection';
  display_as: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  order: Scalars['smallint'];
  /** An array relationship */
  product_attributes: Array<Product_Attribute>;
  /** An aggregate relationship */
  product_attributes_aggregate: Product_Attribute_Aggregate;
  /** An object relationship */
  product_section: Product_Section;
  product_section_id: Scalars['uuid'];
  /** An array relationship */
  product_subsection_attachments: Array<Product_Subsection_Attachment>;
  /** An aggregate relationship */
  product_subsection_attachments_aggregate: Product_Subsection_Attachment_Aggregate;
  /** An object relationship */
  sub_section: Sub_Section;
  subsection_id: Scalars['uuid'];
  value?: Maybe<Scalars['String']>;
};


/** columns and relationships of "product_subsection" */
export type Product_SubsectionProduct_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


/** columns and relationships of "product_subsection" */
export type Product_SubsectionProduct_Attributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


/** columns and relationships of "product_subsection" */
export type Product_SubsectionProduct_Subsection_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Subsection_Attachment_Bool_Exp>;
};


/** columns and relationships of "product_subsection" */
export type Product_SubsectionProduct_Subsection_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Subsection_Attachment_Bool_Exp>;
};

/** aggregated selection of "product_subsection" */
export type Product_Subsection_Aggregate = {
  __typename?: 'product_subsection_aggregate';
  aggregate?: Maybe<Product_Subsection_Aggregate_Fields>;
  nodes: Array<Product_Subsection>;
};

/** aggregate fields of "product_subsection" */
export type Product_Subsection_Aggregate_Fields = {
  __typename?: 'product_subsection_aggregate_fields';
  avg?: Maybe<Product_Subsection_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Subsection_Max_Fields>;
  min?: Maybe<Product_Subsection_Min_Fields>;
  stddev?: Maybe<Product_Subsection_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Subsection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Subsection_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Subsection_Sum_Fields>;
  var_pop?: Maybe<Product_Subsection_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Subsection_Var_Samp_Fields>;
  variance?: Maybe<Product_Subsection_Variance_Fields>;
};


/** aggregate fields of "product_subsection" */
export type Product_Subsection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Subsection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_subsection" */
export type Product_Subsection_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Subsection_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Subsection_Max_Order_By>;
  min?: InputMaybe<Product_Subsection_Min_Order_By>;
  stddev?: InputMaybe<Product_Subsection_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Subsection_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Subsection_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Subsection_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Subsection_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Subsection_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Subsection_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_subsection" */
export type Product_Subsection_Arr_Rel_Insert_Input = {
  data: Array<Product_Subsection_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Subsection_On_Conflict>;
};

/** columns and relationships of "product_subsection_attachment" */
export type Product_Subsection_Attachment = {
  __typename?: 'product_subsection_attachment';
  attachment_id: Scalars['bigint'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  order: Scalars['smallint'];
  /** An object relationship */
  photo: Common_Fileupload;
  /** An object relationship */
  product_subsection: Product_Subsection;
  product_subsection_id: Scalars['uuid'];
};

/** aggregated selection of "product_subsection_attachment" */
export type Product_Subsection_Attachment_Aggregate = {
  __typename?: 'product_subsection_attachment_aggregate';
  aggregate?: Maybe<Product_Subsection_Attachment_Aggregate_Fields>;
  nodes: Array<Product_Subsection_Attachment>;
};

/** aggregate fields of "product_subsection_attachment" */
export type Product_Subsection_Attachment_Aggregate_Fields = {
  __typename?: 'product_subsection_attachment_aggregate_fields';
  avg?: Maybe<Product_Subsection_Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Subsection_Attachment_Max_Fields>;
  min?: Maybe<Product_Subsection_Attachment_Min_Fields>;
  stddev?: Maybe<Product_Subsection_Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Subsection_Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Subsection_Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Subsection_Attachment_Sum_Fields>;
  var_pop?: Maybe<Product_Subsection_Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Subsection_Attachment_Var_Samp_Fields>;
  variance?: Maybe<Product_Subsection_Attachment_Variance_Fields>;
};


/** aggregate fields of "product_subsection_attachment" */
export type Product_Subsection_Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Subsection_Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Subsection_Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Subsection_Attachment_Max_Order_By>;
  min?: InputMaybe<Product_Subsection_Attachment_Min_Order_By>;
  stddev?: InputMaybe<Product_Subsection_Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Subsection_Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Subsection_Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Subsection_Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Subsection_Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Subsection_Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Subsection_Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Product_Subsection_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Subsection_Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Subsection_Attachment_Avg_Fields = {
  __typename?: 'product_subsection_attachment_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_subsection_attachment". All fields are combined with a logical 'AND'. */
export type Product_Subsection_Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Subsection_Attachment_Bool_Exp>>;
  _not?: InputMaybe<Product_Subsection_Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Subsection_Attachment_Bool_Exp>>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  photo?: InputMaybe<Common_Fileupload_Bool_Exp>;
  product_subsection?: InputMaybe<Product_Subsection_Bool_Exp>;
  product_subsection_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_subsection_attachment" */
export enum Product_Subsection_Attachment_Constraint {
  /** unique or primary key constraint on columns "product_subsection_id", "order" */
  ProductSubsectionAttacProductSubsectionIdOrD148f0fcUniq = 'product_subsection_attac_product_subsection_id_or_d148f0fc_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductSubsectionAttachmentPkey = 'product_subsection_attachment_pkey'
}

/** input type for incrementing numeric columns in table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  photo?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  product_subsection?: InputMaybe<Product_Subsection_Obj_Rel_Insert_Input>;
  product_subsection_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Product_Subsection_Attachment_Max_Fields = {
  __typename?: 'product_subsection_attachment_max_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_subsection_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_subsection_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Subsection_Attachment_Min_Fields = {
  __typename?: 'product_subsection_attachment_min_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  product_subsection_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_subsection_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Mutation_Response = {
  __typename?: 'product_subsection_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Subsection_Attachment>;
};

/** on_conflict condition type for table "product_subsection_attachment" */
export type Product_Subsection_Attachment_On_Conflict = {
  constraint: Product_Subsection_Attachment_Constraint;
  update_columns?: Array<Product_Subsection_Attachment_Update_Column>;
  where?: InputMaybe<Product_Subsection_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "product_subsection_attachment". */
export type Product_Subsection_Attachment_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  photo?: InputMaybe<Common_Fileupload_Order_By>;
  product_subsection?: InputMaybe<Product_Subsection_Order_By>;
  product_subsection_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_subsection_attachment */
export type Product_Subsection_Attachment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_subsection_attachment" */
export enum Product_Subsection_Attachment_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Language = 'language',
  /** column name */
  Order = 'order',
  /** column name */
  ProductSubsectionId = 'product_subsection_id'
}

/** input type for updating data in table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Set_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_subsection_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Product_Subsection_Attachment_Stddev_Fields = {
  __typename?: 'product_subsection_attachment_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Subsection_Attachment_Stddev_Pop_Fields = {
  __typename?: 'product_subsection_attachment_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Subsection_Attachment_Stddev_Samp_Fields = {
  __typename?: 'product_subsection_attachment_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Subsection_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Subsection_Attachment_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_subsection_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Product_Subsection_Attachment_Sum_Fields = {
  __typename?: 'product_subsection_attachment_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_subsection_attachment" */
export enum Product_Subsection_Attachment_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Language = 'language',
  /** column name */
  Order = 'order',
  /** column name */
  ProductSubsectionId = 'product_subsection_id'
}

export type Product_Subsection_Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Subsection_Attachment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Subsection_Attachment_Set_Input>;
  where: Product_Subsection_Attachment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Subsection_Attachment_Var_Pop_Fields = {
  __typename?: 'product_subsection_attachment_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Subsection_Attachment_Var_Samp_Fields = {
  __typename?: 'product_subsection_attachment_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Subsection_Attachment_Variance_Fields = {
  __typename?: 'product_subsection_attachment_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_subsection_attachment" */
export type Product_Subsection_Attachment_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Product_Subsection_Avg_Fields = {
  __typename?: 'product_subsection_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_subsection" */
export type Product_Subsection_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_subsection". All fields are combined with a logical 'AND'. */
export type Product_Subsection_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Subsection_Bool_Exp>>;
  _not?: InputMaybe<Product_Subsection_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Subsection_Bool_Exp>>;
  display_as?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  product_attributes?: InputMaybe<Product_Attribute_Bool_Exp>;
  product_section?: InputMaybe<Product_Section_Bool_Exp>;
  product_section_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_subsection_attachments?: InputMaybe<Product_Subsection_Attachment_Bool_Exp>;
  sub_section?: InputMaybe<Sub_Section_Bool_Exp>;
  subsection_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_subsection" */
export enum Product_Subsection_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductSubsectionPkey = 'product_subsection_pkey',
  /** unique or primary key constraint on columns "product_section_id", "subsection_id" */
  ProductSubsectionProductSectionIdSubse_0aefa51bUniq = 'product_subsection_product_section_id_subse_0aefa51b_uniq'
}

/** input type for incrementing numeric columns in table "product_subsection" */
export type Product_Subsection_Inc_Input = {
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "product_subsection" */
export type Product_Subsection_Insert_Input = {
  display_as?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_attributes?: InputMaybe<Product_Attribute_Arr_Rel_Insert_Input>;
  product_section?: InputMaybe<Product_Section_Obj_Rel_Insert_Input>;
  product_section_id?: InputMaybe<Scalars['uuid']>;
  product_subsection_attachments?: InputMaybe<Product_Subsection_Attachment_Arr_Rel_Insert_Input>;
  sub_section?: InputMaybe<Sub_Section_Obj_Rel_Insert_Input>;
  subsection_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Subsection_Max_Fields = {
  __typename?: 'product_subsection_max_fields';
  display_as?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  product_section_id?: Maybe<Scalars['uuid']>;
  subsection_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_subsection" */
export type Product_Subsection_Max_Order_By = {
  display_as?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_section_id?: InputMaybe<Order_By>;
  subsection_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Subsection_Min_Fields = {
  __typename?: 'product_subsection_min_fields';
  display_as?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['smallint']>;
  product_section_id?: Maybe<Scalars['uuid']>;
  subsection_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_subsection" */
export type Product_Subsection_Min_Order_By = {
  display_as?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_section_id?: InputMaybe<Order_By>;
  subsection_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_subsection" */
export type Product_Subsection_Mutation_Response = {
  __typename?: 'product_subsection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Subsection>;
};

/** input type for inserting object relation for remote table "product_subsection" */
export type Product_Subsection_Obj_Rel_Insert_Input = {
  data: Product_Subsection_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Subsection_On_Conflict>;
};

/** on_conflict condition type for table "product_subsection" */
export type Product_Subsection_On_Conflict = {
  constraint: Product_Subsection_Constraint;
  update_columns?: Array<Product_Subsection_Update_Column>;
  where?: InputMaybe<Product_Subsection_Bool_Exp>;
};

/** Ordering options when selecting data from "product_subsection". */
export type Product_Subsection_Order_By = {
  display_as?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_attributes_aggregate?: InputMaybe<Product_Attribute_Aggregate_Order_By>;
  product_section?: InputMaybe<Product_Section_Order_By>;
  product_section_id?: InputMaybe<Order_By>;
  product_subsection_attachments_aggregate?: InputMaybe<Product_Subsection_Attachment_Aggregate_Order_By>;
  sub_section?: InputMaybe<Sub_Section_Order_By>;
  subsection_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_subsection */
export type Product_Subsection_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_subsection" */
export enum Product_Subsection_Select_Column {
  /** column name */
  DisplayAs = 'display_as',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  ProductSectionId = 'product_section_id',
  /** column name */
  SubsectionId = 'subsection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "product_subsection" */
export type Product_Subsection_Set_Input = {
  display_as?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_section_id?: InputMaybe<Scalars['uuid']>;
  subsection_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Subsection_Stddev_Fields = {
  __typename?: 'product_subsection_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_subsection" */
export type Product_Subsection_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Subsection_Stddev_Pop_Fields = {
  __typename?: 'product_subsection_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_subsection" */
export type Product_Subsection_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Subsection_Stddev_Samp_Fields = {
  __typename?: 'product_subsection_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_subsection" */
export type Product_Subsection_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_subsection" */
export type Product_Subsection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Subsection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Subsection_Stream_Cursor_Value_Input = {
  display_as?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['smallint']>;
  product_section_id?: InputMaybe<Scalars['uuid']>;
  subsection_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_Subsection_Sum_Fields = {
  __typename?: 'product_subsection_sum_fields';
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "product_subsection" */
export type Product_Subsection_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "product_subsection" */
export enum Product_Subsection_Update_Column {
  /** column name */
  DisplayAs = 'display_as',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  ProductSectionId = 'product_section_id',
  /** column name */
  SubsectionId = 'subsection_id',
  /** column name */
  Value = 'value'
}

export type Product_Subsection_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Subsection_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Subsection_Set_Input>;
  where: Product_Subsection_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Subsection_Var_Pop_Fields = {
  __typename?: 'product_subsection_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_subsection" */
export type Product_Subsection_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Subsection_Var_Samp_Fields = {
  __typename?: 'product_subsection_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_subsection" */
export type Product_Subsection_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Subsection_Variance_Fields = {
  __typename?: 'product_subsection_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_subsection" */
export type Product_Subsection_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Product_Sum_Fields = {
  __typename?: 'product_sum_fields';
  featured_image_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "product" */
export type Product_Sum_Order_By = {
  featured_image_id?: InputMaybe<Order_By>;
};

/** update columns of table "product" */
export enum Product_Update_Column {
  /** column name */
  CompositionText = 'composition_text',
  /** column name */
  Description = 'description',
  /** column name */
  FeaturedImageId = 'featured_image_id',
  /** column name */
  FormulationId = 'formulation_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ManufacturedById = 'manufactured_by_id',
  /** column name */
  MarketedById = 'marketed_by_id',
  /** column name */
  MediaUploadComplete = 'media_upload_complete',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  SubcategoryId = 'subcategory_id',
  /** column name */
  TranslationComplete = 'translation_complete'
}

export type Product_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Var_Pop_Fields = {
  __typename?: 'product_var_pop_fields';
  featured_image_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product" */
export type Product_Var_Pop_Order_By = {
  featured_image_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Var_Samp_Fields = {
  __typename?: 'product_var_samp_fields';
  featured_image_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product" */
export type Product_Var_Samp_Order_By = {
  featured_image_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Variance_Fields = {
  __typename?: 'product_variance_fields';
  featured_image_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product" */
export type Product_Variance_Order_By = {
  featured_image_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_view" */
export type Product_View = {
  __typename?: 'product_view';
  /** An object relationship */
  consumer?: Maybe<Care_Shared_Entity>;
  consumer_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  sellable_item_stock?: Maybe<Sellable_Item_Stock>;
  sellable_stock_id?: Maybe<Scalars['uuid']>;
  store_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "product_view" */
export type Product_View_Aggregate = {
  __typename?: 'product_view_aggregate';
  aggregate?: Maybe<Product_View_Aggregate_Fields>;
  nodes: Array<Product_View>;
};

/** aggregate fields of "product_view" */
export type Product_View_Aggregate_Fields = {
  __typename?: 'product_view_aggregate_fields';
  avg?: Maybe<Product_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_View_Max_Fields>;
  min?: Maybe<Product_View_Min_Fields>;
  stddev?: Maybe<Product_View_Stddev_Fields>;
  stddev_pop?: Maybe<Product_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_View_Stddev_Samp_Fields>;
  sum?: Maybe<Product_View_Sum_Fields>;
  var_pop?: Maybe<Product_View_Var_Pop_Fields>;
  var_samp?: Maybe<Product_View_Var_Samp_Fields>;
  variance?: Maybe<Product_View_Variance_Fields>;
};


/** aggregate fields of "product_view" */
export type Product_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_view" */
export type Product_View_Aggregate_Order_By = {
  avg?: InputMaybe<Product_View_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_View_Max_Order_By>;
  min?: InputMaybe<Product_View_Min_Order_By>;
  stddev?: InputMaybe<Product_View_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_View_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_View_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_View_Sum_Order_By>;
  var_pop?: InputMaybe<Product_View_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_View_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_View_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_view" */
export type Product_View_Arr_Rel_Insert_Input = {
  data: Array<Product_View_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_View_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_View_Avg_Fields = {
  __typename?: 'product_view_avg_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_view" */
export type Product_View_Avg_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_view". All fields are combined with a logical 'AND'. */
export type Product_View_Bool_Exp = {
  _and?: InputMaybe<Array<Product_View_Bool_Exp>>;
  _not?: InputMaybe<Product_View_Bool_Exp>;
  _or?: InputMaybe<Array<Product_View_Bool_Exp>>;
  consumer?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  consumer_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  sellable_item_stock?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
  sellable_stock_id?: InputMaybe<Uuid_Comparison_Exp>;
  store_id?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_view" */
export enum Product_View_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductViewPkey = 'product_view_pkey'
}

/** input type for incrementing numeric columns in table "product_view" */
export type Product_View_Inc_Input = {
  consumer_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "product_view" */
export type Product_View_Insert_Input = {
  consumer?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  consumer_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_item_stock?: InputMaybe<Sellable_Item_Stock_Obj_Rel_Insert_Input>;
  sellable_stock_id?: InputMaybe<Scalars['uuid']>;
  store_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_View_Max_Fields = {
  __typename?: 'product_view_max_fields';
  consumer_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
  sellable_stock_id?: Maybe<Scalars['uuid']>;
  store_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_view" */
export type Product_View_Max_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_stock_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_View_Min_Fields = {
  __typename?: 'product_view_min_fields';
  consumer_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
  sellable_stock_id?: Maybe<Scalars['uuid']>;
  store_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_view" */
export type Product_View_Min_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_stock_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_view" */
export type Product_View_Mutation_Response = {
  __typename?: 'product_view_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_View>;
};

/** on_conflict condition type for table "product_view" */
export type Product_View_On_Conflict = {
  constraint: Product_View_Constraint;
  update_columns?: Array<Product_View_Update_Column>;
  where?: InputMaybe<Product_View_Bool_Exp>;
};

/** Ordering options when selecting data from "product_view". */
export type Product_View_Order_By = {
  consumer?: InputMaybe<Care_Shared_Entity_Order_By>;
  consumer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_item_stock?: InputMaybe<Sellable_Item_Stock_Order_By>;
  sellable_stock_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_view */
export type Product_View_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_view" */
export enum Product_View_Select_Column {
  /** column name */
  ConsumerId = 'consumer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  SellableStockId = 'sellable_stock_id',
  /** column name */
  StoreId = 'store_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "product_view" */
export type Product_View_Set_Input = {
  consumer_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_stock_id?: InputMaybe<Scalars['uuid']>;
  store_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_View_Stddev_Fields = {
  __typename?: 'product_view_stddev_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_view" */
export type Product_View_Stddev_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_View_Stddev_Pop_Fields = {
  __typename?: 'product_view_stddev_pop_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_view" */
export type Product_View_Stddev_Pop_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_View_Stddev_Samp_Fields = {
  __typename?: 'product_view_stddev_samp_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_view" */
export type Product_View_Stddev_Samp_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_view" */
export type Product_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_View_Stream_Cursor_Value_Input = {
  consumer_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_stock_id?: InputMaybe<Scalars['uuid']>;
  store_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Product_View_Sum_Fields = {
  __typename?: 'product_view_sum_fields';
  consumer_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "product_view" */
export type Product_View_Sum_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** update columns of table "product_view" */
export enum Product_View_Update_Column {
  /** column name */
  ConsumerId = 'consumer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  SellableStockId = 'sellable_stock_id',
  /** column name */
  StoreId = 'store_id',
  /** column name */
  UserId = 'user_id'
}

export type Product_View_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_View_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_View_Set_Input>;
  where: Product_View_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_View_Var_Pop_Fields = {
  __typename?: 'product_view_var_pop_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_view" */
export type Product_View_Var_Pop_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_View_Var_Samp_Fields = {
  __typename?: 'product_view_var_samp_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_view" */
export type Product_View_Var_Samp_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_View_Variance_Fields = {
  __typename?: 'product_view_variance_fields';
  consumer_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_view" */
export type Product_View_Variance_Order_By = {
  consumer_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "products" */
export type Products = {
  __typename?: 'products';
  all_crops: Scalars['Boolean'];
  care_product_id?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  creator: Array<Base_User>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  manufacturer?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object relationship */
  operation_product_type: Operation_Product_Types;
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  products_fertiliser?: Maybe<Products_Fertiliser>;
  /** An object relationship */
  products_pesticide?: Maybe<Products_Pesticide>;
  shared_care_product_id?: Maybe<Scalars['bigint']>;
  type_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  updater: Array<Base_User>;
};


/** columns and relationships of "products" */
export type ProductsCreatorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Productscreator>;
};


/** columns and relationships of "products" */
export type ProductsUpdaterArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Productsupdater>;
};

/** aggregated selection of "products" */
export type Products_Aggregate = {
  __typename?: 'products_aggregate';
  aggregate?: Maybe<Products_Aggregate_Fields>;
  nodes: Array<Products>;
};

/** aggregate fields of "products" */
export type Products_Aggregate_Fields = {
  __typename?: 'products_aggregate_fields';
  avg?: Maybe<Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Products_Max_Fields>;
  min?: Maybe<Products_Min_Fields>;
  stddev?: Maybe<Products_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Sum_Fields>;
  var_pop?: Maybe<Products_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Var_Samp_Fields>;
  variance?: Maybe<Products_Variance_Fields>;
};


/** aggregate fields of "products" */
export type Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "products" */
export type Products_Aggregate_Order_By = {
  avg?: InputMaybe<Products_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Products_Max_Order_By>;
  min?: InputMaybe<Products_Min_Order_By>;
  stddev?: InputMaybe<Products_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Products_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Products_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Products_Sum_Order_By>;
  var_pop?: InputMaybe<Products_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Products_Var_Samp_Order_By>;
  variance?: InputMaybe<Products_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "products" */
export type Products_Arr_Rel_Insert_Input = {
  data: Array<Products_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_On_Conflict>;
};

/** aggregate avg on columns */
export type Products_Avg_Fields = {
  __typename?: 'products_avg_fields';
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_care_product_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "products" */
export type Products_Avg_Order_By = {
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type Products_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Bool_Exp>>;
  _not?: InputMaybe<Products_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Bool_Exp>>;
  all_crops?: InputMaybe<Boolean_Comparison_Exp>;
  care_product_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  operation_product_type?: InputMaybe<Operation_Product_Types_Bool_Exp>;
  polymorphic_ctype_id?: InputMaybe<Int_Comparison_Exp>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Bool_Exp>;
  products_pesticide?: InputMaybe<Products_Pesticide_Bool_Exp>;
  shared_care_product_id?: InputMaybe<Bigint_Comparison_Exp>;
  type_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "products" */
export enum Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductsPkey = 'products_pkey'
}

/** columns and relationships of "products_fertiliser" */
export type Products_Fertiliser = {
  __typename?: 'products_fertiliser';
  baseproduct_ptr_id: Scalars['uuid'];
  /** An array relationship */
  crop_fertilisers: Array<Crop_Fertilisers>;
  /** An aggregate relationship */
  crop_fertilisers_aggregate: Crop_Fertilisers_Aggregate;
  /** An array relationship */
  operations_applied_fertilisers: Array<Operations_Applied_Fertiliser>;
  /** An aggregate relationship */
  operations_applied_fertilisers_aggregate: Operations_Applied_Fertiliser_Aggregate;
  /** An object relationship */
  product: Products;
  /** An array relationship */
  products_fertiliser_contents: Array<Products_Fertiliser_Contents>;
  /** An aggregate relationship */
  products_fertiliser_contents_aggregate: Products_Fertiliser_Contents_Aggregate;
  /** An array relationship */
  products_fertiliser_units: Array<Products_Fertiliser_Units>;
  /** An aggregate relationship */
  products_fertiliser_units_aggregate: Products_Fertiliser_Units_Aggregate;
};


/** columns and relationships of "products_fertiliser" */
export type Products_FertiliserCrop_FertilisersArgs = {
  distinct_on?: InputMaybe<Array<Crop_Fertilisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Fertilisers_Order_By>>;
  where?: InputMaybe<Crop_Fertilisers_Bool_Exp>;
};


/** columns and relationships of "products_fertiliser" */
export type Products_FertiliserCrop_Fertilisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Fertilisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Fertilisers_Order_By>>;
  where?: InputMaybe<Crop_Fertilisers_Bool_Exp>;
};


/** columns and relationships of "products_fertiliser" */
export type Products_FertiliserOperations_Applied_FertilisersArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};


/** columns and relationships of "products_fertiliser" */
export type Products_FertiliserOperations_Applied_Fertilisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};


/** columns and relationships of "products_fertiliser" */
export type Products_FertiliserProducts_Fertiliser_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Contents_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
};


/** columns and relationships of "products_fertiliser" */
export type Products_FertiliserProducts_Fertiliser_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Contents_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
};


/** columns and relationships of "products_fertiliser" */
export type Products_FertiliserProducts_Fertiliser_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Units_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Units_Bool_Exp>;
};


/** columns and relationships of "products_fertiliser" */
export type Products_FertiliserProducts_Fertiliser_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Units_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Units_Bool_Exp>;
};

/** aggregated selection of "products_fertiliser" */
export type Products_Fertiliser_Aggregate = {
  __typename?: 'products_fertiliser_aggregate';
  aggregate?: Maybe<Products_Fertiliser_Aggregate_Fields>;
  nodes: Array<Products_Fertiliser>;
};

/** aggregate fields of "products_fertiliser" */
export type Products_Fertiliser_Aggregate_Fields = {
  __typename?: 'products_fertiliser_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Products_Fertiliser_Max_Fields>;
  min?: Maybe<Products_Fertiliser_Min_Fields>;
};


/** aggregate fields of "products_fertiliser" */
export type Products_Fertiliser_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Fertiliser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "products_fertiliser". All fields are combined with a logical 'AND'. */
export type Products_Fertiliser_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Fertiliser_Bool_Exp>>;
  _not?: InputMaybe<Products_Fertiliser_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Fertiliser_Bool_Exp>>;
  baseproduct_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
  crop_fertilisers?: InputMaybe<Crop_Fertilisers_Bool_Exp>;
  operations_applied_fertilisers?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  products_fertiliser_contents?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
  products_fertiliser_units?: InputMaybe<Products_Fertiliser_Units_Bool_Exp>;
};

/** unique or primary key constraints on table "products_fertiliser" */
export enum Products_Fertiliser_Constraint {
  /** unique or primary key constraint on columns "baseproduct_ptr_id" */
  ProductsFertiliserPkey = 'products_fertiliser_pkey'
}

/** columns and relationships of "products_fertiliser_contents" */
export type Products_Fertiliser_Contents = {
  __typename?: 'products_fertiliser_contents';
  amount?: Maybe<Scalars['float8']>;
  fertiliser_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  nutrient: Nutrients;
  nutrient_id: Scalars['uuid'];
  /** An object relationship */
  products_fertiliser: Products_Fertiliser;
};

/** aggregated selection of "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Aggregate = {
  __typename?: 'products_fertiliser_contents_aggregate';
  aggregate?: Maybe<Products_Fertiliser_Contents_Aggregate_Fields>;
  nodes: Array<Products_Fertiliser_Contents>;
};

/** aggregate fields of "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Aggregate_Fields = {
  __typename?: 'products_fertiliser_contents_aggregate_fields';
  avg?: Maybe<Products_Fertiliser_Contents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Products_Fertiliser_Contents_Max_Fields>;
  min?: Maybe<Products_Fertiliser_Contents_Min_Fields>;
  stddev?: Maybe<Products_Fertiliser_Contents_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Fertiliser_Contents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Fertiliser_Contents_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Fertiliser_Contents_Sum_Fields>;
  var_pop?: Maybe<Products_Fertiliser_Contents_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Fertiliser_Contents_Var_Samp_Fields>;
  variance?: Maybe<Products_Fertiliser_Contents_Variance_Fields>;
};


/** aggregate fields of "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Fertiliser_Contents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Aggregate_Order_By = {
  avg?: InputMaybe<Products_Fertiliser_Contents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Products_Fertiliser_Contents_Max_Order_By>;
  min?: InputMaybe<Products_Fertiliser_Contents_Min_Order_By>;
  stddev?: InputMaybe<Products_Fertiliser_Contents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Products_Fertiliser_Contents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Products_Fertiliser_Contents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Products_Fertiliser_Contents_Sum_Order_By>;
  var_pop?: InputMaybe<Products_Fertiliser_Contents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Products_Fertiliser_Contents_Var_Samp_Order_By>;
  variance?: InputMaybe<Products_Fertiliser_Contents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Arr_Rel_Insert_Input = {
  data: Array<Products_Fertiliser_Contents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_Fertiliser_Contents_On_Conflict>;
};

/** aggregate avg on columns */
export type Products_Fertiliser_Contents_Avg_Fields = {
  __typename?: 'products_fertiliser_contents_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "products_fertiliser_contents". All fields are combined with a logical 'AND'. */
export type Products_Fertiliser_Contents_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Fertiliser_Contents_Bool_Exp>>;
  _not?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Fertiliser_Contents_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  fertiliser_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  nutrient?: InputMaybe<Nutrients_Bool_Exp>;
  nutrient_id?: InputMaybe<Uuid_Comparison_Exp>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Bool_Exp>;
};

/** unique or primary key constraints on table "products_fertiliser_contents" */
export enum Products_Fertiliser_Contents_Constraint {
  /** unique or primary key constraint on columns "fertiliser_id", "nutrient_id" */
  ProductsFertiliserContFertiliserIdNutrientI_8ded9800Uniq = 'products_fertiliser_cont_fertiliser_id_nutrient_i_8ded9800_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductsFertiliserContentsPkey = 'products_fertiliser_contents_pkey'
}

/** input type for incrementing numeric columns in table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Insert_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  fertiliser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  nutrient?: InputMaybe<Nutrients_Obj_Rel_Insert_Input>;
  nutrient_id?: InputMaybe<Scalars['uuid']>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Products_Fertiliser_Contents_Max_Fields = {
  __typename?: 'products_fertiliser_contents_max_fields';
  amount?: Maybe<Scalars['float8']>;
  fertiliser_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  nutrient_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  fertiliser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nutrient_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Products_Fertiliser_Contents_Min_Fields = {
  __typename?: 'products_fertiliser_contents_min_fields';
  amount?: Maybe<Scalars['float8']>;
  fertiliser_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  nutrient_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  fertiliser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nutrient_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Mutation_Response = {
  __typename?: 'products_fertiliser_contents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products_Fertiliser_Contents>;
};

/** on_conflict condition type for table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_On_Conflict = {
  constraint: Products_Fertiliser_Contents_Constraint;
  update_columns?: Array<Products_Fertiliser_Contents_Update_Column>;
  where?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
};

/** Ordering options when selecting data from "products_fertiliser_contents". */
export type Products_Fertiliser_Contents_Order_By = {
  amount?: InputMaybe<Order_By>;
  fertiliser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  nutrient?: InputMaybe<Nutrients_Order_By>;
  nutrient_id?: InputMaybe<Order_By>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Order_By>;
};

/** primary key columns input for table: products_fertiliser_contents */
export type Products_Fertiliser_Contents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "products_fertiliser_contents" */
export enum Products_Fertiliser_Contents_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  FertiliserId = 'fertiliser_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  NutrientId = 'nutrient_id'
}

/** input type for updating data in table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Set_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  fertiliser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  nutrient_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Products_Fertiliser_Contents_Stddev_Fields = {
  __typename?: 'products_fertiliser_contents_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Products_Fertiliser_Contents_Stddev_Pop_Fields = {
  __typename?: 'products_fertiliser_contents_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Products_Fertiliser_Contents_Stddev_Samp_Fields = {
  __typename?: 'products_fertiliser_contents_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Fertiliser_Contents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Fertiliser_Contents_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  fertiliser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  nutrient_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Products_Fertiliser_Contents_Sum_Fields = {
  __typename?: 'products_fertiliser_contents_sum_fields';
  amount?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "products_fertiliser_contents" */
export enum Products_Fertiliser_Contents_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  FertiliserId = 'fertiliser_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  NutrientId = 'nutrient_id'
}

export type Products_Fertiliser_Contents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Products_Fertiliser_Contents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Fertiliser_Contents_Set_Input>;
  where: Products_Fertiliser_Contents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Products_Fertiliser_Contents_Var_Pop_Fields = {
  __typename?: 'products_fertiliser_contents_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Products_Fertiliser_Contents_Var_Samp_Fields = {
  __typename?: 'products_fertiliser_contents_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Products_Fertiliser_Contents_Variance_Fields = {
  __typename?: 'products_fertiliser_contents_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "products_fertiliser_contents" */
export type Products_Fertiliser_Contents_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "products_fertiliser" */
export type Products_Fertiliser_Insert_Input = {
  baseproduct_ptr_id?: InputMaybe<Scalars['uuid']>;
  crop_fertilisers?: InputMaybe<Crop_Fertilisers_Arr_Rel_Insert_Input>;
  operations_applied_fertilisers?: InputMaybe<Operations_Applied_Fertiliser_Arr_Rel_Insert_Input>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  products_fertiliser_contents?: InputMaybe<Products_Fertiliser_Contents_Arr_Rel_Insert_Input>;
  products_fertiliser_units?: InputMaybe<Products_Fertiliser_Units_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Products_Fertiliser_Max_Fields = {
  __typename?: 'products_fertiliser_max_fields';
  baseproduct_ptr_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Products_Fertiliser_Min_Fields = {
  __typename?: 'products_fertiliser_min_fields';
  baseproduct_ptr_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "products_fertiliser" */
export type Products_Fertiliser_Mutation_Response = {
  __typename?: 'products_fertiliser_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products_Fertiliser>;
};

/** input type for inserting object relation for remote table "products_fertiliser" */
export type Products_Fertiliser_Obj_Rel_Insert_Input = {
  data: Products_Fertiliser_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_Fertiliser_On_Conflict>;
};

/** on_conflict condition type for table "products_fertiliser" */
export type Products_Fertiliser_On_Conflict = {
  constraint: Products_Fertiliser_Constraint;
  update_columns?: Array<Products_Fertiliser_Update_Column>;
  where?: InputMaybe<Products_Fertiliser_Bool_Exp>;
};

/** Ordering options when selecting data from "products_fertiliser". */
export type Products_Fertiliser_Order_By = {
  baseproduct_ptr_id?: InputMaybe<Order_By>;
  crop_fertilisers_aggregate?: InputMaybe<Crop_Fertilisers_Aggregate_Order_By>;
  operations_applied_fertilisers_aggregate?: InputMaybe<Operations_Applied_Fertiliser_Aggregate_Order_By>;
  product?: InputMaybe<Products_Order_By>;
  products_fertiliser_contents_aggregate?: InputMaybe<Products_Fertiliser_Contents_Aggregate_Order_By>;
  products_fertiliser_units_aggregate?: InputMaybe<Products_Fertiliser_Units_Aggregate_Order_By>;
};

/** primary key columns input for table: products_fertiliser */
export type Products_Fertiliser_Pk_Columns_Input = {
  baseproduct_ptr_id: Scalars['uuid'];
};

/** select columns of table "products_fertiliser" */
export enum Products_Fertiliser_Select_Column {
  /** column name */
  BaseproductPtrId = 'baseproduct_ptr_id'
}

/** input type for updating data in table "products_fertiliser" */
export type Products_Fertiliser_Set_Input = {
  baseproduct_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "products_fertiliser" */
export type Products_Fertiliser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Fertiliser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Fertiliser_Stream_Cursor_Value_Input = {
  baseproduct_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "products_fertiliser_units" */
export type Products_Fertiliser_Units = {
  __typename?: 'products_fertiliser_units';
  fertiliser_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  products_fertiliser: Products_Fertiliser;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit: Array<Si_Unit>;
  unit_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "products_fertiliser_units" */
export type Products_Fertiliser_UnitsUnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Products_Fertiliser_Unitsunit>;
};

/** aggregated selection of "products_fertiliser_units" */
export type Products_Fertiliser_Units_Aggregate = {
  __typename?: 'products_fertiliser_units_aggregate';
  aggregate?: Maybe<Products_Fertiliser_Units_Aggregate_Fields>;
  nodes: Array<Products_Fertiliser_Units>;
};

/** aggregate fields of "products_fertiliser_units" */
export type Products_Fertiliser_Units_Aggregate_Fields = {
  __typename?: 'products_fertiliser_units_aggregate_fields';
  avg?: Maybe<Products_Fertiliser_Units_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Products_Fertiliser_Units_Max_Fields>;
  min?: Maybe<Products_Fertiliser_Units_Min_Fields>;
  stddev?: Maybe<Products_Fertiliser_Units_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Fertiliser_Units_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Fertiliser_Units_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Fertiliser_Units_Sum_Fields>;
  var_pop?: Maybe<Products_Fertiliser_Units_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Fertiliser_Units_Var_Samp_Fields>;
  variance?: Maybe<Products_Fertiliser_Units_Variance_Fields>;
};


/** aggregate fields of "products_fertiliser_units" */
export type Products_Fertiliser_Units_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Fertiliser_Units_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Aggregate_Order_By = {
  avg?: InputMaybe<Products_Fertiliser_Units_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Products_Fertiliser_Units_Max_Order_By>;
  min?: InputMaybe<Products_Fertiliser_Units_Min_Order_By>;
  stddev?: InputMaybe<Products_Fertiliser_Units_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Products_Fertiliser_Units_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Products_Fertiliser_Units_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Products_Fertiliser_Units_Sum_Order_By>;
  var_pop?: InputMaybe<Products_Fertiliser_Units_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Products_Fertiliser_Units_Var_Samp_Order_By>;
  variance?: InputMaybe<Products_Fertiliser_Units_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Arr_Rel_Insert_Input = {
  data: Array<Products_Fertiliser_Units_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_Fertiliser_Units_On_Conflict>;
};

/** aggregate avg on columns */
export type Products_Fertiliser_Units_Avg_Fields = {
  __typename?: 'products_fertiliser_units_avg_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Avg_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "products_fertiliser_units". All fields are combined with a logical 'AND'. */
export type Products_Fertiliser_Units_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Fertiliser_Units_Bool_Exp>>;
  _not?: InputMaybe<Products_Fertiliser_Units_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Fertiliser_Units_Bool_Exp>>;
  fertiliser_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Bool_Exp>;
  shared_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "products_fertiliser_units" */
export enum Products_Fertiliser_Units_Constraint {
  /** unique or primary key constraint on columns "fertiliser_id", "unit_id" */
  ProductsFertiliserUnitsFertiliserIdUnitId_84e46ebaUniq = 'products_fertiliser_units_fertiliser_id_unit_id_84e46eba_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductsFertiliserUnitsPkey = 'products_fertiliser_units_pkey'
}

/** input type for incrementing numeric columns in table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Inc_Input = {
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Insert_Input = {
  fertiliser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Obj_Rel_Insert_Input>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Products_Fertiliser_Units_Max_Fields = {
  __typename?: 'products_fertiliser_units_max_fields';
  fertiliser_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Max_Order_By = {
  fertiliser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Products_Fertiliser_Units_Min_Fields = {
  __typename?: 'products_fertiliser_units_min_fields';
  fertiliser_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Min_Order_By = {
  fertiliser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Mutation_Response = {
  __typename?: 'products_fertiliser_units_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products_Fertiliser_Units>;
};

/** on_conflict condition type for table "products_fertiliser_units" */
export type Products_Fertiliser_Units_On_Conflict = {
  constraint: Products_Fertiliser_Units_Constraint;
  update_columns?: Array<Products_Fertiliser_Units_Update_Column>;
  where?: InputMaybe<Products_Fertiliser_Units_Bool_Exp>;
};

/** Ordering options when selecting data from "products_fertiliser_units". */
export type Products_Fertiliser_Units_Order_By = {
  fertiliser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: products_fertiliser_units */
export type Products_Fertiliser_Units_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "products_fertiliser_units" */
export enum Products_Fertiliser_Units_Select_Column {
  /** column name */
  FertiliserId = 'fertiliser_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SharedUnitId = 'shared_unit_id',
  /** column name */
  UnitId = 'unit_id'
}

/** input type for updating data in table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Set_Input = {
  fertiliser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Products_Fertiliser_Units_Stddev_Fields = {
  __typename?: 'products_fertiliser_units_stddev_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Stddev_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Products_Fertiliser_Units_Stddev_Pop_Fields = {
  __typename?: 'products_fertiliser_units_stddev_pop_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Stddev_Pop_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Products_Fertiliser_Units_Stddev_Samp_Fields = {
  __typename?: 'products_fertiliser_units_stddev_samp_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Stddev_Samp_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Fertiliser_Units_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Fertiliser_Units_Stream_Cursor_Value_Input = {
  fertiliser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Products_Fertiliser_Units_Sum_Fields = {
  __typename?: 'products_fertiliser_units_sum_fields';
  shared_unit_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Sum_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** update columns of table "products_fertiliser_units" */
export enum Products_Fertiliser_Units_Update_Column {
  /** column name */
  FertiliserId = 'fertiliser_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SharedUnitId = 'shared_unit_id',
  /** column name */
  UnitId = 'unit_id'
}

export type Products_Fertiliser_Units_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Products_Fertiliser_Units_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Fertiliser_Units_Set_Input>;
  where: Products_Fertiliser_Units_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Products_Fertiliser_Units_Var_Pop_Fields = {
  __typename?: 'products_fertiliser_units_var_pop_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Var_Pop_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Products_Fertiliser_Units_Var_Samp_Fields = {
  __typename?: 'products_fertiliser_units_var_samp_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Var_Samp_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Products_Fertiliser_Units_Variance_Fields = {
  __typename?: 'products_fertiliser_units_variance_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "products_fertiliser_units" */
export type Products_Fertiliser_Units_Variance_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** update columns of table "products_fertiliser" */
export enum Products_Fertiliser_Update_Column {
  /** column name */
  BaseproductPtrId = 'baseproduct_ptr_id'
}

export type Products_Fertiliser_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Fertiliser_Set_Input>;
  where: Products_Fertiliser_Bool_Exp;
};

/** input type for incrementing numeric columns in table "products" */
export type Products_Inc_Input = {
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  shared_care_product_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "products" */
export type Products_Insert_Input = {
  all_crops?: InputMaybe<Scalars['Boolean']>;
  care_product_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  operation_product_type?: InputMaybe<Operation_Product_Types_Obj_Rel_Insert_Input>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Obj_Rel_Insert_Input>;
  products_pesticide?: InputMaybe<Products_Pesticide_Obj_Rel_Insert_Input>;
  shared_care_product_id?: InputMaybe<Scalars['bigint']>;
  type_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Products_Max_Fields = {
  __typename?: 'products_max_fields';
  care_product_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  manufacturer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  shared_care_product_id?: Maybe<Scalars['bigint']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "products" */
export type Products_Max_Order_By = {
  care_product_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Products_Min_Fields = {
  __typename?: 'products_min_fields';
  care_product_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  manufacturer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  shared_care_product_id?: Maybe<Scalars['bigint']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "products" */
export type Products_Min_Order_By = {
  care_product_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "products" */
export type Products_Mutation_Response = {
  __typename?: 'products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products>;
};

/** input type for inserting object relation for remote table "products" */
export type Products_Obj_Rel_Insert_Input = {
  data: Products_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_On_Conflict>;
};

/** on_conflict condition type for table "products" */
export type Products_On_Conflict = {
  constraint: Products_Constraint;
  update_columns?: Array<Products_Update_Column>;
  where?: InputMaybe<Products_Bool_Exp>;
};

/** Ordering options when selecting data from "products". */
export type Products_Order_By = {
  all_crops?: InputMaybe<Order_By>;
  care_product_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operation_product_type?: InputMaybe<Operation_Product_Types_Order_By>;
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  products_fertiliser?: InputMaybe<Products_Fertiliser_Order_By>;
  products_pesticide?: InputMaybe<Products_Pesticide_Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "products_pesticide" */
export type Products_Pesticide = {
  __typename?: 'products_pesticide';
  baseproduct_ptr_id: Scalars['uuid'];
  /** An array relationship */
  crop_pesticides: Array<Crop_Pesticides>;
  /** An aggregate relationship */
  crop_pesticides_aggregate: Crop_Pesticides_Aggregate;
  /** An array relationship */
  operations_applied_pesticides: Array<Operations_Applied_Pesticide>;
  /** An aggregate relationship */
  operations_applied_pesticides_aggregate: Operations_Applied_Pesticide_Aggregate;
  /** An object relationship */
  product: Products;
  /** An array relationship */
  products_pesticide_contents: Array<Products_Pesticide_Contents>;
  /** An aggregate relationship */
  products_pesticide_contents_aggregate: Products_Pesticide_Contents_Aggregate;
  /** An array relationship */
  products_pesticide_units: Array<Products_Pesticide_Units>;
  /** An aggregate relationship */
  products_pesticide_units_aggregate: Products_Pesticide_Units_Aggregate;
};


/** columns and relationships of "products_pesticide" */
export type Products_PesticideCrop_PesticidesArgs = {
  distinct_on?: InputMaybe<Array<Crop_Pesticides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Pesticides_Order_By>>;
  where?: InputMaybe<Crop_Pesticides_Bool_Exp>;
};


/** columns and relationships of "products_pesticide" */
export type Products_PesticideCrop_Pesticides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Pesticides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Pesticides_Order_By>>;
  where?: InputMaybe<Crop_Pesticides_Bool_Exp>;
};


/** columns and relationships of "products_pesticide" */
export type Products_PesticideOperations_Applied_PesticidesArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};


/** columns and relationships of "products_pesticide" */
export type Products_PesticideOperations_Applied_Pesticides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};


/** columns and relationships of "products_pesticide" */
export type Products_PesticideProducts_Pesticide_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Contents_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
};


/** columns and relationships of "products_pesticide" */
export type Products_PesticideProducts_Pesticide_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Contents_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
};


/** columns and relationships of "products_pesticide" */
export type Products_PesticideProducts_Pesticide_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Units_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Units_Bool_Exp>;
};


/** columns and relationships of "products_pesticide" */
export type Products_PesticideProducts_Pesticide_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Units_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Units_Bool_Exp>;
};

/** aggregated selection of "products_pesticide" */
export type Products_Pesticide_Aggregate = {
  __typename?: 'products_pesticide_aggregate';
  aggregate?: Maybe<Products_Pesticide_Aggregate_Fields>;
  nodes: Array<Products_Pesticide>;
};

/** aggregate fields of "products_pesticide" */
export type Products_Pesticide_Aggregate_Fields = {
  __typename?: 'products_pesticide_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Products_Pesticide_Max_Fields>;
  min?: Maybe<Products_Pesticide_Min_Fields>;
};


/** aggregate fields of "products_pesticide" */
export type Products_Pesticide_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Pesticide_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "products_pesticide". All fields are combined with a logical 'AND'. */
export type Products_Pesticide_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Pesticide_Bool_Exp>>;
  _not?: InputMaybe<Products_Pesticide_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Pesticide_Bool_Exp>>;
  baseproduct_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
  crop_pesticides?: InputMaybe<Crop_Pesticides_Bool_Exp>;
  operations_applied_pesticides?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  products_pesticide_contents?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
  products_pesticide_units?: InputMaybe<Products_Pesticide_Units_Bool_Exp>;
};

/** unique or primary key constraints on table "products_pesticide" */
export enum Products_Pesticide_Constraint {
  /** unique or primary key constraint on columns "baseproduct_ptr_id" */
  ProductsPesticidePkey = 'products_pesticide_pkey'
}

/** columns and relationships of "products_pesticide_contents" */
export type Products_Pesticide_Contents = {
  __typename?: 'products_pesticide_contents';
  /** An object relationship */
  active_ingredient: Active_Ingredient;
  active_ingredient_id: Scalars['uuid'];
  amount?: Maybe<Scalars['float8']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  pesticide_id: Scalars['uuid'];
  /** An object relationship */
  products_pesticide: Products_Pesticide;
};

/** aggregated selection of "products_pesticide_contents" */
export type Products_Pesticide_Contents_Aggregate = {
  __typename?: 'products_pesticide_contents_aggregate';
  aggregate?: Maybe<Products_Pesticide_Contents_Aggregate_Fields>;
  nodes: Array<Products_Pesticide_Contents>;
};

/** aggregate fields of "products_pesticide_contents" */
export type Products_Pesticide_Contents_Aggregate_Fields = {
  __typename?: 'products_pesticide_contents_aggregate_fields';
  avg?: Maybe<Products_Pesticide_Contents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Products_Pesticide_Contents_Max_Fields>;
  min?: Maybe<Products_Pesticide_Contents_Min_Fields>;
  stddev?: Maybe<Products_Pesticide_Contents_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Pesticide_Contents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Pesticide_Contents_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Pesticide_Contents_Sum_Fields>;
  var_pop?: Maybe<Products_Pesticide_Contents_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Pesticide_Contents_Var_Samp_Fields>;
  variance?: Maybe<Products_Pesticide_Contents_Variance_Fields>;
};


/** aggregate fields of "products_pesticide_contents" */
export type Products_Pesticide_Contents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Pesticide_Contents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Aggregate_Order_By = {
  avg?: InputMaybe<Products_Pesticide_Contents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Products_Pesticide_Contents_Max_Order_By>;
  min?: InputMaybe<Products_Pesticide_Contents_Min_Order_By>;
  stddev?: InputMaybe<Products_Pesticide_Contents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Products_Pesticide_Contents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Products_Pesticide_Contents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Products_Pesticide_Contents_Sum_Order_By>;
  var_pop?: InputMaybe<Products_Pesticide_Contents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Products_Pesticide_Contents_Var_Samp_Order_By>;
  variance?: InputMaybe<Products_Pesticide_Contents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Arr_Rel_Insert_Input = {
  data: Array<Products_Pesticide_Contents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_Pesticide_Contents_On_Conflict>;
};

/** aggregate avg on columns */
export type Products_Pesticide_Contents_Avg_Fields = {
  __typename?: 'products_pesticide_contents_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "products_pesticide_contents". All fields are combined with a logical 'AND'. */
export type Products_Pesticide_Contents_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Pesticide_Contents_Bool_Exp>>;
  _not?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Pesticide_Contents_Bool_Exp>>;
  active_ingredient?: InputMaybe<Active_Ingredient_Bool_Exp>;
  active_ingredient_id?: InputMaybe<Uuid_Comparison_Exp>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  pesticide_id?: InputMaybe<Uuid_Comparison_Exp>;
  products_pesticide?: InputMaybe<Products_Pesticide_Bool_Exp>;
};

/** unique or primary key constraints on table "products_pesticide_contents" */
export enum Products_Pesticide_Contents_Constraint {
  /** unique or primary key constraint on columns "pesticide_id", "active_ingredient_id" */
  ProductsPesticideContePesticideIdActiveIngr_68bcfa33Uniq = 'products_pesticide_conte_pesticide_id_active_ingr_68bcfa33_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductsPesticideContentsPkey = 'products_pesticide_contents_pkey'
}

/** input type for incrementing numeric columns in table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Insert_Input = {
  active_ingredient?: InputMaybe<Active_Ingredient_Obj_Rel_Insert_Input>;
  active_ingredient_id?: InputMaybe<Scalars['uuid']>;
  amount?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  pesticide_id?: InputMaybe<Scalars['uuid']>;
  products_pesticide?: InputMaybe<Products_Pesticide_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Products_Pesticide_Contents_Max_Fields = {
  __typename?: 'products_pesticide_contents_max_fields';
  active_ingredient_id?: Maybe<Scalars['uuid']>;
  amount?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  pesticide_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Max_Order_By = {
  active_ingredient_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pesticide_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Products_Pesticide_Contents_Min_Fields = {
  __typename?: 'products_pesticide_contents_min_fields';
  active_ingredient_id?: Maybe<Scalars['uuid']>;
  amount?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  pesticide_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Min_Order_By = {
  active_ingredient_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pesticide_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Mutation_Response = {
  __typename?: 'products_pesticide_contents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products_Pesticide_Contents>;
};

/** on_conflict condition type for table "products_pesticide_contents" */
export type Products_Pesticide_Contents_On_Conflict = {
  constraint: Products_Pesticide_Contents_Constraint;
  update_columns?: Array<Products_Pesticide_Contents_Update_Column>;
  where?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
};

/** Ordering options when selecting data from "products_pesticide_contents". */
export type Products_Pesticide_Contents_Order_By = {
  active_ingredient?: InputMaybe<Active_Ingredient_Order_By>;
  active_ingredient_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  pesticide_id?: InputMaybe<Order_By>;
  products_pesticide?: InputMaybe<Products_Pesticide_Order_By>;
};

/** primary key columns input for table: products_pesticide_contents */
export type Products_Pesticide_Contents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "products_pesticide_contents" */
export enum Products_Pesticide_Contents_Select_Column {
  /** column name */
  ActiveIngredientId = 'active_ingredient_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PesticideId = 'pesticide_id'
}

/** input type for updating data in table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Set_Input = {
  active_ingredient_id?: InputMaybe<Scalars['uuid']>;
  amount?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  pesticide_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Products_Pesticide_Contents_Stddev_Fields = {
  __typename?: 'products_pesticide_contents_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Products_Pesticide_Contents_Stddev_Pop_Fields = {
  __typename?: 'products_pesticide_contents_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Products_Pesticide_Contents_Stddev_Samp_Fields = {
  __typename?: 'products_pesticide_contents_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Pesticide_Contents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Pesticide_Contents_Stream_Cursor_Value_Input = {
  active_ingredient_id?: InputMaybe<Scalars['uuid']>;
  amount?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  pesticide_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Products_Pesticide_Contents_Sum_Fields = {
  __typename?: 'products_pesticide_contents_sum_fields';
  amount?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "products_pesticide_contents" */
export enum Products_Pesticide_Contents_Update_Column {
  /** column name */
  ActiveIngredientId = 'active_ingredient_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PesticideId = 'pesticide_id'
}

export type Products_Pesticide_Contents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Products_Pesticide_Contents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Pesticide_Contents_Set_Input>;
  where: Products_Pesticide_Contents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Products_Pesticide_Contents_Var_Pop_Fields = {
  __typename?: 'products_pesticide_contents_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Products_Pesticide_Contents_Var_Samp_Fields = {
  __typename?: 'products_pesticide_contents_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Products_Pesticide_Contents_Variance_Fields = {
  __typename?: 'products_pesticide_contents_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "products_pesticide_contents" */
export type Products_Pesticide_Contents_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "products_pesticide" */
export type Products_Pesticide_Insert_Input = {
  baseproduct_ptr_id?: InputMaybe<Scalars['uuid']>;
  crop_pesticides?: InputMaybe<Crop_Pesticides_Arr_Rel_Insert_Input>;
  operations_applied_pesticides?: InputMaybe<Operations_Applied_Pesticide_Arr_Rel_Insert_Input>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  products_pesticide_contents?: InputMaybe<Products_Pesticide_Contents_Arr_Rel_Insert_Input>;
  products_pesticide_units?: InputMaybe<Products_Pesticide_Units_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Products_Pesticide_Max_Fields = {
  __typename?: 'products_pesticide_max_fields';
  baseproduct_ptr_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Products_Pesticide_Min_Fields = {
  __typename?: 'products_pesticide_min_fields';
  baseproduct_ptr_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "products_pesticide" */
export type Products_Pesticide_Mutation_Response = {
  __typename?: 'products_pesticide_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products_Pesticide>;
};

/** input type for inserting object relation for remote table "products_pesticide" */
export type Products_Pesticide_Obj_Rel_Insert_Input = {
  data: Products_Pesticide_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_Pesticide_On_Conflict>;
};

/** on_conflict condition type for table "products_pesticide" */
export type Products_Pesticide_On_Conflict = {
  constraint: Products_Pesticide_Constraint;
  update_columns?: Array<Products_Pesticide_Update_Column>;
  where?: InputMaybe<Products_Pesticide_Bool_Exp>;
};

/** Ordering options when selecting data from "products_pesticide". */
export type Products_Pesticide_Order_By = {
  baseproduct_ptr_id?: InputMaybe<Order_By>;
  crop_pesticides_aggregate?: InputMaybe<Crop_Pesticides_Aggregate_Order_By>;
  operations_applied_pesticides_aggregate?: InputMaybe<Operations_Applied_Pesticide_Aggregate_Order_By>;
  product?: InputMaybe<Products_Order_By>;
  products_pesticide_contents_aggregate?: InputMaybe<Products_Pesticide_Contents_Aggregate_Order_By>;
  products_pesticide_units_aggregate?: InputMaybe<Products_Pesticide_Units_Aggregate_Order_By>;
};

/** primary key columns input for table: products_pesticide */
export type Products_Pesticide_Pk_Columns_Input = {
  baseproduct_ptr_id: Scalars['uuid'];
};

/** select columns of table "products_pesticide" */
export enum Products_Pesticide_Select_Column {
  /** column name */
  BaseproductPtrId = 'baseproduct_ptr_id'
}

/** input type for updating data in table "products_pesticide" */
export type Products_Pesticide_Set_Input = {
  baseproduct_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "products_pesticide" */
export type Products_Pesticide_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Pesticide_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Pesticide_Stream_Cursor_Value_Input = {
  baseproduct_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "products_pesticide_units" */
export type Products_Pesticide_Units = {
  __typename?: 'products_pesticide_units';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  pesticide_id: Scalars['uuid'];
  /** An object relationship */
  products_pesticide: Products_Pesticide;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit: Array<Si_Unit>;
  unit_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "products_pesticide_units" */
export type Products_Pesticide_UnitsUnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Products_Pesticide_Unitsunit>;
};

/** aggregated selection of "products_pesticide_units" */
export type Products_Pesticide_Units_Aggregate = {
  __typename?: 'products_pesticide_units_aggregate';
  aggregate?: Maybe<Products_Pesticide_Units_Aggregate_Fields>;
  nodes: Array<Products_Pesticide_Units>;
};

/** aggregate fields of "products_pesticide_units" */
export type Products_Pesticide_Units_Aggregate_Fields = {
  __typename?: 'products_pesticide_units_aggregate_fields';
  avg?: Maybe<Products_Pesticide_Units_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Products_Pesticide_Units_Max_Fields>;
  min?: Maybe<Products_Pesticide_Units_Min_Fields>;
  stddev?: Maybe<Products_Pesticide_Units_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Pesticide_Units_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Pesticide_Units_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Pesticide_Units_Sum_Fields>;
  var_pop?: Maybe<Products_Pesticide_Units_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Pesticide_Units_Var_Samp_Fields>;
  variance?: Maybe<Products_Pesticide_Units_Variance_Fields>;
};


/** aggregate fields of "products_pesticide_units" */
export type Products_Pesticide_Units_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Pesticide_Units_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "products_pesticide_units" */
export type Products_Pesticide_Units_Aggregate_Order_By = {
  avg?: InputMaybe<Products_Pesticide_Units_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Products_Pesticide_Units_Max_Order_By>;
  min?: InputMaybe<Products_Pesticide_Units_Min_Order_By>;
  stddev?: InputMaybe<Products_Pesticide_Units_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Products_Pesticide_Units_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Products_Pesticide_Units_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Products_Pesticide_Units_Sum_Order_By>;
  var_pop?: InputMaybe<Products_Pesticide_Units_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Products_Pesticide_Units_Var_Samp_Order_By>;
  variance?: InputMaybe<Products_Pesticide_Units_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "products_pesticide_units" */
export type Products_Pesticide_Units_Arr_Rel_Insert_Input = {
  data: Array<Products_Pesticide_Units_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_Pesticide_Units_On_Conflict>;
};

/** aggregate avg on columns */
export type Products_Pesticide_Units_Avg_Fields = {
  __typename?: 'products_pesticide_units_avg_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "products_pesticide_units" */
export type Products_Pesticide_Units_Avg_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "products_pesticide_units". All fields are combined with a logical 'AND'. */
export type Products_Pesticide_Units_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Pesticide_Units_Bool_Exp>>;
  _not?: InputMaybe<Products_Pesticide_Units_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Pesticide_Units_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  pesticide_id?: InputMaybe<Uuid_Comparison_Exp>;
  products_pesticide?: InputMaybe<Products_Pesticide_Bool_Exp>;
  shared_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "products_pesticide_units" */
export enum Products_Pesticide_Units_Constraint {
  /** unique or primary key constraint on columns "pesticide_id", "unit_id" */
  ProductsPesticideUnitsPesticideIdUnitIdE51be96cUniq = 'products_pesticide_units_pesticide_id_unit_id_e51be96c_uniq',
  /** unique or primary key constraint on columns "id" */
  ProductsPesticideUnitsPkey = 'products_pesticide_units_pkey'
}

/** input type for incrementing numeric columns in table "products_pesticide_units" */
export type Products_Pesticide_Units_Inc_Input = {
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "products_pesticide_units" */
export type Products_Pesticide_Units_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  pesticide_id?: InputMaybe<Scalars['uuid']>;
  products_pesticide?: InputMaybe<Products_Pesticide_Obj_Rel_Insert_Input>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Products_Pesticide_Units_Max_Fields = {
  __typename?: 'products_pesticide_units_max_fields';
  id?: Maybe<Scalars['uuid']>;
  pesticide_id?: Maybe<Scalars['uuid']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "products_pesticide_units" */
export type Products_Pesticide_Units_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  pesticide_id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Products_Pesticide_Units_Min_Fields = {
  __typename?: 'products_pesticide_units_min_fields';
  id?: Maybe<Scalars['uuid']>;
  pesticide_id?: Maybe<Scalars['uuid']>;
  shared_unit_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "products_pesticide_units" */
export type Products_Pesticide_Units_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  pesticide_id?: InputMaybe<Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "products_pesticide_units" */
export type Products_Pesticide_Units_Mutation_Response = {
  __typename?: 'products_pesticide_units_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products_Pesticide_Units>;
};

/** on_conflict condition type for table "products_pesticide_units" */
export type Products_Pesticide_Units_On_Conflict = {
  constraint: Products_Pesticide_Units_Constraint;
  update_columns?: Array<Products_Pesticide_Units_Update_Column>;
  where?: InputMaybe<Products_Pesticide_Units_Bool_Exp>;
};

/** Ordering options when selecting data from "products_pesticide_units". */
export type Products_Pesticide_Units_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  pesticide_id?: InputMaybe<Order_By>;
  products_pesticide?: InputMaybe<Products_Pesticide_Order_By>;
  shared_unit_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: products_pesticide_units */
export type Products_Pesticide_Units_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "products_pesticide_units" */
export enum Products_Pesticide_Units_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PesticideId = 'pesticide_id',
  /** column name */
  SharedUnitId = 'shared_unit_id',
  /** column name */
  UnitId = 'unit_id'
}

/** input type for updating data in table "products_pesticide_units" */
export type Products_Pesticide_Units_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  pesticide_id?: InputMaybe<Scalars['uuid']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Products_Pesticide_Units_Stddev_Fields = {
  __typename?: 'products_pesticide_units_stddev_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "products_pesticide_units" */
export type Products_Pesticide_Units_Stddev_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Products_Pesticide_Units_Stddev_Pop_Fields = {
  __typename?: 'products_pesticide_units_stddev_pop_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "products_pesticide_units" */
export type Products_Pesticide_Units_Stddev_Pop_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Products_Pesticide_Units_Stddev_Samp_Fields = {
  __typename?: 'products_pesticide_units_stddev_samp_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "products_pesticide_units" */
export type Products_Pesticide_Units_Stddev_Samp_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "products_pesticide_units" */
export type Products_Pesticide_Units_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Pesticide_Units_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Pesticide_Units_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  pesticide_id?: InputMaybe<Scalars['uuid']>;
  shared_unit_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Products_Pesticide_Units_Sum_Fields = {
  __typename?: 'products_pesticide_units_sum_fields';
  shared_unit_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "products_pesticide_units" */
export type Products_Pesticide_Units_Sum_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** update columns of table "products_pesticide_units" */
export enum Products_Pesticide_Units_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PesticideId = 'pesticide_id',
  /** column name */
  SharedUnitId = 'shared_unit_id',
  /** column name */
  UnitId = 'unit_id'
}

export type Products_Pesticide_Units_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Products_Pesticide_Units_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Pesticide_Units_Set_Input>;
  where: Products_Pesticide_Units_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Products_Pesticide_Units_Var_Pop_Fields = {
  __typename?: 'products_pesticide_units_var_pop_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "products_pesticide_units" */
export type Products_Pesticide_Units_Var_Pop_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Products_Pesticide_Units_Var_Samp_Fields = {
  __typename?: 'products_pesticide_units_var_samp_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "products_pesticide_units" */
export type Products_Pesticide_Units_Var_Samp_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Products_Pesticide_Units_Variance_Fields = {
  __typename?: 'products_pesticide_units_variance_fields';
  shared_unit_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "products_pesticide_units" */
export type Products_Pesticide_Units_Variance_Order_By = {
  shared_unit_id?: InputMaybe<Order_By>;
};

/** update columns of table "products_pesticide" */
export enum Products_Pesticide_Update_Column {
  /** column name */
  BaseproductPtrId = 'baseproduct_ptr_id'
}

export type Products_Pesticide_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Pesticide_Set_Input>;
  where: Products_Pesticide_Bool_Exp;
};

/** primary key columns input for table: products */
export type Products_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "products" */
export enum Products_Select_Column {
  /** column name */
  AllCrops = 'all_crops',
  /** column name */
  CareProductId = 'care_product_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  Name = 'name',
  /** column name */
  PolymorphicCtypeId = 'polymorphic_ctype_id',
  /** column name */
  SharedCareProductId = 'shared_care_product_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "products" */
export type Products_Set_Input = {
  all_crops?: InputMaybe<Scalars['Boolean']>;
  care_product_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  shared_care_product_id?: InputMaybe<Scalars['bigint']>;
  type_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Products_Stddev_Fields = {
  __typename?: 'products_stddev_fields';
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_care_product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "products" */
export type Products_Stddev_Order_By = {
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Products_Stddev_Pop_Fields = {
  __typename?: 'products_stddev_pop_fields';
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_care_product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "products" */
export type Products_Stddev_Pop_Order_By = {
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Products_Stddev_Samp_Fields = {
  __typename?: 'products_stddev_samp_fields';
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_care_product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "products" */
export type Products_Stddev_Samp_Order_By = {
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "products" */
export type Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Stream_Cursor_Value_Input = {
  all_crops?: InputMaybe<Scalars['Boolean']>;
  care_product_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  polymorphic_ctype_id?: InputMaybe<Scalars['Int']>;
  shared_care_product_id?: InputMaybe<Scalars['bigint']>;
  type_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Products_Sum_Fields = {
  __typename?: 'products_sum_fields';
  polymorphic_ctype_id?: Maybe<Scalars['Int']>;
  shared_care_product_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "products" */
export type Products_Sum_Order_By = {
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
};

/** update columns of table "products" */
export enum Products_Update_Column {
  /** column name */
  AllCrops = 'all_crops',
  /** column name */
  CareProductId = 'care_product_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  Name = 'name',
  /** column name */
  PolymorphicCtypeId = 'polymorphic_ctype_id',
  /** column name */
  SharedCareProductId = 'shared_care_product_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Set_Input>;
  where: Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Products_Var_Pop_Fields = {
  __typename?: 'products_var_pop_fields';
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_care_product_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "products" */
export type Products_Var_Pop_Order_By = {
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Products_Var_Samp_Fields = {
  __typename?: 'products_var_samp_fields';
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_care_product_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "products" */
export type Products_Var_Samp_Order_By = {
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Products_Variance_Fields = {
  __typename?: 'products_variance_fields';
  polymorphic_ctype_id?: Maybe<Scalars['Float']>;
  shared_care_product_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "products" */
export type Products_Variance_Order_By = {
  polymorphic_ctype_id?: InputMaybe<Order_By>;
  shared_care_product_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "provider" */
export type Provider = {
  __typename?: 'provider';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "provider" */
export type Provider_Aggregate = {
  __typename?: 'provider_aggregate';
  aggregate?: Maybe<Provider_Aggregate_Fields>;
  nodes: Array<Provider>;
};

/** aggregate fields of "provider" */
export type Provider_Aggregate_Fields = {
  __typename?: 'provider_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Provider_Max_Fields>;
  min?: Maybe<Provider_Min_Fields>;
};


/** aggregate fields of "provider" */
export type Provider_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "provider". All fields are combined with a logical 'AND'. */
export type Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Bool_Exp>>;
  _not?: InputMaybe<Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "provider" */
export enum Provider_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProviderNameKey = 'provider_name_key',
  /** unique or primary key constraint on columns "id" */
  ProviderPkey = 'provider_pkey'
}

/** input type for inserting data into table "provider" */
export type Provider_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Provider_Max_Fields = {
  __typename?: 'provider_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Provider_Min_Fields = {
  __typename?: 'provider_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "provider" */
export type Provider_Mutation_Response = {
  __typename?: 'provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider>;
};

/** input type for inserting object relation for remote table "provider" */
export type Provider_Obj_Rel_Insert_Input = {
  data: Provider_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_On_Conflict>;
};

/** on_conflict condition type for table "provider" */
export type Provider_On_Conflict = {
  constraint: Provider_Constraint;
  update_columns?: Array<Provider_Update_Column>;
  where?: InputMaybe<Provider_Bool_Exp>;
};

/** Ordering options when selecting data from "provider". */
export type Provider_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: provider */
export type Provider_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "provider" */
export enum Provider_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "provider" */
export type Provider_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "provider" */
export type Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "provider" */
export enum Provider_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Provider_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Set_Input>;
  where: Provider_Bool_Exp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "action_log" */
  action_log: Array<Action_Log>;
  /** fetch aggregated fields from the table: "action_log" */
  action_log_aggregate: Action_Log_Aggregate;
  /** fetch data from the table: "action_log" using primary key columns */
  action_log_by_pk?: Maybe<Action_Log>;
  /** fetch data from the table: "active_ingredient" */
  active_ingredient: Array<Active_Ingredient>;
  /** fetch aggregated fields from the table: "active_ingredient" */
  active_ingredient_aggregate: Active_Ingredient_Aggregate;
  /** fetch data from the table: "active_ingredient" using primary key columns */
  active_ingredient_by_pk?: Maybe<Active_Ingredient>;
  /** fetch data from the table: "actual_reading" */
  actual_reading: Array<Actual_Reading>;
  /** fetch aggregated fields from the table: "actual_reading" */
  actual_reading_aggregate: Actual_Reading_Aggregate;
  /** fetch data from the table: "actual_reading" using primary key columns */
  actual_reading_by_pk?: Maybe<Actual_Reading>;
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table: "advice_author_followers" */
  advice_author_followers: Array<Advice_Author_Followers>;
  /** fetch aggregated fields from the table: "advice_author_followers" */
  advice_author_followers_aggregate: Advice_Author_Followers_Aggregate;
  /** fetch data from the table: "advice_author_followers" using primary key columns */
  advice_author_followers_by_pk?: Maybe<Advice_Author_Followers>;
  /** An array relationship */
  advice_authors: Array<Advice_Authors>;
  /** An aggregate relationship */
  advice_authors_aggregate: Advice_Authors_Aggregate;
  /** fetch data from the table: "advice_authors" using primary key columns */
  advice_authors_by_pk?: Maybe<Advice_Authors>;
  advice_categories?: Maybe<Array<Maybe<AdviceCategory>>>;
  /** fetch data from the table: "agent" */
  agent: Array<Agent>;
  /** fetch aggregated fields from the table: "agent" */
  agent_aggregate: Agent_Aggregate;
  /** fetch data from the table: "agent" using primary key columns */
  agent_by_pk?: Maybe<Agent>;
  /** fetch data from the table: "agent_company" */
  agent_company: Array<Agent_Company>;
  /** fetch aggregated fields from the table: "agent_company" */
  agent_company_aggregate: Agent_Company_Aggregate;
  /** fetch data from the table: "agent_company" using primary key columns */
  agent_company_by_pk?: Maybe<Agent_Company>;
  agronomist_plot_crop_diary_by_id?: Maybe<AgronomistPlotCropDiaryType>;
  agronomist_plot_crop_diary_list?: Maybe<AgronomistPlotCropDiaryList>;
  all_bookings?: Maybe<Array<Maybe<BookingGlType>>>;
  all_distribution_centres?: Maybe<Array<Maybe<DistributionCentreGlType>>>;
  all_docks?: Maybe<Array<Maybe<DockGlType>>>;
  all_inwards?: Maybe<Array<Maybe<InwardGlType>>>;
  all_my_orders?: Maybe<Array<Maybe<OrderGlType>>>;
  all_my_plot_summarys?: Maybe<Array<Maybe<PlotCommodityGlType>>>;
  all_sellable_item_stocks?: Maybe<Array<Maybe<SellableItemStockGlType>>>;
  all_trips?: Maybe<Array<Maybe<TripGlType>>>;
  all_vehicles?: Maybe<Array<Maybe<VehicleGlType>>>;
  /** fetch data from the table: "answer_choice" */
  answer_choice: Array<Answer_Choice>;
  /** fetch aggregated fields from the table: "answer_choice" */
  answer_choice_aggregate: Answer_Choice_Aggregate;
  /** fetch data from the table: "answer_choice" using primary key columns */
  answer_choice_by_pk?: Maybe<Answer_Choice>;
  /** fetch data from the table: "application_product_unit" */
  application_product_unit: Array<Application_Product_Unit>;
  /** fetch aggregated fields from the table: "application_product_unit" */
  application_product_unit_aggregate: Application_Product_Unit_Aggregate;
  /** fetch data from the table: "application_product_unit" using primary key columns */
  application_product_unit_by_pk?: Maybe<Application_Product_Unit>;
  /** fetch data from the table: "article" */
  article: Array<Article>;
  /** fetch aggregated fields from the table: "article" */
  article_aggregate: Article_Aggregate;
  /** An array relationship */
  article_attachments: Array<Article_Attachments>;
  /** An aggregate relationship */
  article_attachments_aggregate: Article_Attachments_Aggregate;
  /** fetch data from the table: "article_attachments" using primary key columns */
  article_attachments_by_pk?: Maybe<Article_Attachments>;
  /** fetch data from the table: "article_author_favorite_insights" */
  article_author_favorite_insights: Array<Article_Author_Favorite_Insights>;
  /** fetch aggregated fields from the table: "article_author_favorite_insights" */
  article_author_favorite_insights_aggregate: Article_Author_Favorite_Insights_Aggregate;
  /** fetch data from the table: "article_author_like_insights" */
  article_author_like_insights: Array<Article_Author_Like_Insights>;
  /** fetch aggregated fields from the table: "article_author_like_insights" */
  article_author_like_insights_aggregate: Article_Author_Like_Insights_Aggregate;
  /** fetch data from the table: "article_author_view_insights" */
  article_author_view_insights: Array<Article_Author_View_Insights>;
  /** fetch aggregated fields from the table: "article_author_view_insights" */
  article_author_view_insights_aggregate: Article_Author_View_Insights_Aggregate;
  /** An array relationship */
  article_authors: Array<Article_Authors>;
  /** An aggregate relationship */
  article_authors_aggregate: Article_Authors_Aggregate;
  /** fetch data from the table: "article_authors" using primary key columns */
  article_authors_by_pk?: Maybe<Article_Authors>;
  /** fetch data from the table: "article" using primary key columns */
  article_by_pk?: Maybe<Article>;
  /** An array relationship */
  article_categories: Array<Article_Categories>;
  /** An aggregate relationship */
  article_categories_aggregate: Article_Categories_Aggregate;
  /** fetch data from the table: "article_categories" using primary key columns */
  article_categories_by_pk?: Maybe<Article_Categories>;
  /** fetch data from the table: "article_category" */
  article_category: Array<Article_Category>;
  /** fetch aggregated fields from the table: "article_category" */
  article_category_aggregate: Article_Category_Aggregate;
  /** fetch data from the table: "article_category" using primary key columns */
  article_category_by_pk?: Maybe<Article_Category>;
  /** An array relationship */
  article_crop_categories: Array<Article_Crop_Categories>;
  /** An aggregate relationship */
  article_crop_categories_aggregate: Article_Crop_Categories_Aggregate;
  /** fetch data from the table: "article_crop_categories" using primary key columns */
  article_crop_categories_by_pk?: Maybe<Article_Crop_Categories>;
  article_crop_list?: Maybe<Array<Maybe<CropList>>>;
  /** An array relationship */
  article_crop_varieties: Array<Article_Crop_Varieties>;
  /** An aggregate relationship */
  article_crop_varieties_aggregate: Article_Crop_Varieties_Aggregate;
  /** fetch data from the table: "article_crop_varieties" using primary key columns */
  article_crop_varieties_by_pk?: Maybe<Article_Crop_Varieties>;
  /** An array relationship */
  article_crops: Array<Article_Crops>;
  /** An aggregate relationship */
  article_crops_aggregate: Article_Crops_Aggregate;
  /** fetch data from the table: "article_crops" using primary key columns */
  article_crops_by_pk?: Maybe<Article_Crops>;
  article_detail_trending_metrics?: Maybe<ArticleDetailTrendingMetrics>;
  article_details?: Maybe<ArticleDetail>;
  /** fetch data from the table: "article_favorite_insights" */
  article_favorite_insights: Array<Article_Favorite_Insights>;
  /** fetch aggregated fields from the table: "article_favorite_insights" */
  article_favorite_insights_aggregate: Article_Favorite_Insights_Aggregate;
  /** An array relationship */
  article_favorites: Array<Article_Favorites>;
  /** An aggregate relationship */
  article_favorites_aggregate: Article_Favorites_Aggregate;
  /** fetch data from the table: "article_favorites" using primary key columns */
  article_favorites_by_pk?: Maybe<Article_Favorites>;
  /** fetch data from the table: "article_like_insights" */
  article_like_insights: Array<Article_Like_Insights>;
  /** fetch aggregated fields from the table: "article_like_insights" */
  article_like_insights_aggregate: Article_Like_Insights_Aggregate;
  /** fetch data from the table: "article_likes" */
  article_likes: Array<Article_Likes>;
  /** fetch aggregated fields from the table: "article_likes" */
  article_likes_aggregate: Article_Likes_Aggregate;
  /** fetch data from the table: "article_likes" using primary key columns */
  article_likes_by_pk?: Maybe<Article_Likes>;
  article_list?: Maybe<ArticleList>;
  /** An array relationship */
  article_regions: Array<Article_Regions>;
  /** An aggregate relationship */
  article_regions_aggregate: Article_Regions_Aggregate;
  /** fetch data from the table: "article_regions" using primary key columns */
  article_regions_by_pk?: Maybe<Article_Regions>;
  /** An array relationship */
  article_series: Array<Article_Series>;
  /** An aggregate relationship */
  article_series_aggregate: Article_Series_Aggregate;
  /** fetch data from the table: "article_series" using primary key columns */
  article_series_by_pk?: Maybe<Article_Series>;
  /** fetch data from the table: "article_series_favourite_insights" */
  article_series_favourite_insights: Array<Article_Series_Favourite_Insights>;
  /** fetch aggregated fields from the table: "article_series_favourite_insights" */
  article_series_favourite_insights_aggregate: Article_Series_Favourite_Insights_Aggregate;
  /** fetch data from the table: "article_series_like_insights" */
  article_series_like_insights: Array<Article_Series_Like_Insights>;
  /** fetch aggregated fields from the table: "article_series_like_insights" */
  article_series_like_insights_aggregate: Article_Series_Like_Insights_Aggregate;
  /** fetch data from the table: "article_series_view_insights" */
  article_series_view_insights: Array<Article_Series_View_Insights>;
  /** fetch aggregated fields from the table: "article_series_view_insights" */
  article_series_view_insights_aggregate: Article_Series_View_Insights_Aggregate;
  /** fetch data from the table: "article_subscription_favorite_insights" */
  article_subscription_favorite_insights: Array<Article_Subscription_Favorite_Insights>;
  /** fetch aggregated fields from the table: "article_subscription_favorite_insights" */
  article_subscription_favorite_insights_aggregate: Article_Subscription_Favorite_Insights_Aggregate;
  /** fetch data from the table: "article_subscription_like_insights" */
  article_subscription_like_insights: Array<Article_Subscription_Like_Insights>;
  /** fetch aggregated fields from the table: "article_subscription_like_insights" */
  article_subscription_like_insights_aggregate: Article_Subscription_Like_Insights_Aggregate;
  /** fetch data from the table: "article_subscription_package" */
  article_subscription_package: Array<Article_Subscription_Package>;
  /** fetch aggregated fields from the table: "article_subscription_package" */
  article_subscription_package_aggregate: Article_Subscription_Package_Aggregate;
  /** fetch data from the table: "article_subscription_package" using primary key columns */
  article_subscription_package_by_pk?: Maybe<Article_Subscription_Package>;
  /** fetch data from the table: "article_subscription_view_insights" */
  article_subscription_view_insights: Array<Article_Subscription_View_Insights>;
  /** fetch aggregated fields from the table: "article_subscription_view_insights" */
  article_subscription_view_insights_aggregate: Article_Subscription_View_Insights_Aggregate;
  /** An array relationship */
  article_subscriptions: Array<Article_Subscriptions>;
  /** An aggregate relationship */
  article_subscriptions_aggregate: Article_Subscriptions_Aggregate;
  /** fetch data from the table: "article_subscriptions" using primary key columns */
  article_subscriptions_by_pk?: Maybe<Article_Subscriptions>;
  /** fetch data from the table: "article_user_group" */
  article_user_group: Array<Article_User_Group>;
  /** fetch aggregated fields from the table: "article_user_group" */
  article_user_group_aggregate: Article_User_Group_Aggregate;
  /** fetch data from the table: "article_user_group" using primary key columns */
  article_user_group_by_pk?: Maybe<Article_User_Group>;
  /** fetch data from the table: "article_view_insights" */
  article_view_insights: Array<Article_View_Insights>;
  /** fetch aggregated fields from the table: "article_view_insights" */
  article_view_insights_aggregate: Article_View_Insights_Aggregate;
  /** fetch data from the table: "article_views" */
  article_views: Array<Article_Views>;
  /** fetch aggregated fields from the table: "article_views" */
  article_views_aggregate: Article_Views_Aggregate;
  /** fetch data from the table: "article_views" using primary key columns */
  article_views_by_pk?: Maybe<Article_Views>;
  articles_in_progress?: Maybe<Array<Maybe<ArticlesInProgress>>>;
  /** fetch data from the table: "assessment" */
  assessment: Array<Assessment>;
  /** fetch aggregated fields from the table: "assessment" */
  assessment_aggregate: Assessment_Aggregate;
  /** fetch data from the table: "assessment" using primary key columns */
  assessment_by_pk?: Maybe<Assessment>;
  /** fetch data from the table: "assessment_question" */
  assessment_question: Array<Assessment_Question>;
  /** fetch aggregated fields from the table: "assessment_question" */
  assessment_question_aggregate: Assessment_Question_Aggregate;
  /** fetch data from the table: "assessment_question" using primary key columns */
  assessment_question_by_pk?: Maybe<Assessment_Question>;
  /** fetch data from the table: "attribute" */
  attribute: Array<Attribute>;
  /** fetch aggregated fields from the table: "attribute" */
  attribute_aggregate: Attribute_Aggregate;
  /** fetch data from the table: "attribute" using primary key columns */
  attribute_by_pk?: Maybe<Attribute>;
  /** fetch data from the table: "attribute_choice" */
  attribute_choice: Array<Attribute_Choice>;
  /** fetch aggregated fields from the table: "attribute_choice" */
  attribute_choice_aggregate: Attribute_Choice_Aggregate;
  /** fetch data from the table: "attribute_choice" using primary key columns */
  attribute_choice_by_pk?: Maybe<Attribute_Choice>;
  /** fetch data from the table: "auth_group" */
  auth_group: Array<Auth_Group>;
  /** fetch aggregated fields from the table: "auth_group" */
  auth_group_aggregate: Auth_Group_Aggregate;
  /** fetch data from the table: "auth_group" using primary key columns */
  auth_group_by_pk?: Maybe<Auth_Group>;
  /** fetch data from the table: "auth_group_permissions" */
  auth_group_permissions: Array<Auth_Group_Permissions>;
  /** fetch aggregated fields from the table: "auth_group_permissions" */
  auth_group_permissions_aggregate: Auth_Group_Permissions_Aggregate;
  /** fetch data from the table: "auth_group_permissions" using primary key columns */
  auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** fetch data from the table: "auth_permission" */
  auth_permission: Array<Auth_Permission>;
  /** fetch aggregated fields from the table: "auth_permission" */
  auth_permission_aggregate: Auth_Permission_Aggregate;
  /** fetch data from the table: "auth_permission" using primary key columns */
  auth_permission_by_pk?: Maybe<Auth_Permission>;
  author_details?: Maybe<AuthorDetails>;
  backfill_foundation_pruning_milestones?: Maybe<Scalars['JSONScalar']>;
  backfill_fruit_pruning_milestones?: Maybe<Scalars['JSONScalar']>;
  backfill_operational_costs?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "base_user" */
  base_user: Array<Base_User>;
  /** fetch data from the table: "base_user_address_book" */
  base_user_address_book: Array<Base_User_Address_Book>;
  /** fetch aggregated fields from the table: "base_user_address_book" */
  base_user_address_book_aggregate: Base_User_Address_Book_Aggregate;
  /** fetch data from the table: "base_user_address_book" using primary key columns */
  base_user_address_book_by_pk?: Maybe<Base_User_Address_Book>;
  /** fetch aggregated fields from the table: "base_user" */
  base_user_aggregate: Base_User_Aggregate;
  base_user_by_group?: Maybe<Array<Maybe<BaseUserGlType>>>;
  /** fetch data from the table: "base_user" using primary key columns */
  base_user_by_pk?: Maybe<Base_User>;
  /** An array relationship */
  base_user_companies: Array<Base_User_Companies>;
  /** An aggregate relationship */
  base_user_companies_aggregate: Base_User_Companies_Aggregate;
  /** fetch data from the table: "base_user_companies" using primary key columns */
  base_user_companies_by_pk?: Maybe<Base_User_Companies>;
  /** fetch data from the table: "base_user_departments" */
  base_user_departments: Array<Base_User_Departments>;
  /** fetch aggregated fields from the table: "base_user_departments" */
  base_user_departments_aggregate: Base_User_Departments_Aggregate;
  /** fetch data from the table: "base_user_departments" using primary key columns */
  base_user_departments_by_pk?: Maybe<Base_User_Departments>;
  base_user_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "base_user_groups" */
  base_user_groups: Array<Base_User_Groups>;
  /** fetch aggregated fields from the table: "base_user_groups" */
  base_user_groups_aggregate: Base_User_Groups_Aggregate;
  /** fetch data from the table: "base_user_groups" using primary key columns */
  base_user_groups_by_pk?: Maybe<Base_User_Groups>;
  /** fetch data from the table: "base_user_network" */
  base_user_network: Array<Base_User_Network>;
  /** fetch aggregated fields from the table: "base_user_network" */
  base_user_network_aggregate: Base_User_Network_Aggregate;
  /** fetch data from the table: "base_user_network" using primary key columns */
  base_user_network_by_pk?: Maybe<Base_User_Network>;
  base_user_payment_details?: Maybe<Array<Maybe<PaymentDetailType>>>;
  /** fetch data from the table: "base_user_user_permissions" */
  base_user_user_permissions: Array<Base_User_User_Permissions>;
  /** fetch aggregated fields from the table: "base_user_user_permissions" */
  base_user_user_permissions_aggregate: Base_User_User_Permissions_Aggregate;
  /** fetch data from the table: "base_user_user_permissions" using primary key columns */
  base_user_user_permissions_by_pk?: Maybe<Base_User_User_Permissions>;
  basic_trade_details?: Maybe<Scalars['JSONScalar']>;
  booking_detail?: Maybe<BookingGlType>;
  /** fetch data from the table: "business" */
  business: Array<Business>;
  /** fetch aggregated fields from the table: "business" */
  business_aggregate: Business_Aggregate;
  /** fetch data from the table: "business" using primary key columns */
  business_by_pk?: Maybe<Business>;
  /** fetch data from the table: "business_commodities_supplied" */
  business_commodities_supplied: Array<Business_Commodities_Supplied>;
  /** fetch aggregated fields from the table: "business_commodities_supplied" */
  business_commodities_supplied_aggregate: Business_Commodities_Supplied_Aggregate;
  /** fetch data from the table: "business_commodities_supplied" using primary key columns */
  business_commodities_supplied_by_pk?: Maybe<Business_Commodities_Supplied>;
  /** fetch data from the table: "business_companies" */
  business_companies: Array<Business_Companies>;
  /** fetch aggregated fields from the table: "business_companies" */
  business_companies_aggregate: Business_Companies_Aggregate;
  /** fetch data from the table: "business_companies" using primary key columns */
  business_companies_by_pk?: Maybe<Business_Companies>;
  business_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "business_group" */
  business_group: Array<Business_Group>;
  /** fetch aggregated fields from the table: "business_group" */
  business_group_aggregate: Business_Group_Aggregate;
  /** fetch data from the table: "business_group" using primary key columns */
  business_group_by_pk?: Maybe<Business_Group>;
  business_group_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "business_group_network" */
  business_group_network: Array<Business_Group_Network>;
  /** fetch aggregated fields from the table: "business_group_network" */
  business_group_network_aggregate: Business_Group_Network_Aggregate;
  /** fetch data from the table: "business_group_network" using primary key columns */
  business_group_network_by_pk?: Maybe<Business_Group_Network>;
  /** fetch data from the table: "business_groups" */
  business_groups: Array<Business_Groups>;
  /** fetch aggregated fields from the table: "business_groups" */
  business_groups_aggregate: Business_Groups_Aggregate;
  /** fetch data from the table: "business_groups" using primary key columns */
  business_groups_by_pk?: Maybe<Business_Groups>;
  /** fetch data from the table: "business_network" */
  business_network: Array<Business_Network>;
  /** fetch aggregated fields from the table: "business_network" */
  business_network_aggregate: Business_Network_Aggregate;
  /** fetch data from the table: "business_network" using primary key columns */
  business_network_by_pk?: Maybe<Business_Network>;
  business_payment_details?: Maybe<Array<Maybe<PaymentDetailType>>>;
  /** fetch data from the table: "business_secondary_pocs" */
  business_secondary_pocs: Array<Business_Secondary_Pocs>;
  /** fetch aggregated fields from the table: "business_secondary_pocs" */
  business_secondary_pocs_aggregate: Business_Secondary_Pocs_Aggregate;
  /** fetch data from the table: "business_secondary_pocs" using primary key columns */
  business_secondary_pocs_by_pk?: Maybe<Business_Secondary_Pocs>;
  buyer_hash?: Maybe<Scalars['String']>;
  /** fetch data from the table: "shared_entity" */
  care_shared_entity: Array<Care_Shared_Entity>;
  /** fetch aggregated fields from the table: "shared_entity" */
  care_shared_entity_aggregate: Care_Shared_Entity_Aggregate;
  /** fetch data from the table: "shared_entity" using primary key columns */
  care_shared_entity_by_pk?: Maybe<Care_Shared_Entity>;
  /** fetch data from the table: "category" */
  category: Array<Category>;
  /** fetch aggregated fields from the table: "category" */
  category_aggregate: Category_Aggregate;
  /** fetch data from the table: "category" using primary key columns */
  category_by_pk?: Maybe<Category>;
  /** fetch data from the table: "certificate_issuer" */
  certificate_issuer: Array<Certificate_Issuer>;
  /** fetch aggregated fields from the table: "certificate_issuer" */
  certificate_issuer_aggregate: Certificate_Issuer_Aggregate;
  /** fetch data from the table: "certificate_issuer" using primary key columns */
  certificate_issuer_by_pk?: Maybe<Certificate_Issuer>;
  /** fetch data from the table: "certification" */
  certification: Array<Certification>;
  /** fetch aggregated fields from the table: "certification" */
  certification_aggregate: Certification_Aggregate;
  /** fetch data from the table: "certification" using primary key columns */
  certification_by_pk?: Maybe<Certification>;
  /** fetch data from the table: "comment" */
  comment: Array<Comment>;
  /** fetch aggregated fields from the table: "comment" */
  comment_aggregate: Comment_Aggregate;
  /** fetch data from the table: "comment" using primary key columns */
  comment_by_pk?: Maybe<Comment>;
  /** fetch data from the table: "commodity" */
  commodity: Array<Commodity>;
  /** fetch aggregated fields from the table: "commodity" */
  commodity_aggregate: Commodity_Aggregate;
  /** fetch data from the table: "commodity" using primary key columns */
  commodity_by_pk?: Maybe<Commodity>;
  commodity_listing?: Maybe<Scalars['JSONScalar']>;
  commodity_parameters?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "commodity_variety" */
  commodity_variety: Array<Commodity_Variety>;
  /** fetch aggregated fields from the table: "commodity_variety" */
  commodity_variety_aggregate: Commodity_Variety_Aggregate;
  /** fetch data from the table: "commodity_variety" using primary key columns */
  commodity_variety_by_pk?: Maybe<Commodity_Variety>;
  /** fetch data from the table: "commodity_variety_secondary_groups" */
  commodity_variety_secondary_groups: Array<Commodity_Variety_Secondary_Groups>;
  /** fetch aggregated fields from the table: "commodity_variety_secondary_groups" */
  commodity_variety_secondary_groups_aggregate: Commodity_Variety_Secondary_Groups_Aggregate;
  /** fetch data from the table: "commodity_variety_secondary_groups" using primary key columns */
  commodity_variety_secondary_groups_by_pk?: Maybe<Commodity_Variety_Secondary_Groups>;
  /** fetch data from the table: "common_fileupload" */
  common_fileupload: Array<Common_Fileupload>;
  /** fetch aggregated fields from the table: "common_fileupload" */
  common_fileupload_aggregate: Common_Fileupload_Aggregate;
  /** fetch data from the table: "common_fileupload" using primary key columns */
  common_fileupload_by_pk?: Maybe<Common_Fileupload>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  company_documents?: Maybe<Array<Maybe<DocumentType>>>;
  company_payment_details?: Maybe<Array<Maybe<PaymentDetailType>>>;
  /** fetch data from the table: "django_content_type" */
  content_type: Array<Django_Content_Type>;
  /** fetch aggregated fields from the table: "django_content_type" */
  content_type_aggregate: Django_Content_Type_Aggregate;
  /** fetch data from the table: "django_content_type" using primary key columns */
  content_type_by_pk?: Maybe<Django_Content_Type>;
  /** fetch data from the table: "cost_item" */
  cost_item: Array<Cost_Item>;
  /** fetch aggregated fields from the table: "cost_item" */
  cost_item_aggregate: Cost_Item_Aggregate;
  /** fetch data from the table: "cost_item" using primary key columns */
  cost_item_by_pk?: Maybe<Cost_Item>;
  courses_in_progress?: Maybe<Array<Maybe<CoursesInProgress>>>;
  /** fetch data from the table: "crop" */
  crop: Array<Crop>;
  /** fetch aggregated fields from the table: "crop" */
  crop_aggregate: Crop_Aggregate;
  /** fetch data from the table: "crop" using primary key columns */
  crop_by_pk?: Maybe<Crop>;
  /** An array relationship */
  crop_fertilisers: Array<Crop_Fertilisers>;
  /** An aggregate relationship */
  crop_fertilisers_aggregate: Crop_Fertilisers_Aggregate;
  /** fetch data from the table: "crop_fertilisers" using primary key columns */
  crop_fertilisers_by_pk?: Maybe<Crop_Fertilisers>;
  /** fetch data from the table: "crop_group" */
  crop_group: Array<Crop_Group>;
  /** fetch aggregated fields from the table: "crop_group" */
  crop_group_aggregate: Crop_Group_Aggregate;
  /** fetch data from the table: "crop_group" using primary key columns */
  crop_group_by_pk?: Maybe<Crop_Group>;
  crop_growth_stages_by_plot_crop_codename?: Maybe<Array<Maybe<PrimaryGrowthStagesType>>>;
  /** fetch data from the table: "crop_infestation" */
  crop_infestation: Array<Crop_Infestation>;
  /** fetch aggregated fields from the table: "crop_infestation" */
  crop_infestation_aggregate: Crop_Infestation_Aggregate;
  /** fetch data from the table: "crop_infestation_attachment" */
  crop_infestation_attachment: Array<Crop_Infestation_Attachment>;
  /** fetch aggregated fields from the table: "crop_infestation_attachment" */
  crop_infestation_attachment_aggregate: Crop_Infestation_Attachment_Aggregate;
  /** fetch data from the table: "crop_infestation_attachment" using primary key columns */
  crop_infestation_attachment_by_pk?: Maybe<Crop_Infestation_Attachment>;
  /** fetch data from the table: "crop_infestation" using primary key columns */
  crop_infestation_by_pk?: Maybe<Crop_Infestation>;
  crop_infestation_details_by_pk?: Maybe<CropInfestationDetailType>;
  crop_infestations_by_crop_codename?: Maybe<Array<Maybe<CropInfestationListType>>>;
  crop_infestations_by_plot_crop_codename?: Maybe<Array<Maybe<CropInfestationListType>>>;
  /** fetch data from the table: "crop_milestone" */
  crop_milestone: Array<Crop_Milestone>;
  /** fetch aggregated fields from the table: "crop_milestone" */
  crop_milestone_aggregate: Crop_Milestone_Aggregate;
  /** fetch data from the table: "crop_milestone" using primary key columns */
  crop_milestone_by_pk?: Maybe<Crop_Milestone>;
  /** An array relationship */
  crop_operation_methods: Array<Crop_Operation_Methods>;
  /** An aggregate relationship */
  crop_operation_methods_aggregate: Crop_Operation_Methods_Aggregate;
  /** fetch data from the table: "crop_operation_methods" using primary key columns */
  crop_operation_methods_by_pk?: Maybe<Crop_Operation_Methods>;
  /** An array relationship */
  crop_pesticides: Array<Crop_Pesticides>;
  /** An aggregate relationship */
  crop_pesticides_aggregate: Crop_Pesticides_Aggregate;
  /** fetch data from the table: "crop_pesticides" using primary key columns */
  crop_pesticides_by_pk?: Maybe<Crop_Pesticides>;
  /** fetch data from the table: "crop_variety" */
  crop_variety: Array<Crop_Variety>;
  /** fetch aggregated fields from the table: "crop_variety" */
  crop_variety_aggregate: Crop_Variety_Aggregate;
  /** fetch data from the table: "crop_variety" using primary key columns */
  crop_variety_by_pk?: Maybe<Crop_Variety>;
  /** An array relationship */
  crop_variety_seeds: Array<Crop_Variety_Seeds>;
  /** An aggregate relationship */
  crop_variety_seeds_aggregate: Crop_Variety_Seeds_Aggregate;
  /** fetch data from the table: "crop_variety_seeds" using primary key columns */
  crop_variety_seeds_by_pk?: Maybe<Crop_Variety_Seeds>;
  /** fetch data from the table: "crop_year" */
  crop_year: Array<Crop_Year>;
  /** fetch aggregated fields from the table: "crop_year" */
  crop_year_aggregate: Crop_Year_Aggregate;
  /** fetch data from the table: "crop_year" using primary key columns */
  crop_year_by_pk?: Maybe<Crop_Year>;
  /** fetch data from the table: "cropmonitoring_parameter" */
  cropmonitoring_parameter: Array<Cropmonitoring_Parameter>;
  /** fetch aggregated fields from the table: "cropmonitoring_parameter" */
  cropmonitoring_parameter_aggregate: Cropmonitoring_Parameter_Aggregate;
  /** fetch data from the table: "cropmonitoring_parameter" using primary key columns */
  cropmonitoring_parameter_by_pk?: Maybe<Cropmonitoring_Parameter>;
  /** fetch data from the table: "currency" */
  currency: Array<Currency>;
  /** fetch aggregated fields from the table: "currency" */
  currency_aggregate: Currency_Aggregate;
  /** fetch data from the table: "currency" using primary key columns */
  currency_by_pk?: Maybe<Currency>;
  /** fetch data from the table: "daily_actual_reading" */
  daily_actual_reading: Array<Daily_Actual_Reading>;
  /** fetch aggregated fields from the table: "daily_actual_reading" */
  daily_actual_reading_aggregate: Daily_Actual_Reading_Aggregate;
  /** fetch data from the table: "daily_actual_reading" using primary key columns */
  daily_actual_reading_by_pk?: Maybe<Daily_Actual_Reading>;
  /** fetch data from the table: "daily_forecast_reading" */
  daily_forecast_reading: Array<Daily_Forecast_Reading>;
  /** fetch aggregated fields from the table: "daily_forecast_reading" */
  daily_forecast_reading_aggregate: Daily_Forecast_Reading_Aggregate;
  /** fetch data from the table: "daily_forecast_reading" using primary key columns */
  daily_forecast_reading_by_pk?: Maybe<Daily_Forecast_Reading>;
  decrypted_url?: Maybe<MediaUrlType>;
  /** fetch data from the table: "department" */
  department: Array<Department>;
  /** fetch aggregated fields from the table: "department" */
  department_aggregate: Department_Aggregate;
  /** fetch data from the table: "department" using primary key columns */
  department_by_pk?: Maybe<Department>;
  /** fetch data from the table: "device" */
  device: Array<Device>;
  /** fetch aggregated fields from the table: "device" */
  device_aggregate: Device_Aggregate;
  /** fetch data from the table: "device" using primary key columns */
  device_by_pk?: Maybe<Device>;
  distribution_centre_by_user?: Maybe<Array<Maybe<DistributionCentreGlType>>>;
  distribution_centre_detail?: Maybe<DistributionCentreGlType>;
  dock_detail?: Maybe<DockGlType>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document_attachments" */
  document_attachments: Array<Document_Attachments>;
  /** fetch aggregated fields from the table: "document_attachments" */
  document_attachments_aggregate: Document_Attachments_Aggregate;
  /** fetch data from the table: "document_attachments" using primary key columns */
  document_attachments_by_pk?: Maybe<Document_Attachments>;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk?: Maybe<Document>;
  /** fetch data from the table: "document_data" */
  document_data: Array<Document_Data>;
  /** fetch aggregated fields from the table: "document_data" */
  document_data_aggregate: Document_Data_Aggregate;
  /** fetch data from the table: "document_data" using primary key columns */
  document_data_by_pk?: Maybe<Document_Data>;
  document_entity_data?: Maybe<Scalars['JSONString']>;
  /** fetch data from the table: "document_kind" */
  document_kind: Array<Document_Kind>;
  /** fetch aggregated fields from the table: "document_kind" */
  document_kind_aggregate: Document_Kind_Aggregate;
  /** fetch data from the table: "document_kind" using primary key columns */
  document_kind_by_pk?: Maybe<Document_Kind>;
  /** fetch data from the table: "document_kind_data_field" */
  document_kind_data_field: Array<Document_Kind_Data_Field>;
  /** fetch aggregated fields from the table: "document_kind_data_field" */
  document_kind_data_field_aggregate: Document_Kind_Data_Field_Aggregate;
  /** fetch data from the table: "document_kind_data_field" using primary key columns */
  document_kind_data_field_by_pk?: Maybe<Document_Kind_Data_Field>;
  /** fetch data from the table: "drip_irrigation_system" */
  drip_irrigation_system: Array<Drip_Irrigation_System>;
  /** fetch aggregated fields from the table: "drip_irrigation_system" */
  drip_irrigation_system_aggregate: Drip_Irrigation_System_Aggregate;
  /** fetch data from the table: "drip_irrigation_system" using primary key columns */
  drip_irrigation_system_by_pk?: Maybe<Drip_Irrigation_System>;
  /** fetch data from the table: "expense" */
  expense: Array<Expense>;
  /** fetch aggregated fields from the table: "expense" */
  expense_aggregate: Expense_Aggregate;
  /** fetch data from the table: "expense" using primary key columns */
  expense_by_pk?: Maybe<Expense>;
  expense_config_template_detail?: Maybe<Array<Maybe<OrganisationTradeExpensesTemplateSchema>>>;
  expense_config_versions?: Maybe<Array<Maybe<OrganisationTradeExpensesVersionSchema>>>;
  expense_configs?: Maybe<Array<Maybe<OrganisationTradeExpenseConfigType>>>;
  /** fetch data from the table: "expense_parameter" */
  expense_parameter: Array<Expense_Parameter>;
  /** fetch data from the table: "expense_parameter" using primary key columns */
  expense_parameter_by_pk?: Maybe<Expense_Parameter>;
  expense_timeline_details?: Maybe<Array<Maybe<PlotCropExpenseByDateType>>>;
  expense_timeline_details_v2?: Maybe<Array<Maybe<PlotCropExpenseByDateType>>>;
  /** fetch data from the table: "external_reference" */
  external_reference: Array<External_Reference>;
  /** fetch aggregated fields from the table: "external_reference" */
  external_reference_aggregate: External_Reference_Aggregate;
  /** fetch data from the table: "external_reference" using primary key columns */
  external_reference_by_pk?: Maybe<External_Reference>;
  external_reference_id?: Maybe<Scalars['String']>;
  /** fetch data from the table: "farm" */
  farm: Array<Farm>;
  /** fetch aggregated fields from the table: "farm" */
  farm_aggregate: Farm_Aggregate;
  farm_aggregate_details?: Maybe<Array<Maybe<FarmAggregationType>>>;
  /** fetch data from the table: "farm" using primary key columns */
  farm_by_pk?: Maybe<Farm>;
  farm_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "farm_network" */
  farm_network: Array<Farm_Network>;
  /** fetch aggregated fields from the table: "farm_network" */
  farm_network_aggregate: Farm_Network_Aggregate;
  /** fetch data from the table: "farm_network" using primary key columns */
  farm_network_by_pk?: Maybe<Farm_Network>;
  farmer_latest_trade?: Maybe<Scalars['JSONScalar']>;
  farmer_list?: Maybe<Scalars['JSONScalar']>;
  farmer_profile?: Maybe<Scalars['JSONScalar']>;
  features?: Maybe<Array<Maybe<FeatureType>>>;
  /** fetch data from the table: "field" */
  field: Array<Field>;
  /** fetch aggregated fields from the table: "field" */
  field_aggregate: Field_Aggregate;
  /** fetch data from the table: "field" using primary key columns */
  field_by_pk?: Maybe<Field>;
  /** fetch data from the table: "field_network" */
  field_network: Array<Field_Network>;
  /** fetch aggregated fields from the table: "field_network" */
  field_network_aggregate: Field_Network_Aggregate;
  /** fetch data from the table: "field_network" using primary key columns */
  field_network_by_pk?: Maybe<Field_Network>;
  /** fetch data from the table: "field_weather_location" */
  field_weather_location: Array<Field_Weather_Location>;
  /** fetch aggregated fields from the table: "field_weather_location" */
  field_weather_location_aggregate: Field_Weather_Location_Aggregate;
  /** fetch data from the table: "field_weather_location" using primary key columns */
  field_weather_location_by_pk?: Maybe<Field_Weather_Location>;
  /** fetch data from the table: "fileupload" */
  fileupload: Array<Fileupload>;
  /** fetch aggregated fields from the table: "fileupload" */
  fileupload_aggregate: Fileupload_Aggregate;
  /** fetch data from the table: "fileupload" using primary key columns */
  fileupload_by_pk?: Maybe<Fileupload>;
  financial_summary?: Maybe<FinancialSummaryType>;
  financial_summary_v2?: Maybe<FinancialSummaryType>;
  financial_timeline_v2?: Maybe<PlotCropTimelineTransactionType>;
  /** fetch data from the table: "flood_irrigation_system" */
  flood_irrigation_system: Array<Flood_Irrigation_System>;
  /** fetch aggregated fields from the table: "flood_irrigation_system" */
  flood_irrigation_system_aggregate: Flood_Irrigation_System_Aggregate;
  /** fetch data from the table: "flood_irrigation_system" using primary key columns */
  flood_irrigation_system_by_pk?: Maybe<Flood_Irrigation_System>;
  /** fetch data from the table: "forecast_reading" */
  forecast_reading: Array<Forecast_Reading>;
  /** fetch aggregated fields from the table: "forecast_reading" */
  forecast_reading_aggregate: Forecast_Reading_Aggregate;
  /** fetch data from the table: "forecast_reading" using primary key columns */
  forecast_reading_by_pk?: Maybe<Forecast_Reading>;
  /** fetch data from the table: "gateway" */
  gateway: Array<Gateway>;
  /** fetch aggregated fields from the table: "gateway" */
  gateway_aggregate: Gateway_Aggregate;
  /** fetch data from the table: "gateway" using primary key columns */
  gateway_by_pk?: Maybe<Gateway>;
  /** fetch data from the table: "gateway_configuration" */
  gateway_configuration: Array<Gateway_Configuration>;
  /** fetch aggregated fields from the table: "gateway_configuration" */
  gateway_configuration_aggregate: Gateway_Configuration_Aggregate;
  /** fetch data from the table: "gateway_configuration" using primary key columns */
  gateway_configuration_by_pk?: Maybe<Gateway_Configuration>;
  /** fetch data from the table: "gateway_status" */
  gateway_status: Array<Gateway_Status>;
  /** fetch aggregated fields from the table: "gateway_status" */
  gateway_status_aggregate: Gateway_Status_Aggregate;
  /** fetch data from the table: "gateway_status" using primary key columns */
  gateway_status_by_pk?: Maybe<Gateway_Status>;
  /** fetch data from the table: "grade_price" */
  grade_price: Array<Grade_Price>;
  /** fetch aggregated fields from the table: "grade_price" */
  grade_price_aggregate: Grade_Price_Aggregate;
  /** fetch data from the table: "grade_price" using primary key columns */
  grade_price_by_pk?: Maybe<Grade_Price>;
  income_timeline_details?: Maybe<Array<Maybe<PlotCropIncomeByDateType>>>;
  income_timeline_details_v2?: Maybe<Array<Maybe<PlotCropIncomeByDateType>>>;
  /** fetch data from the table: "infestation" */
  infestation: Array<Infestation>;
  /** fetch aggregated fields from the table: "infestation" */
  infestation_aggregate: Infestation_Aggregate;
  /** fetch data from the table: "infestation" using primary key columns */
  infestation_by_pk?: Maybe<Infestation>;
  /** fetch data from the table: "ingredient" */
  ingredient: Array<Ingredient>;
  /** fetch aggregated fields from the table: "ingredient" */
  ingredient_aggregate: Ingredient_Aggregate;
  /** fetch data from the table: "ingredient" using primary key columns */
  ingredient_by_pk?: Maybe<Ingredient>;
  /** fetch data from the table: "inst_sensor_reading" */
  inst_sensor_reading: Array<Inst_Sensor_Reading>;
  /** fetch aggregated fields from the table: "inst_sensor_reading" */
  inst_sensor_reading_aggregate: Inst_Sensor_Reading_Aggregate;
  /** fetch data from the table: "inst_sensor_reading" using primary key columns */
  inst_sensor_reading_by_pk?: Maybe<Inst_Sensor_Reading>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  inward_detail?: Maybe<InwardGlType>;
  /** fetch data from the table: "irrigation_system" */
  irrigation_system: Array<Irrigation_System>;
  /** fetch aggregated fields from the table: "irrigation_system" */
  irrigation_system_aggregate: Irrigation_System_Aggregate;
  /** fetch data from the table: "irrigation_system" using primary key columns */
  irrigation_system_by_pk?: Maybe<Irrigation_System>;
  key_stages_for_pop?: Maybe<Array<Maybe<Scalars['JSONScalar']>>>;
  kite_entities_attribute?: Maybe<Array<Maybe<EntityAttributeObject>>>;
  kite_entity_attribute?: Maybe<Scalars['String']>;
  location_by_pincode?: Maybe<LocationData>;
  /** fetch data from the table: "location_subscription" */
  location_subscription: Array<Location_Subscription>;
  /** fetch aggregated fields from the table: "location_subscription" */
  location_subscription_aggregate: Location_Subscription_Aggregate;
  /** fetch data from the table: "location_subscription" using primary key columns */
  location_subscription_by_pk?: Maybe<Location_Subscription>;
  /** fetch data from the table: "main_section" */
  main_section: Array<Main_Section>;
  /** fetch aggregated fields from the table: "main_section" */
  main_section_aggregate: Main_Section_Aggregate;
  /** fetch data from the table: "main_section" using primary key columns */
  main_section_by_pk?: Maybe<Main_Section>;
  /** fetch data from the table: "manufacturer" */
  manufacturer: Array<Manufacturer>;
  /** fetch aggregated fields from the table: "manufacturer" */
  manufacturer_aggregate: Manufacturer_Aggregate;
  /** fetch data from the table: "manufacturer" using primary key columns */
  manufacturer_by_pk?: Maybe<Manufacturer>;
  /** fetch data from the table: "manufacturing_facility" */
  manufacturing_facility: Array<Manufacturing_Facility>;
  /** fetch aggregated fields from the table: "manufacturing_facility" */
  manufacturing_facility_aggregate: Manufacturing_Facility_Aggregate;
  /** fetch data from the table: "manufacturing_facility" using primary key columns */
  manufacturing_facility_by_pk?: Maybe<Manufacturing_Facility>;
  /** fetch data from the table: "market" */
  market: Array<Market>;
  /** fetch aggregated fields from the table: "market" */
  market_aggregate: Market_Aggregate;
  /** fetch data from the table: "market" using primary key columns */
  market_by_pk?: Maybe<Market>;
  /** fetch data from the table: "marketer" */
  marketer: Array<Marketer>;
  /** fetch aggregated fields from the table: "marketer" */
  marketer_aggregate: Marketer_Aggregate;
  /** fetch data from the table: "marketer" using primary key columns */
  marketer_by_pk?: Maybe<Marketer>;
  /** fetch data from the table: "marketing_facility" */
  marketing_facility: Array<Marketing_Facility>;
  /** fetch aggregated fields from the table: "marketing_facility" */
  marketing_facility_aggregate: Marketing_Facility_Aggregate;
  /** fetch data from the table: "marketing_facility" using primary key columns */
  marketing_facility_by_pk?: Maybe<Marketing_Facility>;
  me?: Maybe<BaseUserType>;
  me_global?: Maybe<BaseUserGlType>;
  /** fetch data from the table: "measure_of" */
  measure_of: Array<Measure_Of>;
  /** fetch aggregated fields from the table: "measure_of" */
  measure_of_aggregate: Measure_Of_Aggregate;
  /** fetch data from the table: "measure_of" using primary key columns */
  measure_of_by_pk?: Maybe<Measure_Of>;
  /** fetch data from the table: "media" */
  media: Array<Media>;
  /** fetch aggregated fields from the table: "media" */
  media_aggregate: Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  media_by_pk?: Maybe<Media>;
  /** fetch data from the table: "message" */
  message: Array<Message>;
  /** fetch aggregated fields from the table: "message" */
  message_aggregate: Message_Aggregate;
  /** fetch data from the table: "message" using primary key columns */
  message_by_pk?: Maybe<Message>;
  metabase_url?: Maybe<MetabaseUrlType>;
  migrate_financial_data?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "milestone" */
  milestone: Array<Milestone>;
  /** fetch aggregated fields from the table: "milestone" */
  milestone_aggregate: Milestone_Aggregate;
  /** fetch data from the table: "milestone" using primary key columns */
  milestone_by_pk?: Maybe<Milestone>;
  milestones_for_plotcrop?: Maybe<Array<Maybe<Scalars['JSONScalar']>>>;
  /** fetch data from the table: "monitoring_category" */
  monitoring_category: Array<Monitoring_Category>;
  /** fetch aggregated fields from the table: "monitoring_category" */
  monitoring_category_aggregate: Monitoring_Category_Aggregate;
  /** fetch data from the table: "monitoring_category" using primary key columns */
  monitoring_category_by_pk?: Maybe<Monitoring_Category>;
  /** fetch data from the table: "monitoring_parameter" */
  monitoring_parameter: Array<Monitoring_Parameter>;
  /** fetch aggregated fields from the table: "monitoring_parameter" */
  monitoring_parameter_aggregate: Monitoring_Parameter_Aggregate;
  /** fetch data from the table: "monitoring_parameter" using primary key columns */
  monitoring_parameter_by_pk?: Maybe<Monitoring_Parameter>;
  /** An array relationship */
  monitoring_parameter_choices: Array<Monitoring_Parameter_Choices>;
  /** An aggregate relationship */
  monitoring_parameter_choices_aggregate: Monitoring_Parameter_Choices_Aggregate;
  /** fetch data from the table: "monitoring_parameter_choices" using primary key columns */
  monitoring_parameter_choices_by_pk?: Maybe<Monitoring_Parameter_Choices>;
  /** An array relationship */
  monitoring_parameter_unit_choices: Array<Monitoring_Parameter_Unit_Choices>;
  /** An aggregate relationship */
  monitoring_parameter_unit_choices_aggregate: Monitoring_Parameter_Unit_Choices_Aggregate;
  /** fetch data from the table: "monitoring_parameter_unit_choices" using primary key columns */
  monitoring_parameter_unit_choices_by_pk?: Maybe<Monitoring_Parameter_Unit_Choices>;
  /** fetch data from the table: "monitoring_record" */
  monitoring_record: Array<Monitoring_Record>;
  /** fetch aggregated fields from the table: "monitoring_record" */
  monitoring_record_aggregate: Monitoring_Record_Aggregate;
  /** An array relationship */
  monitoring_record_attachments: Array<Monitoring_Record_Attachments>;
  /** An aggregate relationship */
  monitoring_record_attachments_aggregate: Monitoring_Record_Attachments_Aggregate;
  /** fetch data from the table: "monitoring_record_attachments" using primary key columns */
  monitoring_record_attachments_by_pk?: Maybe<Monitoring_Record_Attachments>;
  /** fetch data from the table: "monitoring_record" using primary key columns */
  monitoring_record_by_pk?: Maybe<Monitoring_Record>;
  /** fetch data from the table: "monitoring_sample" */
  monitoring_sample: Array<Monitoring_Sample>;
  /** fetch aggregated fields from the table: "monitoring_sample" */
  monitoring_sample_aggregate: Monitoring_Sample_Aggregate;
  /** fetch data from the table: "monitoring_sample" using primary key columns */
  monitoring_sample_by_pk?: Maybe<Monitoring_Sample>;
  /** fetch data from the table: "monitoring_subcategory" */
  monitoring_subcategory: Array<Monitoring_Subcategory>;
  /** fetch aggregated fields from the table: "monitoring_subcategory" */
  monitoring_subcategory_aggregate: Monitoring_Subcategory_Aggregate;
  /** fetch data from the table: "monitoring_subcategory" using primary key columns */
  monitoring_subcategory_by_pk?: Maybe<Monitoring_Subcategory>;
  /** fetch data from the table: "mutual_group" */
  mutual_group: Array<Mutual_Group>;
  /** fetch aggregated fields from the table: "mutual_group" */
  mutual_group_aggregate: Mutual_Group_Aggregate;
  /** fetch data from the table: "mutual_group" using primary key columns */
  mutual_group_by_pk?: Maybe<Mutual_Group>;
  mutual_group_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "mutual_group_membership" */
  mutual_group_membership: Array<Mutual_Group_Membership>;
  /** fetch aggregated fields from the table: "mutual_group_membership" */
  mutual_group_membership_aggregate: Mutual_Group_Membership_Aggregate;
  /** fetch data from the table: "mutual_group_membership" using primary key columns */
  mutual_group_membership_by_pk?: Maybe<Mutual_Group_Membership>;
  /** fetch data from the table: "mutual_group_network" */
  mutual_group_network: Array<Mutual_Group_Network>;
  /** fetch aggregated fields from the table: "mutual_group_network" */
  mutual_group_network_aggregate: Mutual_Group_Network_Aggregate;
  /** fetch data from the table: "mutual_group_network" using primary key columns */
  mutual_group_network_by_pk?: Maybe<Mutual_Group_Network>;
  /** fetch data from the table: "mutual_group_role" */
  mutual_group_role: Array<Mutual_Group_Role>;
  /** fetch aggregated fields from the table: "mutual_group_role" */
  mutual_group_role_aggregate: Mutual_Group_Role_Aggregate;
  /** fetch data from the table: "mutual_group_role" using primary key columns */
  mutual_group_role_by_pk?: Maybe<Mutual_Group_Role>;
  /** fetch data from the table: "mutual_group_subscription_package" */
  mutual_group_subscription_package: Array<Mutual_Group_Subscription_Package>;
  /** fetch aggregated fields from the table: "mutual_group_subscription_package" */
  mutual_group_subscription_package_aggregate: Mutual_Group_Subscription_Package_Aggregate;
  /** fetch data from the table: "mutual_group_subscription_package" using primary key columns */
  mutual_group_subscription_package_by_pk?: Maybe<Mutual_Group_Subscription_Package>;
  /** fetch data from the table: "mutual_group_weather_station" */
  mutual_group_weather_station: Array<Mutual_Group_Weather_Station>;
  /** fetch aggregated fields from the table: "mutual_group_weather_station" */
  mutual_group_weather_station_aggregate: Mutual_Group_Weather_Station_Aggregate;
  /** fetch data from the table: "mutual_group_weather_station" using primary key columns */
  mutual_group_weather_station_by_pk?: Maybe<Mutual_Group_Weather_Station>;
  mutual_group_weatherstations?: Maybe<Array<Maybe<MutualGroupWeatherStationType>>>;
  my_network_documents?: Maybe<DocumentListResponseType>;
  my_network_users?: Maybe<Array<Maybe<BaseUserAggregationType>>>;
  my_network_users_with_total?: Maybe<BaseUserAggregationTypeWithTotal>;
  my_order_detail?: Maybe<OrderGlType>;
  my_plot_crops?: Maybe<Array<Maybe<PlotCropDetailType>>>;
  my_plot_summary_detail?: Maybe<PlotCommodityGlType>;
  /** fetch data from the table: "network" */
  network: Array<Network>;
  /** fetch aggregated fields from the table: "network" */
  network_aggregate: Network_Aggregate;
  /** fetch data from the table: "network" using primary key columns */
  network_by_pk?: Maybe<Network>;
  /** fetch data from the table: "notification" */
  notification: Array<Notification>;
  /** fetch aggregated fields from the table: "notification" */
  notification_aggregate: Notification_Aggregate;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<Notification>;
  /** fetch data from the table: "notification_category" */
  notification_category: Array<Notification_Category>;
  /** fetch aggregated fields from the table: "notification_category" */
  notification_category_aggregate: Notification_Category_Aggregate;
  /** fetch data from the table: "notification_category" using primary key columns */
  notification_category_by_pk?: Maybe<Notification_Category>;
  notification_metrics?: Maybe<Array<Maybe<NotificationMetrics>>>;
  notification_metrics_by_region?: Maybe<Array<Maybe<NotificationByRegion>>>;
  notification_metrics_by_region_seen?: Maybe<Array<Maybe<NotificationByRegion>>>;
  notification_metrics_seen?: Maybe<Array<Maybe<NotificationMetrics>>>;
  /** fetch data from the table: "notification_template" */
  notification_template: Array<Notification_Template>;
  /** fetch aggregated fields from the table: "notification_template" */
  notification_template_aggregate: Notification_Template_Aggregate;
  /** fetch data from the table: "notification_template" using primary key columns */
  notification_template_by_pk?: Maybe<Notification_Template>;
  /** fetch data from the table: "notification_template_distribution_region" */
  notification_template_distribution_region: Array<Notification_Template_Distribution_Region>;
  /** fetch aggregated fields from the table: "notification_template_distribution_region" */
  notification_template_distribution_region_aggregate: Notification_Template_Distribution_Region_Aggregate;
  /** fetch data from the table: "notification_template_distribution_region" using primary key columns */
  notification_template_distribution_region_by_pk?: Maybe<Notification_Template_Distribution_Region>;
  /** fetch data from the table: "notification_template_distribution_team" */
  notification_template_distribution_team: Array<Notification_Template_Distribution_Team>;
  /** fetch aggregated fields from the table: "notification_template_distribution_team" */
  notification_template_distribution_team_aggregate: Notification_Template_Distribution_Team_Aggregate;
  /** fetch data from the table: "notification_template_distribution_team" using primary key columns */
  notification_template_distribution_team_by_pk?: Maybe<Notification_Template_Distribution_Team>;
  /** fetch data from the table: "notification_template_distribution_user" */
  notification_template_distribution_user: Array<Notification_Template_Distribution_User>;
  /** fetch aggregated fields from the table: "notification_template_distribution_user" */
  notification_template_distribution_user_aggregate: Notification_Template_Distribution_User_Aggregate;
  /** fetch data from the table: "notification_template_distribution_user" using primary key columns */
  notification_template_distribution_user_by_pk?: Maybe<Notification_Template_Distribution_User>;
  notification_total_metrics?: Maybe<Array<Maybe<NotificationTotalMetrics>>>;
  /** fetch data from the table: "nutrients" */
  nutrients: Array<Nutrients>;
  /** fetch aggregated fields from the table: "nutrients" */
  nutrients_aggregate: Nutrients_Aggregate;
  /** fetch data from the table: "nutrients" using primary key columns */
  nutrients_by_pk?: Maybe<Nutrients>;
  observation_categories?: Maybe<Array<Maybe<ObservationCategoriesQuery>>>;
  observation_details?: Maybe<Scalars['JSONScalar']>;
  observation_list?: Maybe<ObservationList>;
  /** fetch data from the table: "observation_notification" */
  observation_notification: Array<Observation_Notification>;
  /** fetch aggregated fields from the table: "observation_notification" */
  observation_notification_aggregate: Observation_Notification_Aggregate;
  /** fetch data from the table: "observation_notification" using primary key columns */
  observation_notification_by_pk?: Maybe<Observation_Notification>;
  observation_subcategories?: Maybe<Array<Maybe<SubCategoriesQuery>>>;
  /** An array relationship */
  operation_attachments: Array<Operation_Attachments>;
  /** An aggregate relationship */
  operation_attachments_aggregate: Operation_Attachments_Aggregate;
  /** fetch data from the table: "operation_attachments" using primary key columns */
  operation_attachments_by_pk?: Maybe<Operation_Attachments>;
  /** fetch data from the table: "operation_cost" */
  operation_cost: Array<Operation_Cost>;
  /** fetch aggregated fields from the table: "operation_cost" */
  operation_cost_aggregate: Operation_Cost_Aggregate;
  /** fetch data from the table: "operation_cost" using primary key columns */
  operation_cost_by_pk?: Maybe<Operation_Cost>;
  /** fetch data from the table: "operation_cost_item" */
  operation_cost_item: Array<Operation_Cost_Item>;
  /** fetch aggregated fields from the table: "operation_cost_item" */
  operation_cost_item_aggregate: Operation_Cost_Item_Aggregate;
  operation_details?: Maybe<Scalars['JSONScalar']>;
  operation_list?: Maybe<OperationList>;
  /** fetch data from the table: "operation_methods" */
  operation_methods: Array<Operation_Methods>;
  /** fetch aggregated fields from the table: "operation_methods" */
  operation_methods_aggregate: Operation_Methods_Aggregate;
  /** fetch data from the table: "operation_methods" using primary key columns */
  operation_methods_by_pk?: Maybe<Operation_Methods>;
  operation_methods_by_type?: Maybe<Array<Maybe<OperationMethodSchema>>>;
  /** fetch data from the table: "operation_product_types" */
  operation_product_types: Array<Operation_Product_Types>;
  /** fetch aggregated fields from the table: "operation_product_types" */
  operation_product_types_aggregate: Operation_Product_Types_Aggregate;
  /** fetch data from the table: "operation_product_types" using primary key columns */
  operation_product_types_by_pk?: Maybe<Operation_Product_Types>;
  operation_products_si_units?: Maybe<Array<Maybe<SiUnitType>>>;
  operation_types?: Maybe<Array<Maybe<OperationTypesSchema>>>;
  /** An array relationship */
  operations: Array<Operations>;
  /** An aggregate relationship */
  operations_aggregate: Operations_Aggregate;
  /** fetch data from the table: "operations_applied_fertiliser" */
  operations_applied_fertiliser: Array<Operations_Applied_Fertiliser>;
  /** fetch aggregated fields from the table: "operations_applied_fertiliser" */
  operations_applied_fertiliser_aggregate: Operations_Applied_Fertiliser_Aggregate;
  /** fetch data from the table: "operations_applied_fertiliser" using primary key columns */
  operations_applied_fertiliser_by_pk?: Maybe<Operations_Applied_Fertiliser>;
  /** fetch data from the table: "operations_applied_pesticide" */
  operations_applied_pesticide: Array<Operations_Applied_Pesticide>;
  /** fetch aggregated fields from the table: "operations_applied_pesticide" */
  operations_applied_pesticide_aggregate: Operations_Applied_Pesticide_Aggregate;
  /** fetch data from the table: "operations_applied_pesticide" using primary key columns */
  operations_applied_pesticide_by_pk?: Maybe<Operations_Applied_Pesticide>;
  /** fetch data from the table: "operations" using primary key columns */
  operations_by_pk?: Maybe<Operations>;
  /** fetch data from the table: "operations_fertiliser" */
  operations_fertiliser: Array<Operations_Fertiliser>;
  /** fetch aggregated fields from the table: "operations_fertiliser" */
  operations_fertiliser_aggregate: Operations_Fertiliser_Aggregate;
  /** fetch data from the table: "operations_fertiliser" using primary key columns */
  operations_fertiliser_by_pk?: Maybe<Operations_Fertiliser>;
  /** fetch data from the table: "operations_harvest" */
  operations_harvest: Array<Operations_Harvest>;
  /** fetch aggregated fields from the table: "operations_harvest" */
  operations_harvest_aggregate: Operations_Harvest_Aggregate;
  /** fetch data from the table: "operations_harvest" using primary key columns */
  operations_harvest_by_pk?: Maybe<Operations_Harvest>;
  /** fetch data from the table: "operations_harvest_output" */
  operations_harvest_output: Array<Operations_Harvest_Output>;
  /** fetch aggregated fields from the table: "operations_harvest_output" */
  operations_harvest_output_aggregate: Operations_Harvest_Output_Aggregate;
  /** fetch data from the table: "operations_harvest_output" using primary key columns */
  operations_harvest_output_by_pk?: Maybe<Operations_Harvest_Output>;
  /** fetch data from the table: "operations_interculture" */
  operations_interculture: Array<Operations_Interculture>;
  /** fetch aggregated fields from the table: "operations_interculture" */
  operations_interculture_aggregate: Operations_Interculture_Aggregate;
  /** fetch data from the table: "operations_interculture" using primary key columns */
  operations_interculture_by_pk?: Maybe<Operations_Interculture>;
  /** fetch data from the table: "operations_irrigation" */
  operations_irrigation: Array<Operations_Irrigation>;
  /** fetch aggregated fields from the table: "operations_irrigation" */
  operations_irrigation_aggregate: Operations_Irrigation_Aggregate;
  /** fetch data from the table: "operations_irrigation" using primary key columns */
  operations_irrigation_by_pk?: Maybe<Operations_Irrigation>;
  /** fetch data from the table: "operations_land_prep" */
  operations_land_prep: Array<Operations_Land_Prep>;
  /** fetch aggregated fields from the table: "operations_land_prep" */
  operations_land_prep_aggregate: Operations_Land_Prep_Aggregate;
  /** fetch data from the table: "operations_land_prep" using primary key columns */
  operations_land_prep_by_pk?: Maybe<Operations_Land_Prep>;
  /** fetch data from the table: "operations_pesticide" */
  operations_pesticide: Array<Operations_Pesticide>;
  /** fetch aggregated fields from the table: "operations_pesticide" */
  operations_pesticide_aggregate: Operations_Pesticide_Aggregate;
  /** fetch data from the table: "operations_pesticide" using primary key columns */
  operations_pesticide_by_pk?: Maybe<Operations_Pesticide>;
  /** fetch data from the table: "operations_sowing" */
  operations_sowing: Array<Operations_Sowing>;
  /** fetch aggregated fields from the table: "operations_sowing" */
  operations_sowing_aggregate: Operations_Sowing_Aggregate;
  /** fetch data from the table: "operations_sowing" using primary key columns */
  operations_sowing_by_pk?: Maybe<Operations_Sowing>;
  /** fetch data from the table: "organisation" */
  organisation: Array<Organisation>;
  /** fetch aggregated fields from the table: "organisation" */
  organisation_aggregate: Organisation_Aggregate;
  organisation_app_configuration?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "organisation" using primary key columns */
  organisation_by_pk?: Maybe<Organisation>;
  /** fetch data from the table: "organisation_document_kind" */
  organisation_document_kind: Array<Organisation_Document_Kind>;
  /** fetch aggregated fields from the table: "organisation_document_kind" */
  organisation_document_kind_aggregate: Organisation_Document_Kind_Aggregate;
  /** fetch data from the table: "organisation_document_kind" using primary key columns */
  organisation_document_kind_by_pk?: Maybe<Organisation_Document_Kind>;
  /** fetch data from the table: "organisation_preferences" */
  organisation_preferences: Array<Organisation_Preferences>;
  /** fetch aggregated fields from the table: "organisation_preferences" */
  organisation_preferences_aggregate: Organisation_Preferences_Aggregate;
  /** fetch data from the table: "organisation_preferences" using primary key columns */
  organisation_preferences_by_pk?: Maybe<Organisation_Preferences>;
  organisation_pricing?: Maybe<OrganisationPricingGlType>;
  /** fetch data from the table: "organisation_season" */
  organisation_season: Array<Organisation_Season>;
  /** fetch aggregated fields from the table: "organisation_season" */
  organisation_season_aggregate: Organisation_Season_Aggregate;
  /** fetch data from the table: "organisation_season" using primary key columns */
  organisation_season_by_pk?: Maybe<Organisation_Season>;
  organisation_si_units?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "payment_detail" */
  payment_detail: Array<Payment_Detail>;
  /** fetch aggregated fields from the table: "payment_detail" */
  payment_detail_aggregate: Payment_Detail_Aggregate;
  /** fetch data from the table: "payment_detail_attachments" */
  payment_detail_attachments: Array<Payment_Detail_Attachments>;
  /** fetch aggregated fields from the table: "payment_detail_attachments" */
  payment_detail_attachments_aggregate: Payment_Detail_Attachments_Aggregate;
  /** fetch data from the table: "payment_detail_attachments" using primary key columns */
  payment_detail_attachments_by_pk?: Maybe<Payment_Detail_Attachments>;
  /** fetch data from the table: "payment_detail" using primary key columns */
  payment_detail_by_pk?: Maybe<Payment_Detail>;
  /** fetch data from the table: "payment_method" */
  payment_method: Array<Payment_Method>;
  /** fetch aggregated fields from the table: "payment_method" */
  payment_method_aggregate: Payment_Method_Aggregate;
  /** fetch data from the table: "payment_method" using primary key columns */
  payment_method_by_pk?: Maybe<Payment_Method>;
  payu_hash?: Maybe<PayUHashType>;
  payu_transaction_hash?: Maybe<PayUPayload>;
  /** fetch data from the table: "plot" */
  plot: Array<Plot>;
  /** fetch aggregated fields from the table: "plot" */
  plot_aggregate: Plot_Aggregate;
  /** fetch data from the table: "plot" using primary key columns */
  plot_by_pk?: Maybe<Plot>;
  /** fetch data from the table: "plot_crop" */
  plot_crop: Array<Plot_Crop>;
  /** fetch data from the table: "plot_crop_agent" */
  plot_crop_agent: Array<Plot_Crop_Agent>;
  /** fetch aggregated fields from the table: "plot_crop_agent" */
  plot_crop_agent_aggregate: Plot_Crop_Agent_Aggregate;
  /** fetch data from the table: "plot_crop_agent" using primary key columns */
  plot_crop_agent_by_pk?: Maybe<Plot_Crop_Agent>;
  /** fetch aggregated fields from the table: "plot_crop" */
  plot_crop_aggregate: Plot_Crop_Aggregate;
  /** fetch data from the table: "plot_crop" using primary key columns */
  plot_crop_by_pk?: Maybe<Plot_Crop>;
  plot_crop_documents?: Maybe<Array<Maybe<DocumentType>>>;
  plot_crop_growth_stages_by_plot_crop_codename?: Maybe<Array<Maybe<PlotCropGrowthStagesType>>>;
  plot_crop_list_with_budget?: Maybe<Array<Maybe<PlotCropBudgetSetType>>>;
  plot_crop_list_with_budget_v2?: Maybe<Array<Maybe<PlotCropBudgetSetType>>>;
  /** fetch data from the table: "plot_crop_milestone" */
  plot_crop_milestone: Array<Plot_Crop_Milestone>;
  /** fetch aggregated fields from the table: "plot_crop_milestone" */
  plot_crop_milestone_aggregate: Plot_Crop_Milestone_Aggregate;
  /** fetch data from the table: "plot_crop_milestone" using primary key columns */
  plot_crop_milestone_by_pk?: Maybe<Plot_Crop_Milestone>;
  /** fetch data from the table: "plot_crop_network" */
  plot_crop_network: Array<Plot_Crop_Network>;
  /** fetch aggregated fields from the table: "plot_crop_network" */
  plot_crop_network_aggregate: Plot_Crop_Network_Aggregate;
  /** fetch data from the table: "plot_crop_network" using primary key columns */
  plot_crop_network_by_pk?: Maybe<Plot_Crop_Network>;
  plot_crop_reference_by_codename?: Maybe<Scalars['String']>;
  plot_crop_search?: Maybe<Array<Maybe<PlotCropType>>>;
  plot_crop_transaction_categories?: Maybe<PlotCropTransactionCategoryTypes>;
  plot_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "plot_network" */
  plot_network: Array<Plot_Network>;
  /** fetch aggregated fields from the table: "plot_network" */
  plot_network_aggregate: Plot_Network_Aggregate;
  /** fetch data from the table: "plot_network" using primary key columns */
  plot_network_by_pk?: Maybe<Plot_Network>;
  /** fetch data from the table: "plot_risk_24hour" */
  plot_risk_24hour: Array<Plot_Risk_24hour>;
  /** fetch aggregated fields from the table: "plot_risk_24hour" */
  plot_risk_24hour_aggregate: Plot_Risk_24hour_Aggregate;
  plot_risk_metrics?: Maybe<Array<Maybe<PlotRiskTotalQuery>>>;
  /** fetch data from the table: "plot_risk_total" */
  plot_risk_total: Array<Plot_Risk_Total>;
  /** fetch aggregated fields from the table: "plot_risk_total" */
  plot_risk_total_aggregate: Plot_Risk_Total_Aggregate;
  /** fetch data from the table: "plot_status" */
  plot_status: Array<Plot_Status>;
  /** fetch aggregated fields from the table: "plot_status" */
  plot_status_aggregate: Plot_Status_Aggregate;
  /** fetch data from the table: "plot_status" using primary key columns */
  plot_status_by_pk?: Maybe<Plot_Status>;
  pop_config?: Maybe<Scalars['JSONScalar']>;
  pop_details?: Maybe<Scalars['JSONScalar']>;
  pop_for_plotcrop?: Maybe<Array<Maybe<Scalars['JSONScalar']>>>;
  /** fetch data from the table: "primary_growth_stage" */
  primary_growth_stage: Array<Primary_Growth_Stage>;
  /** fetch aggregated fields from the table: "primary_growth_stage" */
  primary_growth_stage_aggregate: Primary_Growth_Stage_Aggregate;
  /** fetch data from the table: "primary_growth_stage" using primary key columns */
  primary_growth_stage_by_pk?: Maybe<Primary_Growth_Stage>;
  /** fetch data from the table: "produce_insights" */
  produce_insights: Array<Produce_Insights>;
  /** fetch aggregated fields from the table: "produce_insights" */
  produce_insights_aggregate: Produce_Insights_Aggregate;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product_attachment" */
  product_attachment: Array<Product_Attachment>;
  /** fetch aggregated fields from the table: "product_attachment" */
  product_attachment_aggregate: Product_Attachment_Aggregate;
  /** fetch data from the table: "product_attachment" using primary key columns */
  product_attachment_by_pk?: Maybe<Product_Attachment>;
  /** fetch data from the table: "product_attribute" */
  product_attribute: Array<Product_Attribute>;
  /** fetch aggregated fields from the table: "product_attribute" */
  product_attribute_aggregate: Product_Attribute_Aggregate;
  /** fetch data from the table: "product_attribute" using primary key columns */
  product_attribute_by_pk?: Maybe<Product_Attribute>;
  /** fetch data from the table: "product_attribute_choice" */
  product_attribute_choice: Array<Product_Attribute_Choice>;
  /** fetch aggregated fields from the table: "product_attribute_choice" */
  product_attribute_choice_aggregate: Product_Attribute_Choice_Aggregate;
  /** fetch data from the table: "product_attribute_choice" using primary key columns */
  product_attribute_choice_by_pk?: Maybe<Product_Attribute_Choice>;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_certification" */
  product_certification: Array<Product_Certification>;
  /** fetch aggregated fields from the table: "product_certification" */
  product_certification_aggregate: Product_Certification_Aggregate;
  /** fetch data from the table: "product_certification_attachment" */
  product_certification_attachment: Array<Product_Certification_Attachment>;
  /** fetch aggregated fields from the table: "product_certification_attachment" */
  product_certification_attachment_aggregate: Product_Certification_Attachment_Aggregate;
  /** fetch data from the table: "product_certification_attachment" using primary key columns */
  product_certification_attachment_by_pk?: Maybe<Product_Certification_Attachment>;
  /** fetch data from the table: "product_certification" using primary key columns */
  product_certification_by_pk?: Maybe<Product_Certification>;
  /** fetch data from the table: "product_class" */
  product_class: Array<Product_Class>;
  /** fetch aggregated fields from the table: "product_class" */
  product_class_aggregate: Product_Class_Aggregate;
  /** fetch data from the table: "product_class" using primary key columns */
  product_class_by_pk?: Maybe<Product_Class>;
  /** fetch data from the table: "product_composition" */
  product_composition: Array<Product_Composition>;
  /** fetch aggregated fields from the table: "product_composition" */
  product_composition_aggregate: Product_Composition_Aggregate;
  /** fetch data from the table: "product_composition" using primary key columns */
  product_composition_by_pk?: Maybe<Product_Composition>;
  /** fetch data from the table: "product_crop_association" */
  product_crop_association: Array<Product_Crop_Association>;
  /** fetch aggregated fields from the table: "product_crop_association" */
  product_crop_association_aggregate: Product_Crop_Association_Aggregate;
  /** fetch data from the table: "product_crop_association" using primary key columns */
  product_crop_association_by_pk?: Maybe<Product_Crop_Association>;
  /** fetch data from the table: "product_crop_infestation_recommendation" */
  product_crop_infestation_recommendation: Array<Product_Crop_Infestation_Recommendation>;
  /** fetch aggregated fields from the table: "product_crop_infestation_recommendation" */
  product_crop_infestation_recommendation_aggregate: Product_Crop_Infestation_Recommendation_Aggregate;
  /** fetch data from the table: "product_crop_infestation_recommendation" using primary key columns */
  product_crop_infestation_recommendation_by_pk?: Maybe<Product_Crop_Infestation_Recommendation>;
  /** fetch data from the table: "product_crop_nutrition_recommendation" */
  product_crop_nutrition_recommendation: Array<Product_Crop_Nutrition_Recommendation>;
  /** fetch aggregated fields from the table: "product_crop_nutrition_recommendation" */
  product_crop_nutrition_recommendation_aggregate: Product_Crop_Nutrition_Recommendation_Aggregate;
  /** fetch data from the table: "product_crop_nutrition_recommendation" using primary key columns */
  product_crop_nutrition_recommendation_by_pk?: Maybe<Product_Crop_Nutrition_Recommendation>;
  /** fetch data from the table: "product_favourite" */
  product_favourite: Array<Product_Favourite>;
  /** fetch aggregated fields from the table: "product_favourite" */
  product_favourite_aggregate: Product_Favourite_Aggregate;
  /** fetch data from the table: "product_favourite" using primary key columns */
  product_favourite_by_pk?: Maybe<Product_Favourite>;
  /** fetch data from the table: "product_infestation" */
  product_infestation: Array<Product_Infestation>;
  /** fetch aggregated fields from the table: "product_infestation" */
  product_infestation_aggregate: Product_Infestation_Aggregate;
  /** fetch data from the table: "product_infestation" using primary key columns */
  product_infestation_by_pk?: Maybe<Product_Infestation>;
  /** fetch data from the table: "product_mainsection" */
  product_mainsection: Array<Product_Mainsection>;
  /** fetch aggregated fields from the table: "product_mainsection" */
  product_mainsection_aggregate: Product_Mainsection_Aggregate;
  /** fetch data from the table: "product_mainsection_attachment" */
  product_mainsection_attachment: Array<Product_Mainsection_Attachment>;
  /** fetch aggregated fields from the table: "product_mainsection_attachment" */
  product_mainsection_attachment_aggregate: Product_Mainsection_Attachment_Aggregate;
  /** fetch data from the table: "product_mainsection_attachment" using primary key columns */
  product_mainsection_attachment_by_pk?: Maybe<Product_Mainsection_Attachment>;
  /** fetch data from the table: "product_mainsection" using primary key columns */
  product_mainsection_by_pk?: Maybe<Product_Mainsection>;
  /** An array relationship */
  product_purchased: Array<Product_Purchased>;
  /** An aggregate relationship */
  product_purchased_aggregate: Product_Purchased_Aggregate;
  /** fetch data from the table: "product_purchased" using primary key columns */
  product_purchased_by_pk?: Maybe<Product_Purchased>;
  /** fetch data from the table: "product_section" */
  product_section: Array<Product_Section>;
  /** fetch aggregated fields from the table: "product_section" */
  product_section_aggregate: Product_Section_Aggregate;
  /** fetch data from the table: "product_section_attachment" */
  product_section_attachment: Array<Product_Section_Attachment>;
  /** fetch aggregated fields from the table: "product_section_attachment" */
  product_section_attachment_aggregate: Product_Section_Attachment_Aggregate;
  /** fetch data from the table: "product_section_attachment" using primary key columns */
  product_section_attachment_by_pk?: Maybe<Product_Section_Attachment>;
  /** fetch data from the table: "product_section" using primary key columns */
  product_section_by_pk?: Maybe<Product_Section>;
  /** fetch data from the table: "product_sku" */
  product_sku: Array<Product_Sku>;
  /** fetch aggregated fields from the table: "product_sku" */
  product_sku_aggregate: Product_Sku_Aggregate;
  /** fetch data from the table: "product_sku" using primary key columns */
  product_sku_by_pk?: Maybe<Product_Sku>;
  /** fetch data from the table: "product_subsection" */
  product_subsection: Array<Product_Subsection>;
  /** fetch aggregated fields from the table: "product_subsection" */
  product_subsection_aggregate: Product_Subsection_Aggregate;
  /** fetch data from the table: "product_subsection_attachment" */
  product_subsection_attachment: Array<Product_Subsection_Attachment>;
  /** fetch aggregated fields from the table: "product_subsection_attachment" */
  product_subsection_attachment_aggregate: Product_Subsection_Attachment_Aggregate;
  /** fetch data from the table: "product_subsection_attachment" using primary key columns */
  product_subsection_attachment_by_pk?: Maybe<Product_Subsection_Attachment>;
  /** fetch data from the table: "product_subsection" using primary key columns */
  product_subsection_by_pk?: Maybe<Product_Subsection>;
  /** fetch data from the table: "product_view" */
  product_view: Array<Product_View>;
  /** fetch aggregated fields from the table: "product_view" */
  product_view_aggregate: Product_View_Aggregate;
  /** fetch data from the table: "product_view" using primary key columns */
  product_view_by_pk?: Maybe<Product_View>;
  /** An array relationship */
  products: Array<Products>;
  /** An aggregate relationship */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table: "products_fertiliser" */
  products_fertiliser: Array<Products_Fertiliser>;
  /** fetch aggregated fields from the table: "products_fertiliser" */
  products_fertiliser_aggregate: Products_Fertiliser_Aggregate;
  /** fetch data from the table: "products_fertiliser" using primary key columns */
  products_fertiliser_by_pk?: Maybe<Products_Fertiliser>;
  /** An array relationship */
  products_fertiliser_contents: Array<Products_Fertiliser_Contents>;
  /** An aggregate relationship */
  products_fertiliser_contents_aggregate: Products_Fertiliser_Contents_Aggregate;
  /** fetch data from the table: "products_fertiliser_contents" using primary key columns */
  products_fertiliser_contents_by_pk?: Maybe<Products_Fertiliser_Contents>;
  /** An array relationship */
  products_fertiliser_units: Array<Products_Fertiliser_Units>;
  /** An aggregate relationship */
  products_fertiliser_units_aggregate: Products_Fertiliser_Units_Aggregate;
  /** fetch data from the table: "products_fertiliser_units" using primary key columns */
  products_fertiliser_units_by_pk?: Maybe<Products_Fertiliser_Units>;
  /** fetch data from the table: "products_pesticide" */
  products_pesticide: Array<Products_Pesticide>;
  /** fetch aggregated fields from the table: "products_pesticide" */
  products_pesticide_aggregate: Products_Pesticide_Aggregate;
  /** fetch data from the table: "products_pesticide" using primary key columns */
  products_pesticide_by_pk?: Maybe<Products_Pesticide>;
  /** An array relationship */
  products_pesticide_contents: Array<Products_Pesticide_Contents>;
  /** An aggregate relationship */
  products_pesticide_contents_aggregate: Products_Pesticide_Contents_Aggregate;
  /** fetch data from the table: "products_pesticide_contents" using primary key columns */
  products_pesticide_contents_by_pk?: Maybe<Products_Pesticide_Contents>;
  /** An array relationship */
  products_pesticide_units: Array<Products_Pesticide_Units>;
  /** An aggregate relationship */
  products_pesticide_units_aggregate: Products_Pesticide_Units_Aggregate;
  /** fetch data from the table: "products_pesticide_units" using primary key columns */
  products_pesticide_units_by_pk?: Maybe<Products_Pesticide_Units>;
  /** fetch data from the table: "provider" */
  provider: Array<Provider>;
  /** fetch aggregated fields from the table: "provider" */
  provider_aggregate: Provider_Aggregate;
  /** fetch data from the table: "provider" using primary key columns */
  provider_by_pk?: Maybe<Provider>;
  random_advice_authors?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "receipt" */
  receipt: Array<Receipt>;
  /** fetch aggregated fields from the table: "receipt" */
  receipt_aggregate: Receipt_Aggregate;
  /** fetch data from the table: "receipt" using primary key columns */
  receipt_by_pk?: Maybe<Receipt>;
  /** fetch data from the table: "recommended_product" */
  recommended_product: Array<Recommended_Product>;
  /** fetch aggregated fields from the table: "recommended_product" */
  recommended_product_aggregate: Recommended_Product_Aggregate;
  /** fetch data from the table: "recommended_product" using primary key columns */
  recommended_product_by_pk?: Maybe<Recommended_Product>;
  /** fetch data from the table: "region" */
  region: Array<Region>;
  /** fetch aggregated fields from the table: "region" */
  region_aggregate: Region_Aggregate;
  /** fetch data from the table: "region" using primary key columns */
  region_by_pk?: Maybe<Region>;
  /** fetch data from the table: "region_group" */
  region_group: Array<Region_Group>;
  /** fetch aggregated fields from the table: "region_group" */
  region_group_aggregate: Region_Group_Aggregate;
  /** fetch data from the table: "region_group" using primary key columns */
  region_group_by_pk?: Maybe<Region_Group>;
  registration_mutual_group_list?: Maybe<Array<Maybe<MutualGroupAggregationType>>>;
  registration_mutual_group_list_with_total?: Maybe<MutualGroupAggregationTypeWithTotal>;
  related_article_list?: Maybe<ArticleList>;
  /** fetch data from the table: "reward_configuration" */
  reward_configuration: Array<Reward_Configuration>;
  /** fetch aggregated fields from the table: "reward_configuration" */
  reward_configuration_aggregate: Reward_Configuration_Aggregate;
  /** fetch data from the table: "reward_configuration" using primary key columns */
  reward_configuration_by_pk?: Maybe<Reward_Configuration>;
  /** fetch data from the table: "sap_si" */
  sap_si: Array<Sap_Si>;
  /** fetch aggregated fields from the table: "sap_si" */
  sap_si_aggregate: Sap_Si_Aggregate;
  /** fetch data from the table: "sap_si" using primary key columns */
  sap_si_by_pk?: Maybe<Sap_Si>;
  /** fetch data from the table: "sap_si_map" */
  sap_si_map: Array<Sap_Si_Map>;
  /** fetch aggregated fields from the table: "sap_si_map" */
  sap_si_map_aggregate: Sap_Si_Map_Aggregate;
  /** fetch data from the table: "sap_si_map" using primary key columns */
  sap_si_map_by_pk?: Maybe<Sap_Si_Map>;
  school_categories?: Maybe<Array<Maybe<AdviceCategory>>>;
  /** execute function "search_base_users" which returns "base_user" */
  search_base_users: Array<Base_User>;
  /** execute function "search_base_users" and query aggregates on result of table type "base_user" */
  search_base_users_aggregate: Base_User_Aggregate;
  /** execute function "search_mutual_groups" which returns "mutual_group" */
  search_mutual_groups: Array<Mutual_Group>;
  /** execute function "search_mutual_groups" and query aggregates on result of table type "mutual_group" */
  search_mutual_groups_aggregate: Mutual_Group_Aggregate;
  /** execute function "search_plot_crops" which returns "plot_crop" */
  search_plot_crops: Array<Plot_Crop>;
  /** execute function "search_plot_crops" and query aggregates on result of table type "plot_crop" */
  search_plot_crops_aggregate: Plot_Crop_Aggregate;
  /** fetch data from the table: "secondary_growth_stage" */
  secondary_growth_stage: Array<Secondary_Growth_Stage>;
  /** fetch aggregated fields from the table: "secondary_growth_stage" */
  secondary_growth_stage_aggregate: Secondary_Growth_Stage_Aggregate;
  /** fetch data from the table: "secondary_growth_stage" using primary key columns */
  secondary_growth_stage_by_pk?: Maybe<Secondary_Growth_Stage>;
  /** fetch data from the table: "section" */
  section: Array<Section>;
  /** fetch aggregated fields from the table: "section" */
  section_aggregate: Section_Aggregate;
  /** fetch data from the table: "section" using primary key columns */
  section_by_pk?: Maybe<Section>;
  /** fetch data from the table: "seeds" */
  seeds: Array<Seeds>;
  /** fetch aggregated fields from the table: "seeds" */
  seeds_aggregate: Seeds_Aggregate;
  /** fetch data from the table: "seeds" using primary key columns */
  seeds_by_pk?: Maybe<Seeds>;
  /** fetch data from the table: "sellable_item" */
  sellable_item: Array<Sellable_Item>;
  /** fetch aggregated fields from the table: "sellable_item" */
  sellable_item_aggregate: Sellable_Item_Aggregate;
  /** fetch data from the table: "sellable_item" using primary key columns */
  sellable_item_by_pk?: Maybe<Sellable_Item>;
  /** fetch data from the table: "sellable_item_stock" */
  sellable_item_stock: Array<Sellable_Item_Stock>;
  /** fetch aggregated fields from the table: "sellable_item_stock" */
  sellable_item_stock_aggregate: Sellable_Item_Stock_Aggregate;
  /** fetch data from the table: "sellable_item_stock" using primary key columns */
  sellable_item_stock_by_pk?: Maybe<Sellable_Item_Stock>;
  sellable_item_stock_detail?: Maybe<SellableItemStockGlType>;
  seller_hash?: Maybe<Scalars['String']>;
  /** fetch data from the table: "sensor" */
  sensor: Array<Sensor>;
  /** fetch aggregated fields from the table: "sensor" */
  sensor_aggregate: Sensor_Aggregate;
  /** fetch data from the table: "sensor" using primary key columns */
  sensor_by_pk?: Maybe<Sensor>;
  /** fetch data from the table: "sensor_parameter" */
  sensor_parameter: Array<Sensor_Parameter>;
  /** fetch aggregated fields from the table: "sensor_parameter" */
  sensor_parameter_aggregate: Sensor_Parameter_Aggregate;
  /** fetch data from the table: "sensor_parameter" using primary key columns */
  sensor_parameter_by_pk?: Maybe<Sensor_Parameter>;
  /** An array relationship */
  series: Array<Series>;
  /** An aggregate relationship */
  series_aggregate: Series_Aggregate;
  /** An array relationship */
  series_authors: Array<Series_Authors>;
  /** An aggregate relationship */
  series_authors_aggregate: Series_Authors_Aggregate;
  /** fetch data from the table: "series_authors" using primary key columns */
  series_authors_by_pk?: Maybe<Series_Authors>;
  /** fetch data from the table: "series" using primary key columns */
  series_by_pk?: Maybe<Series>;
  /** fetch data from the table: "series_category" */
  series_category: Array<Series_Category>;
  /** fetch aggregated fields from the table: "series_category" */
  series_category_aggregate: Series_Category_Aggregate;
  /** fetch data from the table: "series_category" using primary key columns */
  series_category_by_pk?: Maybe<Series_Category>;
  series_crop_list?: Maybe<Array<Maybe<CropList>>>;
  /** An array relationship */
  series_crops: Array<Series_Crops>;
  /** An aggregate relationship */
  series_crops_aggregate: Series_Crops_Aggregate;
  /** fetch data from the table: "series_crops" using primary key columns */
  series_crops_by_pk?: Maybe<Series_Crops>;
  /** An array relationship */
  series_favorites: Array<Series_Favorites>;
  /** An aggregate relationship */
  series_favorites_aggregate: Series_Favorites_Aggregate;
  /** fetch data from the table: "series_favorites" using primary key columns */
  series_favorites_by_pk?: Maybe<Series_Favorites>;
  series_lecture_list?: Maybe<SeriesLectureList>;
  /** An array relationship */
  series_likes: Array<Series_Likes>;
  /** An aggregate relationship */
  series_likes_aggregate: Series_Likes_Aggregate;
  /** fetch data from the table: "series_likes" using primary key columns */
  series_likes_by_pk?: Maybe<Series_Likes>;
  series_list?: Maybe<SeriesList>;
  /** fetch data from the table: "shared_entity" */
  setu_trade_shared_entity: Array<Setu_Trade_Shared_Entity>;
  /** fetch data from the table: "shared_entity" using primary key columns */
  setu_trade_shared_entity_by_pk?: Maybe<Setu_Trade_Shared_Entity>;
  /** fetch data from the table: "setu_weather_user" */
  setu_weather_user: Array<Setu_Weather_User>;
  /** fetch aggregated fields from the table: "setu_weather_user" */
  setu_weather_user_aggregate: Setu_Weather_User_Aggregate;
  /** fetch data from the table: "setu_weather_user" using primary key columns */
  setu_weather_user_by_pk?: Maybe<Setu_Weather_User>;
  /** fetch data from the table: "shared_entity" */
  shared_entity: Array<Shared_Entity>;
  /** fetch aggregated fields from the table: "shared_entity" */
  shared_entity_aggregate: Shared_Entity_Aggregate;
  /** fetch data from the table: "shared_entity" using primary key columns */
  shared_entity_by_pk?: Maybe<Shared_Entity>;
  /** fetch data from the table: "si_unit" */
  si_unit: Array<Si_Unit>;
  /** fetch aggregated fields from the table: "si_unit" */
  si_unit_aggregate: Si_Unit_Aggregate;
  /** fetch data from the table: "si_unit" using primary key columns */
  si_unit_by_pk?: Maybe<Si_Unit>;
  /** fetch data from the table: "si_unit_measure" */
  si_unit_measure: Array<Si_Unit_Measure>;
  /** fetch aggregated fields from the table: "si_unit_measure" */
  si_unit_measure_aggregate: Si_Unit_Measure_Aggregate;
  /** fetch data from the table: "si_unit_measure" using primary key columns */
  si_unit_measure_by_pk?: Maybe<Si_Unit_Measure>;
  signed_url?: Maybe<Scalars['String']>;
  /** fetch data from the table: "sku" */
  sku: Array<Sku>;
  /** fetch aggregated fields from the table: "sku" */
  sku_aggregate: Sku_Aggregate;
  /** fetch data from the table: "sku" using primary key columns */
  sku_by_pk?: Maybe<Sku>;
  /** fetch data from the table: "sku_kind" */
  sku_kind: Array<Sku_Kind>;
  /** fetch aggregated fields from the table: "sku_kind" */
  sku_kind_aggregate: Sku_Kind_Aggregate;
  /** fetch data from the table: "sku_kind" using primary key columns */
  sku_kind_by_pk?: Maybe<Sku_Kind>;
  /** fetch data from the table: "soil" */
  soil: Array<Soil>;
  /** fetch aggregated fields from the table: "soil" */
  soil_aggregate: Soil_Aggregate;
  /** fetch data from the table: "soil" using primary key columns */
  soil_by_pk?: Maybe<Soil>;
  /** fetch data from the table: "sprinkler_irrigation_system" */
  sprinkler_irrigation_system: Array<Sprinkler_Irrigation_System>;
  /** fetch aggregated fields from the table: "sprinkler_irrigation_system" */
  sprinkler_irrigation_system_aggregate: Sprinkler_Irrigation_System_Aggregate;
  /** fetch data from the table: "sprinkler_irrigation_system" using primary key columns */
  sprinkler_irrigation_system_by_pk?: Maybe<Sprinkler_Irrigation_System>;
  /** fetch data from the table: "sub_section" */
  sub_section: Array<Sub_Section>;
  /** fetch aggregated fields from the table: "sub_section" */
  sub_section_aggregate: Sub_Section_Aggregate;
  /** fetch data from the table: "sub_section" using primary key columns */
  sub_section_by_pk?: Maybe<Sub_Section>;
  /** fetch data from the table: "subcategory" */
  subcategory: Array<Subcategory>;
  /** fetch aggregated fields from the table: "subcategory" */
  subcategory_aggregate: Subcategory_Aggregate;
  /** fetch data from the table: "subcategory" using primary key columns */
  subcategory_by_pk?: Maybe<Subcategory>;
  /** An array relationship */
  subscription_package_highlights: Array<Subscription_Package_Highlights>;
  /** An aggregate relationship */
  subscription_package_highlights_aggregate: Subscription_Package_Highlights_Aggregate;
  /** fetch data from the table: "subscription_package_highlights" using primary key columns */
  subscription_package_highlights_by_pk?: Maybe<Subscription_Package_Highlights>;
  /** fetch data from the table: "summary_sensor_reading" */
  summary_sensor_reading: Array<Summary_Sensor_Reading>;
  /** fetch aggregated fields from the table: "summary_sensor_reading" */
  summary_sensor_reading_aggregate: Summary_Sensor_Reading_Aggregate;
  /** fetch data from the table: "summary_sensor_reading" using primary key columns */
  summary_sensor_reading_by_pk?: Maybe<Summary_Sensor_Reading>;
  supplier_groups_plot_aggreagte?: Maybe<Array<Maybe<AggregateSupplierGroupPlot>>>;
  supplier_plot_aggreagte?: Maybe<Array<Maybe<MutualGroupMembersipType>>>;
  team_document_count?: Maybe<Scalars['Int']>;
  /** fetch data from the table: "thread" */
  thread: Array<Thread>;
  /** fetch aggregated fields from the table: "thread" */
  thread_aggregate: Thread_Aggregate;
  /** fetch data from the table: "thread" using primary key columns */
  thread_by_pk?: Maybe<Thread>;
  total_article_metrics?: Maybe<Array<Maybe<TotalArticleMetrics>>>;
  total_series_count?: Maybe<TotalMetrics>;
  total_series_favorites?: Maybe<TotalMetrics>;
  total_series_likes?: Maybe<TotalMetrics>;
  total_series_views?: Maybe<TotalMetrics>;
  /** fetch data from the table: "trade" */
  trade: Array<Trade>;
  /** fetch data from the table: "action_log" */
  trade_action_log: Array<Trade_Action_Log>;
  /** fetch data from the table: "action_log" using primary key columns */
  trade_action_log_by_pk?: Maybe<Trade_Action_Log>;
  /** fetch aggregated fields from the table: "trade" */
  trade_aggregate: Trade_Aggregate;
  /** fetch data from the table: "trade" using primary key columns */
  trade_by_pk?: Maybe<Trade>;
  /** fetch data from the table: "trade_commodity" */
  trade_commodity: Array<Trade_Commodity>;
  /** fetch aggregated fields from the table: "trade_commodity" */
  trade_commodity_aggregate: Trade_Commodity_Aggregate;
  /** fetch data from the table: "trade_commodity" using primary key columns */
  trade_commodity_by_pk?: Maybe<Trade_Commodity>;
  trade_grade_quantity_summary?: Maybe<Array<Maybe<TradeGradeSummarySchema>>>;
  trade_grade_quantity_summary_report?: Maybe<TradeGradeSummaryReportSchema>;
  trade_highlights?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "trade_item" */
  trade_item: Array<Trade_Item>;
  /** fetch aggregated fields from the table: "trade_item" */
  trade_item_aggregate: Trade_Item_Aggregate;
  /** fetch data from the table: "trade_item" using primary key columns */
  trade_item_by_pk?: Maybe<Trade_Item>;
  /** fetch data from the table: "trade_region" */
  trade_region: Array<Trade_Region>;
  /** fetch aggregated fields from the table: "trade_region" */
  trade_region_aggregate: Trade_Region_Aggregate;
  /** fetch data from the table: "trade_region" using primary key columns */
  trade_region_by_pk?: Maybe<Trade_Region>;
  /** fetch data from the table: "trade_status" */
  trade_status: Array<Trade_Status>;
  /** fetch data from the table: "trade_status" using primary key columns */
  trade_status_by_pk?: Maybe<Trade_Status>;
  trade_tnc_template_detail?: Maybe<OrganisationTradeTnCsTemplateSchema>;
  trade_tnc_versions?: Maybe<Array<Maybe<OrganisationTradeTnCsVersionSchema>>>;
  /** fetch data from the table: "trade_tradestatusaccess" */
  trade_tradestatusaccess: Array<Trade_Tradestatusaccess>;
  /** fetch data from the table: "trade_tradestatusaccess" using primary key columns */
  trade_tradestatusaccess_by_pk?: Maybe<Trade_Tradestatusaccess>;
  /** fetch data from the table: "trade_transaction" */
  trade_transaction: Array<Trade_Transaction>;
  /** fetch aggregated fields from the table: "trade_transaction" */
  trade_transaction_aggregate: Trade_Transaction_Aggregate;
  /** fetch data from the table: "trade_transaction" using primary key columns */
  trade_transaction_by_pk?: Maybe<Trade_Transaction>;
  /** fetch data from the table: "trade_transaction_summary" */
  trade_transaction_summary: Array<Trade_Transaction_Summary>;
  /** fetch aggregated fields from the table: "trade_transaction_summary" */
  trade_transaction_summary_aggregate: Trade_Transaction_Summary_Aggregate;
  /** fetch data from the table: "trade_transaction_summary" using primary key columns */
  trade_transaction_summary_by_pk?: Maybe<Trade_Transaction_Summary>;
  /** fetch data from the table: "trade_unit" */
  trade_unit: Array<Trade_Unit>;
  /** fetch aggregated fields from the table: "trade_unit" */
  trade_unit_aggregate: Trade_Unit_Aggregate;
  /** fetch data from the table: "trade_unit" using primary key columns */
  trade_unit_by_pk?: Maybe<Trade_Unit>;
  /** fetch data from the table: "transaction_trend" */
  transaction_trend: Array<Transaction_Trend>;
  /** fetch aggregated fields from the table: "transaction_trend" */
  transaction_trend_aggregate: Transaction_Trend_Aggregate;
  /** fetch data from the table: "transaction_trend" using primary key columns */
  transaction_trend_by_pk?: Maybe<Transaction_Trend>;
  trending_metrics_article_author_favorites?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_article_author_likes?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_article_author_views?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_article_category_favorites?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_article_category_likes?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_article_category_views?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_article_favorites?: Maybe<Array<Maybe<TrendingArticleMetrics>>>;
  trending_metrics_article_likes?: Maybe<Array<Maybe<TrendingArticleMetrics>>>;
  trending_metrics_article_users_favorites?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_article_users_likes?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_article_users_views?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_article_views?: Maybe<Array<Maybe<TrendingArticleMetrics>>>;
  trending_metrics_series_author_favorites?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_author_likes?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_author_views?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_category_favorites?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_category_likes?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_category_views?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_favorites?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_likes?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_user_favorites?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_user_likes?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_user_subscription?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_user_views?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trending_metrics_series_views?: Maybe<Array<Maybe<TrendingMetrics>>>;
  trip_detail?: Maybe<TripGlType>;
  tutorials?: Maybe<Array<Maybe<TutorialType>>>;
  tutorials_and_terms?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "unit" */
  unit: Array<Unit>;
  /** fetch aggregated fields from the table: "unit" */
  unit_aggregate: Unit_Aggregate;
  /** fetch data from the table: "unit" using primary key columns */
  unit_by_pk?: Maybe<Unit>;
  user_accounts?: Maybe<Array<Maybe<AccountGlType>>>;
  /** An array relationship */
  user_answer_choices: Array<User_Answer_Choices>;
  /** An aggregate relationship */
  user_answer_choices_aggregate: User_Answer_Choices_Aggregate;
  /** fetch data from the table: "user_answer_choices" using primary key columns */
  user_answer_choices_by_pk?: Maybe<User_Answer_Choices>;
  /** fetch data from the table: "user_assessment_attempt" */
  user_assessment_attempt: Array<User_Assessment_Attempt>;
  /** fetch aggregated fields from the table: "user_assessment_attempt" */
  user_assessment_attempt_aggregate: User_Assessment_Attempt_Aggregate;
  /** fetch data from the table: "user_assessment_attempt" using primary key columns */
  user_assessment_attempt_by_pk?: Maybe<User_Assessment_Attempt>;
  /** fetch data from the table: "user_assessment_question_response" */
  user_assessment_question_response: Array<User_Assessment_Question_Response>;
  /** fetch aggregated fields from the table: "user_assessment_question_response" */
  user_assessment_question_response_aggregate: User_Assessment_Question_Response_Aggregate;
  /** fetch data from the table: "user_assessment_question_response" using primary key columns */
  user_assessment_question_response_by_pk?: Maybe<User_Assessment_Question_Response>;
  user_permission_groups?: Maybe<Array<Maybe<UserGroupType>>>;
  /** fetch data from the table: "user_reward_history" */
  user_reward_history: Array<User_Reward_History>;
  /** fetch aggregated fields from the table: "user_reward_history" */
  user_reward_history_aggregate: User_Reward_History_Aggregate;
  /** fetch data from the table: "user_reward_history" using primary key columns */
  user_reward_history_by_pk?: Maybe<User_Reward_History>;
  /** fetch data from the table: "user_subscription_package" */
  user_subscription_package: Array<User_Subscription_Package>;
  /** fetch aggregated fields from the table: "user_subscription_package" */
  user_subscription_package_aggregate: User_Subscription_Package_Aggregate;
  /** fetch data from the table: "user_subscription_package" using primary key columns */
  user_subscription_package_by_pk?: Maybe<User_Subscription_Package>;
  /** fetch data from the table: "variety_grade" */
  variety_grade: Array<Variety_Grade>;
  /** fetch aggregated fields from the table: "variety_grade" */
  variety_grade_aggregate: Variety_Grade_Aggregate;
  /** fetch data from the table: "variety_grade" using primary key columns */
  variety_grade_by_pk?: Maybe<Variety_Grade>;
  /** fetch data from the table: "variety_grade_photos" */
  variety_grade_photos: Array<Variety_Grade_Photos>;
  /** fetch aggregated fields from the table: "variety_grade_photos" */
  variety_grade_photos_aggregate: Variety_Grade_Photos_Aggregate;
  /** fetch data from the table: "variety_grade_photos" using primary key columns */
  variety_grade_photos_by_pk?: Maybe<Variety_Grade_Photos>;
  /** fetch data from the table: "variety_group" */
  variety_group: Array<Variety_Group>;
  /** fetch aggregated fields from the table: "variety_group" */
  variety_group_aggregate: Variety_Group_Aggregate;
  /** fetch data from the table: "variety_group" using primary key columns */
  variety_group_by_pk?: Maybe<Variety_Group>;
  vehicle_detail?: Maybe<VehicleGlType>;
  /** fetch data from the table: "weather_location" */
  weather_location: Array<Weather_Location>;
  /** fetch aggregated fields from the table: "weather_location" */
  weather_location_aggregate: Weather_Location_Aggregate;
  /** fetch data from the table: "weather_location" using primary key columns */
  weather_location_by_pk?: Maybe<Weather_Location>;
  /** fetch data from the table: "weather_reference" */
  weather_reference: Array<Weather_Reference>;
  /** fetch aggregated fields from the table: "weather_reference" */
  weather_reference_aggregate: Weather_Reference_Aggregate;
  /** fetch data from the table: "weather_reference" using primary key columns */
  weather_reference_by_pk?: Maybe<Weather_Reference>;
};


export type Query_RootAction_LogArgs = {
  distinct_on?: InputMaybe<Array<Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Action_Log_Order_By>>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};


export type Query_RootAction_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Action_Log_Order_By>>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};


export type Query_RootAction_Log_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootActive_IngredientArgs = {
  distinct_on?: InputMaybe<Array<Active_Ingredient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Ingredient_Order_By>>;
  where?: InputMaybe<Active_Ingredient_Bool_Exp>;
};


export type Query_RootActive_Ingredient_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_Ingredient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Ingredient_Order_By>>;
  where?: InputMaybe<Active_Ingredient_Bool_Exp>;
};


export type Query_RootActive_Ingredient_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootActual_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Actual_Reading_Order_By>>;
  where?: InputMaybe<Actual_Reading_Bool_Exp>;
};


export type Query_RootActual_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Actual_Reading_Order_By>>;
  where?: InputMaybe<Actual_Reading_Bool_Exp>;
};


export type Query_RootActual_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAdvice_Author_FollowersArgs = {
  distinct_on?: InputMaybe<Array<Advice_Author_Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Author_Followers_Order_By>>;
  where?: InputMaybe<Advice_Author_Followers_Bool_Exp>;
};


export type Query_RootAdvice_Author_Followers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advice_Author_Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Author_Followers_Order_By>>;
  where?: InputMaybe<Advice_Author_Followers_Bool_Exp>;
};


export type Query_RootAdvice_Author_Followers_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootAdvice_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Advice_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Authors_Order_By>>;
  where?: InputMaybe<Advice_Authors_Bool_Exp>;
};


export type Query_RootAdvice_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advice_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Authors_Order_By>>;
  where?: InputMaybe<Advice_Authors_Bool_Exp>;
};


export type Query_RootAdvice_Authors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAdvice_CategoriesArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootAgentArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


export type Query_RootAgent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


export type Query_RootAgent_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgent_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


export type Query_RootAgent_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


export type Query_RootAgent_Company_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgronomist_Plot_Crop_Diary_By_IdArgs = {
  id: Scalars['String'];
};


export type Query_RootAgronomist_Plot_Crop_Diary_ListArgs = {
  from_date?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['JSONScalar']>>>;
  plot_crop_codename: Scalars['String'];
  till_date?: InputMaybe<Scalars['Date']>;
};


export type Query_RootAll_BookingsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  department_id?: InputMaybe<Scalars['ID']>;
  department_kite_codename?: InputMaybe<Scalars['String']>;
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<BookingGlFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_Distribution_CentresArgs = {
  filter?: InputMaybe<DistributionCentreGlFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_DocksArgs = {
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<DockFilterGlInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_InwardsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<InwardInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_My_OrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootAll_My_Plot_SummarysArgs = {
  filter?: InputMaybe<PlotCommodityFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_Sellable_Item_StocksArgs = {
  filter?: InputMaybe<MySellableItemStockFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_TripsArgs = {
  department_id?: InputMaybe<Scalars['ID']>;
  department_kite_codename?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TripGlFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_VehiclesArgs = {
  filter?: InputMaybe<VehicleGlInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAnswer_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Answer_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Answer_Choice_Order_By>>;
  where?: InputMaybe<Answer_Choice_Bool_Exp>;
};


export type Query_RootAnswer_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Answer_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Answer_Choice_Order_By>>;
  where?: InputMaybe<Answer_Choice_Bool_Exp>;
};


export type Query_RootAnswer_Choice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootApplication_Product_UnitArgs = {
  distinct_on?: InputMaybe<Array<Application_Product_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Product_Unit_Order_By>>;
  where?: InputMaybe<Application_Product_Unit_Bool_Exp>;
};


export type Query_RootApplication_Product_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Product_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Product_Unit_Order_By>>;
  where?: InputMaybe<Application_Product_Unit_Bool_Exp>;
};


export type Query_RootApplication_Product_Unit_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticleArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Query_RootArticle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Query_RootArticle_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Article_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Attachments_Order_By>>;
  where?: InputMaybe<Article_Attachments_Bool_Exp>;
};


export type Query_RootArticle_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Attachments_Order_By>>;
  where?: InputMaybe<Article_Attachments_Bool_Exp>;
};


export type Query_RootArticle_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_Author_Favorite_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_Favorite_Insights_Bool_Exp>;
};


export type Query_RootArticle_Author_Favorite_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_Favorite_Insights_Bool_Exp>;
};


export type Query_RootArticle_Author_Like_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_Like_Insights_Bool_Exp>;
};


export type Query_RootArticle_Author_Like_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_Like_Insights_Bool_Exp>;
};


export type Query_RootArticle_Author_View_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_View_Insights_Bool_Exp>;
};


export type Query_RootArticle_Author_View_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_View_Insights_Bool_Exp>;
};


export type Query_RootArticle_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Article_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Authors_Order_By>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


export type Query_RootArticle_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Authors_Order_By>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


export type Query_RootArticle_Authors_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootArticle_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Categories_Order_By>>;
  where?: InputMaybe<Article_Categories_Bool_Exp>;
};


export type Query_RootArticle_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Categories_Order_By>>;
  where?: InputMaybe<Article_Categories_Bool_Exp>;
};


export type Query_RootArticle_Categories_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Article_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Category_Order_By>>;
  where?: InputMaybe<Article_Category_Bool_Exp>;
};


export type Query_RootArticle_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Category_Order_By>>;
  where?: InputMaybe<Article_Category_Bool_Exp>;
};


export type Query_RootArticle_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootArticle_Crop_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Categories_Order_By>>;
  where?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
};


export type Query_RootArticle_Crop_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Categories_Order_By>>;
  where?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
};


export type Query_RootArticle_Crop_Categories_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_Crop_ListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['JSONScalar']>>>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootArticle_Crop_VarietiesArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Varieties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Varieties_Order_By>>;
  where?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
};


export type Query_RootArticle_Crop_Varieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Varieties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Varieties_Order_By>>;
  where?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
};


export type Query_RootArticle_Crop_Varieties_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_CropsArgs = {
  distinct_on?: InputMaybe<Array<Article_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crops_Order_By>>;
  where?: InputMaybe<Article_Crops_Bool_Exp>;
};


export type Query_RootArticle_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crops_Order_By>>;
  where?: InputMaybe<Article_Crops_Bool_Exp>;
};


export type Query_RootArticle_Crops_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_Detail_Trending_MetricsArgs = {
  id: Scalars['String'];
};


export type Query_RootArticle_DetailsArgs = {
  id: Scalars['String'];
};


export type Query_RootArticle_Favorite_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Favorite_Insights_Bool_Exp>;
};


export type Query_RootArticle_Favorite_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Favorite_Insights_Bool_Exp>;
};


export type Query_RootArticle_FavoritesArgs = {
  distinct_on?: InputMaybe<Array<Article_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Favorites_Order_By>>;
  where?: InputMaybe<Article_Favorites_Bool_Exp>;
};


export type Query_RootArticle_Favorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Favorites_Order_By>>;
  where?: InputMaybe<Article_Favorites_Bool_Exp>;
};


export type Query_RootArticle_Favorites_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_Like_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Like_Insights_Bool_Exp>;
};


export type Query_RootArticle_Like_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Like_Insights_Bool_Exp>;
};


export type Query_RootArticle_LikesArgs = {
  distinct_on?: InputMaybe<Array<Article_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Likes_Order_By>>;
  where?: InputMaybe<Article_Likes_Bool_Exp>;
};


export type Query_RootArticle_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Likes_Order_By>>;
  where?: InputMaybe<Article_Likes_Bool_Exp>;
};


export type Query_RootArticle_Likes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_ListArgs = {
  article_type?: InputMaybe<Scalars['String']>;
  author_ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  category_ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  crop_ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  is_bookmarked?: InputMaybe<Scalars['Boolean']>;
  is_recently_added?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['JSONScalar']>>>;
  package_ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  publish_date_from?: InputMaybe<Scalars['Date']>;
  publish_date_till?: InputMaybe<Scalars['Date']>;
  region_ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  related_article_id?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type Query_RootArticle_RegionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Regions_Order_By>>;
  where?: InputMaybe<Article_Regions_Bool_Exp>;
};


export type Query_RootArticle_Regions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Regions_Order_By>>;
  where?: InputMaybe<Article_Regions_Bool_Exp>;
};


export type Query_RootArticle_Regions_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_SeriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


export type Query_RootArticle_Series_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


export type Query_RootArticle_Series_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootArticle_Series_Favourite_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Favourite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Favourite_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_Favourite_Insights_Bool_Exp>;
};


export type Query_RootArticle_Series_Favourite_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Favourite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Favourite_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_Favourite_Insights_Bool_Exp>;
};


export type Query_RootArticle_Series_Like_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_Like_Insights_Bool_Exp>;
};


export type Query_RootArticle_Series_Like_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_Like_Insights_Bool_Exp>;
};


export type Query_RootArticle_Series_View_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_View_Insights_Bool_Exp>;
};


export type Query_RootArticle_Series_View_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_View_Insights_Bool_Exp>;
};


export type Query_RootArticle_Subscription_Favorite_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_Favorite_Insights_Bool_Exp>;
};


export type Query_RootArticle_Subscription_Favorite_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_Favorite_Insights_Bool_Exp>;
};


export type Query_RootArticle_Subscription_Like_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_Like_Insights_Bool_Exp>;
};


export type Query_RootArticle_Subscription_Like_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_Like_Insights_Bool_Exp>;
};


export type Query_RootArticle_Subscription_PackageArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Package_Order_By>>;
  where?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
};


export type Query_RootArticle_Subscription_Package_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Package_Order_By>>;
  where?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
};


export type Query_RootArticle_Subscription_Package_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootArticle_Subscription_View_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_View_Insights_Bool_Exp>;
};


export type Query_RootArticle_Subscription_View_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_View_Insights_Bool_Exp>;
};


export type Query_RootArticle_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscriptions_Order_By>>;
  where?: InputMaybe<Article_Subscriptions_Bool_Exp>;
};


export type Query_RootArticle_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscriptions_Order_By>>;
  where?: InputMaybe<Article_Subscriptions_Bool_Exp>;
};


export type Query_RootArticle_Subscriptions_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_User_GroupArgs = {
  distinct_on?: InputMaybe<Array<Article_User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_User_Group_Order_By>>;
  where?: InputMaybe<Article_User_Group_Bool_Exp>;
};


export type Query_RootArticle_User_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_User_Group_Order_By>>;
  where?: InputMaybe<Article_User_Group_Bool_Exp>;
};


export type Query_RootArticle_User_Group_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticle_View_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_View_Insights_Order_By>>;
  where?: InputMaybe<Article_View_Insights_Bool_Exp>;
};


export type Query_RootArticle_View_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_View_Insights_Order_By>>;
  where?: InputMaybe<Article_View_Insights_Bool_Exp>;
};


export type Query_RootArticle_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Article_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Views_Order_By>>;
  where?: InputMaybe<Article_Views_Bool_Exp>;
};


export type Query_RootArticle_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Views_Order_By>>;
  where?: InputMaybe<Article_Views_Bool_Exp>;
};


export type Query_RootArticle_Views_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootArticles_In_ProgressArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAssessmentArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Order_By>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


export type Query_RootAssessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Order_By>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


export type Query_RootAssessment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAssessment_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Question_Order_By>>;
  where?: InputMaybe<Assessment_Question_Bool_Exp>;
};


export type Query_RootAssessment_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Question_Order_By>>;
  where?: InputMaybe<Assessment_Question_Bool_Exp>;
};


export type Query_RootAssessment_Question_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAttributeArgs = {
  distinct_on?: InputMaybe<Array<Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attribute_Order_By>>;
  where?: InputMaybe<Attribute_Bool_Exp>;
};


export type Query_RootAttribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attribute_Order_By>>;
  where?: InputMaybe<Attribute_Bool_Exp>;
};


export type Query_RootAttribute_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAttribute_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attribute_Choice_Order_By>>;
  where?: InputMaybe<Attribute_Choice_Bool_Exp>;
};


export type Query_RootAttribute_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attribute_Choice_Order_By>>;
  where?: InputMaybe<Attribute_Choice_Bool_Exp>;
};


export type Query_RootAttribute_Choice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Query_RootAuth_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Query_RootAuth_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuth_Group_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type Query_RootAuth_Group_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type Query_RootAuth_Group_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuth_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type Query_RootAuth_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type Query_RootAuth_Permission_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuthor_DetailsArgs = {
  author_id: Scalars['String'];
};


export type Query_RootBackfill_Operational_CostsArgs = {
  commit: Scalars['Boolean'];
};


export type Query_RootBase_UserArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Query_RootBase_User_Address_BookArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


export type Query_RootBase_User_Address_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


export type Query_RootBase_User_Address_Book_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Query_RootBase_User_By_GroupArgs = {
  distribution_centre_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Query_RootBase_User_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


export type Query_RootBase_User_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


export type Query_RootBase_User_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


export type Query_RootBase_User_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


export type Query_RootBase_User_Departments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_DocumentsArgs = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootBase_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


export type Query_RootBase_User_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


export type Query_RootBase_User_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


export type Query_RootBase_User_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


export type Query_RootBase_User_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_Payment_DetailsArgs = {
  base_user_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootBase_User_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


export type Query_RootBase_User_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


export type Query_RootBase_User_User_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBasic_Trade_DetailsArgs = {
  trade_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootBooking_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootBusinessArgs = {
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Query_RootBusiness_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Query_RootBusiness_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_Commodities_SuppliedArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


export type Query_RootBusiness_Commodities_Supplied_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


export type Query_RootBusiness_Commodities_Supplied_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


export type Query_RootBusiness_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


export type Query_RootBusiness_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_DocumentsArgs = {
  business_id?: InputMaybe<Scalars['Int']>;
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootBusiness_GroupArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Query_RootBusiness_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Query_RootBusiness_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_Group_DocumentsArgs = {
  business_group_id?: InputMaybe<Scalars['Int']>;
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootBusiness_Group_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


export type Query_RootBusiness_Group_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


export type Query_RootBusiness_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


export type Query_RootBusiness_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


export type Query_RootBusiness_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


export type Query_RootBusiness_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


export type Query_RootBusiness_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_Payment_DetailsArgs = {
  business_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootBusiness_Secondary_PocsArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


export type Query_RootBusiness_Secondary_Pocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


export type Query_RootBusiness_Secondary_Pocs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBuyer_HashArgs = {
  trade_id: Scalars['ID'];
};


export type Query_RootCare_Shared_EntityArgs = {
  distinct_on?: InputMaybe<Array<Care_Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Care_Shared_Entity_Order_By>>;
  where?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
};


export type Query_RootCare_Shared_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Care_Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Care_Shared_Entity_Order_By>>;
  where?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
};


export type Query_RootCare_Shared_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootCategoryArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Query_RootCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Query_RootCategory_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCertificate_IssuerArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Issuer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Issuer_Order_By>>;
  where?: InputMaybe<Certificate_Issuer_Bool_Exp>;
};


export type Query_RootCertificate_Issuer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Issuer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Issuer_Order_By>>;
  where?: InputMaybe<Certificate_Issuer_Bool_Exp>;
};


export type Query_RootCertificate_Issuer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCertificationArgs = {
  distinct_on?: InputMaybe<Array<Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certification_Order_By>>;
  where?: InputMaybe<Certification_Bool_Exp>;
};


export type Query_RootCertification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certification_Order_By>>;
  where?: InputMaybe<Certification_Bool_Exp>;
};


export type Query_RootCertification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCommentArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Query_RootComment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Query_RootComment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCommodityArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


export type Query_RootCommodity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


export type Query_RootCommodity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCommodity_ParametersArgs = {
  commodity_trade_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootCommodity_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


export type Query_RootCommodity_Variety_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


export type Query_RootCommodity_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCommodity_Variety_Secondary_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


export type Query_RootCommodity_Variety_Secondary_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


export type Query_RootCommodity_Variety_Secondary_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCommon_FileuploadArgs = {
  distinct_on?: InputMaybe<Array<Common_Fileupload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Fileupload_Order_By>>;
  where?: InputMaybe<Common_Fileupload_Bool_Exp>;
};


export type Query_RootCommon_Fileupload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Common_Fileupload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Fileupload_Order_By>>;
  where?: InputMaybe<Common_Fileupload_Bool_Exp>;
};


export type Query_RootCommon_Fileupload_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootCompanyArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Query_RootCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Query_RootCompany_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompany_DocumentsArgs = {
  company_id?: InputMaybe<Scalars['Int']>;
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootCompany_Payment_DetailsArgs = {
  company_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootContent_TypeArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type Query_RootContent_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type Query_RootContent_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCost_ItemArgs = {
  distinct_on?: InputMaybe<Array<Cost_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cost_Item_Order_By>>;
  where?: InputMaybe<Cost_Item_Bool_Exp>;
};


export type Query_RootCost_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cost_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cost_Item_Order_By>>;
  where?: InputMaybe<Cost_Item_Bool_Exp>;
};


export type Query_RootCost_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourses_In_ProgressArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp>;
};


export type Query_RootCrop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp>;
};


export type Query_RootCrop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_FertilisersArgs = {
  distinct_on?: InputMaybe<Array<Crop_Fertilisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Fertilisers_Order_By>>;
  where?: InputMaybe<Crop_Fertilisers_Bool_Exp>;
};


export type Query_RootCrop_Fertilisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Fertilisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Fertilisers_Order_By>>;
  where?: InputMaybe<Crop_Fertilisers_Bool_Exp>;
};


export type Query_RootCrop_Fertilisers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCrop_GroupArgs = {
  distinct_on?: InputMaybe<Array<Crop_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Group_Order_By>>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};


export type Query_RootCrop_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Group_Order_By>>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};


export type Query_RootCrop_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Growth_Stages_By_Plot_Crop_CodenameArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  plot_crop_codename: Scalars['String'];
};


export type Query_RootCrop_InfestationArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};


export type Query_RootCrop_Infestation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};


export type Query_RootCrop_Infestation_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


export type Query_RootCrop_Infestation_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


export type Query_RootCrop_Infestation_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Infestation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Infestation_Details_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Infestations_By_Crop_CodenameArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crop_codename: Scalars['String'];
  search_string?: InputMaybe<Scalars['String']>;
};


export type Query_RootCrop_Infestations_By_Plot_Crop_CodenameArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  plot_crop_codename: Scalars['String'];
  search_string?: InputMaybe<Scalars['String']>;
};


export type Query_RootCrop_MilestoneArgs = {
  distinct_on?: InputMaybe<Array<Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Milestone_Order_By>>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};


export type Query_RootCrop_Milestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Milestone_Order_By>>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};


export type Query_RootCrop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Operation_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Operation_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Operation_Methods_Order_By>>;
  where?: InputMaybe<Crop_Operation_Methods_Bool_Exp>;
};


export type Query_RootCrop_Operation_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Operation_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Operation_Methods_Order_By>>;
  where?: InputMaybe<Crop_Operation_Methods_Bool_Exp>;
};


export type Query_RootCrop_Operation_Methods_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCrop_PesticidesArgs = {
  distinct_on?: InputMaybe<Array<Crop_Pesticides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Pesticides_Order_By>>;
  where?: InputMaybe<Crop_Pesticides_Bool_Exp>;
};


export type Query_RootCrop_Pesticides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Pesticides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Pesticides_Order_By>>;
  where?: InputMaybe<Crop_Pesticides_Bool_Exp>;
};


export type Query_RootCrop_Pesticides_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCrop_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


export type Query_RootCrop_Variety_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


export type Query_RootCrop_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Variety_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Seeds_Order_By>>;
  where?: InputMaybe<Crop_Variety_Seeds_Bool_Exp>;
};


export type Query_RootCrop_Variety_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Seeds_Order_By>>;
  where?: InputMaybe<Crop_Variety_Seeds_Bool_Exp>;
};


export type Query_RootCrop_Variety_Seeds_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCrop_YearArgs = {
  distinct_on?: InputMaybe<Array<Crop_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Year_Order_By>>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};


export type Query_RootCrop_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Year_Order_By>>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};


export type Query_RootCrop_Year_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCropmonitoring_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Cropmonitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cropmonitoring_Parameter_Order_By>>;
  where?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
};


export type Query_RootCropmonitoring_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cropmonitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cropmonitoring_Parameter_Order_By>>;
  where?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
};


export type Query_RootCropmonitoring_Parameter_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCurrencyArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Query_RootCurrency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Query_RootCurrency_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDaily_Actual_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Daily_Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Actual_Reading_Order_By>>;
  where?: InputMaybe<Daily_Actual_Reading_Bool_Exp>;
};


export type Query_RootDaily_Actual_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Actual_Reading_Order_By>>;
  where?: InputMaybe<Daily_Actual_Reading_Bool_Exp>;
};


export type Query_RootDaily_Actual_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDaily_Forecast_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Daily_Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Forecast_Reading_Order_By>>;
  where?: InputMaybe<Daily_Forecast_Reading_Bool_Exp>;
};


export type Query_RootDaily_Forecast_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Forecast_Reading_Order_By>>;
  where?: InputMaybe<Daily_Forecast_Reading_Bool_Exp>;
};


export type Query_RootDaily_Forecast_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDecrypted_UrlArgs = {
  file_path?: InputMaybe<Scalars['String']>;
};


export type Query_RootDepartmentArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Query_RootDepartment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Query_RootDepartment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDeviceArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


export type Query_RootDevice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


export type Query_RootDevice_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDistribution_Centre_By_UserArgs = {
  user_ref_id?: InputMaybe<Scalars['String']>;
};


export type Query_RootDistribution_Centre_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootDock_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


export type Query_RootDocument_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


export type Query_RootDocument_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_DataArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


export type Query_RootDocument_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


export type Query_RootDocument_Data_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_Entity_DataArgs = {
  document_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootDocument_KindArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Order_By>>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};


export type Query_RootDocument_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Order_By>>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};


export type Query_RootDocument_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_Kind_Data_FieldArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Data_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Data_Field_Order_By>>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};


export type Query_RootDocument_Kind_Data_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Data_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Data_Field_Order_By>>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};


export type Query_RootDocument_Kind_Data_Field_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDrip_Irrigation_SystemArgs = {
  distinct_on?: InputMaybe<Array<Drip_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Drip_Irrigation_System_Order_By>>;
  where?: InputMaybe<Drip_Irrigation_System_Bool_Exp>;
};


export type Query_RootDrip_Irrigation_System_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Drip_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Drip_Irrigation_System_Order_By>>;
  where?: InputMaybe<Drip_Irrigation_System_Bool_Exp>;
};


export type Query_RootDrip_Irrigation_System_By_PkArgs = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};


export type Query_RootExpenseArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


export type Query_RootExpense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


export type Query_RootExpense_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootExpense_Config_Template_DetailArgs = {
  department: Scalars['ID'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  version: Scalars['ID'];
};


export type Query_RootExpense_Config_VersionsArgs = {
  department?: InputMaybe<Scalars['ID']>;
  kind: Scalars['String'];
  mode: Scalars['String'];
};


export type Query_RootExpense_ConfigsArgs = {
  department: Scalars['ID'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  version?: InputMaybe<Scalars['ID']>;
};


export type Query_RootExpense_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Expense_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Parameter_Order_By>>;
  where?: InputMaybe<Expense_Parameter_Bool_Exp>;
};


export type Query_RootExpense_Parameter_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootExpense_Timeline_DetailsArgs = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootExpense_Timeline_Details_V2Args = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootExternal_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<External_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Reference_Order_By>>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};


export type Query_RootExternal_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Reference_Order_By>>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};


export type Query_RootExternal_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootExternal_Reference_IdArgs = {
  app_name?: InputMaybe<Scalars['String']>;
  object_id?: InputMaybe<Scalars['Int']>;
  table_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootFarmArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Query_RootFarm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Query_RootFarm_Aggregate_DetailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mutual_group_codenames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mutual_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  network_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootFarm_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFarm_DocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
  farm_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootFarm_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


export type Query_RootFarm_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


export type Query_RootFarm_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFarmer_Latest_TradeArgs = {
  reference_id?: InputMaybe<Scalars['String']>;
};


export type Query_RootFarmer_ListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  user_type?: InputMaybe<Scalars['String']>;
};


export type Query_RootFarmer_ProfileArgs = {
  reference_id?: InputMaybe<Scalars['String']>;
};


export type Query_RootFeaturesArgs = {
  project?: InputMaybe<Scalars['String']>;
};


export type Query_RootFieldArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


export type Query_RootField_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


export type Query_RootField_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootField_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


export type Query_RootField_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


export type Query_RootField_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootField_Weather_LocationArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


export type Query_RootField_Weather_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


export type Query_RootField_Weather_Location_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFileuploadArgs = {
  distinct_on?: InputMaybe<Array<Fileupload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fileupload_Order_By>>;
  where?: InputMaybe<Fileupload_Bool_Exp>;
};


export type Query_RootFileupload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fileupload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fileupload_Order_By>>;
  where?: InputMaybe<Fileupload_Bool_Exp>;
};


export type Query_RootFileupload_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootFinancial_SummaryArgs = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
  plot_codename?: InputMaybe<Scalars['String']>;
  plot_crop_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootFinancial_Summary_V2Args = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
  plot_codename?: InputMaybe<Scalars['String']>;
  plot_crop_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootFinancial_Timeline_V2Args = {
  plot_crop_codename: Scalars['String'];
  transaction_type?: InputMaybe<Scalars['String']>;
};


export type Query_RootFlood_Irrigation_SystemArgs = {
  distinct_on?: InputMaybe<Array<Flood_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Flood_Irrigation_System_Order_By>>;
  where?: InputMaybe<Flood_Irrigation_System_Bool_Exp>;
};


export type Query_RootFlood_Irrigation_System_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flood_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Flood_Irrigation_System_Order_By>>;
  where?: InputMaybe<Flood_Irrigation_System_Bool_Exp>;
};


export type Query_RootFlood_Irrigation_System_By_PkArgs = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};


export type Query_RootForecast_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Forecast_Reading_Order_By>>;
  where?: InputMaybe<Forecast_Reading_Bool_Exp>;
};


export type Query_RootForecast_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Forecast_Reading_Order_By>>;
  where?: InputMaybe<Forecast_Reading_Bool_Exp>;
};


export type Query_RootForecast_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootGatewayArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


export type Query_RootGateway_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


export type Query_RootGateway_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGateway_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Configuration_Order_By>>;
  where?: InputMaybe<Gateway_Configuration_Bool_Exp>;
};


export type Query_RootGateway_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Configuration_Order_By>>;
  where?: InputMaybe<Gateway_Configuration_Bool_Exp>;
};


export type Query_RootGateway_Configuration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGateway_StatusArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Status_Order_By>>;
  where?: InputMaybe<Gateway_Status_Bool_Exp>;
};


export type Query_RootGateway_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Status_Order_By>>;
  where?: InputMaybe<Gateway_Status_Bool_Exp>;
};


export type Query_RootGateway_Status_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootGrade_PriceArgs = {
  distinct_on?: InputMaybe<Array<Grade_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Price_Order_By>>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};


export type Query_RootGrade_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Price_Order_By>>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};


export type Query_RootGrade_Price_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootIncome_Timeline_DetailsArgs = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootIncome_Timeline_Details_V2Args = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootInfestationArgs = {
  distinct_on?: InputMaybe<Array<Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Infestation_Order_By>>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};


export type Query_RootInfestation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Infestation_Order_By>>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};


export type Query_RootInfestation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootIngredientArgs = {
  distinct_on?: InputMaybe<Array<Ingredient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ingredient_Order_By>>;
  where?: InputMaybe<Ingredient_Bool_Exp>;
};


export type Query_RootIngredient_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ingredient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ingredient_Order_By>>;
  where?: InputMaybe<Ingredient_Bool_Exp>;
};


export type Query_RootIngredient_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootInst_Sensor_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Inst_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inst_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
};


export type Query_RootInst_Sensor_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inst_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inst_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
};


export type Query_RootInst_Sensor_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootInward_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootIrrigation_SystemArgs = {
  distinct_on?: InputMaybe<Array<Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Irrigation_System_Order_By>>;
  where?: InputMaybe<Irrigation_System_Bool_Exp>;
};


export type Query_RootIrrigation_System_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Irrigation_System_Order_By>>;
  where?: InputMaybe<Irrigation_System_Bool_Exp>;
};


export type Query_RootIrrigation_System_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootKey_Stages_For_PopArgs = {
  config_id: Scalars['String'];
  plot_crop_codename: Scalars['String'];
};


export type Query_RootKite_Entities_AttributeArgs = {
  app_name?: InputMaybe<Scalars['String']>;
  attribute_key?: InputMaybe<Scalars['String']>;
  reference_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  table_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootKite_Entity_AttributeArgs = {
  app_name?: InputMaybe<Scalars['String']>;
  attribute_key?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
  table_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootLocation_By_PincodeArgs = {
  pincode?: InputMaybe<Scalars['String']>;
};


export type Query_RootLocation_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Location_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Subscription_Order_By>>;
  where?: InputMaybe<Location_Subscription_Bool_Exp>;
};


export type Query_RootLocation_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Subscription_Order_By>>;
  where?: InputMaybe<Location_Subscription_Bool_Exp>;
};


export type Query_RootLocation_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMain_SectionArgs = {
  distinct_on?: InputMaybe<Array<Main_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Main_Section_Order_By>>;
  where?: InputMaybe<Main_Section_Bool_Exp>;
};


export type Query_RootMain_Section_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Main_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Main_Section_Order_By>>;
  where?: InputMaybe<Main_Section_Bool_Exp>;
};


export type Query_RootMain_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootManufacturerArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By>>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};


export type Query_RootManufacturer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By>>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};


export type Query_RootManufacturer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootManufacturing_FacilityArgs = {
  distinct_on?: InputMaybe<Array<Manufacturing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturing_Facility_Order_By>>;
  where?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
};


export type Query_RootManufacturing_Facility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturing_Facility_Order_By>>;
  where?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
};


export type Query_RootManufacturing_Facility_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMarketArgs = {
  distinct_on?: InputMaybe<Array<Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Order_By>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


export type Query_RootMarket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Order_By>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


export type Query_RootMarket_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMarketerArgs = {
  distinct_on?: InputMaybe<Array<Marketer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Marketer_Order_By>>;
  where?: InputMaybe<Marketer_Bool_Exp>;
};


export type Query_RootMarketer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marketer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Marketer_Order_By>>;
  where?: InputMaybe<Marketer_Bool_Exp>;
};


export type Query_RootMarketer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMarketing_FacilityArgs = {
  distinct_on?: InputMaybe<Array<Marketing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Marketing_Facility_Order_By>>;
  where?: InputMaybe<Marketing_Facility_Bool_Exp>;
};


export type Query_RootMarketing_Facility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marketing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Marketing_Facility_Order_By>>;
  where?: InputMaybe<Marketing_Facility_Bool_Exp>;
};


export type Query_RootMarketing_Facility_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMe_GlobalArgs = {
  reference_id?: InputMaybe<Scalars['String']>;
};


export type Query_RootMeasure_OfArgs = {
  distinct_on?: InputMaybe<Array<Measure_Of_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Measure_Of_Order_By>>;
  where?: InputMaybe<Measure_Of_Bool_Exp>;
};


export type Query_RootMeasure_Of_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Measure_Of_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Measure_Of_Order_By>>;
  where?: InputMaybe<Measure_Of_Bool_Exp>;
};


export type Query_RootMeasure_Of_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMediaArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Query_RootMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Query_RootMedia_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMessageArgs = {
  distinct_on?: InputMaybe<Array<Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Message_Order_By>>;
  where?: InputMaybe<Message_Bool_Exp>;
};


export type Query_RootMessage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Message_Order_By>>;
  where?: InputMaybe<Message_Bool_Exp>;
};


export type Query_RootMessage_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMetabase_UrlArgs = {
  filter?: InputMaybe<MetabaseUrlInput>;
};


export type Query_RootMilestoneArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Query_RootMilestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Query_RootMilestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMilestones_For_PlotcropArgs = {
  crop_year?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
};


export type Query_RootMonitoring_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Category_Order_By>>;
  where?: InputMaybe<Monitoring_Category_Bool_Exp>;
};


export type Query_RootMonitoring_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Category_Order_By>>;
  where?: InputMaybe<Monitoring_Category_Bool_Exp>;
};


export type Query_RootMonitoring_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMonitoring_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
};


export type Query_RootMonitoring_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
};


export type Query_RootMonitoring_Parameter_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMonitoring_Parameter_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Choices_Bool_Exp>;
};


export type Query_RootMonitoring_Parameter_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Choices_Bool_Exp>;
};


export type Query_RootMonitoring_Parameter_Choices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMonitoring_Parameter_Unit_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Unit_Choices_Bool_Exp>;
};


export type Query_RootMonitoring_Parameter_Unit_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Unit_Choices_Bool_Exp>;
};


export type Query_RootMonitoring_Parameter_Unit_Choices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMonitoring_RecordArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Bool_Exp>;
};


export type Query_RootMonitoring_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Bool_Exp>;
};


export type Query_RootMonitoring_Record_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Attachments_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
};


export type Query_RootMonitoring_Record_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Attachments_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
};


export type Query_RootMonitoring_Record_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootMonitoring_Record_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMonitoring_SampleArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Sample_Order_By>>;
  where?: InputMaybe<Monitoring_Sample_Bool_Exp>;
};


export type Query_RootMonitoring_Sample_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Sample_Order_By>>;
  where?: InputMaybe<Monitoring_Sample_Bool_Exp>;
};


export type Query_RootMonitoring_Sample_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMonitoring_SubcategoryArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Subcategory_Order_By>>;
  where?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
};


export type Query_RootMonitoring_Subcategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Subcategory_Order_By>>;
  where?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
};


export type Query_RootMonitoring_Subcategory_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMutual_GroupArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Query_RootMutual_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Query_RootMutual_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMutual_Group_DocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootMutual_Group_MembershipArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


export type Query_RootMutual_Group_Membership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


export type Query_RootMutual_Group_Membership_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMutual_Group_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


export type Query_RootMutual_Group_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


export type Query_RootMutual_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMutual_Group_RoleArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Role_Order_By>>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};


export type Query_RootMutual_Group_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Role_Order_By>>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};


export type Query_RootMutual_Group_Role_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMutual_Group_Subscription_PackageArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Subscription_Package_Order_By>>;
  where?: InputMaybe<Mutual_Group_Subscription_Package_Bool_Exp>;
};


export type Query_RootMutual_Group_Subscription_Package_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Subscription_Package_Order_By>>;
  where?: InputMaybe<Mutual_Group_Subscription_Package_Bool_Exp>;
};


export type Query_RootMutual_Group_Subscription_Package_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMutual_Group_Weather_StationArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Weather_Station_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Weather_Station_Order_By>>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};


export type Query_RootMutual_Group_Weather_Station_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Weather_Station_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Weather_Station_Order_By>>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};


export type Query_RootMutual_Group_Weather_Station_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMy_Network_DocumentsArgs = {
  entity_type: Scalars['String'];
};


export type Query_RootMy_Network_UsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  search_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Query_RootMy_Network_Users_With_TotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mutual_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  network_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  search_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  user_types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Query_RootMy_Order_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootMy_Plot_CropsArgs = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
  plot_codename?: InputMaybe<Scalars['String']>;
  plot_crop_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootMy_Plot_Summary_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootNetworkArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


export type Query_RootNetwork_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


export type Query_RootNetwork_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNotificationArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Query_RootNotification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Query_RootNotification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNotification_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Notification_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Category_Order_By>>;
  where?: InputMaybe<Notification_Category_Bool_Exp>;
};


export type Query_RootNotification_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Category_Order_By>>;
  where?: InputMaybe<Notification_Category_Bool_Exp>;
};


export type Query_RootNotification_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNotification_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Order_By>>;
  where?: InputMaybe<Notification_Template_Bool_Exp>;
};


export type Query_RootNotification_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Order_By>>;
  where?: InputMaybe<Notification_Template_Bool_Exp>;
};


export type Query_RootNotification_Template_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNotification_Template_Distribution_RegionArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Region_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Region_Bool_Exp>;
};


export type Query_RootNotification_Template_Distribution_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Region_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Region_Bool_Exp>;
};


export type Query_RootNotification_Template_Distribution_Region_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootNotification_Template_Distribution_TeamArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Team_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Team_Bool_Exp>;
};


export type Query_RootNotification_Template_Distribution_Team_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Team_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Team_Bool_Exp>;
};


export type Query_RootNotification_Template_Distribution_Team_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootNotification_Template_Distribution_UserArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_User_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_User_Bool_Exp>;
};


export type Query_RootNotification_Template_Distribution_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_User_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_User_Bool_Exp>;
};


export type Query_RootNotification_Template_Distribution_User_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootNutrientsArgs = {
  distinct_on?: InputMaybe<Array<Nutrients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nutrients_Order_By>>;
  where?: InputMaybe<Nutrients_Bool_Exp>;
};


export type Query_RootNutrients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nutrients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nutrients_Order_By>>;
  where?: InputMaybe<Nutrients_Bool_Exp>;
};


export type Query_RootNutrients_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootObservation_CategoriesArgs = {
  crop_codename?: InputMaybe<Scalars['String']>;
  plot_crop_codename?: InputMaybe<Scalars['String']>;
  sowing_date?: InputMaybe<Scalars['String']>;
};


export type Query_RootObservation_DetailsArgs = {
  id: Scalars['String'];
};


export type Query_RootObservation_ListArgs = {
  category_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crop_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crop_year?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  from_date?: InputMaybe<Scalars['Date']>;
  is_notified?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['JSONScalar']>>>;
  parameter_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
  subcategory_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  till_date?: InputMaybe<Scalars['Date']>;
};


export type Query_RootObservation_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Observation_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Observation_Notification_Order_By>>;
  where?: InputMaybe<Observation_Notification_Bool_Exp>;
};


export type Query_RootObservation_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Observation_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Observation_Notification_Order_By>>;
  where?: InputMaybe<Observation_Notification_Bool_Exp>;
};


export type Query_RootObservation_Notification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootObservation_SubcategoriesArgs = {
  category_id?: InputMaybe<Scalars['String']>;
  crop_codename?: InputMaybe<Scalars['String']>;
  plot_crop_codename?: InputMaybe<Scalars['String']>;
  sowing_date?: InputMaybe<Scalars['String']>;
};


export type Query_RootOperation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Attachments_Order_By>>;
  where?: InputMaybe<Operation_Attachments_Bool_Exp>;
};


export type Query_RootOperation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Attachments_Order_By>>;
  where?: InputMaybe<Operation_Attachments_Bool_Exp>;
};


export type Query_RootOperation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOperation_CostArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Order_By>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


export type Query_RootOperation_Cost_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Order_By>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


export type Query_RootOperation_Cost_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOperation_Cost_ItemArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Item_Order_By>>;
  where?: InputMaybe<Operation_Cost_Item_Bool_Exp>;
};


export type Query_RootOperation_Cost_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Item_Order_By>>;
  where?: InputMaybe<Operation_Cost_Item_Bool_Exp>;
};


export type Query_RootOperation_DetailsArgs = {
  id: Scalars['String'];
};


export type Query_RootOperation_ListArgs = {
  crop_year?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  from_date?: InputMaybe<Scalars['Date']>;
  is_applied?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  method_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['JSONScalar']>>>;
  polymorphic_ctype_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  search?: InputMaybe<Scalars['String']>;
  till_date?: InputMaybe<Scalars['Date']>;
};


export type Query_RootOperation_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Methods_Order_By>>;
  where?: InputMaybe<Operation_Methods_Bool_Exp>;
};


export type Query_RootOperation_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Methods_Order_By>>;
  where?: InputMaybe<Operation_Methods_Bool_Exp>;
};


export type Query_RootOperation_Methods_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOperation_Methods_By_TypeArgs = {
  crop_codename?: InputMaybe<Scalars['String']>;
  operation_type: Scalars['String'];
  plot_crop_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootOperation_Product_TypesArgs = {
  distinct_on?: InputMaybe<Array<Operation_Product_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Product_Types_Order_By>>;
  where?: InputMaybe<Operation_Product_Types_Bool_Exp>;
};


export type Query_RootOperation_Product_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Product_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Product_Types_Order_By>>;
  where?: InputMaybe<Operation_Product_Types_Bool_Exp>;
};


export type Query_RootOperation_Product_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOperation_TypesArgs = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootOperationsArgs = {
  distinct_on?: InputMaybe<Array<Operations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Order_By>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


export type Query_RootOperations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Order_By>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


export type Query_RootOperations_Applied_FertiliserArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};


export type Query_RootOperations_Applied_Fertiliser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};


export type Query_RootOperations_Applied_Fertiliser_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOperations_Applied_PesticideArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};


export type Query_RootOperations_Applied_Pesticide_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};


export type Query_RootOperations_Applied_Pesticide_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOperations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOperations_FertiliserArgs = {
  distinct_on?: InputMaybe<Array<Operations_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
};


export type Query_RootOperations_Fertiliser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
};


export type Query_RootOperations_Fertiliser_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Query_RootOperations_HarvestArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Bool_Exp>;
};


export type Query_RootOperations_Harvest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Bool_Exp>;
};


export type Query_RootOperations_Harvest_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Query_RootOperations_Harvest_OutputArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Output_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Output_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
};


export type Query_RootOperations_Harvest_Output_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Output_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Output_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
};


export type Query_RootOperations_Harvest_Output_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOperations_IntercultureArgs = {
  distinct_on?: InputMaybe<Array<Operations_Interculture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Interculture_Order_By>>;
  where?: InputMaybe<Operations_Interculture_Bool_Exp>;
};


export type Query_RootOperations_Interculture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Interculture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Interculture_Order_By>>;
  where?: InputMaybe<Operations_Interculture_Bool_Exp>;
};


export type Query_RootOperations_Interculture_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Query_RootOperations_IrrigationArgs = {
  distinct_on?: InputMaybe<Array<Operations_Irrigation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Irrigation_Order_By>>;
  where?: InputMaybe<Operations_Irrigation_Bool_Exp>;
};


export type Query_RootOperations_Irrigation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Irrigation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Irrigation_Order_By>>;
  where?: InputMaybe<Operations_Irrigation_Bool_Exp>;
};


export type Query_RootOperations_Irrigation_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Query_RootOperations_Land_PrepArgs = {
  distinct_on?: InputMaybe<Array<Operations_Land_Prep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Land_Prep_Order_By>>;
  where?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
};


export type Query_RootOperations_Land_Prep_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Land_Prep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Land_Prep_Order_By>>;
  where?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
};


export type Query_RootOperations_Land_Prep_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Query_RootOperations_PesticideArgs = {
  distinct_on?: InputMaybe<Array<Operations_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Pesticide_Bool_Exp>;
};


export type Query_RootOperations_Pesticide_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Pesticide_Bool_Exp>;
};


export type Query_RootOperations_Pesticide_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Query_RootOperations_SowingArgs = {
  distinct_on?: InputMaybe<Array<Operations_Sowing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Sowing_Order_By>>;
  where?: InputMaybe<Operations_Sowing_Bool_Exp>;
};


export type Query_RootOperations_Sowing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Sowing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Sowing_Order_By>>;
  where?: InputMaybe<Operations_Sowing_Bool_Exp>;
};


export type Query_RootOperations_Sowing_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Query_RootOrganisationArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Query_RootOrganisation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Query_RootOrganisation_App_ConfigurationArgs = {
  bundle_id: Scalars['String'];
  device_id?: InputMaybe<Scalars['String']>;
  firebase_token?: InputMaybe<Scalars['String']>;
  install_version: Scalars['String'];
  platform: Scalars['String'];
};


export type Query_RootOrganisation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisation_Document_KindArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


export type Query_RootOrganisation_Document_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


export type Query_RootOrganisation_Document_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisation_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Preferences_Order_By>>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};


export type Query_RootOrganisation_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Preferences_Order_By>>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};


export type Query_RootOrganisation_Preferences_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisation_PricingArgs = {
  schema_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootOrganisation_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Season_Order_By>>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};


export type Query_RootOrganisation_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Season_Order_By>>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};


export type Query_RootOrganisation_Season_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPayment_DetailArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Order_By>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


export type Query_RootPayment_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Order_By>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


export type Query_RootPayment_Detail_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


export type Query_RootPayment_Detail_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


export type Query_RootPayment_Detail_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPayment_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPayment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};


export type Query_RootPayment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};


export type Query_RootPayment_Method_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPayu_HashArgs = {
  key?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootPayu_Transaction_HashArgs = {
  amount_for_payment: Scalars['Float'];
  email?: InputMaybe<Scalars['String']>;
  reference_id: Scalars['ID'];
  tracking_code: Scalars['ID'];
};


export type Query_RootPlotArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


export type Query_RootPlot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


export type Query_RootPlot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Query_RootPlot_Crop_AgentArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


export type Query_RootPlot_Crop_Agent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


export type Query_RootPlot_Crop_Agent_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Query_RootPlot_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_DocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootPlot_Crop_Growth_Stages_By_Plot_Crop_CodenameArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  plot_crop_codename: Scalars['String'];
};


export type Query_RootPlot_Crop_List_With_BudgetArgs = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootPlot_Crop_List_With_Budget_V2Args = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootPlot_Crop_MilestoneArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Milestone_Order_By>>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};


export type Query_RootPlot_Crop_Milestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Milestone_Order_By>>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};


export type Query_RootPlot_Crop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


export type Query_RootPlot_Crop_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


export type Query_RootPlot_Crop_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_Reference_By_CodenameArgs = {
  app_name?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootPlot_Crop_SearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PlotCropSearchInput>;
};


export type Query_RootPlot_DocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
  plot_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootPlot_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


export type Query_RootPlot_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


export type Query_RootPlot_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Risk_24hourArgs = {
  distinct_on?: InputMaybe<Array<Plot_Risk_24hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Risk_24hour_Order_By>>;
  where?: InputMaybe<Plot_Risk_24hour_Bool_Exp>;
};


export type Query_RootPlot_Risk_24hour_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Risk_24hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Risk_24hour_Order_By>>;
  where?: InputMaybe<Plot_Risk_24hour_Bool_Exp>;
};


export type Query_RootPlot_Risk_MetricsArgs = {
  is_day_summary?: InputMaybe<Scalars['Boolean']>;
  user_id: Scalars['String'];
};


export type Query_RootPlot_Risk_TotalArgs = {
  distinct_on?: InputMaybe<Array<Plot_Risk_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Risk_Total_Order_By>>;
  where?: InputMaybe<Plot_Risk_Total_Bool_Exp>;
};


export type Query_RootPlot_Risk_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Risk_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Risk_Total_Order_By>>;
  where?: InputMaybe<Plot_Risk_Total_Bool_Exp>;
};


export type Query_RootPlot_StatusArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Order_By>>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};


export type Query_RootPlot_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Order_By>>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};


export type Query_RootPlot_Status_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPop_ConfigArgs = {
  date?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
};


export type Query_RootPop_DetailsArgs = {
  ignore_keystage_date?: InputMaybe<Scalars['Boolean']>;
  is_acrewise?: InputMaybe<Scalars['Boolean']>;
  key_stage_id: Scalars['String'];
  override_keystage_date?: InputMaybe<Scalars['String']>;
  plot_area: Scalars['Float'];
  plot_crop_codename: Scalars['String'];
  schedule_id: Scalars['String'];
};


export type Query_RootPop_For_PlotcropArgs = {
  ignore_keystage_date?: InputMaybe<Scalars['Boolean']>;
  is_acrewise: Scalars['Boolean'];
  key_stage_id: Scalars['String'];
  override_keystage_date?: InputMaybe<Scalars['String']>;
  plot_area: Scalars['Float'];
  plot_crop_codename: Scalars['String'];
};


export type Query_RootPrimary_Growth_StageArgs = {
  distinct_on?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Primary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};


export type Query_RootPrimary_Growth_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Primary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};


export type Query_RootPrimary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProduce_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Produce_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produce_Insights_Order_By>>;
  where?: InputMaybe<Produce_Insights_Bool_Exp>;
};


export type Query_RootProduce_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Produce_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produce_Insights_Order_By>>;
  where?: InputMaybe<Produce_Insights_Bool_Exp>;
};


export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Product_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attachment_Order_By>>;
  where?: InputMaybe<Product_Attachment_Bool_Exp>;
};


export type Query_RootProduct_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attachment_Order_By>>;
  where?: InputMaybe<Product_Attachment_Bool_Exp>;
};


export type Query_RootProduct_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_AttributeArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


export type Query_RootProduct_Attribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


export type Query_RootProduct_Attribute_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_Attribute_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Choice_Order_By>>;
  where?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
};


export type Query_RootProduct_Attribute_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Choice_Order_By>>;
  where?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
};


export type Query_RootProduct_Attribute_Choice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_CertificationArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Order_By>>;
  where?: InputMaybe<Product_Certification_Bool_Exp>;
};


export type Query_RootProduct_Certification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Order_By>>;
  where?: InputMaybe<Product_Certification_Bool_Exp>;
};


export type Query_RootProduct_Certification_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Attachment_Order_By>>;
  where?: InputMaybe<Product_Certification_Attachment_Bool_Exp>;
};


export type Query_RootProduct_Certification_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Attachment_Order_By>>;
  where?: InputMaybe<Product_Certification_Attachment_Bool_Exp>;
};


export type Query_RootProduct_Certification_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_Certification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_ClassArgs = {
  distinct_on?: InputMaybe<Array<Product_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Class_Order_By>>;
  where?: InputMaybe<Product_Class_Bool_Exp>;
};


export type Query_RootProduct_Class_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Class_Order_By>>;
  where?: InputMaybe<Product_Class_Bool_Exp>;
};


export type Query_RootProduct_Class_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_CompositionArgs = {
  distinct_on?: InputMaybe<Array<Product_Composition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Composition_Order_By>>;
  where?: InputMaybe<Product_Composition_Bool_Exp>;
};


export type Query_RootProduct_Composition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Composition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Composition_Order_By>>;
  where?: InputMaybe<Product_Composition_Bool_Exp>;
};


export type Query_RootProduct_Composition_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_Crop_AssociationArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Association_Order_By>>;
  where?: InputMaybe<Product_Crop_Association_Bool_Exp>;
};


export type Query_RootProduct_Crop_Association_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Association_Order_By>>;
  where?: InputMaybe<Product_Crop_Association_Bool_Exp>;
};


export type Query_RootProduct_Crop_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_Crop_Infestation_RecommendationArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
};


export type Query_RootProduct_Crop_Infestation_Recommendation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
};


export type Query_RootProduct_Crop_Infestation_Recommendation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_Crop_Nutrition_RecommendationArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Nutrition_Recommendation_Bool_Exp>;
};


export type Query_RootProduct_Crop_Nutrition_Recommendation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Nutrition_Recommendation_Bool_Exp>;
};


export type Query_RootProduct_Crop_Nutrition_Recommendation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_FavouriteArgs = {
  distinct_on?: InputMaybe<Array<Product_Favourite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Favourite_Order_By>>;
  where?: InputMaybe<Product_Favourite_Bool_Exp>;
};


export type Query_RootProduct_Favourite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Favourite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Favourite_Order_By>>;
  where?: InputMaybe<Product_Favourite_Bool_Exp>;
};


export type Query_RootProduct_Favourite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_InfestationArgs = {
  distinct_on?: InputMaybe<Array<Product_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Infestation_Order_By>>;
  where?: InputMaybe<Product_Infestation_Bool_Exp>;
};


export type Query_RootProduct_Infestation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Infestation_Order_By>>;
  where?: InputMaybe<Product_Infestation_Bool_Exp>;
};


export type Query_RootProduct_Infestation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_MainsectionArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Bool_Exp>;
};


export type Query_RootProduct_Mainsection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Bool_Exp>;
};


export type Query_RootProduct_Mainsection_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Attachment_Bool_Exp>;
};


export type Query_RootProduct_Mainsection_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Attachment_Bool_Exp>;
};


export type Query_RootProduct_Mainsection_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_Mainsection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_PurchasedArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchased_Order_By>>;
  where?: InputMaybe<Product_Purchased_Bool_Exp>;
};


export type Query_RootProduct_Purchased_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchased_Order_By>>;
  where?: InputMaybe<Product_Purchased_Bool_Exp>;
};


export type Query_RootProduct_Purchased_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_SectionArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Order_By>>;
  where?: InputMaybe<Product_Section_Bool_Exp>;
};


export type Query_RootProduct_Section_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Order_By>>;
  where?: InputMaybe<Product_Section_Bool_Exp>;
};


export type Query_RootProduct_Section_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Attachment_Order_By>>;
  where?: InputMaybe<Product_Section_Attachment_Bool_Exp>;
};


export type Query_RootProduct_Section_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Attachment_Order_By>>;
  where?: InputMaybe<Product_Section_Attachment_Bool_Exp>;
};


export type Query_RootProduct_Section_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_SkuArgs = {
  distinct_on?: InputMaybe<Array<Product_Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Sku_Order_By>>;
  where?: InputMaybe<Product_Sku_Bool_Exp>;
};


export type Query_RootProduct_Sku_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Sku_Order_By>>;
  where?: InputMaybe<Product_Sku_Bool_Exp>;
};


export type Query_RootProduct_Sku_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_SubsectionArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Order_By>>;
  where?: InputMaybe<Product_Subsection_Bool_Exp>;
};


export type Query_RootProduct_Subsection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Order_By>>;
  where?: InputMaybe<Product_Subsection_Bool_Exp>;
};


export type Query_RootProduct_Subsection_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Subsection_Attachment_Bool_Exp>;
};


export type Query_RootProduct_Subsection_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Subsection_Attachment_Bool_Exp>;
};


export type Query_RootProduct_Subsection_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_Subsection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_ViewArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_View_Order_By>>;
  where?: InputMaybe<Product_View_Bool_Exp>;
};


export type Query_RootProduct_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_View_Order_By>>;
  where?: InputMaybe<Product_View_Bool_Exp>;
};


export type Query_RootProduct_View_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProducts_FertiliserArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Bool_Exp>;
};


export type Query_RootProducts_Fertiliser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Bool_Exp>;
};


export type Query_RootProducts_Fertiliser_By_PkArgs = {
  baseproduct_ptr_id: Scalars['uuid'];
};


export type Query_RootProducts_Fertiliser_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Contents_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
};


export type Query_RootProducts_Fertiliser_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Contents_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
};


export type Query_RootProducts_Fertiliser_Contents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProducts_Fertiliser_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Units_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Units_Bool_Exp>;
};


export type Query_RootProducts_Fertiliser_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Units_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Units_Bool_Exp>;
};


export type Query_RootProducts_Fertiliser_Units_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProducts_PesticideArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Bool_Exp>;
};


export type Query_RootProducts_Pesticide_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Bool_Exp>;
};


export type Query_RootProducts_Pesticide_By_PkArgs = {
  baseproduct_ptr_id: Scalars['uuid'];
};


export type Query_RootProducts_Pesticide_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Contents_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
};


export type Query_RootProducts_Pesticide_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Contents_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
};


export type Query_RootProducts_Pesticide_Contents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProducts_Pesticide_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Units_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Units_Bool_Exp>;
};


export type Query_RootProducts_Pesticide_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Units_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Units_Bool_Exp>;
};


export type Query_RootProducts_Pesticide_Units_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProviderArgs = {
  distinct_on?: InputMaybe<Array<Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Order_By>>;
  where?: InputMaybe<Provider_Bool_Exp>;
};


export type Query_RootProvider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Order_By>>;
  where?: InputMaybe<Provider_Bool_Exp>;
};


export type Query_RootProvider_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRandom_Advice_AuthorsArgs = {
  is_school_author?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  user_reference_id?: InputMaybe<Scalars['String']>;
};


export type Query_RootReceiptArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


export type Query_RootReceipt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


export type Query_RootReceipt_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootRecommended_ProductArgs = {
  distinct_on?: InputMaybe<Array<Recommended_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommended_Product_Order_By>>;
  where?: InputMaybe<Recommended_Product_Bool_Exp>;
};


export type Query_RootRecommended_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recommended_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommended_Product_Order_By>>;
  where?: InputMaybe<Recommended_Product_Bool_Exp>;
};


export type Query_RootRecommended_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Query_RootRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Query_RootRegion_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRegion_GroupArgs = {
  distinct_on?: InputMaybe<Array<Region_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Group_Order_By>>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};


export type Query_RootRegion_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Group_Order_By>>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};


export type Query_RootRegion_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRegistration_Mutual_Group_ListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  search_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verification_status?: InputMaybe<Scalars['String']>;
};


export type Query_RootRegistration_Mutual_Group_List_With_TotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mutual_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  network_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  search_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verification_status?: InputMaybe<Scalars['String']>;
};


export type Query_RootRelated_Article_ListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  parent_article_id: Scalars['String'];
};


export type Query_RootReward_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Reward_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reward_Configuration_Order_By>>;
  where?: InputMaybe<Reward_Configuration_Bool_Exp>;
};


export type Query_RootReward_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reward_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reward_Configuration_Order_By>>;
  where?: InputMaybe<Reward_Configuration_Bool_Exp>;
};


export type Query_RootReward_Configuration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSap_SiArgs = {
  distinct_on?: InputMaybe<Array<Sap_Si_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sap_Si_Order_By>>;
  where?: InputMaybe<Sap_Si_Bool_Exp>;
};


export type Query_RootSap_Si_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sap_Si_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sap_Si_Order_By>>;
  where?: InputMaybe<Sap_Si_Bool_Exp>;
};


export type Query_RootSap_Si_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSap_Si_MapArgs = {
  distinct_on?: InputMaybe<Array<Sap_Si_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sap_Si_Map_Order_By>>;
  where?: InputMaybe<Sap_Si_Map_Bool_Exp>;
};


export type Query_RootSap_Si_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sap_Si_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sap_Si_Map_Order_By>>;
  where?: InputMaybe<Sap_Si_Map_Bool_Exp>;
};


export type Query_RootSap_Si_Map_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSchool_CategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootSearch_Base_UsersArgs = {
  args: Search_Base_Users_Args;
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Query_RootSearch_Base_Users_AggregateArgs = {
  args: Search_Base_Users_Args;
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Query_RootSearch_Mutual_GroupsArgs = {
  args: Search_Mutual_Groups_Args;
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Query_RootSearch_Mutual_Groups_AggregateArgs = {
  args: Search_Mutual_Groups_Args;
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Query_RootSearch_Plot_CropsArgs = {
  args: Search_Plot_Crops_Args;
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Query_RootSearch_Plot_Crops_AggregateArgs = {
  args: Search_Plot_Crops_Args;
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Query_RootSecondary_Growth_StageArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


export type Query_RootSecondary_Growth_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


export type Query_RootSecondary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSectionArgs = {
  distinct_on?: InputMaybe<Array<Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Section_Order_By>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


export type Query_RootSection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Section_Order_By>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


export type Query_RootSection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSeedsArgs = {
  distinct_on?: InputMaybe<Array<Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Seeds_Order_By>>;
  where?: InputMaybe<Seeds_Bool_Exp>;
};


export type Query_RootSeeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Seeds_Order_By>>;
  where?: InputMaybe<Seeds_Bool_Exp>;
};


export type Query_RootSeeds_By_PkArgs = {
  baseproduct_ptr_id: Scalars['uuid'];
};


export type Query_RootSellable_ItemArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Order_By>>;
  where?: InputMaybe<Sellable_Item_Bool_Exp>;
};


export type Query_RootSellable_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Order_By>>;
  where?: InputMaybe<Sellable_Item_Bool_Exp>;
};


export type Query_RootSellable_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSellable_Item_StockArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Stock_Order_By>>;
  where?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
};


export type Query_RootSellable_Item_Stock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Stock_Order_By>>;
  where?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
};


export type Query_RootSellable_Item_Stock_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSellable_Item_Stock_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootSeller_HashArgs = {
  trade_id: Scalars['ID'];
};


export type Query_RootSensorArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Order_By>>;
  where?: InputMaybe<Sensor_Bool_Exp>;
};


export type Query_RootSensor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Order_By>>;
  where?: InputMaybe<Sensor_Bool_Exp>;
};


export type Query_RootSensor_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSensor_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Parameter_Order_By>>;
  where?: InputMaybe<Sensor_Parameter_Bool_Exp>;
};


export type Query_RootSensor_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Parameter_Order_By>>;
  where?: InputMaybe<Sensor_Parameter_Bool_Exp>;
};


export type Query_RootSensor_Parameter_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSeriesArgs = {
  distinct_on?: InputMaybe<Array<Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Order_By>>;
  where?: InputMaybe<Series_Bool_Exp>;
};


export type Query_RootSeries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Order_By>>;
  where?: InputMaybe<Series_Bool_Exp>;
};


export type Query_RootSeries_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Series_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Authors_Order_By>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};


export type Query_RootSeries_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Authors_Order_By>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};


export type Query_RootSeries_Authors_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSeries_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSeries_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Series_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Category_Order_By>>;
  where?: InputMaybe<Series_Category_Bool_Exp>;
};


export type Query_RootSeries_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Category_Order_By>>;
  where?: InputMaybe<Series_Category_Bool_Exp>;
};


export type Query_RootSeries_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSeries_Crop_ListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['JSONScalar']>>>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootSeries_CropsArgs = {
  distinct_on?: InputMaybe<Array<Series_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Crops_Order_By>>;
  where?: InputMaybe<Series_Crops_Bool_Exp>;
};


export type Query_RootSeries_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Crops_Order_By>>;
  where?: InputMaybe<Series_Crops_Bool_Exp>;
};


export type Query_RootSeries_Crops_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSeries_FavoritesArgs = {
  distinct_on?: InputMaybe<Array<Series_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Favorites_Order_By>>;
  where?: InputMaybe<Series_Favorites_Bool_Exp>;
};


export type Query_RootSeries_Favorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Favorites_Order_By>>;
  where?: InputMaybe<Series_Favorites_Bool_Exp>;
};


export type Query_RootSeries_Favorites_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSeries_Lecture_ListArgs = {
  id: Scalars['String'];
  order?: InputMaybe<Scalars['String']>;
};


export type Query_RootSeries_LikesArgs = {
  distinct_on?: InputMaybe<Array<Series_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Likes_Order_By>>;
  where?: InputMaybe<Series_Likes_Bool_Exp>;
};


export type Query_RootSeries_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Likes_Order_By>>;
  where?: InputMaybe<Series_Likes_Bool_Exp>;
};


export type Query_RootSeries_Likes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSeries_ListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['JSONScalar']>>>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootSetu_Trade_Shared_EntityArgs = {
  distinct_on?: InputMaybe<Array<Setu_Trade_Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Trade_Shared_Entity_Order_By>>;
  where?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
};


export type Query_RootSetu_Trade_Shared_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSetu_Weather_UserArgs = {
  distinct_on?: InputMaybe<Array<Setu_Weather_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Weather_User_Order_By>>;
  where?: InputMaybe<Setu_Weather_User_Bool_Exp>;
};


export type Query_RootSetu_Weather_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Setu_Weather_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Weather_User_Order_By>>;
  where?: InputMaybe<Setu_Weather_User_Bool_Exp>;
};


export type Query_RootSetu_Weather_User_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootShared_EntityArgs = {
  distinct_on?: InputMaybe<Array<Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Entity_Order_By>>;
  where?: InputMaybe<Shared_Entity_Bool_Exp>;
};


export type Query_RootShared_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Entity_Order_By>>;
  where?: InputMaybe<Shared_Entity_Bool_Exp>;
};


export type Query_RootShared_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSi_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};


export type Query_RootSi_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};


export type Query_RootSi_Unit_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSi_Unit_MeasureArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Measure_Order_By>>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};


export type Query_RootSi_Unit_Measure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Measure_Order_By>>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};


export type Query_RootSi_Unit_Measure_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSigned_UrlArgs = {
  url?: InputMaybe<Scalars['String']>;
};


export type Query_RootSkuArgs = {
  distinct_on?: InputMaybe<Array<Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Order_By>>;
  where?: InputMaybe<Sku_Bool_Exp>;
};


export type Query_RootSku_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Order_By>>;
  where?: InputMaybe<Sku_Bool_Exp>;
};


export type Query_RootSku_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSku_KindArgs = {
  distinct_on?: InputMaybe<Array<Sku_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Kind_Order_By>>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};


export type Query_RootSku_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sku_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Kind_Order_By>>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};


export type Query_RootSku_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSoilArgs = {
  distinct_on?: InputMaybe<Array<Soil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Soil_Order_By>>;
  where?: InputMaybe<Soil_Bool_Exp>;
};


export type Query_RootSoil_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Soil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Soil_Order_By>>;
  where?: InputMaybe<Soil_Bool_Exp>;
};


export type Query_RootSoil_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSprinkler_Irrigation_SystemArgs = {
  distinct_on?: InputMaybe<Array<Sprinkler_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sprinkler_Irrigation_System_Order_By>>;
  where?: InputMaybe<Sprinkler_Irrigation_System_Bool_Exp>;
};


export type Query_RootSprinkler_Irrigation_System_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sprinkler_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sprinkler_Irrigation_System_Order_By>>;
  where?: InputMaybe<Sprinkler_Irrigation_System_Bool_Exp>;
};


export type Query_RootSprinkler_Irrigation_System_By_PkArgs = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};


export type Query_RootSub_SectionArgs = {
  distinct_on?: InputMaybe<Array<Sub_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sub_Section_Order_By>>;
  where?: InputMaybe<Sub_Section_Bool_Exp>;
};


export type Query_RootSub_Section_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sub_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sub_Section_Order_By>>;
  where?: InputMaybe<Sub_Section_Bool_Exp>;
};


export type Query_RootSub_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubcategoryArgs = {
  distinct_on?: InputMaybe<Array<Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subcategory_Order_By>>;
  where?: InputMaybe<Subcategory_Bool_Exp>;
};


export type Query_RootSubcategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subcategory_Order_By>>;
  where?: InputMaybe<Subcategory_Bool_Exp>;
};


export type Query_RootSubcategory_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscription_Package_HighlightsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Package_Highlights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Package_Highlights_Order_By>>;
  where?: InputMaybe<Subscription_Package_Highlights_Bool_Exp>;
};


export type Query_RootSubscription_Package_Highlights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Package_Highlights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Package_Highlights_Order_By>>;
  where?: InputMaybe<Subscription_Package_Highlights_Bool_Exp>;
};


export type Query_RootSubscription_Package_Highlights_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSummary_Sensor_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Summary_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Summary_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
};


export type Query_RootSummary_Sensor_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Summary_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Summary_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
};


export type Query_RootSummary_Sensor_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSupplier_Groups_Plot_AggreagteArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type Query_RootSupplier_Plot_AggreagteArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<SupplierPlotAggregateInput>;
};


export type Query_RootTeam_Document_CountArgs = {
  mutual_group_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootThreadArgs = {
  distinct_on?: InputMaybe<Array<Thread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Thread_Order_By>>;
  where?: InputMaybe<Thread_Bool_Exp>;
};


export type Query_RootThread_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Thread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Thread_Order_By>>;
  where?: InputMaybe<Thread_Bool_Exp>;
};


export type Query_RootThread_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTradeArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


export type Query_RootTrade_Action_LogArgs = {
  distinct_on?: InputMaybe<Array<Trade_Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Action_Log_Order_By>>;
  where?: InputMaybe<Trade_Action_Log_Bool_Exp>;
};


export type Query_RootTrade_Action_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


export type Query_RootTrade_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_CommodityArgs = {
  distinct_on?: InputMaybe<Array<Trade_Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Commodity_Order_By>>;
  where?: InputMaybe<Trade_Commodity_Bool_Exp>;
};


export type Query_RootTrade_Commodity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Commodity_Order_By>>;
  where?: InputMaybe<Trade_Commodity_Bool_Exp>;
};


export type Query_RootTrade_Commodity_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTrade_Grade_Quantity_SummaryArgs = {
  trade_id: Scalars['Int'];
};


export type Query_RootTrade_Grade_Quantity_Summary_ReportArgs = {
  trade_id: Scalars['Int'];
};


export type Query_RootTrade_ItemArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


export type Query_RootTrade_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


export type Query_RootTrade_Item_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_RegionArgs = {
  distinct_on?: InputMaybe<Array<Trade_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Region_Order_By>>;
  where?: InputMaybe<Trade_Region_Bool_Exp>;
};


export type Query_RootTrade_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Region_Order_By>>;
  where?: InputMaybe<Trade_Region_Bool_Exp>;
};


export type Query_RootTrade_Region_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTrade_StatusArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Order_By>>;
  where?: InputMaybe<Trade_Status_Bool_Exp>;
};


export type Query_RootTrade_Status_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootTrade_Tnc_Template_DetailArgs = {
  department: Scalars['ID'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  version: Scalars['ID'];
};


export type Query_RootTrade_Tnc_VersionsArgs = {
  department?: InputMaybe<Scalars['ID']>;
  kind: Scalars['String'];
  mode: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
};


export type Query_RootTrade_TradestatusaccessArgs = {
  distinct_on?: InputMaybe<Array<Trade_Tradestatusaccess_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Tradestatusaccess_Order_By>>;
  where?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
};


export type Query_RootTrade_Tradestatusaccess_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Bool_Exp>;
};


export type Query_RootTrade_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Bool_Exp>;
};


export type Query_RootTrade_Transaction_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTrade_Transaction_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Summary_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
};


export type Query_RootTrade_Transaction_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Summary_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
};


export type Query_RootTrade_Transaction_Summary_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTrade_UnitArgs = {
  distinct_on?: InputMaybe<Array<Trade_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Unit_Order_By>>;
  where?: InputMaybe<Trade_Unit_Bool_Exp>;
};


export type Query_RootTrade_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Unit_Order_By>>;
  where?: InputMaybe<Trade_Unit_Bool_Exp>;
};


export type Query_RootTrade_Unit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTransaction_TrendArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Trend_Order_By>>;
  where?: InputMaybe<Transaction_Trend_Bool_Exp>;
};


export type Query_RootTransaction_Trend_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Trend_Order_By>>;
  where?: InputMaybe<Transaction_Trend_Bool_Exp>;
};


export type Query_RootTransaction_Trend_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTrip_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootTutorialsArgs = {
  feature?: InputMaybe<Scalars['String']>;
};


export type Query_RootTutorials_And_TermsArgs = {
  feature?: InputMaybe<Scalars['String']>;
};


export type Query_RootUnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Query_RootUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Query_RootUnit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_AccountsArgs = {
  account_type_codename?: InputMaybe<Scalars['String']>;
  kite_reference_id?: InputMaybe<Scalars['String']>;
};


export type Query_RootUser_Answer_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<User_Answer_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Answer_Choices_Order_By>>;
  where?: InputMaybe<User_Answer_Choices_Bool_Exp>;
};


export type Query_RootUser_Answer_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Answer_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Answer_Choices_Order_By>>;
  where?: InputMaybe<User_Answer_Choices_Bool_Exp>;
};


export type Query_RootUser_Answer_Choices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_Assessment_AttemptArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Attempt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Attempt_Order_By>>;
  where?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
};


export type Query_RootUser_Assessment_Attempt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Attempt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Attempt_Order_By>>;
  where?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
};


export type Query_RootUser_Assessment_Attempt_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_Assessment_Question_ResponseArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Question_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Question_Response_Order_By>>;
  where?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};


export type Query_RootUser_Assessment_Question_Response_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Question_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Question_Response_Order_By>>;
  where?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};


export type Query_RootUser_Assessment_Question_Response_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_Permission_GroupsArgs = {
  all_roles?: InputMaybe<Scalars['Boolean']>;
};


export type Query_RootUser_Reward_HistoryArgs = {
  distinct_on?: InputMaybe<Array<User_Reward_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Reward_History_Order_By>>;
  where?: InputMaybe<User_Reward_History_Bool_Exp>;
};


export type Query_RootUser_Reward_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Reward_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Reward_History_Order_By>>;
  where?: InputMaybe<User_Reward_History_Bool_Exp>;
};


export type Query_RootUser_Reward_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_Subscription_PackageArgs = {
  distinct_on?: InputMaybe<Array<User_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscription_Package_Order_By>>;
  where?: InputMaybe<User_Subscription_Package_Bool_Exp>;
};


export type Query_RootUser_Subscription_Package_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscription_Package_Order_By>>;
  where?: InputMaybe<User_Subscription_Package_Bool_Exp>;
};


export type Query_RootUser_Subscription_Package_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootVariety_GradeArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


export type Query_RootVariety_Grade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


export type Query_RootVariety_Grade_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVariety_Grade_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


export type Query_RootVariety_Grade_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


export type Query_RootVariety_Grade_Photos_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVariety_GroupArgs = {
  distinct_on?: InputMaybe<Array<Variety_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Group_Order_By>>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};


export type Query_RootVariety_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Group_Order_By>>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};


export type Query_RootVariety_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVehicle_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootWeather_LocationArgs = {
  distinct_on?: InputMaybe<Array<Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Location_Order_By>>;
  where?: InputMaybe<Weather_Location_Bool_Exp>;
};


export type Query_RootWeather_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Location_Order_By>>;
  where?: InputMaybe<Weather_Location_Bool_Exp>;
};


export type Query_RootWeather_Location_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWeather_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<Weather_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Reference_Order_By>>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};


export type Query_RootWeather_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Reference_Order_By>>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};


export type Query_RootWeather_Reference_By_PkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "receipt" */
export type Receipt = {
  __typename?: 'receipt';
  buyer_tnc?: Maybe<Scalars['String']>;
  /** An object relationship */
  commodity: Setu_Trade_Shared_Entity;
  commodity_id: Scalars['bigint'];
  /** An object relationship */
  commodity_variety?: Maybe<Setu_Trade_Shared_Entity>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  department: Setu_Trade_Shared_Entity;
  department_id: Scalars['bigint'];
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  expenses: Array<Expense>;
  /** An aggregate relationship */
  expenses_aggregate: Expense_Aggregate;
  expiry?: Maybe<Scalars['date']>;
  /** An object relationship */
  facilitator?: Maybe<Setu_Trade_Shared_Entity>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  packaging: Scalars['String'];
  /** An object relationship */
  plot_crop?: Maybe<Setu_Trade_Shared_Entity>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  seller?: Maybe<Setu_Trade_Shared_Entity>;
  seller_expense_amount?: Maybe<Scalars['numeric']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code: Scalars['String'];
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "receipt" */
export type ReceiptExpensesArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptExpenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};

/** aggregated selection of "receipt" */
export type Receipt_Aggregate = {
  __typename?: 'receipt_aggregate';
  aggregate?: Maybe<Receipt_Aggregate_Fields>;
  nodes: Array<Receipt>;
};

/** aggregate fields of "receipt" */
export type Receipt_Aggregate_Fields = {
  __typename?: 'receipt_aggregate_fields';
  avg?: Maybe<Receipt_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Receipt_Max_Fields>;
  min?: Maybe<Receipt_Min_Fields>;
  stddev?: Maybe<Receipt_Stddev_Fields>;
  stddev_pop?: Maybe<Receipt_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Receipt_Stddev_Samp_Fields>;
  sum?: Maybe<Receipt_Sum_Fields>;
  var_pop?: Maybe<Receipt_Var_Pop_Fields>;
  var_samp?: Maybe<Receipt_Var_Samp_Fields>;
  variance?: Maybe<Receipt_Variance_Fields>;
};


/** aggregate fields of "receipt" */
export type Receipt_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Receipt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Receipt_Avg_Fields = {
  __typename?: 'receipt_avg_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "receipt". All fields are combined with a logical 'AND'. */
export type Receipt_Bool_Exp = {
  _and?: InputMaybe<Array<Receipt_Bool_Exp>>;
  _not?: InputMaybe<Receipt_Bool_Exp>;
  _or?: InputMaybe<Array<Receipt_Bool_Exp>>;
  buyer_tnc?: InputMaybe<String_Comparison_Exp>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_id?: InputMaybe<Bigint_Comparison_Exp>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_variety_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  deducted_amount?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  expense_amount?: InputMaybe<Numeric_Comparison_Exp>;
  expenses?: InputMaybe<Expense_Bool_Exp>;
  expiry?: InputMaybe<Date_Comparison_Exp>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  facilitator_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  packaging?: InputMaybe<String_Comparison_Exp>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  plot_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  seller_expense_amount?: InputMaybe<Numeric_Comparison_Exp>;
  seller_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_receivable_amount?: InputMaybe<Numeric_Comparison_Exp>;
  seller_tnc?: InputMaybe<String_Comparison_Exp>;
  standard_deduction?: InputMaybe<Numeric_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  tracking_code?: InputMaybe<String_Comparison_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "receipt" */
export enum Receipt_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReceiptPkey = 'receipt_pkey',
  /** unique or primary key constraint on columns "tracking_code" */
  ReceiptTrackingCodeKey = 'receipt_tracking_code_key'
}

/** input type for incrementing numeric columns in table "receipt" */
export type Receipt_Inc_Input = {
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "receipt" */
export type Receipt_Insert_Input = {
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date?: InputMaybe<Scalars['date']>;
  expenses?: InputMaybe<Expense_Arr_Rel_Insert_Input>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  trades?: InputMaybe<Trade_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Receipt_Max_Fields = {
  __typename?: 'receipt_max_fields';
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  expiry?: Maybe<Scalars['date']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  seller_expense_amount?: Maybe<Scalars['numeric']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Receipt_Min_Fields = {
  __typename?: 'receipt_min_fields';
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  expiry?: Maybe<Scalars['date']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  seller_expense_amount?: Maybe<Scalars['numeric']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "receipt" */
export type Receipt_Mutation_Response = {
  __typename?: 'receipt_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Receipt>;
};

/** input type for inserting object relation for remote table "receipt" */
export type Receipt_Obj_Rel_Insert_Input = {
  data: Receipt_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Receipt_On_Conflict>;
};

/** on_conflict condition type for table "receipt" */
export type Receipt_On_Conflict = {
  constraint: Receipt_Constraint;
  update_columns?: Array<Receipt_Update_Column>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};

/** Ordering options when selecting data from "receipt". */
export type Receipt_Order_By = {
  buyer_tnc?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  expenses_aggregate?: InputMaybe<Expense_Aggregate_Order_By>;
  expiry?: InputMaybe<Order_By>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: receipt */
export type Receipt_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "receipt" */
export enum Receipt_Select_Column {
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeductedAmount = 'deducted_amount',
  /** column name */
  DeductedQuantity = 'deducted_quantity',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  ExpenseAmount = 'expense_amount',
  /** column name */
  Expiry = 'expiry',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Mode = 'mode',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  SellerExpenseAmount = 'seller_expense_amount',
  /** column name */
  SellerId = 'seller_id',
  /** column name */
  SellerReceivableAmount = 'seller_receivable_amount',
  /** column name */
  SellerTnc = 'seller_tnc',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalQuantity = 'total_quantity',
  /** column name */
  TrackingCode = 'tracking_code',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "receipt" */
export type Receipt_Set_Input = {
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date?: InputMaybe<Scalars['date']>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  tracking_code?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Receipt_Stddev_Fields = {
  __typename?: 'receipt_stddev_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Receipt_Stddev_Pop_Fields = {
  __typename?: 'receipt_stddev_pop_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Receipt_Stddev_Samp_Fields = {
  __typename?: 'receipt_stddev_samp_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "receipt" */
export type Receipt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Receipt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Receipt_Stream_Cursor_Value_Input = {
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  deducted_amount?: InputMaybe<Scalars['numeric']>;
  deducted_quantity?: InputMaybe<Scalars['numeric']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date?: InputMaybe<Scalars['date']>;
  expense_amount?: InputMaybe<Scalars['numeric']>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  seller_expense_amount?: InputMaybe<Scalars['numeric']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_receivable_amount?: InputMaybe<Scalars['numeric']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_quantity?: InputMaybe<Scalars['numeric']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Receipt_Sum_Fields = {
  __typename?: 'receipt_sum_fields';
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  seller_expense_amount?: Maybe<Scalars['numeric']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
};

/** update columns of table "receipt" */
export enum Receipt_Update_Column {
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Expiry = 'expiry',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Mode = 'mode',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  SellerId = 'seller_id',
  /** column name */
  SellerTnc = 'seller_tnc',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TrackingCode = 'tracking_code'
}

export type Receipt_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Receipt_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Receipt_Set_Input>;
  where: Receipt_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Receipt_Var_Pop_Fields = {
  __typename?: 'receipt_var_pop_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Receipt_Var_Samp_Fields = {
  __typename?: 'receipt_var_samp_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Receipt_Variance_Fields = {
  __typename?: 'receipt_variance_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "recommended_product" */
export type Recommended_Product = {
  __typename?: 'recommended_product';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  message: Message;
  message_id: Scalars['uuid'];
  /** An object relationship */
  product: Products;
  product_id: Scalars['uuid'];
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit: Array<Si_Unit>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "recommended_product" */
export type Recommended_ProductQuantity_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Recommended_Productquantity_Unit>;
};

/** aggregated selection of "recommended_product" */
export type Recommended_Product_Aggregate = {
  __typename?: 'recommended_product_aggregate';
  aggregate?: Maybe<Recommended_Product_Aggregate_Fields>;
  nodes: Array<Recommended_Product>;
};

/** aggregate fields of "recommended_product" */
export type Recommended_Product_Aggregate_Fields = {
  __typename?: 'recommended_product_aggregate_fields';
  avg?: Maybe<Recommended_Product_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Recommended_Product_Max_Fields>;
  min?: Maybe<Recommended_Product_Min_Fields>;
  stddev?: Maybe<Recommended_Product_Stddev_Fields>;
  stddev_pop?: Maybe<Recommended_Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Recommended_Product_Stddev_Samp_Fields>;
  sum?: Maybe<Recommended_Product_Sum_Fields>;
  var_pop?: Maybe<Recommended_Product_Var_Pop_Fields>;
  var_samp?: Maybe<Recommended_Product_Var_Samp_Fields>;
  variance?: Maybe<Recommended_Product_Variance_Fields>;
};


/** aggregate fields of "recommended_product" */
export type Recommended_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Recommended_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recommended_product" */
export type Recommended_Product_Aggregate_Order_By = {
  avg?: InputMaybe<Recommended_Product_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Recommended_Product_Max_Order_By>;
  min?: InputMaybe<Recommended_Product_Min_Order_By>;
  stddev?: InputMaybe<Recommended_Product_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Recommended_Product_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Recommended_Product_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Recommended_Product_Sum_Order_By>;
  var_pop?: InputMaybe<Recommended_Product_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Recommended_Product_Var_Samp_Order_By>;
  variance?: InputMaybe<Recommended_Product_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "recommended_product" */
export type Recommended_Product_Arr_Rel_Insert_Input = {
  data: Array<Recommended_Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Recommended_Product_On_Conflict>;
};

/** aggregate avg on columns */
export type Recommended_Product_Avg_Fields = {
  __typename?: 'recommended_product_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recommended_product" */
export type Recommended_Product_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "recommended_product". All fields are combined with a logical 'AND'. */
export type Recommended_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Recommended_Product_Bool_Exp>>;
  _not?: InputMaybe<Recommended_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Recommended_Product_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  message?: InputMaybe<Message_Bool_Exp>;
  message_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  quantity_reporting_value?: InputMaybe<Float8_Comparison_Exp>;
  quantity_unit_id?: InputMaybe<String_Comparison_Exp>;
  shared_quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "recommended_product" */
export enum Recommended_Product_Constraint {
  /** unique or primary key constraint on columns "id" */
  RecommendedProductPkey = 'recommended_product_pkey'
}

/** input type for incrementing numeric columns in table "recommended_product" */
export type Recommended_Product_Inc_Input = {
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "recommended_product" */
export type Recommended_Product_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Message_Obj_Rel_Insert_Input>;
  message_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Recommended_Product_Max_Fields = {
  __typename?: 'recommended_product_max_fields';
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "recommended_product" */
export type Recommended_Product_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Recommended_Product_Min_Fields = {
  __typename?: 'recommended_product_min_fields';
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['String']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "recommended_product" */
export type Recommended_Product_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "recommended_product" */
export type Recommended_Product_Mutation_Response = {
  __typename?: 'recommended_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Recommended_Product>;
};

/** on_conflict condition type for table "recommended_product" */
export type Recommended_Product_On_Conflict = {
  constraint: Recommended_Product_Constraint;
  update_columns?: Array<Recommended_Product_Update_Column>;
  where?: InputMaybe<Recommended_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "recommended_product". */
export type Recommended_Product_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  message?: InputMaybe<Message_Order_By>;
  message_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: recommended_product */
export type Recommended_Product_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "recommended_product" */
export enum Recommended_Product_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityReportingValue = 'quantity_reporting_value',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SharedQuantityUnitId = 'shared_quantity_unit_id'
}

/** input type for updating data in table "recommended_product" */
export type Recommended_Product_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Recommended_Product_Stddev_Fields = {
  __typename?: 'recommended_product_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recommended_product" */
export type Recommended_Product_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Recommended_Product_Stddev_Pop_Fields = {
  __typename?: 'recommended_product_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recommended_product" */
export type Recommended_Product_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Recommended_Product_Stddev_Samp_Fields = {
  __typename?: 'recommended_product_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recommended_product" */
export type Recommended_Product_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "recommended_product" */
export type Recommended_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Recommended_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Recommended_Product_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_reporting_value?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['String']>;
  shared_quantity_unit_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Recommended_Product_Sum_Fields = {
  __typename?: 'recommended_product_sum_fields';
  quantity?: Maybe<Scalars['float8']>;
  quantity_reporting_value?: Maybe<Scalars['float8']>;
  shared_quantity_unit_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "recommended_product" */
export type Recommended_Product_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** update columns of table "recommended_product" */
export enum Recommended_Product_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityReportingValue = 'quantity_reporting_value',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SharedQuantityUnitId = 'shared_quantity_unit_id'
}

export type Recommended_Product_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Recommended_Product_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Recommended_Product_Set_Input>;
  where: Recommended_Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Recommended_Product_Var_Pop_Fields = {
  __typename?: 'recommended_product_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recommended_product" */
export type Recommended_Product_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Recommended_Product_Var_Samp_Fields = {
  __typename?: 'recommended_product_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recommended_product" */
export type Recommended_Product_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Recommended_Product_Variance_Fields = {
  __typename?: 'recommended_product_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
  quantity_reporting_value?: Maybe<Scalars['Float']>;
  shared_quantity_unit_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recommended_product" */
export type Recommended_Product_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
  quantity_reporting_value?: InputMaybe<Order_By>;
  shared_quantity_unit_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "region" */
export type Region = {
  __typename?: 'region';
  codename: Scalars['String'];
  description: Scalars['String'];
  /** An array relationship */
  fields: Array<Field>;
  /** An aggregate relationship */
  fields_aggregate: Field_Aggregate;
  geom?: Maybe<Scalars['geometry']>;
  group_id: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An array relationship */
  mutual_groups: Array<Mutual_Group>;
  /** An aggregate relationship */
  mutual_groups_aggregate: Mutual_Group_Aggregate;
  name: Scalars['String'];
  /** An object relationship */
  parent_region?: Maybe<Region>;
  parent_region_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  region_group: Region_Group;
  /** An array relationship */
  regions: Array<Region>;
  /** An aggregate relationship */
  regions_aggregate: Region_Aggregate;
};


/** columns and relationships of "region" */
export type RegionFieldsArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "region" */
export type RegionFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "region" */
export type RegionMutual_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


/** columns and relationships of "region" */
export type RegionMutual_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


/** columns and relationships of "region" */
export type RegionRegionsArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


/** columns and relationships of "region" */
export type RegionRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};

/** aggregated selection of "region" */
export type Region_Aggregate = {
  __typename?: 'region_aggregate';
  aggregate?: Maybe<Region_Aggregate_Fields>;
  nodes: Array<Region>;
};

/** aggregate fields of "region" */
export type Region_Aggregate_Fields = {
  __typename?: 'region_aggregate_fields';
  avg?: Maybe<Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Region_Max_Fields>;
  min?: Maybe<Region_Min_Fields>;
  stddev?: Maybe<Region_Stddev_Fields>;
  stddev_pop?: Maybe<Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Region_Stddev_Samp_Fields>;
  sum?: Maybe<Region_Sum_Fields>;
  var_pop?: Maybe<Region_Var_Pop_Fields>;
  var_samp?: Maybe<Region_Var_Samp_Fields>;
  variance?: Maybe<Region_Variance_Fields>;
};


/** aggregate fields of "region" */
export type Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "region" */
export type Region_Aggregate_Order_By = {
  avg?: InputMaybe<Region_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Region_Max_Order_By>;
  min?: InputMaybe<Region_Min_Order_By>;
  stddev?: InputMaybe<Region_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Region_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Region_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Region_Sum_Order_By>;
  var_pop?: InputMaybe<Region_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Region_Var_Samp_Order_By>;
  variance?: InputMaybe<Region_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "region" */
export type Region_Arr_Rel_Insert_Input = {
  data: Array<Region_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Region_On_Conflict>;
};

/** aggregate avg on columns */
export type Region_Avg_Fields = {
  __typename?: 'region_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "region" */
export type Region_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "region". All fields are combined with a logical 'AND'. */
export type Region_Bool_Exp = {
  _and?: InputMaybe<Array<Region_Bool_Exp>>;
  _not?: InputMaybe<Region_Bool_Exp>;
  _or?: InputMaybe<Array<Region_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_groups?: InputMaybe<Mutual_Group_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_region?: InputMaybe<Region_Bool_Exp>;
  parent_region_id?: InputMaybe<Int_Comparison_Exp>;
  region_group?: InputMaybe<Region_Group_Bool_Exp>;
  regions?: InputMaybe<Region_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "region". All fields are combined with a logical 'AND'. */
export type Region_Bool_Exp_Remote_Rel_Article_Regionsregion = {
  _and?: InputMaybe<Array<Region_Bool_Exp>>;
  _not?: InputMaybe<Region_Bool_Exp>;
  _or?: InputMaybe<Array<Region_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Article_Regionsregion>;
  description?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_groups?: InputMaybe<Mutual_Group_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_region?: InputMaybe<Region_Bool_Exp>;
  parent_region_id?: InputMaybe<Int_Comparison_Exp>;
  region_group?: InputMaybe<Region_Group_Bool_Exp>;
  regions?: InputMaybe<Region_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "region". All fields are combined with a logical 'AND'. */
export type Region_Bool_Exp_Remote_Rel_Notification_Template_Distribution_Regionregion = {
  _and?: InputMaybe<Array<Region_Bool_Exp>>;
  _not?: InputMaybe<Region_Bool_Exp>;
  _or?: InputMaybe<Array<Region_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Notification_Template_Distribution_Regionregion>;
  description?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_groups?: InputMaybe<Mutual_Group_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_region?: InputMaybe<Region_Bool_Exp>;
  parent_region_id?: InputMaybe<Int_Comparison_Exp>;
  region_group?: InputMaybe<Region_Group_Bool_Exp>;
  regions?: InputMaybe<Region_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "region". All fields are combined with a logical 'AND'. */
export type Region_Bool_Exp_Remote_Rel_Shared_Entityregion = {
  _and?: InputMaybe<Array<Region_Bool_Exp>>;
  _not?: InputMaybe<Region_Bool_Exp>;
  _or?: InputMaybe<Array<Region_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityregion>;
  description?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_groups?: InputMaybe<Mutual_Group_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_region?: InputMaybe<Region_Bool_Exp>;
  parent_region_id?: InputMaybe<Int_Comparison_Exp>;
  region_group?: InputMaybe<Region_Group_Bool_Exp>;
  regions?: InputMaybe<Region_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "region". All fields are combined with a logical 'AND'. */
export type Region_Bool_Exp_Remote_Rel_Trade_Regionregion = {
  _and?: InputMaybe<Array<Region_Bool_Exp>>;
  _not?: InputMaybe<Region_Bool_Exp>;
  _or?: InputMaybe<Array<Region_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Trade_Regionregion>;
  description?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_groups?: InputMaybe<Mutual_Group_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_region?: InputMaybe<Region_Bool_Exp>;
  parent_region_id?: InputMaybe<Int_Comparison_Exp>;
  region_group?: InputMaybe<Region_Group_Bool_Exp>;
  regions?: InputMaybe<Region_Bool_Exp>;
};

/** unique or primary key constraints on table "region" */
export enum Region_Constraint {
  /** unique or primary key constraint on columns "codename" */
  RegionCodenameKey = 'region_codename_key',
  /** unique or primary key constraint on columns "name", "parent_region_id", "group_id" */
  RegionGroupIdNameParentRegionIdD398bc0cUniq = 'region_group_id_name_parent_region_id_d398bc0c_uniq',
  /** unique or primary key constraint on columns "id" */
  RegionPkey = 'region_pkey'
}

/** columns and relationships of "region_group" */
export type Region_Group = {
  __typename?: 'region_group';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "region_group" */
export type Region_Group_Aggregate = {
  __typename?: 'region_group_aggregate';
  aggregate?: Maybe<Region_Group_Aggregate_Fields>;
  nodes: Array<Region_Group>;
};

/** aggregate fields of "region_group" */
export type Region_Group_Aggregate_Fields = {
  __typename?: 'region_group_aggregate_fields';
  avg?: Maybe<Region_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Region_Group_Max_Fields>;
  min?: Maybe<Region_Group_Min_Fields>;
  stddev?: Maybe<Region_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Region_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Region_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Region_Group_Sum_Fields>;
  var_pop?: Maybe<Region_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Region_Group_Var_Samp_Fields>;
  variance?: Maybe<Region_Group_Variance_Fields>;
};


/** aggregate fields of "region_group" */
export type Region_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Region_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Region_Group_Avg_Fields = {
  __typename?: 'region_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "region_group". All fields are combined with a logical 'AND'. */
export type Region_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Region_Group_Bool_Exp>>;
  _not?: InputMaybe<Region_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Region_Group_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "region_group" */
export enum Region_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  RegionGroupCodenameKey = 'region_group_codename_key',
  /** unique or primary key constraint on columns "name" */
  RegionGroupNameKey = 'region_group_name_key',
  /** unique or primary key constraint on columns "id" */
  RegionGroupPkey = 'region_group_pkey'
}

/** input type for incrementing numeric columns in table "region_group" */
export type Region_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "region_group" */
export type Region_Group_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Region_Group_Max_Fields = {
  __typename?: 'region_group_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Region_Group_Min_Fields = {
  __typename?: 'region_group_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "region_group" */
export type Region_Group_Mutation_Response = {
  __typename?: 'region_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Region_Group>;
};

/** input type for inserting object relation for remote table "region_group" */
export type Region_Group_Obj_Rel_Insert_Input = {
  data: Region_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Region_Group_On_Conflict>;
};

/** on_conflict condition type for table "region_group" */
export type Region_Group_On_Conflict = {
  constraint: Region_Group_Constraint;
  update_columns?: Array<Region_Group_Update_Column>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "region_group". */
export type Region_Group_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: region_group */
export type Region_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "region_group" */
export enum Region_Group_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "region_group" */
export type Region_Group_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Region_Group_Stddev_Fields = {
  __typename?: 'region_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Region_Group_Stddev_Pop_Fields = {
  __typename?: 'region_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Region_Group_Stddev_Samp_Fields = {
  __typename?: 'region_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "region_group" */
export type Region_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Region_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Region_Group_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Region_Group_Sum_Fields = {
  __typename?: 'region_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "region_group" */
export enum Region_Group_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Region_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Region_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Region_Group_Set_Input>;
  where: Region_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Region_Group_Var_Pop_Fields = {
  __typename?: 'region_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Region_Group_Var_Samp_Fields = {
  __typename?: 'region_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Region_Group_Variance_Fields = {
  __typename?: 'region_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "region" */
export type Region_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  parent_region_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "region" */
export type Region_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Field_Arr_Rel_Insert_Input>;
  geom?: InputMaybe<Scalars['geometry']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_groups?: InputMaybe<Mutual_Group_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  parent_region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  parent_region_id?: InputMaybe<Scalars['Int']>;
  region_group?: InputMaybe<Region_Group_Obj_Rel_Insert_Input>;
  regions?: InputMaybe<Region_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Region_Max_Fields = {
  __typename?: 'region_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_region_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "region" */
export type Region_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Region_Min_Fields = {
  __typename?: 'region_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_region_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "region" */
export type Region_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "region" */
export type Region_Mutation_Response = {
  __typename?: 'region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Region>;
};

/** input type for inserting object relation for remote table "region" */
export type Region_Obj_Rel_Insert_Input = {
  data: Region_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Region_On_Conflict>;
};

/** on_conflict condition type for table "region" */
export type Region_On_Conflict = {
  constraint: Region_Constraint;
  update_columns?: Array<Region_Update_Column>;
  where?: InputMaybe<Region_Bool_Exp>;
};

/** Ordering options when selecting data from "region". */
export type Region_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fields_aggregate?: InputMaybe<Field_Aggregate_Order_By>;
  geom?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mutual_groups_aggregate?: InputMaybe<Mutual_Group_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  parent_region?: InputMaybe<Region_Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
  region_group?: InputMaybe<Region_Group_Order_By>;
  regions_aggregate?: InputMaybe<Region_Aggregate_Order_By>;
};

/** primary key columns input for table: region */
export type Region_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "region" */
export enum Region_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Geom = 'geom',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ParentRegionId = 'parent_region_id'
}

/** input type for updating data in table "region" */
export type Region_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Scalars['geometry']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_region_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Region_Stddev_Fields = {
  __typename?: 'region_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "region" */
export type Region_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Region_Stddev_Pop_Fields = {
  __typename?: 'region_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "region" */
export type Region_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Region_Stddev_Samp_Fields = {
  __typename?: 'region_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "region" */
export type Region_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "region" */
export type Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Region_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Scalars['geometry']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_region_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Region_Sum_Fields = {
  __typename?: 'region_sum_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent_region_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "region" */
export type Region_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** update columns of table "region" */
export enum Region_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Geom = 'geom',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ParentRegionId = 'parent_region_id'
}

export type Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Region_Set_Input>;
  where: Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Region_Var_Pop_Fields = {
  __typename?: 'region_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "region" */
export type Region_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Region_Var_Samp_Fields = {
  __typename?: 'region_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "region" */
export type Region_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Region_Variance_Fields = {
  __typename?: 'region_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "region" */
export type Region_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "reward_configuration" */
export type Reward_Configuration = {
  __typename?: 'reward_configuration';
  action?: Maybe<Scalars['String']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  content_type_id: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  field: Scalars['String'];
  /** An object relationship */
  fileupload?: Maybe<Fileupload>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  point: Scalars['float8'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  /** An array relationship */
  user_reward_histories: Array<User_Reward_History>;
  /** An aggregate relationship */
  user_reward_histories_aggregate: User_Reward_History_Aggregate;
};


/** columns and relationships of "reward_configuration" */
export type Reward_ConfigurationUser_Reward_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<User_Reward_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Reward_History_Order_By>>;
  where?: InputMaybe<User_Reward_History_Bool_Exp>;
};


/** columns and relationships of "reward_configuration" */
export type Reward_ConfigurationUser_Reward_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Reward_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Reward_History_Order_By>>;
  where?: InputMaybe<User_Reward_History_Bool_Exp>;
};

/** aggregated selection of "reward_configuration" */
export type Reward_Configuration_Aggregate = {
  __typename?: 'reward_configuration_aggregate';
  aggregate?: Maybe<Reward_Configuration_Aggregate_Fields>;
  nodes: Array<Reward_Configuration>;
};

/** aggregate fields of "reward_configuration" */
export type Reward_Configuration_Aggregate_Fields = {
  __typename?: 'reward_configuration_aggregate_fields';
  avg?: Maybe<Reward_Configuration_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Reward_Configuration_Max_Fields>;
  min?: Maybe<Reward_Configuration_Min_Fields>;
  stddev?: Maybe<Reward_Configuration_Stddev_Fields>;
  stddev_pop?: Maybe<Reward_Configuration_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reward_Configuration_Stddev_Samp_Fields>;
  sum?: Maybe<Reward_Configuration_Sum_Fields>;
  var_pop?: Maybe<Reward_Configuration_Var_Pop_Fields>;
  var_samp?: Maybe<Reward_Configuration_Var_Samp_Fields>;
  variance?: Maybe<Reward_Configuration_Variance_Fields>;
};


/** aggregate fields of "reward_configuration" */
export type Reward_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reward_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Reward_Configuration_Avg_Fields = {
  __typename?: 'reward_configuration_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  point?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reward_configuration". All fields are combined with a logical 'AND'. */
export type Reward_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Reward_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Reward_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Reward_Configuration_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  field?: InputMaybe<String_Comparison_Exp>;
  fileupload?: InputMaybe<Fileupload_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  point?: InputMaybe<Float8_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_reward_histories?: InputMaybe<User_Reward_History_Bool_Exp>;
};

/** unique or primary key constraints on table "reward_configuration" */
export enum Reward_Configuration_Constraint {
  /** unique or primary key constraint on columns "field", "content_type_id" */
  RewardConfigurationContentTypeIdField_4b40a16bUniq = 'reward_configuration_content_type_id_field_4b40a16b_uniq',
  /** unique or primary key constraint on columns "id" */
  RewardConfigurationPkey = 'reward_configuration_pkey'
}

/** input type for incrementing numeric columns in table "reward_configuration" */
export type Reward_Configuration_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  point?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "reward_configuration" */
export type Reward_Configuration_Insert_Input = {
  action?: InputMaybe<Scalars['String']>;
  attachment_id?: InputMaybe<Scalars['bigint']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['String']>;
  fileupload?: InputMaybe<Fileupload_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  point?: InputMaybe<Scalars['float8']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user_reward_histories?: InputMaybe<User_Reward_History_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Reward_Configuration_Max_Fields = {
  __typename?: 'reward_configuration_max_fields';
  action?: Maybe<Scalars['String']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  content_type_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  point?: Maybe<Scalars['float8']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Reward_Configuration_Min_Fields = {
  __typename?: 'reward_configuration_min_fields';
  action?: Maybe<Scalars['String']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  content_type_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  point?: Maybe<Scalars['float8']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "reward_configuration" */
export type Reward_Configuration_Mutation_Response = {
  __typename?: 'reward_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Reward_Configuration>;
};

/** input type for inserting object relation for remote table "reward_configuration" */
export type Reward_Configuration_Obj_Rel_Insert_Input = {
  data: Reward_Configuration_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Reward_Configuration_On_Conflict>;
};

/** on_conflict condition type for table "reward_configuration" */
export type Reward_Configuration_On_Conflict = {
  constraint: Reward_Configuration_Constraint;
  update_columns?: Array<Reward_Configuration_Update_Column>;
  where?: InputMaybe<Reward_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "reward_configuration". */
export type Reward_Configuration_Order_By = {
  action?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  fileupload?: InputMaybe<Fileupload_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  point?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_reward_histories_aggregate?: InputMaybe<User_Reward_History_Aggregate_Order_By>;
};

/** primary key columns input for table: reward_configuration */
export type Reward_Configuration_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "reward_configuration" */
export enum Reward_Configuration_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Description = 'description',
  /** column name */
  Field = 'field',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Point = 'point',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "reward_configuration" */
export type Reward_Configuration_Set_Input = {
  action?: InputMaybe<Scalars['String']>;
  attachment_id?: InputMaybe<Scalars['bigint']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  point?: InputMaybe<Scalars['float8']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Reward_Configuration_Stddev_Fields = {
  __typename?: 'reward_configuration_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  point?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Reward_Configuration_Stddev_Pop_Fields = {
  __typename?: 'reward_configuration_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  point?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Reward_Configuration_Stddev_Samp_Fields = {
  __typename?: 'reward_configuration_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  point?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "reward_configuration" */
export type Reward_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reward_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reward_Configuration_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']>;
  attachment_id?: InputMaybe<Scalars['bigint']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  point?: InputMaybe<Scalars['float8']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Reward_Configuration_Sum_Fields = {
  __typename?: 'reward_configuration_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  content_type_id?: Maybe<Scalars['Int']>;
  point?: Maybe<Scalars['float8']>;
};

/** update columns of table "reward_configuration" */
export enum Reward_Configuration_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Description = 'description',
  /** column name */
  Field = 'field',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Point = 'point',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type'
}

export type Reward_Configuration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reward_Configuration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reward_Configuration_Set_Input>;
  where: Reward_Configuration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reward_Configuration_Var_Pop_Fields = {
  __typename?: 'reward_configuration_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  point?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Reward_Configuration_Var_Samp_Fields = {
  __typename?: 'reward_configuration_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  point?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Reward_Configuration_Variance_Fields = {
  __typename?: 'reward_configuration_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  point?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sap_si" */
export type Sap_Si = {
  __typename?: 'sap_si';
  basic_text?: Maybe<Scalars['String']>;
  category1_code?: Maybe<Scalars['String']>;
  category1_name?: Maybe<Scalars['String']>;
  category2_code?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['String']>;
  erp_refcode?: Maybe<Scalars['String']>;
  exp_date?: Maybe<Scalars['String']>;
  gst_code?: Maybe<Scalars['String']>;
  hsn_code?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  item_name?: Maybe<Scalars['String']>;
  material_group?: Maybe<Scalars['String']>;
  material_type?: Maybe<Scalars['String']>;
  sales_org?: Maybe<Scalars['String']>;
  send_outlet?: Maybe<Scalars['String']>;
  shelf_life?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "sap_si" */
export type Sap_Si_Aggregate = {
  __typename?: 'sap_si_aggregate';
  aggregate?: Maybe<Sap_Si_Aggregate_Fields>;
  nodes: Array<Sap_Si>;
};

/** aggregate fields of "sap_si" */
export type Sap_Si_Aggregate_Fields = {
  __typename?: 'sap_si_aggregate_fields';
  avg?: Maybe<Sap_Si_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sap_Si_Max_Fields>;
  min?: Maybe<Sap_Si_Min_Fields>;
  stddev?: Maybe<Sap_Si_Stddev_Fields>;
  stddev_pop?: Maybe<Sap_Si_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sap_Si_Stddev_Samp_Fields>;
  sum?: Maybe<Sap_Si_Sum_Fields>;
  var_pop?: Maybe<Sap_Si_Var_Pop_Fields>;
  var_samp?: Maybe<Sap_Si_Var_Samp_Fields>;
  variance?: Maybe<Sap_Si_Variance_Fields>;
};


/** aggregate fields of "sap_si" */
export type Sap_Si_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sap_Si_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sap_Si_Avg_Fields = {
  __typename?: 'sap_si_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sap_si". All fields are combined with a logical 'AND'. */
export type Sap_Si_Bool_Exp = {
  _and?: InputMaybe<Array<Sap_Si_Bool_Exp>>;
  _not?: InputMaybe<Sap_Si_Bool_Exp>;
  _or?: InputMaybe<Array<Sap_Si_Bool_Exp>>;
  basic_text?: InputMaybe<String_Comparison_Exp>;
  category1_code?: InputMaybe<String_Comparison_Exp>;
  category1_name?: InputMaybe<String_Comparison_Exp>;
  category2_code?: InputMaybe<String_Comparison_Exp>;
  division?: InputMaybe<String_Comparison_Exp>;
  erp_refcode?: InputMaybe<String_Comparison_Exp>;
  exp_date?: InputMaybe<String_Comparison_Exp>;
  gst_code?: InputMaybe<String_Comparison_Exp>;
  hsn_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  item_name?: InputMaybe<String_Comparison_Exp>;
  material_group?: InputMaybe<String_Comparison_Exp>;
  material_type?: InputMaybe<String_Comparison_Exp>;
  sales_org?: InputMaybe<String_Comparison_Exp>;
  send_outlet?: InputMaybe<String_Comparison_Exp>;
  shelf_life?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sap_si" */
export enum Sap_Si_Constraint {
  /** unique or primary key constraint on columns "erp_refcode" */
  SapSiErpRefcode_4479b123Uniq = 'sap_si_erp_refcode_4479b123_uniq',
  /** unique or primary key constraint on columns "id" */
  SapSiPkey = 'sap_si_pkey'
}

/** input type for incrementing numeric columns in table "sap_si" */
export type Sap_Si_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sap_si" */
export type Sap_Si_Insert_Input = {
  basic_text?: InputMaybe<Scalars['String']>;
  category1_code?: InputMaybe<Scalars['String']>;
  category1_name?: InputMaybe<Scalars['String']>;
  category2_code?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<Scalars['String']>;
  erp_refcode?: InputMaybe<Scalars['String']>;
  exp_date?: InputMaybe<Scalars['String']>;
  gst_code?: InputMaybe<Scalars['String']>;
  hsn_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  item_name?: InputMaybe<Scalars['String']>;
  material_group?: InputMaybe<Scalars['String']>;
  material_type?: InputMaybe<Scalars['String']>;
  sales_org?: InputMaybe<Scalars['String']>;
  send_outlet?: InputMaybe<Scalars['String']>;
  shelf_life?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "sap_si_map" */
export type Sap_Si_Map = {
  __typename?: 'sap_si_map';
  care_item_id: Scalars['uuid'];
  id: Scalars['bigint'];
  sap_item_id: Scalars['bigint'];
};

/** aggregated selection of "sap_si_map" */
export type Sap_Si_Map_Aggregate = {
  __typename?: 'sap_si_map_aggregate';
  aggregate?: Maybe<Sap_Si_Map_Aggregate_Fields>;
  nodes: Array<Sap_Si_Map>;
};

/** aggregate fields of "sap_si_map" */
export type Sap_Si_Map_Aggregate_Fields = {
  __typename?: 'sap_si_map_aggregate_fields';
  avg?: Maybe<Sap_Si_Map_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sap_Si_Map_Max_Fields>;
  min?: Maybe<Sap_Si_Map_Min_Fields>;
  stddev?: Maybe<Sap_Si_Map_Stddev_Fields>;
  stddev_pop?: Maybe<Sap_Si_Map_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sap_Si_Map_Stddev_Samp_Fields>;
  sum?: Maybe<Sap_Si_Map_Sum_Fields>;
  var_pop?: Maybe<Sap_Si_Map_Var_Pop_Fields>;
  var_samp?: Maybe<Sap_Si_Map_Var_Samp_Fields>;
  variance?: Maybe<Sap_Si_Map_Variance_Fields>;
};


/** aggregate fields of "sap_si_map" */
export type Sap_Si_Map_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sap_Si_Map_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sap_Si_Map_Avg_Fields = {
  __typename?: 'sap_si_map_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sap_item_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sap_si_map". All fields are combined with a logical 'AND'. */
export type Sap_Si_Map_Bool_Exp = {
  _and?: InputMaybe<Array<Sap_Si_Map_Bool_Exp>>;
  _not?: InputMaybe<Sap_Si_Map_Bool_Exp>;
  _or?: InputMaybe<Array<Sap_Si_Map_Bool_Exp>>;
  care_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  sap_item_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "sap_si_map" */
export enum Sap_Si_Map_Constraint {
  /** unique or primary key constraint on columns "id" */
  SapSiMapPkey = 'sap_si_map_pkey',
  /** unique or primary key constraint on columns "sap_item_id", "care_item_id" */
  SapSiMapSapItemIdCareItemIdC0de0599Uniq = 'sap_si_map_sap_item_id_care_item_id_c0de0599_uniq'
}

/** input type for incrementing numeric columns in table "sap_si_map" */
export type Sap_Si_Map_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  sap_item_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sap_si_map" */
export type Sap_Si_Map_Insert_Input = {
  care_item_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  sap_item_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Sap_Si_Map_Max_Fields = {
  __typename?: 'sap_si_map_max_fields';
  care_item_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  sap_item_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Sap_Si_Map_Min_Fields = {
  __typename?: 'sap_si_map_min_fields';
  care_item_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  sap_item_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "sap_si_map" */
export type Sap_Si_Map_Mutation_Response = {
  __typename?: 'sap_si_map_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sap_Si_Map>;
};

/** on_conflict condition type for table "sap_si_map" */
export type Sap_Si_Map_On_Conflict = {
  constraint: Sap_Si_Map_Constraint;
  update_columns?: Array<Sap_Si_Map_Update_Column>;
  where?: InputMaybe<Sap_Si_Map_Bool_Exp>;
};

/** Ordering options when selecting data from "sap_si_map". */
export type Sap_Si_Map_Order_By = {
  care_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sap_item_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sap_si_map */
export type Sap_Si_Map_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "sap_si_map" */
export enum Sap_Si_Map_Select_Column {
  /** column name */
  CareItemId = 'care_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  SapItemId = 'sap_item_id'
}

/** input type for updating data in table "sap_si_map" */
export type Sap_Si_Map_Set_Input = {
  care_item_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  sap_item_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Sap_Si_Map_Stddev_Fields = {
  __typename?: 'sap_si_map_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sap_item_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sap_Si_Map_Stddev_Pop_Fields = {
  __typename?: 'sap_si_map_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sap_item_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sap_Si_Map_Stddev_Samp_Fields = {
  __typename?: 'sap_si_map_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sap_item_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sap_si_map" */
export type Sap_Si_Map_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sap_Si_Map_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sap_Si_Map_Stream_Cursor_Value_Input = {
  care_item_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  sap_item_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Sap_Si_Map_Sum_Fields = {
  __typename?: 'sap_si_map_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  sap_item_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "sap_si_map" */
export enum Sap_Si_Map_Update_Column {
  /** column name */
  CareItemId = 'care_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  SapItemId = 'sap_item_id'
}

export type Sap_Si_Map_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sap_Si_Map_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sap_Si_Map_Set_Input>;
  where: Sap_Si_Map_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sap_Si_Map_Var_Pop_Fields = {
  __typename?: 'sap_si_map_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sap_item_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sap_Si_Map_Var_Samp_Fields = {
  __typename?: 'sap_si_map_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sap_item_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sap_Si_Map_Variance_Fields = {
  __typename?: 'sap_si_map_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sap_item_id?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Sap_Si_Max_Fields = {
  __typename?: 'sap_si_max_fields';
  basic_text?: Maybe<Scalars['String']>;
  category1_code?: Maybe<Scalars['String']>;
  category1_name?: Maybe<Scalars['String']>;
  category2_code?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['String']>;
  erp_refcode?: Maybe<Scalars['String']>;
  exp_date?: Maybe<Scalars['String']>;
  gst_code?: Maybe<Scalars['String']>;
  hsn_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  item_name?: Maybe<Scalars['String']>;
  material_group?: Maybe<Scalars['String']>;
  material_type?: Maybe<Scalars['String']>;
  sales_org?: Maybe<Scalars['String']>;
  send_outlet?: Maybe<Scalars['String']>;
  shelf_life?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Sap_Si_Min_Fields = {
  __typename?: 'sap_si_min_fields';
  basic_text?: Maybe<Scalars['String']>;
  category1_code?: Maybe<Scalars['String']>;
  category1_name?: Maybe<Scalars['String']>;
  category2_code?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['String']>;
  erp_refcode?: Maybe<Scalars['String']>;
  exp_date?: Maybe<Scalars['String']>;
  gst_code?: Maybe<Scalars['String']>;
  hsn_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  item_name?: Maybe<Scalars['String']>;
  material_group?: Maybe<Scalars['String']>;
  material_type?: Maybe<Scalars['String']>;
  sales_org?: Maybe<Scalars['String']>;
  send_outlet?: Maybe<Scalars['String']>;
  shelf_life?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "sap_si" */
export type Sap_Si_Mutation_Response = {
  __typename?: 'sap_si_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sap_Si>;
};

/** on_conflict condition type for table "sap_si" */
export type Sap_Si_On_Conflict = {
  constraint: Sap_Si_Constraint;
  update_columns?: Array<Sap_Si_Update_Column>;
  where?: InputMaybe<Sap_Si_Bool_Exp>;
};

/** Ordering options when selecting data from "sap_si". */
export type Sap_Si_Order_By = {
  basic_text?: InputMaybe<Order_By>;
  category1_code?: InputMaybe<Order_By>;
  category1_name?: InputMaybe<Order_By>;
  category2_code?: InputMaybe<Order_By>;
  division?: InputMaybe<Order_By>;
  erp_refcode?: InputMaybe<Order_By>;
  exp_date?: InputMaybe<Order_By>;
  gst_code?: InputMaybe<Order_By>;
  hsn_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_name?: InputMaybe<Order_By>;
  material_group?: InputMaybe<Order_By>;
  material_type?: InputMaybe<Order_By>;
  sales_org?: InputMaybe<Order_By>;
  send_outlet?: InputMaybe<Order_By>;
  shelf_life?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sap_si */
export type Sap_Si_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "sap_si" */
export enum Sap_Si_Select_Column {
  /** column name */
  BasicText = 'basic_text',
  /** column name */
  Category1Code = 'category1_code',
  /** column name */
  Category1Name = 'category1_name',
  /** column name */
  Category2Code = 'category2_code',
  /** column name */
  Division = 'division',
  /** column name */
  ErpRefcode = 'erp_refcode',
  /** column name */
  ExpDate = 'exp_date',
  /** column name */
  GstCode = 'gst_code',
  /** column name */
  HsnCode = 'hsn_code',
  /** column name */
  Id = 'id',
  /** column name */
  ItemName = 'item_name',
  /** column name */
  MaterialGroup = 'material_group',
  /** column name */
  MaterialType = 'material_type',
  /** column name */
  SalesOrg = 'sales_org',
  /** column name */
  SendOutlet = 'send_outlet',
  /** column name */
  ShelfLife = 'shelf_life',
  /** column name */
  ShortName = 'short_name'
}

/** input type for updating data in table "sap_si" */
export type Sap_Si_Set_Input = {
  basic_text?: InputMaybe<Scalars['String']>;
  category1_code?: InputMaybe<Scalars['String']>;
  category1_name?: InputMaybe<Scalars['String']>;
  category2_code?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<Scalars['String']>;
  erp_refcode?: InputMaybe<Scalars['String']>;
  exp_date?: InputMaybe<Scalars['String']>;
  gst_code?: InputMaybe<Scalars['String']>;
  hsn_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  item_name?: InputMaybe<Scalars['String']>;
  material_group?: InputMaybe<Scalars['String']>;
  material_type?: InputMaybe<Scalars['String']>;
  sales_org?: InputMaybe<Scalars['String']>;
  send_outlet?: InputMaybe<Scalars['String']>;
  shelf_life?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Sap_Si_Stddev_Fields = {
  __typename?: 'sap_si_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sap_Si_Stddev_Pop_Fields = {
  __typename?: 'sap_si_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sap_Si_Stddev_Samp_Fields = {
  __typename?: 'sap_si_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sap_si" */
export type Sap_Si_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sap_Si_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sap_Si_Stream_Cursor_Value_Input = {
  basic_text?: InputMaybe<Scalars['String']>;
  category1_code?: InputMaybe<Scalars['String']>;
  category1_name?: InputMaybe<Scalars['String']>;
  category2_code?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<Scalars['String']>;
  erp_refcode?: InputMaybe<Scalars['String']>;
  exp_date?: InputMaybe<Scalars['String']>;
  gst_code?: InputMaybe<Scalars['String']>;
  hsn_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  item_name?: InputMaybe<Scalars['String']>;
  material_group?: InputMaybe<Scalars['String']>;
  material_type?: InputMaybe<Scalars['String']>;
  sales_org?: InputMaybe<Scalars['String']>;
  send_outlet?: InputMaybe<Scalars['String']>;
  shelf_life?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Sap_Si_Sum_Fields = {
  __typename?: 'sap_si_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "sap_si" */
export enum Sap_Si_Update_Column {
  /** column name */
  BasicText = 'basic_text',
  /** column name */
  Category1Code = 'category1_code',
  /** column name */
  Category1Name = 'category1_name',
  /** column name */
  Category2Code = 'category2_code',
  /** column name */
  Division = 'division',
  /** column name */
  ErpRefcode = 'erp_refcode',
  /** column name */
  ExpDate = 'exp_date',
  /** column name */
  GstCode = 'gst_code',
  /** column name */
  HsnCode = 'hsn_code',
  /** column name */
  Id = 'id',
  /** column name */
  ItemName = 'item_name',
  /** column name */
  MaterialGroup = 'material_group',
  /** column name */
  MaterialType = 'material_type',
  /** column name */
  SalesOrg = 'sales_org',
  /** column name */
  SendOutlet = 'send_outlet',
  /** column name */
  ShelfLife = 'shelf_life',
  /** column name */
  ShortName = 'short_name'
}

export type Sap_Si_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sap_Si_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sap_Si_Set_Input>;
  where: Sap_Si_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sap_Si_Var_Pop_Fields = {
  __typename?: 'sap_si_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sap_Si_Var_Samp_Fields = {
  __typename?: 'sap_si_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sap_Si_Variance_Fields = {
  __typename?: 'sap_si_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Search_Base_Users_Args = {
  query?: InputMaybe<Scalars['String']>;
};

export type Search_Mutual_Groups_Args = {
  query?: InputMaybe<Scalars['String']>;
};

export type Search_Plot_Crops_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "secondary_growth_stage" */
export type Secondary_Growth_Stage = {
  __typename?: 'secondary_growth_stage';
  base_stage: Scalars['String'];
  code: Scalars['String'];
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  max_days_after: Scalars['Int'];
  min_days_after: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  primary_growth_stage: Primary_Growth_Stage;
  primary_growth_stage_id: Scalars['Int'];
};

/** aggregated selection of "secondary_growth_stage" */
export type Secondary_Growth_Stage_Aggregate = {
  __typename?: 'secondary_growth_stage_aggregate';
  aggregate?: Maybe<Secondary_Growth_Stage_Aggregate_Fields>;
  nodes: Array<Secondary_Growth_Stage>;
};

/** aggregate fields of "secondary_growth_stage" */
export type Secondary_Growth_Stage_Aggregate_Fields = {
  __typename?: 'secondary_growth_stage_aggregate_fields';
  avg?: Maybe<Secondary_Growth_Stage_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Secondary_Growth_Stage_Max_Fields>;
  min?: Maybe<Secondary_Growth_Stage_Min_Fields>;
  stddev?: Maybe<Secondary_Growth_Stage_Stddev_Fields>;
  stddev_pop?: Maybe<Secondary_Growth_Stage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Secondary_Growth_Stage_Stddev_Samp_Fields>;
  sum?: Maybe<Secondary_Growth_Stage_Sum_Fields>;
  var_pop?: Maybe<Secondary_Growth_Stage_Var_Pop_Fields>;
  var_samp?: Maybe<Secondary_Growth_Stage_Var_Samp_Fields>;
  variance?: Maybe<Secondary_Growth_Stage_Variance_Fields>;
};


/** aggregate fields of "secondary_growth_stage" */
export type Secondary_Growth_Stage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Aggregate_Order_By = {
  avg?: InputMaybe<Secondary_Growth_Stage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Secondary_Growth_Stage_Max_Order_By>;
  min?: InputMaybe<Secondary_Growth_Stage_Min_Order_By>;
  stddev?: InputMaybe<Secondary_Growth_Stage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Secondary_Growth_Stage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Secondary_Growth_Stage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Secondary_Growth_Stage_Sum_Order_By>;
  var_pop?: InputMaybe<Secondary_Growth_Stage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Secondary_Growth_Stage_Var_Samp_Order_By>;
  variance?: InputMaybe<Secondary_Growth_Stage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Arr_Rel_Insert_Input = {
  data: Array<Secondary_Growth_Stage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Secondary_Growth_Stage_On_Conflict>;
};

/** aggregate avg on columns */
export type Secondary_Growth_Stage_Avg_Fields = {
  __typename?: 'secondary_growth_stage_avg_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "secondary_growth_stage". All fields are combined with a logical 'AND'. */
export type Secondary_Growth_Stage_Bool_Exp = {
  _and?: InputMaybe<Array<Secondary_Growth_Stage_Bool_Exp>>;
  _not?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Secondary_Growth_Stage_Bool_Exp>>;
  base_stage?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_days_after?: InputMaybe<Int_Comparison_Exp>;
  min_days_after?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  primary_growth_stage?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
  primary_growth_stage_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "secondary_growth_stage". All fields are combined with a logical 'AND'. */
export type Secondary_Growth_Stage_Bool_Exp_Remote_Rel_Monitoring_Recordsecondary_Growth_Stage = {
  _and?: InputMaybe<Array<Secondary_Growth_Stage_Bool_Exp>>;
  _not?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Secondary_Growth_Stage_Bool_Exp>>;
  base_stage?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Recordsecondary_Growth_Stage>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_days_after?: InputMaybe<Int_Comparison_Exp>;
  min_days_after?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  primary_growth_stage?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
  primary_growth_stage_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "secondary_growth_stage" */
export enum Secondary_Growth_Stage_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SecondaryGrowthStageCodenameKey = 'secondary_growth_stage_codename_key',
  /** unique or primary key constraint on columns "id" */
  SecondaryGrowthStagePkey = 'secondary_growth_stage_pkey',
  /** unique or primary key constraint on columns "code", "primary_growth_stage_id" */
  SecondaryGrowthStagePrimaryGrowthStageId_0004b9f6Uniq = 'secondary_growth_stage_primary_growth_stage_id__0004b9f6_uniq'
}

/** input type for incrementing numeric columns in table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Insert_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage?: InputMaybe<Primary_Growth_Stage_Obj_Rel_Insert_Input>;
  primary_growth_stage_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Secondary_Growth_Stage_Max_Fields = {
  __typename?: 'secondary_growth_stage_max_fields';
  base_stage?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_growth_stage_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Max_Order_By = {
  base_stage?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Secondary_Growth_Stage_Min_Fields = {
  __typename?: 'secondary_growth_stage_min_fields';
  base_stage?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_growth_stage_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Min_Order_By = {
  base_stage?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Mutation_Response = {
  __typename?: 'secondary_growth_stage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Secondary_Growth_Stage>;
};

/** on_conflict condition type for table "secondary_growth_stage" */
export type Secondary_Growth_Stage_On_Conflict = {
  constraint: Secondary_Growth_Stage_Constraint;
  update_columns?: Array<Secondary_Growth_Stage_Update_Column>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};

/** Ordering options when selecting data from "secondary_growth_stage". */
export type Secondary_Growth_Stage_Order_By = {
  base_stage?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage?: InputMaybe<Primary_Growth_Stage_Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: secondary_growth_stage */
export type Secondary_Growth_Stage_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "secondary_growth_stage" */
export enum Secondary_Growth_Stage_Select_Column {
  /** column name */
  BaseStage = 'base_stage',
  /** column name */
  Code = 'code',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxDaysAfter = 'max_days_after',
  /** column name */
  MinDaysAfter = 'min_days_after',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrimaryGrowthStageId = 'primary_growth_stage_id'
}

/** input type for updating data in table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Set_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Secondary_Growth_Stage_Stddev_Fields = {
  __typename?: 'secondary_growth_stage_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Secondary_Growth_Stage_Stddev_Pop_Fields = {
  __typename?: 'secondary_growth_stage_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Secondary_Growth_Stage_Stddev_Samp_Fields = {
  __typename?: 'secondary_growth_stage_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Secondary_Growth_Stage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Secondary_Growth_Stage_Stream_Cursor_Value_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Secondary_Growth_Stage_Sum_Fields = {
  __typename?: 'secondary_growth_stage_sum_fields';
  id?: Maybe<Scalars['Int']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_growth_stage_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** update columns of table "secondary_growth_stage" */
export enum Secondary_Growth_Stage_Update_Column {
  /** column name */
  BaseStage = 'base_stage',
  /** column name */
  Code = 'code',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxDaysAfter = 'max_days_after',
  /** column name */
  MinDaysAfter = 'min_days_after',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrimaryGrowthStageId = 'primary_growth_stage_id'
}

export type Secondary_Growth_Stage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Secondary_Growth_Stage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Secondary_Growth_Stage_Set_Input>;
  where: Secondary_Growth_Stage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Secondary_Growth_Stage_Var_Pop_Fields = {
  __typename?: 'secondary_growth_stage_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Secondary_Growth_Stage_Var_Samp_Fields = {
  __typename?: 'secondary_growth_stage_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Secondary_Growth_Stage_Variance_Fields = {
  __typename?: 'secondary_growth_stage_variance_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "section" */
export type Section = {
  __typename?: 'section';
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  product_sections: Array<Product_Section>;
  /** An aggregate relationship */
  product_sections_aggregate: Product_Section_Aggregate;
};


/** columns and relationships of "section" */
export type SectionProduct_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Order_By>>;
  where?: InputMaybe<Product_Section_Bool_Exp>;
};


/** columns and relationships of "section" */
export type SectionProduct_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Order_By>>;
  where?: InputMaybe<Product_Section_Bool_Exp>;
};

/** aggregated selection of "section" */
export type Section_Aggregate = {
  __typename?: 'section_aggregate';
  aggregate?: Maybe<Section_Aggregate_Fields>;
  nodes: Array<Section>;
};

/** aggregate fields of "section" */
export type Section_Aggregate_Fields = {
  __typename?: 'section_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Section_Max_Fields>;
  min?: Maybe<Section_Min_Fields>;
};


/** aggregate fields of "section" */
export type Section_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Section_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "section". All fields are combined with a logical 'AND'. */
export type Section_Bool_Exp = {
  _and?: InputMaybe<Array<Section_Bool_Exp>>;
  _not?: InputMaybe<Section_Bool_Exp>;
  _or?: InputMaybe<Array<Section_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  product_sections?: InputMaybe<Product_Section_Bool_Exp>;
};

/** unique or primary key constraints on table "section" */
export enum Section_Constraint {
  /** unique or primary key constraint on columns "id" */
  SectionPkey = 'section_pkey'
}

/** input type for inserting data into table "section" */
export type Section_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  product_sections?: InputMaybe<Product_Section_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Section_Max_Fields = {
  __typename?: 'section_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Section_Min_Fields = {
  __typename?: 'section_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "section" */
export type Section_Mutation_Response = {
  __typename?: 'section_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Section>;
};

/** input type for inserting object relation for remote table "section" */
export type Section_Obj_Rel_Insert_Input = {
  data: Section_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Section_On_Conflict>;
};

/** on_conflict condition type for table "section" */
export type Section_On_Conflict = {
  constraint: Section_Constraint;
  update_columns?: Array<Section_Update_Column>;
  where?: InputMaybe<Section_Bool_Exp>;
};

/** Ordering options when selecting data from "section". */
export type Section_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_sections_aggregate?: InputMaybe<Product_Section_Aggregate_Order_By>;
};

/** primary key columns input for table: section */
export type Section_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "section" */
export enum Section_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "section" */
export type Section_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "section" */
export type Section_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Section_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Section_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "section" */
export enum Section_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Section_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Section_Set_Input>;
  where: Section_Bool_Exp;
};

/** columns and relationships of "seeds" */
export type Seeds = {
  __typename?: 'seeds';
  baseproduct_ptr_id: Scalars['uuid'];
  /** An array relationship */
  crop_variety_seeds: Array<Crop_Variety_Seeds>;
  /** An aggregate relationship */
  crop_variety_seeds_aggregate: Crop_Variety_Seeds_Aggregate;
  /** An object relationship */
  product: Products;
};


/** columns and relationships of "seeds" */
export type SeedsCrop_Variety_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Seeds_Order_By>>;
  where?: InputMaybe<Crop_Variety_Seeds_Bool_Exp>;
};


/** columns and relationships of "seeds" */
export type SeedsCrop_Variety_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Seeds_Order_By>>;
  where?: InputMaybe<Crop_Variety_Seeds_Bool_Exp>;
};

/** aggregated selection of "seeds" */
export type Seeds_Aggregate = {
  __typename?: 'seeds_aggregate';
  aggregate?: Maybe<Seeds_Aggregate_Fields>;
  nodes: Array<Seeds>;
};

/** aggregate fields of "seeds" */
export type Seeds_Aggregate_Fields = {
  __typename?: 'seeds_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Seeds_Max_Fields>;
  min?: Maybe<Seeds_Min_Fields>;
};


/** aggregate fields of "seeds" */
export type Seeds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "seeds". All fields are combined with a logical 'AND'. */
export type Seeds_Bool_Exp = {
  _and?: InputMaybe<Array<Seeds_Bool_Exp>>;
  _not?: InputMaybe<Seeds_Bool_Exp>;
  _or?: InputMaybe<Array<Seeds_Bool_Exp>>;
  baseproduct_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
  crop_variety_seeds?: InputMaybe<Crop_Variety_Seeds_Bool_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
};

/** unique or primary key constraints on table "seeds" */
export enum Seeds_Constraint {
  /** unique or primary key constraint on columns "baseproduct_ptr_id" */
  SeedsPkey = 'seeds_pkey'
}

/** input type for inserting data into table "seeds" */
export type Seeds_Insert_Input = {
  baseproduct_ptr_id?: InputMaybe<Scalars['uuid']>;
  crop_variety_seeds?: InputMaybe<Crop_Variety_Seeds_Arr_Rel_Insert_Input>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Seeds_Max_Fields = {
  __typename?: 'seeds_max_fields';
  baseproduct_ptr_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Seeds_Min_Fields = {
  __typename?: 'seeds_min_fields';
  baseproduct_ptr_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "seeds" */
export type Seeds_Mutation_Response = {
  __typename?: 'seeds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Seeds>;
};

/** input type for inserting object relation for remote table "seeds" */
export type Seeds_Obj_Rel_Insert_Input = {
  data: Seeds_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Seeds_On_Conflict>;
};

/** on_conflict condition type for table "seeds" */
export type Seeds_On_Conflict = {
  constraint: Seeds_Constraint;
  update_columns?: Array<Seeds_Update_Column>;
  where?: InputMaybe<Seeds_Bool_Exp>;
};

/** Ordering options when selecting data from "seeds". */
export type Seeds_Order_By = {
  baseproduct_ptr_id?: InputMaybe<Order_By>;
  crop_variety_seeds_aggregate?: InputMaybe<Crop_Variety_Seeds_Aggregate_Order_By>;
  product?: InputMaybe<Products_Order_By>;
};

/** primary key columns input for table: seeds */
export type Seeds_Pk_Columns_Input = {
  baseproduct_ptr_id: Scalars['uuid'];
};

/** select columns of table "seeds" */
export enum Seeds_Select_Column {
  /** column name */
  BaseproductPtrId = 'baseproduct_ptr_id'
}

/** input type for updating data in table "seeds" */
export type Seeds_Set_Input = {
  baseproduct_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "seeds" */
export type Seeds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seeds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seeds_Stream_Cursor_Value_Input = {
  baseproduct_ptr_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "seeds" */
export enum Seeds_Update_Column {
  /** column name */
  BaseproductPtrId = 'baseproduct_ptr_id'
}

export type Seeds_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seeds_Set_Input>;
  where: Seeds_Bool_Exp;
};

/** columns and relationships of "sellable_item" */
export type Sellable_Item = {
  __typename?: 'sellable_item';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid'];
  /** An object relationship */
  product_sku: Product_Sku;
  /** An object relationship */
  sellable_item?: Maybe<Care_Shared_Entity>;
  /** An array relationship */
  sellable_item_stocks: Array<Sellable_Item_Stock>;
  /** An aggregate relationship */
  sellable_item_stocks_aggregate: Sellable_Item_Stock_Aggregate;
  sellable_reference_id?: Maybe<Scalars['bigint']>;
  sku_id: Scalars['uuid'];
};


/** columns and relationships of "sellable_item" */
export type Sellable_ItemSellable_Item_StocksArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Stock_Order_By>>;
  where?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
};


/** columns and relationships of "sellable_item" */
export type Sellable_ItemSellable_Item_Stocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Stock_Order_By>>;
  where?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
};

/** aggregated selection of "sellable_item" */
export type Sellable_Item_Aggregate = {
  __typename?: 'sellable_item_aggregate';
  aggregate?: Maybe<Sellable_Item_Aggregate_Fields>;
  nodes: Array<Sellable_Item>;
};

/** aggregate fields of "sellable_item" */
export type Sellable_Item_Aggregate_Fields = {
  __typename?: 'sellable_item_aggregate_fields';
  avg?: Maybe<Sellable_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sellable_Item_Max_Fields>;
  min?: Maybe<Sellable_Item_Min_Fields>;
  stddev?: Maybe<Sellable_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Sellable_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sellable_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Sellable_Item_Sum_Fields>;
  var_pop?: Maybe<Sellable_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Sellable_Item_Var_Samp_Fields>;
  variance?: Maybe<Sellable_Item_Variance_Fields>;
};


/** aggregate fields of "sellable_item" */
export type Sellable_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sellable_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sellable_item" */
export type Sellable_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Sellable_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sellable_Item_Max_Order_By>;
  min?: InputMaybe<Sellable_Item_Min_Order_By>;
  stddev?: InputMaybe<Sellable_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sellable_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sellable_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sellable_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Sellable_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sellable_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Sellable_Item_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sellable_item" */
export type Sellable_Item_Arr_Rel_Insert_Input = {
  data: Array<Sellable_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sellable_Item_On_Conflict>;
};

/** aggregate avg on columns */
export type Sellable_Item_Avg_Fields = {
  __typename?: 'sellable_item_avg_fields';
  sellable_reference_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sellable_item" */
export type Sellable_Item_Avg_Order_By = {
  sellable_reference_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sellable_item". All fields are combined with a logical 'AND'. */
export type Sellable_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Sellable_Item_Bool_Exp>>;
  _not?: InputMaybe<Sellable_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Sellable_Item_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_sku?: InputMaybe<Product_Sku_Bool_Exp>;
  sellable_item?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
  sellable_item_stocks?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
  sellable_reference_id?: InputMaybe<Bigint_Comparison_Exp>;
  sku_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "sellable_item" */
export enum Sellable_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  SellableItemPkey = 'sellable_item_pkey',
  /** unique or primary key constraint on columns "sku_id", "product_id" */
  SellableItemProductIdSkuId_636f1e4bUniq = 'sellable_item_product_id_sku_id_636f1e4b_uniq'
}

/** input type for incrementing numeric columns in table "sellable_item" */
export type Sellable_Item_Inc_Input = {
  sellable_reference_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sellable_item" */
export type Sellable_Item_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  product_sku?: InputMaybe<Product_Sku_Obj_Rel_Insert_Input>;
  sellable_item?: InputMaybe<Care_Shared_Entity_Obj_Rel_Insert_Input>;
  sellable_item_stocks?: InputMaybe<Sellable_Item_Stock_Arr_Rel_Insert_Input>;
  sellable_reference_id?: InputMaybe<Scalars['bigint']>;
  sku_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Sellable_Item_Max_Fields = {
  __typename?: 'sellable_item_max_fields';
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
  sellable_reference_id?: Maybe<Scalars['bigint']>;
  sku_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "sellable_item" */
export type Sellable_Item_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_reference_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sellable_Item_Min_Fields = {
  __typename?: 'sellable_item_min_fields';
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['uuid']>;
  sellable_reference_id?: Maybe<Scalars['bigint']>;
  sku_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "sellable_item" */
export type Sellable_Item_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  sellable_reference_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sellable_item" */
export type Sellable_Item_Mutation_Response = {
  __typename?: 'sellable_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sellable_Item>;
};

/** input type for inserting object relation for remote table "sellable_item" */
export type Sellable_Item_Obj_Rel_Insert_Input = {
  data: Sellable_Item_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sellable_Item_On_Conflict>;
};

/** on_conflict condition type for table "sellable_item" */
export type Sellable_Item_On_Conflict = {
  constraint: Sellable_Item_Constraint;
  update_columns?: Array<Sellable_Item_Update_Column>;
  where?: InputMaybe<Sellable_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "sellable_item". */
export type Sellable_Item_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_sku?: InputMaybe<Product_Sku_Order_By>;
  sellable_item?: InputMaybe<Care_Shared_Entity_Order_By>;
  sellable_item_stocks_aggregate?: InputMaybe<Sellable_Item_Stock_Aggregate_Order_By>;
  sellable_reference_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sellable_item */
export type Sellable_Item_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sellable_item" */
export enum Sellable_Item_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  SellableReferenceId = 'sellable_reference_id',
  /** column name */
  SkuId = 'sku_id'
}

/** input type for updating data in table "sellable_item" */
export type Sellable_Item_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_reference_id?: InputMaybe<Scalars['bigint']>;
  sku_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Sellable_Item_Stddev_Fields = {
  __typename?: 'sellable_item_stddev_fields';
  sellable_reference_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sellable_item" */
export type Sellable_Item_Stddev_Order_By = {
  sellable_reference_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sellable_Item_Stddev_Pop_Fields = {
  __typename?: 'sellable_item_stddev_pop_fields';
  sellable_reference_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sellable_item" */
export type Sellable_Item_Stddev_Pop_Order_By = {
  sellable_reference_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sellable_Item_Stddev_Samp_Fields = {
  __typename?: 'sellable_item_stddev_samp_fields';
  sellable_reference_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sellable_item" */
export type Sellable_Item_Stddev_Samp_Order_By = {
  sellable_reference_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "sellable_item_stock" */
export type Sellable_Item_Stock = {
  __typename?: 'sellable_item_stock';
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  discounted_rate?: Maybe<Scalars['float8']>;
  discounted_taxed_rate?: Maybe<Scalars['float8']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_featured: Scalars['Boolean'];
  is_live: Scalars['Boolean'];
  /** An array relationship */
  product_favourites: Array<Product_Favourite>;
  /** An aggregate relationship */
  product_favourites_aggregate: Product_Favourite_Aggregate;
  /** An array relationship */
  product_purchased: Array<Product_Purchased>;
  /** An aggregate relationship */
  product_purchased_aggregate: Product_Purchased_Aggregate;
  /** An array relationship */
  product_views: Array<Product_View>;
  /** An aggregate relationship */
  product_views_aggregate: Product_View_Aggregate;
  remaining_stock: Scalars['Int'];
  /** An object relationship */
  sellable_item: Sellable_Item;
  sellable_product_id: Scalars['uuid'];
  seller?: Maybe<DistributionCentreGlType>;
  stock_reference_id: Scalars['String'];
  store_id: Scalars['String'];
  taxed_rate?: Maybe<Scalars['float8']>;
  unit_rate?: Maybe<Scalars['float8']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
};


/** columns and relationships of "sellable_item_stock" */
export type Sellable_Item_StockProduct_FavouritesArgs = {
  distinct_on?: InputMaybe<Array<Product_Favourite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Favourite_Order_By>>;
  where?: InputMaybe<Product_Favourite_Bool_Exp>;
};


/** columns and relationships of "sellable_item_stock" */
export type Sellable_Item_StockProduct_Favourites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Favourite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Favourite_Order_By>>;
  where?: InputMaybe<Product_Favourite_Bool_Exp>;
};


/** columns and relationships of "sellable_item_stock" */
export type Sellable_Item_StockProduct_PurchasedArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchased_Order_By>>;
  where?: InputMaybe<Product_Purchased_Bool_Exp>;
};


/** columns and relationships of "sellable_item_stock" */
export type Sellable_Item_StockProduct_Purchased_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchased_Order_By>>;
  where?: InputMaybe<Product_Purchased_Bool_Exp>;
};


/** columns and relationships of "sellable_item_stock" */
export type Sellable_Item_StockProduct_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_View_Order_By>>;
  where?: InputMaybe<Product_View_Bool_Exp>;
};


/** columns and relationships of "sellable_item_stock" */
export type Sellable_Item_StockProduct_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_View_Order_By>>;
  where?: InputMaybe<Product_View_Bool_Exp>;
};

/** aggregated selection of "sellable_item_stock" */
export type Sellable_Item_Stock_Aggregate = {
  __typename?: 'sellable_item_stock_aggregate';
  aggregate?: Maybe<Sellable_Item_Stock_Aggregate_Fields>;
  nodes: Array<Sellable_Item_Stock>;
};

/** aggregate fields of "sellable_item_stock" */
export type Sellable_Item_Stock_Aggregate_Fields = {
  __typename?: 'sellable_item_stock_aggregate_fields';
  avg?: Maybe<Sellable_Item_Stock_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sellable_Item_Stock_Max_Fields>;
  min?: Maybe<Sellable_Item_Stock_Min_Fields>;
  stddev?: Maybe<Sellable_Item_Stock_Stddev_Fields>;
  stddev_pop?: Maybe<Sellable_Item_Stock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sellable_Item_Stock_Stddev_Samp_Fields>;
  sum?: Maybe<Sellable_Item_Stock_Sum_Fields>;
  var_pop?: Maybe<Sellable_Item_Stock_Var_Pop_Fields>;
  var_samp?: Maybe<Sellable_Item_Stock_Var_Samp_Fields>;
  variance?: Maybe<Sellable_Item_Stock_Variance_Fields>;
};


/** aggregate fields of "sellable_item_stock" */
export type Sellable_Item_Stock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sellable_Item_Stock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sellable_item_stock" */
export type Sellable_Item_Stock_Aggregate_Order_By = {
  avg?: InputMaybe<Sellable_Item_Stock_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sellable_Item_Stock_Max_Order_By>;
  min?: InputMaybe<Sellable_Item_Stock_Min_Order_By>;
  stddev?: InputMaybe<Sellable_Item_Stock_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sellable_Item_Stock_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sellable_Item_Stock_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sellable_Item_Stock_Sum_Order_By>;
  var_pop?: InputMaybe<Sellable_Item_Stock_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sellable_Item_Stock_Var_Samp_Order_By>;
  variance?: InputMaybe<Sellable_Item_Stock_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sellable_item_stock" */
export type Sellable_Item_Stock_Arr_Rel_Insert_Input = {
  data: Array<Sellable_Item_Stock_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sellable_Item_Stock_On_Conflict>;
};

/** aggregate avg on columns */
export type Sellable_Item_Stock_Avg_Fields = {
  __typename?: 'sellable_item_stock_avg_fields';
  discounted_rate?: Maybe<Scalars['Float']>;
  discounted_taxed_rate?: Maybe<Scalars['Float']>;
  remaining_stock?: Maybe<Scalars['Float']>;
  taxed_rate?: Maybe<Scalars['Float']>;
  unit_rate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sellable_item_stock" */
export type Sellable_Item_Stock_Avg_Order_By = {
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sellable_item_stock". All fields are combined with a logical 'AND'. */
export type Sellable_Item_Stock_Bool_Exp = {
  _and?: InputMaybe<Array<Sellable_Item_Stock_Bool_Exp>>;
  _not?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
  _or?: InputMaybe<Array<Sellable_Item_Stock_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  discounted_rate?: InputMaybe<Float8_Comparison_Exp>;
  discounted_taxed_rate?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_featured?: InputMaybe<Boolean_Comparison_Exp>;
  is_live?: InputMaybe<Boolean_Comparison_Exp>;
  product_favourites?: InputMaybe<Product_Favourite_Bool_Exp>;
  product_purchased?: InputMaybe<Product_Purchased_Bool_Exp>;
  product_views?: InputMaybe<Product_View_Bool_Exp>;
  remaining_stock?: InputMaybe<Int_Comparison_Exp>;
  sellable_item?: InputMaybe<Sellable_Item_Bool_Exp>;
  sellable_product_id?: InputMaybe<Uuid_Comparison_Exp>;
  stock_reference_id?: InputMaybe<String_Comparison_Exp>;
  store_id?: InputMaybe<String_Comparison_Exp>;
  taxed_rate?: InputMaybe<Float8_Comparison_Exp>;
  unit_rate?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sellable_item_stock" */
export enum Sellable_Item_Stock_Constraint {
  /** unique or primary key constraint on columns "id" */
  SellableItemStockPkey = 'sellable_item_stock_pkey',
  /** unique or primary key constraint on columns "store_id", "sellable_product_id", "stock_reference_id" */
  SellableItemStockStoreIdStockReference_57867360Uniq = 'sellable_item_stock_store_id_stock_reference_57867360_uniq'
}

/** input type for incrementing numeric columns in table "sellable_item_stock" */
export type Sellable_Item_Stock_Inc_Input = {
  discounted_rate?: InputMaybe<Scalars['float8']>;
  discounted_taxed_rate?: InputMaybe<Scalars['float8']>;
  remaining_stock?: InputMaybe<Scalars['Int']>;
  taxed_rate?: InputMaybe<Scalars['float8']>;
  unit_rate?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "sellable_item_stock" */
export type Sellable_Item_Stock_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  discounted_rate?: InputMaybe<Scalars['float8']>;
  discounted_taxed_rate?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_featured?: InputMaybe<Scalars['Boolean']>;
  is_live?: InputMaybe<Scalars['Boolean']>;
  product_favourites?: InputMaybe<Product_Favourite_Arr_Rel_Insert_Input>;
  product_purchased?: InputMaybe<Product_Purchased_Arr_Rel_Insert_Input>;
  product_views?: InputMaybe<Product_View_Arr_Rel_Insert_Input>;
  remaining_stock?: InputMaybe<Scalars['Int']>;
  sellable_item?: InputMaybe<Sellable_Item_Obj_Rel_Insert_Input>;
  sellable_product_id?: InputMaybe<Scalars['uuid']>;
  stock_reference_id?: InputMaybe<Scalars['String']>;
  store_id?: InputMaybe<Scalars['String']>;
  taxed_rate?: InputMaybe<Scalars['float8']>;
  unit_rate?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Sellable_Item_Stock_Max_Fields = {
  __typename?: 'sellable_item_stock_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  discounted_rate?: Maybe<Scalars['float8']>;
  discounted_taxed_rate?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  remaining_stock?: Maybe<Scalars['Int']>;
  sellable_product_id?: Maybe<Scalars['uuid']>;
  stock_reference_id?: Maybe<Scalars['String']>;
  store_id?: Maybe<Scalars['String']>;
  taxed_rate?: Maybe<Scalars['float8']>;
  unit_rate?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "sellable_item_stock" */
export type Sellable_Item_Stock_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  sellable_product_id?: InputMaybe<Order_By>;
  stock_reference_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sellable_Item_Stock_Min_Fields = {
  __typename?: 'sellable_item_stock_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  discounted_rate?: Maybe<Scalars['float8']>;
  discounted_taxed_rate?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  remaining_stock?: Maybe<Scalars['Int']>;
  sellable_product_id?: Maybe<Scalars['uuid']>;
  stock_reference_id?: Maybe<Scalars['String']>;
  store_id?: Maybe<Scalars['String']>;
  taxed_rate?: Maybe<Scalars['float8']>;
  unit_rate?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "sellable_item_stock" */
export type Sellable_Item_Stock_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  sellable_product_id?: InputMaybe<Order_By>;
  stock_reference_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sellable_item_stock" */
export type Sellable_Item_Stock_Mutation_Response = {
  __typename?: 'sellable_item_stock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sellable_Item_Stock>;
};

/** input type for inserting object relation for remote table "sellable_item_stock" */
export type Sellable_Item_Stock_Obj_Rel_Insert_Input = {
  data: Sellable_Item_Stock_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sellable_Item_Stock_On_Conflict>;
};

/** on_conflict condition type for table "sellable_item_stock" */
export type Sellable_Item_Stock_On_Conflict = {
  constraint: Sellable_Item_Stock_Constraint;
  update_columns?: Array<Sellable_Item_Stock_Update_Column>;
  where?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
};

/** Ordering options when selecting data from "sellable_item_stock". */
export type Sellable_Item_Stock_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_featured?: InputMaybe<Order_By>;
  is_live?: InputMaybe<Order_By>;
  product_favourites_aggregate?: InputMaybe<Product_Favourite_Aggregate_Order_By>;
  product_purchased_aggregate?: InputMaybe<Product_Purchased_Aggregate_Order_By>;
  product_views_aggregate?: InputMaybe<Product_View_Aggregate_Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  sellable_item?: InputMaybe<Sellable_Item_Order_By>;
  sellable_product_id?: InputMaybe<Order_By>;
  stock_reference_id?: InputMaybe<Order_By>;
  store_id?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sellable_item_stock */
export type Sellable_Item_Stock_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sellable_item_stock" */
export enum Sellable_Item_Stock_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DiscountedRate = 'discounted_rate',
  /** column name */
  DiscountedTaxedRate = 'discounted_taxed_rate',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsFeatured = 'is_featured',
  /** column name */
  IsLive = 'is_live',
  /** column name */
  RemainingStock = 'remaining_stock',
  /** column name */
  SellableProductId = 'sellable_product_id',
  /** column name */
  StockReferenceId = 'stock_reference_id',
  /** column name */
  StoreId = 'store_id',
  /** column name */
  TaxedRate = 'taxed_rate',
  /** column name */
  UnitRate = 'unit_rate',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "sellable_item_stock" */
export type Sellable_Item_Stock_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  discounted_rate?: InputMaybe<Scalars['float8']>;
  discounted_taxed_rate?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_featured?: InputMaybe<Scalars['Boolean']>;
  is_live?: InputMaybe<Scalars['Boolean']>;
  remaining_stock?: InputMaybe<Scalars['Int']>;
  sellable_product_id?: InputMaybe<Scalars['uuid']>;
  stock_reference_id?: InputMaybe<Scalars['String']>;
  store_id?: InputMaybe<Scalars['String']>;
  taxed_rate?: InputMaybe<Scalars['float8']>;
  unit_rate?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Sellable_Item_Stock_Stddev_Fields = {
  __typename?: 'sellable_item_stock_stddev_fields';
  discounted_rate?: Maybe<Scalars['Float']>;
  discounted_taxed_rate?: Maybe<Scalars['Float']>;
  remaining_stock?: Maybe<Scalars['Float']>;
  taxed_rate?: Maybe<Scalars['Float']>;
  unit_rate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sellable_item_stock" */
export type Sellable_Item_Stock_Stddev_Order_By = {
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sellable_Item_Stock_Stddev_Pop_Fields = {
  __typename?: 'sellable_item_stock_stddev_pop_fields';
  discounted_rate?: Maybe<Scalars['Float']>;
  discounted_taxed_rate?: Maybe<Scalars['Float']>;
  remaining_stock?: Maybe<Scalars['Float']>;
  taxed_rate?: Maybe<Scalars['Float']>;
  unit_rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sellable_item_stock" */
export type Sellable_Item_Stock_Stddev_Pop_Order_By = {
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sellable_Item_Stock_Stddev_Samp_Fields = {
  __typename?: 'sellable_item_stock_stddev_samp_fields';
  discounted_rate?: Maybe<Scalars['Float']>;
  discounted_taxed_rate?: Maybe<Scalars['Float']>;
  remaining_stock?: Maybe<Scalars['Float']>;
  taxed_rate?: Maybe<Scalars['Float']>;
  unit_rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sellable_item_stock" */
export type Sellable_Item_Stock_Stddev_Samp_Order_By = {
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sellable_item_stock" */
export type Sellable_Item_Stock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sellable_Item_Stock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sellable_Item_Stock_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  discounted_rate?: InputMaybe<Scalars['float8']>;
  discounted_taxed_rate?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_featured?: InputMaybe<Scalars['Boolean']>;
  is_live?: InputMaybe<Scalars['Boolean']>;
  remaining_stock?: InputMaybe<Scalars['Int']>;
  sellable_product_id?: InputMaybe<Scalars['uuid']>;
  stock_reference_id?: InputMaybe<Scalars['String']>;
  store_id?: InputMaybe<Scalars['String']>;
  taxed_rate?: InputMaybe<Scalars['float8']>;
  unit_rate?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Sellable_Item_Stock_Sum_Fields = {
  __typename?: 'sellable_item_stock_sum_fields';
  discounted_rate?: Maybe<Scalars['float8']>;
  discounted_taxed_rate?: Maybe<Scalars['float8']>;
  remaining_stock?: Maybe<Scalars['Int']>;
  taxed_rate?: Maybe<Scalars['float8']>;
  unit_rate?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "sellable_item_stock" */
export type Sellable_Item_Stock_Sum_Order_By = {
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
};

/** update columns of table "sellable_item_stock" */
export enum Sellable_Item_Stock_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DiscountedRate = 'discounted_rate',
  /** column name */
  DiscountedTaxedRate = 'discounted_taxed_rate',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsFeatured = 'is_featured',
  /** column name */
  IsLive = 'is_live',
  /** column name */
  RemainingStock = 'remaining_stock',
  /** column name */
  SellableProductId = 'sellable_product_id',
  /** column name */
  StockReferenceId = 'stock_reference_id',
  /** column name */
  StoreId = 'store_id',
  /** column name */
  TaxedRate = 'taxed_rate',
  /** column name */
  UnitRate = 'unit_rate',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Sellable_Item_Stock_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sellable_Item_Stock_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sellable_Item_Stock_Set_Input>;
  where: Sellable_Item_Stock_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sellable_Item_Stock_Var_Pop_Fields = {
  __typename?: 'sellable_item_stock_var_pop_fields';
  discounted_rate?: Maybe<Scalars['Float']>;
  discounted_taxed_rate?: Maybe<Scalars['Float']>;
  remaining_stock?: Maybe<Scalars['Float']>;
  taxed_rate?: Maybe<Scalars['Float']>;
  unit_rate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sellable_item_stock" */
export type Sellable_Item_Stock_Var_Pop_Order_By = {
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sellable_Item_Stock_Var_Samp_Fields = {
  __typename?: 'sellable_item_stock_var_samp_fields';
  discounted_rate?: Maybe<Scalars['Float']>;
  discounted_taxed_rate?: Maybe<Scalars['Float']>;
  remaining_stock?: Maybe<Scalars['Float']>;
  taxed_rate?: Maybe<Scalars['Float']>;
  unit_rate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sellable_item_stock" */
export type Sellable_Item_Stock_Var_Samp_Order_By = {
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sellable_Item_Stock_Variance_Fields = {
  __typename?: 'sellable_item_stock_variance_fields';
  discounted_rate?: Maybe<Scalars['Float']>;
  discounted_taxed_rate?: Maybe<Scalars['Float']>;
  remaining_stock?: Maybe<Scalars['Float']>;
  taxed_rate?: Maybe<Scalars['Float']>;
  unit_rate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sellable_item_stock" */
export type Sellable_Item_Stock_Variance_Order_By = {
  discounted_rate?: InputMaybe<Order_By>;
  discounted_taxed_rate?: InputMaybe<Order_By>;
  remaining_stock?: InputMaybe<Order_By>;
  taxed_rate?: InputMaybe<Order_By>;
  unit_rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sellable_item" */
export type Sellable_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sellable_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sellable_Item_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  sellable_reference_id?: InputMaybe<Scalars['bigint']>;
  sku_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Sellable_Item_Sum_Fields = {
  __typename?: 'sellable_item_sum_fields';
  sellable_reference_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sellable_item" */
export type Sellable_Item_Sum_Order_By = {
  sellable_reference_id?: InputMaybe<Order_By>;
};

/** update columns of table "sellable_item" */
export enum Sellable_Item_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  SellableReferenceId = 'sellable_reference_id',
  /** column name */
  SkuId = 'sku_id'
}

export type Sellable_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sellable_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sellable_Item_Set_Input>;
  where: Sellable_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sellable_Item_Var_Pop_Fields = {
  __typename?: 'sellable_item_var_pop_fields';
  sellable_reference_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sellable_item" */
export type Sellable_Item_Var_Pop_Order_By = {
  sellable_reference_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sellable_Item_Var_Samp_Fields = {
  __typename?: 'sellable_item_var_samp_fields';
  sellable_reference_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sellable_item" */
export type Sellable_Item_Var_Samp_Order_By = {
  sellable_reference_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sellable_Item_Variance_Fields = {
  __typename?: 'sellable_item_variance_fields';
  sellable_reference_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sellable_item" */
export type Sellable_Item_Variance_Order_By = {
  sellable_reference_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "sensor" */
export type Sensor = {
  __typename?: 'sensor';
  environment: Scalars['String'];
  /** An object relationship */
  gateway: Gateway;
  gateway_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  inst_readings: Array<Inst_Sensor_Reading>;
  /** An aggregate relationship */
  inst_readings_aggregate: Inst_Sensor_Reading_Aggregate;
  is_active: Scalars['Boolean'];
  location_id: Scalars['uuid'];
  measurement_key?: Maybe<Scalars['String']>;
  /** An object relationship */
  parameter: Sensor_Parameter;
  parameter_id: Scalars['uuid'];
  /** An array relationship */
  summary_readings: Array<Summary_Sensor_Reading>;
  /** An aggregate relationship */
  summary_readings_aggregate: Summary_Sensor_Reading_Aggregate;
  unit_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  weather_location: Weather_Location;
};


/** columns and relationships of "sensor" */
export type SensorInst_ReadingsArgs = {
  distinct_on?: InputMaybe<Array<Inst_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inst_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
};


/** columns and relationships of "sensor" */
export type SensorInst_Readings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inst_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inst_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
};


/** columns and relationships of "sensor" */
export type SensorSummary_ReadingsArgs = {
  distinct_on?: InputMaybe<Array<Summary_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Summary_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
};


/** columns and relationships of "sensor" */
export type SensorSummary_Readings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Summary_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Summary_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
};

/** aggregated selection of "sensor" */
export type Sensor_Aggregate = {
  __typename?: 'sensor_aggregate';
  aggregate?: Maybe<Sensor_Aggregate_Fields>;
  nodes: Array<Sensor>;
};

/** aggregate fields of "sensor" */
export type Sensor_Aggregate_Fields = {
  __typename?: 'sensor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Sensor_Max_Fields>;
  min?: Maybe<Sensor_Min_Fields>;
};


/** aggregate fields of "sensor" */
export type Sensor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sensor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sensor" */
export type Sensor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sensor_Max_Order_By>;
  min?: InputMaybe<Sensor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "sensor" */
export type Sensor_Arr_Rel_Insert_Input = {
  data: Array<Sensor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sensor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sensor". All fields are combined with a logical 'AND'. */
export type Sensor_Bool_Exp = {
  _and?: InputMaybe<Array<Sensor_Bool_Exp>>;
  _not?: InputMaybe<Sensor_Bool_Exp>;
  _or?: InputMaybe<Array<Sensor_Bool_Exp>>;
  environment?: InputMaybe<String_Comparison_Exp>;
  gateway?: InputMaybe<Gateway_Bool_Exp>;
  gateway_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inst_readings?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  measurement_key?: InputMaybe<String_Comparison_Exp>;
  parameter?: InputMaybe<Sensor_Parameter_Bool_Exp>;
  parameter_id?: InputMaybe<Uuid_Comparison_Exp>;
  summary_readings?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
  unit_id?: InputMaybe<Uuid_Comparison_Exp>;
  weather_location?: InputMaybe<Weather_Location_Bool_Exp>;
};

/** unique or primary key constraints on table "sensor" */
export enum Sensor_Constraint {
  /** unique or primary key constraint on columns "measurement_key", "gateway_id", "location_id", "parameter_id" */
  SensorGatewayIdLocationIdP_7d0b215cUniq = 'sensor_gateway_id_location_id_p_7d0b215c_uniq',
  /** unique or primary key constraint on columns "id" */
  SensorPkey = 'sensor_pkey'
}

/** input type for inserting data into table "sensor" */
export type Sensor_Insert_Input = {
  environment?: InputMaybe<Scalars['String']>;
  gateway?: InputMaybe<Gateway_Obj_Rel_Insert_Input>;
  gateway_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  inst_readings?: InputMaybe<Inst_Sensor_Reading_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  measurement_key?: InputMaybe<Scalars['String']>;
  parameter?: InputMaybe<Sensor_Parameter_Obj_Rel_Insert_Input>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  summary_readings?: InputMaybe<Summary_Sensor_Reading_Arr_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['uuid']>;
  weather_location?: InputMaybe<Weather_Location_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Sensor_Max_Fields = {
  __typename?: 'sensor_max_fields';
  environment?: Maybe<Scalars['String']>;
  gateway_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  measurement_key?: Maybe<Scalars['String']>;
  parameter_id?: Maybe<Scalars['uuid']>;
  unit_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "sensor" */
export type Sensor_Max_Order_By = {
  environment?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  measurement_key?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sensor_Min_Fields = {
  __typename?: 'sensor_min_fields';
  environment?: Maybe<Scalars['String']>;
  gateway_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  measurement_key?: Maybe<Scalars['String']>;
  parameter_id?: Maybe<Scalars['uuid']>;
  unit_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "sensor" */
export type Sensor_Min_Order_By = {
  environment?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  measurement_key?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sensor" */
export type Sensor_Mutation_Response = {
  __typename?: 'sensor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sensor>;
};

/** input type for inserting object relation for remote table "sensor" */
export type Sensor_Obj_Rel_Insert_Input = {
  data: Sensor_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sensor_On_Conflict>;
};

/** on_conflict condition type for table "sensor" */
export type Sensor_On_Conflict = {
  constraint: Sensor_Constraint;
  update_columns?: Array<Sensor_Update_Column>;
  where?: InputMaybe<Sensor_Bool_Exp>;
};

/** Ordering options when selecting data from "sensor". */
export type Sensor_Order_By = {
  environment?: InputMaybe<Order_By>;
  gateway?: InputMaybe<Gateway_Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inst_readings_aggregate?: InputMaybe<Inst_Sensor_Reading_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  measurement_key?: InputMaybe<Order_By>;
  parameter?: InputMaybe<Sensor_Parameter_Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  summary_readings_aggregate?: InputMaybe<Summary_Sensor_Reading_Aggregate_Order_By>;
  unit_id?: InputMaybe<Order_By>;
  weather_location?: InputMaybe<Weather_Location_Order_By>;
};

/** columns and relationships of "sensor_parameter" */
export type Sensor_Parameter = {
  __typename?: 'sensor_parameter';
  aggregation_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon_url?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_aggregated: Scalars['Boolean'];
  key: Scalars['String'];
  name: Scalars['String'];
  short_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  unit: Unit;
  unit_id: Scalars['uuid'];
};

/** aggregated selection of "sensor_parameter" */
export type Sensor_Parameter_Aggregate = {
  __typename?: 'sensor_parameter_aggregate';
  aggregate?: Maybe<Sensor_Parameter_Aggregate_Fields>;
  nodes: Array<Sensor_Parameter>;
};

/** aggregate fields of "sensor_parameter" */
export type Sensor_Parameter_Aggregate_Fields = {
  __typename?: 'sensor_parameter_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Sensor_Parameter_Max_Fields>;
  min?: Maybe<Sensor_Parameter_Min_Fields>;
};


/** aggregate fields of "sensor_parameter" */
export type Sensor_Parameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sensor_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sensor_parameter" */
export type Sensor_Parameter_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sensor_Parameter_Max_Order_By>;
  min?: InputMaybe<Sensor_Parameter_Min_Order_By>;
};

/** input type for inserting array relation for remote table "sensor_parameter" */
export type Sensor_Parameter_Arr_Rel_Insert_Input = {
  data: Array<Sensor_Parameter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sensor_Parameter_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sensor_parameter". All fields are combined with a logical 'AND'. */
export type Sensor_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Sensor_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Sensor_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Sensor_Parameter_Bool_Exp>>;
  aggregation_type?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  icon_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_aggregated?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unit_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "sensor_parameter" */
export enum Sensor_Parameter_Constraint {
  /** unique or primary key constraint on columns "key", "name", "unit_id" */
  SensorParameterKeyNameUnitIdAdc91c6fUniq = 'sensor_parameter_key_name_unit_id_adc91c6f_uniq',
  /** unique or primary key constraint on columns "id" */
  SensorParameterPkey = 'sensor_parameter_pkey'
}

/** input type for inserting data into table "sensor_parameter" */
export type Sensor_Parameter_Insert_Input = {
  aggregation_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_aggregated?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Sensor_Parameter_Max_Fields = {
  __typename?: 'sensor_parameter_max_fields';
  aggregation_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "sensor_parameter" */
export type Sensor_Parameter_Max_Order_By = {
  aggregation_type?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  icon_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sensor_Parameter_Min_Fields = {
  __typename?: 'sensor_parameter_min_fields';
  aggregation_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "sensor_parameter" */
export type Sensor_Parameter_Min_Order_By = {
  aggregation_type?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  icon_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sensor_parameter" */
export type Sensor_Parameter_Mutation_Response = {
  __typename?: 'sensor_parameter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sensor_Parameter>;
};

/** input type for inserting object relation for remote table "sensor_parameter" */
export type Sensor_Parameter_Obj_Rel_Insert_Input = {
  data: Sensor_Parameter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sensor_Parameter_On_Conflict>;
};

/** on_conflict condition type for table "sensor_parameter" */
export type Sensor_Parameter_On_Conflict = {
  constraint: Sensor_Parameter_Constraint;
  update_columns?: Array<Sensor_Parameter_Update_Column>;
  where?: InputMaybe<Sensor_Parameter_Bool_Exp>;
};

/** Ordering options when selecting data from "sensor_parameter". */
export type Sensor_Parameter_Order_By = {
  aggregation_type?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  icon_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_aggregated?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sensor_parameter */
export type Sensor_Parameter_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sensor_parameter" */
export enum Sensor_Parameter_Select_Column {
  /** column name */
  AggregationType = 'aggregation_type',
  /** column name */
  Description = 'description',
  /** column name */
  IconUrl = 'icon_url',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAggregated = 'is_aggregated',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  UnitId = 'unit_id'
}

/** input type for updating data in table "sensor_parameter" */
export type Sensor_Parameter_Set_Input = {
  aggregation_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_aggregated?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "sensor_parameter" */
export type Sensor_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sensor_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sensor_Parameter_Stream_Cursor_Value_Input = {
  aggregation_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_aggregated?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "sensor_parameter" */
export enum Sensor_Parameter_Update_Column {
  /** column name */
  AggregationType = 'aggregation_type',
  /** column name */
  Description = 'description',
  /** column name */
  IconUrl = 'icon_url',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAggregated = 'is_aggregated',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  UnitId = 'unit_id'
}

export type Sensor_Parameter_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sensor_Parameter_Set_Input>;
  where: Sensor_Parameter_Bool_Exp;
};

/** primary key columns input for table: sensor */
export type Sensor_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sensor" */
export enum Sensor_Select_Column {
  /** column name */
  Environment = 'environment',
  /** column name */
  GatewayId = 'gateway_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MeasurementKey = 'measurement_key',
  /** column name */
  ParameterId = 'parameter_id',
  /** column name */
  UnitId = 'unit_id'
}

/** input type for updating data in table "sensor" */
export type Sensor_Set_Input = {
  environment?: InputMaybe<Scalars['String']>;
  gateway_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  measurement_key?: InputMaybe<Scalars['String']>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  unit_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "sensor" */
export type Sensor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sensor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sensor_Stream_Cursor_Value_Input = {
  environment?: InputMaybe<Scalars['String']>;
  gateway_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  measurement_key?: InputMaybe<Scalars['String']>;
  parameter_id?: InputMaybe<Scalars['uuid']>;
  unit_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "sensor" */
export enum Sensor_Update_Column {
  /** column name */
  Environment = 'environment',
  /** column name */
  GatewayId = 'gateway_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MeasurementKey = 'measurement_key',
  /** column name */
  ParameterId = 'parameter_id',
  /** column name */
  UnitId = 'unit_id'
}

export type Sensor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sensor_Set_Input>;
  where: Sensor_Bool_Exp;
};

/** columns and relationships of "series" */
export type Series = {
  __typename?: 'series';
  are_lectures_locked: Scalars['Boolean'];
  /** An object relationship */
  article_subscription_package: Article_Subscription_Package;
  /** An array relationship */
  assessments: Array<Assessment>;
  /** An aggregate relationship */
  assessments_aggregate: Assessment_Aggregate;
  /** An array relationship */
  authors: Array<Series_Authors>;
  /** An aggregate relationship */
  authors_aggregate: Series_Authors_Aggregate;
  /** An array relationship */
  categories: Array<Series_Category>;
  /** An aggregate relationship */
  categories_aggregate: Series_Category_Aggregate;
  course_summary?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  discount_price: Scalars['float8'];
  /** An object relationship */
  favorites?: Maybe<Article_Series_Favourite_Insights>;
  /** An object relationship */
  featured_image?: Maybe<Fileupload>;
  featured_image_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  featured_video?: Maybe<Fileupload>;
  featured_video_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_public: Scalars['Boolean'];
  /** An object relationship */
  likes?: Maybe<Article_Series_Like_Insights>;
  name: Scalars['String'];
  order: Scalars['smallint'];
  organisation_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  series_articles: Array<Article_Series>;
  /** An aggregate relationship */
  series_articles_aggregate: Article_Series_Aggregate;
  /** An array relationship */
  series_crops: Array<Series_Crops>;
  /** An aggregate relationship */
  series_crops_aggregate: Series_Crops_Aggregate;
  /** An array relationship */
  series_favorites: Array<Series_Favorites>;
  /** An aggregate relationship */
  series_favorites_aggregate: Series_Favorites_Aggregate;
  /** An array relationship */
  series_likes: Array<Series_Likes>;
  /** An aggregate relationship */
  series_likes_aggregate: Series_Likes_Aggregate;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  subscription_package_id: Scalars['uuid'];
  unit_price: Scalars['float8'];
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  /** An object relationship */
  views?: Maybe<Article_Series_View_Insights>;
};


/** columns and relationships of "series" */
export type SeriesAssessmentsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Order_By>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesAssessments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Order_By>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesAuthorsArgs = {
  distinct_on?: InputMaybe<Array<Series_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Authors_Order_By>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesAuthors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Authors_Order_By>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Series_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Category_Order_By>>;
  where?: InputMaybe<Series_Category_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Category_Order_By>>;
  where?: InputMaybe<Series_Category_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_ArticlesArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_Articles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_CropsArgs = {
  distinct_on?: InputMaybe<Array<Series_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Crops_Order_By>>;
  where?: InputMaybe<Series_Crops_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Crops_Order_By>>;
  where?: InputMaybe<Series_Crops_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_FavoritesArgs = {
  distinct_on?: InputMaybe<Array<Series_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Favorites_Order_By>>;
  where?: InputMaybe<Series_Favorites_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_Favorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Favorites_Order_By>>;
  where?: InputMaybe<Series_Favorites_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_LikesArgs = {
  distinct_on?: InputMaybe<Array<Series_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Likes_Order_By>>;
  where?: InputMaybe<Series_Likes_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Likes_Order_By>>;
  where?: InputMaybe<Series_Likes_Bool_Exp>;
};

/** aggregated selection of "series" */
export type Series_Aggregate = {
  __typename?: 'series_aggregate';
  aggregate?: Maybe<Series_Aggregate_Fields>;
  nodes: Array<Series>;
};

/** aggregate fields of "series" */
export type Series_Aggregate_Fields = {
  __typename?: 'series_aggregate_fields';
  avg?: Maybe<Series_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Series_Max_Fields>;
  min?: Maybe<Series_Min_Fields>;
  stddev?: Maybe<Series_Stddev_Fields>;
  stddev_pop?: Maybe<Series_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Series_Stddev_Samp_Fields>;
  sum?: Maybe<Series_Sum_Fields>;
  var_pop?: Maybe<Series_Var_Pop_Fields>;
  var_samp?: Maybe<Series_Var_Samp_Fields>;
  variance?: Maybe<Series_Variance_Fields>;
};


/** aggregate fields of "series" */
export type Series_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Series_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "series" */
export type Series_Aggregate_Order_By = {
  avg?: InputMaybe<Series_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Series_Max_Order_By>;
  min?: InputMaybe<Series_Min_Order_By>;
  stddev?: InputMaybe<Series_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Series_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Series_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Series_Sum_Order_By>;
  var_pop?: InputMaybe<Series_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Series_Var_Samp_Order_By>;
  variance?: InputMaybe<Series_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "series" */
export type Series_Arr_Rel_Insert_Input = {
  data: Array<Series_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Series_On_Conflict>;
};

/** columns and relationships of "series_authors" */
export type Series_Authors = {
  __typename?: 'series_authors';
  author: Array<Base_User>;
  author_id?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  /** An object relationship */
  series: Series;
  /** An object relationship */
  series_author?: Maybe<Advice_Authors>;
  series_author_id?: Maybe<Scalars['uuid']>;
  series_id: Scalars['uuid'];
  /** An object relationship */
  shared_author?: Maybe<Shared_Entity>;
  shared_author_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "series_authors" */
export type Series_AuthorsAuthorArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Series_Authorsauthor>;
};

/** aggregated selection of "series_authors" */
export type Series_Authors_Aggregate = {
  __typename?: 'series_authors_aggregate';
  aggregate?: Maybe<Series_Authors_Aggregate_Fields>;
  nodes: Array<Series_Authors>;
};

/** aggregate fields of "series_authors" */
export type Series_Authors_Aggregate_Fields = {
  __typename?: 'series_authors_aggregate_fields';
  avg?: Maybe<Series_Authors_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Series_Authors_Max_Fields>;
  min?: Maybe<Series_Authors_Min_Fields>;
  stddev?: Maybe<Series_Authors_Stddev_Fields>;
  stddev_pop?: Maybe<Series_Authors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Series_Authors_Stddev_Samp_Fields>;
  sum?: Maybe<Series_Authors_Sum_Fields>;
  var_pop?: Maybe<Series_Authors_Var_Pop_Fields>;
  var_samp?: Maybe<Series_Authors_Var_Samp_Fields>;
  variance?: Maybe<Series_Authors_Variance_Fields>;
};


/** aggregate fields of "series_authors" */
export type Series_Authors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Series_Authors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "series_authors" */
export type Series_Authors_Aggregate_Order_By = {
  avg?: InputMaybe<Series_Authors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Series_Authors_Max_Order_By>;
  min?: InputMaybe<Series_Authors_Min_Order_By>;
  stddev?: InputMaybe<Series_Authors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Series_Authors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Series_Authors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Series_Authors_Sum_Order_By>;
  var_pop?: InputMaybe<Series_Authors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Series_Authors_Var_Samp_Order_By>;
  variance?: InputMaybe<Series_Authors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "series_authors" */
export type Series_Authors_Arr_Rel_Insert_Input = {
  data: Array<Series_Authors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Series_Authors_On_Conflict>;
};

/** aggregate avg on columns */
export type Series_Authors_Avg_Fields = {
  __typename?: 'series_authors_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "series_authors" */
export type Series_Authors_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "series_authors". All fields are combined with a logical 'AND'. */
export type Series_Authors_Bool_Exp = {
  _and?: InputMaybe<Array<Series_Authors_Bool_Exp>>;
  _not?: InputMaybe<Series_Authors_Bool_Exp>;
  _or?: InputMaybe<Array<Series_Authors_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  series?: InputMaybe<Series_Bool_Exp>;
  series_author?: InputMaybe<Advice_Authors_Bool_Exp>;
  series_author_id?: InputMaybe<Uuid_Comparison_Exp>;
  series_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_author?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_author_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "series_authors" */
export enum Series_Authors_Constraint {
  /** unique or primary key constraint on columns "id" */
  SeriesAuthorsPkey = 'series_authors_pkey',
  /** unique or primary key constraint on columns "author_id", "series_id" */
  SeriesAuthorsSeriesIdAuthorId_14db32ddUniq = 'series_authors_series_id_author_id_14db32dd_uniq'
}

/** input type for incrementing numeric columns in table "series_authors" */
export type Series_Authors_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "series_authors" */
export type Series_Authors_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  series?: InputMaybe<Series_Obj_Rel_Insert_Input>;
  series_author?: InputMaybe<Advice_Authors_Obj_Rel_Insert_Input>;
  series_author_id?: InputMaybe<Scalars['uuid']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_author?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Series_Authors_Max_Fields = {
  __typename?: 'series_authors_max_fields';
  author_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  series_author_id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  shared_author_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "series_authors" */
export type Series_Authors_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  series_author_id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Series_Authors_Min_Fields = {
  __typename?: 'series_authors_min_fields';
  author_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  series_author_id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  shared_author_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "series_authors" */
export type Series_Authors_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  series_author_id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "series_authors" */
export type Series_Authors_Mutation_Response = {
  __typename?: 'series_authors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Series_Authors>;
};

/** on_conflict condition type for table "series_authors" */
export type Series_Authors_On_Conflict = {
  constraint: Series_Authors_Constraint;
  update_columns?: Array<Series_Authors_Update_Column>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};

/** Ordering options when selecting data from "series_authors". */
export type Series_Authors_Order_By = {
  author_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  series?: InputMaybe<Series_Order_By>;
  series_author?: InputMaybe<Advice_Authors_Order_By>;
  series_author_id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_author?: InputMaybe<Shared_Entity_Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: series_authors */
export type Series_Authors_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "series_authors" */
export enum Series_Authors_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Id = 'id',
  /** column name */
  SeriesAuthorId = 'series_author_id',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SharedAuthorId = 'shared_author_id'
}

/** input type for updating data in table "series_authors" */
export type Series_Authors_Set_Input = {
  author_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  series_author_id?: InputMaybe<Scalars['uuid']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Series_Authors_Stddev_Fields = {
  __typename?: 'series_authors_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "series_authors" */
export type Series_Authors_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Series_Authors_Stddev_Pop_Fields = {
  __typename?: 'series_authors_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "series_authors" */
export type Series_Authors_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Series_Authors_Stddev_Samp_Fields = {
  __typename?: 'series_authors_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "series_authors" */
export type Series_Authors_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "series_authors" */
export type Series_Authors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Series_Authors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Series_Authors_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  series_author_id?: InputMaybe<Scalars['uuid']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_author_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Series_Authors_Sum_Fields = {
  __typename?: 'series_authors_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_author_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "series_authors" */
export type Series_Authors_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** update columns of table "series_authors" */
export enum Series_Authors_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Id = 'id',
  /** column name */
  SeriesAuthorId = 'series_author_id',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SharedAuthorId = 'shared_author_id'
}

export type Series_Authors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Series_Authors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Series_Authors_Set_Input>;
  where: Series_Authors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Series_Authors_Var_Pop_Fields = {
  __typename?: 'series_authors_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "series_authors" */
export type Series_Authors_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Series_Authors_Var_Samp_Fields = {
  __typename?: 'series_authors_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "series_authors" */
export type Series_Authors_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Series_Authors_Variance_Fields = {
  __typename?: 'series_authors_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_author_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "series_authors" */
export type Series_Authors_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_author_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Series_Avg_Fields = {
  __typename?: 'series_avg_fields';
  discount_price?: Maybe<Scalars['Float']>;
  featured_image_id?: Maybe<Scalars['Float']>;
  featured_video_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "series" */
export type Series_Avg_Order_By = {
  discount_price?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "series". All fields are combined with a logical 'AND'. */
export type Series_Bool_Exp = {
  _and?: InputMaybe<Array<Series_Bool_Exp>>;
  _not?: InputMaybe<Series_Bool_Exp>;
  _or?: InputMaybe<Array<Series_Bool_Exp>>;
  are_lectures_locked?: InputMaybe<Boolean_Comparison_Exp>;
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
  assessments?: InputMaybe<Assessment_Bool_Exp>;
  authors?: InputMaybe<Series_Authors_Bool_Exp>;
  categories?: InputMaybe<Series_Category_Bool_Exp>;
  course_summary?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  discount_price?: InputMaybe<Float8_Comparison_Exp>;
  favorites?: InputMaybe<Article_Series_Favourite_Insights_Bool_Exp>;
  featured_image?: InputMaybe<Fileupload_Bool_Exp>;
  featured_image_id?: InputMaybe<Bigint_Comparison_Exp>;
  featured_video?: InputMaybe<Fileupload_Bool_Exp>;
  featured_video_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_public?: InputMaybe<Boolean_Comparison_Exp>;
  likes?: InputMaybe<Article_Series_Like_Insights_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  series_articles?: InputMaybe<Article_Series_Bool_Exp>;
  series_crops?: InputMaybe<Series_Crops_Bool_Exp>;
  series_favorites?: InputMaybe<Series_Favorites_Bool_Exp>;
  series_likes?: InputMaybe<Series_Likes_Bool_Exp>;
  shared_organisation_id?: InputMaybe<Bigint_Comparison_Exp>;
  subscription_package_id?: InputMaybe<Uuid_Comparison_Exp>;
  unit_price?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  views?: InputMaybe<Article_Series_View_Insights_Bool_Exp>;
};

/** columns and relationships of "series_category" */
export type Series_Category = {
  __typename?: 'series_category';
  /** An object relationship */
  category: Article_Category;
  category_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  series: Series;
  series_id: Scalars['uuid'];
};

/** aggregated selection of "series_category" */
export type Series_Category_Aggregate = {
  __typename?: 'series_category_aggregate';
  aggregate?: Maybe<Series_Category_Aggregate_Fields>;
  nodes: Array<Series_Category>;
};

/** aggregate fields of "series_category" */
export type Series_Category_Aggregate_Fields = {
  __typename?: 'series_category_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Series_Category_Max_Fields>;
  min?: Maybe<Series_Category_Min_Fields>;
};


/** aggregate fields of "series_category" */
export type Series_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Series_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "series_category" */
export type Series_Category_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Series_Category_Max_Order_By>;
  min?: InputMaybe<Series_Category_Min_Order_By>;
};

/** input type for inserting array relation for remote table "series_category" */
export type Series_Category_Arr_Rel_Insert_Input = {
  data: Array<Series_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Series_Category_On_Conflict>;
};

/** Boolean expression to filter rows from the table "series_category". All fields are combined with a logical 'AND'. */
export type Series_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Series_Category_Bool_Exp>>;
  _not?: InputMaybe<Series_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Series_Category_Bool_Exp>>;
  category?: InputMaybe<Article_Category_Bool_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  series?: InputMaybe<Series_Bool_Exp>;
  series_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "series_category" */
export enum Series_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  SeriesCategoryPkey = 'series_category_pkey',
  /** unique or primary key constraint on columns "series_id", "category_id" */
  SeriesCategorySeriesIdCategoryIdEd46e1c3Uniq = 'series_category_series_id_category_id_ed46e1c3_uniq'
}

/** input type for inserting data into table "series_category" */
export type Series_Category_Insert_Input = {
  category?: InputMaybe<Article_Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  series?: InputMaybe<Series_Obj_Rel_Insert_Input>;
  series_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Series_Category_Max_Fields = {
  __typename?: 'series_category_max_fields';
  category_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "series_category" */
export type Series_Category_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Series_Category_Min_Fields = {
  __typename?: 'series_category_min_fields';
  category_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "series_category" */
export type Series_Category_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "series_category" */
export type Series_Category_Mutation_Response = {
  __typename?: 'series_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Series_Category>;
};

/** on_conflict condition type for table "series_category" */
export type Series_Category_On_Conflict = {
  constraint: Series_Category_Constraint;
  update_columns?: Array<Series_Category_Update_Column>;
  where?: InputMaybe<Series_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "series_category". */
export type Series_Category_Order_By = {
  category?: InputMaybe<Article_Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  series?: InputMaybe<Series_Order_By>;
  series_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: series_category */
export type Series_Category_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "series_category" */
export enum Series_Category_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SeriesId = 'series_id'
}

/** input type for updating data in table "series_category" */
export type Series_Category_Set_Input = {
  category_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  series_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "series_category" */
export type Series_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Series_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Series_Category_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  series_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "series_category" */
export enum Series_Category_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SeriesId = 'series_id'
}

export type Series_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Series_Category_Set_Input>;
  where: Series_Category_Bool_Exp;
};

/** unique or primary key constraints on table "series" */
export enum Series_Constraint {
  /** unique or primary key constraint on columns "name", "subscription_package_id", "order" */
  SeriesNameSubscriptionPackageIdOrderB1e2071dUniq = 'series_name_subscription_package_id_order_b1e2071d_uniq',
  /** unique or primary key constraint on columns "id" */
  SeriesPkey = 'series_pkey'
}

/** columns and relationships of "series_crops" */
export type Series_Crops = {
  __typename?: 'series_crops';
  crop: Array<Crop>;
  crop_id: Scalars['String'];
  id: Scalars['bigint'];
  /** An object relationship */
  series: Series;
  series_id: Scalars['uuid'];
  /** An object relationship */
  shared_crop?: Maybe<Shared_Entity>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "series_crops" */
export type Series_CropsCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp_Remote_Rel_Series_Cropscrop>;
};

/** aggregated selection of "series_crops" */
export type Series_Crops_Aggregate = {
  __typename?: 'series_crops_aggregate';
  aggregate?: Maybe<Series_Crops_Aggregate_Fields>;
  nodes: Array<Series_Crops>;
};

/** aggregate fields of "series_crops" */
export type Series_Crops_Aggregate_Fields = {
  __typename?: 'series_crops_aggregate_fields';
  avg?: Maybe<Series_Crops_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Series_Crops_Max_Fields>;
  min?: Maybe<Series_Crops_Min_Fields>;
  stddev?: Maybe<Series_Crops_Stddev_Fields>;
  stddev_pop?: Maybe<Series_Crops_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Series_Crops_Stddev_Samp_Fields>;
  sum?: Maybe<Series_Crops_Sum_Fields>;
  var_pop?: Maybe<Series_Crops_Var_Pop_Fields>;
  var_samp?: Maybe<Series_Crops_Var_Samp_Fields>;
  variance?: Maybe<Series_Crops_Variance_Fields>;
};


/** aggregate fields of "series_crops" */
export type Series_Crops_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Series_Crops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "series_crops" */
export type Series_Crops_Aggregate_Order_By = {
  avg?: InputMaybe<Series_Crops_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Series_Crops_Max_Order_By>;
  min?: InputMaybe<Series_Crops_Min_Order_By>;
  stddev?: InputMaybe<Series_Crops_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Series_Crops_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Series_Crops_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Series_Crops_Sum_Order_By>;
  var_pop?: InputMaybe<Series_Crops_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Series_Crops_Var_Samp_Order_By>;
  variance?: InputMaybe<Series_Crops_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "series_crops" */
export type Series_Crops_Arr_Rel_Insert_Input = {
  data: Array<Series_Crops_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Series_Crops_On_Conflict>;
};

/** aggregate avg on columns */
export type Series_Crops_Avg_Fields = {
  __typename?: 'series_crops_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "series_crops" */
export type Series_Crops_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "series_crops". All fields are combined with a logical 'AND'. */
export type Series_Crops_Bool_Exp = {
  _and?: InputMaybe<Array<Series_Crops_Bool_Exp>>;
  _not?: InputMaybe<Series_Crops_Bool_Exp>;
  _or?: InputMaybe<Array<Series_Crops_Bool_Exp>>;
  crop_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  series?: InputMaybe<Series_Bool_Exp>;
  series_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_crop?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "series_crops" */
export enum Series_Crops_Constraint {
  /** unique or primary key constraint on columns "id" */
  SeriesCropsPkey = 'series_crops_pkey',
  /** unique or primary key constraint on columns "crop_id", "series_id" */
  SeriesCropsSeriesIdCropIdCe9373f5Uniq = 'series_crops_series_id_crop_id_ce9373f5_uniq'
}

/** input type for incrementing numeric columns in table "series_crops" */
export type Series_Crops_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "series_crops" */
export type Series_Crops_Insert_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  series?: InputMaybe<Series_Obj_Rel_Insert_Input>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_crop?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Series_Crops_Max_Fields = {
  __typename?: 'series_crops_max_fields';
  crop_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  series_id?: Maybe<Scalars['uuid']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "series_crops" */
export type Series_Crops_Max_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Series_Crops_Min_Fields = {
  __typename?: 'series_crops_min_fields';
  crop_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  series_id?: Maybe<Scalars['uuid']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "series_crops" */
export type Series_Crops_Min_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "series_crops" */
export type Series_Crops_Mutation_Response = {
  __typename?: 'series_crops_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Series_Crops>;
};

/** on_conflict condition type for table "series_crops" */
export type Series_Crops_On_Conflict = {
  constraint: Series_Crops_Constraint;
  update_columns?: Array<Series_Crops_Update_Column>;
  where?: InputMaybe<Series_Crops_Bool_Exp>;
};

/** Ordering options when selecting data from "series_crops". */
export type Series_Crops_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  series?: InputMaybe<Series_Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_crop?: InputMaybe<Shared_Entity_Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: series_crops */
export type Series_Crops_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "series_crops" */
export enum Series_Crops_Select_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SharedCropId = 'shared_crop_id'
}

/** input type for updating data in table "series_crops" */
export type Series_Crops_Set_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Series_Crops_Stddev_Fields = {
  __typename?: 'series_crops_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "series_crops" */
export type Series_Crops_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Series_Crops_Stddev_Pop_Fields = {
  __typename?: 'series_crops_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "series_crops" */
export type Series_Crops_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Series_Crops_Stddev_Samp_Fields = {
  __typename?: 'series_crops_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "series_crops" */
export type Series_Crops_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "series_crops" */
export type Series_Crops_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Series_Crops_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Series_Crops_Stream_Cursor_Value_Input = {
  crop_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_crop_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Series_Crops_Sum_Fields = {
  __typename?: 'series_crops_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_crop_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "series_crops" */
export type Series_Crops_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "series_crops" */
export enum Series_Crops_Update_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SharedCropId = 'shared_crop_id'
}

export type Series_Crops_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Series_Crops_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Series_Crops_Set_Input>;
  where: Series_Crops_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Series_Crops_Var_Pop_Fields = {
  __typename?: 'series_crops_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "series_crops" */
export type Series_Crops_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Series_Crops_Var_Samp_Fields = {
  __typename?: 'series_crops_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "series_crops" */
export type Series_Crops_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Series_Crops_Variance_Fields = {
  __typename?: 'series_crops_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "series_crops" */
export type Series_Crops_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_crop_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "series_favorites" */
export type Series_Favorites = {
  __typename?: 'series_favorites';
  id: Scalars['bigint'];
  /** An object relationship */
  series: Series;
  series_id: Scalars['uuid'];
  /** An object relationship */
  shared_user?: Maybe<Shared_Entity>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user: Array<Base_User>;
  user_id: Scalars['String'];
};


/** columns and relationships of "series_favorites" */
export type Series_FavoritesUserArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Series_Favoritesuser>;
};

/** aggregated selection of "series_favorites" */
export type Series_Favorites_Aggregate = {
  __typename?: 'series_favorites_aggregate';
  aggregate?: Maybe<Series_Favorites_Aggregate_Fields>;
  nodes: Array<Series_Favorites>;
};

/** aggregate fields of "series_favorites" */
export type Series_Favorites_Aggregate_Fields = {
  __typename?: 'series_favorites_aggregate_fields';
  avg?: Maybe<Series_Favorites_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Series_Favorites_Max_Fields>;
  min?: Maybe<Series_Favorites_Min_Fields>;
  stddev?: Maybe<Series_Favorites_Stddev_Fields>;
  stddev_pop?: Maybe<Series_Favorites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Series_Favorites_Stddev_Samp_Fields>;
  sum?: Maybe<Series_Favorites_Sum_Fields>;
  var_pop?: Maybe<Series_Favorites_Var_Pop_Fields>;
  var_samp?: Maybe<Series_Favorites_Var_Samp_Fields>;
  variance?: Maybe<Series_Favorites_Variance_Fields>;
};


/** aggregate fields of "series_favorites" */
export type Series_Favorites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Series_Favorites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "series_favorites" */
export type Series_Favorites_Aggregate_Order_By = {
  avg?: InputMaybe<Series_Favorites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Series_Favorites_Max_Order_By>;
  min?: InputMaybe<Series_Favorites_Min_Order_By>;
  stddev?: InputMaybe<Series_Favorites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Series_Favorites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Series_Favorites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Series_Favorites_Sum_Order_By>;
  var_pop?: InputMaybe<Series_Favorites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Series_Favorites_Var_Samp_Order_By>;
  variance?: InputMaybe<Series_Favorites_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "series_favorites" */
export type Series_Favorites_Arr_Rel_Insert_Input = {
  data: Array<Series_Favorites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Series_Favorites_On_Conflict>;
};

/** aggregate avg on columns */
export type Series_Favorites_Avg_Fields = {
  __typename?: 'series_favorites_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "series_favorites" */
export type Series_Favorites_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "series_favorites". All fields are combined with a logical 'AND'. */
export type Series_Favorites_Bool_Exp = {
  _and?: InputMaybe<Array<Series_Favorites_Bool_Exp>>;
  _not?: InputMaybe<Series_Favorites_Bool_Exp>;
  _or?: InputMaybe<Array<Series_Favorites_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  series?: InputMaybe<Series_Bool_Exp>;
  series_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_user?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "series_favorites" */
export enum Series_Favorites_Constraint {
  /** unique or primary key constraint on columns "id" */
  SeriesFavoritesPkey = 'series_favorites_pkey',
  /** unique or primary key constraint on columns "user_id", "series_id" */
  SeriesFavoritesSeriesIdUserIdF4b53cb1Uniq = 'series_favorites_series_id_user_id_f4b53cb1_uniq'
}

/** input type for incrementing numeric columns in table "series_favorites" */
export type Series_Favorites_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "series_favorites" */
export type Series_Favorites_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  series?: InputMaybe<Series_Obj_Rel_Insert_Input>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_user?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Series_Favorites_Max_Fields = {
  __typename?: 'series_favorites_max_fields';
  id?: Maybe<Scalars['bigint']>;
  series_id?: Maybe<Scalars['uuid']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "series_favorites" */
export type Series_Favorites_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Series_Favorites_Min_Fields = {
  __typename?: 'series_favorites_min_fields';
  id?: Maybe<Scalars['bigint']>;
  series_id?: Maybe<Scalars['uuid']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "series_favorites" */
export type Series_Favorites_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "series_favorites" */
export type Series_Favorites_Mutation_Response = {
  __typename?: 'series_favorites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Series_Favorites>;
};

/** on_conflict condition type for table "series_favorites" */
export type Series_Favorites_On_Conflict = {
  constraint: Series_Favorites_Constraint;
  update_columns?: Array<Series_Favorites_Update_Column>;
  where?: InputMaybe<Series_Favorites_Bool_Exp>;
};

/** Ordering options when selecting data from "series_favorites". */
export type Series_Favorites_Order_By = {
  id?: InputMaybe<Order_By>;
  series?: InputMaybe<Series_Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_user?: InputMaybe<Shared_Entity_Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: series_favorites */
export type Series_Favorites_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "series_favorites" */
export enum Series_Favorites_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "series_favorites" */
export type Series_Favorites_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Series_Favorites_Stddev_Fields = {
  __typename?: 'series_favorites_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "series_favorites" */
export type Series_Favorites_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Series_Favorites_Stddev_Pop_Fields = {
  __typename?: 'series_favorites_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "series_favorites" */
export type Series_Favorites_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Series_Favorites_Stddev_Samp_Fields = {
  __typename?: 'series_favorites_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "series_favorites" */
export type Series_Favorites_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "series_favorites" */
export type Series_Favorites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Series_Favorites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Series_Favorites_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Series_Favorites_Sum_Fields = {
  __typename?: 'series_favorites_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "series_favorites" */
export type Series_Favorites_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** update columns of table "series_favorites" */
export enum Series_Favorites_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Series_Favorites_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Series_Favorites_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Series_Favorites_Set_Input>;
  where: Series_Favorites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Series_Favorites_Var_Pop_Fields = {
  __typename?: 'series_favorites_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "series_favorites" */
export type Series_Favorites_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Series_Favorites_Var_Samp_Fields = {
  __typename?: 'series_favorites_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "series_favorites" */
export type Series_Favorites_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Series_Favorites_Variance_Fields = {
  __typename?: 'series_favorites_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "series_favorites" */
export type Series_Favorites_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "series" */
export type Series_Inc_Input = {
  discount_price?: InputMaybe<Scalars['float8']>;
  featured_image_id?: InputMaybe<Scalars['bigint']>;
  featured_video_id?: InputMaybe<Scalars['bigint']>;
  order?: InputMaybe<Scalars['smallint']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  unit_price?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "series" */
export type Series_Insert_Input = {
  are_lectures_locked?: InputMaybe<Scalars['Boolean']>;
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Obj_Rel_Insert_Input>;
  assessments?: InputMaybe<Assessment_Arr_Rel_Insert_Input>;
  authors?: InputMaybe<Series_Authors_Arr_Rel_Insert_Input>;
  categories?: InputMaybe<Series_Category_Arr_Rel_Insert_Input>;
  course_summary?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  discount_price?: InputMaybe<Scalars['float8']>;
  favorites?: InputMaybe<Article_Series_Favourite_Insights_Obj_Rel_Insert_Input>;
  featured_image?: InputMaybe<Fileupload_Obj_Rel_Insert_Input>;
  featured_image_id?: InputMaybe<Scalars['bigint']>;
  featured_video?: InputMaybe<Fileupload_Obj_Rel_Insert_Input>;
  featured_video_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  likes?: InputMaybe<Article_Series_Like_Insights_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  series_articles?: InputMaybe<Article_Series_Arr_Rel_Insert_Input>;
  series_crops?: InputMaybe<Series_Crops_Arr_Rel_Insert_Input>;
  series_favorites?: InputMaybe<Series_Favorites_Arr_Rel_Insert_Input>;
  series_likes?: InputMaybe<Series_Likes_Arr_Rel_Insert_Input>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
  unit_price?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  views?: InputMaybe<Article_Series_View_Insights_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "series_likes" */
export type Series_Likes = {
  __typename?: 'series_likes';
  id: Scalars['bigint'];
  liked_date: Scalars['date'];
  /** An object relationship */
  series: Series;
  series_id: Scalars['uuid'];
  /** An object relationship */
  shared_user?: Maybe<Shared_Entity>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user: Array<Base_User>;
  user_id: Scalars['String'];
};


/** columns and relationships of "series_likes" */
export type Series_LikesUserArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Series_Likesuser>;
};

/** aggregated selection of "series_likes" */
export type Series_Likes_Aggregate = {
  __typename?: 'series_likes_aggregate';
  aggregate?: Maybe<Series_Likes_Aggregate_Fields>;
  nodes: Array<Series_Likes>;
};

/** aggregate fields of "series_likes" */
export type Series_Likes_Aggregate_Fields = {
  __typename?: 'series_likes_aggregate_fields';
  avg?: Maybe<Series_Likes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Series_Likes_Max_Fields>;
  min?: Maybe<Series_Likes_Min_Fields>;
  stddev?: Maybe<Series_Likes_Stddev_Fields>;
  stddev_pop?: Maybe<Series_Likes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Series_Likes_Stddev_Samp_Fields>;
  sum?: Maybe<Series_Likes_Sum_Fields>;
  var_pop?: Maybe<Series_Likes_Var_Pop_Fields>;
  var_samp?: Maybe<Series_Likes_Var_Samp_Fields>;
  variance?: Maybe<Series_Likes_Variance_Fields>;
};


/** aggregate fields of "series_likes" */
export type Series_Likes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Series_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "series_likes" */
export type Series_Likes_Aggregate_Order_By = {
  avg?: InputMaybe<Series_Likes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Series_Likes_Max_Order_By>;
  min?: InputMaybe<Series_Likes_Min_Order_By>;
  stddev?: InputMaybe<Series_Likes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Series_Likes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Series_Likes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Series_Likes_Sum_Order_By>;
  var_pop?: InputMaybe<Series_Likes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Series_Likes_Var_Samp_Order_By>;
  variance?: InputMaybe<Series_Likes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "series_likes" */
export type Series_Likes_Arr_Rel_Insert_Input = {
  data: Array<Series_Likes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Series_Likes_On_Conflict>;
};

/** aggregate avg on columns */
export type Series_Likes_Avg_Fields = {
  __typename?: 'series_likes_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "series_likes" */
export type Series_Likes_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "series_likes". All fields are combined with a logical 'AND'. */
export type Series_Likes_Bool_Exp = {
  _and?: InputMaybe<Array<Series_Likes_Bool_Exp>>;
  _not?: InputMaybe<Series_Likes_Bool_Exp>;
  _or?: InputMaybe<Array<Series_Likes_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  liked_date?: InputMaybe<Date_Comparison_Exp>;
  series?: InputMaybe<Series_Bool_Exp>;
  series_id?: InputMaybe<Uuid_Comparison_Exp>;
  shared_user?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "series_likes" */
export enum Series_Likes_Constraint {
  /** unique or primary key constraint on columns "id" */
  SeriesLikesPkey = 'series_likes_pkey',
  /** unique or primary key constraint on columns "user_id", "series_id" */
  SeriesLikesSeriesIdUserIdCd3b9dc6Uniq = 'series_likes_series_id_user_id_cd3b9dc6_uniq'
}

/** input type for incrementing numeric columns in table "series_likes" */
export type Series_Likes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "series_likes" */
export type Series_Likes_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  liked_date?: InputMaybe<Scalars['date']>;
  series?: InputMaybe<Series_Obj_Rel_Insert_Input>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_user?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Series_Likes_Max_Fields = {
  __typename?: 'series_likes_max_fields';
  id?: Maybe<Scalars['bigint']>;
  liked_date?: Maybe<Scalars['date']>;
  series_id?: Maybe<Scalars['uuid']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "series_likes" */
export type Series_Likes_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  liked_date?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Series_Likes_Min_Fields = {
  __typename?: 'series_likes_min_fields';
  id?: Maybe<Scalars['bigint']>;
  liked_date?: Maybe<Scalars['date']>;
  series_id?: Maybe<Scalars['uuid']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "series_likes" */
export type Series_Likes_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  liked_date?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "series_likes" */
export type Series_Likes_Mutation_Response = {
  __typename?: 'series_likes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Series_Likes>;
};

/** on_conflict condition type for table "series_likes" */
export type Series_Likes_On_Conflict = {
  constraint: Series_Likes_Constraint;
  update_columns?: Array<Series_Likes_Update_Column>;
  where?: InputMaybe<Series_Likes_Bool_Exp>;
};

/** Ordering options when selecting data from "series_likes". */
export type Series_Likes_Order_By = {
  id?: InputMaybe<Order_By>;
  liked_date?: InputMaybe<Order_By>;
  series?: InputMaybe<Series_Order_By>;
  series_id?: InputMaybe<Order_By>;
  shared_user?: InputMaybe<Shared_Entity_Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: series_likes */
export type Series_Likes_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "series_likes" */
export enum Series_Likes_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LikedDate = 'liked_date',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "series_likes" */
export type Series_Likes_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  liked_date?: InputMaybe<Scalars['date']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Series_Likes_Stddev_Fields = {
  __typename?: 'series_likes_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "series_likes" */
export type Series_Likes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Series_Likes_Stddev_Pop_Fields = {
  __typename?: 'series_likes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "series_likes" */
export type Series_Likes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Series_Likes_Stddev_Samp_Fields = {
  __typename?: 'series_likes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "series_likes" */
export type Series_Likes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "series_likes" */
export type Series_Likes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Series_Likes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Series_Likes_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  liked_date?: InputMaybe<Scalars['date']>;
  series_id?: InputMaybe<Scalars['uuid']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Series_Likes_Sum_Fields = {
  __typename?: 'series_likes_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "series_likes" */
export type Series_Likes_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** update columns of table "series_likes" */
export enum Series_Likes_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LikedDate = 'liked_date',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Series_Likes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Series_Likes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Series_Likes_Set_Input>;
  where: Series_Likes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Series_Likes_Var_Pop_Fields = {
  __typename?: 'series_likes_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "series_likes" */
export type Series_Likes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Series_Likes_Var_Samp_Fields = {
  __typename?: 'series_likes_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "series_likes" */
export type Series_Likes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Series_Likes_Variance_Fields = {
  __typename?: 'series_likes_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "series_likes" */
export type Series_Likes_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Series_Max_Fields = {
  __typename?: 'series_max_fields';
  course_summary?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  discount_price?: Maybe<Scalars['float8']>;
  featured_image_id?: Maybe<Scalars['bigint']>;
  featured_video_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  organisation_id?: Maybe<Scalars['Int']>;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  subscription_package_id?: Maybe<Scalars['uuid']>;
  unit_price?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "series" */
export type Series_Max_Order_By = {
  course_summary?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  discount_price?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Series_Min_Fields = {
  __typename?: 'series_min_fields';
  course_summary?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  discount_price?: Maybe<Scalars['float8']>;
  featured_image_id?: Maybe<Scalars['bigint']>;
  featured_video_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
  organisation_id?: Maybe<Scalars['Int']>;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  subscription_package_id?: Maybe<Scalars['uuid']>;
  unit_price?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "series" */
export type Series_Min_Order_By = {
  course_summary?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  discount_price?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "series" */
export type Series_Mutation_Response = {
  __typename?: 'series_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Series>;
};

/** input type for inserting object relation for remote table "series" */
export type Series_Obj_Rel_Insert_Input = {
  data: Series_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Series_On_Conflict>;
};

/** on_conflict condition type for table "series" */
export type Series_On_Conflict = {
  constraint: Series_Constraint;
  update_columns?: Array<Series_Update_Column>;
  where?: InputMaybe<Series_Bool_Exp>;
};

/** Ordering options when selecting data from "series". */
export type Series_Order_By = {
  are_lectures_locked?: InputMaybe<Order_By>;
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Order_By>;
  assessments_aggregate?: InputMaybe<Assessment_Aggregate_Order_By>;
  authors_aggregate?: InputMaybe<Series_Authors_Aggregate_Order_By>;
  categories_aggregate?: InputMaybe<Series_Category_Aggregate_Order_By>;
  course_summary?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  discount_price?: InputMaybe<Order_By>;
  favorites?: InputMaybe<Article_Series_Favourite_Insights_Order_By>;
  featured_image?: InputMaybe<Fileupload_Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video?: InputMaybe<Fileupload_Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_public?: InputMaybe<Order_By>;
  likes?: InputMaybe<Article_Series_Like_Insights_Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  series_articles_aggregate?: InputMaybe<Article_Series_Aggregate_Order_By>;
  series_crops_aggregate?: InputMaybe<Series_Crops_Aggregate_Order_By>;
  series_favorites_aggregate?: InputMaybe<Series_Favorites_Aggregate_Order_By>;
  series_likes_aggregate?: InputMaybe<Series_Likes_Aggregate_Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Article_Series_View_Insights_Order_By>;
};

/** primary key columns input for table: series */
export type Series_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "series" */
export enum Series_Select_Column {
  /** column name */
  AreLecturesLocked = 'are_lectures_locked',
  /** column name */
  CourseSummary = 'course_summary',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  FeaturedImageId = 'featured_image_id',
  /** column name */
  FeaturedVideoId = 'featured_video_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SharedOrganisationId = 'shared_organisation_id',
  /** column name */
  SubscriptionPackageId = 'subscription_package_id',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "series" */
export type Series_Set_Input = {
  are_lectures_locked?: InputMaybe<Scalars['Boolean']>;
  course_summary?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  discount_price?: InputMaybe<Scalars['float8']>;
  featured_image_id?: InputMaybe<Scalars['bigint']>;
  featured_video_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
  unit_price?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Series_Stddev_Fields = {
  __typename?: 'series_stddev_fields';
  discount_price?: Maybe<Scalars['Float']>;
  featured_image_id?: Maybe<Scalars['Float']>;
  featured_video_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "series" */
export type Series_Stddev_Order_By = {
  discount_price?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Series_Stddev_Pop_Fields = {
  __typename?: 'series_stddev_pop_fields';
  discount_price?: Maybe<Scalars['Float']>;
  featured_image_id?: Maybe<Scalars['Float']>;
  featured_video_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "series" */
export type Series_Stddev_Pop_Order_By = {
  discount_price?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Series_Stddev_Samp_Fields = {
  __typename?: 'series_stddev_samp_fields';
  discount_price?: Maybe<Scalars['Float']>;
  featured_image_id?: Maybe<Scalars['Float']>;
  featured_video_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "series" */
export type Series_Stddev_Samp_Order_By = {
  discount_price?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "series" */
export type Series_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Series_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Series_Stream_Cursor_Value_Input = {
  are_lectures_locked?: InputMaybe<Scalars['Boolean']>;
  course_summary?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  discount_price?: InputMaybe<Scalars['float8']>;
  featured_image_id?: InputMaybe<Scalars['bigint']>;
  featured_video_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  shared_organisation_id?: InputMaybe<Scalars['bigint']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
  unit_price?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Series_Sum_Fields = {
  __typename?: 'series_sum_fields';
  discount_price?: Maybe<Scalars['float8']>;
  featured_image_id?: Maybe<Scalars['bigint']>;
  featured_video_id?: Maybe<Scalars['bigint']>;
  order?: Maybe<Scalars['smallint']>;
  organisation_id?: Maybe<Scalars['Int']>;
  shared_organisation_id?: Maybe<Scalars['bigint']>;
  unit_price?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "series" */
export type Series_Sum_Order_By = {
  discount_price?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** update columns of table "series" */
export enum Series_Update_Column {
  /** column name */
  AreLecturesLocked = 'are_lectures_locked',
  /** column name */
  CourseSummary = 'course_summary',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  FeaturedImageId = 'featured_image_id',
  /** column name */
  FeaturedVideoId = 'featured_video_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SharedOrganisationId = 'shared_organisation_id',
  /** column name */
  SubscriptionPackageId = 'subscription_package_id',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Series_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Series_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Series_Set_Input>;
  where: Series_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Series_Var_Pop_Fields = {
  __typename?: 'series_var_pop_fields';
  discount_price?: Maybe<Scalars['Float']>;
  featured_image_id?: Maybe<Scalars['Float']>;
  featured_video_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "series" */
export type Series_Var_Pop_Order_By = {
  discount_price?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Series_Var_Samp_Fields = {
  __typename?: 'series_var_samp_fields';
  discount_price?: Maybe<Scalars['Float']>;
  featured_image_id?: Maybe<Scalars['Float']>;
  featured_video_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "series" */
export type Series_Var_Samp_Order_By = {
  discount_price?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Series_Variance_Fields = {
  __typename?: 'series_variance_fields';
  discount_price?: Maybe<Scalars['Float']>;
  featured_image_id?: Maybe<Scalars['Float']>;
  featured_video_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  shared_organisation_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "series" */
export type Series_Variance_Order_By = {
  discount_price?: InputMaybe<Order_By>;
  featured_image_id?: InputMaybe<Order_By>;
  featured_video_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  shared_organisation_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_Entity = {
  __typename?: 'setu_trade_shared_entity';
  codename: Scalars['String'];
  commodity: Array<Commodity>;
  commodity_variety: Array<Commodity_Variety>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  department: Array<Department>;
  description: Scalars['String'];
  facilitator: Array<Company>;
  group_id?: Maybe<Scalars['bigint']>;
  group_name: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  packaging_unit: Array<Sku>;
  plot_crop: Array<Plot_Crop>;
  private_metadata: Scalars['jsonb'];
  reference_id: Scalars['String'];
  si_unit: Array<Si_Unit>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  user: Array<Base_User>;
  variety_grade: Array<Variety_Grade>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityCommodityArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp_Remote_Rel_Shared_Entitycommodity>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityCommodity_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp_Remote_Rel_Shared_Entitycommodity_Variety>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityDepartmentArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp_Remote_Rel_Shared_Entitydepartment>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityFacilitatorArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp_Remote_Rel_Shared_Entityfacilitator>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityPackaging_UnitArgs = {
  distinct_on?: InputMaybe<Array<Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Order_By>>;
  where?: InputMaybe<Sku_Bool_Exp_Remote_Rel_Shared_Entitypackaging_Unit>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp_Remote_Rel_Shared_Entityplot_Crop>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntitySi_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Shared_Entitysi_Unit>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityUserArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Shared_Entityuser>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityVariety_GradeArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp_Remote_Rel_Shared_Entityvariety_Grade>;
};

/** Boolean expression to filter rows from the table "shared_entity". All fields are combined with a logical 'AND'. */
export type Setu_Trade_Shared_Entity_Bool_Exp = {
  _and?: InputMaybe<Array<Setu_Trade_Shared_Entity_Bool_Exp>>;
  _not?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Setu_Trade_Shared_Entity_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Bigint_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared_entity" */
export enum Setu_Trade_Shared_Entity_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SharedEntityCodenameKey = 'shared_entity_codename_key',
  /** unique or primary key constraint on columns "reference_id", "group_name" */
  SharedEntityGroupNameReferenceId_4db210e6Uniq = 'shared_entity_group_name_reference_id_4db210e6_uniq',
  /** unique or primary key constraint on columns "id" */
  SharedEntityPkey = 'shared_entity_pkey'
}

/** input type for inserting data into table "shared_entity" */
export type Setu_Trade_Shared_Entity_Insert_Input = {
  group_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "shared_entity" */
export type Setu_Trade_Shared_Entity_Mutation_Response = {
  __typename?: 'setu_trade_shared_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Setu_Trade_Shared_Entity>;
};

/** input type for inserting object relation for remote table "shared_entity" */
export type Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input = {
  data: Setu_Trade_Shared_Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Setu_Trade_Shared_Entity_On_Conflict>;
};

/** on_conflict condition type for table "shared_entity" */
export type Setu_Trade_Shared_Entity_On_Conflict = {
  constraint: Setu_Trade_Shared_Entity_Constraint;
  update_columns?: Array<Setu_Trade_Shared_Entity_Update_Column>;
  where?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "shared_entity". */
export type Setu_Trade_Shared_Entity_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared_entity */
export type Setu_Trade_Shared_Entity_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "shared_entity" */
export enum Setu_Trade_Shared_Entity_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "shared_entity" */
export type Setu_Trade_Shared_Entity_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "setu_trade_shared_entity" */
export type Setu_Trade_Shared_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setu_Trade_Shared_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setu_Trade_Shared_Entity_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  group_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "shared_entity" */
export enum Setu_Trade_Shared_Entity_Update_Column {
  /** column name */
  Name = 'name'
}

export type Setu_Trade_Shared_Entity_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Setu_Trade_Shared_Entity_Set_Input>;
  where: Setu_Trade_Shared_Entity_Bool_Exp;
};

/** columns and relationships of "setu_weather_user" */
export type Setu_Weather_User = {
  __typename?: 'setu_weather_user';
  date_joined: Scalars['timestamptz'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  is_staff: Scalars['Boolean'];
  is_superuser: Scalars['Boolean'];
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

/** aggregated selection of "setu_weather_user" */
export type Setu_Weather_User_Aggregate = {
  __typename?: 'setu_weather_user_aggregate';
  aggregate?: Maybe<Setu_Weather_User_Aggregate_Fields>;
  nodes: Array<Setu_Weather_User>;
};

/** aggregate fields of "setu_weather_user" */
export type Setu_Weather_User_Aggregate_Fields = {
  __typename?: 'setu_weather_user_aggregate_fields';
  avg?: Maybe<Setu_Weather_User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Setu_Weather_User_Max_Fields>;
  min?: Maybe<Setu_Weather_User_Min_Fields>;
  stddev?: Maybe<Setu_Weather_User_Stddev_Fields>;
  stddev_pop?: Maybe<Setu_Weather_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Setu_Weather_User_Stddev_Samp_Fields>;
  sum?: Maybe<Setu_Weather_User_Sum_Fields>;
  var_pop?: Maybe<Setu_Weather_User_Var_Pop_Fields>;
  var_samp?: Maybe<Setu_Weather_User_Var_Samp_Fields>;
  variance?: Maybe<Setu_Weather_User_Variance_Fields>;
};


/** aggregate fields of "setu_weather_user" */
export type Setu_Weather_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Setu_Weather_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Setu_Weather_User_Avg_Fields = {
  __typename?: 'setu_weather_user_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "setu_weather_user". All fields are combined with a logical 'AND'. */
export type Setu_Weather_User_Bool_Exp = {
  _and?: InputMaybe<Array<Setu_Weather_User_Bool_Exp>>;
  _not?: InputMaybe<Setu_Weather_User_Bool_Exp>;
  _or?: InputMaybe<Array<Setu_Weather_User_Bool_Exp>>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "setu_weather_user" */
export enum Setu_Weather_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  SetuWeatherUserPkey = 'setu_weather_user_pkey',
  /** unique or primary key constraint on columns "username" */
  SetuWeatherUserUsernameKey = 'setu_weather_user_username_key'
}

/** input type for incrementing numeric columns in table "setu_weather_user" */
export type Setu_Weather_User_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "setu_weather_user" */
export type Setu_Weather_User_Insert_Input = {
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Setu_Weather_User_Max_Fields = {
  __typename?: 'setu_weather_user_max_fields';
  date_joined?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Setu_Weather_User_Min_Fields = {
  __typename?: 'setu_weather_user_min_fields';
  date_joined?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "setu_weather_user" */
export type Setu_Weather_User_Mutation_Response = {
  __typename?: 'setu_weather_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Setu_Weather_User>;
};

/** on_conflict condition type for table "setu_weather_user" */
export type Setu_Weather_User_On_Conflict = {
  constraint: Setu_Weather_User_Constraint;
  update_columns?: Array<Setu_Weather_User_Update_Column>;
  where?: InputMaybe<Setu_Weather_User_Bool_Exp>;
};

/** Ordering options when selecting data from "setu_weather_user". */
export type Setu_Weather_User_Order_By = {
  date_joined?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_staff?: InputMaybe<Order_By>;
  is_superuser?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: setu_weather_user */
export type Setu_Weather_User_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "setu_weather_user" */
export enum Setu_Weather_User_Select_Column {
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsStaff = 'is_staff',
  /** column name */
  IsSuperuser = 'is_superuser',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Password = 'password',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "setu_weather_user" */
export type Setu_Weather_User_Set_Input = {
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Setu_Weather_User_Stddev_Fields = {
  __typename?: 'setu_weather_user_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Setu_Weather_User_Stddev_Pop_Fields = {
  __typename?: 'setu_weather_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Setu_Weather_User_Stddev_Samp_Fields = {
  __typename?: 'setu_weather_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "setu_weather_user" */
export type Setu_Weather_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setu_Weather_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setu_Weather_User_Stream_Cursor_Value_Input = {
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Setu_Weather_User_Sum_Fields = {
  __typename?: 'setu_weather_user_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "setu_weather_user" */
export enum Setu_Weather_User_Update_Column {
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsStaff = 'is_staff',
  /** column name */
  IsSuperuser = 'is_superuser',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Password = 'password',
  /** column name */
  Username = 'username'
}

export type Setu_Weather_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Setu_Weather_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Setu_Weather_User_Set_Input>;
  where: Setu_Weather_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Setu_Weather_User_Var_Pop_Fields = {
  __typename?: 'setu_weather_user_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Setu_Weather_User_Var_Samp_Fields = {
  __typename?: 'setu_weather_user_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Setu_Weather_User_Variance_Fields = {
  __typename?: 'setu_weather_user_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "shared_entity" */
export type Shared_Entity = {
  __typename?: 'shared_entity';
  /** An array relationship */
  advice_authors: Array<Advice_Authors>;
  /** An aggregate relationship */
  advice_authors_aggregate: Advice_Authors_Aggregate;
  /** An array relationship */
  article_authors: Array<Article_Authors>;
  /** An aggregate relationship */
  article_authors_aggregate: Article_Authors_Aggregate;
  /** An array relationship */
  article_crop_categories: Array<Article_Crop_Categories>;
  /** An aggregate relationship */
  article_crop_categories_aggregate: Article_Crop_Categories_Aggregate;
  /** An array relationship */
  article_crop_varieties: Array<Article_Crop_Varieties>;
  /** An aggregate relationship */
  article_crop_varieties_aggregate: Article_Crop_Varieties_Aggregate;
  /** An array relationship */
  article_crops: Array<Article_Crops>;
  /** An aggregate relationship */
  article_crops_aggregate: Article_Crops_Aggregate;
  /** An array relationship */
  article_regions: Array<Article_Regions>;
  /** An aggregate relationship */
  article_regions_aggregate: Article_Regions_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  crop: Array<Crop>;
  description: Scalars['String'];
  farm: Array<Farm>;
  field: Array<Field>;
  group_id?: Maybe<Scalars['bigint']>;
  group_name: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  owner_team: Array<Mutual_Group>;
  plot: Array<Plot>;
  plot_crop: Array<Plot_Crop>;
  private_metadata: Scalars['jsonb'];
  reference_id: Scalars['String'];
  region: Array<Region>;
  /** An array relationship */
  series_authors: Array<Series_Authors>;
  /** An aggregate relationship */
  series_authors_aggregate: Series_Authors_Aggregate;
  /** An array relationship */
  series_crops: Array<Series_Crops>;
  /** An aggregate relationship */
  series_crops_aggregate: Series_Crops_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  user: Array<Base_User>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityAdvice_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Advice_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Authors_Order_By>>;
  where?: InputMaybe<Advice_Authors_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityAdvice_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advice_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Authors_Order_By>>;
  where?: InputMaybe<Advice_Authors_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityArticle_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Article_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Authors_Order_By>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityArticle_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Authors_Order_By>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityArticle_Crop_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Categories_Order_By>>;
  where?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityArticle_Crop_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Categories_Order_By>>;
  where?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityArticle_Crop_VarietiesArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Varieties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Varieties_Order_By>>;
  where?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityArticle_Crop_Varieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Varieties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Varieties_Order_By>>;
  where?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityArticle_CropsArgs = {
  distinct_on?: InputMaybe<Array<Article_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crops_Order_By>>;
  where?: InputMaybe<Article_Crops_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityArticle_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crops_Order_By>>;
  where?: InputMaybe<Article_Crops_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityArticle_RegionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Regions_Order_By>>;
  where?: InputMaybe<Article_Regions_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityArticle_Regions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Regions_Order_By>>;
  where?: InputMaybe<Article_Regions_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp_Remote_Rel_Shared_Entitycrop>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityFarmArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp_Remote_Rel_Shared_Entityfarm>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityFieldArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp_Remote_Rel_Shared_Entityfield>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityOwner_TeamArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp_Remote_Rel_Shared_Entityowner_Team>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityPlotArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp_Remote_Rel_Shared_Entityplot>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp_Remote_Rel_Shared_Entityplot_Crop>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp_Remote_Rel_Shared_Entityregion>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntitySeries_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Series_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Authors_Order_By>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntitySeries_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Authors_Order_By>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntitySeries_CropsArgs = {
  distinct_on?: InputMaybe<Array<Series_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Crops_Order_By>>;
  where?: InputMaybe<Series_Crops_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntitySeries_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Crops_Order_By>>;
  where?: InputMaybe<Series_Crops_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Shared_EntityUserArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Shared_Entityuser>;
};

/** aggregated selection of "shared_entity" */
export type Shared_Entity_Aggregate = {
  __typename?: 'shared_entity_aggregate';
  aggregate?: Maybe<Shared_Entity_Aggregate_Fields>;
  nodes: Array<Shared_Entity>;
};

/** aggregate fields of "shared_entity" */
export type Shared_Entity_Aggregate_Fields = {
  __typename?: 'shared_entity_aggregate_fields';
  avg?: Maybe<Shared_Entity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shared_Entity_Max_Fields>;
  min?: Maybe<Shared_Entity_Min_Fields>;
  stddev?: Maybe<Shared_Entity_Stddev_Fields>;
  stddev_pop?: Maybe<Shared_Entity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shared_Entity_Stddev_Samp_Fields>;
  sum?: Maybe<Shared_Entity_Sum_Fields>;
  var_pop?: Maybe<Shared_Entity_Var_Pop_Fields>;
  var_samp?: Maybe<Shared_Entity_Var_Samp_Fields>;
  variance?: Maybe<Shared_Entity_Variance_Fields>;
};


/** aggregate fields of "shared_entity" */
export type Shared_Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shared_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Shared_Entity_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Shared_Entity_Avg_Fields = {
  __typename?: 'shared_entity_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shared_entity". All fields are combined with a logical 'AND'. */
export type Shared_Entity_Bool_Exp = {
  _and?: InputMaybe<Array<Shared_Entity_Bool_Exp>>;
  _not?: InputMaybe<Shared_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Shared_Entity_Bool_Exp>>;
  advice_authors?: InputMaybe<Advice_Authors_Bool_Exp>;
  article_authors?: InputMaybe<Article_Authors_Bool_Exp>;
  article_crop_categories?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
  article_crop_varieties?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
  article_crops?: InputMaybe<Article_Crops_Bool_Exp>;
  article_regions?: InputMaybe<Article_Regions_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Bigint_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  series_authors?: InputMaybe<Series_Authors_Bool_Exp>;
  series_crops?: InputMaybe<Series_Crops_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared_entity" */
export enum Shared_Entity_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SharedEntityCodenameKey = 'shared_entity_codename_key',
  /** unique or primary key constraint on columns "reference_id", "group_name" */
  SharedEntityGroupNameReferenceId_4db210e6Uniq = 'shared_entity_group_name_reference_id_4db210e6_uniq',
  /** unique or primary key constraint on columns "id" */
  SharedEntityPkey = 'shared_entity_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Shared_Entity_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Shared_Entity_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Shared_Entity_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "shared_entity" */
export type Shared_Entity_Inc_Input = {
  group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "shared_entity" */
export type Shared_Entity_Insert_Input = {
  advice_authors?: InputMaybe<Advice_Authors_Arr_Rel_Insert_Input>;
  article_authors?: InputMaybe<Article_Authors_Arr_Rel_Insert_Input>;
  article_crop_categories?: InputMaybe<Article_Crop_Categories_Arr_Rel_Insert_Input>;
  article_crop_varieties?: InputMaybe<Article_Crop_Varieties_Arr_Rel_Insert_Input>;
  article_crops?: InputMaybe<Article_Crops_Arr_Rel_Insert_Input>;
  article_regions?: InputMaybe<Article_Regions_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  group_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
  series_authors?: InputMaybe<Series_Authors_Arr_Rel_Insert_Input>;
  series_crops?: InputMaybe<Series_Crops_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shared_Entity_Max_Fields = {
  __typename?: 'shared_entity_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['bigint']>;
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Shared_Entity_Min_Fields = {
  __typename?: 'shared_entity_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['bigint']>;
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shared_entity" */
export type Shared_Entity_Mutation_Response = {
  __typename?: 'shared_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shared_Entity>;
};

/** input type for inserting object relation for remote table "shared_entity" */
export type Shared_Entity_Obj_Rel_Insert_Input = {
  data: Shared_Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shared_Entity_On_Conflict>;
};

/** on_conflict condition type for table "shared_entity" */
export type Shared_Entity_On_Conflict = {
  constraint: Shared_Entity_Constraint;
  update_columns?: Array<Shared_Entity_Update_Column>;
  where?: InputMaybe<Shared_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "shared_entity". */
export type Shared_Entity_Order_By = {
  advice_authors_aggregate?: InputMaybe<Advice_Authors_Aggregate_Order_By>;
  article_authors_aggregate?: InputMaybe<Article_Authors_Aggregate_Order_By>;
  article_crop_categories_aggregate?: InputMaybe<Article_Crop_Categories_Aggregate_Order_By>;
  article_crop_varieties_aggregate?: InputMaybe<Article_Crop_Varieties_Aggregate_Order_By>;
  article_crops_aggregate?: InputMaybe<Article_Crops_Aggregate_Order_By>;
  article_regions_aggregate?: InputMaybe<Article_Regions_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  series_authors_aggregate?: InputMaybe<Series_Authors_Aggregate_Order_By>;
  series_crops_aggregate?: InputMaybe<Series_Crops_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared_entity */
export type Shared_Entity_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Shared_Entity_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shared_entity" */
export enum Shared_Entity_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "shared_entity" */
export type Shared_Entity_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  group_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Shared_Entity_Stddev_Fields = {
  __typename?: 'shared_entity_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Shared_Entity_Stddev_Pop_Fields = {
  __typename?: 'shared_entity_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Shared_Entity_Stddev_Samp_Fields = {
  __typename?: 'shared_entity_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "shared_entity" */
export type Shared_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shared_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shared_Entity_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  group_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Shared_Entity_Sum_Fields = {
  __typename?: 'shared_entity_sum_fields';
  group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "shared_entity" */
export enum Shared_Entity_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Shared_Entity_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Shared_Entity_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Shared_Entity_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Shared_Entity_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Shared_Entity_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shared_Entity_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Shared_Entity_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shared_Entity_Set_Input>;
  where: Shared_Entity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shared_Entity_Var_Pop_Fields = {
  __typename?: 'shared_entity_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Shared_Entity_Var_Samp_Fields = {
  __typename?: 'shared_entity_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Shared_Entity_Variance_Fields = {
  __typename?: 'shared_entity_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "si_unit" */
export type Si_Unit = {
  __typename?: 'si_unit';
  base_conversion: Scalars['numeric'];
  /** An object relationship */
  base_unit?: Maybe<Si_Unit>;
  base_unit_id?: Maybe<Scalars['Int']>;
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  measure_of?: Maybe<Si_Unit_Measure>;
  measure_of_id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** aggregated selection of "si_unit" */
export type Si_Unit_Aggregate = {
  __typename?: 'si_unit_aggregate';
  aggregate?: Maybe<Si_Unit_Aggregate_Fields>;
  nodes: Array<Si_Unit>;
};

/** aggregate fields of "si_unit" */
export type Si_Unit_Aggregate_Fields = {
  __typename?: 'si_unit_aggregate_fields';
  avg?: Maybe<Si_Unit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Si_Unit_Max_Fields>;
  min?: Maybe<Si_Unit_Min_Fields>;
  stddev?: Maybe<Si_Unit_Stddev_Fields>;
  stddev_pop?: Maybe<Si_Unit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Si_Unit_Stddev_Samp_Fields>;
  sum?: Maybe<Si_Unit_Sum_Fields>;
  var_pop?: Maybe<Si_Unit_Var_Pop_Fields>;
  var_samp?: Maybe<Si_Unit_Var_Samp_Fields>;
  variance?: Maybe<Si_Unit_Variance_Fields>;
};


/** aggregate fields of "si_unit" */
export type Si_Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Si_Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Si_Unit_Avg_Fields = {
  __typename?: 'si_unit_avg_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Monitoring_Parameter_Unit_Choicesunit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Parameter_Unit_Choicesunit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Monitoring_Recordaggregated_Value_Unit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Recordaggregated_Value_Unit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Monitoring_Sampleunit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Monitoring_Sampleunit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Operations_Applied_Fertiliserquantity_Unit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Operations_Applied_Fertiliserquantity_Unit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Operations_Applied_Pesticidequantity_Unit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Operations_Applied_Pesticidequantity_Unit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Operations_Harvestquantity_Unit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Operations_Harvestquantity_Unit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Products_Fertiliser_Unitsunit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Products_Fertiliser_Unitsunit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Products_Pesticide_Unitsunit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Products_Pesticide_Unitsunit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Recommended_Productquantity_Unit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Recommended_Productquantity_Unit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Shared_Entitysi_Unit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitysi_Unit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Trade_Unitunit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Trade_Unitunit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "si_unit" */
export enum Si_Unit_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SiUnitCodenameKey = 'si_unit_codename_key',
  /** unique or primary key constraint on columns "id" */
  SiUnitPkey = 'si_unit_pkey'
}

/** input type for incrementing numeric columns in table "si_unit" */
export type Si_Unit_Inc_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  measure_of_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "si_unit" */
export type Si_Unit_Insert_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  base_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  measure_of?: InputMaybe<Si_Unit_Measure_Obj_Rel_Insert_Input>;
  measure_of_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Si_Unit_Max_Fields = {
  __typename?: 'si_unit_max_fields';
  base_conversion?: Maybe<Scalars['numeric']>;
  base_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  measure_of_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** columns and relationships of "si_unit_measure" */
export type Si_Unit_Measure = {
  __typename?: 'si_unit_measure';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "si_unit_measure" */
export type Si_Unit_Measure_Aggregate = {
  __typename?: 'si_unit_measure_aggregate';
  aggregate?: Maybe<Si_Unit_Measure_Aggregate_Fields>;
  nodes: Array<Si_Unit_Measure>;
};

/** aggregate fields of "si_unit_measure" */
export type Si_Unit_Measure_Aggregate_Fields = {
  __typename?: 'si_unit_measure_aggregate_fields';
  avg?: Maybe<Si_Unit_Measure_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Si_Unit_Measure_Max_Fields>;
  min?: Maybe<Si_Unit_Measure_Min_Fields>;
  stddev?: Maybe<Si_Unit_Measure_Stddev_Fields>;
  stddev_pop?: Maybe<Si_Unit_Measure_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Si_Unit_Measure_Stddev_Samp_Fields>;
  sum?: Maybe<Si_Unit_Measure_Sum_Fields>;
  var_pop?: Maybe<Si_Unit_Measure_Var_Pop_Fields>;
  var_samp?: Maybe<Si_Unit_Measure_Var_Samp_Fields>;
  variance?: Maybe<Si_Unit_Measure_Variance_Fields>;
};


/** aggregate fields of "si_unit_measure" */
export type Si_Unit_Measure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Si_Unit_Measure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Si_Unit_Measure_Avg_Fields = {
  __typename?: 'si_unit_measure_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "si_unit_measure". All fields are combined with a logical 'AND'. */
export type Si_Unit_Measure_Bool_Exp = {
  _and?: InputMaybe<Array<Si_Unit_Measure_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Measure_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "si_unit_measure" */
export enum Si_Unit_Measure_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SiUnitMeasureCodenameKey = 'si_unit_measure_codename_key',
  /** unique or primary key constraint on columns "id" */
  SiUnitMeasurePkey = 'si_unit_measure_pkey'
}

/** input type for incrementing numeric columns in table "si_unit_measure" */
export type Si_Unit_Measure_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "si_unit_measure" */
export type Si_Unit_Measure_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Si_Unit_Measure_Max_Fields = {
  __typename?: 'si_unit_measure_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Si_Unit_Measure_Min_Fields = {
  __typename?: 'si_unit_measure_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "si_unit_measure" */
export type Si_Unit_Measure_Mutation_Response = {
  __typename?: 'si_unit_measure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Si_Unit_Measure>;
};

/** input type for inserting object relation for remote table "si_unit_measure" */
export type Si_Unit_Measure_Obj_Rel_Insert_Input = {
  data: Si_Unit_Measure_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Si_Unit_Measure_On_Conflict>;
};

/** on_conflict condition type for table "si_unit_measure" */
export type Si_Unit_Measure_On_Conflict = {
  constraint: Si_Unit_Measure_Constraint;
  update_columns?: Array<Si_Unit_Measure_Update_Column>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};

/** Ordering options when selecting data from "si_unit_measure". */
export type Si_Unit_Measure_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: si_unit_measure */
export type Si_Unit_Measure_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "si_unit_measure" */
export enum Si_Unit_Measure_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "si_unit_measure" */
export type Si_Unit_Measure_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Si_Unit_Measure_Stddev_Fields = {
  __typename?: 'si_unit_measure_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Si_Unit_Measure_Stddev_Pop_Fields = {
  __typename?: 'si_unit_measure_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Si_Unit_Measure_Stddev_Samp_Fields = {
  __typename?: 'si_unit_measure_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "si_unit_measure" */
export type Si_Unit_Measure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Si_Unit_Measure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Si_Unit_Measure_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Si_Unit_Measure_Sum_Fields = {
  __typename?: 'si_unit_measure_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "si_unit_measure" */
export enum Si_Unit_Measure_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Si_Unit_Measure_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Si_Unit_Measure_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Si_Unit_Measure_Set_Input>;
  where: Si_Unit_Measure_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Si_Unit_Measure_Var_Pop_Fields = {
  __typename?: 'si_unit_measure_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Si_Unit_Measure_Var_Samp_Fields = {
  __typename?: 'si_unit_measure_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Si_Unit_Measure_Variance_Fields = {
  __typename?: 'si_unit_measure_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Si_Unit_Min_Fields = {
  __typename?: 'si_unit_min_fields';
  base_conversion?: Maybe<Scalars['numeric']>;
  base_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  measure_of_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "si_unit" */
export type Si_Unit_Mutation_Response = {
  __typename?: 'si_unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Si_Unit>;
};

/** input type for inserting object relation for remote table "si_unit" */
export type Si_Unit_Obj_Rel_Insert_Input = {
  data: Si_Unit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Si_Unit_On_Conflict>;
};

/** on_conflict condition type for table "si_unit" */
export type Si_Unit_On_Conflict = {
  constraint: Si_Unit_Constraint;
  update_columns?: Array<Si_Unit_Update_Column>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "si_unit". */
export type Si_Unit_Order_By = {
  base_conversion?: InputMaybe<Order_By>;
  base_unit?: InputMaybe<Si_Unit_Order_By>;
  base_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  measure_of?: InputMaybe<Si_Unit_Measure_Order_By>;
  measure_of_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: si_unit */
export type Si_Unit_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "si_unit" */
export enum Si_Unit_Select_Column {
  /** column name */
  BaseConversion = 'base_conversion',
  /** column name */
  BaseUnitId = 'base_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MeasureOfId = 'measure_of_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "si_unit" */
export type Si_Unit_Set_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  measure_of_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Si_Unit_Stddev_Fields = {
  __typename?: 'si_unit_stddev_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Si_Unit_Stddev_Pop_Fields = {
  __typename?: 'si_unit_stddev_pop_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Si_Unit_Stddev_Samp_Fields = {
  __typename?: 'si_unit_stddev_samp_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "si_unit" */
export type Si_Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Si_Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Si_Unit_Stream_Cursor_Value_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  measure_of_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Si_Unit_Sum_Fields = {
  __typename?: 'si_unit_sum_fields';
  base_conversion?: Maybe<Scalars['numeric']>;
  base_unit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  measure_of_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "si_unit" */
export enum Si_Unit_Update_Column {
  /** column name */
  BaseConversion = 'base_conversion',
  /** column name */
  BaseUnitId = 'base_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MeasureOfId = 'measure_of_id',
  /** column name */
  Name = 'name'
}

export type Si_Unit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Si_Unit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Si_Unit_Set_Input>;
  where: Si_Unit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Si_Unit_Var_Pop_Fields = {
  __typename?: 'si_unit_var_pop_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Si_Unit_Var_Samp_Fields = {
  __typename?: 'si_unit_var_samp_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Si_Unit_Variance_Fields = {
  __typename?: 'si_unit_variance_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sku" */
export type Sku = {
  __typename?: 'sku';
  capacity: Scalars['numeric'];
  /** An object relationship */
  capacity_unit: Si_Unit;
  capacity_unit_id: Scalars['Int'];
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  /** An object relationship */
  dimension_unit?: Maybe<Si_Unit>;
  dimension_unit_id?: Maybe<Scalars['Int']>;
  dimensions?: Maybe<Scalars['_numeric']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  self_weight: Scalars['numeric'];
  /** An object relationship */
  sku_kind: Sku_Kind;
  sku_kind_id: Scalars['Int'];
  unit_price: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "sku" */
export type Sku_Aggregate = {
  __typename?: 'sku_aggregate';
  aggregate?: Maybe<Sku_Aggregate_Fields>;
  nodes: Array<Sku>;
};

/** aggregate fields of "sku" */
export type Sku_Aggregate_Fields = {
  __typename?: 'sku_aggregate_fields';
  avg?: Maybe<Sku_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sku_Max_Fields>;
  min?: Maybe<Sku_Min_Fields>;
  stddev?: Maybe<Sku_Stddev_Fields>;
  stddev_pop?: Maybe<Sku_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sku_Stddev_Samp_Fields>;
  sum?: Maybe<Sku_Sum_Fields>;
  var_pop?: Maybe<Sku_Var_Pop_Fields>;
  var_samp?: Maybe<Sku_Var_Samp_Fields>;
  variance?: Maybe<Sku_Variance_Fields>;
};


/** aggregate fields of "sku" */
export type Sku_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sku_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sku_Avg_Fields = {
  __typename?: 'sku_avg_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sku". All fields are combined with a logical 'AND'. */
export type Sku_Bool_Exp = {
  _and?: InputMaybe<Array<Sku_Bool_Exp>>;
  _not?: InputMaybe<Sku_Bool_Exp>;
  _or?: InputMaybe<Array<Sku_Bool_Exp>>;
  capacity?: InputMaybe<Numeric_Comparison_Exp>;
  capacity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  capacity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dimension_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  dimension_unit_id?: InputMaybe<Int_Comparison_Exp>;
  dimensions?: InputMaybe<_Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  self_weight?: InputMaybe<Numeric_Comparison_Exp>;
  sku_kind?: InputMaybe<Sku_Kind_Bool_Exp>;
  sku_kind_id?: InputMaybe<Int_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "sku". All fields are combined with a logical 'AND'. */
export type Sku_Bool_Exp_Remote_Rel_Shared_Entitypackaging_Unit = {
  _and?: InputMaybe<Array<Sku_Bool_Exp>>;
  _not?: InputMaybe<Sku_Bool_Exp>;
  _or?: InputMaybe<Array<Sku_Bool_Exp>>;
  capacity?: InputMaybe<Numeric_Comparison_Exp>;
  capacity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  capacity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitypackaging_Unit>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dimension_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  dimension_unit_id?: InputMaybe<Int_Comparison_Exp>;
  dimensions?: InputMaybe<_Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  self_weight?: InputMaybe<Numeric_Comparison_Exp>;
  sku_kind?: InputMaybe<Sku_Kind_Bool_Exp>;
  sku_kind_id?: InputMaybe<Int_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sku" */
export enum Sku_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SkuCodenameKey = 'sku_codename_key',
  /** unique or primary key constraint on columns "id" */
  SkuPkey = 'sku_pkey'
}

/** input type for incrementing numeric columns in table "sku" */
export type Sku_Inc_Input = {
  capacity?: InputMaybe<Scalars['numeric']>;
  capacity_unit_id?: InputMaybe<Scalars['Int']>;
  dimension_unit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  self_weight?: InputMaybe<Scalars['numeric']>;
  sku_kind_id?: InputMaybe<Scalars['Int']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "sku" */
export type Sku_Insert_Input = {
  capacity?: InputMaybe<Scalars['numeric']>;
  capacity_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  capacity_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  dimension_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  dimension_unit_id?: InputMaybe<Scalars['Int']>;
  dimensions?: InputMaybe<Scalars['_numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  self_weight?: InputMaybe<Scalars['numeric']>;
  sku_kind?: InputMaybe<Sku_Kind_Obj_Rel_Insert_Input>;
  sku_kind_id?: InputMaybe<Scalars['Int']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "sku_kind" */
export type Sku_Kind = {
  __typename?: 'sku_kind';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "sku_kind" */
export type Sku_Kind_Aggregate = {
  __typename?: 'sku_kind_aggregate';
  aggregate?: Maybe<Sku_Kind_Aggregate_Fields>;
  nodes: Array<Sku_Kind>;
};

/** aggregate fields of "sku_kind" */
export type Sku_Kind_Aggregate_Fields = {
  __typename?: 'sku_kind_aggregate_fields';
  avg?: Maybe<Sku_Kind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sku_Kind_Max_Fields>;
  min?: Maybe<Sku_Kind_Min_Fields>;
  stddev?: Maybe<Sku_Kind_Stddev_Fields>;
  stddev_pop?: Maybe<Sku_Kind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sku_Kind_Stddev_Samp_Fields>;
  sum?: Maybe<Sku_Kind_Sum_Fields>;
  var_pop?: Maybe<Sku_Kind_Var_Pop_Fields>;
  var_samp?: Maybe<Sku_Kind_Var_Samp_Fields>;
  variance?: Maybe<Sku_Kind_Variance_Fields>;
};


/** aggregate fields of "sku_kind" */
export type Sku_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sku_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sku_Kind_Avg_Fields = {
  __typename?: 'sku_kind_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sku_kind". All fields are combined with a logical 'AND'. */
export type Sku_Kind_Bool_Exp = {
  _and?: InputMaybe<Array<Sku_Kind_Bool_Exp>>;
  _not?: InputMaybe<Sku_Kind_Bool_Exp>;
  _or?: InputMaybe<Array<Sku_Kind_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sku_kind" */
export enum Sku_Kind_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SkuKindCodenameKey = 'sku_kind_codename_key',
  /** unique or primary key constraint on columns "id" */
  SkuKindPkey = 'sku_kind_pkey'
}

/** input type for incrementing numeric columns in table "sku_kind" */
export type Sku_Kind_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sku_kind" */
export type Sku_Kind_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Sku_Kind_Max_Fields = {
  __typename?: 'sku_kind_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Sku_Kind_Min_Fields = {
  __typename?: 'sku_kind_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "sku_kind" */
export type Sku_Kind_Mutation_Response = {
  __typename?: 'sku_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sku_Kind>;
};

/** input type for inserting object relation for remote table "sku_kind" */
export type Sku_Kind_Obj_Rel_Insert_Input = {
  data: Sku_Kind_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sku_Kind_On_Conflict>;
};

/** on_conflict condition type for table "sku_kind" */
export type Sku_Kind_On_Conflict = {
  constraint: Sku_Kind_Constraint;
  update_columns?: Array<Sku_Kind_Update_Column>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};

/** Ordering options when selecting data from "sku_kind". */
export type Sku_Kind_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sku_kind */
export type Sku_Kind_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sku_kind" */
export enum Sku_Kind_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "sku_kind" */
export type Sku_Kind_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Sku_Kind_Stddev_Fields = {
  __typename?: 'sku_kind_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sku_Kind_Stddev_Pop_Fields = {
  __typename?: 'sku_kind_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sku_Kind_Stddev_Samp_Fields = {
  __typename?: 'sku_kind_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sku_kind" */
export type Sku_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sku_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sku_Kind_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Sku_Kind_Sum_Fields = {
  __typename?: 'sku_kind_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "sku_kind" */
export enum Sku_Kind_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Sku_Kind_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sku_Kind_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sku_Kind_Set_Input>;
  where: Sku_Kind_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sku_Kind_Var_Pop_Fields = {
  __typename?: 'sku_kind_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sku_Kind_Var_Samp_Fields = {
  __typename?: 'sku_kind_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sku_Kind_Variance_Fields = {
  __typename?: 'sku_kind_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Sku_Max_Fields = {
  __typename?: 'sku_max_fields';
  capacity?: Maybe<Scalars['numeric']>;
  capacity_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  dimension_unit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  self_weight?: Maybe<Scalars['numeric']>;
  sku_kind_id?: Maybe<Scalars['Int']>;
  unit_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Sku_Min_Fields = {
  __typename?: 'sku_min_fields';
  capacity?: Maybe<Scalars['numeric']>;
  capacity_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  dimension_unit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  self_weight?: Maybe<Scalars['numeric']>;
  sku_kind_id?: Maybe<Scalars['Int']>;
  unit_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "sku" */
export type Sku_Mutation_Response = {
  __typename?: 'sku_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sku>;
};

/** input type for inserting object relation for remote table "sku" */
export type Sku_Obj_Rel_Insert_Input = {
  data: Sku_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sku_On_Conflict>;
};

/** on_conflict condition type for table "sku" */
export type Sku_On_Conflict = {
  constraint: Sku_Constraint;
  update_columns?: Array<Sku_Update_Column>;
  where?: InputMaybe<Sku_Bool_Exp>;
};

/** Ordering options when selecting data from "sku". */
export type Sku_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit?: InputMaybe<Si_Unit_Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dimension_unit?: InputMaybe<Si_Unit_Order_By>;
  dimension_unit_id?: InputMaybe<Order_By>;
  dimensions?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  self_weight?: InputMaybe<Order_By>;
  sku_kind?: InputMaybe<Sku_Kind_Order_By>;
  sku_kind_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sku */
export type Sku_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sku" */
export enum Sku_Select_Column {
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CapacityUnitId = 'capacity_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DimensionUnitId = 'dimension_unit_id',
  /** column name */
  Dimensions = 'dimensions',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  SelfWeight = 'self_weight',
  /** column name */
  SkuKindId = 'sku_kind_id',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sku" */
export type Sku_Set_Input = {
  capacity?: InputMaybe<Scalars['numeric']>;
  capacity_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  dimension_unit_id?: InputMaybe<Scalars['Int']>;
  dimensions?: InputMaybe<Scalars['_numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  self_weight?: InputMaybe<Scalars['numeric']>;
  sku_kind_id?: InputMaybe<Scalars['Int']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Sku_Stddev_Fields = {
  __typename?: 'sku_stddev_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sku_Stddev_Pop_Fields = {
  __typename?: 'sku_stddev_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sku_Stddev_Samp_Fields = {
  __typename?: 'sku_stddev_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sku" */
export type Sku_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sku_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sku_Stream_Cursor_Value_Input = {
  capacity?: InputMaybe<Scalars['numeric']>;
  capacity_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  dimension_unit_id?: InputMaybe<Scalars['Int']>;
  dimensions?: InputMaybe<Scalars['_numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  self_weight?: InputMaybe<Scalars['numeric']>;
  sku_kind_id?: InputMaybe<Scalars['Int']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Sku_Sum_Fields = {
  __typename?: 'sku_sum_fields';
  capacity?: Maybe<Scalars['numeric']>;
  capacity_unit_id?: Maybe<Scalars['Int']>;
  dimension_unit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  self_weight?: Maybe<Scalars['numeric']>;
  sku_kind_id?: Maybe<Scalars['Int']>;
  unit_price?: Maybe<Scalars['numeric']>;
};

/** update columns of table "sku" */
export enum Sku_Update_Column {
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CapacityUnitId = 'capacity_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DimensionUnitId = 'dimension_unit_id',
  /** column name */
  Dimensions = 'dimensions',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  SelfWeight = 'self_weight',
  /** column name */
  SkuKindId = 'sku_kind_id',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sku_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sku_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sku_Set_Input>;
  where: Sku_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sku_Var_Pop_Fields = {
  __typename?: 'sku_var_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sku_Var_Samp_Fields = {
  __typename?: 'sku_var_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sku_Variance_Fields = {
  __typename?: 'sku_variance_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "soil" */
export type Soil = {
  __typename?: 'soil';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  photo_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "soil" */
export type Soil_Aggregate = {
  __typename?: 'soil_aggregate';
  aggregate?: Maybe<Soil_Aggregate_Fields>;
  nodes: Array<Soil>;
};

/** aggregate fields of "soil" */
export type Soil_Aggregate_Fields = {
  __typename?: 'soil_aggregate_fields';
  avg?: Maybe<Soil_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Soil_Max_Fields>;
  min?: Maybe<Soil_Min_Fields>;
  stddev?: Maybe<Soil_Stddev_Fields>;
  stddev_pop?: Maybe<Soil_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Soil_Stddev_Samp_Fields>;
  sum?: Maybe<Soil_Sum_Fields>;
  var_pop?: Maybe<Soil_Var_Pop_Fields>;
  var_samp?: Maybe<Soil_Var_Samp_Fields>;
  variance?: Maybe<Soil_Variance_Fields>;
};


/** aggregate fields of "soil" */
export type Soil_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Soil_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Soil_Avg_Fields = {
  __typename?: 'soil_avg_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "soil". All fields are combined with a logical 'AND'. */
export type Soil_Bool_Exp = {
  _and?: InputMaybe<Array<Soil_Bool_Exp>>;
  _not?: InputMaybe<Soil_Bool_Exp>;
  _or?: InputMaybe<Array<Soil_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "soil" */
export enum Soil_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SoilCodenameKey = 'soil_codename_key',
  /** unique or primary key constraint on columns "id" */
  SoilPkey = 'soil_pkey'
}

/** input type for incrementing numeric columns in table "soil" */
export type Soil_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "soil" */
export type Soil_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Soil_Max_Fields = {
  __typename?: 'soil_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Soil_Min_Fields = {
  __typename?: 'soil_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "soil" */
export type Soil_Mutation_Response = {
  __typename?: 'soil_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Soil>;
};

/** input type for inserting object relation for remote table "soil" */
export type Soil_Obj_Rel_Insert_Input = {
  data: Soil_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Soil_On_Conflict>;
};

/** on_conflict condition type for table "soil" */
export type Soil_On_Conflict = {
  constraint: Soil_Constraint;
  update_columns?: Array<Soil_Update_Column>;
  where?: InputMaybe<Soil_Bool_Exp>;
};

/** Ordering options when selecting data from "soil". */
export type Soil_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: soil */
export type Soil_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "soil" */
export enum Soil_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

/** input type for updating data in table "soil" */
export type Soil_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Soil_Stddev_Fields = {
  __typename?: 'soil_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Soil_Stddev_Pop_Fields = {
  __typename?: 'soil_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Soil_Stddev_Samp_Fields = {
  __typename?: 'soil_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "soil" */
export type Soil_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Soil_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Soil_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Soil_Sum_Fields = {
  __typename?: 'soil_sum_fields';
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "soil" */
export enum Soil_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

export type Soil_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Soil_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Soil_Set_Input>;
  where: Soil_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Soil_Var_Pop_Fields = {
  __typename?: 'soil_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Soil_Var_Samp_Fields = {
  __typename?: 'soil_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Soil_Variance_Fields = {
  __typename?: 'soil_variance_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System = {
  __typename?: 'sprinkler_irrigation_system';
  /** An object relationship */
  irrigation_system: Irrigation_System;
  irrigationsystem_ptr_id: Scalars['uuid'];
  lateral_spacing: Scalars['float8'];
  number_of_laterals: Scalars['Int'];
  number_of_sprinklers: Scalars['Int'];
  sprinkler_capacity: Scalars['float8'];
  sprinkler_spacing: Scalars['float8'];
};

/** aggregated selection of "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System_Aggregate = {
  __typename?: 'sprinkler_irrigation_system_aggregate';
  aggregate?: Maybe<Sprinkler_Irrigation_System_Aggregate_Fields>;
  nodes: Array<Sprinkler_Irrigation_System>;
};

/** aggregate fields of "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System_Aggregate_Fields = {
  __typename?: 'sprinkler_irrigation_system_aggregate_fields';
  avg?: Maybe<Sprinkler_Irrigation_System_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sprinkler_Irrigation_System_Max_Fields>;
  min?: Maybe<Sprinkler_Irrigation_System_Min_Fields>;
  stddev?: Maybe<Sprinkler_Irrigation_System_Stddev_Fields>;
  stddev_pop?: Maybe<Sprinkler_Irrigation_System_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sprinkler_Irrigation_System_Stddev_Samp_Fields>;
  sum?: Maybe<Sprinkler_Irrigation_System_Sum_Fields>;
  var_pop?: Maybe<Sprinkler_Irrigation_System_Var_Pop_Fields>;
  var_samp?: Maybe<Sprinkler_Irrigation_System_Var_Samp_Fields>;
  variance?: Maybe<Sprinkler_Irrigation_System_Variance_Fields>;
};


/** aggregate fields of "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sprinkler_Irrigation_System_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sprinkler_Irrigation_System_Avg_Fields = {
  __typename?: 'sprinkler_irrigation_system_avg_fields';
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  number_of_sprinklers?: Maybe<Scalars['Float']>;
  sprinkler_capacity?: Maybe<Scalars['Float']>;
  sprinkler_spacing?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sprinkler_irrigation_system". All fields are combined with a logical 'AND'. */
export type Sprinkler_Irrigation_System_Bool_Exp = {
  _and?: InputMaybe<Array<Sprinkler_Irrigation_System_Bool_Exp>>;
  _not?: InputMaybe<Sprinkler_Irrigation_System_Bool_Exp>;
  _or?: InputMaybe<Array<Sprinkler_Irrigation_System_Bool_Exp>>;
  irrigation_system?: InputMaybe<Irrigation_System_Bool_Exp>;
  irrigationsystem_ptr_id?: InputMaybe<Uuid_Comparison_Exp>;
  lateral_spacing?: InputMaybe<Float8_Comparison_Exp>;
  number_of_laterals?: InputMaybe<Int_Comparison_Exp>;
  number_of_sprinklers?: InputMaybe<Int_Comparison_Exp>;
  sprinkler_capacity?: InputMaybe<Float8_Comparison_Exp>;
  sprinkler_spacing?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "sprinkler_irrigation_system" */
export enum Sprinkler_Irrigation_System_Constraint {
  /** unique or primary key constraint on columns "irrigationsystem_ptr_id" */
  SprinklerIrrigationSystemPkey = 'sprinkler_irrigation_system_pkey'
}

/** input type for incrementing numeric columns in table "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System_Inc_Input = {
  lateral_spacing?: InputMaybe<Scalars['float8']>;
  number_of_laterals?: InputMaybe<Scalars['Int']>;
  number_of_sprinklers?: InputMaybe<Scalars['Int']>;
  sprinkler_capacity?: InputMaybe<Scalars['float8']>;
  sprinkler_spacing?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System_Insert_Input = {
  irrigation_system?: InputMaybe<Irrigation_System_Obj_Rel_Insert_Input>;
  irrigationsystem_ptr_id?: InputMaybe<Scalars['uuid']>;
  lateral_spacing?: InputMaybe<Scalars['float8']>;
  number_of_laterals?: InputMaybe<Scalars['Int']>;
  number_of_sprinklers?: InputMaybe<Scalars['Int']>;
  sprinkler_capacity?: InputMaybe<Scalars['float8']>;
  sprinkler_spacing?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Sprinkler_Irrigation_System_Max_Fields = {
  __typename?: 'sprinkler_irrigation_system_max_fields';
  irrigationsystem_ptr_id?: Maybe<Scalars['uuid']>;
  lateral_spacing?: Maybe<Scalars['float8']>;
  number_of_laterals?: Maybe<Scalars['Int']>;
  number_of_sprinklers?: Maybe<Scalars['Int']>;
  sprinkler_capacity?: Maybe<Scalars['float8']>;
  sprinkler_spacing?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Sprinkler_Irrigation_System_Min_Fields = {
  __typename?: 'sprinkler_irrigation_system_min_fields';
  irrigationsystem_ptr_id?: Maybe<Scalars['uuid']>;
  lateral_spacing?: Maybe<Scalars['float8']>;
  number_of_laterals?: Maybe<Scalars['Int']>;
  number_of_sprinklers?: Maybe<Scalars['Int']>;
  sprinkler_capacity?: Maybe<Scalars['float8']>;
  sprinkler_spacing?: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System_Mutation_Response = {
  __typename?: 'sprinkler_irrigation_system_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sprinkler_Irrigation_System>;
};

/** input type for inserting object relation for remote table "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System_Obj_Rel_Insert_Input = {
  data: Sprinkler_Irrigation_System_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sprinkler_Irrigation_System_On_Conflict>;
};

/** on_conflict condition type for table "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System_On_Conflict = {
  constraint: Sprinkler_Irrigation_System_Constraint;
  update_columns?: Array<Sprinkler_Irrigation_System_Update_Column>;
  where?: InputMaybe<Sprinkler_Irrigation_System_Bool_Exp>;
};

/** Ordering options when selecting data from "sprinkler_irrigation_system". */
export type Sprinkler_Irrigation_System_Order_By = {
  irrigation_system?: InputMaybe<Irrigation_System_Order_By>;
  irrigationsystem_ptr_id?: InputMaybe<Order_By>;
  lateral_spacing?: InputMaybe<Order_By>;
  number_of_laterals?: InputMaybe<Order_By>;
  number_of_sprinklers?: InputMaybe<Order_By>;
  sprinkler_capacity?: InputMaybe<Order_By>;
  sprinkler_spacing?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sprinkler_irrigation_system */
export type Sprinkler_Irrigation_System_Pk_Columns_Input = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};

/** select columns of table "sprinkler_irrigation_system" */
export enum Sprinkler_Irrigation_System_Select_Column {
  /** column name */
  IrrigationsystemPtrId = 'irrigationsystem_ptr_id',
  /** column name */
  LateralSpacing = 'lateral_spacing',
  /** column name */
  NumberOfLaterals = 'number_of_laterals',
  /** column name */
  NumberOfSprinklers = 'number_of_sprinklers',
  /** column name */
  SprinklerCapacity = 'sprinkler_capacity',
  /** column name */
  SprinklerSpacing = 'sprinkler_spacing'
}

/** input type for updating data in table "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System_Set_Input = {
  irrigationsystem_ptr_id?: InputMaybe<Scalars['uuid']>;
  lateral_spacing?: InputMaybe<Scalars['float8']>;
  number_of_laterals?: InputMaybe<Scalars['Int']>;
  number_of_sprinklers?: InputMaybe<Scalars['Int']>;
  sprinkler_capacity?: InputMaybe<Scalars['float8']>;
  sprinkler_spacing?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Sprinkler_Irrigation_System_Stddev_Fields = {
  __typename?: 'sprinkler_irrigation_system_stddev_fields';
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  number_of_sprinklers?: Maybe<Scalars['Float']>;
  sprinkler_capacity?: Maybe<Scalars['Float']>;
  sprinkler_spacing?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sprinkler_Irrigation_System_Stddev_Pop_Fields = {
  __typename?: 'sprinkler_irrigation_system_stddev_pop_fields';
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  number_of_sprinklers?: Maybe<Scalars['Float']>;
  sprinkler_capacity?: Maybe<Scalars['Float']>;
  sprinkler_spacing?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sprinkler_Irrigation_System_Stddev_Samp_Fields = {
  __typename?: 'sprinkler_irrigation_system_stddev_samp_fields';
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  number_of_sprinklers?: Maybe<Scalars['Float']>;
  sprinkler_capacity?: Maybe<Scalars['Float']>;
  sprinkler_spacing?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sprinkler_irrigation_system" */
export type Sprinkler_Irrigation_System_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sprinkler_Irrigation_System_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sprinkler_Irrigation_System_Stream_Cursor_Value_Input = {
  irrigationsystem_ptr_id?: InputMaybe<Scalars['uuid']>;
  lateral_spacing?: InputMaybe<Scalars['float8']>;
  number_of_laterals?: InputMaybe<Scalars['Int']>;
  number_of_sprinklers?: InputMaybe<Scalars['Int']>;
  sprinkler_capacity?: InputMaybe<Scalars['float8']>;
  sprinkler_spacing?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Sprinkler_Irrigation_System_Sum_Fields = {
  __typename?: 'sprinkler_irrigation_system_sum_fields';
  lateral_spacing?: Maybe<Scalars['float8']>;
  number_of_laterals?: Maybe<Scalars['Int']>;
  number_of_sprinklers?: Maybe<Scalars['Int']>;
  sprinkler_capacity?: Maybe<Scalars['float8']>;
  sprinkler_spacing?: Maybe<Scalars['float8']>;
};

/** update columns of table "sprinkler_irrigation_system" */
export enum Sprinkler_Irrigation_System_Update_Column {
  /** column name */
  IrrigationsystemPtrId = 'irrigationsystem_ptr_id',
  /** column name */
  LateralSpacing = 'lateral_spacing',
  /** column name */
  NumberOfLaterals = 'number_of_laterals',
  /** column name */
  NumberOfSprinklers = 'number_of_sprinklers',
  /** column name */
  SprinklerCapacity = 'sprinkler_capacity',
  /** column name */
  SprinklerSpacing = 'sprinkler_spacing'
}

export type Sprinkler_Irrigation_System_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sprinkler_Irrigation_System_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sprinkler_Irrigation_System_Set_Input>;
  where: Sprinkler_Irrigation_System_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sprinkler_Irrigation_System_Var_Pop_Fields = {
  __typename?: 'sprinkler_irrigation_system_var_pop_fields';
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  number_of_sprinklers?: Maybe<Scalars['Float']>;
  sprinkler_capacity?: Maybe<Scalars['Float']>;
  sprinkler_spacing?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sprinkler_Irrigation_System_Var_Samp_Fields = {
  __typename?: 'sprinkler_irrigation_system_var_samp_fields';
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  number_of_sprinklers?: Maybe<Scalars['Float']>;
  sprinkler_capacity?: Maybe<Scalars['Float']>;
  sprinkler_spacing?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sprinkler_Irrigation_System_Variance_Fields = {
  __typename?: 'sprinkler_irrigation_system_variance_fields';
  lateral_spacing?: Maybe<Scalars['Float']>;
  number_of_laterals?: Maybe<Scalars['Float']>;
  number_of_sprinklers?: Maybe<Scalars['Float']>;
  sprinkler_capacity?: Maybe<Scalars['Float']>;
  sprinkler_spacing?: Maybe<Scalars['Float']>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

/** columns and relationships of "sub_section" */
export type Sub_Section = {
  __typename?: 'sub_section';
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  product_subsections: Array<Product_Subsection>;
  /** An aggregate relationship */
  product_subsections_aggregate: Product_Subsection_Aggregate;
};


/** columns and relationships of "sub_section" */
export type Sub_SectionProduct_SubsectionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Order_By>>;
  where?: InputMaybe<Product_Subsection_Bool_Exp>;
};


/** columns and relationships of "sub_section" */
export type Sub_SectionProduct_Subsections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Order_By>>;
  where?: InputMaybe<Product_Subsection_Bool_Exp>;
};

/** aggregated selection of "sub_section" */
export type Sub_Section_Aggregate = {
  __typename?: 'sub_section_aggregate';
  aggregate?: Maybe<Sub_Section_Aggregate_Fields>;
  nodes: Array<Sub_Section>;
};

/** aggregate fields of "sub_section" */
export type Sub_Section_Aggregate_Fields = {
  __typename?: 'sub_section_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Sub_Section_Max_Fields>;
  min?: Maybe<Sub_Section_Min_Fields>;
};


/** aggregate fields of "sub_section" */
export type Sub_Section_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sub_Section_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "sub_section". All fields are combined with a logical 'AND'. */
export type Sub_Section_Bool_Exp = {
  _and?: InputMaybe<Array<Sub_Section_Bool_Exp>>;
  _not?: InputMaybe<Sub_Section_Bool_Exp>;
  _or?: InputMaybe<Array<Sub_Section_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  product_subsections?: InputMaybe<Product_Subsection_Bool_Exp>;
};

/** unique or primary key constraints on table "sub_section" */
export enum Sub_Section_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubSectionPkey = 'sub_section_pkey'
}

/** input type for inserting data into table "sub_section" */
export type Sub_Section_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  product_subsections?: InputMaybe<Product_Subsection_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Sub_Section_Max_Fields = {
  __typename?: 'sub_section_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Sub_Section_Min_Fields = {
  __typename?: 'sub_section_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "sub_section" */
export type Sub_Section_Mutation_Response = {
  __typename?: 'sub_section_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sub_Section>;
};

/** input type for inserting object relation for remote table "sub_section" */
export type Sub_Section_Obj_Rel_Insert_Input = {
  data: Sub_Section_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sub_Section_On_Conflict>;
};

/** on_conflict condition type for table "sub_section" */
export type Sub_Section_On_Conflict = {
  constraint: Sub_Section_Constraint;
  update_columns?: Array<Sub_Section_Update_Column>;
  where?: InputMaybe<Sub_Section_Bool_Exp>;
};

/** Ordering options when selecting data from "sub_section". */
export type Sub_Section_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_subsections_aggregate?: InputMaybe<Product_Subsection_Aggregate_Order_By>;
};

/** primary key columns input for table: sub_section */
export type Sub_Section_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sub_section" */
export enum Sub_Section_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "sub_section" */
export type Sub_Section_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "sub_section" */
export type Sub_Section_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sub_Section_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sub_Section_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "sub_section" */
export enum Sub_Section_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Sub_Section_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sub_Section_Set_Input>;
  where: Sub_Section_Bool_Exp;
};

/** columns and relationships of "subcategory" */
export type Subcategory = {
  __typename?: 'subcategory';
  attachment_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  category: Category;
  category_id: Scalars['uuid'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['smallint'];
  /** An object relationship */
  photo?: Maybe<Common_Fileupload>;
  /** An array relationship */
  products: Array<Product>;
  /** An aggregate relationship */
  products_aggregate: Product_Aggregate;
};


/** columns and relationships of "subcategory" */
export type SubcategoryProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "subcategory" */
export type SubcategoryProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "subcategory" */
export type Subcategory_Aggregate = {
  __typename?: 'subcategory_aggregate';
  aggregate?: Maybe<Subcategory_Aggregate_Fields>;
  nodes: Array<Subcategory>;
};

/** aggregate fields of "subcategory" */
export type Subcategory_Aggregate_Fields = {
  __typename?: 'subcategory_aggregate_fields';
  avg?: Maybe<Subcategory_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subcategory_Max_Fields>;
  min?: Maybe<Subcategory_Min_Fields>;
  stddev?: Maybe<Subcategory_Stddev_Fields>;
  stddev_pop?: Maybe<Subcategory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subcategory_Stddev_Samp_Fields>;
  sum?: Maybe<Subcategory_Sum_Fields>;
  var_pop?: Maybe<Subcategory_Var_Pop_Fields>;
  var_samp?: Maybe<Subcategory_Var_Samp_Fields>;
  variance?: Maybe<Subcategory_Variance_Fields>;
};


/** aggregate fields of "subcategory" */
export type Subcategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subcategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subcategory" */
export type Subcategory_Aggregate_Order_By = {
  avg?: InputMaybe<Subcategory_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subcategory_Max_Order_By>;
  min?: InputMaybe<Subcategory_Min_Order_By>;
  stddev?: InputMaybe<Subcategory_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subcategory_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subcategory_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subcategory_Sum_Order_By>;
  var_pop?: InputMaybe<Subcategory_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subcategory_Var_Samp_Order_By>;
  variance?: InputMaybe<Subcategory_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subcategory" */
export type Subcategory_Arr_Rel_Insert_Input = {
  data: Array<Subcategory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subcategory_On_Conflict>;
};

/** aggregate avg on columns */
export type Subcategory_Avg_Fields = {
  __typename?: 'subcategory_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "subcategory" */
export type Subcategory_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subcategory". All fields are combined with a logical 'AND'. */
export type Subcategory_Bool_Exp = {
  _and?: InputMaybe<Array<Subcategory_Bool_Exp>>;
  _not?: InputMaybe<Subcategory_Bool_Exp>;
  _or?: InputMaybe<Array<Subcategory_Bool_Exp>>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  category?: InputMaybe<Category_Bool_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  photo?: InputMaybe<Common_Fileupload_Bool_Exp>;
  products?: InputMaybe<Product_Bool_Exp>;
};

/** unique or primary key constraints on table "subcategory" */
export enum Subcategory_Constraint {
  /** unique or primary key constraint on columns "name", "category_id" */
  SubcategoryCategoryIdName_234576c6Uniq = 'subcategory_category_id_name_234576c6_uniq',
  /** unique or primary key constraint on columns "id" */
  SubcategoryPkey = 'subcategory_pkey'
}

/** input type for incrementing numeric columns in table "subcategory" */
export type Subcategory_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "subcategory" */
export type Subcategory_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  photo?: InputMaybe<Common_Fileupload_Obj_Rel_Insert_Input>;
  products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Subcategory_Max_Fields = {
  __typename?: 'subcategory_max_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  category_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by max() on columns of table "subcategory" */
export type Subcategory_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subcategory_Min_Fields = {
  __typename?: 'subcategory_min_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  category_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by min() on columns of table "subcategory" */
export type Subcategory_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subcategory" */
export type Subcategory_Mutation_Response = {
  __typename?: 'subcategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subcategory>;
};

/** input type for inserting object relation for remote table "subcategory" */
export type Subcategory_Obj_Rel_Insert_Input = {
  data: Subcategory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subcategory_On_Conflict>;
};

/** on_conflict condition type for table "subcategory" */
export type Subcategory_On_Conflict = {
  constraint: Subcategory_Constraint;
  update_columns?: Array<Subcategory_Update_Column>;
  where?: InputMaybe<Subcategory_Bool_Exp>;
};

/** Ordering options when selecting data from "subcategory". */
export type Subcategory_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  photo?: InputMaybe<Common_Fileupload_Order_By>;
  products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
};

/** primary key columns input for table: subcategory */
export type Subcategory_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "subcategory" */
export enum Subcategory_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "subcategory" */
export type Subcategory_Set_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type Subcategory_Stddev_Fields = {
  __typename?: 'subcategory_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "subcategory" */
export type Subcategory_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subcategory_Stddev_Pop_Fields = {
  __typename?: 'subcategory_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "subcategory" */
export type Subcategory_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subcategory_Stddev_Samp_Fields = {
  __typename?: 'subcategory_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "subcategory" */
export type Subcategory_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subcategory" */
export type Subcategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subcategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subcategory_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  category_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type Subcategory_Sum_Fields = {
  __typename?: 'subcategory_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "subcategory" */
export type Subcategory_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "subcategory" */
export enum Subcategory_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order'
}

export type Subcategory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subcategory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subcategory_Set_Input>;
  where: Subcategory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subcategory_Var_Pop_Fields = {
  __typename?: 'subcategory_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "subcategory" */
export type Subcategory_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subcategory_Var_Samp_Fields = {
  __typename?: 'subcategory_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "subcategory" */
export type Subcategory_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subcategory_Variance_Fields = {
  __typename?: 'subcategory_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "subcategory" */
export type Subcategory_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "subscription_package_highlights" */
export type Subscription_Package_Highlights = {
  __typename?: 'subscription_package_highlights';
  /** An object relationship */
  article_subscription_package: Article_Subscription_Package;
  highlight: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  order: Scalars['Int'];
  subscription_package_id: Scalars['uuid'];
};

/** aggregated selection of "subscription_package_highlights" */
export type Subscription_Package_Highlights_Aggregate = {
  __typename?: 'subscription_package_highlights_aggregate';
  aggregate?: Maybe<Subscription_Package_Highlights_Aggregate_Fields>;
  nodes: Array<Subscription_Package_Highlights>;
};

/** aggregate fields of "subscription_package_highlights" */
export type Subscription_Package_Highlights_Aggregate_Fields = {
  __typename?: 'subscription_package_highlights_aggregate_fields';
  avg?: Maybe<Subscription_Package_Highlights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscription_Package_Highlights_Max_Fields>;
  min?: Maybe<Subscription_Package_Highlights_Min_Fields>;
  stddev?: Maybe<Subscription_Package_Highlights_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Package_Highlights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Package_Highlights_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Package_Highlights_Sum_Fields>;
  var_pop?: Maybe<Subscription_Package_Highlights_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Package_Highlights_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Package_Highlights_Variance_Fields>;
};


/** aggregate fields of "subscription_package_highlights" */
export type Subscription_Package_Highlights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Package_Highlights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Aggregate_Order_By = {
  avg?: InputMaybe<Subscription_Package_Highlights_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Package_Highlights_Max_Order_By>;
  min?: InputMaybe<Subscription_Package_Highlights_Min_Order_By>;
  stddev?: InputMaybe<Subscription_Package_Highlights_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscription_Package_Highlights_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscription_Package_Highlights_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscription_Package_Highlights_Sum_Order_By>;
  var_pop?: InputMaybe<Subscription_Package_Highlights_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscription_Package_Highlights_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscription_Package_Highlights_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Package_Highlights_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Package_Highlights_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscription_Package_Highlights_Avg_Fields = {
  __typename?: 'subscription_package_highlights_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscription_package_highlights". All fields are combined with a logical 'AND'. */
export type Subscription_Package_Highlights_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Package_Highlights_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Package_Highlights_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Package_Highlights_Bool_Exp>>;
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
  highlight?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  subscription_package_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_package_highlights" */
export enum Subscription_Package_Highlights_Constraint {
  /** unique or primary key constraint on columns "subscription_package_id", "highlight" */
  SubscriptionPackageHigSubscriptionPackageIdA0791efdUniq = 'subscription_package_hig_subscription_package_id__a0791efd_uniq',
  /** unique or primary key constraint on columns "id" */
  SubscriptionPackageHighlightsPkey = 'subscription_package_highlights_pkey'
}

/** input type for incrementing numeric columns in table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Insert_Input = {
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Obj_Rel_Insert_Input>;
  highlight?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Subscription_Package_Highlights_Max_Fields = {
  __typename?: 'subscription_package_highlights_max_fields';
  highlight?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  subscription_package_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Max_Order_By = {
  highlight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Package_Highlights_Min_Fields = {
  __typename?: 'subscription_package_highlights_min_fields';
  highlight?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  subscription_package_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Min_Order_By = {
  highlight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Mutation_Response = {
  __typename?: 'subscription_package_highlights_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Package_Highlights>;
};

/** on_conflict condition type for table "subscription_package_highlights" */
export type Subscription_Package_Highlights_On_Conflict = {
  constraint: Subscription_Package_Highlights_Constraint;
  update_columns?: Array<Subscription_Package_Highlights_Update_Column>;
  where?: InputMaybe<Subscription_Package_Highlights_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_package_highlights". */
export type Subscription_Package_Highlights_Order_By = {
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Order_By>;
  highlight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_package_highlights */
export type Subscription_Package_Highlights_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "subscription_package_highlights" */
export enum Subscription_Package_Highlights_Select_Column {
  /** column name */
  Highlight = 'highlight',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  SubscriptionPackageId = 'subscription_package_id'
}

/** input type for updating data in table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Set_Input = {
  highlight?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Subscription_Package_Highlights_Stddev_Fields = {
  __typename?: 'subscription_package_highlights_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Package_Highlights_Stddev_Pop_Fields = {
  __typename?: 'subscription_package_highlights_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Package_Highlights_Stddev_Samp_Fields = {
  __typename?: 'subscription_package_highlights_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Package_Highlights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Package_Highlights_Stream_Cursor_Value_Input = {
  highlight?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Subscription_Package_Highlights_Sum_Fields = {
  __typename?: 'subscription_package_highlights_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "subscription_package_highlights" */
export enum Subscription_Package_Highlights_Update_Column {
  /** column name */
  Highlight = 'highlight',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Order = 'order',
  /** column name */
  SubscriptionPackageId = 'subscription_package_id'
}

export type Subscription_Package_Highlights_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscription_Package_Highlights_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Package_Highlights_Set_Input>;
  where: Subscription_Package_Highlights_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscription_Package_Highlights_Var_Pop_Fields = {
  __typename?: 'subscription_package_highlights_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscription_Package_Highlights_Var_Samp_Fields = {
  __typename?: 'subscription_package_highlights_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscription_Package_Highlights_Variance_Fields = {
  __typename?: 'subscription_package_highlights_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "subscription_package_highlights" */
export type Subscription_Package_Highlights_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "action_log" */
  action_log: Array<Action_Log>;
  /** fetch aggregated fields from the table: "action_log" */
  action_log_aggregate: Action_Log_Aggregate;
  /** fetch data from the table: "action_log" using primary key columns */
  action_log_by_pk?: Maybe<Action_Log>;
  /** fetch data from the table in a streaming manner : "action_log" */
  action_log_stream: Array<Action_Log>;
  /** fetch data from the table: "active_ingredient" */
  active_ingredient: Array<Active_Ingredient>;
  /** fetch aggregated fields from the table: "active_ingredient" */
  active_ingredient_aggregate: Active_Ingredient_Aggregate;
  /** fetch data from the table: "active_ingredient" using primary key columns */
  active_ingredient_by_pk?: Maybe<Active_Ingredient>;
  /** fetch data from the table in a streaming manner : "active_ingredient" */
  active_ingredient_stream: Array<Active_Ingredient>;
  /** fetch data from the table: "actual_reading" */
  actual_reading: Array<Actual_Reading>;
  /** fetch aggregated fields from the table: "actual_reading" */
  actual_reading_aggregate: Actual_Reading_Aggregate;
  /** fetch data from the table: "actual_reading" using primary key columns */
  actual_reading_by_pk?: Maybe<Actual_Reading>;
  /** fetch data from the table in a streaming manner : "actual_reading" */
  actual_reading_stream: Array<Actual_Reading>;
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table in a streaming manner : "address" */
  address_stream: Array<Address>;
  /** fetch data from the table: "advice_author_followers" */
  advice_author_followers: Array<Advice_Author_Followers>;
  /** fetch aggregated fields from the table: "advice_author_followers" */
  advice_author_followers_aggregate: Advice_Author_Followers_Aggregate;
  /** fetch data from the table: "advice_author_followers" using primary key columns */
  advice_author_followers_by_pk?: Maybe<Advice_Author_Followers>;
  /** fetch data from the table in a streaming manner : "advice_author_followers" */
  advice_author_followers_stream: Array<Advice_Author_Followers>;
  /** An array relationship */
  advice_authors: Array<Advice_Authors>;
  /** An aggregate relationship */
  advice_authors_aggregate: Advice_Authors_Aggregate;
  /** fetch data from the table: "advice_authors" using primary key columns */
  advice_authors_by_pk?: Maybe<Advice_Authors>;
  /** fetch data from the table in a streaming manner : "advice_authors" */
  advice_authors_stream: Array<Advice_Authors>;
  /** fetch data from the table: "agent" */
  agent: Array<Agent>;
  /** fetch aggregated fields from the table: "agent" */
  agent_aggregate: Agent_Aggregate;
  /** fetch data from the table: "agent" using primary key columns */
  agent_by_pk?: Maybe<Agent>;
  /** fetch data from the table: "agent_company" */
  agent_company: Array<Agent_Company>;
  /** fetch aggregated fields from the table: "agent_company" */
  agent_company_aggregate: Agent_Company_Aggregate;
  /** fetch data from the table: "agent_company" using primary key columns */
  agent_company_by_pk?: Maybe<Agent_Company>;
  /** fetch data from the table in a streaming manner : "agent_company" */
  agent_company_stream: Array<Agent_Company>;
  /** fetch data from the table in a streaming manner : "agent" */
  agent_stream: Array<Agent>;
  /** fetch data from the table: "answer_choice" */
  answer_choice: Array<Answer_Choice>;
  /** fetch aggregated fields from the table: "answer_choice" */
  answer_choice_aggregate: Answer_Choice_Aggregate;
  /** fetch data from the table: "answer_choice" using primary key columns */
  answer_choice_by_pk?: Maybe<Answer_Choice>;
  /** fetch data from the table in a streaming manner : "answer_choice" */
  answer_choice_stream: Array<Answer_Choice>;
  /** fetch data from the table: "application_product_unit" */
  application_product_unit: Array<Application_Product_Unit>;
  /** fetch aggregated fields from the table: "application_product_unit" */
  application_product_unit_aggregate: Application_Product_Unit_Aggregate;
  /** fetch data from the table: "application_product_unit" using primary key columns */
  application_product_unit_by_pk?: Maybe<Application_Product_Unit>;
  /** fetch data from the table in a streaming manner : "application_product_unit" */
  application_product_unit_stream: Array<Application_Product_Unit>;
  /** fetch data from the table: "article" */
  article: Array<Article>;
  /** fetch aggregated fields from the table: "article" */
  article_aggregate: Article_Aggregate;
  /** An array relationship */
  article_attachments: Array<Article_Attachments>;
  /** An aggregate relationship */
  article_attachments_aggregate: Article_Attachments_Aggregate;
  /** fetch data from the table: "article_attachments" using primary key columns */
  article_attachments_by_pk?: Maybe<Article_Attachments>;
  /** fetch data from the table in a streaming manner : "article_attachments" */
  article_attachments_stream: Array<Article_Attachments>;
  /** fetch data from the table: "article_author_favorite_insights" */
  article_author_favorite_insights: Array<Article_Author_Favorite_Insights>;
  /** fetch aggregated fields from the table: "article_author_favorite_insights" */
  article_author_favorite_insights_aggregate: Article_Author_Favorite_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_author_favorite_insights" */
  article_author_favorite_insights_stream: Array<Article_Author_Favorite_Insights>;
  /** fetch data from the table: "article_author_like_insights" */
  article_author_like_insights: Array<Article_Author_Like_Insights>;
  /** fetch aggregated fields from the table: "article_author_like_insights" */
  article_author_like_insights_aggregate: Article_Author_Like_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_author_like_insights" */
  article_author_like_insights_stream: Array<Article_Author_Like_Insights>;
  /** fetch data from the table: "article_author_view_insights" */
  article_author_view_insights: Array<Article_Author_View_Insights>;
  /** fetch aggregated fields from the table: "article_author_view_insights" */
  article_author_view_insights_aggregate: Article_Author_View_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_author_view_insights" */
  article_author_view_insights_stream: Array<Article_Author_View_Insights>;
  /** An array relationship */
  article_authors: Array<Article_Authors>;
  /** An aggregate relationship */
  article_authors_aggregate: Article_Authors_Aggregate;
  /** fetch data from the table: "article_authors" using primary key columns */
  article_authors_by_pk?: Maybe<Article_Authors>;
  /** fetch data from the table in a streaming manner : "article_authors" */
  article_authors_stream: Array<Article_Authors>;
  /** fetch data from the table: "article" using primary key columns */
  article_by_pk?: Maybe<Article>;
  /** An array relationship */
  article_categories: Array<Article_Categories>;
  /** An aggregate relationship */
  article_categories_aggregate: Article_Categories_Aggregate;
  /** fetch data from the table: "article_categories" using primary key columns */
  article_categories_by_pk?: Maybe<Article_Categories>;
  /** fetch data from the table in a streaming manner : "article_categories" */
  article_categories_stream: Array<Article_Categories>;
  /** fetch data from the table: "article_category" */
  article_category: Array<Article_Category>;
  /** fetch aggregated fields from the table: "article_category" */
  article_category_aggregate: Article_Category_Aggregate;
  /** fetch data from the table: "article_category" using primary key columns */
  article_category_by_pk?: Maybe<Article_Category>;
  /** fetch data from the table in a streaming manner : "article_category" */
  article_category_stream: Array<Article_Category>;
  /** An array relationship */
  article_crop_categories: Array<Article_Crop_Categories>;
  /** An aggregate relationship */
  article_crop_categories_aggregate: Article_Crop_Categories_Aggregate;
  /** fetch data from the table: "article_crop_categories" using primary key columns */
  article_crop_categories_by_pk?: Maybe<Article_Crop_Categories>;
  /** fetch data from the table in a streaming manner : "article_crop_categories" */
  article_crop_categories_stream: Array<Article_Crop_Categories>;
  /** An array relationship */
  article_crop_varieties: Array<Article_Crop_Varieties>;
  /** An aggregate relationship */
  article_crop_varieties_aggregate: Article_Crop_Varieties_Aggregate;
  /** fetch data from the table: "article_crop_varieties" using primary key columns */
  article_crop_varieties_by_pk?: Maybe<Article_Crop_Varieties>;
  /** fetch data from the table in a streaming manner : "article_crop_varieties" */
  article_crop_varieties_stream: Array<Article_Crop_Varieties>;
  /** An array relationship */
  article_crops: Array<Article_Crops>;
  /** An aggregate relationship */
  article_crops_aggregate: Article_Crops_Aggregate;
  /** fetch data from the table: "article_crops" using primary key columns */
  article_crops_by_pk?: Maybe<Article_Crops>;
  /** fetch data from the table in a streaming manner : "article_crops" */
  article_crops_stream: Array<Article_Crops>;
  /** fetch data from the table: "article_favorite_insights" */
  article_favorite_insights: Array<Article_Favorite_Insights>;
  /** fetch aggregated fields from the table: "article_favorite_insights" */
  article_favorite_insights_aggregate: Article_Favorite_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_favorite_insights" */
  article_favorite_insights_stream: Array<Article_Favorite_Insights>;
  /** An array relationship */
  article_favorites: Array<Article_Favorites>;
  /** An aggregate relationship */
  article_favorites_aggregate: Article_Favorites_Aggregate;
  /** fetch data from the table: "article_favorites" using primary key columns */
  article_favorites_by_pk?: Maybe<Article_Favorites>;
  /** fetch data from the table in a streaming manner : "article_favorites" */
  article_favorites_stream: Array<Article_Favorites>;
  /** fetch data from the table: "article_like_insights" */
  article_like_insights: Array<Article_Like_Insights>;
  /** fetch aggregated fields from the table: "article_like_insights" */
  article_like_insights_aggregate: Article_Like_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_like_insights" */
  article_like_insights_stream: Array<Article_Like_Insights>;
  /** fetch data from the table: "article_likes" */
  article_likes: Array<Article_Likes>;
  /** fetch aggregated fields from the table: "article_likes" */
  article_likes_aggregate: Article_Likes_Aggregate;
  /** fetch data from the table: "article_likes" using primary key columns */
  article_likes_by_pk?: Maybe<Article_Likes>;
  /** fetch data from the table in a streaming manner : "article_likes" */
  article_likes_stream: Array<Article_Likes>;
  /** An array relationship */
  article_regions: Array<Article_Regions>;
  /** An aggregate relationship */
  article_regions_aggregate: Article_Regions_Aggregate;
  /** fetch data from the table: "article_regions" using primary key columns */
  article_regions_by_pk?: Maybe<Article_Regions>;
  /** fetch data from the table in a streaming manner : "article_regions" */
  article_regions_stream: Array<Article_Regions>;
  /** An array relationship */
  article_series: Array<Article_Series>;
  /** An aggregate relationship */
  article_series_aggregate: Article_Series_Aggregate;
  /** fetch data from the table: "article_series" using primary key columns */
  article_series_by_pk?: Maybe<Article_Series>;
  /** fetch data from the table: "article_series_favourite_insights" */
  article_series_favourite_insights: Array<Article_Series_Favourite_Insights>;
  /** fetch aggregated fields from the table: "article_series_favourite_insights" */
  article_series_favourite_insights_aggregate: Article_Series_Favourite_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_series_favourite_insights" */
  article_series_favourite_insights_stream: Array<Article_Series_Favourite_Insights>;
  /** fetch data from the table: "article_series_like_insights" */
  article_series_like_insights: Array<Article_Series_Like_Insights>;
  /** fetch aggregated fields from the table: "article_series_like_insights" */
  article_series_like_insights_aggregate: Article_Series_Like_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_series_like_insights" */
  article_series_like_insights_stream: Array<Article_Series_Like_Insights>;
  /** fetch data from the table in a streaming manner : "article_series" */
  article_series_stream: Array<Article_Series>;
  /** fetch data from the table: "article_series_view_insights" */
  article_series_view_insights: Array<Article_Series_View_Insights>;
  /** fetch aggregated fields from the table: "article_series_view_insights" */
  article_series_view_insights_aggregate: Article_Series_View_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_series_view_insights" */
  article_series_view_insights_stream: Array<Article_Series_View_Insights>;
  /** fetch data from the table in a streaming manner : "article" */
  article_stream: Array<Article>;
  /** fetch data from the table: "article_subscription_favorite_insights" */
  article_subscription_favorite_insights: Array<Article_Subscription_Favorite_Insights>;
  /** fetch aggregated fields from the table: "article_subscription_favorite_insights" */
  article_subscription_favorite_insights_aggregate: Article_Subscription_Favorite_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_subscription_favorite_insights" */
  article_subscription_favorite_insights_stream: Array<Article_Subscription_Favorite_Insights>;
  /** fetch data from the table: "article_subscription_like_insights" */
  article_subscription_like_insights: Array<Article_Subscription_Like_Insights>;
  /** fetch aggregated fields from the table: "article_subscription_like_insights" */
  article_subscription_like_insights_aggregate: Article_Subscription_Like_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_subscription_like_insights" */
  article_subscription_like_insights_stream: Array<Article_Subscription_Like_Insights>;
  /** fetch data from the table: "article_subscription_package" */
  article_subscription_package: Array<Article_Subscription_Package>;
  /** fetch aggregated fields from the table: "article_subscription_package" */
  article_subscription_package_aggregate: Article_Subscription_Package_Aggregate;
  /** fetch data from the table: "article_subscription_package" using primary key columns */
  article_subscription_package_by_pk?: Maybe<Article_Subscription_Package>;
  /** fetch data from the table in a streaming manner : "article_subscription_package" */
  article_subscription_package_stream: Array<Article_Subscription_Package>;
  /** fetch data from the table: "article_subscription_view_insights" */
  article_subscription_view_insights: Array<Article_Subscription_View_Insights>;
  /** fetch aggregated fields from the table: "article_subscription_view_insights" */
  article_subscription_view_insights_aggregate: Article_Subscription_View_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_subscription_view_insights" */
  article_subscription_view_insights_stream: Array<Article_Subscription_View_Insights>;
  /** An array relationship */
  article_subscriptions: Array<Article_Subscriptions>;
  /** An aggregate relationship */
  article_subscriptions_aggregate: Article_Subscriptions_Aggregate;
  /** fetch data from the table: "article_subscriptions" using primary key columns */
  article_subscriptions_by_pk?: Maybe<Article_Subscriptions>;
  /** fetch data from the table in a streaming manner : "article_subscriptions" */
  article_subscriptions_stream: Array<Article_Subscriptions>;
  /** fetch data from the table: "article_user_group" */
  article_user_group: Array<Article_User_Group>;
  /** fetch aggregated fields from the table: "article_user_group" */
  article_user_group_aggregate: Article_User_Group_Aggregate;
  /** fetch data from the table: "article_user_group" using primary key columns */
  article_user_group_by_pk?: Maybe<Article_User_Group>;
  /** fetch data from the table in a streaming manner : "article_user_group" */
  article_user_group_stream: Array<Article_User_Group>;
  /** fetch data from the table: "article_view_insights" */
  article_view_insights: Array<Article_View_Insights>;
  /** fetch aggregated fields from the table: "article_view_insights" */
  article_view_insights_aggregate: Article_View_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "article_view_insights" */
  article_view_insights_stream: Array<Article_View_Insights>;
  /** fetch data from the table: "article_views" */
  article_views: Array<Article_Views>;
  /** fetch aggregated fields from the table: "article_views" */
  article_views_aggregate: Article_Views_Aggregate;
  /** fetch data from the table: "article_views" using primary key columns */
  article_views_by_pk?: Maybe<Article_Views>;
  /** fetch data from the table in a streaming manner : "article_views" */
  article_views_stream: Array<Article_Views>;
  /** fetch data from the table: "assessment" */
  assessment: Array<Assessment>;
  /** fetch aggregated fields from the table: "assessment" */
  assessment_aggregate: Assessment_Aggregate;
  /** fetch data from the table: "assessment" using primary key columns */
  assessment_by_pk?: Maybe<Assessment>;
  /** fetch data from the table: "assessment_question" */
  assessment_question: Array<Assessment_Question>;
  /** fetch aggregated fields from the table: "assessment_question" */
  assessment_question_aggregate: Assessment_Question_Aggregate;
  /** fetch data from the table: "assessment_question" using primary key columns */
  assessment_question_by_pk?: Maybe<Assessment_Question>;
  /** fetch data from the table in a streaming manner : "assessment_question" */
  assessment_question_stream: Array<Assessment_Question>;
  /** fetch data from the table in a streaming manner : "assessment" */
  assessment_stream: Array<Assessment>;
  /** fetch data from the table: "attribute" */
  attribute: Array<Attribute>;
  /** fetch aggregated fields from the table: "attribute" */
  attribute_aggregate: Attribute_Aggregate;
  /** fetch data from the table: "attribute" using primary key columns */
  attribute_by_pk?: Maybe<Attribute>;
  /** fetch data from the table: "attribute_choice" */
  attribute_choice: Array<Attribute_Choice>;
  /** fetch aggregated fields from the table: "attribute_choice" */
  attribute_choice_aggregate: Attribute_Choice_Aggregate;
  /** fetch data from the table: "attribute_choice" using primary key columns */
  attribute_choice_by_pk?: Maybe<Attribute_Choice>;
  /** fetch data from the table in a streaming manner : "attribute_choice" */
  attribute_choice_stream: Array<Attribute_Choice>;
  /** fetch data from the table in a streaming manner : "attribute" */
  attribute_stream: Array<Attribute>;
  /** fetch data from the table: "auth_group" */
  auth_group: Array<Auth_Group>;
  /** fetch aggregated fields from the table: "auth_group" */
  auth_group_aggregate: Auth_Group_Aggregate;
  /** fetch data from the table: "auth_group" using primary key columns */
  auth_group_by_pk?: Maybe<Auth_Group>;
  /** fetch data from the table: "auth_group_permissions" */
  auth_group_permissions: Array<Auth_Group_Permissions>;
  /** fetch aggregated fields from the table: "auth_group_permissions" */
  auth_group_permissions_aggregate: Auth_Group_Permissions_Aggregate;
  /** fetch data from the table: "auth_group_permissions" using primary key columns */
  auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** fetch data from the table in a streaming manner : "auth_group_permissions" */
  auth_group_permissions_stream: Array<Auth_Group_Permissions>;
  /** fetch data from the table in a streaming manner : "auth_group" */
  auth_group_stream: Array<Auth_Group>;
  /** fetch data from the table: "auth_permission" */
  auth_permission: Array<Auth_Permission>;
  /** fetch aggregated fields from the table: "auth_permission" */
  auth_permission_aggregate: Auth_Permission_Aggregate;
  /** fetch data from the table: "auth_permission" using primary key columns */
  auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** fetch data from the table in a streaming manner : "auth_permission" */
  auth_permission_stream: Array<Auth_Permission>;
  /** fetch data from the table: "base_user" */
  base_user: Array<Base_User>;
  /** fetch data from the table: "base_user_address_book" */
  base_user_address_book: Array<Base_User_Address_Book>;
  /** fetch aggregated fields from the table: "base_user_address_book" */
  base_user_address_book_aggregate: Base_User_Address_Book_Aggregate;
  /** fetch data from the table: "base_user_address_book" using primary key columns */
  base_user_address_book_by_pk?: Maybe<Base_User_Address_Book>;
  /** fetch data from the table in a streaming manner : "base_user_address_book" */
  base_user_address_book_stream: Array<Base_User_Address_Book>;
  /** fetch aggregated fields from the table: "base_user" */
  base_user_aggregate: Base_User_Aggregate;
  /** fetch data from the table: "base_user" using primary key columns */
  base_user_by_pk?: Maybe<Base_User>;
  /** An array relationship */
  base_user_companies: Array<Base_User_Companies>;
  /** An aggregate relationship */
  base_user_companies_aggregate: Base_User_Companies_Aggregate;
  /** fetch data from the table: "base_user_companies" using primary key columns */
  base_user_companies_by_pk?: Maybe<Base_User_Companies>;
  /** fetch data from the table in a streaming manner : "base_user_companies" */
  base_user_companies_stream: Array<Base_User_Companies>;
  /** fetch data from the table: "base_user_departments" */
  base_user_departments: Array<Base_User_Departments>;
  /** fetch aggregated fields from the table: "base_user_departments" */
  base_user_departments_aggregate: Base_User_Departments_Aggregate;
  /** fetch data from the table: "base_user_departments" using primary key columns */
  base_user_departments_by_pk?: Maybe<Base_User_Departments>;
  /** fetch data from the table in a streaming manner : "base_user_departments" */
  base_user_departments_stream: Array<Base_User_Departments>;
  /** fetch data from the table: "base_user_groups" */
  base_user_groups: Array<Base_User_Groups>;
  /** fetch aggregated fields from the table: "base_user_groups" */
  base_user_groups_aggregate: Base_User_Groups_Aggregate;
  /** fetch data from the table: "base_user_groups" using primary key columns */
  base_user_groups_by_pk?: Maybe<Base_User_Groups>;
  /** fetch data from the table in a streaming manner : "base_user_groups" */
  base_user_groups_stream: Array<Base_User_Groups>;
  /** fetch data from the table: "base_user_network" */
  base_user_network: Array<Base_User_Network>;
  /** fetch aggregated fields from the table: "base_user_network" */
  base_user_network_aggregate: Base_User_Network_Aggregate;
  /** fetch data from the table: "base_user_network" using primary key columns */
  base_user_network_by_pk?: Maybe<Base_User_Network>;
  /** fetch data from the table in a streaming manner : "base_user_network" */
  base_user_network_stream: Array<Base_User_Network>;
  /** fetch data from the table in a streaming manner : "base_user" */
  base_user_stream: Array<Base_User>;
  /** fetch data from the table: "base_user_user_permissions" */
  base_user_user_permissions: Array<Base_User_User_Permissions>;
  /** fetch aggregated fields from the table: "base_user_user_permissions" */
  base_user_user_permissions_aggregate: Base_User_User_Permissions_Aggregate;
  /** fetch data from the table: "base_user_user_permissions" using primary key columns */
  base_user_user_permissions_by_pk?: Maybe<Base_User_User_Permissions>;
  /** fetch data from the table in a streaming manner : "base_user_user_permissions" */
  base_user_user_permissions_stream: Array<Base_User_User_Permissions>;
  /** fetch data from the table: "business" */
  business: Array<Business>;
  /** fetch aggregated fields from the table: "business" */
  business_aggregate: Business_Aggregate;
  /** fetch data from the table: "business" using primary key columns */
  business_by_pk?: Maybe<Business>;
  /** fetch data from the table: "business_commodities_supplied" */
  business_commodities_supplied: Array<Business_Commodities_Supplied>;
  /** fetch aggregated fields from the table: "business_commodities_supplied" */
  business_commodities_supplied_aggregate: Business_Commodities_Supplied_Aggregate;
  /** fetch data from the table: "business_commodities_supplied" using primary key columns */
  business_commodities_supplied_by_pk?: Maybe<Business_Commodities_Supplied>;
  /** fetch data from the table in a streaming manner : "business_commodities_supplied" */
  business_commodities_supplied_stream: Array<Business_Commodities_Supplied>;
  /** fetch data from the table: "business_companies" */
  business_companies: Array<Business_Companies>;
  /** fetch aggregated fields from the table: "business_companies" */
  business_companies_aggregate: Business_Companies_Aggregate;
  /** fetch data from the table: "business_companies" using primary key columns */
  business_companies_by_pk?: Maybe<Business_Companies>;
  /** fetch data from the table in a streaming manner : "business_companies" */
  business_companies_stream: Array<Business_Companies>;
  /** fetch data from the table: "business_group" */
  business_group: Array<Business_Group>;
  /** fetch aggregated fields from the table: "business_group" */
  business_group_aggregate: Business_Group_Aggregate;
  /** fetch data from the table: "business_group" using primary key columns */
  business_group_by_pk?: Maybe<Business_Group>;
  /** fetch data from the table: "business_group_network" */
  business_group_network: Array<Business_Group_Network>;
  /** fetch aggregated fields from the table: "business_group_network" */
  business_group_network_aggregate: Business_Group_Network_Aggregate;
  /** fetch data from the table: "business_group_network" using primary key columns */
  business_group_network_by_pk?: Maybe<Business_Group_Network>;
  /** fetch data from the table in a streaming manner : "business_group_network" */
  business_group_network_stream: Array<Business_Group_Network>;
  /** fetch data from the table in a streaming manner : "business_group" */
  business_group_stream: Array<Business_Group>;
  /** fetch data from the table: "business_groups" */
  business_groups: Array<Business_Groups>;
  /** fetch aggregated fields from the table: "business_groups" */
  business_groups_aggregate: Business_Groups_Aggregate;
  /** fetch data from the table: "business_groups" using primary key columns */
  business_groups_by_pk?: Maybe<Business_Groups>;
  /** fetch data from the table in a streaming manner : "business_groups" */
  business_groups_stream: Array<Business_Groups>;
  /** fetch data from the table: "business_network" */
  business_network: Array<Business_Network>;
  /** fetch aggregated fields from the table: "business_network" */
  business_network_aggregate: Business_Network_Aggregate;
  /** fetch data from the table: "business_network" using primary key columns */
  business_network_by_pk?: Maybe<Business_Network>;
  /** fetch data from the table in a streaming manner : "business_network" */
  business_network_stream: Array<Business_Network>;
  /** fetch data from the table: "business_secondary_pocs" */
  business_secondary_pocs: Array<Business_Secondary_Pocs>;
  /** fetch aggregated fields from the table: "business_secondary_pocs" */
  business_secondary_pocs_aggregate: Business_Secondary_Pocs_Aggregate;
  /** fetch data from the table: "business_secondary_pocs" using primary key columns */
  business_secondary_pocs_by_pk?: Maybe<Business_Secondary_Pocs>;
  /** fetch data from the table in a streaming manner : "business_secondary_pocs" */
  business_secondary_pocs_stream: Array<Business_Secondary_Pocs>;
  /** fetch data from the table in a streaming manner : "business" */
  business_stream: Array<Business>;
  /** fetch data from the table: "shared_entity" */
  care_shared_entity: Array<Care_Shared_Entity>;
  /** fetch aggregated fields from the table: "shared_entity" */
  care_shared_entity_aggregate: Care_Shared_Entity_Aggregate;
  /** fetch data from the table: "shared_entity" using primary key columns */
  care_shared_entity_by_pk?: Maybe<Care_Shared_Entity>;
  /** fetch data from the table in a streaming manner : "shared_entity" */
  care_shared_entity_stream: Array<Care_Shared_Entity>;
  /** fetch data from the table: "category" */
  category: Array<Category>;
  /** fetch aggregated fields from the table: "category" */
  category_aggregate: Category_Aggregate;
  /** fetch data from the table: "category" using primary key columns */
  category_by_pk?: Maybe<Category>;
  /** fetch data from the table in a streaming manner : "category" */
  category_stream: Array<Category>;
  /** fetch data from the table: "certificate_issuer" */
  certificate_issuer: Array<Certificate_Issuer>;
  /** fetch aggregated fields from the table: "certificate_issuer" */
  certificate_issuer_aggregate: Certificate_Issuer_Aggregate;
  /** fetch data from the table: "certificate_issuer" using primary key columns */
  certificate_issuer_by_pk?: Maybe<Certificate_Issuer>;
  /** fetch data from the table in a streaming manner : "certificate_issuer" */
  certificate_issuer_stream: Array<Certificate_Issuer>;
  /** fetch data from the table: "certification" */
  certification: Array<Certification>;
  /** fetch aggregated fields from the table: "certification" */
  certification_aggregate: Certification_Aggregate;
  /** fetch data from the table: "certification" using primary key columns */
  certification_by_pk?: Maybe<Certification>;
  /** fetch data from the table in a streaming manner : "certification" */
  certification_stream: Array<Certification>;
  /** fetch data from the table: "comment" */
  comment: Array<Comment>;
  /** fetch aggregated fields from the table: "comment" */
  comment_aggregate: Comment_Aggregate;
  /** fetch data from the table: "comment" using primary key columns */
  comment_by_pk?: Maybe<Comment>;
  /** fetch data from the table in a streaming manner : "comment" */
  comment_stream: Array<Comment>;
  /** fetch data from the table: "commodity" */
  commodity: Array<Commodity>;
  /** fetch aggregated fields from the table: "commodity" */
  commodity_aggregate: Commodity_Aggregate;
  /** fetch data from the table: "commodity" using primary key columns */
  commodity_by_pk?: Maybe<Commodity>;
  /** fetch data from the table in a streaming manner : "commodity" */
  commodity_stream: Array<Commodity>;
  /** fetch data from the table: "commodity_variety" */
  commodity_variety: Array<Commodity_Variety>;
  /** fetch aggregated fields from the table: "commodity_variety" */
  commodity_variety_aggregate: Commodity_Variety_Aggregate;
  /** fetch data from the table: "commodity_variety" using primary key columns */
  commodity_variety_by_pk?: Maybe<Commodity_Variety>;
  /** fetch data from the table: "commodity_variety_secondary_groups" */
  commodity_variety_secondary_groups: Array<Commodity_Variety_Secondary_Groups>;
  /** fetch aggregated fields from the table: "commodity_variety_secondary_groups" */
  commodity_variety_secondary_groups_aggregate: Commodity_Variety_Secondary_Groups_Aggregate;
  /** fetch data from the table: "commodity_variety_secondary_groups" using primary key columns */
  commodity_variety_secondary_groups_by_pk?: Maybe<Commodity_Variety_Secondary_Groups>;
  /** fetch data from the table in a streaming manner : "commodity_variety_secondary_groups" */
  commodity_variety_secondary_groups_stream: Array<Commodity_Variety_Secondary_Groups>;
  /** fetch data from the table in a streaming manner : "commodity_variety" */
  commodity_variety_stream: Array<Commodity_Variety>;
  /** fetch data from the table: "common_fileupload" */
  common_fileupload: Array<Common_Fileupload>;
  /** fetch aggregated fields from the table: "common_fileupload" */
  common_fileupload_aggregate: Common_Fileupload_Aggregate;
  /** fetch data from the table: "common_fileupload" using primary key columns */
  common_fileupload_by_pk?: Maybe<Common_Fileupload>;
  /** fetch data from the table in a streaming manner : "common_fileupload" */
  common_fileupload_stream: Array<Common_Fileupload>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table in a streaming manner : "company" */
  company_stream: Array<Company>;
  /** fetch data from the table: "django_content_type" */
  content_type: Array<Django_Content_Type>;
  /** fetch aggregated fields from the table: "django_content_type" */
  content_type_aggregate: Django_Content_Type_Aggregate;
  /** fetch data from the table: "django_content_type" using primary key columns */
  content_type_by_pk?: Maybe<Django_Content_Type>;
  /** fetch data from the table: "cost_item" */
  cost_item: Array<Cost_Item>;
  /** fetch aggregated fields from the table: "cost_item" */
  cost_item_aggregate: Cost_Item_Aggregate;
  /** fetch data from the table: "cost_item" using primary key columns */
  cost_item_by_pk?: Maybe<Cost_Item>;
  /** fetch data from the table in a streaming manner : "cost_item" */
  cost_item_stream: Array<Cost_Item>;
  /** fetch data from the table: "crop" */
  crop: Array<Crop>;
  /** fetch aggregated fields from the table: "crop" */
  crop_aggregate: Crop_Aggregate;
  /** fetch data from the table: "crop" using primary key columns */
  crop_by_pk?: Maybe<Crop>;
  /** An array relationship */
  crop_fertilisers: Array<Crop_Fertilisers>;
  /** An aggregate relationship */
  crop_fertilisers_aggregate: Crop_Fertilisers_Aggregate;
  /** fetch data from the table: "crop_fertilisers" using primary key columns */
  crop_fertilisers_by_pk?: Maybe<Crop_Fertilisers>;
  /** fetch data from the table in a streaming manner : "crop_fertilisers" */
  crop_fertilisers_stream: Array<Crop_Fertilisers>;
  /** fetch data from the table: "crop_group" */
  crop_group: Array<Crop_Group>;
  /** fetch aggregated fields from the table: "crop_group" */
  crop_group_aggregate: Crop_Group_Aggregate;
  /** fetch data from the table: "crop_group" using primary key columns */
  crop_group_by_pk?: Maybe<Crop_Group>;
  /** fetch data from the table in a streaming manner : "crop_group" */
  crop_group_stream: Array<Crop_Group>;
  /** fetch data from the table: "crop_infestation" */
  crop_infestation: Array<Crop_Infestation>;
  /** fetch aggregated fields from the table: "crop_infestation" */
  crop_infestation_aggregate: Crop_Infestation_Aggregate;
  /** fetch data from the table: "crop_infestation_attachment" */
  crop_infestation_attachment: Array<Crop_Infestation_Attachment>;
  /** fetch aggregated fields from the table: "crop_infestation_attachment" */
  crop_infestation_attachment_aggregate: Crop_Infestation_Attachment_Aggregate;
  /** fetch data from the table: "crop_infestation_attachment" using primary key columns */
  crop_infestation_attachment_by_pk?: Maybe<Crop_Infestation_Attachment>;
  /** fetch data from the table in a streaming manner : "crop_infestation_attachment" */
  crop_infestation_attachment_stream: Array<Crop_Infestation_Attachment>;
  /** fetch data from the table: "crop_infestation" using primary key columns */
  crop_infestation_by_pk?: Maybe<Crop_Infestation>;
  /** fetch data from the table in a streaming manner : "crop_infestation" */
  crop_infestation_stream: Array<Crop_Infestation>;
  /** fetch data from the table: "crop_milestone" */
  crop_milestone: Array<Crop_Milestone>;
  /** fetch aggregated fields from the table: "crop_milestone" */
  crop_milestone_aggregate: Crop_Milestone_Aggregate;
  /** fetch data from the table: "crop_milestone" using primary key columns */
  crop_milestone_by_pk?: Maybe<Crop_Milestone>;
  /** fetch data from the table in a streaming manner : "crop_milestone" */
  crop_milestone_stream: Array<Crop_Milestone>;
  /** An array relationship */
  crop_operation_methods: Array<Crop_Operation_Methods>;
  /** An aggregate relationship */
  crop_operation_methods_aggregate: Crop_Operation_Methods_Aggregate;
  /** fetch data from the table: "crop_operation_methods" using primary key columns */
  crop_operation_methods_by_pk?: Maybe<Crop_Operation_Methods>;
  /** fetch data from the table in a streaming manner : "crop_operation_methods" */
  crop_operation_methods_stream: Array<Crop_Operation_Methods>;
  /** An array relationship */
  crop_pesticides: Array<Crop_Pesticides>;
  /** An aggregate relationship */
  crop_pesticides_aggregate: Crop_Pesticides_Aggregate;
  /** fetch data from the table: "crop_pesticides" using primary key columns */
  crop_pesticides_by_pk?: Maybe<Crop_Pesticides>;
  /** fetch data from the table in a streaming manner : "crop_pesticides" */
  crop_pesticides_stream: Array<Crop_Pesticides>;
  /** fetch data from the table in a streaming manner : "crop" */
  crop_stream: Array<Crop>;
  /** fetch data from the table: "crop_variety" */
  crop_variety: Array<Crop_Variety>;
  /** fetch aggregated fields from the table: "crop_variety" */
  crop_variety_aggregate: Crop_Variety_Aggregate;
  /** fetch data from the table: "crop_variety" using primary key columns */
  crop_variety_by_pk?: Maybe<Crop_Variety>;
  /** An array relationship */
  crop_variety_seeds: Array<Crop_Variety_Seeds>;
  /** An aggregate relationship */
  crop_variety_seeds_aggregate: Crop_Variety_Seeds_Aggregate;
  /** fetch data from the table: "crop_variety_seeds" using primary key columns */
  crop_variety_seeds_by_pk?: Maybe<Crop_Variety_Seeds>;
  /** fetch data from the table in a streaming manner : "crop_variety_seeds" */
  crop_variety_seeds_stream: Array<Crop_Variety_Seeds>;
  /** fetch data from the table in a streaming manner : "crop_variety" */
  crop_variety_stream: Array<Crop_Variety>;
  /** fetch data from the table: "crop_year" */
  crop_year: Array<Crop_Year>;
  /** fetch aggregated fields from the table: "crop_year" */
  crop_year_aggregate: Crop_Year_Aggregate;
  /** fetch data from the table: "crop_year" using primary key columns */
  crop_year_by_pk?: Maybe<Crop_Year>;
  /** fetch data from the table in a streaming manner : "crop_year" */
  crop_year_stream: Array<Crop_Year>;
  /** fetch data from the table: "cropmonitoring_parameter" */
  cropmonitoring_parameter: Array<Cropmonitoring_Parameter>;
  /** fetch aggregated fields from the table: "cropmonitoring_parameter" */
  cropmonitoring_parameter_aggregate: Cropmonitoring_Parameter_Aggregate;
  /** fetch data from the table: "cropmonitoring_parameter" using primary key columns */
  cropmonitoring_parameter_by_pk?: Maybe<Cropmonitoring_Parameter>;
  /** fetch data from the table in a streaming manner : "cropmonitoring_parameter" */
  cropmonitoring_parameter_stream: Array<Cropmonitoring_Parameter>;
  /** fetch data from the table: "currency" */
  currency: Array<Currency>;
  /** fetch aggregated fields from the table: "currency" */
  currency_aggregate: Currency_Aggregate;
  /** fetch data from the table: "currency" using primary key columns */
  currency_by_pk?: Maybe<Currency>;
  /** fetch data from the table in a streaming manner : "currency" */
  currency_stream: Array<Currency>;
  /** fetch data from the table: "daily_actual_reading" */
  daily_actual_reading: Array<Daily_Actual_Reading>;
  /** fetch aggregated fields from the table: "daily_actual_reading" */
  daily_actual_reading_aggregate: Daily_Actual_Reading_Aggregate;
  /** fetch data from the table: "daily_actual_reading" using primary key columns */
  daily_actual_reading_by_pk?: Maybe<Daily_Actual_Reading>;
  /** fetch data from the table in a streaming manner : "daily_actual_reading" */
  daily_actual_reading_stream: Array<Daily_Actual_Reading>;
  /** fetch data from the table: "daily_forecast_reading" */
  daily_forecast_reading: Array<Daily_Forecast_Reading>;
  /** fetch aggregated fields from the table: "daily_forecast_reading" */
  daily_forecast_reading_aggregate: Daily_Forecast_Reading_Aggregate;
  /** fetch data from the table: "daily_forecast_reading" using primary key columns */
  daily_forecast_reading_by_pk?: Maybe<Daily_Forecast_Reading>;
  /** fetch data from the table in a streaming manner : "daily_forecast_reading" */
  daily_forecast_reading_stream: Array<Daily_Forecast_Reading>;
  /** fetch data from the table: "department" */
  department: Array<Department>;
  /** fetch aggregated fields from the table: "department" */
  department_aggregate: Department_Aggregate;
  /** fetch data from the table: "department" using primary key columns */
  department_by_pk?: Maybe<Department>;
  /** fetch data from the table in a streaming manner : "department" */
  department_stream: Array<Department>;
  /** fetch data from the table: "device" */
  device: Array<Device>;
  /** fetch aggregated fields from the table: "device" */
  device_aggregate: Device_Aggregate;
  /** fetch data from the table: "device" using primary key columns */
  device_by_pk?: Maybe<Device>;
  /** fetch data from the table in a streaming manner : "device" */
  device_stream: Array<Device>;
  /** fetch data from the table in a streaming manner : "django_content_type" */
  django_content_type_stream: Array<Django_Content_Type>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document_attachments" */
  document_attachments: Array<Document_Attachments>;
  /** fetch aggregated fields from the table: "document_attachments" */
  document_attachments_aggregate: Document_Attachments_Aggregate;
  /** fetch data from the table: "document_attachments" using primary key columns */
  document_attachments_by_pk?: Maybe<Document_Attachments>;
  /** fetch data from the table in a streaming manner : "document_attachments" */
  document_attachments_stream: Array<Document_Attachments>;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk?: Maybe<Document>;
  /** fetch data from the table: "document_data" */
  document_data: Array<Document_Data>;
  /** fetch aggregated fields from the table: "document_data" */
  document_data_aggregate: Document_Data_Aggregate;
  /** fetch data from the table: "document_data" using primary key columns */
  document_data_by_pk?: Maybe<Document_Data>;
  /** fetch data from the table in a streaming manner : "document_data" */
  document_data_stream: Array<Document_Data>;
  /** fetch data from the table: "document_kind" */
  document_kind: Array<Document_Kind>;
  /** fetch aggregated fields from the table: "document_kind" */
  document_kind_aggregate: Document_Kind_Aggregate;
  /** fetch data from the table: "document_kind" using primary key columns */
  document_kind_by_pk?: Maybe<Document_Kind>;
  /** fetch data from the table: "document_kind_data_field" */
  document_kind_data_field: Array<Document_Kind_Data_Field>;
  /** fetch aggregated fields from the table: "document_kind_data_field" */
  document_kind_data_field_aggregate: Document_Kind_Data_Field_Aggregate;
  /** fetch data from the table: "document_kind_data_field" using primary key columns */
  document_kind_data_field_by_pk?: Maybe<Document_Kind_Data_Field>;
  /** fetch data from the table in a streaming manner : "document_kind_data_field" */
  document_kind_data_field_stream: Array<Document_Kind_Data_Field>;
  /** fetch data from the table in a streaming manner : "document_kind" */
  document_kind_stream: Array<Document_Kind>;
  /** fetch data from the table in a streaming manner : "document" */
  document_stream: Array<Document>;
  /** fetch data from the table: "drip_irrigation_system" */
  drip_irrigation_system: Array<Drip_Irrigation_System>;
  /** fetch aggregated fields from the table: "drip_irrigation_system" */
  drip_irrigation_system_aggregate: Drip_Irrigation_System_Aggregate;
  /** fetch data from the table: "drip_irrigation_system" using primary key columns */
  drip_irrigation_system_by_pk?: Maybe<Drip_Irrigation_System>;
  /** fetch data from the table in a streaming manner : "drip_irrigation_system" */
  drip_irrigation_system_stream: Array<Drip_Irrigation_System>;
  /** fetch data from the table: "expense" */
  expense: Array<Expense>;
  /** fetch aggregated fields from the table: "expense" */
  expense_aggregate: Expense_Aggregate;
  /** fetch data from the table: "expense" using primary key columns */
  expense_by_pk?: Maybe<Expense>;
  /** fetch data from the table: "expense_parameter" */
  expense_parameter: Array<Expense_Parameter>;
  /** fetch data from the table: "expense_parameter" using primary key columns */
  expense_parameter_by_pk?: Maybe<Expense_Parameter>;
  /** fetch data from the table in a streaming manner : "expense_parameter" */
  expense_parameter_stream: Array<Expense_Parameter>;
  /** fetch data from the table in a streaming manner : "expense" */
  expense_stream: Array<Expense>;
  /** fetch data from the table: "external_reference" */
  external_reference: Array<External_Reference>;
  /** fetch aggregated fields from the table: "external_reference" */
  external_reference_aggregate: External_Reference_Aggregate;
  /** fetch data from the table: "external_reference" using primary key columns */
  external_reference_by_pk?: Maybe<External_Reference>;
  /** fetch data from the table in a streaming manner : "external_reference" */
  external_reference_stream: Array<External_Reference>;
  /** fetch data from the table: "farm" */
  farm: Array<Farm>;
  /** fetch aggregated fields from the table: "farm" */
  farm_aggregate: Farm_Aggregate;
  /** fetch data from the table: "farm" using primary key columns */
  farm_by_pk?: Maybe<Farm>;
  /** fetch data from the table: "farm_network" */
  farm_network: Array<Farm_Network>;
  /** fetch aggregated fields from the table: "farm_network" */
  farm_network_aggregate: Farm_Network_Aggregate;
  /** fetch data from the table: "farm_network" using primary key columns */
  farm_network_by_pk?: Maybe<Farm_Network>;
  /** fetch data from the table in a streaming manner : "farm_network" */
  farm_network_stream: Array<Farm_Network>;
  /** fetch data from the table in a streaming manner : "farm" */
  farm_stream: Array<Farm>;
  /** fetch data from the table: "field" */
  field: Array<Field>;
  /** fetch aggregated fields from the table: "field" */
  field_aggregate: Field_Aggregate;
  /** fetch data from the table: "field" using primary key columns */
  field_by_pk?: Maybe<Field>;
  /** fetch data from the table: "field_network" */
  field_network: Array<Field_Network>;
  /** fetch aggregated fields from the table: "field_network" */
  field_network_aggregate: Field_Network_Aggregate;
  /** fetch data from the table: "field_network" using primary key columns */
  field_network_by_pk?: Maybe<Field_Network>;
  /** fetch data from the table in a streaming manner : "field_network" */
  field_network_stream: Array<Field_Network>;
  /** fetch data from the table in a streaming manner : "field" */
  field_stream: Array<Field>;
  /** fetch data from the table: "field_weather_location" */
  field_weather_location: Array<Field_Weather_Location>;
  /** fetch aggregated fields from the table: "field_weather_location" */
  field_weather_location_aggregate: Field_Weather_Location_Aggregate;
  /** fetch data from the table: "field_weather_location" using primary key columns */
  field_weather_location_by_pk?: Maybe<Field_Weather_Location>;
  /** fetch data from the table in a streaming manner : "field_weather_location" */
  field_weather_location_stream: Array<Field_Weather_Location>;
  /** fetch data from the table: "fileupload" */
  fileupload: Array<Fileupload>;
  /** fetch aggregated fields from the table: "fileupload" */
  fileupload_aggregate: Fileupload_Aggregate;
  /** fetch data from the table: "fileupload" using primary key columns */
  fileupload_by_pk?: Maybe<Fileupload>;
  /** fetch data from the table in a streaming manner : "fileupload" */
  fileupload_stream: Array<Fileupload>;
  /** fetch data from the table: "flood_irrigation_system" */
  flood_irrigation_system: Array<Flood_Irrigation_System>;
  /** fetch aggregated fields from the table: "flood_irrigation_system" */
  flood_irrigation_system_aggregate: Flood_Irrigation_System_Aggregate;
  /** fetch data from the table: "flood_irrigation_system" using primary key columns */
  flood_irrigation_system_by_pk?: Maybe<Flood_Irrigation_System>;
  /** fetch data from the table in a streaming manner : "flood_irrigation_system" */
  flood_irrigation_system_stream: Array<Flood_Irrigation_System>;
  /** fetch data from the table: "forecast_reading" */
  forecast_reading: Array<Forecast_Reading>;
  /** fetch aggregated fields from the table: "forecast_reading" */
  forecast_reading_aggregate: Forecast_Reading_Aggregate;
  /** fetch data from the table: "forecast_reading" using primary key columns */
  forecast_reading_by_pk?: Maybe<Forecast_Reading>;
  /** fetch data from the table in a streaming manner : "forecast_reading" */
  forecast_reading_stream: Array<Forecast_Reading>;
  /** fetch data from the table: "gateway" */
  gateway: Array<Gateway>;
  /** fetch aggregated fields from the table: "gateway" */
  gateway_aggregate: Gateway_Aggregate;
  /** fetch data from the table: "gateway" using primary key columns */
  gateway_by_pk?: Maybe<Gateway>;
  /** fetch data from the table: "gateway_configuration" */
  gateway_configuration: Array<Gateway_Configuration>;
  /** fetch aggregated fields from the table: "gateway_configuration" */
  gateway_configuration_aggregate: Gateway_Configuration_Aggregate;
  /** fetch data from the table: "gateway_configuration" using primary key columns */
  gateway_configuration_by_pk?: Maybe<Gateway_Configuration>;
  /** fetch data from the table in a streaming manner : "gateway_configuration" */
  gateway_configuration_stream: Array<Gateway_Configuration>;
  /** fetch data from the table: "gateway_status" */
  gateway_status: Array<Gateway_Status>;
  /** fetch aggregated fields from the table: "gateway_status" */
  gateway_status_aggregate: Gateway_Status_Aggregate;
  /** fetch data from the table: "gateway_status" using primary key columns */
  gateway_status_by_pk?: Maybe<Gateway_Status>;
  /** fetch data from the table in a streaming manner : "gateway_status" */
  gateway_status_stream: Array<Gateway_Status>;
  /** fetch data from the table in a streaming manner : "gateway" */
  gateway_stream: Array<Gateway>;
  /** fetch data from the table: "grade_price" */
  grade_price: Array<Grade_Price>;
  /** fetch aggregated fields from the table: "grade_price" */
  grade_price_aggregate: Grade_Price_Aggregate;
  /** fetch data from the table: "grade_price" using primary key columns */
  grade_price_by_pk?: Maybe<Grade_Price>;
  /** fetch data from the table in a streaming manner : "grade_price" */
  grade_price_stream: Array<Grade_Price>;
  /** fetch data from the table: "infestation" */
  infestation: Array<Infestation>;
  /** fetch aggregated fields from the table: "infestation" */
  infestation_aggregate: Infestation_Aggregate;
  /** fetch data from the table: "infestation" using primary key columns */
  infestation_by_pk?: Maybe<Infestation>;
  /** fetch data from the table in a streaming manner : "infestation" */
  infestation_stream: Array<Infestation>;
  /** fetch data from the table: "ingredient" */
  ingredient: Array<Ingredient>;
  /** fetch aggregated fields from the table: "ingredient" */
  ingredient_aggregate: Ingredient_Aggregate;
  /** fetch data from the table: "ingredient" using primary key columns */
  ingredient_by_pk?: Maybe<Ingredient>;
  /** fetch data from the table in a streaming manner : "ingredient" */
  ingredient_stream: Array<Ingredient>;
  /** fetch data from the table: "inst_sensor_reading" */
  inst_sensor_reading: Array<Inst_Sensor_Reading>;
  /** fetch aggregated fields from the table: "inst_sensor_reading" */
  inst_sensor_reading_aggregate: Inst_Sensor_Reading_Aggregate;
  /** fetch data from the table: "inst_sensor_reading" using primary key columns */
  inst_sensor_reading_by_pk?: Maybe<Inst_Sensor_Reading>;
  /** fetch data from the table in a streaming manner : "inst_sensor_reading" */
  inst_sensor_reading_stream: Array<Inst_Sensor_Reading>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table in a streaming manner : "invoice" */
  invoice_stream: Array<Invoice>;
  /** fetch data from the table: "irrigation_system" */
  irrigation_system: Array<Irrigation_System>;
  /** fetch aggregated fields from the table: "irrigation_system" */
  irrigation_system_aggregate: Irrigation_System_Aggregate;
  /** fetch data from the table: "irrigation_system" using primary key columns */
  irrigation_system_by_pk?: Maybe<Irrigation_System>;
  /** fetch data from the table in a streaming manner : "irrigation_system" */
  irrigation_system_stream: Array<Irrigation_System>;
  /** fetch data from the table: "location_subscription" */
  location_subscription: Array<Location_Subscription>;
  /** fetch aggregated fields from the table: "location_subscription" */
  location_subscription_aggregate: Location_Subscription_Aggregate;
  /** fetch data from the table: "location_subscription" using primary key columns */
  location_subscription_by_pk?: Maybe<Location_Subscription>;
  /** fetch data from the table in a streaming manner : "location_subscription" */
  location_subscription_stream: Array<Location_Subscription>;
  /** fetch data from the table: "main_section" */
  main_section: Array<Main_Section>;
  /** fetch aggregated fields from the table: "main_section" */
  main_section_aggregate: Main_Section_Aggregate;
  /** fetch data from the table: "main_section" using primary key columns */
  main_section_by_pk?: Maybe<Main_Section>;
  /** fetch data from the table in a streaming manner : "main_section" */
  main_section_stream: Array<Main_Section>;
  /** fetch data from the table: "manufacturer" */
  manufacturer: Array<Manufacturer>;
  /** fetch aggregated fields from the table: "manufacturer" */
  manufacturer_aggregate: Manufacturer_Aggregate;
  /** fetch data from the table: "manufacturer" using primary key columns */
  manufacturer_by_pk?: Maybe<Manufacturer>;
  /** fetch data from the table in a streaming manner : "manufacturer" */
  manufacturer_stream: Array<Manufacturer>;
  /** fetch data from the table: "manufacturing_facility" */
  manufacturing_facility: Array<Manufacturing_Facility>;
  /** fetch aggregated fields from the table: "manufacturing_facility" */
  manufacturing_facility_aggregate: Manufacturing_Facility_Aggregate;
  /** fetch data from the table: "manufacturing_facility" using primary key columns */
  manufacturing_facility_by_pk?: Maybe<Manufacturing_Facility>;
  /** fetch data from the table in a streaming manner : "manufacturing_facility" */
  manufacturing_facility_stream: Array<Manufacturing_Facility>;
  /** fetch data from the table: "market" */
  market: Array<Market>;
  /** fetch aggregated fields from the table: "market" */
  market_aggregate: Market_Aggregate;
  /** fetch data from the table: "market" using primary key columns */
  market_by_pk?: Maybe<Market>;
  /** fetch data from the table in a streaming manner : "market" */
  market_stream: Array<Market>;
  /** fetch data from the table: "marketer" */
  marketer: Array<Marketer>;
  /** fetch aggregated fields from the table: "marketer" */
  marketer_aggregate: Marketer_Aggregate;
  /** fetch data from the table: "marketer" using primary key columns */
  marketer_by_pk?: Maybe<Marketer>;
  /** fetch data from the table in a streaming manner : "marketer" */
  marketer_stream: Array<Marketer>;
  /** fetch data from the table: "marketing_facility" */
  marketing_facility: Array<Marketing_Facility>;
  /** fetch aggregated fields from the table: "marketing_facility" */
  marketing_facility_aggregate: Marketing_Facility_Aggregate;
  /** fetch data from the table: "marketing_facility" using primary key columns */
  marketing_facility_by_pk?: Maybe<Marketing_Facility>;
  /** fetch data from the table in a streaming manner : "marketing_facility" */
  marketing_facility_stream: Array<Marketing_Facility>;
  /** fetch data from the table: "measure_of" */
  measure_of: Array<Measure_Of>;
  /** fetch aggregated fields from the table: "measure_of" */
  measure_of_aggregate: Measure_Of_Aggregate;
  /** fetch data from the table: "measure_of" using primary key columns */
  measure_of_by_pk?: Maybe<Measure_Of>;
  /** fetch data from the table in a streaming manner : "measure_of" */
  measure_of_stream: Array<Measure_Of>;
  /** fetch data from the table: "media" */
  media: Array<Media>;
  /** fetch aggregated fields from the table: "media" */
  media_aggregate: Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  media_by_pk?: Maybe<Media>;
  /** fetch data from the table in a streaming manner : "media" */
  media_stream: Array<Media>;
  /** fetch data from the table: "message" */
  message: Array<Message>;
  /** fetch aggregated fields from the table: "message" */
  message_aggregate: Message_Aggregate;
  /** fetch data from the table: "message" using primary key columns */
  message_by_pk?: Maybe<Message>;
  /** fetch data from the table in a streaming manner : "message" */
  message_stream: Array<Message>;
  /** fetch data from the table: "milestone" */
  milestone: Array<Milestone>;
  /** fetch aggregated fields from the table: "milestone" */
  milestone_aggregate: Milestone_Aggregate;
  /** fetch data from the table: "milestone" using primary key columns */
  milestone_by_pk?: Maybe<Milestone>;
  /** fetch data from the table in a streaming manner : "milestone" */
  milestone_stream: Array<Milestone>;
  /** fetch data from the table: "monitoring_category" */
  monitoring_category: Array<Monitoring_Category>;
  /** fetch aggregated fields from the table: "monitoring_category" */
  monitoring_category_aggregate: Monitoring_Category_Aggregate;
  /** fetch data from the table: "monitoring_category" using primary key columns */
  monitoring_category_by_pk?: Maybe<Monitoring_Category>;
  /** fetch data from the table in a streaming manner : "monitoring_category" */
  monitoring_category_stream: Array<Monitoring_Category>;
  /** fetch data from the table: "monitoring_parameter" */
  monitoring_parameter: Array<Monitoring_Parameter>;
  /** fetch aggregated fields from the table: "monitoring_parameter" */
  monitoring_parameter_aggregate: Monitoring_Parameter_Aggregate;
  /** fetch data from the table: "monitoring_parameter" using primary key columns */
  monitoring_parameter_by_pk?: Maybe<Monitoring_Parameter>;
  /** An array relationship */
  monitoring_parameter_choices: Array<Monitoring_Parameter_Choices>;
  /** An aggregate relationship */
  monitoring_parameter_choices_aggregate: Monitoring_Parameter_Choices_Aggregate;
  /** fetch data from the table: "monitoring_parameter_choices" using primary key columns */
  monitoring_parameter_choices_by_pk?: Maybe<Monitoring_Parameter_Choices>;
  /** fetch data from the table in a streaming manner : "monitoring_parameter_choices" */
  monitoring_parameter_choices_stream: Array<Monitoring_Parameter_Choices>;
  /** fetch data from the table in a streaming manner : "monitoring_parameter" */
  monitoring_parameter_stream: Array<Monitoring_Parameter>;
  /** An array relationship */
  monitoring_parameter_unit_choices: Array<Monitoring_Parameter_Unit_Choices>;
  /** An aggregate relationship */
  monitoring_parameter_unit_choices_aggregate: Monitoring_Parameter_Unit_Choices_Aggregate;
  /** fetch data from the table: "monitoring_parameter_unit_choices" using primary key columns */
  monitoring_parameter_unit_choices_by_pk?: Maybe<Monitoring_Parameter_Unit_Choices>;
  /** fetch data from the table in a streaming manner : "monitoring_parameter_unit_choices" */
  monitoring_parameter_unit_choices_stream: Array<Monitoring_Parameter_Unit_Choices>;
  /** fetch data from the table: "monitoring_record" */
  monitoring_record: Array<Monitoring_Record>;
  /** fetch aggregated fields from the table: "monitoring_record" */
  monitoring_record_aggregate: Monitoring_Record_Aggregate;
  /** An array relationship */
  monitoring_record_attachments: Array<Monitoring_Record_Attachments>;
  /** An aggregate relationship */
  monitoring_record_attachments_aggregate: Monitoring_Record_Attachments_Aggregate;
  /** fetch data from the table: "monitoring_record_attachments" using primary key columns */
  monitoring_record_attachments_by_pk?: Maybe<Monitoring_Record_Attachments>;
  /** fetch data from the table in a streaming manner : "monitoring_record_attachments" */
  monitoring_record_attachments_stream: Array<Monitoring_Record_Attachments>;
  /** fetch data from the table: "monitoring_record" using primary key columns */
  monitoring_record_by_pk?: Maybe<Monitoring_Record>;
  /** fetch data from the table in a streaming manner : "monitoring_record" */
  monitoring_record_stream: Array<Monitoring_Record>;
  /** fetch data from the table: "monitoring_sample" */
  monitoring_sample: Array<Monitoring_Sample>;
  /** fetch aggregated fields from the table: "monitoring_sample" */
  monitoring_sample_aggregate: Monitoring_Sample_Aggregate;
  /** fetch data from the table: "monitoring_sample" using primary key columns */
  monitoring_sample_by_pk?: Maybe<Monitoring_Sample>;
  /** fetch data from the table in a streaming manner : "monitoring_sample" */
  monitoring_sample_stream: Array<Monitoring_Sample>;
  /** fetch data from the table: "monitoring_subcategory" */
  monitoring_subcategory: Array<Monitoring_Subcategory>;
  /** fetch aggregated fields from the table: "monitoring_subcategory" */
  monitoring_subcategory_aggregate: Monitoring_Subcategory_Aggregate;
  /** fetch data from the table: "monitoring_subcategory" using primary key columns */
  monitoring_subcategory_by_pk?: Maybe<Monitoring_Subcategory>;
  /** fetch data from the table in a streaming manner : "monitoring_subcategory" */
  monitoring_subcategory_stream: Array<Monitoring_Subcategory>;
  /** fetch data from the table: "mutual_group" */
  mutual_group: Array<Mutual_Group>;
  /** fetch aggregated fields from the table: "mutual_group" */
  mutual_group_aggregate: Mutual_Group_Aggregate;
  /** fetch data from the table: "mutual_group" using primary key columns */
  mutual_group_by_pk?: Maybe<Mutual_Group>;
  /** fetch data from the table: "mutual_group_membership" */
  mutual_group_membership: Array<Mutual_Group_Membership>;
  /** fetch aggregated fields from the table: "mutual_group_membership" */
  mutual_group_membership_aggregate: Mutual_Group_Membership_Aggregate;
  /** fetch data from the table: "mutual_group_membership" using primary key columns */
  mutual_group_membership_by_pk?: Maybe<Mutual_Group_Membership>;
  /** fetch data from the table in a streaming manner : "mutual_group_membership" */
  mutual_group_membership_stream: Array<Mutual_Group_Membership>;
  /** fetch data from the table: "mutual_group_network" */
  mutual_group_network: Array<Mutual_Group_Network>;
  /** fetch aggregated fields from the table: "mutual_group_network" */
  mutual_group_network_aggregate: Mutual_Group_Network_Aggregate;
  /** fetch data from the table: "mutual_group_network" using primary key columns */
  mutual_group_network_by_pk?: Maybe<Mutual_Group_Network>;
  /** fetch data from the table in a streaming manner : "mutual_group_network" */
  mutual_group_network_stream: Array<Mutual_Group_Network>;
  /** fetch data from the table: "mutual_group_role" */
  mutual_group_role: Array<Mutual_Group_Role>;
  /** fetch aggregated fields from the table: "mutual_group_role" */
  mutual_group_role_aggregate: Mutual_Group_Role_Aggregate;
  /** fetch data from the table: "mutual_group_role" using primary key columns */
  mutual_group_role_by_pk?: Maybe<Mutual_Group_Role>;
  /** fetch data from the table in a streaming manner : "mutual_group_role" */
  mutual_group_role_stream: Array<Mutual_Group_Role>;
  /** fetch data from the table in a streaming manner : "mutual_group" */
  mutual_group_stream: Array<Mutual_Group>;
  /** fetch data from the table: "mutual_group_subscription_package" */
  mutual_group_subscription_package: Array<Mutual_Group_Subscription_Package>;
  /** fetch aggregated fields from the table: "mutual_group_subscription_package" */
  mutual_group_subscription_package_aggregate: Mutual_Group_Subscription_Package_Aggregate;
  /** fetch data from the table: "mutual_group_subscription_package" using primary key columns */
  mutual_group_subscription_package_by_pk?: Maybe<Mutual_Group_Subscription_Package>;
  /** fetch data from the table in a streaming manner : "mutual_group_subscription_package" */
  mutual_group_subscription_package_stream: Array<Mutual_Group_Subscription_Package>;
  /** fetch data from the table: "mutual_group_weather_station" */
  mutual_group_weather_station: Array<Mutual_Group_Weather_Station>;
  /** fetch aggregated fields from the table: "mutual_group_weather_station" */
  mutual_group_weather_station_aggregate: Mutual_Group_Weather_Station_Aggregate;
  /** fetch data from the table: "mutual_group_weather_station" using primary key columns */
  mutual_group_weather_station_by_pk?: Maybe<Mutual_Group_Weather_Station>;
  /** fetch data from the table in a streaming manner : "mutual_group_weather_station" */
  mutual_group_weather_station_stream: Array<Mutual_Group_Weather_Station>;
  /** fetch data from the table: "network" */
  network: Array<Network>;
  /** fetch aggregated fields from the table: "network" */
  network_aggregate: Network_Aggregate;
  /** fetch data from the table: "network" using primary key columns */
  network_by_pk?: Maybe<Network>;
  /** fetch data from the table in a streaming manner : "network" */
  network_stream: Array<Network>;
  /** fetch data from the table: "notification" */
  notification: Array<Notification>;
  /** fetch aggregated fields from the table: "notification" */
  notification_aggregate: Notification_Aggregate;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<Notification>;
  /** fetch data from the table: "notification_category" */
  notification_category: Array<Notification_Category>;
  /** fetch aggregated fields from the table: "notification_category" */
  notification_category_aggregate: Notification_Category_Aggregate;
  /** fetch data from the table: "notification_category" using primary key columns */
  notification_category_by_pk?: Maybe<Notification_Category>;
  /** fetch data from the table in a streaming manner : "notification_category" */
  notification_category_stream: Array<Notification_Category>;
  /** fetch data from the table in a streaming manner : "notification" */
  notification_stream: Array<Notification>;
  /** fetch data from the table: "notification_template" */
  notification_template: Array<Notification_Template>;
  /** fetch aggregated fields from the table: "notification_template" */
  notification_template_aggregate: Notification_Template_Aggregate;
  /** fetch data from the table: "notification_template" using primary key columns */
  notification_template_by_pk?: Maybe<Notification_Template>;
  /** fetch data from the table: "notification_template_distribution_region" */
  notification_template_distribution_region: Array<Notification_Template_Distribution_Region>;
  /** fetch aggregated fields from the table: "notification_template_distribution_region" */
  notification_template_distribution_region_aggregate: Notification_Template_Distribution_Region_Aggregate;
  /** fetch data from the table: "notification_template_distribution_region" using primary key columns */
  notification_template_distribution_region_by_pk?: Maybe<Notification_Template_Distribution_Region>;
  /** fetch data from the table in a streaming manner : "notification_template_distribution_region" */
  notification_template_distribution_region_stream: Array<Notification_Template_Distribution_Region>;
  /** fetch data from the table: "notification_template_distribution_team" */
  notification_template_distribution_team: Array<Notification_Template_Distribution_Team>;
  /** fetch aggregated fields from the table: "notification_template_distribution_team" */
  notification_template_distribution_team_aggregate: Notification_Template_Distribution_Team_Aggregate;
  /** fetch data from the table: "notification_template_distribution_team" using primary key columns */
  notification_template_distribution_team_by_pk?: Maybe<Notification_Template_Distribution_Team>;
  /** fetch data from the table in a streaming manner : "notification_template_distribution_team" */
  notification_template_distribution_team_stream: Array<Notification_Template_Distribution_Team>;
  /** fetch data from the table: "notification_template_distribution_user" */
  notification_template_distribution_user: Array<Notification_Template_Distribution_User>;
  /** fetch aggregated fields from the table: "notification_template_distribution_user" */
  notification_template_distribution_user_aggregate: Notification_Template_Distribution_User_Aggregate;
  /** fetch data from the table: "notification_template_distribution_user" using primary key columns */
  notification_template_distribution_user_by_pk?: Maybe<Notification_Template_Distribution_User>;
  /** fetch data from the table in a streaming manner : "notification_template_distribution_user" */
  notification_template_distribution_user_stream: Array<Notification_Template_Distribution_User>;
  /** fetch data from the table in a streaming manner : "notification_template" */
  notification_template_stream: Array<Notification_Template>;
  /** fetch data from the table: "nutrients" */
  nutrients: Array<Nutrients>;
  /** fetch aggregated fields from the table: "nutrients" */
  nutrients_aggregate: Nutrients_Aggregate;
  /** fetch data from the table: "nutrients" using primary key columns */
  nutrients_by_pk?: Maybe<Nutrients>;
  /** fetch data from the table in a streaming manner : "nutrients" */
  nutrients_stream: Array<Nutrients>;
  /** fetch data from the table: "observation_notification" */
  observation_notification: Array<Observation_Notification>;
  /** fetch aggregated fields from the table: "observation_notification" */
  observation_notification_aggregate: Observation_Notification_Aggregate;
  /** fetch data from the table: "observation_notification" using primary key columns */
  observation_notification_by_pk?: Maybe<Observation_Notification>;
  /** fetch data from the table in a streaming manner : "observation_notification" */
  observation_notification_stream: Array<Observation_Notification>;
  /** An array relationship */
  operation_attachments: Array<Operation_Attachments>;
  /** An aggregate relationship */
  operation_attachments_aggregate: Operation_Attachments_Aggregate;
  /** fetch data from the table: "operation_attachments" using primary key columns */
  operation_attachments_by_pk?: Maybe<Operation_Attachments>;
  /** fetch data from the table in a streaming manner : "operation_attachments" */
  operation_attachments_stream: Array<Operation_Attachments>;
  /** fetch data from the table: "operation_cost" */
  operation_cost: Array<Operation_Cost>;
  /** fetch aggregated fields from the table: "operation_cost" */
  operation_cost_aggregate: Operation_Cost_Aggregate;
  /** fetch data from the table: "operation_cost" using primary key columns */
  operation_cost_by_pk?: Maybe<Operation_Cost>;
  /** fetch data from the table: "operation_cost_item" */
  operation_cost_item: Array<Operation_Cost_Item>;
  /** fetch aggregated fields from the table: "operation_cost_item" */
  operation_cost_item_aggregate: Operation_Cost_Item_Aggregate;
  /** fetch data from the table in a streaming manner : "operation_cost_item" */
  operation_cost_item_stream: Array<Operation_Cost_Item>;
  /** fetch data from the table in a streaming manner : "operation_cost" */
  operation_cost_stream: Array<Operation_Cost>;
  /** fetch data from the table: "operation_methods" */
  operation_methods: Array<Operation_Methods>;
  /** fetch aggregated fields from the table: "operation_methods" */
  operation_methods_aggregate: Operation_Methods_Aggregate;
  /** fetch data from the table: "operation_methods" using primary key columns */
  operation_methods_by_pk?: Maybe<Operation_Methods>;
  /** fetch data from the table in a streaming manner : "operation_methods" */
  operation_methods_stream: Array<Operation_Methods>;
  /** fetch data from the table: "operation_product_types" */
  operation_product_types: Array<Operation_Product_Types>;
  /** fetch aggregated fields from the table: "operation_product_types" */
  operation_product_types_aggregate: Operation_Product_Types_Aggregate;
  /** fetch data from the table: "operation_product_types" using primary key columns */
  operation_product_types_by_pk?: Maybe<Operation_Product_Types>;
  /** fetch data from the table in a streaming manner : "operation_product_types" */
  operation_product_types_stream: Array<Operation_Product_Types>;
  /** An array relationship */
  operations: Array<Operations>;
  /** An aggregate relationship */
  operations_aggregate: Operations_Aggregate;
  /** fetch data from the table: "operations_applied_fertiliser" */
  operations_applied_fertiliser: Array<Operations_Applied_Fertiliser>;
  /** fetch aggregated fields from the table: "operations_applied_fertiliser" */
  operations_applied_fertiliser_aggregate: Operations_Applied_Fertiliser_Aggregate;
  /** fetch data from the table: "operations_applied_fertiliser" using primary key columns */
  operations_applied_fertiliser_by_pk?: Maybe<Operations_Applied_Fertiliser>;
  /** fetch data from the table in a streaming manner : "operations_applied_fertiliser" */
  operations_applied_fertiliser_stream: Array<Operations_Applied_Fertiliser>;
  /** fetch data from the table: "operations_applied_pesticide" */
  operations_applied_pesticide: Array<Operations_Applied_Pesticide>;
  /** fetch aggregated fields from the table: "operations_applied_pesticide" */
  operations_applied_pesticide_aggregate: Operations_Applied_Pesticide_Aggregate;
  /** fetch data from the table: "operations_applied_pesticide" using primary key columns */
  operations_applied_pesticide_by_pk?: Maybe<Operations_Applied_Pesticide>;
  /** fetch data from the table in a streaming manner : "operations_applied_pesticide" */
  operations_applied_pesticide_stream: Array<Operations_Applied_Pesticide>;
  /** fetch data from the table: "operations" using primary key columns */
  operations_by_pk?: Maybe<Operations>;
  /** fetch data from the table: "operations_fertiliser" */
  operations_fertiliser: Array<Operations_Fertiliser>;
  /** fetch aggregated fields from the table: "operations_fertiliser" */
  operations_fertiliser_aggregate: Operations_Fertiliser_Aggregate;
  /** fetch data from the table: "operations_fertiliser" using primary key columns */
  operations_fertiliser_by_pk?: Maybe<Operations_Fertiliser>;
  /** fetch data from the table in a streaming manner : "operations_fertiliser" */
  operations_fertiliser_stream: Array<Operations_Fertiliser>;
  /** fetch data from the table: "operations_harvest" */
  operations_harvest: Array<Operations_Harvest>;
  /** fetch aggregated fields from the table: "operations_harvest" */
  operations_harvest_aggregate: Operations_Harvest_Aggregate;
  /** fetch data from the table: "operations_harvest" using primary key columns */
  operations_harvest_by_pk?: Maybe<Operations_Harvest>;
  /** fetch data from the table: "operations_harvest_output" */
  operations_harvest_output: Array<Operations_Harvest_Output>;
  /** fetch aggregated fields from the table: "operations_harvest_output" */
  operations_harvest_output_aggregate: Operations_Harvest_Output_Aggregate;
  /** fetch data from the table: "operations_harvest_output" using primary key columns */
  operations_harvest_output_by_pk?: Maybe<Operations_Harvest_Output>;
  /** fetch data from the table in a streaming manner : "operations_harvest_output" */
  operations_harvest_output_stream: Array<Operations_Harvest_Output>;
  /** fetch data from the table in a streaming manner : "operations_harvest" */
  operations_harvest_stream: Array<Operations_Harvest>;
  /** fetch data from the table: "operations_interculture" */
  operations_interculture: Array<Operations_Interculture>;
  /** fetch aggregated fields from the table: "operations_interculture" */
  operations_interculture_aggregate: Operations_Interculture_Aggregate;
  /** fetch data from the table: "operations_interculture" using primary key columns */
  operations_interculture_by_pk?: Maybe<Operations_Interculture>;
  /** fetch data from the table in a streaming manner : "operations_interculture" */
  operations_interculture_stream: Array<Operations_Interculture>;
  /** fetch data from the table: "operations_irrigation" */
  operations_irrigation: Array<Operations_Irrigation>;
  /** fetch aggregated fields from the table: "operations_irrigation" */
  operations_irrigation_aggregate: Operations_Irrigation_Aggregate;
  /** fetch data from the table: "operations_irrigation" using primary key columns */
  operations_irrigation_by_pk?: Maybe<Operations_Irrigation>;
  /** fetch data from the table in a streaming manner : "operations_irrigation" */
  operations_irrigation_stream: Array<Operations_Irrigation>;
  /** fetch data from the table: "operations_land_prep" */
  operations_land_prep: Array<Operations_Land_Prep>;
  /** fetch aggregated fields from the table: "operations_land_prep" */
  operations_land_prep_aggregate: Operations_Land_Prep_Aggregate;
  /** fetch data from the table: "operations_land_prep" using primary key columns */
  operations_land_prep_by_pk?: Maybe<Operations_Land_Prep>;
  /** fetch data from the table in a streaming manner : "operations_land_prep" */
  operations_land_prep_stream: Array<Operations_Land_Prep>;
  /** fetch data from the table: "operations_pesticide" */
  operations_pesticide: Array<Operations_Pesticide>;
  /** fetch aggregated fields from the table: "operations_pesticide" */
  operations_pesticide_aggregate: Operations_Pesticide_Aggregate;
  /** fetch data from the table: "operations_pesticide" using primary key columns */
  operations_pesticide_by_pk?: Maybe<Operations_Pesticide>;
  /** fetch data from the table in a streaming manner : "operations_pesticide" */
  operations_pesticide_stream: Array<Operations_Pesticide>;
  /** fetch data from the table: "operations_sowing" */
  operations_sowing: Array<Operations_Sowing>;
  /** fetch aggregated fields from the table: "operations_sowing" */
  operations_sowing_aggregate: Operations_Sowing_Aggregate;
  /** fetch data from the table: "operations_sowing" using primary key columns */
  operations_sowing_by_pk?: Maybe<Operations_Sowing>;
  /** fetch data from the table in a streaming manner : "operations_sowing" */
  operations_sowing_stream: Array<Operations_Sowing>;
  /** fetch data from the table in a streaming manner : "operations" */
  operations_stream: Array<Operations>;
  /** fetch data from the table: "organisation" */
  organisation: Array<Organisation>;
  /** fetch aggregated fields from the table: "organisation" */
  organisation_aggregate: Organisation_Aggregate;
  /** fetch data from the table: "organisation" using primary key columns */
  organisation_by_pk?: Maybe<Organisation>;
  /** fetch data from the table: "organisation_document_kind" */
  organisation_document_kind: Array<Organisation_Document_Kind>;
  /** fetch aggregated fields from the table: "organisation_document_kind" */
  organisation_document_kind_aggregate: Organisation_Document_Kind_Aggregate;
  /** fetch data from the table: "organisation_document_kind" using primary key columns */
  organisation_document_kind_by_pk?: Maybe<Organisation_Document_Kind>;
  /** fetch data from the table in a streaming manner : "organisation_document_kind" */
  organisation_document_kind_stream: Array<Organisation_Document_Kind>;
  /** fetch data from the table: "organisation_preferences" */
  organisation_preferences: Array<Organisation_Preferences>;
  /** fetch aggregated fields from the table: "organisation_preferences" */
  organisation_preferences_aggregate: Organisation_Preferences_Aggregate;
  /** fetch data from the table: "organisation_preferences" using primary key columns */
  organisation_preferences_by_pk?: Maybe<Organisation_Preferences>;
  /** fetch data from the table in a streaming manner : "organisation_preferences" */
  organisation_preferences_stream: Array<Organisation_Preferences>;
  /** fetch data from the table: "organisation_season" */
  organisation_season: Array<Organisation_Season>;
  /** fetch aggregated fields from the table: "organisation_season" */
  organisation_season_aggregate: Organisation_Season_Aggregate;
  /** fetch data from the table: "organisation_season" using primary key columns */
  organisation_season_by_pk?: Maybe<Organisation_Season>;
  /** fetch data from the table in a streaming manner : "organisation_season" */
  organisation_season_stream: Array<Organisation_Season>;
  /** fetch data from the table in a streaming manner : "organisation" */
  organisation_stream: Array<Organisation>;
  /** fetch data from the table: "payment_detail" */
  payment_detail: Array<Payment_Detail>;
  /** fetch aggregated fields from the table: "payment_detail" */
  payment_detail_aggregate: Payment_Detail_Aggregate;
  /** fetch data from the table: "payment_detail_attachments" */
  payment_detail_attachments: Array<Payment_Detail_Attachments>;
  /** fetch aggregated fields from the table: "payment_detail_attachments" */
  payment_detail_attachments_aggregate: Payment_Detail_Attachments_Aggregate;
  /** fetch data from the table: "payment_detail_attachments" using primary key columns */
  payment_detail_attachments_by_pk?: Maybe<Payment_Detail_Attachments>;
  /** fetch data from the table in a streaming manner : "payment_detail_attachments" */
  payment_detail_attachments_stream: Array<Payment_Detail_Attachments>;
  /** fetch data from the table: "payment_detail" using primary key columns */
  payment_detail_by_pk?: Maybe<Payment_Detail>;
  /** fetch data from the table in a streaming manner : "payment_detail" */
  payment_detail_stream: Array<Payment_Detail>;
  /** fetch data from the table: "payment_method" */
  payment_method: Array<Payment_Method>;
  /** fetch aggregated fields from the table: "payment_method" */
  payment_method_aggregate: Payment_Method_Aggregate;
  /** fetch data from the table: "payment_method" using primary key columns */
  payment_method_by_pk?: Maybe<Payment_Method>;
  /** fetch data from the table in a streaming manner : "payment_method" */
  payment_method_stream: Array<Payment_Method>;
  /** fetch data from the table: "plot" */
  plot: Array<Plot>;
  /** fetch aggregated fields from the table: "plot" */
  plot_aggregate: Plot_Aggregate;
  /** fetch data from the table: "plot" using primary key columns */
  plot_by_pk?: Maybe<Plot>;
  /** fetch data from the table: "plot_crop" */
  plot_crop: Array<Plot_Crop>;
  /** fetch data from the table: "plot_crop_agent" */
  plot_crop_agent: Array<Plot_Crop_Agent>;
  /** fetch aggregated fields from the table: "plot_crop_agent" */
  plot_crop_agent_aggregate: Plot_Crop_Agent_Aggregate;
  /** fetch data from the table: "plot_crop_agent" using primary key columns */
  plot_crop_agent_by_pk?: Maybe<Plot_Crop_Agent>;
  /** fetch data from the table in a streaming manner : "plot_crop_agent" */
  plot_crop_agent_stream: Array<Plot_Crop_Agent>;
  /** fetch aggregated fields from the table: "plot_crop" */
  plot_crop_aggregate: Plot_Crop_Aggregate;
  /** fetch data from the table: "plot_crop" using primary key columns */
  plot_crop_by_pk?: Maybe<Plot_Crop>;
  /** fetch data from the table: "plot_crop_milestone" */
  plot_crop_milestone: Array<Plot_Crop_Milestone>;
  /** fetch aggregated fields from the table: "plot_crop_milestone" */
  plot_crop_milestone_aggregate: Plot_Crop_Milestone_Aggregate;
  /** fetch data from the table: "plot_crop_milestone" using primary key columns */
  plot_crop_milestone_by_pk?: Maybe<Plot_Crop_Milestone>;
  /** fetch data from the table in a streaming manner : "plot_crop_milestone" */
  plot_crop_milestone_stream: Array<Plot_Crop_Milestone>;
  /** fetch data from the table: "plot_crop_network" */
  plot_crop_network: Array<Plot_Crop_Network>;
  /** fetch aggregated fields from the table: "plot_crop_network" */
  plot_crop_network_aggregate: Plot_Crop_Network_Aggregate;
  /** fetch data from the table: "plot_crop_network" using primary key columns */
  plot_crop_network_by_pk?: Maybe<Plot_Crop_Network>;
  /** fetch data from the table in a streaming manner : "plot_crop_network" */
  plot_crop_network_stream: Array<Plot_Crop_Network>;
  /** fetch data from the table in a streaming manner : "plot_crop" */
  plot_crop_stream: Array<Plot_Crop>;
  /** fetch data from the table: "plot_network" */
  plot_network: Array<Plot_Network>;
  /** fetch aggregated fields from the table: "plot_network" */
  plot_network_aggregate: Plot_Network_Aggregate;
  /** fetch data from the table: "plot_network" using primary key columns */
  plot_network_by_pk?: Maybe<Plot_Network>;
  /** fetch data from the table in a streaming manner : "plot_network" */
  plot_network_stream: Array<Plot_Network>;
  /** fetch data from the table: "plot_risk_24hour" */
  plot_risk_24hour: Array<Plot_Risk_24hour>;
  /** fetch aggregated fields from the table: "plot_risk_24hour" */
  plot_risk_24hour_aggregate: Plot_Risk_24hour_Aggregate;
  /** fetch data from the table in a streaming manner : "plot_risk_24hour" */
  plot_risk_24hour_stream: Array<Plot_Risk_24hour>;
  /** fetch data from the table: "plot_risk_total" */
  plot_risk_total: Array<Plot_Risk_Total>;
  /** fetch aggregated fields from the table: "plot_risk_total" */
  plot_risk_total_aggregate: Plot_Risk_Total_Aggregate;
  /** fetch data from the table in a streaming manner : "plot_risk_total" */
  plot_risk_total_stream: Array<Plot_Risk_Total>;
  /** fetch data from the table: "plot_status" */
  plot_status: Array<Plot_Status>;
  /** fetch aggregated fields from the table: "plot_status" */
  plot_status_aggregate: Plot_Status_Aggregate;
  /** fetch data from the table: "plot_status" using primary key columns */
  plot_status_by_pk?: Maybe<Plot_Status>;
  /** fetch data from the table in a streaming manner : "plot_status" */
  plot_status_stream: Array<Plot_Status>;
  /** fetch data from the table in a streaming manner : "plot" */
  plot_stream: Array<Plot>;
  /** fetch data from the table: "primary_growth_stage" */
  primary_growth_stage: Array<Primary_Growth_Stage>;
  /** fetch aggregated fields from the table: "primary_growth_stage" */
  primary_growth_stage_aggregate: Primary_Growth_Stage_Aggregate;
  /** fetch data from the table: "primary_growth_stage" using primary key columns */
  primary_growth_stage_by_pk?: Maybe<Primary_Growth_Stage>;
  /** fetch data from the table in a streaming manner : "primary_growth_stage" */
  primary_growth_stage_stream: Array<Primary_Growth_Stage>;
  /** fetch data from the table: "produce_insights" */
  produce_insights: Array<Produce_Insights>;
  /** fetch aggregated fields from the table: "produce_insights" */
  produce_insights_aggregate: Produce_Insights_Aggregate;
  /** fetch data from the table in a streaming manner : "produce_insights" */
  produce_insights_stream: Array<Produce_Insights>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product_attachment" */
  product_attachment: Array<Product_Attachment>;
  /** fetch aggregated fields from the table: "product_attachment" */
  product_attachment_aggregate: Product_Attachment_Aggregate;
  /** fetch data from the table: "product_attachment" using primary key columns */
  product_attachment_by_pk?: Maybe<Product_Attachment>;
  /** fetch data from the table in a streaming manner : "product_attachment" */
  product_attachment_stream: Array<Product_Attachment>;
  /** fetch data from the table: "product_attribute" */
  product_attribute: Array<Product_Attribute>;
  /** fetch aggregated fields from the table: "product_attribute" */
  product_attribute_aggregate: Product_Attribute_Aggregate;
  /** fetch data from the table: "product_attribute" using primary key columns */
  product_attribute_by_pk?: Maybe<Product_Attribute>;
  /** fetch data from the table: "product_attribute_choice" */
  product_attribute_choice: Array<Product_Attribute_Choice>;
  /** fetch aggregated fields from the table: "product_attribute_choice" */
  product_attribute_choice_aggregate: Product_Attribute_Choice_Aggregate;
  /** fetch data from the table: "product_attribute_choice" using primary key columns */
  product_attribute_choice_by_pk?: Maybe<Product_Attribute_Choice>;
  /** fetch data from the table in a streaming manner : "product_attribute_choice" */
  product_attribute_choice_stream: Array<Product_Attribute_Choice>;
  /** fetch data from the table in a streaming manner : "product_attribute" */
  product_attribute_stream: Array<Product_Attribute>;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_certification" */
  product_certification: Array<Product_Certification>;
  /** fetch aggregated fields from the table: "product_certification" */
  product_certification_aggregate: Product_Certification_Aggregate;
  /** fetch data from the table: "product_certification_attachment" */
  product_certification_attachment: Array<Product_Certification_Attachment>;
  /** fetch aggregated fields from the table: "product_certification_attachment" */
  product_certification_attachment_aggregate: Product_Certification_Attachment_Aggregate;
  /** fetch data from the table: "product_certification_attachment" using primary key columns */
  product_certification_attachment_by_pk?: Maybe<Product_Certification_Attachment>;
  /** fetch data from the table in a streaming manner : "product_certification_attachment" */
  product_certification_attachment_stream: Array<Product_Certification_Attachment>;
  /** fetch data from the table: "product_certification" using primary key columns */
  product_certification_by_pk?: Maybe<Product_Certification>;
  /** fetch data from the table in a streaming manner : "product_certification" */
  product_certification_stream: Array<Product_Certification>;
  /** fetch data from the table: "product_class" */
  product_class: Array<Product_Class>;
  /** fetch aggregated fields from the table: "product_class" */
  product_class_aggregate: Product_Class_Aggregate;
  /** fetch data from the table: "product_class" using primary key columns */
  product_class_by_pk?: Maybe<Product_Class>;
  /** fetch data from the table in a streaming manner : "product_class" */
  product_class_stream: Array<Product_Class>;
  /** fetch data from the table: "product_composition" */
  product_composition: Array<Product_Composition>;
  /** fetch aggregated fields from the table: "product_composition" */
  product_composition_aggregate: Product_Composition_Aggregate;
  /** fetch data from the table: "product_composition" using primary key columns */
  product_composition_by_pk?: Maybe<Product_Composition>;
  /** fetch data from the table in a streaming manner : "product_composition" */
  product_composition_stream: Array<Product_Composition>;
  /** fetch data from the table: "product_crop_association" */
  product_crop_association: Array<Product_Crop_Association>;
  /** fetch aggregated fields from the table: "product_crop_association" */
  product_crop_association_aggregate: Product_Crop_Association_Aggregate;
  /** fetch data from the table: "product_crop_association" using primary key columns */
  product_crop_association_by_pk?: Maybe<Product_Crop_Association>;
  /** fetch data from the table in a streaming manner : "product_crop_association" */
  product_crop_association_stream: Array<Product_Crop_Association>;
  /** fetch data from the table: "product_crop_infestation_recommendation" */
  product_crop_infestation_recommendation: Array<Product_Crop_Infestation_Recommendation>;
  /** fetch aggregated fields from the table: "product_crop_infestation_recommendation" */
  product_crop_infestation_recommendation_aggregate: Product_Crop_Infestation_Recommendation_Aggregate;
  /** fetch data from the table: "product_crop_infestation_recommendation" using primary key columns */
  product_crop_infestation_recommendation_by_pk?: Maybe<Product_Crop_Infestation_Recommendation>;
  /** fetch data from the table in a streaming manner : "product_crop_infestation_recommendation" */
  product_crop_infestation_recommendation_stream: Array<Product_Crop_Infestation_Recommendation>;
  /** fetch data from the table: "product_crop_nutrition_recommendation" */
  product_crop_nutrition_recommendation: Array<Product_Crop_Nutrition_Recommendation>;
  /** fetch aggregated fields from the table: "product_crop_nutrition_recommendation" */
  product_crop_nutrition_recommendation_aggregate: Product_Crop_Nutrition_Recommendation_Aggregate;
  /** fetch data from the table: "product_crop_nutrition_recommendation" using primary key columns */
  product_crop_nutrition_recommendation_by_pk?: Maybe<Product_Crop_Nutrition_Recommendation>;
  /** fetch data from the table in a streaming manner : "product_crop_nutrition_recommendation" */
  product_crop_nutrition_recommendation_stream: Array<Product_Crop_Nutrition_Recommendation>;
  /** fetch data from the table: "product_favourite" */
  product_favourite: Array<Product_Favourite>;
  /** fetch aggregated fields from the table: "product_favourite" */
  product_favourite_aggregate: Product_Favourite_Aggregate;
  /** fetch data from the table: "product_favourite" using primary key columns */
  product_favourite_by_pk?: Maybe<Product_Favourite>;
  /** fetch data from the table in a streaming manner : "product_favourite" */
  product_favourite_stream: Array<Product_Favourite>;
  /** fetch data from the table: "product_infestation" */
  product_infestation: Array<Product_Infestation>;
  /** fetch aggregated fields from the table: "product_infestation" */
  product_infestation_aggregate: Product_Infestation_Aggregate;
  /** fetch data from the table: "product_infestation" using primary key columns */
  product_infestation_by_pk?: Maybe<Product_Infestation>;
  /** fetch data from the table in a streaming manner : "product_infestation" */
  product_infestation_stream: Array<Product_Infestation>;
  /** fetch data from the table: "product_mainsection" */
  product_mainsection: Array<Product_Mainsection>;
  /** fetch aggregated fields from the table: "product_mainsection" */
  product_mainsection_aggregate: Product_Mainsection_Aggregate;
  /** fetch data from the table: "product_mainsection_attachment" */
  product_mainsection_attachment: Array<Product_Mainsection_Attachment>;
  /** fetch aggregated fields from the table: "product_mainsection_attachment" */
  product_mainsection_attachment_aggregate: Product_Mainsection_Attachment_Aggregate;
  /** fetch data from the table: "product_mainsection_attachment" using primary key columns */
  product_mainsection_attachment_by_pk?: Maybe<Product_Mainsection_Attachment>;
  /** fetch data from the table in a streaming manner : "product_mainsection_attachment" */
  product_mainsection_attachment_stream: Array<Product_Mainsection_Attachment>;
  /** fetch data from the table: "product_mainsection" using primary key columns */
  product_mainsection_by_pk?: Maybe<Product_Mainsection>;
  /** fetch data from the table in a streaming manner : "product_mainsection" */
  product_mainsection_stream: Array<Product_Mainsection>;
  /** An array relationship */
  product_purchased: Array<Product_Purchased>;
  /** An aggregate relationship */
  product_purchased_aggregate: Product_Purchased_Aggregate;
  /** fetch data from the table: "product_purchased" using primary key columns */
  product_purchased_by_pk?: Maybe<Product_Purchased>;
  /** fetch data from the table in a streaming manner : "product_purchased" */
  product_purchased_stream: Array<Product_Purchased>;
  /** fetch data from the table: "product_section" */
  product_section: Array<Product_Section>;
  /** fetch aggregated fields from the table: "product_section" */
  product_section_aggregate: Product_Section_Aggregate;
  /** fetch data from the table: "product_section_attachment" */
  product_section_attachment: Array<Product_Section_Attachment>;
  /** fetch aggregated fields from the table: "product_section_attachment" */
  product_section_attachment_aggregate: Product_Section_Attachment_Aggregate;
  /** fetch data from the table: "product_section_attachment" using primary key columns */
  product_section_attachment_by_pk?: Maybe<Product_Section_Attachment>;
  /** fetch data from the table in a streaming manner : "product_section_attachment" */
  product_section_attachment_stream: Array<Product_Section_Attachment>;
  /** fetch data from the table: "product_section" using primary key columns */
  product_section_by_pk?: Maybe<Product_Section>;
  /** fetch data from the table in a streaming manner : "product_section" */
  product_section_stream: Array<Product_Section>;
  /** fetch data from the table: "product_sku" */
  product_sku: Array<Product_Sku>;
  /** fetch aggregated fields from the table: "product_sku" */
  product_sku_aggregate: Product_Sku_Aggregate;
  /** fetch data from the table: "product_sku" using primary key columns */
  product_sku_by_pk?: Maybe<Product_Sku>;
  /** fetch data from the table in a streaming manner : "product_sku" */
  product_sku_stream: Array<Product_Sku>;
  /** fetch data from the table in a streaming manner : "product" */
  product_stream: Array<Product>;
  /** fetch data from the table: "product_subsection" */
  product_subsection: Array<Product_Subsection>;
  /** fetch aggregated fields from the table: "product_subsection" */
  product_subsection_aggregate: Product_Subsection_Aggregate;
  /** fetch data from the table: "product_subsection_attachment" */
  product_subsection_attachment: Array<Product_Subsection_Attachment>;
  /** fetch aggregated fields from the table: "product_subsection_attachment" */
  product_subsection_attachment_aggregate: Product_Subsection_Attachment_Aggregate;
  /** fetch data from the table: "product_subsection_attachment" using primary key columns */
  product_subsection_attachment_by_pk?: Maybe<Product_Subsection_Attachment>;
  /** fetch data from the table in a streaming manner : "product_subsection_attachment" */
  product_subsection_attachment_stream: Array<Product_Subsection_Attachment>;
  /** fetch data from the table: "product_subsection" using primary key columns */
  product_subsection_by_pk?: Maybe<Product_Subsection>;
  /** fetch data from the table in a streaming manner : "product_subsection" */
  product_subsection_stream: Array<Product_Subsection>;
  /** fetch data from the table: "product_view" */
  product_view: Array<Product_View>;
  /** fetch aggregated fields from the table: "product_view" */
  product_view_aggregate: Product_View_Aggregate;
  /** fetch data from the table: "product_view" using primary key columns */
  product_view_by_pk?: Maybe<Product_View>;
  /** fetch data from the table in a streaming manner : "product_view" */
  product_view_stream: Array<Product_View>;
  /** An array relationship */
  products: Array<Products>;
  /** An aggregate relationship */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table: "products_fertiliser" */
  products_fertiliser: Array<Products_Fertiliser>;
  /** fetch aggregated fields from the table: "products_fertiliser" */
  products_fertiliser_aggregate: Products_Fertiliser_Aggregate;
  /** fetch data from the table: "products_fertiliser" using primary key columns */
  products_fertiliser_by_pk?: Maybe<Products_Fertiliser>;
  /** An array relationship */
  products_fertiliser_contents: Array<Products_Fertiliser_Contents>;
  /** An aggregate relationship */
  products_fertiliser_contents_aggregate: Products_Fertiliser_Contents_Aggregate;
  /** fetch data from the table: "products_fertiliser_contents" using primary key columns */
  products_fertiliser_contents_by_pk?: Maybe<Products_Fertiliser_Contents>;
  /** fetch data from the table in a streaming manner : "products_fertiliser_contents" */
  products_fertiliser_contents_stream: Array<Products_Fertiliser_Contents>;
  /** fetch data from the table in a streaming manner : "products_fertiliser" */
  products_fertiliser_stream: Array<Products_Fertiliser>;
  /** An array relationship */
  products_fertiliser_units: Array<Products_Fertiliser_Units>;
  /** An aggregate relationship */
  products_fertiliser_units_aggregate: Products_Fertiliser_Units_Aggregate;
  /** fetch data from the table: "products_fertiliser_units" using primary key columns */
  products_fertiliser_units_by_pk?: Maybe<Products_Fertiliser_Units>;
  /** fetch data from the table in a streaming manner : "products_fertiliser_units" */
  products_fertiliser_units_stream: Array<Products_Fertiliser_Units>;
  /** fetch data from the table: "products_pesticide" */
  products_pesticide: Array<Products_Pesticide>;
  /** fetch aggregated fields from the table: "products_pesticide" */
  products_pesticide_aggregate: Products_Pesticide_Aggregate;
  /** fetch data from the table: "products_pesticide" using primary key columns */
  products_pesticide_by_pk?: Maybe<Products_Pesticide>;
  /** An array relationship */
  products_pesticide_contents: Array<Products_Pesticide_Contents>;
  /** An aggregate relationship */
  products_pesticide_contents_aggregate: Products_Pesticide_Contents_Aggregate;
  /** fetch data from the table: "products_pesticide_contents" using primary key columns */
  products_pesticide_contents_by_pk?: Maybe<Products_Pesticide_Contents>;
  /** fetch data from the table in a streaming manner : "products_pesticide_contents" */
  products_pesticide_contents_stream: Array<Products_Pesticide_Contents>;
  /** fetch data from the table in a streaming manner : "products_pesticide" */
  products_pesticide_stream: Array<Products_Pesticide>;
  /** An array relationship */
  products_pesticide_units: Array<Products_Pesticide_Units>;
  /** An aggregate relationship */
  products_pesticide_units_aggregate: Products_Pesticide_Units_Aggregate;
  /** fetch data from the table: "products_pesticide_units" using primary key columns */
  products_pesticide_units_by_pk?: Maybe<Products_Pesticide_Units>;
  /** fetch data from the table in a streaming manner : "products_pesticide_units" */
  products_pesticide_units_stream: Array<Products_Pesticide_Units>;
  /** fetch data from the table in a streaming manner : "products" */
  products_stream: Array<Products>;
  /** fetch data from the table: "provider" */
  provider: Array<Provider>;
  /** fetch aggregated fields from the table: "provider" */
  provider_aggregate: Provider_Aggregate;
  /** fetch data from the table: "provider" using primary key columns */
  provider_by_pk?: Maybe<Provider>;
  /** fetch data from the table in a streaming manner : "provider" */
  provider_stream: Array<Provider>;
  /** fetch data from the table: "receipt" */
  receipt: Array<Receipt>;
  /** fetch aggregated fields from the table: "receipt" */
  receipt_aggregate: Receipt_Aggregate;
  /** fetch data from the table: "receipt" using primary key columns */
  receipt_by_pk?: Maybe<Receipt>;
  /** fetch data from the table in a streaming manner : "receipt" */
  receipt_stream: Array<Receipt>;
  /** fetch data from the table: "recommended_product" */
  recommended_product: Array<Recommended_Product>;
  /** fetch aggregated fields from the table: "recommended_product" */
  recommended_product_aggregate: Recommended_Product_Aggregate;
  /** fetch data from the table: "recommended_product" using primary key columns */
  recommended_product_by_pk?: Maybe<Recommended_Product>;
  /** fetch data from the table in a streaming manner : "recommended_product" */
  recommended_product_stream: Array<Recommended_Product>;
  /** fetch data from the table: "region" */
  region: Array<Region>;
  /** fetch aggregated fields from the table: "region" */
  region_aggregate: Region_Aggregate;
  /** fetch data from the table: "region" using primary key columns */
  region_by_pk?: Maybe<Region>;
  /** fetch data from the table: "region_group" */
  region_group: Array<Region_Group>;
  /** fetch aggregated fields from the table: "region_group" */
  region_group_aggregate: Region_Group_Aggregate;
  /** fetch data from the table: "region_group" using primary key columns */
  region_group_by_pk?: Maybe<Region_Group>;
  /** fetch data from the table in a streaming manner : "region_group" */
  region_group_stream: Array<Region_Group>;
  /** fetch data from the table in a streaming manner : "region" */
  region_stream: Array<Region>;
  /** fetch data from the table: "reward_configuration" */
  reward_configuration: Array<Reward_Configuration>;
  /** fetch aggregated fields from the table: "reward_configuration" */
  reward_configuration_aggregate: Reward_Configuration_Aggregate;
  /** fetch data from the table: "reward_configuration" using primary key columns */
  reward_configuration_by_pk?: Maybe<Reward_Configuration>;
  /** fetch data from the table in a streaming manner : "reward_configuration" */
  reward_configuration_stream: Array<Reward_Configuration>;
  /** fetch data from the table: "sap_si" */
  sap_si: Array<Sap_Si>;
  /** fetch aggregated fields from the table: "sap_si" */
  sap_si_aggregate: Sap_Si_Aggregate;
  /** fetch data from the table: "sap_si" using primary key columns */
  sap_si_by_pk?: Maybe<Sap_Si>;
  /** fetch data from the table: "sap_si_map" */
  sap_si_map: Array<Sap_Si_Map>;
  /** fetch aggregated fields from the table: "sap_si_map" */
  sap_si_map_aggregate: Sap_Si_Map_Aggregate;
  /** fetch data from the table: "sap_si_map" using primary key columns */
  sap_si_map_by_pk?: Maybe<Sap_Si_Map>;
  /** fetch data from the table in a streaming manner : "sap_si_map" */
  sap_si_map_stream: Array<Sap_Si_Map>;
  /** fetch data from the table in a streaming manner : "sap_si" */
  sap_si_stream: Array<Sap_Si>;
  /** execute function "search_base_users" which returns "base_user" */
  search_base_users: Array<Base_User>;
  /** execute function "search_base_users" and query aggregates on result of table type "base_user" */
  search_base_users_aggregate: Base_User_Aggregate;
  /** execute function "search_mutual_groups" which returns "mutual_group" */
  search_mutual_groups: Array<Mutual_Group>;
  /** execute function "search_mutual_groups" and query aggregates on result of table type "mutual_group" */
  search_mutual_groups_aggregate: Mutual_Group_Aggregate;
  /** execute function "search_plot_crops" which returns "plot_crop" */
  search_plot_crops: Array<Plot_Crop>;
  /** execute function "search_plot_crops" and query aggregates on result of table type "plot_crop" */
  search_plot_crops_aggregate: Plot_Crop_Aggregate;
  /** fetch data from the table: "secondary_growth_stage" */
  secondary_growth_stage: Array<Secondary_Growth_Stage>;
  /** fetch aggregated fields from the table: "secondary_growth_stage" */
  secondary_growth_stage_aggregate: Secondary_Growth_Stage_Aggregate;
  /** fetch data from the table: "secondary_growth_stage" using primary key columns */
  secondary_growth_stage_by_pk?: Maybe<Secondary_Growth_Stage>;
  /** fetch data from the table in a streaming manner : "secondary_growth_stage" */
  secondary_growth_stage_stream: Array<Secondary_Growth_Stage>;
  /** fetch data from the table: "section" */
  section: Array<Section>;
  /** fetch aggregated fields from the table: "section" */
  section_aggregate: Section_Aggregate;
  /** fetch data from the table: "section" using primary key columns */
  section_by_pk?: Maybe<Section>;
  /** fetch data from the table in a streaming manner : "section" */
  section_stream: Array<Section>;
  /** fetch data from the table: "seeds" */
  seeds: Array<Seeds>;
  /** fetch aggregated fields from the table: "seeds" */
  seeds_aggregate: Seeds_Aggregate;
  /** fetch data from the table: "seeds" using primary key columns */
  seeds_by_pk?: Maybe<Seeds>;
  /** fetch data from the table in a streaming manner : "seeds" */
  seeds_stream: Array<Seeds>;
  /** fetch data from the table: "sellable_item" */
  sellable_item: Array<Sellable_Item>;
  /** fetch aggregated fields from the table: "sellable_item" */
  sellable_item_aggregate: Sellable_Item_Aggregate;
  /** fetch data from the table: "sellable_item" using primary key columns */
  sellable_item_by_pk?: Maybe<Sellable_Item>;
  /** fetch data from the table: "sellable_item_stock" */
  sellable_item_stock: Array<Sellable_Item_Stock>;
  /** fetch aggregated fields from the table: "sellable_item_stock" */
  sellable_item_stock_aggregate: Sellable_Item_Stock_Aggregate;
  /** fetch data from the table: "sellable_item_stock" using primary key columns */
  sellable_item_stock_by_pk?: Maybe<Sellable_Item_Stock>;
  /** fetch data from the table in a streaming manner : "sellable_item_stock" */
  sellable_item_stock_stream: Array<Sellable_Item_Stock>;
  /** fetch data from the table in a streaming manner : "sellable_item" */
  sellable_item_stream: Array<Sellable_Item>;
  /** fetch data from the table: "sensor" */
  sensor: Array<Sensor>;
  /** fetch aggregated fields from the table: "sensor" */
  sensor_aggregate: Sensor_Aggregate;
  /** fetch data from the table: "sensor" using primary key columns */
  sensor_by_pk?: Maybe<Sensor>;
  /** fetch data from the table: "sensor_parameter" */
  sensor_parameter: Array<Sensor_Parameter>;
  /** fetch aggregated fields from the table: "sensor_parameter" */
  sensor_parameter_aggregate: Sensor_Parameter_Aggregate;
  /** fetch data from the table: "sensor_parameter" using primary key columns */
  sensor_parameter_by_pk?: Maybe<Sensor_Parameter>;
  /** fetch data from the table in a streaming manner : "sensor_parameter" */
  sensor_parameter_stream: Array<Sensor_Parameter>;
  /** fetch data from the table in a streaming manner : "sensor" */
  sensor_stream: Array<Sensor>;
  /** An array relationship */
  series: Array<Series>;
  /** An aggregate relationship */
  series_aggregate: Series_Aggregate;
  /** An array relationship */
  series_authors: Array<Series_Authors>;
  /** An aggregate relationship */
  series_authors_aggregate: Series_Authors_Aggregate;
  /** fetch data from the table: "series_authors" using primary key columns */
  series_authors_by_pk?: Maybe<Series_Authors>;
  /** fetch data from the table in a streaming manner : "series_authors" */
  series_authors_stream: Array<Series_Authors>;
  /** fetch data from the table: "series" using primary key columns */
  series_by_pk?: Maybe<Series>;
  /** fetch data from the table: "series_category" */
  series_category: Array<Series_Category>;
  /** fetch aggregated fields from the table: "series_category" */
  series_category_aggregate: Series_Category_Aggregate;
  /** fetch data from the table: "series_category" using primary key columns */
  series_category_by_pk?: Maybe<Series_Category>;
  /** fetch data from the table in a streaming manner : "series_category" */
  series_category_stream: Array<Series_Category>;
  /** An array relationship */
  series_crops: Array<Series_Crops>;
  /** An aggregate relationship */
  series_crops_aggregate: Series_Crops_Aggregate;
  /** fetch data from the table: "series_crops" using primary key columns */
  series_crops_by_pk?: Maybe<Series_Crops>;
  /** fetch data from the table in a streaming manner : "series_crops" */
  series_crops_stream: Array<Series_Crops>;
  /** An array relationship */
  series_favorites: Array<Series_Favorites>;
  /** An aggregate relationship */
  series_favorites_aggregate: Series_Favorites_Aggregate;
  /** fetch data from the table: "series_favorites" using primary key columns */
  series_favorites_by_pk?: Maybe<Series_Favorites>;
  /** fetch data from the table in a streaming manner : "series_favorites" */
  series_favorites_stream: Array<Series_Favorites>;
  /** An array relationship */
  series_likes: Array<Series_Likes>;
  /** An aggregate relationship */
  series_likes_aggregate: Series_Likes_Aggregate;
  /** fetch data from the table: "series_likes" using primary key columns */
  series_likes_by_pk?: Maybe<Series_Likes>;
  /** fetch data from the table in a streaming manner : "series_likes" */
  series_likes_stream: Array<Series_Likes>;
  /** fetch data from the table in a streaming manner : "series" */
  series_stream: Array<Series>;
  /** fetch data from the table: "shared_entity" */
  setu_trade_shared_entity: Array<Setu_Trade_Shared_Entity>;
  /** fetch data from the table: "shared_entity" using primary key columns */
  setu_trade_shared_entity_by_pk?: Maybe<Setu_Trade_Shared_Entity>;
  /** fetch data from the table in a streaming manner : "shared_entity" */
  setu_trade_shared_entity_stream: Array<Setu_Trade_Shared_Entity>;
  /** fetch data from the table: "setu_weather_user" */
  setu_weather_user: Array<Setu_Weather_User>;
  /** fetch aggregated fields from the table: "setu_weather_user" */
  setu_weather_user_aggregate: Setu_Weather_User_Aggregate;
  /** fetch data from the table: "setu_weather_user" using primary key columns */
  setu_weather_user_by_pk?: Maybe<Setu_Weather_User>;
  /** fetch data from the table in a streaming manner : "setu_weather_user" */
  setu_weather_user_stream: Array<Setu_Weather_User>;
  /** fetch data from the table: "shared_entity" */
  shared_entity: Array<Shared_Entity>;
  /** fetch aggregated fields from the table: "shared_entity" */
  shared_entity_aggregate: Shared_Entity_Aggregate;
  /** fetch data from the table: "shared_entity" using primary key columns */
  shared_entity_by_pk?: Maybe<Shared_Entity>;
  /** fetch data from the table in a streaming manner : "shared_entity" */
  shared_entity_stream: Array<Shared_Entity>;
  /** fetch data from the table: "si_unit" */
  si_unit: Array<Si_Unit>;
  /** fetch aggregated fields from the table: "si_unit" */
  si_unit_aggregate: Si_Unit_Aggregate;
  /** fetch data from the table: "si_unit" using primary key columns */
  si_unit_by_pk?: Maybe<Si_Unit>;
  /** fetch data from the table: "si_unit_measure" */
  si_unit_measure: Array<Si_Unit_Measure>;
  /** fetch aggregated fields from the table: "si_unit_measure" */
  si_unit_measure_aggregate: Si_Unit_Measure_Aggregate;
  /** fetch data from the table: "si_unit_measure" using primary key columns */
  si_unit_measure_by_pk?: Maybe<Si_Unit_Measure>;
  /** fetch data from the table in a streaming manner : "si_unit_measure" */
  si_unit_measure_stream: Array<Si_Unit_Measure>;
  /** fetch data from the table in a streaming manner : "si_unit" */
  si_unit_stream: Array<Si_Unit>;
  /** fetch data from the table: "sku" */
  sku: Array<Sku>;
  /** fetch aggregated fields from the table: "sku" */
  sku_aggregate: Sku_Aggregate;
  /** fetch data from the table: "sku" using primary key columns */
  sku_by_pk?: Maybe<Sku>;
  /** fetch data from the table: "sku_kind" */
  sku_kind: Array<Sku_Kind>;
  /** fetch aggregated fields from the table: "sku_kind" */
  sku_kind_aggregate: Sku_Kind_Aggregate;
  /** fetch data from the table: "sku_kind" using primary key columns */
  sku_kind_by_pk?: Maybe<Sku_Kind>;
  /** fetch data from the table in a streaming manner : "sku_kind" */
  sku_kind_stream: Array<Sku_Kind>;
  /** fetch data from the table in a streaming manner : "sku" */
  sku_stream: Array<Sku>;
  /** fetch data from the table: "soil" */
  soil: Array<Soil>;
  /** fetch aggregated fields from the table: "soil" */
  soil_aggregate: Soil_Aggregate;
  /** fetch data from the table: "soil" using primary key columns */
  soil_by_pk?: Maybe<Soil>;
  /** fetch data from the table in a streaming manner : "soil" */
  soil_stream: Array<Soil>;
  /** fetch data from the table: "sprinkler_irrigation_system" */
  sprinkler_irrigation_system: Array<Sprinkler_Irrigation_System>;
  /** fetch aggregated fields from the table: "sprinkler_irrigation_system" */
  sprinkler_irrigation_system_aggregate: Sprinkler_Irrigation_System_Aggregate;
  /** fetch data from the table: "sprinkler_irrigation_system" using primary key columns */
  sprinkler_irrigation_system_by_pk?: Maybe<Sprinkler_Irrigation_System>;
  /** fetch data from the table in a streaming manner : "sprinkler_irrigation_system" */
  sprinkler_irrigation_system_stream: Array<Sprinkler_Irrigation_System>;
  /** fetch data from the table: "sub_section" */
  sub_section: Array<Sub_Section>;
  /** fetch aggregated fields from the table: "sub_section" */
  sub_section_aggregate: Sub_Section_Aggregate;
  /** fetch data from the table: "sub_section" using primary key columns */
  sub_section_by_pk?: Maybe<Sub_Section>;
  /** fetch data from the table in a streaming manner : "sub_section" */
  sub_section_stream: Array<Sub_Section>;
  /** fetch data from the table: "subcategory" */
  subcategory: Array<Subcategory>;
  /** fetch aggregated fields from the table: "subcategory" */
  subcategory_aggregate: Subcategory_Aggregate;
  /** fetch data from the table: "subcategory" using primary key columns */
  subcategory_by_pk?: Maybe<Subcategory>;
  /** fetch data from the table in a streaming manner : "subcategory" */
  subcategory_stream: Array<Subcategory>;
  /** An array relationship */
  subscription_package_highlights: Array<Subscription_Package_Highlights>;
  /** An aggregate relationship */
  subscription_package_highlights_aggregate: Subscription_Package_Highlights_Aggregate;
  /** fetch data from the table: "subscription_package_highlights" using primary key columns */
  subscription_package_highlights_by_pk?: Maybe<Subscription_Package_Highlights>;
  /** fetch data from the table in a streaming manner : "subscription_package_highlights" */
  subscription_package_highlights_stream: Array<Subscription_Package_Highlights>;
  /** fetch data from the table: "summary_sensor_reading" */
  summary_sensor_reading: Array<Summary_Sensor_Reading>;
  /** fetch aggregated fields from the table: "summary_sensor_reading" */
  summary_sensor_reading_aggregate: Summary_Sensor_Reading_Aggregate;
  /** fetch data from the table: "summary_sensor_reading" using primary key columns */
  summary_sensor_reading_by_pk?: Maybe<Summary_Sensor_Reading>;
  /** fetch data from the table in a streaming manner : "summary_sensor_reading" */
  summary_sensor_reading_stream: Array<Summary_Sensor_Reading>;
  /** fetch data from the table: "thread" */
  thread: Array<Thread>;
  /** fetch aggregated fields from the table: "thread" */
  thread_aggregate: Thread_Aggregate;
  /** fetch data from the table: "thread" using primary key columns */
  thread_by_pk?: Maybe<Thread>;
  /** fetch data from the table in a streaming manner : "thread" */
  thread_stream: Array<Thread>;
  /** fetch data from the table: "trade" */
  trade: Array<Trade>;
  /** fetch data from the table: "action_log" */
  trade_action_log: Array<Trade_Action_Log>;
  /** fetch data from the table: "action_log" using primary key columns */
  trade_action_log_by_pk?: Maybe<Trade_Action_Log>;
  /** fetch data from the table in a streaming manner : "action_log" */
  trade_action_log_stream: Array<Trade_Action_Log>;
  /** fetch aggregated fields from the table: "trade" */
  trade_aggregate: Trade_Aggregate;
  /** fetch data from the table: "trade" using primary key columns */
  trade_by_pk?: Maybe<Trade>;
  /** fetch data from the table: "trade_commodity" */
  trade_commodity: Array<Trade_Commodity>;
  /** fetch aggregated fields from the table: "trade_commodity" */
  trade_commodity_aggregate: Trade_Commodity_Aggregate;
  /** fetch data from the table: "trade_commodity" using primary key columns */
  trade_commodity_by_pk?: Maybe<Trade_Commodity>;
  /** fetch data from the table in a streaming manner : "trade_commodity" */
  trade_commodity_stream: Array<Trade_Commodity>;
  /** fetch data from the table: "trade_item" */
  trade_item: Array<Trade_Item>;
  /** fetch aggregated fields from the table: "trade_item" */
  trade_item_aggregate: Trade_Item_Aggregate;
  /** fetch data from the table: "trade_item" using primary key columns */
  trade_item_by_pk?: Maybe<Trade_Item>;
  /** fetch data from the table in a streaming manner : "trade_item" */
  trade_item_stream: Array<Trade_Item>;
  /** fetch data from the table: "trade_region" */
  trade_region: Array<Trade_Region>;
  /** fetch aggregated fields from the table: "trade_region" */
  trade_region_aggregate: Trade_Region_Aggregate;
  /** fetch data from the table: "trade_region" using primary key columns */
  trade_region_by_pk?: Maybe<Trade_Region>;
  /** fetch data from the table in a streaming manner : "trade_region" */
  trade_region_stream: Array<Trade_Region>;
  /** fetch data from the table: "trade_status" */
  trade_status: Array<Trade_Status>;
  /** fetch data from the table: "trade_status" using primary key columns */
  trade_status_by_pk?: Maybe<Trade_Status>;
  /** fetch data from the table in a streaming manner : "trade_status" */
  trade_status_stream: Array<Trade_Status>;
  /** fetch data from the table in a streaming manner : "trade" */
  trade_stream: Array<Trade>;
  /** fetch data from the table: "trade_tradestatusaccess" */
  trade_tradestatusaccess: Array<Trade_Tradestatusaccess>;
  /** fetch data from the table: "trade_tradestatusaccess" using primary key columns */
  trade_tradestatusaccess_by_pk?: Maybe<Trade_Tradestatusaccess>;
  /** fetch data from the table in a streaming manner : "trade_tradestatusaccess" */
  trade_tradestatusaccess_stream: Array<Trade_Tradestatusaccess>;
  /** fetch data from the table: "trade_transaction" */
  trade_transaction: Array<Trade_Transaction>;
  /** fetch aggregated fields from the table: "trade_transaction" */
  trade_transaction_aggregate: Trade_Transaction_Aggregate;
  /** fetch data from the table: "trade_transaction" using primary key columns */
  trade_transaction_by_pk?: Maybe<Trade_Transaction>;
  /** fetch data from the table in a streaming manner : "trade_transaction" */
  trade_transaction_stream: Array<Trade_Transaction>;
  /** fetch data from the table: "trade_transaction_summary" */
  trade_transaction_summary: Array<Trade_Transaction_Summary>;
  /** fetch aggregated fields from the table: "trade_transaction_summary" */
  trade_transaction_summary_aggregate: Trade_Transaction_Summary_Aggregate;
  /** fetch data from the table: "trade_transaction_summary" using primary key columns */
  trade_transaction_summary_by_pk?: Maybe<Trade_Transaction_Summary>;
  /** fetch data from the table in a streaming manner : "trade_transaction_summary" */
  trade_transaction_summary_stream: Array<Trade_Transaction_Summary>;
  /** fetch data from the table: "trade_unit" */
  trade_unit: Array<Trade_Unit>;
  /** fetch aggregated fields from the table: "trade_unit" */
  trade_unit_aggregate: Trade_Unit_Aggregate;
  /** fetch data from the table: "trade_unit" using primary key columns */
  trade_unit_by_pk?: Maybe<Trade_Unit>;
  /** fetch data from the table in a streaming manner : "trade_unit" */
  trade_unit_stream: Array<Trade_Unit>;
  /** fetch data from the table: "transaction_trend" */
  transaction_trend: Array<Transaction_Trend>;
  /** fetch aggregated fields from the table: "transaction_trend" */
  transaction_trend_aggregate: Transaction_Trend_Aggregate;
  /** fetch data from the table: "transaction_trend" using primary key columns */
  transaction_trend_by_pk?: Maybe<Transaction_Trend>;
  /** fetch data from the table in a streaming manner : "transaction_trend" */
  transaction_trend_stream: Array<Transaction_Trend>;
  /** fetch data from the table: "unit" */
  unit: Array<Unit>;
  /** fetch aggregated fields from the table: "unit" */
  unit_aggregate: Unit_Aggregate;
  /** fetch data from the table: "unit" using primary key columns */
  unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table in a streaming manner : "unit" */
  unit_stream: Array<Unit>;
  /** An array relationship */
  user_answer_choices: Array<User_Answer_Choices>;
  /** An aggregate relationship */
  user_answer_choices_aggregate: User_Answer_Choices_Aggregate;
  /** fetch data from the table: "user_answer_choices" using primary key columns */
  user_answer_choices_by_pk?: Maybe<User_Answer_Choices>;
  /** fetch data from the table in a streaming manner : "user_answer_choices" */
  user_answer_choices_stream: Array<User_Answer_Choices>;
  /** fetch data from the table: "user_assessment_attempt" */
  user_assessment_attempt: Array<User_Assessment_Attempt>;
  /** fetch aggregated fields from the table: "user_assessment_attempt" */
  user_assessment_attempt_aggregate: User_Assessment_Attempt_Aggregate;
  /** fetch data from the table: "user_assessment_attempt" using primary key columns */
  user_assessment_attempt_by_pk?: Maybe<User_Assessment_Attempt>;
  /** fetch data from the table in a streaming manner : "user_assessment_attempt" */
  user_assessment_attempt_stream: Array<User_Assessment_Attempt>;
  /** fetch data from the table: "user_assessment_question_response" */
  user_assessment_question_response: Array<User_Assessment_Question_Response>;
  /** fetch aggregated fields from the table: "user_assessment_question_response" */
  user_assessment_question_response_aggregate: User_Assessment_Question_Response_Aggregate;
  /** fetch data from the table: "user_assessment_question_response" using primary key columns */
  user_assessment_question_response_by_pk?: Maybe<User_Assessment_Question_Response>;
  /** fetch data from the table in a streaming manner : "user_assessment_question_response" */
  user_assessment_question_response_stream: Array<User_Assessment_Question_Response>;
  /** fetch data from the table: "user_reward_history" */
  user_reward_history: Array<User_Reward_History>;
  /** fetch aggregated fields from the table: "user_reward_history" */
  user_reward_history_aggregate: User_Reward_History_Aggregate;
  /** fetch data from the table: "user_reward_history" using primary key columns */
  user_reward_history_by_pk?: Maybe<User_Reward_History>;
  /** fetch data from the table in a streaming manner : "user_reward_history" */
  user_reward_history_stream: Array<User_Reward_History>;
  /** fetch data from the table: "user_subscription_package" */
  user_subscription_package: Array<User_Subscription_Package>;
  /** fetch aggregated fields from the table: "user_subscription_package" */
  user_subscription_package_aggregate: User_Subscription_Package_Aggregate;
  /** fetch data from the table: "user_subscription_package" using primary key columns */
  user_subscription_package_by_pk?: Maybe<User_Subscription_Package>;
  /** fetch data from the table in a streaming manner : "user_subscription_package" */
  user_subscription_package_stream: Array<User_Subscription_Package>;
  /** fetch data from the table: "variety_grade" */
  variety_grade: Array<Variety_Grade>;
  /** fetch aggregated fields from the table: "variety_grade" */
  variety_grade_aggregate: Variety_Grade_Aggregate;
  /** fetch data from the table: "variety_grade" using primary key columns */
  variety_grade_by_pk?: Maybe<Variety_Grade>;
  /** fetch data from the table: "variety_grade_photos" */
  variety_grade_photos: Array<Variety_Grade_Photos>;
  /** fetch aggregated fields from the table: "variety_grade_photos" */
  variety_grade_photos_aggregate: Variety_Grade_Photos_Aggregate;
  /** fetch data from the table: "variety_grade_photos" using primary key columns */
  variety_grade_photos_by_pk?: Maybe<Variety_Grade_Photos>;
  /** fetch data from the table in a streaming manner : "variety_grade_photos" */
  variety_grade_photos_stream: Array<Variety_Grade_Photos>;
  /** fetch data from the table in a streaming manner : "variety_grade" */
  variety_grade_stream: Array<Variety_Grade>;
  /** fetch data from the table: "variety_group" */
  variety_group: Array<Variety_Group>;
  /** fetch aggregated fields from the table: "variety_group" */
  variety_group_aggregate: Variety_Group_Aggregate;
  /** fetch data from the table: "variety_group" using primary key columns */
  variety_group_by_pk?: Maybe<Variety_Group>;
  /** fetch data from the table in a streaming manner : "variety_group" */
  variety_group_stream: Array<Variety_Group>;
  /** fetch data from the table: "weather_location" */
  weather_location: Array<Weather_Location>;
  /** fetch aggregated fields from the table: "weather_location" */
  weather_location_aggregate: Weather_Location_Aggregate;
  /** fetch data from the table: "weather_location" using primary key columns */
  weather_location_by_pk?: Maybe<Weather_Location>;
  /** fetch data from the table in a streaming manner : "weather_location" */
  weather_location_stream: Array<Weather_Location>;
  /** fetch data from the table: "weather_reference" */
  weather_reference: Array<Weather_Reference>;
  /** fetch aggregated fields from the table: "weather_reference" */
  weather_reference_aggregate: Weather_Reference_Aggregate;
  /** fetch data from the table: "weather_reference" using primary key columns */
  weather_reference_by_pk?: Maybe<Weather_Reference>;
  /** fetch data from the table in a streaming manner : "weather_reference" */
  weather_reference_stream: Array<Weather_Reference>;
};


export type Subscription_RootAction_LogArgs = {
  distinct_on?: InputMaybe<Array<Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Action_Log_Order_By>>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};


export type Subscription_RootAction_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Action_Log_Order_By>>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};


export type Subscription_RootAction_Log_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAction_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Action_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};


export type Subscription_RootActive_IngredientArgs = {
  distinct_on?: InputMaybe<Array<Active_Ingredient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Ingredient_Order_By>>;
  where?: InputMaybe<Active_Ingredient_Bool_Exp>;
};


export type Subscription_RootActive_Ingredient_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_Ingredient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Ingredient_Order_By>>;
  where?: InputMaybe<Active_Ingredient_Bool_Exp>;
};


export type Subscription_RootActive_Ingredient_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootActive_Ingredient_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Active_Ingredient_Stream_Cursor_Input>>;
  where?: InputMaybe<Active_Ingredient_Bool_Exp>;
};


export type Subscription_RootActual_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Actual_Reading_Order_By>>;
  where?: InputMaybe<Actual_Reading_Bool_Exp>;
};


export type Subscription_RootActual_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Actual_Reading_Order_By>>;
  where?: InputMaybe<Actual_Reading_Bool_Exp>;
};


export type Subscription_RootActual_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootActual_Reading_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Actual_Reading_Stream_Cursor_Input>>;
  where?: InputMaybe<Actual_Reading_Bool_Exp>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAdvice_Author_FollowersArgs = {
  distinct_on?: InputMaybe<Array<Advice_Author_Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Author_Followers_Order_By>>;
  where?: InputMaybe<Advice_Author_Followers_Bool_Exp>;
};


export type Subscription_RootAdvice_Author_Followers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advice_Author_Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Author_Followers_Order_By>>;
  where?: InputMaybe<Advice_Author_Followers_Bool_Exp>;
};


export type Subscription_RootAdvice_Author_Followers_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootAdvice_Author_Followers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Advice_Author_Followers_Stream_Cursor_Input>>;
  where?: InputMaybe<Advice_Author_Followers_Bool_Exp>;
};


export type Subscription_RootAdvice_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Advice_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Authors_Order_By>>;
  where?: InputMaybe<Advice_Authors_Bool_Exp>;
};


export type Subscription_RootAdvice_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advice_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advice_Authors_Order_By>>;
  where?: InputMaybe<Advice_Authors_Bool_Exp>;
};


export type Subscription_RootAdvice_Authors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAdvice_Authors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Advice_Authors_Stream_Cursor_Input>>;
  where?: InputMaybe<Advice_Authors_Bool_Exp>;
};


export type Subscription_RootAgentArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


export type Subscription_RootAgent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


export type Subscription_RootAgent_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgent_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


export type Subscription_RootAgent_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


export type Subscription_RootAgent_Company_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgent_Company_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agent_Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


export type Subscription_RootAgent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agent_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


export type Subscription_RootAnswer_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Answer_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Answer_Choice_Order_By>>;
  where?: InputMaybe<Answer_Choice_Bool_Exp>;
};


export type Subscription_RootAnswer_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Answer_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Answer_Choice_Order_By>>;
  where?: InputMaybe<Answer_Choice_Bool_Exp>;
};


export type Subscription_RootAnswer_Choice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAnswer_Choice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Answer_Choice_Stream_Cursor_Input>>;
  where?: InputMaybe<Answer_Choice_Bool_Exp>;
};


export type Subscription_RootApplication_Product_UnitArgs = {
  distinct_on?: InputMaybe<Array<Application_Product_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Product_Unit_Order_By>>;
  where?: InputMaybe<Application_Product_Unit_Bool_Exp>;
};


export type Subscription_RootApplication_Product_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Product_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Product_Unit_Order_By>>;
  where?: InputMaybe<Application_Product_Unit_Bool_Exp>;
};


export type Subscription_RootApplication_Product_Unit_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootApplication_Product_Unit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Application_Product_Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Application_Product_Unit_Bool_Exp>;
};


export type Subscription_RootArticleArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Subscription_RootArticle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Subscription_RootArticle_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Article_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Attachments_Order_By>>;
  where?: InputMaybe<Article_Attachments_Bool_Exp>;
};


export type Subscription_RootArticle_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Attachments_Order_By>>;
  where?: InputMaybe<Article_Attachments_Bool_Exp>;
};


export type Subscription_RootArticle_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Attachments_Bool_Exp>;
};


export type Subscription_RootArticle_Author_Favorite_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_Favorite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Author_Favorite_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_Favorite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Author_Favorite_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Author_Favorite_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Author_Favorite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Author_Like_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Author_Like_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Author_Like_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Author_Like_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Author_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Author_View_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Author_View_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Author_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Author_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Author_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Author_View_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Author_View_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Author_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Article_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Authors_Order_By>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


export type Subscription_RootArticle_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Authors_Order_By>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


export type Subscription_RootArticle_Authors_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Authors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Authors_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Authors_Bool_Exp>;
};


export type Subscription_RootArticle_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootArticle_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Categories_Order_By>>;
  where?: InputMaybe<Article_Categories_Bool_Exp>;
};


export type Subscription_RootArticle_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Categories_Order_By>>;
  where?: InputMaybe<Article_Categories_Bool_Exp>;
};


export type Subscription_RootArticle_Categories_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Categories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Categories_Bool_Exp>;
};


export type Subscription_RootArticle_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Article_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Category_Order_By>>;
  where?: InputMaybe<Article_Category_Bool_Exp>;
};


export type Subscription_RootArticle_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Category_Order_By>>;
  where?: InputMaybe<Article_Category_Bool_Exp>;
};


export type Subscription_RootArticle_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootArticle_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Category_Bool_Exp>;
};


export type Subscription_RootArticle_Crop_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Categories_Order_By>>;
  where?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
};


export type Subscription_RootArticle_Crop_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Categories_Order_By>>;
  where?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
};


export type Subscription_RootArticle_Crop_Categories_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Crop_Categories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Crop_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Crop_Categories_Bool_Exp>;
};


export type Subscription_RootArticle_Crop_VarietiesArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Varieties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Varieties_Order_By>>;
  where?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
};


export type Subscription_RootArticle_Crop_Varieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crop_Varieties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crop_Varieties_Order_By>>;
  where?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
};


export type Subscription_RootArticle_Crop_Varieties_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Crop_Varieties_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Crop_Varieties_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Crop_Varieties_Bool_Exp>;
};


export type Subscription_RootArticle_CropsArgs = {
  distinct_on?: InputMaybe<Array<Article_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crops_Order_By>>;
  where?: InputMaybe<Article_Crops_Bool_Exp>;
};


export type Subscription_RootArticle_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Crops_Order_By>>;
  where?: InputMaybe<Article_Crops_Bool_Exp>;
};


export type Subscription_RootArticle_Crops_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Crops_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Crops_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Crops_Bool_Exp>;
};


export type Subscription_RootArticle_Favorite_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Favorite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Favorite_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Favorite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Favorite_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Favorite_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Favorite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_FavoritesArgs = {
  distinct_on?: InputMaybe<Array<Article_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Favorites_Order_By>>;
  where?: InputMaybe<Article_Favorites_Bool_Exp>;
};


export type Subscription_RootArticle_Favorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Favorites_Order_By>>;
  where?: InputMaybe<Article_Favorites_Bool_Exp>;
};


export type Subscription_RootArticle_Favorites_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Favorites_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Favorites_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Favorites_Bool_Exp>;
};


export type Subscription_RootArticle_Like_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Like_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Like_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Like_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_LikesArgs = {
  distinct_on?: InputMaybe<Array<Article_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Likes_Order_By>>;
  where?: InputMaybe<Article_Likes_Bool_Exp>;
};


export type Subscription_RootArticle_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Likes_Order_By>>;
  where?: InputMaybe<Article_Likes_Bool_Exp>;
};


export type Subscription_RootArticle_Likes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Likes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Likes_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Likes_Bool_Exp>;
};


export type Subscription_RootArticle_RegionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Regions_Order_By>>;
  where?: InputMaybe<Article_Regions_Bool_Exp>;
};


export type Subscription_RootArticle_Regions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Regions_Order_By>>;
  where?: InputMaybe<Article_Regions_Bool_Exp>;
};


export type Subscription_RootArticle_Regions_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Regions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Regions_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Regions_Bool_Exp>;
};


export type Subscription_RootArticle_SeriesArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


export type Subscription_RootArticle_Series_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Order_By>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


export type Subscription_RootArticle_Series_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootArticle_Series_Favourite_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Favourite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Favourite_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_Favourite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Series_Favourite_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Favourite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Favourite_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_Favourite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Series_Favourite_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Series_Favourite_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Series_Favourite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Series_Like_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Series_Like_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Series_Like_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Series_Like_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Series_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Series_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Series_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Series_Bool_Exp>;
};


export type Subscription_RootArticle_Series_View_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Series_View_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Series_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Series_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Series_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Series_View_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Series_View_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Series_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_Favorite_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_Favorite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_Favorite_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Favorite_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_Favorite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_Favorite_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Subscription_Favorite_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Subscription_Favorite_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_Like_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_Like_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Like_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Like_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_Like_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Subscription_Like_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Subscription_Like_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_PackageArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Package_Order_By>>;
  where?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_Package_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_Package_Order_By>>;
  where?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_Package_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootArticle_Subscription_Package_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Subscription_Package_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_View_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_View_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscription_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscription_View_Insights_Order_By>>;
  where?: InputMaybe<Article_Subscription_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_Subscription_View_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Subscription_View_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Subscription_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscriptions_Order_By>>;
  where?: InputMaybe<Article_Subscriptions_Bool_Exp>;
};


export type Subscription_RootArticle_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Subscriptions_Order_By>>;
  where?: InputMaybe<Article_Subscriptions_Bool_Exp>;
};


export type Subscription_RootArticle_Subscriptions_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Subscriptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Subscriptions_Bool_Exp>;
};


export type Subscription_RootArticle_User_GroupArgs = {
  distinct_on?: InputMaybe<Array<Article_User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_User_Group_Order_By>>;
  where?: InputMaybe<Article_User_Group_Bool_Exp>;
};


export type Subscription_RootArticle_User_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_User_Group_Order_By>>;
  where?: InputMaybe<Article_User_Group_Bool_Exp>;
};


export type Subscription_RootArticle_User_Group_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_User_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_User_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_User_Group_Bool_Exp>;
};


export type Subscription_RootArticle_View_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Article_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_View_Insights_Order_By>>;
  where?: InputMaybe<Article_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_View_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_View_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_View_Insights_Order_By>>;
  where?: InputMaybe<Article_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_View_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_View_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_View_Insights_Bool_Exp>;
};


export type Subscription_RootArticle_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Article_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Views_Order_By>>;
  where?: InputMaybe<Article_Views_Bool_Exp>;
};


export type Subscription_RootArticle_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Views_Order_By>>;
  where?: InputMaybe<Article_Views_Bool_Exp>;
};


export type Subscription_RootArticle_Views_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootArticle_Views_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Views_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Views_Bool_Exp>;
};


export type Subscription_RootAssessmentArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Order_By>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


export type Subscription_RootAssessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Order_By>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


export type Subscription_RootAssessment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAssessment_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Question_Order_By>>;
  where?: InputMaybe<Assessment_Question_Bool_Exp>;
};


export type Subscription_RootAssessment_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assessment_Question_Order_By>>;
  where?: InputMaybe<Assessment_Question_Bool_Exp>;
};


export type Subscription_RootAssessment_Question_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAssessment_Question_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Assessment_Question_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Question_Bool_Exp>;
};


export type Subscription_RootAssessment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Assessment_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


export type Subscription_RootAttributeArgs = {
  distinct_on?: InputMaybe<Array<Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attribute_Order_By>>;
  where?: InputMaybe<Attribute_Bool_Exp>;
};


export type Subscription_RootAttribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attribute_Order_By>>;
  where?: InputMaybe<Attribute_Bool_Exp>;
};


export type Subscription_RootAttribute_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAttribute_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attribute_Choice_Order_By>>;
  where?: InputMaybe<Attribute_Choice_Bool_Exp>;
};


export type Subscription_RootAttribute_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attribute_Choice_Order_By>>;
  where?: InputMaybe<Attribute_Choice_Bool_Exp>;
};


export type Subscription_RootAttribute_Choice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAttribute_Choice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Attribute_Choice_Stream_Cursor_Input>>;
  where?: InputMaybe<Attribute_Choice_Bool_Exp>;
};


export type Subscription_RootAttribute_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Attribute_Stream_Cursor_Input>>;
  where?: InputMaybe<Attribute_Bool_Exp>;
};


export type Subscription_RootAuth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootAuth_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootAuth_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAuth_Group_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type Subscription_RootAuth_Group_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type Subscription_RootAuth_Group_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAuth_Group_Permissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_Group_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type Subscription_RootAuth_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootAuth_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type Subscription_RootAuth_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type Subscription_RootAuth_Permission_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAuth_Permission_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type Subscription_RootBase_UserArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Subscription_RootBase_User_Address_BookArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


export type Subscription_RootBase_User_Address_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


export type Subscription_RootBase_User_Address_Book_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_Address_Book_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Address_Book_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


export type Subscription_RootBase_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Subscription_RootBase_User_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


export type Subscription_RootBase_User_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


export type Subscription_RootBase_User_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_Companies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Companies_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


export type Subscription_RootBase_User_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


export type Subscription_RootBase_User_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


export type Subscription_RootBase_User_Departments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_Departments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Departments_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


export type Subscription_RootBase_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


export type Subscription_RootBase_User_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


export type Subscription_RootBase_User_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


export type Subscription_RootBase_User_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


export type Subscription_RootBase_User_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


export type Subscription_RootBase_User_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


export type Subscription_RootBase_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Subscription_RootBase_User_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


export type Subscription_RootBase_User_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


export type Subscription_RootBase_User_User_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_User_Permissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_User_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


export type Subscription_RootBusinessArgs = {
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Subscription_RootBusiness_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Subscription_RootBusiness_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Commodities_SuppliedArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


export type Subscription_RootBusiness_Commodities_Supplied_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


export type Subscription_RootBusiness_Commodities_Supplied_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Commodities_Supplied_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Commodities_Supplied_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


export type Subscription_RootBusiness_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


export type Subscription_RootBusiness_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


export type Subscription_RootBusiness_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Companies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Companies_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


export type Subscription_RootBusiness_GroupArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Subscription_RootBusiness_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Subscription_RootBusiness_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Group_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Group_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Group_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Group_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Subscription_RootBusiness_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


export type Subscription_RootBusiness_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


export type Subscription_RootBusiness_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


export type Subscription_RootBusiness_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Secondary_PocsArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


export type Subscription_RootBusiness_Secondary_Pocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


export type Subscription_RootBusiness_Secondary_Pocs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Secondary_Pocs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Secondary_Pocs_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


export type Subscription_RootBusiness_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Subscription_RootCare_Shared_EntityArgs = {
  distinct_on?: InputMaybe<Array<Care_Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Care_Shared_Entity_Order_By>>;
  where?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
};


export type Subscription_RootCare_Shared_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Care_Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Care_Shared_Entity_Order_By>>;
  where?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
};


export type Subscription_RootCare_Shared_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootCare_Shared_Entity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Care_Shared_Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Care_Shared_Entity_Bool_Exp>;
};


export type Subscription_RootCategoryArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCategory_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCategory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCertificate_IssuerArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Issuer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Issuer_Order_By>>;
  where?: InputMaybe<Certificate_Issuer_Bool_Exp>;
};


export type Subscription_RootCertificate_Issuer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Issuer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Issuer_Order_By>>;
  where?: InputMaybe<Certificate_Issuer_Bool_Exp>;
};


export type Subscription_RootCertificate_Issuer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCertificate_Issuer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Certificate_Issuer_Stream_Cursor_Input>>;
  where?: InputMaybe<Certificate_Issuer_Bool_Exp>;
};


export type Subscription_RootCertificationArgs = {
  distinct_on?: InputMaybe<Array<Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certification_Order_By>>;
  where?: InputMaybe<Certification_Bool_Exp>;
};


export type Subscription_RootCertification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certification_Order_By>>;
  where?: InputMaybe<Certification_Bool_Exp>;
};


export type Subscription_RootCertification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCertification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Certification_Stream_Cursor_Input>>;
  where?: InputMaybe<Certification_Bool_Exp>;
};


export type Subscription_RootCommentArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Subscription_RootComment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Subscription_RootComment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootComment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Subscription_RootCommodityArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


export type Subscription_RootCommodity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


export type Subscription_RootCommodity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCommodity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Commodity_Stream_Cursor_Input>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


export type Subscription_RootCommodity_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


export type Subscription_RootCommodity_Variety_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


export type Subscription_RootCommodity_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCommodity_Variety_Secondary_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


export type Subscription_RootCommodity_Variety_Secondary_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


export type Subscription_RootCommodity_Variety_Secondary_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCommodity_Variety_Secondary_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Commodity_Variety_Secondary_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


export type Subscription_RootCommodity_Variety_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Commodity_Variety_Stream_Cursor_Input>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


export type Subscription_RootCommon_FileuploadArgs = {
  distinct_on?: InputMaybe<Array<Common_Fileupload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Fileupload_Order_By>>;
  where?: InputMaybe<Common_Fileupload_Bool_Exp>;
};


export type Subscription_RootCommon_Fileupload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Common_Fileupload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Fileupload_Order_By>>;
  where?: InputMaybe<Common_Fileupload_Bool_Exp>;
};


export type Subscription_RootCommon_Fileupload_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootCommon_Fileupload_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Common_Fileupload_Stream_Cursor_Input>>;
  where?: InputMaybe<Common_Fileupload_Bool_Exp>;
};


export type Subscription_RootCompanyArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompany_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Subscription_RootContent_TypeArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type Subscription_RootContent_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type Subscription_RootContent_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCost_ItemArgs = {
  distinct_on?: InputMaybe<Array<Cost_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cost_Item_Order_By>>;
  where?: InputMaybe<Cost_Item_Bool_Exp>;
};


export type Subscription_RootCost_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cost_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cost_Item_Order_By>>;
  where?: InputMaybe<Cost_Item_Bool_Exp>;
};


export type Subscription_RootCost_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCost_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cost_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Cost_Item_Bool_Exp>;
};


export type Subscription_RootCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp>;
};


export type Subscription_RootCrop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp>;
};


export type Subscription_RootCrop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_FertilisersArgs = {
  distinct_on?: InputMaybe<Array<Crop_Fertilisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Fertilisers_Order_By>>;
  where?: InputMaybe<Crop_Fertilisers_Bool_Exp>;
};


export type Subscription_RootCrop_Fertilisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Fertilisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Fertilisers_Order_By>>;
  where?: InputMaybe<Crop_Fertilisers_Bool_Exp>;
};


export type Subscription_RootCrop_Fertilisers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCrop_Fertilisers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Fertilisers_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Fertilisers_Bool_Exp>;
};


export type Subscription_RootCrop_GroupArgs = {
  distinct_on?: InputMaybe<Array<Crop_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Group_Order_By>>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};


export type Subscription_RootCrop_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Group_Order_By>>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};


export type Subscription_RootCrop_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};


export type Subscription_RootCrop_InfestationArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};


export type Subscription_RootCrop_Infestation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};


export type Subscription_RootCrop_Infestation_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


export type Subscription_RootCrop_Infestation_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


export type Subscription_RootCrop_Infestation_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Infestation_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Infestation_Attachment_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


export type Subscription_RootCrop_Infestation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Infestation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Infestation_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};


export type Subscription_RootCrop_MilestoneArgs = {
  distinct_on?: InputMaybe<Array<Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Milestone_Order_By>>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootCrop_Milestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Milestone_Order_By>>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootCrop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Milestone_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Milestone_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootCrop_Operation_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Operation_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Operation_Methods_Order_By>>;
  where?: InputMaybe<Crop_Operation_Methods_Bool_Exp>;
};


export type Subscription_RootCrop_Operation_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Operation_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Operation_Methods_Order_By>>;
  where?: InputMaybe<Crop_Operation_Methods_Bool_Exp>;
};


export type Subscription_RootCrop_Operation_Methods_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCrop_Operation_Methods_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Operation_Methods_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Operation_Methods_Bool_Exp>;
};


export type Subscription_RootCrop_PesticidesArgs = {
  distinct_on?: InputMaybe<Array<Crop_Pesticides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Pesticides_Order_By>>;
  where?: InputMaybe<Crop_Pesticides_Bool_Exp>;
};


export type Subscription_RootCrop_Pesticides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Pesticides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Pesticides_Order_By>>;
  where?: InputMaybe<Crop_Pesticides_Bool_Exp>;
};


export type Subscription_RootCrop_Pesticides_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCrop_Pesticides_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Pesticides_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Pesticides_Bool_Exp>;
};


export type Subscription_RootCrop_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Bool_Exp>;
};


export type Subscription_RootCrop_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


export type Subscription_RootCrop_Variety_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


export type Subscription_RootCrop_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Variety_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Seeds_Order_By>>;
  where?: InputMaybe<Crop_Variety_Seeds_Bool_Exp>;
};


export type Subscription_RootCrop_Variety_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Seeds_Order_By>>;
  where?: InputMaybe<Crop_Variety_Seeds_Bool_Exp>;
};


export type Subscription_RootCrop_Variety_Seeds_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCrop_Variety_Seeds_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Variety_Seeds_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Variety_Seeds_Bool_Exp>;
};


export type Subscription_RootCrop_Variety_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Variety_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


export type Subscription_RootCrop_YearArgs = {
  distinct_on?: InputMaybe<Array<Crop_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Year_Order_By>>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};


export type Subscription_RootCrop_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Year_Order_By>>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};


export type Subscription_RootCrop_Year_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Year_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Year_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};


export type Subscription_RootCropmonitoring_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Cropmonitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cropmonitoring_Parameter_Order_By>>;
  where?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
};


export type Subscription_RootCropmonitoring_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cropmonitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cropmonitoring_Parameter_Order_By>>;
  where?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
};


export type Subscription_RootCropmonitoring_Parameter_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCropmonitoring_Parameter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cropmonitoring_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Cropmonitoring_Parameter_Bool_Exp>;
};


export type Subscription_RootCurrencyArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Subscription_RootCurrency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Subscription_RootCurrency_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCurrency_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Currency_Stream_Cursor_Input>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Subscription_RootDaily_Actual_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Daily_Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Actual_Reading_Order_By>>;
  where?: InputMaybe<Daily_Actual_Reading_Bool_Exp>;
};


export type Subscription_RootDaily_Actual_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Actual_Reading_Order_By>>;
  where?: InputMaybe<Daily_Actual_Reading_Bool_Exp>;
};


export type Subscription_RootDaily_Actual_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDaily_Actual_Reading_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Daily_Actual_Reading_Stream_Cursor_Input>>;
  where?: InputMaybe<Daily_Actual_Reading_Bool_Exp>;
};


export type Subscription_RootDaily_Forecast_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Daily_Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Forecast_Reading_Order_By>>;
  where?: InputMaybe<Daily_Forecast_Reading_Bool_Exp>;
};


export type Subscription_RootDaily_Forecast_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Forecast_Reading_Order_By>>;
  where?: InputMaybe<Daily_Forecast_Reading_Bool_Exp>;
};


export type Subscription_RootDaily_Forecast_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDaily_Forecast_Reading_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Daily_Forecast_Reading_Stream_Cursor_Input>>;
  where?: InputMaybe<Daily_Forecast_Reading_Bool_Exp>;
};


export type Subscription_RootDepartmentArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Subscription_RootDepartment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Subscription_RootDepartment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDepartment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Department_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Subscription_RootDeviceArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


export type Subscription_RootDevice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


export type Subscription_RootDevice_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDevice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Device_Stream_Cursor_Input>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


export type Subscription_RootDjango_Content_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Django_Content_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type Subscription_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


export type Subscription_RootDocument_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


export type Subscription_RootDocument_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


export type Subscription_RootDocument_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_DataArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


export type Subscription_RootDocument_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


export type Subscription_RootDocument_Data_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


export type Subscription_RootDocument_KindArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Order_By>>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};


export type Subscription_RootDocument_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Order_By>>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};


export type Subscription_RootDocument_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_Kind_Data_FieldArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Data_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Data_Field_Order_By>>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};


export type Subscription_RootDocument_Kind_Data_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Data_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Data_Field_Order_By>>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};


export type Subscription_RootDocument_Kind_Data_Field_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_Kind_Data_Field_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Kind_Data_Field_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};


export type Subscription_RootDocument_Kind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};


export type Subscription_RootDocument_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDrip_Irrigation_SystemArgs = {
  distinct_on?: InputMaybe<Array<Drip_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Drip_Irrigation_System_Order_By>>;
  where?: InputMaybe<Drip_Irrigation_System_Bool_Exp>;
};


export type Subscription_RootDrip_Irrigation_System_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Drip_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Drip_Irrigation_System_Order_By>>;
  where?: InputMaybe<Drip_Irrigation_System_Bool_Exp>;
};


export type Subscription_RootDrip_Irrigation_System_By_PkArgs = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};


export type Subscription_RootDrip_Irrigation_System_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Drip_Irrigation_System_Stream_Cursor_Input>>;
  where?: InputMaybe<Drip_Irrigation_System_Bool_Exp>;
};


export type Subscription_RootExpenseArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


export type Subscription_RootExpense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


export type Subscription_RootExpense_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootExpense_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Expense_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Parameter_Order_By>>;
  where?: InputMaybe<Expense_Parameter_Bool_Exp>;
};


export type Subscription_RootExpense_Parameter_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootExpense_Parameter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Expense_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Expense_Parameter_Bool_Exp>;
};


export type Subscription_RootExpense_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Expense_Stream_Cursor_Input>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


export type Subscription_RootExternal_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<External_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Reference_Order_By>>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};


export type Subscription_RootExternal_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Reference_Order_By>>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};


export type Subscription_RootExternal_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootExternal_Reference_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<External_Reference_Stream_Cursor_Input>>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};


export type Subscription_RootFarmArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Subscription_RootFarm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Subscription_RootFarm_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFarm_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


export type Subscription_RootFarm_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


export type Subscription_RootFarm_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFarm_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Farm_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


export type Subscription_RootFarm_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Farm_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Subscription_RootFieldArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


export type Subscription_RootField_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


export type Subscription_RootField_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootField_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


export type Subscription_RootField_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


export type Subscription_RootField_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootField_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Field_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


export type Subscription_RootField_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Field_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


export type Subscription_RootField_Weather_LocationArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


export type Subscription_RootField_Weather_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


export type Subscription_RootField_Weather_Location_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootField_Weather_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Field_Weather_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


export type Subscription_RootFileuploadArgs = {
  distinct_on?: InputMaybe<Array<Fileupload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fileupload_Order_By>>;
  where?: InputMaybe<Fileupload_Bool_Exp>;
};


export type Subscription_RootFileupload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fileupload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fileupload_Order_By>>;
  where?: InputMaybe<Fileupload_Bool_Exp>;
};


export type Subscription_RootFileupload_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootFileupload_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fileupload_Stream_Cursor_Input>>;
  where?: InputMaybe<Fileupload_Bool_Exp>;
};


export type Subscription_RootFlood_Irrigation_SystemArgs = {
  distinct_on?: InputMaybe<Array<Flood_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Flood_Irrigation_System_Order_By>>;
  where?: InputMaybe<Flood_Irrigation_System_Bool_Exp>;
};


export type Subscription_RootFlood_Irrigation_System_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flood_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Flood_Irrigation_System_Order_By>>;
  where?: InputMaybe<Flood_Irrigation_System_Bool_Exp>;
};


export type Subscription_RootFlood_Irrigation_System_By_PkArgs = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};


export type Subscription_RootFlood_Irrigation_System_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Flood_Irrigation_System_Stream_Cursor_Input>>;
  where?: InputMaybe<Flood_Irrigation_System_Bool_Exp>;
};


export type Subscription_RootForecast_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Forecast_Reading_Order_By>>;
  where?: InputMaybe<Forecast_Reading_Bool_Exp>;
};


export type Subscription_RootForecast_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Forecast_Reading_Order_By>>;
  where?: InputMaybe<Forecast_Reading_Bool_Exp>;
};


export type Subscription_RootForecast_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootForecast_Reading_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Forecast_Reading_Stream_Cursor_Input>>;
  where?: InputMaybe<Forecast_Reading_Bool_Exp>;
};


export type Subscription_RootGatewayArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


export type Subscription_RootGateway_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


export type Subscription_RootGateway_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGateway_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Configuration_Order_By>>;
  where?: InputMaybe<Gateway_Configuration_Bool_Exp>;
};


export type Subscription_RootGateway_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Configuration_Order_By>>;
  where?: InputMaybe<Gateway_Configuration_Bool_Exp>;
};


export type Subscription_RootGateway_Configuration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGateway_Configuration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gateway_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Gateway_Configuration_Bool_Exp>;
};


export type Subscription_RootGateway_StatusArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Status_Order_By>>;
  where?: InputMaybe<Gateway_Status_Bool_Exp>;
};


export type Subscription_RootGateway_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Status_Order_By>>;
  where?: InputMaybe<Gateway_Status_Bool_Exp>;
};


export type Subscription_RootGateway_Status_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootGateway_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gateway_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Gateway_Status_Bool_Exp>;
};


export type Subscription_RootGateway_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gateway_Stream_Cursor_Input>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


export type Subscription_RootGrade_PriceArgs = {
  distinct_on?: InputMaybe<Array<Grade_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Price_Order_By>>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};


export type Subscription_RootGrade_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Price_Order_By>>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};


export type Subscription_RootGrade_Price_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGrade_Price_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Grade_Price_Stream_Cursor_Input>>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};


export type Subscription_RootInfestationArgs = {
  distinct_on?: InputMaybe<Array<Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Infestation_Order_By>>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};


export type Subscription_RootInfestation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Infestation_Order_By>>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};


export type Subscription_RootInfestation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootInfestation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Infestation_Stream_Cursor_Input>>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};


export type Subscription_RootIngredientArgs = {
  distinct_on?: InputMaybe<Array<Ingredient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ingredient_Order_By>>;
  where?: InputMaybe<Ingredient_Bool_Exp>;
};


export type Subscription_RootIngredient_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ingredient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ingredient_Order_By>>;
  where?: InputMaybe<Ingredient_Bool_Exp>;
};


export type Subscription_RootIngredient_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootIngredient_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ingredient_Stream_Cursor_Input>>;
  where?: InputMaybe<Ingredient_Bool_Exp>;
};


export type Subscription_RootInst_Sensor_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Inst_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inst_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
};


export type Subscription_RootInst_Sensor_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inst_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inst_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
};


export type Subscription_RootInst_Sensor_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootInst_Sensor_Reading_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Inst_Sensor_Reading_Stream_Cursor_Input>>;
  where?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
};


export type Subscription_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootInvoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootIrrigation_SystemArgs = {
  distinct_on?: InputMaybe<Array<Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Irrigation_System_Order_By>>;
  where?: InputMaybe<Irrigation_System_Bool_Exp>;
};


export type Subscription_RootIrrigation_System_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Irrigation_System_Order_By>>;
  where?: InputMaybe<Irrigation_System_Bool_Exp>;
};


export type Subscription_RootIrrigation_System_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootIrrigation_System_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Irrigation_System_Stream_Cursor_Input>>;
  where?: InputMaybe<Irrigation_System_Bool_Exp>;
};


export type Subscription_RootLocation_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Location_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Subscription_Order_By>>;
  where?: InputMaybe<Location_Subscription_Bool_Exp>;
};


export type Subscription_RootLocation_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Subscription_Order_By>>;
  where?: InputMaybe<Location_Subscription_Bool_Exp>;
};


export type Subscription_RootLocation_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLocation_Subscription_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Location_Subscription_Stream_Cursor_Input>>;
  where?: InputMaybe<Location_Subscription_Bool_Exp>;
};


export type Subscription_RootMain_SectionArgs = {
  distinct_on?: InputMaybe<Array<Main_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Main_Section_Order_By>>;
  where?: InputMaybe<Main_Section_Bool_Exp>;
};


export type Subscription_RootMain_Section_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Main_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Main_Section_Order_By>>;
  where?: InputMaybe<Main_Section_Bool_Exp>;
};


export type Subscription_RootMain_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMain_Section_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Main_Section_Stream_Cursor_Input>>;
  where?: InputMaybe<Main_Section_Bool_Exp>;
};


export type Subscription_RootManufacturerArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By>>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};


export type Subscription_RootManufacturer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By>>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};


export type Subscription_RootManufacturer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootManufacturer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Manufacturer_Stream_Cursor_Input>>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};


export type Subscription_RootManufacturing_FacilityArgs = {
  distinct_on?: InputMaybe<Array<Manufacturing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturing_Facility_Order_By>>;
  where?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
};


export type Subscription_RootManufacturing_Facility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturing_Facility_Order_By>>;
  where?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
};


export type Subscription_RootManufacturing_Facility_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootManufacturing_Facility_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Manufacturing_Facility_Stream_Cursor_Input>>;
  where?: InputMaybe<Manufacturing_Facility_Bool_Exp>;
};


export type Subscription_RootMarketArgs = {
  distinct_on?: InputMaybe<Array<Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Order_By>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


export type Subscription_RootMarket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Order_By>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


export type Subscription_RootMarket_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMarket_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Market_Stream_Cursor_Input>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


export type Subscription_RootMarketerArgs = {
  distinct_on?: InputMaybe<Array<Marketer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Marketer_Order_By>>;
  where?: InputMaybe<Marketer_Bool_Exp>;
};


export type Subscription_RootMarketer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marketer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Marketer_Order_By>>;
  where?: InputMaybe<Marketer_Bool_Exp>;
};


export type Subscription_RootMarketer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMarketer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Marketer_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketer_Bool_Exp>;
};


export type Subscription_RootMarketing_FacilityArgs = {
  distinct_on?: InputMaybe<Array<Marketing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Marketing_Facility_Order_By>>;
  where?: InputMaybe<Marketing_Facility_Bool_Exp>;
};


export type Subscription_RootMarketing_Facility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Marketing_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Marketing_Facility_Order_By>>;
  where?: InputMaybe<Marketing_Facility_Bool_Exp>;
};


export type Subscription_RootMarketing_Facility_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMarketing_Facility_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Marketing_Facility_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketing_Facility_Bool_Exp>;
};


export type Subscription_RootMeasure_OfArgs = {
  distinct_on?: InputMaybe<Array<Measure_Of_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Measure_Of_Order_By>>;
  where?: InputMaybe<Measure_Of_Bool_Exp>;
};


export type Subscription_RootMeasure_Of_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Measure_Of_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Measure_Of_Order_By>>;
  where?: InputMaybe<Measure_Of_Bool_Exp>;
};


export type Subscription_RootMeasure_Of_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMeasure_Of_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Measure_Of_Stream_Cursor_Input>>;
  where?: InputMaybe<Measure_Of_Bool_Exp>;
};


export type Subscription_RootMediaArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMedia_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMedia_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMessageArgs = {
  distinct_on?: InputMaybe<Array<Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Message_Order_By>>;
  where?: InputMaybe<Message_Bool_Exp>;
};


export type Subscription_RootMessage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Message_Order_By>>;
  where?: InputMaybe<Message_Bool_Exp>;
};


export type Subscription_RootMessage_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMessage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Message_Bool_Exp>;
};


export type Subscription_RootMilestoneArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Subscription_RootMilestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Subscription_RootMilestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMilestone_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Milestone_Stream_Cursor_Input>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Subscription_RootMonitoring_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Category_Order_By>>;
  where?: InputMaybe<Monitoring_Category_Bool_Exp>;
};


export type Subscription_RootMonitoring_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Category_Order_By>>;
  where?: InputMaybe<Monitoring_Category_Bool_Exp>;
};


export type Subscription_RootMonitoring_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMonitoring_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Monitoring_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Monitoring_Category_Bool_Exp>;
};


export type Subscription_RootMonitoring_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
};


export type Subscription_RootMonitoring_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
};


export type Subscription_RootMonitoring_Parameter_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMonitoring_Parameter_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Choices_Bool_Exp>;
};


export type Subscription_RootMonitoring_Parameter_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Choices_Bool_Exp>;
};


export type Subscription_RootMonitoring_Parameter_Choices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMonitoring_Parameter_Choices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Monitoring_Parameter_Choices_Stream_Cursor_Input>>;
  where?: InputMaybe<Monitoring_Parameter_Choices_Bool_Exp>;
};


export type Subscription_RootMonitoring_Parameter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Monitoring_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Monitoring_Parameter_Bool_Exp>;
};


export type Subscription_RootMonitoring_Parameter_Unit_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Unit_Choices_Bool_Exp>;
};


export type Subscription_RootMonitoring_Parameter_Unit_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Parameter_Unit_Choices_Order_By>>;
  where?: InputMaybe<Monitoring_Parameter_Unit_Choices_Bool_Exp>;
};


export type Subscription_RootMonitoring_Parameter_Unit_Choices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMonitoring_Parameter_Unit_Choices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Monitoring_Parameter_Unit_Choices_Stream_Cursor_Input>>;
  where?: InputMaybe<Monitoring_Parameter_Unit_Choices_Bool_Exp>;
};


export type Subscription_RootMonitoring_RecordArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Bool_Exp>;
};


export type Subscription_RootMonitoring_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Bool_Exp>;
};


export type Subscription_RootMonitoring_Record_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Attachments_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
};


export type Subscription_RootMonitoring_Record_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Record_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Record_Attachments_Order_By>>;
  where?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
};


export type Subscription_RootMonitoring_Record_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootMonitoring_Record_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Monitoring_Record_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Monitoring_Record_Attachments_Bool_Exp>;
};


export type Subscription_RootMonitoring_Record_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMonitoring_Record_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Monitoring_Record_Stream_Cursor_Input>>;
  where?: InputMaybe<Monitoring_Record_Bool_Exp>;
};


export type Subscription_RootMonitoring_SampleArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Sample_Order_By>>;
  where?: InputMaybe<Monitoring_Sample_Bool_Exp>;
};


export type Subscription_RootMonitoring_Sample_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Sample_Order_By>>;
  where?: InputMaybe<Monitoring_Sample_Bool_Exp>;
};


export type Subscription_RootMonitoring_Sample_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMonitoring_Sample_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Monitoring_Sample_Stream_Cursor_Input>>;
  where?: InputMaybe<Monitoring_Sample_Bool_Exp>;
};


export type Subscription_RootMonitoring_SubcategoryArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Subcategory_Order_By>>;
  where?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
};


export type Subscription_RootMonitoring_Subcategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitoring_Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitoring_Subcategory_Order_By>>;
  where?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
};


export type Subscription_RootMonitoring_Subcategory_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMonitoring_Subcategory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Monitoring_Subcategory_Stream_Cursor_Input>>;
  where?: InputMaybe<Monitoring_Subcategory_Bool_Exp>;
};


export type Subscription_RootMutual_GroupArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Subscription_RootMutual_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Subscription_RootMutual_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMutual_Group_MembershipArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Membership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Membership_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMutual_Group_Membership_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Membership_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


export type Subscription_RootMutual_Group_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMutual_Group_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


export type Subscription_RootMutual_Group_RoleArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Role_Order_By>>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Role_Order_By>>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Role_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMutual_Group_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};


export type Subscription_RootMutual_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Subscription_PackageArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Subscription_Package_Order_By>>;
  where?: InputMaybe<Mutual_Group_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Subscription_Package_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Subscription_Package_Order_By>>;
  where?: InputMaybe<Mutual_Group_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Subscription_Package_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMutual_Group_Subscription_Package_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Subscription_Package_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Weather_StationArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Weather_Station_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Weather_Station_Order_By>>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Weather_Station_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Weather_Station_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Weather_Station_Order_By>>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Weather_Station_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMutual_Group_Weather_Station_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Weather_Station_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};


export type Subscription_RootNetworkArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


export type Subscription_RootNetwork_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


export type Subscription_RootNetwork_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNetwork_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


export type Subscription_RootNotificationArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNotification_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Notification_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Category_Order_By>>;
  where?: InputMaybe<Notification_Category_Bool_Exp>;
};


export type Subscription_RootNotification_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Category_Order_By>>;
  where?: InputMaybe<Notification_Category_Bool_Exp>;
};


export type Subscription_RootNotification_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNotification_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Category_Bool_Exp>;
};


export type Subscription_RootNotification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Order_By>>;
  where?: InputMaybe<Notification_Template_Bool_Exp>;
};


export type Subscription_RootNotification_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Order_By>>;
  where?: InputMaybe<Notification_Template_Bool_Exp>;
};


export type Subscription_RootNotification_Template_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNotification_Template_Distribution_RegionArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Region_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Region_Bool_Exp>;
};


export type Subscription_RootNotification_Template_Distribution_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Region_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Region_Bool_Exp>;
};


export type Subscription_RootNotification_Template_Distribution_Region_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootNotification_Template_Distribution_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Template_Distribution_Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Template_Distribution_Region_Bool_Exp>;
};


export type Subscription_RootNotification_Template_Distribution_TeamArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Team_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Team_Bool_Exp>;
};


export type Subscription_RootNotification_Template_Distribution_Team_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_Team_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_Team_Bool_Exp>;
};


export type Subscription_RootNotification_Template_Distribution_Team_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootNotification_Template_Distribution_Team_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Template_Distribution_Team_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Template_Distribution_Team_Bool_Exp>;
};


export type Subscription_RootNotification_Template_Distribution_UserArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_User_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_User_Bool_Exp>;
};


export type Subscription_RootNotification_Template_Distribution_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Template_Distribution_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Template_Distribution_User_Order_By>>;
  where?: InputMaybe<Notification_Template_Distribution_User_Bool_Exp>;
};


export type Subscription_RootNotification_Template_Distribution_User_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootNotification_Template_Distribution_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Template_Distribution_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Template_Distribution_User_Bool_Exp>;
};


export type Subscription_RootNotification_Template_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Template_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Template_Bool_Exp>;
};


export type Subscription_RootNutrientsArgs = {
  distinct_on?: InputMaybe<Array<Nutrients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nutrients_Order_By>>;
  where?: InputMaybe<Nutrients_Bool_Exp>;
};


export type Subscription_RootNutrients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nutrients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nutrients_Order_By>>;
  where?: InputMaybe<Nutrients_Bool_Exp>;
};


export type Subscription_RootNutrients_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNutrients_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nutrients_Stream_Cursor_Input>>;
  where?: InputMaybe<Nutrients_Bool_Exp>;
};


export type Subscription_RootObservation_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Observation_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Observation_Notification_Order_By>>;
  where?: InputMaybe<Observation_Notification_Bool_Exp>;
};


export type Subscription_RootObservation_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Observation_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Observation_Notification_Order_By>>;
  where?: InputMaybe<Observation_Notification_Bool_Exp>;
};


export type Subscription_RootObservation_Notification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootObservation_Notification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Observation_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Observation_Notification_Bool_Exp>;
};


export type Subscription_RootOperation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Attachments_Order_By>>;
  where?: InputMaybe<Operation_Attachments_Bool_Exp>;
};


export type Subscription_RootOperation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Attachments_Order_By>>;
  where?: InputMaybe<Operation_Attachments_Bool_Exp>;
};


export type Subscription_RootOperation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOperation_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operation_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Operation_Attachments_Bool_Exp>;
};


export type Subscription_RootOperation_CostArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Order_By>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


export type Subscription_RootOperation_Cost_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Order_By>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


export type Subscription_RootOperation_Cost_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOperation_Cost_ItemArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Item_Order_By>>;
  where?: InputMaybe<Operation_Cost_Item_Bool_Exp>;
};


export type Subscription_RootOperation_Cost_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Cost_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Cost_Item_Order_By>>;
  where?: InputMaybe<Operation_Cost_Item_Bool_Exp>;
};


export type Subscription_RootOperation_Cost_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operation_Cost_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Operation_Cost_Item_Bool_Exp>;
};


export type Subscription_RootOperation_Cost_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operation_Cost_Stream_Cursor_Input>>;
  where?: InputMaybe<Operation_Cost_Bool_Exp>;
};


export type Subscription_RootOperation_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Methods_Order_By>>;
  where?: InputMaybe<Operation_Methods_Bool_Exp>;
};


export type Subscription_RootOperation_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Methods_Order_By>>;
  where?: InputMaybe<Operation_Methods_Bool_Exp>;
};


export type Subscription_RootOperation_Methods_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOperation_Methods_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operation_Methods_Stream_Cursor_Input>>;
  where?: InputMaybe<Operation_Methods_Bool_Exp>;
};


export type Subscription_RootOperation_Product_TypesArgs = {
  distinct_on?: InputMaybe<Array<Operation_Product_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Product_Types_Order_By>>;
  where?: InputMaybe<Operation_Product_Types_Bool_Exp>;
};


export type Subscription_RootOperation_Product_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Product_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Product_Types_Order_By>>;
  where?: InputMaybe<Operation_Product_Types_Bool_Exp>;
};


export type Subscription_RootOperation_Product_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOperation_Product_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operation_Product_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Operation_Product_Types_Bool_Exp>;
};


export type Subscription_RootOperationsArgs = {
  distinct_on?: InputMaybe<Array<Operations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Order_By>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


export type Subscription_RootOperations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Order_By>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


export type Subscription_RootOperations_Applied_FertiliserArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};


export type Subscription_RootOperations_Applied_Fertiliser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};


export type Subscription_RootOperations_Applied_Fertiliser_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOperations_Applied_Fertiliser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Applied_Fertiliser_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Applied_Fertiliser_Bool_Exp>;
};


export type Subscription_RootOperations_Applied_PesticideArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};


export type Subscription_RootOperations_Applied_Pesticide_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Applied_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Applied_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};


export type Subscription_RootOperations_Applied_Pesticide_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOperations_Applied_Pesticide_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Applied_Pesticide_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Applied_Pesticide_Bool_Exp>;
};


export type Subscription_RootOperations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOperations_FertiliserArgs = {
  distinct_on?: InputMaybe<Array<Operations_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
};


export type Subscription_RootOperations_Fertiliser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Fertiliser_Order_By>>;
  where?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
};


export type Subscription_RootOperations_Fertiliser_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Subscription_RootOperations_Fertiliser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Fertiliser_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Fertiliser_Bool_Exp>;
};


export type Subscription_RootOperations_HarvestArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Bool_Exp>;
};


export type Subscription_RootOperations_Harvest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Bool_Exp>;
};


export type Subscription_RootOperations_Harvest_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Subscription_RootOperations_Harvest_OutputArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Output_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Output_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
};


export type Subscription_RootOperations_Harvest_Output_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Harvest_Output_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Harvest_Output_Order_By>>;
  where?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
};


export type Subscription_RootOperations_Harvest_Output_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOperations_Harvest_Output_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Harvest_Output_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Harvest_Output_Bool_Exp>;
};


export type Subscription_RootOperations_Harvest_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Harvest_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Harvest_Bool_Exp>;
};


export type Subscription_RootOperations_IntercultureArgs = {
  distinct_on?: InputMaybe<Array<Operations_Interculture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Interculture_Order_By>>;
  where?: InputMaybe<Operations_Interculture_Bool_Exp>;
};


export type Subscription_RootOperations_Interculture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Interculture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Interculture_Order_By>>;
  where?: InputMaybe<Operations_Interculture_Bool_Exp>;
};


export type Subscription_RootOperations_Interculture_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Subscription_RootOperations_Interculture_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Interculture_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Interculture_Bool_Exp>;
};


export type Subscription_RootOperations_IrrigationArgs = {
  distinct_on?: InputMaybe<Array<Operations_Irrigation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Irrigation_Order_By>>;
  where?: InputMaybe<Operations_Irrigation_Bool_Exp>;
};


export type Subscription_RootOperations_Irrigation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Irrigation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Irrigation_Order_By>>;
  where?: InputMaybe<Operations_Irrigation_Bool_Exp>;
};


export type Subscription_RootOperations_Irrigation_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Subscription_RootOperations_Irrigation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Irrigation_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Irrigation_Bool_Exp>;
};


export type Subscription_RootOperations_Land_PrepArgs = {
  distinct_on?: InputMaybe<Array<Operations_Land_Prep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Land_Prep_Order_By>>;
  where?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
};


export type Subscription_RootOperations_Land_Prep_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Land_Prep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Land_Prep_Order_By>>;
  where?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
};


export type Subscription_RootOperations_Land_Prep_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Subscription_RootOperations_Land_Prep_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Land_Prep_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Land_Prep_Bool_Exp>;
};


export type Subscription_RootOperations_PesticideArgs = {
  distinct_on?: InputMaybe<Array<Operations_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Pesticide_Bool_Exp>;
};


export type Subscription_RootOperations_Pesticide_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Pesticide_Order_By>>;
  where?: InputMaybe<Operations_Pesticide_Bool_Exp>;
};


export type Subscription_RootOperations_Pesticide_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Subscription_RootOperations_Pesticide_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Pesticide_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Pesticide_Bool_Exp>;
};


export type Subscription_RootOperations_SowingArgs = {
  distinct_on?: InputMaybe<Array<Operations_Sowing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Sowing_Order_By>>;
  where?: InputMaybe<Operations_Sowing_Bool_Exp>;
};


export type Subscription_RootOperations_Sowing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Sowing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Sowing_Order_By>>;
  where?: InputMaybe<Operations_Sowing_Bool_Exp>;
};


export type Subscription_RootOperations_Sowing_By_PkArgs = {
  operation_ptr_id: Scalars['uuid'];
};


export type Subscription_RootOperations_Sowing_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Sowing_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Sowing_Bool_Exp>;
};


export type Subscription_RootOperations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


export type Subscription_RootOrganisationArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootOrganisation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootOrganisation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Document_KindArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


export type Subscription_RootOrganisation_Document_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


export type Subscription_RootOrganisation_Document_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Document_Kind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Document_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


export type Subscription_RootOrganisation_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Preferences_Order_By>>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};


export type Subscription_RootOrganisation_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Preferences_Order_By>>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};


export type Subscription_RootOrganisation_Preferences_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Preferences_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Preferences_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};


export type Subscription_RootOrganisation_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Season_Order_By>>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};


export type Subscription_RootOrganisation_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Season_Order_By>>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};


export type Subscription_RootOrganisation_Season_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Season_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Season_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};


export type Subscription_RootOrganisation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootPayment_DetailArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Order_By>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


export type Subscription_RootPayment_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Order_By>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


export type Subscription_RootPayment_Detail_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


export type Subscription_RootPayment_Detail_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


export type Subscription_RootPayment_Detail_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPayment_Detail_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Detail_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


export type Subscription_RootPayment_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPayment_Detail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


export type Subscription_RootPayment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};


export type Subscription_RootPayment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};


export type Subscription_RootPayment_Method_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPayment_Method_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Method_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};


export type Subscription_RootPlotArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


export type Subscription_RootPlot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


export type Subscription_RootPlot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_AgentArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Agent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Agent_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Agent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Agent_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_MilestoneArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Milestone_Order_By>>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Milestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Milestone_Order_By>>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Milestone_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Milestone_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Subscription_RootPlot_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Risk_24hourArgs = {
  distinct_on?: InputMaybe<Array<Plot_Risk_24hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Risk_24hour_Order_By>>;
  where?: InputMaybe<Plot_Risk_24hour_Bool_Exp>;
};


export type Subscription_RootPlot_Risk_24hour_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Risk_24hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Risk_24hour_Order_By>>;
  where?: InputMaybe<Plot_Risk_24hour_Bool_Exp>;
};


export type Subscription_RootPlot_Risk_24hour_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Risk_24hour_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Risk_24hour_Bool_Exp>;
};


export type Subscription_RootPlot_Risk_TotalArgs = {
  distinct_on?: InputMaybe<Array<Plot_Risk_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Risk_Total_Order_By>>;
  where?: InputMaybe<Plot_Risk_Total_Bool_Exp>;
};


export type Subscription_RootPlot_Risk_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Risk_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Risk_Total_Order_By>>;
  where?: InputMaybe<Plot_Risk_Total_Bool_Exp>;
};


export type Subscription_RootPlot_Risk_Total_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Risk_Total_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Risk_Total_Bool_Exp>;
};


export type Subscription_RootPlot_StatusArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Order_By>>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};


export type Subscription_RootPlot_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Order_By>>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};


export type Subscription_RootPlot_Status_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};


export type Subscription_RootPlot_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


export type Subscription_RootPrimary_Growth_StageArgs = {
  distinct_on?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Primary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootPrimary_Growth_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Primary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootPrimary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPrimary_Growth_Stage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Primary_Growth_Stage_Stream_Cursor_Input>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootProduce_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Produce_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produce_Insights_Order_By>>;
  where?: InputMaybe<Produce_Insights_Bool_Exp>;
};


export type Subscription_RootProduce_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Produce_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produce_Insights_Order_By>>;
  where?: InputMaybe<Produce_Insights_Bool_Exp>;
};


export type Subscription_RootProduce_Insights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Produce_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<Produce_Insights_Bool_Exp>;
};


export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Product_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attachment_Order_By>>;
  where?: InputMaybe<Product_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attachment_Order_By>>;
  where?: InputMaybe<Product_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Attachment_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_AttributeArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


export type Subscription_RootProduct_Attribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Order_By>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


export type Subscription_RootProduct_Attribute_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Attribute_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Choice_Order_By>>;
  where?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
};


export type Subscription_RootProduct_Attribute_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Attribute_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Attribute_Choice_Order_By>>;
  where?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
};


export type Subscription_RootProduct_Attribute_Choice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Attribute_Choice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Attribute_Choice_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Attribute_Choice_Bool_Exp>;
};


export type Subscription_RootProduct_Attribute_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Attribute_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Attribute_Bool_Exp>;
};


export type Subscription_RootProduct_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_CertificationArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Order_By>>;
  where?: InputMaybe<Product_Certification_Bool_Exp>;
};


export type Subscription_RootProduct_Certification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Order_By>>;
  where?: InputMaybe<Product_Certification_Bool_Exp>;
};


export type Subscription_RootProduct_Certification_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Attachment_Order_By>>;
  where?: InputMaybe<Product_Certification_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Certification_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Certification_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Certification_Attachment_Order_By>>;
  where?: InputMaybe<Product_Certification_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Certification_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Certification_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Certification_Attachment_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Certification_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Certification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Certification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Certification_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Certification_Bool_Exp>;
};


export type Subscription_RootProduct_ClassArgs = {
  distinct_on?: InputMaybe<Array<Product_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Class_Order_By>>;
  where?: InputMaybe<Product_Class_Bool_Exp>;
};


export type Subscription_RootProduct_Class_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Class_Order_By>>;
  where?: InputMaybe<Product_Class_Bool_Exp>;
};


export type Subscription_RootProduct_Class_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Class_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Class_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Class_Bool_Exp>;
};


export type Subscription_RootProduct_CompositionArgs = {
  distinct_on?: InputMaybe<Array<Product_Composition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Composition_Order_By>>;
  where?: InputMaybe<Product_Composition_Bool_Exp>;
};


export type Subscription_RootProduct_Composition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Composition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Composition_Order_By>>;
  where?: InputMaybe<Product_Composition_Bool_Exp>;
};


export type Subscription_RootProduct_Composition_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Composition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Composition_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Composition_Bool_Exp>;
};


export type Subscription_RootProduct_Crop_AssociationArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Association_Order_By>>;
  where?: InputMaybe<Product_Crop_Association_Bool_Exp>;
};


export type Subscription_RootProduct_Crop_Association_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Association_Order_By>>;
  where?: InputMaybe<Product_Crop_Association_Bool_Exp>;
};


export type Subscription_RootProduct_Crop_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Crop_Association_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Crop_Association_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Crop_Association_Bool_Exp>;
};


export type Subscription_RootProduct_Crop_Infestation_RecommendationArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
};


export type Subscription_RootProduct_Crop_Infestation_Recommendation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Infestation_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
};


export type Subscription_RootProduct_Crop_Infestation_Recommendation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Crop_Infestation_Recommendation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Crop_Infestation_Recommendation_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Crop_Infestation_Recommendation_Bool_Exp>;
};


export type Subscription_RootProduct_Crop_Nutrition_RecommendationArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Nutrition_Recommendation_Bool_Exp>;
};


export type Subscription_RootProduct_Crop_Nutrition_Recommendation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Crop_Nutrition_Recommendation_Order_By>>;
  where?: InputMaybe<Product_Crop_Nutrition_Recommendation_Bool_Exp>;
};


export type Subscription_RootProduct_Crop_Nutrition_Recommendation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Crop_Nutrition_Recommendation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Crop_Nutrition_Recommendation_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Crop_Nutrition_Recommendation_Bool_Exp>;
};


export type Subscription_RootProduct_FavouriteArgs = {
  distinct_on?: InputMaybe<Array<Product_Favourite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Favourite_Order_By>>;
  where?: InputMaybe<Product_Favourite_Bool_Exp>;
};


export type Subscription_RootProduct_Favourite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Favourite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Favourite_Order_By>>;
  where?: InputMaybe<Product_Favourite_Bool_Exp>;
};


export type Subscription_RootProduct_Favourite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Favourite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Favourite_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Favourite_Bool_Exp>;
};


export type Subscription_RootProduct_InfestationArgs = {
  distinct_on?: InputMaybe<Array<Product_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Infestation_Order_By>>;
  where?: InputMaybe<Product_Infestation_Bool_Exp>;
};


export type Subscription_RootProduct_Infestation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Infestation_Order_By>>;
  where?: InputMaybe<Product_Infestation_Bool_Exp>;
};


export type Subscription_RootProduct_Infestation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Infestation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Infestation_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Infestation_Bool_Exp>;
};


export type Subscription_RootProduct_MainsectionArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Bool_Exp>;
};


export type Subscription_RootProduct_Mainsection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Bool_Exp>;
};


export type Subscription_RootProduct_Mainsection_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Mainsection_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Mainsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Mainsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Mainsection_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Mainsection_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Mainsection_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Mainsection_Attachment_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Mainsection_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Mainsection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Mainsection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Mainsection_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Mainsection_Bool_Exp>;
};


export type Subscription_RootProduct_PurchasedArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchased_Order_By>>;
  where?: InputMaybe<Product_Purchased_Bool_Exp>;
};


export type Subscription_RootProduct_Purchased_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchased_Order_By>>;
  where?: InputMaybe<Product_Purchased_Bool_Exp>;
};


export type Subscription_RootProduct_Purchased_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Purchased_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Purchased_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Purchased_Bool_Exp>;
};


export type Subscription_RootProduct_SectionArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Order_By>>;
  where?: InputMaybe<Product_Section_Bool_Exp>;
};


export type Subscription_RootProduct_Section_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Order_By>>;
  where?: InputMaybe<Product_Section_Bool_Exp>;
};


export type Subscription_RootProduct_Section_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Attachment_Order_By>>;
  where?: InputMaybe<Product_Section_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Section_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Section_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Section_Attachment_Order_By>>;
  where?: InputMaybe<Product_Section_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Section_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Section_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Section_Attachment_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Section_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Section_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Section_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Section_Bool_Exp>;
};


export type Subscription_RootProduct_SkuArgs = {
  distinct_on?: InputMaybe<Array<Product_Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Sku_Order_By>>;
  where?: InputMaybe<Product_Sku_Bool_Exp>;
};


export type Subscription_RootProduct_Sku_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Sku_Order_By>>;
  where?: InputMaybe<Product_Sku_Bool_Exp>;
};


export type Subscription_RootProduct_Sku_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Sku_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Sku_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Sku_Bool_Exp>;
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_SubsectionArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Order_By>>;
  where?: InputMaybe<Product_Subsection_Bool_Exp>;
};


export type Subscription_RootProduct_Subsection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Order_By>>;
  where?: InputMaybe<Product_Subsection_Bool_Exp>;
};


export type Subscription_RootProduct_Subsection_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Subsection_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Subsection_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Subsection_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Subsection_Attachment_Order_By>>;
  where?: InputMaybe<Product_Subsection_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Subsection_Attachment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Subsection_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Subsection_Attachment_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Subsection_Attachment_Bool_Exp>;
};


export type Subscription_RootProduct_Subsection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Subsection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Subsection_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Subsection_Bool_Exp>;
};


export type Subscription_RootProduct_ViewArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_View_Order_By>>;
  where?: InputMaybe<Product_View_Bool_Exp>;
};


export type Subscription_RootProduct_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_View_Order_By>>;
  where?: InputMaybe<Product_View_Bool_Exp>;
};


export type Subscription_RootProduct_View_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_View_Bool_Exp>;
};


export type Subscription_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProducts_FertiliserArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Bool_Exp>;
};


export type Subscription_RootProducts_Fertiliser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Bool_Exp>;
};


export type Subscription_RootProducts_Fertiliser_By_PkArgs = {
  baseproduct_ptr_id: Scalars['uuid'];
};


export type Subscription_RootProducts_Fertiliser_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Contents_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
};


export type Subscription_RootProducts_Fertiliser_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Contents_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
};


export type Subscription_RootProducts_Fertiliser_Contents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProducts_Fertiliser_Contents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Products_Fertiliser_Contents_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Fertiliser_Contents_Bool_Exp>;
};


export type Subscription_RootProducts_Fertiliser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Products_Fertiliser_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Fertiliser_Bool_Exp>;
};


export type Subscription_RootProducts_Fertiliser_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Units_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Units_Bool_Exp>;
};


export type Subscription_RootProducts_Fertiliser_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Fertiliser_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Fertiliser_Units_Order_By>>;
  where?: InputMaybe<Products_Fertiliser_Units_Bool_Exp>;
};


export type Subscription_RootProducts_Fertiliser_Units_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProducts_Fertiliser_Units_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Products_Fertiliser_Units_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Fertiliser_Units_Bool_Exp>;
};


export type Subscription_RootProducts_PesticideArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Bool_Exp>;
};


export type Subscription_RootProducts_Pesticide_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Bool_Exp>;
};


export type Subscription_RootProducts_Pesticide_By_PkArgs = {
  baseproduct_ptr_id: Scalars['uuid'];
};


export type Subscription_RootProducts_Pesticide_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Contents_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
};


export type Subscription_RootProducts_Pesticide_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Contents_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
};


export type Subscription_RootProducts_Pesticide_Contents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProducts_Pesticide_Contents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Products_Pesticide_Contents_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Pesticide_Contents_Bool_Exp>;
};


export type Subscription_RootProducts_Pesticide_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Products_Pesticide_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Pesticide_Bool_Exp>;
};


export type Subscription_RootProducts_Pesticide_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Units_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Units_Bool_Exp>;
};


export type Subscription_RootProducts_Pesticide_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Pesticide_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Pesticide_Units_Order_By>>;
  where?: InputMaybe<Products_Pesticide_Units_Bool_Exp>;
};


export type Subscription_RootProducts_Pesticide_Units_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProducts_Pesticide_Units_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Products_Pesticide_Units_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Pesticide_Units_Bool_Exp>;
};


export type Subscription_RootProducts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProviderArgs = {
  distinct_on?: InputMaybe<Array<Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Order_By>>;
  where?: InputMaybe<Provider_Bool_Exp>;
};


export type Subscription_RootProvider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Order_By>>;
  where?: InputMaybe<Provider_Bool_Exp>;
};


export type Subscription_RootProvider_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProvider_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Bool_Exp>;
};


export type Subscription_RootReceiptArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


export type Subscription_RootReceipt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


export type Subscription_RootReceipt_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootReceipt_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Receipt_Stream_Cursor_Input>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


export type Subscription_RootRecommended_ProductArgs = {
  distinct_on?: InputMaybe<Array<Recommended_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommended_Product_Order_By>>;
  where?: InputMaybe<Recommended_Product_Bool_Exp>;
};


export type Subscription_RootRecommended_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recommended_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommended_Product_Order_By>>;
  where?: InputMaybe<Recommended_Product_Bool_Exp>;
};


export type Subscription_RootRecommended_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRecommended_Product_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Recommended_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Recommended_Product_Bool_Exp>;
};


export type Subscription_RootRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRegion_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRegion_GroupArgs = {
  distinct_on?: InputMaybe<Array<Region_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Group_Order_By>>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};


export type Subscription_RootRegion_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Group_Order_By>>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};


export type Subscription_RootRegion_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRegion_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Region_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};


export type Subscription_RootRegion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootReward_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Reward_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reward_Configuration_Order_By>>;
  where?: InputMaybe<Reward_Configuration_Bool_Exp>;
};


export type Subscription_RootReward_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reward_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reward_Configuration_Order_By>>;
  where?: InputMaybe<Reward_Configuration_Bool_Exp>;
};


export type Subscription_RootReward_Configuration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReward_Configuration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Reward_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Reward_Configuration_Bool_Exp>;
};


export type Subscription_RootSap_SiArgs = {
  distinct_on?: InputMaybe<Array<Sap_Si_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sap_Si_Order_By>>;
  where?: InputMaybe<Sap_Si_Bool_Exp>;
};


export type Subscription_RootSap_Si_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sap_Si_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sap_Si_Order_By>>;
  where?: InputMaybe<Sap_Si_Bool_Exp>;
};


export type Subscription_RootSap_Si_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSap_Si_MapArgs = {
  distinct_on?: InputMaybe<Array<Sap_Si_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sap_Si_Map_Order_By>>;
  where?: InputMaybe<Sap_Si_Map_Bool_Exp>;
};


export type Subscription_RootSap_Si_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sap_Si_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sap_Si_Map_Order_By>>;
  where?: InputMaybe<Sap_Si_Map_Bool_Exp>;
};


export type Subscription_RootSap_Si_Map_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSap_Si_Map_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sap_Si_Map_Stream_Cursor_Input>>;
  where?: InputMaybe<Sap_Si_Map_Bool_Exp>;
};


export type Subscription_RootSap_Si_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sap_Si_Stream_Cursor_Input>>;
  where?: InputMaybe<Sap_Si_Bool_Exp>;
};


export type Subscription_RootSearch_Base_UsersArgs = {
  args: Search_Base_Users_Args;
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Subscription_RootSearch_Base_Users_AggregateArgs = {
  args: Search_Base_Users_Args;
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Subscription_RootSearch_Mutual_GroupsArgs = {
  args: Search_Mutual_Groups_Args;
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Subscription_RootSearch_Mutual_Groups_AggregateArgs = {
  args: Search_Mutual_Groups_Args;
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Subscription_RootSearch_Plot_CropsArgs = {
  args: Search_Plot_Crops_Args;
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Subscription_RootSearch_Plot_Crops_AggregateArgs = {
  args: Search_Plot_Crops_Args;
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Subscription_RootSecondary_Growth_StageArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootSecondary_Growth_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootSecondary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSecondary_Growth_Stage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Secondary_Growth_Stage_Stream_Cursor_Input>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootSectionArgs = {
  distinct_on?: InputMaybe<Array<Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Section_Order_By>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


export type Subscription_RootSection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Section_Order_By>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


export type Subscription_RootSection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Section_Stream_Cursor_Input>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


export type Subscription_RootSeedsArgs = {
  distinct_on?: InputMaybe<Array<Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Seeds_Order_By>>;
  where?: InputMaybe<Seeds_Bool_Exp>;
};


export type Subscription_RootSeeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Seeds_Order_By>>;
  where?: InputMaybe<Seeds_Bool_Exp>;
};


export type Subscription_RootSeeds_By_PkArgs = {
  baseproduct_ptr_id: Scalars['uuid'];
};


export type Subscription_RootSeeds_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Seeds_Stream_Cursor_Input>>;
  where?: InputMaybe<Seeds_Bool_Exp>;
};


export type Subscription_RootSellable_ItemArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Order_By>>;
  where?: InputMaybe<Sellable_Item_Bool_Exp>;
};


export type Subscription_RootSellable_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Order_By>>;
  where?: InputMaybe<Sellable_Item_Bool_Exp>;
};


export type Subscription_RootSellable_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSellable_Item_StockArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Stock_Order_By>>;
  where?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
};


export type Subscription_RootSellable_Item_Stock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sellable_Item_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sellable_Item_Stock_Order_By>>;
  where?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
};


export type Subscription_RootSellable_Item_Stock_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSellable_Item_Stock_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sellable_Item_Stock_Stream_Cursor_Input>>;
  where?: InputMaybe<Sellable_Item_Stock_Bool_Exp>;
};


export type Subscription_RootSellable_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sellable_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Sellable_Item_Bool_Exp>;
};


export type Subscription_RootSensorArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Order_By>>;
  where?: InputMaybe<Sensor_Bool_Exp>;
};


export type Subscription_RootSensor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Order_By>>;
  where?: InputMaybe<Sensor_Bool_Exp>;
};


export type Subscription_RootSensor_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSensor_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Parameter_Order_By>>;
  where?: InputMaybe<Sensor_Parameter_Bool_Exp>;
};


export type Subscription_RootSensor_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Parameter_Order_By>>;
  where?: InputMaybe<Sensor_Parameter_Bool_Exp>;
};


export type Subscription_RootSensor_Parameter_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSensor_Parameter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sensor_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Sensor_Parameter_Bool_Exp>;
};


export type Subscription_RootSensor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sensor_Stream_Cursor_Input>>;
  where?: InputMaybe<Sensor_Bool_Exp>;
};


export type Subscription_RootSeriesArgs = {
  distinct_on?: InputMaybe<Array<Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Order_By>>;
  where?: InputMaybe<Series_Bool_Exp>;
};


export type Subscription_RootSeries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Order_By>>;
  where?: InputMaybe<Series_Bool_Exp>;
};


export type Subscription_RootSeries_AuthorsArgs = {
  distinct_on?: InputMaybe<Array<Series_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Authors_Order_By>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};


export type Subscription_RootSeries_Authors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Authors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Authors_Order_By>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};


export type Subscription_RootSeries_Authors_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSeries_Authors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Series_Authors_Stream_Cursor_Input>>;
  where?: InputMaybe<Series_Authors_Bool_Exp>;
};


export type Subscription_RootSeries_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSeries_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Series_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Category_Order_By>>;
  where?: InputMaybe<Series_Category_Bool_Exp>;
};


export type Subscription_RootSeries_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Category_Order_By>>;
  where?: InputMaybe<Series_Category_Bool_Exp>;
};


export type Subscription_RootSeries_Category_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSeries_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Series_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Series_Category_Bool_Exp>;
};


export type Subscription_RootSeries_CropsArgs = {
  distinct_on?: InputMaybe<Array<Series_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Crops_Order_By>>;
  where?: InputMaybe<Series_Crops_Bool_Exp>;
};


export type Subscription_RootSeries_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Crops_Order_By>>;
  where?: InputMaybe<Series_Crops_Bool_Exp>;
};


export type Subscription_RootSeries_Crops_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSeries_Crops_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Series_Crops_Stream_Cursor_Input>>;
  where?: InputMaybe<Series_Crops_Bool_Exp>;
};


export type Subscription_RootSeries_FavoritesArgs = {
  distinct_on?: InputMaybe<Array<Series_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Favorites_Order_By>>;
  where?: InputMaybe<Series_Favorites_Bool_Exp>;
};


export type Subscription_RootSeries_Favorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Favorites_Order_By>>;
  where?: InputMaybe<Series_Favorites_Bool_Exp>;
};


export type Subscription_RootSeries_Favorites_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSeries_Favorites_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Series_Favorites_Stream_Cursor_Input>>;
  where?: InputMaybe<Series_Favorites_Bool_Exp>;
};


export type Subscription_RootSeries_LikesArgs = {
  distinct_on?: InputMaybe<Array<Series_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Likes_Order_By>>;
  where?: InputMaybe<Series_Likes_Bool_Exp>;
};


export type Subscription_RootSeries_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Series_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Series_Likes_Order_By>>;
  where?: InputMaybe<Series_Likes_Bool_Exp>;
};


export type Subscription_RootSeries_Likes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSeries_Likes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Series_Likes_Stream_Cursor_Input>>;
  where?: InputMaybe<Series_Likes_Bool_Exp>;
};


export type Subscription_RootSeries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Series_Stream_Cursor_Input>>;
  where?: InputMaybe<Series_Bool_Exp>;
};


export type Subscription_RootSetu_Trade_Shared_EntityArgs = {
  distinct_on?: InputMaybe<Array<Setu_Trade_Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Trade_Shared_Entity_Order_By>>;
  where?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
};


export type Subscription_RootSetu_Trade_Shared_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSetu_Trade_Shared_Entity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setu_Trade_Shared_Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
};


export type Subscription_RootSetu_Weather_UserArgs = {
  distinct_on?: InputMaybe<Array<Setu_Weather_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Weather_User_Order_By>>;
  where?: InputMaybe<Setu_Weather_User_Bool_Exp>;
};


export type Subscription_RootSetu_Weather_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Setu_Weather_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Weather_User_Order_By>>;
  where?: InputMaybe<Setu_Weather_User_Bool_Exp>;
};


export type Subscription_RootSetu_Weather_User_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSetu_Weather_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setu_Weather_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Setu_Weather_User_Bool_Exp>;
};


export type Subscription_RootShared_EntityArgs = {
  distinct_on?: InputMaybe<Array<Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Entity_Order_By>>;
  where?: InputMaybe<Shared_Entity_Bool_Exp>;
};


export type Subscription_RootShared_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Entity_Order_By>>;
  where?: InputMaybe<Shared_Entity_Bool_Exp>;
};


export type Subscription_RootShared_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootShared_Entity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shared_Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Shared_Entity_Bool_Exp>;
};


export type Subscription_RootSi_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};


export type Subscription_RootSi_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};


export type Subscription_RootSi_Unit_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSi_Unit_MeasureArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Measure_Order_By>>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};


export type Subscription_RootSi_Unit_Measure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Measure_Order_By>>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};


export type Subscription_RootSi_Unit_Measure_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSi_Unit_Measure_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Si_Unit_Measure_Stream_Cursor_Input>>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};


export type Subscription_RootSi_Unit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Si_Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};


export type Subscription_RootSkuArgs = {
  distinct_on?: InputMaybe<Array<Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Order_By>>;
  where?: InputMaybe<Sku_Bool_Exp>;
};


export type Subscription_RootSku_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Order_By>>;
  where?: InputMaybe<Sku_Bool_Exp>;
};


export type Subscription_RootSku_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSku_KindArgs = {
  distinct_on?: InputMaybe<Array<Sku_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Kind_Order_By>>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};


export type Subscription_RootSku_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sku_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Kind_Order_By>>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};


export type Subscription_RootSku_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSku_Kind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sku_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};


export type Subscription_RootSku_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sku_Stream_Cursor_Input>>;
  where?: InputMaybe<Sku_Bool_Exp>;
};


export type Subscription_RootSoilArgs = {
  distinct_on?: InputMaybe<Array<Soil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Soil_Order_By>>;
  where?: InputMaybe<Soil_Bool_Exp>;
};


export type Subscription_RootSoil_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Soil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Soil_Order_By>>;
  where?: InputMaybe<Soil_Bool_Exp>;
};


export type Subscription_RootSoil_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSoil_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Soil_Stream_Cursor_Input>>;
  where?: InputMaybe<Soil_Bool_Exp>;
};


export type Subscription_RootSprinkler_Irrigation_SystemArgs = {
  distinct_on?: InputMaybe<Array<Sprinkler_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sprinkler_Irrigation_System_Order_By>>;
  where?: InputMaybe<Sprinkler_Irrigation_System_Bool_Exp>;
};


export type Subscription_RootSprinkler_Irrigation_System_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sprinkler_Irrigation_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sprinkler_Irrigation_System_Order_By>>;
  where?: InputMaybe<Sprinkler_Irrigation_System_Bool_Exp>;
};


export type Subscription_RootSprinkler_Irrigation_System_By_PkArgs = {
  irrigationsystem_ptr_id: Scalars['uuid'];
};


export type Subscription_RootSprinkler_Irrigation_System_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sprinkler_Irrigation_System_Stream_Cursor_Input>>;
  where?: InputMaybe<Sprinkler_Irrigation_System_Bool_Exp>;
};


export type Subscription_RootSub_SectionArgs = {
  distinct_on?: InputMaybe<Array<Sub_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sub_Section_Order_By>>;
  where?: InputMaybe<Sub_Section_Bool_Exp>;
};


export type Subscription_RootSub_Section_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sub_Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sub_Section_Order_By>>;
  where?: InputMaybe<Sub_Section_Bool_Exp>;
};


export type Subscription_RootSub_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSub_Section_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sub_Section_Stream_Cursor_Input>>;
  where?: InputMaybe<Sub_Section_Bool_Exp>;
};


export type Subscription_RootSubcategoryArgs = {
  distinct_on?: InputMaybe<Array<Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subcategory_Order_By>>;
  where?: InputMaybe<Subcategory_Bool_Exp>;
};


export type Subscription_RootSubcategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subcategory_Order_By>>;
  where?: InputMaybe<Subcategory_Bool_Exp>;
};


export type Subscription_RootSubcategory_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubcategory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Subcategory_Stream_Cursor_Input>>;
  where?: InputMaybe<Subcategory_Bool_Exp>;
};


export type Subscription_RootSubscription_Package_HighlightsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Package_Highlights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Package_Highlights_Order_By>>;
  where?: InputMaybe<Subscription_Package_Highlights_Bool_Exp>;
};


export type Subscription_RootSubscription_Package_Highlights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Package_Highlights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Package_Highlights_Order_By>>;
  where?: InputMaybe<Subscription_Package_Highlights_Bool_Exp>;
};


export type Subscription_RootSubscription_Package_Highlights_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubscription_Package_Highlights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Subscription_Package_Highlights_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Package_Highlights_Bool_Exp>;
};


export type Subscription_RootSummary_Sensor_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Summary_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Summary_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
};


export type Subscription_RootSummary_Sensor_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Summary_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Summary_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
};


export type Subscription_RootSummary_Sensor_Reading_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSummary_Sensor_Reading_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Summary_Sensor_Reading_Stream_Cursor_Input>>;
  where?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
};


export type Subscription_RootThreadArgs = {
  distinct_on?: InputMaybe<Array<Thread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Thread_Order_By>>;
  where?: InputMaybe<Thread_Bool_Exp>;
};


export type Subscription_RootThread_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Thread_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Thread_Order_By>>;
  where?: InputMaybe<Thread_Bool_Exp>;
};


export type Subscription_RootThread_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootThread_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Thread_Stream_Cursor_Input>>;
  where?: InputMaybe<Thread_Bool_Exp>;
};


export type Subscription_RootTradeArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


export type Subscription_RootTrade_Action_LogArgs = {
  distinct_on?: InputMaybe<Array<Trade_Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Action_Log_Order_By>>;
  where?: InputMaybe<Trade_Action_Log_Bool_Exp>;
};


export type Subscription_RootTrade_Action_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Action_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Action_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Action_Log_Bool_Exp>;
};


export type Subscription_RootTrade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


export type Subscription_RootTrade_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_CommodityArgs = {
  distinct_on?: InputMaybe<Array<Trade_Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Commodity_Order_By>>;
  where?: InputMaybe<Trade_Commodity_Bool_Exp>;
};


export type Subscription_RootTrade_Commodity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Commodity_Order_By>>;
  where?: InputMaybe<Trade_Commodity_Bool_Exp>;
};


export type Subscription_RootTrade_Commodity_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTrade_Commodity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Commodity_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Commodity_Bool_Exp>;
};


export type Subscription_RootTrade_ItemArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


export type Subscription_RootTrade_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


export type Subscription_RootTrade_Item_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


export type Subscription_RootTrade_RegionArgs = {
  distinct_on?: InputMaybe<Array<Trade_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Region_Order_By>>;
  where?: InputMaybe<Trade_Region_Bool_Exp>;
};


export type Subscription_RootTrade_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Region_Order_By>>;
  where?: InputMaybe<Trade_Region_Bool_Exp>;
};


export type Subscription_RootTrade_Region_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTrade_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Region_Bool_Exp>;
};


export type Subscription_RootTrade_StatusArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Order_By>>;
  where?: InputMaybe<Trade_Status_Bool_Exp>;
};


export type Subscription_RootTrade_Status_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTrade_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Status_Bool_Exp>;
};


export type Subscription_RootTrade_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


export type Subscription_RootTrade_TradestatusaccessArgs = {
  distinct_on?: InputMaybe<Array<Trade_Tradestatusaccess_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Tradestatusaccess_Order_By>>;
  where?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
};


export type Subscription_RootTrade_Tradestatusaccess_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Tradestatusaccess_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Tradestatusaccess_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
};


export type Subscription_RootTrade_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Bool_Exp>;
};


export type Subscription_RootTrade_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Bool_Exp>;
};


export type Subscription_RootTrade_Transaction_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTrade_Transaction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Transaction_Bool_Exp>;
};


export type Subscription_RootTrade_Transaction_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Summary_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
};


export type Subscription_RootTrade_Transaction_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Summary_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
};


export type Subscription_RootTrade_Transaction_Summary_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTrade_Transaction_Summary_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Transaction_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
};


export type Subscription_RootTrade_UnitArgs = {
  distinct_on?: InputMaybe<Array<Trade_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Unit_Order_By>>;
  where?: InputMaybe<Trade_Unit_Bool_Exp>;
};


export type Subscription_RootTrade_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Unit_Order_By>>;
  where?: InputMaybe<Trade_Unit_Bool_Exp>;
};


export type Subscription_RootTrade_Unit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTrade_Unit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Unit_Bool_Exp>;
};


export type Subscription_RootTransaction_TrendArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Trend_Order_By>>;
  where?: InputMaybe<Transaction_Trend_Bool_Exp>;
};


export type Subscription_RootTransaction_Trend_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Trend_Order_By>>;
  where?: InputMaybe<Transaction_Trend_Bool_Exp>;
};


export type Subscription_RootTransaction_Trend_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTransaction_Trend_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transaction_Trend_Stream_Cursor_Input>>;
  where?: InputMaybe<Transaction_Trend_Bool_Exp>;
};


export type Subscription_RootUnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUnit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUser_Answer_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<User_Answer_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Answer_Choices_Order_By>>;
  where?: InputMaybe<User_Answer_Choices_Bool_Exp>;
};


export type Subscription_RootUser_Answer_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Answer_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Answer_Choices_Order_By>>;
  where?: InputMaybe<User_Answer_Choices_Bool_Exp>;
};


export type Subscription_RootUser_Answer_Choices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Answer_Choices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Answer_Choices_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Answer_Choices_Bool_Exp>;
};


export type Subscription_RootUser_Assessment_AttemptArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Attempt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Attempt_Order_By>>;
  where?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
};


export type Subscription_RootUser_Assessment_Attempt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Attempt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Attempt_Order_By>>;
  where?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
};


export type Subscription_RootUser_Assessment_Attempt_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Assessment_Attempt_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Assessment_Attempt_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
};


export type Subscription_RootUser_Assessment_Question_ResponseArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Question_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Question_Response_Order_By>>;
  where?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};


export type Subscription_RootUser_Assessment_Question_Response_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Question_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Question_Response_Order_By>>;
  where?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};


export type Subscription_RootUser_Assessment_Question_Response_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Assessment_Question_Response_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Assessment_Question_Response_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};


export type Subscription_RootUser_Reward_HistoryArgs = {
  distinct_on?: InputMaybe<Array<User_Reward_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Reward_History_Order_By>>;
  where?: InputMaybe<User_Reward_History_Bool_Exp>;
};


export type Subscription_RootUser_Reward_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Reward_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Reward_History_Order_By>>;
  where?: InputMaybe<User_Reward_History_Bool_Exp>;
};


export type Subscription_RootUser_Reward_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Reward_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Reward_History_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Reward_History_Bool_Exp>;
};


export type Subscription_RootUser_Subscription_PackageArgs = {
  distinct_on?: InputMaybe<Array<User_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscription_Package_Order_By>>;
  where?: InputMaybe<User_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootUser_Subscription_Package_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscription_Package_Order_By>>;
  where?: InputMaybe<User_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootUser_Subscription_Package_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootUser_Subscription_Package_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Subscription_Package_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootVariety_GradeArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


export type Subscription_RootVariety_Grade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


export type Subscription_RootVariety_Grade_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVariety_Grade_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


export type Subscription_RootVariety_Grade_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


export type Subscription_RootVariety_Grade_Photos_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVariety_Grade_Photos_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Variety_Grade_Photos_Stream_Cursor_Input>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


export type Subscription_RootVariety_Grade_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Variety_Grade_Stream_Cursor_Input>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


export type Subscription_RootVariety_GroupArgs = {
  distinct_on?: InputMaybe<Array<Variety_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Group_Order_By>>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};


export type Subscription_RootVariety_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Group_Order_By>>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};


export type Subscription_RootVariety_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVariety_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Variety_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};


export type Subscription_RootWeather_LocationArgs = {
  distinct_on?: InputMaybe<Array<Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Location_Order_By>>;
  where?: InputMaybe<Weather_Location_Bool_Exp>;
};


export type Subscription_RootWeather_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Location_Order_By>>;
  where?: InputMaybe<Weather_Location_Bool_Exp>;
};


export type Subscription_RootWeather_Location_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWeather_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Weather_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Weather_Location_Bool_Exp>;
};


export type Subscription_RootWeather_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<Weather_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Reference_Order_By>>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};


export type Subscription_RootWeather_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Reference_Order_By>>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};


export type Subscription_RootWeather_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWeather_Reference_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Weather_Reference_Stream_Cursor_Input>>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};

/** columns and relationships of "summary_sensor_reading" */
export type Summary_Sensor_Reading = {
  __typename?: 'summary_sensor_reading';
  aggregation_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  date: Scalars['date'];
  id: Scalars['bigint'];
  location_id: Scalars['uuid'];
  /** An object relationship */
  sensor: Sensor;
  sensor_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  value?: Maybe<Scalars['float8']>;
  /** An object relationship */
  weather_location: Weather_Location;
};

/** aggregated selection of "summary_sensor_reading" */
export type Summary_Sensor_Reading_Aggregate = {
  __typename?: 'summary_sensor_reading_aggregate';
  aggregate?: Maybe<Summary_Sensor_Reading_Aggregate_Fields>;
  nodes: Array<Summary_Sensor_Reading>;
};

/** aggregate fields of "summary_sensor_reading" */
export type Summary_Sensor_Reading_Aggregate_Fields = {
  __typename?: 'summary_sensor_reading_aggregate_fields';
  avg?: Maybe<Summary_Sensor_Reading_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Summary_Sensor_Reading_Max_Fields>;
  min?: Maybe<Summary_Sensor_Reading_Min_Fields>;
  stddev?: Maybe<Summary_Sensor_Reading_Stddev_Fields>;
  stddev_pop?: Maybe<Summary_Sensor_Reading_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Summary_Sensor_Reading_Stddev_Samp_Fields>;
  sum?: Maybe<Summary_Sensor_Reading_Sum_Fields>;
  var_pop?: Maybe<Summary_Sensor_Reading_Var_Pop_Fields>;
  var_samp?: Maybe<Summary_Sensor_Reading_Var_Samp_Fields>;
  variance?: Maybe<Summary_Sensor_Reading_Variance_Fields>;
};


/** aggregate fields of "summary_sensor_reading" */
export type Summary_Sensor_Reading_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Summary_Sensor_Reading_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Aggregate_Order_By = {
  avg?: InputMaybe<Summary_Sensor_Reading_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Summary_Sensor_Reading_Max_Order_By>;
  min?: InputMaybe<Summary_Sensor_Reading_Min_Order_By>;
  stddev?: InputMaybe<Summary_Sensor_Reading_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Summary_Sensor_Reading_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Summary_Sensor_Reading_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Summary_Sensor_Reading_Sum_Order_By>;
  var_pop?: InputMaybe<Summary_Sensor_Reading_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Summary_Sensor_Reading_Var_Samp_Order_By>;
  variance?: InputMaybe<Summary_Sensor_Reading_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Arr_Rel_Insert_Input = {
  data: Array<Summary_Sensor_Reading_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Summary_Sensor_Reading_On_Conflict>;
};

/** aggregate avg on columns */
export type Summary_Sensor_Reading_Avg_Fields = {
  __typename?: 'summary_sensor_reading_avg_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "summary_sensor_reading". All fields are combined with a logical 'AND'. */
export type Summary_Sensor_Reading_Bool_Exp = {
  _and?: InputMaybe<Array<Summary_Sensor_Reading_Bool_Exp>>;
  _not?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
  _or?: InputMaybe<Array<Summary_Sensor_Reading_Bool_Exp>>;
  aggregation_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  sensor?: InputMaybe<Sensor_Bool_Exp>;
  sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
  weather_location?: InputMaybe<Weather_Location_Bool_Exp>;
};

/** unique or primary key constraints on table "summary_sensor_reading" */
export enum Summary_Sensor_Reading_Constraint {
  /** unique or primary key constraint on columns "date", "aggregation_type", "location_id", "sensor_id" */
  SummarySensorReadingDateLocationIdSensor_293eeba9Uniq = 'summary_sensor_reading_date_location_id_sensor__293eeba9_uniq',
  /** unique or primary key constraint on columns "id" */
  SummarySensorReadingPkey = 'summary_sensor_reading_pkey'
}

/** input type for incrementing numeric columns in table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Insert_Input = {
  aggregation_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  sensor?: InputMaybe<Sensor_Obj_Rel_Insert_Input>;
  sensor_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
  weather_location?: InputMaybe<Weather_Location_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Summary_Sensor_Reading_Max_Fields = {
  __typename?: 'summary_sensor_reading_max_fields';
  aggregation_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  sensor_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Max_Order_By = {
  aggregation_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Summary_Sensor_Reading_Min_Fields = {
  __typename?: 'summary_sensor_reading_min_fields';
  aggregation_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['uuid']>;
  sensor_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Min_Order_By = {
  aggregation_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Mutation_Response = {
  __typename?: 'summary_sensor_reading_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Summary_Sensor_Reading>;
};

/** on_conflict condition type for table "summary_sensor_reading" */
export type Summary_Sensor_Reading_On_Conflict = {
  constraint: Summary_Sensor_Reading_Constraint;
  update_columns?: Array<Summary_Sensor_Reading_Update_Column>;
  where?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
};

/** Ordering options when selecting data from "summary_sensor_reading". */
export type Summary_Sensor_Reading_Order_By = {
  aggregation_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  sensor?: InputMaybe<Sensor_Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  weather_location?: InputMaybe<Weather_Location_Order_By>;
};

/** primary key columns input for table: summary_sensor_reading */
export type Summary_Sensor_Reading_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "summary_sensor_reading" */
export enum Summary_Sensor_Reading_Select_Column {
  /** column name */
  AggregationType = 'aggregation_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Set_Input = {
  aggregation_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  sensor_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Summary_Sensor_Reading_Stddev_Fields = {
  __typename?: 'summary_sensor_reading_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Summary_Sensor_Reading_Stddev_Pop_Fields = {
  __typename?: 'summary_sensor_reading_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Summary_Sensor_Reading_Stddev_Samp_Fields = {
  __typename?: 'summary_sensor_reading_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Summary_Sensor_Reading_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Summary_Sensor_Reading_Stream_Cursor_Value_Input = {
  aggregation_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  sensor_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Summary_Sensor_Reading_Sum_Fields = {
  __typename?: 'summary_sensor_reading_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "summary_sensor_reading" */
export enum Summary_Sensor_Reading_Update_Column {
  /** column name */
  AggregationType = 'aggregation_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Summary_Sensor_Reading_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Summary_Sensor_Reading_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Summary_Sensor_Reading_Set_Input>;
  where: Summary_Sensor_Reading_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Summary_Sensor_Reading_Var_Pop_Fields = {
  __typename?: 'summary_sensor_reading_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Summary_Sensor_Reading_Var_Samp_Fields = {
  __typename?: 'summary_sensor_reading_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Summary_Sensor_Reading_Variance_Fields = {
  __typename?: 'summary_sensor_reading_variance_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "summary_sensor_reading" */
export type Summary_Sensor_Reading_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "thread" */
export type Thread = {
  __typename?: 'thread';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An array relationship */
  messages: Array<Message>;
  /** An aggregate relationship */
  messages_aggregate: Message_Aggregate;
  /** An object relationship */
  monitoring_record?: Maybe<Monitoring_Record>;
  plot_crop: Array<Plot_Crop>;
  plot_crop_id?: Maybe<Scalars['String']>;
  record_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "thread" */
export type ThreadMessagesArgs = {
  distinct_on?: InputMaybe<Array<Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Message_Order_By>>;
  where?: InputMaybe<Message_Bool_Exp>;
};


/** columns and relationships of "thread" */
export type ThreadMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Message_Order_By>>;
  where?: InputMaybe<Message_Bool_Exp>;
};


/** columns and relationships of "thread" */
export type ThreadPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp_Remote_Rel_Threadplot_Crop>;
};

/** aggregated selection of "thread" */
export type Thread_Aggregate = {
  __typename?: 'thread_aggregate';
  aggregate?: Maybe<Thread_Aggregate_Fields>;
  nodes: Array<Thread>;
};

/** aggregate fields of "thread" */
export type Thread_Aggregate_Fields = {
  __typename?: 'thread_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Thread_Max_Fields>;
  min?: Maybe<Thread_Min_Fields>;
};


/** aggregate fields of "thread" */
export type Thread_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Thread_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "thread" */
export type Thread_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Thread_Max_Order_By>;
  min?: InputMaybe<Thread_Min_Order_By>;
};

/** input type for inserting array relation for remote table "thread" */
export type Thread_Arr_Rel_Insert_Input = {
  data: Array<Thread_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Thread_On_Conflict>;
};

/** Boolean expression to filter rows from the table "thread". All fields are combined with a logical 'AND'. */
export type Thread_Bool_Exp = {
  _and?: InputMaybe<Array<Thread_Bool_Exp>>;
  _not?: InputMaybe<Thread_Bool_Exp>;
  _or?: InputMaybe<Array<Thread_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  messages?: InputMaybe<Message_Bool_Exp>;
  monitoring_record?: InputMaybe<Monitoring_Record_Bool_Exp>;
  plot_crop_id?: InputMaybe<String_Comparison_Exp>;
  record_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "thread" */
export enum Thread_Constraint {
  /** unique or primary key constraint on columns "id" */
  ThreadPkey = 'thread_pkey'
}

/** input type for inserting data into table "thread" */
export type Thread_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<Message_Arr_Rel_Insert_Input>;
  monitoring_record?: InputMaybe<Monitoring_Record_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['String']>;
  record_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Thread_Max_Fields = {
  __typename?: 'thread_max_fields';
  id?: Maybe<Scalars['uuid']>;
  plot_crop_id?: Maybe<Scalars['String']>;
  record_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "thread" */
export type Thread_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  record_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Thread_Min_Fields = {
  __typename?: 'thread_min_fields';
  id?: Maybe<Scalars['uuid']>;
  plot_crop_id?: Maybe<Scalars['String']>;
  record_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "thread" */
export type Thread_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  record_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "thread" */
export type Thread_Mutation_Response = {
  __typename?: 'thread_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Thread>;
};

/** input type for inserting object relation for remote table "thread" */
export type Thread_Obj_Rel_Insert_Input = {
  data: Thread_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Thread_On_Conflict>;
};

/** on_conflict condition type for table "thread" */
export type Thread_On_Conflict = {
  constraint: Thread_Constraint;
  update_columns?: Array<Thread_Update_Column>;
  where?: InputMaybe<Thread_Bool_Exp>;
};

/** Ordering options when selecting data from "thread". */
export type Thread_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Message_Aggregate_Order_By>;
  monitoring_record?: InputMaybe<Monitoring_Record_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  record_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: thread */
export type Thread_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "thread" */
export enum Thread_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  RecordId = 'record_id'
}

/** input type for updating data in table "thread" */
export type Thread_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_crop_id?: InputMaybe<Scalars['String']>;
  record_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "thread" */
export type Thread_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Thread_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Thread_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_crop_id?: InputMaybe<Scalars['String']>;
  record_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "thread" */
export enum Thread_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  RecordId = 'record_id'
}

export type Thread_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Thread_Set_Input>;
  where: Thread_Bool_Exp;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "trade" */
export type Trade = {
  __typename?: 'trade';
  /** An array relationship */
  action_logs: Array<Trade_Action_Log>;
  /** An object relationship */
  buyer?: Maybe<Setu_Trade_Shared_Entity>;
  buyer_consent_id?: Maybe<Scalars['bigint']>;
  buyer_hash?: Maybe<Scalars['String']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_remark?: Maybe<Scalars['String']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  buyer_verification?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  commodity: Setu_Trade_Shared_Entity;
  commodity_id: Scalars['bigint'];
  /** An object relationship */
  commodity_variety?: Maybe<Setu_Trade_Shared_Entity>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by: Array<Base_User>;
  created_by_id: Scalars['String'];
  /** An object relationship */
  current_status?: Maybe<Trade_Status>;
  current_status_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  department: Setu_Trade_Shared_Entity;
  department_id: Scalars['bigint'];
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  expenses: Array<Expense>;
  /** An aggregate relationship */
  expenses_aggregate: Expense_Aggregate;
  expiry?: Maybe<Scalars['date']>;
  /** An object relationship */
  facilitator?: Maybe<Setu_Trade_Shared_Entity>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  invoice_id?: Maybe<Scalars['bigint']>;
  kind: Scalars['String'];
  mode: Scalars['String'];
  packaging: Scalars['String'];
  /** An object relationship */
  parent_trade?: Maybe<Trade>;
  parent_trade_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  plot_crop?: Maybe<Setu_Trade_Shared_Entity>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  receipt?: Maybe<Receipt>;
  receipt_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  seller?: Maybe<Setu_Trade_Shared_Entity>;
  seller_consent_id?: Maybe<Scalars['bigint']>;
  seller_hash?: Maybe<Scalars['String']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_remark?: Maybe<Scalars['String']>;
  seller_tnc?: Maybe<Scalars['String']>;
  seller_verification?: Maybe<Scalars['Boolean']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code: Scalars['String'];
  trade_amounts_counter: Scalars['Int'];
  /** An array relationship */
  trade_items: Array<Trade_Item>;
  /** An aggregate relationship */
  trade_items_aggregate: Trade_Item_Aggregate;
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by: Array<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "trade" */
export type TradeAction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Action_Log_Order_By>>;
  where?: InputMaybe<Trade_Action_Log_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeCreated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Tradecreated_By>;
};


/** columns and relationships of "trade" */
export type TradeExpensesArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeExpenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTrade_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTrade_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeUpdated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Tradeupdated_By>;
};

/** columns and relationships of "action_log" */
export type Trade_Action_Log = {
  __typename?: 'trade_action_log';
  action_flag: Scalars['String'];
  change_message: Scalars['String'];
  change_object?: Maybe<Scalars['jsonb']>;
  change_title: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  id: Scalars['bigint'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "action_log" */
export type Trade_Action_LogChange_ObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "action_log" */
export type Trade_Action_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Action_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Action_Log_Max_Order_By>;
  min?: InputMaybe<Trade_Action_Log_Min_Order_By>;
  stddev?: InputMaybe<Trade_Action_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Action_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Action_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Action_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Action_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Action_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Action_Log_Variance_Order_By>;
};

/** order by avg() on columns of table "action_log" */
export type Trade_Action_Log_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "action_log". All fields are combined with a logical 'AND'. */
export type Trade_Action_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Action_Log_Bool_Exp>>;
  _not?: InputMaybe<Trade_Action_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Action_Log_Bool_Exp>>;
  action_flag?: InputMaybe<String_Comparison_Exp>;
  change_message?: InputMaybe<String_Comparison_Exp>;
  change_object?: InputMaybe<Jsonb_Comparison_Exp>;
  change_title?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "action_log" */
export type Trade_Action_Log_Max_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  change_title?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "action_log" */
export type Trade_Action_Log_Min_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  change_title?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "action_log". */
export type Trade_Action_Log_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  change_object?: InputMaybe<Order_By>;
  change_title?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** select columns of table "action_log" */
export enum Trade_Action_Log_Select_Column {
  /** column name */
  ActionFlag = 'action_flag',
  /** column name */
  ChangeMessage = 'change_message',
  /** column name */
  ChangeObject = 'change_object',
  /** column name */
  ChangeTitle = 'change_title',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** order by stddev() on columns of table "action_log" */
export type Trade_Action_Log_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "action_log" */
export type Trade_Action_Log_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "action_log" */
export type Trade_Action_Log_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_action_log" */
export type Trade_Action_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Action_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Action_Log_Stream_Cursor_Value_Input = {
  action_flag?: InputMaybe<Scalars['String']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  change_title?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "action_log" */
export type Trade_Action_Log_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "action_log" */
export type Trade_Action_Log_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "action_log" */
export type Trade_Action_Log_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "action_log" */
export type Trade_Action_Log_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregated selection of "trade" */
export type Trade_Aggregate = {
  __typename?: 'trade_aggregate';
  aggregate?: Maybe<Trade_Aggregate_Fields>;
  nodes: Array<Trade>;
};

/** aggregate fields of "trade" */
export type Trade_Aggregate_Fields = {
  __typename?: 'trade_aggregate_fields';
  avg?: Maybe<Trade_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Max_Fields>;
  min?: Maybe<Trade_Min_Fields>;
  stddev?: Maybe<Trade_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Sum_Fields>;
  var_pop?: Maybe<Trade_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Var_Samp_Fields>;
  variance?: Maybe<Trade_Variance_Fields>;
};


/** aggregate fields of "trade" */
export type Trade_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade" */
export type Trade_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Max_Order_By>;
  min?: InputMaybe<Trade_Min_Order_By>;
  stddev?: InputMaybe<Trade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trade" */
export type Trade_Arr_Rel_Insert_Input = {
  data: Array<Trade_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_On_Conflict>;
};

/** aggregate avg on columns */
export type Trade_Avg_Fields = {
  __typename?: 'trade_avg_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade" */
export type Trade_Avg_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade". All fields are combined with a logical 'AND'. */
export type Trade_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Bool_Exp>>;
  _not?: InputMaybe<Trade_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Bool_Exp>>;
  action_logs?: InputMaybe<Trade_Action_Log_Bool_Exp>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  buyer_consent_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_remark?: InputMaybe<String_Comparison_Exp>;
  buyer_tnc?: InputMaybe<String_Comparison_Exp>;
  buyer_verification?: InputMaybe<Boolean_Comparison_Exp>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_id?: InputMaybe<Bigint_Comparison_Exp>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_variety_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  current_status?: InputMaybe<Trade_Status_Bool_Exp>;
  current_status_id?: InputMaybe<String_Comparison_Exp>;
  deducted_amount?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  expense_amount?: InputMaybe<Numeric_Comparison_Exp>;
  expenses?: InputMaybe<Expense_Bool_Exp>;
  expiry?: InputMaybe<Date_Comparison_Exp>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  facilitator_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoice_id?: InputMaybe<Bigint_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  packaging?: InputMaybe<String_Comparison_Exp>;
  parent_trade?: InputMaybe<Trade_Bool_Exp>;
  parent_trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  plot_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  receipt?: InputMaybe<Receipt_Bool_Exp>;
  receipt_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  seller_consent_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_remark?: InputMaybe<String_Comparison_Exp>;
  seller_tnc?: InputMaybe<String_Comparison_Exp>;
  seller_verification?: InputMaybe<Boolean_Comparison_Exp>;
  standard_deduction?: InputMaybe<Numeric_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  tracking_code?: InputMaybe<String_Comparison_Exp>;
  trade_amounts_counter?: InputMaybe<Int_Comparison_Exp>;
  trade_items?: InputMaybe<Trade_Item_Bool_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "trade_commodity" */
export type Trade_Commodity = {
  __typename?: 'trade_commodity';
  commodity: Array<Commodity>;
  commodity_id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  external_commodity_reference: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  last_updated?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['uuid'];
  /** An array relationship */
  trade_transaction_summaries: Array<Trade_Transaction_Summary>;
  /** An aggregate relationship */
  trade_transaction_summaries_aggregate: Trade_Transaction_Summary_Aggregate;
  /** An array relationship */
  trade_transactions: Array<Trade_Transaction>;
  /** An aggregate relationship */
  trade_transactions_aggregate: Trade_Transaction_Aggregate;
  /** An array relationship */
  transaction_trends: Array<Transaction_Trend>;
  /** An aggregate relationship */
  transaction_trends_aggregate: Transaction_Trend_Aggregate;
};


/** columns and relationships of "trade_commodity" */
export type Trade_CommodityCommodityArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp_Remote_Rel_Trade_Commoditycommodity>;
};


/** columns and relationships of "trade_commodity" */
export type Trade_CommodityTrade_Transaction_SummariesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Summary_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
};


/** columns and relationships of "trade_commodity" */
export type Trade_CommodityTrade_Transaction_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Summary_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
};


/** columns and relationships of "trade_commodity" */
export type Trade_CommodityTrade_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Bool_Exp>;
};


/** columns and relationships of "trade_commodity" */
export type Trade_CommodityTrade_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Bool_Exp>;
};


/** columns and relationships of "trade_commodity" */
export type Trade_CommodityTransaction_TrendsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Trend_Order_By>>;
  where?: InputMaybe<Transaction_Trend_Bool_Exp>;
};


/** columns and relationships of "trade_commodity" */
export type Trade_CommodityTransaction_Trends_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Trend_Order_By>>;
  where?: InputMaybe<Transaction_Trend_Bool_Exp>;
};

/** aggregated selection of "trade_commodity" */
export type Trade_Commodity_Aggregate = {
  __typename?: 'trade_commodity_aggregate';
  aggregate?: Maybe<Trade_Commodity_Aggregate_Fields>;
  nodes: Array<Trade_Commodity>;
};

/** aggregate fields of "trade_commodity" */
export type Trade_Commodity_Aggregate_Fields = {
  __typename?: 'trade_commodity_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Trade_Commodity_Max_Fields>;
  min?: Maybe<Trade_Commodity_Min_Fields>;
};


/** aggregate fields of "trade_commodity" */
export type Trade_Commodity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Commodity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "trade_commodity". All fields are combined with a logical 'AND'. */
export type Trade_Commodity_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Commodity_Bool_Exp>>;
  _not?: InputMaybe<Trade_Commodity_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Commodity_Bool_Exp>>;
  commodity_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  external_commodity_reference?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  trade_transaction_summaries?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
  trade_transactions?: InputMaybe<Trade_Transaction_Bool_Exp>;
  transaction_trends?: InputMaybe<Transaction_Trend_Bool_Exp>;
};

/** unique or primary key constraints on table "trade_commodity" */
export enum Trade_Commodity_Constraint {
  /** unique or primary key constraint on columns "provider_id", "external_commodity_reference", "commodity_id" */
  TradeCommodityCommodityIdExternalCo_5238c4beUniq = 'trade_commodity_commodity_id_external_co_5238c4be_uniq',
  /** unique or primary key constraint on columns "id" */
  TradeCommodityPkey = 'trade_commodity_pkey'
}

/** input type for inserting data into table "trade_commodity" */
export type Trade_Commodity_Insert_Input = {
  commodity_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  external_commodity_reference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_updated?: InputMaybe<Scalars['timestamptz']>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  trade_transaction_summaries?: InputMaybe<Trade_Transaction_Summary_Arr_Rel_Insert_Input>;
  trade_transactions?: InputMaybe<Trade_Transaction_Arr_Rel_Insert_Input>;
  transaction_trends?: InputMaybe<Transaction_Trend_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Trade_Commodity_Max_Fields = {
  __typename?: 'trade_commodity_max_fields';
  commodity_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  external_commodity_reference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
  provider_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Trade_Commodity_Min_Fields = {
  __typename?: 'trade_commodity_min_fields';
  commodity_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  external_commodity_reference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
  provider_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "trade_commodity" */
export type Trade_Commodity_Mutation_Response = {
  __typename?: 'trade_commodity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Commodity>;
};

/** input type for inserting object relation for remote table "trade_commodity" */
export type Trade_Commodity_Obj_Rel_Insert_Input = {
  data: Trade_Commodity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Commodity_On_Conflict>;
};

/** on_conflict condition type for table "trade_commodity" */
export type Trade_Commodity_On_Conflict = {
  constraint: Trade_Commodity_Constraint;
  update_columns?: Array<Trade_Commodity_Update_Column>;
  where?: InputMaybe<Trade_Commodity_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_commodity". */
export type Trade_Commodity_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  external_commodity_reference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  trade_transaction_summaries_aggregate?: InputMaybe<Trade_Transaction_Summary_Aggregate_Order_By>;
  trade_transactions_aggregate?: InputMaybe<Trade_Transaction_Aggregate_Order_By>;
  transaction_trends_aggregate?: InputMaybe<Transaction_Trend_Aggregate_Order_By>;
};

/** primary key columns input for table: trade_commodity */
export type Trade_Commodity_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "trade_commodity" */
export enum Trade_Commodity_Select_Column {
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  Description = 'description',
  /** column name */
  ExternalCommodityReference = 'external_commodity_reference',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  ProviderId = 'provider_id'
}

/** input type for updating data in table "trade_commodity" */
export type Trade_Commodity_Set_Input = {
  commodity_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  external_commodity_reference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_updated?: InputMaybe<Scalars['timestamptz']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "trade_commodity" */
export type Trade_Commodity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Commodity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Commodity_Stream_Cursor_Value_Input = {
  commodity_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  external_commodity_reference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_updated?: InputMaybe<Scalars['timestamptz']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "trade_commodity" */
export enum Trade_Commodity_Update_Column {
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  Description = 'description',
  /** column name */
  ExternalCommodityReference = 'external_commodity_reference',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  ProviderId = 'provider_id'
}

export type Trade_Commodity_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Commodity_Set_Input>;
  where: Trade_Commodity_Bool_Exp;
};

/** unique or primary key constraints on table "trade" */
export enum Trade_Constraint {
  /** unique or primary key constraint on columns "id" */
  TradePkey = 'trade_pkey',
  /** unique or primary key constraint on columns "tracking_code" */
  TradeTrackingCodeKey = 'trade_tracking_code_key'
}

/** input type for incrementing numeric columns in table "trade" */
export type Trade_Inc_Input = {
  buyer_consent_id?: InputMaybe<Scalars['bigint']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  parent_trade_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  seller_consent_id?: InputMaybe<Scalars['bigint']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  trade_amounts_counter?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trade" */
export type Trade_Insert_Input = {
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  buyer_consent_id?: InputMaybe<Scalars['bigint']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_remark?: InputMaybe<Scalars['String']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  current_status_id?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date?: InputMaybe<Scalars['date']>;
  expenses?: InputMaybe<Expense_Arr_Rel_Insert_Input>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  parent_trade_id?: InputMaybe<Scalars['bigint']>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  receipt?: InputMaybe<Receipt_Obj_Rel_Insert_Input>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  seller_consent_id?: InputMaybe<Scalars['bigint']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_remark?: InputMaybe<Scalars['String']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  trade_amounts_counter?: InputMaybe<Scalars['Int']>;
  trade_items?: InputMaybe<Trade_Item_Arr_Rel_Insert_Input>;
  trades?: InputMaybe<Trade_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "trade_item" */
export type Trade_Item = {
  __typename?: 'trade_item';
  amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Setu_Trade_Shared_Entity;
  currency_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  packaging_unit?: Maybe<Setu_Trade_Shared_Entity>;
  packaging_unit_id?: Maybe<Scalars['bigint']>;
  quantity: Scalars['numeric'];
  /** An object relationship */
  quantity_unit: Setu_Trade_Shared_Entity;
  quantity_unit_id: Scalars['bigint'];
  rate: Scalars['numeric'];
  /** An object relationship */
  rate_unit: Setu_Trade_Shared_Entity;
  rate_unit_id: Scalars['bigint'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  variety_grade?: Maybe<Setu_Trade_Shared_Entity>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "trade_item" */
export type Trade_Item_Aggregate = {
  __typename?: 'trade_item_aggregate';
  aggregate?: Maybe<Trade_Item_Aggregate_Fields>;
  nodes: Array<Trade_Item>;
};

/** aggregate fields of "trade_item" */
export type Trade_Item_Aggregate_Fields = {
  __typename?: 'trade_item_aggregate_fields';
  avg?: Maybe<Trade_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Item_Max_Fields>;
  min?: Maybe<Trade_Item_Min_Fields>;
  stddev?: Maybe<Trade_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Item_Sum_Fields>;
  var_pop?: Maybe<Trade_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Item_Var_Samp_Fields>;
  variance?: Maybe<Trade_Item_Variance_Fields>;
};


/** aggregate fields of "trade_item" */
export type Trade_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_item" */
export type Trade_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Item_Max_Order_By>;
  min?: InputMaybe<Trade_Item_Min_Order_By>;
  stddev?: InputMaybe<Trade_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Item_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trade_item" */
export type Trade_Item_Arr_Rel_Insert_Input = {
  data: Array<Trade_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Item_On_Conflict>;
};

/** aggregate avg on columns */
export type Trade_Item_Avg_Fields = {
  __typename?: 'trade_item_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_item" */
export type Trade_Item_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_item". All fields are combined with a logical 'AND'. */
export type Trade_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Item_Bool_Exp>>;
  _not?: InputMaybe<Trade_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Item_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  currency_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  packaging_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  packaging_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  quantity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  rate?: InputMaybe<Numeric_Comparison_Exp>;
  rate_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  rate_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  variety_grade?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  variety_grade_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "trade_item" */
export enum Trade_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  TradeItemPkey = 'trade_item_pkey'
}

/** input type for incrementing numeric columns in table "trade_item" */
export type Trade_Item_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  currency_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_unit_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  rate?: InputMaybe<Scalars['numeric']>;
  rate_unit_id?: InputMaybe<Scalars['bigint']>;
  variety_grade_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "trade_item" */
export type Trade_Item_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_unit?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  packaging_unit_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  quantity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  rate?: InputMaybe<Scalars['numeric']>;
  rate_unit?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  rate_unit_id?: InputMaybe<Scalars['bigint']>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  variety_grade?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  variety_grade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Trade_Item_Max_Fields = {
  __typename?: 'trade_item_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  packaging_unit_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['numeric']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trade_item" */
export type Trade_Item_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Item_Min_Fields = {
  __typename?: 'trade_item_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  packaging_unit_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['numeric']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trade_item" */
export type Trade_Item_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trade_item" */
export type Trade_Item_Mutation_Response = {
  __typename?: 'trade_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Item>;
};

/** on_conflict condition type for table "trade_item" */
export type Trade_Item_On_Conflict = {
  constraint: Trade_Item_Constraint;
  update_columns?: Array<Trade_Item_Update_Column>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_item". */
export type Trade_Item_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_grade?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade_item */
export type Trade_Item_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "trade_item" */
export enum Trade_Item_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  PackagingUnitId = 'packaging_unit_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  RateUnitId = 'rate_unit_id',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VarietyGradeId = 'variety_grade_id'
}

/** input type for updating data in table "trade_item" */
export type Trade_Item_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  currency_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_unit_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  rate?: InputMaybe<Scalars['numeric']>;
  rate_unit_id?: InputMaybe<Scalars['bigint']>;
  variety_grade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Trade_Item_Stddev_Fields = {
  __typename?: 'trade_item_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_item" */
export type Trade_Item_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Item_Stddev_Pop_Fields = {
  __typename?: 'trade_item_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_item" */
export type Trade_Item_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Item_Stddev_Samp_Fields = {
  __typename?: 'trade_item_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_item" */
export type Trade_Item_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_item" */
export type Trade_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Item_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_unit_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  rate?: InputMaybe<Scalars['numeric']>;
  rate_unit_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  variety_grade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Trade_Item_Sum_Fields = {
  __typename?: 'trade_item_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  currency_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  packaging_unit_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['numeric']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_item" */
export type Trade_Item_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** update columns of table "trade_item" */
export enum Trade_Item_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  PackagingUnitId = 'packaging_unit_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  RateUnitId = 'rate_unit_id',
  /** column name */
  VarietyGradeId = 'variety_grade_id'
}

export type Trade_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trade_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Item_Set_Input>;
  where: Trade_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trade_Item_Var_Pop_Fields = {
  __typename?: 'trade_item_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_item" */
export type Trade_Item_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Item_Var_Samp_Fields = {
  __typename?: 'trade_item_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_item" */
export type Trade_Item_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Item_Variance_Fields = {
  __typename?: 'trade_item_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_item" */
export type Trade_Item_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Trade_Max_Fields = {
  __typename?: 'trade_max_fields';
  buyer_consent_id?: Maybe<Scalars['bigint']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_remark?: Maybe<Scalars['String']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  current_status_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  expiry?: Maybe<Scalars['date']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  parent_trade_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  seller_consent_id?: Maybe<Scalars['bigint']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_remark?: Maybe<Scalars['String']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  trade_amounts_counter?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trade" */
export type Trade_Max_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_remark?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  current_status_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  expiry?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_remark?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Min_Fields = {
  __typename?: 'trade_min_fields';
  buyer_consent_id?: Maybe<Scalars['bigint']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_remark?: Maybe<Scalars['String']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  current_status_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  expiry?: Maybe<Scalars['date']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  parent_trade_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  seller_consent_id?: Maybe<Scalars['bigint']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_remark?: Maybe<Scalars['String']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  trade_amounts_counter?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "trade" */
export type Trade_Min_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_remark?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  current_status_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  expiry?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_remark?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trade" */
export type Trade_Mutation_Response = {
  __typename?: 'trade_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade>;
};

/** input type for inserting object relation for remote table "trade" */
export type Trade_Obj_Rel_Insert_Input = {
  data: Trade_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_On_Conflict>;
};

/** on_conflict condition type for table "trade" */
export type Trade_On_Conflict = {
  constraint: Trade_Constraint;
  update_columns?: Array<Trade_Update_Column>;
  where?: InputMaybe<Trade_Bool_Exp>;
};

/** Ordering options when selecting data from "trade". */
export type Trade_Order_By = {
  action_logs_aggregate?: InputMaybe<Trade_Action_Log_Aggregate_Order_By>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_remark?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  buyer_verification?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  current_status?: InputMaybe<Trade_Status_Order_By>;
  current_status_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  expenses_aggregate?: InputMaybe<Expense_Aggregate_Order_By>;
  expiry?: InputMaybe<Order_By>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  parent_trade?: InputMaybe<Trade_Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt?: InputMaybe<Receipt_Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_remark?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  seller_verification?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trade_items_aggregate?: InputMaybe<Trade_Item_Aggregate_Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade */
export type Trade_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** columns and relationships of "trade_region" */
export type Trade_Region = {
  __typename?: 'trade_region';
  external_name_reference: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An array relationship */
  markets: Array<Market>;
  /** An aggregate relationship */
  markets_aggregate: Market_Aggregate;
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['uuid'];
  region: Array<Region>;
  region_id: Scalars['String'];
};


/** columns and relationships of "trade_region" */
export type Trade_RegionMarketsArgs = {
  distinct_on?: InputMaybe<Array<Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Order_By>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


/** columns and relationships of "trade_region" */
export type Trade_RegionMarkets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Order_By>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


/** columns and relationships of "trade_region" */
export type Trade_RegionRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp_Remote_Rel_Trade_Regionregion>;
};

/** aggregated selection of "trade_region" */
export type Trade_Region_Aggregate = {
  __typename?: 'trade_region_aggregate';
  aggregate?: Maybe<Trade_Region_Aggregate_Fields>;
  nodes: Array<Trade_Region>;
};

/** aggregate fields of "trade_region" */
export type Trade_Region_Aggregate_Fields = {
  __typename?: 'trade_region_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Trade_Region_Max_Fields>;
  min?: Maybe<Trade_Region_Min_Fields>;
};


/** aggregate fields of "trade_region" */
export type Trade_Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "trade_region". All fields are combined with a logical 'AND'. */
export type Trade_Region_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Region_Bool_Exp>>;
  _not?: InputMaybe<Trade_Region_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Region_Bool_Exp>>;
  external_name_reference?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  markets?: InputMaybe<Market_Bool_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  region_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trade_region" */
export enum Trade_Region_Constraint {
  /** unique or primary key constraint on columns "id" */
  TradeRegionPkey = 'trade_region_pkey',
  /** unique or primary key constraint on columns "external_name_reference", "provider_id", "region_id" */
  TradeRegionRegionIdExternalNameBda7791cUniq = 'trade_region_region_id_external_name__bda7791c_uniq'
}

/** input type for inserting data into table "trade_region" */
export type Trade_Region_Insert_Input = {
  external_name_reference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  markets?: InputMaybe<Market_Arr_Rel_Insert_Input>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  region_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trade_Region_Max_Fields = {
  __typename?: 'trade_region_max_fields';
  external_name_reference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  region_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Trade_Region_Min_Fields = {
  __typename?: 'trade_region_min_fields';
  external_name_reference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  region_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "trade_region" */
export type Trade_Region_Mutation_Response = {
  __typename?: 'trade_region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Region>;
};

/** input type for inserting object relation for remote table "trade_region" */
export type Trade_Region_Obj_Rel_Insert_Input = {
  data: Trade_Region_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Region_On_Conflict>;
};

/** on_conflict condition type for table "trade_region" */
export type Trade_Region_On_Conflict = {
  constraint: Trade_Region_Constraint;
  update_columns?: Array<Trade_Region_Update_Column>;
  where?: InputMaybe<Trade_Region_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_region". */
export type Trade_Region_Order_By = {
  external_name_reference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  markets_aggregate?: InputMaybe<Market_Aggregate_Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade_region */
export type Trade_Region_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "trade_region" */
export enum Trade_Region_Select_Column {
  /** column name */
  ExternalNameReference = 'external_name_reference',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RegionId = 'region_id'
}

/** input type for updating data in table "trade_region" */
export type Trade_Region_Set_Input = {
  external_name_reference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  region_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "trade_region" */
export type Trade_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Region_Stream_Cursor_Value_Input = {
  external_name_reference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  region_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "trade_region" */
export enum Trade_Region_Update_Column {
  /** column name */
  ExternalNameReference = 'external_name_reference',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RegionId = 'region_id'
}

export type Trade_Region_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Region_Set_Input>;
  where: Trade_Region_Bool_Exp;
};

/** select columns of table "trade" */
export enum Trade_Select_Column {
  /** column name */
  BuyerConsentId = 'buyer_consent_id',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  BuyerRemark = 'buyer_remark',
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  BuyerVerification = 'buyer_verification',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CurrentStatusId = 'current_status_id',
  /** column name */
  DeductedAmount = 'deducted_amount',
  /** column name */
  DeductedQuantity = 'deducted_quantity',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  ExpenseAmount = 'expense_amount',
  /** column name */
  Expiry = 'expiry',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Mode = 'mode',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  ParentTradeId = 'parent_trade_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  SellerConsentId = 'seller_consent_id',
  /** column name */
  SellerId = 'seller_id',
  /** column name */
  SellerRemark = 'seller_remark',
  /** column name */
  SellerTnc = 'seller_tnc',
  /** column name */
  SellerVerification = 'seller_verification',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalQuantity = 'total_quantity',
  /** column name */
  TrackingCode = 'tracking_code',
  /** column name */
  TradeAmountsCounter = 'trade_amounts_counter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "trade" */
export type Trade_Set_Input = {
  buyer_consent_id?: InputMaybe<Scalars['bigint']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_remark?: InputMaybe<Scalars['String']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  current_status_id?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date?: InputMaybe<Scalars['date']>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_trade_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  seller_consent_id?: InputMaybe<Scalars['bigint']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_remark?: InputMaybe<Scalars['String']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  trade_amounts_counter?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "trade_status" */
export type Trade_Status = {
  __typename?: 'trade_status';
  category: Scalars['String'];
  /** An array relationship */
  children: Array<Trade_Status>;
  /** An array relationship */
  departments: Array<Trade_Tradestatusaccess>;
  id: Scalars['String'];
  is_data_editable: Scalars['Boolean'];
  /** An object relationship */
  parent?: Maybe<Trade_Status>;
  parent_status_id?: Maybe<Scalars['String']>;
  sequence_no: Scalars['String'];
};


/** columns and relationships of "trade_status" */
export type Trade_StatusChildrenArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Order_By>>;
  where?: InputMaybe<Trade_Status_Bool_Exp>;
};


/** columns and relationships of "trade_status" */
export type Trade_StatusDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Tradestatusaccess_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Tradestatusaccess_Order_By>>;
  where?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
};

/** order by aggregate values of table "trade_status" */
export type Trade_Status_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Status_Max_Order_By>;
  min?: InputMaybe<Trade_Status_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "trade_status". All fields are combined with a logical 'AND'. */
export type Trade_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Status_Bool_Exp>>;
  _not?: InputMaybe<Trade_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Status_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  children?: InputMaybe<Trade_Status_Bool_Exp>;
  departments?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_data_editable?: InputMaybe<Boolean_Comparison_Exp>;
  parent?: InputMaybe<Trade_Status_Bool_Exp>;
  parent_status_id?: InputMaybe<String_Comparison_Exp>;
  sequence_no?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "trade_status" */
export type Trade_Status_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trade_status" */
export type Trade_Status_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trade_status". */
export type Trade_Status_Order_By = {
  category?: InputMaybe<Order_By>;
  children_aggregate?: InputMaybe<Trade_Status_Aggregate_Order_By>;
  departments_aggregate?: InputMaybe<Trade_Tradestatusaccess_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_data_editable?: InputMaybe<Order_By>;
  parent?: InputMaybe<Trade_Status_Order_By>;
  parent_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** select columns of table "trade_status" */
export enum Trade_Status_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Id = 'id',
  /** column name */
  IsDataEditable = 'is_data_editable',
  /** column name */
  ParentStatusId = 'parent_status_id',
  /** column name */
  SequenceNo = 'sequence_no'
}

/** Streaming cursor of the table "trade_status" */
export type Trade_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Status_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_data_editable?: InputMaybe<Scalars['Boolean']>;
  parent_status_id?: InputMaybe<Scalars['String']>;
  sequence_no?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Trade_Stddev_Fields = {
  __typename?: 'trade_stddev_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade" */
export type Trade_Stddev_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Stddev_Pop_Fields = {
  __typename?: 'trade_stddev_pop_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade" */
export type Trade_Stddev_Pop_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Stddev_Samp_Fields = {
  __typename?: 'trade_stddev_samp_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade" */
export type Trade_Stddev_Samp_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade" */
export type Trade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Stream_Cursor_Value_Input = {
  buyer_consent_id?: InputMaybe<Scalars['bigint']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_remark?: InputMaybe<Scalars['String']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  buyer_verification?: InputMaybe<Scalars['Boolean']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  current_status_id?: InputMaybe<Scalars['String']>;
  deducted_amount?: InputMaybe<Scalars['numeric']>;
  deducted_quantity?: InputMaybe<Scalars['numeric']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date?: InputMaybe<Scalars['date']>;
  expense_amount?: InputMaybe<Scalars['numeric']>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  invoice_id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_trade_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  seller_consent_id?: InputMaybe<Scalars['bigint']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_remark?: InputMaybe<Scalars['String']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  seller_verification?: InputMaybe<Scalars['Boolean']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_quantity?: InputMaybe<Scalars['numeric']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  trade_amounts_counter?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Trade_Sum_Fields = {
  __typename?: 'trade_sum_fields';
  buyer_consent_id?: Maybe<Scalars['bigint']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  parent_trade_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  seller_consent_id?: Maybe<Scalars['bigint']>;
  seller_id?: Maybe<Scalars['bigint']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  trade_amounts_counter?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trade" */
export type Trade_Sum_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
};

/** columns and relationships of "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess = {
  __typename?: 'trade_tradestatusaccess';
  /** An object relationship */
  department?: Maybe<Setu_Trade_Shared_Entity>;
  department_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  status_id: Scalars['String'];
  /** An object relationship */
  trade_status: Trade_Status;
};

/** order by aggregate values of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Tradestatusaccess_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Tradestatusaccess_Max_Order_By>;
  min?: InputMaybe<Trade_Tradestatusaccess_Min_Order_By>;
  stddev?: InputMaybe<Trade_Tradestatusaccess_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Tradestatusaccess_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Tradestatusaccess_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Tradestatusaccess_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Tradestatusaccess_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Tradestatusaccess_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Tradestatusaccess_Variance_Order_By>;
};

/** order by avg() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Avg_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_tradestatusaccess". All fields are combined with a logical 'AND'. */
export type Trade_Tradestatusaccess_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Tradestatusaccess_Bool_Exp>>;
  _not?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Tradestatusaccess_Bool_Exp>>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  status_id?: InputMaybe<String_Comparison_Exp>;
  trade_status?: InputMaybe<Trade_Status_Bool_Exp>;
};

/** order by max() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Max_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Min_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trade_tradestatusaccess". */
export type Trade_Tradestatusaccess_Order_By = {
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  trade_status?: InputMaybe<Trade_Status_Order_By>;
};

/** select columns of table "trade_tradestatusaccess" */
export enum Trade_Tradestatusaccess_Select_Column {
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id',
  /** column name */
  StatusId = 'status_id'
}

/** order by stddev() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Stddev_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Stddev_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Stddev_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Tradestatusaccess_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Tradestatusaccess_Stream_Cursor_Value_Input = {
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  status_id?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Sum_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Var_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Var_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Variance_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "trade_transaction" */
export type Trade_Transaction = {
  __typename?: 'trade_transaction';
  arrival?: Maybe<Scalars['float8']>;
  commodity_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  departure?: Maybe<Scalars['float8']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  market: Market;
  market_id: Scalars['uuid'];
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['uuid'];
  timestamp: Scalars['timestamptz'];
  /** An object relationship */
  trade_commodity: Trade_Commodity;
  /** An object relationship */
  trade_unit: Trade_Unit;
  unit_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "trade_transaction" */
export type Trade_Transaction_Aggregate = {
  __typename?: 'trade_transaction_aggregate';
  aggregate?: Maybe<Trade_Transaction_Aggregate_Fields>;
  nodes: Array<Trade_Transaction>;
};

/** aggregate fields of "trade_transaction" */
export type Trade_Transaction_Aggregate_Fields = {
  __typename?: 'trade_transaction_aggregate_fields';
  avg?: Maybe<Trade_Transaction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Transaction_Max_Fields>;
  min?: Maybe<Trade_Transaction_Min_Fields>;
  stddev?: Maybe<Trade_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Transaction_Sum_Fields>;
  var_pop?: Maybe<Trade_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Trade_Transaction_Variance_Fields>;
};


/** aggregate fields of "trade_transaction" */
export type Trade_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_transaction" */
export type Trade_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Transaction_Max_Order_By>;
  min?: InputMaybe<Trade_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Trade_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trade_transaction" */
export type Trade_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Trade_Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Transaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Trade_Transaction_Avg_Fields = {
  __typename?: 'trade_transaction_avg_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_transaction" */
export type Trade_Transaction_Avg_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_transaction". All fields are combined with a logical 'AND'. */
export type Trade_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Trade_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Transaction_Bool_Exp>>;
  arrival?: InputMaybe<Float8_Comparison_Exp>;
  commodity_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  departure?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  market?: InputMaybe<Market_Bool_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  max_price?: InputMaybe<Float8_Comparison_Exp>;
  mean_price?: InputMaybe<Float8_Comparison_Exp>;
  min_price?: InputMaybe<Float8_Comparison_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  trade_commodity?: InputMaybe<Trade_Commodity_Bool_Exp>;
  trade_unit?: InputMaybe<Trade_Unit_Bool_Exp>;
  unit_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "trade_transaction" */
export enum Trade_Transaction_Constraint {
  /** unique or primary key constraint on columns "id" */
  TradeTransactionPkey = 'trade_transaction_pkey',
  /** unique or primary key constraint on columns "provider_id", "timestamp", "commodity_id", "market_id" */
  TradeTransactionTimestampMarketIdComm_809b07edUniq = 'trade_transaction_timestamp_market_id_comm_809b07ed_uniq'
}

/** input type for incrementing numeric columns in table "trade_transaction" */
export type Trade_Transaction_Inc_Input = {
  arrival?: InputMaybe<Scalars['float8']>;
  departure?: InputMaybe<Scalars['float8']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "trade_transaction" */
export type Trade_Transaction_Insert_Input = {
  arrival?: InputMaybe<Scalars['float8']>;
  commodity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  departure?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market?: InputMaybe<Market_Obj_Rel_Insert_Input>;
  market_id?: InputMaybe<Scalars['uuid']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  trade_commodity?: InputMaybe<Trade_Commodity_Obj_Rel_Insert_Input>;
  trade_unit?: InputMaybe<Trade_Unit_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Trade_Transaction_Max_Fields = {
  __typename?: 'trade_transaction_max_fields';
  arrival?: Maybe<Scalars['float8']>;
  commodity_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  departure?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  market_id?: Maybe<Scalars['uuid']>;
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
  provider_id?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  unit_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "trade_transaction" */
export type Trade_Transaction_Max_Order_By = {
  arrival?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Transaction_Min_Fields = {
  __typename?: 'trade_transaction_min_fields';
  arrival?: Maybe<Scalars['float8']>;
  commodity_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  departure?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  market_id?: Maybe<Scalars['uuid']>;
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
  provider_id?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  unit_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "trade_transaction" */
export type Trade_Transaction_Min_Order_By = {
  arrival?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trade_transaction" */
export type Trade_Transaction_Mutation_Response = {
  __typename?: 'trade_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Transaction>;
};

/** on_conflict condition type for table "trade_transaction" */
export type Trade_Transaction_On_Conflict = {
  constraint: Trade_Transaction_Constraint;
  update_columns?: Array<Trade_Transaction_Update_Column>;
  where?: InputMaybe<Trade_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_transaction". */
export type Trade_Transaction_Order_By = {
  arrival?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  market?: InputMaybe<Market_Order_By>;
  market_id?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  trade_commodity?: InputMaybe<Trade_Commodity_Order_By>;
  trade_unit?: InputMaybe<Trade_Unit_Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade_transaction */
export type Trade_Transaction_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "trade_transaction" */
export enum Trade_Transaction_Select_Column {
  /** column name */
  Arrival = 'arrival',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Departure = 'departure',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  MaxPrice = 'max_price',
  /** column name */
  MeanPrice = 'mean_price',
  /** column name */
  MinPrice = 'min_price',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "trade_transaction" */
export type Trade_Transaction_Set_Input = {
  arrival?: InputMaybe<Scalars['float8']>;
  commodity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  departure?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market_id?: InputMaybe<Scalars['uuid']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  unit_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Trade_Transaction_Stddev_Fields = {
  __typename?: 'trade_transaction_stddev_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_transaction" */
export type Trade_Transaction_Stddev_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Transaction_Stddev_Pop_Fields = {
  __typename?: 'trade_transaction_stddev_pop_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_transaction" */
export type Trade_Transaction_Stddev_Pop_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Transaction_Stddev_Samp_Fields = {
  __typename?: 'trade_transaction_stddev_samp_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_transaction" */
export type Trade_Transaction_Stddev_Samp_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_transaction" */
export type Trade_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Transaction_Stream_Cursor_Value_Input = {
  arrival?: InputMaybe<Scalars['float8']>;
  commodity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  departure?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market_id?: InputMaybe<Scalars['uuid']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  unit_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Trade_Transaction_Sum_Fields = {
  __typename?: 'trade_transaction_sum_fields';
  arrival?: Maybe<Scalars['float8']>;
  departure?: Maybe<Scalars['float8']>;
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "trade_transaction" */
export type Trade_Transaction_Sum_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "trade_transaction_summary" */
export type Trade_Transaction_Summary = {
  __typename?: 'trade_transaction_summary';
  arrival?: Maybe<Scalars['float8']>;
  commodity_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  date: Scalars['date'];
  departure?: Maybe<Scalars['float8']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  market: Market;
  market_id: Scalars['uuid'];
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['uuid'];
  /** An object relationship */
  trade_commodity: Trade_Commodity;
  /** An object relationship */
  trade_unit: Trade_Unit;
  unit_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "trade_transaction_summary" */
export type Trade_Transaction_Summary_Aggregate = {
  __typename?: 'trade_transaction_summary_aggregate';
  aggregate?: Maybe<Trade_Transaction_Summary_Aggregate_Fields>;
  nodes: Array<Trade_Transaction_Summary>;
};

/** aggregate fields of "trade_transaction_summary" */
export type Trade_Transaction_Summary_Aggregate_Fields = {
  __typename?: 'trade_transaction_summary_aggregate_fields';
  avg?: Maybe<Trade_Transaction_Summary_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Transaction_Summary_Max_Fields>;
  min?: Maybe<Trade_Transaction_Summary_Min_Fields>;
  stddev?: Maybe<Trade_Transaction_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Transaction_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Transaction_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Transaction_Summary_Sum_Fields>;
  var_pop?: Maybe<Trade_Transaction_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Transaction_Summary_Var_Samp_Fields>;
  variance?: Maybe<Trade_Transaction_Summary_Variance_Fields>;
};


/** aggregate fields of "trade_transaction_summary" */
export type Trade_Transaction_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Transaction_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Transaction_Summary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Transaction_Summary_Max_Order_By>;
  min?: InputMaybe<Trade_Transaction_Summary_Min_Order_By>;
  stddev?: InputMaybe<Trade_Transaction_Summary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Transaction_Summary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Transaction_Summary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Transaction_Summary_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Transaction_Summary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Transaction_Summary_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Transaction_Summary_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Arr_Rel_Insert_Input = {
  data: Array<Trade_Transaction_Summary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Transaction_Summary_On_Conflict>;
};

/** aggregate avg on columns */
export type Trade_Transaction_Summary_Avg_Fields = {
  __typename?: 'trade_transaction_summary_avg_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Avg_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_transaction_summary". All fields are combined with a logical 'AND'. */
export type Trade_Transaction_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Transaction_Summary_Bool_Exp>>;
  _not?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Transaction_Summary_Bool_Exp>>;
  arrival?: InputMaybe<Float8_Comparison_Exp>;
  commodity_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  departure?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  market?: InputMaybe<Market_Bool_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  max_price?: InputMaybe<Float8_Comparison_Exp>;
  mean_price?: InputMaybe<Float8_Comparison_Exp>;
  min_price?: InputMaybe<Float8_Comparison_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  trade_commodity?: InputMaybe<Trade_Commodity_Bool_Exp>;
  trade_unit?: InputMaybe<Trade_Unit_Bool_Exp>;
  unit_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "trade_transaction_summary" */
export enum Trade_Transaction_Summary_Constraint {
  /** unique or primary key constraint on columns "provider_id", "date", "commodity_id", "market_id" */
  TradeTransactionSummarDateMarketIdCommodity_1116e3b0Uniq = 'trade_transaction_summar_date_market_id_commodity_1116e3b0_uniq',
  /** unique or primary key constraint on columns "id" */
  TradeTransactionSummaryPkey = 'trade_transaction_summary_pkey'
}

/** input type for incrementing numeric columns in table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Inc_Input = {
  arrival?: InputMaybe<Scalars['float8']>;
  departure?: InputMaybe<Scalars['float8']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Insert_Input = {
  arrival?: InputMaybe<Scalars['float8']>;
  commodity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  departure?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market?: InputMaybe<Market_Obj_Rel_Insert_Input>;
  market_id?: InputMaybe<Scalars['uuid']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  trade_commodity?: InputMaybe<Trade_Commodity_Obj_Rel_Insert_Input>;
  trade_unit?: InputMaybe<Trade_Unit_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Trade_Transaction_Summary_Max_Fields = {
  __typename?: 'trade_transaction_summary_max_fields';
  arrival?: Maybe<Scalars['float8']>;
  commodity_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  departure?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  market_id?: Maybe<Scalars['uuid']>;
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
  provider_id?: Maybe<Scalars['uuid']>;
  unit_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Max_Order_By = {
  arrival?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Transaction_Summary_Min_Fields = {
  __typename?: 'trade_transaction_summary_min_fields';
  arrival?: Maybe<Scalars['float8']>;
  commodity_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  departure?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  market_id?: Maybe<Scalars['uuid']>;
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
  provider_id?: Maybe<Scalars['uuid']>;
  unit_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Min_Order_By = {
  arrival?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Mutation_Response = {
  __typename?: 'trade_transaction_summary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Transaction_Summary>;
};

/** on_conflict condition type for table "trade_transaction_summary" */
export type Trade_Transaction_Summary_On_Conflict = {
  constraint: Trade_Transaction_Summary_Constraint;
  update_columns?: Array<Trade_Transaction_Summary_Update_Column>;
  where?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_transaction_summary". */
export type Trade_Transaction_Summary_Order_By = {
  arrival?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  market?: InputMaybe<Market_Order_By>;
  market_id?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  trade_commodity?: InputMaybe<Trade_Commodity_Order_By>;
  trade_unit?: InputMaybe<Trade_Unit_Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade_transaction_summary */
export type Trade_Transaction_Summary_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "trade_transaction_summary" */
export enum Trade_Transaction_Summary_Select_Column {
  /** column name */
  Arrival = 'arrival',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Departure = 'departure',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  MaxPrice = 'max_price',
  /** column name */
  MeanPrice = 'mean_price',
  /** column name */
  MinPrice = 'min_price',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Set_Input = {
  arrival?: InputMaybe<Scalars['float8']>;
  commodity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  departure?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market_id?: InputMaybe<Scalars['uuid']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  unit_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Trade_Transaction_Summary_Stddev_Fields = {
  __typename?: 'trade_transaction_summary_stddev_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Stddev_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Transaction_Summary_Stddev_Pop_Fields = {
  __typename?: 'trade_transaction_summary_stddev_pop_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Stddev_Pop_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Transaction_Summary_Stddev_Samp_Fields = {
  __typename?: 'trade_transaction_summary_stddev_samp_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Stddev_Samp_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Transaction_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Transaction_Summary_Stream_Cursor_Value_Input = {
  arrival?: InputMaybe<Scalars['float8']>;
  commodity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  departure?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market_id?: InputMaybe<Scalars['uuid']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  unit_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Trade_Transaction_Summary_Sum_Fields = {
  __typename?: 'trade_transaction_summary_sum_fields';
  arrival?: Maybe<Scalars['float8']>;
  departure?: Maybe<Scalars['float8']>;
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Sum_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** update columns of table "trade_transaction_summary" */
export enum Trade_Transaction_Summary_Update_Column {
  /** column name */
  Arrival = 'arrival',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Departure = 'departure',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  MaxPrice = 'max_price',
  /** column name */
  MeanPrice = 'mean_price',
  /** column name */
  MinPrice = 'min_price',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Trade_Transaction_Summary_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trade_Transaction_Summary_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Transaction_Summary_Set_Input>;
  where: Trade_Transaction_Summary_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trade_Transaction_Summary_Var_Pop_Fields = {
  __typename?: 'trade_transaction_summary_var_pop_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Var_Pop_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Transaction_Summary_Var_Samp_Fields = {
  __typename?: 'trade_transaction_summary_var_samp_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Var_Samp_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Transaction_Summary_Variance_Fields = {
  __typename?: 'trade_transaction_summary_variance_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_transaction_summary" */
export type Trade_Transaction_Summary_Variance_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** update columns of table "trade_transaction" */
export enum Trade_Transaction_Update_Column {
  /** column name */
  Arrival = 'arrival',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Departure = 'departure',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  MaxPrice = 'max_price',
  /** column name */
  MeanPrice = 'mean_price',
  /** column name */
  MinPrice = 'min_price',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Trade_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trade_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Transaction_Set_Input>;
  where: Trade_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trade_Transaction_Var_Pop_Fields = {
  __typename?: 'trade_transaction_var_pop_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_transaction" */
export type Trade_Transaction_Var_Pop_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Transaction_Var_Samp_Fields = {
  __typename?: 'trade_transaction_var_samp_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_transaction" */
export type Trade_Transaction_Var_Samp_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Transaction_Variance_Fields = {
  __typename?: 'trade_transaction_variance_fields';
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_transaction" */
export type Trade_Transaction_Variance_Order_By = {
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "trade_unit" */
export type Trade_Unit = {
  __typename?: 'trade_unit';
  description?: Maybe<Scalars['String']>;
  external_unit_reference: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['uuid'];
  /** An array relationship */
  trade_transaction_summaries: Array<Trade_Transaction_Summary>;
  /** An aggregate relationship */
  trade_transaction_summaries_aggregate: Trade_Transaction_Summary_Aggregate;
  /** An array relationship */
  trade_transactions: Array<Trade_Transaction>;
  /** An aggregate relationship */
  trade_transactions_aggregate: Trade_Transaction_Aggregate;
  /** An array relationship */
  transaction_trends: Array<Transaction_Trend>;
  /** An aggregate relationship */
  transaction_trends_aggregate: Transaction_Trend_Aggregate;
  unit: Array<Si_Unit>;
  unit_id: Scalars['String'];
};


/** columns and relationships of "trade_unit" */
export type Trade_UnitTrade_Transaction_SummariesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Summary_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
};


/** columns and relationships of "trade_unit" */
export type Trade_UnitTrade_Transaction_Summaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Summary_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
};


/** columns and relationships of "trade_unit" */
export type Trade_UnitTrade_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Bool_Exp>;
};


/** columns and relationships of "trade_unit" */
export type Trade_UnitTrade_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Transaction_Order_By>>;
  where?: InputMaybe<Trade_Transaction_Bool_Exp>;
};


/** columns and relationships of "trade_unit" */
export type Trade_UnitTransaction_TrendsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Trend_Order_By>>;
  where?: InputMaybe<Transaction_Trend_Bool_Exp>;
};


/** columns and relationships of "trade_unit" */
export type Trade_UnitTransaction_Trends_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Trend_Order_By>>;
  where?: InputMaybe<Transaction_Trend_Bool_Exp>;
};


/** columns and relationships of "trade_unit" */
export type Trade_UnitUnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Trade_Unitunit>;
};

/** aggregated selection of "trade_unit" */
export type Trade_Unit_Aggregate = {
  __typename?: 'trade_unit_aggregate';
  aggregate?: Maybe<Trade_Unit_Aggregate_Fields>;
  nodes: Array<Trade_Unit>;
};

/** aggregate fields of "trade_unit" */
export type Trade_Unit_Aggregate_Fields = {
  __typename?: 'trade_unit_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Trade_Unit_Max_Fields>;
  min?: Maybe<Trade_Unit_Min_Fields>;
};


/** aggregate fields of "trade_unit" */
export type Trade_Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "trade_unit". All fields are combined with a logical 'AND'. */
export type Trade_Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Unit_Bool_Exp>>;
  _not?: InputMaybe<Trade_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Unit_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  external_unit_reference?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  trade_transaction_summaries?: InputMaybe<Trade_Transaction_Summary_Bool_Exp>;
  trade_transactions?: InputMaybe<Trade_Transaction_Bool_Exp>;
  transaction_trends?: InputMaybe<Transaction_Trend_Bool_Exp>;
  unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trade_unit" */
export enum Trade_Unit_Constraint {
  /** unique or primary key constraint on columns "id" */
  TradeUnitPkey = 'trade_unit_pkey',
  /** unique or primary key constraint on columns "provider_id", "external_unit_reference", "unit_id" */
  TradeUnitUnitIdExternalUnitReCf6b2bbfUniq = 'trade_unit_unit_id_external_unit_re_cf6b2bbf_uniq'
}

/** input type for inserting data into table "trade_unit" */
export type Trade_Unit_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  external_unit_reference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  trade_transaction_summaries?: InputMaybe<Trade_Transaction_Summary_Arr_Rel_Insert_Input>;
  trade_transactions?: InputMaybe<Trade_Transaction_Arr_Rel_Insert_Input>;
  transaction_trends?: InputMaybe<Transaction_Trend_Arr_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trade_Unit_Max_Fields = {
  __typename?: 'trade_unit_max_fields';
  description?: Maybe<Scalars['String']>;
  external_unit_reference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Trade_Unit_Min_Fields = {
  __typename?: 'trade_unit_min_fields';
  description?: Maybe<Scalars['String']>;
  external_unit_reference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "trade_unit" */
export type Trade_Unit_Mutation_Response = {
  __typename?: 'trade_unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Unit>;
};

/** input type for inserting object relation for remote table "trade_unit" */
export type Trade_Unit_Obj_Rel_Insert_Input = {
  data: Trade_Unit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Unit_On_Conflict>;
};

/** on_conflict condition type for table "trade_unit" */
export type Trade_Unit_On_Conflict = {
  constraint: Trade_Unit_Constraint;
  update_columns?: Array<Trade_Unit_Update_Column>;
  where?: InputMaybe<Trade_Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_unit". */
export type Trade_Unit_Order_By = {
  description?: InputMaybe<Order_By>;
  external_unit_reference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  trade_transaction_summaries_aggregate?: InputMaybe<Trade_Transaction_Summary_Aggregate_Order_By>;
  trade_transactions_aggregate?: InputMaybe<Trade_Transaction_Aggregate_Order_By>;
  transaction_trends_aggregate?: InputMaybe<Transaction_Trend_Aggregate_Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade_unit */
export type Trade_Unit_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "trade_unit" */
export enum Trade_Unit_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  ExternalUnitReference = 'external_unit_reference',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UnitId = 'unit_id'
}

/** input type for updating data in table "trade_unit" */
export type Trade_Unit_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  external_unit_reference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "trade_unit" */
export type Trade_Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Unit_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  external_unit_reference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "trade_unit" */
export enum Trade_Unit_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  ExternalUnitReference = 'external_unit_reference',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UnitId = 'unit_id'
}

export type Trade_Unit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Unit_Set_Input>;
  where: Trade_Unit_Bool_Exp;
};

/** update columns of table "trade" */
export enum Trade_Update_Column {
  /** column name */
  BuyerConsentId = 'buyer_consent_id',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  BuyerRemark = 'buyer_remark',
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  CurrentStatusId = 'current_status_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Expiry = 'expiry',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Mode = 'mode',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  ParentTradeId = 'parent_trade_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  SellerConsentId = 'seller_consent_id',
  /** column name */
  SellerId = 'seller_id',
  /** column name */
  SellerRemark = 'seller_remark',
  /** column name */
  SellerTnc = 'seller_tnc',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TradeAmountsCounter = 'trade_amounts_counter'
}

export type Trade_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trade_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Set_Input>;
  where: Trade_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trade_Var_Pop_Fields = {
  __typename?: 'trade_var_pop_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade" */
export type Trade_Var_Pop_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Var_Samp_Fields = {
  __typename?: 'trade_var_samp_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade" */
export type Trade_Var_Samp_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Variance_Fields = {
  __typename?: 'trade_variance_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade" */
export type Trade_Variance_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
};

/** columns and relationships of "transaction_trend" */
export type Transaction_Trend = {
  __typename?: 'transaction_trend';
  absolute_change?: Maybe<Scalars['float8']>;
  arrival?: Maybe<Scalars['float8']>;
  commodity_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  departure?: Maybe<Scalars['float8']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  market: Market;
  market_id: Scalars['uuid'];
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
  percent_change?: Maybe<Scalars['float8']>;
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['uuid'];
  /** An object relationship */
  trade_commodity: Trade_Commodity;
  /** An object relationship */
  trade_unit: Trade_Unit;
  unit_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "transaction_trend" */
export type Transaction_Trend_Aggregate = {
  __typename?: 'transaction_trend_aggregate';
  aggregate?: Maybe<Transaction_Trend_Aggregate_Fields>;
  nodes: Array<Transaction_Trend>;
};

/** aggregate fields of "transaction_trend" */
export type Transaction_Trend_Aggregate_Fields = {
  __typename?: 'transaction_trend_aggregate_fields';
  avg?: Maybe<Transaction_Trend_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Transaction_Trend_Max_Fields>;
  min?: Maybe<Transaction_Trend_Min_Fields>;
  stddev?: Maybe<Transaction_Trend_Stddev_Fields>;
  stddev_pop?: Maybe<Transaction_Trend_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transaction_Trend_Stddev_Samp_Fields>;
  sum?: Maybe<Transaction_Trend_Sum_Fields>;
  var_pop?: Maybe<Transaction_Trend_Var_Pop_Fields>;
  var_samp?: Maybe<Transaction_Trend_Var_Samp_Fields>;
  variance?: Maybe<Transaction_Trend_Variance_Fields>;
};


/** aggregate fields of "transaction_trend" */
export type Transaction_Trend_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Trend_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "transaction_trend" */
export type Transaction_Trend_Aggregate_Order_By = {
  avg?: InputMaybe<Transaction_Trend_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transaction_Trend_Max_Order_By>;
  min?: InputMaybe<Transaction_Trend_Min_Order_By>;
  stddev?: InputMaybe<Transaction_Trend_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transaction_Trend_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transaction_Trend_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transaction_Trend_Sum_Order_By>;
  var_pop?: InputMaybe<Transaction_Trend_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transaction_Trend_Var_Samp_Order_By>;
  variance?: InputMaybe<Transaction_Trend_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "transaction_trend" */
export type Transaction_Trend_Arr_Rel_Insert_Input = {
  data: Array<Transaction_Trend_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transaction_Trend_On_Conflict>;
};

/** aggregate avg on columns */
export type Transaction_Trend_Avg_Fields = {
  __typename?: 'transaction_trend_avg_fields';
  absolute_change?: Maybe<Scalars['Float']>;
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
  percent_change?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "transaction_trend" */
export type Transaction_Trend_Avg_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transaction_trend". All fields are combined with a logical 'AND'. */
export type Transaction_Trend_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Trend_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Trend_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Trend_Bool_Exp>>;
  absolute_change?: InputMaybe<Float8_Comparison_Exp>;
  arrival?: InputMaybe<Float8_Comparison_Exp>;
  commodity_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  departure?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  market?: InputMaybe<Market_Bool_Exp>;
  market_id?: InputMaybe<Uuid_Comparison_Exp>;
  max_price?: InputMaybe<Float8_Comparison_Exp>;
  mean_price?: InputMaybe<Float8_Comparison_Exp>;
  min_price?: InputMaybe<Float8_Comparison_Exp>;
  percent_change?: InputMaybe<Float8_Comparison_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  trade_commodity?: InputMaybe<Trade_Commodity_Bool_Exp>;
  trade_unit?: InputMaybe<Trade_Unit_Bool_Exp>;
  unit_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "transaction_trend" */
export enum Transaction_Trend_Constraint {
  /** unique or primary key constraint on columns "provider_id", "commodity_id", "market_id" */
  TransactionTrendMarketIdCommodityIdP_42321214Uniq = 'transaction_trend_market_id_commodity_id_p_42321214_uniq',
  /** unique or primary key constraint on columns "id" */
  TransactionTrendPkey = 'transaction_trend_pkey'
}

/** input type for incrementing numeric columns in table "transaction_trend" */
export type Transaction_Trend_Inc_Input = {
  absolute_change?: InputMaybe<Scalars['float8']>;
  arrival?: InputMaybe<Scalars['float8']>;
  departure?: InputMaybe<Scalars['float8']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
  percent_change?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "transaction_trend" */
export type Transaction_Trend_Insert_Input = {
  absolute_change?: InputMaybe<Scalars['float8']>;
  arrival?: InputMaybe<Scalars['float8']>;
  commodity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  departure?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market?: InputMaybe<Market_Obj_Rel_Insert_Input>;
  market_id?: InputMaybe<Scalars['uuid']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
  percent_change?: InputMaybe<Scalars['float8']>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  trade_commodity?: InputMaybe<Trade_Commodity_Obj_Rel_Insert_Input>;
  trade_unit?: InputMaybe<Trade_Unit_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Transaction_Trend_Max_Fields = {
  __typename?: 'transaction_trend_max_fields';
  absolute_change?: Maybe<Scalars['float8']>;
  arrival?: Maybe<Scalars['float8']>;
  commodity_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  departure?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  market_id?: Maybe<Scalars['uuid']>;
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
  percent_change?: Maybe<Scalars['float8']>;
  provider_id?: Maybe<Scalars['uuid']>;
  unit_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "transaction_trend" */
export type Transaction_Trend_Max_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transaction_Trend_Min_Fields = {
  __typename?: 'transaction_trend_min_fields';
  absolute_change?: Maybe<Scalars['float8']>;
  arrival?: Maybe<Scalars['float8']>;
  commodity_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  departure?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  market_id?: Maybe<Scalars['uuid']>;
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
  percent_change?: Maybe<Scalars['float8']>;
  provider_id?: Maybe<Scalars['uuid']>;
  unit_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "transaction_trend" */
export type Transaction_Trend_Min_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transaction_trend" */
export type Transaction_Trend_Mutation_Response = {
  __typename?: 'transaction_trend_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Transaction_Trend>;
};

/** on_conflict condition type for table "transaction_trend" */
export type Transaction_Trend_On_Conflict = {
  constraint: Transaction_Trend_Constraint;
  update_columns?: Array<Transaction_Trend_Update_Column>;
  where?: InputMaybe<Transaction_Trend_Bool_Exp>;
};

/** Ordering options when selecting data from "transaction_trend". */
export type Transaction_Trend_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  market?: InputMaybe<Market_Order_By>;
  market_id?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  trade_commodity?: InputMaybe<Trade_Commodity_Order_By>;
  trade_unit?: InputMaybe<Trade_Unit_Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transaction_trend */
export type Transaction_Trend_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "transaction_trend" */
export enum Transaction_Trend_Select_Column {
  /** column name */
  AbsoluteChange = 'absolute_change',
  /** column name */
  Arrival = 'arrival',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Departure = 'departure',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  MaxPrice = 'max_price',
  /** column name */
  MeanPrice = 'mean_price',
  /** column name */
  MinPrice = 'min_price',
  /** column name */
  PercentChange = 'percent_change',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "transaction_trend" */
export type Transaction_Trend_Set_Input = {
  absolute_change?: InputMaybe<Scalars['float8']>;
  arrival?: InputMaybe<Scalars['float8']>;
  commodity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  departure?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market_id?: InputMaybe<Scalars['uuid']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
  percent_change?: InputMaybe<Scalars['float8']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  unit_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Transaction_Trend_Stddev_Fields = {
  __typename?: 'transaction_trend_stddev_fields';
  absolute_change?: Maybe<Scalars['Float']>;
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
  percent_change?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "transaction_trend" */
export type Transaction_Trend_Stddev_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transaction_Trend_Stddev_Pop_Fields = {
  __typename?: 'transaction_trend_stddev_pop_fields';
  absolute_change?: Maybe<Scalars['Float']>;
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
  percent_change?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "transaction_trend" */
export type Transaction_Trend_Stddev_Pop_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transaction_Trend_Stddev_Samp_Fields = {
  __typename?: 'transaction_trend_stddev_samp_fields';
  absolute_change?: Maybe<Scalars['Float']>;
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
  percent_change?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "transaction_trend" */
export type Transaction_Trend_Stddev_Samp_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transaction_trend" */
export type Transaction_Trend_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transaction_Trend_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transaction_Trend_Stream_Cursor_Value_Input = {
  absolute_change?: InputMaybe<Scalars['float8']>;
  arrival?: InputMaybe<Scalars['float8']>;
  commodity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  departure?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market_id?: InputMaybe<Scalars['uuid']>;
  max_price?: InputMaybe<Scalars['float8']>;
  mean_price?: InputMaybe<Scalars['float8']>;
  min_price?: InputMaybe<Scalars['float8']>;
  percent_change?: InputMaybe<Scalars['float8']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  unit_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Transaction_Trend_Sum_Fields = {
  __typename?: 'transaction_trend_sum_fields';
  absolute_change?: Maybe<Scalars['float8']>;
  arrival?: Maybe<Scalars['float8']>;
  departure?: Maybe<Scalars['float8']>;
  max_price?: Maybe<Scalars['float8']>;
  mean_price?: Maybe<Scalars['float8']>;
  min_price?: Maybe<Scalars['float8']>;
  percent_change?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "transaction_trend" */
export type Transaction_Trend_Sum_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
};

/** update columns of table "transaction_trend" */
export enum Transaction_Trend_Update_Column {
  /** column name */
  AbsoluteChange = 'absolute_change',
  /** column name */
  Arrival = 'arrival',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Departure = 'departure',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  MaxPrice = 'max_price',
  /** column name */
  MeanPrice = 'mean_price',
  /** column name */
  MinPrice = 'min_price',
  /** column name */
  PercentChange = 'percent_change',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Transaction_Trend_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transaction_Trend_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transaction_Trend_Set_Input>;
  where: Transaction_Trend_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transaction_Trend_Var_Pop_Fields = {
  __typename?: 'transaction_trend_var_pop_fields';
  absolute_change?: Maybe<Scalars['Float']>;
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
  percent_change?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "transaction_trend" */
export type Transaction_Trend_Var_Pop_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transaction_Trend_Var_Samp_Fields = {
  __typename?: 'transaction_trend_var_samp_fields';
  absolute_change?: Maybe<Scalars['Float']>;
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
  percent_change?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "transaction_trend" */
export type Transaction_Trend_Var_Samp_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transaction_Trend_Variance_Fields = {
  __typename?: 'transaction_trend_variance_fields';
  absolute_change?: Maybe<Scalars['Float']>;
  arrival?: Maybe<Scalars['Float']>;
  departure?: Maybe<Scalars['Float']>;
  max_price?: Maybe<Scalars['Float']>;
  mean_price?: Maybe<Scalars['Float']>;
  min_price?: Maybe<Scalars['Float']>;
  percent_change?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "transaction_trend" */
export type Transaction_Trend_Variance_Order_By = {
  absolute_change?: InputMaybe<Order_By>;
  arrival?: InputMaybe<Order_By>;
  departure?: InputMaybe<Order_By>;
  max_price?: InputMaybe<Order_By>;
  mean_price?: InputMaybe<Order_By>;
  min_price?: InputMaybe<Order_By>;
  percent_change?: InputMaybe<Order_By>;
};

/** columns and relationships of "unit" */
export type Unit = {
  __typename?: 'unit';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  measure_of?: Maybe<Measure_Of>;
  measure_of_id?: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  /** An array relationship */
  parameters: Array<Sensor_Parameter>;
  /** An aggregate relationship */
  parameters_aggregate: Sensor_Parameter_Aggregate;
  short_name: Scalars['String'];
};


/** columns and relationships of "unit" */
export type UnitParametersArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Parameter_Order_By>>;
  where?: InputMaybe<Sensor_Parameter_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitParameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Parameter_Order_By>>;
  where?: InputMaybe<Sensor_Parameter_Bool_Exp>;
};

/** aggregated selection of "unit" */
export type Unit_Aggregate = {
  __typename?: 'unit_aggregate';
  aggregate?: Maybe<Unit_Aggregate_Fields>;
  nodes: Array<Unit>;
};

/** aggregate fields of "unit" */
export type Unit_Aggregate_Fields = {
  __typename?: 'unit_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Unit_Max_Fields>;
  min?: Maybe<Unit_Min_Fields>;
};


/** aggregate fields of "unit" */
export type Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "unit" */
export type Unit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Unit_Max_Order_By>;
  min?: InputMaybe<Unit_Min_Order_By>;
};

/** input type for inserting array relation for remote table "unit" */
export type Unit_Arr_Rel_Insert_Input = {
  data: Array<Unit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};

/** Boolean expression to filter rows from the table "unit". All fields are combined with a logical 'AND'. */
export type Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Bool_Exp>>;
  _not?: InputMaybe<Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Measure_Of_Bool_Exp>;
  measure_of_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parameters?: InputMaybe<Sensor_Parameter_Bool_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "unit" */
export enum Unit_Constraint {
  /** unique or primary key constraint on columns "name", "measure_of_id" */
  UnitNameMeasureOfId_769c60f3Uniq = 'unit_name_measure_of_id_769c60f3_uniq',
  /** unique or primary key constraint on columns "id" */
  UnitPkey = 'unit_pkey'
}

/** input type for inserting data into table "unit" */
export type Unit_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  measure_of?: InputMaybe<Measure_Of_Obj_Rel_Insert_Input>;
  measure_of_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parameters?: InputMaybe<Sensor_Parameter_Arr_Rel_Insert_Input>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Unit_Max_Fields = {
  __typename?: 'unit_max_fields';
  id?: Maybe<Scalars['uuid']>;
  measure_of_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "unit" */
export type Unit_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_of_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Unit_Min_Fields = {
  __typename?: 'unit_min_fields';
  id?: Maybe<Scalars['uuid']>;
  measure_of_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "unit" */
export type Unit_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_of_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "unit" */
export type Unit_Mutation_Response = {
  __typename?: 'unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit>;
};

/** input type for inserting object relation for remote table "unit" */
export type Unit_Obj_Rel_Insert_Input = {
  data: Unit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};

/** on_conflict condition type for table "unit" */
export type Unit_On_Conflict = {
  constraint: Unit_Constraint;
  update_columns?: Array<Unit_Update_Column>;
  where?: InputMaybe<Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "unit". */
export type Unit_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  measure_of?: InputMaybe<Measure_Of_Order_By>;
  measure_of_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parameters_aggregate?: InputMaybe<Sensor_Parameter_Aggregate_Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unit */
export type Unit_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "unit" */
export enum Unit_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MeasureOfId = 'measure_of_id',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name'
}

/** input type for updating data in table "unit" */
export type Unit_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  measure_of_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "unit" */
export type Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  measure_of_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "unit" */
export enum Unit_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MeasureOfId = 'measure_of_id',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name'
}

export type Unit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_Set_Input>;
  where: Unit_Bool_Exp;
};

/** columns and relationships of "user_answer_choices" */
export type User_Answer_Choices = {
  __typename?: 'user_answer_choices';
  /** An object relationship */
  answer_choice?: Maybe<Answer_Choice>;
  choice_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  response_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user_assessment_question_response?: Maybe<User_Assessment_Question_Response>;
};

/** aggregated selection of "user_answer_choices" */
export type User_Answer_Choices_Aggregate = {
  __typename?: 'user_answer_choices_aggregate';
  aggregate?: Maybe<User_Answer_Choices_Aggregate_Fields>;
  nodes: Array<User_Answer_Choices>;
};

/** aggregate fields of "user_answer_choices" */
export type User_Answer_Choices_Aggregate_Fields = {
  __typename?: 'user_answer_choices_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Answer_Choices_Max_Fields>;
  min?: Maybe<User_Answer_Choices_Min_Fields>;
};


/** aggregate fields of "user_answer_choices" */
export type User_Answer_Choices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Answer_Choices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_answer_choices" */
export type User_Answer_Choices_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Answer_Choices_Max_Order_By>;
  min?: InputMaybe<User_Answer_Choices_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_answer_choices" */
export type User_Answer_Choices_Arr_Rel_Insert_Input = {
  data: Array<User_Answer_Choices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Answer_Choices_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_answer_choices". All fields are combined with a logical 'AND'. */
export type User_Answer_Choices_Bool_Exp = {
  _and?: InputMaybe<Array<User_Answer_Choices_Bool_Exp>>;
  _not?: InputMaybe<User_Answer_Choices_Bool_Exp>;
  _or?: InputMaybe<Array<User_Answer_Choices_Bool_Exp>>;
  answer_choice?: InputMaybe<Answer_Choice_Bool_Exp>;
  choice_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  response_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_assessment_question_response?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};

/** unique or primary key constraints on table "user_answer_choices" */
export enum User_Answer_Choices_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAnswerChoicesPkey = 'user_answer_choices_pkey'
}

/** input type for inserting data into table "user_answer_choices" */
export type User_Answer_Choices_Insert_Input = {
  answer_choice?: InputMaybe<Answer_Choice_Obj_Rel_Insert_Input>;
  choice_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  response_id?: InputMaybe<Scalars['uuid']>;
  user_assessment_question_response?: InputMaybe<User_Assessment_Question_Response_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Answer_Choices_Max_Fields = {
  __typename?: 'user_answer_choices_max_fields';
  choice_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  response_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_answer_choices" */
export type User_Answer_Choices_Max_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Answer_Choices_Min_Fields = {
  __typename?: 'user_answer_choices_min_fields';
  choice_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  response_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_answer_choices" */
export type User_Answer_Choices_Min_Order_By = {
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_answer_choices" */
export type User_Answer_Choices_Mutation_Response = {
  __typename?: 'user_answer_choices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Answer_Choices>;
};

/** on_conflict condition type for table "user_answer_choices" */
export type User_Answer_Choices_On_Conflict = {
  constraint: User_Answer_Choices_Constraint;
  update_columns?: Array<User_Answer_Choices_Update_Column>;
  where?: InputMaybe<User_Answer_Choices_Bool_Exp>;
};

/** Ordering options when selecting data from "user_answer_choices". */
export type User_Answer_Choices_Order_By = {
  answer_choice?: InputMaybe<Answer_Choice_Order_By>;
  choice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  user_assessment_question_response?: InputMaybe<User_Assessment_Question_Response_Order_By>;
};

/** primary key columns input for table: user_answer_choices */
export type User_Answer_Choices_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_answer_choices" */
export enum User_Answer_Choices_Select_Column {
  /** column name */
  ChoiceId = 'choice_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ResponseId = 'response_id'
}

/** input type for updating data in table "user_answer_choices" */
export type User_Answer_Choices_Set_Input = {
  choice_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  response_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_answer_choices" */
export type User_Answer_Choices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Answer_Choices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Answer_Choices_Stream_Cursor_Value_Input = {
  choice_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  response_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_answer_choices" */
export enum User_Answer_Choices_Update_Column {
  /** column name */
  ChoiceId = 'choice_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ResponseId = 'response_id'
}

export type User_Answer_Choices_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Answer_Choices_Set_Input>;
  where: User_Answer_Choices_Bool_Exp;
};

/** columns and relationships of "user_assessment_attempt" */
export type User_Assessment_Attempt = {
  __typename?: 'user_assessment_attempt';
  /** An object relationship */
  assessment: Assessment;
  assessment_id: Scalars['uuid'];
  attempted_by_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  score?: Maybe<Scalars['Int']>;
  shared_attempted_by_id?: Maybe<Scalars['bigint']>;
  status: Scalars['String'];
  text_score?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  /** An array relationship */
  user_assessment_question_responses: Array<User_Assessment_Question_Response>;
  /** An aggregate relationship */
  user_assessment_question_responses_aggregate: User_Assessment_Question_Response_Aggregate;
};


/** columns and relationships of "user_assessment_attempt" */
export type User_Assessment_AttemptUser_Assessment_Question_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Question_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Question_Response_Order_By>>;
  where?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};


/** columns and relationships of "user_assessment_attempt" */
export type User_Assessment_AttemptUser_Assessment_Question_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assessment_Question_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assessment_Question_Response_Order_By>>;
  where?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};

/** aggregated selection of "user_assessment_attempt" */
export type User_Assessment_Attempt_Aggregate = {
  __typename?: 'user_assessment_attempt_aggregate';
  aggregate?: Maybe<User_Assessment_Attempt_Aggregate_Fields>;
  nodes: Array<User_Assessment_Attempt>;
};

/** aggregate fields of "user_assessment_attempt" */
export type User_Assessment_Attempt_Aggregate_Fields = {
  __typename?: 'user_assessment_attempt_aggregate_fields';
  avg?: Maybe<User_Assessment_Attempt_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Assessment_Attempt_Max_Fields>;
  min?: Maybe<User_Assessment_Attempt_Min_Fields>;
  stddev?: Maybe<User_Assessment_Attempt_Stddev_Fields>;
  stddev_pop?: Maybe<User_Assessment_Attempt_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Assessment_Attempt_Stddev_Samp_Fields>;
  sum?: Maybe<User_Assessment_Attempt_Sum_Fields>;
  var_pop?: Maybe<User_Assessment_Attempt_Var_Pop_Fields>;
  var_samp?: Maybe<User_Assessment_Attempt_Var_Samp_Fields>;
  variance?: Maybe<User_Assessment_Attempt_Variance_Fields>;
};


/** aggregate fields of "user_assessment_attempt" */
export type User_Assessment_Attempt_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Assessment_Attempt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Aggregate_Order_By = {
  avg?: InputMaybe<User_Assessment_Attempt_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Assessment_Attempt_Max_Order_By>;
  min?: InputMaybe<User_Assessment_Attempt_Min_Order_By>;
  stddev?: InputMaybe<User_Assessment_Attempt_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Assessment_Attempt_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Assessment_Attempt_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Assessment_Attempt_Sum_Order_By>;
  var_pop?: InputMaybe<User_Assessment_Attempt_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Assessment_Attempt_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Assessment_Attempt_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_assessment_attempt" */
export type User_Assessment_Attempt_Arr_Rel_Insert_Input = {
  data: Array<User_Assessment_Attempt_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Assessment_Attempt_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Assessment_Attempt_Avg_Fields = {
  __typename?: 'user_assessment_attempt_avg_fields';
  score?: Maybe<Scalars['Float']>;
  shared_attempted_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Avg_Order_By = {
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_assessment_attempt". All fields are combined with a logical 'AND'. */
export type User_Assessment_Attempt_Bool_Exp = {
  _and?: InputMaybe<Array<User_Assessment_Attempt_Bool_Exp>>;
  _not?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
  _or?: InputMaybe<Array<User_Assessment_Attempt_Bool_Exp>>;
  assessment?: InputMaybe<Assessment_Bool_Exp>;
  assessment_id?: InputMaybe<Uuid_Comparison_Exp>;
  attempted_by_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  score?: InputMaybe<Int_Comparison_Exp>;
  shared_attempted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  text_score?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user_assessment_question_responses?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};

/** unique or primary key constraints on table "user_assessment_attempt" */
export enum User_Assessment_Attempt_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAssessmentAttemptPkey = 'user_assessment_attempt_pkey'
}

/** input type for incrementing numeric columns in table "user_assessment_attempt" */
export type User_Assessment_Attempt_Inc_Input = {
  score?: InputMaybe<Scalars['Int']>;
  shared_attempted_by_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_assessment_attempt" */
export type User_Assessment_Attempt_Insert_Input = {
  assessment?: InputMaybe<Assessment_Obj_Rel_Insert_Input>;
  assessment_id?: InputMaybe<Scalars['uuid']>;
  attempted_by_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Int']>;
  shared_attempted_by_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  text_score?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_assessment_question_responses?: InputMaybe<User_Assessment_Question_Response_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Assessment_Attempt_Max_Fields = {
  __typename?: 'user_assessment_attempt_max_fields';
  assessment_id?: Maybe<Scalars['uuid']>;
  attempted_by_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Int']>;
  shared_attempted_by_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  text_score?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Max_Order_By = {
  assessment_id?: InputMaybe<Order_By>;
  attempted_by_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  text_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Assessment_Attempt_Min_Fields = {
  __typename?: 'user_assessment_attempt_min_fields';
  assessment_id?: Maybe<Scalars['uuid']>;
  attempted_by_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Int']>;
  shared_attempted_by_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  text_score?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Min_Order_By = {
  assessment_id?: InputMaybe<Order_By>;
  attempted_by_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  text_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_assessment_attempt" */
export type User_Assessment_Attempt_Mutation_Response = {
  __typename?: 'user_assessment_attempt_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Assessment_Attempt>;
};

/** input type for inserting object relation for remote table "user_assessment_attempt" */
export type User_Assessment_Attempt_Obj_Rel_Insert_Input = {
  data: User_Assessment_Attempt_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Assessment_Attempt_On_Conflict>;
};

/** on_conflict condition type for table "user_assessment_attempt" */
export type User_Assessment_Attempt_On_Conflict = {
  constraint: User_Assessment_Attempt_Constraint;
  update_columns?: Array<User_Assessment_Attempt_Update_Column>;
  where?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
};

/** Ordering options when selecting data from "user_assessment_attempt". */
export type User_Assessment_Attempt_Order_By = {
  assessment?: InputMaybe<Assessment_Order_By>;
  assessment_id?: InputMaybe<Order_By>;
  attempted_by_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  text_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_assessment_question_responses_aggregate?: InputMaybe<User_Assessment_Question_Response_Aggregate_Order_By>;
};

/** primary key columns input for table: user_assessment_attempt */
export type User_Assessment_Attempt_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_assessment_attempt" */
export enum User_Assessment_Attempt_Select_Column {
  /** column name */
  AssessmentId = 'assessment_id',
  /** column name */
  AttemptedById = 'attempted_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Score = 'score',
  /** column name */
  SharedAttemptedById = 'shared_attempted_by_id',
  /** column name */
  Status = 'status',
  /** column name */
  TextScore = 'text_score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "user_assessment_attempt" */
export type User_Assessment_Attempt_Set_Input = {
  assessment_id?: InputMaybe<Scalars['uuid']>;
  attempted_by_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Int']>;
  shared_attempted_by_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  text_score?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Assessment_Attempt_Stddev_Fields = {
  __typename?: 'user_assessment_attempt_stddev_fields';
  score?: Maybe<Scalars['Float']>;
  shared_attempted_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Stddev_Order_By = {
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Assessment_Attempt_Stddev_Pop_Fields = {
  __typename?: 'user_assessment_attempt_stddev_pop_fields';
  score?: Maybe<Scalars['Float']>;
  shared_attempted_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Stddev_Pop_Order_By = {
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Assessment_Attempt_Stddev_Samp_Fields = {
  __typename?: 'user_assessment_attempt_stddev_samp_fields';
  score?: Maybe<Scalars['Float']>;
  shared_attempted_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Stddev_Samp_Order_By = {
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_assessment_attempt" */
export type User_Assessment_Attempt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Assessment_Attempt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Assessment_Attempt_Stream_Cursor_Value_Input = {
  assessment_id?: InputMaybe<Scalars['uuid']>;
  attempted_by_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Int']>;
  shared_attempted_by_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  text_score?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Assessment_Attempt_Sum_Fields = {
  __typename?: 'user_assessment_attempt_sum_fields';
  score?: Maybe<Scalars['Int']>;
  shared_attempted_by_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Sum_Order_By = {
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_assessment_attempt" */
export enum User_Assessment_Attempt_Update_Column {
  /** column name */
  AssessmentId = 'assessment_id',
  /** column name */
  AttemptedById = 'attempted_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Score = 'score',
  /** column name */
  SharedAttemptedById = 'shared_attempted_by_id',
  /** column name */
  Status = 'status',
  /** column name */
  TextScore = 'text_score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type User_Assessment_Attempt_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Assessment_Attempt_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Assessment_Attempt_Set_Input>;
  where: User_Assessment_Attempt_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Assessment_Attempt_Var_Pop_Fields = {
  __typename?: 'user_assessment_attempt_var_pop_fields';
  score?: Maybe<Scalars['Float']>;
  shared_attempted_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Var_Pop_Order_By = {
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Assessment_Attempt_Var_Samp_Fields = {
  __typename?: 'user_assessment_attempt_var_samp_fields';
  score?: Maybe<Scalars['Float']>;
  shared_attempted_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Var_Samp_Order_By = {
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Assessment_Attempt_Variance_Fields = {
  __typename?: 'user_assessment_attempt_variance_fields';
  score?: Maybe<Scalars['Float']>;
  shared_attempted_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_assessment_attempt" */
export type User_Assessment_Attempt_Variance_Order_By = {
  score?: InputMaybe<Order_By>;
  shared_attempted_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_assessment_question_response" */
export type User_Assessment_Question_Response = {
  __typename?: 'user_assessment_question_response';
  answer: Scalars['String'];
  answered_by_id: Scalars['String'];
  /** An object relationship */
  assessment_question: Assessment_Question;
  assessment_question_id: Scalars['uuid'];
  attempt_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  shared_answered_by_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  /** An array relationship */
  user_answer_choices: Array<User_Answer_Choices>;
  /** An aggregate relationship */
  user_answer_choices_aggregate: User_Answer_Choices_Aggregate;
  /** An object relationship */
  user_assessment_attempt: User_Assessment_Attempt;
};


/** columns and relationships of "user_assessment_question_response" */
export type User_Assessment_Question_ResponseUser_Answer_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<User_Answer_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Answer_Choices_Order_By>>;
  where?: InputMaybe<User_Answer_Choices_Bool_Exp>;
};


/** columns and relationships of "user_assessment_question_response" */
export type User_Assessment_Question_ResponseUser_Answer_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Answer_Choices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Answer_Choices_Order_By>>;
  where?: InputMaybe<User_Answer_Choices_Bool_Exp>;
};

/** aggregated selection of "user_assessment_question_response" */
export type User_Assessment_Question_Response_Aggregate = {
  __typename?: 'user_assessment_question_response_aggregate';
  aggregate?: Maybe<User_Assessment_Question_Response_Aggregate_Fields>;
  nodes: Array<User_Assessment_Question_Response>;
};

/** aggregate fields of "user_assessment_question_response" */
export type User_Assessment_Question_Response_Aggregate_Fields = {
  __typename?: 'user_assessment_question_response_aggregate_fields';
  avg?: Maybe<User_Assessment_Question_Response_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Assessment_Question_Response_Max_Fields>;
  min?: Maybe<User_Assessment_Question_Response_Min_Fields>;
  stddev?: Maybe<User_Assessment_Question_Response_Stddev_Fields>;
  stddev_pop?: Maybe<User_Assessment_Question_Response_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Assessment_Question_Response_Stddev_Samp_Fields>;
  sum?: Maybe<User_Assessment_Question_Response_Sum_Fields>;
  var_pop?: Maybe<User_Assessment_Question_Response_Var_Pop_Fields>;
  var_samp?: Maybe<User_Assessment_Question_Response_Var_Samp_Fields>;
  variance?: Maybe<User_Assessment_Question_Response_Variance_Fields>;
};


/** aggregate fields of "user_assessment_question_response" */
export type User_Assessment_Question_Response_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Assessment_Question_Response_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Aggregate_Order_By = {
  avg?: InputMaybe<User_Assessment_Question_Response_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Assessment_Question_Response_Max_Order_By>;
  min?: InputMaybe<User_Assessment_Question_Response_Min_Order_By>;
  stddev?: InputMaybe<User_Assessment_Question_Response_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Assessment_Question_Response_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Assessment_Question_Response_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Assessment_Question_Response_Sum_Order_By>;
  var_pop?: InputMaybe<User_Assessment_Question_Response_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Assessment_Question_Response_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Assessment_Question_Response_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Arr_Rel_Insert_Input = {
  data: Array<User_Assessment_Question_Response_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Assessment_Question_Response_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Assessment_Question_Response_Avg_Fields = {
  __typename?: 'user_assessment_question_response_avg_fields';
  shared_answered_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Avg_Order_By = {
  shared_answered_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_assessment_question_response". All fields are combined with a logical 'AND'. */
export type User_Assessment_Question_Response_Bool_Exp = {
  _and?: InputMaybe<Array<User_Assessment_Question_Response_Bool_Exp>>;
  _not?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
  _or?: InputMaybe<Array<User_Assessment_Question_Response_Bool_Exp>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  answered_by_id?: InputMaybe<String_Comparison_Exp>;
  assessment_question?: InputMaybe<Assessment_Question_Bool_Exp>;
  assessment_question_id?: InputMaybe<Uuid_Comparison_Exp>;
  attempt_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  shared_answered_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user_answer_choices?: InputMaybe<User_Answer_Choices_Bool_Exp>;
  user_assessment_attempt?: InputMaybe<User_Assessment_Attempt_Bool_Exp>;
};

/** unique or primary key constraints on table "user_assessment_question_response" */
export enum User_Assessment_Question_Response_Constraint {
  /** unique or primary key constraint on columns "answered_by_id", "attempt_id", "assessment_question_id" */
  UserAssessmentQuestionAssessmentQuestionIdA_7179ec94Uniq = 'user_assessment_question_assessment_question_id_a_7179ec94_uniq',
  /** unique or primary key constraint on columns "id" */
  UserAssessmentQuestionResponsePkey = 'user_assessment_question_response_pkey'
}

/** input type for incrementing numeric columns in table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Inc_Input = {
  shared_answered_by_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Insert_Input = {
  answer?: InputMaybe<Scalars['String']>;
  answered_by_id?: InputMaybe<Scalars['String']>;
  assessment_question?: InputMaybe<Assessment_Question_Obj_Rel_Insert_Input>;
  assessment_question_id?: InputMaybe<Scalars['uuid']>;
  attempt_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  shared_answered_by_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  user_answer_choices?: InputMaybe<User_Answer_Choices_Arr_Rel_Insert_Input>;
  user_assessment_attempt?: InputMaybe<User_Assessment_Attempt_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Assessment_Question_Response_Max_Fields = {
  __typename?: 'user_assessment_question_response_max_fields';
  answer?: Maybe<Scalars['String']>;
  answered_by_id?: Maybe<Scalars['String']>;
  assessment_question_id?: Maybe<Scalars['uuid']>;
  attempt_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shared_answered_by_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  answered_by_id?: InputMaybe<Order_By>;
  assessment_question_id?: InputMaybe<Order_By>;
  attempt_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_answered_by_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Assessment_Question_Response_Min_Fields = {
  __typename?: 'user_assessment_question_response_min_fields';
  answer?: Maybe<Scalars['String']>;
  answered_by_id?: Maybe<Scalars['String']>;
  assessment_question_id?: Maybe<Scalars['uuid']>;
  attempt_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shared_answered_by_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  answered_by_id?: InputMaybe<Order_By>;
  assessment_question_id?: InputMaybe<Order_By>;
  attempt_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shared_answered_by_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Mutation_Response = {
  __typename?: 'user_assessment_question_response_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Assessment_Question_Response>;
};

/** input type for inserting object relation for remote table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Obj_Rel_Insert_Input = {
  data: User_Assessment_Question_Response_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Assessment_Question_Response_On_Conflict>;
};

/** on_conflict condition type for table "user_assessment_question_response" */
export type User_Assessment_Question_Response_On_Conflict = {
  constraint: User_Assessment_Question_Response_Constraint;
  update_columns?: Array<User_Assessment_Question_Response_Update_Column>;
  where?: InputMaybe<User_Assessment_Question_Response_Bool_Exp>;
};

/** Ordering options when selecting data from "user_assessment_question_response". */
export type User_Assessment_Question_Response_Order_By = {
  answer?: InputMaybe<Order_By>;
  answered_by_id?: InputMaybe<Order_By>;
  assessment_question?: InputMaybe<Assessment_Question_Order_By>;
  assessment_question_id?: InputMaybe<Order_By>;
  attempt_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  shared_answered_by_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_answer_choices_aggregate?: InputMaybe<User_Answer_Choices_Aggregate_Order_By>;
  user_assessment_attempt?: InputMaybe<User_Assessment_Attempt_Order_By>;
};

/** primary key columns input for table: user_assessment_question_response */
export type User_Assessment_Question_Response_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_assessment_question_response" */
export enum User_Assessment_Question_Response_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  AnsweredById = 'answered_by_id',
  /** column name */
  AssessmentQuestionId = 'assessment_question_id',
  /** column name */
  AttemptId = 'attempt_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SharedAnsweredById = 'shared_answered_by_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Set_Input = {
  answer?: InputMaybe<Scalars['String']>;
  answered_by_id?: InputMaybe<Scalars['String']>;
  assessment_question_id?: InputMaybe<Scalars['uuid']>;
  attempt_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  shared_answered_by_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Assessment_Question_Response_Stddev_Fields = {
  __typename?: 'user_assessment_question_response_stddev_fields';
  shared_answered_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Stddev_Order_By = {
  shared_answered_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Assessment_Question_Response_Stddev_Pop_Fields = {
  __typename?: 'user_assessment_question_response_stddev_pop_fields';
  shared_answered_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Stddev_Pop_Order_By = {
  shared_answered_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Assessment_Question_Response_Stddev_Samp_Fields = {
  __typename?: 'user_assessment_question_response_stddev_samp_fields';
  shared_answered_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Stddev_Samp_Order_By = {
  shared_answered_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Assessment_Question_Response_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Assessment_Question_Response_Stream_Cursor_Value_Input = {
  answer?: InputMaybe<Scalars['String']>;
  answered_by_id?: InputMaybe<Scalars['String']>;
  assessment_question_id?: InputMaybe<Scalars['uuid']>;
  attempt_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  shared_answered_by_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Assessment_Question_Response_Sum_Fields = {
  __typename?: 'user_assessment_question_response_sum_fields';
  shared_answered_by_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Sum_Order_By = {
  shared_answered_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_assessment_question_response" */
export enum User_Assessment_Question_Response_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  AnsweredById = 'answered_by_id',
  /** column name */
  AssessmentQuestionId = 'assessment_question_id',
  /** column name */
  AttemptId = 'attempt_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  SharedAnsweredById = 'shared_answered_by_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

export type User_Assessment_Question_Response_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Assessment_Question_Response_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Assessment_Question_Response_Set_Input>;
  where: User_Assessment_Question_Response_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Assessment_Question_Response_Var_Pop_Fields = {
  __typename?: 'user_assessment_question_response_var_pop_fields';
  shared_answered_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Var_Pop_Order_By = {
  shared_answered_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Assessment_Question_Response_Var_Samp_Fields = {
  __typename?: 'user_assessment_question_response_var_samp_fields';
  shared_answered_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Var_Samp_Order_By = {
  shared_answered_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Assessment_Question_Response_Variance_Fields = {
  __typename?: 'user_assessment_question_response_variance_fields';
  shared_answered_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_assessment_question_response" */
export type User_Assessment_Question_Response_Variance_Order_By = {
  shared_answered_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_reward_history" */
export type User_Reward_History = {
  __typename?: 'user_reward_history';
  content_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  reward_configuration: Reward_Configuration;
  reward_id: Scalars['uuid'];
  reward_point: Scalars['float8'];
  row_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['String'];
};

/** aggregated selection of "user_reward_history" */
export type User_Reward_History_Aggregate = {
  __typename?: 'user_reward_history_aggregate';
  aggregate?: Maybe<User_Reward_History_Aggregate_Fields>;
  nodes: Array<User_Reward_History>;
};

/** aggregate fields of "user_reward_history" */
export type User_Reward_History_Aggregate_Fields = {
  __typename?: 'user_reward_history_aggregate_fields';
  avg?: Maybe<User_Reward_History_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Reward_History_Max_Fields>;
  min?: Maybe<User_Reward_History_Min_Fields>;
  stddev?: Maybe<User_Reward_History_Stddev_Fields>;
  stddev_pop?: Maybe<User_Reward_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Reward_History_Stddev_Samp_Fields>;
  sum?: Maybe<User_Reward_History_Sum_Fields>;
  var_pop?: Maybe<User_Reward_History_Var_Pop_Fields>;
  var_samp?: Maybe<User_Reward_History_Var_Samp_Fields>;
  variance?: Maybe<User_Reward_History_Variance_Fields>;
};


/** aggregate fields of "user_reward_history" */
export type User_Reward_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Reward_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_reward_history" */
export type User_Reward_History_Aggregate_Order_By = {
  avg?: InputMaybe<User_Reward_History_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Reward_History_Max_Order_By>;
  min?: InputMaybe<User_Reward_History_Min_Order_By>;
  stddev?: InputMaybe<User_Reward_History_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Reward_History_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Reward_History_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Reward_History_Sum_Order_By>;
  var_pop?: InputMaybe<User_Reward_History_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Reward_History_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Reward_History_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_reward_history" */
export type User_Reward_History_Arr_Rel_Insert_Input = {
  data: Array<User_Reward_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Reward_History_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Reward_History_Avg_Fields = {
  __typename?: 'user_reward_history_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  reward_point?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_reward_history" */
export type User_Reward_History_Avg_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_reward_history". All fields are combined with a logical 'AND'. */
export type User_Reward_History_Bool_Exp = {
  _and?: InputMaybe<Array<User_Reward_History_Bool_Exp>>;
  _not?: InputMaybe<User_Reward_History_Bool_Exp>;
  _or?: InputMaybe<Array<User_Reward_History_Bool_Exp>>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  reward_configuration?: InputMaybe<Reward_Configuration_Bool_Exp>;
  reward_id?: InputMaybe<Uuid_Comparison_Exp>;
  reward_point?: InputMaybe<Float8_Comparison_Exp>;
  row_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_reward_history" */
export enum User_Reward_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserRewardHistoryPkey = 'user_reward_history_pkey'
}

/** input type for incrementing numeric columns in table "user_reward_history" */
export type User_Reward_History_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  reward_point?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "user_reward_history" */
export type User_Reward_History_Insert_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  reward_configuration?: InputMaybe<Reward_Configuration_Obj_Rel_Insert_Input>;
  reward_id?: InputMaybe<Scalars['uuid']>;
  reward_point?: InputMaybe<Scalars['float8']>;
  row_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Reward_History_Max_Fields = {
  __typename?: 'user_reward_history_max_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  reward_id?: Maybe<Scalars['uuid']>;
  reward_point?: Maybe<Scalars['float8']>;
  row_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_reward_history" */
export type User_Reward_History_Max_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reward_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
  row_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Reward_History_Min_Fields = {
  __typename?: 'user_reward_history_min_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  reward_id?: Maybe<Scalars['uuid']>;
  reward_point?: Maybe<Scalars['float8']>;
  row_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_reward_history" */
export type User_Reward_History_Min_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reward_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
  row_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_reward_history" */
export type User_Reward_History_Mutation_Response = {
  __typename?: 'user_reward_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Reward_History>;
};

/** on_conflict condition type for table "user_reward_history" */
export type User_Reward_History_On_Conflict = {
  constraint: User_Reward_History_Constraint;
  update_columns?: Array<User_Reward_History_Update_Column>;
  where?: InputMaybe<User_Reward_History_Bool_Exp>;
};

/** Ordering options when selecting data from "user_reward_history". */
export type User_Reward_History_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  reward_configuration?: InputMaybe<Reward_Configuration_Order_By>;
  reward_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
  row_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_reward_history */
export type User_Reward_History_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_reward_history" */
export enum User_Reward_History_Select_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  RewardId = 'reward_id',
  /** column name */
  RewardPoint = 'reward_point',
  /** column name */
  RowId = 'row_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_reward_history" */
export type User_Reward_History_Set_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  reward_id?: InputMaybe<Scalars['uuid']>;
  reward_point?: InputMaybe<Scalars['float8']>;
  row_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Reward_History_Stddev_Fields = {
  __typename?: 'user_reward_history_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  reward_point?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_reward_history" */
export type User_Reward_History_Stddev_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Reward_History_Stddev_Pop_Fields = {
  __typename?: 'user_reward_history_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  reward_point?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_reward_history" */
export type User_Reward_History_Stddev_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Reward_History_Stddev_Samp_Fields = {
  __typename?: 'user_reward_history_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  reward_point?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_reward_history" */
export type User_Reward_History_Stddev_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_reward_history" */
export type User_Reward_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Reward_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Reward_History_Stream_Cursor_Value_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  reward_id?: InputMaybe<Scalars['uuid']>;
  reward_point?: InputMaybe<Scalars['float8']>;
  row_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Reward_History_Sum_Fields = {
  __typename?: 'user_reward_history_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  reward_point?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "user_reward_history" */
export type User_Reward_History_Sum_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
};

/** update columns of table "user_reward_history" */
export enum User_Reward_History_Update_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  RewardId = 'reward_id',
  /** column name */
  RewardPoint = 'reward_point',
  /** column name */
  RowId = 'row_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Reward_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Reward_History_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Reward_History_Set_Input>;
  where: User_Reward_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Reward_History_Var_Pop_Fields = {
  __typename?: 'user_reward_history_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  reward_point?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_reward_history" */
export type User_Reward_History_Var_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Reward_History_Var_Samp_Fields = {
  __typename?: 'user_reward_history_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  reward_point?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_reward_history" */
export type User_Reward_History_Var_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Reward_History_Variance_Fields = {
  __typename?: 'user_reward_history_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  reward_point?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_reward_history" */
export type User_Reward_History_Variance_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  reward_point?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_subscription_package" */
export type User_Subscription_Package = {
  __typename?: 'user_subscription_package';
  /** An object relationship */
  article_subscription_package: Article_Subscription_Package;
  id: Scalars['bigint'];
  /** An object relationship */
  shared_user?: Maybe<Shared_Entity>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  subscription_package_id: Scalars['uuid'];
  user_id: Scalars['String'];
  valid_from?: Maybe<Scalars['date']>;
  valid_to?: Maybe<Scalars['date']>;
};

/** aggregated selection of "user_subscription_package" */
export type User_Subscription_Package_Aggregate = {
  __typename?: 'user_subscription_package_aggregate';
  aggregate?: Maybe<User_Subscription_Package_Aggregate_Fields>;
  nodes: Array<User_Subscription_Package>;
};

/** aggregate fields of "user_subscription_package" */
export type User_Subscription_Package_Aggregate_Fields = {
  __typename?: 'user_subscription_package_aggregate_fields';
  avg?: Maybe<User_Subscription_Package_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Subscription_Package_Max_Fields>;
  min?: Maybe<User_Subscription_Package_Min_Fields>;
  stddev?: Maybe<User_Subscription_Package_Stddev_Fields>;
  stddev_pop?: Maybe<User_Subscription_Package_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Subscription_Package_Stddev_Samp_Fields>;
  sum?: Maybe<User_Subscription_Package_Sum_Fields>;
  var_pop?: Maybe<User_Subscription_Package_Var_Pop_Fields>;
  var_samp?: Maybe<User_Subscription_Package_Var_Samp_Fields>;
  variance?: Maybe<User_Subscription_Package_Variance_Fields>;
};


/** aggregate fields of "user_subscription_package" */
export type User_Subscription_Package_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Subscription_Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_subscription_package" */
export type User_Subscription_Package_Aggregate_Order_By = {
  avg?: InputMaybe<User_Subscription_Package_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Subscription_Package_Max_Order_By>;
  min?: InputMaybe<User_Subscription_Package_Min_Order_By>;
  stddev?: InputMaybe<User_Subscription_Package_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Subscription_Package_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Subscription_Package_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Subscription_Package_Sum_Order_By>;
  var_pop?: InputMaybe<User_Subscription_Package_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Subscription_Package_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Subscription_Package_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_subscription_package" */
export type User_Subscription_Package_Arr_Rel_Insert_Input = {
  data: Array<User_Subscription_Package_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Subscription_Package_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Subscription_Package_Avg_Fields = {
  __typename?: 'user_subscription_package_avg_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_subscription_package" */
export type User_Subscription_Package_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_subscription_package". All fields are combined with a logical 'AND'. */
export type User_Subscription_Package_Bool_Exp = {
  _and?: InputMaybe<Array<User_Subscription_Package_Bool_Exp>>;
  _not?: InputMaybe<User_Subscription_Package_Bool_Exp>;
  _or?: InputMaybe<Array<User_Subscription_Package_Bool_Exp>>;
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  shared_user?: InputMaybe<Shared_Entity_Bool_Exp>;
  shared_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  subscription_package_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_subscription_package" */
export enum User_Subscription_Package_Constraint {
  /** unique or primary key constraint on columns "subscription_package_id", "user_id" */
  UserSubscriptionPackagSubscriptionPackageIdDd12a05cUniq = 'user_subscription_packag_subscription_package_id__dd12a05c_uniq',
  /** unique or primary key constraint on columns "id" */
  UserSubscriptionPackagePkey = 'user_subscription_package_pkey'
}

/** input type for incrementing numeric columns in table "user_subscription_package" */
export type User_Subscription_Package_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_subscription_package" */
export type User_Subscription_Package_Insert_Input = {
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  shared_user?: InputMaybe<Shared_Entity_Obj_Rel_Insert_Input>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type User_Subscription_Package_Max_Fields = {
  __typename?: 'user_subscription_package_max_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  subscription_package_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['date']>;
  valid_to?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "user_subscription_package" */
export type User_Subscription_Package_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Subscription_Package_Min_Fields = {
  __typename?: 'user_subscription_package_min_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
  subscription_package_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['date']>;
  valid_to?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "user_subscription_package" */
export type User_Subscription_Package_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_subscription_package" */
export type User_Subscription_Package_Mutation_Response = {
  __typename?: 'user_subscription_package_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Subscription_Package>;
};

/** on_conflict condition type for table "user_subscription_package" */
export type User_Subscription_Package_On_Conflict = {
  constraint: User_Subscription_Package_Constraint;
  update_columns?: Array<User_Subscription_Package_Update_Column>;
  where?: InputMaybe<User_Subscription_Package_Bool_Exp>;
};

/** Ordering options when selecting data from "user_subscription_package". */
export type User_Subscription_Package_Order_By = {
  article_subscription_package?: InputMaybe<Article_Subscription_Package_Order_By>;
  id?: InputMaybe<Order_By>;
  shared_user?: InputMaybe<Shared_Entity_Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
  subscription_package_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_subscription_package */
export type User_Subscription_Package_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "user_subscription_package" */
export enum User_Subscription_Package_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  SubscriptionPackageId = 'subscription_package_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** input type for updating data in table "user_subscription_package" */
export type User_Subscription_Package_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type User_Subscription_Package_Stddev_Fields = {
  __typename?: 'user_subscription_package_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_subscription_package" */
export type User_Subscription_Package_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Subscription_Package_Stddev_Pop_Fields = {
  __typename?: 'user_subscription_package_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_subscription_package" */
export type User_Subscription_Package_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Subscription_Package_Stddev_Samp_Fields = {
  __typename?: 'user_subscription_package_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_subscription_package" */
export type User_Subscription_Package_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_subscription_package" */
export type User_Subscription_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Subscription_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Subscription_Package_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  shared_user_id?: InputMaybe<Scalars['bigint']>;
  subscription_package_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type User_Subscription_Package_Sum_Fields = {
  __typename?: 'user_subscription_package_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  shared_user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_subscription_package" */
export type User_Subscription_Package_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_subscription_package" */
export enum User_Subscription_Package_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SharedUserId = 'shared_user_id',
  /** column name */
  SubscriptionPackageId = 'subscription_package_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

export type User_Subscription_Package_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Subscription_Package_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Subscription_Package_Set_Input>;
  where: User_Subscription_Package_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Subscription_Package_Var_Pop_Fields = {
  __typename?: 'user_subscription_package_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_subscription_package" */
export type User_Subscription_Package_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Subscription_Package_Var_Samp_Fields = {
  __typename?: 'user_subscription_package_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_subscription_package" */
export type User_Subscription_Package_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Subscription_Package_Variance_Fields = {
  __typename?: 'user_subscription_package_variance_fields';
  id?: Maybe<Scalars['Float']>;
  shared_user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_subscription_package" */
export type User_Subscription_Package_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  shared_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "variety_grade" */
export type Variety_Grade = {
  __typename?: 'variety_grade';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  photos: Array<Variety_Grade_Photos>;
  /** An aggregate relationship */
  photos_aggregate: Variety_Grade_Photos_Aggregate;
  short_name?: Maybe<Scalars['String']>;
  specifications: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  variety: Commodity_Variety;
  variety_id: Scalars['Int'];
};


/** columns and relationships of "variety_grade" */
export type Variety_GradePhotosArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


/** columns and relationships of "variety_grade" */
export type Variety_GradePhotos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};

/** aggregated selection of "variety_grade" */
export type Variety_Grade_Aggregate = {
  __typename?: 'variety_grade_aggregate';
  aggregate?: Maybe<Variety_Grade_Aggregate_Fields>;
  nodes: Array<Variety_Grade>;
};

/** aggregate fields of "variety_grade" */
export type Variety_Grade_Aggregate_Fields = {
  __typename?: 'variety_grade_aggregate_fields';
  avg?: Maybe<Variety_Grade_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Variety_Grade_Max_Fields>;
  min?: Maybe<Variety_Grade_Min_Fields>;
  stddev?: Maybe<Variety_Grade_Stddev_Fields>;
  stddev_pop?: Maybe<Variety_Grade_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variety_Grade_Stddev_Samp_Fields>;
  sum?: Maybe<Variety_Grade_Sum_Fields>;
  var_pop?: Maybe<Variety_Grade_Var_Pop_Fields>;
  var_samp?: Maybe<Variety_Grade_Var_Samp_Fields>;
  variance?: Maybe<Variety_Grade_Variance_Fields>;
};


/** aggregate fields of "variety_grade" */
export type Variety_Grade_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "variety_grade" */
export type Variety_Grade_Aggregate_Order_By = {
  avg?: InputMaybe<Variety_Grade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variety_Grade_Max_Order_By>;
  min?: InputMaybe<Variety_Grade_Min_Order_By>;
  stddev?: InputMaybe<Variety_Grade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variety_Grade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variety_Grade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variety_Grade_Sum_Order_By>;
  var_pop?: InputMaybe<Variety_Grade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variety_Grade_Var_Samp_Order_By>;
  variance?: InputMaybe<Variety_Grade_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variety_grade" */
export type Variety_Grade_Arr_Rel_Insert_Input = {
  data: Array<Variety_Grade_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Grade_On_Conflict>;
};

/** aggregate avg on columns */
export type Variety_Grade_Avg_Fields = {
  __typename?: 'variety_grade_avg_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "variety_grade" */
export type Variety_Grade_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variety_grade". All fields are combined with a logical 'AND'. */
export type Variety_Grade_Bool_Exp = {
  _and?: InputMaybe<Array<Variety_Grade_Bool_Exp>>;
  _not?: InputMaybe<Variety_Grade_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Grade_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photos?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  specifications?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  variety?: InputMaybe<Commodity_Variety_Bool_Exp>;
  variety_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "variety_grade". All fields are combined with a logical 'AND'. */
export type Variety_Grade_Bool_Exp_Remote_Rel_Shared_Entityvariety_Grade = {
  _and?: InputMaybe<Array<Variety_Grade_Bool_Exp>>;
  _not?: InputMaybe<Variety_Grade_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Grade_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityvariety_Grade>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photos?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  specifications?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  variety?: InputMaybe<Commodity_Variety_Bool_Exp>;
  variety_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "variety_grade" */
export enum Variety_Grade_Constraint {
  /** unique or primary key constraint on columns "codename" */
  VarietyGradeCodenameKey = 'variety_grade_codename_key',
  /** unique or primary key constraint on columns "name", "variety_id" */
  VarietyGradeNameVarietyId_66e65a93Uniq = 'variety_grade_name_variety_id_66e65a93_uniq',
  /** unique or primary key constraint on columns "id" */
  VarietyGradePkey = 'variety_grade_pkey'
}

/** input type for incrementing numeric columns in table "variety_grade" */
export type Variety_Grade_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  variety_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "variety_grade" */
export type Variety_Grade_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Variety_Grade_Photos_Arr_Rel_Insert_Input>;
  short_name?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  variety?: InputMaybe<Commodity_Variety_Obj_Rel_Insert_Input>;
  variety_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Variety_Grade_Max_Fields = {
  __typename?: 'variety_grade_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  variety_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "variety_grade" */
export type Variety_Grade_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  specifications?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variety_Grade_Min_Fields = {
  __typename?: 'variety_grade_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  variety_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "variety_grade" */
export type Variety_Grade_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  specifications?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variety_grade" */
export type Variety_Grade_Mutation_Response = {
  __typename?: 'variety_grade_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Variety_Grade>;
};

/** input type for inserting object relation for remote table "variety_grade" */
export type Variety_Grade_Obj_Rel_Insert_Input = {
  data: Variety_Grade_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Grade_On_Conflict>;
};

/** on_conflict condition type for table "variety_grade" */
export type Variety_Grade_On_Conflict = {
  constraint: Variety_Grade_Constraint;
  update_columns?: Array<Variety_Grade_Update_Column>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};

/** Ordering options when selecting data from "variety_grade". */
export type Variety_Grade_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photos_aggregate?: InputMaybe<Variety_Grade_Photos_Aggregate_Order_By>;
  short_name?: InputMaybe<Order_By>;
  specifications?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety?: InputMaybe<Commodity_Variety_Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "variety_grade_photos" */
export type Variety_Grade_Photos = {
  __typename?: 'variety_grade_photos';
  id: Scalars['Int'];
  media_id: Scalars['Int'];
  /** An object relationship */
  photo: Media;
  /** An object relationship */
  variety_grade: Variety_Grade;
  varietygrade_id: Scalars['Int'];
};

/** aggregated selection of "variety_grade_photos" */
export type Variety_Grade_Photos_Aggregate = {
  __typename?: 'variety_grade_photos_aggregate';
  aggregate?: Maybe<Variety_Grade_Photos_Aggregate_Fields>;
  nodes: Array<Variety_Grade_Photos>;
};

/** aggregate fields of "variety_grade_photos" */
export type Variety_Grade_Photos_Aggregate_Fields = {
  __typename?: 'variety_grade_photos_aggregate_fields';
  avg?: Maybe<Variety_Grade_Photos_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Variety_Grade_Photos_Max_Fields>;
  min?: Maybe<Variety_Grade_Photos_Min_Fields>;
  stddev?: Maybe<Variety_Grade_Photos_Stddev_Fields>;
  stddev_pop?: Maybe<Variety_Grade_Photos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variety_Grade_Photos_Stddev_Samp_Fields>;
  sum?: Maybe<Variety_Grade_Photos_Sum_Fields>;
  var_pop?: Maybe<Variety_Grade_Photos_Var_Pop_Fields>;
  var_samp?: Maybe<Variety_Grade_Photos_Var_Samp_Fields>;
  variance?: Maybe<Variety_Grade_Photos_Variance_Fields>;
};


/** aggregate fields of "variety_grade_photos" */
export type Variety_Grade_Photos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "variety_grade_photos" */
export type Variety_Grade_Photos_Aggregate_Order_By = {
  avg?: InputMaybe<Variety_Grade_Photos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variety_Grade_Photos_Max_Order_By>;
  min?: InputMaybe<Variety_Grade_Photos_Min_Order_By>;
  stddev?: InputMaybe<Variety_Grade_Photos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variety_Grade_Photos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variety_Grade_Photos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variety_Grade_Photos_Sum_Order_By>;
  var_pop?: InputMaybe<Variety_Grade_Photos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variety_Grade_Photos_Var_Samp_Order_By>;
  variance?: InputMaybe<Variety_Grade_Photos_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variety_grade_photos" */
export type Variety_Grade_Photos_Arr_Rel_Insert_Input = {
  data: Array<Variety_Grade_Photos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Grade_Photos_On_Conflict>;
};

/** aggregate avg on columns */
export type Variety_Grade_Photos_Avg_Fields = {
  __typename?: 'variety_grade_photos_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variety_grade_photos". All fields are combined with a logical 'AND'. */
export type Variety_Grade_Photos_Bool_Exp = {
  _and?: InputMaybe<Array<Variety_Grade_Photos_Bool_Exp>>;
  _not?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Grade_Photos_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  media_id?: InputMaybe<Int_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  variety_grade?: InputMaybe<Variety_Grade_Bool_Exp>;
  varietygrade_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "variety_grade_photos" */
export enum Variety_Grade_Photos_Constraint {
  /** unique or primary key constraint on columns "id" */
  VarietyGradePhotosPkey = 'variety_grade_photos_pkey',
  /** unique or primary key constraint on columns "media_id", "varietygrade_id" */
  VarietyGradePhotosVarietygradeIdMediaId_666d4e7fUniq = 'variety_grade_photos_varietygrade_id_media_id_666d4e7f_uniq'
}

/** input type for incrementing numeric columns in table "variety_grade_photos" */
export type Variety_Grade_Photos_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  varietygrade_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "variety_grade_photos" */
export type Variety_Grade_Photos_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  variety_grade?: InputMaybe<Variety_Grade_Obj_Rel_Insert_Input>;
  varietygrade_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Variety_Grade_Photos_Max_Fields = {
  __typename?: 'variety_grade_photos_max_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  varietygrade_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variety_Grade_Photos_Min_Fields = {
  __typename?: 'variety_grade_photos_min_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  varietygrade_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variety_grade_photos" */
export type Variety_Grade_Photos_Mutation_Response = {
  __typename?: 'variety_grade_photos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Variety_Grade_Photos>;
};

/** on_conflict condition type for table "variety_grade_photos" */
export type Variety_Grade_Photos_On_Conflict = {
  constraint: Variety_Grade_Photos_Constraint;
  update_columns?: Array<Variety_Grade_Photos_Update_Column>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};

/** Ordering options when selecting data from "variety_grade_photos". */
export type Variety_Grade_Photos_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  variety_grade?: InputMaybe<Variety_Grade_Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variety_grade_photos */
export type Variety_Grade_Photos_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "variety_grade_photos" */
export enum Variety_Grade_Photos_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  VarietygradeId = 'varietygrade_id'
}

/** input type for updating data in table "variety_grade_photos" */
export type Variety_Grade_Photos_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  varietygrade_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Variety_Grade_Photos_Stddev_Fields = {
  __typename?: 'variety_grade_photos_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variety_Grade_Photos_Stddev_Pop_Fields = {
  __typename?: 'variety_grade_photos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variety_Grade_Photos_Stddev_Samp_Fields = {
  __typename?: 'variety_grade_photos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variety_grade_photos" */
export type Variety_Grade_Photos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variety_Grade_Photos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variety_Grade_Photos_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  varietygrade_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Variety_Grade_Photos_Sum_Fields = {
  __typename?: 'variety_grade_photos_sum_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  varietygrade_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** update columns of table "variety_grade_photos" */
export enum Variety_Grade_Photos_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  VarietygradeId = 'varietygrade_id'
}

export type Variety_Grade_Photos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variety_Grade_Photos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variety_Grade_Photos_Set_Input>;
  where: Variety_Grade_Photos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variety_Grade_Photos_Var_Pop_Fields = {
  __typename?: 'variety_grade_photos_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variety_Grade_Photos_Var_Samp_Fields = {
  __typename?: 'variety_grade_photos_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variety_Grade_Photos_Variance_Fields = {
  __typename?: 'variety_grade_photos_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variety_grade */
export type Variety_Grade_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "variety_grade" */
export enum Variety_Grade_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Specifications = 'specifications',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VarietyId = 'variety_id'
}

/** input type for updating data in table "variety_grade" */
export type Variety_Grade_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  variety_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Variety_Grade_Stddev_Fields = {
  __typename?: 'variety_grade_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "variety_grade" */
export type Variety_Grade_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variety_Grade_Stddev_Pop_Fields = {
  __typename?: 'variety_grade_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "variety_grade" */
export type Variety_Grade_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variety_Grade_Stddev_Samp_Fields = {
  __typename?: 'variety_grade_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "variety_grade" */
export type Variety_Grade_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variety_grade" */
export type Variety_Grade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variety_Grade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variety_Grade_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  variety_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Variety_Grade_Sum_Fields = {
  __typename?: 'variety_grade_sum_fields';
  id?: Maybe<Scalars['Int']>;
  variety_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "variety_grade" */
export type Variety_Grade_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** update columns of table "variety_grade" */
export enum Variety_Grade_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Specifications = 'specifications',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VarietyId = 'variety_id'
}

export type Variety_Grade_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variety_Grade_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variety_Grade_Set_Input>;
  where: Variety_Grade_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variety_Grade_Var_Pop_Fields = {
  __typename?: 'variety_grade_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "variety_grade" */
export type Variety_Grade_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variety_Grade_Var_Samp_Fields = {
  __typename?: 'variety_grade_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "variety_grade" */
export type Variety_Grade_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variety_Grade_Variance_Fields = {
  __typename?: 'variety_grade_variance_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "variety_grade" */
export type Variety_Grade_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "variety_group" */
export type Variety_Group = {
  __typename?: 'variety_group';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  primary_varieties: Array<Commodity_Variety>;
  /** An aggregate relationship */
  primary_varieties_aggregate: Commodity_Variety_Aggregate;
  private_metadata: Scalars['jsonb'];
  /** An array relationship */
  secondary_varieties: Array<Commodity_Variety_Secondary_Groups>;
  /** An aggregate relationship */
  secondary_varieties_aggregate: Commodity_Variety_Secondary_Groups_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "variety_group" */
export type Variety_GroupMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "variety_group" */
export type Variety_GroupPrimary_VarietiesArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


/** columns and relationships of "variety_group" */
export type Variety_GroupPrimary_Varieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


/** columns and relationships of "variety_group" */
export type Variety_GroupPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "variety_group" */
export type Variety_GroupSecondary_VarietiesArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


/** columns and relationships of "variety_group" */
export type Variety_GroupSecondary_Varieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};

/** aggregated selection of "variety_group" */
export type Variety_Group_Aggregate = {
  __typename?: 'variety_group_aggregate';
  aggregate?: Maybe<Variety_Group_Aggregate_Fields>;
  nodes: Array<Variety_Group>;
};

/** aggregate fields of "variety_group" */
export type Variety_Group_Aggregate_Fields = {
  __typename?: 'variety_group_aggregate_fields';
  avg?: Maybe<Variety_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Variety_Group_Max_Fields>;
  min?: Maybe<Variety_Group_Min_Fields>;
  stddev?: Maybe<Variety_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Variety_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variety_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Variety_Group_Sum_Fields>;
  var_pop?: Maybe<Variety_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Variety_Group_Var_Samp_Fields>;
  variance?: Maybe<Variety_Group_Variance_Fields>;
};


/** aggregate fields of "variety_group" */
export type Variety_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variety_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Variety_Group_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Variety_Group_Avg_Fields = {
  __typename?: 'variety_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "variety_group". All fields are combined with a logical 'AND'. */
export type Variety_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Variety_Group_Bool_Exp>>;
  _not?: InputMaybe<Variety_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Group_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  primary_varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  secondary_varieties?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "variety_group" */
export enum Variety_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  VarietyGroupCodenameKey = 'variety_group_codename_key',
  /** unique or primary key constraint on columns "id" */
  VarietyGroupPkey = 'variety_group_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Variety_Group_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Variety_Group_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Variety_Group_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "variety_group" */
export type Variety_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "variety_group" */
export type Variety_Group_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_varieties?: InputMaybe<Commodity_Variety_Arr_Rel_Insert_Input>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  secondary_varieties?: InputMaybe<Commodity_Variety_Secondary_Groups_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Variety_Group_Max_Fields = {
  __typename?: 'variety_group_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Variety_Group_Min_Fields = {
  __typename?: 'variety_group_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "variety_group" */
export type Variety_Group_Mutation_Response = {
  __typename?: 'variety_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Variety_Group>;
};

/** input type for inserting object relation for remote table "variety_group" */
export type Variety_Group_Obj_Rel_Insert_Input = {
  data: Variety_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Group_On_Conflict>;
};

/** on_conflict condition type for table "variety_group" */
export type Variety_Group_On_Conflict = {
  constraint: Variety_Group_Constraint;
  update_columns?: Array<Variety_Group_Update_Column>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "variety_group". */
export type Variety_Group_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_varieties_aggregate?: InputMaybe<Commodity_Variety_Aggregate_Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  secondary_varieties_aggregate?: InputMaybe<Commodity_Variety_Secondary_Groups_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variety_group */
export type Variety_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Variety_Group_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "variety_group" */
export enum Variety_Group_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "variety_group" */
export type Variety_Group_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Variety_Group_Stddev_Fields = {
  __typename?: 'variety_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Variety_Group_Stddev_Pop_Fields = {
  __typename?: 'variety_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Variety_Group_Stddev_Samp_Fields = {
  __typename?: 'variety_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "variety_group" */
export type Variety_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variety_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variety_Group_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Variety_Group_Sum_Fields = {
  __typename?: 'variety_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "variety_group" */
export enum Variety_Group_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Variety_Group_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Variety_Group_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Variety_Group_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Variety_Group_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Variety_Group_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variety_Group_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Variety_Group_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variety_Group_Set_Input>;
  where: Variety_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variety_Group_Var_Pop_Fields = {
  __typename?: 'variety_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Variety_Group_Var_Samp_Fields = {
  __typename?: 'variety_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Variety_Group_Variance_Fields = {
  __typename?: 'variety_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "weather_location" */
export type Weather_Location = {
  __typename?: 'weather_location';
  /** An array relationship */
  actual_readings: Array<Actual_Reading>;
  /** An aggregate relationship */
  actual_readings_aggregate: Actual_Reading_Aggregate;
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['bigint'];
  /** An array relationship */
  daily_actual_readings: Array<Daily_Actual_Reading>;
  /** An aggregate relationship */
  daily_actual_readings_aggregate: Daily_Actual_Reading_Aggregate;
  /** An array relationship */
  daily_forecast_readings: Array<Daily_Forecast_Reading>;
  /** An aggregate relationship */
  daily_forecast_readings_aggregate: Daily_Forecast_Reading_Aggregate;
  elevation?: Maybe<Scalars['float8']>;
  /** An array relationship */
  forecast_readings: Array<Forecast_Reading>;
  /** An aggregate relationship */
  forecast_readings_aggregate: Forecast_Reading_Aggregate;
  /** An array relationship */
  gateways: Array<Gateway>;
  /** An aggregate relationship */
  gateways_aggregate: Gateway_Aggregate;
  geom: Scalars['geometry'];
  id: Scalars['uuid'];
  /** An array relationship */
  inst_readings: Array<Inst_Sensor_Reading>;
  /** An aggregate relationship */
  inst_readings_aggregate: Inst_Sensor_Reading_Aggregate;
  is_active: Scalars['Boolean'];
  loc_desc?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  /** An array relationship */
  sensors: Array<Sensor>;
  /** An aggregate relationship */
  sensors_aggregate: Sensor_Aggregate;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
  /** An array relationship */
  subscriptions: Array<Location_Subscription>;
  /** An aggregate relationship */
  subscriptions_aggregate: Location_Subscription_Aggregate;
  /** An array relationship */
  summary_readings: Array<Summary_Sensor_Reading>;
  /** An aggregate relationship */
  summary_readings_aggregate: Summary_Sensor_Reading_Aggregate;
  time_zone: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id: Scalars['bigint'];
};


/** columns and relationships of "weather_location" */
export type Weather_LocationActual_ReadingsArgs = {
  distinct_on?: InputMaybe<Array<Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Actual_Reading_Order_By>>;
  where?: InputMaybe<Actual_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationActual_Readings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Actual_Reading_Order_By>>;
  where?: InputMaybe<Actual_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationDaily_Actual_ReadingsArgs = {
  distinct_on?: InputMaybe<Array<Daily_Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Actual_Reading_Order_By>>;
  where?: InputMaybe<Daily_Actual_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationDaily_Actual_Readings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Actual_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Actual_Reading_Order_By>>;
  where?: InputMaybe<Daily_Actual_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationDaily_Forecast_ReadingsArgs = {
  distinct_on?: InputMaybe<Array<Daily_Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Forecast_Reading_Order_By>>;
  where?: InputMaybe<Daily_Forecast_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationDaily_Forecast_Readings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Forecast_Reading_Order_By>>;
  where?: InputMaybe<Daily_Forecast_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationForecast_ReadingsArgs = {
  distinct_on?: InputMaybe<Array<Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Forecast_Reading_Order_By>>;
  where?: InputMaybe<Forecast_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationForecast_Readings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Forecast_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Forecast_Reading_Order_By>>;
  where?: InputMaybe<Forecast_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationGatewaysArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationGateways_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationInst_ReadingsArgs = {
  distinct_on?: InputMaybe<Array<Inst_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inst_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationInst_Readings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inst_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inst_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationSensorsArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Order_By>>;
  where?: InputMaybe<Sensor_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationSensors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sensor_Order_By>>;
  where?: InputMaybe<Sensor_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Location_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Subscription_Order_By>>;
  where?: InputMaybe<Location_Subscription_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Subscription_Order_By>>;
  where?: InputMaybe<Location_Subscription_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationSummary_ReadingsArgs = {
  distinct_on?: InputMaybe<Array<Summary_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Summary_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
};


/** columns and relationships of "weather_location" */
export type Weather_LocationSummary_Readings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Summary_Sensor_Reading_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Summary_Sensor_Reading_Order_By>>;
  where?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
};

/** aggregated selection of "weather_location" */
export type Weather_Location_Aggregate = {
  __typename?: 'weather_location_aggregate';
  aggregate?: Maybe<Weather_Location_Aggregate_Fields>;
  nodes: Array<Weather_Location>;
};

/** aggregate fields of "weather_location" */
export type Weather_Location_Aggregate_Fields = {
  __typename?: 'weather_location_aggregate_fields';
  avg?: Maybe<Weather_Location_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Weather_Location_Max_Fields>;
  min?: Maybe<Weather_Location_Min_Fields>;
  stddev?: Maybe<Weather_Location_Stddev_Fields>;
  stddev_pop?: Maybe<Weather_Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Weather_Location_Stddev_Samp_Fields>;
  sum?: Maybe<Weather_Location_Sum_Fields>;
  var_pop?: Maybe<Weather_Location_Var_Pop_Fields>;
  var_samp?: Maybe<Weather_Location_Var_Samp_Fields>;
  variance?: Maybe<Weather_Location_Variance_Fields>;
};


/** aggregate fields of "weather_location" */
export type Weather_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Weather_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Weather_Location_Avg_Fields = {
  __typename?: 'weather_location_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  elevation?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "weather_location". All fields are combined with a logical 'AND'. */
export type Weather_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Weather_Location_Bool_Exp>>;
  _not?: InputMaybe<Weather_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Weather_Location_Bool_Exp>>;
  actual_readings?: InputMaybe<Actual_Reading_Bool_Exp>;
  address_line1?: InputMaybe<String_Comparison_Exp>;
  address_line2?: InputMaybe<String_Comparison_Exp>;
  city_village?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  daily_actual_readings?: InputMaybe<Daily_Actual_Reading_Bool_Exp>;
  daily_forecast_readings?: InputMaybe<Daily_Forecast_Reading_Bool_Exp>;
  elevation?: InputMaybe<Float8_Comparison_Exp>;
  forecast_readings?: InputMaybe<Forecast_Reading_Bool_Exp>;
  gateways?: InputMaybe<Gateway_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inst_readings?: InputMaybe<Inst_Sensor_Reading_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  loc_desc?: InputMaybe<String_Comparison_Exp>;
  post_code?: InputMaybe<String_Comparison_Exp>;
  region_county?: InputMaybe<String_Comparison_Exp>;
  sensors?: InputMaybe<Sensor_Bool_Exp>;
  state_province?: InputMaybe<String_Comparison_Exp>;
  sub_region?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Location_Subscription_Bool_Exp>;
  summary_readings?: InputMaybe<Summary_Sensor_Reading_Bool_Exp>;
  time_zone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "weather_location" */
export enum Weather_Location_Constraint {
  /** unique or primary key constraint on columns "geom" */
  WeatherLocationGeomKey = 'weather_location_geom_key',
  /** unique or primary key constraint on columns "id" */
  WeatherLocationPkey = 'weather_location_pkey'
}

/** input type for incrementing numeric columns in table "weather_location" */
export type Weather_Location_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']>;
  elevation?: InputMaybe<Scalars['float8']>;
  updated_by_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "weather_location" */
export type Weather_Location_Insert_Input = {
  actual_readings?: InputMaybe<Actual_Reading_Arr_Rel_Insert_Input>;
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['bigint']>;
  daily_actual_readings?: InputMaybe<Daily_Actual_Reading_Arr_Rel_Insert_Input>;
  daily_forecast_readings?: InputMaybe<Daily_Forecast_Reading_Arr_Rel_Insert_Input>;
  elevation?: InputMaybe<Scalars['float8']>;
  forecast_readings?: InputMaybe<Forecast_Reading_Arr_Rel_Insert_Input>;
  gateways?: InputMaybe<Gateway_Arr_Rel_Insert_Input>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['uuid']>;
  inst_readings?: InputMaybe<Inst_Sensor_Reading_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  sensors?: InputMaybe<Sensor_Arr_Rel_Insert_Input>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
  subscriptions?: InputMaybe<Location_Subscription_Arr_Rel_Insert_Input>;
  summary_readings?: InputMaybe<Summary_Sensor_Reading_Arr_Rel_Insert_Input>;
  time_zone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Weather_Location_Max_Fields = {
  __typename?: 'weather_location_max_fields';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['bigint']>;
  elevation?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  loc_desc?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
  time_zone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Weather_Location_Min_Fields = {
  __typename?: 'weather_location_min_fields';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city_village?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['bigint']>;
  elevation?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  loc_desc?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  region_county?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  sub_region?: Maybe<Scalars['String']>;
  time_zone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "weather_location" */
export type Weather_Location_Mutation_Response = {
  __typename?: 'weather_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Weather_Location>;
};

/** input type for inserting object relation for remote table "weather_location" */
export type Weather_Location_Obj_Rel_Insert_Input = {
  data: Weather_Location_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Weather_Location_On_Conflict>;
};

/** on_conflict condition type for table "weather_location" */
export type Weather_Location_On_Conflict = {
  constraint: Weather_Location_Constraint;
  update_columns?: Array<Weather_Location_Update_Column>;
  where?: InputMaybe<Weather_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "weather_location". */
export type Weather_Location_Order_By = {
  actual_readings_aggregate?: InputMaybe<Actual_Reading_Aggregate_Order_By>;
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_village?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  daily_actual_readings_aggregate?: InputMaybe<Daily_Actual_Reading_Aggregate_Order_By>;
  daily_forecast_readings_aggregate?: InputMaybe<Daily_Forecast_Reading_Aggregate_Order_By>;
  elevation?: InputMaybe<Order_By>;
  forecast_readings_aggregate?: InputMaybe<Forecast_Reading_Aggregate_Order_By>;
  gateways_aggregate?: InputMaybe<Gateway_Aggregate_Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inst_readings_aggregate?: InputMaybe<Inst_Sensor_Reading_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  loc_desc?: InputMaybe<Order_By>;
  post_code?: InputMaybe<Order_By>;
  region_county?: InputMaybe<Order_By>;
  sensors_aggregate?: InputMaybe<Sensor_Aggregate_Order_By>;
  state_province?: InputMaybe<Order_By>;
  sub_region?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Location_Subscription_Aggregate_Order_By>;
  summary_readings_aggregate?: InputMaybe<Summary_Sensor_Reading_Aggregate_Order_By>;
  time_zone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: weather_location */
export type Weather_Location_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "weather_location" */
export enum Weather_Location_Select_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  CityVillage = 'city_village',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Elevation = 'elevation',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocDesc = 'loc_desc',
  /** column name */
  PostCode = 'post_code',
  /** column name */
  RegionCounty = 'region_county',
  /** column name */
  StateProvince = 'state_province',
  /** column name */
  SubRegion = 'sub_region',
  /** column name */
  TimeZone = 'time_zone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "weather_location" */
export type Weather_Location_Set_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['bigint']>;
  elevation?: InputMaybe<Scalars['float8']>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
  time_zone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Weather_Location_Stddev_Fields = {
  __typename?: 'weather_location_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  elevation?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Weather_Location_Stddev_Pop_Fields = {
  __typename?: 'weather_location_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  elevation?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Weather_Location_Stddev_Samp_Fields = {
  __typename?: 'weather_location_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  elevation?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "weather_location" */
export type Weather_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weather_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weather_Location_Stream_Cursor_Value_Input = {
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  city_village?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['bigint']>;
  elevation?: InputMaybe<Scalars['float8']>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  loc_desc?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  region_county?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  sub_region?: InputMaybe<Scalars['String']>;
  time_zone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Weather_Location_Sum_Fields = {
  __typename?: 'weather_location_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']>;
  elevation?: Maybe<Scalars['float8']>;
  updated_by_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "weather_location" */
export enum Weather_Location_Update_Column {
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  CityVillage = 'city_village',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Elevation = 'elevation',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocDesc = 'loc_desc',
  /** column name */
  PostCode = 'post_code',
  /** column name */
  RegionCounty = 'region_county',
  /** column name */
  StateProvince = 'state_province',
  /** column name */
  SubRegion = 'sub_region',
  /** column name */
  TimeZone = 'time_zone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Weather_Location_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Weather_Location_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Weather_Location_Set_Input>;
  where: Weather_Location_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Weather_Location_Var_Pop_Fields = {
  __typename?: 'weather_location_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  elevation?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Weather_Location_Var_Samp_Fields = {
  __typename?: 'weather_location_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  elevation?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Weather_Location_Variance_Fields = {
  __typename?: 'weather_location_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  elevation?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "weather_reference" */
export type Weather_Reference = {
  __typename?: 'weather_reference';
  codename: Scalars['String'];
  description: Scalars['String'];
  /** An array relationship */
  field_weather_locations: Array<Field_Weather_Location>;
  /** An aggregate relationship */
  field_weather_locations_aggregate: Field_Weather_Location_Aggregate;
  geom: Scalars['geometry'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};


/** columns and relationships of "weather_reference" */
export type Weather_ReferenceField_Weather_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


/** columns and relationships of "weather_reference" */
export type Weather_ReferenceField_Weather_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};

/** aggregated selection of "weather_reference" */
export type Weather_Reference_Aggregate = {
  __typename?: 'weather_reference_aggregate';
  aggregate?: Maybe<Weather_Reference_Aggregate_Fields>;
  nodes: Array<Weather_Reference>;
};

/** aggregate fields of "weather_reference" */
export type Weather_Reference_Aggregate_Fields = {
  __typename?: 'weather_reference_aggregate_fields';
  avg?: Maybe<Weather_Reference_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Weather_Reference_Max_Fields>;
  min?: Maybe<Weather_Reference_Min_Fields>;
  stddev?: Maybe<Weather_Reference_Stddev_Fields>;
  stddev_pop?: Maybe<Weather_Reference_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Weather_Reference_Stddev_Samp_Fields>;
  sum?: Maybe<Weather_Reference_Sum_Fields>;
  var_pop?: Maybe<Weather_Reference_Var_Pop_Fields>;
  var_samp?: Maybe<Weather_Reference_Var_Samp_Fields>;
  variance?: Maybe<Weather_Reference_Variance_Fields>;
};


/** aggregate fields of "weather_reference" */
export type Weather_Reference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Weather_Reference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Weather_Reference_Avg_Fields = {
  __typename?: 'weather_reference_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "weather_reference". All fields are combined with a logical 'AND'. */
export type Weather_Reference_Bool_Exp = {
  _and?: InputMaybe<Array<Weather_Reference_Bool_Exp>>;
  _not?: InputMaybe<Weather_Reference_Bool_Exp>;
  _or?: InputMaybe<Array<Weather_Reference_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  field_weather_locations?: InputMaybe<Field_Weather_Location_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "weather_reference" */
export enum Weather_Reference_Constraint {
  /** unique or primary key constraint on columns "codename" */
  WeatherReferenceCodenameKey = 'weather_reference_codename_key',
  /** unique or primary key constraint on columns "geom" */
  WeatherReferenceGeomKey = 'weather_reference_geom_key',
  /** unique or primary key constraint on columns "id" */
  WeatherReferencePkey = 'weather_reference_pkey'
}

/** input type for incrementing numeric columns in table "weather_reference" */
export type Weather_Reference_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "weather_reference" */
export type Weather_Reference_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  field_weather_locations?: InputMaybe<Field_Weather_Location_Arr_Rel_Insert_Input>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Weather_Reference_Max_Fields = {
  __typename?: 'weather_reference_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Weather_Reference_Min_Fields = {
  __typename?: 'weather_reference_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "weather_reference" */
export type Weather_Reference_Mutation_Response = {
  __typename?: 'weather_reference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Weather_Reference>;
};

/** input type for inserting object relation for remote table "weather_reference" */
export type Weather_Reference_Obj_Rel_Insert_Input = {
  data: Weather_Reference_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Weather_Reference_On_Conflict>;
};

/** on_conflict condition type for table "weather_reference" */
export type Weather_Reference_On_Conflict = {
  constraint: Weather_Reference_Constraint;
  update_columns?: Array<Weather_Reference_Update_Column>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};

/** Ordering options when selecting data from "weather_reference". */
export type Weather_Reference_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  field_weather_locations_aggregate?: InputMaybe<Field_Weather_Location_Aggregate_Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: weather_reference */
export type Weather_Reference_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "weather_reference" */
export enum Weather_Reference_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "weather_reference" */
export type Weather_Reference_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Weather_Reference_Stddev_Fields = {
  __typename?: 'weather_reference_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Weather_Reference_Stddev_Pop_Fields = {
  __typename?: 'weather_reference_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Weather_Reference_Stddev_Samp_Fields = {
  __typename?: 'weather_reference_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "weather_reference" */
export type Weather_Reference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weather_Reference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weather_Reference_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Weather_Reference_Sum_Fields = {
  __typename?: 'weather_reference_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "weather_reference" */
export enum Weather_Reference_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Weather_Reference_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Weather_Reference_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Weather_Reference_Set_Input>;
  where: Weather_Reference_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Weather_Reference_Var_Pop_Fields = {
  __typename?: 'weather_reference_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Weather_Reference_Var_Samp_Fields = {
  __typename?: 'weather_reference_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Weather_Reference_Variance_Fields = {
  __typename?: 'weather_reference_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type AgentLoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type AgentLoginMutation = { __typename?: 'mutation_root', agent_login?: { __typename?: 'AgentLogin', token: string, refresh_token: string, me?: { __typename?: 'BaseUserType', id: string, full_name?: string | null, agent?: { __typename?: 'AgentType', id: string, name: string, eid: string, organisation: { __typename?: 'OrganisationType', id: string, codename: string, uid?: string | null, name: string } } | null } | null } | null };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshTokenMutation = { __typename?: 'mutation_root', refresh_token?: { __typename?: 'Refresh', token: string, refresh_token: string } | null };

export type AuthenticatedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthenticatedUserQuery = { __typename?: 'query_root', me?: { __typename?: 'BaseUserType', id: string, permissions?: Array<string | null> | null, is_verified?: boolean | null, first_name: string, last_name: string, full_name?: string | null, email: string, number: string, agent?: { __typename?: 'AgentType', id: string, current_department?: { __typename?: 'DepartmentType', id: string, name: string, codename: string } | null, departments?: Array<{ __typename?: 'AgentDepartmentType', department?: { __typename?: 'DepartmentType', id: string, name: string, codename: string } | null } | null> | null, organisation: { __typename?: 'OrganisationType', id: string, uid?: string | null, name: string } } | null, photo?: { __typename?: 'MediaType', id: string, url: string } | null, current_department?: { __typename?: 'DepartmentType', id: string, name: string, codename: string } | null, companies: Array<{ __typename?: 'CompanyType', id: string, name: string, codename: string }> } | null };

export type BaseUserDisplayFragFragment = { __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null };

export type BaseUserFragFragment = { __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null };

export type UsersQueryVariables = Exact<{
  group?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type UsersQuery = { __typename?: 'query_root', base_user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> };

export type ExpenseFragFragment = { __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } };

export type DeleteExpenseItemMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['bigint']> | Scalars['bigint']>;
}>;


export type DeleteExpenseItemMutation = { __typename?: 'mutation_root', delete_expense?: { __typename?: 'expense_mutation_response', returning: Array<{ __typename?: 'expense', id: any, trade?: { __typename?: 'trade', id: any, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }> } | null }> } | null };

export type AllInvoicesQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Invoice_Select_Column> | Invoice_Select_Column>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By> | Invoice_Order_By>;
  where?: InputMaybe<Invoice_Bool_Exp>;
}>;


export type AllInvoicesQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', id: any, tracking_code: string, total_amount?: any | null, total_quantity?: any | null, created_at: any, updated_at: any, current_status_id?: string | null, created_by?: { __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> } | null, unit: Array<{ __typename?: 'trade', id: any, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string } }> }>, trades: Array<{ __typename?: 'trade', id: any, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> } | null }> }>, invoice_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', count: number } | null } };

export type GenerateInvoicesMutationVariables = Exact<{
  department_id?: InputMaybe<Scalars['ID']>;
  trade_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GenerateInvoicesMutation = { __typename?: 'mutation_root', generate_invoices?: { __typename?: 'GenerateInvoiceMutation', invoices?: Array<{ __typename?: 'InvoiceType', id: string } | null> | null } | null };

export type BulkUpdateInvoiceMutationVariables = Exact<{
  where: Invoice_Bool_Exp;
  set: Invoice_Set_Input;
}>;


export type BulkUpdateInvoiceMutation = { __typename?: 'mutation_root', update_invoice?: { __typename?: 'invoice_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'invoice', id: any, current_status_id?: string | null }> } | null };

export type InvoicePreviewQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type InvoicePreviewQuery = { __typename?: 'query_root', invoice_by_pk?: { __typename?: 'invoice', id: any, tracking_code: string, standard_deduction?: any | null, expense_amount?: any | null, deducted_amount?: any | null, deducted_quantity?: any | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> } | null, trades: Array<{ __typename?: 'trade', id: any, total_quantity?: any | null, total_amount?: any | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, rate: any, quantity: any, amount?: any | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string } }> }> } | null };

export type TradeMetricsQueryVariables = Exact<{
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['bigint']>;
  parent?: InputMaybe<Bigint_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
}>;


export type TradeMetricsQuery = { __typename?: 'query_root', trade_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number, sum?: { __typename?: 'trade_sum_fields', total_amount?: any | null, total_quantity?: any | null, expense_amount?: any | null } | null } | null } };

export type ReceiptDetailFragFragment = { __typename?: 'receipt', id: any, seller_receivable_amount?: any | null, seller_expense_amount?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, seller_tnc?: string | null, packaging: string, standard_deduction?: any | null, expense_amount?: any | null, buyer_tnc?: string | null, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, deducted_quantity?: any | null, department: { __typename?: 'setu_trade_shared_entity', id: any, reference_id: string }, editable_trades: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null }, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }>, firstTrade: Array<{ __typename?: 'trade', id: any, trade_items: Array<{ __typename?: 'trade_item', id: any, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> }, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> } }> }>, trades: Array<{ __typename?: 'trade', id: any, total_quantity?: any | null, total_amount?: any | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, total_amount?: any | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string }> } | null }> }> };

export type ReceiptDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type ReceiptDetailQuery = { __typename?: 'query_root', receipt_by_pk?: { __typename?: 'receipt', id: any, seller_receivable_amount?: any | null, seller_expense_amount?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, seller_tnc?: string | null, packaging: string, standard_deduction?: any | null, expense_amount?: any | null, buyer_tnc?: string | null, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, deducted_quantity?: any | null, department: { __typename?: 'setu_trade_shared_entity', id: any, reference_id: string }, editable_trades: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null }, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }>, firstTrade: Array<{ __typename?: 'trade', id: any, trade_items: Array<{ __typename?: 'trade_item', id: any, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> }, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> } }> }>, trades: Array<{ __typename?: 'trade', id: any, total_quantity?: any | null, total_amount?: any | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, total_amount?: any | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string }> } | null }> }> } | null };

export type AllReceiptsQueryVariables = Exact<{
  where?: InputMaybe<Receipt_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By> | Receipt_Order_By>;
}>;


export type AllReceiptsQuery = { __typename?: 'query_root', receipt: Array<{ __typename?: 'receipt', id: any, tracking_code: string, created_at: any, total_amount?: any | null, total_quantity?: any | null, kind: string, updated_at: any, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, number: string, external_reference_id?: string | null, current_address?: { __typename?: 'address', id: number, village: string } | null }> } | null, trades: Array<{ __typename?: 'trade', id: any, trade_items: Array<{ __typename?: 'trade_item', rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string } }>, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, number: string, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, current_address?: { __typename?: 'address', id: number, village: string } | null }> } | null }>, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null }>, receipt_aggregate: { __typename?: 'receipt_aggregate', aggregate?: { __typename?: 'receipt_aggregate_fields', count: number } | null } };

export type AddUpdateReceiptMutationVariables = Exact<{
  input?: InputMaybe<ReceiptInput>;
}>;


export type AddUpdateReceiptMutation = { __typename?: 'mutation_root', add_update_receipt?: { __typename?: 'AddUpdateReceipt', receipt: { __typename?: 'ReceiptType', id: string } } | null };

export type KiteCommodityFragFragment = { __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null };

export type KiteCommodityVarietyFragFragment = { __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null };

export type AddUpdateSharedEntityMutationVariables = Exact<{
  reference_id?: InputMaybe<Scalars['String']>;
  group_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type AddUpdateSharedEntityMutation = { __typename?: 'mutation_root', insert_setu_trade_shared_entity_one?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string, group_name: string } | null };

export type AllCommoditiesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type AllCommoditiesQuery = { __typename?: 'query_root', commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> };

export type AllVarietiesQueryVariables = Exact<{
  commodity_id?: InputMaybe<Scalars['Int']>;
}>;


export type AllVarietiesQuery = { __typename?: 'query_root', commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null }> };

export type AllPlotCropsQueryVariables = Exact<{
  farmer?: InputMaybe<Scalars['Int']>;
  crop?: InputMaybe<Scalars['Int']>;
}>;


export type AllPlotCropsQuery = { __typename?: 'query_root', plot_crop: Array<{ __typename?: 'plot_crop', id: number, tag: string, name: string, codename: string, external_reference_id?: string | null }> };

export type AllVarietyGradesQueryVariables = Exact<{
  variety?: InputMaybe<Scalars['Int']>;
}>;


export type AllVarietyGradesQuery = { __typename?: 'query_root', variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string, codename: string }> };

export type AllSiUnitsQueryVariables = Exact<{
  type?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AllSiUnitsQuery = { __typename?: 'query_root', si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> };

export type GetSharedEntityQueryVariables = Exact<{
  codename?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
}>;


export type GetSharedEntityQuery = { __typename?: 'query_root', setu_trade_shared_entity: Array<{ __typename?: 'setu_trade_shared_entity', id: any, name: string }> };

export type ExpenseParametersQueryVariables = Exact<{
  codename?: InputMaybe<Scalars['String']>;
}>;


export type ExpenseParametersQuery = { __typename?: 'query_root', expense_parameter: Array<{ __typename?: 'expense_parameter', id: any, name: string }> };

export type CreateExpensesTemplatesMutationVariables = Exact<{
  department: Scalars['Int'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  expenses: Array<InputMaybe<ExpensesConfigSchema>> | InputMaybe<ExpensesConfigSchema>;
}>;


export type CreateExpensesTemplatesMutation = { __typename?: 'mutation_root', create_expenses_config?: { __typename?: 'CreateExpenseConfigMutation', version?: number | null, department_id?: number | null, trade_kind?: string | null, trade_mode?: string | null, expenses_details?: Array<{ __typename?: 'OrganisationTradeExpensesTemplateSchema', expense_parameter?: string | null, kind?: string | null, buyer_charge?: any | null, seller_charge?: any | null } | null> | null } | null };

export type CreateTnCsConfigMutationVariables = Exact<{
  department: Scalars['Int'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  terms: Scalars['String'];
  party: Scalars['String'];
}>;


export type CreateTnCsConfigMutation = { __typename?: 'mutation_root', create_tnc_config?: { __typename?: 'CreateTNCConfigMutation', version?: number | null, trade_party?: string | null, conditions?: string | null } | null };

export type TimelineQueryVariables = Exact<{
  tradeId: Scalars['bigint'];
}>;


export type TimelineQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, tracking_code: string, total_amount?: any | null, action_logs: Array<{ __typename?: 'trade_action_log', id: any, created_at: any, change_object?: any | null, change_message: string, change_title: string, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null }>, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, current_address?: { __typename?: 'address', id: number, village: string } | null }> } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, current_address?: { __typename?: 'address', id: number, village: string } | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null } | null };

export type TradeDetailFragFragment = { __typename?: 'trade', id: any, receipt_id?: any | null, standard_deduction?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, packaging: string, seller_tnc?: string | null, buyer_tnc?: string | null, seller_verification?: boolean | null, buyer_verification?: boolean | null, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, expense_amount?: any | null, department: { __typename?: 'setu_trade_shared_entity', id: any, reference_id: string }, parent_trade?: { __typename?: 'trade', id: any, kind: string, start_date?: any | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> }, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string, codename: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> } }>, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }> };

export type TradeHashesQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type TradeHashesQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, seller_hash?: string | null, buyer_hash?: string | null } | null };

export type AllTradeRequestsQueryVariables = Exact<{
  where?: InputMaybe<Trade_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By> | Trade_Order_By>;
}>;


export type AllTradeRequestsQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', id: any, receipt_id?: any | null, tracking_code: string, created_at: any, kind: string, seller_verification?: boolean | null, buyer_verification?: boolean | null, total_amount?: any | null, total_quantity?: any | null, expense_amount?: any | null, standard_deduction?: any | null, current_status_id?: string | null, updated_at: any, invoice?: { __typename?: 'invoice', id: any, current_status_id?: string | null } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, number: string, external_reference_id?: string | null, current_address?: { __typename?: 'address', id: number, village: string } | null }> } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id?: string | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, item_units: Array<{ __typename?: 'trade_item', id: any, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string } }>, trade_items: Array<{ __typename?: 'trade_item', id: any, rate: any, quantity: any, amount?: any | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null }>, trade_items_aggregate: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', quantity?: any | null } | null, avg?: { __typename?: 'trade_item_avg_fields', rate?: number | null } | null } | null }, created_by: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> }>, trade_statuses: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number, min?: { __typename?: 'trade_min_fields', current_status_id?: string | null } | null } | null }, trade_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null } };

export type UpsertTradeMutationVariables = Exact<{
  input: Trade_Insert_Input;
}>;


export type UpsertTradeMutation = { __typename?: 'mutation_root', insert_trade_one?: { __typename?: 'trade', id: any, receipt_id?: any | null, standard_deduction?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, packaging: string, seller_tnc?: string | null, buyer_tnc?: string | null, seller_verification?: boolean | null, buyer_verification?: boolean | null, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, expense_amount?: any | null, department: { __typename?: 'setu_trade_shared_entity', id: any, reference_id: string }, parent_trade?: { __typename?: 'trade', id: any, kind: string, start_date?: any | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> }, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string, codename: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> } }>, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }> } | null };

export type BroadcastConsentMutationVariables = Exact<{
  trade_id: Scalars['ID'];
  send_to_buyer?: InputMaybe<Scalars['Boolean']>;
  send_to_seller?: InputMaybe<Scalars['Boolean']>;
}>;


export type BroadcastConsentMutation = { __typename?: 'mutation_root', broadcast_consents?: { __typename?: 'BroadcastConsents', buyer_status?: boolean | null, seller_status?: boolean | null } | null };

export type TradeDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type TradeDetailQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, receipt_id?: any | null, standard_deduction?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, packaging: string, seller_tnc?: string | null, buyer_tnc?: string | null, seller_verification?: boolean | null, buyer_verification?: boolean | null, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, expense_amount?: any | null, department: { __typename?: 'setu_trade_shared_entity', id: any, reference_id: string }, parent_trade?: { __typename?: 'trade', id: any, kind: string, start_date?: any | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> }, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string, codename: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> } }>, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }> } | null };

export type DeleteTradeItemMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteTradeItemMutation = { __typename?: 'mutation_root', delete_trade_item_by_pk?: { __typename?: 'trade_item', id: any, trade: { __typename?: 'trade', id: any, trade_items: Array<{ __typename?: 'trade_item', id: any }> } } | null };

export type UpdateTradeMutationVariables = Exact<{
  id: Scalars['bigint'];
  _set?: InputMaybe<Trade_Set_Input>;
}>;


export type UpdateTradeMutation = { __typename?: 'mutation_root', update_trade_by_pk?: { __typename?: 'trade', id: any, receipt_id?: any | null, standard_deduction?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, packaging: string, seller_tnc?: string | null, buyer_tnc?: string | null, seller_verification?: boolean | null, buyer_verification?: boolean | null, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, expense_amount?: any | null, department: { __typename?: 'setu_trade_shared_entity', id: any, reference_id: string }, parent_trade?: { __typename?: 'trade', id: any, kind: string, start_date?: any | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id?: string | null, is_verified?: boolean | null, codename: string, name?: string | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, codename: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> }, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string, codename: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string }> } }>, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }> } | null };

export type IncrementTradeCounterMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type IncrementTradeCounterMutation = { __typename?: 'mutation_root', update_trade_by_pk?: { __typename?: 'trade', id: any, trade_amounts_counter: number } | null };

export type FinalTradeListQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['bigint']>;
}>;


export type FinalTradeListQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', id: any, start_date?: any | null, parent_trade?: { __typename?: 'trade', id: any, kind: string, start_date?: any | null } | null }> };

export type BulkUpdateTradeMutationVariables = Exact<{
  where: Trade_Bool_Exp;
  set: Trade_Set_Input;
}>;


export type BulkUpdateTradeMutation = { __typename?: 'mutation_root', update_trade?: { __typename?: 'trade_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'trade', id: any, current_status_id?: string | null }> } | null };

export type BookingTradeSummaryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type BookingTradeSummaryQuery = { __typename?: 'query_root', trade_grade_quantity_summary_report?: { __typename?: 'TradeGradeSummaryReportSchema', more_trade?: boolean | null, grade_summary?: Array<{ __typename?: 'TradeGradeSummarySchema', variety_grade_id?: number | null, remaining_quantity?: number | null, booked_quantity?: number | null, variety_grade_name?: string | null } | null> | null } | null };

export type ExpenseConfigVersionsQueryVariables = Exact<{
  department?: InputMaybe<Scalars['ID']>;
  kind: Scalars['String'];
  mode: Scalars['String'];
}>;


export type ExpenseConfigVersionsQuery = { __typename?: 'query_root', expense_config_versions?: Array<{ __typename?: 'OrganisationTradeExpensesVersionSchema', version_id?: number | null, name?: string | null, kind?: string | null, mode?: string | null } | null> | null };

export type ExpenseConfigsQueryVariables = Exact<{
  version?: InputMaybe<Scalars['ID']>;
  department: Scalars['ID'];
  kind: Scalars['String'];
  mode: Scalars['String'];
}>;


export type ExpenseConfigsQuery = { __typename?: 'query_root', expense_configs?: Array<{ __typename?: 'OrganisationTradeExpenseConfigType', id: string, paid_by?: string | null, kind?: string | null, value: any, expense_parameter: { __typename?: 'ExpenseParameterType', id: string, name: string } } | null> | null };

export type TradeStatusesQueryVariables = Exact<{
  where?: InputMaybe<Trade_Status_Bool_Exp>;
}>;


export type TradeStatusesQuery = { __typename?: 'query_root', trade_status: Array<{ __typename?: 'trade_status', id: string }> };

export type TncConfigVersionsQueryVariables = Exact<{
  department?: InputMaybe<Scalars['ID']>;
  kind: Scalars['String'];
  mode: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
}>;


export type TncConfigVersionsQuery = { __typename?: 'query_root', trade_tnc_versions?: Array<{ __typename?: 'OrganisationTradeTNCsVersionSchema', name?: string | null, kind?: string | null, mode?: string | null, role?: string | null, id?: number | null } | null> | null };

export type TncConfigsQueryVariables = Exact<{
  version: Scalars['ID'];
  department: Scalars['ID'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
}>;


export type TncConfigsQuery = { __typename?: 'query_root', trade_tnc_template_detail?: { __typename?: 'OrganisationTradeTNCsTemplateSchema', seller?: string | null, buyer?: string | null } | null };

export type PavtiTradeDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type PavtiTradeDetailQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, created_at: any, tracking_code: string, kind: string, buyer_verification?: boolean | null, seller_verification?: boolean | null, packaging: string, standard_deduction?: any | null, total_amount?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, seller_tnc?: string | null, buyer_tnc?: string | null, created_by: Array<{ __typename?: 'base_user', full_name?: string | null, number: string }>, facilitator?: { __typename?: 'setu_trade_shared_entity', name: string } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, plot_crop: Array<{ __typename?: 'plot_crop', id: number, plot: { __typename?: 'plot', id: number, field: { __typename?: 'field', id: number, address?: { __typename?: 'address', id: number, raw_address?: string | null } | null } } }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, amount?: any | null, currency: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string } }>, trade_items_aggregate: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', quantity?: any | null } | null } | null }, buyer_expenses: { __typename?: 'expense_aggregate', aggregate?: { __typename?: 'expense_aggregate_fields', sum?: { __typename?: 'expense_sum_fields', amount?: any | null } | null } | null, nodes: Array<{ __typename?: 'expense', kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }> }, seller_expenses: { __typename?: 'expense_aggregate', aggregate?: { __typename?: 'expense_aggregate_fields', sum?: { __typename?: 'expense_sum_fields', amount?: any | null } | null } | null, nodes: Array<{ __typename?: 'expense', kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }> } } | null };

export type TradeDetailsSubscriptionVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type TradeDetailsSubscription = { __typename?: 'subscription_root', trade_by_pk?: { __typename?: 'trade', id: any, seller_verification?: boolean | null, seller_remark?: string | null, buyer_verification?: boolean | null, buyer_remark?: string | null } | null };

export type UpdateTradeVerificationMutationVariables = Exact<{
  id: Scalars['bigint'];
  set?: InputMaybe<Trade_Set_Input>;
}>;


export type UpdateTradeVerificationMutation = { __typename?: 'mutation_root', update_trade_by_pk?: { __typename?: 'trade', id: any } | null };

export type GenerateTradeOtpMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type GenerateTradeOtpMutation = { __typename?: 'mutation_root', generate_trade_otp?: { __typename?: 'GenerateTradeOTP', status?: boolean | null } | null };

export type VerifyTradeOtpMutationVariables = Exact<{
  token: Scalars['String'];
  otp: Scalars['String'];
}>;


export type VerifyTradeOtpMutation = { __typename?: 'mutation_root', verify_trade_otp?: { __typename?: 'VerifyTradeOTP', token?: string | null, refresh_token?: string | null, refresh_expires_in?: number | null, payload?: any | null } | null };

export const BaseUserDisplayFragFragmentDoc = gql`
    fragment BaseUserDisplayFrag on base_user {
  id
  reference_id
  full_name
  external_reference_id
  photo {
    id
    url
  }
}
    `;
export const BaseUserFragFragmentDoc = gql`
    fragment BaseUserFrag on base_user {
  id
  codename: reference_id
  name: full_name
  number
  external_reference_id
  is_verified
  companies {
    id
    company {
      id
      name
      codename
    }
  }
  current_address {
    id
    raw_address
  }
}
    `;
export const KiteCommodityFragFragmentDoc = gql`
    fragment KiteCommodityFrag on commodity {
  id
  name
  codename
  crop_id
}
    `;
export const KiteCommodityVarietyFragFragmentDoc = gql`
    fragment KiteCommodityVarietyFrag on commodity_variety {
  id
  name
  codename
  crop_variety_id
}
    `;
export const ExpenseFragFragmentDoc = gql`
    fragment ExpenseFrag on expense {
  id
  paid_by
  expense_parameter {
    id
    name
  }
  kind
  value
  amount
}
    `;
export const ReceiptDetailFragFragmentDoc = gql`
    fragment ReceiptDetailFrag on receipt {
  id
  seller_receivable_amount
  seller_expense_amount
  department {
    id
    reference_id
  }
  editable_trades: trades_aggregate(
    where: {current_status: {is_data_editable: {_eq: false}}}
  ) {
    aggregate {
      count
    }
  }
  seller {
    id
    user {
      ...BaseUserFrag
    }
  }
  commodity {
    id
    commodity {
      ...KiteCommodityFrag
    }
  }
  commodity_variety {
    id
    commodity_variety {
      ...KiteCommodityVarietyFrag
    }
  }
  facilitator {
    id
    facilitator {
      id
      name
      codename
    }
  }
  plot_crop {
    id
    plot_crop {
      id
      external_reference_id
      tag
      name
      codename
    }
  }
  start_date
  end_date
  expiry
  seller_tnc
  packaging
  standard_deduction
  expense_amount
  buyer_tnc
  mode
  kind
  expenses {
    ...ExpenseFrag
  }
  firstTrade: trades(limit: 1) {
    id
    trade_items(limit: 1) {
      id
      rate_unit {
        id
        si_unit {
          id
          name
          codename
        }
      }
      quantity_unit {
        id
        si_unit {
          id
          name
          codename
        }
      }
    }
  }
  total_amount
  total_quantity
  deducted_amount
  deducted_quantity
  trades {
    id
    total_quantity
    total_amount
    buyer {
      id
      user {
        ...BaseUserFrag
      }
    }
    trade_items {
      id
      quantity
      rate
      total_amount: amount
      variety_grade {
        id
        variety_grade {
          id
          name
        }
      }
    }
  }
}
    ${BaseUserFragFragmentDoc}
${KiteCommodityFragFragmentDoc}
${KiteCommodityVarietyFragFragmentDoc}
${ExpenseFragFragmentDoc}`;
export const TradeDetailFragFragmentDoc = gql`
    fragment TradeDetailFrag on trade {
  id
  receipt_id
  department {
    id
    reference_id
  }
  parent_trade {
    id
    kind
    start_date
  }
  buyer {
    id
    user {
      ...BaseUserFrag
    }
  }
  seller {
    id
    user {
      ...BaseUserFrag
    }
  }
  commodity {
    id
    commodity {
      ...KiteCommodityFrag
    }
  }
  commodity_variety {
    id
    commodity_variety {
      ...KiteCommodityVarietyFrag
    }
  }
  facilitator {
    id
    facilitator {
      id
      name
      codename
    }
  }
  plot_crop {
    id
    plot_crop {
      id
      external_reference_id
      tag
      name
      codename
    }
  }
  standard_deduction
  start_date
  end_date
  expiry
  packaging
  seller_tnc
  buyer_tnc
  seller_verification
  buyer_verification
  mode
  kind
  total_amount
  total_quantity
  expense_amount
  trade_items {
    id
    quantity
    quantity_unit {
      id
      si_unit {
        id
        name
        codename
      }
    }
    variety_grade {
      id
      variety_grade {
        id
        name
        codename
      }
    }
    rate
    rate_unit {
      id
      si_unit {
        id
        name
        codename
      }
    }
  }
  expenses {
    ...ExpenseFrag
  }
}
    ${BaseUserFragFragmentDoc}
${KiteCommodityFragFragmentDoc}
${KiteCommodityVarietyFragFragmentDoc}
${ExpenseFragFragmentDoc}`;
export const AgentLoginDocument = gql`
    mutation AgentLogin($username: String!, $password: String!) {
  agent_login(username: $username, password: $password) {
    token
    refresh_token
    me {
      id
      full_name
      agent {
        id
        name
        eid
        organisation {
          id
          codename
          uid
          name
        }
      }
    }
  }
}
    `;

export function useAgentLoginMutation() {
  return Urql.useMutation<AgentLoginMutation, AgentLoginMutationVariables>(AgentLoginDocument);
};
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refresh_token(refresh_token: $refreshToken) {
    token
    refresh_token
  }
}
    `;

export function useRefreshTokenMutation() {
  return Urql.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument);
};
export const AuthenticatedUserDocument = gql`
    query AuthenticatedUser {
  me {
    id
    permissions
    agent {
      id
      current_department {
        id
        name
        codename
      }
      departments {
        department {
          id
          name
          codename
        }
      }
      organisation {
        id
        uid
        name
      }
    }
    is_verified
    first_name
    last_name
    full_name
    email
    number
    photo {
      id
      url
    }
    current_department {
      id
      name
      codename
    }
    companies {
      id
      name
      codename
    }
  }
}
    `;

export function useAuthenticatedUserQuery(options?: Omit<Urql.UseQueryArgs<AuthenticatedUserQueryVariables>, 'query'>) {
  return Urql.useQuery<AuthenticatedUserQuery, AuthenticatedUserQueryVariables>({ query: AuthenticatedUserDocument, ...options });
};
export const UsersDocument = gql`
    query Users($group: String, $query: String) {
  base_user(
    where: {groups: {group: {name: {_eq: $group}}}, _or: [{full_name: {_ilike: $query}}, {number: {_ilike: $query}}]}
    order_by: {full_name: asc_nulls_last}
    limit: 15
  ) {
    ...BaseUserFrag
  }
}
    ${BaseUserFragFragmentDoc}`;

export function useUsersQuery(options?: Omit<Urql.UseQueryArgs<UsersQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersQuery, UsersQueryVariables>({ query: UsersDocument, ...options });
};
export const DeleteExpenseItemDocument = gql`
    mutation DeleteExpenseItem($ids: [bigint!]) {
  delete_expense(where: {id: {_in: $ids}}) {
    returning {
      id
      trade {
        id
        expenses {
          ...ExpenseFrag
        }
      }
    }
  }
}
    ${ExpenseFragFragmentDoc}`;

export function useDeleteExpenseItemMutation() {
  return Urql.useMutation<DeleteExpenseItemMutation, DeleteExpenseItemMutationVariables>(DeleteExpenseItemDocument);
};
export const AllInvoicesDocument = gql`
    query AllInvoices($distinct_on: [invoice_select_column!], $limit: Int, $offset: Int, $order_by: [invoice_order_by!], $where: invoice_bool_exp) {
  invoice(
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    tracking_code
    total_amount
    total_quantity
    created_at
    updated_at
    current_status_id
    created_by {
      ...BaseUserDisplayFrag
    }
    buyer {
      id
      user {
        ...BaseUserDisplayFrag
      }
    }
    unit: trades(limit: 1) {
      id
      trade_items(limit: 1) {
        id
        quantity_unit {
          id
          name
        }
      }
    }
    trades {
      id
      seller {
        id
        user {
          ...BaseUserDisplayFrag
        }
      }
    }
  }
  invoice_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${BaseUserDisplayFragFragmentDoc}`;

export function useAllInvoicesQuery(options?: Omit<Urql.UseQueryArgs<AllInvoicesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllInvoicesQuery, AllInvoicesQueryVariables>({ query: AllInvoicesDocument, ...options });
};
export const GenerateInvoicesDocument = gql`
    mutation GenerateInvoices($department_id: ID, $trade_ids: [ID]) {
  generate_invoices(trade_ids: $trade_ids, department_id: $department_id) {
    invoices {
      id
    }
  }
}
    `;

export function useGenerateInvoicesMutation() {
  return Urql.useMutation<GenerateInvoicesMutation, GenerateInvoicesMutationVariables>(GenerateInvoicesDocument);
};
export const BulkUpdateInvoiceDocument = gql`
    mutation BulkUpdateInvoice($where: invoice_bool_exp!, $set: invoice_set_input!) {
  update_invoice(where: $where, _set: $set) {
    returning {
      id
      current_status_id
    }
    affected_rows
  }
}
    `;

export function useBulkUpdateInvoiceMutation() {
  return Urql.useMutation<BulkUpdateInvoiceMutation, BulkUpdateInvoiceMutationVariables>(BulkUpdateInvoiceDocument);
};
export const InvoicePreviewDocument = gql`
    query InvoicePreview($id: bigint!) {
  invoice_by_pk(id: $id) {
    id
    tracking_code
    standard_deduction
    expense_amount
    deducted_amount
    deducted_quantity
    buyer {
      id
      user {
        ...BaseUserDisplayFrag
      }
    }
    trades {
      id
      seller {
        id
        user {
          ...BaseUserDisplayFrag
        }
      }
      total_quantity
      total_amount
      trade_items(order_by: {variety_grade: {name: asc_nulls_last}}) {
        id
        rate
        quantity
        amount
        variety_grade {
          id
          name
        }
        quantity_unit {
          id
          name
        }
        rate_unit {
          id
          name
        }
      }
    }
  }
}
    ${BaseUserDisplayFragFragmentDoc}`;

export function useInvoicePreviewQuery(options: Omit<Urql.UseQueryArgs<InvoicePreviewQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoicePreviewQuery, InvoicePreviewQueryVariables>({ query: InvoicePreviewDocument, ...options });
};
export const TradeMetricsDocument = gql`
    query TradeMetrics($kind: String, $mode: String, $department: bigint, $parent: bigint_comparison_exp, $date: timestamptz_comparison_exp) {
  trade_aggregate(
    where: {kind: {_eq: $kind}, mode: {_eq: $mode}, department_id: {_eq: $department}, parent_trade_id: $parent, created_at: $date}
  ) {
    aggregate {
      count
      sum {
        total_amount
        total_quantity
        expense_amount
      }
    }
  }
}
    `;

export function useTradeMetricsQuery(options?: Omit<Urql.UseQueryArgs<TradeMetricsQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeMetricsQuery, TradeMetricsQueryVariables>({ query: TradeMetricsDocument, ...options });
};
export const ReceiptDetailDocument = gql`
    query ReceiptDetail($id: bigint!) {
  receipt_by_pk(id: $id) {
    ...ReceiptDetailFrag
  }
}
    ${ReceiptDetailFragFragmentDoc}`;

export function useReceiptDetailQuery(options: Omit<Urql.UseQueryArgs<ReceiptDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ReceiptDetailQuery, ReceiptDetailQueryVariables>({ query: ReceiptDetailDocument, ...options });
};
export const AllReceiptsDocument = gql`
    query AllReceipts($where: receipt_bool_exp, $limit: Int, $offset: Int, $order_by: [receipt_order_by!]) {
  receipt(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
    id
    tracking_code
    created_at
    total_amount
    total_quantity
    kind
    seller {
      id
      user {
        id
        full_name
        number
        external_reference_id
        current_address {
          id
          village
        }
      }
    }
    trades {
      id
      trade_items(limit: 1) {
        rate_unit {
          id
          name
          reference_id
        }
        quantity_unit {
          id
          name
          reference_id
        }
      }
      buyer {
        id
        user {
          id
          full_name
          photo {
            id
            url
          }
          number
          external_reference_id
          current_address {
            id
            village
          }
        }
      }
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    total_amount
    updated_at
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
  }
  receipt_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useAllReceiptsQuery(options?: Omit<Urql.UseQueryArgs<AllReceiptsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllReceiptsQuery, AllReceiptsQueryVariables>({ query: AllReceiptsDocument, ...options });
};
export const AddUpdateReceiptDocument = gql`
    mutation AddUpdateReceipt($input: ReceiptInput) {
  add_update_receipt(input: $input) {
    receipt {
      id
    }
  }
}
    `;

export function useAddUpdateReceiptMutation() {
  return Urql.useMutation<AddUpdateReceiptMutation, AddUpdateReceiptMutationVariables>(AddUpdateReceiptDocument);
};
export const AddUpdateSharedEntityDocument = gql`
    mutation AddUpdateSharedEntity($reference_id: String, $group_name: String, $name: String) {
  insert_setu_trade_shared_entity_one(
    object: {reference_id: $reference_id, group_name: $group_name, name: $name}
    on_conflict: {constraint: shared_entity_group_name_reference_id_4db210e6_uniq, update_columns: [name]}
  ) {
    id
    name
    reference_id
    group_name
  }
}
    `;

export function useAddUpdateSharedEntityMutation() {
  return Urql.useMutation<AddUpdateSharedEntityMutation, AddUpdateSharedEntityMutationVariables>(AddUpdateSharedEntityDocument);
};
export const AllCommoditiesDocument = gql`
    query AllCommodities($query: String) {
  commodity(
    where: {name: {_ilike: $query}}
    order_by: {name: asc_nulls_last}
    limit: 10
  ) {
    ...KiteCommodityFrag
  }
}
    ${KiteCommodityFragFragmentDoc}`;

export function useAllCommoditiesQuery(options?: Omit<Urql.UseQueryArgs<AllCommoditiesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllCommoditiesQuery, AllCommoditiesQueryVariables>({ query: AllCommoditiesDocument, ...options });
};
export const AllVarietiesDocument = gql`
    query AllVarieties($commodity_id: Int) {
  commodity_variety(
    where: {commodity_id: {_eq: $commodity_id}}
    order_by: {name: asc_nulls_last}
  ) {
    ...KiteCommodityVarietyFrag
  }
}
    ${KiteCommodityVarietyFragFragmentDoc}`;

export function useAllVarietiesQuery(options?: Omit<Urql.UseQueryArgs<AllVarietiesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllVarietiesQuery, AllVarietiesQueryVariables>({ query: AllVarietiesDocument, ...options });
};
export const AllPlotCropsDocument = gql`
    query AllPlotCrops($farmer: Int, $crop: Int) {
  plot_crop(
    where: {farmer_id: {_eq: $farmer}, crop_id: {_eq: $crop}}
    order_by: {name: asc_nulls_last}
  ) {
    id
    tag
    name
    codename
    external_reference_id
  }
}
    `;

export function useAllPlotCropsQuery(options?: Omit<Urql.UseQueryArgs<AllPlotCropsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllPlotCropsQuery, AllPlotCropsQueryVariables>({ query: AllPlotCropsDocument, ...options });
};
export const AllVarietyGradesDocument = gql`
    query AllVarietyGrades($variety: Int) {
  variety_grade(
    where: {variety_id: {_eq: $variety}}
    order_by: {name: asc_nulls_last}
  ) {
    id
    name
    codename
  }
}
    `;

export function useAllVarietyGradesQuery(options?: Omit<Urql.UseQueryArgs<AllVarietyGradesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllVarietyGradesQuery, AllVarietyGradesQueryVariables>({ query: AllVarietyGradesDocument, ...options });
};
export const AllSiUnitsDocument = gql`
    query AllSIUnits($type: [String!]) {
  si_unit(where: {measure_of: {name: {_in: $type}}}) {
    id
    name
    codename
  }
}
    `;

export function useAllSiUnitsQuery(options?: Omit<Urql.UseQueryArgs<AllSiUnitsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllSiUnitsQuery, AllSiUnitsQueryVariables>({ query: AllSiUnitsDocument, ...options });
};
export const GetSharedEntityDocument = gql`
    query getSharedEntity($codename: String, $group: String) {
  setu_trade_shared_entity(
    where: {reference_id: {_eq: $codename}, group_name: {_eq: $group}}
  ) {
    id
    name
  }
}
    `;

export function useGetSharedEntityQuery(options?: Omit<Urql.UseQueryArgs<GetSharedEntityQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSharedEntityQuery, GetSharedEntityQueryVariables>({ query: GetSharedEntityDocument, ...options });
};
export const ExpenseParametersDocument = gql`
    query ExpenseParameters($codename: String) {
  expense_parameter {
    id
    name
  }
}
    `;

export function useExpenseParametersQuery(options?: Omit<Urql.UseQueryArgs<ExpenseParametersQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseParametersQuery, ExpenseParametersQueryVariables>({ query: ExpenseParametersDocument, ...options });
};
export const CreateExpensesTemplatesDocument = gql`
    mutation CreateExpensesTemplates($department: Int!, $kind: String!, $mode: String!, $expenses: [ExpensesConfigSchema]!) {
  create_expenses_config(
    department_id: $department
    trade_kind: $kind
    trade_mode: $mode
    expenses_config: $expenses
  ) {
    version
    department_id
    trade_kind
    trade_mode
    expenses_details {
      expense_parameter
      kind
      buyer_charge
      seller_charge
    }
  }
}
    `;

export function useCreateExpensesTemplatesMutation() {
  return Urql.useMutation<CreateExpensesTemplatesMutation, CreateExpensesTemplatesMutationVariables>(CreateExpensesTemplatesDocument);
};
export const CreateTnCsConfigDocument = gql`
    mutation CreateTNCsConfig($department: Int!, $kind: String!, $mode: String!, $terms: String!, $party: String!) {
  create_tnc_config(
    conditions: $terms
    trade_party: $party
    department_id: $department
    trade_kind: $kind
    trade_mode: $mode
  ) {
    version
    trade_party
    conditions
  }
}
    `;

export function useCreateTnCsConfigMutation() {
  return Urql.useMutation<CreateTnCsConfigMutation, CreateTnCsConfigMutationVariables>(CreateTnCsConfigDocument);
};
export const TimelineDocument = gql`
    query Timeline($tradeId: bigint!) {
  trade_by_pk(id: $tradeId) {
    id
    action_logs {
      id
      created_at
      change_object
      change_message
      change_title
      created_by {
        id
        full_name
      }
    }
    tracking_code
    seller {
      id
      user {
        id
        full_name
        current_address {
          id
          village
        }
      }
    }
    buyer {
      id
      user {
        id
        full_name
        current_address {
          id
          village
        }
      }
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    total_amount
  }
}
    `;

export function useTimelineQuery(options: Omit<Urql.UseQueryArgs<TimelineQueryVariables>, 'query'>) {
  return Urql.useQuery<TimelineQuery, TimelineQueryVariables>({ query: TimelineDocument, ...options });
};
export const TradeHashesDocument = gql`
    query TradeHashes($id: bigint!) {
  trade_by_pk(id: $id) {
    id
    seller_hash
    buyer_hash
  }
}
    `;

export function useTradeHashesQuery(options: Omit<Urql.UseQueryArgs<TradeHashesQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeHashesQuery, TradeHashesQueryVariables>({ query: TradeHashesDocument, ...options });
};
export const AllTradeRequestsDocument = gql`
    query AllTradeRequests($where: trade_bool_exp, $limit: Int, $offset: Int, $order_by: [trade_order_by!]) {
  trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
    id
    receipt_id
    invoice {
      id
      current_status_id
    }
    tracking_code
    created_at
    kind
    seller_verification
    buyer_verification
    total_amount
    total_quantity
    expense_amount
    standard_deduction
    seller {
      id
      user {
        id
        full_name
        number
        external_reference_id
        current_address {
          id
          village
        }
      }
    }
    buyer {
      id
      user {
        id
        full_name
        external_reference_id
      }
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    item_units: trade_items(limit: 1) {
      id
      quantity_unit {
        id
        name
        reference_id
      }
      rate_unit {
        id
        name
        reference_id
      }
    }
    trade_items(order_by: {variety_grade: {name: asc_nulls_last}}) {
      id
      rate
      variety_grade {
        id
        name
      }
      quantity
      amount
    }
    trade_items_aggregate {
      aggregate {
        sum {
          quantity
        }
        avg {
          rate
        }
      }
    }
    total_amount
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    current_status_id
    updated_at
  }
  trade_statuses: trade_aggregate(where: $where, distinct_on: [current_status_id]) {
    aggregate {
      count
      min {
        current_status_id
      }
    }
  }
  trade_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useAllTradeRequestsQuery(options?: Omit<Urql.UseQueryArgs<AllTradeRequestsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllTradeRequestsQuery, AllTradeRequestsQueryVariables>({ query: AllTradeRequestsDocument, ...options });
};
export const UpsertTradeDocument = gql`
    mutation UpsertTrade($input: trade_insert_input!) {
  insert_trade_one(
    object: $input
    on_conflict: {constraint: trade_pkey, update_columns: [buyer_id, seller_id, commodity_id, commodity_variety_id, plot_crop_id, packaging, kind, mode, facilitator_id, standard_deduction, start_date, end_date, expiry, seller_tnc, buyer_tnc, department_id]}
  ) {
    ...TradeDetailFrag
  }
}
    ${TradeDetailFragFragmentDoc}`;

export function useUpsertTradeMutation() {
  return Urql.useMutation<UpsertTradeMutation, UpsertTradeMutationVariables>(UpsertTradeDocument);
};
export const BroadcastConsentDocument = gql`
    mutation BroadcastConsent($trade_id: ID!, $send_to_buyer: Boolean, $send_to_seller: Boolean) {
  broadcast_consents(
    trade_id: $trade_id
    send_to_buyer: $send_to_buyer
    send_to_seller: $send_to_seller
  ) {
    buyer_status
    seller_status
  }
}
    `;

export function useBroadcastConsentMutation() {
  return Urql.useMutation<BroadcastConsentMutation, BroadcastConsentMutationVariables>(BroadcastConsentDocument);
};
export const TradeDetailDocument = gql`
    query TradeDetail($id: bigint!) {
  trade_by_pk(id: $id) {
    ...TradeDetailFrag
  }
}
    ${TradeDetailFragFragmentDoc}`;

export function useTradeDetailQuery(options: Omit<Urql.UseQueryArgs<TradeDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeDetailQuery, TradeDetailQueryVariables>({ query: TradeDetailDocument, ...options });
};
export const DeleteTradeItemDocument = gql`
    mutation DeleteTradeItem($id: bigint!) {
  delete_trade_item_by_pk(id: $id) {
    id
    trade {
      id
      trade_items {
        id
      }
    }
  }
}
    `;

export function useDeleteTradeItemMutation() {
  return Urql.useMutation<DeleteTradeItemMutation, DeleteTradeItemMutationVariables>(DeleteTradeItemDocument);
};
export const UpdateTradeDocument = gql`
    mutation UpdateTrade($id: bigint!, $_set: trade_set_input) {
  update_trade_by_pk(pk_columns: {id: $id}, _set: $_set) {
    ...TradeDetailFrag
  }
}
    ${TradeDetailFragFragmentDoc}`;

export function useUpdateTradeMutation() {
  return Urql.useMutation<UpdateTradeMutation, UpdateTradeMutationVariables>(UpdateTradeDocument);
};
export const IncrementTradeCounterDocument = gql`
    mutation IncrementTradeCounter($id: bigint!) {
  update_trade_by_pk(pk_columns: {id: $id}, _inc: {trade_amounts_counter: 1}) {
    id
    trade_amounts_counter
  }
}
    `;

export function useIncrementTradeCounterMutation() {
  return Urql.useMutation<IncrementTradeCounterMutation, IncrementTradeCounterMutationVariables>(IncrementTradeCounterDocument);
};
export const FinalTradeListDocument = gql`
    query FinalTradeList($parentId: bigint) {
  trade(where: {parent_trade_id: {_eq: $parentId}, kind: {_eq: "final"}}) {
    id
    parent_trade {
      id
      kind
      start_date
    }
    start_date
  }
}
    `;

export function useFinalTradeListQuery(options?: Omit<Urql.UseQueryArgs<FinalTradeListQueryVariables>, 'query'>) {
  return Urql.useQuery<FinalTradeListQuery, FinalTradeListQueryVariables>({ query: FinalTradeListDocument, ...options });
};
export const BulkUpdateTradeDocument = gql`
    mutation BulkUpdateTrade($where: trade_bool_exp!, $set: trade_set_input!) {
  update_trade(where: $where, _set: $set) {
    returning {
      id
      current_status_id
    }
    affected_rows
  }
}
    `;

export function useBulkUpdateTradeMutation() {
  return Urql.useMutation<BulkUpdateTradeMutation, BulkUpdateTradeMutationVariables>(BulkUpdateTradeDocument);
};
export const BookingTradeSummaryDocument = gql`
    query BookingTradeSummary($id: Int!) {
  trade_grade_quantity_summary_report(trade_id: $id) {
    more_trade
    grade_summary {
      variety_grade_id
      remaining_quantity
      booked_quantity
      variety_grade_name
    }
  }
}
    `;

export function useBookingTradeSummaryQuery(options: Omit<Urql.UseQueryArgs<BookingTradeSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<BookingTradeSummaryQuery, BookingTradeSummaryQueryVariables>({ query: BookingTradeSummaryDocument, ...options });
};
export const ExpenseConfigVersionsDocument = gql`
    query ExpenseConfigVersions($department: ID, $kind: String!, $mode: String!) {
  expense_config_versions(department: $department, kind: $kind, mode: $mode) {
    version_id
    name
    kind
    mode
  }
}
    `;

export function useExpenseConfigVersionsQuery(options: Omit<Urql.UseQueryArgs<ExpenseConfigVersionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseConfigVersionsQuery, ExpenseConfigVersionsQueryVariables>({ query: ExpenseConfigVersionsDocument, ...options });
};
export const ExpenseConfigsDocument = gql`
    query ExpenseConfigs($version: ID, $department: ID!, $kind: String!, $mode: String!) {
  expense_configs(
    version: $version
    department: $department
    kind: $kind
    mode: $mode
  ) {
    id
    paid_by
    expense_parameter {
      id
      name
    }
    kind
    value
  }
}
    `;

export function useExpenseConfigsQuery(options: Omit<Urql.UseQueryArgs<ExpenseConfigsQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseConfigsQuery, ExpenseConfigsQueryVariables>({ query: ExpenseConfigsDocument, ...options });
};
export const TradeStatusesDocument = gql`
    query TradeStatuses($where: trade_status_bool_exp) {
  trade_status(order_by: {sequence_no: asc}, where: $where) {
    id
  }
}
    `;

export function useTradeStatusesQuery(options?: Omit<Urql.UseQueryArgs<TradeStatusesQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeStatusesQuery, TradeStatusesQueryVariables>({ query: TradeStatusesDocument, ...options });
};
export const TncConfigVersionsDocument = gql`
    query TncConfigVersions($department: ID, $kind: String!, $mode: String!, $role: String) {
  trade_tnc_versions(
    department: $department
    kind: $kind
    mode: $mode
    role: $role
  ) {
    id: version_id
    name
    kind
    mode
    role
  }
}
    `;

export function useTncConfigVersionsQuery(options: Omit<Urql.UseQueryArgs<TncConfigVersionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TncConfigVersionsQuery, TncConfigVersionsQueryVariables>({ query: TncConfigVersionsDocument, ...options });
};
export const TncConfigsDocument = gql`
    query TncConfigs($version: ID!, $department: ID!, $kind: String!, $mode: String!, $role: String) {
  trade_tnc_template_detail(
    version: $version
    department: $department
    kind: $kind
    mode: $mode
    role: $role
  ) {
    seller
    buyer
  }
}
    `;

export function useTncConfigsQuery(options: Omit<Urql.UseQueryArgs<TncConfigsQueryVariables>, 'query'>) {
  return Urql.useQuery<TncConfigsQuery, TncConfigsQueryVariables>({ query: TncConfigsDocument, ...options });
};
export const PavtiTradeDetailDocument = gql`
    query PavtiTradeDetail($id: bigint!) {
  trade_by_pk(id: $id) {
    id
    created_at
    tracking_code
    kind
    buyer_verification
    seller_verification
    created_by {
      full_name
      number
    }
    facilitator {
      name
    }
    plot_crop {
      id
      name
      plot_crop {
        id
        plot {
          id
          field {
            id
            address {
              id
              raw_address
            }
          }
        }
      }
    }
    seller {
      id
      name
    }
    buyer {
      id
      name
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    packaging
    trade_items {
      id
      currency {
        id
        name
      }
      variety_grade {
        id
        name
      }
      quantity
      quantity_unit {
        id
        name
      }
      rate
      rate_unit {
        id
        name
      }
      amount
    }
    trade_items_aggregate {
      aggregate {
        sum {
          quantity
        }
      }
    }
    standard_deduction
    total_amount
    buyer_expenses: expenses_aggregate(where: {paid_by: {_eq: "buyer"}}) {
      aggregate {
        sum {
          amount
        }
      }
      nodes {
        expense_parameter {
          id
          name
        }
        kind
        value
        amount
      }
    }
    seller_expenses: expenses_aggregate(where: {paid_by: {_eq: "seller"}}) {
      aggregate {
        sum {
          amount
        }
      }
      nodes {
        expense_parameter {
          id
          name
        }
        kind
        value
        amount
      }
    }
    start_date
    end_date
    expiry
    seller_tnc
    buyer_tnc
  }
}
    `;

export function usePavtiTradeDetailQuery(options: Omit<Urql.UseQueryArgs<PavtiTradeDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<PavtiTradeDetailQuery, PavtiTradeDetailQueryVariables>({ query: PavtiTradeDetailDocument, ...options });
};
export const TradeDetailsDocument = gql`
    subscription TradeDetails($id: bigint!) {
  trade_by_pk(id: $id) {
    id
    seller_verification
    seller_remark
    buyer_verification
    buyer_remark
  }
}
    `;

export function useTradeDetailsSubscription<TData = TradeDetailsSubscription>(options: Omit<Urql.UseSubscriptionArgs<TradeDetailsSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<TradeDetailsSubscription, TData>) {
  return Urql.useSubscription<TradeDetailsSubscription, TData, TradeDetailsSubscriptionVariables>({ query: TradeDetailsDocument, ...options }, handler);
};
export const UpdateTradeVerificationDocument = gql`
    mutation UpdateTradeVerification($id: bigint!, $set: trade_set_input) {
  update_trade_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;

export function useUpdateTradeVerificationMutation() {
  return Urql.useMutation<UpdateTradeVerificationMutation, UpdateTradeVerificationMutationVariables>(UpdateTradeVerificationDocument);
};
export const GenerateTradeOtpDocument = gql`
    mutation GenerateTradeOTP($token: String!) {
  generate_trade_otp(token: $token) {
    status
  }
}
    `;

export function useGenerateTradeOtpMutation() {
  return Urql.useMutation<GenerateTradeOtpMutation, GenerateTradeOtpMutationVariables>(GenerateTradeOtpDocument);
};
export const VerifyTradeOtpDocument = gql`
    mutation VerifyTradeOTP($token: String!, $otp: String!) {
  verify_trade_otp(otp: $otp, token: $token) {
    token
    refresh_token
    refresh_expires_in
    payload
  }
}
    `;

export function useVerifyTradeOtpMutation() {
  return Urql.useMutation<VerifyTradeOtpMutation, VerifyTradeOtpMutationVariables>(VerifyTradeOtpDocument);
};